
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire365b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire365b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';
parcelRequire("013Yp");

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$g = 60103;
$1bb9784afa87e369$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $1bb9784afa87e369$var$h = Symbol.for;
    $1bb9784afa87e369$var$g = $1bb9784afa87e369$var$h("react.element");
    $1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$h("react.fragment");
}
var $1bb9784afa87e369$var$m = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$n = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$1bb9784afa87e369$var$n.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $1bb9784afa87e369$var$m.current
    };
}
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("013Yp", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $00332d224329ec89$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00332d224329ec89$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $00332d224329ec89$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $00332d224329ec89$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $00332d224329ec89$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $00332d224329ec89$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $00332d224329ec89$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($00332d224329ec89$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($00332d224329ec89$var$getOwnPropertySymbols) {
            symbols = $00332d224329ec89$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($00332d224329ec89$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';

var $013Yp = parcelRequire("013Yp");
var $b9040d2deeb360f4$var$n = 60103, $b9040d2deeb360f4$var$p = 60106;
$b9040d2deeb360f4$export$ffb0004e005737fa = 60107;
$b9040d2deeb360f4$export$5f8d39834fd61797 = 60108;
$b9040d2deeb360f4$export$e2c29f18771995cb = 60114;
var $b9040d2deeb360f4$var$q = 60109, $b9040d2deeb360f4$var$r = 60110, $b9040d2deeb360f4$var$t = 60112;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = 60113;
var $b9040d2deeb360f4$var$u = 60115, $b9040d2deeb360f4$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $b9040d2deeb360f4$var$w = Symbol.for;
    $b9040d2deeb360f4$var$n = $b9040d2deeb360f4$var$w("react.element");
    $b9040d2deeb360f4$var$p = $b9040d2deeb360f4$var$w("react.portal");
    $b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$w("react.fragment");
    $b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$w("react.strict_mode");
    $b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$w("react.profiler");
    $b9040d2deeb360f4$var$q = $b9040d2deeb360f4$var$w("react.provider");
    $b9040d2deeb360f4$var$r = $b9040d2deeb360f4$var$w("react.context");
    $b9040d2deeb360f4$var$t = $b9040d2deeb360f4$var$w("react.forward_ref");
    $b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w("react.suspense");
    $b9040d2deeb360f4$var$u = $b9040d2deeb360f4$var$w("react.memo");
    $b9040d2deeb360f4$var$v = $b9040d2deeb360f4$var$w("react.lazy");
}
var $b9040d2deeb360f4$var$x = "function" === typeof Symbol && Symbol.iterator;
function $b9040d2deeb360f4$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$x && a[$b9040d2deeb360f4$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $b9040d2deeb360f4$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b9040d2deeb360f4$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$B = {};
function $b9040d2deeb360f4$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
$b9040d2deeb360f4$var$C.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($b9040d2deeb360f4$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$D() {}
$b9040d2deeb360f4$var$D.prototype = $b9040d2deeb360f4$var$C.prototype;
function $b9040d2deeb360f4$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
var $b9040d2deeb360f4$var$F = $b9040d2deeb360f4$var$E.prototype = new $b9040d2deeb360f4$var$D;
$b9040d2deeb360f4$var$F.constructor = $b9040d2deeb360f4$var$E;
$013Yp($b9040d2deeb360f4$var$F, $b9040d2deeb360f4$var$C.prototype);
$b9040d2deeb360f4$var$F.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$G = {
    current: null
}, $b9040d2deeb360f4$var$H = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$H.call(b, e) && !$b9040d2deeb360f4$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $b9040d2deeb360f4$var$G.current
    };
}
function $b9040d2deeb360f4$var$K(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$n;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$M = /\/+/g;
function $b9040d2deeb360f4$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$n:
                case $b9040d2deeb360f4$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $b9040d2deeb360f4$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($b9040d2deeb360f4$var$M, "$&/") + "/"), $b9040d2deeb360f4$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($b9040d2deeb360f4$var$L(d) && (d = $b9040d2deeb360f4$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($b9040d2deeb360f4$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $b9040d2deeb360f4$var$N(k, g);
        h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    }
    else if (f = $b9040d2deeb360f4$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $b9040d2deeb360f4$var$N(k, g++), h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($b9040d2deeb360f4$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $b9040d2deeb360f4$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $b9040d2deeb360f4$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $b9040d2deeb360f4$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $b9040d2deeb360f4$var$R = {
    current: null
};
function $b9040d2deeb360f4$var$S() {
    var a = $b9040d2deeb360f4$var$R.current;
    if (null === a) throw Error($b9040d2deeb360f4$var$z(321));
    return a;
}
var $b9040d2deeb360f4$var$T = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $b9040d2deeb360f4$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $013Yp
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$P,
    forEach: function(a, b, c) {
        $b9040d2deeb360f4$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$L(a)) throw Error($b9040d2deeb360f4$var$z(143));
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$C;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$T;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($b9040d2deeb360f4$var$z(267, a));
    var e = $013Yp({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$H.call(b, f) && !$b9040d2deeb360f4$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $b9040d2deeb360f4$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$J;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$J.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$t,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$L;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$Q
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useContext(a, b);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useEffect(a, b);
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useImperativeHandle(a, b, c);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$S().useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useReducer(a, b, c);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$S().useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$S().useState(a);
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("6EA3T", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $013Yp = parcelRequire("013Yp");

var $33s19 = parcelRequire("33s19");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$7fPBF) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $013Yp({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $7fPBF.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $013Yp({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $013Yp({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $013Yp({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $33s19.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $33s19.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $33s19.unstable_UserBlockingPriority, ed = $33s19.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $013Yp(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $013Yp({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $013Yp({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $013Yp({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $013Yp({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $013Yp({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $013Yp({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $013Yp({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $013Yp({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $013Yp({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $013Yp({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $013Yp({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $013Yp({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $013Yp({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $33s19.unstable_runWithPriority, Of = $33s19.unstable_scheduleCallback, Pf = $33s19.unstable_cancelCallback, Qf = $33s19.unstable_shouldYield, Rf = $33s19.unstable_requestPaint, Sf = $33s19.unstable_now, Tf = $33s19.unstable_getCurrentPriorityLevel, Uf = $33s19.unstable_ImmediatePriority, Vf = $33s19.unstable_UserBlockingPriority, Wf = $33s19.unstable_NormalPriority, Xf = $33s19.unstable_LowPriority, Yf = $33s19.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $013Yp({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $013Yp({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $7fPBF.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $013Yp({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $013Yp({}, e, {
                    value: void 0
                });
                d = $013Yp({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $013Yp({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
var $749777fefd570b40$var$f, $749777fefd570b40$var$g, $749777fefd570b40$var$h, $749777fefd570b40$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $749777fefd570b40$var$t = null, $749777fefd570b40$var$u = null, $749777fefd570b40$var$w = function() {
        if (null !== $749777fefd570b40$var$t) try {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$t(!0, a);
            $749777fefd570b40$var$t = null;
        } catch (b) {
            throw setTimeout($749777fefd570b40$var$w, 0), b;
        }
    };
    $749777fefd570b40$var$f = function(a) {
        null !== $749777fefd570b40$var$t ? setTimeout($749777fefd570b40$var$f, 0, a) : ($749777fefd570b40$var$t = a, setTimeout($749777fefd570b40$var$w, 0));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$u = setTimeout(a, b);
    };
    $749777fefd570b40$var$h = function() {
        clearTimeout($749777fefd570b40$var$u);
    };
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $749777fefd570b40$var$k = $749777fefd570b40$export$d66a1c1c77bd778b = function() {};
} else {
    var $749777fefd570b40$var$x = window.setTimeout, $749777fefd570b40$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $749777fefd570b40$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $749777fefd570b40$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null, $749777fefd570b40$var$C = -1, $749777fefd570b40$var$D = 5, $749777fefd570b40$var$E = 0;
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return $749777fefd570b40$export$c4744153514ff05d() >= $749777fefd570b40$var$E;
    };
    $749777fefd570b40$var$k = function() {};
    $749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $749777fefd570b40$var$F = new MessageChannel, $749777fefd570b40$var$G = $749777fefd570b40$var$F.port2;
    $749777fefd570b40$var$F.port1.onmessage = function() {
        if (null !== $749777fefd570b40$var$B) {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$E = a + $749777fefd570b40$var$D;
            try {
                $749777fefd570b40$var$B(!0, a) ? $749777fefd570b40$var$G.postMessage(null) : ($749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null);
            } catch (b) {
                throw $749777fefd570b40$var$G.postMessage(null), b;
            }
        } else $749777fefd570b40$var$A = !1;
    };
    $749777fefd570b40$var$f = function(a) {
        $749777fefd570b40$var$B = a;
        $749777fefd570b40$var$A || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$G.postMessage(null));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$C = $749777fefd570b40$var$x(function() {
            a($749777fefd570b40$export$c4744153514ff05d());
        }, b);
    };
    $749777fefd570b40$var$h = function() {
        $749777fefd570b40$var$y($749777fefd570b40$var$C);
        $749777fefd570b40$var$C = -1;
    };
}
function $749777fefd570b40$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $749777fefd570b40$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $749777fefd570b40$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $749777fefd570b40$var$I(n, c)) void 0 !== r && 0 > $749777fefd570b40$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $749777fefd570b40$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $749777fefd570b40$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $749777fefd570b40$var$L = [], $749777fefd570b40$var$M = [], $749777fefd570b40$var$N = 1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = 3, $749777fefd570b40$var$Q = !1, $749777fefd570b40$var$R = !1, $749777fefd570b40$var$S = !1;
function $749777fefd570b40$var$T(a) {
    for(var b = $749777fefd570b40$var$J($749777fefd570b40$var$M); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$K($749777fefd570b40$var$M);
        else if (b.startTime <= a) $749777fefd570b40$var$K($749777fefd570b40$var$M), b.sortIndex = b.expirationTime, $749777fefd570b40$var$H($749777fefd570b40$var$L, b);
        else break;
        b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
    }
}
function $749777fefd570b40$var$U(a) {
    $749777fefd570b40$var$S = !1;
    $749777fefd570b40$var$T(a);
    if (!$749777fefd570b40$var$R) {
        if (null !== $749777fefd570b40$var$J($749777fefd570b40$var$L)) $749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V);
        else {
            var b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== b && $749777fefd570b40$var$g($749777fefd570b40$var$U, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$V(a, b) {
    $749777fefd570b40$var$R = !1;
    $749777fefd570b40$var$S && ($749777fefd570b40$var$S = !1, $749777fefd570b40$var$h());
    $749777fefd570b40$var$Q = !0;
    var c = $749777fefd570b40$var$P;
    try {
        $749777fefd570b40$var$T(b);
        for($749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L); null !== $749777fefd570b40$var$O && (!($749777fefd570b40$var$O.expirationTime > b) || a && !$749777fefd570b40$export$b5836b71941fa3ed());){
            var d = $749777fefd570b40$var$O.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$O.callback = null;
                $749777fefd570b40$var$P = $749777fefd570b40$var$O.priorityLevel;
                var e = d($749777fefd570b40$var$O.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$O.callback = e : $749777fefd570b40$var$O === $749777fefd570b40$var$J($749777fefd570b40$var$L) && $749777fefd570b40$var$K($749777fefd570b40$var$L);
                $749777fefd570b40$var$T(b);
            } else $749777fefd570b40$var$K($749777fefd570b40$var$L);
            $749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L);
        }
        if (null !== $749777fefd570b40$var$O) var m = !0;
        else {
            var n = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== n && $749777fefd570b40$var$g($749777fefd570b40$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = c, $749777fefd570b40$var$Q = !1;
    }
}
var $749777fefd570b40$var$W = $749777fefd570b40$var$k;
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V));
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$P;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$J($749777fefd570b40$var$L);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$P;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = $749777fefd570b40$var$W;
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$H($749777fefd570b40$var$M, a), null === $749777fefd570b40$var$J($749777fefd570b40$var$L) && a === $749777fefd570b40$var$J($749777fefd570b40$var$M) && ($749777fefd570b40$var$S ? $749777fefd570b40$var$h() : $749777fefd570b40$var$S = !0, $749777fefd570b40$var$g($749777fefd570b40$var$U, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$H($749777fefd570b40$var$L, a), $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V)));
    return a;
};
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$P;
    return function() {
        var c = $749777fefd570b40$var$P;
        $749777fefd570b40$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$P = c;
        }
    };
};

});



parcelRegister("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iDep4"))();

});
parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});



parcelRegister("3oWWu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27a155bcdd967657$export$2b8d127b894957b9; }, function (v) { return $27a155bcdd967657$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27a155bcdd967657$export$cea3a54a6425200c; }, function (v) { return $27a155bcdd967657$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27a155bcdd967657$export$a7c73072b1a182ae; }, function (v) { return $27a155bcdd967657$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27a155bcdd967657$export$9f27bc3417b4524d; }, function (v) { return $27a155bcdd967657$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27a155bcdd967657$export$db77ccec0bb4ccac; }, function (v) { return $27a155bcdd967657$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27a155bcdd967657$export$8392c0c9d3dcbd35; }, function (v) { return $27a155bcdd967657$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27a155bcdd967657$export$ffb0004e005737fa; }, function (v) { return $27a155bcdd967657$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27a155bcdd967657$export$b624eff549462981; }, function (v) { return $27a155bcdd967657$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27a155bcdd967657$export$7897aa7841a5380c; }, function (v) { return $27a155bcdd967657$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27a155bcdd967657$export$602eac185826482c; }, function (v) { return $27a155bcdd967657$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27a155bcdd967657$export$e2c29f18771995cb; }, function (v) { return $27a155bcdd967657$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27a155bcdd967657$export$5f8d39834fd61797; }, function (v) { return $27a155bcdd967657$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27a155bcdd967657$export$74bf444e3cd11ea5; }, function (v) { return $27a155bcdd967657$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27a155bcdd967657$export$92387174baf9b227; }, function (v) { return $27a155bcdd967657$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27a155bcdd967657$export$ec112efeb987d9c6; }, function (v) { return $27a155bcdd967657$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27a155bcdd967657$export$b706b080d889d2c9; }, function (v) { return $27a155bcdd967657$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27a155bcdd967657$export$5be5a87408f70ddc; }, function (v) { return $27a155bcdd967657$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27a155bcdd967657$export$45a5e7f76e0caa8d; }, function (v) { return $27a155bcdd967657$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27a155bcdd967657$export$455c2e768291efa6; }, function (v) { return $27a155bcdd967657$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27a155bcdd967657$export$9522e17588c12572; }, function (v) { return $27a155bcdd967657$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27a155bcdd967657$export$2110ac352bb060b9; }, function (v) { return $27a155bcdd967657$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27a155bcdd967657$export$56885ab8b9c456ab; }, function (v) { return $27a155bcdd967657$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27a155bcdd967657$export$d927fcb6adf8f9de; }, function (v) { return $27a155bcdd967657$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27a155bcdd967657$export$b82d16f27459e05a; }, function (v) { return $27a155bcdd967657$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27a155bcdd967657$export$522c17b4f5e123e8; }, function (v) { return $27a155bcdd967657$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27a155bcdd967657$export$1aabd8a0274ecfd6; }, function (v) { return $27a155bcdd967657$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27a155bcdd967657$export$9b621391a187a31a; }, function (v) { return $27a155bcdd967657$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27a155bcdd967657$export$f5bbd400c2f4426f; }, function (v) { return $27a155bcdd967657$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27a155bcdd967657$export$2b8d127b894957b9;
var $27a155bcdd967657$export$cea3a54a6425200c;
var $27a155bcdd967657$export$a7c73072b1a182ae;
var $27a155bcdd967657$export$9f27bc3417b4524d;
var $27a155bcdd967657$export$db77ccec0bb4ccac;
var $27a155bcdd967657$export$8392c0c9d3dcbd35;
var $27a155bcdd967657$export$ffb0004e005737fa;
var $27a155bcdd967657$export$b624eff549462981;
var $27a155bcdd967657$export$7897aa7841a5380c;
var $27a155bcdd967657$export$602eac185826482c;
var $27a155bcdd967657$export$e2c29f18771995cb;
var $27a155bcdd967657$export$5f8d39834fd61797;
var $27a155bcdd967657$export$74bf444e3cd11ea5;
var $27a155bcdd967657$export$92387174baf9b227;
var $27a155bcdd967657$export$ec112efeb987d9c6;
var $27a155bcdd967657$export$b706b080d889d2c9;
var $27a155bcdd967657$export$5be5a87408f70ddc;
var $27a155bcdd967657$export$45a5e7f76e0caa8d;
var $27a155bcdd967657$export$455c2e768291efa6;
var $27a155bcdd967657$export$9522e17588c12572;
var $27a155bcdd967657$export$2110ac352bb060b9;
var $27a155bcdd967657$export$56885ab8b9c456ab;
var $27a155bcdd967657$export$d927fcb6adf8f9de;
var $27a155bcdd967657$export$b82d16f27459e05a;
var $27a155bcdd967657$export$522c17b4f5e123e8;
var $27a155bcdd967657$export$1aabd8a0274ecfd6;
var $27a155bcdd967657$export$9b621391a187a31a;
var $27a155bcdd967657$export$f5bbd400c2f4426f;
'use strict';
var $27a155bcdd967657$var$b = "function" === typeof Symbol && Symbol.for, $27a155bcdd967657$var$c = $27a155bcdd967657$var$b ? Symbol.for("react.element") : 60103, $27a155bcdd967657$var$d = $27a155bcdd967657$var$b ? Symbol.for("react.portal") : 60106, $27a155bcdd967657$var$e = $27a155bcdd967657$var$b ? Symbol.for("react.fragment") : 60107, $27a155bcdd967657$var$f = $27a155bcdd967657$var$b ? Symbol.for("react.strict_mode") : 60108, $27a155bcdd967657$var$g = $27a155bcdd967657$var$b ? Symbol.for("react.profiler") : 60114, $27a155bcdd967657$var$h = $27a155bcdd967657$var$b ? Symbol.for("react.provider") : 60109, $27a155bcdd967657$var$k = $27a155bcdd967657$var$b ? Symbol.for("react.context") : 60110, $27a155bcdd967657$var$l = $27a155bcdd967657$var$b ? Symbol.for("react.async_mode") : 60111, $27a155bcdd967657$var$m = $27a155bcdd967657$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27a155bcdd967657$var$n = $27a155bcdd967657$var$b ? Symbol.for("react.forward_ref") : 60112, $27a155bcdd967657$var$p = $27a155bcdd967657$var$b ? Symbol.for("react.suspense") : 60113, $27a155bcdd967657$var$q = $27a155bcdd967657$var$b ? Symbol.for("react.suspense_list") : 60120, $27a155bcdd967657$var$r = $27a155bcdd967657$var$b ? Symbol.for("react.memo") : 60115, $27a155bcdd967657$var$t = $27a155bcdd967657$var$b ? Symbol.for("react.lazy") : 60116, $27a155bcdd967657$var$v = $27a155bcdd967657$var$b ? Symbol.for("react.block") : 60121, $27a155bcdd967657$var$w = $27a155bcdd967657$var$b ? Symbol.for("react.fundamental") : 60117, $27a155bcdd967657$var$x = $27a155bcdd967657$var$b ? Symbol.for("react.responder") : 60118, $27a155bcdd967657$var$y = $27a155bcdd967657$var$b ? Symbol.for("react.scope") : 60119;
function $27a155bcdd967657$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27a155bcdd967657$var$c:
                switch(a = a.type, a){
                    case $27a155bcdd967657$var$l:
                    case $27a155bcdd967657$var$m:
                    case $27a155bcdd967657$var$e:
                    case $27a155bcdd967657$var$g:
                    case $27a155bcdd967657$var$f:
                    case $27a155bcdd967657$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27a155bcdd967657$var$k:
                            case $27a155bcdd967657$var$n:
                            case $27a155bcdd967657$var$t:
                            case $27a155bcdd967657$var$r:
                            case $27a155bcdd967657$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27a155bcdd967657$var$d:
                return u;
        }
    }
}
function $27a155bcdd967657$var$A(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$m;
}
$27a155bcdd967657$export$2b8d127b894957b9 = $27a155bcdd967657$var$l;
$27a155bcdd967657$export$cea3a54a6425200c = $27a155bcdd967657$var$m;
$27a155bcdd967657$export$a7c73072b1a182ae = $27a155bcdd967657$var$k;
$27a155bcdd967657$export$9f27bc3417b4524d = $27a155bcdd967657$var$h;
$27a155bcdd967657$export$db77ccec0bb4ccac = $27a155bcdd967657$var$c;
$27a155bcdd967657$export$8392c0c9d3dcbd35 = $27a155bcdd967657$var$n;
$27a155bcdd967657$export$ffb0004e005737fa = $27a155bcdd967657$var$e;
$27a155bcdd967657$export$b624eff549462981 = $27a155bcdd967657$var$t;
$27a155bcdd967657$export$7897aa7841a5380c = $27a155bcdd967657$var$r;
$27a155bcdd967657$export$602eac185826482c = $27a155bcdd967657$var$d;
$27a155bcdd967657$export$e2c29f18771995cb = $27a155bcdd967657$var$g;
$27a155bcdd967657$export$5f8d39834fd61797 = $27a155bcdd967657$var$f;
$27a155bcdd967657$export$74bf444e3cd11ea5 = $27a155bcdd967657$var$p;
$27a155bcdd967657$export$92387174baf9b227 = function(a) {
    return $27a155bcdd967657$var$A(a) || $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$l;
};
$27a155bcdd967657$export$ec112efeb987d9c6 = $27a155bcdd967657$var$A;
$27a155bcdd967657$export$b706b080d889d2c9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$k;
};
$27a155bcdd967657$export$5be5a87408f70ddc = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$h;
};
$27a155bcdd967657$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27a155bcdd967657$var$c;
};
$27a155bcdd967657$export$455c2e768291efa6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$n;
};
$27a155bcdd967657$export$9522e17588c12572 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$e;
};
$27a155bcdd967657$export$2110ac352bb060b9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$t;
};
$27a155bcdd967657$export$56885ab8b9c456ab = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$r;
};
$27a155bcdd967657$export$d927fcb6adf8f9de = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$d;
};
$27a155bcdd967657$export$b82d16f27459e05a = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$g;
};
$27a155bcdd967657$export$522c17b4f5e123e8 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$f;
};
$27a155bcdd967657$export$1aabd8a0274ecfd6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$p;
};
$27a155bcdd967657$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27a155bcdd967657$var$e || a === $27a155bcdd967657$var$m || a === $27a155bcdd967657$var$g || a === $27a155bcdd967657$var$f || a === $27a155bcdd967657$var$p || a === $27a155bcdd967657$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27a155bcdd967657$var$t || a.$$typeof === $27a155bcdd967657$var$r || a.$$typeof === $27a155bcdd967657$var$h || a.$$typeof === $27a155bcdd967657$var$k || a.$$typeof === $27a155bcdd967657$var$n || a.$$typeof === $27a155bcdd967657$var$w || a.$$typeof === $27a155bcdd967657$var$x || a.$$typeof === $27a155bcdd967657$var$y || a.$$typeof === $27a155bcdd967657$var$v);
};
$27a155bcdd967657$export$f5bbd400c2f4426f = $27a155bcdd967657$var$z;

});

parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
'use strict';
var $2fad1f91101d4119$var$b = 60103, $2fad1f91101d4119$var$c = 60106, $2fad1f91101d4119$var$d = 60107, $2fad1f91101d4119$var$e = 60108, $2fad1f91101d4119$var$f = 60114, $2fad1f91101d4119$var$g = 60109, $2fad1f91101d4119$var$h = 60110, $2fad1f91101d4119$var$k = 60112, $2fad1f91101d4119$var$l = 60113, $2fad1f91101d4119$var$m = 60120, $2fad1f91101d4119$var$n = 60115, $2fad1f91101d4119$var$p = 60116, $2fad1f91101d4119$var$q = 60121, $2fad1f91101d4119$var$r = 60122, $2fad1f91101d4119$var$u = 60117, $2fad1f91101d4119$var$v = 60129, $2fad1f91101d4119$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $2fad1f91101d4119$var$x = Symbol.for;
    $2fad1f91101d4119$var$b = $2fad1f91101d4119$var$x("react.element");
    $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$x("react.portal");
    $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$x("react.fragment");
    $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$x("react.strict_mode");
    $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$x("react.profiler");
    $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$x("react.provider");
    $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$x("react.context");
    $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$x("react.forward_ref");
    $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$x("react.suspense");
    $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$x("react.suspense_list");
    $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$x("react.memo");
    $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$x("react.lazy");
    $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$x("react.block");
    $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$x("react.server.block");
    $2fad1f91101d4119$var$u = $2fad1f91101d4119$var$x("react.fundamental");
    $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$x("react.debug_trace_mode");
    $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$x("react.legacy_hidden");
}
function $2fad1f91101d4119$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $2fad1f91101d4119$var$b:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$d:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$h:
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$p:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $2fad1f91101d4119$var$c:
                return t;
        }
    }
}
var $2fad1f91101d4119$var$z = $2fad1f91101d4119$var$g, $2fad1f91101d4119$var$A = $2fad1f91101d4119$var$b, $2fad1f91101d4119$var$B = $2fad1f91101d4119$var$k, $2fad1f91101d4119$var$C = $2fad1f91101d4119$var$d, $2fad1f91101d4119$var$D = $2fad1f91101d4119$var$p, $2fad1f91101d4119$var$E = $2fad1f91101d4119$var$n, $2fad1f91101d4119$var$F = $2fad1f91101d4119$var$c, $2fad1f91101d4119$var$G = $2fad1f91101d4119$var$f, $2fad1f91101d4119$var$H = $2fad1f91101d4119$var$e, $2fad1f91101d4119$var$I = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$z;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$B;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$C;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$D;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$E;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$F;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$G;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$H;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$I;
$2fad1f91101d4119$export$92387174baf9b227 = function() {
    return !1;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$b;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$d || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$v || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$l || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$w || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$p || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$g || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$u || a.$$typeof === $2fad1f91101d4119$var$q || a[0] === $2fad1f91101d4119$var$r) ? !0 : !1;
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$y;

});

parcelRegister("fVMg8", function(module, exports) {
var global = typeof self !== 'undefined' ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: 'URLSearchParams' in self1,
            iterable: 'Symbol' in self1 && 'iterator' in Symbol,
            blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in self1,
            arrayBuffer: 'ArrayBuffer' in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException('Aborted', 'AbortError'));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("8MJe2", function(module, exports) {

var $jHo6y = parcelRequire("jHo6y");
function $6655e33f0d2c88e7$var$_defineProperty(e, r, t) {
    return (r = $jHo6y(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $6655e33f0d2c88e7$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jHo6y", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $e574bb2d4ac0a9b8$var$_typeof = $bRUy3.default;

var $9GPcj = parcelRequire("9GPcj");
function $e574bb2d4ac0a9b8$var$toPropertyKey(t) {
    var i = $9GPcj(t, "string");
    return "symbol" == $e574bb2d4ac0a9b8$var$_typeof(i) ? i : i + "";
}
module.exports = $e574bb2d4ac0a9b8$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bRUy3", function(module, exports) {
function $8a40824683152bd6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8a40824683152bd6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8a40824683152bd6$var$_typeof(o);
}
module.exports = $8a40824683152bd6$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9GPcj", function(module, exports) {

var $bRUy3 = parcelRequire("bRUy3");
var $70dfc0196094649e$var$_typeof = $bRUy3.default;
function $70dfc0196094649e$var$toPrimitive(t, r) {
    if ("object" != $70dfc0196094649e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $70dfc0196094649e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $70dfc0196094649e$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("9GPfD", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $70dfcab4636df6ef$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $70dfcab4636df6ef$export$2e2bcd8739ae039 = fn;

});

parcelRegister("44Txg", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "SheetsRegistry", function () { return SheetsRegistry; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $kY3Ke = parcelRequire("kY3Ke");

var $8RSXT = parcelRequire("8RSXT");

var $8knIu = parcelRequire("8knIu");

var $4OFm0 = parcelRequire("4OFm0");

var $1KLsX = parcelRequire("1KLsX");

var $3zeAJ = parcelRequire("3zeAJ");

var $cFLic = parcelRequire("cFLic");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $1KLsX.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $3zeAJ.default)((0, $3zeAJ.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    };
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $kY3Ke.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $4OFm0.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $kY3Ke.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $kY3Ke.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $kY3Ke.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $1KLsX.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $kY3Ke.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $kY3Ke.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    };
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $kY3Ke.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    };
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    };
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    };
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    };
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    };
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    };
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    };
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $kY3Ke.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    };
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    };
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    };
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    };
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    };
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    };
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    };
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    };
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    };
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    };
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    };
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    };
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    };
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    };
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    };
    _proto.reset = function reset() {
        this.registry = [];
    };
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    };
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $cFLic.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $4OFm0.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    };
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    };
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    };
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    };
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    };
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    };
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    };
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    };
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $8RSXT.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $kY3Ke.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    };
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $kY3Ke.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    };
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    };
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $kY3Ke.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $8knIu.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $8knIu.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $4OFm0.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $2f829d591bf300a5$export$2e2bcd8739ae039 = index;

});
parcelRegister("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8RSXT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $674de8e403e00348$export$2e2bcd8739ae039; });
var $674de8e403e00348$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $674de8e403e00348$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $674de8e403e00348$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $674de8e403e00348$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $674de8e403e00348$export$2e2bcd8739ae039 = $674de8e403e00348$export$4e09c449d6c407f7;

});

parcelRegister("8knIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6102969760a10d5a$export$2e2bcd8739ae039; });
var $6102969760a10d5a$var$isProduction = true;
function $6102969760a10d5a$var$warning(condition, message) {
    if (!$6102969760a10d5a$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $6102969760a10d5a$export$2e2bcd8739ae039 = $6102969760a10d5a$var$warning;

});

parcelRegister("4OFm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $381be8fad7784fe9$export$2e2bcd8739ae039; });

var $aYCSV = parcelRequire("aYCSV");
function $381be8fad7784fe9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aYCSV.default)(o.key), o);
    }
}
function $381be8fad7784fe9$export$2e2bcd8739ae039(e, r, t) {
    return r && $381be8fad7784fe9$var$_defineProperties(e.prototype, r), t && $381be8fad7784fe9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("aYCSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fddabb4b045308c$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");

var $3qCmf = parcelRequire("3qCmf");
function $7fddabb4b045308c$export$2e2bcd8739ae039(t) {
    var i = (0, $3qCmf.default)(t, "string");
    return "symbol" == (0, $6TO5S.default)(i) ? i : i + "";
}

});
parcelRegister("6TO5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $505ebcb184373782$export$2e2bcd8739ae039; });
function $505ebcb184373782$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $505ebcb184373782$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $505ebcb184373782$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3qCmf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27f18dd8fc16da3b$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");
function $27f18dd8fc16da3b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6TO5S.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6TO5S.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("1KLsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146ee816144a450d$export$2e2bcd8739ae039; });

var $iJeDO = parcelRequire("iJeDO");
function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $iJeDO.default)(t, o);
}

});
parcelRegister("iJeDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da27c96857818bcc$export$2e2bcd8739ae039; });
function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("3zeAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298ff58efa174465$export$2e2bcd8739ae039; });
function $298ff58efa174465$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("gYL3V", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $c5c6c18b1c76eb46$export$2b8d127b894957b9; }, function (v) { return $c5c6c18b1c76eb46$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $c5c6c18b1c76eb46$export$cea3a54a6425200c; }, function (v) { return $c5c6c18b1c76eb46$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $c5c6c18b1c76eb46$export$a7c73072b1a182ae; }, function (v) { return $c5c6c18b1c76eb46$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c5c6c18b1c76eb46$export$9f27bc3417b4524d; }, function (v) { return $c5c6c18b1c76eb46$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c5c6c18b1c76eb46$export$db77ccec0bb4ccac; }, function (v) { return $c5c6c18b1c76eb46$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c5c6c18b1c76eb46$export$8392c0c9d3dcbd35; }, function (v) { return $c5c6c18b1c76eb46$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c5c6c18b1c76eb46$export$ffb0004e005737fa; }, function (v) { return $c5c6c18b1c76eb46$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c5c6c18b1c76eb46$export$b624eff549462981; }, function (v) { return $c5c6c18b1c76eb46$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c5c6c18b1c76eb46$export$7897aa7841a5380c; }, function (v) { return $c5c6c18b1c76eb46$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c5c6c18b1c76eb46$export$602eac185826482c; }, function (v) { return $c5c6c18b1c76eb46$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c5c6c18b1c76eb46$export$e2c29f18771995cb; }, function (v) { return $c5c6c18b1c76eb46$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c5c6c18b1c76eb46$export$5f8d39834fd61797; }, function (v) { return $c5c6c18b1c76eb46$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c5c6c18b1c76eb46$export$74bf444e3cd11ea5; }, function (v) { return $c5c6c18b1c76eb46$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c5c6c18b1c76eb46$export$92387174baf9b227; }, function (v) { return $c5c6c18b1c76eb46$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c5c6c18b1c76eb46$export$ec112efeb987d9c6; }, function (v) { return $c5c6c18b1c76eb46$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c5c6c18b1c76eb46$export$b706b080d889d2c9; }, function (v) { return $c5c6c18b1c76eb46$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c5c6c18b1c76eb46$export$5be5a87408f70ddc; }, function (v) { return $c5c6c18b1c76eb46$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c5c6c18b1c76eb46$export$45a5e7f76e0caa8d; }, function (v) { return $c5c6c18b1c76eb46$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c5c6c18b1c76eb46$export$455c2e768291efa6; }, function (v) { return $c5c6c18b1c76eb46$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c5c6c18b1c76eb46$export$9522e17588c12572; }, function (v) { return $c5c6c18b1c76eb46$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c5c6c18b1c76eb46$export$2110ac352bb060b9; }, function (v) { return $c5c6c18b1c76eb46$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c5c6c18b1c76eb46$export$56885ab8b9c456ab; }, function (v) { return $c5c6c18b1c76eb46$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c5c6c18b1c76eb46$export$d927fcb6adf8f9de; }, function (v) { return $c5c6c18b1c76eb46$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c5c6c18b1c76eb46$export$b82d16f27459e05a; }, function (v) { return $c5c6c18b1c76eb46$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c5c6c18b1c76eb46$export$522c17b4f5e123e8; }, function (v) { return $c5c6c18b1c76eb46$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c5c6c18b1c76eb46$export$1aabd8a0274ecfd6; }, function (v) { return $c5c6c18b1c76eb46$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c5c6c18b1c76eb46$export$9b621391a187a31a; }, function (v) { return $c5c6c18b1c76eb46$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c5c6c18b1c76eb46$export$f5bbd400c2f4426f; }, function (v) { return $c5c6c18b1c76eb46$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c5c6c18b1c76eb46$export$2b8d127b894957b9;
var $c5c6c18b1c76eb46$export$cea3a54a6425200c;
var $c5c6c18b1c76eb46$export$a7c73072b1a182ae;
var $c5c6c18b1c76eb46$export$9f27bc3417b4524d;
var $c5c6c18b1c76eb46$export$db77ccec0bb4ccac;
var $c5c6c18b1c76eb46$export$8392c0c9d3dcbd35;
var $c5c6c18b1c76eb46$export$ffb0004e005737fa;
var $c5c6c18b1c76eb46$export$b624eff549462981;
var $c5c6c18b1c76eb46$export$7897aa7841a5380c;
var $c5c6c18b1c76eb46$export$602eac185826482c;
var $c5c6c18b1c76eb46$export$e2c29f18771995cb;
var $c5c6c18b1c76eb46$export$5f8d39834fd61797;
var $c5c6c18b1c76eb46$export$74bf444e3cd11ea5;
var $c5c6c18b1c76eb46$export$92387174baf9b227;
var $c5c6c18b1c76eb46$export$ec112efeb987d9c6;
var $c5c6c18b1c76eb46$export$b706b080d889d2c9;
var $c5c6c18b1c76eb46$export$5be5a87408f70ddc;
var $c5c6c18b1c76eb46$export$45a5e7f76e0caa8d;
var $c5c6c18b1c76eb46$export$455c2e768291efa6;
var $c5c6c18b1c76eb46$export$9522e17588c12572;
var $c5c6c18b1c76eb46$export$2110ac352bb060b9;
var $c5c6c18b1c76eb46$export$56885ab8b9c456ab;
var $c5c6c18b1c76eb46$export$d927fcb6adf8f9de;
var $c5c6c18b1c76eb46$export$b82d16f27459e05a;
var $c5c6c18b1c76eb46$export$522c17b4f5e123e8;
var $c5c6c18b1c76eb46$export$1aabd8a0274ecfd6;
var $c5c6c18b1c76eb46$export$9b621391a187a31a;
var $c5c6c18b1c76eb46$export$f5bbd400c2f4426f;
'use strict';
var $c5c6c18b1c76eb46$var$b = "function" === typeof Symbol && Symbol.for, $c5c6c18b1c76eb46$var$c = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.element") : 60103, $c5c6c18b1c76eb46$var$d = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.portal") : 60106, $c5c6c18b1c76eb46$var$e = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.fragment") : 60107, $c5c6c18b1c76eb46$var$f = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.strict_mode") : 60108, $c5c6c18b1c76eb46$var$g = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.profiler") : 60114, $c5c6c18b1c76eb46$var$h = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.provider") : 60109, $c5c6c18b1c76eb46$var$k = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.context") : 60110, $c5c6c18b1c76eb46$var$l = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.async_mode") : 60111, $c5c6c18b1c76eb46$var$m = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.concurrent_mode") : 60111, $c5c6c18b1c76eb46$var$n = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.forward_ref") : 60112, $c5c6c18b1c76eb46$var$p = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.suspense") : 60113, $c5c6c18b1c76eb46$var$q = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.suspense_list") : 60120, $c5c6c18b1c76eb46$var$r = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.memo") : 60115, $c5c6c18b1c76eb46$var$t = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.lazy") : 60116, $c5c6c18b1c76eb46$var$v = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.block") : 60121, $c5c6c18b1c76eb46$var$w = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.fundamental") : 60117, $c5c6c18b1c76eb46$var$x = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.responder") : 60118, $c5c6c18b1c76eb46$var$y = $c5c6c18b1c76eb46$var$b ? Symbol.for("react.scope") : 60119;
function $c5c6c18b1c76eb46$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $c5c6c18b1c76eb46$var$c:
                switch(a = a.type, a){
                    case $c5c6c18b1c76eb46$var$l:
                    case $c5c6c18b1c76eb46$var$m:
                    case $c5c6c18b1c76eb46$var$e:
                    case $c5c6c18b1c76eb46$var$g:
                    case $c5c6c18b1c76eb46$var$f:
                    case $c5c6c18b1c76eb46$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c5c6c18b1c76eb46$var$k:
                            case $c5c6c18b1c76eb46$var$n:
                            case $c5c6c18b1c76eb46$var$t:
                            case $c5c6c18b1c76eb46$var$r:
                            case $c5c6c18b1c76eb46$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $c5c6c18b1c76eb46$var$d:
                return u;
        }
    }
}
function $c5c6c18b1c76eb46$var$A(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$m;
}
$c5c6c18b1c76eb46$export$2b8d127b894957b9 = $c5c6c18b1c76eb46$var$l;
$c5c6c18b1c76eb46$export$cea3a54a6425200c = $c5c6c18b1c76eb46$var$m;
$c5c6c18b1c76eb46$export$a7c73072b1a182ae = $c5c6c18b1c76eb46$var$k;
$c5c6c18b1c76eb46$export$9f27bc3417b4524d = $c5c6c18b1c76eb46$var$h;
$c5c6c18b1c76eb46$export$db77ccec0bb4ccac = $c5c6c18b1c76eb46$var$c;
$c5c6c18b1c76eb46$export$8392c0c9d3dcbd35 = $c5c6c18b1c76eb46$var$n;
$c5c6c18b1c76eb46$export$ffb0004e005737fa = $c5c6c18b1c76eb46$var$e;
$c5c6c18b1c76eb46$export$b624eff549462981 = $c5c6c18b1c76eb46$var$t;
$c5c6c18b1c76eb46$export$7897aa7841a5380c = $c5c6c18b1c76eb46$var$r;
$c5c6c18b1c76eb46$export$602eac185826482c = $c5c6c18b1c76eb46$var$d;
$c5c6c18b1c76eb46$export$e2c29f18771995cb = $c5c6c18b1c76eb46$var$g;
$c5c6c18b1c76eb46$export$5f8d39834fd61797 = $c5c6c18b1c76eb46$var$f;
$c5c6c18b1c76eb46$export$74bf444e3cd11ea5 = $c5c6c18b1c76eb46$var$p;
$c5c6c18b1c76eb46$export$92387174baf9b227 = function(a) {
    return $c5c6c18b1c76eb46$var$A(a) || $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$l;
};
$c5c6c18b1c76eb46$export$ec112efeb987d9c6 = $c5c6c18b1c76eb46$var$A;
$c5c6c18b1c76eb46$export$b706b080d889d2c9 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$k;
};
$c5c6c18b1c76eb46$export$5be5a87408f70ddc = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$h;
};
$c5c6c18b1c76eb46$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c5c6c18b1c76eb46$var$c;
};
$c5c6c18b1c76eb46$export$455c2e768291efa6 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$n;
};
$c5c6c18b1c76eb46$export$9522e17588c12572 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$e;
};
$c5c6c18b1c76eb46$export$2110ac352bb060b9 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$t;
};
$c5c6c18b1c76eb46$export$56885ab8b9c456ab = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$r;
};
$c5c6c18b1c76eb46$export$d927fcb6adf8f9de = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$d;
};
$c5c6c18b1c76eb46$export$b82d16f27459e05a = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$g;
};
$c5c6c18b1c76eb46$export$522c17b4f5e123e8 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$f;
};
$c5c6c18b1c76eb46$export$1aabd8a0274ecfd6 = function(a) {
    return $c5c6c18b1c76eb46$var$z(a) === $c5c6c18b1c76eb46$var$p;
};
$c5c6c18b1c76eb46$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c5c6c18b1c76eb46$var$e || a === $c5c6c18b1c76eb46$var$m || a === $c5c6c18b1c76eb46$var$g || a === $c5c6c18b1c76eb46$var$f || a === $c5c6c18b1c76eb46$var$p || a === $c5c6c18b1c76eb46$var$q || "object" === typeof a && null !== a && (a.$$typeof === $c5c6c18b1c76eb46$var$t || a.$$typeof === $c5c6c18b1c76eb46$var$r || a.$$typeof === $c5c6c18b1c76eb46$var$h || a.$$typeof === $c5c6c18b1c76eb46$var$k || a.$$typeof === $c5c6c18b1c76eb46$var$n || a.$$typeof === $c5c6c18b1c76eb46$var$w || a.$$typeof === $c5c6c18b1c76eb46$var$x || a.$$typeof === $c5c6c18b1c76eb46$var$y || a.$$typeof === $c5c6c18b1c76eb46$var$v);
};
$c5c6c18b1c76eb46$export$f5bbd400c2f4426f = $c5c6c18b1c76eb46$var$z;

});

parcelRegister("4FMad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $319Q5.default;
    }
});

var $319Q5 = parcelRequire("319Q5");

});
parcelRegister("319Q5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $232918e90c6d41e0$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $gC5xr = parcelRequire("gC5xr");
function $232918e90c6d41e0$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $gC5xr.default), (0, $kY3Ke.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $gC5xr.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(Component));
}

});
parcelRegister("gC5xr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1847dc22fee4a01$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $c1847dc22fee4a01$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create('fill', {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $c1847dc22fee4a01$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'svg' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $dKzJP.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $dKzJP.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $7fPBF.createElement("title", null, titleAccess) : null);
});
$c1847dc22fee4a01$var$SvgIcon.muiName = 'SvgIcon';
var $c1847dc22fee4a01$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($c1847dc22fee4a01$export$9dd6ff9ea0189349, {
    name: 'MuiSvgIcon'
})($c1847dc22fee4a01$var$SvgIcon);

});
parcelRegister("lfiYO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f779b8b0ef990dda$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");
function $f779b8b0ef990dda$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $cFLic.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("jtRae", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2e9f7015a5aa268$export$2e2bcd8739ae039; });
function $e2e9f7015a5aa268$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $e2e9f7015a5aa268$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $e2e9f7015a5aa268$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $e2e9f7015a5aa268$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e2e9f7015a5aa268$export$2e2bcd8739ae039 = $e2e9f7015a5aa268$export$4f5d2d50c9deca37;

});

parcelRegister("3Sc7z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d1fd1396d61783f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $9Ys8p = parcelRequire("9Ys8p");

var $11f0A = parcelRequire("11f0A");
function $2d1fd1396d61783f$var$withStyles(stylesOrCreator, options) {
    return (0, $9Ys8p.default)(stylesOrCreator, (0, $kY3Ke.default)({
        defaultTheme: (0, $11f0A.default)
    }, options));
}
var $2d1fd1396d61783f$export$2e2bcd8739ae039 = $2d1fd1396d61783f$var$withStyles;

});
parcelRegister("9Ys8p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742f8aa0af85a055$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $8Ae2G = parcelRequire("8Ae2G");


var $8SBLK = parcelRequire("8SBLK");

var $4mLf7 = parcelRequire("4mLf7");

var $qjAyq = parcelRequire("qjAyq");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $742f8aa0af85a055$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $lfiYO.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $8SBLK.default)(stylesOrCreator, (0, $kY3Ke.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $lfiYO.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $kY3Ke.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $qjAyq.default)() || defaultTheme;
                if (name) more = (0, $4mLf7.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, (0, $kY3Ke.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(WithStyles, Component);
        return WithStyles;
    };
};
var $742f8aa0af85a055$export$2e2bcd8739ae039 = $742f8aa0af85a055$var$withStyles;

});
parcelRegister("8Ae2G", function(module, exports) {
'use strict';

var $dOv1V = parcelRequire("dOv1V");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dOv1V.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRegister("dOv1V", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3oWWu"));

});


parcelRegister("8SBLK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6770aa0df1654af8$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $44Txg = parcelRequire("44Txg");

var $5lgEe = parcelRequire("5lgEe");

var $6iO8i = parcelRequire("6iO8i");

var $qjAyq = parcelRequire("qjAyq");

var $1sFhF = parcelRequire("1sFhF");

var $lC6DR = parcelRequire("lC6DR");

var $fRjr7 = parcelRequire("fRjr7");

var $5U1nW = parcelRequire("5U1nW");
function $6770aa0df1654af8$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $5lgEe.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $6770aa0df1654af8$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $6iO8i.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $6iO8i.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $kY3Ke.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $6iO8i.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $kY3Ke.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $6iO8i.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $44Txg.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $kY3Ke.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $5lgEe.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $6770aa0df1654af8$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $6770aa0df1654af8$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $6iO8i.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $6iO8i.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $6770aa0df1654af8$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $6770aa0df1654af8$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $5U1nW.default) : _options$defaultTheme, stylesOptions2 = (0, $lfiYO.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $fRjr7.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $lC6DR.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $qjAyq.default)() || defaultTheme;
        var stylesOptions = (0, $kY3Ke.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext((0, $1sFhF.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
        $6770aa0df1654af8$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $6770aa0df1654af8$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $6770aa0df1654af8$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
            if (shouldUpdate.current) $6770aa0df1654af8$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $6770aa0df1654af8$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("5lgEe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e3bd3dc0cde4bb2$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

function $3e3bd3dc0cde4bb2$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $kY3Ke.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("6iO8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $496b4fdb24be05f0$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $496b4fdb24be05f0$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $496b4fdb24be05f0$export$2e2bcd8739ae039 = $496b4fdb24be05f0$var$multiKeyStore;

});

parcelRegister("qjAyq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04f19fb51cdc1b19$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $9Pho7 = parcelRequire("9Pho7");
function $04f19fb51cdc1b19$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext((0, $9Pho7.default));
    return theme;
}

});
parcelRegister("9Pho7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72765d5a04729b8b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
var $72765d5a04729b8b$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
var $72765d5a04729b8b$export$2e2bcd8739ae039 = $72765d5a04729b8b$var$ThemeContext;

});


parcelRegister("1sFhF", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $11086e1f7e254e7d$export$f4de434b269fe487; });
$parcel$export(module.exports, "default", function () { return $11086e1f7e254e7d$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");



var $3azh1 = parcelRequire("3azh1");

var $44Txg = parcelRequire("44Txg");

var $2f7cf = parcelRequire("2f7cf");
var $11086e1f7e254e7d$var$jss = (0, $44Txg.create)((0, $2f7cf.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $11086e1f7e254e7d$var$generateClassName = (0, $3azh1.default)(); // Exported for test purposes
var $11086e1f7e254e7d$export$70a8aea9ff58d1cd = new Map();
var $11086e1f7e254e7d$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $11086e1f7e254e7d$var$generateClassName,
    jss: $11086e1f7e254e7d$var$jss,
    sheetsCache: null,
    sheetsManager: $11086e1f7e254e7d$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $11086e1f7e254e7d$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($11086e1f7e254e7d$var$defaultOptions);
var $11086e1f7e254e7d$var$injectFirstNode;
function $11086e1f7e254e7d$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $lfiYO.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($11086e1f7e254e7d$export$f4de434b269fe487);
    var context = (0, $kY3Ke.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!$11086e1f7e254e7d$var$injectFirstNode) {
            var head = document.head;
            $11086e1f7e254e7d$var$injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore($11086e1f7e254e7d$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $44Txg.create)({
            plugins: (0, $2f7cf.default)().plugins,
            insertionPoint: $11086e1f7e254e7d$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($11086e1f7e254e7d$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("3azh1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24edaae2b2cd3d08$export$2e2bcd8739ae039; });

var $dpn1r = parcelRequire("dpn1r");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $24edaae2b2cd3d08$var$pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
function $24edaae2b2cd3d08$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($24edaae2b2cd3d08$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $dpn1r.default] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("dpn1r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c2f77ebe7334565$export$2e2bcd8739ae039; });
var $9c2f77ebe7334565$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $9c2f77ebe7334565$export$2e2bcd8739ae039 = $9c2f77ebe7334565$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("2f7cf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a2290961d7ef227$export$2e2bcd8739ae039; });

var $hQ0MI = parcelRequire("hQ0MI");

var $iHUoJ = parcelRequire("iHUoJ");

var $2st1L = parcelRequire("2st1L");

var $8UI4A = parcelRequire("8UI4A");

var $HJOoC = parcelRequire("HJOoC");

var $k1ICi = parcelRequire("k1ICi");

var $ereeq = parcelRequire("ereeq");
function $1a2290961d7ef227$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $hQ0MI.default)(),
            (0, $iHUoJ.default)(),
            (0, $2st1L.default)(),
            (0, $8UI4A.default)(),
            (0, $HJOoC.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $k1ICi.default)(),
            (0, $ereeq.default)()
        ]
    };
}

});
parcelRegister("hQ0MI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfc7e6da35572a9f$export$2e2bcd8739ae039; });


var $44Txg = parcelRequire("44Txg");
var $cfc7e6da35572a9f$var$now = Date.now();
var $cfc7e6da35572a9f$var$fnValuesNs = "fnValues" + $cfc7e6da35572a9f$var$now;
var $cfc7e6da35572a9f$var$fnRuleNs = "fnStyle" + ++$cfc7e6da35572a9f$var$now;
var $cfc7e6da35572a9f$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $44Txg.createRule)(name, {}, options);
            rule[$cfc7e6da35572a9f$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($cfc7e6da35572a9f$var$fnValuesNs in rule || $cfc7e6da35572a9f$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$cfc7e6da35572a9f$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$cfc7e6da35572a9f$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$cfc7e6da35572a9f$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $cfc7e6da35572a9f$export$2e2bcd8739ae039 = $cfc7e6da35572a9f$var$functionPlugin;

});

parcelRegister("iHUoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9e7fd9a87ac63d8$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $44Txg = parcelRequire("44Txg");
var $d9e7fd9a87ac63d8$var$at = '@global';
var $d9e7fd9a87ac63d8$var$atPrefix = '@global ';
var $d9e7fd9a87ac63d8$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $d9e7fd9a87ac63d8$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $44Txg.RuleList)((0, $kY3Ke.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $d9e7fd9a87ac63d8$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $d9e7fd9a87ac63d8$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($d9e7fd9a87ac63d8$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $kY3Ke.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $d9e7fd9a87ac63d8$var$separatorRegExp = /\s*,\s*/g;
function $d9e7fd9a87ac63d8$var$addScope(selector, scope) {
    var parts = selector.split($d9e7fd9a87ac63d8$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $d9e7fd9a87ac63d8$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$d9e7fd9a87ac63d8$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $kY3Ke.default)({}, options, {
        selector: $d9e7fd9a87ac63d8$var$addScope(name, rule.selector)
    }));
    delete style[$d9e7fd9a87ac63d8$var$at];
}
function $d9e7fd9a87ac63d8$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $d9e7fd9a87ac63d8$var$at.length) !== $d9e7fd9a87ac63d8$var$at) continue;
        var selector = $d9e7fd9a87ac63d8$var$addScope(prop.substr($d9e7fd9a87ac63d8$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $kY3Ke.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $d9e7fd9a87ac63d8$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $d9e7fd9a87ac63d8$var$at) return new $d9e7fd9a87ac63d8$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $d9e7fd9a87ac63d8$var$atPrefix.length) === $d9e7fd9a87ac63d8$var$atPrefix) return new $d9e7fd9a87ac63d8$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $d9e7fd9a87ac63d8$var$handleNestedGlobalContainerRule(rule, sheet);
        $d9e7fd9a87ac63d8$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $d9e7fd9a87ac63d8$export$2e2bcd8739ae039 = $d9e7fd9a87ac63d8$var$jssGlobal;

});

parcelRegister("2st1L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca4b68b05337263$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $1ca4b68b05337263$var$separatorRegExp = /\s*,\s*/g;
var $1ca4b68b05337263$var$parentRegExp = /&/g;
var $1ca4b68b05337263$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1ca4b68b05337263$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($1ca4b68b05337263$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($1ca4b68b05337263$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($1ca4b68b05337263$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $kY3Ke.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $kY3Ke.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($1ca4b68b05337263$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $kY3Ke.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $kY3Ke.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $1ca4b68b05337263$export$2e2bcd8739ae039 = $1ca4b68b05337263$var$jssNested;

});

parcelRegister("8UI4A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67d5bda86214f661$export$2e2bcd8739ae039; });

var $2l6VF = parcelRequire("2l6VF");
/**
 * Convert camel cased property names to dash separated.
 */ function $67d5bda86214f661$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $2l6VF.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($67d5bda86214f661$var$convertCase);
        else converted.fallbacks = $67d5bda86214f661$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $67d5bda86214f661$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $67d5bda86214f661$var$convertCase(style[index]);
            return style;
        }
        return $67d5bda86214f661$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $2l6VF.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $67d5bda86214f661$export$2e2bcd8739ae039 = $67d5bda86214f661$var$camelCase;

});
parcelRegister("2l6VF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b42eaed349bc9b0$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $1b42eaed349bc9b0$var$uppercasePattern = /[A-Z]/g;
var $1b42eaed349bc9b0$var$msPattern = /^ms-/;
var $1b42eaed349bc9b0$var$cache = {};
function $1b42eaed349bc9b0$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $1b42eaed349bc9b0$var$hyphenateStyleName(name) {
    if ($1b42eaed349bc9b0$var$cache.hasOwnProperty(name)) return $1b42eaed349bc9b0$var$cache[name];
    var hName = name.replace($1b42eaed349bc9b0$var$uppercasePattern, $1b42eaed349bc9b0$var$toHyphenLower);
    return $1b42eaed349bc9b0$var$cache[name] = $1b42eaed349bc9b0$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $1b42eaed349bc9b0$export$2e2bcd8739ae039 = $1b42eaed349bc9b0$var$hyphenateStyleName;

});


parcelRegister("HJOoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08378d8b5b0526fb$export$2e2bcd8739ae039; });

var $44Txg = parcelRequire("44Txg");
var $08378d8b5b0526fb$var$px = (0, $44Txg.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $08378d8b5b0526fb$var$ms = (0, $44Txg.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $08378d8b5b0526fb$var$percent = (0, $44Txg.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $08378d8b5b0526fb$var$defaultUnits = {
    // Animation properties
    'animation-delay': $08378d8b5b0526fb$var$ms,
    'animation-duration': $08378d8b5b0526fb$var$ms,
    // Background properties
    'background-position': $08378d8b5b0526fb$var$px,
    'background-position-x': $08378d8b5b0526fb$var$px,
    'background-position-y': $08378d8b5b0526fb$var$px,
    'background-size': $08378d8b5b0526fb$var$px,
    // Border Properties
    border: $08378d8b5b0526fb$var$px,
    'border-bottom': $08378d8b5b0526fb$var$px,
    'border-bottom-left-radius': $08378d8b5b0526fb$var$px,
    'border-bottom-right-radius': $08378d8b5b0526fb$var$px,
    'border-bottom-width': $08378d8b5b0526fb$var$px,
    'border-left': $08378d8b5b0526fb$var$px,
    'border-left-width': $08378d8b5b0526fb$var$px,
    'border-radius': $08378d8b5b0526fb$var$px,
    'border-right': $08378d8b5b0526fb$var$px,
    'border-right-width': $08378d8b5b0526fb$var$px,
    'border-top': $08378d8b5b0526fb$var$px,
    'border-top-left-radius': $08378d8b5b0526fb$var$px,
    'border-top-right-radius': $08378d8b5b0526fb$var$px,
    'border-top-width': $08378d8b5b0526fb$var$px,
    'border-width': $08378d8b5b0526fb$var$px,
    'border-block': $08378d8b5b0526fb$var$px,
    'border-block-end': $08378d8b5b0526fb$var$px,
    'border-block-end-width': $08378d8b5b0526fb$var$px,
    'border-block-start': $08378d8b5b0526fb$var$px,
    'border-block-start-width': $08378d8b5b0526fb$var$px,
    'border-block-width': $08378d8b5b0526fb$var$px,
    'border-inline': $08378d8b5b0526fb$var$px,
    'border-inline-end': $08378d8b5b0526fb$var$px,
    'border-inline-end-width': $08378d8b5b0526fb$var$px,
    'border-inline-start': $08378d8b5b0526fb$var$px,
    'border-inline-start-width': $08378d8b5b0526fb$var$px,
    'border-inline-width': $08378d8b5b0526fb$var$px,
    'border-start-start-radius': $08378d8b5b0526fb$var$px,
    'border-start-end-radius': $08378d8b5b0526fb$var$px,
    'border-end-start-radius': $08378d8b5b0526fb$var$px,
    'border-end-end-radius': $08378d8b5b0526fb$var$px,
    // Margin properties
    margin: $08378d8b5b0526fb$var$px,
    'margin-bottom': $08378d8b5b0526fb$var$px,
    'margin-left': $08378d8b5b0526fb$var$px,
    'margin-right': $08378d8b5b0526fb$var$px,
    'margin-top': $08378d8b5b0526fb$var$px,
    'margin-block': $08378d8b5b0526fb$var$px,
    'margin-block-end': $08378d8b5b0526fb$var$px,
    'margin-block-start': $08378d8b5b0526fb$var$px,
    'margin-inline': $08378d8b5b0526fb$var$px,
    'margin-inline-end': $08378d8b5b0526fb$var$px,
    'margin-inline-start': $08378d8b5b0526fb$var$px,
    // Padding properties
    padding: $08378d8b5b0526fb$var$px,
    'padding-bottom': $08378d8b5b0526fb$var$px,
    'padding-left': $08378d8b5b0526fb$var$px,
    'padding-right': $08378d8b5b0526fb$var$px,
    'padding-top': $08378d8b5b0526fb$var$px,
    'padding-block': $08378d8b5b0526fb$var$px,
    'padding-block-end': $08378d8b5b0526fb$var$px,
    'padding-block-start': $08378d8b5b0526fb$var$px,
    'padding-inline': $08378d8b5b0526fb$var$px,
    'padding-inline-end': $08378d8b5b0526fb$var$px,
    'padding-inline-start': $08378d8b5b0526fb$var$px,
    // Mask properties
    'mask-position-x': $08378d8b5b0526fb$var$px,
    'mask-position-y': $08378d8b5b0526fb$var$px,
    'mask-size': $08378d8b5b0526fb$var$px,
    // Width and height properties
    height: $08378d8b5b0526fb$var$px,
    width: $08378d8b5b0526fb$var$px,
    'min-height': $08378d8b5b0526fb$var$px,
    'max-height': $08378d8b5b0526fb$var$px,
    'min-width': $08378d8b5b0526fb$var$px,
    'max-width': $08378d8b5b0526fb$var$px,
    // Position properties
    bottom: $08378d8b5b0526fb$var$px,
    left: $08378d8b5b0526fb$var$px,
    top: $08378d8b5b0526fb$var$px,
    right: $08378d8b5b0526fb$var$px,
    inset: $08378d8b5b0526fb$var$px,
    'inset-block': $08378d8b5b0526fb$var$px,
    'inset-block-end': $08378d8b5b0526fb$var$px,
    'inset-block-start': $08378d8b5b0526fb$var$px,
    'inset-inline': $08378d8b5b0526fb$var$px,
    'inset-inline-end': $08378d8b5b0526fb$var$px,
    'inset-inline-start': $08378d8b5b0526fb$var$px,
    // Shadow properties
    'box-shadow': $08378d8b5b0526fb$var$px,
    'text-shadow': $08378d8b5b0526fb$var$px,
    // Column properties
    'column-gap': $08378d8b5b0526fb$var$px,
    'column-rule': $08378d8b5b0526fb$var$px,
    'column-rule-width': $08378d8b5b0526fb$var$px,
    'column-width': $08378d8b5b0526fb$var$px,
    // Font and text properties
    'font-size': $08378d8b5b0526fb$var$px,
    'font-size-delta': $08378d8b5b0526fb$var$px,
    'letter-spacing': $08378d8b5b0526fb$var$px,
    'text-decoration-thickness': $08378d8b5b0526fb$var$px,
    'text-indent': $08378d8b5b0526fb$var$px,
    'text-stroke': $08378d8b5b0526fb$var$px,
    'text-stroke-width': $08378d8b5b0526fb$var$px,
    'word-spacing': $08378d8b5b0526fb$var$px,
    // Motion properties
    motion: $08378d8b5b0526fb$var$px,
    'motion-offset': $08378d8b5b0526fb$var$px,
    // Outline properties
    outline: $08378d8b5b0526fb$var$px,
    'outline-offset': $08378d8b5b0526fb$var$px,
    'outline-width': $08378d8b5b0526fb$var$px,
    // Perspective properties
    perspective: $08378d8b5b0526fb$var$px,
    'perspective-origin-x': $08378d8b5b0526fb$var$percent,
    'perspective-origin-y': $08378d8b5b0526fb$var$percent,
    // Transform properties
    'transform-origin': $08378d8b5b0526fb$var$percent,
    'transform-origin-x': $08378d8b5b0526fb$var$percent,
    'transform-origin-y': $08378d8b5b0526fb$var$percent,
    'transform-origin-z': $08378d8b5b0526fb$var$percent,
    // Transition properties
    'transition-delay': $08378d8b5b0526fb$var$ms,
    'transition-duration': $08378d8b5b0526fb$var$ms,
    // Alignment properties
    'vertical-align': $08378d8b5b0526fb$var$px,
    'flex-basis': $08378d8b5b0526fb$var$px,
    // Some random properties
    'shape-margin': $08378d8b5b0526fb$var$px,
    size: $08378d8b5b0526fb$var$px,
    gap: $08378d8b5b0526fb$var$px,
    // Grid properties
    grid: $08378d8b5b0526fb$var$px,
    'grid-gap': $08378d8b5b0526fb$var$px,
    'row-gap': $08378d8b5b0526fb$var$px,
    'grid-row-gap': $08378d8b5b0526fb$var$px,
    'grid-column-gap': $08378d8b5b0526fb$var$px,
    'grid-template-rows': $08378d8b5b0526fb$var$px,
    'grid-template-columns': $08378d8b5b0526fb$var$px,
    'grid-auto-rows': $08378d8b5b0526fb$var$px,
    'grid-auto-columns': $08378d8b5b0526fb$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $08378d8b5b0526fb$var$px,
    'box-shadow-y': $08378d8b5b0526fb$var$px,
    'box-shadow-blur': $08378d8b5b0526fb$var$px,
    'box-shadow-spread': $08378d8b5b0526fb$var$px,
    'font-line-height': $08378d8b5b0526fb$var$px,
    'text-shadow-x': $08378d8b5b0526fb$var$px,
    'text-shadow-y': $08378d8b5b0526fb$var$px,
    'text-shadow-blur': $08378d8b5b0526fb$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $08378d8b5b0526fb$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $08378d8b5b0526fb$var$units = $08378d8b5b0526fb$var$addCamelCasedVersion($08378d8b5b0526fb$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $08378d8b5b0526fb$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $08378d8b5b0526fb$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $08378d8b5b0526fb$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $08378d8b5b0526fb$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $08378d8b5b0526fb$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $08378d8b5b0526fb$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $08378d8b5b0526fb$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $08378d8b5b0526fb$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $08378d8b5b0526fb$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $08378d8b5b0526fb$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $08378d8b5b0526fb$export$2e2bcd8739ae039 = $08378d8b5b0526fb$var$defaultUnit;

});

parcelRegister("k1ICi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9468291f7d3e685$export$2e2bcd8739ae039; });

var $8Ne5j = parcelRequire("8Ne5j");

var $44Txg = parcelRequire("44Txg");
/**
 * Add vendor prefix to a property name when needed.
 */ function $e9468291f7d3e685$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $8Ne5j.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $8Ne5j.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $8Ne5j.supportedValue)(supportedProp, (0, $44Txg.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $8Ne5j.supportedValue)(prop, (0, $44Txg.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $e9468291f7d3e685$export$2e2bcd8739ae039 = $e9468291f7d3e685$var$jssVendorPrefixer;

});
parcelRegister("8Ne5j", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $666dd33fa502ad5d$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $666dd33fa502ad5d$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $666dd33fa502ad5d$export$511766124059c277; });

var $8RSXT = parcelRequire("8RSXT");

var $cwJVy = parcelRequire("cwJVy");
// Export javascript style and css style vendor prefixes.
var $666dd33fa502ad5d$var$js = '';
var $666dd33fa502ad5d$var$css = '';
var $666dd33fa502ad5d$var$vendor = '';
var $666dd33fa502ad5d$var$browser = '';
var $666dd33fa502ad5d$var$isTouch = (0, $8RSXT.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $8RSXT.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $666dd33fa502ad5d$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $666dd33fa502ad5d$var$_document$createEleme = document.createElement('p'), $666dd33fa502ad5d$var$style = $666dd33fa502ad5d$var$_document$createEleme.style;
    var $666dd33fa502ad5d$var$testProp = 'Transform';
    for(var $666dd33fa502ad5d$var$key in $666dd33fa502ad5d$var$jsCssMap)if ($666dd33fa502ad5d$var$key + $666dd33fa502ad5d$var$testProp in $666dd33fa502ad5d$var$style) {
        $666dd33fa502ad5d$var$js = $666dd33fa502ad5d$var$key;
        $666dd33fa502ad5d$var$css = $666dd33fa502ad5d$var$jsCssMap[$666dd33fa502ad5d$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($666dd33fa502ad5d$var$js === 'Webkit' && 'msHyphens' in $666dd33fa502ad5d$var$style) {
        $666dd33fa502ad5d$var$js = 'ms';
        $666dd33fa502ad5d$var$css = $666dd33fa502ad5d$var$jsCssMap.ms;
        $666dd33fa502ad5d$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($666dd33fa502ad5d$var$js === 'Webkit' && '-apple-trailing-word' in $666dd33fa502ad5d$var$style) $666dd33fa502ad5d$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $666dd33fa502ad5d$export$82e9f45cca5ba907 = {
    js: $666dd33fa502ad5d$var$js,
    css: $666dd33fa502ad5d$var$css,
    vendor: $666dd33fa502ad5d$var$vendor,
    browser: $666dd33fa502ad5d$var$browser,
    isTouch: $666dd33fa502ad5d$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $666dd33fa502ad5d$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $666dd33fa502ad5d$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $666dd33fa502ad5d$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $666dd33fa502ad5d$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Webkit') return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $666dd33fa502ad5d$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $666dd33fa502ad5d$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $666dd33fa502ad5d$var$camelize(str) {
    return str.replace($666dd33fa502ad5d$var$regExp, $666dd33fa502ad5d$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $666dd33fa502ad5d$var$pascalize(str) {
    return $666dd33fa502ad5d$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $666dd33fa502ad5d$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($666dd33fa502ad5d$var$camelize(longhand) in style) return prop;
            if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(longhand) in style) return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $666dd33fa502ad5d$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.vendor === 'apple' && !$666dd33fa502ad5d$export$82e9f45cca5ba907.isTouch) return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $666dd33fa502ad5d$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $666dd33fa502ad5d$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $666dd33fa502ad5d$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Webkit' || $666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms' && $666dd33fa502ad5d$export$82e9f45cca5ba907.browser !== 'edge') return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $666dd33fa502ad5d$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Moz' || $666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms' || $666dd33fa502ad5d$export$82e9f45cca5ba907.vendor === 'apple') return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $666dd33fa502ad5d$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $666dd33fa502ad5d$var$pascalize(prop);
            return jsProp in style ? $666dd33fa502ad5d$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $666dd33fa502ad5d$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $666dd33fa502ad5d$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(newProp) in style ? $666dd33fa502ad5d$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $666dd33fa502ad5d$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $666dd33fa502ad5d$var$camelize(prop) in style ? prop : false;
    }
};
var $666dd33fa502ad5d$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $666dd33fa502ad5d$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js + pascalized in style) return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $666dd33fa502ad5d$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms') return "" + $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $666dd33fa502ad5d$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($666dd33fa502ad5d$export$82e9f45cca5ba907.js === 'ms') return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $666dd33fa502ad5d$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $666dd33fa502ad5d$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $666dd33fa502ad5d$var$propMap[prop];
        if (!newProp) return false;
        return $666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(newProp) in style ? $666dd33fa502ad5d$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $666dd33fa502ad5d$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $666dd33fa502ad5d$var$propKeys = Object.keys($666dd33fa502ad5d$var$propMap$1);
var $666dd33fa502ad5d$var$prefixCss = function prefixCss(p) {
    return $666dd33fa502ad5d$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $666dd33fa502ad5d$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($666dd33fa502ad5d$var$propKeys.indexOf(prop) > -1) {
            var newProp = $666dd33fa502ad5d$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(newProp) in style ? $666dd33fa502ad5d$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($666dd33fa502ad5d$export$82e9f45cca5ba907.js + $666dd33fa502ad5d$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($666dd33fa502ad5d$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $666dd33fa502ad5d$var$plugins = [
    $666dd33fa502ad5d$var$appearence,
    $666dd33fa502ad5d$var$colorAdjust,
    $666dd33fa502ad5d$var$mask,
    $666dd33fa502ad5d$var$textOrientation,
    $666dd33fa502ad5d$var$transform,
    $666dd33fa502ad5d$var$transition,
    $666dd33fa502ad5d$var$writingMode,
    $666dd33fa502ad5d$var$userSelect,
    $666dd33fa502ad5d$var$breakPropsOld,
    $666dd33fa502ad5d$var$inlineLogicalOld,
    $666dd33fa502ad5d$var$unprefixed,
    $666dd33fa502ad5d$var$prefixed,
    $666dd33fa502ad5d$var$scrollSnap,
    $666dd33fa502ad5d$var$overscrollBehavior,
    $666dd33fa502ad5d$var$flex2012,
    $666dd33fa502ad5d$var$flex2009
];
var $666dd33fa502ad5d$var$propertyDetectors = $666dd33fa502ad5d$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $666dd33fa502ad5d$var$noPrefill = $666dd33fa502ad5d$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $cwJVy.default)(p.noPrefill));
    return a;
}, []);
var $666dd33fa502ad5d$var$el;
var $666dd33fa502ad5d$var$cache = {};
if (0, $8RSXT.default) {
    $666dd33fa502ad5d$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $666dd33fa502ad5d$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $666dd33fa502ad5d$var$key$1 in $666dd33fa502ad5d$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($666dd33fa502ad5d$var$key$1)) $666dd33fa502ad5d$var$cache[$666dd33fa502ad5d$var$computed[$666dd33fa502ad5d$var$key$1]] = $666dd33fa502ad5d$var$computed[$666dd33fa502ad5d$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $666dd33fa502ad5d$var$noPrefill.forEach(function(x) {
        return delete $666dd33fa502ad5d$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $666dd33fa502ad5d$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$666dd33fa502ad5d$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($666dd33fa502ad5d$var$cache[prop] != null) return $666dd33fa502ad5d$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $666dd33fa502ad5d$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $666dd33fa502ad5d$var$propertyDetectors.length; i++){
        $666dd33fa502ad5d$var$cache[prop] = $666dd33fa502ad5d$var$propertyDetectors[i](prop, $666dd33fa502ad5d$var$el.style, options); // Break loop, if value found.
        if ($666dd33fa502ad5d$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $666dd33fa502ad5d$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $666dd33fa502ad5d$var$cache[prop];
}
var $666dd33fa502ad5d$var$cache$1 = {};
var $666dd33fa502ad5d$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $666dd33fa502ad5d$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $666dd33fa502ad5d$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $666dd33fa502ad5d$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $666dd33fa502ad5d$export$ce097f82c2e4551a(p1) : ", " + $666dd33fa502ad5d$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $8RSXT.default) $666dd33fa502ad5d$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $666dd33fa502ad5d$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$666dd33fa502ad5d$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($666dd33fa502ad5d$var$cache$1[cacheKey] != null) return $666dd33fa502ad5d$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $666dd33fa502ad5d$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $666dd33fa502ad5d$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($666dd33fa502ad5d$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($666dd33fa502ad5d$var$transPropsRegExp, $666dd33fa502ad5d$var$prefixTransitionCallback);
    else if ($666dd33fa502ad5d$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $666dd33fa502ad5d$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $666dd33fa502ad5d$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $666dd33fa502ad5d$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($666dd33fa502ad5d$var$el$1.style[property] === '') {
            $666dd33fa502ad5d$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $666dd33fa502ad5d$var$el$1.style[property] = ''; // Write current value to cache.
    $666dd33fa502ad5d$var$cache$1[cacheKey] = prefixedValue;
    return $666dd33fa502ad5d$var$cache$1[cacheKey];
}

});
parcelRegister("cwJVy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91ec1961173e898a$export$2e2bcd8739ae039; });

var $hogKY = parcelRequire("hogKY");

var $1DcFf = parcelRequire("1DcFf");

var $6A22e = parcelRequire("6A22e");

var $aqkvt = parcelRequire("aqkvt");
function $91ec1961173e898a$export$2e2bcd8739ae039(r) {
    return (0, $hogKY.default)(r) || (0, $1DcFf.default)(r) || (0, $6A22e.default)(r) || (0, $aqkvt.default)();
}

});
parcelRegister("hogKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca91ad18e54285de$export$2e2bcd8739ae039; });

var $9A91F = parcelRequire("9A91F");
function $ca91ad18e54285de$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9A91F.default)(r);
}

});
parcelRegister("9A91F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f9e7a38a1550ef5$export$2e2bcd8739ae039; });
function $6f9e7a38a1550ef5$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("1DcFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $130341d5473c4bb5$export$2e2bcd8739ae039; });
function $130341d5473c4bb5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6A22e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca7aef5b7b26ccf$export$2e2bcd8739ae039; });

var $9A91F = parcelRequire("9A91F");
function $4ca7aef5b7b26ccf$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9A91F.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9A91F.default)(r, a) : void 0;
    }
}

});

parcelRegister("aqkvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $796c3d48dfd34a55$export$2e2bcd8739ae039; });
function $796c3d48dfd34a55$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("ereeq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a82ea068e11a8bb7$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $a82ea068e11a8bb7$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $a82ea068e11a8bb7$export$2e2bcd8739ae039 = $a82ea068e11a8bb7$var$jssPropsSort;

});



parcelRegister("lC6DR", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $fbc24c8a3a7273f5$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $fbc24c8a3a7273f5$var$indexCounter = -1000000000;
function $fbc24c8a3a7273f5$export$a2647aa13413c947() {
    $fbc24c8a3a7273f5$var$indexCounter += 1;
    return $fbc24c8a3a7273f5$var$indexCounter;
}

});

parcelRegister("fRjr7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8bae1f03dc88f11$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("6TO5S");

var $belNS = parcelRequire("belNS");

function $b8bae1f03dc88f11$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $kY3Ke.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $belNS.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("belNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82d1ea3856aa84de$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $6TO5S = parcelRequire("6TO5S");
function $82d1ea3856aa84de$export$53b83ca8eaab0383(item) {
    return item && (0, $6TO5S.default)(item) === 'object' && item.constructor === Object;
}
function $82d1ea3856aa84de$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $kY3Ke.default)({}, target) : target;
    if ($82d1ea3856aa84de$export$53b83ca8eaab0383(target) && $82d1ea3856aa84de$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($82d1ea3856aa84de$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $82d1ea3856aa84de$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});


parcelRegister("5U1nW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44c341c4411ec330$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $44c341c4411ec330$var$noopTheme = {};
var $44c341c4411ec330$export$2e2bcd8739ae039 = $44c341c4411ec330$var$noopTheme;

});


parcelRegister("4mLf7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32dddcee9c992506$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $32dddcee9c992506$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("11f0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0be186d51ba4e7b4$export$2e2bcd8739ae039; });

var $baumZ = parcelRequire("baumZ");
var $0be186d51ba4e7b4$var$defaultTheme = (0, $baumZ.default)();
var $0be186d51ba4e7b4$export$2e2bcd8739ae039 = $0be186d51ba4e7b4$var$defaultTheme;

});
parcelRegister("baumZ", function(module, exports) {

$parcel$export(module.exports, "createMuiTheme", function () { return $82182fb36768db67$export$c469355549431d9b; });
$parcel$export(module.exports, "default", function () { return $82182fb36768db67$export$2e2bcd8739ae039; });
parcelRequire("dQMrF");

var $lfiYO = parcelRequire("lfiYO");

var $belNS = parcelRequire("belNS");

var $73Zof = parcelRequire("73Zof");

var $9Ki4d = parcelRequire("9Ki4d");

var $h7QOt = parcelRequire("h7QOt");

var $4aB3i = parcelRequire("4aB3i");

var $8SI4M = parcelRequire("8SI4M");

var $klLaD = parcelRequire("klLaD");

var $9mZij = parcelRequire("9mZij");

var $etJ3Q = parcelRequire("etJ3Q");

var $ep8x4 = parcelRequire("ep8x4");
function $82182fb36768db67$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $lfiYO.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $h7QOt.default)(paletteInput);
    var breakpoints = (0, $73Zof.default)(breakpointsInput);
    var spacing = (0, $9mZij.default)(spacingInput);
    var muiTheme = (0, $belNS.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $9Ki4d.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $8SI4M.default),
        typography: (0, $4aB3i.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $klLaD.default),
        transitions: (0, $etJ3Q.default),
        zIndex: (0, $ep8x4.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $belNS.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $82182fb36768db67$var$warnedOnce = false;
function $82182fb36768db67$export$c469355549431d9b() {
    return $82182fb36768db67$var$createTheme.apply(void 0, arguments);
}
var $82182fb36768db67$export$2e2bcd8739ae039 = $82182fb36768db67$var$createTheme;

});
parcelRegister("dQMrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a155b5e75cfe9a4d$export$2e2bcd8739ae039; });

var $aYCSV = parcelRequire("aYCSV");
function $a155b5e75cfe9a4d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $aYCSV.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("73Zof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52486f03e1d1cf0e$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");
var $52486f03e1d1cf0e$export$ed97f33186d4b816 = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $52486f03e1d1cf0e$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $lfiYO.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $52486f03e1d1cf0e$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$52486f03e1d1cf0e$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $52486f03e1d1cf0e$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $52486f03e1d1cf0e$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $52486f03e1d1cf0e$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$52486f03e1d1cf0e$export$ed97f33186d4b816[endIndex + 1]] === 'number' ? values[$52486f03e1d1cf0e$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $kY3Ke.default)({
        keys: $52486f03e1d1cf0e$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("9Ki4d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71866ca77f79561c$export$2e2bcd8739ae039; });

var $dQMrF = parcelRequire("dQMrF");

var $kY3Ke = parcelRequire("kY3Ke");
function $71866ca77f79561c$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $kY3Ke.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $kY3Ke.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $dQMrF.default)({}, breakpoints.up('sm'), (0, $kY3Ke.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $dQMrF.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $dQMrF.default)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("h7QOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c77c0eb7af060821$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $belNS = parcelRequire("belNS");
var $2dHXF = parcelRequire("2dHXF");

var $e8d4o = parcelRequire("e8d4o");

var $k03mY = parcelRequire("k03mY");

var $jZSZ2 = parcelRequire("jZSZ2");

var $cd81v = parcelRequire("cd81v");

var $1OsIT = parcelRequire("1OsIT");

var $7OPUd = parcelRequire("7OPUd");

var $iozeL = parcelRequire("iozeL");

var $cmHIq = parcelRequire("cmHIq");

var $2jEfe = parcelRequire("2jEfe");
var $c77c0eb7af060821$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $e8d4o.default).white,
        default: (0, $k03mY.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $c77c0eb7af060821$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $e8d4o.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: (0, $k03mY.default)[800],
        default: '#303030'
    },
    action: {
        active: (0, $e8d4o.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $c77c0eb7af060821$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $2jEfe.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $2jEfe.darken)(intent.main, tonalOffsetDark);
    }
}
function $c77c0eb7af060821$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $jZSZ2.default)[300],
        main: (0, $jZSZ2.default)[500],
        dark: (0, $jZSZ2.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $cd81v.default).A200,
        main: (0, $cd81v.default).A400,
        dark: (0, $cd81v.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $1OsIT.default)[300],
        main: (0, $1OsIT.default)[500],
        dark: (0, $1OsIT.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $7OPUd.default)[300],
        main: (0, $7OPUd.default)[500],
        dark: (0, $7OPUd.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $iozeL.default)[300],
        main: (0, $iozeL.default)[500],
        dark: (0, $iozeL.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $cmHIq.default)[300],
        main: (0, $cmHIq.default)[500],
        dark: (0, $cmHIq.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $lfiYO.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $2jEfe.getContrastRatio)(background, $c77c0eb7af060821$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $c77c0eb7af060821$export$55ce6f3a06c59543.text.primary : $c77c0eb7af060821$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $kY3Ke.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $2dHXF.default)(4, mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $2dHXF.default)(5, JSON.stringify(color.main)));
        $c77c0eb7af060821$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $c77c0eb7af060821$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $c77c0eb7af060821$export$55ce6f3a06c59543,
        light: $c77c0eb7af060821$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $belNS.default)((0, $kY3Ke.default)({
        // A collection of common colors.
        common: (0, $e8d4o.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $k03mY.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("2dHXF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19dee57cd24e0b67$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $19dee57cd24e0b67$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = 'https://mui.com/production-error/?code=' + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});

parcelRegister("e8d4o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a49bf374448b9fc5$export$2e2bcd8739ae039; });
var $a49bf374448b9fc5$var$common = {
    black: '#000',
    white: '#fff'
};
var $a49bf374448b9fc5$export$2e2bcd8739ae039 = $a49bf374448b9fc5$var$common;

});

parcelRegister("k03mY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8f66be0e3874be3$export$2e2bcd8739ae039; });
var $e8f66be0e3874be3$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $e8f66be0e3874be3$export$2e2bcd8739ae039 = $e8f66be0e3874be3$var$grey;

});

parcelRegister("jZSZ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8ee5d6d37837375$export$2e2bcd8739ae039; });
var $e8ee5d6d37837375$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $e8ee5d6d37837375$export$2e2bcd8739ae039 = $e8ee5d6d37837375$var$indigo;

});

parcelRegister("cd81v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e3cec340889a0a4$export$2e2bcd8739ae039; });
var $8e3cec340889a0a4$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $8e3cec340889a0a4$export$2e2bcd8739ae039 = $8e3cec340889a0a4$var$pink;

});

parcelRegister("1OsIT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1520bdc021d884e4$export$2e2bcd8739ae039; });
var $1520bdc021d884e4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $1520bdc021d884e4$export$2e2bcd8739ae039 = $1520bdc021d884e4$var$red;

});

parcelRegister("7OPUd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b15774c11c66319$export$2e2bcd8739ae039; });
var $5b15774c11c66319$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $5b15774c11c66319$export$2e2bcd8739ae039 = $5b15774c11c66319$var$orange;

});

parcelRegister("iozeL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d645cd3cde5fd0f4$export$2e2bcd8739ae039; });
var $d645cd3cde5fd0f4$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $d645cd3cde5fd0f4$export$2e2bcd8739ae039 = $d645cd3cde5fd0f4$var$blue;

});

parcelRegister("cmHIq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $900973193536dad6$export$2e2bcd8739ae039; });
var $900973193536dad6$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $900973193536dad6$export$2e2bcd8739ae039 = $900973193536dad6$var$green;

});

parcelRegister("2jEfe", function(module, exports) {

$parcel$export(module.exports, "hexToRgb", function () { return $1afc92da9459c293$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "rgbToHex", function () { return $1afc92da9459c293$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "decomposeColor", function () { return $1afc92da9459c293$export$677b39864803984e; });
$parcel$export(module.exports, "hslToRgb", function () { return $1afc92da9459c293$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "recomposeColor", function () { return $1afc92da9459c293$export$211a73f2b8c10ce4; });
$parcel$export(module.exports, "getContrastRatio", function () { return $1afc92da9459c293$export$d061e26956a60b0a; });
$parcel$export(module.exports, "getLuminance", function () { return $1afc92da9459c293$export$c852d90bf7403b62; });
$parcel$export(module.exports, "emphasize", function () { return $1afc92da9459c293$export$e665714f76e581fd; });
$parcel$export(module.exports, "darken", function () { return $1afc92da9459c293$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $1afc92da9459c293$export$c0816ed86df316af; });
$parcel$export(module.exports, "fade", function () { return $1afc92da9459c293$export$cbea29d068a2e18f; });
$parcel$export(module.exports, "alpha", function () { return $1afc92da9459c293$export$58f0f39f63f3cf42; });

var $2dHXF = parcelRequire("2dHXF");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $1afc92da9459c293$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $1afc92da9459c293$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $1afc92da9459c293$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $1afc92da9459c293$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $1afc92da9459c293$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $1afc92da9459c293$var$intToHex(n);
    }).join(''));
}
function $1afc92da9459c293$export$29fb7152bd3f781a(color) {
    color = $1afc92da9459c293$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $1afc92da9459c293$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $1afc92da9459c293$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $1afc92da9459c293$export$677b39864803984e($1afc92da9459c293$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error((0, $2dHXF.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $1afc92da9459c293$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
function $1afc92da9459c293$export$d061e26956a60b0a(foreground, background) {
    var lumA = $1afc92da9459c293$export$c852d90bf7403b62(foreground);
    var lumB = $1afc92da9459c293$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $1afc92da9459c293$export$c852d90bf7403b62(color) {
    color = $1afc92da9459c293$export$677b39864803984e(color);
    var rgb = color.type === 'hsl' ? $1afc92da9459c293$export$677b39864803984e($1afc92da9459c293$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $1afc92da9459c293$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $1afc92da9459c293$export$c852d90bf7403b62(color) > 0.5 ? $1afc92da9459c293$export$4b073707ff63303(color, coefficient) : $1afc92da9459c293$export$c0816ed86df316af(color, coefficient);
}
var $1afc92da9459c293$var$warnedOnce = false;
function $1afc92da9459c293$export$cbea29d068a2e18f(color, value) {
    return $1afc92da9459c293$export$58f0f39f63f3cf42(color, value);
}
function $1afc92da9459c293$export$58f0f39f63f3cf42(color, value) {
    color = $1afc92da9459c293$export$677b39864803984e(color);
    value = $1afc92da9459c293$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $1afc92da9459c293$export$211a73f2b8c10ce4(color);
}
function $1afc92da9459c293$export$4b073707ff63303(color, coefficient) {
    color = $1afc92da9459c293$export$677b39864803984e(color);
    coefficient = $1afc92da9459c293$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $1afc92da9459c293$export$211a73f2b8c10ce4(color);
}
function $1afc92da9459c293$export$c0816ed86df316af(color, coefficient) {
    color = $1afc92da9459c293$export$677b39864803984e(color);
    coefficient = $1afc92da9459c293$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $1afc92da9459c293$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("4aB3i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3094d668b44e28b5$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $belNS = parcelRequire("belNS");
function $3094d668b44e28b5$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $3094d668b44e28b5$var$warnedOnce = false;
function $3094d668b44e28b5$var$roundWithDeprecationWarning(value) {
    return $3094d668b44e28b5$var$round(value);
}
var $3094d668b44e28b5$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $3094d668b44e28b5$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $3094d668b44e28b5$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $3094d668b44e28b5$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $lfiYO.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $kY3Ke.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $3094d668b44e28b5$var$defaultFontFamily ? {
            letterSpacing: "".concat($3094d668b44e28b5$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $3094d668b44e28b5$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $3094d668b44e28b5$var$caseAllCaps)
    };
    return (0, $belNS.default)((0, $kY3Ke.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $3094d668b44e28b5$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("8SI4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67758e7e7f998125$export$2e2bcd8739ae039; });
var $67758e7e7f998125$var$shadowKeyUmbraOpacity = 0.2;
var $67758e7e7f998125$var$shadowKeyPenumbraOpacity = 0.14;
var $67758e7e7f998125$var$shadowAmbientShadowOpacity = 0.12;
function $67758e7e7f998125$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($67758e7e7f998125$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($67758e7e7f998125$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($67758e7e7f998125$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $67758e7e7f998125$var$shadows = [
    'none',
    $67758e7e7f998125$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $67758e7e7f998125$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $67758e7e7f998125$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $67758e7e7f998125$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $67758e7e7f998125$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $67758e7e7f998125$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $67758e7e7f998125$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $67758e7e7f998125$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $67758e7e7f998125$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $67758e7e7f998125$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $67758e7e7f998125$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $67758e7e7f998125$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $67758e7e7f998125$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $67758e7e7f998125$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $67758e7e7f998125$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $67758e7e7f998125$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $67758e7e7f998125$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $67758e7e7f998125$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $67758e7e7f998125$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $67758e7e7f998125$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $67758e7e7f998125$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $67758e7e7f998125$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $67758e7e7f998125$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $67758e7e7f998125$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $67758e7e7f998125$export$2e2bcd8739ae039 = $67758e7e7f998125$var$shadows;

});

parcelRegister("klLaD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed0a5be855041830$export$2e2bcd8739ae039; });
var $ed0a5be855041830$var$shape = {
    borderRadius: 4
};
var $ed0a5be855041830$export$2e2bcd8739ae039 = $ed0a5be855041830$var$shape;

});

parcelRegister("9mZij", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d25b6eb1a86cead$export$2e2bcd8739ae039; });

var $aXuZY = parcelRequire("aXuZY");
var $6d25b6eb1a86cead$var$warnOnce;
function $6d25b6eb1a86cead$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $aXuZY.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("aXuZY", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $7fa775b8616abf44$export$1def6f833384e3d1; });
$parcel$export(module.exports, "default", function () { return $7fa775b8616abf44$export$2e2bcd8739ae039; });

var $2gIIh = parcelRequire("2gIIh");


var $c2PJn = parcelRequire("c2PJn");

var $cMoso = parcelRequire("cMoso");

var $53ZLU = parcelRequire("53ZLU");
var $7fa775b8616abf44$var$properties = {
    m: 'margin',
    p: 'padding'
};
var $7fa775b8616abf44$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
var $7fa775b8616abf44$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $7fa775b8616abf44$var$getCssProperties = (0, $53ZLU.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($7fa775b8616abf44$var$aliases[prop]) prop = $7fa775b8616abf44$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(''), _prop$split2 = (0, $2gIIh.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $7fa775b8616abf44$var$properties[a];
    var direction = $7fa775b8616abf44$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $7fa775b8616abf44$var$spacingKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY'
];
function $7fa775b8616abf44$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === 'number') return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return function() {
        return undefined;
    };
}
function $7fa775b8616abf44$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return "-".concat(transformed);
}
function $7fa775b8616abf44$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $7fa775b8616abf44$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $7fa775b8616abf44$var$spacing(props) {
    var theme = props.theme;
    var transformer = $7fa775b8616abf44$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($7fa775b8616abf44$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $7fa775b8616abf44$var$getCssProperties(prop);
        var styleFromPropValue = $7fa775b8616abf44$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $c2PJn.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $cMoso.default), {});
}
$7fa775b8616abf44$var$spacing.propTypes = {};
$7fa775b8616abf44$var$spacing.filterProps = $7fa775b8616abf44$var$spacingKeys;
var $7fa775b8616abf44$export$2e2bcd8739ae039 = $7fa775b8616abf44$var$spacing;

});
parcelRegister("2gIIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a6fc27d69850fe4$export$2e2bcd8739ae039; });

var $a2azi = parcelRequire("a2azi");

var $k0gbs = parcelRequire("k0gbs");

var $6A22e = parcelRequire("6A22e");

var $bM4Gu = parcelRequire("bM4Gu");
function $1a6fc27d69850fe4$export$2e2bcd8739ae039(r, e) {
    return (0, $a2azi.default)(r) || (0, $k0gbs.default)(r, e) || (0, $6A22e.default)(r, e) || (0, $bM4Gu.default)();
}

});
parcelRegister("a2azi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e249f0a1430824$export$2e2bcd8739ae039; });
function $74e249f0a1430824$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("k0gbs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9005c7c032e54f6$export$2e2bcd8739ae039; });
function $e9005c7c032e54f6$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("bM4Gu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8927cf96e9e7e6b4$export$2e2bcd8739ae039; });
function $8927cf96e9e7e6b4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("c2PJn", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $8c4dcca252fa4780$export$88347efdb2e19abd; });

var $cwJVy = parcelRequire("cwJVy");

var $kY3Ke = parcelRequire("kY3Ke");

var $6TO5S = parcelRequire("6TO5S");


var $cMoso = parcelRequire("cMoso");
// For instance with the first breakpoint xs: [xs, sm[.
var $8c4dcca252fa4780$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $8c4dcca252fa4780$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: function up(key) {
        return "@media (min-width:".concat($8c4dcca252fa4780$var$values[key], "px)");
    }
};
function $8c4dcca252fa4780$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $8c4dcca252fa4780$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $6TO5S.default)(propValue) === 'object') {
        var _themeBreakpoints = props.theme.breakpoints || $8c4dcca252fa4780$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $8c4dcca252fa4780$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $8c4dcca252fa4780$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kY3Ke.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $cMoso.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ].concat((0, $cwJVy.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $8c4dcca252fa4780$export$2e2bcd8739ae039 = $8c4dcca252fa4780$var$breakpoints;

});
parcelRegister("cMoso", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94dcf05f2ffce2a1$export$2e2bcd8739ae039; });

var $belNS = parcelRequire("belNS");
function $94dcf05f2ffce2a1$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $belNS.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $94dcf05f2ffce2a1$export$2e2bcd8739ae039 = $94dcf05f2ffce2a1$var$merge;

});


parcelRegister("53ZLU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3afd261e26f93cfb$export$2e2bcd8739ae039; });
function $3afd261e26f93cfb$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("etJ3Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "easing", function () { return $a8a6ba4f52956167$export$24c5ac7c37452e7d; });
$parcel$export(module.exports, "duration", function () { return $a8a6ba4f52956167$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $a8a6ba4f52956167$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");
var $a8a6ba4f52956167$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $a8a6ba4f52956167$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $a8a6ba4f52956167$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $a8a6ba4f52956167$export$2e2bcd8739ae039 = {
    easing: $a8a6ba4f52956167$export$24c5ac7c37452e7d,
    duration: $a8a6ba4f52956167$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $a8a6ba4f52956167$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $a8a6ba4f52956167$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $lfiYO.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $a8a6ba4f52956167$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $a8a6ba4f52956167$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("ep8x4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7ca04dab89da169$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $a7ca04dab89da169$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $a7ca04dab89da169$export$2e2bcd8739ae039 = $a7ca04dab89da169$var$zIndex;

});




parcelRegister("dKzJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a02b4b1d0139e2ba$export$2e2bcd8739ae039; });

var $2dHXF = parcelRequire("2dHXF");
function $a02b4b1d0139e2ba$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $2dHXF.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRegister("6qwOn", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    return module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $91b5651481cc9d5c$var$_extends.apply(null, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bASKz", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $870d86b95a3e4035$var$_createTheme = $62qsu((parcelRequire("ciNCa")));
var $870d86b95a3e4035$var$defaultTheme = (0, $870d86b95a3e4035$var$_createTheme.default)();
var $870d86b95a3e4035$var$_default = $870d86b95a3e4035$var$defaultTheme;
module.exports.default = $870d86b95a3e4035$var$_default;

});
parcelRegister("62qsu", function(module, exports) {
function $4657741705a128f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $4657741705a128f0$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ciNCa", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMuiTheme = $8f4da6e70b5d569c$var$createMuiTheme;
module.exports.default = void 0;

var $8f4da6e70b5d569c$var$_defineProperty2 = $62qsu((parcelRequire("8MJe2")));

var $8f4da6e70b5d569c$var$_objectWithoutProperties2 = $62qsu((parcelRequire("emuQy")));

var $belNS = parcelRequire("belNS");

var $8f4da6e70b5d569c$var$_createBreakpoints = $62qsu((parcelRequire("hUTDE")));

var $8f4da6e70b5d569c$var$_createMixins = $62qsu((parcelRequire("5E7kH")));

var $8f4da6e70b5d569c$var$_createPalette = $62qsu((parcelRequire("bWUJ0")));

var $8f4da6e70b5d569c$var$_createTypography = $62qsu((parcelRequire("ex8Ky")));

var $8f4da6e70b5d569c$var$_shadows = $62qsu((parcelRequire("bUfuB")));

var $8f4da6e70b5d569c$var$_shape = $62qsu((parcelRequire("lJtvE")));

var $8f4da6e70b5d569c$var$_createSpacing = $62qsu((parcelRequire("9hqJO")));

var $8f4da6e70b5d569c$var$_transitions = $62qsu((parcelRequire("h0z3Q")));

var $8f4da6e70b5d569c$var$_zIndex = $62qsu((parcelRequire("brult")));
function $8f4da6e70b5d569c$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $8f4da6e70b5d569c$var$_objectWithoutProperties2.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $8f4da6e70b5d569c$var$_createPalette.default)(paletteInput);
    var breakpoints = (0, $8f4da6e70b5d569c$var$_createBreakpoints.default)(breakpointsInput);
    var spacing = (0, $8f4da6e70b5d569c$var$_createSpacing.default)(spacingInput);
    var muiTheme = (0, $belNS.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $8f4da6e70b5d569c$var$_createMixins.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: $8f4da6e70b5d569c$var$_shadows.default,
        typography: (0, $8f4da6e70b5d569c$var$_createTypography.default)(palette, typographyInput),
        spacing: spacing,
        shape: $8f4da6e70b5d569c$var$_shape.default,
        transitions: $8f4da6e70b5d569c$var$_transitions.default,
        zIndex: $8f4da6e70b5d569c$var$_zIndex.default
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $belNS.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $8f4da6e70b5d569c$var$warnedOnce = false;
function $8f4da6e70b5d569c$var$createMuiTheme() {
    return $8f4da6e70b5d569c$var$createTheme.apply(void 0, arguments);
}
var $8f4da6e70b5d569c$var$_default = $8f4da6e70b5d569c$var$createTheme;
module.exports.default = $8f4da6e70b5d569c$var$_default;

});
parcelRegister("emuQy", function(module, exports) {

var $1ifJj = parcelRequire("1ifJj");
function $a74b0c43386c0a1b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1ifJj(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $a74b0c43386c0a1b$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1ifJj", function(module, exports) {
function $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hUTDE", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0b2d3426d652554$var$createBreakpoints;
module.exports.keys = void 0;

var $d0b2d3426d652554$var$_extends2 = $62qsu((parcelRequire("cvBp9")));

var $d0b2d3426d652554$var$_objectWithoutProperties2 = $62qsu((parcelRequire("emuQy")));
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var $d0b2d3426d652554$var$keys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
module.exports.keys = $d0b2d3426d652554$var$keys;
function $d0b2d3426d652554$var$createBreakpoints(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $d0b2d3426d652554$var$_objectWithoutProperties2.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $d0b2d3426d652554$var$keys.indexOf(key) + 1;
        var upperbound = values[$d0b2d3426d652554$var$keys[endIndex]];
        if (endIndex === $d0b2d3426d652554$var$keys.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $d0b2d3426d652554$var$keys.indexOf(end);
        if (endIndex === $d0b2d3426d652554$var$keys.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$d0b2d3426d652554$var$keys[endIndex + 1]] === 'number' ? values[$d0b2d3426d652554$var$keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $d0b2d3426d652554$var$_extends2.default)({
        keys: $d0b2d3426d652554$var$keys,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("5E7kH", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41c66058e0123042$var$createMixins;

var $41c66058e0123042$var$_defineProperty2 = $62qsu((parcelRequire("8MJe2")));

var $41c66058e0123042$var$_extends3 = $62qsu((parcelRequire("cvBp9")));
function $41c66058e0123042$var$createMixins(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $41c66058e0123042$var$_extends3.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $41c66058e0123042$var$_extends3.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $41c66058e0123042$var$_defineProperty2.default)({}, breakpoints.up('sm'), (0, $41c66058e0123042$var$_extends3.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $41c66058e0123042$var$_defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $41c66058e0123042$var$_defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("bWUJ0", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b311ce3dac879f3$var$createPalette;
module.exports.dark = module.exports.light = void 0;

var $8b311ce3dac879f3$var$_extends2 = $62qsu((parcelRequire("cvBp9")));

var $8b311ce3dac879f3$var$_objectWithoutProperties2 = $62qsu((parcelRequire("emuQy")));

var $belNS = parcelRequire("belNS");
var $2dHXF = parcelRequire("2dHXF");

var $8b311ce3dac879f3$var$_common = $62qsu((parcelRequire("jA5ka")));

var $8b311ce3dac879f3$var$_grey = $62qsu((parcelRequire("1JGdk")));

var $8b311ce3dac879f3$var$_indigo = $62qsu((parcelRequire("cu0Dy")));

var $8b311ce3dac879f3$var$_pink = $62qsu((parcelRequire("frWBK")));

var $8b311ce3dac879f3$var$_red = $62qsu((parcelRequire("6uxvP")));

var $8b311ce3dac879f3$var$_orange = $62qsu((parcelRequire("hvhdP")));

var $8b311ce3dac879f3$var$_blue = $62qsu((parcelRequire("jdGkx")));

var $8b311ce3dac879f3$var$_green = $62qsu((parcelRequire("92Npr")));

var $l01Vv = parcelRequire("l01Vv");
var $8b311ce3dac879f3$var$light = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: $8b311ce3dac879f3$var$_common.default.white,
        default: $8b311ce3dac879f3$var$_grey.default[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
module.exports.light = $8b311ce3dac879f3$var$light;
var $8b311ce3dac879f3$var$dark = {
    text: {
        primary: $8b311ce3dac879f3$var$_common.default.white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: $8b311ce3dac879f3$var$_grey.default[800],
        default: '#303030'
    },
    action: {
        active: $8b311ce3dac879f3$var$_common.default.white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
module.exports.dark = $8b311ce3dac879f3$var$dark;
function $8b311ce3dac879f3$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $l01Vv.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $l01Vv.darken)(intent.main, tonalOffsetDark);
    }
}
function $8b311ce3dac879f3$var$createPalette(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: $8b311ce3dac879f3$var$_indigo.default[300],
        main: $8b311ce3dac879f3$var$_indigo.default[500],
        dark: $8b311ce3dac879f3$var$_indigo.default[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: $8b311ce3dac879f3$var$_pink.default.A200,
        main: $8b311ce3dac879f3$var$_pink.default.A400,
        dark: $8b311ce3dac879f3$var$_pink.default.A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: $8b311ce3dac879f3$var$_red.default[300],
        main: $8b311ce3dac879f3$var$_red.default[500],
        dark: $8b311ce3dac879f3$var$_red.default[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: $8b311ce3dac879f3$var$_orange.default[300],
        main: $8b311ce3dac879f3$var$_orange.default[500],
        dark: $8b311ce3dac879f3$var$_orange.default[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: $8b311ce3dac879f3$var$_blue.default[300],
        main: $8b311ce3dac879f3$var$_blue.default[500],
        dark: $8b311ce3dac879f3$var$_blue.default[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: $8b311ce3dac879f3$var$_green.default[300],
        main: $8b311ce3dac879f3$var$_green.default[500],
        dark: $8b311ce3dac879f3$var$_green.default[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $8b311ce3dac879f3$var$_objectWithoutProperties2.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $l01Vv.getContrastRatio)(background, $8b311ce3dac879f3$var$dark.text.primary) >= contrastThreshold ? $8b311ce3dac879f3$var$dark.text.primary : $8b311ce3dac879f3$var$light.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $8b311ce3dac879f3$var$_extends2.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $2dHXF.default)(4, mainShade));
        if (typeof color.main !== 'string') throw new Error(_formatMuiErrorMessage(5, JSON.stringify(color.main)));
        $8b311ce3dac879f3$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $8b311ce3dac879f3$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $8b311ce3dac879f3$var$dark,
        light: $8b311ce3dac879f3$var$light
    };
    var paletteOutput = (0, $belNS.default)((0, $8b311ce3dac879f3$var$_extends2.default)({
        // A collection of common colors.
        common: $8b311ce3dac879f3$var$_common.default,
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: $8b311ce3dac879f3$var$_grey.default,
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("jA5ka", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $03adc42ade3075bd$var$common = {
    black: '#000',
    white: '#fff'
};
var $03adc42ade3075bd$var$_default = $03adc42ade3075bd$var$common;
module.exports.default = $03adc42ade3075bd$var$_default;

});

parcelRegister("1JGdk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $143abd3e876eed30$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $143abd3e876eed30$var$_default = $143abd3e876eed30$var$grey;
module.exports.default = $143abd3e876eed30$var$_default;

});

parcelRegister("cu0Dy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9168c7dad3b43782$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $9168c7dad3b43782$var$_default = $9168c7dad3b43782$var$indigo;
module.exports.default = $9168c7dad3b43782$var$_default;

});

parcelRegister("frWBK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b3f6d6ea5929c610$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $b3f6d6ea5929c610$var$_default = $b3f6d6ea5929c610$var$pink;
module.exports.default = $b3f6d6ea5929c610$var$_default;

});

parcelRegister("6uxvP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4b9f8a494697178b$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $4b9f8a494697178b$var$_default = $4b9f8a494697178b$var$red;
module.exports.default = $4b9f8a494697178b$var$_default;

});

parcelRegister("hvhdP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $cbe2b0e0c3f870f7$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $cbe2b0e0c3f870f7$var$_default = $cbe2b0e0c3f870f7$var$orange;
module.exports.default = $cbe2b0e0c3f870f7$var$_default;

});

parcelRegister("jdGkx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dfe0111ee5dc98b8$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $dfe0111ee5dc98b8$var$_default = $dfe0111ee5dc98b8$var$blue;
module.exports.default = $dfe0111ee5dc98b8$var$_default;

});

parcelRegister("92Npr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $695aa0a0b830e1e9$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $695aa0a0b830e1e9$var$_default = $695aa0a0b830e1e9$var$green;
module.exports.default = $695aa0a0b830e1e9$var$_default;

});

parcelRegister("l01Vv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hexToRgb = $f49b179a65a83654$var$hexToRgb;
module.exports.rgbToHex = $f49b179a65a83654$var$rgbToHex;
module.exports.hslToRgb = $f49b179a65a83654$var$hslToRgb;
module.exports.decomposeColor = $f49b179a65a83654$var$decomposeColor;
module.exports.recomposeColor = $f49b179a65a83654$var$recomposeColor;
module.exports.getContrastRatio = $f49b179a65a83654$var$getContrastRatio;
module.exports.getLuminance = $f49b179a65a83654$var$getLuminance;
module.exports.emphasize = $f49b179a65a83654$var$emphasize;
module.exports.fade = $f49b179a65a83654$var$fade;
module.exports.alpha = $f49b179a65a83654$var$alpha;
module.exports.darken = $f49b179a65a83654$var$darken;
module.exports.lighten = $f49b179a65a83654$var$lighten;

var $2dHXF = parcelRequire("2dHXF");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f49b179a65a83654$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f49b179a65a83654$var$hexToRgb(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $f49b179a65a83654$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f49b179a65a83654$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $f49b179a65a83654$var$decomposeColor(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $f49b179a65a83654$var$intToHex(n);
    }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f49b179a65a83654$var$hslToRgb(color) {
    color = $f49b179a65a83654$var$decomposeColor(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f49b179a65a83654$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f49b179a65a83654$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f49b179a65a83654$var$decomposeColor($f49b179a65a83654$var$hexToRgb(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error((0, $2dHXF.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ function $f49b179a65a83654$var$recomposeColor(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f49b179a65a83654$var$getContrastRatio(foreground, background) {
    var lumA = $f49b179a65a83654$var$getLuminance(foreground);
    var lumB = $f49b179a65a83654$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f49b179a65a83654$var$getLuminance(color) {
    color = $f49b179a65a83654$var$decomposeColor(color);
    var rgb = color.type === 'hsl' ? $f49b179a65a83654$var$decomposeColor($f49b179a65a83654$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f49b179a65a83654$var$emphasize(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $f49b179a65a83654$var$getLuminance(color) > 0.5 ? $f49b179a65a83654$var$darken(color, coefficient) : $f49b179a65a83654$var$lighten(color, coefficient);
}
var $f49b179a65a83654$var$warnedOnce = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */ function $f49b179a65a83654$var$fade(color, value) {
    return $f49b179a65a83654$var$alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f49b179a65a83654$var$alpha(color, value) {
    color = $f49b179a65a83654$var$decomposeColor(color);
    value = $f49b179a65a83654$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $f49b179a65a83654$var$recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f49b179a65a83654$var$darken(color, coefficient) {
    color = $f49b179a65a83654$var$decomposeColor(color);
    coefficient = $f49b179a65a83654$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f49b179a65a83654$var$recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f49b179a65a83654$var$lighten(color, coefficient) {
    color = $f49b179a65a83654$var$decomposeColor(color);
    coefficient = $f49b179a65a83654$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $f49b179a65a83654$var$recomposeColor(color);
}

});


parcelRegister("ex8Ky", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a94aef48554980af$var$createTypography;

var $a94aef48554980af$var$_extends2 = $62qsu((parcelRequire("cvBp9")));

var $a94aef48554980af$var$_objectWithoutProperties2 = $62qsu((parcelRequire("emuQy")));

var $belNS = parcelRequire("belNS");
function $a94aef48554980af$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $a94aef48554980af$var$warnedOnce = false;
function $a94aef48554980af$var$roundWithDeprecationWarning(value) {
    return $a94aef48554980af$var$round(value);
}
var $a94aef48554980af$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $a94aef48554980af$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */ function $a94aef48554980af$var$createTypography(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $a94aef48554980af$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $a94aef48554980af$var$_objectWithoutProperties2.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $a94aef48554980af$var$_extends2.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $a94aef48554980af$var$defaultFontFamily ? {
            letterSpacing: "".concat($a94aef48554980af$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $a94aef48554980af$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $a94aef48554980af$var$caseAllCaps)
    };
    return (0, $belNS.default)((0, $a94aef48554980af$var$_extends2.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $a94aef48554980af$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("bUfuB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $8ab0f129ba35d31e$var$shadowKeyUmbraOpacity = 0.2;
var $8ab0f129ba35d31e$var$shadowKeyPenumbraOpacity = 0.14;
var $8ab0f129ba35d31e$var$shadowAmbientShadowOpacity = 0.12;
function $8ab0f129ba35d31e$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($8ab0f129ba35d31e$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($8ab0f129ba35d31e$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($8ab0f129ba35d31e$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $8ab0f129ba35d31e$var$shadows = [
    'none',
    $8ab0f129ba35d31e$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $8ab0f129ba35d31e$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $8ab0f129ba35d31e$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $8ab0f129ba35d31e$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $8ab0f129ba35d31e$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $8ab0f129ba35d31e$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $8ab0f129ba35d31e$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $8ab0f129ba35d31e$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $8ab0f129ba35d31e$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $8ab0f129ba35d31e$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $8ab0f129ba35d31e$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $8ab0f129ba35d31e$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $8ab0f129ba35d31e$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $8ab0f129ba35d31e$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $8ab0f129ba35d31e$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $8ab0f129ba35d31e$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $8ab0f129ba35d31e$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $8ab0f129ba35d31e$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $8ab0f129ba35d31e$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $8ab0f129ba35d31e$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $8ab0f129ba35d31e$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $8ab0f129ba35d31e$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $8ab0f129ba35d31e$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $8ab0f129ba35d31e$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $8ab0f129ba35d31e$var$_default = $8ab0f129ba35d31e$var$shadows;
module.exports.default = $8ab0f129ba35d31e$var$_default;

});

parcelRegister("lJtvE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $fd24b0e54900b243$var$shape = {
    borderRadius: 4
};
var $fd24b0e54900b243$var$_default = $fd24b0e54900b243$var$shape;
module.exports.default = $fd24b0e54900b243$var$_default;

});

parcelRegister("9hqJO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c1a712f1c867472$var$createSpacing;

var $aXuZY = parcelRequire("aXuZY");
var $6c1a712f1c867472$var$warnOnce;
function $6c1a712f1c867472$var$createSpacing() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $aXuZY.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("h0z3Q", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.duration = module.exports.easing = void 0;

var $c61da22a24462ea7$var$_objectWithoutProperties2 = $62qsu((parcelRequire("emuQy")));
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var $c61da22a24462ea7$var$easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
module.exports.easing = $c61da22a24462ea7$var$easing;
var $c61da22a24462ea7$var$duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
module.exports.duration = $c61da22a24462ea7$var$duration;
function $c61da22a24462ea7$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ var $c61da22a24462ea7$var$_default = {
    easing: $c61da22a24462ea7$var$easing,
    duration: $c61da22a24462ea7$var$duration,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $c61da22a24462ea7$var$duration.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $c61da22a24462ea7$var$easing.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $c61da22a24462ea7$var$_objectWithoutProperties2.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $c61da22a24462ea7$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $c61da22a24462ea7$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};
module.exports.default = $c61da22a24462ea7$var$_default;

});

parcelRegister("brult", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $8549c14b7fb851c3$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $8549c14b7fb851c3$var$_default = $8549c14b7fb851c3$var$zIndex;
module.exports.default = $8549c14b7fb851c3$var$_default;

});



parcelRegister("kYamb", function(module, exports) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    module.exports = factory(function() {
        try {
            return (parcelRequire("6qwOn"));
        } catch (e) {}
    }());
})(module.exports, function(moment) {
    'use strict';
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n['default'] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: 'rgb'
            },
            hsl: {
                channels: 3,
                labels: 'hsl'
            },
            hsv: {
                channels: 3,
                labels: 'hsv'
            },
            hwb: {
                channels: 3,
                labels: 'hwb'
            },
            cmyk: {
                channels: 4,
                labels: 'cmyk'
            },
            xyz: {
                channels: 3,
                labels: 'xyz'
            },
            lab: {
                channels: 3,
                labels: 'lab'
            },
            lch: {
                channels: 3,
                labels: 'lch'
            },
            hex: {
                channels: 1,
                labels: [
                    'hex'
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    'keyword'
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    'ansi16'
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    'ansi256'
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    'h',
                    'c',
                    'g'
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    'r16',
                    'g16',
                    'b16'
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    'gray'
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!('channels' in convert[model])) throw new Error('missing channels property: ' + model);
            if (!('labels' in convert[model])) throw new Error('missing channel labels property: ' + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], 'channels', {
                value: channels
            });
            Object.defineProperty(convert[model], 'labels', {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var keyword in colorName)if (colorName.hasOwnProperty(keyword)) {
                var value = colorName[keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
                return char + char;
            }).join('');
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], 'channels', {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], 'labels', {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === 'string') {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues('rgb', vals);
            else if (vals = colorString.getHsla(obj)) this.setValues('hsl', vals);
            else if (vals = colorString.getHwb(obj)) this.setValues('hwb', vals);
        } else if (typeof obj === 'object') {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues('rgb', vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues('hsl', vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues('hsv', vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues('hwb', vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues('cmyk', vals);
        }
    };
    Color.prototype = {
        isValid: function() {
            return this.valid;
        },
        rgb: function() {
            return this.setSpace('rgb', arguments);
        },
        hsl: function() {
            return this.setSpace('hsl', arguments);
        },
        hsv: function() {
            return this.setSpace('hsv', arguments);
        },
        hwb: function() {
            return this.setSpace('hwb', arguments);
        },
        cmyk: function() {
            return this.setSpace('cmyk', arguments);
        },
        rgbArray: function() {
            return this.values.rgb;
        },
        hslArray: function() {
            return this.values.hsl;
        },
        hsvArray: function() {
            return this.values.hsv;
        },
        hwbArray: function() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function() {
            return this.values.cmyk;
        },
        rgbaArray: function() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues('alpha', val);
            return this;
        },
        red: function(val) {
            return this.setChannel('rgb', 0, val);
        },
        green: function(val) {
            return this.setChannel('rgb', 1, val);
        },
        blue: function(val) {
            return this.setChannel('rgb', 2, val);
        },
        hue: function(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel('hsl', 0, val);
        },
        saturation: function(val) {
            return this.setChannel('hsl', 1, val);
        },
        lightness: function(val) {
            return this.setChannel('hsl', 2, val);
        },
        saturationv: function(val) {
            return this.setChannel('hsv', 1, val);
        },
        whiteness: function(val) {
            return this.setChannel('hwb', 1, val);
        },
        blackness: function(val) {
            return this.setChannel('hwb', 2, val);
        },
        value: function(val) {
            return this.setChannel('hsv', 2, val);
        },
        cyan: function(val) {
            return this.setChannel('cmyk', 0, val);
        },
        magenta: function(val) {
            return this.setChannel('cmyk', 1, val);
        },
        yellow: function(val) {
            return this.setChannel('cmyk', 2, val);
        },
        black: function(val) {
            return this.setChannel('cmyk', 3, val);
        },
        hexString: function() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return 'AAA';
            return contrastRatio >= 4.5 ? 'AA' : '';
        },
        dark: function() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function() {
            return !this.dark();
        },
        negate: function() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues('rgb', rgb);
            return this;
        },
        lighten: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        darken: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        saturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        desaturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        whiten: function(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        blacken: function(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        greyscale: function() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues('rgb', [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha - alpha * ratio);
            return this;
        },
        opaquer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha + alpha * ratio);
            return this;
        },
        rotate: function(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues('hsl', hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function() {
            return this.rgb();
        },
        clone: function() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === '[object Array]') target[prop] = value.slice(0);
                else if (type === '[object Number]') target[prop] = value;
                else console.error('unexpected color value:', value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            'red',
            'green',
            'blue'
        ],
        hsl: [
            'hue',
            'saturation',
            'lightness'
        ],
        hsv: [
            'hue',
            'saturation',
            'value'
        ],
        hwb: [
            'hue',
            'whiteness',
            'blackness'
        ],
        cmyk: [
            'cyan',
            'magenta',
            'yellow',
            'black'
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === 'alpha') alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === 'alpha') return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === 'number') vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== 'undefined') window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            '__proto__',
            'prototype',
            'constructor'
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function(value) {
            return value === null || typeof value === 'undefined';
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function(value) {
            return value !== null && Object.prototype.toString.call(value) === '[object Object]';
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function(value) {
            return (typeof value === 'number' || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function(value, defaultValue) {
            return typeof value === 'undefined' ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function(fn, args, thisArg) {
            if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function() {
                return me.apply(this, arguments);
            };
            var Surrogate = function() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function(t) {
            return t;
        },
        easeInQuad: function(t) {
            return t * t;
        },
        easeOutQuad: function(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function(t) {
            return t * t * t;
        },
        easeOutCubic: function(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        easeOutQuart: function(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && typeof style === 'object') {
                type = style.toString();
                if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case 'triangle':
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case 'rectRounded':
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case 'rect':
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case 'rectRot':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case 'crossRot':
                    rad += QUARTER_PI;
                /* falls through */ case 'cross':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'star':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'line':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case 'dash':
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function(ctx) {
            ctx.restore();
        },
        lineTo: function(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === 'middle') {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set('global', {
        defaultColor: 'rgba(0,0,0,0.1)',
        defaultFontColor: '#666',
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: 'normal',
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function(value, size) {
            var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === 'normal') return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case 'px':
                    return value;
                case '%':
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ''
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === 'function') {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function(rectX, width) {
        return {
            x: function(x) {
                return rectX + rectX + width - x;
            },
            setWidth: function(w) {
                width = w;
            },
            textAlign: function(align) {
                if (align === 'center') return align;
                return align === 'right' ? 'left' : 'right';
            },
            xPlus: function(x, value) {
                return x - value;
            },
            leftForLtr: function(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function() {
        return {
            x: function(x) {
                return x;
            },
            setWidth: function(w) {},
            textAlign: function(align) {
                return align;
            },
            xPlus: function(x, value) {
                return x + value;
            },
            leftForLtr: function(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function(ctx, direction) {
        var style, original;
        if (direction === 'ltr' || direction === 'rtl') {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue('direction'),
                style.getPropertyPriority('direction')
            ];
            style.setProperty('direction', direction, 'important');
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty('direction', original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === '_') continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target;
            if (type === typeof origin) {
                if (type === 'string') {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function() {
            this.hidden = false;
        },
        pivot: function() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: '',
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'animationObject', {
        get: function() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'chartInstance', {
        get: function() {
            return this.chart;
        },
        set: function(value) {
            this.chart = value;
        }
    });
    core_defaults._set('global', {
        animation: {
            duration: 1000,
            easing: 'easeOutQuart',
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        'push',
        'pop',
        'shift',
        'splice',
        'unshift'
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, '_chartjs', {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === 'function') object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth'
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'pointStyle'
        ],
        initialize: function(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function(key, target, source) {
                    if (key !== '_meta' && key !== 'data') helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: '#fff',
                borderWidth: 2,
                borderAlign: 'center'
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === 'inner';
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = 'round';
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = 'bevel';
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: 'arc',
        inLabelRange: function(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: 'line',
        draw: function() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            point: {
                radius: 3,
                pointStyle: 'circle',
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: 'point',
        inRange: function(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: 'bottom',
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, 'left', 'right');
        } else if (vm.base < vm.y) edge = swap(edge, 'bottom', 'top');
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: 'rectangle',
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill('evenodd');
            ctx.restore();
        },
        height: function() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: 'linear'
                }
            ]
        }
    });
    core_defaults._set('global', {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderSkipped',
            'borderWidth',
            'barPercentage',
            'barThickness',
            'categoryPercentage',
            'maxBarThickness',
            'minBarLength'
        ],
        initialize: function() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
            deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
            deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
            deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
            deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
        },
        update: function(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom',
                    id: 'x-axis-0' // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    position: 'left',
                    id: 'y-axis-0'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return '';
                },
                label: function(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || '';
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth',
            'hoverRadius',
            'hitRadius',
            'pointStyle',
            'rotation'
        ],
        /**
	 * @protected
	 */ update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: 'single'
        },
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return '';
                },
                label: function(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== 'inner') {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set('horizontalBar', {
        hover: {
            mode: 'index',
            axis: 'y'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    type: 'category',
                    position: 'left',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: 'left'
            }
        },
        tooltips: {
            mode: 'index',
            axis: 'y'
        }
    });
    core_defaults._set('global', {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    id: 'x-axis-0'
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    id: 'y-axis-0'
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth',
            'cubicInterpolationMode',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === 'monotone') helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
        scale: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return '';
                },
                label: function(item, data) {
                    return data.labels[item.index] + ': ' + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
        spanGaps: false,
        scale: {
            type: 'radialLinear'
        },
        elements: {
            line: {
                fill: 'start',
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderWidth',
            'borderColor',
            'borderCapStyle',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set('scatter', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    id: 'x-axis-1',
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    id: 'y-axis-1',
                    type: 'linear',
                    position: 'left'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    return ''; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function(item) {
                    return '(' + item.xLabel + ', ' + item.yLabel + ')';
                }
            }
        }
    });
    core_defaults._set('global', {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf('x') !== -1;
        var useY = axis.indexOf('y') !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || 'x';
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ 'x-axis': function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
        var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, 'chartArea'),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos('top');
        chartArea.x += updatePos('left');
        updatePos('right');
        updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            'left',
            'right'
        ]) : marginForPositions([
            'top',
            'bottom'
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set('global', {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || 'top';
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function(chart, item, options) {
            var props = [
                'fullWidth',
                'position',
                'weight'
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext('2d') || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = [
        'animationstart',
        'webkitAnimationStart'
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: 'mousedown',
        touchmove: 'mousemove',
        touchend: 'mouseup',
        pointerenter: 'mouseenter',
        pointerdown: 'mousedown',
        pointermove: 'mousemove',
        pointerup: 'mouseup',
        pointerleave: 'mouseout',
        pointerout: 'mouseout'
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute('height');
        var renderWidth = canvas.getAttribute('width');
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || 'block';
        if (renderWidth === null || renderWidth === '') {
            var displayWidth = readUsedSize(canvas, 'width');
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === '') {
            if (canvas.style.height === '') // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, 'height');
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, 'passive', {
                // eslint-disable-next-line getter-return
                get: function() {
                    supports = true;
                }
            });
            window.addEventListener('e', null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement('div');
        el.className = cls || '';
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
        var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function() {
            resizer._reset();
            handler();
        };
        addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
        addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent('resize', chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent('resize', chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = '/* Chart.js */\n' + css;
            var style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function(item, config) {
            if (typeof item === 'string') item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext('2d');
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                'height',
                'width'
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + '_' + type] = function(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + '_' + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function() {}
    }, implementation);
    core_defaults._set('global', {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === 'function') {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
        tooltips: {
            enabled: true,
            custom: null,
            mode: 'nearest',
            position: 'average',
            intersect: true,
            backgroundColor: 'rgba(0,0,0,0.8)',
            titleFontStyle: 'bold',
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: '#fff',
            titleAlign: 'left',
            bodySpacing: 2,
            bodyFontColor: '#fff',
            bodyAlign: 'left',
            footerFontStyle: 'bold',
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: '#fff',
            footerAlign: 'left',
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: '#fff',
            displayColors: true,
            borderColor: 'rgba(0,0,0,0)',
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function(tooltipItems, data) {
                    var title = '';
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    if (label) label += ': ';
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
            label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
            value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = 'center';
        var yAlign = 'center';
        if (model.y < size.height) yAlign = 'top';
        else if (model.y > chart.height - size.height) yAlign = 'bottom';
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === 'center') {
            lf = function(x) {
                return x <= midX;
            };
            rf = function(x) {
                return x > midX;
            };
        } else {
            lf = function(x) {
                return x <= size.width / 2;
            };
            rf = function(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function(y) {
            return y <= midY ? 'top' : 'bottom';
        };
        if (lf(model.x)) {
            xAlign = 'left';
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = 'right';
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === 'right') x -= size.width;
        else if (xAlign === 'center') {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === 'top') y += paddingAndSize;
        else if (yAlign === 'bottom') y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === 'center') {
            if (xAlign === 'left') x += paddingAndSize;
            else if (xAlign === 'right') x -= paddingAndSize;
        } else if (xAlign === 'left') x -= radiusAndPadding;
        else if (xAlign === 'right') x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === 'center') {
                y2 = ptY + height / 2;
                if (xAlign === 'left') {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === 'left') {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === 'right') {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === 'top') {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = 'middle';
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = 'middle';
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = 'middle';
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === 'top') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === 'bottom') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === 'mouseout') me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        elements: {},
        events: [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ],
        hover: {
            onHover: null,
            mode: 'nearest',
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                if (key === 'xAxes' || key === 'yAxes') {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === 'scales') // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === 'scale') // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, 'data', {
                get: function() {
                    return me.config.data;
                },
                set: function(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, 'beforeInit');
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, 'afterInit');
            return me;
        },
        clear: function() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + 'px';
            canvas.style.height = newHeight + 'px';
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, 'resize', [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || 'scale';
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: 'category',
                    dposition: 'bottom'
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: 'linear',
                    dposition: 'left'
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: 'radialLinear',
                isDefault: true,
                dposition: 'chartArea'
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function(config) {
            var me = this;
            var i, ilen;
            if (!config || typeof config !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, 'beforeUpdate') === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, 'afterUpdate');
            me._layers.sort(compare2Level('z', '_idx'));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function() {
            var me = this;
            if (core_plugins.notify(me, 'beforeLayout') === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, 'afterScaleUpdate');
            core_plugins.notify(me, 'afterLayout');
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function() {
            var me = this;
            if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, 'afterDatasetsUpdate');
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, 'beforeDatasetUpdate', [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, 'afterDatasetUpdate', [
                args
            ]);
        },
        render: function(config) {
            var me = this;
            if (!config || typeof config !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, 'beforeRender') === false) return;
            var onComplete = function(animation) {
                core_plugins.notify(me, 'afterRender');
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, 'beforeDraw', [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, 'afterDraw', [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level('order', 'index'));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, 'beforeDatasetsDraw', [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, 'afterDatasetsDraw', [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeDatasetDraw', [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, 'afterDatasetDraw', [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeTooltipDraw', [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, 'afterTooltipDraw', [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function(e) {
            return core_interaction.modes['x-axis'](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === 'function') return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, 'destroy');
            delete Chart.instances[me.id];
        },
        toBase64Image: function() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function() {
                    me.resize();
                };
                platform.addEventListener(me, 'resize', listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function(elements, mode, enabled) {
            var prefix = enabled ? 'set' : 'remove';
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
            }
            if (mode === 'dataset') this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        },
        /**
	 * @private
	 */ eventHandler: function(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, 'beforeEvent', [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, 'afterEvent', [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === 'mouseout') me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === 'mouseup' || e.type === 'click') {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === 'undefined') return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === 'string') {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== 'none';
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return 'none';
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, 'max-width', 'clientWidth');
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, 'max-height', 'clientHeight');
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + 'px';
                canvas.style.width = width + 'px';
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error('Color.js not found!');
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function(value) {
                return helpers$1.isArray(value) ? value : '' + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = '';
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = '0'; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return '0';
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return '';
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
        display: true,
        position: 'left',
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: 'rgba(0,0,0,0.25)',
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: '',
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== 'undefined') filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function() {
        // noop
        },
        beforeUpdate: function() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === 'bottom';
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        isFullWidth: function() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return '[' + v.start + ', ' + v.end + ']';
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== 'auto') return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === 'top') {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === 'bottom') {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === 'left') {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === 'top') {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? 'center' : 'left';
            } else if (position === 'bottom') {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? 'center' : 'right';
            } else if (position === 'left') {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? 'left' : 'right';
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? 'right' : 'left';
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = 'middle';
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText('' + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === 'left';
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: 'bottom'
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function(value) {
            if (typeof value === 'string') return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: 'left',
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : '',
            meta.stack
        ].join('.');
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: 'left',
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '',
                        meta.stack
                    ].join('.');
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: 'rgba(255,255,255,0.75)',
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return 'center';
        else if (angle < 180) return 'left';
        return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = 'middle';
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : '';
            });
        },
        getLabelForIndex: function(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === 'linear' || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === 'function') value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === 'function') {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? 'day' : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === 'ticks') ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, 'time', ticks[0], 'pos');
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
            last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: 'bottom',
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: 'linear',
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: 'auto',
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1('time scale', time.format, 'time.format', 'time.parser');
            deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
            deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || 'day';
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === 'data' || source === 'auto' && distribution === 'series') timestamps = timestamps.data;
            else if (source === 'labels') timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === 'ticks' && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : '';
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === 'string') return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, 'time', time, 'pos');
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, 'pos', pos, 'time');
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: 'MMM D, YYYY, h:mm:ss a',
        millisecond: 'h:mm:ss.SSS a',
        second: 'h:mm:ss a',
        minute: 'h:mm a',
        hour: 'hA',
        day: 'MMM D',
        week: 'll',
        month: 'MMM YYYY',
        quarter: '[Q]Q - YYYY',
        year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
        _id: 'moment',
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            if (typeof value === 'string' && typeof format === 'string') value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            return moment(time).format(format);
        },
        add: function(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function(time, unit, weekday) {
            time = moment(time);
            if (unit === 'isoWeek') return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set('global', {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return 'origin';
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === '-' || fill[0] === '+') target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case 'bottom':
                return 'start';
            case 'top':
                return 'end';
            case 'zero':
                return 'origin';
            // supported boundaries
            case 'origin':
            case 'start':
            case 'end':
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === 'start') target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === 'end') target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = 'dataset';
        if (fill === false) return null;
        if (!isFinite(fill)) type = 'boundary';
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: 'filler',
        afterDatasetsUpdate: function(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        legend: {
            display: true,
            position: 'top',
            align: 'center',
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = 'left';
                ctx.textBaseline = 'middle';
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function() {
            return this.options.position === 'top' || this.options.position === 'bottom';
        },
        // Actually draw the legend on the canvas
        draw: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign('left');
            ctx.textBaseline = 'middle';
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function(dimension, blockSize) {
                switch(opts.align){
                    case 'start':
                        return labelOpts.padding;
                    case 'end':
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === 'mouseup' ? 'click' : e.type;
            var hoveredItem;
            if (type === 'mousemove') {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === 'click') {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === 'click') {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: 'legend',
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
        title: {
            display: false,
            fontStyle: 'bold',
            fullWidth: true,
            padding: 10,
            position: 'top',
            text: '',
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        // Actually draw the title block on the canvas
        draw: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === 'left' ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: 'title',
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        'Bar',
        'Bubble',
        'Doughnut',
        'Line',
        'PolarArea',
        'Radar',
        'Scatter'
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});

});

parcelRegister("hzZfF", function(module, exports) {

var $aH9iS = parcelRequire("aH9iS");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $034d80e6a88ef527$var$isEqual(value, other) {
    return $aH9iS(value, other);
}
module.exports = $034d80e6a88ef527$var$isEqual;

});
parcelRegister("aH9iS", function(module, exports) {

var $h11tW = parcelRequire("h11tW");

var $d2kYI = parcelRequire("d2kYI");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $7c952302caee51c1$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$d2kYI(value) && !$d2kYI(other)) return value !== value && other !== other;
    return $h11tW(value, other, bitmask, customizer, $7c952302caee51c1$var$baseIsEqual, stack);
}
module.exports = $7c952302caee51c1$var$baseIsEqual;

});
parcelRegister("h11tW", function(module, exports) {

var $a6ECp = parcelRequire("a6ECp");

var $1JRPZ = parcelRequire("1JRPZ");

var $4eUTQ = parcelRequire("4eUTQ");

var $lgEYI = parcelRequire("lgEYI");

var $3tPzb = parcelRequire("3tPzb");

var $7wkJN = parcelRequire("7wkJN");

var $9gBlp = parcelRequire("9gBlp");

var $cuTxs = parcelRequire("cuTxs");
/** Used to compose bitmasks for value comparisons. */ var $c633adf42a0b7174$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c633adf42a0b7174$var$argsTag = '[object Arguments]', $c633adf42a0b7174$var$arrayTag = '[object Array]', $c633adf42a0b7174$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c633adf42a0b7174$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c633adf42a0b7174$var$hasOwnProperty = $c633adf42a0b7174$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c633adf42a0b7174$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $7wkJN(object), othIsArr = $7wkJN(other), objTag = objIsArr ? $c633adf42a0b7174$var$arrayTag : $3tPzb(object), othTag = othIsArr ? $c633adf42a0b7174$var$arrayTag : $3tPzb(other);
    objTag = objTag == $c633adf42a0b7174$var$argsTag ? $c633adf42a0b7174$var$objectTag : objTag;
    othTag = othTag == $c633adf42a0b7174$var$argsTag ? $c633adf42a0b7174$var$objectTag : othTag;
    var objIsObj = objTag == $c633adf42a0b7174$var$objectTag, othIsObj = othTag == $c633adf42a0b7174$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $9gBlp(object)) {
        if (!$9gBlp(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $a6ECp);
        return objIsArr || $cuTxs(object) ? $1JRPZ(object, other, bitmask, customizer, equalFunc, stack) : $4eUTQ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c633adf42a0b7174$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c633adf42a0b7174$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $c633adf42a0b7174$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $a6ECp);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $a6ECp);
    return $lgEYI(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $c633adf42a0b7174$var$baseIsEqualDeep;

});
parcelRegister("a6ECp", function(module, exports) {

var $ibr17 = parcelRequire("ibr17");

var $eoTVC = parcelRequire("eoTVC");

var $DoMSX = parcelRequire("DoMSX");

var $k4t2v = parcelRequire("k4t2v");

var $4NwfS = parcelRequire("4NwfS");

var $lcWk9 = parcelRequire("lcWk9");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $75b9f8e835026959$var$Stack(entries) {
    var data = this.__data__ = new $ibr17(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$75b9f8e835026959$var$Stack.prototype.clear = $eoTVC;
$75b9f8e835026959$var$Stack.prototype['delete'] = $DoMSX;
$75b9f8e835026959$var$Stack.prototype.get = $k4t2v;
$75b9f8e835026959$var$Stack.prototype.has = $4NwfS;
$75b9f8e835026959$var$Stack.prototype.set = $lcWk9;
module.exports = $75b9f8e835026959$var$Stack;

});
parcelRegister("ibr17", function(module, exports) {

var $foxyq = parcelRequire("foxyq");

var $13lJV = parcelRequire("13lJV");

var $jjKHO = parcelRequire("jjKHO");

var $9CRkh = parcelRequire("9CRkh");

var $gz97O = parcelRequire("gz97O");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d3ce36181053a891$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d3ce36181053a891$var$ListCache.prototype.clear = $foxyq;
$d3ce36181053a891$var$ListCache.prototype['delete'] = $13lJV;
$d3ce36181053a891$var$ListCache.prototype.get = $jjKHO;
$d3ce36181053a891$var$ListCache.prototype.has = $9CRkh;
$d3ce36181053a891$var$ListCache.prototype.set = $gz97O;
module.exports = $d3ce36181053a891$var$ListCache;

});
parcelRegister("foxyq", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b3532018e1ff9eab$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $b3532018e1ff9eab$var$listCacheClear;

});

parcelRegister("13lJV", function(module, exports) {

var $4Ptfn = parcelRequire("4Ptfn");
/** Used for built-in method references. */ var $0c46ef5003b13e31$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $0c46ef5003b13e31$var$splice = $0c46ef5003b13e31$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0c46ef5003b13e31$var$listCacheDelete(key) {
    var data = this.__data__, index = $4Ptfn(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $0c46ef5003b13e31$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $0c46ef5003b13e31$var$listCacheDelete;

});
parcelRegister("4Ptfn", function(module, exports) {

var $bGvkD = parcelRequire("bGvkD");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $38429cb5a86e691c$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($bGvkD(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $38429cb5a86e691c$var$assocIndexOf;

});
parcelRegister("bGvkD", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $881bebc960934ade$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $881bebc960934ade$var$eq;

});



parcelRegister("jjKHO", function(module, exports) {

var $4Ptfn = parcelRequire("4Ptfn");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e1040571ebb469f5$var$listCacheGet(key) {
    var data = this.__data__, index = $4Ptfn(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $e1040571ebb469f5$var$listCacheGet;

});

parcelRegister("9CRkh", function(module, exports) {

var $4Ptfn = parcelRequire("4Ptfn");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7021072296e166d7$var$listCacheHas(key) {
    return $4Ptfn(this.__data__, key) > -1;
}
module.exports = $7021072296e166d7$var$listCacheHas;

});

parcelRegister("gz97O", function(module, exports) {

var $4Ptfn = parcelRequire("4Ptfn");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c0f6fe3ec712f3b3$var$listCacheSet(key, value) {
    var data = this.__data__, index = $4Ptfn(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $c0f6fe3ec712f3b3$var$listCacheSet;

});


parcelRegister("eoTVC", function(module, exports) {

var $ibr17 = parcelRequire("ibr17");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $a7beb0ce4fa4126e$var$stackClear() {
    this.__data__ = new $ibr17;
    this.size = 0;
}
module.exports = $a7beb0ce4fa4126e$var$stackClear;

});

parcelRegister("DoMSX", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0766dee8ae28686e$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $0766dee8ae28686e$var$stackDelete;

});

parcelRegister("k4t2v", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e9cab4f83b8cf2e9$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $e9cab4f83b8cf2e9$var$stackGet;

});

parcelRegister("4NwfS", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $37e4c239050b91e3$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $37e4c239050b91e3$var$stackHas;

});

parcelRegister("lcWk9", function(module, exports) {

var $ibr17 = parcelRequire("ibr17");

var $55ur3 = parcelRequire("55ur3");

var $ejRls = parcelRequire("ejRls");
/** Used as the size to enable large array optimizations. */ var $f707f5e6173bece0$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $f707f5e6173bece0$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $ibr17) {
        var pairs = data.__data__;
        if (!$55ur3 || pairs.length < $f707f5e6173bece0$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $ejRls(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $f707f5e6173bece0$var$stackSet;

});
parcelRegister("55ur3", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $3b45073a9f2f1273$var$Map = $cS0Ds($1DySm, 'Map');
module.exports = $3b45073a9f2f1273$var$Map;

});
parcelRegister("cS0Ds", function(module, exports) {

var $fRlj1 = parcelRequire("fRlj1");

var $1kkOJ = parcelRequire("1kkOJ");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $95eb055fdd27d869$var$getNative(object, key) {
    var value = $1kkOJ(object, key);
    return $fRlj1(value) ? value : undefined;
}
module.exports = $95eb055fdd27d869$var$getNative;

});
parcelRegister("fRlj1", function(module, exports) {

var $Fb9OL = parcelRequire("Fb9OL");

var $k5w0M = parcelRequire("k5w0M");

var $kSkOG = parcelRequire("kSkOG");

var $kZRNU = parcelRequire("kZRNU");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b8bc552383eab615$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b8bc552383eab615$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $b8bc552383eab615$var$funcProto = Function.prototype, $b8bc552383eab615$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b8bc552383eab615$var$funcToString = $b8bc552383eab615$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b8bc552383eab615$var$hasOwnProperty = $b8bc552383eab615$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $b8bc552383eab615$var$reIsNative = RegExp('^' + $b8bc552383eab615$var$funcToString.call($b8bc552383eab615$var$hasOwnProperty).replace($b8bc552383eab615$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b8bc552383eab615$var$baseIsNative(value) {
    if (!$kSkOG(value) || $k5w0M(value)) return false;
    var pattern = $Fb9OL(value) ? $b8bc552383eab615$var$reIsNative : $b8bc552383eab615$var$reIsHostCtor;
    return pattern.test($kZRNU(value));
}
module.exports = $b8bc552383eab615$var$baseIsNative;

});
parcelRegister("Fb9OL", function(module, exports) {

var $eXwEi = parcelRequire("eXwEi");

var $kSkOG = parcelRequire("kSkOG");
/** `Object#toString` result references. */ var $07bc7c115e963817$var$asyncTag = '[object AsyncFunction]', $07bc7c115e963817$var$funcTag = '[object Function]', $07bc7c115e963817$var$genTag = '[object GeneratorFunction]', $07bc7c115e963817$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $07bc7c115e963817$var$isFunction(value) {
    if (!$kSkOG(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eXwEi(value);
    return tag == $07bc7c115e963817$var$funcTag || tag == $07bc7c115e963817$var$genTag || tag == $07bc7c115e963817$var$asyncTag || tag == $07bc7c115e963817$var$proxyTag;
}
module.exports = $07bc7c115e963817$var$isFunction;

});
parcelRegister("eXwEi", function(module, exports) {

var $hjYSj = parcelRequire("hjYSj");

var $adgZm = parcelRequire("adgZm");

var $ahXW6 = parcelRequire("ahXW6");
/** `Object#toString` result references. */ var $ae3fe6c5950c122e$var$nullTag = '[object Null]', $ae3fe6c5950c122e$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ae3fe6c5950c122e$var$symToStringTag = $hjYSj ? $hjYSj.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ae3fe6c5950c122e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ae3fe6c5950c122e$var$undefinedTag : $ae3fe6c5950c122e$var$nullTag;
    return $ae3fe6c5950c122e$var$symToStringTag && $ae3fe6c5950c122e$var$symToStringTag in Object(value) ? $adgZm(value) : $ahXW6(value);
}
module.exports = $ae3fe6c5950c122e$var$baseGetTag;

});
parcelRegister("hjYSj", function(module, exports) {

var $1DySm = parcelRequire("1DySm");
/** Built-in value references. */ var $c9c36e86f7d6f497$var$Symbol = $1DySm.Symbol;
module.exports = $c9c36e86f7d6f497$var$Symbol;

});
parcelRegister("1DySm", function(module, exports) {

var $8X2yT = parcelRequire("8X2yT");
/** Detect free variable `self`. */ var $13147c93e8511c05$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $13147c93e8511c05$var$root = $8X2yT || $13147c93e8511c05$var$freeSelf || Function('return this')();
module.exports = $13147c93e8511c05$var$root;

});
parcelRegister("8X2yT", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $6845d21fa7e75b3b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $6845d21fa7e75b3b$var$freeGlobal;

});



parcelRegister("adgZm", function(module, exports) {

var $hjYSj = parcelRequire("hjYSj");
/** Used for built-in method references. */ var $76f84bdae49ee13c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $76f84bdae49ee13c$var$hasOwnProperty = $76f84bdae49ee13c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $76f84bdae49ee13c$var$nativeObjectToString = $76f84bdae49ee13c$var$objectProto.toString;
/** Built-in value references. */ var $76f84bdae49ee13c$var$symToStringTag = $hjYSj ? $hjYSj.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $76f84bdae49ee13c$var$getRawTag(value) {
    var isOwn = $76f84bdae49ee13c$var$hasOwnProperty.call(value, $76f84bdae49ee13c$var$symToStringTag), tag = value[$76f84bdae49ee13c$var$symToStringTag];
    try {
        value[$76f84bdae49ee13c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $76f84bdae49ee13c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$76f84bdae49ee13c$var$symToStringTag] = tag;
        else delete value[$76f84bdae49ee13c$var$symToStringTag];
    }
    return result;
}
module.exports = $76f84bdae49ee13c$var$getRawTag;

});

parcelRegister("ahXW6", function(module, exports) {
/** Used for built-in method references. */ var $77d9fbfccc3fe2a6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $77d9fbfccc3fe2a6$var$nativeObjectToString = $77d9fbfccc3fe2a6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $77d9fbfccc3fe2a6$var$objectToString(value) {
    return $77d9fbfccc3fe2a6$var$nativeObjectToString.call(value);
}
module.exports = $77d9fbfccc3fe2a6$var$objectToString;

});


parcelRegister("kSkOG", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f328ff7ee4fde81a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f328ff7ee4fde81a$var$isObject;

});


parcelRegister("k5w0M", function(module, exports) {

var $24tqU = parcelRequire("24tqU");
/** Used to detect methods masquerading as native. */ var $e9fd1b1d57dc1cf8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($24tqU && $24tqU.keys && $24tqU.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e9fd1b1d57dc1cf8$var$isMasked(func) {
    return !!$e9fd1b1d57dc1cf8$var$maskSrcKey && $e9fd1b1d57dc1cf8$var$maskSrcKey in func;
}
module.exports = $e9fd1b1d57dc1cf8$var$isMasked;

});
parcelRegister("24tqU", function(module, exports) {

var $1DySm = parcelRequire("1DySm");
/** Used to detect overreaching core-js shims. */ var $1822c948e6f3062a$var$coreJsData = $1DySm["__core-js_shared__"];
module.exports = $1822c948e6f3062a$var$coreJsData;

});


parcelRegister("kZRNU", function(module, exports) {
/** Used for built-in method references. */ var $f4933d7f0a06eb7d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f4933d7f0a06eb7d$var$funcToString = $f4933d7f0a06eb7d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f4933d7f0a06eb7d$var$toSource(func) {
    if (func != null) {
        try {
            return $f4933d7f0a06eb7d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $f4933d7f0a06eb7d$var$toSource;

});


parcelRegister("1kkOJ", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $0f77ce8dc1867245$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $0f77ce8dc1867245$var$getValue;

});



parcelRegister("ejRls", function(module, exports) {

var $8Amwq = parcelRequire("8Amwq");

var $7v4cX = parcelRequire("7v4cX");

var $46YH9 = parcelRequire("46YH9");

var $2YNeK = parcelRequire("2YNeK");

var $fq6pV = parcelRequire("fq6pV");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a6cc38418910b2e0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a6cc38418910b2e0$var$MapCache.prototype.clear = $8Amwq;
$a6cc38418910b2e0$var$MapCache.prototype['delete'] = $7v4cX;
$a6cc38418910b2e0$var$MapCache.prototype.get = $46YH9;
$a6cc38418910b2e0$var$MapCache.prototype.has = $2YNeK;
$a6cc38418910b2e0$var$MapCache.prototype.set = $fq6pV;
module.exports = $a6cc38418910b2e0$var$MapCache;

});
parcelRegister("8Amwq", function(module, exports) {

var $5kvl6 = parcelRequire("5kvl6");

var $ibr17 = parcelRequire("ibr17");

var $55ur3 = parcelRequire("55ur3");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $640327eb3d1069cf$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $5kvl6,
        'map': new ($55ur3 || $ibr17),
        'string': new $5kvl6
    };
}
module.exports = $640327eb3d1069cf$var$mapCacheClear;

});
parcelRegister("5kvl6", function(module, exports) {

var $gGs3m = parcelRequire("gGs3m");

var $dj7NW = parcelRequire("dj7NW");

var $g496M = parcelRequire("g496M");

var $th0Zm = parcelRequire("th0Zm");

var $biNn6 = parcelRequire("biNn6");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3e17215e62373b7a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$3e17215e62373b7a$var$Hash.prototype.clear = $gGs3m;
$3e17215e62373b7a$var$Hash.prototype['delete'] = $dj7NW;
$3e17215e62373b7a$var$Hash.prototype.get = $g496M;
$3e17215e62373b7a$var$Hash.prototype.has = $th0Zm;
$3e17215e62373b7a$var$Hash.prototype.set = $biNn6;
module.exports = $3e17215e62373b7a$var$Hash;

});
parcelRegister("gGs3m", function(module, exports) {

var $boWgw = parcelRequire("boWgw");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c25654624248087e$var$hashClear() {
    this.__data__ = $boWgw ? $boWgw(null) : {};
    this.size = 0;
}
module.exports = $c25654624248087e$var$hashClear;

});
parcelRegister("boWgw", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");
/* Built-in method references that are verified to be native. */ var $84cf21ec84c19391$var$nativeCreate = $cS0Ds(Object, 'create');
module.exports = $84cf21ec84c19391$var$nativeCreate;

});


parcelRegister("dj7NW", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9b031a80da354f86$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9b031a80da354f86$var$hashDelete;

});

parcelRegister("g496M", function(module, exports) {

var $boWgw = parcelRequire("boWgw");
/** Used to stand-in for `undefined` hash values. */ var $bb2415c9bb53848d$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $bb2415c9bb53848d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb2415c9bb53848d$var$hasOwnProperty = $bb2415c9bb53848d$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bb2415c9bb53848d$var$hashGet(key) {
    var data = this.__data__;
    if ($boWgw) {
        var result = data[key];
        return result === $bb2415c9bb53848d$var$HASH_UNDEFINED ? undefined : result;
    }
    return $bb2415c9bb53848d$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $bb2415c9bb53848d$var$hashGet;

});

parcelRegister("th0Zm", function(module, exports) {

var $boWgw = parcelRequire("boWgw");
/** Used for built-in method references. */ var $057fe85caf4b041d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $057fe85caf4b041d$var$hasOwnProperty = $057fe85caf4b041d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $057fe85caf4b041d$var$hashHas(key) {
    var data = this.__data__;
    return $boWgw ? data[key] !== undefined : $057fe85caf4b041d$var$hasOwnProperty.call(data, key);
}
module.exports = $057fe85caf4b041d$var$hashHas;

});

parcelRegister("biNn6", function(module, exports) {

var $boWgw = parcelRequire("boWgw");
/** Used to stand-in for `undefined` hash values. */ var $83a7ac52366bc66e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $83a7ac52366bc66e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $boWgw && value === undefined ? $83a7ac52366bc66e$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $83a7ac52366bc66e$var$hashSet;

});



parcelRegister("7v4cX", function(module, exports) {

var $jUk43 = parcelRequire("jUk43");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $575eb14ab2b31b03$var$mapCacheDelete(key) {
    var result = $jUk43(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $575eb14ab2b31b03$var$mapCacheDelete;

});
parcelRegister("jUk43", function(module, exports) {

var $8P708 = parcelRequire("8P708");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e7e2cfab823d50ee$var$getMapData(map, key) {
    var data = map.__data__;
    return $8P708(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $e7e2cfab823d50ee$var$getMapData;

});
parcelRegister("8P708", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $66c884747b0ddd4d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $66c884747b0ddd4d$var$isKeyable;

});



parcelRegister("46YH9", function(module, exports) {

var $jUk43 = parcelRequire("jUk43");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2fe6cdb7e5c793dc$var$mapCacheGet(key) {
    return $jUk43(this, key).get(key);
}
module.exports = $2fe6cdb7e5c793dc$var$mapCacheGet;

});

parcelRegister("2YNeK", function(module, exports) {

var $jUk43 = parcelRequire("jUk43");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $22b760cf30a31377$var$mapCacheHas(key) {
    return $jUk43(this, key).has(key);
}
module.exports = $22b760cf30a31377$var$mapCacheHas;

});

parcelRegister("fq6pV", function(module, exports) {

var $jUk43 = parcelRequire("jUk43");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b39e430f93ec17f8$var$mapCacheSet(key, value) {
    var data = $jUk43(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $b39e430f93ec17f8$var$mapCacheSet;

});




parcelRegister("1JRPZ", function(module, exports) {

var $aKlWX = parcelRequire("aKlWX");

var $gGKJn = parcelRequire("gGKJn");

var $8fDqx = parcelRequire("8fDqx");
/** Used to compose bitmasks for value comparisons. */ var $1443c170489acf32$var$COMPARE_PARTIAL_FLAG = 1, $1443c170489acf32$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1443c170489acf32$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1443c170489acf32$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1443c170489acf32$var$COMPARE_UNORDERED_FLAG ? new $aKlWX : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$gGKJn(other, function(othValue, othIndex) {
                if (!$8fDqx(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $1443c170489acf32$var$equalArrays;

});
parcelRegister("aKlWX", function(module, exports) {

var $ejRls = parcelRequire("ejRls");

var $lcsEj = parcelRequire("lcsEj");

var $kDzQ4 = parcelRequire("kDzQ4");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $7d2f3a0d9ce14f26$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $ejRls;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$7d2f3a0d9ce14f26$var$SetCache.prototype.add = $7d2f3a0d9ce14f26$var$SetCache.prototype.push = $lcsEj;
$7d2f3a0d9ce14f26$var$SetCache.prototype.has = $kDzQ4;
module.exports = $7d2f3a0d9ce14f26$var$SetCache;

});
parcelRegister("lcsEj", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $f6f0f11ce35948e9$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f6f0f11ce35948e9$var$setCacheAdd(value) {
    this.__data__.set(value, $f6f0f11ce35948e9$var$HASH_UNDEFINED);
    return this;
}
module.exports = $f6f0f11ce35948e9$var$setCacheAdd;

});

parcelRegister("kDzQ4", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f0633ffdd75034a5$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $f0633ffdd75034a5$var$setCacheHas;

});


parcelRegister("gGKJn", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c264d15e7c8deb78$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $c264d15e7c8deb78$var$arraySome;

});

parcelRegister("8fDqx", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $601e4ed5362647b9$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $601e4ed5362647b9$var$cacheHas;

});


parcelRegister("4eUTQ", function(module, exports) {

var $hjYSj = parcelRequire("hjYSj");

var $bdBvw = parcelRequire("bdBvw");

var $bGvkD = parcelRequire("bGvkD");

var $1JRPZ = parcelRequire("1JRPZ");

var $3zqiw = parcelRequire("3zqiw");

var $kqPJB = parcelRequire("kqPJB");
/** Used to compose bitmasks for value comparisons. */ var $31649b4ecd936387$var$COMPARE_PARTIAL_FLAG = 1, $31649b4ecd936387$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $31649b4ecd936387$var$boolTag = '[object Boolean]', $31649b4ecd936387$var$dateTag = '[object Date]', $31649b4ecd936387$var$errorTag = '[object Error]', $31649b4ecd936387$var$mapTag = '[object Map]', $31649b4ecd936387$var$numberTag = '[object Number]', $31649b4ecd936387$var$regexpTag = '[object RegExp]', $31649b4ecd936387$var$setTag = '[object Set]', $31649b4ecd936387$var$stringTag = '[object String]', $31649b4ecd936387$var$symbolTag = '[object Symbol]';
var $31649b4ecd936387$var$arrayBufferTag = '[object ArrayBuffer]', $31649b4ecd936387$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $31649b4ecd936387$var$symbolProto = $hjYSj ? $hjYSj.prototype : undefined, $31649b4ecd936387$var$symbolValueOf = $31649b4ecd936387$var$symbolProto ? $31649b4ecd936387$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $31649b4ecd936387$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $31649b4ecd936387$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $31649b4ecd936387$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $bdBvw(object), new $bdBvw(other))) return false;
            return true;
        case $31649b4ecd936387$var$boolTag:
        case $31649b4ecd936387$var$dateTag:
        case $31649b4ecd936387$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $bGvkD(+object, +other);
        case $31649b4ecd936387$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $31649b4ecd936387$var$regexpTag:
        case $31649b4ecd936387$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $31649b4ecd936387$var$mapTag:
            var convert = $3zqiw;
        case $31649b4ecd936387$var$setTag:
            var isPartial = bitmask & $31649b4ecd936387$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $kqPJB);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $31649b4ecd936387$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1JRPZ(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $31649b4ecd936387$var$symbolTag:
            if ($31649b4ecd936387$var$symbolValueOf) return $31649b4ecd936387$var$symbolValueOf.call(object) == $31649b4ecd936387$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $31649b4ecd936387$var$equalByTag;

});
parcelRegister("bdBvw", function(module, exports) {

var $1DySm = parcelRequire("1DySm");
/** Built-in value references. */ var $82ae00c827cb4de5$var$Uint8Array = $1DySm.Uint8Array;
module.exports = $82ae00c827cb4de5$var$Uint8Array;

});

parcelRegister("3zqiw", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $29990a2aa372abaa$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $29990a2aa372abaa$var$mapToArray;

});

parcelRegister("kqPJB", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $edfe5dc5ee94a646$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $edfe5dc5ee94a646$var$setToArray;

});


parcelRegister("lgEYI", function(module, exports) {

var $ftbiQ = parcelRequire("ftbiQ");
/** Used to compose bitmasks for value comparisons. */ var $f7bae1035bea0715$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f7bae1035bea0715$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7bae1035bea0715$var$hasOwnProperty = $f7bae1035bea0715$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f7bae1035bea0715$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f7bae1035bea0715$var$COMPARE_PARTIAL_FLAG, objProps = $ftbiQ(object), objLength = objProps.length, othProps = $ftbiQ(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f7bae1035bea0715$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $f7bae1035bea0715$var$equalObjects;

});
parcelRegister("ftbiQ", function(module, exports) {

var $7Pscw = parcelRequire("7Pscw");

var $lgL09 = parcelRequire("lgL09");

var $1m8gD = parcelRequire("1m8gD");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b43254fda44c104a$var$getAllKeys(object) {
    return $7Pscw(object, $1m8gD, $lgL09);
}
module.exports = $b43254fda44c104a$var$getAllKeys;

});
parcelRegister("7Pscw", function(module, exports) {

var $kAZ2U = parcelRequire("kAZ2U");

var $7wkJN = parcelRequire("7wkJN");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5b332bf09b0c6ec2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $7wkJN(object) ? result : $kAZ2U(result, symbolsFunc(object));
}
module.exports = $5b332bf09b0c6ec2$var$baseGetAllKeys;

});
parcelRegister("kAZ2U", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $efe685e6768936ef$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $efe685e6768936ef$var$arrayPush;

});

parcelRegister("7wkJN", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $579b9ba2588bb9de$var$isArray = Array.isArray;
module.exports = $579b9ba2588bb9de$var$isArray;

});


parcelRegister("lgL09", function(module, exports) {

var $iiRuw = parcelRequire("iiRuw");

var $lJTi6 = parcelRequire("lJTi6");
/** Used for built-in method references. */ var $f7bf8d1519698205$var$objectProto = Object.prototype;
/** Built-in value references. */ var $f7bf8d1519698205$var$propertyIsEnumerable = $f7bf8d1519698205$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f7bf8d1519698205$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $f7bf8d1519698205$var$getSymbols = !$f7bf8d1519698205$var$nativeGetSymbols ? $lJTi6 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $iiRuw($f7bf8d1519698205$var$nativeGetSymbols(object), function(symbol) {
        return $f7bf8d1519698205$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $f7bf8d1519698205$var$getSymbols;

});
parcelRegister("iiRuw", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $d53366b2ff590363$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $d53366b2ff590363$var$arrayFilter;

});

parcelRegister("lJTi6", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $fd38b0983d4c349d$var$stubArray() {
    return [];
}
module.exports = $fd38b0983d4c349d$var$stubArray;

});


parcelRegister("1m8gD", function(module, exports) {

var $1NsVH = parcelRequire("1NsVH");

var $gjkox = parcelRequire("gjkox");

var $5VpCg = parcelRequire("5VpCg");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0fce4239ee480ef0$var$keys(object) {
    return $5VpCg(object) ? $1NsVH(object) : $gjkox(object);
}
module.exports = $0fce4239ee480ef0$var$keys;

});
parcelRegister("1NsVH", function(module, exports) {

var $3GJcb = parcelRequire("3GJcb");

var $6O5ny = parcelRequire("6O5ny");

var $7wkJN = parcelRequire("7wkJN");

var $9gBlp = parcelRequire("9gBlp");

var $e8xSQ = parcelRequire("e8xSQ");

var $cuTxs = parcelRequire("cuTxs");
/** Used for built-in method references. */ var $14f0cee26f6289b7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $14f0cee26f6289b7$var$hasOwnProperty = $14f0cee26f6289b7$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $14f0cee26f6289b7$var$arrayLikeKeys(value, inherited) {
    var isArr = $7wkJN(value), isArg = !isArr && $6O5ny(value), isBuff = !isArr && !isArg && $9gBlp(value), isType = !isArr && !isArg && !isBuff && $cuTxs(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $3GJcb(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $14f0cee26f6289b7$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $e8xSQ(key, length)))) result.push(key);
    return result;
}
module.exports = $14f0cee26f6289b7$var$arrayLikeKeys;

});
parcelRegister("3GJcb", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $2af85a3e5a570ba7$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $2af85a3e5a570ba7$var$baseTimes;

});

parcelRegister("6O5ny", function(module, exports) {

var $1VgPC = parcelRequire("1VgPC");

var $d2kYI = parcelRequire("d2kYI");
/** Used for built-in method references. */ var $4f4b95b8aefe4d77$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4f4b95b8aefe4d77$var$hasOwnProperty = $4f4b95b8aefe4d77$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $4f4b95b8aefe4d77$var$propertyIsEnumerable = $4f4b95b8aefe4d77$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $4f4b95b8aefe4d77$var$isArguments = $1VgPC(function() {
    return arguments;
}()) ? $1VgPC : function(value) {
    return $d2kYI(value) && $4f4b95b8aefe4d77$var$hasOwnProperty.call(value, 'callee') && !$4f4b95b8aefe4d77$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $4f4b95b8aefe4d77$var$isArguments;

});
parcelRegister("1VgPC", function(module, exports) {

var $eXwEi = parcelRequire("eXwEi");

var $d2kYI = parcelRequire("d2kYI");
/** `Object#toString` result references. */ var $16682bb217664efe$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $16682bb217664efe$var$baseIsArguments(value) {
    return $d2kYI(value) && $eXwEi(value) == $16682bb217664efe$var$argsTag;
}
module.exports = $16682bb217664efe$var$baseIsArguments;

});
parcelRegister("d2kYI", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97dbbc1a069ce16a$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $97dbbc1a069ce16a$var$isObjectLike;

});



parcelRegister("9gBlp", function(module, exports) {

var $1DySm = parcelRequire("1DySm");

var $1Wbuo = parcelRequire("1Wbuo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1DySm.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1Wbuo;
module.exports = isBuffer;

});
parcelRegister("1Wbuo", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $16941ebaddae1967$var$stubFalse() {
    return false;
}
module.exports = $16941ebaddae1967$var$stubFalse;

});


parcelRegister("e8xSQ", function(module, exports) {
/** Used as references for various `Number` constants. */ var $a4ac18a3b008eabc$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a4ac18a3b008eabc$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a4ac18a3b008eabc$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a4ac18a3b008eabc$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $a4ac18a3b008eabc$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $a4ac18a3b008eabc$var$isIndex;

});

parcelRegister("cuTxs", function(module, exports) {

var $5xVTl = parcelRequire("5xVTl");

var $gSVZ6 = parcelRequire("gSVZ6");

var $iU8uW = parcelRequire("iU8uW");
/* Node.js helper references. */ var $91935e2ee1691ad1$var$nodeIsTypedArray = $iU8uW && $iU8uW.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $91935e2ee1691ad1$var$isTypedArray = $91935e2ee1691ad1$var$nodeIsTypedArray ? $gSVZ6($91935e2ee1691ad1$var$nodeIsTypedArray) : $5xVTl;
module.exports = $91935e2ee1691ad1$var$isTypedArray;

});
parcelRegister("5xVTl", function(module, exports) {

var $eXwEi = parcelRequire("eXwEi");

var $1FA1m = parcelRequire("1FA1m");

var $d2kYI = parcelRequire("d2kYI");
/** `Object#toString` result references. */ var $409cf0e4c937c990$var$argsTag = '[object Arguments]', $409cf0e4c937c990$var$arrayTag = '[object Array]', $409cf0e4c937c990$var$boolTag = '[object Boolean]', $409cf0e4c937c990$var$dateTag = '[object Date]', $409cf0e4c937c990$var$errorTag = '[object Error]', $409cf0e4c937c990$var$funcTag = '[object Function]', $409cf0e4c937c990$var$mapTag = '[object Map]', $409cf0e4c937c990$var$numberTag = '[object Number]', $409cf0e4c937c990$var$objectTag = '[object Object]', $409cf0e4c937c990$var$regexpTag = '[object RegExp]', $409cf0e4c937c990$var$setTag = '[object Set]', $409cf0e4c937c990$var$stringTag = '[object String]', $409cf0e4c937c990$var$weakMapTag = '[object WeakMap]';
var $409cf0e4c937c990$var$arrayBufferTag = '[object ArrayBuffer]', $409cf0e4c937c990$var$dataViewTag = '[object DataView]', $409cf0e4c937c990$var$float32Tag = '[object Float32Array]', $409cf0e4c937c990$var$float64Tag = '[object Float64Array]', $409cf0e4c937c990$var$int8Tag = '[object Int8Array]', $409cf0e4c937c990$var$int16Tag = '[object Int16Array]', $409cf0e4c937c990$var$int32Tag = '[object Int32Array]', $409cf0e4c937c990$var$uint8Tag = '[object Uint8Array]', $409cf0e4c937c990$var$uint8ClampedTag = '[object Uint8ClampedArray]', $409cf0e4c937c990$var$uint16Tag = '[object Uint16Array]', $409cf0e4c937c990$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $409cf0e4c937c990$var$typedArrayTags = {};
$409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$float32Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$float64Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int8Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int16Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int32Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint8Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint8ClampedTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint16Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint32Tag] = true;
$409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$argsTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$arrayTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$arrayBufferTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$boolTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$dataViewTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$dateTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$errorTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$funcTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$mapTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$numberTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$objectTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$regexpTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$setTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$stringTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $409cf0e4c937c990$var$baseIsTypedArray(value) {
    return $d2kYI(value) && $1FA1m(value.length) && !!$409cf0e4c937c990$var$typedArrayTags[$eXwEi(value)];
}
module.exports = $409cf0e4c937c990$var$baseIsTypedArray;

});
parcelRegister("1FA1m", function(module, exports) {
/** Used as references for various `Number` constants. */ var $13758fcec31fd7af$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $13758fcec31fd7af$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $13758fcec31fd7af$var$MAX_SAFE_INTEGER;
}
module.exports = $13758fcec31fd7af$var$isLength;

});


parcelRegister("gSVZ6", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c4aeaafb4421a79e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $c4aeaafb4421a79e$var$baseUnary;

});

parcelRegister("iU8uW", function(module, exports) {

var $8X2yT = parcelRequire("8X2yT");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8X2yT.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("gjkox", function(module, exports) {

var $fzGpL = parcelRequire("fzGpL");

var $2V88E = parcelRequire("2V88E");
/** Used for built-in method references. */ var $bdfe3da66489f7d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bdfe3da66489f7d9$var$hasOwnProperty = $bdfe3da66489f7d9$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bdfe3da66489f7d9$var$baseKeys(object) {
    if (!$fzGpL(object)) return $2V88E(object);
    var result = [];
    for(var key in Object(object))if ($bdfe3da66489f7d9$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $bdfe3da66489f7d9$var$baseKeys;

});
parcelRegister("fzGpL", function(module, exports) {
/** Used for built-in method references. */ var $b56b06902d83e6f4$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $b56b06902d83e6f4$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $b56b06902d83e6f4$var$objectProto;
    return value === proto;
}
module.exports = $b56b06902d83e6f4$var$isPrototype;

});

parcelRegister("2V88E", function(module, exports) {

var $lMYRi = parcelRequire("lMYRi");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $220737c9fb125768$var$nativeKeys = $lMYRi(Object.keys, Object);
module.exports = $220737c9fb125768$var$nativeKeys;

});
parcelRegister("lMYRi", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fdcd49ef52ce3234$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $fdcd49ef52ce3234$var$overArg;

});



parcelRegister("5VpCg", function(module, exports) {

var $Fb9OL = parcelRequire("Fb9OL");

var $1FA1m = parcelRequire("1FA1m");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $4506257970d5c979$var$isArrayLike(value) {
    return value != null && $1FA1m(value.length) && !$Fb9OL(value);
}
module.exports = $4506257970d5c979$var$isArrayLike;

});




parcelRegister("3tPzb", function(module, exports) {

var $6JzGB = parcelRequire("6JzGB");

var $55ur3 = parcelRequire("55ur3");

var $h9bAs = parcelRequire("h9bAs");

var $3D3eV = parcelRequire("3D3eV");

var $jr2IZ = parcelRequire("jr2IZ");

var $eXwEi = parcelRequire("eXwEi");

var $kZRNU = parcelRequire("kZRNU");
/** `Object#toString` result references. */ var $288c148fae7027f4$var$mapTag = '[object Map]', $288c148fae7027f4$var$objectTag = '[object Object]', $288c148fae7027f4$var$promiseTag = '[object Promise]', $288c148fae7027f4$var$setTag = '[object Set]', $288c148fae7027f4$var$weakMapTag = '[object WeakMap]';
var $288c148fae7027f4$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $288c148fae7027f4$var$dataViewCtorString = $kZRNU($6JzGB), $288c148fae7027f4$var$mapCtorString = $kZRNU($55ur3), $288c148fae7027f4$var$promiseCtorString = $kZRNU($h9bAs), $288c148fae7027f4$var$setCtorString = $kZRNU($3D3eV), $288c148fae7027f4$var$weakMapCtorString = $kZRNU($jr2IZ);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $288c148fae7027f4$var$getTag = $eXwEi;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($6JzGB && $288c148fae7027f4$var$getTag(new $6JzGB(new ArrayBuffer(1))) != $288c148fae7027f4$var$dataViewTag || $55ur3 && $288c148fae7027f4$var$getTag(new $55ur3) != $288c148fae7027f4$var$mapTag || $h9bAs && $288c148fae7027f4$var$getTag($h9bAs.resolve()) != $288c148fae7027f4$var$promiseTag || $3D3eV && $288c148fae7027f4$var$getTag(new $3D3eV) != $288c148fae7027f4$var$setTag || $jr2IZ && $288c148fae7027f4$var$getTag(new $jr2IZ) != $288c148fae7027f4$var$weakMapTag) $288c148fae7027f4$var$getTag = function(value) {
    var result = $eXwEi(value), Ctor = result == $288c148fae7027f4$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $kZRNU(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $288c148fae7027f4$var$dataViewCtorString:
            return $288c148fae7027f4$var$dataViewTag;
        case $288c148fae7027f4$var$mapCtorString:
            return $288c148fae7027f4$var$mapTag;
        case $288c148fae7027f4$var$promiseCtorString:
            return $288c148fae7027f4$var$promiseTag;
        case $288c148fae7027f4$var$setCtorString:
            return $288c148fae7027f4$var$setTag;
        case $288c148fae7027f4$var$weakMapCtorString:
            return $288c148fae7027f4$var$weakMapTag;
    }
    return result;
};
module.exports = $288c148fae7027f4$var$getTag;

});
parcelRegister("6JzGB", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $4e72a091824b54c2$var$DataView = $cS0Ds($1DySm, 'DataView');
module.exports = $4e72a091824b54c2$var$DataView;

});

parcelRegister("h9bAs", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $c7bc43de39f545d4$var$Promise = $cS0Ds($1DySm, 'Promise');
module.exports = $c7bc43de39f545d4$var$Promise;

});

parcelRegister("3D3eV", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $2a4786f2dfc898c9$var$Set = $cS0Ds($1DySm, 'Set');
module.exports = $2a4786f2dfc898c9$var$Set;

});

parcelRegister("jr2IZ", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");

var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $e262a6fad30144cf$var$WeakMap = $cS0Ds($1DySm, 'WeakMap');
module.exports = $e262a6fad30144cf$var$WeakMap;

});





parcelRegister("8d7ev", function(module, exports) {

var $2TbF5 = parcelRequire("2TbF5");

var $jGN4W = parcelRequire("jGN4W");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $5fa525eed03daf3a$var$keyBy = $jGN4W(function(result, value, key) {
    $2TbF5(result, key, value);
});
module.exports = $5fa525eed03daf3a$var$keyBy;

});
parcelRegister("2TbF5", function(module, exports) {

var $3fIJf = parcelRequire("3fIJf");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $21a9c399fabc76fe$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $3fIJf) $3fIJf(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $21a9c399fabc76fe$var$baseAssignValue;

});
parcelRegister("3fIJf", function(module, exports) {

var $cS0Ds = parcelRequire("cS0Ds");
var $25e57808ab068dc5$var$defineProperty = function() {
    try {
        var func = $cS0Ds(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $25e57808ab068dc5$var$defineProperty;

});


parcelRegister("jGN4W", function(module, exports) {

var $bJakB = parcelRequire("bJakB");

var $hd2Mf = parcelRequire("hd2Mf");

var $gr1Zx = parcelRequire("gr1Zx");

var $7wkJN = parcelRequire("7wkJN");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $e5580294ab566520$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $7wkJN(collection) ? $bJakB : $hd2Mf, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $gr1Zx(iteratee, 2), accumulator);
    };
}
module.exports = $e5580294ab566520$var$createAggregator;

});
parcelRegister("bJakB", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $889be944aebe51a0$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $889be944aebe51a0$var$arrayAggregator;

});

parcelRegister("hd2Mf", function(module, exports) {

var $aSAH0 = parcelRequire("aSAH0");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c875ce1166898f67$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $aSAH0(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $c875ce1166898f67$var$baseAggregator;

});
parcelRegister("aSAH0", function(module, exports) {

var $lRCxV = parcelRequire("lRCxV");

var $dSjPV = parcelRequire("dSjPV");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $7ebb68e7a3797e10$var$baseEach = $dSjPV($lRCxV);
module.exports = $7ebb68e7a3797e10$var$baseEach;

});
parcelRegister("lRCxV", function(module, exports) {

var $2hbBP = parcelRequire("2hbBP");

var $1m8gD = parcelRequire("1m8gD");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $feac72adfe18f958$var$baseForOwn(object, iteratee) {
    return object && $2hbBP(object, iteratee, $1m8gD);
}
module.exports = $feac72adfe18f958$var$baseForOwn;

});
parcelRegister("2hbBP", function(module, exports) {

var $57QEK = parcelRequire("57QEK");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $1a862ca629cc3032$var$baseFor = $57QEK();
module.exports = $1a862ca629cc3032$var$baseFor;

});
parcelRegister("57QEK", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3bb6739cad2da2c9$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $3bb6739cad2da2c9$var$createBaseFor;

});



parcelRegister("dSjPV", function(module, exports) {

var $5VpCg = parcelRequire("5VpCg");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $a19fb4a1ae1d38c6$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$5VpCg(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $a19fb4a1ae1d38c6$var$createBaseEach;

});



parcelRegister("gr1Zx", function(module, exports) {

var $3h5Kd = parcelRequire("3h5Kd");

var $cO6Fj = parcelRequire("cO6Fj");

var $jEcWK = parcelRequire("jEcWK");

var $7wkJN = parcelRequire("7wkJN");

var $3ZHO3 = parcelRequire("3ZHO3");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $bf70b66c162aef31$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $jEcWK;
    if (typeof value == 'object') return $7wkJN(value) ? $cO6Fj(value[0], value[1]) : $3h5Kd(value);
    return $3ZHO3(value);
}
module.exports = $bf70b66c162aef31$var$baseIteratee;

});
parcelRegister("3h5Kd", function(module, exports) {

var $i1uaW = parcelRequire("i1uaW");

var $12FFi = parcelRequire("12FFi");

var $c0UBD = parcelRequire("c0UBD");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $26276a5f2fd81978$var$baseMatches(source) {
    var matchData = $12FFi(source);
    if (matchData.length == 1 && matchData[0][2]) return $c0UBD(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $i1uaW(object, source, matchData);
    };
}
module.exports = $26276a5f2fd81978$var$baseMatches;

});
parcelRegister("i1uaW", function(module, exports) {

var $a6ECp = parcelRequire("a6ECp");

var $aH9iS = parcelRequire("aH9iS");
/** Used to compose bitmasks for value comparisons. */ var $d1efba33353344a0$var$COMPARE_PARTIAL_FLAG = 1, $d1efba33353344a0$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $d1efba33353344a0$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $a6ECp;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $aH9iS(srcValue, objValue, $d1efba33353344a0$var$COMPARE_PARTIAL_FLAG | $d1efba33353344a0$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $d1efba33353344a0$var$baseIsMatch;

});

parcelRegister("12FFi", function(module, exports) {

var $2Kknc = parcelRequire("2Kknc");

var $1m8gD = parcelRequire("1m8gD");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $0c264c2d18b81eb5$var$getMatchData(object) {
    var result = $1m8gD(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $2Kknc(value)
        ];
    }
    return result;
}
module.exports = $0c264c2d18b81eb5$var$getMatchData;

});
parcelRegister("2Kknc", function(module, exports) {

var $kSkOG = parcelRequire("kSkOG");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $1fffae593e239b7a$var$isStrictComparable(value) {
    return value === value && !$kSkOG(value);
}
module.exports = $1fffae593e239b7a$var$isStrictComparable;

});


parcelRegister("c0UBD", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $8bf164e6cb59822f$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $8bf164e6cb59822f$var$matchesStrictComparable;

});


parcelRegister("cO6Fj", function(module, exports) {

var $aH9iS = parcelRequire("aH9iS");

var $lgLo8 = parcelRequire("lgLo8");

var $xKPda = parcelRequire("xKPda");

var $92oU2 = parcelRequire("92oU2");

var $2Kknc = parcelRequire("2Kknc");

var $c0UBD = parcelRequire("c0UBD");

var $PnZBU = parcelRequire("PnZBU");
/** Used to compose bitmasks for value comparisons. */ var $952f5322c982d82b$var$COMPARE_PARTIAL_FLAG = 1, $952f5322c982d82b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $952f5322c982d82b$var$baseMatchesProperty(path, srcValue) {
    if ($92oU2(path) && $2Kknc(srcValue)) return $c0UBD($PnZBU(path), srcValue);
    return function(object) {
        var objValue = $lgLo8(object, path);
        return objValue === undefined && objValue === srcValue ? $xKPda(object, path) : $aH9iS(srcValue, objValue, $952f5322c982d82b$var$COMPARE_PARTIAL_FLAG | $952f5322c982d82b$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $952f5322c982d82b$var$baseMatchesProperty;

});
parcelRegister("lgLo8", function(module, exports) {

var $k0FqL = parcelRequire("k0FqL");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $f7bfd9e73571977c$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $k0FqL(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $f7bfd9e73571977c$var$get;

});
parcelRegister("k0FqL", function(module, exports) {

var $3557P = parcelRequire("3557P");

var $PnZBU = parcelRequire("PnZBU");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $e913f1fcbff7147e$var$baseGet(object, path) {
    path = $3557P(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$PnZBU(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $e913f1fcbff7147e$var$baseGet;

});
parcelRegister("3557P", function(module, exports) {

var $7wkJN = parcelRequire("7wkJN");

var $92oU2 = parcelRequire("92oU2");

var $e2Gs0 = parcelRequire("e2Gs0");

var $anDUw = parcelRequire("anDUw");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $23e5d07d36d464f0$var$castPath(value, object) {
    if ($7wkJN(value)) return value;
    return $92oU2(value, object) ? [
        value
    ] : $e2Gs0($anDUw(value));
}
module.exports = $23e5d07d36d464f0$var$castPath;

});
parcelRegister("92oU2", function(module, exports) {

var $7wkJN = parcelRequire("7wkJN");

var $47uRs = parcelRequire("47uRs");
/** Used to match property names within property paths. */ var $69479e268680fe10$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $69479e268680fe10$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $69479e268680fe10$var$isKey(value, object) {
    if ($7wkJN(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $47uRs(value)) return true;
    return $69479e268680fe10$var$reIsPlainProp.test(value) || !$69479e268680fe10$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $69479e268680fe10$var$isKey;

});
parcelRegister("47uRs", function(module, exports) {

var $eXwEi = parcelRequire("eXwEi");

var $d2kYI = parcelRequire("d2kYI");
/** `Object#toString` result references. */ var $2fffc1449db40502$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2fffc1449db40502$var$isSymbol(value) {
    return typeof value == 'symbol' || $d2kYI(value) && $eXwEi(value) == $2fffc1449db40502$var$symbolTag;
}
module.exports = $2fffc1449db40502$var$isSymbol;

});


parcelRegister("e2Gs0", function(module, exports) {

var $gXNmQ = parcelRequire("gXNmQ");
/** Used to match property names within property paths. */ var $a3922e70313d25cb$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a3922e70313d25cb$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a3922e70313d25cb$var$stringToPath = $gXNmQ(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a3922e70313d25cb$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a3922e70313d25cb$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $a3922e70313d25cb$var$stringToPath;

});
parcelRegister("gXNmQ", function(module, exports) {

var $6Sx5I = parcelRequire("6Sx5I");
/** Used as the maximum memoize cache size. */ var $032fe0d410f8199d$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $032fe0d410f8199d$var$memoizeCapped(func) {
    var result = $6Sx5I(func, function(key) {
        if (cache.size === $032fe0d410f8199d$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $032fe0d410f8199d$var$memoizeCapped;

});
parcelRegister("6Sx5I", function(module, exports) {

var $ejRls = parcelRequire("ejRls");
/** Error message constants. */ var $5021746db8365e7e$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5021746db8365e7e$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5021746db8365e7e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5021746db8365e7e$var$memoize.Cache || $ejRls);
    return memoized;
}
// Expose `MapCache`.
$5021746db8365e7e$var$memoize.Cache = $ejRls;
module.exports = $5021746db8365e7e$var$memoize;

});



parcelRegister("anDUw", function(module, exports) {

var $1cImV = parcelRequire("1cImV");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $78eb02cd4ef313ef$var$toString(value) {
    return value == null ? '' : $1cImV(value);
}
module.exports = $78eb02cd4ef313ef$var$toString;

});
parcelRegister("1cImV", function(module, exports) {

var $hjYSj = parcelRequire("hjYSj");

var $6wRkJ = parcelRequire("6wRkJ");

var $7wkJN = parcelRequire("7wkJN");

var $47uRs = parcelRequire("47uRs");
/** Used as references for various `Number` constants. */ var $0e09541fbe2727c0$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0e09541fbe2727c0$var$symbolProto = $hjYSj ? $hjYSj.prototype : undefined, $0e09541fbe2727c0$var$symbolToString = $0e09541fbe2727c0$var$symbolProto ? $0e09541fbe2727c0$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0e09541fbe2727c0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($7wkJN(value)) // Recursively convert values (susceptible to call stack limits).
    return $6wRkJ(value, $0e09541fbe2727c0$var$baseToString) + '';
    if ($47uRs(value)) return $0e09541fbe2727c0$var$symbolToString ? $0e09541fbe2727c0$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$0e09541fbe2727c0$var$INFINITY ? '-0' : result;
}
module.exports = $0e09541fbe2727c0$var$baseToString;

});
parcelRegister("6wRkJ", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4c0f1a1d993f5976$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $4c0f1a1d993f5976$var$arrayMap;

});




parcelRegister("PnZBU", function(module, exports) {

var $47uRs = parcelRequire("47uRs");
/** Used as references for various `Number` constants. */ var $09a75ffd36bdbd18$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $09a75ffd36bdbd18$var$toKey(value) {
    if (typeof value == 'string' || $47uRs(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$09a75ffd36bdbd18$var$INFINITY ? '-0' : result;
}
module.exports = $09a75ffd36bdbd18$var$toKey;

});



parcelRegister("xKPda", function(module, exports) {

var $kUHVs = parcelRequire("kUHVs");

var $jk7Bs = parcelRequire("jk7Bs");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $065767a6557522ec$var$hasIn(object, path) {
    return object != null && $jk7Bs(object, path, $kUHVs);
}
module.exports = $065767a6557522ec$var$hasIn;

});
parcelRegister("kUHVs", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f39b1c537d656d19$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $f39b1c537d656d19$var$baseHasIn;

});

parcelRegister("jk7Bs", function(module, exports) {

var $3557P = parcelRequire("3557P");

var $6O5ny = parcelRequire("6O5ny");

var $7wkJN = parcelRequire("7wkJN");

var $e8xSQ = parcelRequire("e8xSQ");

var $1FA1m = parcelRequire("1FA1m");

var $PnZBU = parcelRequire("PnZBU");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $e115c865f83e382c$var$hasPath(object, path, hasFunc) {
    path = $3557P(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $PnZBU(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1FA1m(length) && $e8xSQ(key, length) && ($7wkJN(object) || $6O5ny(object));
}
module.exports = $e115c865f83e382c$var$hasPath;

});



parcelRegister("jEcWK", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e4dbcba8665d9b6c$var$identity(value) {
    return value;
}
module.exports = $e4dbcba8665d9b6c$var$identity;

});

parcelRegister("3ZHO3", function(module, exports) {

var $jYszf = parcelRequire("jYszf");

var $jNRao = parcelRequire("jNRao");

var $92oU2 = parcelRequire("92oU2");

var $PnZBU = parcelRequire("PnZBU");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $2e890ca2b88f7d2c$var$property(path) {
    return $92oU2(path) ? $jYszf($PnZBU(path)) : $jNRao(path);
}
module.exports = $2e890ca2b88f7d2c$var$property;

});
parcelRegister("jYszf", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e8a9c7d31faa2cc3$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $e8a9c7d31faa2cc3$var$baseProperty;

});

parcelRegister("jNRao", function(module, exports) {

var $k0FqL = parcelRequire("k0FqL");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e6abd5b3ef04327c$var$basePropertyDeep(path) {
    return function(object) {
        return $k0FqL(object, path);
    };
}
module.exports = $e6abd5b3ef04327c$var$basePropertyDeep;

});





parcelRegister("cs61D", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("aj35g")).source;
    re.src_Cc = (parcelRequire("d0AeK")).source;
    re.src_Z = (parcelRequire("3IZhh")).source;
    re.src_P = (parcelRequire("fmZj1")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("aj35g", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("d0AeK", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("3IZhh", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("fmZj1", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});


parcelRegister("gSkQi", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("eBahF", function(module, exports) {

$parcel$export(module.exports, "DataGrid", function () { return _s; });

var $7fPBF = parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");

var $7UqAk = parcelRequire("7UqAk");

var $e0IBS = parcelRequire("e0IBS");
var $2jEfe = parcelRequire("2jEfe");
var $fH0xA = parcelRequire("fH0xA");

var $dKzJP = parcelRequire("dKzJP");
var $319Q5 = parcelRequire("319Q5");
var $kyQ4S = parcelRequire("kyQ4S");
var $g3iV0 = parcelRequire("g3iV0");
var $bSzdr = parcelRequire("bSzdr");
var $ejsyu = parcelRequire("ejsyu");
var $1sMi9 = parcelRequire("1sMi9");
var $55RWP = parcelRequire("55RWP");

var $4mLf7 = parcelRequire("4mLf7");
var $8SBLK = parcelRequire("8SBLK");

var $dzfbx = parcelRequire("dzfbx");

var $MQfsM = parcelRequire("MQfsM");

var $i8OTH = parcelRequire("i8OTH");

var $g1A03 = parcelRequire("g1A03");

var $g21Gx = parcelRequire("g21Gx");

var $jaezp = parcelRequire("jaezp");

var $iRcsz = parcelRequire("iRcsz");

var $hzQpW = parcelRequire("hzQpW");

var $7Em3j = parcelRequire("7Em3j");

var $bG0nA = parcelRequire("bG0nA");

var $ckpfM = parcelRequire("ckpfM");

var $iyOta = parcelRequire("iyOta");

var $l6eg8 = parcelRequire("l6eg8");

var $5IlSp = parcelRequire("5IlSp");

var $4mZpH = parcelRequire("4mZpH");

var $fwAOd = parcelRequire("fwAOd");

var $lLRv0 = parcelRequire("lLRv0");

var $hdcUo = parcelRequire("hdcUo");

var $cuouK = parcelRequire("cuouK");

var $k2dmk = parcelRequire("k2dmk");

var $fHFY6 = parcelRequire("fHFY6");

var $9SdKL = parcelRequire("9SdKL");

var $5jbjs = parcelRequire("5jbjs");

var $3NUyv = parcelRequire("3NUyv");

var $2oXYc = parcelRequire("2oXYc");

var $4BA58 = parcelRequire("4BA58");
var ne;
!function(e) {
    e.resize = "resize", e.debouncedResize = "debouncedResize", e.componentError = "componentError", e.unmount = "unmount", e.cellModeChange = "cellModeChange", e.cellClick = "cellClick", e.cellDoubleClick = "cellDoubleClick", e.cellMouseDown = "cellMouseDown", e.cellMouseUp = "cellMouseUp", e.cellOver = "cellOver", e.cellOut = "cellOut", e.cellEnter = "cellEnter", e.cellLeave = "cellLeave", e.cellKeyDown = "cellKeyDown", e.cellBlur = "cellBlur", e.cellFocus = "cellFocus", e.cellFocusOut = "cellFocusOut", e.cellDragStart = "cellDragStart", e.cellDragEnter = "cellDragEnter", e.cellDragOver = "cellDragOver", e.cellDragEnd = "cellDragEnd", e.editCellPropsChange = "editCellPropsChange", e.cellEditCommit = "cellEditCommit", e.cellEditStart = "cellEditStart", e.cellEditStop = "cellEditStop", e.cellNavigationKeyDown = "cellNavigationKeyDown", e.rowClick = "rowClick", e.rowDoubleClick = "rowDoubleClick", e.rowOver = "rowOver", e.rowOut = "rowOut", e.rowEnter = "rowEnter", e.rowLeave = "rowLeave", e.editRowsModelChange = "editRowsModelChange", e.columnHeaderBlur = "columnHeaderBlur", e.columnHeaderFocus = "columnHeaderFocus", e.columnHeaderNavigationKeyDown = "columnHeaderNavigationKeyDown", e.columnHeaderKeyDown = "columnHeaderKeyDown", e.columnHeaderClick = "columnHeaderClick", e.columnHeaderDoubleClick = "columnHeaderDoubleClick", e.columnHeaderOver = "columnHeaderOver", e.columnHeaderOut = "columnHeaderOut", e.columnHeaderEnter = "columnHeaderEnter", e.columnHeaderLeave = "columnHeaderLeave", e.columnHeaderDragStart = "columnHeaderDragStart", e.columnHeaderDragOver = "columnHeaderDragOver", e.columnHeaderDragEnter = "columnHeaderDragEnter", e.columnHeaderDragEnd = "columnHeaderDragEnd", e.selectionChange = "selectionChange", e.pageChange = "pageChange", e.pageSizeChange = "pageSizeChange", e.rowsScroll = "rowsScroll", e.rowsScrollEnd = "rowsScrollEnd", e.columnSeparatorMouseDown = "columnSeparatorMouseDown", e.columnResize = "columnResize", e.columnWidthChange = "columnWidthChange", e.columnResizeStart = "columnResizeStart", e.columnResizeStop = "columnResizeStop", e.columnOrderChange = "columnOrderChange", e.rowsUpdate = "rowsUpdate", e.rowsSet = "rowsSet", e.rowsClear = "rowsClear", e.columnsChange = "columnsChange", e.sortModelChange = "sortModelChange", e.filterModelChange = "filterModelChange", e.stateChange = "stateChange", e.columnVisibilityChange = "columnVisibilityChange", e.viewportRowsChange = "viewportRowsChange";
}(ne || (ne = {}));
const oe = $7fPBF.createContext(void 0);
function ae() {
    const t = $7fPBF.useContext(oe);
    if (void 0 === t) throw new Error([
        "Material-UI X: Could not find the data grid context.",
        "It looks like you rendered your component outside of a DataGrid or XGrid parent component.",
        "This can also happen if you are bundling multiple versions of the data grid."
    ].join("\n"));
    return t;
}
const ie = (e)=>e.columns, se = (e)=>e.columns.all, ce = (e)=>e.columns.lookup, ue = (0, $7UqAk.createSelector)(se, ce, (e, t)=>e.map((e)=>t[e])), de = (0, $7UqAk.createSelector)(ue, (e)=>e.filter((e)=>null != e.field && !e.hide)), pe = (0, $7UqAk.createSelector)(de, (e)=>{
    const t = [];
    return {
        totalWidth: e.reduce((e, r)=>(t.push(e), e + r.computedWidth), 0),
        positions: t
    };
}), me = (0, $7UqAk.createSelector)(ue, (e)=>e.filter((e)=>e.filterable)), fe = (0, $7UqAk.createSelector)(me, (e)=>e.map((e)=>e.field)), ge = (0, $7UqAk.createSelector)(de, (e)=>e.length), be = (0, $7UqAk.createSelector)(pe, (e)=>e.totalWidth), he = "MuiDataGrid", ve = "root", Ce = "columnHeader", we = "row", Oe = "cell", ye = "MuiDataGrid-columnHeader", Ee = "MuiDataGrid-row", Se = "MuiDataGrid-cell", Me = "MuiDataGrid-columnSeparator--resizable", xe = "MuiDataGrid-columnHeaderTitleContainer", ke = "MuiDataGrid-columnHeaderDropZone", De = "MuiDataGrid-columnHeader--dragging";
function Re(e, t) {
    return e === t || e != e && t != t;
}
function Ie(e, t) {
    for(var r = e.length; r--;)if (Re(e[r][0], t)) return r;
    return -1;
}
var Pe = Array.prototype.splice;
function Le(e) {
    var t = -1, r = null == e ? 0 : e.length;
    for(this.clear(); ++t < r;){
        var l = e[t];
        this.set(l[0], l[1]);
    }
}
Le.prototype.clear = function() {
    this.__data__ = [], this.size = 0;
}, Le.prototype.delete = function(e) {
    var t = this.__data__, r = Ie(t, e);
    return !(r < 0) && (r == t.length - 1 ? t.pop() : Pe.call(t, r, 1), --this.size, !0);
}, Le.prototype.get = function(e) {
    var t = this.__data__, r = Ie(t, e);
    return r < 0 ? void 0 : t[r][1];
}, Le.prototype.has = function(e) {
    return Ie(this.__data__, e) > -1;
}, Le.prototype.set = function(e, t) {
    var r = this.__data__, l = Ie(r, e);
    return l < 0 ? (++this.size, r.push([
        e,
        t
    ])) : r[l][1] = t, this;
};
var Fe = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global, je = "object" == typeof self && self && self.Object === Object && self, ze = Fe || je || Function("return this")(), Te = ze.Symbol, He = Object.prototype, Ae = He.hasOwnProperty, _e = He.toString, Ge = Te ? Te.toStringTag : void 0;
var Ne = Object.prototype.toString;
var $e = Te ? Te.toStringTag : void 0;
function Ve(e) {
    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : $e && $e in Object(e) ? function(e) {
        var t = Ae.call(e, Ge), r = e[Ge];
        try {
            e[Ge] = void 0;
            var l = !0;
        } catch (e) {}
        var n = _e.call(e);
        return l && (t ? e[Ge] = r : delete e[Ge]), n;
    }(e) : function(e) {
        return Ne.call(e);
    }(e);
}
function Be(e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
}
function We(e) {
    if (!Be(e)) return !1;
    var t = Ve(e);
    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
}
var Ue, Ke = ze["__core-js_shared__"], Ze = (Ue = /[^.]+$/.exec(Ke && Ke.keys && Ke.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Ue : "";
var Xe = Function.prototype.toString;
function qe(e) {
    if (null != e) {
        try {
            return Xe.call(e);
        } catch (e) {}
        try {
            return e + "";
        } catch (e) {}
    }
    return "";
}
var Ye = /^\[object .+?Constructor\]$/, Je = Function.prototype, Qe = Object.prototype, et = Je.toString, tt = Qe.hasOwnProperty, rt = RegExp("^" + et.call(tt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function lt(e) {
    var t;
    return !(!Be(e) || (t = e, Ze && Ze in t)) && (We(e) ? rt : Ye).test(qe(e));
}
function nt(e, t) {
    var r = function(e, t) {
        return null == e ? void 0 : e[t];
    }(e, t);
    return lt(r) ? r : void 0;
}
var ot = nt(ze, "Map"), at = nt(Object, "create");
var it = Object.prototype.hasOwnProperty;
var st = Object.prototype.hasOwnProperty;
function ct(e) {
    var t = -1, r = null == e ? 0 : e.length;
    for(this.clear(); ++t < r;){
        var l = e[t];
        this.set(l[0], l[1]);
    }
}
function ut(e, t) {
    var r, l, n = e.__data__;
    return ("string" == (l = typeof (r = t)) || "number" == l || "symbol" == l || "boolean" == l ? "__proto__" !== r : null === r) ? n["string" == typeof t ? "string" : "hash"] : n.map;
}
function dt(e) {
    var t = -1, r = null == e ? 0 : e.length;
    for(this.clear(); ++t < r;){
        var l = e[t];
        this.set(l[0], l[1]);
    }
}
ct.prototype.clear = function() {
    this.__data__ = at ? at(null) : {}, this.size = 0;
}, ct.prototype.delete = function(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
}, ct.prototype.get = function(e) {
    var t = this.__data__;
    if (at) {
        var r = t[e];
        return "__lodash_hash_undefined__" === r ? void 0 : r;
    }
    return it.call(t, e) ? t[e] : void 0;
}, ct.prototype.has = function(e) {
    var t = this.__data__;
    return at ? void 0 !== t[e] : st.call(t, e);
}, ct.prototype.set = function(e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = at && void 0 === t ? "__lodash_hash_undefined__" : t, this;
}, dt.prototype.clear = function() {
    this.size = 0, this.__data__ = {
        hash: new ct,
        map: new (ot || Le),
        string: new ct
    };
}, dt.prototype.delete = function(e) {
    var t = ut(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
}, dt.prototype.get = function(e) {
    return ut(this, e).get(e);
}, dt.prototype.has = function(e) {
    return ut(this, e).has(e);
}, dt.prototype.set = function(e, t) {
    var r = ut(this, e), l = r.size;
    return r.set(e, t), this.size += r.size == l ? 0 : 1, this;
};
function pt(e) {
    var t = this.__data__ = new Le(e);
    this.size = t.size;
}
pt.prototype.clear = function() {
    this.__data__ = new Le, this.size = 0;
}, pt.prototype.delete = function(e) {
    var t = this.__data__, r = t.delete(e);
    return this.size = t.size, r;
}, pt.prototype.get = function(e) {
    return this.__data__.get(e);
}, pt.prototype.has = function(e) {
    return this.__data__.has(e);
}, pt.prototype.set = function(e, t) {
    var r = this.__data__;
    if (r instanceof Le) {
        var l = r.__data__;
        if (!ot || l.length < 199) return l.push([
            e,
            t
        ]), this.size = ++r.size, this;
        r = this.__data__ = new dt(l);
    }
    return r.set(e, t), this.size = r.size, this;
};
function mt(e) {
    var t = -1, r = null == e ? 0 : e.length;
    for(this.__data__ = new dt; ++t < r;)this.add(e[t]);
}
function ft(e, t) {
    for(var r = -1, l = null == e ? 0 : e.length; ++r < l;)if (t(e[r], r, e)) return !0;
    return !1;
}
mt.prototype.add = mt.prototype.push = function(e) {
    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, mt.prototype.has = function(e) {
    return this.__data__.has(e);
};
function gt(e, t, r, l, n, o) {
    var a = 1 & r, i = e.length, s = t.length;
    if (i != s && !(a && s > i)) return !1;
    var c = o.get(e);
    if (c && o.get(t)) return c == t;
    var u = -1, d = !0, p = 2 & r ? new mt : void 0;
    for(o.set(e, t), o.set(t, e); ++u < i;){
        var m = e[u], f = t[u];
        if (l) var g = a ? l(f, m, u, t, e, o) : l(m, f, u, e, t, o);
        if (void 0 !== g) {
            if (g) continue;
            d = !1;
            break;
        }
        if (p) {
            if (!ft(t, function(e, t) {
                if (a = t, !p.has(a) && (m === e || n(m, e, r, l, o))) return p.push(t);
                var a;
            })) {
                d = !1;
                break;
            }
        } else if (m !== f && !n(m, f, r, l, o)) {
            d = !1;
            break;
        }
    }
    return o.delete(e), o.delete(t), d;
}
var bt = ze.Uint8Array;
function ht(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(e, l) {
        r[++t] = [
            l,
            e
        ];
    }), r;
}
function vt(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(e) {
        r[++t] = e;
    }), r;
}
var Ct = Te ? Te.prototype : void 0, wt = Ct ? Ct.valueOf : void 0;
var Ot = Array.isArray;
var yt = Object.prototype.propertyIsEnumerable, Et = Object.getOwnPropertySymbols, St = Et ? function(e) {
    return null == e ? [] : (e = Object(e), function(e, t) {
        for(var r = -1, l = null == e ? 0 : e.length, n = 0, o = []; ++r < l;){
            var a = e[r];
            t(a, r, e) && (o[n++] = a);
        }
        return o;
    }(Et(e), function(t) {
        return yt.call(e, t);
    }));
} : function() {
    return [];
};
function Mt(e) {
    return null != e && "object" == typeof e;
}
function xt(e) {
    return Mt(e) && "[object Arguments]" == Ve(e);
}
var kt = Object.prototype, Dt = kt.hasOwnProperty, Rt = kt.propertyIsEnumerable, It = xt(function() {
    return arguments;
}()) ? xt : function(e) {
    return Mt(e) && Dt.call(e, "callee") && !Rt.call(e, "callee");
};
var Pt = exports && !exports.nodeType && exports, Lt = Pt && true && module && !module.nodeType && module, Ft = Lt && Lt.exports === Pt ? ze.Buffer : void 0, jt = (Ft ? Ft.isBuffer : void 0) || function() {
    return !1;
}, zt = /^(?:0|[1-9]\d*)$/;
function Tt(e, t) {
    var r = typeof e;
    return !!(t = null == t ? 9007199254740991 : t) && ("number" == r || "symbol" != r && zt.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Ht(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}
var At = {};
At["[object Float32Array]"] = At["[object Float64Array]"] = At["[object Int8Array]"] = At["[object Int16Array]"] = At["[object Int32Array]"] = At["[object Uint8Array]"] = At["[object Uint8ClampedArray]"] = At["[object Uint16Array]"] = At["[object Uint32Array]"] = !0, At["[object Arguments]"] = At["[object Array]"] = At["[object ArrayBuffer]"] = At["[object Boolean]"] = At["[object DataView]"] = At["[object Date]"] = At["[object Error]"] = At["[object Function]"] = At["[object Map]"] = At["[object Number]"] = At["[object Object]"] = At["[object RegExp]"] = At["[object Set]"] = At["[object String]"] = At["[object WeakMap]"] = !1;
var _t, Gt = exports && !exports.nodeType && exports, Nt = Gt && true && module && !module.nodeType && module, $t = Nt && Nt.exports === Gt && Fe.process, Vt = function() {
    try {
        return $t && $t.binding && $t.binding("util");
    } catch (e) {}
}(), Bt = Vt && Vt.isTypedArray, Wt = Bt ? (_t = Bt, function(e) {
    return _t(e);
}) : function(e) {
    return Mt(e) && Ht(e.length) && !!At[Ve(e)];
}, Ut = Object.prototype.hasOwnProperty;
function Kt(e, t) {
    var r = Ot(e), l = !r && It(e), n = !r && !l && jt(e), o = !r && !l && !n && Wt(e), a = r || l || n || o, i = a ? function(e, t) {
        for(var r = -1, l = Array(e); ++r < e;)l[r] = t(r);
        return l;
    }(e.length, String) : [], s = i.length;
    for(var c in e)!t && !Ut.call(e, c) || a && ("length" == c || n && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || Tt(c, s)) || i.push(c);
    return i;
}
var Zt = Object.prototype;
var Xt = function(e, t) {
    return function(r) {
        return e(t(r));
    };
}(Object.keys, Object), qt = Object.prototype.hasOwnProperty;
function Yt(e) {
    if (r = (t = e) && t.constructor, t !== ("function" == typeof r && r.prototype || Zt)) return Xt(e);
    var t, r, l = [];
    for(var n in Object(e))qt.call(e, n) && "constructor" != n && l.push(n);
    return l;
}
function Jt(e) {
    var t;
    return null != (t = e) && Ht(t.length) && !We(t) ? Kt(e) : Yt(e);
}
function Qt(e) {
    return function(e, t, r) {
        var l = t(e);
        return Ot(e) ? l : function(e, t) {
            for(var r = -1, l = t.length, n = e.length; ++r < l;)e[n + r] = t[r];
            return e;
        }(l, r(e));
    }(e, Jt, St);
}
var er = Object.prototype.hasOwnProperty;
var tr = nt(ze, "DataView"), rr = nt(ze, "Promise"), lr = nt(ze, "Set"), nr = nt(ze, "WeakMap"), or = qe(tr), ar = qe(ot), ir = qe(rr), sr = qe(lr), cr = qe(nr), ur = Ve;
(tr && "[object DataView]" != ur(new tr(new ArrayBuffer(1))) || ot && "[object Map]" != ur(new ot) || rr && "[object Promise]" != ur(rr.resolve()) || lr && "[object Set]" != ur(new lr) || nr && "[object WeakMap]" != ur(new nr)) && (ur = function(e) {
    var t = Ve(e), r = "[object Object]" == t ? e.constructor : void 0, l = r ? qe(r) : "";
    if (l) switch(l){
        case or:
            return "[object DataView]";
        case ar:
            return "[object Map]";
        case ir:
            return "[object Promise]";
        case sr:
            return "[object Set]";
        case cr:
            return "[object WeakMap]";
    }
    return t;
});
var dr = ur, pr = "[object Object]", mr = Object.prototype.hasOwnProperty;
function fr(e, t, r, l, n, o) {
    var a = Ot(e), i = Ot(t), s = a ? "[object Array]" : dr(e), c = i ? "[object Array]" : dr(t), u = (s = "[object Arguments]" == s ? pr : s) == pr, d = (c = "[object Arguments]" == c ? pr : c) == pr, p = s == c;
    if (p && jt(e)) {
        if (!jt(t)) return !1;
        a = !0, u = !1;
    }
    if (p && !u) return o || (o = new pt), a || Wt(e) ? gt(e, t, r, l, n, o) : function(e, t, r, l, n, o, a) {
        switch(r){
            case "[object DataView]":
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                e = e.buffer, t = t.buffer;
            case "[object ArrayBuffer]":
                return !(e.byteLength != t.byteLength || !o(new bt(e), new bt(t)));
            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
                return Re(+e, +t);
            case "[object Error]":
                return e.name == t.name && e.message == t.message;
            case "[object RegExp]":
            case "[object String]":
                return e == t + "";
            case "[object Map]":
                var i = ht;
            case "[object Set]":
                var s = 1 & l;
                if (i || (i = vt), e.size != t.size && !s) return !1;
                var c = a.get(e);
                if (c) return c == t;
                l |= 2, a.set(e, t);
                var u = gt(i(e), i(t), l, n, o, a);
                return a.delete(e), u;
            case "[object Symbol]":
                if (wt) return wt.call(e) == wt.call(t);
        }
        return !1;
    }(e, t, s, r, l, n, o);
    if (!(1 & r)) {
        var m = u && mr.call(e, "__wrapped__"), f = d && mr.call(t, "__wrapped__");
        if (m || f) {
            var g = m ? e.value() : e, b = f ? t.value() : t;
            return o || (o = new pt), n(g, b, r, l, o);
        }
    }
    return !!p && (o || (o = new pt), function(e, t, r, l, n, o) {
        var a = 1 & r, i = Qt(e), s = i.length;
        if (s != Qt(t).length && !a) return !1;
        for(var c = s; c--;){
            var u = i[c];
            if (!(a ? u in t : er.call(t, u))) return !1;
        }
        var d = o.get(e);
        if (d && o.get(t)) return d == t;
        var p = !0;
        o.set(e, t), o.set(t, e);
        for(var m = a; ++c < s;){
            var f = e[u = i[c]], g = t[u];
            if (l) var b = a ? l(g, f, u, t, e, o) : l(f, g, u, e, t, o);
            if (!(void 0 === b ? f === g || n(f, g, r, l, o) : b)) {
                p = !1;
                break;
            }
            m || (m = "constructor" == u);
        }
        if (p && !m) {
            var h = e.constructor, v = t.constructor;
            h == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof h && h instanceof h && "function" == typeof v && v instanceof v || (p = !1);
        }
        return o.delete(e), o.delete(t), p;
    }(e, t, r, l, n, o));
}
function gr(e, t, r, l, n) {
    return e === t || (null == e || null == t || !Mt(e) && !Mt(t) ? e != e && t != t : fr(e, t, r, l, gr, n));
}
function br(e, t) {
    return gr(e, t);
}
function hr(e) {
    return (0, $1sMi9.default)(e);
}
const vr = "undefined" != typeof window ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
function Cr(e, t, r) {
    const l = {};
    return Object.keys(e).forEach((n)=>{
        l[n] = e[n].reduce((e, l)=>(l && (r && r[l] && e.push(r[l]), e.push(t(l))), e), []).join(" ");
    }), l;
}
const wr = {
    active: "Mui-active",
    checked: "Mui-checked",
    disabled: "Mui-disabled",
    error: "Mui-error",
    focused: "Mui-focused",
    focusVisible: "Mui-focusVisible",
    required: "Mui-required",
    expanded: "Mui-expanded",
    selected: "Mui-selected"
};
function Or(e, t) {
    return wr[t] || `${e}-${t}`;
}
function yr(e) {
    return "function" == typeof e;
}
function Er(e) {
    return e.type || e.mode;
}
function Sr() {
    return "fade" in $e0IBS ? "fade" in $e0IBS && "alpha" in $e0IBS ? "v4.12" : "v4" : "v5";
}
function Mr(e, t) {
    var r, l, o;
    return (null === (r = $e0IBS) || void 0 === r ? void 0 : r.alpha) ? null === (l = $e0IBS) || void 0 === l ? void 0 : l.alpha(e, t) : null === (o = $e0IBS) || void 0 === o ? void 0 : o.fade(e, t);
}
function xr() {
    var e, t, r;
    return (null === (e = $e0IBS) || void 0 === e ? void 0 : e.createTheme) ? null === (t = $e0IBS) || void 0 === t ? void 0 : t.createTheme() : null === (r = $e0IBS) || void 0 === r ? void 0 : r.createMuiTheme();
}
function kr() {
    try {
        const e = "__some_random_key_you_are_not_going_to_use__";
        return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
    } catch (e) {
        return !1;
    }
}
function Dr(e) {
    return Or("MuiDataGrid", e);
}
function Rr(e) {
    return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
const Ir = kr() && null != window.localStorage.getItem("DEBUG"), Pr = ()=>{}, Lr = {
    debug: Pr,
    info: Pr,
    warn: Pr,
    error: Pr
}, Fr = [
    "debug",
    "info",
    "warn",
    "error"
];
function jr(e, t, r = console) {
    const l = Fr.indexOf(t);
    if (-1 === l) throw new Error(`Material-UI: Log level ${t} not recognized.`);
    return Fr.reduce((t, n, o)=>(t[n] = o >= l ? (...t)=>{
            const [l, ...o] = t;
            r[n](`Material-UI: ${e} - ${l}`, ...o);
        } : Pr, t), {});
}
const zr = (e)=>(t)=>jr(t, e);
let Tr;
function Hr(e, t) {
    Tr = Ir ? zr("debug") : t.logger ? t.logLevel ? (e)=>jr(e, t.logLevel.toString(), t.logger) : null : t.logLevel ? zr(t.logLevel.toString()) : null;
}
function Ar(t) {
    const { current: r } = $7fPBF.useRef(Tr ? Tr(t) : Lr);
    return r;
}
function _r(t, r, l) {
    const n = Ar("useGridApiMethod"), o = $7fPBF.useRef(r), [a] = $7fPBF.useState(Object.keys(r)), i = $7fPBF.useCallback(()=>{
        t.current && a.forEach((e)=>{
            t.current.hasOwnProperty(e) || (n.debug(`Adding ${l}.${e} to apiRef`), t.current[e] = (...t)=>o.current[e](...t));
        });
    }, [
        a,
        l,
        t,
        n
    ]);
    $7fPBF.useEffect(()=>{
        o.current = r;
    }, [
        r
    ]), $7fPBF.useEffect(()=>{
        i();
    }, [
        i
    ]), i();
}
const Gr = ()=>({
        all: [],
        lookup: {}
    }), Nr = {
    noRowsLabel: "No rows",
    noResultsOverlayLabel: "No results found.",
    errorOverlayDefaultLabel: "An error occurred.",
    toolbarDensity: "Density",
    toolbarDensityLabel: "Density",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Comfortable",
    toolbarColumns: "Columns",
    toolbarColumnsLabel: "Select columns",
    toolbarFilters: "Filters",
    toolbarFiltersLabel: "Show filters",
    toolbarFiltersTooltipHide: "Hide filters",
    toolbarFiltersTooltipShow: "Show filters",
    toolbarFiltersTooltipActive: (e)=>1 !== e ? `${e} active filters` : `${e} active filter`,
    toolbarExport: "Export",
    toolbarExportLabel: "Export",
    toolbarExportCSV: "Download as CSV",
    columnsPanelTextFieldLabel: "Find column",
    columnsPanelTextFieldPlaceholder: "Column title",
    columnsPanelDragIconLabel: "Reorder column",
    columnsPanelShowAllButton: "Show all",
    columnsPanelHideAllButton: "Hide all",
    filterPanelAddFilter: "Add filter",
    filterPanelDeleteIconLabel: "Delete",
    filterPanelOperators: "Operators",
    filterPanelOperatorAnd: "And",
    filterPanelOperatorOr: "Or",
    filterPanelColumns: "Columns",
    filterPanelInputLabel: "Value",
    filterPanelInputPlaceholder: "Filter value",
    filterOperatorContains: "contains",
    filterOperatorEquals: "equals",
    filterOperatorStartsWith: "starts with",
    filterOperatorEndsWith: "ends with",
    filterOperatorIs: "is",
    filterOperatorNot: "is not",
    filterOperatorAfter: "is after",
    filterOperatorOnOrAfter: "is on or after",
    filterOperatorBefore: "is before",
    filterOperatorOnOrBefore: "is on or before",
    filterOperatorIsEmpty: "is empty",
    filterOperatorIsNotEmpty: "is not empty",
    filterValueAny: "any",
    filterValueTrue: "true",
    filterValueFalse: "false",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Show columns",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Hide",
    columnMenuUnsort: "Unsort",
    columnMenuSortAsc: "Sort by ASC",
    columnMenuSortDesc: "Sort by DESC",
    columnHeaderFiltersTooltipActive: (e)=>1 !== e ? `${e} active filters` : `${e} active filter`,
    columnHeaderFiltersLabel: "Show filters",
    columnHeaderSortIconLabel: "Sort",
    footerRowSelected: (e)=>1 !== e ? `${e.toLocaleString()} rows selected` : `${e.toLocaleString()} row selected`,
    footerTotalRows: "Total Rows:",
    footerTotalVisibleRows: (e, t)=>`${e.toLocaleString()} of ${t.toLocaleString()}`,
    checkboxSelectionHeaderName: "Checkbox selection",
    booleanCellTrueLabel: "true",
    booleanCellFalseLabel: "false",
    MuiTablePagination: {}
};
var $r;
!function(e) {
    e.Compact = "compact", e.Standard = "standard", e.Comfortable = "comfortable";
}($r || ($r = {}));
const Vr = {
    client: "client",
    server: "server"
}, Br = {
    columnBuffer: 2,
    density: $r.Standard,
    filterMode: Vr.client,
    headerHeight: 56,
    paginationMode: Vr.client,
    rowHeight: 52,
    rowsPerPageOptions: [
        25,
        50,
        100
    ],
    scrollEndThreshold: 80,
    sortingMode: Vr.client,
    sortingOrder: [
        "asc",
        "desc",
        null
    ],
    logger: console,
    logLevel: "error"
}, Wr = Object.assign(Object.assign({}, Br), {
    localeText: Nr
});
function Ur() {
    return {
        dragCol: ""
    };
}
function Kr() {
    return {
        resizingColumnField: ""
    };
}
var Zr;
!function(e) {
    e.And = "and", e.Or = "or";
}(Zr || (Zr = {}));
const Xr = ()=>({
        items: [],
        linkOperator: Zr.And
    }), qr = ()=>({
        visibleRowsLookup: {}
    }), Yr = ()=>({
        idRowsLookup: {},
        allRows: [],
        totalRowCount: 0
    });
function Jr() {
    return {
        sortedRows: [],
        sortModel: []
    };
}
const Qr = ()=>({
        realScroll: {
            left: 0,
            top: 0
        },
        renderContext: null,
        renderingZoneScroll: {
            left: 0,
            top: 0
        },
        virtualPage: 0,
        virtualRowsCount: 0
    }), el = ()=>({
        rows: {
            idRowsLookup: {},
            allRows: [],
            totalRowCount: 0
        },
        editRows: {},
        pagination: {
            page: 0,
            pageCount: 0,
            rowCount: 0,
            pageSize: 100
        },
        options: Wr,
        isScrolling: !1,
        columns: {
            all: [],
            lookup: {}
        },
        columnReorder: {
            dragCol: ""
        },
        columnResize: {
            resizingColumnField: ""
        },
        rendering: {
            realScroll: {
                left: 0,
                top: 0
            },
            renderContext: null,
            renderingZoneScroll: {
                left: 0,
                top: 0
            },
            virtualPage: 0,
            virtualRowsCount: 0
        },
        containerSizes: null,
        scrollBar: {
            hasScrollX: !1,
            hasScrollY: !1,
            scrollBarSize: {
                x: 0,
                y: 0
            }
        },
        viewportSizes: {
            width: 0,
            height: 1
        },
        sorting: {
            sortedRows: [],
            sortModel: []
        },
        focus: {
            cell: null,
            columnHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null
        },
        selection: [],
        filter: Xr(),
        columnMenu: {
            open: !1
        },
        preferencePanel: {
            open: !1
        },
        visibleRows: {
            visibleRowsLookup: {}
        },
        density: {
            value: $r.Standard,
            rowHeight: 52,
            headerHeight: 56
        }
    }), tl = (t)=>{
    const r = Ar("useGridApi"), [, l] = $7fPBF.useState();
    t.current.state || (r.info("Initialising state."), t.current.state = el(), t.current.forceUpdate = l);
    const n = $7fPBF.useCallback(()=>t.current.state, [
        t
    ]), o = $7fPBF.useCallback((e)=>{
        let r;
        r = yr(e) ? e(t.current.state) : e, t.current.state = r, l(()=>r);
        const n = {
            api: t.current,
            state: r
        };
        t.current.publishEvent(ne.stateChange, n);
    }, [
        t
    ]);
    return _r(t, {
        getState: n,
        setState: o
    }, "GridStateApi"), t.current;
}, rl = (t)=>{
    tl(t);
    const r = $7fPBF.useCallback(()=>t.current.forceUpdate(()=>t.current.state), [
        t
    ]), l = $7fPBF.useCallback((e)=>{
        const r = e(t.current.state);
        if (t.current.state === r) return !1;
        const { ignoreSetState: l, postUpdate: n } = t.current.applyControlStateConstraint(r);
        if (!l && (t.current.state = r, t.current.publishEvent)) {
            const e = {
                api: t.current,
                state: r
            };
            t.current.publishEvent(ne.stateChange, e);
        }
        return n(), !l;
    }, [
        t
    ]);
    return [
        t.current.state,
        l,
        r
    ];
}, ll = (e, t)=>{
    const [r] = rl(e);
    return t(r);
}, nl = (e)=>e.rendering, ol = (0, $7UqAk.createSelector)(nl, (e)=>e.realScroll), al = $7fPBF.memo(function({ width: t, height: r }) {
    return t && r ? $7fPBF.createElement("div", {
        style: {
            minWidth: t,
            maxWidth: t,
            lineHeight: r - 1 + "px",
            minHeight: r,
            maxHeight: r
        },
        className: "MuiDataGrid-cell"
    }) : null;
}), il = (e)=>e.options;
var sl;
function cl(t, r, l, n) {
    const o = Ar("useGridApiEventHandler"), { signature: a } = ll(t, il);
    $7fPBF.useEffect(()=>{
        if (l && r) {
            const e = (e, r, n = {})=>{
                a === sl.XGrid && (n.api = t.current), r.defaultMuiPrevented || l(e, r, n);
            };
            return t.current.subscribeEvent(r, e, n);
        }
    }, [
        t,
        o,
        r,
        l,
        n,
        a
    ]);
}
!function(e) {
    e.DataGrid = "DataGrid", e.XGrid = "XGrid";
}(sl || (sl = {}));
const ul = {
    isFirst: !0
};
function dl(e, t, r) {
    cl(e, t, r, ul);
}
const pl = $7fPBF.memo(function(t) {
    const { scrollDirection: l } = t, n = $7fPBF.useRef(null), o = ae(), a = $7fPBF.useRef(), [i, s] = $7fPBF.useState(!1), c = $7fPBF.useRef({
        left: 0,
        top: 0
    }), u = $7fPBF.useCallback((e)=>{
        c.current = e;
    }, []), d = $7fPBF.useCallback((e)=>{
        let t;
        if ("left" === l) t = e.clientX - n.current.getBoundingClientRect().right;
        else {
            if ("right" !== l) throw new Error("wrong dir");
            t = Math.max(1, e.clientX - n.current.getBoundingClientRect().left);
        }
        t = 1.5 * (t - 1) + 1, clearTimeout(a.current), a.current = setTimeout(()=>{
            o.current.scroll({
                left: c.current.left + t,
                top: c.current.top
            });
        });
    }, [
        l,
        o
    ]);
    $7fPBF.useEffect(()=>()=>{
            clearTimeout(a.current);
        }, []);
    const p = $7fPBF.useCallback(()=>{
        s((e)=>!e);
    }, []);
    return cl(o, ne.rowsScroll, u), cl(o, ne.columnHeaderDragStart, p), cl(o, ne.columnHeaderDragEnd, p), i ? $7fPBF.createElement("div", {
        ref: n,
        className: (0, $jtRae.default)("MuiDataGrid-scrollArea", `MuiDataGrid-scrollArea--${l}`),
        onDragOver: d
    }) : null;
}), ml = (e)=>e.columnReorder, fl = (0, $7UqAk.createSelector)(ml, (e)=>e.dragCol), gl = (e)=>e.columnResize, bl = (0, $7UqAk.createSelector)(gl, (e)=>e.resizingColumnField), hl = (e)=>e.rows, vl = (0, $7UqAk.createSelector)(hl, (e)=>e && e.totalRowCount), Cl = (0, $7UqAk.createSelector)(hl, (e)=>e && e.idRowsLookup), wl = (0, $7UqAk.createSelector)(hl, (e)=>e.allRows), Ol = (0, $7UqAk.createSelector)(hl, (e)=>e.allRows.map((t)=>e.idRowsLookup[t])), yl = (e)=>e.sorting, El = (0, $7UqAk.createSelector)(yl, wl, (e, t)=>e.sortedRows.length ? e.sortedRows : t), Sl = (0, $7UqAk.createSelector)(El, Cl, (e, t)=>{
    const r = new Map;
    return e.forEach((e)=>{
        r.set(e, t[e]);
    }), r;
}), Ml = (0, $7UqAk.createSelector)(yl, (e)=>e.sortModel), xl = (0, $7UqAk.createSelector)(Ml, (e)=>e.reduce((t, r, l)=>(t[r.field] = {
            sortDirection: r.sort,
            sortIndex: e.length > 1 ? l + 1 : void 0
        }, t), {})), kl = (e)=>e.visibleRows, Dl = (0, $7UqAk.createSelector)(kl, Sl, (e, t)=>{
    const r = new Map;
    return t.forEach((t, l)=>{
        !1 !== e.visibleRowsLookup[l] && r.set(l, t);
    }), r;
}), Rl = (0, $7UqAk.createSelector)(Dl, (e)=>[
        ...e.entries()
    ]), Il = (0, $7UqAk.createSelector)(Dl, (e)=>[
        ...e.keys()
    ]), Pl = (0, $7UqAk.createSelector)(kl, vl, (e, t)=>null == e.visibleRows ? t : e.visibleRows.length), Ll = (e)=>e.filter, Fl = (0, $7UqAk.createSelector)(Ll, ce, (e, t)=>{
    var r;
    return null === (r = e.items) || void 0 === r ? void 0 : r.filter((e)=>{
        var r, l;
        if (!e.columnField) return !1;
        const n = t[e.columnField];
        if (!(null == n ? void 0 : n.filterOperators) || 0 === (null === (r = null == n ? void 0 : n.filterOperators) || void 0 === r ? void 0 : r.length)) return !1;
        const o = n.filterOperators.find((t)=>t.value === e.operatorValue);
        return !!o && (!o.InputComponent || null != e.value && "" !== (null === (l = e.value) || void 0 === l ? void 0 : l.toString()));
    });
}), jl = (0, $7UqAk.createSelector)(Fl, (e)=>e.length), zl = (0, $7UqAk.createSelector)(Fl, (e)=>e.reduce((e, t)=>(e[t.columnField] ? e[t.columnField].push(t) : e[t.columnField] = [
            t
        ], e), {})), Tl = (e)=>e.focus, Hl = (0, $7UqAk.createSelector)(Tl, (e)=>e.cell), Al = (0, $7UqAk.createSelector)(Tl, (e)=>e.columnHeader), _l = (e)=>e.tabIndex, Gl = (0, $7UqAk.createSelector)(_l, (e)=>e.cell), Nl = (0, $7UqAk.createSelector)(_l, (e)=>e.columnHeader), $l = (e)=>e.density, Vl = (0, $7UqAk.createSelector)($l, (e)=>e.value), Bl = (0, $7UqAk.createSelector)($l, (e)=>e.rowHeight), Wl = (0, $7UqAk.createSelector)($l, (e)=>e.headerHeight), Ul = (e)=>e.columnMenu, Kl = (e)=>"Escape" === e, Zl = (e)=>"Enter" === e, Xl = (e)=>"Tab" === e, ql = (e)=>" " === e, Yl = (e)=>0 === e.indexOf("Arrow"), Jl = (e)=>"Home" === e || "End" === e, Ql = (e)=>0 === e.indexOf("Page"), en = (e)=>"Delete" === e || "Backspace" === e, tn = RegExp("^(\\p{L}|\\p{M}\\p{L}|\\p{M}|\\p{N}|\\p{Z}|\\p{S}|\\p{P})$", "iu"), rn = (e)=>tn.test(e), ln = [
    "Enter",
    "Escape",
    "Tab"
], nn = [
    "Enter",
    "Tab"
], on = (e)=>nn.indexOf(e) > -1, an = (e)=>Jl(e) || Yl(e) || Ql(e) || ql(e), sn = (e)=>!!e.key, cn = (e)=>Xl(e) || Kl(e), un = $7fPBF.createContext(void 0);
const dn = ()=>{
    const t = $7fPBF.useContext(un);
    if (!t) throw new Error("Material-UI: useGridRootProps should only be used inside the DataGrid/XGrid component.");
    return t;
}, pn = $7fPBF.forwardRef(function(t, r) {
    var l;
    const { field: n, id: o, value: a, tabIndex: i, hasFocus: s } = t, u = ae(), d = dn(), p = $7fPBF.useRef(null), m = (0, $55RWP.default)(p, r), f = t.api.getCellElement(o, n);
    $7fPBF.useLayoutEffect(()=>{
        0 === i && f && (f.tabIndex = -1);
    }, [
        f,
        i
    ]), $7fPBF.useLayoutEffect(()=>{
        if (s && p.current) p.current.querySelector("input").focus();
    }, [
        s
    ]);
    const g = $7fPBF.useCallback((e)=>{
        ql(e.key) && e.stopPropagation(), an(e.key) && !e.shiftKey && u.current.publishEvent(ne.cellNavigationKeyDown, t, e);
    }, [
        u,
        t
    ]), b = null == u ? void 0 : u.current.components.Checkbox, h = !d.isRowSelectable || d.isRowSelectable(u.current.getRowParams(o));
    return $7fPBF.createElement(b, Object.assign({
        ref: m,
        tabIndex: i,
        checked: !!a,
        onChange: (e)=>{
            u.current.selectRow(o, e.target.checked, !0);
        },
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: "MuiDataGrid-checkboxInput",
        color: "primary",
        inputProps: {
            "aria-label": "Select Row checkbox"
        },
        onKeyDown: g,
        disabled: !h
    }, null === (l = null == u ? void 0 : u.current.componentsProps) || void 0 === l ? void 0 : l.checkbox));
}), mn = $7fPBF.memo(pn), fn = (e)=>e.pagination, gn = (0, $7UqAk.createSelector)(fn, Il, (e, t)=>{
    const r = e.page * e.pageSize, l = r + e.pageSize;
    return t.slice(r, l);
}), bn = (e)=>e.selection, hn = (0, $7UqAk.createSelector)(bn, (e)=>e.length), vn = (0, $7UqAk.createSelector)(bn, Cl, (e, t)=>new Map(e.map((e)=>[
            e,
            t[e]
        ]))), Cn = (0, $7UqAk.createSelector)(bn, (e)=>e.reduce((e, t)=>(e[t] = t, e), {})), wn = $7fPBF.forwardRef(function(t, r) {
    var l;
    const [, n] = $7fPBF.useState(!1), o = ae(), a = ll(o, il), i = ll(o, Nl), s = ll(o, hn), c = ll(o, vl), u = s > 0 && s !== c, d = s > 0 && s === c || u, p = null !== i && i.field === t.field ? 0 : -1;
    $7fPBF.useLayoutEffect(()=>{
        const e = o.current.getColumnHeaderElement(t.field);
        0 === p && e && (e.tabIndex = -1);
    }, [
        p,
        o,
        t.field
    ]);
    const m = $7fPBF.useCallback((e)=>{
        ql(e.key) && e.stopPropagation(), an(e.key) && !e.shiftKey && o.current.publishEvent(ne.columnHeaderNavigationKeyDown, t, e);
    }, [
        o,
        t
    ]), f = $7fPBF.useCallback(()=>{
        n((e)=>!e);
    }, []);
    $7fPBF.useEffect(()=>null == o ? void 0 : o.current.subscribeEvent(ne.selectionChange, f), [
        o,
        f
    ]);
    const g = null == o ? void 0 : o.current.components.Checkbox;
    return $7fPBF.createElement(g, Object.assign({
        ref: r,
        indeterminate: u,
        checked: d,
        onChange: (e)=>{
            const t = e.target.checked, r = a.checkboxSelectionVisibleOnly ? gn(o.current.state) : Il(o.current.state);
            o.current.selectRows(r, t, !e.target.indeterminate);
        },
        className: "MuiDataGrid-checkboxInput",
        color: "primary",
        inputProps: {
            "aria-label": "Select All Rows checkbox"
        },
        tabIndex: p,
        onKeyDown: m
    }, null === (l = null == o ? void 0 : o.current.componentsProps) || void 0 === l ? void 0 : l.checkbox));
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function On(e, t) {
    var r = {};
    for(var l in e)Object.prototype.hasOwnProperty.call(e, l) && t.indexOf(l) < 0 && (r[l] = e[l]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(l = Object.getOwnPropertySymbols(e); n < l.length; n++)t.indexOf(l[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[n]) && (r[l[n]] = e[l[n]]);
    }
    return r;
}
function yn(t) {
    const { id: r, value: l, formattedValue: n, api: o, field: a, row: i, colDef: s, cellMode: c, isEditable: u, tabIndex: d, hasFocus: p, getValue: m } = t, f = On(t, [
        "id",
        "value",
        "formattedValue",
        "api",
        "field",
        "row",
        "colDef",
        "cellMode",
        "isEditable",
        "tabIndex",
        "hasFocus",
        "getValue"
    ]), g = $7fPBF.useRef(), [b, h] = $7fPBF.useState(l), C = $7fPBF.useCallback((e)=>{
        const t = e.target.value;
        h(t), o.setEditCellValue({
            id: r,
            field: a,
            value: t
        }, e);
    }, [
        o,
        a,
        r
    ]);
    return $7fPBF.useEffect(()=>{
        h(l);
    }, [
        l
    ]), vr(()=>{
        p && g.current.focus();
    }, [
        p
    ]), $7fPBF.createElement((0, $dzfbx.default), Object.assign({
        inputRef: g,
        className: "MuiDataGrid-editInputCell",
        fullWidth: !0,
        type: "number" === s.type ? s.type : "text",
        value: b || "",
        onChange: C
    }, f));
}
const En = (t)=>$7fPBF.createElement(yn, Object.assign({}, t)), Sn = (e, t)=>{
    const r = e.indexOf(t);
    return t && -1 !== r && r + 1 !== e.length ? e[r + 1] : e[0];
}, Mn = (e, t)=>null == e && null != t ? -1 : null == t && null != e ? 1 : null == e && null == t ? 0 : null, xn = new Intl.Collator, kn = (e, t)=>{
    const r = Mn(e, t);
    return null !== r ? r : Number(e) - Number(t);
}, Dn = (e, t)=>{
    const r = Mn(e, t);
    return null !== r ? r : e > t ? 1 : e < t ? -1 : 0;
}, Rn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), "ArrowUpward"), In = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward"), Pn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), "FilterList"), Ln = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), "FilterAlt"), Fn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search"), jn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu"), zn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle"), Tn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), "ColumnIcon"), Hn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M11 19V5h2v14z"
}), "Separator"), An = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), "ViewHeadline"), _n = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), "TableRows"), Gn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), "ViewStream"), Nn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "TripleDotsVertical"), $n = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), Vn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add"), Bn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Load"), Wn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "Drag"), Un = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAlt"), Kn = (0, $319Q5.default)($7fPBF.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), Zn = ({ valueOptions: t })=>(t ? [
        "",
        ...t
    ] : [
        ""
    ]).map((t)=>"object" == typeof t ? $7fPBF.createElement("option", {
            key: t.value,
            value: t.value
        }, t.label) : $7fPBF.createElement("option", {
            key: t,
            value: t
        }, t)), Xn = 500;
function qn(t) {
    const { item: r, applyValue: l, type: n, apiRef: o } = t, a = On(t, [
        "item",
        "applyValue",
        "type",
        "apiRef"
    ]), i = $7fPBF.useRef(), [s, c] = $7fPBF.useState(r.value || ""), [u, p] = $7fPBF.useState(!1), m = (0, $ejsyu.default)(), f = "singleSelect" === n ? {
        select: !0,
        SelectProps: {
            native: !0
        },
        children: Zn(o.current.getColumn(r.columnField))
    } : {}, g = $7fPBF.useCallback((e)=>{
        let t = e.target.value;
        if ("singleSelect" === n) {
            const e = o.current.getColumn(r.columnField);
            t = e.valueOptions.map((e)=>"object" == typeof e ? e.value : e).find((e)=>String(e) === t);
        }
        clearTimeout(i.current), c(t), p(!0), i.current = setTimeout(()=>{
            l(Object.assign(Object.assign({}, r), {
                value: t
            })), p(!1);
        }, 500);
    }, [
        o,
        l,
        r,
        n
    ]);
    $7fPBF.useEffect(()=>()=>{
            clearTimeout(i.current);
        }, []), $7fPBF.useEffect(()=>{
        c(r.value || "");
    }, [
        r.value
    ]);
    const b = u ? {
        endAdornment: $7fPBF.createElement(Bn, null)
    } : a.InputProps;
    return $7fPBF.createElement((0, $MQfsM.default), Object.assign({
        id: m,
        label: o.current.getLocaleText("filterPanelInputLabel"),
        placeholder: o.current.getLocaleText("filterPanelInputPlaceholder"),
        value: s,
        onChange: g,
        type: n || "text",
        variant: "standard",
        InputProps: b,
        InputLabelProps: {
            shrink: !0
        }
    }, f, a));
}
const Yn = ()=>[
        {
            value: "contains",
            getApplyFilterFn: (e)=>{
                if (!e.value) return null;
                const t = new RegExp(Rr(e.value), "i");
                return ({ value: e })=>t.test(e && e.toString() || "");
            },
            InputComponent: qn
        },
        {
            value: "equals",
            getApplyFilterFn: (e)=>{
                if (!e.value) return null;
                const t = new Intl.Collator(void 0, {
                    sensitivity: "base",
                    usage: "search"
                });
                return ({ value: r })=>0 === t.compare(e.value, r && r.toString() || "");
            },
            InputComponent: qn
        },
        {
            value: "startsWith",
            getApplyFilterFn: (e)=>{
                if (!e.value) return null;
                const t = new RegExp(`^${Rr(e.value)}.*$`, "i");
                return ({ value: e })=>t.test(e && e.toString() || "");
            },
            InputComponent: qn
        },
        {
            value: "endsWith",
            getApplyFilterFn: (e)=>{
                if (!e.value) return null;
                const t = new RegExp(`.*${Rr(e.value)}$`, "i");
                return ({ value: e })=>t.test(e && e.toString() || "");
            },
            InputComponent: qn
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>({ value: e })=>"" === e || null == e
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>({ value: e })=>"" !== e && null != e
        }
    ], Jn = {
    width: 100,
    minWidth: 50,
    hide: !1,
    sortable: !0,
    resizable: !0,
    filterable: !0,
    sortComparator: (e, t)=>{
        const r = Mn(e, t);
        return null !== r ? r : "string" == typeof e ? xn.compare(e.toString(), t.toString()) : e - t;
    },
    type: "string",
    align: "left",
    filterOperators: Yn(),
    renderEditCell: En
}, Qn = $7fPBF.memo((t)=>{
    const { id: r, value: l, formattedValue: n, api: o, field: a, row: i, colDef: s, cellMode: c, isEditable: u, hasFocus: d, tabIndex: p, getValue: m } = t, f = On(t, [
        "id",
        "value",
        "formattedValue",
        "api",
        "field",
        "row",
        "colDef",
        "cellMode",
        "isEditable",
        "hasFocus",
        "tabIndex",
        "getValue"
    ]), g = $7fPBF.useMemo(()=>l ? o.components.BooleanCellTrueIcon : o.components.BooleanCellFalseIcon, [
        o.components.BooleanCellFalseIcon,
        o.components.BooleanCellTrueIcon,
        l
    ]);
    return $7fPBF.createElement(g, Object.assign({
        fontSize: "small",
        className: "MuiDataGrid-booleanCell",
        titleAccess: o.getLocaleText(l ? "booleanCellTrueLabel" : "booleanCellFalseLabel"),
        "data-value": Boolean(l)
    }, f));
});
function eo(t) {
    const { id: l, value: n, formattedValue: o, api: a, field: i, row: s, colDef: c, cellMode: u, isEditable: p, tabIndex: m, className: f, getValue: g, hasFocus: b } = t, h = On(t, [
        "id",
        "value",
        "formattedValue",
        "api",
        "field",
        "row",
        "colDef",
        "cellMode",
        "isEditable",
        "tabIndex",
        "className",
        "getValue",
        "hasFocus"
    ]), v = $7fPBF.useRef(null), C = (0, $ejsyu.default)(), [O, y] = $7fPBF.useState(n), E = $7fPBF.useCallback((e)=>{
        const t = e.target.checked;
        y(t), a.setEditCellValue({
            id: l,
            field: i,
            value: t
        }, e);
    }, [
        a,
        i,
        l
    ]);
    return $7fPBF.useEffect(()=>{
        y(n);
    }, [
        n
    ]), vr(()=>{
        b && v.current.focus();
    }, [
        b
    ]), $7fPBF.createElement("label", Object.assign({
        htmlFor: C,
        className: (0, $jtRae.default)("MuiDataGrid-editBooleanCell", f)
    }, h), $7fPBF.createElement((0, $i8OTH.default), {
        id: C,
        inputRef: v,
        checked: Boolean(O),
        onChange: E,
        size: "small"
    }));
}
function to(t) {
    const { item: r, applyValue: l, apiRef: n } = t, o = On(t, [
        "item",
        "applyValue",
        "apiRef"
    ]), [a, i] = $7fPBF.useState(r.value || ""), s = $7fPBF.useCallback((e)=>{
        const t = e.target.value;
        i(t), l(Object.assign(Object.assign({}, r), {
            value: t
        }));
    }, [
        l,
        r
    ]);
    return $7fPBF.useEffect(()=>{
        i(r.value || "");
    }, [
        r.value
    ]), $7fPBF.createElement((0, $MQfsM.default), Object.assign({
        label: n.current.getLocaleText("filterPanelInputLabel"),
        value: a,
        onChange: s,
        variant: "standard",
        select: !0,
        SelectProps: {
            native: !0
        },
        InputLabelProps: {
            shrink: !0
        }
    }, o), $7fPBF.createElement("option", {
        value: ""
    }, n.current.getLocaleText("filterValueAny")), $7fPBF.createElement("option", {
        value: "true"
    }, n.current.getLocaleText("filterValueTrue")), $7fPBF.createElement("option", {
        value: "false"
    }, n.current.getLocaleText("filterValueFalse")));
}
const ro = Object.assign(Object.assign({}, Jn), {
    type: "boolean",
    align: "center",
    headerAlign: "center",
    renderCell: (t)=>$7fPBF.createElement(Qn, Object.assign({}, t)),
    renderEditCell: (t)=>$7fPBF.createElement(eo, Object.assign({}, t)),
    sortComparator: kn,
    valueFormatter: function({ value: e, api: t }) {
        return e ? t.getLocaleText("booleanCellTrueLabel") : t.getLocaleText("booleanCellFalseLabel");
    },
    filterOperators: [
        {
            value: "is",
            getApplyFilterFn: (e)=>{
                if (!e.value) return null;
                const t = "true" === e.value;
                return ({ value: e })=>Boolean(e) === t;
            },
            InputComponent: to
        }
    ]
}), lo = Object.assign(Object.assign({}, ro), {
    field: "__check__",
    type: "checkboxSelection",
    width: 50,
    resizable: !1,
    sortable: !1,
    filterable: !1,
    disableColumnMenu: !0,
    disableReorder: !0,
    valueGetter: (e)=>void 0 !== Cn(e.api.state)[e.id],
    renderHeader: (t)=>$7fPBF.createElement(wn, Object.assign({}, t)),
    renderCell: (t)=>$7fPBF.createElement(mn, Object.assign({}, t)),
    cellClassName: "MuiDataGrid-cellCheckbox",
    headerClassName: "MuiDataGrid-columnHeaderCheckbox"
}), no = ()=>[
        {
            label: "=",
            value: "=",
            getApplyFilterFn: (e)=>e.value ? ({ value: t })=>Number(t) === e.value : null,
            InputComponent: qn,
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: "!=",
            value: "!=",
            getApplyFilterFn: (e)=>e.value ? ({ value: t })=>Number(t) !== e.value : null,
            InputComponent: qn,
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: ">",
            value: ">",
            getApplyFilterFn: (e)=>e.value ? ({ value: t })=>Number(t) > e.value : null,
            InputComponent: qn,
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: ">=",
            value: ">=",
            getApplyFilterFn: (e)=>e.value ? ({ value: t })=>Number(t) >= e.value : null,
            InputComponent: qn,
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: "<",
            value: "<",
            getApplyFilterFn: (e)=>e.value ? ({ value: t })=>Number(t) < e.value : null,
            InputComponent: qn,
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: "<=",
            value: "<=",
            getApplyFilterFn: (e)=>e.value ? ({ value: t })=>Number(t) <= e.value : null,
            InputComponent: qn,
            InputComponentProps: {
                type: "number"
            }
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>({ value: e })=>null == e
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>({ value: e })=>null != e
        }
    ], oo = Object.assign(Object.assign({}, Jn), {
    type: "number",
    align: "right",
    headerAlign: "right",
    sortComparator: kn,
    valueParser: (e)=>Number(e),
    valueFormatter: ({ value: e })=>e && function(e) {
            return "number" == typeof e;
        }(e) && e.toLocaleString() || e,
    filterOperators: no()
}), ao = /(\d+)-(\d+)-(\d+)/, io = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;
function so(e, t, r, l) {
    if (!e.value) return null;
    const [n, o, a, i, s] = e.value.match(r ? io : ao).slice(1).map(Number), c = new Date(n, o - 1, a, i || 0, s || 0).getTime();
    return ({ value: e })=>{
        if (!e) return !1;
        const n = e instanceof Date ? e : new Date(e.toString());
        if (l) return t(n.getTime(), c);
        const o = (e instanceof Date ? new Date(n) : n).setHours(r ? n.getHours() : 0, r ? n.getMinutes() : 0, 0, 0);
        return t(o, c);
    };
}
const co = (e)=>[
        {
            value: "is",
            getApplyFilterFn: (t)=>so(t, (e, t)=>e === t, e),
            InputComponent: qn,
            InputComponentProps: {
                type: e ? "datetime-local" : "date"
            }
        },
        {
            value: "not",
            getApplyFilterFn: (t)=>so(t, (e, t)=>e !== t, e),
            InputComponent: qn,
            InputComponentProps: {
                type: e ? "datetime-local" : "date"
            }
        },
        {
            value: "after",
            getApplyFilterFn: (t)=>so(t, (e, t)=>e > t, e),
            InputComponent: qn,
            InputComponentProps: {
                type: e ? "datetime-local" : "date"
            }
        },
        {
            value: "onOrAfter",
            getApplyFilterFn: (t)=>so(t, (e, t)=>e >= t, e),
            InputComponent: qn,
            InputComponentProps: {
                type: e ? "datetime-local" : "date"
            }
        },
        {
            value: "before",
            getApplyFilterFn: (t)=>so(t, (e, t)=>e < t, e, !e),
            InputComponent: qn,
            InputComponentProps: {
                type: e ? "datetime-local" : "date"
            }
        },
        {
            value: "onOrBefore",
            getApplyFilterFn: (t)=>so(t, (e, t)=>e <= t, e),
            InputComponent: qn,
            InputComponentProps: {
                type: e ? "datetime-local" : "date"
            }
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>({ value: e })=>null == e
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>({ value: e })=>null != e
        }
    ];
function uo(t) {
    const { id: r, value: l, formattedValue: n, api: o, field: a, row: i, colDef: s, cellMode: c, isEditable: u, tabIndex: d, hasFocus: p, getValue: m } = t, f = On(t, [
        "id",
        "value",
        "formattedValue",
        "api",
        "field",
        "row",
        "colDef",
        "cellMode",
        "isEditable",
        "tabIndex",
        "hasFocus",
        "getValue"
    ]), g = $7fPBF.useRef(), [b, h] = $7fPBF.useState(l), C = $7fPBF.useCallback((e)=>{
        const t = e.target.value;
        if (h(t), "" === t) return void o.setEditCellValue({
            id: r,
            field: a,
            value: null
        }, e);
        const [l, n] = t.split("T"), [i, s, c] = l.split("-"), u = new Date;
        if (u.setFullYear(Number(i)), u.setMonth(Number(s) - 1), u.setDate(Number(c)), u.setHours(0, 0, 0, 0), n) {
            const [e, t] = n.split(":");
            u.setHours(Number(e), Number(t), 0, 0);
        }
        o.setEditCellValue({
            id: r,
            field: a,
            value: u
        }, e);
    }, [
        o,
        a,
        r
    ]), w = "dateTime" === s.type;
    $7fPBF.useEffect(()=>{
        h(l);
    }, [
        l
    ]), vr(()=>{
        p && g.current.focus();
    }, [
        p
    ]);
    let O = b || "";
    if (b instanceof Date) {
        const e = b.getTimezoneOffset();
        O = new Date(b.getTime() - 60 * e * 1e3).toISOString().substr(0, w ? 16 : 10);
    }
    return $7fPBF.createElement((0, $dzfbx.default), Object.assign({
        inputRef: g,
        fullWidth: !0,
        className: "MuiDataGrid-editInputCell",
        type: w ? "datetime-local" : "date",
        value: O,
        onChange: C
    }, f));
}
const po = (t)=>$7fPBF.createElement(uo, Object.assign({}, t));
function mo({ value: e }) {
    return e instanceof Date ? e.toLocaleDateString() : e;
}
function fo({ value: e }) {
    return e instanceof Date ? e.toLocaleString() : e;
}
const go = Object.assign(Object.assign({}, Jn), {
    type: "date",
    sortComparator: Dn,
    valueFormatter: mo,
    filterOperators: co(),
    renderEditCell: po
}), bo = Object.assign(Object.assign({}, Jn), {
    type: "dateTime",
    sortComparator: Dn,
    valueFormatter: fo,
    filterOperators: co(!0),
    renderEditCell: po
}), ho = (t)=>"object" == typeof t ? $7fPBF.createElement((0, $g21Gx.default), {
        key: t.value,
        value: t.value
    }, t.label) : $7fPBF.createElement((0, $g21Gx.default), {
        key: t,
        value: t
    }, t);
function vo(t) {
    var r;
    const { id: l, value: n, formattedValue: o, api: a, field: i, row: s, colDef: c, cellMode: u, isEditable: d, tabIndex: p, className: m, getValue: f, hasFocus: g } = t, b = On(t, [
        "id",
        "value",
        "formattedValue",
        "api",
        "field",
        "row",
        "colDef",
        "cellMode",
        "isEditable",
        "tabIndex",
        "className",
        "getValue",
        "hasFocus"
    ]), h = $7fPBF.useRef();
    return vr(()=>{
        g && h.current.querySelector('[role="button"]').focus();
    }, [
        g
    ]), $7fPBF.createElement((0, $g1A03.default), Object.assign({
        ref: h,
        value: n,
        onChange: (e)=>{
            a.setEditCellValue({
                id: l,
                field: i,
                value: e.target.value
            }, e), e.key || (a.commitCellChange({
                id: l,
                field: i
            }, e), a.setCellMode(l, i, "view"));
        },
        MenuProps: {
            onClose: (e, t)=>{
                ("backdropClick" === t || Kl(e.key)) && a.setCellMode(l, i, "view");
            }
        },
        fullWidth: !0,
        open: !0
    }, b), null === (r = c.valueOptions) || void 0 === r ? void 0 : r.map(ho));
}
const Co = (t)=>$7fPBF.createElement(vo, Object.assign({}, t)), wo = Object.assign(Object.assign({}, Jn), {
    type: "singleSelect",
    renderEditCell: Co,
    filterOperators: [
        {
            value: "is",
            getApplyFilterFn: (e)=>null == e.value || "" === e.value ? null : ({ value: t })=>"object" == typeof t ? e.value === t.value : e.value === t,
            InputComponent: qn,
            InputComponentProps: {
                type: "singleSelect"
            }
        },
        {
            value: "not",
            getApplyFilterFn: (e)=>null == e.value || "" === e.value ? null : ({ value: t })=>"object" == typeof t ? e.value !== t.value : e.value !== t,
            InputComponent: qn,
            InputComponentProps: {
                type: "singleSelect"
            }
        }
    ]
}), Oo = "__default__", yo = ()=>{
    const e = {
        string: Jn,
        number: oo,
        date: go,
        dateTime: bo,
        boolean: ro,
        singleSelect: wo
    };
    return e.__default__ = Jn, e;
}, Eo = (e, t)=>t ? e[t] : e.__default__, So = "string", Mo = "number", xo = "date", ko = "dateTime", Do = "boolean";
const Ro = $7fPBF.memo(function(t) {
    const { direction: r, index: l } = t, n = ae(), o = n.current.components.ColumnUnsortedIcon;
    if (null == r && null === o) return null;
    const a = $7fPBF.createElement((0, $iRcsz.default), {
        tabIndex: -1,
        "aria-label": n.current.getLocaleText("columnHeaderSortIconLabel"),
        title: n.current.getLocaleText("columnHeaderSortIconLabel"),
        size: "small"
    }, function(t, r) {
        let l = t.ColumnUnsortedIcon;
        return "asc" === r ? l = t.ColumnSortedAscendingIcon : "desc" === r && (l = t.ColumnSortedDescendingIcon), $7fPBF.createElement(l, {
            fontSize: "small",
            className: "MuiDataGrid-sortIcon"
        });
    }(n.current.components, r));
    return $7fPBF.createElement("div", {
        className: "MuiDataGrid-iconButtonContainer"
    }, null != l && $7fPBF.createElement((0, $jaezp.default), {
        badgeContent: l,
        color: "default"
    }, a), null == l && a);
});
function Io(e, t) {
    return e.closest(`.${t}`);
}
function Po(e) {
    return null != e && e.classList.contains("MuiDataGrid-columnHeader");
}
function Lo(e) {
    const t = e.getAttribute("data-field"), r = Io(e, "MuiDataGrid-root");
    if (!r) throw new Error("Material-UI: The root element is not found.");
    return r.querySelectorAll(`.MuiDataGrid-cell[data-field="${t}"]`);
}
function Fo(e) {
    return e.replace(/["\\]/g, "\\$&");
}
function jo(e, t) {
    return e.querySelector(`.MuiDataGrid-row[data-id="${Fo(String(t))}"]`);
}
const zo = $7fPBF.forwardRef(function(t, l) {
    const { className: n } = t, o = On(t, [
        "className"
    ]);
    return $7fPBF.createElement("div", Object.assign({
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-columnHeaderTitle", n)
    }, o));
});
function To(t) {
    const { label: r, description: l, columnWidth: n } = t, o = $7fPBF.useRef(null), [a, i] = $7fPBF.useState("");
    return $7fPBF.useEffect(()=>{
        if (!l && o && o.current) {
            const t = (e = o.current).scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
            i(t ? r : "");
        }
        var e;
    }, [
        o,
        n,
        l,
        r
    ]), $7fPBF.createElement((0, $hzQpW.default), {
        title: l || a
    }, $7fPBF.createElement(zo, {
        ref: o
    }, r));
}
let Ho = !1;
const Ao = Ho, _o = $7fPBF.memo(function(t) {
    const { resizable: l, resizing: n, height: o } = t, a = On(t, [
        "resizable",
        "resizing",
        "height"
    ]), i = ae(), { showColumnRightBorder: s } = ll(i, il), c = i.current.components.ColumnResizeIcon, u = $7fPBF.useCallback((e)=>{
        e.preventDefault(), e.stopPropagation();
    }, []);
    return $7fPBF.createElement("div", Object.assign({
        className: (0, $jtRae.default)("MuiDataGrid-columnSeparator", {
            "MuiDataGrid-columnSeparator--resizable": l,
            "Mui-resizing": n
        }),
        style: {
            minHeight: o,
            opacity: s ? 0 : 1
        }
    }, a, {
        onClick: u
    }), $7fPBF.createElement(c, {
        className: "MuiDataGrid-iconSeparator"
    }));
}), Go = $7fPBF.memo((t)=>{
    const { column: l, open: n, columnMenuId: o, columnMenuButtonId: a, iconButtonRef: i } = t, s = ae(), c = s.current.components.ColumnMenuIcon, u = $7fPBF.useCallback((e)=>{
        e.preventDefault(), e.stopPropagation(), s.current.toggleColumnMenu(l.field);
    }, [
        s,
        l.field
    ]);
    return $7fPBF.createElement("div", {
        className: (0, $jtRae.default)("MuiDataGrid-menuIcon", {
            "MuiDataGrid-menuOpen": n
        })
    }, $7fPBF.createElement((0, $iRcsz.default), {
        ref: i,
        tabIndex: -1,
        className: "MuiDataGrid-menuIconButton",
        "aria-label": s.current.getLocaleText("columnMenuLabel"),
        title: s.current.getLocaleText("columnMenuLabel"),
        size: "small",
        onClick: u,
        "aria-expanded": n ? "true" : void 0,
        "aria-haspopup": "true",
        "aria-controls": o,
        id: a
    }, $7fPBF.createElement(c, {
        fontSize: "small"
    })));
}), No = (e)=>e.preferencePanel, $o = (e)=>e.viewportSizes;
var Vo;
function Bo(t) {
    const { counter: r } = t, l = ae(), n = l.current.components.ColumnFilteredIcon, o = $7fPBF.useCallback((e)=>{
        e.preventDefault(), e.stopPropagation();
        const { open: t, openedPanelValue: r } = No(l.current.state);
        t && r === Vo.filters ? l.current.hideFilterPanel() : l.current.showFilterPanel();
    }, [
        l
    ]);
    if (!r) return null;
    const a = $7fPBF.createElement((0, $iRcsz.default), {
        onClick: o,
        color: "default",
        "aria-label": l.current.getLocaleText("columnHeaderFiltersLabel"),
        size: "small",
        tabIndex: -1
    }, $7fPBF.createElement(n, {
        className: "MuiDataGrid-filterIcon",
        fontSize: "small"
    }));
    return $7fPBF.createElement((0, $hzQpW.default), {
        title: l.current.getLocaleText("columnHeaderFiltersTooltipActive")(r),
        enterDelay: 1e3
    }, $7fPBF.createElement("div", {
        className: "MuiDataGrid-iconButtonContainer"
    }, r > 1 && $7fPBF.createElement((0, $jaezp.default), {
        badgeContent: r,
        color: "default"
    }, a), 1 === r && a));
}
!function(e) {
    e.filters = "filters", e.columns = "columns";
}(Vo || (Vo = {}));
const Wo = (0, $8SBLK.default)((e)=>({
        root: {
            zIndex: e.zIndex.modal,
            "& .MuiDataGrid-gridMenuList": {
                outline: 0
            }
        }
    }), {
    name: "MuiGridMenu",
    defaultTheme: xr()
}), Uo = {
    "bottom-start": "top left",
    "bottom-end": "top right"
}, Ko = (t)=>{
    const { open: r, target: l, onClickAway: n, children: o, position: a } = t, i = On(t, [
        "open",
        "target",
        "onClickAway",
        "children",
        "position"
    ]), s = $7fPBF.useRef(l), c = $7fPBF.useRef(r), u = Wo();
    return $7fPBF.useEffect(()=>{
        c.current && s.current && s.current.focus(), c.current = r, s.current = l;
    }, [
        r,
        l
    ]), $7fPBF.createElement((0, $iyOta.default), Object.assign({
        className: u.root,
        open: r,
        anchorEl: l,
        transition: !0,
        placement: a
    }, i), ({ TransitionProps: t, placement: r })=>$7fPBF.createElement((0, $7Em3j.default), {
            onClickAway: n
        }, $7fPBF.createElement((0, $bG0nA.default), Object.assign({}, t, {
            style: {
                transformOrigin: Uo[r]
            }
        }), $7fPBF.createElement((0, $ckpfM.default), null, o))));
};
function Zo({ columnMenuId: t, columnMenuButtonId: r, ContentComponent: l, contentComponentProps: n, field: o, open: a, target: i }) {
    const s = ae(), c = null == s ? void 0 : s.current.getColumn(o), u = $7fPBF.useCallback((e)=>{
        e.stopPropagation(), null == s || s.current.hideColumnMenu();
    }, [
        s
    ]);
    return i ? $7fPBF.createElement(Ko, {
        placement: "bottom-" + ("right" === c.align ? "start" : "end"),
        open: a,
        target: i,
        onClickAway: u
    }, $7fPBF.createElement(l, Object.assign({
        currentColumn: c,
        hideMenu: u,
        open: a,
        id: t,
        labelledby: r
    }, n))) : null;
}
function Xo(t) {
    var l;
    const { column: n, columnMenuOpen: o, colIndex: a, headerHeight: i, isDragging: s, isResizing: c, sortDirection: u, sortIndex: p, options: m, filterItemsCounter: f, hasFocus: g, tabIndex: b } = t, h = ae(), v = $7fPBF.useRef(null), C = (0, $ejsyu.default)(), w = (0, $ejsyu.default)(), O = $7fPBF.useRef(null), { classes: y, disableColumnReorder: E, showColumnRightBorder: S, disableColumnResize: M, disableColumnMenu: x, disableColumnFilter: k } = m, D = null != u, R = "number" === n.type;
    let I = null;
    n.renderHeader && h.current && (I = n.renderHeader(h.current.getColumnHeaderParams(n.field)));
    const P = $7fPBF.useCallback((e)=>(t)=>h.current.publishEvent(e, h.current.getColumnHeaderParams(n.field), t), [
        h,
        n.field
    ]), L = $7fPBF.useMemo(()=>({
            onClick: P(ne.columnHeaderClick),
            onDoubleClick: P(ne.columnHeaderDoubleClick),
            onMouseOver: P(ne.columnHeaderOver),
            onMouseOut: P(ne.columnHeaderOut),
            onMouseEnter: P(ne.columnHeaderEnter),
            onMouseLeave: P(ne.columnHeaderLeave),
            onKeyDown: P(ne.columnHeaderKeyDown),
            onFocus: P(ne.columnHeaderFocus),
            onBlur: P(ne.columnHeaderBlur)
        }), [
        P
    ]), F = $7fPBF.useMemo(()=>({
            onDragStart: P(ne.columnHeaderDragStart),
            onDragEnter: P(ne.columnHeaderDragEnter),
            onDragOver: P(ne.columnHeaderDragOver),
            onDragEnd: P(ne.columnHeaderDragEnd)
        }), [
        P
    ]), j = $7fPBF.useMemo(()=>({
            onMouseDown: P(ne.columnSeparatorMouseDown)
        }), [
        P
    ]), z = [
        null == y ? void 0 : y.columnHeader
    ];
    if (n.headerClassName) {
        const e = yr(n.headerClassName) ? n.headerClassName({
            field: n.field,
            colDef: n,
            api: h.current
        }) : n.headerClassName;
        z.push(e);
    }
    const T = (0, $jtRae.default)("center" === n.headerAlign && "MuiDataGrid-columnHeader--alignCenter", "right" === n.headerAlign && "MuiDataGrid-columnHeader--alignRight", {
        "MuiDataGrid-columnHeader--sortable": n.sortable,
        "MuiDataGrid-columnHeader--moving": s,
        "MuiDataGrid-columnHeader--sorted": D,
        "MuiDataGrid-columnHeader--numeric": R,
        "MuiDataGrid-withBorder": S
    }, ...z), H = n.computedWidth;
    let A;
    null != u && (A = {
        "aria-sort": "asc" === u ? "ascending" : "descending"
    });
    const _ = !x && !n.disableColumnMenu && $7fPBF.createElement(Go, {
        column: n,
        columnMenuId: C,
        columnMenuButtonId: w,
        open: o,
        iconButtonRef: O
    }), G = $7fPBF.createElement($7fPBF.Fragment, null, !k && $7fPBF.createElement(Bo, {
        counter: f
    }), n.sortable && !n.hideSortIcons && $7fPBF.createElement(Ro, {
        direction: u,
        index: p
    }));
    return $7fPBF.useLayoutEffect(()=>{
        const e = h.current.state.columnMenu;
        if (g && !e.open) {
            const e = v.current.querySelector('[tabindex="0"]');
            e ? e.focus() : v.current.focus();
        }
    }), $7fPBF.createElement("div", Object.assign({
        ref: v,
        className: T,
        key: n.field,
        "data-field": n.field,
        style: {
            width: H,
            minWidth: H,
            maxWidth: H
        },
        role: "columnheader",
        tabIndex: b,
        "aria-colindex": a + 1
    }, A, L), $7fPBF.createElement("div", Object.assign({
        className: "MuiDataGrid-columnHeaderDraggableContainer",
        draggable: !E && !n.disableReorder
    }, F), $7fPBF.createElement("div", {
        className: "MuiDataGrid-columnHeaderTitleContainer"
    }, I || $7fPBF.createElement(To, {
        label: n.headerName || n.field,
        description: n.description,
        columnWidth: H
    }), G), _), $7fPBF.createElement(_o, Object.assign({
        resizable: !M && !!n.resizable,
        resizing: c,
        height: i
    }, j)), $7fPBF.createElement(Zo, {
        columnMenuId: C,
        columnMenuButtonId: w,
        field: n.field,
        open: o,
        target: O.current,
        ContentComponent: h.current.components.ColumnMenu,
        contentComponentProps: null === (l = h.current.componentsProps) || void 0 === l ? void 0 : l.columnMenu
    }));
}
function qo(t) {
    const { columns: r } = t, l = ae(), n = ll(l, il), o = ll(l, xl), a = ll(l, zl), i = ll(l, fl), s = ll(l, bl), c = ll(l, Al), u = ll(l, nl).renderContext, d = ll(l, Nl), p = ll(l, Gl), m = ll(l, Wl), f = ll(l, Ul), g = r.map((t, r)=>{
        const l = (g = r, null == u ? g : g + u.firstColIdx);
        var g;
        const b = 0 === l, h = !(null === d && null === p), v = null !== d && d.field === t.field || b && !h ? 0 : -1, C = null !== c && c.field === t.field, w = f.open && f.field === t.field;
        return $7fPBF.createElement(Xo, Object.assign({
            key: t.field
        }, o[t.field], {
            columnMenuOpen: w,
            filterItemsCounter: a[t.field] && a[t.field].length,
            options: n,
            headerHeight: m,
            isDragging: t.field === i,
            column: t,
            colIndex: l,
            isResizing: s === t.field,
            hasFocus: C,
            tabIndex: v
        }));
    });
    return $7fPBF.createElement($7fPBF.Fragment, null, g);
}
const Yo = (e)=>e.containerSizes, Jo = (e)=>e.viewportSizes, Qo = (e)=>e.scrollBar, ea = (0, $7UqAk.createSelector)(Yo, (e)=>null == e ? null : e.dataContainerSizes), ta = (0, $7UqAk.createSelector)(Yo, (e)=>null == e ? 0 : e.dataContainerSizes.height), ra = (e)=>e.scrollBar, la = $7fPBF.forwardRef(function(t, l) {
    var n;
    const o = ae(), a = ll(o, de), i = ll(o, Yo), s = ll(o, Wl), c = ll(o, nl).renderContext, { hasScrollX: u } = ll(o, ra), d = ll(o, fl), p = (0, $jtRae.default)("MuiDataGrid-columnHeaderWrapper", {
        scroll: u,
        "MuiDataGrid-columnHeaderDropZone": d
    }), m = $7fPBF.useMemo(()=>null == c ? [] : a.slice(c.firstColIdx, c.lastColIdx + 1), [
        a,
        c
    ]);
    return $7fPBF.createElement($7fPBF.Fragment, null, $7fPBF.createElement(pl, {
        scrollDirection: "left"
    }), $7fPBF.createElement("div", {
        ref: l,
        className: p,
        "aria-rowindex": 1,
        role: "row",
        style: {
            minWidth: null === (n = null == i ? void 0 : i.totalSizes) || void 0 === n ? void 0 : n.width
        }
    }, $7fPBF.createElement(al, {
        width: null == c ? void 0 : c.leftEmptyWidth,
        height: s
    }), $7fPBF.createElement(qo, {
        columns: m
    }), $7fPBF.createElement(al, {
        width: null == c ? void 0 : c.rightEmptyWidth,
        height: s
    })), $7fPBF.createElement(pl, {
        scrollDirection: "right"
    }));
}), na = $7fPBF.forwardRef(function(t, l) {
    const { className: n, style: o } = t, a = On(t, [
        "className",
        "style"
    ]), i = ae(), s = ll(i, Wl);
    return $7fPBF.createElement("div", Object.assign({
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-columnsContainer", n)
    }, a, {
        style: Object.assign({
            minHeight: s,
            maxHeight: s,
            lineHeight: `${s}px`
        }, o)
    }));
});
function oa(t) {
    return $7fPBF.createElement("div", {
        className: "MuiDataGrid-main"
    }, t.children);
}
const aa = $7fPBF.forwardRef(function(t, l) {
    const { className: n, size: o } = t, a = On(t, [
        "className",
        "size"
    ]), i = ae(), { autoHeight: s } = ll(i, il), c = ll(i, Wl), u = ll(i, Bl), d = ll(i, ta);
    $7fPBF.useEffect(()=>{
        i.current.resize();
    }, [
        i
    ]);
    const p = $7fPBF.useMemo(()=>{
        if (!s) return o.height;
        return c + (d < u ? 2 * u : d);
    }, [
        s,
        d,
        c,
        u,
        o.height
    ]);
    return $7fPBF.createElement("div", {
        className: "MuiDataGrid-windowContainer",
        style: {
            width: o.width,
            height: p
        }
    }, $7fPBF.createElement("div", Object.assign({
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-window", n)
    }, a, {
        style: {
            top: c,
            overflowY: s ? "hidden" : "auto"
        }
    })));
});
function ia(e, t) {
    var r = function(e) {
        var t = e.__resizeTriggers__, r = t.firstElementChild, l = t.lastElementChild, n = r.firstElementChild;
        l.scrollLeft = l.scrollWidth, l.scrollTop = l.scrollHeight, n.style.width = r.offsetWidth + 1 + "px", n.style.height = r.offsetHeight + 1 + "px", r.scrollLeft = r.scrollWidth, r.scrollTop = r.scrollHeight;
    }, l = function(e) {
        if (!(e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0)) {
            var l = this;
            r(this), this.__resizeRAF__ && t.cancelAnimationFrame(this.__resizeRAF__), this.__resizeRAF__ = t.requestAnimationFrame(function() {
                (function(e) {
                    return e.offsetWidth != e.__resizeLast__.width || e.offsetHeight != e.__resizeLast__.height;
                })(l) && (l.__resizeLast__.width = l.offsetWidth, l.__resizeLast__.height = l.offsetHeight, l.__resizeListeners__.forEach(function(t) {
                    t.call(l, e);
                }));
            });
        }
    }, n = !1, o = "", a = "animationstart", i = "Webkit Moz O ms".split(" "), s = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), c = document.createElement("fakeelement");
    if (void 0 !== c.style.animationName && (n = !0), !1 === n) {
        for(var u = 0; u < i.length; u++)if (void 0 !== c.style[i[u] + "AnimationName"]) {
            o = "-" + i[u].toLowerCase() + "-", a = s[u], n = !0;
            break;
        }
    }
    var d = "resizeanim", p = "@" + o + "keyframes " + "resizeanim { from { opacity: 0; } to { opacity: 0; } } ", m = o + "animation: 1ms " + "resizeanim; ";
    return {
        addResizeListener: function(n, o) {
            if (!n.__resizeTriggers__) {
                var i = n.ownerDocument, s = t.getComputedStyle(n);
                s && "static" == s.position && (n.style.position = "relative"), function(t) {
                    if (!t.getElementById("muiDetectElementResize")) {
                        var r = (p || "") + ".Mui-resizeTriggers { " + (m || "") + 'visibility: hidden; opacity: 0; } .Mui-resizeTriggers, .Mui-resizeTriggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .Mui-resizeTriggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', l = t.head || t.getElementsByTagName("head")[0], n = t.createElement("style");
                        n.id = "muiDetectElementResize", n.type = "text/css", null != e && n.setAttribute("nonce", e), n.styleSheet ? n.styleSheet.cssText = r : n.appendChild(t.createTextNode(r)), l.appendChild(n);
                    }
                }(i), n.__resizeLast__ = {}, n.__resizeListeners__ = [], (n.__resizeTriggers__ = i.createElement("div")).className = "Mui-resizeTriggers", n.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>', n.appendChild(n.__resizeTriggers__), r(n), n.addEventListener("scroll", l, !0), a && (n.__resizeTriggers__.__animationListener__ = function(e) {
                    e.animationName == d && r(n);
                }, n.__resizeTriggers__.addEventListener(a, n.__resizeTriggers__.__animationListener__));
            }
            n.__resizeListeners__.push(o);
        },
        removeResizeListener: function(e, t) {
            if (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t), 1), !e.__resizeListeners__.length) {
                e.removeEventListener("scroll", l, !0), e.__resizeTriggers__.__animationListener__ && (e.__resizeTriggers__.removeEventListener(a, e.__resizeTriggers__.__animationListener__), e.__resizeTriggers__.__animationListener__ = null);
                try {
                    e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__);
                } catch (e) {}
            }
        }
    };
}
const sa = $7fPBF.forwardRef(function(t, r) {
    const { children: l, defaultHeight: n = null, defaultWidth: o = null, disableHeight: a = !1, disableWidth: i = !1, nonce: s, onResize: u, style: d } = t, m = On(t, [
        "children",
        "defaultHeight",
        "defaultWidth",
        "disableHeight",
        "disableWidth",
        "nonce",
        "onResize",
        "style"
    ]), [f, g] = $7fPBF.useState({
        height: n,
        width: o
    }), b = $7fPBF.useRef(null), h = $7fPBF.useRef(null), v = hr(()=>{
        if (h.current) {
            const e = h.current.offsetHeight || 0, t = h.current.offsetWidth || 0, r = (0, $bSzdr.default)(h.current).getComputedStyle(h.current), l = parseInt(r.paddingLeft, 10) || 0, n = parseInt(r.paddingRight, 10) || 0, o = e - (parseInt(r.paddingTop, 10) || 0) - (parseInt(r.paddingBottom, 10) || 0), s = t - l - n;
            (!a && f.height !== o || !i && f.width !== s) && (g({
                height: o,
                width: s
            }), u && u({
                height: o,
                width: s
            }));
        }
    });
    vr(()=>{
        var e;
        if (h.current = b.current.parentElement, !h) return;
        const t = (0, $bSzdr.default)(null !== (e = h.current) && void 0 !== e ? e : void 0), r = ia(s, t);
        return r.addResizeListener(h.current, v), v(), ()=>{
            r.removeResizeListener(h.current, v);
        };
    }, [
        s,
        v
    ]);
    const C = {
        overflow: "visible"
    }, w = {};
    a || (C.height = 0, w.height = f.height), i || (C.width = 0, w.width = f.width);
    const O = (0, $55RWP.default)(b, r);
    return $7fPBF.createElement("div", Object.assign({
        ref: O,
        style: Object.assign(Object.assign({}, C), d)
    }, m), null === f.height && null === f.width ? null : l(w));
}), ca = (e)=>e.editRows;
function ua(t) {
    const { className: l } = t, n = On(t, [
        "className"
    ]), o = ae(), a = ll(o, ea), i = {
        minWidth: null == a ? void 0 : a.width,
        minHeight: null == a ? void 0 : a.height
    };
    return $7fPBF.createElement("div", Object.assign({
        className: (0, $jtRae.default)("MuiDataGrid-dataContainer", l),
        style: i
    }, n));
}
const da = $7fPBF.forwardRef(function(t, r) {
    const { height: l, width: n, children: o } = t;
    return $7fPBF.createElement("div", {
        ref: r,
        className: "MuiDataGrid-renderingZone",
        style: {
            maxHeight: l,
            width: n
        }
    }, o);
});
function pa(t) {
    const { selected: l, id: n, className: o, rowIndex: a, children: i } = t, s = a + 2, c = ae(), u = ll(c, Bl), { classes: d, getRowClassName: p } = ll(c, il), m = $7fPBF.useCallback((e)=>(t)=>{
            (1 !== t.target.nodeType || t.currentTarget.contains(t.target)) && c.current.publishEvent(e, null == c ? void 0 : c.current.getRowParams(n), t);
        }, [
        c,
        n
    ]), f = $7fPBF.useMemo(()=>({
            onClick: m(ne.rowClick),
            onDoubleClick: m(ne.rowDoubleClick),
            onMouseOver: m(ne.rowOver),
            onMouseOut: m(ne.rowOut),
            onMouseEnter: m(ne.rowEnter),
            onMouseLeave: m(ne.rowLeave)
        }), [
        m
    ]), g = {
        maxHeight: u,
        minHeight: u
    }, b = yr(p) && p(c.current.getRowParams(n)), h = (0, $jtRae.default)(o, b, null == d ? void 0 : d.row, {
        "Mui-selected": l
    });
    return $7fPBF.createElement("div", Object.assign({
        key: n,
        "data-id": n,
        "data-rowindex": a,
        role: "row",
        className: h,
        "aria-rowindex": s,
        "aria-selected": l,
        style: g
    }, f), i);
}
const ma = $7fPBF.memo(function(t) {
    const { align: l, className: n, children: o, colIndex: a, cellMode: i, field: s, formattedValue: c, hasFocus: u, height: d, isEditable: p, isSelected: g, rowIndex: b, rowId: h, showRightBorder: v, tabIndex: C, value: w, width: O } = t, y = null == c ? w : c, E = $7fPBF.useRef(null), S = ae(), M = (0, $jtRae.default)(n, `MuiDataGrid-cell--text${(0, $dKzJP.default)(l)}`, {
        "MuiDataGrid-withBorder": v,
        "MuiDataGrid-cell--editable": p
    }), x = $7fPBF.useCallback((e)=>(t)=>{
            if (t.relatedTarget && t.currentTarget.contains(t.relatedTarget)) return;
            const r = S.current.getCellParams(h, s || "");
            S.current.publishEvent(e, r, t);
        }, [
        S,
        s,
        h
    ]), k = $7fPBF.useCallback((e)=>(t)=>{
            const r = S.current.getCellParams(h, s || "");
            S.current.publishEvent(e, r, t);
        }, [
        S,
        s,
        h
    ]), D = $7fPBF.useCallback((e)=>(t)=>{
            (1 !== t.target.nodeType || t.currentTarget.contains(t.target)) && S.current.publishEvent(e, S.current.getCellParams(h, s || ""), t);
        }, [
        S,
        s,
        h
    ]), R = $7fPBF.useMemo(()=>({
            onClick: D(ne.cellClick),
            onDoubleClick: D(ne.cellDoubleClick),
            onMouseDown: D(ne.cellMouseDown),
            onMouseUp: k(ne.cellMouseUp),
            onMouseOver: D(ne.cellOver),
            onMouseOut: D(ne.cellOut),
            onMouseEnter: D(ne.cellEnter),
            onMouseLeave: D(ne.cellLeave),
            onKeyDown: D(ne.cellKeyDown),
            onBlur: x(ne.cellBlur),
            onFocus: D(ne.cellFocus),
            onDragStart: D(ne.cellDragStart),
            onDragEnter: D(ne.cellDragEnter),
            onDragOver: D(ne.cellDragOver)
        }), [
        D,
        x,
        k
    ]), I = {
        minWidth: O,
        maxWidth: O,
        lineHeight: d - 1 + "px",
        minHeight: d,
        maxHeight: d
    };
    return $7fPBF.useLayoutEffect(()=>{
        if (!u || "edit" === i) return;
        const e = (0, $g3iV0.default)(S.current.rootElementRef.current);
        if (E.current && !E.current.contains(e.activeElement)) {
            const e = E.current.querySelector('[tabindex="0"]');
            e ? e.focus() : E.current.focus();
        }
    }), $7fPBF.createElement("div", Object.assign({
        ref: E,
        className: M,
        role: "cell",
        "data-value": w,
        "data-field": s,
        "data-rowindex": b,
        "data-colindex": a,
        "data-rowselected": g,
        "data-editable": p,
        "data-mode": i,
        "aria-colindex": a + 1,
        style: I,
        tabIndex: C
    }, R), null != o ? o : null == y ? void 0 : y.toString());
}), fa = $7fPBF.memo(function(t) {
    const { columns: l, firstColIdx: n, hasScrollX: o, hasScrollY: a, height: i, id: s, getCellClassName: c, lastColIdx: u, rowIndex: d, cellFocus: p, cellTabIndex: m, showCellRightBorder: f, isSelected: g, editRowState: b, cellClassName: h } = t, v = On(t, [
        "columns",
        "firstColIdx",
        "hasScrollX",
        "hasScrollY",
        "height",
        "id",
        "getCellClassName",
        "lastColIdx",
        "rowIndex",
        "cellFocus",
        "cellTabIndex",
        "showCellRightBorder",
        "isSelected",
        "editRowState",
        "cellClassName"
    ]), C = ae(), w = l.slice(n, u + 1).map((e, u)=>{
        const w = n + u, O = w === l.length - 1, y = O ? !(O && o && !a) && !t.extendRowFullWidth : f, E = C.current.getCellParams(s, e.field), S = [
            h
        ];
        e.cellClassName && S.push((0, $jtRae.default)(yr(e.cellClassName) ? e.cellClassName(E) : e.cellClassName));
        const M = b && b[e.field];
        let x = null;
        if (null == M && e.renderCell && (x = e.renderCell(E), S.push("MuiDataGrid-cell--withRenderer")), null != M && e.renderEditCell) {
            const t = Object.assign(Object.assign({}, E), M);
            x = e.renderEditCell(t), S.push("MuiDataGrid-cell--editing");
        }
        c && S.push(c(E));
        return Object.assign({
            value: E.value,
            field: e.field,
            width: e.computedWidth,
            rowId: s,
            height: i,
            showRightBorder: y,
            formattedValue: E.formattedValue,
            align: e.align || "left",
            rowIndex: d,
            cellMode: E.cellMode,
            colIndex: w,
            children: x,
            isEditable: E.isEditable,
            isSelected: g,
            hasFocus: null !== p && p.id === s && p.field === e.field,
            tabIndex: null !== m && m.id === s && m.field === e.field && "view" === E.cellMode ? 0 : -1,
            className: (0, $jtRae.default)(S)
        }, v);
    });
    return $7fPBF.createElement($7fPBF.Fragment, null, w.map((t)=>$7fPBF.createElement(ma, Object.assign({
            key: t.field
        }, t))));
});
function ga(t) {
    const { height: r, width: l, children: n } = t;
    return $7fPBF.createElement("div", {
        className: "MuiDataGrid-viewport",
        style: {
            minWidth: l,
            maxWidth: l,
            maxHeight: r
        }
    }, n);
}
const ba = $7fPBF.forwardRef(function(t, r) {
    const l = ae(), n = dn(), o = ll(l, il), a = ll(l, Yo), i = ll(l, Jo), s = ll(l, Qo), c = ll(l, de), u = ll(l, nl), d = ll(l, Hl), p = ll(l, Gl), m = ll(l, Cn), f = ll(l, Rl), g = ll(l, Bl), b = ll(l, ca);
    return $7fPBF.createElement(ua, null, $7fPBF.createElement(ga, Object.assign({}, i), $7fPBF.createElement(da, Object.assign({
        ref: r
    }, (null == a ? void 0 : a.renderingZone) || {
        width: 0,
        height: 0
    }), (()=>{
        if (null == u.renderContext) return null;
        return f.slice(u.renderContext.firstRowIdx, u.renderContext.lastRowIdx).map(([t, r], l)=>{
            var a;
            return $7fPBF.createElement(pa, {
                className: (u.renderContext.firstRowIdx + l) % 2 == 0 ? "Mui-even" : "Mui-odd",
                key: t,
                id: t,
                selected: void 0 !== m[t],
                rowIndex: u.renderContext.firstRowIdx + l
            }, $7fPBF.createElement(al, {
                width: u.renderContext.leftEmptyWidth,
                height: g
            }), $7fPBF.createElement(fa, {
                columns: c,
                row: r,
                id: t,
                height: g,
                firstColIdx: u.renderContext.firstColIdx,
                lastColIdx: u.renderContext.lastColIdx,
                hasScrollX: s.hasScrollX,
                hasScrollY: s.hasScrollY,
                showCellRightBorder: !!n.showCellRightBorder,
                extendRowFullWidth: !n.disableExtendRowFullWidth,
                rowIndex: u.renderContext.firstRowIdx + l,
                cellFocus: d,
                cellTabIndex: p,
                isSelected: void 0 !== m[t],
                editRowState: b[t],
                cellClassName: null === (a = o.classes) || void 0 === a ? void 0 : a.cell,
                getCellClassName: n.getCellClassName
            }), $7fPBF.createElement(al, {
                width: u.renderContext.rightEmptyWidth,
                height: g
            }));
        });
    })())));
});
function ha() {
    var t, r, l;
    const n = ae(), o = dn(), a = ll(n, vl), i = ll(n, Pl), s = !o.loading && 0 === a, c = !o.loading && a > 0 && 0 === i;
    return s ? $7fPBF.createElement(n.current.components.NoRowsOverlay, Object.assign({}, null === (t = o.componentsProps) || void 0 === t ? void 0 : t.noRowsOverlay)) : c ? $7fPBF.createElement(n.current.components.NoResultsOverlay, Object.assign({}, null === (r = o.componentsProps) || void 0 === r ? void 0 : r.noResultsOverlay)) : o.loading ? $7fPBF.createElement(n.current.components.LoadingOverlay, Object.assign({}, null === (l = o.componentsProps) || void 0 === l ? void 0 : l.loadingOverlay)) : null;
}
function va(t) {
    const { children: r } = t, l = ae(), n = dn(), o = $7fPBF.useRef(null), a = $7fPBF.useRef(null), i = $7fPBF.useRef(null), s = $7fPBF.useRef(null);
    l.current.columnHeadersContainerElementRef = a, l.current.columnHeadersElementRef = o, l.current.windowRef = i, l.current.renderingZoneRef = s;
    const c = $7fPBF.useCallback((e)=>l.current.publishEvent(ne.resize, e), [
        l
    ]);
    return $7fPBF.createElement(oa, null, $7fPBF.createElement(ha, null), $7fPBF.createElement(na, {
        ref: a
    }, $7fPBF.createElement(la, {
        ref: o
    })), $7fPBF.createElement(sa, {
        nonce: n.nonce,
        disableHeight: n.autoHeight,
        onResize: c
    }, (t)=>$7fPBF.createElement(aa, {
            ref: i,
            size: t
        }, $7fPBF.createElement(ba, {
            ref: s
        }))), r);
}
class Ca extends $7fPBF.Component {
    static getDerivedStateFromError(e) {
        return {
            hasError: !0,
            error: e
        };
    }
    componentDidCatch(e, t) {
        this.props.api.current && (this.logError(e), this.props.api.current.showError({
            error: e,
            errorInfo: t
        }));
    }
    logError(e, t) {
        this.props.logger.error(`An unexpected error occurred. Error: ${e && e.message}. `, e, t);
    }
    render() {
        var e;
        return this.props.hasError || (null === (e = this.state) || void 0 === e ? void 0 : e.hasError) ? this.props.render(this.props.componentProps || this.state) : this.props.children;
    }
}
function wa(t) {
    const { children: r } = t, l = Ar("GridErrorHandler"), n = ae(), o = dn(), [a] = rl(n);
    return $7fPBF.createElement(Ca, {
        hasError: null != a.error,
        componentProps: a.error,
        api: n,
        logger: l,
        render: (t)=>{
            var r;
            return $7fPBF.createElement(oa, null, $7fPBF.createElement(n.current.components.ErrorOverlay, Object.assign({}, t, null === (r = o.componentsProps) || void 0 === r ? void 0 : r.errorOverlay)));
        }
    }, r);
}
function Oa() {
    var t;
    const r = ae(), l = dn(), n = $7fPBF.useRef(null);
    return r.current.footerRef = n, l.hideFooter ? null : $7fPBF.createElement("div", {
        ref: n
    }, $7fPBF.createElement(r.current.components.Footer, Object.assign({}, null === (t = l.componentsProps) || void 0 === t ? void 0 : t.footer)));
}
function ya() {
    var t;
    const r = ae(), l = dn(), n = $7fPBF.useRef(null);
    return r.current.headerRef = n, $7fPBF.createElement("div", {
        ref: n
    }, $7fPBF.createElement(r.current.components.Header, Object.assign({}, null === (t = l.componentsProps) || void 0 === t ? void 0 : t.header)));
}
const Ea = (0, $8SBLK.default)((e)=>{
    const t = "light" === Er(e.palette) ? (0, $2jEfe.lighten)(Mr(e.palette.divider, 1), .88) : (0, $2jEfe.darken)(Mr(e.palette.divider, 1), .68), r = {
        root: Object.assign(Object.assign({
            flex: 1,
            boxSizing: "border-box",
            position: "relative",
            border: `1px solid ${t}`,
            borderRadius: e.shape.borderRadius,
            color: e.palette.text.primary
        }, e.typography.body2), {
            outline: "none",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            "& *, & *::before, & *::after": {
                boxSizing: "inherit"
            },
            "&.MuiDataGrid-autoHeight": {
                height: "auto"
            },
            "& .MuiDataGrid-main": {
                position: "relative",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column"
            },
            "& .MuiDataGrid-overlay": {
                display: "flex",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                alignSelf: "center",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: Mr(e.palette.background.default, e.palette.action.disabledOpacity)
            },
            "& .MuiDataGrid-toolbarContainer": {
                display: "flex",
                alignItems: "center",
                padding: "4px 4px 0"
            },
            "& .MuiDataGrid-columnsContainer": {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                borderBottom: `1px solid ${t}`
            },
            "& .MuiDataGrid-scrollArea": {
                position: "absolute",
                top: 0,
                zIndex: 101,
                width: 20,
                bottom: 0
            },
            "& .MuiDataGrid-scrollArea--left": {
                left: 0
            },
            "& .MuiDataGrid-scrollArea--right": {
                right: 0
            },
            "& .MuiDataGrid-columnHeaderWrapper": {
                display: "flex",
                width: "100%",
                alignItems: "center",
                overflow: "hidden"
            },
            "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
                WebkitTapHighlightColor: "transparent",
                lineHeight: null,
                padding: "0 10px"
            },
            "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within": {
                outline: `solid ${Mr(e.palette.primary.main, .5)} 1px`,
                outlineWidth: 1,
                outlineOffset: -1
            },
            "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus": {
                outline: `solid ${e.palette.primary.main} 1px`
            },
            "& .MuiDataGrid-columnHeaderCheckbox, & .MuiDataGrid-cellCheckbox": {
                padding: 0,
                justifyContent: "center",
                alignItems: "center"
            },
            "& .MuiDataGrid-columnHeader": {
                position: "relative",
                display: "flex",
                alignItems: "center"
            },
            "& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon": {
                opacity: 0,
                transition: e.transitions.create([
                    "opacity"
                ], {
                    duration: e.transitions.duration.shorter
                })
            },
            "& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted):hover .MuiDataGrid-sortIcon": {
                opacity: .5
            },
            "& .MuiDataGrid-columnHeaderTitleContainer": {
                display: "flex",
                alignItems: "center",
                minWidth: 0,
                flex: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                padding: "0 6px"
            },
            "& .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon": {
                fontSize: "inherit"
            },
            "& .MuiDataGrid-columnHeader--sortable": {
                cursor: "pointer"
            },
            "& .MuiDataGrid-columnHeader--alignCenter .MuiDataGrid-columnHeaderTitleContainer": {
                justifyContent: "center"
            },
            "& .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderDraggableContainer, & .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer": {
                flexDirection: "row-reverse"
            },
            "& .MuiDataGrid-columnHeader--alignCenter .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-menuIcon": {
                marginRight: "auto",
                marginLeft: -6
            },
            "& .MuiDataGrid-columnHeaderTitle": {
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontWeight: e.typography.fontWeightMedium
            },
            "& .MuiDataGrid-columnHeader--moving": {
                backgroundColor: e.palette.action.hover
            },
            "& .MuiDataGrid-columnSeparator": {
                position: "absolute",
                right: -12,
                zIndex: 100,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                color: t
            },
            "& .MuiDataGrid-columnSeparator--resizable": {
                cursor: "col-resize",
                touchAction: "none",
                "&:hover": {
                    color: e.palette.text.primary,
                    "@media (hover: none)": {
                        color: t
                    }
                },
                "&.Mui-resizing": {
                    color: e.palette.text.primary
                }
            },
            "& .MuiDataGrid-iconSeparator": {
                color: "inherit"
            },
            "& .MuiDataGrid-menuIcon": {
                visibility: "hidden",
                fontSize: 20,
                marginRight: -6,
                display: "flex",
                alignItems: "center"
            },
            "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon, .MuiDataGrid-menuOpen": {
                visibility: "visible"
            },
            "& .MuiDataGrid-columnHeaderWrapper.scroll .MuiDataGrid-columnHeader:last-child": {
                borderRight: "none"
            },
            "& .MuiDataGrid-dataContainer": {
                position: "relative",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column"
            },
            "& .MuiDataGrid-window": {
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                overflowX: "auto"
            },
            "& .MuiDataGrid-viewport": {
                position: "sticky",
                top: 0,
                left: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden"
            },
            "& .MuiDataGrid-row": {
                display: "flex",
                width: "fit-content",
                "&:hover": {
                    backgroundColor: e.palette.action.hover,
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                },
                "&.Mui-selected": {
                    backgroundColor: Mr(e.palette.primary.main, e.palette.action.selectedOpacity),
                    "&:hover": {
                        backgroundColor: Mr(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
                        "@media (hover: none)": {
                            backgroundColor: Mr(e.palette.primary.main, e.palette.action.selectedOpacity)
                        }
                    }
                }
            },
            "& .MuiDataGrid-cell": {
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                borderBottom: `1px solid ${t}`
            },
            "& .MuiDataGrid-cell.MuiDataGrid-cell--editing": {
                padding: 1,
                display: "flex",
                boxShadow: e.shadows[2],
                backgroundColor: e.palette.background.paper,
                "&:focus-within": {
                    outline: `solid ${e.palette.primary.main} 1px`,
                    outlineOffset: "-1px"
                }
            },
            "& .MuiDataGrid-editInputCell": Object.assign(Object.assign({}, e.typography.body2), {
                padding: "1px 0",
                "& input": {
                    padding: "0 16px",
                    height: "100%"
                }
            }),
            "& .MuiDataGrid-editBooleanCell": {
                display: "flex",
                height: "100%",
                width: "100%",
                alignItems: "center",
                justifyContent: "center"
            },
            '& .MuiDataGrid-booleanCell[data-value="true"]': {
                color: e.palette.text.secondary
            },
            '& .MuiDataGrid-booleanCell[data-value="false"]': {
                color: e.palette.text.disabled
            },
            "& .MuiDataGrid-columnHeaderWrapper .MuiDataGrid-cell": {
                borderBottom: "none"
            },
            "& .MuiDataGrid-cell--withRenderer": {
                display: "flex",
                alignItems: "center"
            },
            "& .MuiDataGrid-withBorder": {
                borderRight: `1px solid ${t}`
            },
            "& .MuiDataGrid-cell--textLeft": {
                textAlign: "left"
            },
            "& .MuiDataGrid-cell--textLeft.MuiDataGrid-cell--withRenderer, & .MuiDataGrid-cell--textLeft.MuiDataGrid-cell--editing": {
                justifyContent: "flex-start"
            },
            "& .MuiDataGrid-cell--textRight": {
                textAlign: "right"
            },
            "& .MuiDataGrid-cell--textRight.MuiDataGrid-cell--withRenderer, & .MuiDataGrid-cell--textRight.MuiDataGrid-cell--editing": {
                justifyContent: "flex-end"
            },
            "& .MuiDataGrid-cell--textCenter": {
                textAlign: "center"
            },
            "& .MuiDataGrid-cell--textCenter.MuiDataGrid-cell--withRenderer, & .MuiDataGrid-cell--textCenter.MuiDataGrid-cell--editing": {
                justifyContent: "center"
            },
            "& .MuiDataGrid-rowCount, & .MuiDataGrid-selectedRowCount": {
                alignItems: "center",
                display: "flex",
                margin: e.spacing(0, 2)
            },
            "& .MuiDataGrid-footerContainer": {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                minHeight: 52,
                "& .MuiDataGrid-selectedRowCount": {
                    visibility: "hidden",
                    width: 0,
                    height: 0,
                    [e.breakpoints.up("sm")]: {
                        visibility: "visible",
                        width: "auto",
                        height: "auto"
                    }
                }
            },
            "& .MuiDataGrid-columnHeaderDropZone .MuiDataGrid-columnHeaderDraggableContainer": {
                cursor: "move"
            },
            "& .MuiDataGrid-columnHeaderDraggableContainer": {
                display: "flex",
                width: "100%"
            },
            "& .MuiDataGrid-columnHeader--dragging": {
                background: e.palette.background.paper,
                padding: "0 12px",
                borderRadius: e.shape.borderRadius,
                opacity: e.palette.action.disabledOpacity
            }
        })
    };
    if ("dark" === Er(e.palette)) {
        const e = "#202022", t = "#585859", l = "#838384";
        r.root = Object.assign(Object.assign({}, r.root), {
            scrollbarColor: `${t} ${e}`,
            "& *::-webkit-scrollbar": {
                backgroundColor: e
            },
            "& *::-webkit-scrollbar-thumb": {
                borderRadius: 8,
                backgroundColor: t,
                minHeight: 24,
                border: `3px solid ${e}`
            },
            "& *::-webkit-scrollbar-thumb:focus": {
                backgroundColor: l
            },
            "& *::-webkit-scrollbar-thumb:active": {
                backgroundColor: l
            },
            "& *::-webkit-scrollbar-thumb:hover": {
                backgroundColor: l
            },
            "& *::-webkit-scrollbar-corner": {
                backgroundColor: e
            }
        });
    }
    return r;
}, {
    name: "MuiDataGrid",
    defaultTheme: xr()
}), Sa = $7fPBF.forwardRef(function(t, l) {
    var n;
    const o = Ea(), a = ae(), i = dn(), { children: s, className: u } = t, d = On(t, [
        "children",
        "className"
    ]), p = ll(a, ge), [m] = rl(a), f = ll(a, il), g = $7fPBF.useRef(null), b = (0, $55RWP.default)(g, l);
    return a.current.rootElementRef = g, $7fPBF.createElement((0, $l6eg8.default), null, $7fPBF.createElement("div", Object.assign({
        ref: b,
        className: (0, $jtRae.default)(o.root, null === (n = f.classes) || void 0 === n ? void 0 : n.root, i.className, u, {
            "MuiDataGrid-autoHeight": i.autoHeight
        }),
        role: "grid",
        "aria-colcount": p,
        "aria-rowcount": m.rows.totalRowCount,
        "aria-multiselectable": !i.disableMultipleSelection,
        "aria-label": i["aria-label"],
        "aria-labelledby": i["aria-labelledby"],
        style: i.style
    }, d), s));
}), Ma = $7fPBF.forwardRef(function(t, l) {
    const { className: n } = t, o = On(t, [
        "className"
    ]);
    return $7fPBF.createElement("div", Object.assign({
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-footerContainer", n)
    }, o));
}), xa = $7fPBF.forwardRef(function(t, l) {
    const { className: n, style: o } = t, a = On(t, [
        "className",
        "style"
    ]), i = ae(), s = ll(i, Wl);
    return $7fPBF.createElement("div", Object.assign({
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-overlay", n),
        style: Object.assign({
            top: s
        }, o)
    }, a));
}), ka = $7fPBF.forwardRef(function(t, l) {
    const { className: n, children: o } = t, a = On(t, [
        "className",
        "children"
    ]);
    return o ? $7fPBF.createElement("div", Object.assign({
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-toolbarContainer", n)
    }, a), o) : null;
}), Da = (t)=>{
    const { onClick: r } = t, l = ae(), n = dn(), o = $7fPBF.useCallback((e)=>{
        r(e), l.current.showPreferences(Vo.columns);
    }, [
        l,
        r
    ]);
    return n.disableColumnSelector ? null : $7fPBF.createElement((0, $g21Gx.default), {
        onClick: o
    }, l.current.getLocaleText("columnMenuShowColumns"));
}, Ra = (t)=>{
    const { column: r, onClick: l } = t, n = ae(), o = dn(), a = $7fPBF.useCallback((e)=>{
        l(e), n.current.showFilterPanel(null == r ? void 0 : r.field);
    }, [
        n,
        null == r ? void 0 : r.field,
        l
    ]);
    return o.disableColumnFilter || !(null == r ? void 0 : r.filterable) ? null : $7fPBF.createElement((0, $g21Gx.default), {
        onClick: a
    }, n.current.getLocaleText("columnMenuFilter"));
}, Ia = $7fPBF.forwardRef(function(t, l) {
    const { hideMenu: n, currentColumn: o, open: a, id: i, labelledby: s, className: c, children: u } = t, d = On(t, [
        "hideMenu",
        "currentColumn",
        "open",
        "id",
        "labelledby",
        "className",
        "children"
    ]), p = $7fPBF.useCallback((e)=>{
        Xl(e.key) && e.preventDefault(), cn(e.key) && n();
    }, [
        n
    ]);
    return $7fPBF.createElement((0, $5IlSp.default), Object.assign({
        id: i,
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-gridMenuList", c),
        "aria-labelledby": s,
        onKeyDown: p,
        autoFocus: a
    }, d), u);
}), Pa = (t)=>{
    const { column: r, onClick: l } = t, n = ae(), o = dn(), a = $7fPBF.useRef(), i = $7fPBF.useCallback((e)=>{
        l(e), a.current = setTimeout(()=>{
            n.current.setColumnVisibility(null == r ? void 0 : r.field, !1);
        }, 100);
    }, [
        n,
        null == r ? void 0 : r.field,
        l
    ]);
    return $7fPBF.useEffect(()=>()=>clearTimeout(a.current), []), o.disableColumnSelector ? null : $7fPBF.createElement((0, $g21Gx.default), {
        onClick: i
    }, n.current.getLocaleText("columnMenuHideColumn"));
}, La = (t)=>{
    const { column: r, onClick: l } = t, n = ae(), o = ll(n, Ml), a = $7fPBF.useMemo(()=>{
        if (!r) return null;
        const e = o.find((e)=>e.field === r.field);
        return null == e ? void 0 : e.sort;
    }, [
        r,
        o
    ]), i = $7fPBF.useCallback((e)=>{
        l(e);
        const t = e.currentTarget.getAttribute("data-value") || null;
        null == n || n.current.sortColumn(r, t);
    }, [
        n,
        r,
        l
    ]);
    return r && r.sortable ? $7fPBF.createElement($7fPBF.Fragment, null, $7fPBF.createElement((0, $g21Gx.default), {
        onClick: i,
        disabled: null == a
    }, n.current.getLocaleText("columnMenuUnsort")), $7fPBF.createElement((0, $g21Gx.default), {
        onClick: i,
        "data-value": "asc",
        disabled: "asc" === a
    }, n.current.getLocaleText("columnMenuSortAsc")), $7fPBF.createElement((0, $g21Gx.default), {
        onClick: i,
        "data-value": "desc",
        disabled: "desc" === a
    }, n.current.getLocaleText("columnMenuSortDesc"))) : null;
}, Fa = $7fPBF.forwardRef(function(t, r) {
    const { hideMenu: l, currentColumn: n } = t;
    return $7fPBF.createElement(Ia, Object.assign({
        ref: r
    }, t), $7fPBF.createElement(La, {
        onClick: l,
        column: n
    }), $7fPBF.createElement(Ra, {
        onClick: l,
        column: n
    }), $7fPBF.createElement(Pa, {
        onClick: l,
        column: n
    }), $7fPBF.createElement(Da, {
        onClick: l,
        column: n
    }));
}), ja = (0, $8SBLK.default)(()=>({
        root: {
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            flex: "1 1",
            maxHeight: 400
        }
    }), {
    name: "MuiGridPanelContent"
});
function za(t) {
    const l = ja(), { className: n } = t, o = On(t, [
        "className"
    ]);
    return $7fPBF.createElement("div", Object.assign({
        className: (0, $jtRae.default)(l.root, n)
    }, o));
}
const Ta = (0, $8SBLK.default)(()=>({
        root: {
            padding: 4,
            display: "flex",
            justifyContent: "space-between"
        }
    }), {
    name: "MuiGridPanelFooter"
});
function Ha(t) {
    const l = Ta(), { className: n } = t, o = On(t, [
        "className"
    ]);
    return $7fPBF.createElement("div", Object.assign({
        className: (0, $jtRae.default)(l.root, n)
    }, o));
}
const Aa = (0, $8SBLK.default)((e)=>({
        root: {
            padding: e.spacing(1)
        }
    }), {
    name: "MuiDataGridPanelHeader",
    defaultTheme: xr()
});
function _a(t) {
    const l = Aa(), { className: n } = t, o = On(t, [
        "className"
    ]);
    return $7fPBF.createElement("div", Object.assign({
        className: (0, $jtRae.default)(l.root, n)
    }, o));
}
const Ga = (0, $8SBLK.default)(()=>({
        root: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
            "&:focus": {
                outline: 0
            }
        }
    }), {
    name: "MuiGridPanelWrapper"
}), Na = ()=>!0;
function $a(t) {
    const l = Ga(), { className: n } = t, o = On(t, [
        "className"
    ]), a = Sr().startsWith("v4") ? {
        getDoc: ()=>document
    } : {};
    return $7fPBF.createElement((0, $hdcUo.default), Object.assign({
        open: !0,
        disableEnforceFocus: !0,
        isEnabled: Na
    }, a), $7fPBF.createElement("div", Object.assign({
        tabIndex: -1,
        className: (0, $jtRae.default)(l.root, n)
    }, o)));
}
const Va = (0, $8SBLK.default)({
    container: {
        padding: "8px 0px 8px 8px"
    },
    column: {
        display: "flex",
        justifyContent: "space-between",
        padding: "1px 8px 1px 7px"
    },
    switch: {
        marginRight: 4
    },
    dragIcon: {
        justifyContent: "flex-end"
    }
}, {
    name: "MuiDataGridColumnsPanel"
});
function Ba() {
    const t = Va(), r = ae(), l = $7fPBF.useRef(null), n = ll(r, ue), { disableColumnReorder: o } = ll(r, il), [a, i] = $7fPBF.useState(""), s = $7fPBF.useCallback((e)=>{
        const { name: t } = e.target, l = r.current.getColumn(t);
        r.current.setColumnVisibility(t, !!l.hide);
    }, [
        r
    ]), c = $7fPBF.useCallback((e)=>{
        r.current.updateColumns(n.map((t)=>(t.hide = e, t)));
    }, [
        r,
        n
    ]), u = $7fPBF.useCallback(()=>c(!1), [
        c
    ]), d = $7fPBF.useCallback(()=>c(!0), [
        c
    ]), p = $7fPBF.useCallback((e)=>{
        i(e.target.value);
    }, []), m = $7fPBF.useMemo(()=>a ? n.filter((e)=>e.field.toLowerCase().indexOf(a.toLowerCase()) > -1 || e.headerName && e.headerName.toLowerCase().indexOf(a.toLowerCase()) > -1) : n, [
        n,
        a
    ]);
    return $7fPBF.useEffect(()=>{
        l.current.focus();
    }, []), $7fPBF.createElement($a, null, $7fPBF.createElement(_a, null, $7fPBF.createElement((0, $MQfsM.default), {
        label: r.current.getLocaleText("columnsPanelTextFieldLabel"),
        placeholder: r.current.getLocaleText("columnsPanelTextFieldPlaceholder"),
        inputRef: l,
        value: a,
        onChange: p,
        variant: "standard",
        fullWidth: !0
    })), $7fPBF.createElement(za, null, $7fPBF.createElement("div", {
        className: t.container
    }, m.map((l)=>$7fPBF.createElement("div", {
            key: l.field,
            className: t.column
        }, $7fPBF.createElement((0, $lLRv0.default), {
            control: $7fPBF.createElement((0, $4mZpH.default), {
                className: t.switch,
                checked: !l.hide,
                onClick: s,
                name: l.field,
                color: "primary",
                size: "small"
            }),
            label: l.headerName || l.field
        }), !o && Ao && $7fPBF.createElement((0, $iRcsz.default), {
            draggable: !0,
            className: t.dragIcon,
            "aria-label": r.current.getLocaleText("columnsPanelDragIconLabel"),
            title: r.current.getLocaleText("columnsPanelDragIconLabel"),
            size: "small",
            disabled: !0
        }, $7fPBF.createElement(Wn, null)))))), $7fPBF.createElement(Ha, null, $7fPBF.createElement((0, $fwAOd.default), {
        onClick: d,
        color: "primary"
    }, r.current.getLocaleText("columnsPanelHideAllButton")), $7fPBF.createElement((0, $fwAOd.default), {
        onClick: u,
        color: "primary"
    }, r.current.getLocaleText("columnsPanelShowAllButton"))));
}
const Wa = (0, $8SBLK.default)((e)=>({
        root: {
            zIndex: e.zIndex.modal
        },
        paper: {
            backgroundColor: e.palette.background.paper,
            minWidth: 300,
            maxHeight: 450,
            display: "flex"
        }
    }), {
    name: "MuiGridPanel",
    defaultTheme: xr()
}), Ua = function(e, t) {
    const r = {};
    return t.forEach((t)=>{
        r[t] = Or(e, t);
    }), r;
}("MuiGridPanel", [
    "root",
    "paper"
]), Ka = $7fPBF.forwardRef(function(t, l) {
    var n;
    const { children: o, className: a, open: i } = t, s = On(t, [
        "children",
        "className",
        "open"
    ]), c = Wa(s), u = ae(), d = $7fPBF.useCallback(()=>{
        u.current.hidePreferences();
    }, [
        u
    ]), p = $7fPBF.useCallback((e)=>{
        Kl(e.key) && u.current.hidePreferences();
    }, [
        u
    ]), m = null === (n = null == u ? void 0 : u.current.columnHeadersContainerElementRef) || void 0 === n ? void 0 : n.current;
    return m ? $7fPBF.createElement((0, $iyOta.default), Object.assign({
        ref: l,
        placement: "bottom-start",
        className: (0, $jtRae.default)(a, c.root),
        open: i,
        anchorEl: m,
        modifiers: "v5" === Sr() ? [
            {
                name: "flip",
                enabled: !1
            }
        ] : {
            flip: {
                enabled: !1
            }
        }
    }, s), $7fPBF.createElement((0, $7Em3j.default), {
        onClickAway: d
    }, $7fPBF.createElement((0, $ckpfM.default), {
        className: c.paper,
        elevation: 8,
        onKeyDown: p
    }, o))) : null;
}), Za = $7fPBF.forwardRef(function(t, r) {
    var l, n, o;
    const a = ae(), i = ll(a, ue), s = dn(), c = ll(a, No), u = c.openedPanelValue === Vo.columns, d = !c.openedPanelValue || !u, p = a.current.components.ColumnsPanel, m = a.current.components.FilterPanel, f = a.current.components.Panel;
    return $7fPBF.createElement(f, Object.assign({
        ref: r,
        open: i.length > 0 && c.open
    }, null === (l = null == a ? void 0 : a.current.componentsProps) || void 0 === l ? void 0 : l.panel, t), !s.disableColumnSelector && u && $7fPBF.createElement(p, Object.assign({}, null === (n = null == a ? void 0 : a.current.componentsProps) || void 0 === n ? void 0 : n.columnsPanel)), !s.disableColumnFilter && d && $7fPBF.createElement(m, Object.assign({}, null === (o = null == a ? void 0 : a.current.componentsProps) || void 0 === o ? void 0 : o.filterPanel)));
}), Xa = (0, $8SBLK.default)({
    root: {
        display: "flex",
        justifyContent: "space-around",
        padding: 8
    },
    linkOperatorSelect: {
        minWidth: 60
    },
    columnSelect: {
        width: 150
    },
    operatorSelect: {
        width: 120
    },
    filterValueInput: {
        width: 190
    },
    closeIcon: {
        flexShrink: 0,
        justifyContent: "flex-end",
        marginRight: 6,
        marginBottom: 2
    }
}, {
    name: "MuiGridFilterForm"
});
function qa(t) {
    var r, l;
    const { item: n, hasMultipleFilters: o, deleteFilter: a, applyFilterChanges: i, multiFilterOperator: s, showMultiFilterOperators: c, disableMultiFilterOperator: u, applyMultiFilterOperatorChanges: p } = t, f = Xa(), g = ae(), b = ll(g, me), h = (0, $ejsyu.default)(), v = (0, $ejsyu.default)(), C = (0, $ejsyu.default)(), w = (0, $ejsyu.default)(), y = (0, $ejsyu.default)(), E = (0, $ejsyu.default)(), M = $7fPBF.useCallback(()=>n.columnField ? g.current.getColumn(n.columnField) : null, [
        g,
        n
    ]), x = $7fPBF.useCallback(()=>{
        var e;
        const t = M();
        return n.operatorValue && t ? null === (e = t.filterOperators) || void 0 === e ? void 0 : e.find((e)=>e.value === n.operatorValue) : null;
    }, [
        n,
        M
    ]), k = $7fPBF.useCallback((e)=>{
        const t = e.target.value, r = g.current.getColumn(t).filterOperators[0];
        i(Object.assign(Object.assign({}, n), {
            value: void 0,
            columnField: t,
            operatorValue: r.value
        }));
    }, [
        g,
        i,
        n
    ]), D = $7fPBF.useCallback((e)=>{
        const t = e.target.value;
        i(Object.assign(Object.assign({}, n), {
            operatorValue: t
        }));
    }, [
        i,
        n
    ]), R = $7fPBF.useCallback((e)=>{
        const t = e.target.value === Zr.And.toString() ? Zr.And : Zr.Or;
        p(t);
    }, [
        p
    ]), I = $7fPBF.useCallback(()=>{
        a(n);
    }, [
        a,
        n
    ]), P = x();
    return $7fPBF.createElement("div", {
        className: f.root
    }, $7fPBF.createElement((0, $cuouK.default), {
        variant: "standard",
        className: f.closeIcon
    }, $7fPBF.createElement((0, $iRcsz.default), {
        "aria-label": g.current.getLocaleText("filterPanelDeleteIconLabel"),
        title: g.current.getLocaleText("filterPanelDeleteIconLabel"),
        onClick: I,
        size: "small"
    }, $7fPBF.createElement($n, {
        fontSize: "small"
    }))), $7fPBF.createElement((0, $cuouK.default), {
        variant: "standard",
        className: f.linkOperatorSelect,
        style: {
            display: o ? "block" : "none",
            visibility: c ? "visible" : "hidden"
        }
    }, $7fPBF.createElement((0, $k2dmk.default), {
        htmlFor: h,
        id: v
    }, g.current.getLocaleText("filterPanelOperators")), $7fPBF.createElement((0, $g1A03.default), {
        labelId: v,
        id: h,
        value: s,
        onChange: R,
        disabled: !!u,
        native: !0
    }, $7fPBF.createElement("option", {
        key: Zr.And.toString(),
        value: Zr.And.toString()
    }, g.current.getLocaleText("filterPanelOperatorAnd")), $7fPBF.createElement("option", {
        key: Zr.Or.toString(),
        value: Zr.Or.toString()
    }, g.current.getLocaleText("filterPanelOperatorOr")))), $7fPBF.createElement((0, $cuouK.default), {
        variant: "standard",
        className: f.columnSelect
    }, $7fPBF.createElement((0, $k2dmk.default), {
        htmlFor: C,
        id: w
    }, g.current.getLocaleText("filterPanelColumns")), $7fPBF.createElement((0, $g1A03.default), {
        labelId: w,
        id: C,
        value: n.columnField || "",
        onChange: k,
        native: !0
    }, b.map((t)=>$7fPBF.createElement("option", {
            key: t.field,
            value: t.field
        }, t.headerName || t.field)))), $7fPBF.createElement((0, $cuouK.default), {
        variant: "standard",
        className: f.operatorSelect
    }, $7fPBF.createElement((0, $k2dmk.default), {
        htmlFor: y,
        id: E
    }, g.current.getLocaleText("filterPanelOperators")), $7fPBF.createElement((0, $g1A03.default), {
        labelId: E,
        id: y,
        value: n.operatorValue,
        onChange: D,
        native: !0
    }, null === (l = null === (r = M()) || void 0 === r ? void 0 : r.filterOperators) || void 0 === l ? void 0 : l.map((t)=>$7fPBF.createElement("option", {
            key: t.value,
            value: t.value
        }, t.label || g.current.getLocaleText(`filterOperator${(0, $dKzJP.default)(t.value)}`))))), $7fPBF.createElement((0, $cuouK.default), {
        variant: "standard",
        className: f.filterValueInput
    }, (null == P ? void 0 : P.InputComponent) ? $7fPBF.createElement(P.InputComponent, Object.assign({
        apiRef: g,
        item: n,
        applyValue: i
    }, P.InputComponentProps)) : null));
}
function Ya() {
    const t = ae(), [r] = rl(t), { disableMultipleColumnsFiltering: l } = ll(t, il), n = $7fPBF.useMemo(()=>r.filter.items.length > 1, [
        r.filter.items.length
    ]), o = $7fPBF.useCallback((e)=>{
        t.current.upsertFilter(e);
    }, [
        t
    ]), a = $7fPBF.useCallback((e)=>{
        t.current.applyFilterLinkOperator(e);
    }, [
        t
    ]), i = $7fPBF.useCallback(()=>{
        t.current.upsertFilter({});
    }, [
        t
    ]), s = $7fPBF.useCallback((e)=>{
        t.current.deleteFilter(e);
    }, [
        t
    ]);
    return $7fPBF.useEffect(()=>{
        0 === r.filter.items.length && i();
    }, [
        i,
        r.filter.items.length
    ]), $7fPBF.createElement($a, null, $7fPBF.createElement(za, null, r.filter.items.map((t, l)=>$7fPBF.createElement(qa, {
            key: null == t.id ? l : t.id,
            item: t,
            applyFilterChanges: o,
            deleteFilter: s,
            hasMultipleFilters: n,
            showMultiFilterOperators: l > 0,
            multiFilterOperator: r.filter.linkOperator,
            disableMultiFilterOperator: 1 !== l,
            applyMultiFilterOperatorChanges: a
        }))), !l && $7fPBF.createElement(Ha, null, $7fPBF.createElement((0, $fwAOd.default), {
        onClick: i,
        startIcon: $7fPBF.createElement(Vn, null),
        color: "primary"
    }, t.current.getLocaleText("filterPanelAddFilter"))));
}
const Ja = $7fPBF.forwardRef(function(t, r) {
    const { onClick: l } = t, n = On(t, [
        "onClick"
    ]), o = ae(), a = dn(), i = o.current.components.ColumnSelectorIcon, { open: s, openedPanelValue: c } = ll(o, No);
    return a.disableColumnSelector ? null : $7fPBF.createElement((0, $fwAOd.default), Object.assign({
        ref: r,
        size: "small",
        color: "primary",
        "aria-label": o.current.getLocaleText("toolbarColumnsLabel"),
        startIcon: $7fPBF.createElement(i, null)
    }, n, {
        onClick: (e)=>{
            s && c === Vo.columns ? o.current.hidePreferences() : o.current.showPreferences(Vo.columns), null == l || l(e);
        }
    }), o.current.getLocaleText("toolbarColumns"));
}), Qa = $7fPBF.forwardRef(function(t, r) {
    const { onClick: l } = t, n = On(t, [
        "onClick"
    ]), o = ae(), a = dn(), i = ll(o, Vl), s = (0, $ejsyu.default)(), c = (0, $ejsyu.default)(), [u, p] = $7fPBF.useState(null), m = o.current.components.DensityCompactIcon, f = o.current.components.DensityStandardIcon, g = o.current.components.DensityComfortableIcon, b = [
        {
            icon: $7fPBF.createElement(m, null),
            label: o.current.getLocaleText("toolbarDensityCompact"),
            value: $r.Compact
        },
        {
            icon: $7fPBF.createElement(f, null),
            label: o.current.getLocaleText("toolbarDensityStandard"),
            value: $r.Standard
        },
        {
            icon: $7fPBF.createElement(g, null),
            label: o.current.getLocaleText("toolbarDensityComfortable"),
            value: $r.Comfortable
        }
    ], h = $7fPBF.useCallback(()=>{
        switch(i){
            case $r.Compact:
                return $7fPBF.createElement(m, null);
            case $r.Comfortable:
                return $7fPBF.createElement(g, null);
            default:
                return $7fPBF.createElement(f, null);
        }
    }, [
        i,
        m,
        g,
        f
    ]), v = ()=>p(null);
    if (a.disableDensitySelector) return null;
    const C = b.map((t, r)=>$7fPBF.createElement((0, $g21Gx.default), {
            key: r,
            onClick: ()=>{
                var e;
                return e = t.value, o.current.setDensity(e), void p(null);
            },
            selected: t.value === i
        }, $7fPBF.createElement((0, $fHFY6.default), null, t.icon), t.label));
    return $7fPBF.createElement($7fPBF.Fragment, null, $7fPBF.createElement((0, $fwAOd.default), Object.assign({
        ref: r,
        color: "primary",
        size: "small",
        startIcon: h(),
        "aria-label": o.current.getLocaleText("toolbarDensityLabel"),
        "aria-expanded": u ? "true" : void 0,
        "aria-haspopup": "menu",
        "aria-labelledby": c,
        id: s
    }, n, {
        onClick: (e)=>{
            p(e.currentTarget), null == l || l(e);
        }
    }), o.current.getLocaleText("toolbarDensity")), $7fPBF.createElement(Ko, {
        open: Boolean(u),
        target: u,
        onClickAway: v,
        position: "bottom-start"
    }, $7fPBF.createElement((0, $5IlSp.default), {
        id: c,
        className: "MuiDataGrid-gridMenuList",
        "aria-labelledby": s,
        onKeyDown: (e)=>{
            Xl(e.key) && e.preventDefault(), cn(e.key) && v();
        },
        autoFocusItem: Boolean(u)
    }, C)));
}), ei = (0, $8SBLK.default)((e)=>({
        list: {
            margin: e.spacing(1, 1, .5),
            padding: e.spacing(0, 1)
        }
    }), {
    name: "MuiGridToolbarFilterButton",
    defaultTheme: xr()
}), ti = $7fPBF.forwardRef(function(t, r) {
    const { componentsProps: l = {} } = t, n = On(t, [
        "componentsProps"
    ]), o = l.button || {}, a = ei(), i = ae(), s = dn(), c = ll(i, jl), u = ll(i, Fl), d = ll(i, ce), p = ll(i, No), f = $7fPBF.useMemo(()=>{
        if (p.open) return i.current.getLocaleText("toolbarFiltersTooltipHide");
        if (0 === c) return i.current.getLocaleText("toolbarFiltersTooltipShow");
        return $7fPBF.createElement("div", null, i.current.getLocaleText("toolbarFiltersTooltipActive")(c), $7fPBF.createElement("ul", {
            className: a.list
        }, u.map((t, r)=>Object.assign({}, d[t.columnField] && $7fPBF.createElement("li", {
                key: r
            }, `${d[t.columnField].headerName || t.columnField}\n                  ${((e)=>d[e.columnField].filterOperators.find((t)=>t.value === e.operatorValue).label || i.current.getLocaleText(`filterOperator${(0, $dKzJP.default)(e.operatorValue)}`).toString())(t)}\n                  ${t.value}`)))));
    }, [
        i,
        p.open,
        c,
        u,
        d,
        a
    ]);
    if (s.disableColumnFilter) return null;
    const g = i.current.components.OpenFilterButtonIcon;
    return $7fPBF.createElement((0, $hzQpW.default), Object.assign({
        title: f,
        enterDelay: 1e3
    }, n), $7fPBF.createElement((0, $fwAOd.default), Object.assign({
        ref: r,
        size: "small",
        color: "primary",
        "aria-label": i.current.getLocaleText("toolbarFiltersLabel"),
        startIcon: $7fPBF.createElement((0, $jaezp.default), {
            badgeContent: c,
            color: "primary"
        }, $7fPBF.createElement(g, null))
    }, o, {
        onClick: (e)=>{
            var t;
            const { open: r, openedPanelValue: l } = p;
            r && l === Vo.filters ? i.current.hideFilterPanel() : i.current.showFilterPanel(), null === (t = o.onClick) || void 0 === t || t.call(o, e);
        }
    }), i.current.getLocaleText("toolbarFilters")));
}), ri = $7fPBF.forwardRef(function(t, r) {
    const { csvOptions: l, onClick: n } = t, o = On(t, [
        "csvOptions",
        "onClick"
    ]), a = ae(), i = (0, $ejsyu.default)(), s = (0, $ejsyu.default)(), [c, u] = $7fPBF.useState(null), p = a.current.components.ExportIcon, m = [];
    m.push({
        label: a.current.getLocaleText("toolbarExportCSV"),
        format: "csv",
        formatOptions: l
    });
    const f = ()=>u(null), g = (e)=>()=>{
            "csv" === e.format && a.current.exportDataAsCsv(e.formatOptions), u(null);
        };
    return $7fPBF.createElement($7fPBF.Fragment, null, $7fPBF.createElement((0, $fwAOd.default), Object.assign({
        ref: r,
        color: "primary",
        size: "small",
        startIcon: $7fPBF.createElement(p, null),
        "aria-expanded": c ? "true" : void 0,
        "aria-label": a.current.getLocaleText("toolbarExportLabel"),
        "aria-haspopup": "menu",
        "aria-labelledby": s,
        id: i
    }, o, {
        onClick: (e)=>{
            u(e.currentTarget), null == n || n(e);
        }
    }), a.current.getLocaleText("toolbarExport")), $7fPBF.createElement(Ko, {
        open: Boolean(c),
        target: c,
        onClickAway: f,
        position: "bottom-start"
    }, $7fPBF.createElement((0, $5IlSp.default), {
        id: s,
        className: "MuiDataGrid-gridMenuList",
        "aria-labelledby": i,
        onKeyDown: (e)=>{
            Xl(e.key) && e.preventDefault(), cn(e.key) && f();
        },
        autoFocusItem: Boolean(c)
    }, m.map((t, r)=>$7fPBF.createElement((0, $g21Gx.default), {
            key: r,
            onClick: g(t)
        }, t.label)))));
}), li = $7fPBF.forwardRef(function(t, r) {
    const l = dn();
    return l.disableColumnFilter && l.disableColumnSelector && l.disableDensitySelector ? null : $7fPBF.createElement(ka, Object.assign({
        ref: r
    }, t), $7fPBF.createElement(Ja, null), $7fPBF.createElement(ti, null), $7fPBF.createElement(Qa, null), $7fPBF.createElement(ri, null));
}), ni = $7fPBF.forwardRef(function(t, l) {
    const { className: n, rowCount: o, visibleRowCount: a } = t, i = On(t, [
        "className",
        "rowCount",
        "visibleRowCount"
    ]), s = ae();
    if (0 === o) return null;
    const c = a < o ? s.current.getLocaleText("footerTotalVisibleRows")(a, o) : o.toLocaleString();
    return $7fPBF.createElement("div", Object.assign({
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-rowCount", n)
    }, i), s.current.getLocaleText("footerTotalRows"), " ", c);
}), oi = $7fPBF.forwardRef(function(t, l) {
    const { className: n, selectedRowCount: o } = t, a = On(t, [
        "className",
        "selectedRowCount"
    ]), i = ae().current.getLocaleText("footerRowSelected")(o);
    return $7fPBF.createElement("div", Object.assign({
        ref: l,
        className: (0, $jtRae.default)("MuiDataGrid-selectedRowCount", n)
    }, a), i);
}), ai = $7fPBF.forwardRef(function(t, r) {
    var l;
    const n = ae(), o = dn(), a = ll(n, vl), i = ll(n, hn), s = ll(n, fn), c = ll(n, Pl), u = !o.hideFooterSelectedRowCount && i > 0 ? $7fPBF.createElement(oi, {
        selectedRowCount: i
    }) : $7fPBF.createElement("div", null), d = o.hideFooterRowCount || o.pagination ? null : $7fPBF.createElement(ni, {
        rowCount: a,
        visibleRowCount: c
    }), p = !!o.pagination && null != s.pageSize && !o.hideFooterPagination && (null == n ? void 0 : n.current.components.Pagination), m = p && $7fPBF.createElement(p, Object.assign({}, null === (l = null == n ? void 0 : n.current.componentsProps) || void 0 === l ? void 0 : l.pagination));
    return $7fPBF.createElement(Ma, Object.assign({
        ref: r
    }, t), u, d, m);
}), ii = $7fPBF.forwardRef(function(t, r) {
    var l, n;
    const o = ae(), a = null == o ? void 0 : o.current.components.PreferencesPanel, i = a && $7fPBF.createElement(a, Object.assign({}, null === (l = null == o ? void 0 : o.current.componentsProps) || void 0 === l ? void 0 : l.preferencesPanel)), s = null == o ? void 0 : o.current.components.Toolbar, c = s && $7fPBF.createElement(s, Object.assign({}, null === (n = null == o ? void 0 : o.current.componentsProps) || void 0 === n ? void 0 : n.toolbar));
    return $7fPBF.createElement("div", Object.assign({
        ref: r
    }, t), i, c);
}), si = $7fPBF.forwardRef(function(t, r) {
    return $7fPBF.createElement(xa, Object.assign({
        ref: r
    }, t), $7fPBF.createElement((0, $9SdKL.default), null));
}), ci = $7fPBF.forwardRef(function(t, r) {
    const l = ae().current.getLocaleText("noRowsLabel");
    return $7fPBF.createElement(xa, Object.assign({
        ref: r
    }, t), l);
}), ui = (0, $8SBLK.default)((e)=>({
        selectLabel: {
            display: "none",
            [e.breakpoints.up("md")]: {
                display: "block"
            }
        },
        caption: {
            "&[id]": {
                display: "none",
                [e.breakpoints.up("md")]: {
                    display: "block"
                }
            }
        },
        input: {
            display: "none",
            [e.breakpoints.up("md")]: {
                display: "inline-flex"
            }
        }
    }), {
    defaultTheme: xr()
}), di = $7fPBF.forwardRef(function(t, r) {
    var l, n, o;
    const a = ui(), i = ae(), s = dn(), c = ll(i, fn), u = $7fPBF.useMemo(()=>Math.floor(c.rowCount / (c.pageSize || 1)), [
        c.rowCount,
        c.pageSize
    ]), d = $7fPBF.useCallback((e)=>{
        const t = Number(e.target.value);
        i.current.setPageSize(t);
    }, [
        i
    ]), p = $7fPBF.useCallback((e, t)=>{
        i.current.setPage(t);
    }, [
        i
    ]);
    return $7fPBF.createElement((0, $5jbjs.default), Object.assign({
        ref: r,
        classes: Object.assign(Object.assign({}, "v5" === Sr() ? {
            selectLabel: a.selectLabel
        } : {
            caption: a.caption
        }), {
            input: a.input
        }),
        component: "div",
        count: c.rowCount,
        page: c.page <= u ? c.page : u,
        rowsPerPageOptions: (null === (o = s.rowsPerPageOptions) || void 0 === o ? void 0 : o.includes(c.pageSize)) ? s.rowsPerPageOptions : [],
        rowsPerPage: c.pageSize
    }, i.current.getLocaleText("MuiTablePagination"), "v4" !== Sr() ? {
        onPageChange: p,
        onRowsPerPageChange: d
    } : {
        onChangePage: p,
        onChangeRowsPerPage: d
    }, t));
});
function pi(t, r) {
    const l = Ar("useApi"), n = $7fPBF.useCallback((e, l, n = {})=>{
        if (n.defaultMuiPrevented = !1, n && ((e)=>void 0 !== e.isPropagationStopped)(n) && n.isPropagationStopped()) return;
        const o = r.signature === sl.XGrid ? {
            api: t.current
        } : {};
        t.current.emit(e, l, n, o);
    }, [
        t,
        r.signature
    ]), o = $7fPBF.useCallback((e, r, n)=>{
        l.debug(`Binding ${e} event`), t.current.on(e, r, n);
        const o = t.current;
        return ()=>{
            l.debug(`Clearing ${e} event`), o.removeListener(e, r);
        };
    }, [
        t,
        l
    ]), a = $7fPBF.useCallback((e)=>{
        t.current.publishEvent(ne.componentError, e);
    }, [
        t
    ]);
    $7fPBF.useEffect(()=>{
        l.debug("Initializing grid api.");
        const e = t.current;
        return ()=>{
            l.info("Unmounting Grid component. Clearing all events listeners."), e.emit(ne.unmount), e.removeAllListeners();
        };
    }, [
        l,
        t
    ]), _r(t, {
        subscribeEvent: o,
        publishEvent: n,
        showError: a
    }, "GridCoreApi");
}
const mi = (t)=>{
    const r = Ar("useGridContainerProps"), [l, n, o] = rl(t), a = $7fPBF.useRef({
        width: 0,
        height: 0
    }), i = ll(t, il), s = ll(t, Bl), c = ll(t, be), u = ll(t, Pl), d = ll(t, fn), p = t.current.windowRef, m = $7fPBF.useCallback(()=>{
        if (r.debug("Calculating virtual row count."), i.pagination && (!i.autoPageSize || i.pageSize)) {
            const e = u - d.page * d.pageSize;
            return e > d.pageSize ? d.pageSize : e;
        }
        return u;
    }, [
        r,
        i.autoPageSize,
        i.pagination,
        i.pageSize,
        d.page,
        d.pageSize,
        u
    ]), f = $7fPBF.useCallback((e)=>{
        r.debug("Calculating scrollbar sizes.");
        let t = c > a.current.width;
        const l = {
            y: 0,
            x: t ? i.scrollbarSize : 0
        };
        if (0 === e) return {
            hasScrollX: t,
            hasScrollY: !1,
            scrollBarSize: l
        };
        const n = e * s, o = !i.autoPageSize && !i.autoHeight && n + l.x > a.current.height;
        return l.y = o ? i.scrollbarSize : 0, t = c + l.y > a.current.width, l.x = t ? i.scrollbarSize : 0, r.debug(`Scrollbar size on axis x: ${l.x}, y: ${l.y}`), {
            hasScrollX: t,
            hasScrollY: o,
            scrollBarSize: l
        };
    }, [
        r,
        c,
        i.autoPageSize,
        i.autoHeight,
        s,
        i.scrollbarSize
    ]), g = $7fPBF.useCallback((e, t)=>{
        if (!(null == p ? void 0 : p.current)) return null;
        r.debug("Calculating container sizes.");
        const l = p.current.getBoundingClientRect();
        a.current = {
            width: l.width,
            height: l.height
        }, r.debug(`window Size - W: ${a.current.width} H: ${a.current.height} `);
        return {
            width: a.current.width - t.scrollBarSize.y,
            height: i.autoHeight ? e * s : a.current.height - t.scrollBarSize.x
        };
    }, [
        r,
        i.autoHeight,
        s,
        p
    ]), b = $7fPBF.useCallback((e, t, l)=>{
        if (!p || !p.current || 0 === c || Number.isNaN(c)) return null;
        const n = e * s - a.current.height > 2 * s;
        if (i.autoPageSize || i.autoHeight || !n) {
            const n = Math.floor(t.height / s), o = l.hasScrollY || e < n ? e : n, u = Math.max(o * s + (i.autoHeight ? l.scrollBarSize.x : 0), 1), d = {
                isVirtualized: !1,
                virtualRowsCount: o,
                renderingZonePageSize: o,
                viewportPageSize: o,
                totalSizes: {
                    width: c,
                    height: u
                },
                dataContainerSizes: {
                    width: c,
                    height: u
                },
                renderingZoneScrollHeight: u - t.height,
                renderingZone: {
                    width: c,
                    height: u
                },
                windowSizes: a.current,
                lastPage: 1
            };
            return r.debug("Fixed container props", d), d;
        }
        const o = Math.floor(t.height / s), u = o > 0 ? Math.ceil(e / o) - 1 : 0, d = 2 * o, m = d * s, f = m - t.height;
        let g = u * f + t.height;
        const b = e % o;
        b > 0 && (g = g - f + b * s);
        const h = {
            isVirtualized: n,
            virtualRowsCount: e,
            viewportPageSize: o,
            totalSizes: {
                width: c,
                height: g
            },
            dataContainerSizes: {
                width: c,
                height: g
            },
            renderingZonePageSize: d,
            renderingZone: {
                width: c,
                height: m
            },
            renderingZoneScrollHeight: f,
            windowSizes: a.current,
            lastPage: u
        };
        return r.debug("virtualized container props", h), h;
    }, [
        p,
        c,
        s,
        i.autoPageSize,
        i.autoHeight,
        r
    ]), h = $7fPBF.useCallback((e, t)=>{
        let r = !1;
        n((l)=>(r = e(l), r ? t(l) : l)), r && o();
    }, [
        o,
        n
    ]), v = $7fPBF.useCallback(()=>{
        r.debug("Refreshing container sizes");
        const e = m(), t = f(e), l = g(e, t);
        if (!l) return;
        h((e)=>e.scrollBar !== t, (e)=>Object.assign(Object.assign({}, e), {
                scrollBar: t
            })), h((e)=>e.viewportSizes !== l, (e)=>Object.assign(Object.assign({}, e), {
                viewportSizes: l
            }));
        const n = b(e, l, t);
        h((e)=>!br(e.containerSizes, n), (e)=>Object.assign(Object.assign({}, e), {
                containerSizes: n
            }));
    }, [
        b,
        f,
        g,
        m,
        r,
        h
    ]);
    $7fPBF.useEffect(()=>{
        v();
    }, [
        l.columns,
        l.options.hideFooter,
        v,
        u
    ]), cl(t, ne.debouncedResize, v);
}, fi = (t, r, l, n, o)=>{
    const a = Ar("useNativeEventListener"), [i, s] = $7fPBF.useState(!1), c = $7fPBF.useRef(n), u = $7fPBF.useCallback((e)=>c.current && c.current(e), []);
    $7fPBF.useEffect(()=>{
        c.current = n;
    }, [
        n
    ]), $7fPBF.useEffect(()=>{
        let e;
        if (e = yr(r) ? r() : r && r.current ? r.current : null, e && u && l && !i) {
            a.debug(`Binding native ${l} event`), e.addEventListener(l, u, o);
            const r = e;
            s(!0);
            const n = ()=>{
                a.debug(`Clearing native ${l} event`), r.removeEventListener(l, u, o);
            };
            t.current.subscribeEvent(ne.unmount, n);
        }
    }, [
        r,
        u,
        l,
        i,
        a,
        o,
        t
    ]);
}, gi = (t)=>{
    const r = Ar("useGridColumnMenu"), [l, n, o] = rl(t), a = $7fPBF.useCallback((e)=>{
        r.debug("Opening Column Menu"), n((t)=>Object.assign(Object.assign({}, t), {
                columnMenu: {
                    open: !0,
                    field: e
                }
            })), t.current.hidePreferences(), o();
    }, [
        t,
        o,
        r,
        n
    ]), i = $7fPBF.useCallback(()=>{
        r.debug("Hiding Column Menu"), n((e)=>Object.assign(Object.assign({}, e), {
                columnMenu: Object.assign(Object.assign({}, e.columnMenu), {
                    open: !1,
                    field: void 0
                })
            })), o();
    }, [
        o,
        r,
        n
    ]), s = $7fPBF.useCallback((e)=>{
        r.debug("Toggle Column Menu"), l.columnMenu.open && l.columnMenu.field === e ? i() : a(e);
    }, [
        r,
        a,
        i,
        l
    ]), c = $7fPBF.useCallback(()=>{
        n((e)=>e.columnMenu.open ? Object.assign(Object.assign({}, e), {
                columnMenu: Object.assign(Object.assign({}, e.columnMenu), {
                    open: !1
                })
            }) : e);
    }, [
        n
    ]);
    $7fPBF.useEffect(()=>{
        l.isScrolling && i();
    }, [
        l.isScrolling,
        i
    ]), _r(t, {
        showColumnMenu: a,
        hideColumnMenu: i,
        toggleColumnMenu: s
    }, "ColumnMenuApi"), cl(t, ne.columnResizeStart, c);
}, bi = (t, r)=>{
    const l = Ar("useGridColumnReorder"), [, n, o] = rl(t), a = ll(t, fl), i = $7fPBF.useRef(null), s = $7fPBF.useRef({
        x: 0,
        y: 0
    }), c = $7fPBF.useRef(null), u = $7fPBF.useRef();
    $7fPBF.useEffect(()=>()=>{
            clearTimeout(u.current);
        }, []);
    const d = $7fPBF.useCallback((e, a)=>{
        r.disableColumnReorder || e.colDef.disableReorder || (l.debug(`Start dragging col ${e.field}`), i.current = a.currentTarget, i.current.classList.add("MuiDataGrid-columnHeader--dragging"), n((t)=>Object.assign(Object.assign({}, t), {
                columnReorder: Object.assign(Object.assign({}, t.columnReorder), {
                    dragCol: e.field
                })
            })), o(), u.current = setTimeout(()=>{
            i.current.classList.remove("MuiDataGrid-columnHeader--dragging");
        }), c.current = t.current.getColumnIndex(e.field, !1));
    }, [
        r.disableColumnReorder,
        l,
        n,
        o,
        t
    ]), p = $7fPBF.useCallback((e, t)=>{
        t.preventDefault();
    }, []), m = $7fPBF.useCallback((e, r)=>{
        if (!a) return;
        l.debug(`Dragging over col ${e.field}`), r.preventDefault();
        const n = {
            x: r.clientX,
            y: r.clientY
        };
        if (e.field !== a && (o = s.current, i = n, o.x !== i.x || o.y !== i.y)) {
            const r = t.current.getColumnIndex(e.field, !1), l = t.current.getColumnIndex(e.field, !0), o = t.current.getColumn(e.field), i = t.current.getColumnIndex(a, !1), c = t.current.getVisibleColumns().length, u = !o.disableReorder || l > 0 && l < c - 1, d = ((e, t)=>e.x <= t.x ? "right" : "left")(s.current, n), p = "left" === d && r < i, m = "right" === d && i < r;
            u && (p || m) && t.current.setColumnIndex(a, r), s.current = n;
        }
        var o, i;
    }, [
        t,
        a,
        l
    ]), f = $7fPBF.useCallback((e, s)=>{
        !r.disableColumnReorder && a && (l.debug("End dragging col"), s.preventDefault(), clearTimeout(u.current), i.current = null, "none" === s.dataTransfer.dropEffect && (t.current.setColumnIndex(e.field, c.current), c.current = null), n((e)=>Object.assign(Object.assign({}, e), {
                columnReorder: Object.assign(Object.assign({}, e.columnReorder), {
                    dragCol: ""
                })
            })), o());
    }, [
        r.disableColumnReorder,
        l,
        n,
        o,
        t,
        a
    ]);
    cl(t, ne.columnHeaderDragStart, d), cl(t, ne.columnHeaderDragEnter, p), cl(t, ne.columnHeaderDragOver, m), cl(t, ne.columnHeaderDragEnd, f), cl(t, ne.cellDragEnter, p), cl(t, ne.cellDragOver, m), cl(t, ne.cellDragEnd, f);
};
function hi(e, t) {
    t = function(e) {
        const t = Object.assign({}, e);
        return Object.keys(e).forEach((r)=>{
            e.hasOwnProperty(r) && void 0 === e[r] && delete t[r];
        }), t;
    }(t);
    return Object.assign(Object.assign({}, e), t);
}
function vi(e, t = {}, r, l, n) {
    l.debug("Hydrating GridColumns with default definitions");
    const o = function(e, t) {
        const r = Object.assign(Object.assign({}, e), t), l = {};
        return Object.entries(r).forEach(([e, t])=>{
            t = Object.assign(Object.assign({}, r[t.extendType || "__default__"]), t), l[e] = t;
        }), l;
    }(yo(), t), a = e.map((e)=>Object.assign(Object.assign({}, Eo(o, e.type)), e));
    if (r) {
        const e = Object.assign({}, lo);
        return e.headerName = n("checkboxSelectionHeaderName"), [
            e,
            ...a
        ];
    }
    return a;
}
function Ci(e, t) {
    return e.debug("Building columns lookup"), t.reduce((e, t)=>(e[t.field] = t, e), {});
}
const wi = (e, t)=>{
    var r, l;
    const n = {
        all: [
            ...null !== (r = null == t ? void 0 : t.all) && void 0 !== r ? r : []
        ],
        lookup: Object.assign({}, null !== (l = null == t ? void 0 : t.lookup) && void 0 !== l ? l : {})
    };
    return e.forEach((e)=>{
        null == n.lookup[e.field] ? (n.lookup[e.field] = e, n.all.push(e.field)) : n.lookup[e.field] = Object.assign(Object.assign({}, n.lookup[e.field]), e);
    }), n;
};
function Oi(t, r) {
    const l = Ar("useGridColumns"), [n, o, a] = rl(t), i = ll(t, pe), s = ll(t, ue), c = ll(t, de), u = $7fPBF.useCallback((e, r = !0)=>{
        l.debug("Updating columns state."), o((t)=>Object.assign(Object.assign({}, t), {
                columns: e
            })), a(), t.current && r && t.current.publishEvent(ne.columnsChange, e.all);
    }, [
        l,
        o,
        a,
        t
    ]), d = $7fPBF.useCallback((e)=>t.current.state.columns.lookup[e], [
        t
    ]), p = $7fPBF.useCallback(()=>s, [
        s
    ]), m = $7fPBF.useCallback(()=>c, [
        c
    ]), f = $7fPBF.useCallback(()=>i, [
        i
    ]), g = $7fPBF.useCallback((e, t = !0)=>t ? c.findIndex((t)=>t.field === e) : s.findIndex((t)=>t.field === e), [
        s,
        c
    ]), b = $7fPBF.useCallback((e)=>{
        const t = g(e);
        return i.positions[t];
    }, [
        i.positions,
        g
    ]), h = $7fPBF.useCallback((e, r)=>{
        l.debug("updating GridColumns with new state");
        const n = t.current.state, o = function(e, t) {
            var r, l;
            let n = 0, o = t;
            const a = [];
            for(let t = 0; t < e.length; t += 1){
                const i = Object.assign({}, e[t]);
                if (i.hide) i.computedWidth = 0;
                else {
                    const e = null !== (r = i.minWidth) && void 0 !== r ? r : Jn.minWidth;
                    if (i.flex && i.flex > 0) n += i.flex, i.computedWidth = e;
                    else {
                        const t = Math.max(null !== (l = i.width) && void 0 !== l ? l : Jn.width, e);
                        i.computedWidth = t, o -= t;
                    }
                }
                a.push(i);
            }
            if (n && o > 0) {
                const e = n > 0 ? o / n : 0;
                for(let t = 0; t < a.length; t += 1){
                    const r = a[t];
                    !r.hide && r.flex && r.flex > 0 && (a[t].computedWidth = Math.max(e * r.flex, r.computedWidth));
                }
            }
            return a;
        }(e.all.map((t)=>e.lookup[t]), n.viewportSizes.width), a = {
            all: o.map((e)=>e.field),
            lookup: Ci(l, o)
        };
        u(a, r);
    }, [
        t,
        l,
        u
    ]), v = $7fPBF.useCallback((e)=>{
        const r = wi(e, t.current.state.columns);
        h(r, !1);
    }, [
        t,
        h
    ]), C = $7fPBF.useCallback((e)=>v([
            e
        ]), [
        v
    ]), w = $7fPBF.useCallback((e, r)=>{
        const l = d(e), n = Object.assign(Object.assign({}, l), {
            hide: !r
        });
        v([
            n
        ]), a(), t.current.publishEvent(ne.columnVisibilityChange, {
            field: e,
            colDef: n,
            api: t,
            isVisible: r
        });
    }, [
        t,
        a,
        d,
        v
    ]), O = $7fPBF.useCallback((e, r)=>{
        const o = n.columns.all.findIndex((t)=>t === e);
        if (o === r) return;
        l.debug(`Moving column ${e} to index ${r}`);
        const a = {
            field: e,
            element: t.current.getColumnHeaderElement(e),
            colDef: t.current.getColumn(e),
            targetIndex: r,
            oldIndex: o,
            api: t.current
        };
        t.current.publishEvent(ne.columnOrderChange, a);
        const i = [
            ...n.columns.all
        ];
        i.splice(r, 0, i.splice(o, 1)[0]), u(Object.assign(Object.assign({}, n.columns), {
            all: i
        }));
    }, [
        t,
        n.columns,
        l,
        u
    ]), y = $7fPBF.useCallback((e, r)=>{
        l.debug(`Updating column ${e} width to ${r}`);
        const n = t.current.getColumn(e);
        t.current.updateColumn(Object.assign(Object.assign({}, n), {
            width: r
        })), t.current.publishEvent(ne.columnWidthChange, {
            element: t.current.getColumnHeaderElement(e),
            colDef: n,
            api: t,
            width: r
        });
    }, [
        t,
        l
    ]);
    _r(t, {
        getColumn: d,
        getAllColumns: p,
        getColumnIndex: g,
        getColumnPosition: b,
        getVisibleColumns: m,
        getColumnsMeta: f,
        updateColumn: C,
        updateColumns: v,
        setColumnVisibility: w,
        setColumnIndex: O,
        setColumnWidth: y
    }, "ColApi"), $7fPBF.useEffect(()=>{
        if (l.info(`GridColumns have changed, new length ${r.columns.length}`), r.columns.length > 0) {
            const e = vi(r.columns, r.columnTypes, !!r.checkboxSelection, l, t.current.getLocaleText), n = wi(e);
            h(n);
        } else u({
            all: [],
            lookup: {}
        });
    }, [
        l,
        t,
        r.columns,
        r.columnTypes,
        r.checkboxSelection,
        u,
        h
    ]), $7fPBF.useEffect(()=>{
        l.debug(`GridColumns gridState.viewportSizes.width, changed ${n.viewportSizes.width}`);
        const e = ue(t.current.state);
        t.current.updateColumns(e);
    }, [
        t,
        n.viewportSizes.width,
        l
    ]), dl(t, ne.columnVisibilityChange, r.onColumnVisibilityChange);
}
function yi(e, r) {
    const l = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({}), n = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((e)=>{
        const { stateId: t, stateSelector: r } = e, n = On(e, [
            "stateId",
            "stateSelector"
        ]);
        l.current[t] = Object.assign(Object.assign({}, n), {
            stateId: t,
            stateSelector: r || ((e)=>e[t])
        });
    }, []), o = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((t)=>{
        let n = !1;
        const o = [], a = l.current;
        if (Object.keys(a).forEach((r)=>{
            const l = a[r], i = l.stateSelector(e.current.state), s = l.stateSelector(t);
            s !== i && s !== l.propModel && o.push(l.stateId), void 0 !== l.propModel && s !== l.propModel && (n = !0);
        }), o.length > 1) throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${o[0]}, therefore, you're not allowed to update ${o.join(", ")} in the same transaction.`);
        return {
            ignoreSetState: n,
            postUpdate: ()=>{
                o.forEach((l)=>{
                    const n = a[l], o = a[l].stateSelector(t);
                    if (n.propOnChange) {
                        const t = r.signature === sl.XGrid ? {
                            api: e.current
                        } : {};
                        n.propOnChange(o, t);
                    }
                    e.current.publishEvent(n.changeEvent, o);
                });
            }
        };
    }, [
        e,
        r.signature
    ]);
    _r(e, {
        updateControlState: n,
        applyControlStateConstraint: o
    }, "controlStateApi");
}
const Ei = (t, r, l, n)=>{
    const o = tl(t), [a, i, s] = rl(t), c = $7fPBF.useCallback((e)=>{
        void 0 === a[r] && (a[r] = n), i((t)=>{
            const n = Object.assign({}, t);
            return n[r] = l(t[r], e), n;
        }), s();
    }, [
        s,
        a,
        n,
        l,
        i,
        r
    ]), u = $7fPBF.useRef(c);
    $7fPBF.useEffect(()=>{
        u.current = c;
    }, [
        c
    ]);
    const d = $7fPBF.useCallback((e)=>u.current(e), []);
    return {
        gridState: a,
        dispatch: d,
        gridApi: o
    };
}, Si = (t, r)=>{
    const l = Ar("useGridFilter"), [n, o, a] = rl(t), i = ll(t, fe), s = $7fPBF.useCallback(()=>{
        l.debug("clearing filtered rows"), o((e)=>Object.assign(Object.assign({}, e), {
                visibleRows: {
                    visibleRowsLookup: {}
                }
            }));
    }, [
        l,
        o
    ]), c = $7fPBF.useCallback((e, r = Zr.And)=>{
        if (!e.columnField || !e.operatorValue) return;
        const n = t.current.getColumn(e.columnField);
        if (!n) return;
        const i = n.valueParser ? n.valueParser(e.value) : e.value, s = Object.assign(Object.assign({}, e), {
            value: i
        });
        l.debug(`Filtering column: ${s.columnField} ${s.operatorValue} ${s.value} `);
        const c = n.filterOperators;
        if (!(null == c ? void 0 : c.length)) throw new Error(`Material-UI: No filter operators found for column '${n.field}'.`);
        const u = c.find((e)=>e.value === s.operatorValue);
        if (!u) throw new Error(`Material-UI: No filter operator found for column '${n.field}' and operator value '${s.operatorValue}'.`);
        const d = u.getApplyFilterFn(s, n);
        "function" == typeof d && (o((e)=>{
            const l = Object.assign({}, e.visibleRows.visibleRowsLookup);
            return Sl(e).forEach((e, n)=>{
                const o = t.current.getCellParams(n, s.columnField), a = d(o);
                null == l[n] ? l[n] = a : l[n] = r === Zr.And ? l[n] && a : l[n] || a;
            }), Object.assign(Object.assign({}, e), {
                visibleRows: Object.assign(Object.assign({}, e.visibleRows), {
                    visibleRowsLookup: l,
                    visibleRows: Object.entries(l).filter(([, e])=>e).map(([e])=>e)
                })
            });
        }), a());
    }, [
        t,
        a,
        l,
        o
    ]), u = $7fPBF.useCallback(()=>{
        if (r.filterMode === Vr.server) return void a();
        s();
        const { items: e, linkOperator: l } = t.current.state.filter;
        e.forEach((e)=>{
            t.current.applyFilter(e, l);
        }), a();
    }, [
        t,
        s,
        a,
        r.filterMode
    ]), d = $7fPBF.useCallback((e)=>{
        l.debug("Upserting filter"), o((l)=>{
            const n = [
                ...l.filter.items
            ], o = Object.assign({}, e), a = n.findIndex((e)=>e.id === o.id);
            if (1 === n.length && br(n[0], {}) ? n[0] = o : -1 === a ? n.push(o) : n[a] = o, null == o.id && (o.id = Math.round(1e5 * Math.random())), null == o.columnField && (o.columnField = i[0]), null != o.columnField && null == o.operatorValue) {
                const e = t.current.getColumn(o.columnField);
                o.operatorValue = e && e.filterOperators[0].value;
            }
            r.disableMultipleColumnsFiltering && n.length > 1 && (n.length = 1);
            return Object.assign(Object.assign({}, l), {
                filter: Object.assign(Object.assign({}, l.filter), {
                    items: n
                })
            });
        }), u();
    }, [
        l,
        o,
        t,
        u,
        r.disableMultipleColumnsFiltering,
        i
    ]), p = $7fPBF.useCallback((e)=>{
        l.debug(`Deleting filter on column ${e.columnField} with value ${e.value}`), o((t)=>{
            const r = [
                ...t.filter.items.filter((t)=>t.id !== e.id)
            ];
            return Object.assign(Object.assign({}, t), {
                filter: Object.assign(Object.assign({}, t.filter), {
                    items: r
                })
            });
        }), 0 === t.current.state.filter.items.length && t.current.upsertFilter({}), u();
    }, [
        t,
        u,
        l,
        o
    ]), m = $7fPBF.useCallback((e)=>{
        if (l.debug("Displaying filter panel"), e) {
            const r = n.filter.items.length > 0 ? n.filter.items[n.filter.items.length - 1] : null;
            r && r.columnField === e || t.current.upsertFilter({
                columnField: e
            });
        }
        t.current.showPreferences(Vo.filters);
    }, [
        t,
        n.filter.items,
        l
    ]), f = $7fPBF.useCallback(()=>{
        l.debug("Hiding filter panel"), null == t || t.current.hidePreferences();
    }, [
        t,
        l
    ]), g = $7fPBF.useCallback((e = Zr.And)=>{
        l.debug("Applying filter link operator"), o((t)=>Object.assign(Object.assign({}, t), {
                filter: Object.assign(Object.assign({}, t.filter), {
                    linkOperator: e
                })
            })), u();
    }, [
        u,
        l,
        o
    ]), b = $7fPBF.useCallback(()=>{
        s(), l.debug("Clearing filter model"), o((e)=>Object.assign(Object.assign({}, e), {
                filter: Xr()
            }));
    }, [
        s,
        l,
        o
    ]), h = $7fPBF.useCallback((e)=>{
        b(), l.debug("Setting filter model"), g(e.linkOperator), e.items.forEach((e)=>d(e));
    }, [
        g,
        b,
        l,
        d
    ]), v = $7fPBF.useCallback(()=>Dl(t.current.state), [
        t
    ]);
    _r(t, {
        applyFilterLinkOperator: g,
        applyFilters: u,
        applyFilter: c,
        deleteFilter: p,
        upsertFilter: d,
        setFilterModel: h,
        showFilterPanel: m,
        hideFilterPanel: f,
        getVisibleRowModels: v
    }, "FilterApi"), $7fPBF.useEffect(()=>{
        t.current && (l.debug("Rows prop changed, applying filters"), s(), t.current.applyFilters());
    }, [
        t,
        s,
        l,
        r.rows
    ]);
    const C = $7fPBF.useCallback(()=>{
        l.debug("onColUpdated - GridColumns changed, applying filters");
        const e = t.current.state.filter, r = fe(t.current.state);
        l.debug("GridColumns changed, applying filters"), e.items.forEach((e)=>{
            r.find((t)=>t === e.columnField) || t.current.deleteFilter(e);
        }), t.current.applyFilters();
    }, [
        t,
        l
    ]);
    $7fPBF.useEffect(()=>{
        t.current.updateControlState({
            stateId: "filter",
            propModel: r.filterModel,
            propOnChange: r.onFilterModelChange,
            stateSelector: (e)=>e.filter,
            changeEvent: ne.filterModelChange
        });
    }, [
        t,
        r.filterModel,
        r.onFilterModelChange
    ]), $7fPBF.useEffect(()=>{
        if (void 0 !== r.filterModel && r.filterModel.items.length > 1) {
            if (r.filterModel.items.find((e)=>null == e.id)) throw new Error("The 'id' field is required on filterModel.items when you use multiple filters.");
        }
        const e = t.current.state.filter;
        void 0 !== r.filterModel && r.filterModel !== e && (l.debug("filterModel prop changed, applying filters"), o((e)=>Object.assign(Object.assign({}, e), {
                filter: r.filterModel || Xr()
            })), t.current.applyFilters());
    }, [
        t,
        l,
        r.filterModel,
        o
    ]), cl(t, ne.rowsSet, t.current.applyFilters), cl(t, ne.rowsUpdate, t.current.applyFilters), cl(t, ne.columnsChange, C);
}, Mi = (t, r)=>{
    const l = Ar("useGridFocus"), [, n, o] = rl(t), a = $7fPBF.useRef(null), i = $7fPBF.useCallback((e, t)=>{
        n((r)=>(l.debug(`Focusing on cell with id=${e} and field=${t}`), Object.assign(Object.assign({}, r), {
                tabIndex: {
                    cell: {
                        id: e,
                        field: t
                    },
                    columnHeader: null
                },
                focus: {
                    cell: {
                        id: e,
                        field: t
                    },
                    columnHeader: null
                }
            }))), o();
    }, [
        o,
        l,
        n
    ]), s = $7fPBF.useCallback((e, r)=>{
        const { cell: a } = t.current.state.focus;
        a && t.current.publishEvent(ne.cellFocusOut, t.current.getCellParams(a.id, a.field), r), n((t)=>(l.debug(`Focusing on column header with colIndex=${e}`), Object.assign(Object.assign({}, t), {
                tabIndex: {
                    columnHeader: {
                        field: e
                    },
                    cell: null
                },
                focus: {
                    columnHeader: {
                        field: e
                    },
                    cell: null
                }
            }))), o();
    }, [
        t,
        o,
        l,
        n
    ]), c = $7fPBF.useCallback(({ id: e, field: r })=>{
        t.current.setCellFocus(e, r);
    }, [
        t
    ]), u = $7fPBF.useCallback((e, r)=>{
        "Enter" === r.key || "Tab" === r.key || an(r.key) || t.current.setCellFocus(e.id, e.field);
    }, [
        t
    ]), d = $7fPBF.useCallback(({ field: e }, r)=>{
        r.target === r.currentTarget && t.current.setColumnHeaderFocus(e, r);
    }, [
        t
    ]), p = $7fPBF.useCallback(()=>{
        l.debug("Clearing focus"), n((e)=>Object.assign(Object.assign({}, e), {
                focus: {
                    cell: null,
                    columnHeader: null
                }
            }));
    }, [
        l,
        n
    ]), m = $7fPBF.useCallback((e)=>{
        a.current = e;
    }, []), g = $7fPBF.useCallback((e)=>{
        const r = a.current;
        a.current = null;
        const { cell: l } = t.current.state.focus;
        if (!l) return void (r && t.current.setCellFocus(r.id, r.field));
        if ((null == r ? void 0 : r.id) === l.id && (null == r ? void 0 : r.field) === l.field) return;
        const i = t.current.getCellElement(l.id, l.field);
        (null == i ? void 0 : i.contains(e.target)) || (t.current.publishEvent(ne.cellFocusOut, t.current.getCellParams(l.id, l.field), e), r ? t.current.setCellFocus(r.id, r.field) : (n((e)=>Object.assign(Object.assign({}, e), {
                focus: {
                    cell: null,
                    columnHeader: null
                }
            })), o()));
    }, [
        t,
        o,
        n
    ]), b = $7fPBF.useCallback((e)=>{
        if ("view" === e.cellMode) return;
        const { cell: r } = t.current.state.focus;
        (null == r ? void 0 : r.id) === e.id && (null == r ? void 0 : r.field) === e.field || t.current.setCellFocus(e.id, e.field);
    }, [
        t
    ]);
    _r(t, {
        setCellFocus: i,
        setColumnHeaderFocus: s
    }, "GridFocusApi"), $7fPBF.useEffect(()=>{
        const { cell: e } = t.current.state.focus;
        if (e) t.current.getRow(e.id) || n((e)=>Object.assign(Object.assign({}, e), {
                focus: {
                    cell: null,
                    columnHeader: null
                }
            }));
    }, [
        t,
        n,
        r.rows
    ]), $7fPBF.useEffect(()=>{
        const e = (0, $g3iV0.default)(t.current.rootElementRef.current);
        return e.addEventListener("click", g), ()=>{
            e.removeEventListener("click", g);
        };
    }, [
        t,
        g
    ]), cl(t, ne.columnHeaderBlur, p), cl(t, ne.cellDoubleClick, c), cl(t, ne.cellMouseUp, m), cl(t, ne.cellKeyDown, u), cl(t, ne.cellModeChange, b), cl(t, ne.columnHeaderFocus, d);
}, xi = (t)=>{
    const r = Ar("useGridKeyboard"), l = $7fPBF.useCallback((e, l)=>{
        const n = Io(l.target, "MuiDataGrid-row"), o = Number(n.getAttribute("data-rowindex"));
        let a = o;
        const i = [
            ...t.current.getSelectedRows().keys()
        ];
        if (i.length > 0) {
            const e = i.map((e)=>t.current.getRowIndex(e)), r = e.map((e)=>Math.abs(o - e)), l = Math.max(...r);
            a = e[r.indexOf(l)];
        }
        t.current.publishEvent(ne.cellNavigationKeyDown, e, l);
        const s = t.current.state.focus.cell, c = t.current.getRowIndex(s.id), u = Array(Math.abs(c - a) + 1).fill(c > a ? a : c);
        r.debug("Selecting rows "), t.current.selectRows(u, !0, !0);
    }, [
        r,
        t
    ]), n = $7fPBF.useCallback((e, r)=>{
        if (1 === r.target.nodeType && (null == (n = r.target) || !n.classList.contains("MuiDataGrid-cell"))) return;
        var n;
        const o = t.current.getCellParams(e.id, e.field);
        if (!("edit" === o.cellMode)) {
            if (ql(r.key) && r.shiftKey) return r.preventDefault(), void t.current.selectRow(o.id);
            if (!an(r.key) || r.shiftKey) return an(r.key) && r.shiftKey ? (r.preventDefault(), void l(o, r)) : void ("c" === r.key.toLowerCase() && (r.ctrlKey || r.metaKey) || "a" === r.key.toLowerCase() && (r.ctrlKey || r.metaKey) && (r.preventDefault(), t.current.selectRows(t.current.getAllRowIds(), !0)));
            t.current.publishEvent(ne.cellNavigationKeyDown, o, r);
        }
    }, [
        t,
        l
    ]), o = $7fPBF.useCallback((e, r)=>{
        Po(r.target) && (ql(r.key) && Po(r.target) && r.preventDefault(), !an(r.key) || ql(r.key) || r.shiftKey ? Zl(r.key) && (r.ctrlKey || r.metaKey) && t.current.toggleColumnMenu(e.field) : t.current.publishEvent(ne.cellNavigationKeyDown, e, r));
    }, [
        t
    ]);
    cl(t, ne.cellKeyDown, n), cl(t, ne.columnHeaderKeyDown, o);
}, ki = (t, r)=>{
    const l = Ar("useGridKeyboardNavigation"), n = ll(t, fn), o = ll(t, vl), a = ll(t, ge), i = ll(t, Yo), s = (e)=>Zl(e.key) ? "ArrowDown" : Xl(e.key) ? e.shiftKey ? "ArrowLeft" : "ArrowRight" : e.key, c = $7fPBF.useCallback((e, c)=>{
        c.preventDefault();
        const u = t.current.getColumnIndex(e.field), d = t.current.getRowIndex(e.id), p = s(c), m = c.ctrlKey || c.metaKey || c.shiftKey;
        let f, g = o;
        if (r.pagination && o > n.pageSize && (g = n.pageSize * (n.page + 1)), Yl(p)) f = ((e, t)=>{
            if (!Yl(e)) throw new Error("Material-UI: The first argument (key) should be an arrow key code.");
            switch(e){
                case "ArrowLeft":
                    return Object.assign(Object.assign({}, t), {
                        colIndex: t.colIndex - 1
                    });
                case "ArrowRight":
                    return Object.assign(Object.assign({}, t), {
                        colIndex: t.colIndex + 1
                    });
                case "ArrowUp":
                    return Object.assign(Object.assign({}, t), {
                        rowIndex: t.rowIndex - 1
                    });
                default:
                    return Object.assign(Object.assign({}, t), {
                        rowIndex: t.rowIndex + 1
                    });
            }
        })(p, {
            colIndex: u,
            rowIndex: d
        });
        else if (Jl(p)) {
            const e = "Home" === p ? 0 : a - 1;
            if (m) {
                let t = 0;
                t = 0 === e ? r.pagination ? g - n.pageSize : 0 : g - 1, f = {
                    colIndex: e,
                    rowIndex: t
                };
            } else f = {
                colIndex: e,
                rowIndex: d
            };
        } else {
            if (!Ql(p) && !ql(p)) throw new Error("Material-UI. Key not mapped to navigation behavior.");
            f = {
                colIndex: u,
                rowIndex: d + (p.indexOf("Down") > -1 || ql(p) ? i.viewportPageSize : -1 * i.viewportPageSize)
            };
        }
        if (f.rowIndex < 0) {
            const e = t.current.getVisibleColumns()[f.colIndex].field;
            return void t.current.setColumnHeaderFocus(e, c);
        }
        f.rowIndex = f.rowIndex >= g && g > 0 ? g - 1 : f.rowIndex, f.colIndex = f.colIndex <= 0 ? 0 : f.colIndex, f.colIndex = f.colIndex >= a ? a - 1 : f.colIndex, l.debug(`Navigating to next cell row ${f.rowIndex}, col ${f.colIndex}`), t.current.scrollToIndexes(f);
        const b = t.current.getVisibleColumns()[f.colIndex].field, h = t.current.getRowIdFromRowIndex(f.rowIndex);
        t.current.setCellFocus(h, b);
    }, [
        o,
        r.pagination,
        n.pageSize,
        n.page,
        a,
        l,
        t,
        i
    ]), u = $7fPBF.useCallback((e, r)=>{
        let n;
        r.preventDefault();
        const o = t.current.getColumnIndex(e.field), c = s(r);
        if (Yl(c)) n = ((e, t)=>{
            if (!Yl(e)) throw new Error("Material-UI: The first argument (key) should be an arrow key code.");
            switch(e){
                case "ArrowLeft":
                    return {
                        colIndex: t.colIndex - 1
                    };
                case "ArrowRight":
                    return {
                        colIndex: t.colIndex + 1
                    };
                case "ArrowDown":
                    return null;
                default:
                    return Object.assign({}, t);
            }
        })(c, {
            colIndex: o
        });
        else {
            if (!Jl(c)) {
                if (Ql(c)) {
                    if (c.indexOf("Down") > -1) {
                        const e = t.current.getVisibleColumns()[o].field, r = t.current.getRowIdFromRowIndex(i.viewportPageSize - 1);
                        t.current.setCellFocus(r, e);
                    }
                    return;
                }
                throw new Error("Material-UI. Key not mapped to navigation behavior.");
            }
            n = {
                colIndex: "Home" === c ? 0 : a - 1
            };
        }
        if (!n) {
            const e = t.current.getVisibleColumns()[o].field, r = t.current.getRowIdFromRowIndex(0);
            return void t.current.setCellFocus(r, e);
        }
        n.colIndex = Math.max(0, n.colIndex), n.colIndex = n.colIndex >= a ? a - 1 : n.colIndex, l.debug(`Navigating to next column row ${n.colIndex}`), t.current.scrollToIndexes(n);
        const u = t.current.getVisibleColumns()[n.colIndex].field;
        t.current.setColumnHeaderFocus(u, r);
    }, [
        t,
        a,
        i,
        l
    ]);
    cl(t, ne.cellNavigationKeyDown, c), cl(t, ne.columnHeaderNavigationKeyDown, u);
};
function Di(t, r) {
    const l = Ar("useGridScrollFn"), n = $7fPBF.useRef();
    return [
        $7fPBF.useCallback((e)=>{
            var o;
            e.left === (null === (o = n.current) || void 0 === o ? void 0 : o.left) && e.top === n.current.top || t && t.current && (l.debug(`Moving ${t.current.className} to: ${e.left}-${e.top}`), t.current.style.transform = `translate3d(-${e.left}px, -${e.top}px, 0)`, r.current.style.transform = `translate3d(-${e.left}px, 0, 0)`, n.current = e);
        }, [
            t,
            l,
            r
        ])
    ];
}
const Ri = (e, t)=>t > 0 && e > 0 ? Math.ceil(e / t) : 0, Ii = (e)=>e.pageCount ? Object.assign(Object.assign({}, e), {
        page: Math.max(Math.min(e.page, e.pageCount - 1), 0)
    }) : e, Pi = (t, r)=>{
    const l = Ar("useGridPage"), [, n, o] = rl(t), a = ll(t, Pl), i = $7fPBF.useCallback((e)=>{
        l.debug(`Setting page to ${e}`), n((t)=>Object.assign(Object.assign({}, t), {
                pagination: Ii(Object.assign(Object.assign({}, t.pagination), {
                    page: e
                }))
            })), o();
    }, [
        n,
        o,
        l
    ]);
    $7fPBF.useEffect(()=>{
        t.current.updateControlState({
            stateId: "page",
            propModel: r.page,
            propOnChange: r.onPageChange,
            stateSelector: (e)=>e.pagination.page,
            changeEvent: ne.pageChange
        });
    }, [
        t,
        r.page,
        r.onPageChange
    ]), $7fPBF.useEffect(()=>{
        n((e)=>{
            const t = void 0 !== r.rowCount ? r.rowCount : a, l = Ri(t, e.pagination.pageSize), n = null == r.page ? e.pagination.page : r.page;
            return Object.assign(Object.assign({}, e), {
                pagination: Ii(Object.assign(Object.assign({}, e.pagination), {
                    page: n,
                    rowCount: t,
                    pageCount: l
                }))
            });
        }), o();
    }, [
        n,
        o,
        a,
        r.rowCount,
        r.page,
        t
    ]);
    const s = $7fPBF.useCallback((e)=>{
        n((t)=>{
            const r = Ri(t.pagination.rowCount, e);
            return Object.assign(Object.assign({}, t), {
                pagination: Ii(Object.assign(Object.assign({}, t.pagination), {
                    pageCount: r,
                    page: t.pagination.page
                }))
            });
        }), o();
    }, [
        n,
        o
    ]);
    cl(t, ne.pageSizeChange, s);
    _r(t, {
        setPage: i
    }, "GridPageApi");
}, Li = (t, r)=>{
    const l = Ar("useGridPageSize"), [, n, o] = rl(t), a = ll(t, Pl), i = ll(t, Yo), s = $7fPBF.useCallback((e)=>{
        l.debug(`Setting page size to ${e}`), n((t)=>Object.assign(Object.assign({}, t), {
                pagination: Object.assign(Object.assign({}, t.pagination), {
                    pageSize: e
                })
            })), o();
    }, [
        n,
        o,
        l
    ]);
    $7fPBF.useEffect(()=>{
        t.current.updateControlState({
            stateId: "pageSize",
            propModel: r.pageSize,
            propOnChange: r.onPageSizeChange,
            stateSelector: (e)=>e.pagination.pageSize,
            changeEvent: ne.pageSizeChange
        });
    }, [
        t,
        r.pageSize,
        r.onPageSizeChange
    ]), $7fPBF.useEffect(()=>{
        const e = null == i ? void 0 : i.viewportPageSize, l = t.current.state.pagination.pageSize;
        let a = l;
        null != r.pageSize ? a = r.pageSize : r.autoPageSize && (a = null != e ? e : 0), a !== l && (r.autoPageSize && t.current.publishEvent(ne.pageSizeChange, e), n((e)=>Object.assign(Object.assign({}, e), {
                pagination: Object.assign(Object.assign({}, e.pagination), {
                    pageSize: a
                })
            })), o());
    }, [
        t,
        n,
        o,
        a,
        r.autoPageSize,
        r.pageSize,
        null == i ? void 0 : i.viewportPageSize
    ]);
    _r(t, {
        setPageSize: s
    }, "GridPageSizeApi");
}, Fi = (t)=>{
    const r = Ar("useGridPreferencesPanel"), [, l, n] = rl(t), o = $7fPBF.useRef(), a = $7fPBF.useRef(), i = $7fPBF.useCallback(()=>{
        r.debug("Hiding Preferences Panel"), l((e)=>Object.assign(Object.assign({}, e), {
                preferencePanel: {
                    open: !1
                }
            })), n();
    }, [
        n,
        r,
        l
    ]), s = $7fPBF.useCallback(()=>{
        a.current = setTimeout(()=>clearTimeout(o.current), 0);
    }, []), c = $7fPBF.useCallback(()=>{
        o.current = setTimeout(i, 100);
    }, [
        i
    ]);
    _r(t, {
        showPreferences: $7fPBF.useCallback((e)=>{
            r.debug("Opening Preferences Panel"), s(), l((t)=>Object.assign(Object.assign({}, t), {
                    preferencePanel: Object.assign(Object.assign({}, t.preferencePanel), {
                        open: !0,
                        openedPanelValue: e
                    })
                })), n();
        }, [
            s,
            n,
            r,
            l
        ]),
        hidePreferences: c
    }, "ColumnMenuApi"), $7fPBF.useEffect(()=>()=>{
            clearTimeout(o.current), clearTimeout(a.current);
        }, []);
};
let ji = !1;
function zi(t) {
    const r = $7fPBF.useCallback((e)=>({
            field: e,
            colDef: t.current.getColumn(e),
            api: t.current
        }), [
        t
    ]), l = $7fPBF.useCallback((e)=>{
        const r = t.current.getRow(e);
        if (!r) throw new Error(`No row with id #${e} found`);
        return {
            id: e,
            columns: t.current.getAllColumns(),
            row: r,
            api: t.current,
            getValue: t.current.getCellValue
        };
    }, [
        t
    ]), n = $7fPBF.useCallback((e, r)=>{
        const l = t.current.getRow(e);
        if (!l) throw new Error(`No row with id #${e} found`);
        const n = Hl(t.current.state), o = Gl(t.current.state);
        return {
            id: e,
            field: r,
            row: l,
            value: l[r],
            colDef: t.current.getColumn(r),
            cellMode: t.current.getCellMode(e, r),
            getValue: t.current.getCellValue,
            api: t.current,
            hasFocus: null !== n && n.field === r && n.id === e,
            tabIndex: o && o.field === r && o.id === e ? 0 : -1
        };
    }, [
        t
    ]), o = $7fPBF.useCallback((e, r)=>{
        const l = t.current.getColumn(r), n = t.current.getCellValue(e, r), o = t.current.getRow(e);
        if (!o) throw new Error(`No row with id #${e} found`);
        const a = Hl(t.current.state), i = Gl(t.current.state), s = {
            id: e,
            field: r,
            row: o,
            colDef: l,
            cellMode: t.current.getCellMode(e, r),
            getValue: t.current.getCellValue,
            api: t.current,
            hasFocus: null !== a && a.field === r && a.id === e,
            tabIndex: i && i.field === r && i.id === e ? 0 : -1,
            value: n,
            formattedValue: n
        };
        return l.valueFormatter && (s.formattedValue = l.valueFormatter(s)), s.isEditable = l && t.current.isCellEditable(s), s;
    }, [
        t
    ]), a = $7fPBF.useCallback((e, r)=>{
        const l = t.current.getColumn(r);
        if (!l || !l.valueGetter) {
            const l = t.current.getRow(e);
            if (!l) throw new Error(`No row with id #${e} found`);
            return l[r];
        }
        return l.valueGetter(n(e, r));
    }, [
        t,
        n
    ]), i = $7fPBF.useCallback((e)=>t.current.rootElementRef.current ? function(e, t) {
            return e.querySelector(`[role="columnheader"][data-field="${Fo(t)}"]`);
        }(t.current.rootElementRef.current, e) : null, [
        t
    ]), s = $7fPBF.useCallback((e)=>t.current.rootElementRef.current ? jo(t.current.rootElementRef.current, e) : null, [
        t
    ]), c = $7fPBF.useCallback((e, r)=>t.current.rootElementRef.current ? function(e, { id: t, field: r }) {
            const l = jo(e, t);
            return l ? l.querySelector(`.MuiDataGrid-cell[data-field="${Fo(r)}"]`) : null;
        }(t.current.rootElementRef.current, {
            id: e,
            field: r
        }) : null, [
        t
    ]);
    _r(t, {
        getCellValue: a,
        getCellParams: o,
        getCellElement: c,
        getRowParams: l,
        getRowElement: s,
        getColumnHeaderParams: r,
        getColumnHeaderElement: i
    }, "GridParamsApi");
}
function Ti(e, t, r) {
    if (null == e) throw new Error([
        "Material-UI: The data grid component requires all rows to have a unique id property.",
        r || "A row was provided without id in the rows prop:",
        JSON.stringify(t)
    ].join("\n"));
    return !0;
}
function Hi(e, t, r) {
    const l = t ? t(e) : e.id;
    return Ti(l, e, r), l;
}
function Ai(e, t, r) {
    const l = Object.assign(Object.assign({}, {
        idRowsLookup: {},
        allRows: [],
        totalRowCount: 0
    }), {
        totalRowCount: t && t > e.length ? t : e.length
    });
    return e.forEach((e)=>{
        const t = Hi(e, r);
        l.allRows.push(t), l.idRowsLookup[t] = e;
    }), l;
}
const _i = (t, r)=>{
    const l = Ar("useGridRows"), [, n, o] = rl(t), a = ll(t, hl), i = $7fPBF.useRef(), s = $7fPBF.useCallback((e)=>{
        null == i.current && (i.current = setTimeout(()=>{
            l.debug("Updating component"), i.current = null, e && e(), o();
        }, 100));
    }, [
        l,
        o
    ]), c = $7fPBF.useRef(a);
    $7fPBF.useEffect(()=>()=>clearTimeout(i.current), []), $7fPBF.useEffect(()=>{
        n((e)=>(c.current = Ai(r.rows, r.rowCount, r.getRowId), Object.assign(Object.assign({}, e), {
                rows: c.current
            })));
    }, [
        r.getRowId,
        r.rows,
        r.rowCount,
        n
    ]);
    const u = $7fPBF.useCallback((e)=>t.current.getSortedRowIds ? t.current.getSortedRowIds().indexOf(e) : t.current.state.rows.allRows.indexOf(e), [
        t
    ]), d = $7fPBF.useCallback((e)=>t.current.getSortedRowIds ? t.current.getSortedRowIds()[e] : t.current.state.rows.allRows[e], [
        t
    ]), p = $7fPBF.useCallback((e)=>{
        var r;
        return null !== (r = t.current.state.rows.idRowsLookup[e]) && void 0 !== r ? r : null;
    }, [
        t
    ]), m = $7fPBF.useCallback((e)=>{
        l.debug(`updating all rows, new length ${e.length}`), c.current.allRows.length > 0 && t.current.publishEvent(ne.rowsClear);
        const o = [], a = e.reduce((e, t)=>{
            const l = Hi(t, r.getRowId);
            return e[l] = t, o.push(l), e;
        }, {}), i = r.rowCount && r.rowCount > o.length ? r.rowCount : o.length;
        c.current = {
            idRowsLookup: a,
            allRows: o,
            totalRowCount: i
        }, n((e)=>Object.assign(Object.assign({}, e), {
                rows: c.current
            })), s(()=>t.current.publishEvent(ne.rowsSet));
    }, [
        l,
        n,
        s,
        t,
        r.getRowId,
        r.rowCount
    ]), f = $7fPBF.useCallback((e)=>{
        const l = e.reduce((e, t)=>{
            const l = Hi(t, r.getRowId, "A row was provided without id when calling updateRows():");
            return e[l] = null != e[l] ? Object.assign(Object.assign({}, e[l]), t) : t, e;
        }, {}), o = [], a = [];
        let i = null;
        if (Object.entries(l).forEach(([e, t])=>{
            if ("delete" === t._action) return void a.push(e);
            const r = p(e);
            r ? (i || (i = Object.assign({}, c.current.idRowsLookup)), i[e] = Object.assign(Object.assign({}, r), t)) : o.push(t);
        }), i && (c.current.idRowsLookup = i, n((e)=>Object.assign(Object.assign({}, e), {
                rows: Object.assign({}, c.current)
            }))), a.length > 0 || o.length > 0) {
            a.forEach((e)=>{
                delete c.current.idRowsLookup[e];
            });
            const e = [
                ...Object.values(c.current.idRowsLookup),
                ...o
            ];
            m(e);
        }
        s(()=>t.current.publishEvent(ne.rowsUpdate));
    }, [
        t,
        s,
        p,
        r.getRowId,
        n,
        m
    ]), g = $7fPBF.useCallback(()=>new Map(t.current.state.rows.allRows.map((e)=>[
                e,
                t.current.state.rows.idRowsLookup[e]
            ])), [
        t
    ]), b = $7fPBF.useCallback(()=>t.current.state.rows.totalRowCount, [
        t
    ]), h = $7fPBF.useCallback(()=>t.current.state.rows.allRows, [
        t
    ]);
    _r(t, {
        getRowIndex: u,
        getRowIdFromRowIndex: d,
        getRow: p,
        getRowModels: g,
        getRowsCount: b,
        getAllRowIds: h,
        setRows: m,
        updateRows: f
    }, "GridRowApi");
};
function Gi(t, r) {
    const l = Ar("useGridEditRows"), [, n, o] = rl(t), a = (e, r)=>{
        "view" !== e.cellMode && (t.current.commitCellChange(e, r), t.current.publishEvent(ne.cellEditStop, e, r));
    }, i = hr((e, t)=>{
        a(e, t);
    }), s = hr((e)=>{
        const { cell: r } = t.current.state.focus;
        if (!r) return;
        const l = t.current.getCellParams(r.id, r.field);
        a(l, e);
    }), c = $7fPBF.useCallback((e, r, a)=>{
        const i = "edit" === t.current.getCellMode(e, r);
        "edit" === a && i || "view" === a && !i || (l.debug(`Switching cell id: ${e} field: ${r} to mode: ${a}`), n((l)=>{
            const n = Object.assign({}, l.editRows);
            return n[e] = Object.assign({}, n[e]), "edit" === a ? n[e][r] = {
                value: t.current.getCellValue(e, r)
            } : (delete n[e][r], Object.keys(n[e]).length || delete n[e]), Object.assign(Object.assign({}, l), {
                editRows: n
            });
        }), o(), t.current.publishEvent(ne.cellModeChange, {
            id: e,
            field: r,
            mode: a,
            api: t.current
        }));
    }, [
        t,
        o,
        l,
        n
    ]), u = $7fPBF.useCallback((e, r)=>{
        const l = t.current.state.editRows;
        return l[e] && l[e][r] ? "edit" : "view";
    }, [
        t
    ]), d = $7fPBF.useCallback((e)=>!!e.colDef.editable && !!e.colDef.renderEditCell && (!r.isCellEditable || r.isCellEditable(e)), [
        r.isCellEditable
    ]), p = $7fPBF.useCallback((e, r)=>{
        const l = {
            id: e.id,
            field: e.field,
            props: {
                value: e.value
            }
        };
        t.current.publishEvent(ne.editCellPropsChange, l, r);
    }, [
        t
    ]), m = $7fPBF.useCallback((e)=>{
        const { id: r, field: a, props: i } = e;
        l.debug(`Setting cell props on id: ${r} field: ${a}`), n((e)=>{
            const l = t.current.getColumn(a), n = l.valueParser ? l.valueParser(i.value, t.current.getCellParams(r, a)) : i.value, o = Object.assign({}, e.editRows);
            return o[r] = Object.assign({}, e.editRows[r]), o[r][a] = Object.assign(Object.assign({}, i), {
                value: n
            }), Object.assign(Object.assign({}, e), {
                editRows: o
            });
        }), o();
    }, [
        t,
        o,
        l,
        n
    ]), f = $7fPBF.useCallback((e)=>{
        m(e);
    }, [
        m
    ]), g = $7fPBF.useCallback((e)=>{
        l.debug("Setting row model"), n((t)=>Object.assign(Object.assign({}, t), {
                editRows: e
            })), o();
    }, [
        o,
        l,
        n
    ]), b = $7fPBF.useCallback(()=>t.current.state.editRows, [
        t
    ]), h = $7fPBF.useCallback((e, r)=>{
        const { id: l, field: n } = e, o = t.current.getEditRowsModel();
        if (!o[l] || !o[l][n]) throw new Error(`Cell at id: ${l} and field: ${n} is not in edit mode`);
        const { error: a, value: i } = o[l][n];
        if (!a) {
            const l = Object.assign(Object.assign({}, e), {
                value: i
            });
            return t.current.publishEvent(ne.cellEditCommit, l, r), !0;
        }
        return !1;
    }, [
        t
    ]), v = $7fPBF.useCallback((e)=>{
        const { id: r, field: n } = e, o = t.current.getEditRowsModel(), { value: a } = o[r][n];
        l.debug(`Setting cell id: ${r} field: ${n} to value: ${null == a ? void 0 : a.toString()}`);
        const i = t.current.getRow(r), s = Object.assign(Object.assign({}, i), {
            [n]: a
        });
        t.current.updateRows([
            s
        ]);
    }, [
        t,
        l
    ]), C = $7fPBF.useCallback((e, t)=>{
        e.isEditable && (c(e.id, e.field, "edit"), sn(t) && rn(t.key) && m({
            id: e.id,
            field: e.field,
            props: {
                value: ""
            }
        }));
    }, [
        m,
        c
    ]), w = $7fPBF.useCallback((e, t)=>{
        const r = t.detail > 1;
        e.isEditable && "view" === e.cellMode && r && t.preventDefault();
    }, []), O = $7fPBF.useCallback((e, r)=>{
        const { id: l, field: n, cellMode: o, isEditable: a } = e;
        if (!a) return;
        const i = "edit" === o, s = r.ctrlKey || r.metaKey || r.altKey;
        var c;
        if (!i && (c = r.key, Zl(c) || en(c) || rn(c)) && !s && t.current.publishEvent(ne.cellEditStart, e, r), !i && en(r.key) && (t.current.setEditCellValue({
            id: l,
            field: n,
            value: ""
        }), t.current.commitCellChange({
            id: l,
            field: n
        }, r), t.current.publishEvent(ne.cellEditStop, e, r)), i && on(r.key)) {
            const e = {
                id: l,
                field: n
            };
            if (!t.current.commitCellChange(e, r)) return;
        }
        i && ((e)=>ln.indexOf(e) > -1)(r.key) && t.current.publishEvent(ne.cellEditStop, e, r);
    }, [
        t
    ]), y = $7fPBF.useCallback((e, r)=>{
        c(e.id, e.field, "view"), r && sn(r) && (on(r.key) ? t.current.publishEvent(ne.cellNavigationKeyDown, e, r) : ("Escape" === r.key || en(r.key)) && t.current.setCellFocus(e.id, e.field));
    }, [
        t,
        c
    ]), E = $7fPBF.useCallback((e, r)=>{
        e.isEditable && t.current.publishEvent(ne.cellEditStart, e, r);
    }, [
        t
    ]);
    cl(t, ne.cellKeyDown, O), cl(t, ne.cellMouseDown, w), cl(t, ne.cellDoubleClick, E), cl(t, ne.cellFocusOut, i), cl(t, ne.columnHeaderDragStart, s), cl(t, ne.cellEditStart, C), cl(t, ne.cellEditStop, y), cl(t, ne.cellEditCommit, v), cl(t, ne.editCellPropsChange, f), dl(t, ne.cellEditCommit, r.onCellEditCommit), dl(t, ne.editCellPropsChange, r.onEditCellPropsChange), dl(t, ne.cellEditStart, r.onCellEditStart), dl(t, ne.cellEditStop, r.onCellEditStop), _r(t, {
        setCellMode: c,
        getCellMode: u,
        isCellEditable: d,
        commitCellChange: h,
        setEditRowsModel: g,
        getEditRowsModel: b,
        setEditCellValue: p
    }, "EditRowApi"), $7fPBF.useEffect(()=>{
        t.current.updateControlState({
            stateId: "editRows",
            propModel: r.editRowsModel,
            propOnChange: r.onEditRowsModelChange,
            stateSelector: (e)=>e.editRows,
            changeEvent: ne.editRowsModelChange
        });
    }, [
        t,
        r.editRowsModel,
        r.onEditRowsModelChange
    ]), $7fPBF.useEffect(()=>{
        const e = t.current.state.editRows;
        void 0 !== r.editRowsModel && r.editRowsModel !== e && t.current.setEditRowsModel(r.editRowsModel || {});
    }, [
        t,
        r.editRowsModel
    ]);
}
const Ni = (t, r)=>{
    const l = Ar("useGridSelection"), [, n, o] = rl(t), a = ll(t, il), i = ll(t, Cl), s = $7fPBF.useMemo(()=>null == r.selectionModel || Array.isArray(r.selectionModel) ? r.selectionModel : [
            r.selectionModel
        ], [
        r.selectionModel
    ]), { checkboxSelection: c, disableMultipleSelection: u, disableSelectionOnClick: d, isRowSelectable: p } = a, m = $7fPBF.useCallback(()=>vn(t.current.state), [
        t
    ]), f = $7fPBF.useCallback((e)=>{
        const { id: r, allowMultipleOverride: a, isSelected: i, isMultipleKey: s } = e;
        p && !p(t.current.getRowParams(r)) || (l.debug(`Selecting row ${r}`), n((e)=>{
            let t = Cn(e);
            if (a || !u && s || c) (null == i ? void 0 === t[r] : i) ? t[r] = r : delete t[r];
            else {
                const e = null == i ? !s || void 0 === t[r] : i;
                t = {}, e && (t[r] = r);
            }
            return Object.assign(Object.assign({}, e), {
                selection: Object.values(t)
            });
        }), o());
    }, [
        p,
        u,
        t,
        l,
        c,
        o,
        n
    ]), g = $7fPBF.useCallback((e, r = !0, l = !1)=>{
        const n = t.current.getRow(e);
        n && f({
            id: e,
            row: n,
            allowMultipleOverride: l,
            isSelected: r
        });
    }, [
        t,
        f
    ]), b = $7fPBF.useCallback((e, r = !0, l = !1)=>{
        const a = p ? e.filter((e)=>p(t.current.getRowParams(e))) : e;
        u && a.length > 1 && !c || (n((e)=>{
            const t = l ? {} : Cn(e);
            return a.forEach((e)=>{
                r ? t[e] = e : void 0 !== t[e] && delete t[e];
            }), Object.assign(Object.assign({}, e), {
                selection: Object.values(t)
            });
        }), o());
    }, [
        p,
        u,
        c,
        n,
        o,
        t
    ]), h = $7fPBF.useCallback((e)=>{
        t.current.state.selection !== e && n((t)=>Object.assign(Object.assign({}, t), {
                selection: e
            }));
    }, [
        n,
        t
    ]), v = $7fPBF.useCallback((e, t)=>{
        d || f({
            id: e.id,
            row: e.row,
            isMultipleKey: t.metaKey || t.ctrlKey
        });
    }, [
        d,
        f
    ]);
    cl(t, ne.rowClick, v);
    _r(t, {
        selectRow: g,
        getSelectedRows: m,
        selectRows: b,
        setSelectionModel: h
    }, "GridSelectionApi"), $7fPBF.useEffect(()=>{
        t.current.updateControlState({
            stateId: "selection",
            propModel: s,
            propOnChange: r.onSelectionModelChange,
            stateSelector: bn,
            changeEvent: ne.selectionChange
        });
    }, [
        t,
        r.onSelectionModelChange,
        s
    ]), $7fPBF.useEffect(()=>{
        n((e)=>{
            const t = bn(e), r = Cn(e);
            let l = !1;
            return t.forEach((e)=>{
                i[e] || (delete r[e], l = !0);
            }), l ? Object.assign(Object.assign({}, e), {
                selection: Object.values(r)
            }) : e;
        }), o();
    }, [
        i,
        t,
        n,
        o
    ]), $7fPBF.useEffect(()=>{
        void 0 !== s && t.current.setSelectionModel(s);
    }, [
        t,
        s,
        n
    ]), $7fPBF.useEffect(()=>{
        n((e)=>{
            const r = [
                ...e.selection
            ], l = Cn(e);
            let n = !1;
            return r.forEach((e)=>{
                !p || p(t.current.getRowParams(e)) || (delete l[e], n = !0);
            }), n ? Object.assign(Object.assign({}, e), {
                selection: Object.values(l)
            }) : e;
        }), o();
    }, [
        t,
        n,
        o,
        p
    ]);
}, $i = (t, r)=>{
    const l = Ar("useGridSorting"), [n, o, a] = rl(t), i = ll(t, vl), s = $7fPBF.useCallback((e, t)=>{
        const r = n.sorting.sortModel.findIndex((t)=>t.field === e);
        let l = [
            ...n.sorting.sortModel
        ];
        return r > -1 ? t ? l.splice(r, 1, t) : l.splice(r, 1) : l = [
            ...n.sorting.sortModel,
            t
        ], l;
    }, [
        n.sorting.sortModel
    ]), c = $7fPBF.useCallback((e, t)=>{
        const l = n.sorting.sortModel.find((t)=>t.field === e.field);
        if (l) {
            const e = void 0 === t ? Sn(r.sortingOrder, l.sort) : t;
            return null == e ? void 0 : Object.assign(Object.assign({}, l), {
                sort: e
            });
        }
        return {
            field: e.field,
            sort: void 0 === t ? Sn(r.sortingOrder) : t
        };
    }, [
        n.sorting.sortModel,
        r.sortingOrder
    ]), u = $7fPBF.useCallback((e, r)=>({
            id: e,
            field: r,
            value: t.current.getCellValue(e, r),
            api: t.current
        }), [
        t
    ]), d = $7fPBF.useCallback((e)=>(t, r)=>e.reduce((e, l, n)=>{
                if (0 !== e) return e;
                const { comparator: o } = l, a = t[n], i = r[n];
                return e = o(a.value, i.value, a, i);
            }, 0), []), p = $7fPBF.useCallback((e)=>e.map((e)=>{
            const r = t.current.getColumn(e.field);
            if (!r) throw new Error(`Error sorting: column with field '${e.field}' not found. `);
            const l = "desc" === e.sort ? (e, t, l, n)=>-1 * r.sortComparator(e, t, l, n) : r.sortComparator;
            return {
                field: r.field,
                comparator: l
            };
        }), [
        t
    ]), m = $7fPBF.useCallback(()=>{
        let e = t.current.getAllRowIds();
        if (r.sortingMode === Vr.server) return l.debug("Skipping sorting rows as sortingMode = server"), void o((t)=>Object.assign(Object.assign({}, t), {
                sorting: Object.assign(Object.assign({}, t.sorting), {
                    sortedRows: e
                })
            }));
        const n = t.current.state.sorting.sortModel;
        if (n.length > 0) {
            const t = p(n);
            l.debug("Sorting rows with ", n), e = e.map((e)=>t.map((t)=>u(e, t.field))).sort(d(t)).map((e)=>e[0].id);
        }
        o((t)=>Object.assign(Object.assign({}, t), {
                sorting: Object.assign(Object.assign({}, t.sorting), {
                    sortedRows: e
                })
            })), a();
    }, [
        t,
        l,
        u,
        o,
        a,
        p,
        d,
        r.sortingMode
    ]), f = $7fPBF.useCallback((e)=>{
        o((t)=>Object.assign(Object.assign({}, t), {
                sorting: Object.assign(Object.assign({}, t.sorting), {
                    sortModel: e
                })
            })), a(), t.current.applySorting();
    }, [
        o,
        a,
        t
    ]), g = $7fPBF.useCallback((e, t, l)=>{
        if (!e.sortable) return;
        const n = c(e, t);
        let o;
        o = !l || r.disableMultipleColumnsSorting ? n ? [
            n
        ] : [] : s(e.field, n), f(o);
    }, [
        s,
        f,
        c,
        r.disableMultipleColumnsSorting
    ]), b = $7fPBF.useCallback(({ colDef: e }, t)=>{
        const r = t.shiftKey || t.metaKey || t.ctrlKey;
        g(e, void 0, r);
    }, [
        g
    ]), h = $7fPBF.useCallback(({ colDef: e }, t)=>{
        !Zl(t.key) || t.ctrlKey || t.metaKey || g(e, void 0, t.shiftKey);
    }, [
        g
    ]), v = $7fPBF.useCallback(()=>{
        o((e)=>Object.assign(Object.assign({}, e), {
                sorting: Object.assign(Object.assign({}, e.sorting), {
                    sortedRows: []
                })
            }));
    }, [
        o
    ]), C = $7fPBF.useCallback(()=>n.sorting.sortModel, [
        n.sorting.sortModel
    ]), w = $7fPBF.useCallback(()=>Object.values(Sl(t.current.state)), [
        t
    ]), O = $7fPBF.useCallback(()=>El(t.current.state), [
        t
    ]), y = $7fPBF.useCallback(()=>{
        o((e)=>{
            const t = e.sorting.sortModel, r = ue(e);
            let l = t;
            return t.length > 0 && (l = t.reduce((e, t)=>(r.find((e)=>e.field === t.field) && e.push(t), e), [])), Object.assign(Object.assign({}, e), {
                sorting: Object.assign(Object.assign({}, e.sorting), {
                    sortModel: l
                })
            });
        });
    }, [
        o
    ]);
    cl(t, ne.columnHeaderClick, b), cl(t, ne.columnHeaderKeyDown, h), cl(t, ne.rowsSet, t.current.applySorting), cl(t, ne.rowsClear, v), cl(t, ne.rowsUpdate, t.current.applySorting), cl(t, ne.columnsChange, y);
    _r(t, {
        getSortModel: C,
        getSortedRows: w,
        getSortedRowIds: O,
        setSortModel: f,
        sortColumn: g,
        applySorting: m
    }, "GridSortApi"), $7fPBF.useEffect(()=>{
        t.current.applySorting();
    }, [
        t,
        r.rows
    ]), $7fPBF.useEffect(()=>{
        i > 0 && (l.debug("row changed, applying sortModel"), t.current.applySorting());
    }, [
        i,
        t,
        l
    ]), $7fPBF.useEffect(()=>{
        t.current.updateControlState({
            stateId: "sortModel",
            propModel: r.sortModel,
            propOnChange: r.onSortModelChange,
            stateSelector: (e)=>e.sorting.sortModel,
            changeEvent: ne.sortModelChange
        });
    }, [
        t,
        r.sortModel,
        r.onSortModelChange
    ]), $7fPBF.useEffect(()=>{
        const e = t.current.state.sorting.sortModel;
        void 0 !== r.sortModel && r.sortModel !== e && f(r.sortModel);
    }, [
        r.sortModel,
        t,
        f
    ]);
};
function Vi(e) {
    const { clientHeight: t, scrollTop: r, offsetHeight: l, offsetTop: n } = e, o = n + l;
    return o - t > r ? o - t : n < r ? n : void 0;
}
function Bi(e, t, r = 0, l = t.length) {
    if (t.length <= 0) return -1;
    if (r >= l) return r;
    const n = r + Math.floor((l - r) / 2);
    return e <= t[n] ? Bi(e, t, r, n) : Bi(e, t, n + 1, l);
}
const Wi = (t)=>{
    var r;
    const l = Ar("useGridVirtualRows"), n = t.current.columnHeadersElementRef, o = t.current.windowRef, a = t.current.renderingZoneRef, [i, s, c] = rl(t), u = ll(t, il), d = ll(t, Bl), p = ll(t, fn), m = ll(t, vl), f = ll(t, de), g = ll(t, pe), b = $7fPBF.useRef(null), h = $7fPBF.useRef(null), v = $7fPBF.useRef(0), [C] = Di(a, n), w = $7fPBF.useCallback((e)=>{
        let t = !1;
        return s((r)=>{
            const l = Object.assign(Object.assign({}, r.rendering), e);
            return br(r.rendering, l) ? r : (t = !0, Object.assign(Object.assign({}, r), {
                rendering: l
            }));
        }), t;
    }, [
        s
    ]), O = $7fPBF.useCallback((e)=>{
        if (null == t.current.state.containerSizes) return null;
        let r = 0;
        u.pagination && null != p.pageSize && "client" === u.paginationMode && (r = p.pageSize * p.page);
        const l = e * t.current.state.containerSizes.viewportPageSize + r;
        let n = l + t.current.state.containerSizes.renderingZonePageSize;
        const o = t.current.state.containerSizes.virtualRowsCount + r;
        n > o && (n = o);
        return {
            page: e,
            firstRowIdx: l,
            lastRowIdx: n
        };
    }, [
        t,
        u.pagination,
        p.pageSize,
        u.paginationMode,
        p.page
    ]), y = $7fPBF.useCallback(()=>{
        if (null == t.current.state.containerSizes) return null;
        return Object.assign(Object.assign(Object.assign({}, b.current), O(t.current.state.rendering.virtualPage)), {
            paginationCurrentPage: p.page,
            pageSize: p.pageSize
        });
    }, [
        b,
        O,
        t,
        p.page,
        p.pageSize
    ]), E = $7fPBF.useCallback(()=>{
        const e = y();
        w({
            renderContext: e
        }) && (l.debug("reRender: trigger rendering"), c());
    }, [
        y,
        l,
        c,
        w
    ]), S = $7fPBF.useCallback((e)=>Bi(e, g.positions), [
        g.positions
    ]), M = $7fPBF.useCallback((e)=>f.length ? f[S(e)] : null, [
        S,
        f
    ]), x = $7fPBF.useCallback((e, r)=>{
        var n, o, a, i;
        if (!e) return !1;
        h.current = e;
        const s = e.windowSizes.width;
        v.current = r, l.debug(`GridColumns from ${null === (n = M(r)) || void 0 === n ? void 0 : n.field} to ${null === (o = M(r + s)) || void 0 === o ? void 0 : o.field}`);
        const c = S(r), d = S(r + s), p = (null === (a = null == b ? void 0 : b.current) || void 0 === a ? void 0 : a.firstColIdx) || 0, m = (null === (i = null == b ? void 0 : b.current) || void 0 === i ? void 0 : i.lastColIdx) || 0, C = u.columnBuffer, w = C > 1 ? C - 1 : C, O = Math.abs(c - w - p), y = Math.abs(d + w - m);
        l.debug(`Column buffer: ${C}, tolerance: ${w}`), l.debug(`Previous values  => first: ${p}, last: ${m}`), l.debug(`Current displayed values  => first: ${c}, last: ${d}`), l.debug(`Difference with first: ${O} and last: ${y} `);
        const E = f.length > 0 ? f.length - 1 : 0, x = c - C >= 0 ? c - C : 0, k = {
            leftEmptyWidth: g.positions[x],
            rightEmptyWidth: 0,
            firstColIdx: x,
            lastColIdx: d + C >= E ? E : d + C
        };
        return t.current.state.scrollBar.hasScrollX ? k.rightEmptyWidth = g.totalWidth - g.positions[k.lastColIdx] - f[k.lastColIdx].computedWidth : u.disableExtendRowFullWidth || (k.rightEmptyWidth = t.current.state.viewportSizes.width - g.totalWidth), br(k, b.current) ? (l.debug("No rendering needed on columns"), !1) : (b.current = k, l.debug("New columns state to render", k), !0);
    }, [
        t,
        g.positions,
        g.totalWidth,
        M,
        S,
        l,
        u.columnBuffer,
        u.disableExtendRowFullWidth,
        f
    ]), k = $7fPBF.useCallback((e = !1)=>{
        const r = t.current.state, n = r.containerSizes;
        if (!o || !o.current || !n) return;
        const a = r.scrollBar, { scrollLeft: i, scrollTop: s } = o.current;
        l.debug(`Handling scroll Left: ${i} Top: ${s}`);
        let c = x(n, i);
        const u = i, d = r.containerSizes.renderingZoneScrollHeight, m = r.rendering.virtualPage, f = d > 0 ? Math.floor(s / d) : 0, g = s % d, b = {
            left: a.hasScrollX ? u : 0,
            top: n.isVirtualized ? g : s
        };
        n.isVirtualized && m !== f ? (w({
            virtualPage: f
        }), l.debug(`Changing page from ${m} to ${f}`), c = !0) : (!n.isVirtualized && m > 0 && (l.debug("Virtualization disabled, setting virtualPage to 0"), w({
            virtualPage: 0
        })), C(b)), w({
            renderingZoneScroll: b,
            realScroll: {
                left: o.current.scrollLeft,
                top: o.current.scrollTop
            }
        }), t.current.publishEvent(ne.rowsScroll, b);
        const h = r.rendering.renderContext && r.rendering.renderContext.paginationCurrentPage !== p.page;
        (e || c || h) && E();
    }, [
        t,
        l,
        p.page,
        E,
        C,
        w,
        x,
        o
    ]), D = $7fPBF.useCallback((e)=>{
        if (0 === m || 0 === f.length) return !1;
        l.debug(`Scrolling to cell at row ${e.rowIndex}, col: ${e.colIndex} `);
        const r = {};
        if (null != e.colIndex && (r.left = Vi({
            clientHeight: o.current.clientWidth,
            scrollTop: o.current.scrollLeft,
            offsetHeight: f[e.colIndex].computedWidth,
            offsetTop: g.positions[e.colIndex]
        })), null != e.rowIndex) {
            const t = u.pagination ? e.rowIndex - p.page * p.pageSize : e.rowIndex;
            r.top = Vi({
                clientHeight: o.current.clientHeight,
                scrollTop: o.current.scrollTop,
                offsetHeight: d,
                offsetTop: d * t
            });
        }
        return r.left, t.current.scroll(r), !0;
    }, [
        m,
        f,
        l,
        t,
        u.pagination,
        p.page,
        p.pageSize,
        o,
        g.positions,
        d
    ]), R = $7fPBF.useCallback(()=>{
        C({
            left: 0,
            top: 0
        }), w({
            virtualPage: 0
        }), o && o.current && (o.current.scrollTop = 0, o.current.scrollLeft = 0), w({
            renderingZoneScroll: {
                left: 0,
                top: 0
            }
        });
    }, [
        C,
        w,
        o
    ]), I = $7fPBF.useRef(null), P = $7fPBF.useCallback(()=>{
        o.current.scrollLeft < 0 || o.current.scrollTop < 0 || (I.current || s((e)=>Object.assign(Object.assign({}, e), {
                isScrolling: !0
            })), clearTimeout(I.current), I.current = setTimeout(()=>{
            I.current = null, s((e)=>Object.assign(Object.assign({}, e), {
                    isScrolling: !1
                })), c();
        }, 300), t.current.updateViewport && t.current.updateViewport());
    }, [
        o,
        t,
        s,
        c
    ]), L = $7fPBF.useCallback((e)=>{
        o.current && null != e.left && n.current && (n.current.scrollLeft = e.left, o.current.scrollLeft = e.left, l.debug(`Scrolling left: ${e.left}`)), o.current && null != e.top && (o.current.scrollTop = e.top, l.debug(`Scrolling top: ${e.top}`)), l.debug("Scrolling, updating container, and viewport");
    }, [
        o,
        n,
        l
    ]), F = $7fPBF.useCallback(()=>ol(t.current.state), [
        t
    ]), j = $7fPBF.useCallback(()=>i.containerSizes, [
        i.containerSizes
    ]), z = $7fPBF.useCallback(()=>i.rendering.renderContext || void 0, [
        i.rendering.renderContext
    ]);
    vr(()=>{
        a && a.current && (l.debug("applying scrollTop ", i.rendering.renderingZoneScroll.top), C(i.rendering.renderingZoneScroll));
    });
    _r(t, {
        scroll: L,
        scrollToIndexes: D,
        getContainerPropsState: j,
        getRenderContextState: z,
        getScrollPosition: F,
        updateViewport: k
    }, "GridVirtualizationApi"), $7fPBF.useEffect(()=>{
        var e;
        (null === (e = i.rendering.renderContext) || void 0 === e ? void 0 : e.paginationCurrentPage) !== p.page && t.current.updateViewport && (l.debug(`State paginationState.page changed to ${p.page}. `), t.current.updateViewport(!0), R());
    }, [
        t,
        p.page,
        null === (r = i.rendering.renderContext) || void 0 === r ? void 0 : r.paginationCurrentPage,
        l,
        R
    ]), $7fPBF.useEffect(()=>(t.current.updateViewport && (l.debug(`totalRowCount has changed to ${m}, updating viewport.`), t.current.updateViewport(!0)), ()=>{
            clearTimeout(I.current);
        }), [
        l,
        m,
        i.viewportSizes,
        i.scrollBar,
        i.containerSizes,
        t
    ]);
    const T = $7fPBF.useCallback((e)=>{
        e.target.scrollLeft = 0, e.target.scrollTop = 0;
    }, []);
    fi(t, o, "scroll", P, {
        passive: !0
    }), fi(t, ()=>{
        var e, r, l;
        return null === (l = null === (r = null === (e = t.current) || void 0 === e ? void 0 : e.renderingZoneRef) || void 0 === r ? void 0 : r.current) || void 0 === l ? void 0 : l.parentElement;
    }, "scroll", T), fi(t, ()=>{
        var e, r;
        return null === (r = null === (e = t.current) || void 0 === e ? void 0 : e.columnHeadersContainerElementRef) || void 0 === r ? void 0 : r.current;
    }, "scroll", T);
    const H = $7fPBF.useCallback(()=>{
        l.debug("Clearing previous renderedColRef"), b.current = null;
    }, [
        l,
        b
    ]);
    cl(t, ne.columnsChange, H), cl(t, ne.debouncedResize, H);
};
class Ui extends class {
    on(e, t) {
        Array.isArray(this.events[e]) || (this.events[e] = []), this.events[e].push(t);
    }
    removeListener(e, t) {
        if (Array.isArray(this.events[e])) {
            const r = this.events[e].indexOf(t);
            r > -1 && this.events[e].splice(r, 1);
        }
    }
    removeAllListeners(e) {
        e ? Array.isArray(this.events[e]) && (this.events[e] = []) : this.events = {};
    }
    emit(e, ...t) {
        if (Array.isArray(this.events[e])) {
            const r = this.events[e].slice(), l = r.length;
            for(let e = 0; e < l; e += 1)r[e].apply(this, t);
        }
    }
    once(e, t) {
        const r = this;
        this.on(e, function l(...n) {
            r.removeListener(e, l), t.apply(r, n);
        });
    }
    constructor(){
        this.maxListeners = 10, this.warnOnce = !1, this.events = {};
    }
} {
    on(e, t, r) {
        Array.isArray(this.events[e]) || (this.events[e] = []), r && r.isFirst ? this.events[e].splice(0, 0, t) : this.events[e].push(t);
    }
}
function Ki(...t) {
    const r = t[0], l = $7fPBF.useRef(new Ui);
    return $7fPBF.useImperativeHandle(r, ()=>l.current, [
        l
    ]), l;
}
let Zi = !1;
function Xi() {
    if ("undefined" == typeof document) return Zi;
    if (!Zi) {
        const e = document.createElement("div");
        e.style.touchAction = "none", document.body.appendChild(e), Zi = "none" === window.getComputedStyle(e).touchAction, e.parentElement.removeChild(e);
    }
    return Zi;
}
function qi(e, t) {
    if (void 0 !== t && e.changedTouches) {
        for(let r = 0; r < e.changedTouches.length; r += 1){
            const l = e.changedTouches[r];
            if (l.identifier === t) return {
                x: l.clientX,
                y: l.clientY
            };
        }
        return !1;
    }
    return {
        x: e.clientX,
        y: e.clientY
    };
}
const Yi = (t, r)=>{
    const l = Ar("useGridColumnResize"), [, n, o] = rl(t), a = $7fPBF.useRef(), i = $7fPBF.useRef(), s = $7fPBF.useRef(), c = $7fPBF.useRef(), u = $7fPBF.useRef(), d = $7fPBF.useRef(), p = (e)=>{
        l.debug(`Updating width to ${e} for col ${a.current.field}`), a.current.computedWidth = e, a.current.width = e, a.current.flex = void 0, i.current.style.width = `${e}px`, i.current.style.minWidth = `${e}px`, i.current.style.maxWidth = `${e}px`, s.current.forEach((t)=>{
            const r = t;
            r.style.width = `${e}px`, r.style.minWidth = `${e}px`, r.style.maxWidth = `${e}px`;
        });
    }, m = hr((e)=>{
        w(), t.current.updateColumn(a.current), clearTimeout(u.current), u.current = setTimeout(()=>{
            var r;
            t.current.publishEvent(ne.columnResizeStop, null, e), t.current.publishEvent(ne.columnWidthChange, {
                element: i.current,
                colDef: a.current,
                api: t,
                width: null === (r = a.current) || void 0 === r ? void 0 : r.computedWidth
            }, e);
        }), l.debug(`Updating col ${a.current.field} with new width: ${a.current.width}`);
    }), g = hr((e)=>{
        var r;
        if (0 === e.buttons) return void m(e);
        let l = c.current + e.clientX - i.current.getBoundingClientRect().left;
        l = Math.max(null === (r = a.current) || void 0 === r ? void 0 : r.minWidth, l), p(l), t.current.publishEvent(ne.columnResize, {
            element: i.current,
            colDef: a.current,
            api: t,
            width: l
        }, e);
    }), b = hr(({ colDef: e }, r)=>{
        var n;
        if (0 !== r.button) return;
        if (!r.currentTarget.classList.contains("MuiDataGrid-columnSeparator--resizable")) return;
        r.preventDefault(), i.current = Io(r.currentTarget, "MuiDataGrid-columnHeader"), l.debug(`Start Resize on col ${e.field}`), t.current.publishEvent(ne.columnResizeStart, {
            field: e.field
        }, r), a.current = e, i.current = null === (n = t.current.columnHeadersElementRef) || void 0 === n ? void 0 : n.current.querySelector(`[data-field="${e.field}"]`), s.current = Lo(i.current);
        const o = (0, $g3iV0.default)(t.current.rootElementRef.current);
        o.body.style.cursor = "col-resize", c.current = a.current.computedWidth - (r.clientX - i.current.getBoundingClientRect().left), o.addEventListener("mousemove", g), o.addEventListener("mouseup", m);
    }), h = hr((e)=>{
        qi(e, d.current) && (w(), t.current.updateColumn(a.current), clearTimeout(u.current), u.current = setTimeout(()=>{
            t.current.publishEvent(ne.columnResizeStop, null, e);
        }), l.debug(`Updating col ${a.current.field} with new width: ${a.current.width}`));
    }), v = hr((e)=>{
        var r;
        const l = qi(e, d.current);
        if (!l) return;
        if ("mousemove" === e.type && 0 === e.buttons) return void h(e);
        let n = c.current + l.x - i.current.getBoundingClientRect().left;
        n = Math.max(null === (r = a.current) || void 0 === r ? void 0 : r.minWidth, n), p(n), t.current.publishEvent(ne.columnResize, {
            element: i.current,
            colDef: a.current,
            api: t,
            width: n
        }, e);
    }), C = hr((e)=>{
        var r;
        if (!Io(e.target, "MuiDataGrid-columnSeparator--resizable")) return;
        Xi() || e.preventDefault();
        const n = e.changedTouches[0];
        null != n && (d.current = n.identifier), i.current = Io(e.target, "MuiDataGrid-columnHeader");
        const o = i.current.getAttribute("data-field");
        const u = t.current.getColumn(o);
        l.debug(`Start Resize on col ${u.field}`), t.current.publishEvent(ne.columnResizeStart, {
            field: o
        }, e), a.current = u, i.current = function(e, t) {
            return e.querySelector(`[data-field="${t}"]`);
        }(null === (r = t.current.columnHeadersElementRef) || void 0 === r ? void 0 : r.current, u.field), s.current = Lo(i.current), c.current = a.current.computedWidth - (n.clientX - i.current.getBoundingClientRect().left);
        const p = (0, $g3iV0.default)(e.currentTarget);
        p.addEventListener("touchmove", v), p.addEventListener("touchend", h);
    }), w = $7fPBF.useCallback(()=>{
        const e = (0, $g3iV0.default)(t.current.rootElementRef.current);
        e.body.style.removeProperty("cursor"), e.removeEventListener("mousemove", g), e.removeEventListener("mouseup", m), e.removeEventListener("touchmove", v), e.removeEventListener("touchend", h);
    }, [
        t,
        g,
        m,
        v,
        h
    ]), O = $7fPBF.useCallback(({ field: e })=>{
        n((t)=>Object.assign(Object.assign({}, t), {
                columnResize: Object.assign(Object.assign({}, t.columnResize), {
                    resizingColumnField: e
                })
            })), o();
    }, [
        n,
        o
    ]), y = $7fPBF.useCallback(()=>{
        n((e)=>Object.assign(Object.assign({}, e), {
                columnResize: Object.assign(Object.assign({}, e.columnResize), {
                    resizingColumnField: ""
                })
            })), o();
    }, [
        n,
        o
    ]);
    $7fPBF.useEffect(()=>()=>{
            clearTimeout(u.current), w();
        }, [
        t,
        C,
        w
    ]), fi(t, ()=>{
        var e, r;
        return null === (r = null === (e = t.current) || void 0 === e ? void 0 : e.columnHeadersElementRef) || void 0 === r ? void 0 : r.current;
    }, "touchstart", C, {
        passive: Xi()
    }), cl(t, ne.columnSeparatorMouseDown, b), cl(t, ne.columnResizeStart, O), cl(t, ne.columnResizeStop, y), dl(t, ne.columnResize, r.onColumnResize), dl(t, ne.columnWidthChange, r.onColumnWidthChange);
}, Ji = $7fPBF.memo(function(t) {
    const r = ae(), l = dn(), [n] = l.sortingOrder, o = "asc" === n ? null == r ? void 0 : r.current.components.ColumnSortedAscendingIcon : null == r ? void 0 : r.current.components.ColumnSortedDescendingIcon;
    return o ? $7fPBF.createElement(o, Object.assign({}, t)) : null;
}), Qi = $7fPBF.forwardRef(function(t, r) {
    const { message: l } = t, n = On(t, [
        "message"
    ]), o = ae().current.getLocaleText("errorOverlayDefaultLabel");
    return $7fPBF.createElement(xa, Object.assign({
        ref: r
    }, n), l || o);
}), es = $7fPBF.forwardRef(function(t, r) {
    const l = ae().current.getLocaleText("noResultsOverlayLabel");
    return $7fPBF.createElement(xa, Object.assign({
        ref: r
    }, t), l);
}), ts = {
    BooleanCellFalseIcon: $n,
    BooleanCellTrueIcon: Kn,
    Checkbox: (0, $i8OTH.default),
    ColumnFilteredIcon: Ln,
    ColumnMenu: Fa,
    ColumnMenuIcon: Nn,
    ColumnResizeIcon: Hn,
    ColumnSelectorIcon: Tn,
    ColumnSortedAscendingIcon: Rn,
    ColumnSortedDescendingIcon: In,
    ColumnsPanel: Ba,
    ColumnUnsortedIcon: Ji,
    DensityComfortableIcon: Gn,
    DensityCompactIcon: An,
    DensityStandardIcon: _n,
    ErrorOverlay: Qi,
    ExportIcon: Un,
    FilterPanel: Ya,
    Footer: ai,
    Header: ii,
    LoadingOverlay: si,
    NoResultsOverlay: es,
    NoRowsOverlay: ci,
    OpenFilterButtonIcon: Pn,
    Pagination: di,
    Panel: Ka,
    PreferencesPanel: Za
}, rs = (t, r)=>{
    const l = $7fPBF.useMemo(()=>{
        var e, t;
        return {
            BooleanCellTrueIcon: r.components && r.components.BooleanCellTrueIcon || ts.BooleanCellTrueIcon,
            BooleanCellFalseIcon: r.components && r.components.BooleanCellFalseIcon || ts.BooleanCellFalseIcon,
            ColumnFilteredIcon: r.components && r.components.ColumnFilteredIcon || ts.ColumnFilteredIcon,
            ColumnMenuIcon: r.components && r.components.ColumnMenuIcon || ts.ColumnMenuIcon,
            ColumnResizeIcon: r.components && r.components.ColumnResizeIcon || ts.ColumnResizeIcon,
            ColumnSelectorIcon: r.components && r.components.ColumnSelectorIcon || ts.ColumnSelectorIcon,
            ColumnUnsortedIcon: void 0 === (null === (e = r.components) || void 0 === e ? void 0 : e.ColumnUnsortedIcon) ? ts.ColumnUnsortedIcon : null === (t = r.components) || void 0 === t ? void 0 : t.ColumnUnsortedIcon,
            ColumnSortedAscendingIcon: r.components && r.components.ColumnSortedAscendingIcon || ts.ColumnSortedAscendingIcon,
            ColumnSortedDescendingIcon: r.components && r.components.ColumnSortedDescendingIcon || ts.ColumnSortedDescendingIcon,
            DensityComfortableIcon: r.components && r.components.DensityComfortableIcon || ts.DensityComfortableIcon,
            DensityCompactIcon: r.components && r.components.DensityCompactIcon || ts.DensityCompactIcon,
            DensityStandardIcon: r.components && r.components.DensityStandardIcon || ts.DensityStandardIcon,
            ExportIcon: r.components && r.components.ExportIcon || ts.ExportIcon,
            OpenFilterButtonIcon: r.components && r.components.OpenFilterButtonIcon || ts.OpenFilterButtonIcon,
            Checkbox: r.components && r.components.Checkbox || ts.Checkbox,
            ColumnMenu: r.components && r.components.ColumnMenu || ts.ColumnMenu,
            ErrorOverlay: r.components && r.components.ErrorOverlay || ts.ErrorOverlay,
            Footer: r.components && r.components.Footer || ts.Footer,
            Header: r.components && r.components.Header || ts.Header,
            Toolbar: r.components && r.components.Toolbar,
            PreferencesPanel: r.components && r.components.PreferencesPanel || ts.PreferencesPanel,
            LoadingOverlay: r.components && r.components.LoadingOverlay || ts.LoadingOverlay,
            NoResultsOverlay: r.components && r.components.NoResultsOverlay || ts.NoResultsOverlay,
            NoRowsOverlay: r.components && r.components.NoRowsOverlay || ts.NoRowsOverlay,
            Pagination: r.components && r.components.Pagination || ts.Pagination,
            FilterPanel: r.components && r.components.FilterPanel || ts.FilterPanel,
            ColumnsPanel: r.components && r.components.ColumnsPanel || ts.ColumnsPanel,
            Panel: r.components && r.components.Panel || ts.Panel
        };
    }, [
        r.components
    ]);
    t.current.components = l, t.current.componentsProps = r.componentsProps;
}, ls = ()=>{
    const t = ae(), r = ll(t, il), l = ll(t, Ol), n = ll(t, de), [o] = rl(t);
    return $7fPBF.useMemo(()=>({
            state: o,
            rows: l,
            columns: n,
            options: r,
            apiRef: t,
            rootElement: t.current.rootElementRef
        }), [
        o,
        l,
        n,
        r,
        t
    ]);
}, ns = (e, t)=>{
    var r, l;
    return "v5" === Sr() ? {
        components: {
            MuiDataGrid: {
                defaultProps: {
                    localeText: Object.assign(Object.assign({}, e), {
                        MuiTablePagination: (null === (r = null == t ? void 0 : t.components) || void 0 === r ? void 0 : r.MuiTablePagination.defaultProps) || {}
                    })
                }
            }
        }
    } : {
        props: {
            MuiDataGrid: {
                localeText: Object.assign(Object.assign({}, e), {
                    MuiTablePagination: (null === (l = null == t ? void 0 : t.props) || void 0 === l ? void 0 : l.MuiTablePagination) || {}
                })
            }
        }
    };
}, os = ns({
    noRowsLabel: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0635\u0641\u0648\u0641",
    noResultsOverlayLabel: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0646\u062A\u0627\u0626\u062C.",
    errorOverlayDefaultLabel: "\u062D\u062F\u062B \u062E\u0637\u0623.",
    toolbarDensity: "\u0643\u062B\u0627\u0641\u0629",
    toolbarDensityLabel: "\u0643\u062B\u0627\u0641\u0629",
    toolbarDensityCompact: "\u0645\u062F\u0645\u062C",
    toolbarDensityStandard: "\u0627\u0644\u0645\u0639\u064A\u0627\u0631",
    toolbarDensityComfortable: "\u0645\u0631\u064A\u062D",
    toolbarColumns: "\u0627\u0644\u0623\u0639\u0645\u062F\u0629",
    toolbarColumnsLabel: "\u062D\u062F\u062F \u0627\u0644\u0623\u0639\u0645\u062F\u0629",
    toolbarFilters: "\u0627\u0644\u0641\u0644\u0627\u062A\u0631",
    toolbarFiltersLabel: "\u0627\u0638\u0647\u0631 \u0627\u0644\u0641\u0644\u0627\u062A\u0631",
    toolbarFiltersTooltipHide: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0641\u0644\u0627\u062A\u0631",
    toolbarFiltersTooltipShow: "\u0627\u0638\u0647\u0631 \u0627\u0644\u0641\u0644\u0627\u062A\u0631",
    toolbarFiltersTooltipActive: (e)=>`${e} \u{641}\u{644}\u{627}\u{62A}\u{631} \u{646}\u{634}\u{637}\u{629}`,
    toolbarExport: "\u062A\u0635\u062F\u064A\u0631",
    toolbarExportLabel: "\u062A\u0635\u062F\u064A\u0631",
    toolbarExportCSV: "\u062A\u0646\u0632\u064A\u0644 \u0643\u0645\u0644\u0641 CSV",
    columnsPanelTextFieldLabel: "\u0627\u064A\u062C\u0627\u062F \u0639\u0645\u0648\u062F",
    columnsPanelTextFieldPlaceholder: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0639\u0645\u0648\u062F",
    columnsPanelDragIconLabel: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0639\u0645\u0648\u062F",
    columnsPanelShowAllButton: "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644",
    columnsPanelHideAllButton: "\u0627\u062E\u0641\u0627\u0621 \u0627\u0644\u0643\u0644",
    filterPanelAddFilter: "\u0627\u0636\u0641 \u0641\u0644\u062A\u0631",
    filterPanelDeleteIconLabel: "\u062D\u0630\u0641",
    filterPanelOperators: "\u0627\u0644\u0639\u0627\u0645\u0644\u064A\u0646",
    filterPanelOperatorAnd: "\u0648",
    filterPanelOperatorOr: "\u0627\u0648",
    filterPanelColumns: "\u0627\u0644\u0623\u0639\u0645\u062F\u0629",
    filterPanelInputLabel: "\u0642\u064A\u0645\u0629",
    filterPanelInputPlaceholder: "\u0642\u064A\u0645\u0629 \u0627\u0644\u062A\u0635\u0641\u064A\u0629",
    filterOperatorContains: "\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649",
    filterOperatorEquals: "\u064A\u0633\u0627\u0648\u064A",
    filterOperatorStartsWith: "\u064A\u0628\u062F\u0623 \u0628",
    filterOperatorEndsWith: "\u064A\u0646\u062A\u0647\u064A \u0628\u0640",
    filterOperatorIs: "\u064A\u0643\u0648\u0646",
    filterOperatorNot: "\u0644\u064A\u0633",
    filterOperatorAfter: "\u064A\u0643\u0648\u0646 \u0628\u0639\u062F",
    filterOperatorOnOrAfter: "\u0641\u064A \u0623\u0648 \u0628\u0639\u062F",
    filterOperatorBefore: "\u064A\u0643\u0648\u0646",
    filterOperatorOnOrBefore: "\u0641\u064A \u0623\u0648 \u0642\u0628\u0644",
    filterOperatorIsEmpty: "\u0641\u0627\u0631\u063A",
    filterOperatorIsNotEmpty: "\u0644\u064A\u0633 \u0641\u0627\u0631\u063A\u0627",
    filterValueAny: "\u0623\u064A",
    filterValueTrue: "\u0635\u062D\u064A\u062D",
    filterValueFalse: "\u062E\u0627\u0637\u0626\u0629",
    columnMenuLabel: "\u0627\u0644\u0642\u0627\u0626\u0645\u0629",
    columnMenuShowColumns: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0623\u0639\u0645\u062F\u0629",
    columnMenuFilter: "\u0641\u0644\u062A\u0631",
    columnMenuHideColumn: "\u0625\u062E\u0641\u0627\u0621",
    columnMenuUnsort: "\u063A\u064A\u0631 \u0645\u0631\u062A\u0628",
    columnMenuSortAsc: "\u0627\u0644\u062A\u0631\u062A\u064A\u0628 \u062D\u0633\u0628 ASC",
    columnMenuSortDesc: "\u0627\u0644\u062A\u0631\u062A\u064A\u0628 \u062D\u0633\u0628 DESC",
    columnHeaderFiltersTooltipActive: (e)=>`${e} \u{641}\u{644}\u{627}\u{62A}\u{631} \u{646}\u{634}\u{637}\u{629}`,
    columnHeaderFiltersLabel: "\u0627\u0638\u0647\u0631 \u0627\u0644\u0641\u0644\u0627\u062A\u0631",
    columnHeaderSortIconLabel: "\u062A\u0631\u062A\u064A\u0628",
    footerRowSelected: (e)=>`${e.toLocaleString()} \u{635}\u{641}\u{648}\u{641} \u{645}\u{62E}\u{62A}\u{627}\u{631}\u{629}`,
    footerTotalRows: "\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0635\u0641\u0648\u0641:",
    footerTotalVisibleRows: (e, t)=>`${e.toLocaleString()} \u{645}\u{646} ${t.toLocaleString()}`,
    checkboxSelectionHeaderName: "\u062A\u062D\u062F\u064A\u062F",
    booleanCellTrueLabel: "\u0635\u062D\u064A\u062D",
    booleanCellFalseLabel: "\u062E\u0627\u0637\u0626\u0629"
}, (0, $3NUyv.enUS)), as = ns({
    noRowsLabel: "\u041D\u044F\u043C\u0430 \u0440\u0435\u0434\u043E\u0432\u0435",
    errorOverlayDefaultLabel: "\u0412\u044A\u0437\u043D\u0438\u043A\u043D\u0430 \u0433\u0440\u0435\u0448\u043A\u0430.",
    toolbarDensity: "\u0413\u044A\u0441\u0442\u043E\u0442\u0430",
    toolbarDensityLabel: "\u0413\u044A\u0441\u0442\u043E\u0442\u0430",
    toolbarDensityCompact: "\u041A\u043E\u043C\u043F\u0430\u043A\u0442\u043D\u0430",
    toolbarDensityStandard: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430",
    toolbarDensityComfortable: "\u041A\u043E\u043C\u0444\u043E\u0440\u0442\u043D\u0430",
    toolbarColumns: "\u041A\u043E\u043B\u043E\u043D\u0438",
    toolbarColumnsLabel: "\u041F\u043E\u043A\u0430\u0436\u0438 \u0441\u0435\u043B\u0435\u043A\u0442\u043E\u0440\u0430 \u043D\u0430 \u043A\u043E\u043B\u043E\u043D\u0438",
    toolbarFilters: "\u0424\u0438\u043B\u0442\u0440\u0438",
    toolbarFiltersLabel: "\u041F\u043E\u043A\u0430\u0436\u0438 \u0424\u0438\u043B\u0442\u0440\u0438\u0442\u0435",
    toolbarFiltersTooltipHide: "\u0421\u043A\u0440\u0438\u0439 \u0424\u0438\u043B\u0442\u0440\u0438\u0442\u0435",
    toolbarFiltersTooltipShow: "\u041F\u043E\u043A\u0430\u0436\u0438 \u0424\u0438\u043B\u0442\u0440\u0438\u0442\u0435",
    toolbarFiltersTooltipActive: (e)=>`${e} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{438} \u{444}\u{438}\u{43B}\u{442}\u{440}\u{438}`,
    columnsPanelTextFieldLabel: "\u041D\u0430\u043C\u0435\u0440\u0438 \u043A\u043E\u043B\u043E\u043D\u0430",
    columnsPanelTextFieldPlaceholder: "\u0417\u0430\u0433\u043B\u0430\u0432\u0438\u0435 \u043D\u0430 \u043A\u043E\u043B\u043E\u043D\u0430",
    columnsPanelDragIconLabel: "\u041F\u0440\u0435\u043D\u0430\u0440\u0435\u0434\u0438 \u043D\u0430 \u043A\u043E\u043B\u043E\u043D\u0430",
    columnsPanelShowAllButton: "\u041F\u043E\u043A\u0430\u0436\u0438 \u0412\u0441\u0438\u0447\u043A\u0438",
    columnsPanelHideAllButton: "\u0421\u043A\u0440\u0438\u0439 \u0412\u0441\u0438\u0447\u043A\u0438",
    filterPanelAddFilter: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0424\u0438\u043B\u0442\u044A\u0440",
    filterPanelDeleteIconLabel: "\u0418\u0437\u0442\u0440\u0438\u0439",
    filterPanelOperators: "\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0438",
    filterPanelOperatorAnd: "\u0418",
    filterPanelOperatorOr: "\u0418\u043B\u0438",
    filterPanelColumns: "\u041A\u043E\u043B\u043E\u043D\u0438",
    filterOperatorContains: "\u0441\u044A\u0434\u044A\u0440\u0436\u0430",
    filterOperatorEquals: "\u0440\u0430\u0432\u043D\u043E",
    filterOperatorStartsWith: "\u0437\u0430\u043F\u043E\u0447\u0432\u0430 \u0441",
    filterOperatorEndsWith: "\u0437\u0430\u0432\u044A\u0440\u0448\u0432\u0430 \u0441",
    filterOperatorIs: "\u0435",
    filterOperatorNot: "\u043D\u0435 \u0435",
    filterOperatorAfter: "\u0435 \u0441\u043B\u0435\u0434",
    filterOperatorOnOrAfter: "\u0435 \u043D\u0430 \u0438\u043B\u0438 \u0441\u043B\u0435\u0434",
    filterOperatorBefore: "\u0435 \u043F\u0440\u0435\u0434\u0438",
    filterOperatorOnOrBefore: "\u0435 \u043D\u0430 \u0438\u043B\u0438 \u043F\u0440\u0435\u0434\u0438",
    filterPanelInputLabel: "\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442",
    filterPanelInputPlaceholder: "\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442 \u043D\u0430 \u0444\u0438\u043B\u0442\u044A\u0440\u0430",
    columnMenuLabel: "\u041C\u0435\u043D\u044E",
    columnMenuShowColumns: "\u041F\u043E\u043A\u0430\u0436\u0438 \u043A\u043E\u043B\u043E\u043D\u0438\u0442\u0435",
    columnMenuFilter: "\u0424\u0438\u043B\u0442\u0440\u0438",
    columnMenuHideColumn: "\u0421\u043A\u0440\u0438\u0439",
    columnMenuUnsort: "\u041E\u0442\u043C\u0435\u043D\u0438 \u0441\u043E\u0440\u0442\u0438\u0440\u0430\u043D\u0435\u0442\u043E",
    columnMenuSortAsc: "\u0421\u043E\u0440\u0442\u0438\u0440\u0430\u0439 \u043F\u043E \u0432\u044A\u0437\u0445\u043E\u0434\u044F\u0449 \u0440\u0435\u0434",
    columnMenuSortDesc: "\u0421\u043E\u0440\u0442\u0438\u0440\u0430\u0439 \u043F\u043E \u043D\u0438\u0437\u0445\u043E\u0434\u044F\u0449 \u0440\u0435\u0434",
    columnHeaderFiltersTooltipActive: (e)=>`${e} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{438} \u{444}\u{438}\u{43B}\u{442}\u{440}\u{438}`,
    columnHeaderFiltersLabel: "\u041F\u043E\u043A\u0430\u0436\u0438 \u0424\u0438\u043B\u0442\u0440\u0438\u0442\u0435",
    columnHeaderSortIconLabel: "\u0421\u043E\u0440\u0442\u0438\u0440\u0430\u0439",
    footerRowSelected: (e)=>1 !== e ? `${e.toLocaleString()} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D}\u{438} \u{440}\u{435}\u{434}\u{43E}\u{432}\u{435}` : `${e.toLocaleString()} \u{438}\u{437}\u{431}\u{440}\u{430}\u{43D} \u{440}\u{435}\u{434}`,
    footerTotalRows: "\u041E\u0431\u0449\u043E R\u0435\u0434\u043E\u0432\u0435:"
}, (0, $3NUyv.bgBG)), is = ns({
    noRowsLabel: "\u017D\xe1dn\xe9 z\xe1znamy",
    noResultsOverlayLabel: "Nena\u0161li se \u017Eadn\xe9 v\xfdsledky.",
    errorOverlayDefaultLabel: "Stala sa nep\u0159edv\xeddan\xe1 chyba.",
    toolbarDensity: "Hustota",
    toolbarDensityLabel: "Hustota",
    toolbarDensityCompact: "Kompaktn\xed",
    toolbarDensityStandard: "Standartn\xed",
    toolbarDensityComfortable: "Komfortn\xed",
    toolbarColumns: "Sloupce",
    toolbarColumnsLabel: "Vybrat sloupec",
    toolbarFilters: "Filtry",
    toolbarFiltersLabel: "Zobrazit filtry",
    toolbarFiltersTooltipHide: "Skr\xfdt filtry",
    toolbarFiltersTooltipShow: "Zobrazit filtry",
    toolbarFiltersTooltipActive: (e)=>{
        let t = "aktivn\xedch filtr\u016F";
        return e > 1 && e < 5 ? t = "aktivn\xed filtry" : 1 === e && (t = "aktivn\xed filtr"), `${e} ${t}`;
    },
    toolbarExport: "Export",
    toolbarExportLabel: "Export",
    toolbarExportCSV: "St\xe1hnout jako CSV",
    columnsPanelTextFieldLabel: "Naj\xedt sloupec",
    columnsPanelTextFieldPlaceholder: "N\xe1zev sloupce",
    columnsPanelDragIconLabel: "Uspo\u0159\xe1dat sloupce",
    columnsPanelShowAllButton: "Zobrazit v\u0161e",
    columnsPanelHideAllButton: "Skr\xfdt v\u0161e",
    filterPanelAddFilter: "P\u0159idat filtr",
    filterPanelDeleteIconLabel: "Odstranit",
    filterPanelOperators: "Oper\xe1tory",
    filterPanelOperatorAnd: "A",
    filterPanelOperatorOr: "Nebo",
    filterPanelColumns: "Sloupce",
    filterPanelInputLabel: "Hodnota",
    filterPanelInputPlaceholder: "Hodnota filtru",
    filterOperatorContains: "obsahuje",
    filterOperatorEquals: "rovn\xe1 se",
    filterOperatorStartsWith: "za\u010D\xedn\xe1 s",
    filterOperatorEndsWith: "kon\u010D\xed na",
    filterOperatorIs: "je",
    filterOperatorNot: "nen\xed",
    filterOperatorAfter: "je po",
    filterOperatorOnOrAfter: "je na nebo po",
    filterOperatorBefore: "je p\u0159ed",
    filterOperatorOnOrBefore: "je na nebo d\u0159\xedve",
    filterValueAny: "jak\xfdkoliv",
    filterValueTrue: "ano",
    filterValueFalse: "ne",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Zobrazit sloupce",
    columnMenuFilter: "Filtr",
    columnMenuHideColumn: "Skr\xfdt",
    columnMenuUnsort: "Zru\u0161it filtry",
    columnMenuSortAsc: "Se\u0159adit vzestupn\u011B",
    columnMenuSortDesc: "Se\u0159adit sestupn\u011B",
    columnHeaderFiltersTooltipActive: (e)=>{
        let t = "aktivn\xedch filtr\u016F";
        return e > 1 && e < 5 ? t = "aktivn\xed filtry" : 1 === e && (t = "aktivn\xed filtr"), `${e} ${t}`;
    },
    columnHeaderFiltersLabel: "Zobrazit filtry",
    columnHeaderSortIconLabel: "Filtrovat",
    footerRowSelected: (e)=>{
        let t = "vybran\xfdch z\xe1znam\u016F";
        return e > 1 && e < 5 ? t = "vybran\xe9 z\xe1znamy" : 1 === e && (t = "vybran\xfd z\xe1znam"), `${e} ${t}`;
    },
    footerTotalRows: "Celkem \u0159\xe1dk\u016F:",
    checkboxSelectionHeaderName: "V\xfdb\u011Br \u0159\xe1dku",
    booleanCellTrueLabel: "ano",
    booleanCellFalseLabel: "ne"
}, (0, $3NUyv.csCZ)), ss = ns({
    noRowsLabel: "Keine Eintr\xe4ge",
    noResultsOverlayLabel: "Keine Ergebnisse gefunden.",
    errorOverlayDefaultLabel: "Ein unerwarteter Fehler ist aufgetreten.",
    toolbarDensity: "Zeilenh\xf6he",
    toolbarDensityLabel: "Zeilenh\xf6he",
    toolbarDensityCompact: "Kompakt",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Breit",
    toolbarColumns: "Spalten",
    toolbarColumnsLabel: "Zeige Spaltenauswahl",
    toolbarFilters: "Filter",
    toolbarFiltersLabel: "Zeige Filter",
    toolbarFiltersTooltipHide: "Verberge Filter",
    toolbarFiltersTooltipShow: "Zeige Filter",
    toolbarFiltersTooltipActive: (e)=>1 !== e ? `${e} aktive Filter` : `${e} aktiver Filter`,
    toolbarExport: "Exportieren",
    toolbarExportLabel: "Exportieren",
    toolbarExportCSV: "Download als CSV",
    columnsPanelTextFieldLabel: "Finde Spalte",
    columnsPanelTextFieldPlaceholder: "Spalten\xfcberschrift",
    columnsPanelDragIconLabel: "Spalte umsortieren",
    columnsPanelShowAllButton: "Zeige alle",
    columnsPanelHideAllButton: "Verberge alle",
    filterPanelAddFilter: "Filter hinzuf\xfcgen",
    filterPanelDeleteIconLabel: "L\xf6schen",
    filterPanelOperators: "Operatoren",
    filterPanelOperatorAnd: "Und",
    filterPanelOperatorOr: "Oder",
    filterPanelColumns: "Spalten",
    filterPanelInputLabel: "Wert",
    filterPanelInputPlaceholder: "Wert filtern",
    filterOperatorContains: "beinhaltet",
    filterOperatorEquals: "ist gleich",
    filterOperatorStartsWith: "beginnt mit",
    filterOperatorEndsWith: "endet mit",
    filterOperatorIs: "ist",
    filterOperatorNot: "ist nicht",
    filterOperatorOnOrAfter: "ist an oder nach",
    filterOperatorBefore: "ist vor",
    filterOperatorOnOrBefore: "ist an oder vor",
    filterOperatorAfter: "ist nach",
    filterOperatorIsEmpty: "ist leer",
    filterOperatorIsNotEmpty: "ist nicht leer",
    columnMenuLabel: "Men\xfc",
    columnMenuShowColumns: "Zeige alle Spalten",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Verbergen",
    columnMenuUnsort: "Sortierung deaktivieren",
    columnMenuSortAsc: "Sortiere aufsteigend",
    columnMenuSortDesc: "Sortiere absteigend",
    columnHeaderFiltersTooltipActive: (e)=>1 !== e ? `${e} aktive Filter` : `${e} aktiver Filter`,
    columnHeaderFiltersLabel: "Zeige Filter",
    columnHeaderSortIconLabel: "Sortieren",
    footerRowSelected: (e)=>1 !== e ? `${e.toLocaleString()} Eintr\xe4ge ausgew\xe4hlt` : `${e.toLocaleString()} Eintrag ausgew\xe4hlt`,
    footerTotalRows: "Gesamt:",
    footerTotalVisibleRows: (e, t)=>`${e.toLocaleString()} von ${t.toLocaleString()}`
}, (0, $3NUyv.deDE)), cs = ns({
    noRowsLabel: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03BA\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03AE\u03C3\u03B5\u03B9\u03C2",
    errorOverlayDefaultLabel: "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03B1\u03C0\u03C1\u03CC\u03B2\u03BB\u03B5\u03C0\u03C4\u03BF \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1.",
    toolbarDensity: "\u038E\u03C8\u03BF\u03C2 \u03C3\u03B5\u03B9\u03C1\u03AC\u03C2",
    toolbarDensityLabel: "\u038E\u03C8\u03BF\u03C2 \u03C3\u03B5\u03B9\u03C1\u03AC\u03C2",
    toolbarDensityCompact: "\u03A3\u03C5\u03BC\u03C0\u03B1\u03B3\u03AE\u03C2",
    toolbarDensityStandard: "\u03A0\u03C1\u03BF\u03BA\u03B1\u03B8\u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03BF",
    toolbarDensityComfortable: "\u03A0\u03BB\u03B1\u03C4\u03CD",
    toolbarColumns: "\u03A3\u03C4\u03AE\u03BB\u03B5\u03C2",
    toolbarColumnsLabel: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C3\u03C4\u03AE\u03BB\u03B5\u03C2",
    toolbarFilters: "\u03A6\u03AF\u03BB\u03C4\u03C1\u03B1",
    toolbarFiltersLabel: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C6\u03AF\u03BB\u03C4\u03C1\u03C9\u03BD",
    toolbarFiltersTooltipHide: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03C6\u03AF\u03BB\u03C4\u03C1\u03C9\u03BD",
    toolbarFiltersTooltipShow: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C6\u03AF\u03BB\u03C4\u03C1\u03C9\u03BD",
    toolbarFiltersTooltipActive: (e)=>1 !== e ? `${e} \u{3B5}\u{3BD}\u{3B5}\u{3C1}\u{3B3}\u{3AC} \u{3C6}\u{3AF}\u{3BB}\u{3C4}\u{3C1}\u{3B1}` : `${e} \u{3B5}\u{3BD}\u{3B5}\u{3C1}\u{3B3}\u{3CC} \u{3C6}\u{3AF}\u{3BB}\u{3C4}\u{3C1}\u{3BF}`,
    toolbarExport: "\u0395\u03BE\u03B1\u03B3\u03C9\u03B3\u03AE",
    toolbarExportLabel: "\u0395\u03BE\u03B1\u03B3\u03C9\u03B3\u03AE",
    toolbarExportCSV: "\u039B\u03AE\u03C8\u03B7 \u03C9\u03C2 CSV",
    columnsPanelTextFieldLabel: "\u0395\u03CD\u03C1\u03B5\u03C3\u03B7 \u03C3\u03C4\u03AE\u03BB\u03B7\u03C2",
    columnsPanelTextFieldPlaceholder: "\u0395\u03C0\u03B9\u03BA\u03B5\u03C6\u03B1\u03BB\u03AF\u03B4\u03B1 \u03C3\u03C4\u03AE\u03BB\u03B7\u03C2",
    columnsPanelDragIconLabel: "\u0391\u03BD\u03B1\u03B4\u03B9\u03AC\u03C4\u03B1\u03BE\u03B7 \u03C3\u03C4\u03AE\u03BB\u03B7\u03C2",
    columnsPanelShowAllButton: "\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03CC\u03BB\u03C9\u03BD",
    columnsPanelHideAllButton: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03CC\u03BB\u03C9\u03BD",
    filterPanelAddFilter: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF\u03C5",
    filterPanelDeleteIconLabel: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE",
    filterPanelOperators: "\u03A4\u03B5\u03BB\u03B5\u03C3\u03C4\u03AD\u03C2",
    filterPanelOperatorAnd: "\u039A\u03B1\u03AF",
    filterPanelOperatorOr: "\u0389",
    filterPanelColumns: "\u03A3\u03C4\u03AE\u03BB\u03B5\u03C2",
    filterPanelInputLabel: "\u03A4\u03B9\u03BC\u03AE",
    filterPanelInputPlaceholder: "\u03A4\u03B9\u03BC\u03AE \u03C6\u03AF\u03BB\u03C4\u03C1\u03BF\u03C5",
    filterOperatorContains: "\u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9",
    filterOperatorEquals: "\u03B9\u03C3\u03BF\u03CD\u03C4\u03B1\u03B9",
    filterOperatorStartsWith: "\u03BE\u03B5\u03BA\u03B9\u03BD\u03AC\u03B5\u03B9 \u03BC\u03B5",
    filterOperatorEndsWith: "\u03C4\u03B5\u03BB\u03B5\u03B9\u03CE\u03BD\u03B5\u03B9 \u03BC\u03B5",
    filterOperatorIs: "\u03B5\u03AF\u03BD\u03B1\u03B9",
    filterOperatorNot: "\u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9",
    filterOperatorAfter: "\u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03C4\u03AC",
    filterOperatorOnOrAfter: "\u03B5\u03AF\u03BD\u03B1\u03B9 \u03AF\u03C3\u03BF \u03AE \u03BC\u03B5\u03C4\u03AC",
    filterOperatorBefore: "\u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03B9\u03BD",
    filterOperatorOnOrBefore: "\u03B5\u03AF\u03BD\u03B1\u03B9 \u03AF\u03C3\u03BF \u03AE \u03C0\u03C1\u03B9\u03BD",
    columnMenuLabel: "\u039C\u03B5\u03BD\u03BF\u03CD",
    columnMenuShowColumns: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BB\u03CE\u03BD",
    columnMenuFilter: "\u03A6\u03AF\u03BB\u03C4\u03C1\u03BF",
    columnMenuHideColumn: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7",
    columnMenuUnsort: "\u0391\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C4\u03B1\u03BE\u03B9\u03BD\u03CC\u03BC\u03B7\u03C3\u03B7\u03C2",
    columnMenuSortAsc: "\u03A4\u03B1\u03BE\u03B9\u03BD\u03CC\u03BC\u03B7\u03C3\u03B7 \u03C3\u03B5 \u03B1\u03CD\u03BE\u03BF\u03C5\u03C3\u03B1 \u03C3\u03B5\u03B9\u03C1\u03AC",
    columnMenuSortDesc: "\u03A4\u03B1\u03BE\u03B9\u03BD\u03CC\u03BC\u03B7\u03C3\u03B7 \u03C3\u03B5 \u03C6\u03B8\u03AF\u03BD\u03BF\u03C5\u03C3\u03B1 \u03C3\u03B5\u03B9\u03C1\u03AC",
    columnHeaderFiltersTooltipActive: (e)=>1 !== e ? `${e} \u{3B5}\u{3BD}\u{3B5}\u{3C1}\u{3B3}\u{3AC} \u{3C6}\u{3AF}\u{3BB}\u{3C4}\u{3C1}\u{3B1}` : `${e} \u{3B5}\u{3BD}\u{3B5}\u{3C1}\u{3B3}\u{3CC} \u{3C6}\u{3AF}\u{3BB}\u{3C4}\u{3C1}\u{3BF}`,
    columnHeaderFiltersLabel: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C6\u03AF\u03BB\u03C4\u03C1\u03C9\u03BD",
    columnHeaderSortIconLabel: "\u03A4\u03B1\u03BE\u03B9\u03BD\u03CC\u03BC\u03B7\u03C3\u03B7",
    footerRowSelected: (e)=>1 !== e ? `${e.toLocaleString()} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B5}\u{3C2} \u{3B3}\u{3C1}\u{3B1}\u{3BC}\u{3BC}\u{3AD}\u{3C2}` : `${e.toLocaleString()} \u{3B5}\u{3C0}\u{3B9}\u{3BB}\u{3B5}\u{3B3}\u{3BC}\u{3AD}\u{3BD}\u{3B7} \u{3B3}\u{3C1}\u{3B1}\u{3BC}\u{3BC}\u{3AE}`,
    footerTotalRows: "\u03A3\u03CD\u03BD\u03BF\u03BB\u03BF \u0393\u03C1\u03B1\u03BC\u03BC\u03CE\u03BD:"
}), us = ns(Nr, (0, $3NUyv.enUS)), ds = ns({
    noRowsLabel: "Sin filas",
    errorOverlayDefaultLabel: "Ha ocurrido un error.",
    toolbarDensity: "Densidad",
    toolbarDensityLabel: "Densidad",
    toolbarDensityCompact: "Compacta",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Comoda",
    toolbarColumns: "Columnas",
    toolbarColumnsLabel: "Seleccionar columnas",
    toolbarFilters: "Filtros",
    toolbarFiltersLabel: "Mostrar filtros",
    toolbarFiltersTooltipHide: "Ocultar filtros",
    toolbarFiltersTooltipShow: "Mostrar filtros",
    toolbarFiltersTooltipActive: (e)=>e > 1 ? `${e} filtros activos` : `${e} filtro activo`,
    toolbarExport: "Exportar",
    toolbarExportLabel: "Exportar",
    toolbarExportCSV: "Descargar como CSV",
    columnsPanelTextFieldLabel: "Columna de b\xfasqueda",
    columnsPanelTextFieldPlaceholder: "T\xedtulo de columna",
    columnsPanelDragIconLabel: "Reorder columna",
    columnsPanelShowAllButton: "Mostrar todo",
    columnsPanelHideAllButton: "Ocultar todo",
    filterPanelAddFilter: "Agregar filtro",
    filterPanelDeleteIconLabel: "Borrar",
    filterPanelOperators: "Operadores",
    filterPanelOperatorAnd: "Y",
    filterPanelOperatorOr: "O",
    filterPanelColumns: "Columnas",
    filterPanelInputLabel: "Valor",
    filterPanelInputPlaceholder: "Valor de filtro",
    filterOperatorContains: "contiene",
    filterOperatorEquals: "es igual",
    filterOperatorStartsWith: "comienza con",
    filterOperatorEndsWith: "termina con",
    filterOperatorIs: "es",
    filterOperatorNot: "no es",
    filterOperatorAfter: "es posterior",
    filterOperatorOnOrAfter: "es en o posterior",
    filterOperatorBefore: "es anterior",
    filterOperatorOnOrBefore: "es en o anterior",
    filterOperatorIsEmpty: "est\xe1 vac\xedo",
    filterOperatorIsNotEmpty: "no esta vac\xedo",
    columnMenuLabel: "Men\xfa",
    columnMenuShowColumns: "Mostrar columnas",
    columnMenuFilter: "Filtro",
    columnMenuHideColumn: "Ocultar",
    columnMenuUnsort: "Desordenar",
    columnMenuSortAsc: "Ordenar ASC",
    columnMenuSortDesc: "Ordenar DESC",
    columnHeaderFiltersTooltipActive: (e)=>e > 1 ? `${e} filtros activos` : `${e} filtro activo`,
    columnHeaderFiltersLabel: "Mostrar filtros",
    columnHeaderSortIconLabel: "Ordenar",
    footerRowSelected: (e)=>e > 1 ? `${e.toLocaleString()} filas seleccionadas` : `${e.toLocaleString()} fila seleccionada`,
    footerTotalRows: "Filas Totales:",
    footerTotalVisibleRows: (e, t)=>`${e.toLocaleString()} de ${t.toLocaleString()}`
}, (0, $3NUyv.esES)), ps = ns({
    noRowsLabel: "Pas de r\xe9sultats",
    noResultsOverlayLabel: "Aucun r\xe9sultat.",
    errorOverlayDefaultLabel: "Une erreur est apparue.",
    toolbarDensity: "Densit\xe9",
    toolbarDensityLabel: "Densit\xe9",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Confortable",
    toolbarColumns: "Colonnes",
    toolbarColumnsLabel: "Choisir les colonnes",
    toolbarFilters: "Filtres",
    toolbarFiltersLabel: "Afficher les filtres",
    toolbarFiltersTooltipHide: "Cacher les filtres",
    toolbarFiltersTooltipShow: "Afficher les filtres",
    toolbarFiltersTooltipActive: (e)=>e > 1 ? `${e} filtres actifs` : `${e} filtre actif`,
    toolbarExport: "Exporter",
    toolbarExportLabel: "Exporter",
    toolbarExportCSV: "T\xe9l\xe9charger en CSV",
    columnsPanelTextFieldLabel: "Chercher colonne",
    columnsPanelTextFieldPlaceholder: "Titre de la colonne",
    columnsPanelDragIconLabel: "R\xe9organiser la colonne",
    columnsPanelShowAllButton: "Tout afficher",
    columnsPanelHideAllButton: "Tout cacher",
    filterPanelAddFilter: "Ajouter un filtre",
    filterPanelDeleteIconLabel: "Supprimer",
    filterPanelOperators: "Op\xe9rateurs",
    filterPanelOperatorAnd: "Et",
    filterPanelOperatorOr: "Ou",
    filterPanelColumns: "Colonnes",
    filterPanelInputLabel: "Valeur",
    filterPanelInputPlaceholder: "Filtrer la valeur",
    filterOperatorContains: "contient",
    filterOperatorEquals: "\xe9gal \xe0",
    filterOperatorStartsWith: "commence par",
    filterOperatorEndsWith: "se termine par",
    filterOperatorIs: "est",
    filterOperatorNot: "n'est pas",
    filterOperatorOnOrAfter: "\xe9gal ou post\xe9rieur",
    filterOperatorAfter: "post\xe9rieur",
    filterOperatorOnOrBefore: "\xe9gal ou ant\xe9rieur",
    filterOperatorBefore: "ant\xe9rieur",
    filterOperatorIsEmpty: "est vide",
    filterOperatorIsNotEmpty: "n'est pas vide",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Afficher les colonnes",
    columnMenuFilter: "Filtrer",
    columnMenuHideColumn: "Cacher",
    columnMenuUnsort: "Annuler le tri",
    columnMenuSortAsc: "Tri ascendant",
    columnMenuSortDesc: "Tri descendant",
    columnHeaderFiltersTooltipActive: (e)=>e > 1 ? `${e} filtres actifs` : `${e} filtre actif`,
    columnHeaderFiltersLabel: "Afficher les filtres",
    columnHeaderSortIconLabel: "Trier",
    footerRowSelected: (e)=>e > 1 ? `${e.toLocaleString()} lignes s\xe9lectionn\xe9es` : `${e.toLocaleString()} ligne s\xe9lectionn\xe9e`,
    footerTotalRows: "Lignes totales :",
    footerTotalVisibleRows: (e, t)=>`${e.toLocaleString()} sur ${t.toLocaleString()}`,
    checkboxSelectionHeaderName: "S\xe9lection"
}, (0, $3NUyv.frFR)), ms = ns({
    noRowsLabel: "Nessun record",
    noResultsOverlayLabel: "Nessun record trovato.",
    errorOverlayDefaultLabel: "Si \xe8 verificato un errore.",
    toolbarDensity: "Densit\xe0",
    toolbarDensityLabel: "Densit\xe0",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Confortable",
    toolbarColumns: "Colonne",
    toolbarColumnsLabel: "Seleziona le colonne",
    toolbarFilters: "Filtri",
    toolbarFiltersLabel: "Mostra i filtri",
    toolbarFiltersTooltipHide: "Nascondi i filtri",
    toolbarFiltersTooltipShow: "Mostra i filtri",
    toolbarFiltersTooltipActive: (e)=>e > 1 ? `${e} filtri attivi` : `${e} filtro attivo`,
    columnsPanelTextFieldLabel: "Cerca colonna",
    columnsPanelTextFieldPlaceholder: "Titolo della colonna",
    columnsPanelDragIconLabel: "Riordina la colonna",
    columnsPanelShowAllButton: "Mostra tutto",
    columnsPanelHideAllButton: "Nascondi tutto",
    filterPanelAddFilter: "Aggiungi un filtro",
    filterPanelDeleteIconLabel: "Rimuovi",
    filterPanelOperators: "Operatori",
    filterPanelOperatorAnd: "E (and)",
    filterPanelOperatorOr: "O (or)",
    filterPanelColumns: "Colonne",
    filterPanelInputLabel: "Valore",
    filterPanelInputPlaceholder: "Filtra il valore",
    filterOperatorContains: "contiene",
    filterOperatorEquals: "uguale a",
    filterOperatorStartsWith: "comincia per",
    filterOperatorEndsWith: "termina per",
    filterOperatorIs: "uguale a",
    filterOperatorNot: "diversa da",
    filterOperatorOnOrAfter: "a partire dal",
    filterOperatorAfter: "dopo il",
    filterOperatorOnOrBefore: "fino al",
    filterOperatorBefore: "prima del",
    filterOperatorIsEmpty: "\xe8 vuoto",
    filterOperatorIsNotEmpty: "non \xe8 vuoto",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Mostra le colonne",
    columnMenuFilter: "Filtra",
    columnMenuHideColumn: "Nascondi",
    columnMenuUnsort: "Annulla l'ordinamento",
    columnMenuSortAsc: "Ordinamento crescente",
    columnMenuSortDesc: "Ordinamento decrescente",
    columnHeaderFiltersTooltipActive: (e)=>e > 1 ? `${e} filtri attivi` : `${e} filtro attivo`,
    columnHeaderFiltersLabel: "Mostra i filtri",
    columnHeaderSortIconLabel: "Ordina",
    footerRowSelected: (e)=>e > 1 ? `${e.toLocaleString()} record selezionati` : `${e.toLocaleString()} record selezionato`,
    footerTotalRows: "Record totali :",
    footerTotalVisibleRows: (e, t)=>`${e.toLocaleString()} di ${t.toLocaleString()}`,
    checkboxSelectionHeaderName: "Seleziona"
}, (0, $3NUyv.itIT)), fs = ns({
    noRowsLabel: "\u884C\u304C\u3042\u308A\u307E\u305B\u3093",
    errorOverlayDefaultLabel: "\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    toolbarDensity: "\u884C\u9593\u9694",
    toolbarDensityLabel: "\u884C\u9593\u9694",
    toolbarDensityCompact: "\u30B3\u30F3\u30D1\u30AF\u30C8",
    toolbarDensityStandard: "\u6A19\u6E96",
    toolbarDensityComfortable: "\u3072\u308D\u3081",
    toolbarColumns: "\u5217\u4E00\u89A7",
    toolbarColumnsLabel: "\u5217\u9078\u629E",
    toolbarFilters: "\u30D5\u30A3\u30EB\u30BF\u30FC",
    toolbarFiltersLabel: "\u30D5\u30A3\u30EB\u30BF\u30FC\u8868\u793A",
    toolbarFiltersTooltipHide: "\u30D5\u30A3\u30EB\u30BF\u30FC\u975E\u8868\u793A",
    toolbarFiltersTooltipShow: "\u30D5\u30A3\u30EB\u30BF\u30FC\u8868\u793A",
    toolbarFiltersTooltipActive: (e)=>`${e}\u{4EF6}\u{306E}\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}\u{3092}\u{9069}\u{7528}\u{4E2D}`,
    toolbarExport: "\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
    toolbarExportLabel: "\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
    toolbarExportCSV: "CSV\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
    columnsPanelTextFieldLabel: "\u5217\u691C\u7D22",
    columnsPanelTextFieldPlaceholder: "\u691C\u7D22\u30AF\u30A8\u30EA\u3092\u5165\u529B...",
    columnsPanelDragIconLabel: "\u5217\u4E26\u3079\u66FF\u3048",
    columnsPanelShowAllButton: "\u3059\u3079\u3066\u8868\u793A",
    columnsPanelHideAllButton: "\u3059\u3079\u3066\u975E\u8868\u793A",
    filterPanelAddFilter: "\u30D5\u30A3\u30EB\u30BF\u30FC\u8FFD\u52A0",
    filterPanelDeleteIconLabel: "\u524A\u9664",
    filterPanelOperators: "\u30AA\u30DA\u30EC\u30FC\u30BF",
    filterPanelOperatorAnd: "And",
    filterPanelOperatorOr: "Or",
    filterPanelColumns: "\u5217",
    filterPanelInputLabel: "\u5024",
    filterPanelInputPlaceholder: "\u5024\u3092\u5165\u529B...",
    filterOperatorContains: "...\u3092\u542B\u3080",
    filterOperatorEquals: "...\u306B\u7B49\u3057\u3044",
    filterOperatorStartsWith: "...\u3067\u59CB\u307E\u308B",
    filterOperatorEndsWith: "...\u3067\u7D42\u308F\u308B",
    filterOperatorIs: "...\u3067\u3042\u308B",
    filterOperatorNot: "...\u3067\u306A\u3044",
    filterOperatorAfter: "...\u3088\u308A\u5F8C\u308D",
    filterOperatorOnOrAfter: "...\u4EE5\u964D",
    filterOperatorBefore: "...\u3088\u308A\u524D",
    filterOperatorOnOrBefore: "...\u4EE5\u524D",
    columnMenuLabel: "\u30E1\u30CB\u30E5\u30FC",
    columnMenuShowColumns: "\u5217\u8868\u793A",
    columnMenuFilter: "\u30D5\u30A3\u30EB\u30BF\u30FC",
    columnMenuHideColumn: "\u5217\u975E\u8868\u793A",
    columnMenuUnsort: "\u30BD\u30FC\u30C8\u89E3\u9664",
    columnMenuSortAsc: "\u6607\u9806\u30BD\u30FC\u30C8",
    columnMenuSortDesc: "\u964D\u9806\u30BD\u30FC\u30C8",
    columnHeaderFiltersTooltipActive: (e)=>`${e}\u{4EF6}\u{306E}\u{30D5}\u{30A3}\u{30EB}\u{30BF}\u{30FC}\u{3092}\u{9069}\u{7528}\u{4E2D}`,
    columnHeaderFiltersLabel: "\u30D5\u30A3\u30EB\u30BF\u30FC\u8868\u793A",
    columnHeaderSortIconLabel: "\u30BD\u30FC\u30C8",
    footerRowSelected: (e)=>`${e}\u{884C}\u{3092}\u{9078}\u{629E}\u{4E2D}`,
    footerTotalRows: "\u7DCF\u884C\u6570:"
}, (0, $3NUyv.jaJP)), gs = ns({
    noRowsLabel: "Geen resultaten.",
    errorOverlayDefaultLabel: "Er deed zich een fout voor.",
    toolbarDensity: "Grootte",
    toolbarDensityLabel: "Grootte",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Normaal",
    toolbarDensityComfortable: "Breed",
    toolbarColumns: "Kolommen",
    toolbarColumnsLabel: "Kies kolommen",
    toolbarFilters: "Filters",
    toolbarFiltersLabel: "Toon filters",
    toolbarFiltersTooltipHide: "Verberg filters",
    toolbarFiltersTooltipShow: "Toon filters",
    toolbarFiltersTooltipActive: (e)=>e > 1 ? `${e} actieve filters` : `${e} filter actief`,
    columnsPanelTextFieldLabel: "Zoek kolom",
    columnsPanelTextFieldPlaceholder: "Kolomtitel",
    columnsPanelDragIconLabel: "Kolom herschikken",
    columnsPanelShowAllButton: "Alles tonen",
    columnsPanelHideAllButton: "Alles verbergen",
    filterPanelAddFilter: "Filter toevoegen",
    filterPanelDeleteIconLabel: "Verwijderen",
    filterPanelOperators: "Operatoren",
    filterPanelOperatorAnd: "En",
    filterPanelOperatorOr: "Of",
    filterPanelColumns: "Kolommen",
    filterPanelInputLabel: "Waarde",
    filterPanelInputPlaceholder: "Filter waarde",
    filterOperatorContains: "bevat",
    filterOperatorEquals: "gelijk aan",
    filterOperatorStartsWith: "begint met",
    filterOperatorEndsWith: "eindigt met",
    filterOperatorIs: "is",
    filterOperatorNot: "is niet",
    filterOperatorOnOrAfter: "is gelijk of er voor",
    filterOperatorAfter: "is voor",
    filterOperatorOnOrBefore: "is gelijk of er na",
    filterOperatorBefore: "is na",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Toon kolommen",
    columnMenuFilter: "Filteren",
    columnMenuHideColumn: "Verbergen",
    columnMenuUnsort: "Annuleer sortering",
    columnMenuSortAsc: "Oplopend sorteren",
    columnMenuSortDesc: "Aflopend sorteren",
    columnHeaderFiltersTooltipActive: (e)=>e > 1 ? `${e} actieve filters` : `${e} filter actief`,
    columnHeaderFiltersLabel: "Toon filters",
    columnHeaderSortIconLabel: "Sorteren",
    footerRowSelected: (e)=>e > 1 ? `${e.toLocaleString()} rijen geselecteerd` : `${e.toLocaleString()} rij geselecteerd`,
    footerTotalRows: "Totaal:"
}, (0, $3NUyv.nlNL)), bs = {
    noRowsLabel: "Brak danych",
    errorOverlayDefaultLabel: "Wyst\u0105pi\u0142 b\u0142\u0105d.",
    toolbarDensity: "Wysoko\u015B\u0107 rz\u0119du",
    toolbarDensityLabel: "Wysoko\u015B\u0107 rz\u0119du",
    toolbarDensityCompact: "Kompakt",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Komfort",
    toolbarColumns: "Kolumny",
    toolbarColumnsLabel: "Zaznacz kolumny",
    toolbarFilters: "Filtry",
    toolbarFiltersLabel: "Poka\u017C filtry",
    toolbarFiltersTooltipHide: "Ukryj filtry",
    toolbarFiltersTooltipShow: "Poka\u017C filtry",
    toolbarFiltersTooltipActive: (e)=>`Liczba aktywnych filtr\xf3w: ${e}`,
    toolbarExport: "Eksportuj",
    toolbarExportLabel: "Eksportuj",
    toolbarExportCSV: "Pobierz jako plik CSV",
    columnsPanelTextFieldLabel: "Znajd\u017A kolumn\u0119",
    columnsPanelTextFieldPlaceholder: "Tytu\u0142 kolumny",
    columnsPanelDragIconLabel: "Zmie\u0144 kolejno\u015B\u0107 kolumn",
    columnsPanelShowAllButton: "Poka\u017C wszystko",
    columnsPanelHideAllButton: "Ukryj wszystko",
    filterPanelAddFilter: "Dodaj filtr",
    filterPanelDeleteIconLabel: "Usu\u0144",
    filterPanelOperators: "Operator",
    filterPanelOperatorAnd: "I",
    filterPanelOperatorOr: "Lub",
    filterPanelColumns: "Kolumny",
    filterPanelInputLabel: "Warto\u015B\u0107",
    filterPanelInputPlaceholder: "Filtrowana warto\u015B\u0107",
    filterOperatorContains: "zawiera",
    filterOperatorEquals: "r\xf3wna si\u0119",
    filterOperatorStartsWith: "zaczyna si\u0119 od",
    filterOperatorEndsWith: "ko\u0144czy si\u0119 na",
    filterOperatorIs: "r\xf3wna si\u0119",
    filterOperatorNot: "r\xf3\u017Cne",
    filterOperatorAfter: "wi\u0119ksze ni\u017C",
    filterOperatorOnOrAfter: "wi\u0119ksze lub r\xf3wne",
    filterOperatorBefore: "mniejsze ni\u017C",
    filterOperatorOnOrBefore: "mniejsze lub r\xf3wne",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Poka\u017C wszystkie kolumny",
    columnMenuFilter: "Filtr",
    columnMenuHideColumn: "Ukryj",
    columnMenuUnsort: "Anuluj sortowanie",
    columnMenuSortAsc: "Sortuj rosn\u0105co",
    columnMenuSortDesc: "Sortuj malej\u0105co",
    columnHeaderFiltersTooltipActive: (e)=>`Liczba aktywnych filtr\xf3w: ${e}`,
    columnHeaderFiltersLabel: "Poka\u017C filtry",
    columnHeaderSortIconLabel: "Sortuj",
    footerRowSelected: (e)=>`Liczba wybranych wierszy: ${e.toLocaleString()}`,
    footerTotalRows: "\u0141\u0105czna liczba wierszy:"
}, hs = ns(bs, (0, $3NUyv.plPL)), vs = ns({
    noRowsLabel: "Nenhuma linha",
    noResultsOverlayLabel: "Nenhum resultado encontrado.",
    errorOverlayDefaultLabel: "Ocorreu um erro.",
    toolbarDensity: "Densidade",
    toolbarDensityLabel: "Densidade",
    toolbarDensityCompact: "Compacto",
    toolbarDensityStandard: "Padr\xe3o",
    toolbarDensityComfortable: "Confort\xe1vel",
    toolbarColumns: "Colunas",
    toolbarColumnsLabel: "Exibir seletor de colunas",
    toolbarFilters: "Filtros",
    toolbarFiltersLabel: "Exibir filtros",
    toolbarFiltersTooltipHide: "Ocultar filtros",
    toolbarFiltersTooltipShow: "Exibir filtros",
    toolbarFiltersTooltipActive: (e)=>`${e} ${1 !== e ? "filtros" : "filtro"} ${1 !== e ? "ativos" : "ativo"}`,
    toolbarExport: "Exportar",
    toolbarExportLabel: "Exportar",
    toolbarExportCSV: "Baixar como CSV",
    columnsPanelTextFieldLabel: "Localizar coluna",
    columnsPanelTextFieldPlaceholder: "T\xedtulo da coluna",
    columnsPanelDragIconLabel: "Reordenar Coluna",
    columnsPanelShowAllButton: "Mostrar todas",
    columnsPanelHideAllButton: "Ocultar todas",
    filterPanelAddFilter: "Adicionar filtro",
    filterPanelDeleteIconLabel: "Excluir",
    filterPanelOperators: "Operadores",
    filterPanelOperatorAnd: "E",
    filterPanelOperatorOr: "Ou",
    filterPanelColumns: "Colunas",
    filterPanelInputLabel: "Valor",
    filterPanelInputPlaceholder: "Filtrar valor",
    filterOperatorContains: "cont\xe9m",
    filterOperatorEquals: "\xe9 igual a",
    filterOperatorStartsWith: "come\xe7a com",
    filterOperatorEndsWith: "termina com",
    filterOperatorIs: "\xe9",
    filterOperatorNot: "n\xe3o \xe9",
    filterOperatorOnOrAfter: "em ou ap\xf3s",
    filterOperatorBefore: "antes de",
    filterOperatorOnOrBefore: "em ou antes de",
    filterOperatorAfter: "ap\xf3s",
    filterOperatorIsEmpty: "est\xe1 vazio",
    filterOperatorIsNotEmpty: "n\xe3o est\xe1 vazio",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Exibir colunas",
    columnMenuFilter: "Filtrar",
    columnMenuHideColumn: "Ocultar",
    columnMenuUnsort: "Desfazer ordena\xe7\xe3o",
    columnMenuSortAsc: "Ordenar do menor para o maior",
    columnMenuSortDesc: "Ordenar do maior para o menor",
    columnHeaderFiltersTooltipActive: (e)=>`${e} ${1 !== e ? "filtros" : "filtro"} ${1 !== e ? "ativos" : "ativo"}`,
    columnHeaderFiltersLabel: "Exibir Filtros",
    columnHeaderSortIconLabel: "Ordenar",
    footerRowSelected: (e)=>1 !== e ? `${e.toLocaleString()} linhas selecionadas` : `${e.toLocaleString()} linha selecionada`,
    footerTotalRows: "Total de linhas:",
    footerTotalVisibleRows: (e, t)=>`${e.toLocaleString()} de ${t.toLocaleString()}`,
    checkboxSelectionHeaderName: "Sele\xe7\xe3o",
    booleanCellTrueLabel: "sim",
    booleanCellFalseLabel: "n\xe3o"
}, (0, $3NUyv.ptBR)), Cs = {
    noRowsLabel: "\u041D\u0435\u0442 \u0441\u0442\u0440\u043E\u043A",
    errorOverlayDefaultLabel: "\u041E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u0430 \u043E\u0448\u0438\u0431\u043A\u0430.",
    toolbarDensity: "\u0412\u044B\u0441\u043E\u0442\u0430 \u0441\u0442\u0440\u043E\u043A\u0438",
    toolbarDensityLabel: "\u0412\u044B\u0441\u043E\u0442\u0430 \u0441\u0442\u0440\u043E\u043A\u0438",
    toolbarDensityCompact: "\u041A\u043E\u043C\u043F\u0430\u043A\u0442\u043D\u0430\u044F",
    toolbarDensityStandard: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430\u044F",
    toolbarDensityComfortable: "\u041A\u043E\u043C\u0444\u043E\u0440\u0442\u043D\u0430\u044F",
    toolbarColumns: "\u0421\u0442\u043E\u043B\u0431\u0446\u044B",
    toolbarColumnsLabel: "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u0435 \u0441\u0442\u043E\u043B\u0431\u0446\u044B",
    toolbarFilters: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B",
    toolbarFiltersLabel: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B",
    toolbarFiltersTooltipHide: "\u0421\u043A\u0440\u044B\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B",
    toolbarFiltersTooltipShow: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B",
    toolbarFiltersTooltipActive: (e)=>{
        let t = "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432";
        const r = e % 10;
        return r > 1 && r < 5 ? t = "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0444\u0438\u043B\u044C\u0442\u0440\u0430" : 1 === r && (t = "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u0444\u0438\u043B\u044C\u0442\u0440"), `${e} ${t}`;
    },
    toolbarExport: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442",
    toolbarExportLabel: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442",
    toolbarExportCSV: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 CSV",
    columnsPanelTextFieldLabel: "\u041D\u0430\u0439\u0442\u0438 \u0441\u0442\u043E\u043B\u0431\u0435\u0446",
    columnsPanelTextFieldPlaceholder: "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u0441\u0442\u043E\u043B\u0431\u0446\u0430",
    columnsPanelDragIconLabel: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0441\u0442\u043E\u043B\u0431\u0446\u0430",
    columnsPanelShowAllButton: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
    columnsPanelHideAllButton: "\u0421\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0435",
    filterPanelAddFilter: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440",
    filterPanelDeleteIconLabel: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    filterPanelOperators: "\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u044B",
    filterPanelOperatorAnd: "\u0418",
    filterPanelOperatorOr: "\u0418\u043B\u0438",
    filterPanelColumns: "\u0421\u0442\u043E\u043B\u0431\u0446\u044B",
    filterPanelInputLabel: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435",
    filterPanelInputPlaceholder: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u0430",
    filterOperatorContains: "\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442",
    filterOperatorEquals: "\u0440\u0430\u0432\u0435\u043D",
    filterOperatorStartsWith: "\u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F \u0441",
    filterOperatorEndsWith: "\u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430",
    filterOperatorIs: "\u0440\u0430\u0432\u0435\u043D",
    filterOperatorNot: "\u043D\u0435 \u0440\u0430\u0432\u0435\u043D",
    filterOperatorAfter: "\u0431\u043E\u043B\u044C\u0448\u0435 \u0447\u0435\u043C",
    filterOperatorOnOrAfter: "\u0431\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E",
    filterOperatorBefore: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0447\u0435\u043C",
    filterOperatorOnOrBefore: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E",
    filterValueAny: "\u043B\u044E\u0431\u043E\u0439",
    filterValueTrue: "\u0438\u0441\u0442\u0438\u043D\u0430",
    filterValueFalse: "\u043B\u043E\u0436\u044C",
    columnMenuLabel: "\u041C\u0435\u043D\u044E",
    columnMenuShowColumns: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0446\u044B",
    columnMenuFilter: "\u0424\u0438\u043B\u044C\u0442\u0440",
    columnMenuHideColumn: "\u0421\u043A\u0440\u044B\u0442\u044C",
    columnMenuUnsort: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0443",
    columnMenuSortAsc: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
    columnMenuSortDesc: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
    columnHeaderFiltersTooltipActive: (e)=>{
        let t = "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432";
        const r = e % 10;
        return r > 1 && r < 5 ? t = "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0444\u0438\u043B\u044C\u0442\u0440\u0430" : 1 === r && (t = "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u0444\u0438\u043B\u044C\u0442\u0440"), `${e} ${t}`;
    },
    columnHeaderFiltersLabel: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B",
    columnHeaderSortIconLabel: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    footerRowSelected: (e)=>{
        let t = "\u0441\u0442\u0440\u043E\u043A \u0432\u044B\u0431\u0440\u0430\u043D\u043E";
        const r = e % 10;
        return r > 1 && r < 5 ? t = "\u0441\u0442\u0440\u043E\u043A\u0438 \u0432\u044B\u0431\u0440\u0430\u043D\u044B" : 1 === r && (t = "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u0430"), `${e} ${t}`;
    },
    footerTotalRows: "\u0412\u0441\u0435\u0433\u043E \u0441\u0442\u0440\u043E\u043A:",
    checkboxSelectionHeaderName: "\u0412\u044B\u0431\u043E\u0440 \u0444\u043B\u0430\u0436\u043A\u0430",
    booleanCellTrueLabel: "\u0438\u0441\u0442\u0438\u043D\u0430",
    booleanCellFalseLabel: "\u043B\u043E\u0436\u044C"
}, ws = ns(Cs, (0, $3NUyv.ruRU)), Os = {
    noRowsLabel: "\u017Diadne z\xe1znamy",
    noResultsOverlayLabel: "Nena\u0161li sa \u017Eadne v\xfdsledky.",
    errorOverlayDefaultLabel: "Stala sa nepredv\xeddan\xe1 chyba.",
    toolbarDensity: "Hustota",
    toolbarDensityLabel: "Hustota",
    toolbarDensityCompact: "Kompaktn\xe1",
    toolbarDensityStandard: "\u0160tandartn\xe1",
    toolbarDensityComfortable: "Komfortn\xe1",
    toolbarColumns: "St\u013Apce",
    toolbarColumnsLabel: "Vybra\u0165 st\u013Apce",
    toolbarFilters: "Filtre",
    toolbarFiltersLabel: "Zobrazi\u0165 filtre",
    toolbarFiltersTooltipHide: "Skry\u0165 filtre ",
    toolbarFiltersTooltipShow: "Zobrazi\u0165 filtre",
    toolbarFiltersTooltipActive: (e)=>{
        let t = "akt\xedvnych filtrov";
        return e > 1 && e < 5 ? t = "akt\xedvne filtre" : 1 === e && (t = "akt\xedvny filter"), `${e} ${t}`;
    },
    toolbarExport: "Export",
    toolbarExportLabel: "Export",
    toolbarExportCSV: "Stiahnu\u0165 ako CSV",
    columnsPanelTextFieldLabel: "N\xe1js\u0165 st\u013Apec",
    columnsPanelTextFieldPlaceholder: "N\xe1zov st\u013Apca",
    columnsPanelDragIconLabel: "Usporiad\u0165 st\u013Apce",
    columnsPanelShowAllButton: "Zobrazi\u0165 v\u0161etko",
    columnsPanelHideAllButton: "Skry\u0165 v\u0161etko",
    filterPanelAddFilter: "Prida\u0165 filter",
    filterPanelDeleteIconLabel: "Odstr\xe1ni\u0165",
    filterPanelOperators: "Oper\xe1tory",
    filterPanelOperatorAnd: "A",
    filterPanelOperatorOr: "Alebo",
    filterPanelColumns: "St\u013Apce",
    filterPanelInputLabel: "Hodnota",
    filterPanelInputPlaceholder: "Hodnota filtra",
    filterOperatorContains: "obsahuje",
    filterOperatorEquals: "rovn\xe1 sa",
    filterOperatorStartsWith: "za\u010D\xedna s",
    filterOperatorEndsWith: "kon\u010D\xed na",
    filterOperatorIs: "je",
    filterOperatorNot: "nie je",
    filterOperatorAfter: "je po",
    filterOperatorOnOrAfter: "je na alebo po",
    filterOperatorBefore: "je pred",
    filterOperatorOnOrBefore: "je na alebo sk\xf4r",
    filterValueAny: "ak\xfdko\u013Evek",
    filterValueTrue: "\xe1no",
    filterValueFalse: "nie",
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Zobrazi\u0165 st\u013Apce",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Skry\u0165",
    columnMenuUnsort: "Zru\u0161i\u0165 filtre",
    columnMenuSortAsc: "Zoradi\u0165 vzostupne",
    columnMenuSortDesc: "Zoradi\u0165 zostupne",
    columnHeaderFiltersTooltipActive: (e)=>{
        let t = "akt\xedvnych filtrov";
        return e > 1 && e < 5 ? t = "akt\xedvne filtre" : 1 === e && (t = "akt\xedvny filter"), `${e} ${t}`;
    },
    columnHeaderFiltersLabel: "Zobrazi\u0165 filtre",
    columnHeaderSortIconLabel: "Filtrova\u0165",
    footerRowSelected: (e)=>{
        let t = "vybran\xfdch z\xe1znamov";
        return e > 1 && e < 5 ? t = "vybran\xe9 z\xe1znamy" : 1 === e && (t = "vybran\xfd z\xe1znam"), `${e} ${t}`;
    },
    footerTotalRows: "Riadkov spolu:",
    checkboxSelectionHeaderName: "V\xfdber riadku",
    booleanCellTrueLabel: "\xe1no",
    booleanCellFalseLabel: "nie"
}, ys = ns(Os, (0, $3NUyv.skSK)), Es = ns({
    noRowsLabel: "Sat\u0131r yok",
    errorOverlayDefaultLabel: "Bir hata olu\u015Ftu.",
    toolbarDensity: "Yo\u011Funluk",
    toolbarDensityLabel: "Yo\u011Funluk",
    toolbarDensityCompact: "S\u0131k\u0131",
    toolbarDensityStandard: "Standart",
    toolbarDensityComfortable: "Rahat",
    toolbarColumns: "S\xfctunlar",
    toolbarColumnsLabel: "S\xfctun se\xe7",
    toolbarFilters: "Filtreler",
    toolbarFiltersLabel: "Filtreleri g\xf6ster",
    toolbarFiltersTooltipHide: "Filtreleri gizle",
    toolbarFiltersTooltipShow: "Filtreleri g\xf6ster",
    toolbarFiltersTooltipActive: (e)=>`${e} aktif filtre`,
    toolbarExport: "D\u0131\u015Fa aktar",
    toolbarExportLabel: "D\u0131\u015Fa aktar",
    toolbarExportCSV: "CSV olarak aktar",
    columnsPanelTextFieldLabel: "S\xfctun ara",
    columnsPanelTextFieldPlaceholder: "S\xfctun ad\u0131",
    columnsPanelDragIconLabel: "S\xfctunlar\u0131 yeniden s\u0131rala",
    columnsPanelShowAllButton: "Hepsini g\xf6ster",
    columnsPanelHideAllButton: "Hepsini gizle",
    filterPanelAddFilter: "Filtre Ekle",
    filterPanelDeleteIconLabel: "Kald\u0131r",
    filterPanelOperators: "Operat\xf6r",
    filterPanelOperatorAnd: "Ve",
    filterPanelOperatorOr: "Veya",
    filterPanelColumns: "S\xfctunlar",
    filterPanelInputLabel: "De\u011Fer",
    filterPanelInputPlaceholder: "Filtre de\u011Feri",
    filterOperatorContains: "i\xe7erir",
    filterOperatorEquals: "e\u015Fittir",
    filterOperatorStartsWith: "ile ba\u015Flar",
    filterOperatorEndsWith: "ile biter",
    filterOperatorIs: "e\u015Fittir",
    filterOperatorNot: "e\u015Fit de\u011Fildir",
    filterOperatorAfter: "b\xfcy\xfck",
    filterOperatorOnOrAfter: "b\xfcy\xfck e\u015Fit",
    filterOperatorBefore: "k\xfc\xe7\xfck",
    filterOperatorOnOrBefore: "k\xfc\xe7\xfck e\u015Fit",
    filterOperatorIsEmpty: "bo\u015F",
    filterOperatorIsNotEmpty: "dolu",
    columnMenuLabel: "Men\xfc",
    columnMenuShowColumns: "S\xfctunlar\u0131 g\xf6ster",
    columnMenuFilter: "Filtre uygula",
    columnMenuHideColumn: "Gizle",
    columnMenuUnsort: "S\u0131ralama",
    columnMenuSortAsc: "S\u0131rala - Artan",
    columnMenuSortDesc: "S\u0131rala - Azalan",
    columnHeaderFiltersTooltipActive: (e)=>`${e} filtre aktif`,
    columnHeaderFiltersLabel: "Filtreleri g\xf6ster",
    columnHeaderSortIconLabel: "S\u0131rala",
    footerRowSelected: (e)=>`${e.toLocaleString()} sat\u{131}r se\xe7ildi`,
    footerTotalRows: "Toplam Sat\u0131r:",
    footerTotalVisibleRows: (e, t)=>`${e.toLocaleString()} / ${t.toLocaleString()}`
}, (0, $3NUyv.trTR)), Ss = {
    noRowsLabel: "\u041D\u0435\u043C\u0430\u0454 \u0440\u044F\u0434\u043A\u0456\u0432",
    errorOverlayDefaultLabel: "\u0412\u0438\u044F\u0432\u043B\u0435\u043D\u043E \u043F\u043E\u043C\u0438\u043B\u043A\u0443.",
    toolbarDensity: "\u0412\u0438\u0441\u043E\u0442\u0430 \u0440\u044F\u0434\u043A\u0430",
    toolbarDensityLabel: "\u0412\u0438\u0441\u043E\u0442\u0430 \u0440\u044F\u0434\u043A\u0430",
    toolbarDensityCompact: "\u041A\u043E\u043C\u043F\u0430\u043A\u0442\u043D\u0438\u0439",
    toolbarDensityStandard: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0438\u0439",
    toolbarDensityComfortable: "\u041A\u043E\u043C\u0444\u043E\u0440\u0442\u043D\u0438\u0439",
    toolbarColumns: "\u0421\u0442\u043E\u0432\u043F\u0446\u0456",
    toolbarColumnsLabel: "\u0412\u0438\u0434\u0456\u043B\u0456\u0442\u044C \u0441\u0442\u043E\u0432\u043F\u0446\u0456",
    toolbarFilters: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
    toolbarFiltersLabel: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
    toolbarFiltersTooltipHide: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
    toolbarFiltersTooltipShow: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
    toolbarFiltersTooltipActive: (e)=>1 !== e ? `${e} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{456} \u{444}\u{456}\u{43B}\u{44C}\u{442}\u{440}\u{438}` : `${e} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{438}\u{439} \u{444}\u{456}\u{43B}\u{44C}\u{442}\u{440}`,
    toolbarExport: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442",
    toolbarExportLabel: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442",
    toolbarExportCSV: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0443 \u0444\u043E\u0440\u043C\u0430\u0442\u0456 CSV",
    columnsPanelTextFieldLabel: "\u0417\u043D\u0430\u0439\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C",
    columnsPanelTextFieldPlaceholder: "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u0441\u0442\u043E\u0432\u043F\u0446\u044F",
    columnsPanelDragIconLabel: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0441\u0442\u043E\u0432\u043F\u0446\u044F",
    columnsPanelShowAllButton: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0443\u0441\u0456",
    columnsPanelHideAllButton: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u0443\u0441\u0456",
    filterPanelAddFilter: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440",
    filterPanelDeleteIconLabel: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    filterPanelOperators: "\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0438",
    filterPanelOperatorAnd: "\u0406",
    filterPanelOperatorOr: "\u0410\u0431\u043E",
    filterPanelColumns: "\u0421\u0442\u043E\u0432\u043F\u0446\u0456",
    filterPanelInputLabel: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    filterPanelInputPlaceholder: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0444\u0456\u043B\u044C\u0442\u0440\u0430",
    filterOperatorContains: "\u043C\u0456\u0441\u0442\u0438\u0442\u044C",
    filterOperatorEquals: "\u0434\u043E\u0440\u0456\u0432\u043D\u044E\u0454",
    filterOperatorStartsWith: "\u043F\u043E\u0447\u0438\u043D\u0430\u0454\u0442\u044C\u0441\u044F \u0437",
    filterOperatorEndsWith: "\u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F \u043D\u0430",
    filterOperatorIs: "\u0434\u043E\u0440\u0456\u0432\u043D\u044E\u0454",
    filterOperatorNot: "\u043D\u0435",
    filterOperatorAfter: "\u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0456\u0436",
    filterOperatorOnOrAfter: "\u0431\u0456\u043B\u044C\u0448\u0435 \u0430\u0431\u043E \u0434\u043E\u0440\u0456\u0432\u043D\u044E\u0454",
    filterOperatorBefore: "\u043C\u0435\u043D\u0448\u0435 \u043D\u0456\u0436",
    filterOperatorOnOrBefore: "\u043C\u0435\u043D\u0448\u0435 \u0430\u0431\u043E \u0434\u043E\u0440\u0456\u0432\u043D\u044E\u0454",
    filterValueAny: "\u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u0439",
    filterValueTrue: "\u043F\u0440\u0430\u0432\u0434\u0430",
    filterValueFalse: "\u043F\u043E\u043C\u0438\u043B\u043A\u043E\u0432\u0438\u0439",
    columnMenuLabel: "\u041C\u0435\u043D\u044E",
    columnMenuShowColumns: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0441\u0442\u043E\u0432\u043F\u0446\u0456",
    columnMenuFilter: "\u0424\u0456\u043B\u044C\u0442\u0440",
    columnMenuHideColumn: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438",
    columnMenuUnsort: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0441\u043E\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    columnMenuSortAsc: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430 \u0437\u0440\u043E\u0441\u0442\u0430\u043D\u043D\u044F\u043C",
    columnMenuSortDesc: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430 \u0441\u043F\u0430\u0434\u0430\u043D\u043D\u044F\u043C",
    columnHeaderFiltersTooltipActive: (e)=>1 !== e ? `${e} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{456} \u{444}\u{456}\u{43B}\u{44C}\u{442}\u{440}\u{438}` : `${e} \u{430}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{438}\u{439} \u{444}\u{456}\u{43B}\u{44C}\u{442}\u{440}`,
    columnHeaderFiltersLabel: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
    columnHeaderSortIconLabel: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438",
    footerRowSelected: (e)=>1 !== e ? `${e.toLocaleString()} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{456} \u{440}\u{44F}\u{434}\u{43A}\u{438}` : `${e.toLocaleString()} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}`,
    footerTotalRows: "\u0412\u0441\u044C\u043E\u0433\u043E \u0440\u044F\u0434\u043A\u0456\u0432:",
    checkboxSelectionHeaderName: "\u0412\u0438\u0431\u0456\u0440 \u043F\u0440\u0430\u043F\u043E\u0440\u0446\u044F",
    booleanCellTrueLabel: "\u043F\u0440\u0430\u0432\u0434\u0430",
    booleanCellFalseLabel: "\u043F\u043E\u043C\u0438\u043B\u043A\u043E\u0432\u0438\u0439"
}, Ms = ns(Ss, (0, $3NUyv.ukUA)), xs = 100, ks = {
    apiRef: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any, (e)=>null != e.apiRef ? new Error([
            "Material-UI: `apiRef` is not a valid prop.",
            "GridApiRef is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    checkboxSelectionVisibleOnly: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool, (e)=>!0 === e.checkboxSelectionVisibleOnly ? new Error([
            "Material-UI: `<DataGrid checkboxSelectionVisibleOnly={true} />` is not a valid prop.",
            "Selecting all columns only on the current page is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    columns: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired, (e)=>e.columns && e.columns.some((e)=>e.resizable) ? new Error([
            "Material-UI: `column.resizable = true` is not a valid prop.",
            "Column resizing is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    disableColumnReorder: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool, (e)=>!1 === e.disableColumnReorder ? new Error([
            "Material-UI: `<DataGrid disableColumnReorder={false} />` is not a valid prop.",
            "Column reordering is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    disableColumnResize: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool, (e)=>!1 === e.disableColumnResize ? new Error([
            "Material-UI: `<DataGrid disableColumnResize={false} />` is not a valid prop.",
            "Column resizing is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    disableMultipleColumnsFiltering: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool, (e)=>!1 === e.disableMultipleColumnsFiltering ? new Error([
            "Material-UI: `<DataGrid disableMultipleColumnsFiltering={false} />` is not a valid prop.",
            "Only single column sorting is available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    disableMultipleColumnsSorting: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool, (e)=>!1 === e.disableMultipleColumnsSorting ? new Error([
            "Material-UI: `<DataGrid disableMultipleColumnsSorting={false} />` is not a valid prop.",
            "Only single column sorting is available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    disableMultipleSelection: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool, (e)=>!1 === e.disableMultipleSelection ? new Error([
            "Material-UI: `<DataGrid disableMultipleSelection={false} />` is not a valid prop.",
            "Only single column selection is available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    filterModel: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any, (e)=>null != e.filterModel && e.filterModel.items.length > 1 ? new Error([
            "Material-UI: `<DataGrid filterModel={model} />` is not a valid prop. `model.items` has more than 1 item.",
            "Only single filter is available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    onRowsScrollEnd: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any, (e)=>null != e.onRowsScrollEnd ? new Error([
            "Material-UI: `onRowsScrollEnd` is not a valid prop.",
            "onRowsScrollEnd is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    onViewportRowsChange: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any, (e)=>null != e.onViewportRowsChange ? new Error([
            "Material-UI: `onViewportRowsChange` is not a valid prop.",
            "onViewportRowsChange is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    pageSize: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number, (e)=>e.pageSize && e.pageSize > 100 ? new Error([
            `Material-UI: \`<DataGrid pageSize={${e.pageSize}} />\` is not a valid prop.`,
            "Only page size below 100 is available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    pagination: (e)=>!1 === e.pagination ? new Error([
            "Material-UI: `<DataGrid pagination={false} />` is not a valid prop.",
            "Infinite scrolling is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to disable the pagination."
        ].join("\n")) : null,
    rows: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    scrollEndThreshold: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number, (e)=>e.scrollEndThreshold ? new Error([
            `Material-UI: \`<DataGrid scrollEndThreshold={${e.scrollEndThreshold}} />\` is not a valid prop.`,
            "scrollEndThreshold is not available in the MIT version.",
            "",
            "You need to upgrade to the XGrid component to unlock this feature."
        ].join("\n")) : null),
    selectionModel: (0, $4BA58.default)((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array
    ]), (e)=>!e.checkboxSelection && Array.isArray(e.selectionModel) && e.selectionModel.length > 1 ? new Error([
            `Material-UI: \`<DataGrid selectionModel={${JSON.stringify(e.selectionModel)}} />\` is not a valid prop.`,
            "selectionModel can only be of 1 item in DataGrid.",
            "",
            "You need to upgrade to the XGrid component to unlock multiple selection."
        ].join("\n")) : null)
}, Ds = ({ apiRef: t, props: r, children: l })=>$7fPBF.createElement(un.Provider, {
        value: r
    }, $7fPBF.createElement(oe.Provider, {
        value: t
    }, l)), Rs = (e, t)=>{
    if ("string" == typeof e) {
        const r = e.replace(/"/g, '""');
        return r.includes(t) ? `"${r}"` : r;
    }
    return e;
};
function Is(e) {
    const { columns: t, rows: r, selectedRowIds: l, getCellParams: n, delimiterCharacter: o, includeHeaders: a = !0 } = e;
    let i = [
        ...r.keys()
    ];
    l.length && (i = i.filter((e)=>l.includes(e)));
    const s = i.reduce((e, r)=>`${e}${(function(e, t, r, l) {
            const n = [];
            return t.forEach((t)=>t.field !== lo.field && n.push(Rs(r(e, t.field).formattedValue, l))), n;
        })(r, t, n, o).join(o)}\r\n`, "").trim();
    if (!a) return s;
    return `${`${t.filter((e)=>e.field !== lo.field).map((e)=>Rs(e.headerName || e.field, o)).join(o)}\r\n`}${s}`.trim();
}
function Ps(e) {
    const t = document.createElement("span");
    t.style.whiteSpace = "pre", t.style.userSelect = "all", t.style.opacity = "0px", t.textContent = e, document.body.appendChild(t);
    const r = document.createRange();
    r.selectNode(t);
    const l = window.getSelection();
    l.removeAllRanges(), l.addRange(r);
    try {
        document.execCommand("copy");
    } finally{
        document.body.removeChild(t);
    }
}
const Ls = (t)=>{
    const r = Ar("useGridCsvExport"), l = ll(t, de), n = ll(t, ue), o = ll(t, Dl), a = ll(t, bn), i = $7fPBF.useCallback((e)=>{
        let i;
        if (r.debug("Get data as CSV"), null == e ? void 0 : e.fields) i = e.fields.map((e)=>n.find((t)=>t.field === e)).filter((e)=>!!e);
        else i = ((null == e ? void 0 : e.allColumns) ? n : l).filter((e)=>!e.disableExport);
        return Is({
            columns: i,
            rows: o,
            selectedRowIds: a,
            getCellParams: t.current.getCellParams,
            delimiterCharacter: (null == e ? void 0 : e.delimiter) || ","
        });
    }, [
        r,
        l,
        n,
        o,
        a,
        t
    ]), s = $7fPBF.useCallback((e)=>{
        r.debug("Export data as CSV");
        const t = i(e);
        !function(e, t = "csv", r = document.title) {
            const l = `${r}.${t}`;
            if ("download" in HTMLAnchorElement.prototype) {
                const t = URL.createObjectURL(e), r = document.createElement("a");
                return r.href = t, r.download = l, r.click(), void setTimeout(()=>{
                    URL.revokeObjectURL(t);
                });
            }
            throw new Error("exportAs not supported");
        }(new Blob([
            (null == e ? void 0 : e.utf8WithBom) ? new Uint8Array([
                239,
                187,
                191
            ]) : "",
            t
        ], {
            type: "text/csv"
        }), "csv", null == e ? void 0 : e.fileName);
    }, [
        r,
        i
    ]);
    _r(t, {
        getDataAsCsv: i,
        exportDataAsCsv: s
    }, "GridCsvExportApi");
};
function Fs(e, t) {
    switch(t.type){
        case "options::UPDATE":
            return hi(e, t.payload);
        default:
            throw new Error(`Material-UI: Action ${t.type} not found.`);
    }
}
const js = false;
const zs = (t, r)=>{
    Hr(0, r), pi(t, r), function(t, r) {
        const [, l] = rl(t), n = $7fPBF.useCallback((e)=>{
            l((t)=>Object.assign(Object.assign({}, t), {
                    error: e
                }));
        }, [
            l
        ]);
        $7fPBF.useEffect(()=>{
            n(r.error);
        }, [
            n,
            r.error
        ]), cl(t, ne.componentError, n);
    }(t, r), yi(t, r), function(t, { scrollbarSize: r }) {
        const l = Ar("useGridScrollbarSizeDetector"), [n, o] = $7fPBF.useState(0), [, a] = rl(t), i = ll(t, ue).length > 0, s = $7fPBF.useCallback(()=>{
            var e, r;
            let n = 0;
            (null === (r = null === (e = t.current) || void 0 === e ? void 0 : e.rootElementRef) || void 0 === r ? void 0 : r.current) && (n = function(e, t) {
                const r = e.createElement("div");
                r.style.width = "99px", r.style.height = "99px", r.style.position = "absolute", r.style.overflow = "scroll", r.className = "scrollDiv", t.appendChild(r);
                const l = r.offsetWidth - r.clientWidth;
                return t.removeChild(r), l;
            }((0, $g3iV0.default)(t.current.rootElementRef.current), t.current.rootElementRef.current), l.debug(`Detected scroll bar size ${n}.`)), o(n);
        }, [
            t,
            l
        ]);
        vr(()=>{
            i && null == r && s();
        }, [
            s,
            i,
            r
        ]), $7fPBF.useEffect(()=>{
            null == r && a((e)=>Object.assign(Object.assign({}, e), {
                    options: Object.assign(Object.assign({}, e.options), {
                        scrollbarSize: n
                    })
                }));
        }, [
            r,
            n,
            a
        ]);
    }(t, r), function(t, r) {
        const l = Ar("useOptionsProp"), n = $7fPBF.useMemo(()=>Object.assign(Object.assign({}, r), {
                classes: Cr({
                    root: [
                        "root"
                    ],
                    columnHeader: [
                        "columnHeader"
                    ],
                    row: [
                        "row"
                    ],
                    cell: [
                        "cell"
                    ]
                }, Dr, r.classes),
                localeText: Object.assign(Object.assign({}, Nr), r.localeText)
            }), [
            r
        ]), { gridState: o, dispatch: a } = Ei(t, "options", Fs, Object.assign({}, Wr)), i = $7fPBF.useCallback((e)=>{
            l.debug("updating options state."), a({
                type: "options::UPDATE",
                payload: e
            });
        }, [
            a,
            l
        ]);
        $7fPBF.useEffect(()=>{
            i(n);
        }, [
            n,
            i
        ]), o.options;
    }(t, r), function(e, t) {
        dl(e, ne.columnHeaderClick, t.onColumnHeaderClick), dl(e, ne.columnHeaderDoubleClick, t.onColumnHeaderDoubleClick), dl(e, ne.columnHeaderOver, t.onColumnHeaderOver), dl(e, ne.columnHeaderOut, t.onColumnHeaderOut), dl(e, ne.columnHeaderEnter, t.onColumnHeaderEnter), dl(e, ne.columnHeaderLeave, t.onColumnHeaderLeave), dl(e, ne.columnOrderChange, t.onColumnOrderChange), dl(e, ne.cellClick, t.onCellClick), dl(e, ne.cellDoubleClick, t.onCellDoubleClick), dl(e, ne.cellOver, t.onCellOver), dl(e, ne.cellOut, t.onCellOut), dl(e, ne.cellEnter, t.onCellEnter), dl(e, ne.cellLeave, t.onCellLeave), dl(e, ne.cellKeyDown, t.onCellKeyDown), dl(e, ne.cellBlur, t.onCellBlur), dl(e, ne.cellFocusOut, t.onCellFocusOut), dl(e, ne.rowDoubleClick, t.onRowDoubleClick), dl(e, ne.rowClick, t.onRowClick), dl(e, ne.rowOver, t.onRowOver), dl(e, ne.rowOut, t.onRowOut), dl(e, ne.rowEnter, t.onRowEnter), dl(e, ne.rowLeave, t.onRowLeave), dl(e, ne.componentError, t.onError), dl(e, ne.stateChange, t.onStateChange);
    }(t, r), ((t)=>{
        const { localeText: r } = ll(t, il);
        _r(t, {
            getLocaleText: $7fPBF.useCallback((e)=>{
                if (null == r[e]) throw new Error(`Missing translation for key ${e}.`);
                return r[e];
            }, [
                r
            ])
        }, "LocaleTextApi");
    })(t), function(t, r) {
        const l = Ar("useResizeContainer"), n = $7fPBF.useRef(!1), o = $7fPBF.useCallback(()=>{
            var e;
            l.debug("resizing..."), t.current.publishEvent(ne.debouncedResize, {
                containerSize: null === (e = t.current.state.containerSizes) || void 0 === e ? void 0 : e.windowSizes
            });
        }, [
            t,
            l
        ]);
        _r(t, {
            resize: o
        }, "GridEventsApi");
        const a = $7fPBF.useMemo(()=>(0, $kyQ4S.default)(o, 60), [
            o
        ]), i = $7fPBF.useCallback((e)=>{
            const t = /jsdom/.test(window.navigator.userAgent);
            0 !== e.height || n.current || r.autoHeight || t || (l.warn([
                "The parent of the grid has an empty height.",
                "You need to make sure the container has an intrinsic height.",
                "The grid displays with a height of 0px.",
                "",
                "You can find a solution in the docs:",
                "https://material-ui.com/components/data-grid/layout/"
            ].join("\n")), n.current = !0), 0 !== e.width || n.current || t || (l.warn([
                "The parent of the grid has an empty width.",
                "You need to make sure the container has an intrinsic width.",
                "The grid displays with a width of 0px.",
                "",
                "You can find a solution in the docs:",
                "https://material-ui.com/components/data-grid/layout/"
            ].join("\n")), n.current = !0), js ? o() : a();
        }, [
            r.autoHeight,
            a,
            l,
            o
        ]);
        $7fPBF.useEffect(()=>()=>{
                l.info("canceling resize..."), a.clear();
            }, [
            l,
            a
        ]), $7fPBF.useEffect(()=>{
            l.info("canceling resize..."), a.clear();
        }, [
            r.rows,
            a,
            l
        ]), cl(t, ne.resize, i), dl(t, ne.debouncedResize, r.onResize);
    }(t, r), function(e, { rows: t }) {}(0, r), Oi(t, r), zi(t), _i(t, r), Gi(t, r), Mi(t, r), xi(t), ki(t, r), Ni(t, r), $i(t, r), gi(t), Fi(t), Si(t, r), mi(t), ((t, r)=>{
        const l = Ar("useDensity"), [, n, o] = rl(t), a = $7fPBF.useCallback((e, t, r)=>{
            switch(e){
                case $r.Compact:
                    return {
                        value: e,
                        headerHeight: Math.floor(.7 * t),
                        rowHeight: Math.floor(.7 * r)
                    };
                case $r.Comfortable:
                    return {
                        value: e,
                        headerHeight: Math.floor(1.3 * t),
                        rowHeight: Math.floor(1.3 * r)
                    };
                default:
                    return {
                        value: e,
                        headerHeight: t,
                        rowHeight: r
                    };
            }
        }, []), i = $7fPBF.useCallback((e, t = r.headerHeight, i = r.rowHeight)=>{
            l.debug(`Set grid density to ${e}`), n((r)=>Object.assign(Object.assign({}, r), {
                    density: Object.assign(Object.assign({}, r.density), a(e, t, i))
                })), o();
        }, [
            l,
            n,
            o,
            a,
            r.headerHeight,
            r.rowHeight
        ]);
        $7fPBF.useEffect(()=>{
            i(r.density, r.headerHeight, r.rowHeight);
        }, [
            i,
            r.density,
            r.rowHeight,
            r.headerHeight
        ]), _r(t, {
            setDensity: i
        }, "GridDensityApi");
    })(t, r), Wi(t), Yi(t, r), Li(t, r), Pi(t, r), Ls(t), ((t, r)=>{
        const l = ll(t, Yo), n = ll(t, de), o = $7fPBF.useRef(!1), a = ll(t, nl), i = $7fPBF.useRef(null), s = $7fPBF.useCallback((e)=>{
            if (!l) return;
            const a = e.top + l.windowSizes.height + r.scrollEndThreshold;
            if (a < l.dataContainerSizes.height && (o.current = !1), a >= l.dataContainerSizes.height && !o.current) {
                const e = {
                    api: t,
                    visibleColumns: n,
                    viewportPageSize: l.viewportPageSize,
                    virtualRowsCount: l.virtualRowsCount
                };
                t.current.publishEvent(ne.rowsScrollEnd, e), o.current = !0;
            }
        }, [
            t,
            r.scrollEndThreshold,
            n,
            l
        ]), c = $7fPBF.useCallback(()=>{
            const e = t.current.getScrollPosition();
            s(e);
        }, [
            t,
            s
        ]);
        $7fPBF.useEffect(()=>{
            const e = a.renderContext;
            if (e) {
                if (!i.current || e.firstRowIdx !== i.current.firstRowIndex || e.lastRowIdx !== i.current.lastRowIndex) {
                    const r = {
                        firstRowIndex: e.firstRowIdx,
                        lastRowIndex: e.lastRowIdx
                    };
                    t.current.publishEvent(ne.viewportRowsChange, r);
                }
                i.current = {
                    firstRowIndex: e.firstRowIdx,
                    lastRowIndex: e.lastRowIdx
                };
            }
        }, [
            t,
            r.onViewportRowsChange,
            a
        ]), cl(t, ne.rowsScroll, c), dl(t, ne.rowsScrollEnd, r.onRowsScrollEnd), dl(t, ne.viewportRowsChange, r.onViewportRowsChange);
    })(t, r), ((t)=>{
        const r = ll(t, de), l = $7fPBF.useCallback((e = !1)=>{
            const l = t.current.getSelectedRows(), n = r.filter((e)=>e.field !== lo.field);
            if (0 === l.size || 0 === n.length) return;
            const o = Is({
                columns: r,
                rows: l,
                selectedRowIds: [],
                includeHeaders: e,
                getCellParams: t.current.getCellParams,
                delimiterCharacter: "\t"
            });
            navigator.clipboard ? navigator.clipboard.writeText(o).catch(()=>{
                Ps(o);
            }) : Ps(o);
        }, [
            t,
            r
        ]), n = $7fPBF.useCallback((e)=>{
            var r;
            const l = e.ctrlKey || e.metaKey || e.altKey;
            "c" === e.key.toLowerCase() && l && "" === (null === (r = window.getSelection()) || void 0 === r ? void 0 : r.toString()) && t.current.copySelectedRowsToClipboard(e.altKey);
        }, [
            t
        ]);
        fi(t, t.current.rootElementRef, "keydown", n), _r(t, {
            copySelectedRowsToClipboard: l
        }, "GridClipboardApi");
    })(t), rs(t, r), function(t, { state: r }) {
        const [, l, n] = rl(t), o = Ar("useStateProp");
        $7fPBF.useEffect(()=>{
            null != r && t.current.state !== r && (o.debug("Overriding state with props.state"), l((e)=>Object.assign(Object.assign({}, e), r)), n());
        }, [
            t,
            n,
            o,
            r,
            l
        ]);
    }(t, r), function(e) {
        const [t] = rl(e), r = Ar("useRenderInfoLog");
        if (null != t.rendering.renderContext) {
            const { page: e, firstColIdx: l, lastColIdx: n, firstRowIdx: o, lastRowIdx: a } = t.rendering.renderContext;
            r.info(`Rendering, page: ${e}, col: ${l}-${n}, row: ${o}-${a}`);
        }
    }(t);
}, Ts = {
    apiRef: void 0,
    disableColumnResize: !0,
    disableColumnReorder: !0,
    disableMultipleColumnsFiltering: !0,
    disableMultipleColumnsSorting: !0,
    disableMultipleSelection: !0,
    pagination: !0,
    onRowsScrollEnd: void 0,
    onViewportRowsChange: void 0,
    checkboxSelectionVisibleOnly: !1,
    signature: "DataGrid"
}, Hs = (t)=>{
    if (t.pageSize > 100) throw new Error("'props.pageSize' cannot exceed 100 in DataGrid.");
    const r = function({ props: t, name: r }) {
        const l = (0, $fH0xA.default)();
        return $7fPBF.useMemo(()=>{
            const e = Object.assign({}, t), n = (0, $4mLf7.default)({
                theme: l,
                name: r,
                props: e
            }), o = n.theme || l, a = "rtl" === o.direction;
            return Object.assign({
                theme: o,
                isRtl: a
            }, n);
        }, [
            t,
            r,
            l
        ]);
    }({
        props: t,
        name: "MuiDataGrid"
    });
    return $7fPBF.useMemo(()=>Object.assign(Object.assign({}, r), Ts), [
        r
    ]);
}, As = $7fPBF.forwardRef(function(t, r) {
    const l = Hs(t), n = Ki();
    return zs(n, l), $7fPBF.createElement(Ds, {
        apiRef: n,
        props: l
    }, $7fPBF.createElement(Sa, {
        ref: r
    }, $7fPBF.createElement(wa, null, $7fPBF.createElement(ya, null), $7fPBF.createElement(va, null), $7fPBF.createElement(Oa, null))));
});
As.defaultProps = Br;
const _s = $7fPBF.memo(As);
_s.propTypes = ks;

});
parcelRegister("7UqAk", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $5c22629b42831e80$export$595d22ed68ca2841; });

var $7Chb3 = parcelRequire("7Chb3");
function $5c22629b42831e80$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $5c22629b42831e80$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $5c22629b42831e80$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $5c22629b42831e80$export$595d22ed68ca2841 = /* #__PURE__ */ $5c22629b42831e80$export$5943f4447f6ef248((0, $7Chb3.defaultMemoize));
var $5c22629b42831e80$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $5c22629b42831e80$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("7Chb3", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $58b9680bf8a527fb$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $58b9680bf8a527fb$var$NOT_FOUND = 'NOT_FOUND';
function $58b9680bf8a527fb$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $58b9680bf8a527fb$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $58b9680bf8a527fb$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $58b9680bf8a527fb$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $58b9680bf8a527fb$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $58b9680bf8a527fb$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $58b9680bf8a527fb$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $58b9680bf8a527fb$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $58b9680bf8a527fb$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $58b9680bf8a527fb$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $58b9680bf8a527fb$var$createSingletonCache(comparator) : $58b9680bf8a527fb$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $58b9680bf8a527fb$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("e0IBS", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return (parcelRequire("baumZ")).default; });
$parcel$export(module.exports, "createMuiTheme", function () { return (parcelRequire("baumZ")).createMuiTheme; });
$parcel$export(module.exports, "unstable_createMuiStrictModeTheme", function () { return (parcelRequire("01C7i")).default; });
$parcel$export(module.exports, "createStyles", function () { return (parcelRequire("lEobJ")).default; });
$parcel$export(module.exports, "makeStyles", function () { return (parcelRequire("by0pu")).default; });
$parcel$export(module.exports, "responsiveFontSizes", function () { return (parcelRequire("i6it8")).default; });
$parcel$export(module.exports, "styled", function () { return (parcelRequire("j9gH9")).default; });
$parcel$export(module.exports, "useTheme", function () { return (parcelRequire("fH0xA")).default; });
$parcel$export(module.exports, "withStyles", function () { return (parcelRequire("3Sc7z")).default; });
$parcel$export(module.exports, "withTheme", function () { return (parcelRequire("gfGvy")).default; });
$parcel$export(module.exports, "createGenerateClassName", function () { return (parcelRequire("3azh1")).default; });
$parcel$export(module.exports, "jssPreset", function () { return (parcelRequire("2f7cf")).default; });
$parcel$export(module.exports, "ServerStyleSheets", function () { return (parcelRequire("3fYcb")).default; });
$parcel$export(module.exports, "StylesProvider", function () { return (parcelRequire("1sFhF")).default; });
$parcel$export(module.exports, "MuiThemeProvider", function () { return (parcelRequire("juaRV")).default; });
$parcel$export(module.exports, "ThemeProvider", function () { return (parcelRequire("juaRV")).default; });

var $2jEfe = parcelRequire("2jEfe");

var $baumZ = parcelRequire("baumZ");

var $01C7i = parcelRequire("01C7i");

var $lEobJ = parcelRequire("lEobJ");

var $by0pu = parcelRequire("by0pu");

var $i6it8 = parcelRequire("i6it8");

var $j9gH9 = parcelRequire("j9gH9");

var $etJ3Q = parcelRequire("etJ3Q");

var $fH0xA = parcelRequire("fH0xA");

var $3Sc7z = parcelRequire("3Sc7z");

var $gfGvy = parcelRequire("gfGvy");

var $3azh1 = parcelRequire("3azh1");
var $2f7cf = parcelRequire("2f7cf");
var $3fYcb = parcelRequire("3fYcb");
var $1sFhF = parcelRequire("1sFhF");
var $juaRV = parcelRequire("juaRV");
$parcel$exportWildcard(module.exports, $2jEfe);
$parcel$exportWildcard(module.exports, $etJ3Q);

});
parcelRegister("01C7i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $004da94699d88f77$export$2e2bcd8739ae039; });

var $belNS = parcelRequire("belNS");

var $baumZ = parcelRequire("baumZ");
function $004da94699d88f77$export$2e2bcd8739ae039(options) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return (0, $baumZ.default).apply(void 0, [
        (0, $belNS.default)({
            unstable_strictMode: true
        }, options)
    ].concat(args));
}

});

parcelRegister("lEobJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc3018ae2585a40e$export$2e2bcd8739ae039; });

var $7ydWz = parcelRequire("7ydWz");
function $fc3018ae2585a40e$export$2e2bcd8739ae039(styles) {
    // warning(
    //   warnOnce,
    //   [
    //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
    //     'Please use @material-ui/styles/createStyles',
    //   ].join('\n'),
    // );
    // warnOnce = true;
    return (0, $7ydWz.default)(styles);
}

});
parcelRegister("7ydWz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57f6864a400bfbb2$export$2e2bcd8739ae039; });
function $57f6864a400bfbb2$export$2e2bcd8739ae039(styles) {
    return styles;
}

});


parcelRegister("by0pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $868330232ae946ef$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $8SBLK = parcelRequire("8SBLK");

var $11f0A = parcelRequire("11f0A");
function $868330232ae946ef$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $8SBLK.default)(stylesOrCreator, (0, $kY3Ke.default)({
        defaultTheme: (0, $11f0A.default)
    }, options));
}
var $868330232ae946ef$export$2e2bcd8739ae039 = $868330232ae946ef$var$makeStyles;

});

parcelRegister("i6it8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2d71d138fffa7c7$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $2dHXF = parcelRequire("2dHXF");

var $bMVvp = parcelRequire("bMVvp");
function $d2d71d138fffa7c7$export$2e2bcd8739ae039(themeInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$breakpoints = options.breakpoints, breakpoints = _options$breakpoints === void 0 ? [
        'sm',
        'md',
        'lg'
    ] : _options$breakpoints, _options$disableAlign = options.disableAlign, disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign, _options$factor = options.factor, factor = _options$factor === void 0 ? 2 : _options$factor, _options$variants = options.variants, variants = _options$variants === void 0 ? [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] : _options$variants;
    var theme = (0, $kY3Ke.default)({}, themeInput);
    theme.typography = (0, $kY3Ke.default)({}, theme.typography);
    var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    var convert = (0, $bMVvp.convertLength)(typography.htmlFontSize);
    var breakpointValues = breakpoints.map(function(x) {
        return theme.breakpoints.values[x];
    });
    variants.forEach(function(variant) {
        var style = typography[variant];
        var remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        var maxFontSize = remFontSize;
        var minFontSize = 1 + (maxFontSize - 1) / factor;
        var lineHeight = style.lineHeight;
        if (!(0, $bMVvp.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, $2dHXF.default)(6));
        if (!(0, $bMVvp.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        var transform = null;
        if (!disableAlign) transform = function transform(value) {
            return (0, $bMVvp.alignProperty)({
                size: value,
                grid: (0, $bMVvp.fontGrid)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        };
        typography[variant] = (0, $kY3Ke.default)({}, style, (0, $bMVvp.responsiveProperty)({
            cssProperty: 'fontSize',
            min: minFontSize,
            max: maxFontSize,
            unit: 'rem',
            breakpoints: breakpointValues,
            transform: transform
        }));
    });
    return theme;
}

});
parcelRegister("bMVvp", function(module, exports) {

$parcel$export(module.exports, "isUnitless", function () { return $8950c8ccfb164812$export$9623ad5dc13f2eaa; });
$parcel$export(module.exports, "convertLength", function () { return $8950c8ccfb164812$export$ea1536a749e80563; });
$parcel$export(module.exports, "alignProperty", function () { return $8950c8ccfb164812$export$aec9aaffd8096b21; });
$parcel$export(module.exports, "fontGrid", function () { return $8950c8ccfb164812$export$63653082df276400; });
$parcel$export(module.exports, "responsiveProperty", function () { return $8950c8ccfb164812$export$26a139329f9dd721; });

var $dQMrF = parcelRequire("dQMrF");
function $8950c8ccfb164812$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
} // Ported from Compass
function $8950c8ccfb164812$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"
function $8950c8ccfb164812$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.
function $8950c8ccfb164812$export$ea1536a749e80563(baseFontSize) {
    return function(length, toUnit) {
        var fromUnit = $8950c8ccfb164812$export$65f2564e9a9b9222(length); // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
         // Convert input length to pixels.
        var pxLength = $8950c8ccfb164812$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $8950c8ccfb164812$export$8af1d214c6c2f0f1(length) * $8950c8ccfb164812$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') {
                pxLength = $8950c8ccfb164812$export$8af1d214c6c2f0f1(length) * $8950c8ccfb164812$export$8af1d214c6c2f0f1(baseFontSize);
                return length;
            }
        } // Convert length in pixels to the output unit
        var outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $8950c8ccfb164812$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $8950c8ccfb164812$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $8950c8ccfb164812$export$aec9aaffd8096b21(_ref) {
    var size = _ref.size, grid = _ref.grid;
    var sizeBelow = size - size % grid;
    var sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
function $8950c8ccfb164812$export$63653082df276400(_ref2) {
    var lineHeight = _ref2.lineHeight, pixels = _ref2.pixels, htmlFontSize = _ref2.htmlFontSize;
    return pixels / (lineHeight * htmlFontSize);
}
function $8950c8ccfb164812$export$26a139329f9dd721(_ref3) {
    var cssProperty = _ref3.cssProperty, min = _ref3.min, max = _ref3.max, _ref3$unit = _ref3.unit, unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit, _ref3$breakpoints = _ref3.breakpoints, breakpoints = _ref3$breakpoints === void 0 ? [
        600,
        960,
        1280
    ] : _ref3$breakpoints, _ref3$transform = _ref3.transform, transform = _ref3$transform === void 0 ? null : _ref3$transform;
    var output = (0, $dQMrF.default)({}, cssProperty, "".concat(min).concat(unit));
    var factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach(function(breakpoint) {
        var value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output["@media (min-width:".concat(breakpoint, "px)")] = (0, $dQMrF.default)({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
    });
    return output;
}

});


parcelRegister("j9gH9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df0bced7dc8fd3b9$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cWPwu = parcelRequire("cWPwu");

var $11f0A = parcelRequire("11f0A");
var $df0bced7dc8fd3b9$var$styled = function styled(Component) {
    var componentCreator = (0, $cWPwu.default)(Component);
    return function(style, options) {
        return componentCreator(style, (0, $kY3Ke.default)({
            defaultTheme: (0, $11f0A.default)
        }, options));
    };
};
var $df0bced7dc8fd3b9$export$2e2bcd8739ae039 = $df0bced7dc8fd3b9$var$styled;

});
parcelRegister("cWPwu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96d2de35519883fb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");



var $8Ae2G = parcelRequire("8Ae2G");

var $8SBLK = parcelRequire("8SBLK");
function $96d2de35519883fb$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
} // styled-components's API removes the mapping between components and styles.
function $96d2de35519883fb$export$2e2bcd8739ae039(Component) {
    var componentCreator = function componentCreator(style) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var name = options.name, stylesOptions = (0, $lfiYO.default)(options, [
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var stylesOrCreator = typeof style === 'function' ? function(theme) {
            return {
                root: function root(props) {
                    return style((0, $kY3Ke.default)({
                        theme: theme
                    }, props));
                }
            };
        } : {
            root: style
        };
        var useStyles = (0, $8SBLK.default)(stylesOrCreator, (0, $kY3Ke.default)({
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var filterProps;
        var propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ var StyledComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function StyledComponent(props, ref) {
            var children = props.children, classNameProp = props.className, clone = props.clone, ComponentProp = props.component, other = (0, $lfiYO.default)(props, [
                "children",
                "className",
                "clone",
                "component"
            ]);
            var classes = useStyles(props);
            var className = (0, $jtRae.default)(classes.root, classNameProp);
            var spread = other;
            if (filterProps) spread = $96d2de35519883fb$var$omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(children, (0, $kY3Ke.default)({
                className: (0, $jtRae.default)(children.props.className, className)
            }, spread));
            if (typeof children === 'function') return children((0, $kY3Ke.default)({
                className: className
            }, spread));
            var FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(FinalComponent, (0, $kY3Ke.default)({
                ref: ref,
                className: className
            }, spread), children);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}

});


parcelRegister("fH0xA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6cb4a8b6f0895c2$export$2e2bcd8739ae039; });

var $qjAyq = parcelRequire("qjAyq");
parcelRequire("7fPBF");

var $11f0A = parcelRequire("11f0A");
function $b6cb4a8b6f0895c2$export$2e2bcd8739ae039() {
    var theme = (0, $qjAyq.default)() || (0, $11f0A.default);
    return theme;
}

});

parcelRegister("gfGvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd4f05440748828c$export$2e2bcd8739ae039; });

var $lFQgX = parcelRequire("lFQgX");

var $11f0A = parcelRequire("11f0A");
var $bd4f05440748828c$var$withTheme = (0, $lFQgX.withThemeCreator)({
    defaultTheme: (0, $11f0A.default)
});
var $bd4f05440748828c$export$2e2bcd8739ae039 = $bd4f05440748828c$var$withTheme;

});
parcelRegister("lFQgX", function(module, exports) {

$parcel$export(module.exports, "withThemeCreator", function () { return $fc75f98d5f0fb578$export$f19c0a3aeca9fe3a; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $8Ae2G = parcelRequire("8Ae2G");


var $qjAyq = parcelRequire("qjAyq");
function $fc75f98d5f0fb578$export$f19c0a3aeca9fe3a() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaultTheme = options.defaultTheme;
    var withTheme = function withTheme(Component) {
        var WithTheme = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function WithTheme(props, ref) {
            var innerRef = props.innerRef, other = (0, $lfiYO.default)(props, [
                "innerRef"
            ]);
            var theme = (0, $qjAyq.default)() || defaultTheme;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, (0, $kY3Ke.default)({
                theme: theme,
                ref: innerRef || ref
            }, other));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(WithTheme, Component);
        return WithTheme;
    };
    return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.
var $fc75f98d5f0fb578$var$withTheme = $fc75f98d5f0fb578$export$f19c0a3aeca9fe3a();
var $fc75f98d5f0fb578$export$2e2bcd8739ae039 = $fc75f98d5f0fb578$var$withTheme;

});


parcelRegister("3fYcb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25f17765d62e7b36$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $7fPBF = parcelRequire("7fPBF");

var $44Txg = parcelRequire("44Txg");

var $1sFhF = parcelRequire("1sFhF");

var $3azh1 = parcelRequire("3azh1");
var $25f17765d62e7b36$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ServerStyleSheets() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $03dWn.default)(this, ServerStyleSheets);
        this.options = options;
    }
    (0, $4OFm0.default)(ServerStyleSheets, [
        {
            key: "collect",
            value: function collect(children) {
                // This is needed in order to deduplicate the injection of CSS in the page.
                var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.
                this.sheetsRegistry = new (0, $44Txg.SheetsRegistry)(); // A new class name generator
                var generateClassName = (0, $3azh1.default)();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1sFhF.default), (0, $kY3Ke.default)({
                    sheetsManager: sheetsManager,
                    serverGenerateClassName: generateClassName,
                    sheetsRegistry: this.sheetsRegistry
                }, this.options), children);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
            }
        },
        {
            key: "getStyleElement",
            value: function getStyleElement(props) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement('style', (0, $kY3Ke.default)({
                    id: 'jss-server-side',
                    key: 'jss-server-side',
                    dangerouslySetInnerHTML: {
                        __html: this.toString()
                    }
                }, props));
            }
        }
    ]);
    return ServerStyleSheets;
}();

});
parcelRegister("03dWn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $009b183922525d46$export$2e2bcd8739ae039; });
function $009b183922525d46$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});


parcelRegister("juaRV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2f93ff9e08fe911$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $9Pho7 = parcelRequire("9Pho7");

var $qjAyq = parcelRequire("qjAyq");

var $dpn1r = parcelRequire("dpn1r");
function $e2f93ff9e08fe911$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $e2f93ff9e08fe911$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $qjAyq.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $e2f93ff9e08fe911$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $dpn1r.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $9Pho7.default).Provider, {
        value: theme
    }, children);
}
var $e2f93ff9e08fe911$export$2e2bcd8739ae039 = $e2f93ff9e08fe911$var$ThemeProvider;

});


parcelRegister("kyQ4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef7f61252e98e07c$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $ef7f61252e98e07c$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("g3iV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bafb99f6ef0f8c91$export$2e2bcd8739ae039; });
function $bafb99f6ef0f8c91$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("bSzdr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a600dfc61eb2fc1$export$2e2bcd8739ae039; });

var $g3iV0 = parcelRequire("g3iV0");
function $8a600dfc61eb2fc1$export$2e2bcd8739ae039(node) {
    var doc = (0, $g3iV0.default)(node);
    return doc.defaultView || window;
}

});

parcelRegister("ejsyu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6b8fd82dc3995bb$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $a6b8fd82dc3995bb$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $7fPBF.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $7fPBF.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}

});

parcelRegister("1sMi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $110dddb238987762$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
var $110dddb238987762$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
function $110dddb238987762$export$2e2bcd8739ae039(fn) {
    var ref = $7fPBF.useRef(fn);
    $110dddb238987762$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $7fPBF.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}

});

parcelRegister("55RWP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b57445021f35677$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $6FBGG = parcelRequire("6FBGG");
function $3b57445021f35677$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $7fPBF.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $6FBGG.default)(refA, refValue);
            (0, $6FBGG.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("6FBGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4db3ce545fa60717$export$2e2bcd8739ae039; });
// TODO v5: consider to make it private
function $4db3ce545fa60717$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("dzfbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e0a52b199e51af8$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $2dHXF = parcelRequire("2dHXF");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $4pUwJ = parcelRequire("4pUwJ");

var $bdGMx = parcelRequire("bdGMx");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");

var $55RWP = parcelRequire("55RWP");

var $6EYHi = parcelRequire("6EYHi");

var $OVmIV = parcelRequire("OVmIV");
var $9e0a52b199e51af8$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var placeholder = {
        color: 'currentColor',
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: '0 !important'
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        '@global': {
            '@keyframes mui-auto-fill': {},
            '@keyframes mui-auto-fill-cancel': {}
        },
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: '1.1876em',
            // Reset (19px), match the native input line-height
            boxSizing: 'border-box',
            // Prevent padding issue with fullWidth.
            position: 'relative',
            cursor: 'text',
            display: 'inline-flex',
            alignItems: 'center',
            '&$disabled': {
                color: theme.palette.text.disabled,
                cursor: 'default'
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            '&$marginDense': {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the `input` element. */ input: {
            font: 'inherit',
            letterSpacing: 'inherit',
            color: 'currentColor',
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: 'content-box',
            background: 'none',
            height: '1.1876em',
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: 'transparent',
            display: 'block',
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: '100%',
            // Fix IE 11 width issue
            animationName: 'mui-auto-fill-cancel',
            animationDuration: '10ms',
            '&::-webkit-input-placeholder': placeholder,
            '&::-moz-placeholder': placeholder,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholder,
            // IE 11
            '&::-ms-input-placeholder': placeholder,
            // Edge
            '&:focus': {
                outline: 0
            },
            // Reset Firefox invalid required input style
            '&:invalid': {
                boxShadow: 'none'
            },
            '&::-webkit-search-decoration': {
                // Remove the padding when type=search.
                '-webkit-appearance': 'none'
            },
            // Show and hide the placeholder logic
            'label[data-shrink=false] + $formControl &': {
                '&::-webkit-input-placeholder': placeholderHidden,
                '&::-moz-placeholder': placeholderHidden,
                // Firefox 19+
                '&:-ms-input-placeholder': placeholderHidden,
                // IE 11
                '&::-ms-input-placeholder': placeholderHidden,
                // Edge
                '&:focus::-webkit-input-placeholder': placeholderVisible,
                '&:focus::-moz-placeholder': placeholderVisible,
                // Firefox 19+
                '&:focus:-ms-input-placeholder': placeholderVisible,
                // IE 11
                '&:focus::-ms-input-placeholder': placeholderVisible // Edge
            },
            '&$disabled': {
                opacity: 1 // Reset iOS opacity
            },
            '&:-webkit-autofill': {
                animationDuration: '5000s',
                animationName: 'mui-auto-fill'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: 'auto',
            resize: 'none',
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            '-moz-appearance': 'textfield',
            '-webkit-appearance': 'textfield'
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $9e0a52b199e51af8$var$useEnhancedEffect = typeof window === 'undefined' ? $7fPBF.useEffect : $7fPBF.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $9e0a52b199e51af8$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props['aria-describedby'], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, valueProp = props.value, other = (0, $lfiYO.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $7fPBF.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $7fPBF.useRef();
    var handleInputRefWarning = $7fPBF.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $55RWP.default)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $55RWP.default)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $55RWP.default)(inputRef, handleInputRefProp);
    var _React$useState = $7fPBF.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $bdGMx.useFormControl)();
    var fcs = (0, $4pUwJ.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'margin',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $7fPBF.useCallback(function(obj) {
        if ((0, $OVmIV.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $9e0a52b199e51af8$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $2dHXF.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $kY3Ke.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== 'string') inputProps = (0, $kY3Ke.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = 'textarea';
        else {
            inputProps = (0, $kY3Ke.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $6EYHi.default);
        }
    } else inputProps = (0, $kY3Ke.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $7fPBF.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes["color".concat((0, $dKzJP.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $7fPBF.createElement((0, $bdGMx.default).Provider, {
        value: null
    }, /*#__PURE__*/ $7fPBF.createElement(InputComponent, (0, $kY3Ke.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $jtRae.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $kY3Ke.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $9e0a52b199e51af8$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($9e0a52b199e51af8$export$9dd6ff9ea0189349, {
    name: 'MuiInputBase'
})($9e0a52b199e51af8$var$InputBase);

});
parcelRegister("4pUwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3375584ccd2a5a4f$export$2e2bcd8739ae039; });
function $3375584ccd2a5a4f$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("bdGMx", function(module, exports) {

$parcel$export(module.exports, "useFormControl", function () { return $82b218372db34c3a$export$62ecd8ad1bbe1a18; });
$parcel$export(module.exports, "default", function () { return $82b218372db34c3a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ var $82b218372db34c3a$var$FormControlContext = $7fPBF.createContext();
function $82b218372db34c3a$export$62ecd8ad1bbe1a18() {
    return $7fPBF.useContext($82b218372db34c3a$var$FormControlContext);
}
var $82b218372db34c3a$export$2e2bcd8739ae039 = $82b218372db34c3a$var$FormControlContext;

});

parcelRegister("6EYHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d958fbe8c962249$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $kyQ4S = parcelRequire("kyQ4S");

var $55RWP = parcelRequire("55RWP");

function $4d958fbe8c962249$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $4d958fbe8c962249$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $4d958fbe8c962249$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
var $4d958fbe8c962249$var$TextareaAutosize = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $lfiYO.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $7fPBF.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $7fPBF.useRef(null);
    var handleRef = (0, $55RWP.default)(ref, inputRef);
    var shadowRef = $7fPBF.useRef(null);
    var renders = $7fPBF.useRef(0);
    var _React$useState = $7fPBF.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $7fPBF.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        var boxSizing = computedStyle['box-sizing'];
        var padding = $4d958fbe8c962249$var$getStyleValue(computedStyle, 'padding-bottom') + $4d958fbe8c962249$var$getStyleValue(computedStyle, 'padding-top');
        var border = $4d958fbe8c962249$var$getStyleValue(computedStyle, 'border-bottom-width') + $4d958fbe8c962249$var$getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $7fPBF.useEffect(function() {
        var handleResize = (0, $kyQ4S.default)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        syncHeight
    ]);
    $4d958fbe8c962249$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $7fPBF.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("textarea", (0, $kY3Ke.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $kY3Ke.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? 'hidden' : null
        }, style)
    }, other)), /*#__PURE__*/ $7fPBF.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $kY3Ke.default)({}, $4d958fbe8c962249$var$styles.shadow, style)
    }));
});
var $4d958fbe8c962249$export$2e2bcd8739ae039 = $4d958fbe8c962249$var$TextareaAutosize;

});

parcelRegister("OVmIV", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $09912b38b5ca7fba$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $09912b38b5ca7fba$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $09912b38b5ca7fba$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $09912b38b5ca7fba$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($09912b38b5ca7fba$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $09912b38b5ca7fba$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
function $09912b38b5ca7fba$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});


parcelRegister("MQfsM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $092d03414723de94$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");



var $hiB9I = parcelRequire("hiB9I");

var $c75ZW = parcelRequire("c75ZW");

var $6bZ8k = parcelRequire("6bZ8k");

var $k2dmk = parcelRequire("k2dmk");

var $cuouK = parcelRequire("cuouK");

var $k8IO2 = parcelRequire("k8IO2");

var $g1A03 = parcelRequire("g1A03");

var $3Sc7z = parcelRequire("3Sc7z");
var $092d03414723de94$var$variantComponent = {
    standard: (0, $hiB9I.default),
    filled: (0, $c75ZW.default),
    outlined: (0, $6bZ8k.default)
};
var $092d03414723de94$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $092d03414723de94$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $lfiYO.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, label, displayRequired && "\xA0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $092d03414723de94$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $7fPBF.createElement(InputComponent, (0, $kY3Ke.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $7fPBF.createElement((0, $cuouK.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $7fPBF.createElement((0, $k2dmk.default), (0, $kY3Ke.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $7fPBF.createElement((0, $g1A03.default), (0, $kY3Ke.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $7fPBF.createElement((0, $k8IO2.default), (0, $kY3Ke.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $092d03414723de94$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($092d03414723de94$export$9dd6ff9ea0189349, {
    name: 'MuiTextField'
})($092d03414723de94$var$TextField);

});
parcelRegister("hiB9I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c980f0749e81b8bd$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $dzfbx = parcelRequire("dzfbx");

var $3Sc7z = parcelRequire("3Sc7z");
var $c980f0749e81b8bd$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative'
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            'label + &': {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:not($disabled):before': {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $c980f0749e81b8bd$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $lfiYO.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $dzfbx.default), (0, $kY3Ke.default)({
        classes: (0, $kY3Ke.default)({}, classes, {
            root: (0, $jtRae.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$c980f0749e81b8bd$var$Input.muiName = 'Input';
var $c980f0749e81b8bd$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($c980f0749e81b8bd$export$9dd6ff9ea0189349, {
    name: 'MuiInput'
})($c980f0749e81b8bd$var$Input);

});

parcelRegister("c75ZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d1aca982fb21d7b$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $dzfbx = parcelRequire("dzfbx");

var $3Sc7z = parcelRequire("3Sc7z");
var $8d1aca982fb21d7b$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            '&:hover': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: backgroundColor
                }
            },
            '&$focused': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
            },
            '&$disabled': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:before': {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '27px 12px 10px',
            '&$marginDense': {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '27px 12px 10px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            '&$inputMarginDense': {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $8d1aca982fb21d7b$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $lfiYO.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $dzfbx.default), (0, $kY3Ke.default)({
        classes: (0, $kY3Ke.default)({}, classes, {
            root: (0, $jtRae.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$8d1aca982fb21d7b$var$FilledInput.muiName = 'Input';
var $8d1aca982fb21d7b$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($8d1aca982fb21d7b$export$9dd6ff9ea0189349, {
    name: 'MuiFilledInput'
})($8d1aca982fb21d7b$var$FilledInput);

});

parcelRegister("6bZ8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $482330f7584ad7c2$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $dzfbx = parcelRequire("dzfbx");

var $5fCAV = parcelRequire("5fCAV");

var $3Sc7z = parcelRequire("3Sc7z");
var $482330f7584ad7c2$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            '&:hover $notchedOutline': {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                '&:hover $notchedOutline': {
                    borderColor: borderColor
                }
            },
            '&$focused $notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            '&$error $notchedOutline': {
                borderColor: theme.palette.error.main
            },
            '&$disabled $notchedOutline': {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused $notchedOutline': {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '18.5px 14px',
            '&$marginDense': {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '18.5px 14px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $482330f7584ad7c2$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $lfiYO.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $dzfbx.default), (0, $kY3Ke.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $7fPBF.createElement((0, $5fCAV.default), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $kY3Ke.default)({}, classes, {
            root: (0, $jtRae.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$482330f7584ad7c2$var$OutlinedInput.muiName = 'Input';
var $482330f7584ad7c2$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($482330f7584ad7c2$export$9dd6ff9ea0189349, {
    name: 'MuiOutlinedInput'
})($482330f7584ad7c2$var$OutlinedInput);

});
parcelRegister("5fCAV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d2c4a91216442c6$export$2e2bcd8739ae039; });

var $dQMrF = parcelRequire("dQMrF");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $fH0xA = parcelRequire("fH0xA");

var $dKzJP = parcelRequire("dKzJP");
var $3d2c4a91216442c6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'absolute',
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: '0 8px',
            pointerEvents: 'none',
            borderRadius: 'inherit',
            borderStyle: 'solid',
            borderWidth: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: 'left',
            padding: 0,
            lineHeight: '11px',
            // sync with `height` in `legend` styles
            transition: theme.transitions.create('width', {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: 'block',
            width: 'auto',
            textAlign: 'left',
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: '0.75em',
            visibility: 'hidden',
            maxWidth: 0.01,
            transition: theme.transitions.create('max-width', {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            '& > span': {
                paddingLeft: 5,
                paddingRight: 5,
                display: 'inline-block'
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create('max-width', {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $3d2c4a91216442c6$var$NotchedOutline = /*#__PURE__*/ $7fPBF.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $fH0xA.default)();
    var align = theme.direction === 'rtl' ? 'right' : 'left';
    if (label !== undefined) return /*#__PURE__*/ $7fPBF.createElement("fieldset", (0, $kY3Ke.default)({
        "aria-hidden": true,
        className: (0, $jtRae.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $7fPBF.createElement("legend", {
        className: (0, $jtRae.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $7fPBF.createElement("span", null, label) : /*#__PURE__*/ $7fPBF.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $7fPBF.createElement("fieldset", (0, $kY3Ke.default)({
        "aria-hidden": true,
        style: (0, $kY3Ke.default)((0, $dQMrF.default)({}, "padding".concat((0, $dKzJP.default)(align)), 8), style),
        className: (0, $jtRae.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
});
var $3d2c4a91216442c6$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($3d2c4a91216442c6$export$9dd6ff9ea0189349, {
    name: 'PrivateNotchedOutline'
})($3d2c4a91216442c6$var$NotchedOutline);

});


parcelRegister("k2dmk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e95e5b61afcdc62e$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $4pUwJ = parcelRequire("4pUwJ");

var $iWRZu = parcelRequire("iWRZu");

var $3Sc7z = parcelRequire("3Sc7z");

var $itsQ3 = parcelRequire("itsQ3");
var $e95e5b61afcdc62e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'block',
            transformOrigin: 'top left'
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: 'absolute',
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: 'translate(0, 24px) scale(1)'
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: 'translate(0, 21px) scale(1)'
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left'
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                'color',
                'transform'
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(12px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(12px, 17px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(12px, 10px) scale(0.75)',
                '&$marginDense': {
                    transform: 'translate(12px, 7px) scale(0.75)'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(14px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(14px, 12px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(14px, -6px) scale(0.75)'
            }
        }
    };
};
var $e95e5b61afcdc62e$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $iWRZu.default)();
    var shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $4pUwJ.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'margin',
            'variant'
        ]
    });
    return /*#__PURE__*/ $7fPBF.createElement((0, $itsQ3.default), (0, $kY3Ke.default)({
        "data-shrink": shrink,
        className: (0, $jtRae.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
            'filled': classes.filled,
            'outlined': classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $e95e5b61afcdc62e$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($e95e5b61afcdc62e$export$9dd6ff9ea0189349, {
    name: 'MuiInputLabel'
})($e95e5b61afcdc62e$var$InputLabel);

});
parcelRegister("iWRZu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb78639c8d45e62$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $bdGMx = parcelRequire("bdGMx");
function $dcb78639c8d45e62$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $bdGMx.default));
}

});

parcelRegister("itsQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7314e27b700237b$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $4pUwJ = parcelRequire("4pUwJ");

var $iWRZu = parcelRequire("iWRZu");

var $dKzJP = parcelRequire("dKzJP");

var $3Sc7z = parcelRequire("3Sc7z");
var $d7314e27b700237b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            '&$focused': {
                color: theme.palette.primary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused': {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            '&$error': {
                color: theme.palette.error.main
            }
        }
    };
};
var $d7314e27b700237b$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? 'label' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $iWRZu.default)();
    var fcs = (0, $4pUwJ.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes["color".concat((0, $dKzJP.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $7fPBF.createElement("span", {
        "aria-hidden": true,
        className: (0, $jtRae.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", '*'));
});
var $d7314e27b700237b$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($d7314e27b700237b$export$9dd6ff9ea0189349, {
    name: 'MuiFormLabel'
})($d7314e27b700237b$var$FormLabel);

});


parcelRegister("cuouK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $917b498c372b36e4$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $OVmIV = parcelRequire("OVmIV");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");

var $e7oTH = parcelRequire("e7oTH");

var $bdGMx = parcelRequire("bdGMx");
var $917b498c372b36e4$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top' // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: '100%'
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $917b498c372b36e4$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? 'none' : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $7fPBF.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, function(child) {
            if (!(0, $e7oTH.default)(child, [
                'Input',
                'Select'
            ])) return;
            var input = (0, $e7oTH.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $OVmIV.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $7fPBF.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, function(child) {
            if (!(0, $e7oTH.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $OVmIV.isFilled)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $7fPBF.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $7fPBF.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $7fPBF.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === 'small' ? 'dense' : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $bdGMx.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, $dKzJP.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $917b498c372b36e4$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($917b498c372b36e4$export$9dd6ff9ea0189349, {
    name: 'MuiFormControl'
})($917b498c372b36e4$var$FormControl);

});
parcelRegister("e7oTH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4750838c7947bc8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $a4750838c7947bc8$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});


parcelRegister("k8IO2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea974f91f41ce986$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $4pUwJ = parcelRequire("4pUwJ");

var $iWRZu = parcelRequire("iWRZu");

var $3Sc7z = parcelRequire("3Sc7z");
var $ea974f91f41ce986$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: 'left',
            marginTop: 3,
            margin: 0,
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $ea974f91f41ce986$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'p' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $iWRZu.default)();
    var fcs = (0, $4pUwJ.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'margin',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), children === ' ' ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $7fPBF.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : children);
});
var $ea974f91f41ce986$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($ea974f91f41ce986$export$9dd6ff9ea0189349, {
    name: 'MuiFormHelperText'
})($ea974f91f41ce986$var$FormHelperText);

});

parcelRegister("g1A03", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baa8aa2814cee247$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $5lgEe = parcelRequire("5lgEe");

var $3xTip = parcelRequire("3xTip");

var $4pUwJ = parcelRequire("4pUwJ");

var $iWRZu = parcelRequire("iWRZu");

var $3Sc7z = parcelRequire("3Sc7z");

var $jYjYo = parcelRequire("jYjYo");

var $hiB9I = parcelRequire("hiB9I");

var $arezW = parcelRequire("arezW");

var $jg1Pw = parcelRequire("jg1Pw");

var $c75ZW = parcelRequire("c75ZW");

var $6bZ8k = parcelRequire("6bZ8k");
var $baa8aa2814cee247$export$9dd6ff9ea0189349 = (0, $arezW.styles);
var $baa8aa2814cee247$var$_ref = /*#__PURE__*/ $7fPBF.createElement((0, $hiB9I.default), null);
var $baa8aa2814cee247$var$_ref2 = /*#__PURE__*/ $7fPBF.createElement((0, $c75ZW.default), null);
var $baa8aa2814cee247$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $jYjYo.default) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $lfiYO.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $jg1Pw.default) : (0, $3xTip.default);
    var muiFormControl = (0, $iWRZu.default)();
    var fcs = (0, $4pUwJ.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $baa8aa2814cee247$var$_ref,
        outlined: /*#__PURE__*/ $7fPBF.createElement((0, $6bZ8k.default), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $baa8aa2814cee247$var$_ref2
    })[variant];
    return /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, (0, $kY3Ke.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $kY3Ke.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $kY3Ke.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $5lgEe.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$baa8aa2814cee247$var$Select.muiName = 'Select';
var $baa8aa2814cee247$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($baa8aa2814cee247$export$9dd6ff9ea0189349, {
    name: 'MuiSelect'
})($baa8aa2814cee247$var$Select);

});
parcelRegister("3xTip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $294f58cb5ad587cd$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $6TO5S = parcelRequire("6TO5S");

var $2dHXF = parcelRequire("2dHXF");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $jtRae = parcelRequire("jtRae");

var $g3iV0 = parcelRequire("g3iV0");

var $dKzJP = parcelRequire("dKzJP");

var $7w83m = parcelRequire("7w83m");

var $OVmIV = parcelRequire("OVmIV");

var $55RWP = parcelRequire("55RWP");

var $3deDh = parcelRequire("3deDh");
function $294f58cb5ad587cd$var$areEqualValues(a, b) {
    if ((0, $6TO5S.default)(b) === 'object' && b !== null) return a === b;
    return String(a) === String(b);
}
function $294f58cb5ad587cd$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $294f58cb5ad587cd$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props['aria-label'], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $lfiYO.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $3deDh.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    }), _useControlled2 = (0, $2gIIh.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $7fPBF.useRef(null);
    var _React$useState = $7fPBF.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $7fPBF.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $7fPBF.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $7fPBF.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $55RWP.default)(ref, inputRefProp);
    $7fPBF.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $7fPBF.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $7fPBF.useEffect(function() {
        if (displayNode) {
            var label = (0, $g3iV0.default)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener('click', handler);
                return function() {
                    label.removeEventListener('click', handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $7fPBF.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, 'target', {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $OVmIV.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $2dHXF.default)(2));
            selected = value.some(function(v) {
                return $294f58cb5ad587cd$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $294f58cb5ad587cd$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            'aria-selected': selected ? 'true' : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(', ') : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? 'true' : undefined,
        "aria-expanded": open ? 'true' : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(' ') || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $294f58cb5ad587cd$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $7fPBF.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : display), /*#__PURE__*/ $7fPBF.createElement("input", (0, $kY3Ke.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $7fPBF.createElement(IconComponent, {
        className: (0, $jtRae.default)(classes.icon, classes["icon".concat((0, $dKzJP.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $7fPBF.createElement((0, $7w83m.default), (0, $kY3Ke.default)({
        id: "menu-".concat(name || ''),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $kY3Ke.default)({
            'aria-labelledby': labelId,
            role: 'listbox',
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $kY3Ke.default)({}, MenuProps.PaperProps, {
            style: (0, $kY3Ke.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $294f58cb5ad587cd$export$2e2bcd8739ae039 = $294f58cb5ad587cd$var$SelectInput;

});
parcelRegister("j2VHG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("45MkT"));

});

parcelRegister("7w83m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5791c4c777b9b408$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $9zU0q = parcelRequire("9zU0q");

var $5IlSp = parcelRequire("5IlSp");

var $fw0lo = parcelRequire("fw0lo");

var $6FBGG = parcelRequire("6FBGG");

var $fH0xA = parcelRequire("fH0xA");

var $5791c4c777b9b408$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
var $5791c4c777b9b408$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
var $5791c4c777b9b408$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: 'calc(100% - 96px)',
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: 'touch'
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $5791c4c777b9b408$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $lfiYO.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $lfiYO.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $fH0xA.default)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $7fPBF.useRef(null);
    var contentAnchorRef = $7fPBF.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $7fPBF.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $fw0lo.findDOMNode(instance);
                (0, $6FBGG.default)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $7fPBF.createElement((0, $9zU0q.default), (0, $kY3Ke.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $kY3Ke.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === 'rtl' ? $5791c4c777b9b408$var$RTL_ORIGIN : $5791c4c777b9b408$var$LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? $5791c4c777b9b408$var$RTL_ORIGIN : $5791c4c777b9b408$var$LTR_ORIGIN,
        PaperProps: (0, $kY3Ke.default)({}, PaperProps, {
            classes: (0, $kY3Ke.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $7fPBF.createElement((0, $5IlSp.default), (0, $kY3Ke.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $jtRae.default)(classes.list, MenuListProps.className)
    }), items));
});
var $5791c4c777b9b408$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($5791c4c777b9b408$export$9dd6ff9ea0189349, {
    name: 'MuiMenu'
})($5791c4c777b9b408$var$Menu);

});
parcelRegister("9zU0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f92d3838cb251f9$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $fw0lo = parcelRequire("fw0lo");


var $kyQ4S = parcelRequire("kyQ4S");

var $jtRae = parcelRequire("jtRae");

var $g3iV0 = parcelRequire("g3iV0");

var $bSzdr = parcelRequire("bSzdr");

var $5oAE5 = parcelRequire("5oAE5");


var $3Sc7z = parcelRequire("3Sc7z");

var $xOJv4 = parcelRequire("xOJv4");

var $bG0nA = parcelRequire("bG0nA");

var $ckpfM = parcelRequire("ckpfM");
function $6f92d3838cb251f9$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $6f92d3838cb251f9$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $6f92d3838cb251f9$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === 'number' ? "".concat(n, "px") : n;
    }).join(' ');
} // Sum the scrollTop between two elements.
function $6f92d3838cb251f9$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $6f92d3838cb251f9$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $6f92d3838cb251f9$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: 'absolute',
        overflowY: 'auto',
        overflowX: 'hidden',
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: 'calc(100% - 32px)',
        maxHeight: 'calc(100% - 32px)',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $6f92d3838cb251f9$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $bG0nA.default) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $lfiYO.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $7fPBF.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $7fPBF.useCallback(function(contentAnchorOffset) {
        if (anchorReference === 'anchorPosition') return anchorPosition;
        var resolvedAnchorEl = $6f92d3838cb251f9$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $g3iV0.default)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
        return {
            top: anchorRect.top + $6f92d3838cb251f9$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $6f92d3838cb251f9$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $7fPBF.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === 'anchorEl') {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $6f92d3838cb251f9$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $7fPBF.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $6f92d3838cb251f9$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $6f92d3838cb251f9$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $7fPBF.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $6f92d3838cb251f9$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $bSzdr.default)($6f92d3838cb251f9$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $6f92d3838cb251f9$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $7fPBF.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $7fPBF.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $fw0lo.findDOMNode(instance);
    }, []);
    $7fPBF.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $kyQ4S.default)(function() {
            setPositioningStyles();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $g3iV0.default)($6f92d3838cb251f9$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $7fPBF.createElement((0, $xOJv4.default), (0, $kY3Ke.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $jtRae.default)(classes.root, className)
    }, other), /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $5oAE5.default)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $7fPBF.createElement((0, $ckpfM.default), (0, $kY3Ke.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $jtRae.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $6f92d3838cb251f9$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($6f92d3838cb251f9$export$9dd6ff9ea0189349, {
    name: 'MuiPopover'
})($6f92d3838cb251f9$var$Popover);

});
parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});

parcelRegister("5oAE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3edb9eb5f349c2b5$export$2e2bcd8739ae039; });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $3edb9eb5f349c2b5$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}

});

parcelRegister("xOJv4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $065a6fac87661fe9$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $4mLf7 = parcelRequire("4mLf7");
var $qjAyq = parcelRequire("qjAyq");



var $g3iV0 = parcelRequire("g3iV0");

var $fzP0v = parcelRequire("fzP0v");

var $5oAE5 = parcelRequire("5oAE5");

var $55RWP = parcelRequire("55RWP");

var $1sMi9 = parcelRequire("1sMi9");

var $ep8x4 = parcelRequire("ep8x4");

var $69oMy = parcelRequire("69oMy");

var $hdcUo = parcelRequire("hdcUo");

var $kAbDb = parcelRequire("kAbDb");
function $065a6fac87661fe9$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container;
    return $fw0lo.findDOMNode(container);
}
function $065a6fac87661fe9$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $065a6fac87661fe9$var$defaultManager = new (0, $69oMy.default)();
var $065a6fac87661fe9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'fixed',
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: 'hidden'
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $065a6fac87661fe9$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $qjAyq.default)();
    var props = (0, $4mLf7.default)({
        name: 'MuiModal',
        props: (0, $kY3Ke.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $kAbDb.default) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $065a6fac87661fe9$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $lfiYO.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $7fPBF.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $7fPBF.useRef({});
    var mountNodeRef = $7fPBF.useRef(null);
    var modalRef = $7fPBF.useRef(null);
    var handleRef = (0, $55RWP.default)(modalRef, ref);
    var hasTransition = $065a6fac87661fe9$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $g3iV0.default)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $1sMi9.default)(function() {
        var resolvedContainer = $065a6fac87661fe9$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $7fPBF.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $1sMi9.default)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $69oMy.ariaHidden)(modalRef.current, true);
    });
    var handleClose = $7fPBF.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $7fPBF.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== 'Escape' || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, 'escapeKeyDown');
        }
    };
    var inlineStyle = $065a6fac87661fe9$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $ep8x4.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || '-1';
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $5oAE5.default)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $5oAE5.default)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $7fPBF.createElement((0, $fzP0v.default), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $kY3Ke.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $7fPBF.createElement(BackdropComponent, (0, $kY3Ke.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $7fPBF.createElement((0, $hdcUo.default), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $7fPBF.cloneElement(children, childProps))));
});
var $065a6fac87661fe9$export$2e2bcd8739ae039 = $065a6fac87661fe9$var$Modal;

});
parcelRegister("fzP0v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b571b0dcac5ffd08$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");




var $6FBGG = parcelRequire("6FBGG");

var $55RWP = parcelRequire("55RWP");
function $b571b0dcac5ffd08$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container; // #StrictMode ready
    return $fw0lo.findDOMNode(container);
}
var $b571b0dcac5ffd08$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $b571b0dcac5ffd08$var$Portal = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $7fPBF.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $55RWP.default)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? children.ref : null, ref);
    $b571b0dcac5ffd08$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($b571b0dcac5ffd08$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $b571b0dcac5ffd08$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $6FBGG.default)(ref, mountNode);
            return function() {
                (0, $6FBGG.default)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $b571b0dcac5ffd08$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) return /*#__PURE__*/ $7fPBF.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $fw0lo.createPortal(children, mountNode) : mountNode;
});
var $b571b0dcac5ffd08$export$2e2bcd8739ae039 = $b571b0dcac5ffd08$var$Portal;

});

parcelRegister("69oMy", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $47a6ce8c3ec91191$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "default", function () { return $47a6ce8c3ec91191$export$2e2bcd8739ae039; });

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $cwJVy = parcelRequire("cwJVy");

var $5mw8i = parcelRequire("5mw8i");

var $g3iV0 = parcelRequire("g3iV0");

var $bSzdr = parcelRequire("bSzdr");
function $47a6ce8c3ec91191$var$isOverflowing(container) {
    var doc = (0, $g3iV0.default)(container);
    if (doc.body === container) return (0, $bSzdr.default)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $47a6ce8c3ec91191$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
}
function $47a6ce8c3ec91191$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}
function $47a6ce8c3ec91191$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $cwJVy.default)(nodesToExclude));
    var blacklistTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE'
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $47a6ce8c3ec91191$export$e1bd0c6150f13d96(node, show);
    });
}
function $47a6ce8c3ec91191$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $47a6ce8c3ec91191$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($47a6ce8c3ec91191$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $5mw8i.default)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: 'padding-right',
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style['padding-right'] = "".concat($47a6ce8c3ec91191$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $g3iV0.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($47a6ce8c3ec91191$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: 'overflow',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty('padding-right');
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $47a6ce8c3ec91191$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $47a6ce8c3ec91191$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $03dWn.default)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $4OFm0.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $47a6ce8c3ec91191$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $47a6ce8c3ec91191$var$getHiddenSiblings(container);
                $47a6ce8c3ec91191$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $47a6ce8c3ec91191$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $47a6ce8c3ec91191$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $47a6ce8c3ec91191$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $47a6ce8c3ec91191$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $47a6ce8c3ec91191$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $47a6ce8c3ec91191$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $47a6ce8c3ec91191$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();

});
parcelRegister("5mw8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e77eebbacf1ead0$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $3e77eebbacf1ead0$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}

});


parcelRegister("hdcUo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c87da9ed45a21779$export$2e2bcd8739ae039; });
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $g3iV0 = parcelRequire("g3iV0");

var $55RWP = parcelRequire("55RWP");

/**
 * Utility component that locks focus inside the component.
 */ function $c87da9ed45a21779$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $7fPBF.useRef();
    var sentinelStart = $7fPBF.useRef(null);
    var sentinelEnd = $7fPBF.useRef(null);
    var nodeToRestore = $7fPBF.useRef();
    var rootRef = $7fPBF.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $7fPBF.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $fw0lo.findDOMNode(instance);
    }, []);
    var handleRef = (0, $55RWP.default)(children.ref, handleOwnRef);
    var prevOpenRef = $7fPBF.useRef();
    $7fPBF.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== 'undefined') // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $7fPBF.useEffect(function() {
        if (!open) return;
        var doc = (0, $g3iV0.default)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener('focus', contain, true);
        doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener('focus', contain, true);
            doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $7fPBF.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $7fPBF.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $c87da9ed45a21779$export$2e2bcd8739ae039 = $c87da9ed45a21779$var$Unstable_TrapFocus;

});

parcelRegister("kAbDb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efc03123516863ca$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");

var $efc03123516863ca$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: 'fixed',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
/**
 * @ignore - internal component.
 */ var $efc03123516863ca$var$SimpleBackdrop = /*#__PURE__*/ $7fPBF.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $lfiYO.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $kY3Ke.default)({}, $efc03123516863ca$export$9dd6ff9ea0189349.root, invisible ? $efc03123516863ca$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $efc03123516863ca$export$2e2bcd8739ae039 = $efc03123516863ca$var$SimpleBackdrop;

});


parcelRegister("bG0nA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8803e9529720cdf1$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $8qMCX = parcelRequire("8qMCX");

var $fH0xA = parcelRequire("fH0xA");

var $2Jy9X = parcelRequire("2Jy9X");

var $55RWP = parcelRequire("55RWP");
function $8803e9529720cdf1$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $8803e9529720cdf1$var$styles = {
    entering: {
        opacity: 1,
        transform: $8803e9529720cdf1$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $8803e9529720cdf1$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 'auto' : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $8qMCX.default) : _props$TransitionComp, other = (0, $lfiYO.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $7fPBF.useRef();
    var autoTimeout = $7fPBF.useRef();
    var theme = (0, $fH0xA.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $7fPBF.useRef(null);
    var foreignRef = (0, $55RWP.default)(children.ref, ref);
    var handleRef = (0, $55RWP.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $2gIIh.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $2Jy9X.reflow)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $2Jy9X.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $2Jy9X.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(',');
        node.style.opacity = '0';
        node.style.transform = $8803e9529720cdf1$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $7fPBF.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
            style: (0, $kY3Ke.default)({
                opacity: 0,
                transform: $8803e9529720cdf1$var$getScale(0.75),
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $8803e9529720cdf1$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$8803e9529720cdf1$var$Grow.muiSupportAuto = true;
var $8803e9529720cdf1$export$2e2bcd8739ae039 = $8803e9529720cdf1$var$Grow;

});
parcelRegister("8qMCX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $623678cbb6daf054$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $1KLsX = parcelRequire("1KLsX");


var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $bTMtR = parcelRequire("bTMtR");


var $8ovTL = parcelRequire("8ovTL");

var $kKJSm = parcelRequire("kKJSm");
var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $kKJSm.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cFLic.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $8ovTL.default);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;

});
parcelRegister("bTMtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a9a7006a9b8efe4$export$2e2bcd8739ae039; });
var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("8ovTL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61c94efb1735eff6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);

});

parcelRegister("kKJSm", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $f1bbb084f2fb10b7$export$7d26bbb1236dafd6; });
var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("2Jy9X", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $1fda481bdef76ccd$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $1fda481bdef76ccd$export$8cb1e9b404609ae9; });
var $1fda481bdef76ccd$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $1fda481bdef76ccd$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}

});


parcelRegister("ckpfM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f9af11a15994c69$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");
var $8f9af11a15994c69$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $kY3Ke.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create('box-shadow')
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $8f9af11a15994c69$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? 'elevation' : _props$variant, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $8f9af11a15994c69$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($8f9af11a15994c69$export$9dd6ff9ea0189349, {
    name: 'MuiPaper'
})($8f9af11a15994c69$var$Paper);

});


parcelRegister("5IlSp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4292080ff34860fb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $fw0lo = parcelRequire("fw0lo");

var $g3iV0 = parcelRequire("g3iV0");

var $fOH1P = parcelRequire("fOH1P");

var $5mw8i = parcelRequire("5mw8i");

var $55RWP = parcelRequire("55RWP");
function $4292080ff34860fb$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $4292080ff34860fb$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $4292080ff34860fb$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $4292080ff34860fb$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$4292080ff34860fb$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $4292080ff34860fb$var$useEnhancedEffect = typeof window === 'undefined' ? $7fPBF.useEffect : $7fPBF.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $4292080ff34860fb$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $lfiYO.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $7fPBF.useRef(null);
    var textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $4292080ff34860fb$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $5mw8i.default)(true), "px");
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $g3iV0.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $4292080ff34860fb$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4292080ff34860fb$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $4292080ff34860fb$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4292080ff34860fb$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $4292080ff34860fb$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4292080ff34860fb$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $4292080ff34860fb$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4292080ff34860fb$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $4292080ff34860fb$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $4292080ff34860fb$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $4292080ff34860fb$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $7fPBF.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $fw0lo.findDOMNode(instance);
    }, []);
    var handleRef = (0, $55RWP.default)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $7fPBF.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $7fPBF.createElement((0, $fOH1P.default), (0, $kY3Ke.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $4292080ff34860fb$export$2e2bcd8739ae039 = $4292080ff34860fb$var$MenuList;

});
parcelRegister("fOH1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b83ce716d4e62678$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $2YkFy = parcelRequire("2YkFy");
var $b83ce716d4e62678$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $b83ce716d4e62678$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'ul' : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $7fPBF.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $2YkFy.default).Provider, {
        value: context
    }, /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $b83ce716d4e62678$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($b83ce716d4e62678$export$9dd6ff9ea0189349, {
    name: 'MuiList'
})($b83ce716d4e62678$var$List);

});
parcelRegister("2YkFy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22a137de54290818$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ var $22a137de54290818$var$ListContext = $7fPBF.createContext({});
var $22a137de54290818$export$2e2bcd8739ae039 = $22a137de54290818$var$ListContext;

});




parcelRegister("3deDh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $256defba4345466a$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $7fPBF = parcelRequire("7fPBF");
function $256defba4345466a$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? 'value' : _ref$state;
    var _React$useRef = $7fPBF.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $7fPBF.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $7fPBF.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("jYjYo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8a31d2e5a67fd6c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $e8a31d2e5a67fd6c$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("arezW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7997bc0ac5b72a2d$export$9dd6ff9ea0189349; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jg1Pw = parcelRequire("jg1Pw");

var $3Sc7z = parcelRequire("3Sc7z");

var $4pUwJ = parcelRequire("4pUwJ");

var $iWRZu = parcelRequire("iWRZu");

var $jYjYo = parcelRequire("jYjYo");

var $hiB9I = parcelRequire("hiB9I");
var $7997bc0ac5b72a2d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            '-moz-appearance': 'none',
            // Reset
            '-webkit-appearance': 'none',
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: 'none',
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: 'pointer',
            '&:focus': {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            '&::-ms-expand': {
                display: 'none'
            },
            '&$disabled': {
                cursor: 'default'
            },
            '&[multiple]': {
                height: 'auto'
            },
            '&:not([multiple]) option, &:not([multiple]) optgroup': {
                backgroundColor: theme.palette.background.paper
            },
            '&&': {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: 'auto',
            // Resets for multpile select with chips
            minHeight: '1.1876em',
            // Required for select\text-field height consistency
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: 'absolute',
            right: 0,
            top: 'calc(50% - 12px)',
            // Center vertically
            pointerEvents: 'none',
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
            width: '100%'
        }
    };
};
var $7997bc0ac5b72a2d$var$defaultInput = /*#__PURE__*/ $7fPBF.createElement((0, $hiB9I.default), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $7997bc0ac5b72a2d$var$NativeSelect = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $jYjYo.default) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $7997bc0ac5b72a2d$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $iWRZu.default)();
    var fcs = (0, $4pUwJ.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    return /*#__PURE__*/ $7fPBF.cloneElement(input, (0, $kY3Ke.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $jg1Pw.default),
        inputProps: (0, $kY3Ke.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$7997bc0ac5b72a2d$var$NativeSelect.muiName = 'Select';
var $7997bc0ac5b72a2d$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($7997bc0ac5b72a2d$export$9dd6ff9ea0189349, {
    name: 'MuiNativeSelect'
})($7997bc0ac5b72a2d$var$NativeSelect);

});
parcelRegister("jg1Pw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e050ee5bbc64d202$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $dKzJP = parcelRequire("dKzJP");
/**
 * @ignore - internal component.
 */ var $e050ee5bbc64d202$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("select", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $7fPBF.createElement(IconComponent, {
        className: (0, $jtRae.default)(classes.icon, classes["icon".concat((0, $dKzJP.default)(variant))], disabled && classes.disabled)
    }));
});
var $e050ee5bbc64d202$export$2e2bcd8739ae039 = $e050ee5bbc64d202$var$NativeSelectInput;

});




parcelRegister("i8OTH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d350747c0774ad7b$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $kVsLZ = parcelRequire("kVsLZ");

var $3eiyr = parcelRequire("3eiyr");

var $9vk0I = parcelRequire("9vk0I");

var $2jEfe = parcelRequire("2jEfe");

var $aDS8G = parcelRequire("aDS8G");

var $dKzJP = parcelRequire("dKzJP");

var $3Sc7z = parcelRequire("3Sc7z");
var $d350747c0774ad7b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */ indeterminate: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $2jEfe.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $2jEfe.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $d350747c0774ad7b$var$defaultCheckedIcon = /*#__PURE__*/ $7fPBF.createElement((0, $9vk0I.default), null);
var $d350747c0774ad7b$var$defaultIcon = /*#__PURE__*/ $7fPBF.createElement((0, $3eiyr.default), null);
var $d350747c0774ad7b$var$defaultIndeterminateIcon = /*#__PURE__*/ $7fPBF.createElement((0, $aDS8G.default), null);
var $d350747c0774ad7b$var$Checkbox = /*#__PURE__*/ $7fPBF.forwardRef(function Checkbox(props, ref) {
    var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? $d350747c0774ad7b$var$defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? $d350747c0774ad7b$var$defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? $d350747c0774ad7b$var$defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $lfiYO.default)(props, [
        "checkedIcon",
        "classes",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "inputProps",
        "size"
    ]);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    return /*#__PURE__*/ $7fPBF.createElement((0, $kVsLZ.default), (0, $kY3Ke.default)({
        type: "checkbox",
        classes: {
            root: (0, $jtRae.default)(classes.root, classes["color".concat((0, $dKzJP.default)(color))], indeterminate && classes.indeterminate),
            checked: classes.checked,
            disabled: classes.disabled
        },
        color: color,
        inputProps: (0, $kY3Ke.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
            fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
        }),
        checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(indeterminateIcon, {
            fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
        }),
        ref: ref
    }, other));
});
var $d350747c0774ad7b$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($d350747c0774ad7b$export$9dd6ff9ea0189349, {
    name: 'MuiCheckbox'
})($d350747c0774ad7b$var$Checkbox);

});
parcelRegister("kVsLZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3bf73407f42ef47$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3deDh = parcelRequire("3deDh");

var $iWRZu = parcelRequire("iWRZu");

var $3Sc7z = parcelRequire("3Sc7z");

var $iRcsz = parcelRequire("iRcsz");
var $f3bf73407f42ef47$export$9dd6ff9ea0189349 = {
    root: {
        padding: 9
    },
    checked: {},
    disabled: {},
    input: {
        cursor: 'inherit',
        position: 'absolute',
        opacity: 0,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        zIndex: 1
    }
};
/**
 * @ignore - internal component.
 */ var $f3bf73407f42ef47$var$SwitchBase = /*#__PURE__*/ $7fPBF.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0, $lfiYO.default)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "classes",
        "className",
        "defaultChecked",
        "disabled",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value"
    ]);
    var _useControlled = (0, $3deDh.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    }), _useControlled2 = (0, $2gIIh.default)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
    var muiFormControl = (0, $iWRZu.default)();
    var handleFocus = function handleFocus(event) {
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    var handleInputChange = function handleInputChange(event) {
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v5: remove the second argument.
        onChange(event, newChecked);
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    var hasLabelFor = type === 'checkbox' || type === 'radio';
    return /*#__PURE__*/ $7fPBF.createElement((0, $iRcsz.default), (0, $kY3Ke.default)({
        component: "span",
        className: (0, $jtRae.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement("input", (0, $kY3Ke.default)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
    }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var $f3bf73407f42ef47$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($f3bf73407f42ef47$export$9dd6ff9ea0189349, {
    name: 'PrivateSwitchBase'
})($f3bf73407f42ef47$var$SwitchBase);

});
parcelRegister("iRcsz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dba6d77993e9fccb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $2jEfe = parcelRequire("2jEfe");

var $gd1Bg = parcelRequire("gd1Bg");

var $dKzJP = parcelRequire("dKzJP");
var $dba6d77993e9fccb$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: 'center',
            flex: '0 0 auto',
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: '50%',
            overflow: 'visible',
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                backgroundColor: 'transparent',
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            '$sizeSmall&': {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            '$sizeSmall&': {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: '100%',
            display: 'flex',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $dba6d77993e9fccb$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $lfiYO.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $gd1Bg.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, color !== 'default' && classes["color".concat((0, $dKzJP.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $dKzJP.default)(size))], {
            'start': classes.edgeStart,
            'end': classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.label
    }, children));
});
var $dba6d77993e9fccb$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($dba6d77993e9fccb$export$9dd6ff9ea0189349, {
    name: 'MuiIconButton'
})($dba6d77993e9fccb$var$IconButton);

});
parcelRegister("gd1Bg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $030b993186d314ba$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $fw0lo = parcelRequire("fw0lo");

var $jtRae = parcelRequire("jtRae");


var $55RWP = parcelRequire("55RWP");

var $1sMi9 = parcelRequire("1sMi9");


var $3Sc7z = parcelRequire("3Sc7z");

var $K4XJ4 = parcelRequire("K4XJ4");

var $6Xtyn = parcelRequire("6Xtyn");
var $030b993186d314ba$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$disabled': {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $030b993186d314ba$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, other = (0, $lfiYO.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $7fPBF.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $fw0lo.findDOMNode(buttonRef.current);
    }
    var rippleRef = $7fPBF.useRef(null);
    var _React$useState = $7fPBF.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $K4XJ4.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $7fPBF.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $7fPBF.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $1sMi9.default)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler('start', onMouseDown);
    var handleDragLeave = useRippleHandler('stop', onDragLeave);
    var handleMouseUp = useRippleHandler('stop', onMouseUp);
    var handleMouseLeave = useRippleHandler('stop', function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler('start', onTouchStart);
    var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    var handleTouchMove = useRippleHandler('stop', onTouchMove);
    var handleBlur = useRippleHandler('stop', function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $1sMi9.default)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $7fPBF.useRef(false);
    var handleKeyDown = (0, $1sMi9.default)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $1sMi9.default)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === 'button' && other.href) ComponentProp = 'a';
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== 'a' || !other.href) buttonProps.role = 'button';
        buttonProps['aria-disabled'] = disabled;
    }
    var handleUserRef = (0, $55RWP.default)(buttonRefProp, ref);
    var handleOwnRef = (0, $55RWP.default)(focusVisibleRef, buttonRef);
    var handleRef = (0, $55RWP.default)(handleUserRef, handleOwnRef);
    var _React$useState2 = $7fPBF.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $7fPBF.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $7fPBF.createElement(ComponentProp, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $7fPBF.createElement((0, $6Xtyn.default), (0, $kY3Ke.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $030b993186d314ba$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($030b993186d314ba$export$9dd6ff9ea0189349, {
    name: 'MuiButtonBase'
})($030b993186d314ba$var$ButtonBase);

});
parcelRegister("K4XJ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a8256810246336$export$2e2bcd8739ae039; });
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
var $08a8256810246336$var$hadKeyboardEvent = true;
var $08a8256810246336$var$hadFocusVisibleRecently = false;
var $08a8256810246336$var$hadFocusVisibleRecentlyTimeout = null;
var $08a8256810246336$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $08a8256810246336$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === 'INPUT' && $08a8256810246336$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $08a8256810246336$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $08a8256810246336$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $08a8256810246336$var$handlePointerDown() {
    $08a8256810246336$var$hadKeyboardEvent = false;
}
function $08a8256810246336$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($08a8256810246336$var$hadFocusVisibleRecently) $08a8256810246336$var$hadKeyboardEvent = true;
    }
}
function $08a8256810246336$var$prepare(doc) {
    doc.addEventListener('keydown', $08a8256810246336$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $08a8256810246336$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $08a8256810246336$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $08a8256810246336$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $08a8256810246336$var$handleVisibilityChange, true);
}
function $08a8256810246336$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $08a8256810246336$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $08a8256810246336$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $08a8256810246336$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $08a8256810246336$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $08a8256810246336$var$handleVisibilityChange, true);
}
function $08a8256810246336$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(':focus-visible');
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $08a8256810246336$var$hadKeyboardEvent || $08a8256810246336$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $08a8256810246336$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $08a8256810246336$var$hadFocusVisibleRecently = true;
    window.clearTimeout($08a8256810246336$var$hadFocusVisibleRecentlyTimeout);
    $08a8256810246336$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $08a8256810246336$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $08a8256810246336$export$2e2bcd8739ae039() {
    var ref = $7fPBF.useCallback(function(instance) {
        var node = $fw0lo.findDOMNode(instance);
        if (node != null) $08a8256810246336$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $08a8256810246336$var$isFocusVisible,
        onBlurVisible: $08a8256810246336$var$handleBlurVisible,
        ref: ref
    };
}

});

parcelRegister("6Xtyn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $510f2d7a40afd2d1$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cwJVy = parcelRequire("cwJVy");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $4axyc = parcelRequire("4axyc");

var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $gGehT = parcelRequire("gGehT");
var $510f2d7a40afd2d1$var$DURATION = 550;
var $510f2d7a40afd2d1$export$95d0c9356b2231a3 = 80;
var $510f2d7a40afd2d1$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: 'inherit'
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: 'absolute'
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: 'scale(1)',
            animation: "$enter ".concat($510f2d7a40afd2d1$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($510f2d7a40afd2d1$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: 'absolute',
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        '@keyframes enter': {
            '0%': {
                transform: 'scale(0)',
                opacity: 0.1
            },
            '100%': {
                transform: 'scale(1)',
                opacity: 0.3
            }
        },
        '@keyframes exit': {
            '0%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        '@keyframes pulsate': {
            '0%': {
                transform: 'scale(1)'
            },
            '50%': {
                transform: 'scale(0.92)'
            },
            '100%': {
                transform: 'scale(1)'
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $510f2d7a40afd2d1$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $lfiYO.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $7fPBF.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $7fPBF.useRef(0);
    var rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $7fPBF.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $7fPBF.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $7fPBF.useRef(null);
    var container = $7fPBF.useRef(null);
    $7fPBF.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $7fPBF.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $cwJVy.default)(oldRipples), [
                /*#__PURE__*/ $7fPBF.createElement((0, $gGehT.default), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $510f2d7a40afd2d1$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $7fPBF.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === 'touchstart') ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $510f2d7a40afd2d1$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $7fPBF.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $7fPBF.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === 'touchend' && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $7fPBF.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $7fPBF.createElement((0, $4axyc.default), {
        component: null,
        exit: true
    }, ripples));
});
var $510f2d7a40afd2d1$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($510f2d7a40afd2d1$export$9dd6ff9ea0189349, {
    flip: false,
    name: 'MuiTouchRipple'
})(/*#__PURE__*/ $7fPBF.memo($510f2d7a40afd2d1$var$TouchRipple));

});
parcelRegister("4axyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30921f11ad4ef55c$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $3zeAJ = parcelRequire("3zeAJ");

var $1KLsX = parcelRequire("1KLsX");


var $7fPBF = parcelRequire("7fPBF");

var $8ovTL = parcelRequire("8ovTL");

var $3CAnX = parcelRequire("3CAnX");
var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $3zeAJ.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $3CAnX.getInitialChildMapping)(nextProps, handleExited) : (0, $3CAnX.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $3CAnX.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kY3Ke.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cFLic.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;

});
parcelRegister("3CAnX", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $2a31251aa5f7eb4f$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $2a31251aa5f7eb4f$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $2a31251aa5f7eb4f$export$36fd1af28d383ec0; });

var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("gGehT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c24ba6d466a8355b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $1sMi9 = parcelRequire("1sMi9");
var $c24ba6d466a8355b$var$useEnhancedEffect = typeof window === 'undefined' ? $7fPBF.useEffect : $7fPBF.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $c24ba6d466a8355b$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $7fPBF.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $jtRae.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $jtRae.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $1sMi9.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $c24ba6d466a8355b$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        className: childClassName
    }));
}
var $c24ba6d466a8355b$export$2e2bcd8739ae039 = $c24ba6d466a8355b$var$Ripple;

});





parcelRegister("3eiyr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25a11273446a4f46$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $25a11273446a4f46$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("9vk0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eb687fae0011849$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $6eb687fae0011849$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("aDS8G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bf78acb03c9cf60$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $7bf78acb03c9cf60$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});


parcelRegister("g21Gx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $babe23e46024b8f1$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $hPUC4 = parcelRequire("hPUC4");
var $babe23e46024b8f1$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({}, theme.typography.body1, (0, $dQMrF.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: 'border-box',
            width: 'auto',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }, theme.breakpoints.up('sm'), {
            minHeight: 'auto'
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $kY3Ke.default)({}, theme.typography.body2, {
            minHeight: 'auto'
        })
    };
};
var $babe23e46024b8f1$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'li' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? 'menuitem' : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $7fPBF.createElement((0, $hPUC4.default), (0, $kY3Ke.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $kY3Ke.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $jtRae.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $babe23e46024b8f1$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($babe23e46024b8f1$export$9dd6ff9ea0189349, {
    name: 'MuiMenuItem'
})($babe23e46024b8f1$var$MenuItem);

});
parcelRegister("hPUC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfc31d3c5af6e55c$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $gd1Bg = parcelRequire("gd1Bg");

var $e7oTH = parcelRequire("e7oTH");

var $55RWP = parcelRequire("55RWP");

var $2YkFy = parcelRequire("2YkFy");

var $fw0lo = parcelRequire("fw0lo");
var $cfc31d3c5af6e55c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            position: 'relative',
            textDecoration: 'none',
            width: '100%',
            boxSizing: 'border-box',
            textAlign: 'left',
            paddingTop: 8,
            paddingBottom: 8,
            '&$focusVisible': {
                backgroundColor: theme.palette.action.selected
            },
            '&$selected, &$selected:hover': {
                backgroundColor: theme.palette.action.selected
            },
            '&$disabled': {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: 'relative'
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: 'flex-start'
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: 'padding-box'
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $cfc31d3c5af6e55c$var$useEnhancedEffect = typeof window === 'undefined' ? $7fPBF.useEffect : $7fPBF.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $cfc31d3c5af6e55c$var$ListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $lfiYO.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $lfiYO.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $7fPBF.useContext((0, $2YkFy.default));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $7fPBF.useRef(null);
    $cfc31d3c5af6e55c$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $7fPBF.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $e7oTH.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    var handleOwnRef = $7fPBF.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $fw0lo.findDOMNode(instance);
    }, []);
    var handleRef = (0, $55RWP.default)(handleOwnRef, ref);
    var componentProps = (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $jtRae.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $gd1Bg.default);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ $7fPBF.createElement((0, $2YkFy.default).Provider, {
            value: childContext
        }, /*#__PURE__*/ $7fPBF.createElement(ContainerComponent, (0, $kY3Ke.default)({
            className: (0, $jtRae.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $7fPBF.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $7fPBF.createElement((0, $2YkFy.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        ref: handleRef
    }, componentProps), children));
});
var $cfc31d3c5af6e55c$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($cfc31d3c5af6e55c$export$9dd6ff9ea0189349, {
    name: 'MuiListItem'
})($cfc31d3c5af6e55c$var$ListItem);

});


parcelRegister("jaezp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df3a40d5108bd5a9$export$2e2bcd8739ae039; });
parcelRequire("2gIIh");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $df3a40d5108bd5a9$var$RADIUS_STANDARD = 10;
var $df3a40d5108bd5a9$var$RADIUS_DOT = 4;
var $df3a40d5108bd5a9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            display: 'inline-flex',
            // For correct alignment with the text.
            verticalAlign: 'middle',
            flexShrink: 0
        },
        /* Styles applied to the badge `span` element. */ badge: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            boxSizing: 'border-box',
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.pxToRem(12),
            minWidth: $df3a40d5108bd5a9$var$RADIUS_STANDARD * 2,
            lineHeight: 1,
            padding: '0 6px',
            height: $df3a40d5108bd5a9$var$RADIUS_STANDARD * 2,
            borderRadius: $df3a40d5108bd5a9$var$RADIUS_STANDARD,
            zIndex: 1,
            // Render the badge on top of potential ripples.
            transition: theme.transitions.create('transform', {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText
        },
        /* Styles applied to the root element if `variant="dot"`. */ dot: {
            borderRadius: $df3a40d5108bd5a9$var$RADIUS_DOT,
            height: $df3a40d5108bd5a9$var$RADIUS_DOT * 2,
            minWidth: $df3a40d5108bd5a9$var$RADIUS_DOT * 2,
            padding: 0
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */ anchorOriginTopRightRectangle: {
            top: 0,
            right: 0,
            transform: 'scale(1) translate(50%, -50%)',
            transformOrigin: '100% 0%',
            '&$invisible': {
                transform: 'scale(0) translate(50%, -50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangular"`. */ anchorOriginTopRightRectangular: {
            top: 0,
            right: 0,
            transform: 'scale(1) translate(50%, -50%)',
            transformOrigin: '100% 0%',
            '&$invisible': {
                transform: 'scale(0) translate(50%, -50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */ anchorOriginBottomRightRectangle: {
            bottom: 0,
            right: 0,
            transform: 'scale(1) translate(50%, 50%)',
            transformOrigin: '100% 100%',
            '&$invisible': {
                transform: 'scale(0) translate(50%, 50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangular"`. */ anchorOriginBottomRightRectangular: {
            bottom: 0,
            right: 0,
            transform: 'scale(1) translate(50%, 50%)',
            transformOrigin: '100% 100%',
            '&$invisible': {
                transform: 'scale(0) translate(50%, 50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */ anchorOriginTopLeftRectangle: {
            top: 0,
            left: 0,
            transform: 'scale(1) translate(-50%, -50%)',
            transformOrigin: '0% 0%',
            '&$invisible': {
                transform: 'scale(0) translate(-50%, -50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangular"`. */ anchorOriginTopLeftRectangular: {
            top: 0,
            left: 0,
            transform: 'scale(1) translate(-50%, -50%)',
            transformOrigin: '0% 0%',
            '&$invisible': {
                transform: 'scale(0) translate(-50%, -50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */ anchorOriginBottomLeftRectangle: {
            bottom: 0,
            left: 0,
            transform: 'scale(1) translate(-50%, 50%)',
            transformOrigin: '0% 100%',
            '&$invisible': {
                transform: 'scale(0) translate(-50%, 50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangular"`. */ anchorOriginBottomLeftRectangular: {
            bottom: 0,
            left: 0,
            transform: 'scale(1) translate(-50%, 50%)',
            transformOrigin: '0% 100%',
            '&$invisible': {
                transform: 'scale(0) translate(-50%, 50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */ anchorOriginTopRightCircle: {
            top: '14%',
            right: '14%',
            transform: 'scale(1) translate(50%, -50%)',
            transformOrigin: '100% 0%',
            '&$invisible': {
                transform: 'scale(0) translate(50%, -50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circular"`. */ anchorOriginTopRightCircular: {
            top: '14%',
            right: '14%',
            transform: 'scale(1) translate(50%, -50%)',
            transformOrigin: '100% 0%',
            '&$invisible': {
                transform: 'scale(0) translate(50%, -50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */ anchorOriginBottomRightCircle: {
            bottom: '14%',
            right: '14%',
            transform: 'scale(1) translate(50%, 50%)',
            transformOrigin: '100% 100%',
            '&$invisible': {
                transform: 'scale(0) translate(50%, 50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circular"`. */ anchorOriginBottomRightCircular: {
            bottom: '14%',
            right: '14%',
            transform: 'scale(1) translate(50%, 50%)',
            transformOrigin: '100% 100%',
            '&$invisible': {
                transform: 'scale(0) translate(50%, 50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */ anchorOriginTopLeftCircle: {
            top: '14%',
            left: '14%',
            transform: 'scale(1) translate(-50%, -50%)',
            transformOrigin: '0% 0%',
            '&$invisible': {
                transform: 'scale(0) translate(-50%, -50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circular"`. */ anchorOriginTopLeftCircular: {
            top: '14%',
            left: '14%',
            transform: 'scale(1) translate(-50%, -50%)',
            transformOrigin: '0% 0%',
            '&$invisible': {
                transform: 'scale(0) translate(-50%, -50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */ anchorOriginBottomLeftCircle: {
            bottom: '14%',
            left: '14%',
            transform: 'scale(1) translate(-50%, 50%)',
            transformOrigin: '0% 100%',
            '&$invisible': {
                transform: 'scale(0) translate(-50%, 50%)'
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circular"`. */ anchorOriginBottomLeftCircular: {
            bottom: '14%',
            left: '14%',
            transform: 'scale(1) translate(-50%, 50%)',
            transformOrigin: '0% 100%',
            '&$invisible': {
                transform: 'scale(0) translate(-50%, 50%)'
            }
        },
        /* Pseudo-class to the badge `span` element if `invisible={true}`. */ invisible: {
            transition: theme.transitions.create('transform', {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.leavingScreen
            })
        }
    };
};
var $df3a40d5108bd5a9$var$Badge = /*#__PURE__*/ $7fPBF.forwardRef(function Badge(props, ref) {
    var _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: 'top',
        horizontal: 'right'
    } : _props$anchorOrigin, badgeContent = props.badgeContent, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, ComponentProp = _props$component === void 0 ? 'span' : _props$component, invisibleProp = props.invisible, _props$max = props.max, max = _props$max === void 0 ? 99 : _props$max, _props$overlap = props.overlap, overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap, _props$showZero = props.showZero, showZero = _props$showZero === void 0 ? false : _props$showZero, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $lfiYO.default)(props, [
        "anchorOrigin",
        "badgeContent",
        "children",
        "classes",
        "className",
        "color",
        "component",
        "invisible",
        "max",
        "overlap",
        "showZero",
        "variant"
    ]);
    var invisible = invisibleProp;
    if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) invisible = true;
    var displayValue = '';
    if (variant !== 'dot') displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
    return /*#__PURE__*/ $7fPBF.createElement(ComponentProp, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        ref: ref
    }, other), children, /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $jtRae.default)(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0, $dKzJP.default)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0, $dKzJP.default)(anchorOrigin.vertical)).concat((0, $dKzJP.default)(anchorOrigin.horizontal)).concat((0, $dKzJP.default)(overlap))], color !== 'default' && classes["color".concat((0, $dKzJP.default)(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
    }, displayValue));
});
var $df3a40d5108bd5a9$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($df3a40d5108bd5a9$export$9dd6ff9ea0189349, {
    name: 'MuiBadge'
})($df3a40d5108bd5a9$var$Badge);

});

parcelRegister("hzQpW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccbe5d8d0fc27d1e$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $jtRae = parcelRequire("jtRae");

var $belNS = parcelRequire("belNS");

var $2jEfe = parcelRequire("2jEfe");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");

var $bG0nA = parcelRequire("bG0nA");

var $iyOta = parcelRequire("iyOta");

var $55RWP = parcelRequire("55RWP");

var $ejsyu = parcelRequire("ejsyu");

var $6FBGG = parcelRequire("6FBGG");

var $K4XJ4 = parcelRequire("K4XJ4");

var $3deDh = parcelRequire("3deDh");

var $fH0xA = parcelRequire("fH0xA");
function $ccbe5d8d0fc27d1e$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
function $ccbe5d8d0fc27d1e$var$arrowGenerator() {
    return {
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: '-0.71em',
            marginLeft: 4,
            marginRight: 4,
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.71em',
            marginLeft: 4,
            marginRight: 4,
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: '-0.71em',
            height: '1em',
            width: '0.71em',
            marginTop: 4,
            marginBottom: 4,
            '&::before': {
                transformOrigin: '100% 100%'
            }
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: '-0.71em',
            height: '1em',
            width: '0.71em',
            marginTop: 4,
            marginBottom: 4,
            '&::before': {
                transformOrigin: '0 0'
            }
        }
    };
}
var $ccbe5d8d0fc27d1e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the Popper component. */ popper: {
            zIndex: theme.zIndex.tooltip,
            pointerEvents: 'none' // disable jss-rtl plugin
        },
        /* Styles applied to the Popper component if `interactive={true}`. */ popperInteractive: {
            pointerEvents: 'auto'
        },
        /* Styles applied to the Popper component if `arrow={true}`. */ popperArrow: $ccbe5d8d0fc27d1e$var$arrowGenerator(),
        /* Styles applied to the tooltip (label wrapper) element. */ tooltip: {
            backgroundColor: (0, $2jEfe.alpha)(theme.palette.grey[700], 0.9),
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.white,
            fontFamily: theme.typography.fontFamily,
            padding: '4px 8px',
            fontSize: theme.typography.pxToRem(10),
            lineHeight: "".concat($ccbe5d8d0fc27d1e$var$round(1.4), "em"),
            maxWidth: 300,
            wordWrap: 'break-word',
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */ tooltipArrow: {
            position: 'relative',
            margin: '0'
        },
        /* Styles applied to the arrow element. */ arrow: {
            overflow: 'hidden',
            position: 'absolute',
            width: '1em',
            height: '0.71em',
            boxSizing: 'border-box',
            color: (0, $2jEfe.alpha)(theme.palette.grey[700], 0.9),
            '&::before': {
                content: '""',
                margin: 'auto',
                display: 'block',
                width: '100%',
                height: '100%',
                backgroundColor: 'currentColor',
                transform: 'rotate(45deg)'
            }
        },
        /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */ touch: {
            padding: '8px 16px',
            fontSize: theme.typography.pxToRem(14),
            lineHeight: "".concat($ccbe5d8d0fc27d1e$var$round(16 / 14), "em"),
            fontWeight: theme.typography.fontWeightRegular
        },
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */ tooltipPlacementLeft: (0, $dQMrF.default)({
            transformOrigin: 'right center',
            margin: '0 24px '
        }, theme.breakpoints.up('sm'), {
            margin: '0 14px'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */ tooltipPlacementRight: (0, $dQMrF.default)({
            transformOrigin: 'left center',
            margin: '0 24px'
        }, theme.breakpoints.up('sm'), {
            margin: '0 14px'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */ tooltipPlacementTop: (0, $dQMrF.default)({
            transformOrigin: 'center bottom',
            margin: '24px 0'
        }, theme.breakpoints.up('sm'), {
            margin: '14px 0'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */ tooltipPlacementBottom: (0, $dQMrF.default)({
            transformOrigin: 'center top',
            margin: '24px 0'
        }, theme.breakpoints.up('sm'), {
            margin: '14px 0'
        })
    };
};
var $ccbe5d8d0fc27d1e$var$hystersisOpen = false;
var $ccbe5d8d0fc27d1e$var$hystersisTimer = null;
function $ccbe5d8d0fc27d1e$export$b9ee5a7ace0541f8() {
    $ccbe5d8d0fc27d1e$var$hystersisOpen = false;
    clearTimeout($ccbe5d8d0fc27d1e$var$hystersisTimer);
}
var $ccbe5d8d0fc27d1e$var$Tooltip = /*#__PURE__*/ $7fPBF.forwardRef(function Tooltip(props, ref) {
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, children = props.children, classes = props.classes, _props$disableFocusLi = props.disableFocusListener, disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi, _props$disableHoverLi = props.disableHoverListener, disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi, _props$disableTouchLi = props.disableTouchListener, disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi, _props$enterDelay = props.enterDelay, enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay, _props$enterNextDelay = props.enterNextDelay, enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay, _props$enterTouchDela = props.enterTouchDelay, enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela, idProp = props.id, _props$interactive = props.interactive, interactive = _props$interactive === void 0 ? false : _props$interactive, _props$leaveDelay = props.leaveDelay, leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay, _props$leaveTouchDela = props.leaveTouchDelay, leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela, onClose = props.onClose, onOpen = props.onOpen, openProp = props.open, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$PopperComponen = props.PopperComponent, PopperComponent = _props$PopperComponen === void 0 ? (0, $iyOta.default) : _props$PopperComponen, PopperProps = props.PopperProps, title = props.title, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $bG0nA.default) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $lfiYO.default)(props, [
        "arrow",
        "children",
        "classes",
        "disableFocusListener",
        "disableHoverListener",
        "disableTouchListener",
        "enterDelay",
        "enterNextDelay",
        "enterTouchDelay",
        "id",
        "interactive",
        "leaveDelay",
        "leaveTouchDelay",
        "onClose",
        "onOpen",
        "open",
        "placement",
        "PopperComponent",
        "PopperProps",
        "title",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var theme = (0, $fH0xA.default)();
    var _React$useState = $7fPBF.useState(), childNode = _React$useState[0], setChildNode = _React$useState[1];
    var _React$useState2 = $7fPBF.useState(null), arrowRef = _React$useState2[0], setArrowRef = _React$useState2[1];
    var ignoreNonTouchEvents = $7fPBF.useRef(false);
    var closeTimer = $7fPBF.useRef();
    var enterTimer = $7fPBF.useRef();
    var leaveTimer = $7fPBF.useRef();
    var touchTimer = $7fPBF.useRef();
    var _useControlled = (0, $3deDh.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    }), _useControlled2 = (0, $2gIIh.default)(_useControlled, 2), openState = _useControlled2[0], setOpenState = _useControlled2[1];
    var open = openState;
    var _React$useRef, isControlled;
    var id = (0, $ejsyu.default)(idProp);
    $7fPBF.useEffect(function() {
        return function() {
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            clearTimeout(touchTimer.current);
        };
    }, []);
    var handleOpen = function handleOpen(event) {
        clearTimeout($ccbe5d8d0fc27d1e$var$hystersisTimer);
        $ccbe5d8d0fc27d1e$var$hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen) onOpen(event);
    };
    var handleEnter = function handleEnter() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) childrenProps.onMouseOver(event);
            if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
             // Remove the title ahead of time.
            // We don't want to wait for the next render commit.
            // We would risk displaying two tooltips at the same time (native + this one).
            if (childNode) childNode.removeAttribute('title');
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            if (enterDelay || $ccbe5d8d0fc27d1e$var$hystersisOpen && enterNextDelay) {
                event.persist();
                enterTimer.current = setTimeout(function() {
                    handleOpen(event);
                }, $ccbe5d8d0fc27d1e$var$hystersisOpen ? enterNextDelay : enterDelay);
            } else handleOpen(event);
        };
    };
    var _useIsFocusVisible = (0, $K4XJ4.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $7fPBF.useState(false), childIsFocusVisible = _React$useState3[0], setChildIsFocusVisible = _React$useState3[1];
    var handleBlur = function handleBlur() {
        if (childIsFocusVisible) {
            setChildIsFocusVisible(false);
            onBlurVisible();
        }
    };
    var handleFocus = function handleFocus() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            // Workaround for https://github.com/facebook/react/issues/7769
            // The autoFocus of React might trigger the event before the componentDidMount.
            // We need to account for this eventuality.
            if (!childNode) setChildNode(event.currentTarget);
            if (isFocusVisible(event)) {
                setChildIsFocusVisible(true);
                handleEnter()(event);
            }
            var childrenProps = children.props;
            if (childrenProps.onFocus && forward) childrenProps.onFocus(event);
        };
    };
    var handleClose = function handleClose(event) {
        clearTimeout($ccbe5d8d0fc27d1e$var$hystersisTimer);
        $ccbe5d8d0fc27d1e$var$hystersisTimer = setTimeout(function() {
            $ccbe5d8d0fc27d1e$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(function() {
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    };
    var handleLeave = function handleLeave() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === 'blur') {
                if (childrenProps.onBlur && forward) childrenProps.onBlur(event);
                handleBlur();
            }
            if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) childrenProps.onMouseLeave(event);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            event.persist();
            leaveTimer.current = setTimeout(function() {
                handleClose(event);
            }, leaveDelay);
        };
    };
    var detectTouchStart = function detectTouchStart(event) {
        ignoreNonTouchEvents.current = true;
        var childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    var handleTouchStart = function handleTouchStart(event) {
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        clearTimeout(touchTimer.current);
        event.persist();
        touchTimer.current = setTimeout(function() {
            handleEnter()(event);
        }, enterTouchDelay);
    };
    var handleTouchEnd = function handleTouchEnd(event) {
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        clearTimeout(touchTimer.current);
        clearTimeout(leaveTimer.current);
        event.persist();
        leaveTimer.current = setTimeout(function() {
            handleClose(event);
        }, leaveTouchDelay);
    };
    var handleUseRef = (0, $55RWP.default)(setChildNode, ref);
    var handleFocusRef = (0, $55RWP.default)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $7fPBF.useCallback(function(instance) {
        // #StrictMode ready
        (0, $6FBGG.default)(handleFocusRef, $fw0lo.findDOMNode(instance));
    }, [
        handleFocusRef
    ]);
    var handleRef = (0, $55RWP.default)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
    if (title === '') open = false;
     // For accessibility and SEO concerns, we render the title to the DOM node when
    // the tooltip is hidden. However, we have made a tradeoff when
    // `disableHoverListener` is set. This title logic is disabled.
    // It's allowing us to keep the implementation size minimal.
    // We are open to change the tradeoff.
    var shouldShowNativeTitle = !open && !disableHoverListener;
    var childrenProps = (0, $kY3Ke.default)({
        'aria-describedby': open ? id : null,
        title: shouldShowNativeTitle && typeof title === 'string' ? title : null
    }, other, children.props, {
        className: (0, $jtRae.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    });
    var interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = handleEnter();
        childrenProps.onMouseLeave = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onMouseOver = handleEnter(false);
            interactiveWrapperListeners.onMouseLeave = handleLeave(false);
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = handleFocus();
        childrenProps.onBlur = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onFocus = handleFocus(false);
            interactiveWrapperListeners.onBlur = handleLeave(false);
        }
    }
    var mergedPopperProps = $7fPBF.useMemo(function() {
        return (0, $belNS.default)({
            popperOptions: {
                modifiers: {
                    arrow: {
                        enabled: Boolean(arrowRef),
                        element: arrowRef
                    }
                }
            }
        }, PopperProps);
    }, [
        arrowRef,
        PopperProps
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps), /*#__PURE__*/ $7fPBF.createElement(PopperComponent, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
        placement: placement,
        anchorEl: childNode,
        open: childNode ? open : false,
        id: childrenProps['aria-describedby'],
        transition: true
    }, interactiveWrapperListeners, mergedPopperProps), function(_ref) {
        var placementInner = _ref.placement, TransitionPropsInner = _ref.TransitionProps;
        return /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
            timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), /*#__PURE__*/ $7fPBF.createElement("div", {
            className: (0, $jtRae.default)(classes.tooltip, classes["tooltipPlacement".concat((0, $dKzJP.default)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
        }, title, arrow ? /*#__PURE__*/ $7fPBF.createElement("span", {
            className: classes.arrow,
            ref: setArrowRef
        }) : null));
    }));
});
var $ccbe5d8d0fc27d1e$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($ccbe5d8d0fc27d1e$export$9dd6ff9ea0189349, {
    name: 'MuiTooltip',
    flip: false
})($ccbe5d8d0fc27d1e$var$Tooltip);

});
parcelRegister("iyOta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8328d26be2ba3fe$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $3JC20 = parcelRequire("3JC20");


var $qjAyq = parcelRequire("qjAyq");

var $fzP0v = parcelRequire("fzP0v");

var $5oAE5 = parcelRequire("5oAE5");

var $6FBGG = parcelRequire("6FBGG");

var $55RWP = parcelRequire("55RWP");
function $d8328d26be2ba3fe$var$flipPlacement(placement, theme) {
    var direction = theme && theme.direction || 'ltr';
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $d8328d26be2ba3fe$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $d8328d26be2ba3fe$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $d8328d26be2ba3fe$var$defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */ var $d8328d26be2ba3fe$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(props, ref) {
    var anchorEl = props.anchorEl, children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, modifiers = props.modifiers, open = props.open, _props$placement = props.placement, initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$popperOptions = props.popperOptions, popperOptions = _props$popperOptions === void 0 ? $d8328d26be2ba3fe$var$defaultPopperOptions : _props$popperOptions, popperRefProp = props.popperRef, style = props.style, _props$transition = props.transition, transition = _props$transition === void 0 ? false : _props$transition, other = (0, $lfiYO.default)(props, [
        "anchorEl",
        "children",
        "container",
        "disablePortal",
        "keepMounted",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "style",
        "transition"
    ]);
    var tooltipRef = $7fPBF.useRef(null);
    var ownRef = (0, $55RWP.default)(tooltipRef, ref);
    var popperRef = $7fPBF.useRef(null);
    var handlePopperRef = (0, $55RWP.default)(popperRef, popperRefProp);
    var handlePopperRefRef = $7fPBF.useRef(handlePopperRef);
    $d8328d26be2ba3fe$var$useEnhancedEffect(function() {
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $7fPBF.useImperativeHandle(popperRefProp, function() {
        return popperRef.current;
    }, []);
    var _React$useState = $7fPBF.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var theme = (0, $qjAyq.default)();
    var rtlPlacement = $d8328d26be2ba3fe$var$flipPlacement(initialPlacement, theme);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ var _React$useState2 = $7fPBF.useState(rtlPlacement), placement = _React$useState2[0], setPlacement = _React$useState2[1];
    $7fPBF.useEffect(function() {
        if (popperRef.current) popperRef.current.update();
    });
    var handleOpen = $7fPBF.useCallback(function() {
        if (!tooltipRef.current || !anchorEl || !open) return;
        if (popperRef.current) {
            popperRef.current.destroy();
            handlePopperRefRef.current(null);
        }
        var handlePopperUpdate = function handlePopperUpdate(data) {
            setPlacement(data.placement);
        };
        var resolvedAnchorEl = $d8328d26be2ba3fe$var$getAnchorEl(anchorEl);
        var box;
        var popper = new (0, $3JC20.default)($d8328d26be2ba3fe$var$getAnchorEl(anchorEl), tooltipRef.current, (0, $kY3Ke.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: (0, $kY3Ke.default)({}, disablePortal ? {} : {
                // It's using scrollParent by default, we can use the viewport when using a portal.
                preventOverflow: {
                    boundariesElement: 'window'
                }
            }, modifiers, popperOptions.modifiers),
            // We could have been using a custom modifier like react-popper is doing.
            // But it seems this is the best public API for this use case.
            onCreate: (0, $5oAE5.default)(handlePopperUpdate, popperOptions.onCreate),
            onUpdate: (0, $5oAE5.default)(handlePopperUpdate, popperOptions.onUpdate)
        }));
        handlePopperRefRef.current(popper);
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        rtlPlacement,
        popperOptions
    ]);
    var handleRef = $7fPBF.useCallback(function(node) {
        (0, $6FBGG.default)(ownRef, node);
        handleOpen();
    }, [
        ownRef,
        handleOpen
    ]);
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleClose = function handleClose() {
        if (!popperRef.current) return;
        popperRef.current.destroy();
        handlePopperRefRef.current(null);
    };
    var handleExited = function handleExited() {
        setExited(true);
        handleClose();
    };
    $7fPBF.useEffect(function() {
        return function() {
            handleClose();
        };
    }, []);
    $7fPBF.useEffect(function() {
        if (!open && !transition) // Otherwise handleExited will call this.
        handleClose();
    }, [
        open,
        transition
    ]);
    if (!keepMounted && !open && (!transition || exited)) return null;
    var childProps = {
        placement: placement
    };
    if (transition) childProps.TransitionProps = {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $fzP0v.default), {
        disablePortal: disablePortal,
        container: container
    }, /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        ref: handleRef,
        role: "tooltip"
    }, other, {
        style: (0, $kY3Ke.default)({
            // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
            position: 'fixed',
            // Fix Popper.js display issue
            top: 0,
            left: 0,
            display: !open && keepMounted && !transition ? 'none' : null
        }, style)
    }), typeof children === 'function' ? children(childProps) : children));
});
var $d8328d26be2ba3fe$export$2e2bcd8739ae039 = $d8328d26be2ba3fe$var$Popper;

});
parcelRegister("3JC20", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b831351567a32f4$export$2e2bcd8739ae039; });
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $2b831351567a32f4$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $2b831351567a32f4$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($2b831351567a32f4$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $2b831351567a32f4$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $2b831351567a32f4$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $2b831351567a32f4$var$timeoutDuration);
        }
    };
}
var $2b831351567a32f4$var$supportsMicroTasks = $2b831351567a32f4$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $2b831351567a32f4$var$debounce = $2b831351567a32f4$var$supportsMicroTasks ? $2b831351567a32f4$var$microtaskDebounce : $2b831351567a32f4$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $2b831351567a32f4$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $2b831351567a32f4$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $2b831351567a32f4$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $2b831351567a32f4$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $2b831351567a32f4$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $2b831351567a32f4$var$getScrollParent($2b831351567a32f4$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $2b831351567a32f4$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $2b831351567a32f4$var$isIE11 = $2b831351567a32f4$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $2b831351567a32f4$var$isIE10 = $2b831351567a32f4$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $2b831351567a32f4$var$isIE(version) {
    if (version === 11) return $2b831351567a32f4$var$isIE11;
    if (version === 10) return $2b831351567a32f4$var$isIE10;
    return $2b831351567a32f4$var$isIE11 || $2b831351567a32f4$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $2b831351567a32f4$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $2b831351567a32f4$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $2b831351567a32f4$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $2b831351567a32f4$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $2b831351567a32f4$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $2b831351567a32f4$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $2b831351567a32f4$var$getRoot(node) {
    if (node.parentNode !== null) return $2b831351567a32f4$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $2b831351567a32f4$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($2b831351567a32f4$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $2b831351567a32f4$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $2b831351567a32f4$var$getRoot(element1);
    if (element1root.host) return $2b831351567a32f4$var$findCommonOffsetParent(element1root.host, element2);
    else return $2b831351567a32f4$var$findCommonOffsetParent(element1, $2b831351567a32f4$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $2b831351567a32f4$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $2b831351567a32f4$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $2b831351567a32f4$var$getScroll(element, 'top');
    var scrollLeft = $2b831351567a32f4$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $2b831351567a32f4$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $2b831351567a32f4$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $2b831351567a32f4$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $2b831351567a32f4$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $2b831351567a32f4$var$isIE(10) && getComputedStyle(html);
    return {
        height: $2b831351567a32f4$var$getSize('Height', body, html, computedStyle),
        width: $2b831351567a32f4$var$getSize('Width', body, html, computedStyle)
    };
}
var $2b831351567a32f4$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $2b831351567a32f4$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $2b831351567a32f4$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $2b831351567a32f4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $2b831351567a32f4$var$getClientRect(offsets) {
    return $2b831351567a32f4$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $2b831351567a32f4$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($2b831351567a32f4$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $2b831351567a32f4$var$getScroll(element, 'top');
            var scrollLeft = $2b831351567a32f4$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $2b831351567a32f4$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $2b831351567a32f4$var$getStyleComputedProperty(element);
        horizScrollbar -= $2b831351567a32f4$var$getBordersSize(styles, 'x');
        vertScrollbar -= $2b831351567a32f4$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $2b831351567a32f4$var$getClientRect(result);
}
function $2b831351567a32f4$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $2b831351567a32f4$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $2b831351567a32f4$var$getBoundingClientRect(children);
    var parentRect = $2b831351567a32f4$var$getBoundingClientRect(parent);
    var scrollParent = $2b831351567a32f4$var$getScrollParent(children);
    var styles = $2b831351567a32f4$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $2b831351567a32f4$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $2b831351567a32f4$var$includeScroll(offsets, parent);
    return offsets;
}
function $2b831351567a32f4$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $2b831351567a32f4$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $2b831351567a32f4$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $2b831351567a32f4$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $2b831351567a32f4$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $2b831351567a32f4$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($2b831351567a32f4$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $2b831351567a32f4$var$getParentNode(element);
    if (!parentNode) return false;
    return $2b831351567a32f4$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $2b831351567a32f4$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $2b831351567a32f4$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $2b831351567a32f4$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $2b831351567a32f4$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $2b831351567a32f4$var$getFixedPositionOffsetParent(popper) : $2b831351567a32f4$var$findCommonOffsetParent(popper, $2b831351567a32f4$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $2b831351567a32f4$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $2b831351567a32f4$var$getScrollParent($2b831351567a32f4$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $2b831351567a32f4$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$2b831351567a32f4$var$isFixed(offsetParent)) {
            var _getWindowSizes = $2b831351567a32f4$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $2b831351567a32f4$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $2b831351567a32f4$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $2b831351567a32f4$var$_extends({
            key: key
        }, rects[key], {
            area: $2b831351567a32f4$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $2b831351567a32f4$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $2b831351567a32f4$var$getFixedPositionOffsetParent(popper) : $2b831351567a32f4$var$findCommonOffsetParent(popper, $2b831351567a32f4$var$getReferenceNode(reference));
    return $2b831351567a32f4$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $2b831351567a32f4$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $2b831351567a32f4$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $2b831351567a32f4$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $2b831351567a32f4$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$2b831351567a32f4$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $2b831351567a32f4$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $2b831351567a32f4$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $2b831351567a32f4$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $2b831351567a32f4$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $2b831351567a32f4$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $2b831351567a32f4$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $2b831351567a32f4$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $2b831351567a32f4$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $2b831351567a32f4$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $2b831351567a32f4$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $2b831351567a32f4$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $2b831351567a32f4$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $2b831351567a32f4$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $2b831351567a32f4$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $2b831351567a32f4$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $2b831351567a32f4$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($2b831351567a32f4$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$2b831351567a32f4$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $2b831351567a32f4$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $2b831351567a32f4$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $2b831351567a32f4$var$attachToScrollParents($2b831351567a32f4$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $2b831351567a32f4$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $2b831351567a32f4$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $2b831351567a32f4$var$getScrollParent(reference);
    $2b831351567a32f4$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $2b831351567a32f4$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $2b831351567a32f4$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $2b831351567a32f4$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $2b831351567a32f4$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $2b831351567a32f4$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $2b831351567a32f4$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $2b831351567a32f4$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $2b831351567a32f4$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $2b831351567a32f4$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $2b831351567a32f4$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $2b831351567a32f4$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $2b831351567a32f4$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $2b831351567a32f4$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $2b831351567a32f4$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $2b831351567a32f4$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $2b831351567a32f4$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $2b831351567a32f4$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $2b831351567a32f4$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $2b831351567a32f4$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $2b831351567a32f4$var$isFirefox = $2b831351567a32f4$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $2b831351567a32f4$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $2b831351567a32f4$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $2b831351567a32f4$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $2b831351567a32f4$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$2b831351567a32f4$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $2b831351567a32f4$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $2b831351567a32f4$var$_extends({}, attributes, data.attributes);
    data.styles = $2b831351567a32f4$var$_extends({}, styles, data.styles);
    data.arrowStyles = $2b831351567a32f4$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $2b831351567a32f4$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $2b831351567a32f4$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$2b831351567a32f4$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $2b831351567a32f4$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $2b831351567a32f4$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $2b831351567a32f4$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $2b831351567a32f4$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $2b831351567a32f4$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $2b831351567a32f4$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $2b831351567a32f4$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $2b831351567a32f4$var$validPlacements = $2b831351567a32f4$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $2b831351567a32f4$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $2b831351567a32f4$var$validPlacements.indexOf(placement);
    var arr = $2b831351567a32f4$var$validPlacements.slice(index + 1).concat($2b831351567a32f4$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $2b831351567a32f4$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($2b831351567a32f4$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $2b831351567a32f4$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $2b831351567a32f4$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $2b831351567a32f4$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $2b831351567a32f4$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $2b831351567a32f4$var$clockwise(placement);
            break;
        case $2b831351567a32f4$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $2b831351567a32f4$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $2b831351567a32f4$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $2b831351567a32f4$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $2b831351567a32f4$var$_extends({}, data.offsets.popper, $2b831351567a32f4$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $2b831351567a32f4$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $2b831351567a32f4$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $2b831351567a32f4$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $2b831351567a32f4$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($2b831351567a32f4$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $2b831351567a32f4$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($2b831351567a32f4$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($2b831351567a32f4$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $2b831351567a32f4$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $2b831351567a32f4$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $2b831351567a32f4$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $2b831351567a32f4$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $2b831351567a32f4$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $2b831351567a32f4$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $2b831351567a32f4$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $2b831351567a32f4$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $2b831351567a32f4$var$defineProperty({}, side, reference[side]),
            end: $2b831351567a32f4$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $2b831351567a32f4$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$hide(data) {
    if (!$2b831351567a32f4$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $2b831351567a32f4$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2b831351567a32f4$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $2b831351567a32f4$var$getOppositePlacement(placement);
    data.offsets.popper = $2b831351567a32f4$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $2b831351567a32f4$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2b831351567a32f4$var$applyStyle,
        /** @prop {Function} */ onLoad: $2b831351567a32f4$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $2b831351567a32f4$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $2b831351567a32f4$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $2b831351567a32f4$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $2b831351567a32f4$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $2b831351567a32f4$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $2b831351567a32f4$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($2b831351567a32f4$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $2b831351567a32f4$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $2b831351567a32f4$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $2b831351567a32f4$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $2b831351567a32f4$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $2b831351567a32f4$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $2b831351567a32f4$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $2b831351567a32f4$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $2b831351567a32f4$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $2b831351567a32f4$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$2b831351567a32f4$var$Popper.placements = $2b831351567a32f4$var$placements;
$2b831351567a32f4$var$Popper.Defaults = $2b831351567a32f4$var$Defaults;
var $2b831351567a32f4$export$2e2bcd8739ae039 = $2b831351567a32f4$var$Popper;

});



parcelRegister("7Em3j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $591d5ff9e95c3c35$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $g3iV0 = parcelRequire("g3iV0");

var $55RWP = parcelRequire("55RWP");

var $1sMi9 = parcelRequire("1sMi9");

function $591d5ff9e95c3c35$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $591d5ff9e95c3c35$var$clickedRootScrollbar(event) {
    return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */ function $591d5ff9e95c3c35$var$ClickAwayListener(props) {
    var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
    var movedRef = $7fPBF.useRef(false);
    var nodeRef = $7fPBF.useRef(null);
    var activatedRef = $7fPBF.useRef(false);
    var syntheticEventRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(function() {
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(function() {
            activatedRef.current = true;
        }, 0);
        return function() {
            activatedRef.current = false;
        };
    }, []); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $7fPBF.useCallback(function(instance) {
        // #StrictMode ready
        nodeRef.current = $fw0lo.findDOMNode(instance);
    }, []);
    var handleRef = (0, $55RWP.default)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    var handleClickAway = (0, $1sMi9.default)(function(event) {
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || $591d5ff9e95c3c35$var$clickedRootScrollbar(event)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else {
            // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
            var doc = (0, $g3iV0.default)(nodeRef.current);
            insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        }
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
        return function(event) {
            syntheticEventRef.current = true;
            var childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    };
    var childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $7fPBF.useEffect(function() {
        if (touchEvent !== false) {
            var mappedTouchEvent = $591d5ff9e95c3c35$var$mapEventPropToEvent(touchEvent);
            var doc = (0, $g3iV0.default)(nodeRef.current);
            var handleTouchMove = function handleTouchMove() {
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return function() {
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $7fPBF.useEffect(function() {
        if (mouseEvent !== false) {
            var mappedMouseEvent = $591d5ff9e95c3c35$var$mapEventPropToEvent(mouseEvent);
            var doc = (0, $g3iV0.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return function() {
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps));
}
var $591d5ff9e95c3c35$export$2e2bcd8739ae039 = $591d5ff9e95c3c35$var$ClickAwayListener;

});

parcelRegister("l6eg8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5c53819d1ef1da7$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $f5c53819d1ef1da7$var$useEnhancedEffect = typeof window !== 'undefined' && true ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */ function $f5c53819d1ef1da7$var$NoSsr(props) {
    var children = props.children, _props$defer = props.defer, defer = _props$defer === void 0 ? false : _props$defer, _props$fallback = props.fallback, fallback = _props$fallback === void 0 ? null : _props$fallback;
    var _React$useState = $7fPBF.useState(false), mountedState = _React$useState[0], setMountedState = _React$useState[1];
    $f5c53819d1ef1da7$var$useEnhancedEffect(function() {
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $7fPBF.useEffect(function() {
        if (defer) setMountedState(true);
    }, [
        defer
    ]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, mountedState ? children : fallback);
}
var $f5c53819d1ef1da7$export$2e2bcd8739ae039 = $f5c53819d1ef1da7$var$NoSsr;

});

parcelRegister("4mZpH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32e8daf75b1fa3c5$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $2jEfe = parcelRequire("2jEfe");

var $dKzJP = parcelRequire("dKzJP");

var $kVsLZ = parcelRequire("kVsLZ");
var $32e8daf75b1fa3c5$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            width: 58,
            height: 38,
            overflow: 'hidden',
            padding: 12,
            boxSizing: 'border-box',
            position: 'relative',
            flexShrink: 0,
            zIndex: 0,
            // Reset the stacking context.
            verticalAlign: 'middle',
            // For correct alignment with the text.
            '@media print': {
                colorAdjust: 'exact'
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -8
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -8
        },
        /* Styles applied to the internal `SwitchBase` component's `root` class. */ switchBase: {
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
            // Render above the focus ripple.
            color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
            transition: theme.transitions.create([
                'left',
                'transform'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            '&$checked': {
                transform: 'translateX(20px)'
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                opacity: 0.5
            },
            '&$disabled + $track': {
                opacity: theme.palette.type === 'light' ? 0.12 : 0.1
            }
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $2jEfe.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                backgroundColor: theme.palette.primary.main
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
            }
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $2jEfe.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                backgroundColor: theme.palette.secondary.main
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            width: 40,
            height: 24,
            padding: 7,
            '& $thumb': {
                width: 16,
                height: 16
            },
            '& $switchBase': {
                padding: 4,
                '&$checked': {
                    transform: 'translateX(16px)'
                }
            }
        },
        /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */ checked: {},
        /* Pseudo-class applied to the internal SwitchBase component's disabled class. */ disabled: {},
        /* Styles applied to the internal SwitchBase component's input element. */ input: {
            left: '-100%',
            width: '300%'
        },
        /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */ thumb: {
            boxShadow: theme.shadows[1],
            backgroundColor: 'currentColor',
            width: 20,
            height: 20,
            borderRadius: '50%'
        },
        /* Styles applied to the track element. */ track: {
            height: '100%',
            width: '100%',
            borderRadius: 7,
            zIndex: -1,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
            opacity: theme.palette.type === 'light' ? 0.38 : 0.3
        }
    };
};
var $32e8daf75b1fa3c5$var$Switch = /*#__PURE__*/ $7fPBF.forwardRef(function Switch(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "color",
        "edge",
        "size"
    ]);
    var icon = /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.thumb
    });
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $jtRae.default)(classes.root, className, {
            'start': classes.edgeStart,
            'end': classes.edgeEnd
        }[edge], size === "small" && classes["size".concat((0, $dKzJP.default)(size))])
    }, /*#__PURE__*/ $7fPBF.createElement((0, $kVsLZ.default), (0, $kY3Ke.default)({
        type: "checkbox",
        icon: icon,
        checkedIcon: icon,
        classes: {
            root: (0, $jtRae.default)(classes.switchBase, classes["color".concat((0, $dKzJP.default)(color))]),
            input: classes.input,
            checked: classes.checked,
            disabled: classes.disabled
        },
        ref: ref
    }, other)), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.track
    }));
});
var $32e8daf75b1fa3c5$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($32e8daf75b1fa3c5$export$9dd6ff9ea0189349, {
    name: 'MuiSwitch'
})($32e8daf75b1fa3c5$var$Switch);

});

parcelRegister("fwAOd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4d665a64aa39cdd$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $2jEfe = parcelRequire("2jEfe");

var $gd1Bg = parcelRequire("gd1Bg");

var $dKzJP = parcelRequire("dKzJP");
var $b4d665a64aa39cdd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({}, theme.typography.button, {
            boxSizing: 'border-box',
            minWidth: 64,
            padding: '6px 16px',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                'background-color',
                'box-shadow',
                'border'
            ], {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                },
                '&$disabled': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: '100%',
            // Ensure the correct width for iOS Safari
            display: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: '6px 8px'
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: '5px 15px',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $2jEfe.alpha)(theme.palette.primary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $2jEfe.alpha)(theme.palette.secondary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            '&:hover': {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                '&$disabled': {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            '&$focusVisible': {
                boxShadow: theme.shadows[6]
            },
            '&:active': {
                boxShadow: theme.shadows[8]
            },
            '&$disabled': {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            },
            '&$focusVisible': {
                boxShadow: 'none'
            },
            '&:active': {
                boxShadow: 'none'
            },
            '&$disabled': {
                boxShadow: 'none'
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit',
            borderColor: 'currentColor'
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: '4px 5px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: '8px 11px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: '3px 9px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: '7px 21px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: '4px 10px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: '8px 22px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: 'inherit',
            marginRight: 8,
            marginLeft: -4,
            '&$iconSizeSmall': {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: 'inherit',
            marginRight: -4,
            marginLeft: 8,
            '&$iconSizeSmall': {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            '& > *:first-child': {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            '& > *:first-child': {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            '& > *:first-child': {
                fontSize: 22
            }
        }
    };
};
var $b4d665a64aa39cdd$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? 'text' : _props$variant, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $jtRae.default)(classes.startIcon, classes["iconSize".concat((0, $dKzJP.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $jtRae.default)(classes.endIcon, classes["iconSize".concat((0, $dKzJP.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $7fPBF.createElement((0, $gd1Bg.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, $dKzJP.default)(color))], size !== 'medium' && [
            classes["".concat(variant, "Size").concat((0, $dKzJP.default)(size))],
            classes["size".concat((0, $dKzJP.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $jtRae.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $b4d665a64aa39cdd$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($b4d665a64aa39cdd$export$9dd6ff9ea0189349, {
    name: 'MuiButton'
})($b4d665a64aa39cdd$var$Button);

});

parcelRegister("lLRv0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $041716a77e3a7034$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $iWRZu = parcelRequire("iWRZu");

var $3Sc7z = parcelRequire("3Sc7z");

var $1rW9t = parcelRequire("1rW9t");

var $dKzJP = parcelRequire("dKzJP");
var $041716a77e3a7034$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            // For correct alignment with the text.
            verticalAlign: 'middle',
            WebkitTapHighlightColor: 'transparent',
            marginLeft: -11,
            marginRight: 16,
            // used for row presentation of radio/checkbox
            '&$disabled': {
                cursor: 'default'
            }
        },
        /* Styles applied to the root element if `labelPlacement="start"`. */ labelPlacementStart: {
            flexDirection: 'row-reverse',
            marginLeft: 16,
            // used for row presentation of radio/checkbox
            marginRight: -11
        },
        /* Styles applied to the root element if `labelPlacement="top"`. */ labelPlacementTop: {
            flexDirection: 'column-reverse',
            marginLeft: 16
        },
        /* Styles applied to the root element if `labelPlacement="bottom"`. */ labelPlacementBottom: {
            flexDirection: 'column',
            marginLeft: 16
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the label's Typography component. */ label: {
            '&$disabled': {
                color: theme.palette.text.disabled
            }
        }
    };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var $041716a77e3a7034$var$FormControlLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormControlLabel(props, ref) {
    var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0, $lfiYO.default)(props, [
        "checked",
        "classes",
        "className",
        "control",
        "disabled",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "value"
    ]);
    var muiFormControl = (0, $iWRZu.default)();
    var disabled = disabledProp;
    if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') disabled = control.props.disabled;
    if (typeof disabled === 'undefined' && muiFormControl) disabled = muiFormControl.disabled;
    var controlProps = {
        disabled: disabled
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach(function(key) {
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    return /*#__PURE__*/ $7fPBF.createElement("label", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0, $dKzJP.default)(labelPlacement))], disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.cloneElement(control, controlProps), /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), {
        component: "span",
        className: (0, $jtRae.default)(classes.label, disabled && classes.disabled)
    }, label));
});
var $041716a77e3a7034$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($041716a77e3a7034$export$9dd6ff9ea0189349, {
    name: 'MuiFormControlLabel'
})($041716a77e3a7034$var$FormControlLabel);

});
parcelRegister("1rW9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e56bcd6ac435bd$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $10e56bcd6ac435bd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: 'absolute',
            height: 1,
            width: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: '0.35em'
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: 'inline'
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: 'block'
        }
    };
};
var $10e56bcd6ac435bd$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p'
};
var $10e56bcd6ac435bd$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'initial' : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? 'initial' : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body1' : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $10e56bcd6ac435bd$var$defaultVariantMapping : _props$variantMapping, other = (0, $lfiYO.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? 'p' : variantMapping[variant] || $10e56bcd6ac435bd$var$defaultVariantMapping[variant]) || 'span';
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, $dKzJP.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, $dKzJP.default)(align))], display !== 'initial' && classes["display".concat((0, $dKzJP.default)(display))]),
        ref: ref
    }, other));
});
var $10e56bcd6ac435bd$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($10e56bcd6ac435bd$export$9dd6ff9ea0189349, {
    name: 'MuiTypography'
})($10e56bcd6ac435bd$var$Typography);

});


parcelRegister("fHFY6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6eb6d347c1304b3$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $2YkFy = parcelRequire("2YkFy");
var $b6eb6d347c1304b3$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            minWidth: 56,
            color: theme.palette.action.active,
            flexShrink: 0,
            display: 'inline-flex'
        },
        /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */ alignItemsFlexStart: {
            marginTop: 8
        }
    };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ var $b6eb6d347c1304b3$var$ListItemIcon = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemIcon(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $lfiYO.default)(props, [
        "classes",
        "className"
    ]);
    var context = $7fPBF.useContext((0, $2YkFy.default));
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
        ref: ref
    }, other));
});
var $b6eb6d347c1304b3$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($b6eb6d347c1304b3$export$9dd6ff9ea0189349, {
    name: 'MuiListItemIcon'
})($b6eb6d347c1304b3$var$ListItemIcon);

});

parcelRegister("9SdKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7303d34c4b4ff570$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $7303d34c4b4ff570$var$SIZE = 44;
var $7303d34c4b4ff570$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-block'
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: '$circular-rotate 1.4s linear infinite'
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: 'block' // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: '$circular-dash 1.4s ease-in-out infinite',
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: '80px, 200px',
            strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        '@keyframes circular-rotate': {
            '0%': {
                // Fix IE 11 wobbly
                transformOrigin: '50% 50%'
            },
            '100%': {
                transform: 'rotate(360deg)'
            }
        },
        '@keyframes circular-dash': {
            '0%': {
                strokeDasharray: '1px, 200px',
                strokeDashoffset: '0px'
            },
            '50%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-15px'
            },
            '100%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-125px'
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: 'none'
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $7303d34c4b4ff570$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'indeterminate' : _props$variant, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === 'determinate' || variant === 'static') {
        var circumference = 2 * Math.PI * (($7303d34c4b4ff570$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $dKzJP.default)(color))], {
            'determinate': classes.determinate,
            'indeterminate': classes.indeterminate,
            'static': classes.static
        }[variant]),
        style: (0, $kY3Ke.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $7fPBF.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($7303d34c4b4ff570$var$SIZE / 2, " ").concat($7303d34c4b4ff570$var$SIZE / 2, " ").concat($7303d34c4b4ff570$var$SIZE, " ").concat($7303d34c4b4ff570$var$SIZE)
    }, /*#__PURE__*/ $7fPBF.createElement("circle", {
        className: (0, $jtRae.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            'determinate': classes.circleDeterminate,
            'indeterminate': classes.circleIndeterminate,
            'static': classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $7303d34c4b4ff570$var$SIZE,
        cy: $7303d34c4b4ff570$var$SIZE,
        r: ($7303d34c4b4ff570$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $7303d34c4b4ff570$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($7303d34c4b4ff570$export$9dd6ff9ea0189349, {
    name: 'MuiCircularProgress',
    flip: false
})($7303d34c4b4ff570$var$CircularProgress);

});

parcelRegister("5jbjs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dd78092bd055609$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");



var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $dzfbx = parcelRequire("dzfbx");

var $g21Gx = parcelRequire("g21Gx");

var $g1A03 = parcelRequire("g1A03");

var $kvwQS = parcelRequire("kvwQS");

var $kGz5b = parcelRequire("kGz5b");

var $1rW9t = parcelRequire("1rW9t");

var $dH8x6 = parcelRequire("dH8x6");

var $ejsyu = parcelRequire("ejsyu");
var $3dd78092bd055609$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(14),
            overflow: 'auto',
            // Increase the specificity to override TableCell.
            '&:last-child': {
                padding: 0
            }
        },
        /* Styles applied to the Toolbar component. */ toolbar: {
            minHeight: 52,
            paddingRight: 2
        },
        /* Styles applied to the spacer element. */ spacer: {
            flex: '1 1 100%'
        },
        /* Styles applied to the caption Typography components if `variant="caption"`. */ caption: {
            flexShrink: 0
        },
        // TODO v5: `.selectRoot` should be merged with `.input`
        /* Styles applied to the Select component root element. */ selectRoot: {
            marginRight: 32,
            marginLeft: 8
        },
        /* Styles applied to the Select component `select` class. */ select: {
            paddingLeft: 8,
            paddingRight: 24,
            textAlign: 'right',
            textAlignLast: 'right' // Align <select> on Chrome.
        },
        // TODO v5: remove
        /* Styles applied to the Select component `icon` class. */ selectIcon: {},
        /* Styles applied to the `InputBase` component. */ input: {
            color: 'inherit',
            fontSize: 'inherit',
            flexShrink: 0
        },
        /* Styles applied to the MenuItem component. */ menuItem: {},
        /* Styles applied to the internal `TablePaginationActions` component. */ actions: {
            flexShrink: 0,
            marginLeft: 20
        }
    };
};
var $3dd78092bd055609$var$defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
    var from = _ref.from, to = _ref.to, count = _ref.count;
    return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
};
var $3dd78092bd055609$var$defaultRowsPerPageOptions = [
    10,
    25,
    50,
    100
];
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ var $3dd78092bd055609$var$TablePagination = /*#__PURE__*/ $7fPBF.forwardRef(function TablePagination(props, ref) {
    var _props$ActionsCompone = props.ActionsComponent, ActionsComponent = _props$ActionsCompone === void 0 ? (0, $dH8x6.default) : _props$ActionsCompone, backIconButtonProps = props.backIconButtonProps, _props$backIconButton = props.backIconButtonText, backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton, classes = props.classes, className = props.className, colSpanProp = props.colSpan, _props$component = props.component, Component = _props$component === void 0 ? (0, $kvwQS.default) : _props$component, count = props.count, _props$labelDisplayed = props.labelDisplayedRows, labelDisplayedRows = _props$labelDisplayed === void 0 ? $3dd78092bd055609$var$defaultLabelDisplayedRows : _props$labelDisplayed, _props$labelRowsPerPa = props.labelRowsPerPage, labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa, nextIconButtonProps = props.nextIconButtonProps, _props$nextIconButton = props.nextIconButtonText, nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton, onChangePage = props.onChangePage, onPageChange = props.onPageChange, onChangeRowsPerPageProp = props.onChangeRowsPerPage, onRowsPerPageChangeProp = props.onRowsPerPageChange, page = props.page, rowsPerPage = props.rowsPerPage, _props$rowsPerPageOpt = props.rowsPerPageOptions, rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? $3dd78092bd055609$var$defaultRowsPerPageOptions : _props$rowsPerPageOpt, _props$SelectProps = props.SelectProps, SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps, other = (0, $lfiYO.default)(props, [
        "ActionsComponent",
        "backIconButtonProps",
        "backIconButtonText",
        "classes",
        "className",
        "colSpan",
        "component",
        "count",
        "labelDisplayedRows",
        "labelRowsPerPage",
        "nextIconButtonProps",
        "nextIconButtonText",
        "onChangePage",
        "onPageChange",
        "onChangeRowsPerPage",
        "onRowsPerPageChange",
        "page",
        "rowsPerPage",
        "rowsPerPageOptions",
        "SelectProps"
    ]);
    var onChangeRowsPerPage = onChangeRowsPerPageProp || onRowsPerPageChangeProp;
    var colSpan;
    if (Component === (0, $kvwQS.default) || Component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    var selectId = (0, $ejsyu.default)();
    var labelId = (0, $ejsyu.default)();
    var MenuItemComponent = SelectProps.native ? 'option' : (0, $g21Gx.default);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        colSpan: colSpan,
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement((0, $kGz5b.default), {
        className: classes.toolbar
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.spacer
    }), rowsPerPageOptions.length > 1 && /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), {
        color: "inherit",
        variant: "body2",
        className: classes.caption,
        id: labelId
    }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/ $7fPBF.createElement((0, $g1A03.default), (0, $kY3Ke.default)({
        classes: {
            select: classes.select,
            icon: classes.selectIcon
        },
        input: /*#__PURE__*/ $7fPBF.createElement((0, $dzfbx.default), {
            className: (0, $jtRae.default)(classes.input, classes.selectRoot)
        }),
        value: rowsPerPage,
        onChange: onChangeRowsPerPage,
        id: selectId,
        labelId: labelId
    }, SelectProps), rowsPerPageOptions.map(function(rowsPerPageOption) {
        return /*#__PURE__*/ $7fPBF.createElement(MenuItemComponent, {
            className: classes.menuItem,
            key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
    })), /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), {
        color: "inherit",
        variant: "body2",
        className: classes.caption
    }, labelDisplayedRows({
        from: count === 0 ? 0 : page * rowsPerPage + 1,
        to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
        count: count === -1 ? -1 : count,
        page: page
    })), /*#__PURE__*/ $7fPBF.createElement(ActionsComponent, {
        className: classes.actions,
        backIconButtonProps: (0, $kY3Ke.default)({
            title: backIconButtonText,
            'aria-label': backIconButtonText
        }, backIconButtonProps),
        count: count,
        nextIconButtonProps: (0, $kY3Ke.default)({
            title: nextIconButtonText,
            'aria-label': nextIconButtonText
        }, nextIconButtonProps),
        onChangePage: onChangePage,
        onPageChange: onPageChange,
        page: page,
        rowsPerPage: rowsPerPage
    })));
});
var $3dd78092bd055609$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($3dd78092bd055609$export$9dd6ff9ea0189349, {
    name: 'MuiTablePagination'
})($3dd78092bd055609$var$TablePagination);

});
parcelRegister("kvwQS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eee02f9bd412c485$export$2e2bcd8739ae039; });

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");

var $2jEfe = parcelRequire("2jEfe");

var $hOyZl = parcelRequire("hOyZl");

var $1w5Ks = parcelRequire("1w5Ks");
var $eee02f9bd412c485$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({}, theme.typography.body2, {
            display: 'table-cell',
            verticalAlign: 'inherit',
            // Workaround for a rendering bug with spanned columns in Chrome 62.0.
            // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
            borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, $2jEfe.lighten)((0, $2jEfe.alpha)(theme.palette.divider, 1), 0.88) : (0, $2jEfe.darken)((0, $2jEfe.alpha)(theme.palette.divider, 1), 0.68)),
            textAlign: 'left',
            padding: 16
        }),
        /* Styles applied to the root element if `variant="head"` or `context.table.head`. */ head: {
            color: theme.palette.text.primary,
            lineHeight: theme.typography.pxToRem(24),
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the root element if `variant="body"` or `context.table.body`. */ body: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */ footer: {
            color: theme.palette.text.secondary,
            lineHeight: theme.typography.pxToRem(21),
            fontSize: theme.typography.pxToRem(12)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: '6px 24px 6px 16px',
            '&:last-child': {
                paddingRight: 16
            },
            '&$paddingCheckbox': {
                width: 24,
                // prevent the checkbox column from growing
                padding: '0 12px 0 16px',
                '&:last-child': {
                    paddingLeft: 12,
                    paddingRight: 16
                },
                '& > *': {
                    padding: 0
                }
            }
        },
        /* Styles applied to the root element if `padding="checkbox"`. */ paddingCheckbox: {
            width: 48,
            // prevent the checkbox column from growing
            padding: '0 0 0 4px',
            '&:last-child': {
                paddingLeft: 0,
                paddingRight: 4
            }
        },
        /* Styles applied to the root element if `padding="none"`. */ paddingNone: {
            padding: 0,
            '&:last-child': {
                padding: 0
            }
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right',
            flexDirection: 'row-reverse'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `context.table.stickyHeader={true}`. */ stickyHeader: {
            position: 'sticky',
            top: 0,
            left: 0,
            zIndex: 2,
            backgroundColor: theme.palette.background.default
        }
    };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ var $eee02f9bd412c485$var$TableCell = /*#__PURE__*/ $7fPBF.forwardRef(function TableCell(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, component = props.component, paddingProp = props.padding, scopeProp = props.scope, sizeProp = props.size, sortDirection = props.sortDirection, variantProp = props.variant, other = (0, $lfiYO.default)(props, [
        "align",
        "classes",
        "className",
        "component",
        "padding",
        "scope",
        "size",
        "sortDirection",
        "variant"
    ]);
    var table = $7fPBF.useContext((0, $hOyZl.default));
    var tablelvl2 = $7fPBF.useContext((0, $1w5Ks.default));
    var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    var role;
    var Component;
    if (component) {
        Component = component;
        role = isHeadCell ? 'columnheader' : 'cell';
    } else Component = isHeadCell ? 'th' : 'td';
    var scope = scopeProp;
    if (!scope && isHeadCell) scope = 'col';
    var padding = paddingProp || (table && table.padding ? table.padding : 'normal');
    var size = sizeProp || (table && table.size ? table.size : 'medium');
    var variant = variantProp || tablelvl2 && tablelvl2.variant;
    var ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $jtRae.default)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0, $dKzJP.default)(align))], padding !== 'normal' && classes["padding".concat((0, $dKzJP.default)(padding))], size !== 'medium' && classes["size".concat((0, $dKzJP.default)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
        "aria-sort": ariaSort,
        role: role,
        scope: scope
    }, other));
});
var $eee02f9bd412c485$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($eee02f9bd412c485$export$9dd6ff9ea0189349, {
    name: 'MuiTableCell'
})($eee02f9bd412c485$var$TableCell);

});
parcelRegister("hOyZl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf823f2da9fda545$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ var $cf823f2da9fda545$var$TableContext = $7fPBF.createContext();
var $cf823f2da9fda545$export$2e2bcd8739ae039 = $cf823f2da9fda545$var$TableContext;

});

parcelRegister("1w5Ks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11ad3d14282fcd19$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ var $11ad3d14282fcd19$var$Tablelvl2Context = $7fPBF.createContext();
var $11ad3d14282fcd19$export$2e2bcd8739ae039 = $11ad3d14282fcd19$var$Tablelvl2Context;

});


parcelRegister("kGz5b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f2f1915561a2bb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");
var $f0f2f1915561a2bb$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: (0, $dQMrF.default)({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `variant="regular"`. */ regular: theme.mixins.toolbar,
        /* Styles applied to the root element if `variant="dense"`. */ dense: {
            minHeight: 48
        }
    };
};
var $f0f2f1915561a2bb$var$Toolbar = /*#__PURE__*/ $7fPBF.forwardRef(function Toolbar(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? 'regular' : _props$variant, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "variant"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $f0f2f1915561a2bb$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($f0f2f1915561a2bb$export$9dd6ff9ea0189349, {
    name: 'MuiToolbar'
})($f0f2f1915561a2bb$var$Toolbar);

});

parcelRegister("dH8x6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f85e8f81b2fbb98$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $fppyJ = parcelRequire("fppyJ");

var $kxFei = parcelRequire("kxFei");

var $fH0xA = parcelRequire("fH0xA");

var $iRcsz = parcelRequire("iRcsz");
/**
 * @ignore - internal component.
 */ var $9f85e8f81b2fbb98$var$_ref = /*#__PURE__*/ $7fPBF.createElement((0, $kxFei.default), null);
var $9f85e8f81b2fbb98$var$_ref2 = /*#__PURE__*/ $7fPBF.createElement((0, $fppyJ.default), null);
var $9f85e8f81b2fbb98$var$_ref3 = /*#__PURE__*/ $7fPBF.createElement((0, $fppyJ.default), null);
var $9f85e8f81b2fbb98$var$_ref4 = /*#__PURE__*/ $7fPBF.createElement((0, $kxFei.default), null);
var $9f85e8f81b2fbb98$var$TablePaginationActions = /*#__PURE__*/ $7fPBF.forwardRef(function TablePaginationActions(props, ref) {
    var backIconButtonProps = props.backIconButtonProps, count = props.count, nextIconButtonProps = props.nextIconButtonProps, _props$onChangePage = props.onChangePage, onChangePage = _props$onChangePage === void 0 ? function() {} : _props$onChangePage, _props$onPageChange = props.onPageChange, onPageChange = _props$onPageChange === void 0 ? function() {} : _props$onPageChange, page = props.page, rowsPerPage = props.rowsPerPage, other = (0, $lfiYO.default)(props, [
        "backIconButtonProps",
        "count",
        "nextIconButtonProps",
        "onChangePage",
        "onPageChange",
        "page",
        "rowsPerPage"
    ]);
    var theme = (0, $fH0xA.default)();
    var handleBackButtonClick = function handleBackButtonClick(event) {
        onChangePage(event, page - 1);
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function handleNextButtonClick(event) {
        onChangePage(event, page + 1);
        onPageChange(event, page + 1);
    };
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement((0, $iRcsz.default), (0, $kY3Ke.default)({
        onClick: handleBackButtonClick,
        disabled: page === 0,
        color: "inherit"
    }, backIconButtonProps), theme.direction === 'rtl' ? $9f85e8f81b2fbb98$var$_ref : $9f85e8f81b2fbb98$var$_ref2), /*#__PURE__*/ $7fPBF.createElement((0, $iRcsz.default), (0, $kY3Ke.default)({
        onClick: handleNextButtonClick,
        disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
        color: "inherit"
    }, nextIconButtonProps), theme.direction === 'rtl' ? $9f85e8f81b2fbb98$var$_ref3 : $9f85e8f81b2fbb98$var$_ref4));
});
var $9f85e8f81b2fbb98$export$2e2bcd8739ae039 = $9f85e8f81b2fbb98$var$TablePaginationActions;

});
parcelRegister("fppyJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b37d0452018f3112$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $b37d0452018f3112$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("kxFei", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef46df12d7196717$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $ef46df12d7196717$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});



parcelRegister("3NUyv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zhCN = module.exports.viVN = module.exports.ukUA = module.exports.trTR = module.exports.svSE = module.exports.skSK = module.exports.ruRU = module.exports.roRO = module.exports.ptPT = module.exports.ptBR = module.exports.plPL = module.exports.nlNL = module.exports.koKR = module.exports.jaJP = module.exports.itIT = module.exports.isIS = module.exports.idID = module.exports.hyAM = module.exports.huHU = module.exports.hiIN = module.exports.heIL = module.exports.frFR = module.exports.fiFI = module.exports.faIR = module.exports.etEE = module.exports.esES = module.exports.enUS = module.exports.deDE = module.exports.csCZ = module.exports.caES = module.exports.bgBG = module.exports.azAZ = void 0;
var $2c51d170f1c5aad6$var$azAZ = {
    props: {
        MuiBreadcrumbs: {
            expandText: "Yolu g\xf6st\u0259r"
        },
        MuiTablePagination: {
            backIconButtonText: "\u018Fvv\u0259lki s\u0259hif\u0259",
            labelRowsPerPage: "S\u0259hif\u0259y\u0259 d\xfc\u015F\u0259n s\u0259trl\u0259r:",
            labelDisplayedRows: function labelDisplayedRows(_ref) {
                var from = _ref.from, to = _ref.to, count = _ref.count;
                return "".concat(from, "-").concat(to, " d\u0259n ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "N\xf6vb\u0259ti s\u0259hif\u0259"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                var pluralForm = 'Ulduz';
                var lastDigit = value % 10;
                if (lastDigit > 1 && lastDigit < 5) pluralForm = 'Ulduzlar';
                return "".concat(value, " ").concat(pluralForm);
            },
            emptyLabelText: "Bo\u015F"
        },
        MuiAutocomplete: {
            clearText: "Silm\u0259k",
            closeText: "Ba\u011Flamaq",
            loadingText: "Y\xfckl\u0259nir\u2026",
            noOptionsText: "Se\xe7iml\u0259r m\xf6vcud deyil",
            openText: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C"
        },
        MuiAlert: {
            closeText: "Ba\u011Flamaq"
        },
        MuiPagination: {
            'aria-label': "S\u0259hif\u0259nin naviqasiyas\u0131",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(page, " ").concat(selected ? "s\u0259hif\u0259" : "s\u0259hif\u0259y\u0259 ke\xe7");
                if (type === 'first') return "Birinci s\u0259hif\u0259y\u0259 ke\xe7";
                if (type === 'last') return "Sonuncu s\u0259hif\u0259y\u0259 ke\xe7";
                if (type === 'next') return "N\xf6vb\u0259ti s\u0259hif\u0259y\u0259 ke\xe7";
                if (type === 'previous') return "\u018Fvv\u0259lki s\u0259hif\u0259y\u0259 ke\xe7";
                return undefined;
            }
        }
    }
};
module.exports.azAZ = $2c51d170f1c5aad6$var$azAZ;
var $2c51d170f1c5aad6$var$bgBG = {
    props: {
        MuiBreadcrumbs: {
            expandText: "\u041F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 \u043F\u044A\u0442\u044F"
        },
        MuiTablePagination: {
            backIconButtonText: "\u041F\u0440\u0435\u0434\u0438\u0448\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
            labelRowsPerPage: "\u0420\u0435\u0434\u043E\u0432\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430:",
            labelDisplayedRows: function labelDisplayedRows(_ref2) {
                var from = _ref2.from, to = _ref2.to, count = _ref2.count;
                return "".concat(from, "-").concat(to, " \u043E\u0442 ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " \u0417\u0432\u0435\u0437\u0434").concat(value !== 1 ? "\u0438" : "\u0430");
            },
            emptyLabelText: "\u0418\u0437\u0447\u0438\u0441\u0442\u0438"
        },
        MuiAutocomplete: {
            clearText: "\u0418\u0437\u0447\u0438\u0441\u0442\u0438",
            closeText: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
            loadingText: "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435\u2026",
            noOptionsText: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0438 \u043E\u043F\u0446\u0438\u0438",
            openText: "\u041E\u0442\u0432\u043E\u0440\u0438"
        },
        MuiAlert: {
            closeText: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"
        },
        MuiPagination: {
            'aria-label': "\u041F\u0430\u0433\u0438\u043D\u0430\u0446\u0438\u044F",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : "\u041A\u044A\u043C ", "\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ").concat(page);
                if (type === 'first') return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u044A\u0440\u0432\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                if (type === 'last') return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                if (type === 'next') return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                if (type === 'previous') return "\u041E\u0442\u0438\u0434\u0438 \u043D\u0430 \u043F\u0440\u0435\u0434\u0438\u0448\u043D\u0430\u0442\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430";
                return undefined;
            }
        }
    }
};
module.exports.bgBG = $2c51d170f1c5aad6$var$bgBG;
var $2c51d170f1c5aad6$var$caES = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "P\xe0gina anterior",
            labelRowsPerPage: "Files per p\xe0gina:",
            labelDisplayedRows: function labelDisplayedRows(_ref3) {
                var from = _ref3.from, to = _ref3.to, count = _ref3.count;
                return "".concat(from, "-").concat(to, " de ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "Seg\xfcent p\xe0gina"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " ").concat(value !== 1 ? 'Estrelles' : 'Estrella');
            },
            emptyLabelText: 'Buit'
        },
        MuiAutocomplete: {
            clearText: 'Netejar',
            closeText: 'Tancar',
            loadingText: "Carregant\u2026",
            noOptionsText: 'Sense opcions',
            openText: 'Obert'
        },
        MuiAlert: {
            closeText: 'Tancat'
        } // MuiPagination: {
    }
};
module.exports.caES = $2c51d170f1c5aad6$var$caES;
var $2c51d170f1c5aad6$var$csCZ = {
    props: {
        MuiBreadcrumbs: {
            expandText: "Uk\xe1zat cestu"
        },
        MuiTablePagination: {
            backIconButtonText: "P\u0159edchoz\xed str\xe1nka",
            labelRowsPerPage: "\u0158\xe1dk\u016F na str\xe1nce:",
            labelDisplayedRows: function labelDisplayedRows(_ref4) {
                var from = _ref4.from, to = _ref4.to, count = _ref4.count;
                return "".concat(from, "-").concat(to, " z ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "Dal\u0161\xed str\xe1nka"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                if (value === 1) return "".concat(value, " hv\u011Bzdi\u010Dka");
                if (value >= 2 && value <= 4) return "".concat(value, " hv\u011Bzdi\u010Dky");
                return "".concat(value, " hv\u011Bzdi\u010Dek");
            },
            emptyLabelText: "Pr\xe1zdn\xe9"
        },
        MuiAutocomplete: {
            clearText: 'Vymazat',
            closeText: "Zav\u0159\xedt",
            loadingText: "Na\u010D\xedt\xe1n\xed\u2026",
            noOptionsText: "\u017D\xe1dn\xe9 mo\u017Enosti",
            openText: "Otev\u0159\xedt"
        },
        MuiAlert: {
            closeText: "Zav\u0159\xedt"
        },
        MuiPagination: {
            'aria-label': "Navigace str\xe1nkov\xe1n\xedm",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : "J\xedt na ").concat(page, " str\xE1nku");
                if (type === 'first') return "J\xedt na prvn\xed str\xe1nku";
                if (type === 'last') return "J\xedt na posledn\xed str\xe1nku";
                if (type === 'next') return "J\xedt na dal\u0161\xed str\xe1nku";
                if (type === 'previous') return "J\xedt na p\u0159edchoz\xed str\xe1nku";
                return undefined;
            }
        }
    }
};
module.exports.csCZ = $2c51d170f1c5aad6$var$csCZ;
var $2c51d170f1c5aad6$var$deDE = {
    props: {
        MuiBreadcrumbs: {
            expandText: 'Pfad anzeigen'
        },
        MuiTablePagination: {
            backIconButtonText: "N\xe4chste Seite",
            labelRowsPerPage: 'Zeilen pro Seite:',
            labelDisplayedRows: function labelDisplayedRows(_ref5) {
                var from = _ref5.from, to = _ref5.to, count = _ref5.count;
                return "".concat(from, "-").concat(to, " von ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "N\xe4chste Seite"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " ").concat(value !== 1 ? 'Sterne' : 'Stern');
            },
            emptyLabelText: 'Keine Wertung'
        },
        MuiAutocomplete: {
            clearText: 'Leeren',
            closeText: "Schlie\xdfen",
            loadingText: "Wird geladen\u2026",
            noOptionsText: 'Keine Optionen',
            openText: "\xd6ffnen"
        },
        MuiAlert: {
            closeText: "Schlie\xdfen"
        },
        MuiPagination: {
            'aria-label': 'Navigation via Seitennummerierung',
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : 'Gehe zu ', "Seite ").concat(page);
                if (type === 'first') return 'Zur ersten Seite';
                if (type === 'last') return 'Zur letzten Seite';
                if (type === 'next') return "Zur n\xe4chsten Seite";
                if (type === 'previous') return 'Zur vorherigen Seite';
                return undefined;
            }
        }
    }
}; // default
module.exports.deDE = $2c51d170f1c5aad6$var$deDE;
var $2c51d170f1c5aad6$var$enUS = {
};
module.exports.enUS = $2c51d170f1c5aad6$var$enUS;
var $2c51d170f1c5aad6$var$esES = {
    props: {
        MuiBreadcrumbs: {
            expandText: 'Mostrar ruta'
        },
        MuiTablePagination: {
            backIconButtonText: "P\xe1gina anterior",
            labelRowsPerPage: "Filas por p\xe1gina:",
            labelDisplayedRows: function labelDisplayedRows(_ref6) {
                var from = _ref6.from, to = _ref6.to, count = _ref6.count;
                return "".concat(from, "-").concat(to, " de ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "Siguiente p\xe1gina"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Estrella").concat(value !== 1 ? 's' : '');
            },
            emptyLabelText: "Vac\xedo"
        },
        MuiAutocomplete: {
            clearText: 'Limpiar',
            closeText: 'Cerrar',
            loadingText: "Cargando\u2026",
            noOptionsText: 'Sin opciones',
            openText: 'Abierto'
        },
        MuiAlert: {
            closeText: 'Cerrar'
        },
        MuiPagination: {
            'aria-label': 'Paginador',
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : 'Ir a la ', "p\xE1gina ").concat(page);
                if (type === 'first') return "Ir a la primera p\xe1gina";
                if (type === 'last') return "Ir a la \xfaltima p\xe1gina";
                if (type === 'next') return "Ir a la p\xe1gina siguiente";
                if (type === 'previous') return "Ir a la p\xe1gina anterior";
                return undefined;
            }
        }
    }
};
module.exports.esES = $2c51d170f1c5aad6$var$esES;
var $2c51d170f1c5aad6$var$etEE = {
    props: {
        MuiBreadcrumbs: {
            expandText: "N\xe4ita teed"
        },
        MuiTablePagination: {
            backIconButtonText: "Eelmine lehek\xfclg",
            labelRowsPerPage: "Ridu lehek\xfcljel:",
            labelDisplayedRows: function labelDisplayedRows(_ref7) {
                var from = _ref7.from, to = _ref7.to, count = _ref7.count;
                return "".concat(from, "-").concat(to, " / ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "J\xe4rgmine lehek\xfclg"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " T\xE4rn").concat(value !== 1 ? 'i' : '');
            },
            emptyLabelText: "T\xfchi"
        },
        MuiAutocomplete: {
            clearText: "T\xfchjenda",
            closeText: 'Sulge',
            loadingText: "Laen\u2026",
            noOptionsText: 'Valikuid ei ole',
            openText: 'Ava'
        },
        MuiAlert: {
            closeText: 'Sulge'
        },
        MuiPagination: {
            'aria-label': "Lehek\xfclgede valik",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : 'Vali ', "lehek\xFClg ").concat(page);
                if (type === 'first') return "Vali esimene lehek\xfclg";
                if (type === 'last') return "Vali viimane lehek\xfclg";
                if (type === 'next') return "Vali j\xe4rgmine lehek\xfclg";
                if (type === 'previous') return "Vali eelmine lehek\xfclg";
                return undefined;
            }
        }
    }
};
module.exports.etEE = $2c51d170f1c5aad6$var$etEE;
var $2c51d170f1c5aad6$var$faIR = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiBreadcrumbs: {
            expandText: "\u0646\u0645\u0627\u06CC\u0634 \u0645\u0633\u06CC\u0631"
        },
        MuiTablePagination: {
            backIconButtonText: "\u0635\u0641\u062D\u0647\u0654 \u0642\u0628\u0644",
            labelRowsPerPage: "\u062A\u0639\u062F\u0627\u062F \u0633\u0637\u0631\u0647\u0627\u06CC \u0647\u0631 \u0635\u0641\u062D\u0647:",
            labelDisplayedRows: function labelDisplayedRows(_ref8) {
                var from = _ref8.from, to = _ref8.to, count = _ref8.count;
                return "".concat(from, "-").concat(to, " \u0627\u0632 ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "\u0635\u0641\u062D\u0647\u0654 \u0628\u0639\u062F"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " \u0633\u062A\u0627\u0631\u0647");
            },
            emptyLabelText: "\u062E\u0627\u0644\u06CC"
        },
        MuiAutocomplete: {
            clearText: "\u067E\u0627\u06A9\u200C\u06A9\u0631\u062F\u0646",
            closeText: "\u0628\u0633\u062A\u0646",
            loadingText: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026",
            noOptionsText: "\u0628\u06CC\u200C\u0646\u062A\u06CC\u062C\u0647",
            openText: "\u0628\u0627\u0632\u06A9\u0631\u062F\u0646"
        },
        MuiAlert: {
            closeText: "\u0628\u0633\u062A\u0646"
        },
        MuiPagination: {
            'aria-label': "\u0646\u0627\u0648\u0628\u0631\u06CC \u0635\u0641\u062D\u0647",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : "\u0631\u0641\u062A\u0646 \u0628\u0647 ", "\u0635\u0641\u062D\u0647\u0654 ").concat(page);
                if (type === 'first') return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0627\u0648\u0644\u06CC\u0646 \u0635\u0641\u062D\u0647";
                if (type === 'last') return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0622\u062E\u0631\u06CC\u0646 \u0635\u0641\u062D\u0647";
                if (type === 'next') return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0635\u0641\u062D\u0647\u200C\u06CC \u0628\u0639\u062F\u06CC";
                if (type === 'previous') return "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0635\u0641\u062D\u0647\u200C\u06CC \u0642\u0628\u0644\u06CC";
                return undefined;
            }
        }
    }
};
module.exports.faIR = $2c51d170f1c5aad6$var$faIR;
var $2c51d170f1c5aad6$var$fiFI = {
    props: {
        MuiBreadcrumbs: {
            expandText: "N\xe4yt\xe4 reitti"
        },
        MuiTablePagination: {
            backIconButtonText: 'Edellinen sivu',
            labelRowsPerPage: "Rivej\xe4 per sivu:",
            labelDisplayedRows: function labelDisplayedRows(_ref9) {
                var from = _ref9.from, to = _ref9.to, count = _ref9.count;
                return "".concat(from, "-").concat(to, " / ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: 'Seuraava sivu'
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " T\xE4ht").concat(value !== 1 ? "e\xe4" : 'i');
            },
            emptyLabelText: "Tyhj\xe4"
        },
        MuiAutocomplete: {
            clearText: "Tyhjenn\xe4",
            closeText: 'Sulje',
            loadingText: "Ladataan\u2026",
            noOptionsText: 'Ei valintoja',
            openText: 'Avaa'
        },
        MuiAlert: {
            closeText: 'Sulje'
        },
        MuiPagination: {
            'aria-label': 'Sivutus navigaatio',
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? 'sivu' : 'Mene sivulle', " ").concat(page);
                if (type === 'first') return "Mene ensimm\xe4iselle sivulle";
                if (type === 'last') return 'Mene viimeiselle sivulle';
                if (type === 'next') return 'Mene seuraavalle sivulle';
                if (type === 'previous') return 'Mene edelliselle sivulle';
                return undefined;
            }
        }
    }
};
module.exports.fiFI = $2c51d170f1c5aad6$var$fiFI;
var $2c51d170f1c5aad6$var$frFR = {
    props: {
        MuiBreadcrumbs: {
            expandText: 'Montrer le chemin'
        },
        MuiTablePagination: {
            backIconButtonText: "Page pr\xe9c\xe9dente",
            labelRowsPerPage: 'Lignes par page :',
            labelDisplayedRows: function labelDisplayedRows(_ref10) {
                var from = _ref10.from, to = _ref10.to, count = _ref10.count;
                return "".concat(from, "-").concat(to, " sur ").concat(count !== -1 ? count : "plus que ".concat(to));
            },
            nextIconButtonText: 'Page suivante'
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Etoile").concat(value !== 1 ? 's' : '');
            },
            emptyLabelText: 'Vide'
        },
        MuiAutocomplete: {
            clearText: 'Vider',
            closeText: 'Fermer',
            loadingText: "Chargement\u2026",
            noOptionsText: "Pas de r\xe9sultats",
            openText: 'Ouvrir'
        },
        MuiAlert: {
            closeText: 'Fermer'
        },
        MuiPagination: {
            'aria-label': 'navigation de pagination',
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : "Aller \xe0 la ", "page ").concat(page);
                if (type === 'first') return "Aller \xe0 la premi\xe8re page";
                if (type === 'last') return "Aller \xe0 la derni\xe8re page";
                if (type === 'next') return "Aller \xe0 la page suivante";
                if (type === 'previous') return "Aller \xe0 la page pr\xe9c\xe9dente";
                return undefined;
            }
        }
    }
};
module.exports.frFR = $2c51d170f1c5aad6$var$frFR;
var $2c51d170f1c5aad6$var$heIL = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "\u05D4\u05E2\u05DE\u05D5\u05D3 \u05D4\u05E7\u05D5\u05D3\u05DD",
            labelRowsPerPage: "\u05E9\u05D5\u05E8\u05D5\u05EA \u05D1\u05E2\u05DE\u05D5\u05D3:",
            labelDisplayedRows: function labelDisplayedRows(_ref11) {
                var from = _ref11.from, to = _ref11.to, count = _ref11.count;
                return "".concat(from, "-").concat(to, " \u05DE\u05EA\u05D5\u05DA ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "\u05D4\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D0"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " \u05DB\u05D5\u05DB\u05D1").concat(value !== 1 ? "\u05D9\u05DD" : '');
            },
            emptyLabelText: "\u05E8\u05D9\u05E7"
        },
        MuiAutocomplete: {
            clearText: "\u05E0\u05E7\u05D4",
            closeText: "\u05E1\u05D2\u05D5\u05E8",
            loadingText: "\u05D8\u05D5\u05E2\u05DF\u2026",
            noOptionsText: "\u05D0\u05D9\u05DF \u05D0\u05D5\u05E4\u05E6\u05D9\u05D5\u05EA",
            openText: "\u05E4\u05EA\u05D7"
        },
        MuiAlert: {
            closeText: "\u05E1\u05D2\u05D5\u05E8"
        } // MuiPagination: {
    }
};
module.exports.heIL = $2c51d170f1c5aad6$var$heIL;
var $2c51d170f1c5aad6$var$hiIN = {
    props: {
        MuiBreadcrumbs: {
            expandText: "\u0930\u093E\u0938\u094D\u0924\u093E \u0926\u093F\u0916\u093E\u092F\u0947\u0902"
        },
        MuiTablePagination: {
            backIconButtonText: "\u092A\u093F\u091B\u0932\u093E \u092A\u0943\u0937\u094D\u0920",
            labelRowsPerPage: "\u092A\u0902\u0915\u094D\u0924\u093F\u092F\u093E\u0901 \u092A\u094D\u0930\u0924\u093F \u092A\u0943\u0937\u094D\u0920:",
            labelDisplayedRows: function labelDisplayedRows(_ref12) {
                var from = _ref12.from, to = _ref12.to, count = _ref12.count;
                return "".concat(from, "-").concat(to === -1 ? count : to, " \u0915\u0941\u0932 ").concat(count, " \u092E\u0947\u0902");
            },
            nextIconButtonText: "\u0905\u0917\u0932\u093E \u092A\u0943\u0937\u094D\u0920"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " \u0924\u093E\u0930").concat(value !== 1 ? "\u0947" : "\u093E");
            },
            emptyLabelText: "\u0930\u093F\u0915\u094D\u0924"
        },
        MuiAutocomplete: {
            clearText: "\u0939\u091F\u093E\u092F\u0947\u0902",
            closeText: "\u092C\u0902\u0926 \u0915\u0930\u0947\u0902",
            loadingText: "\u0932\u094B\u0921 \u0939\u094B \u0930\u0939\u093E \u0939\u0948\u2026",
            noOptionsText: "\u0915\u094B\u0908 \u0935\u093F\u0915\u0932\u094D\u092A \u0928\u0939\u0940\u0902",
            openText: "\u0916\u094B\u0932\u0947\u0902"
        },
        MuiAlert: {
            closeText: "\u092C\u0902\u0926 \u0915\u0930\u0947\u0902"
        },
        MuiPagination: {
            'aria-label': "\u092A\u0943\u0938\u094D\u0920\u093E\u0928\u0941\u0938\u093E\u0930 \u0938\u0902\u091A\u093E\u0932\u0928",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "\u092A\u0943\u0937\u094D\u0920 ".concat(page, " ").concat(selected ? '' : " \u092A\u0930 \u091C\u093E\u090F\u0901");
                if (type === 'first') return "\u092A\u0939\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                if (type === 'last') return "\u0905\u0902\u0924\u093F\u092E \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                if (type === 'next') return "\u0905\u0917\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                if (type === 'previous') return "\u092A\u093F\u091B\u0932\u0947 \u092A\u0943\u0937\u094D\u0920 \u092A\u0930 \u091C\u093E\u090F\u0901";
                return undefined;
            }
        }
    }
};
module.exports.hiIN = $2c51d170f1c5aad6$var$hiIN;
var $2c51d170f1c5aad6$var$huHU = {
    props: {
        MuiBreadcrumbs: {
            expandText: "\xdatvonal"
        },
        MuiTablePagination: {
            backIconButtonText: "El\u0151z\u0151 oldal",
            labelRowsPerPage: "Sorok sz\xe1ma:",
            labelDisplayedRows: function labelDisplayedRows(_ref13) {
                var from = _ref13.from, to = _ref13.to, count = _ref13.count;
                return "".concat(from, "-").concat(to, " / ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "K\xf6vetkez\u0151 oldal"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Csillag");
            },
            emptyLabelText: "\xdcres"
        },
        MuiAutocomplete: {
            clearText: "T\xf6rl\xe9s",
            closeText: "Bez\xe1r\xe1s",
            loadingText: "T\xf6lt\xe9s\u2026",
            noOptionsText: "Nincs tal\xe1lat",
            openText: "Megnyit\xe1s"
        },
        MuiAlert: {
            closeText: "Bez\xe1r\xe1s"
        },
        MuiPagination: {
            'aria-label': "Lapoz\xe1s",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(page, ". oldal").concat(selected ? '' : 'ra');
                if (type === 'first') return "Els\u0151 oldalra";
                if (type === 'last') return "Utols\xf3 oldalra";
                if (type === 'next') return "K\xf6vetkez\u0151 oldalra";
                if (type === 'previous') return "El\u0151z\u0151 oldalra";
                return undefined;
            }
        }
    }
};
module.exports.huHU = $2c51d170f1c5aad6$var$huHU;
var $2c51d170f1c5aad6$var$hyAM = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "\u0546\u0561\u056D\u0578\u0580\u0564\u0568",
            labelRowsPerPage: "\u054F\u0578\u0572\u0565\u0580 \u0574\u0565\u056F \u0567\u057B\u0578\u0582\u0574`",
            labelDisplayedRows: function labelDisplayedRows(_ref14) {
                var from = _ref14.from, to = _ref14.to, count = _ref14.count;
                return "".concat(from, "-").concat(to, " / ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "\u0540\u0561\u057B\u0578\u0580\u0564\u0568"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " \u0531\u057D\u057F\u0572");
            },
            emptyLabelText: "\u0534\u0561\u057F\u0561\u0580\u056F"
        },
        MuiAutocomplete: {
            clearText: "\u0544\u0561\u0584\u0580\u0565\u056C",
            closeText: "\u0553\u0561\u056F\u0565\u056C",
            loadingText: "\u0532\u0565\u057C\u0576\u0578\u0582\u0574\u2026",
            noOptionsText: "\u054F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
            openText: "\u0532\u0561\u0581\u0565\u056C"
        },
        MuiAlert: {
            closeText: "\u0553\u0561\u056F\u0565\u056C"
        } // MuiPagination: {
    }
};
module.exports.hyAM = $2c51d170f1c5aad6$var$hyAM;
var $2c51d170f1c5aad6$var$idID = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: 'Halaman sebelumnya',
            labelRowsPerPage: 'Baris per halaman:',
            labelDisplayedRows: function labelDisplayedRows(_ref15) {
                var from = _ref15.from, to = _ref15.to, count = _ref15.count;
                return "".concat(from, "-").concat(to, " dari ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: 'Halaman selanjutnya'
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Bintang");
            } // emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: 'Hapus',
            closeText: 'Tutup',
            loadingText: "Memuat\u2026",
            noOptionsText: 'Tidak ada opsi',
            openText: 'Buka'
        },
        MuiAlert: {
            closeText: 'Tutup'
        } // MuiPagination: {
    }
};
module.exports.idID = $2c51d170f1c5aad6$var$idID;
var $2c51d170f1c5aad6$var$isIS = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "Fyrri s\xed\xf0a",
            labelRowsPerPage: "Ra\xf0ir \xe1 s\xed\xf0u:",
            labelDisplayedRows: function labelDisplayedRows(_ref16) {
                var from = _ref16.from, to = _ref16.to, count = _ref16.count;
                return "".concat(from, "-").concat(to, " af ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "N\xe6sta s\xed\xf0a"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " ").concat(value === 1 ? 'Stjarna' : "Stj\xf6rnur");
            },
            emptyLabelText: "T\xf3mt"
        },
        MuiAutocomplete: {
            clearText: 'Hreinsa',
            closeText: 'Loka',
            loadingText: "Hla\xf0a\u2026",
            noOptionsText: "Engar ni\xf0urst\xf6\xf0ur",
            openText: 'Opna'
        },
        MuiAlert: {
            closeText: 'Loka'
        } // MuiPagination: {
    }
};
module.exports.isIS = $2c51d170f1c5aad6$var$isIS;
var $2c51d170f1c5aad6$var$itIT = {
    props: {
        MuiBreadcrumbs: {
            expandText: 'Visualizza percorso'
        },
        MuiTablePagination: {
            backIconButtonText: 'Pagina precedente',
            labelRowsPerPage: 'Righe per pagina:',
            labelDisplayedRows: function labelDisplayedRows(_ref17) {
                var from = _ref17.from, to = _ref17.to, count = _ref17.count;
                return "".concat(from, "-").concat(to, " di ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: 'Pagina successiva'
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Stell").concat(value !== 1 ? 'e' : 'a');
            },
            emptyLabelText: 'Vuoto'
        },
        MuiAutocomplete: {
            clearText: 'Svuota',
            closeText: 'Chiudi',
            loadingText: "Caricamento in corso\u2026",
            noOptionsText: 'Nessuna opzione',
            openText: 'Apri'
        },
        MuiAlert: {
            closeText: 'Chiudi'
        },
        MuiPagination: {
            'aria-label': 'Navigazione impaginata',
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : 'Vai alla ', "pagina ").concat(page);
                if (type === 'first') return 'Vai alla prima pagina';
                if (type === 'last') return "Vai all'ultima pagina";
                if (type === 'next') return 'Vai alla pagina successiva';
                if (type === 'previous') return 'Vai alla pagina precedente';
                return undefined;
            }
        }
    }
};
module.exports.itIT = $2c51d170f1c5aad6$var$itIT;
var $2c51d170f1c5aad6$var$jaJP = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "\u524D\u306E\u30DA\u30FC\u30B8",
            labelRowsPerPage: "\u30DA\u30FC\u30B8\u3054\u3068\u306E\u884C:",
            labelDisplayedRows: function labelDisplayedRows(_ref18) {
                var from = _ref18.from, to = _ref18.to, count = _ref18.count;
                return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "\u6B21\u306E\u30DA\u30FC\u30B8"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " ").concat(value !== 1 ? "\u51FA\u6F14\u8005" : "\u661F");
            } // emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: "\u30AF\u30EA\u30A2",
            closeText: "\u9589\u3058\u308B",
            loadingText: "\u7A4D\u307F\u8FBC\u307F\u2026",
            noOptionsText: "\u7D50\u679C\u304C\u3042\u308A\u307E\u305B\u3093",
            openText: "\u958B\u3044\u305F"
        },
        MuiAlert: {
            closeText: "\u9589\u3058\u308B"
        } // MuiPagination: {
    }
};
module.exports.jaJP = $2c51d170f1c5aad6$var$jaJP;
var $2c51d170f1c5aad6$var$koKR = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "\uC774\uC804 \uD398\uC774\uC9C0",
            labelRowsPerPage: "\uD398\uC774\uC9C0 \uB2F9 \uD589:",
            labelDisplayedRows: function labelDisplayedRows(_ref19) {
                var from = _ref19.from, to = _ref19.to, count = _ref19.count;
                return "".concat(from, "-").concat(to, " / ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "\uB2E4\uC74C \uD398\uC774\uC9C0"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " \uC810");
            } // emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: "\uC9C0\uC6B0\uAE30",
            closeText: "\uB2EB\uAE30",
            loadingText: "\uBD88\uB7EC\uC624\uB294 \uC911\u2026",
            noOptionsText: "\uC635\uC158 \uC5C6\uC74C",
            openText: "\uC5F4\uAE30"
        }
    }
};
module.exports.koKR = $2c51d170f1c5aad6$var$koKR;
var $2c51d170f1c5aad6$var$nlNL = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: 'Vorige pagina',
            labelRowsPerPage: 'Regels per pagina :',
            labelDisplayedRows: function labelDisplayedRows(_ref20) {
                var from = _ref20.from, to = _ref20.to, count = _ref20.count;
                return "".concat(from, "-").concat(to, " van ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: 'Volgende pagina'
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Ster").concat(value !== 1 ? 'ren' : '');
            } // emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: 'Wissen',
            closeText: 'Sluiten',
            loadingText: "Laden\u2026",
            noOptionsText: 'Geen opties',
            openText: 'Openen'
        },
        MuiAlert: {
            closeText: 'Sluiten'
        } // MuiPagination: {
    }
};
module.exports.nlNL = $2c51d170f1c5aad6$var$nlNL;
var $2c51d170f1c5aad6$var$plPL = {
    props: {
        MuiBreadcrumbs: {
            expandText: "Poka\u017C \u015Bcie\u017Ck\u0119"
        },
        MuiTablePagination: {
            backIconButtonText: 'Poprzednia strona',
            labelRowsPerPage: "Wierszy na stron\u0119:",
            labelDisplayedRows: function labelDisplayedRows(_ref21) {
                var from = _ref21.from, to = _ref21.to, count = _ref21.count;
                return "".concat(from, "-").concat(to, " z ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "Nast\u0119pna strona"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                var pluralForm = 'gwiazdek';
                var lastDigit = value % 10;
                if ((value < 10 || value > 20) && lastDigit > 1 && lastDigit < 5) pluralForm = 'gwiazdki';
                else if (value === 1) pluralForm = 'gwiazdka';
                return "".concat(value, " ").concat(pluralForm);
            },
            emptyLabelText: 'Brak gwiazdek'
        },
        MuiAutocomplete: {
            clearText: "Wyczy\u015B\u0107",
            closeText: 'Zamknij',
            loadingText: "\u0141adowanie\u2026",
            noOptionsText: 'Brak opcji',
            openText: "Otw\xf3rz"
        },
        MuiAlert: {
            closeText: 'Zamknij'
        },
        MuiPagination: {
            'aria-label': "Nawigacja podzia\u0142u na strony",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return selected ? "".concat(page, ". strona") : "Przejd\u017A do ".concat(page, ". strony");
                if (type === 'first') return "Przejd\u017A do pierwszej strony";
                if (type === 'last') return "Przejd\u017A do ostatniej strony";
                if (type === 'next') return "Przejd\u017A do nast\u0119pnej strony";
                if (type === 'previous') return "Przejd\u017A do poprzedniej strony";
                return undefined;
            }
        }
    }
};
module.exports.plPL = $2c51d170f1c5aad6$var$plPL;
var $2c51d170f1c5aad6$var$ptBR = {
    props: {
        MuiBreadcrumbs: {
            expandText: 'Mostrar caminho'
        },
        MuiTablePagination: {
            backIconButtonText: "P\xe1gina anterior",
            labelRowsPerPage: "Linhas por p\xe1gina:",
            labelDisplayedRows: function labelDisplayedRows(_ref22) {
                var from = _ref22.from, to = _ref22.to, count = _ref22.count;
                return "".concat(from, "-").concat(to, " de ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "Pr\xf3xima p\xe1gina"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Estrela").concat(value !== 1 ? 's' : '');
            },
            emptyLabelText: 'Vazio'
        },
        MuiAutocomplete: {
            clearText: 'Limpar',
            closeText: 'Fechar',
            loadingText: "Carregando\u2026",
            noOptionsText: "Sem op\xe7\xf5es",
            openText: 'Abrir'
        },
        MuiAlert: {
            closeText: 'Fechar'
        },
        MuiPagination: {
            'aria-label': "Navegar pela pagina\xe7\xe3o",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : 'Ir para a ', "p\xE1gina ").concat(page);
                if (type === 'first') return "Ir para a primeira p\xe1gina";
                if (type === 'last') return "Ir para a \xfaltima p\xe1gina";
                if (type === 'next') return "Ir para a pr\xf3xima p\xe1gina";
                if (type === 'previous') return "Ir para a p\xe1gina anterior";
                return undefined;
            }
        }
    }
};
module.exports.ptBR = $2c51d170f1c5aad6$var$ptBR;
var $2c51d170f1c5aad6$var$ptPT = {
    props: {
        MuiBreadcrumbs: {
            expandText: 'Mostrar caminho'
        },
        MuiTablePagination: {
            backIconButtonText: "P\xe1gina anterior",
            labelRowsPerPage: "Linhas por p\xe1gina:",
            labelDisplayedRows: function labelDisplayedRows(_ref23) {
                var from = _ref23.from, to = _ref23.to, count = _ref23.count;
                return "".concat(from, "-").concat(to, " de ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "Pr\xf3xima p\xe1gina"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Estrela").concat(value !== 1 ? 's' : '');
            },
            emptyLabelText: 'Vazio'
        },
        MuiAutocomplete: {
            clearText: 'Limpar',
            closeText: 'Fechar',
            loadingText: "A carregar\u2026",
            noOptionsText: "Sem op\xe7\xf5es",
            openText: 'Abrir'
        },
        MuiAlert: {
            closeText: 'Fechar'
        },
        MuiPagination: {
            'aria-label': "Navegar por p\xe1ginas",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : 'Ir para a ', "p\xE1gina ").concat(page);
                if (type === 'first') return "Primeira p\xe1gina";
                if (type === 'last') return "\xdaltima p\xe1gina";
                if (type === 'next') return "Pr\xf3xima p\xe1gina";
                if (type === 'previous') return "P\xe1gina anterior";
                return undefined;
            }
        }
    }
};
module.exports.ptPT = $2c51d170f1c5aad6$var$ptPT;
var $2c51d170f1c5aad6$var$roRO = {
    props: {
        MuiBreadcrumbs: {
            expandText: "Arat\u0103 calea"
        },
        MuiTablePagination: {
            backIconButtonText: "Pagina precedent\u0103",
            labelRowsPerPage: "R\xe2nduri pe pagin\u0103:",
            labelDisplayedRows: function labelDisplayedRows(_ref24) {
                var from = _ref24.from, to = _ref24.to, count = _ref24.count;
                return "".concat(from, "-").concat(to, " din ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "Pagina urm\u0103toare"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " St").concat(value !== 1 ? 'ele' : 'ea');
            },
            emptyLabelText: 'Gol'
        },
        MuiAutocomplete: {
            clearText: "\u0218terge",
            closeText: "\xcenchide",
            loadingText: "Se \xeencarc\u0103\u2026",
            noOptionsText: "Nicio op\u021Biune",
            openText: 'Deschide'
        },
        MuiAlert: {
            closeText: "\xcenchide"
        },
        MuiPagination: {
            'aria-label': 'Navigare prin paginare',
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : 'Mergi la ', "pagina ").concat(page);
                if (type === 'first') return "Mergi la prima pagin\u0103";
                if (type === 'last') return "Mergi la ultima pagin\u0103";
                if (type === 'next') return "Mergi la pagina urm\u0103toare";
                if (type === 'previous') return "Mergi la pagina precedent\u0103";
                return undefined;
            }
        }
    }
};
module.exports.roRO = $2c51d170f1c5aad6$var$roRO;
var $2c51d170f1c5aad6$var$ruRU = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
            labelRowsPerPage: "\u0421\u0442\u0440\u043E\u043A \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435:",
            labelDisplayedRows: function labelDisplayedRows(_ref25) {
                var from = _ref25.from, to = _ref25.to, count = _ref25.count;
                return "".concat(from, "-").concat(to, " \u0438\u0437 ").concat(count !== -1 ? count : "\u0431\u043E\u043B\u0435\u0435 \u0447\u0435\u043C ".concat(to));
            },
            nextIconButtonText: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                var pluralForm = "\u0417\u0432\u0451\u0437\u0434";
                var lastDigit = value % 10;
                if (lastDigit > 1 && lastDigit < 5) pluralForm = "\u0417\u0432\u0435\u0437\u0434\u044B";
                else if (lastDigit === 1) pluralForm = "\u0417\u0432\u0435\u0437\u0434\u0430";
                return "".concat(value, " ").concat(pluralForm);
            } // emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
            closeText: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
            loadingText: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
            noOptionsText: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432",
            openText: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C"
        },
        MuiAlert: {
            closeText: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
        } // MuiPagination: {
    }
};
module.exports.ruRU = $2c51d170f1c5aad6$var$ruRU;
var $2c51d170f1c5aad6$var$skSK = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "Predch\xe1dzaj\xfaca str\xe1nka",
            labelRowsPerPage: "Riadkov na str\xe1nke:",
            labelDisplayedRows: function labelDisplayedRows(_ref26) {
                var from = _ref26.from, to = _ref26.to, count = _ref26.count;
                return "".concat(from, "-").concat(to, " z ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "\u010Eal\u0161ia str\xe1nka"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                if (value === 1) return "".concat(value, " hviezdi\u010Dka");
                if (value >= 2 && value <= 4) return "".concat(value, " hviezdi\u010Dky");
                return "".concat(value, " hviezdi\u010Diek");
            } // emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: "Vymaza\u0165",
            closeText: "Zavrie\u0165",
            loadingText: "Na\u010D\xedtanie\u2026",
            noOptionsText: "\u017Diadne mo\u017Enosti",
            openText: "Otvori\u0165"
        },
        MuiAlert: {
            closeText: "Zavrie\u0165"
        } // MuiPagination: {
    }
};
module.exports.skSK = $2c51d170f1c5aad6$var$skSK;
var $2c51d170f1c5aad6$var$svSE = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "F\xf6reg\xe5ende sida",
            labelRowsPerPage: 'Rader per sida:',
            labelDisplayedRows: function labelDisplayedRows(_ref27) {
                var from = _ref27.from, to = _ref27.to, count = _ref27.count;
                return "".concat(from, "-").concat(to, " av ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: "N\xe4sta sida"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " ").concat(value !== 1 ? "Stj\xe4rnor" : "Stj\xe4rna");
            } // emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: 'Rensa',
            closeText: "St\xe4ng",
            loadingText: "Laddar\u2026",
            noOptionsText: 'Inga alternativ',
            openText: "\xd6ppen"
        },
        MuiAlert: {
            closeText: "St\xe4ng"
        } // MuiPagination: {
    }
};
module.exports.svSE = $2c51d170f1c5aad6$var$svSE;
var $2c51d170f1c5aad6$var$trTR = {
    props: {
        MuiBreadcrumbs: {
            expandText: "Yolu g\xf6ster"
        },
        MuiTablePagination: {
            backIconButtonText: "\xd6nceki sayfa",
            labelRowsPerPage: "Sayfa ba\u015F\u0131na sat\u0131r:",
            labelDisplayedRows: function labelDisplayedRows(_ref28) {
                var from = _ref28.from, to = _ref28.to, count = _ref28.count;
                return "".concat(from, "-").concat(to, " tanesinden ").concat(count !== -1 ? count : "more than ".concat(to));
            },
            nextIconButtonText: 'Sonraki sayfa'
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " Y\u0131ld\u0131z");
            },
            emptyLabelText: "Bo\u015F"
        },
        MuiAutocomplete: {
            clearText: 'Temizle',
            closeText: 'Kapat',
            loadingText: "Y\xfckleniyor\u2026",
            noOptionsText: "Se\xe7enek yok",
            openText: "A\xe7"
        },
        MuiAlert: {
            closeText: 'Kapat'
        },
        MuiPagination: {
            'aria-label': 'Sayfa navigasyonu',
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(page, ". ").concat(selected ? 'sayfa' : 'sayfaya git');
                if (type === 'first') return "\u0130lk sayfaya git";
                if (type === 'last') return 'Son sayfaya git';
                if (type === 'next') return 'Sonraki sayfaya git';
                if (type === 'previous') return "\xd6nceki sayfaya git";
                return undefined;
            }
        }
    }
};
module.exports.trTR = $2c51d170f1c5aad6$var$trTR;
var $2c51d170f1c5aad6$var$ukUA = {
    props: {
        MuiBreadcrumbs: {
            expandText: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0448\u043B\u044F\u0445 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A"
        },
        MuiTablePagination: {
            backIconButtonText: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430",
            labelRowsPerPage: "\u0420\u044F\u0434\u043A\u0456\u0432 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456:",
            labelDisplayedRows: function labelDisplayedRows(_ref29) {
                var from = _ref29.from, to = _ref29.to, count = _ref29.count;
                return "".concat(from, "-").concat(to, " \u0437 ").concat(count !== -1 ? count : "\u043F\u043E\u043D\u0430\u0434 ".concat(to));
            },
            nextIconButtonText: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                var pluralForm = "\u0417\u0456\u0440\u043E\u043A";
                var lastDigit = value % 10;
                if (lastDigit > 1 && lastDigit < 5) pluralForm = "\u0417\u0456\u0440\u043A\u0438";
                else if (lastDigit === 1) pluralForm = "\u0417\u0456\u0440\u043A\u0430";
                return "".concat(value, " ").concat(pluralForm);
            },
            emptyLabelText: "\u0420\u0435\u0439\u0442\u0438\u043D\u0433 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439"
        },
        MuiAutocomplete: {
            clearText: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
            closeText: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
            loadingText: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
            noOptionsText: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u0456\u0432",
            openText: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438"
        },
        MuiAlert: {
            closeText: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438"
        },
        MuiPagination: {
            'aria-label': "\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u043C\u0438",
            getItemAriaLabel: function getItemAriaLabel(type, page, selected) {
                if (type === 'page') return "".concat(selected ? '' : "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 ", "\u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 ").concat(page);
                if (type === 'first') return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u0435\u0440\u0448\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                if (type === 'last') return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043E\u0441\u0442\u0430\u043D\u043D\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                if (type === 'next') return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                if (type === 'previous') return "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443";
                return undefined;
            }
        }
    }
};
module.exports.ukUA = $2c51d170f1c5aad6$var$ukUA;
var $2c51d170f1c5aad6$var$viVN = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "Trang tr\u01B0\u1EDBc",
            labelRowsPerPage: "S\u1ED1 h\xe0ng m\u1ED7i trang:",
            labelDisplayedRows: function labelDisplayedRows(_ref30) {
                var from = _ref30.from, to = _ref30.to, count = _ref30.count;
                return "".concat(from, "-").concat(to, " trong ").concat(count !== -1 ? count : "nhi\u1EC1u h\u01A1n ".concat(to));
            },
            nextIconButtonText: 'Trang sau'
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " sao");
            },
            emptyLabelText: "Tr\u1ED1ng"
        },
        MuiAutocomplete: {
            clearText: "X\xf3a",
            closeText: "\u0110\xf3ng",
            loadingText: "\u0110ang t\u1EA3i\u2026",
            noOptionsText: "Kh\xf4ng c\xf3 l\u1EF1a ch\u1ECDn",
            openText: "M\u1EDF"
        },
        MuiAlert: {
            closeText: "\u0110\xf3ng"
        } // MuiPagination: {
    }
};
module.exports.viVN = $2c51d170f1c5aad6$var$viVN;
var $2c51d170f1c5aad6$var$zhCN = {
    props: {
        // MuiBreadcrumbs: {
        //   expandText: 'Show path',
        // },
        MuiTablePagination: {
            backIconButtonText: "\u4E0A\u4E00\u9875",
            labelRowsPerPage: "\u6BCF\u9875\u884C\u6570:",
            labelDisplayedRows: function labelDisplayedRows(_ref31) {
                var from = _ref31.from, to = _ref31.to, count = _ref31.count;
                return "".concat(from, "-").concat(to, " \u7684 ").concat(count !== -1 ? count : "\u8D85\u8FC7 ".concat(to));
            },
            nextIconButtonText: "\u4E0B\u4E00\u9875"
        },
        MuiRating: {
            getLabelText: function getLabelText(value) {
                return "".concat(value, " \u661F").concat(value !== 1 ? "\u661F" : '');
            } // emptyLabelText: 'Empty',
        },
        MuiAutocomplete: {
            clearText: "\u660E\u786E",
            closeText: "\u5173",
            loadingText: "\u8F7D\u5165\u4E2D\u2026",
            noOptionsText: "\u6CA1\u6709\u9009\u62E9",
            openText: "\u6253\u5F00"
        },
        MuiAlert: {
            closeText: "\u5173"
        } // MuiPagination: {
    }
};
module.exports.zhCN = $2c51d170f1c5aad6$var$zhCN;

});

parcelRegister("4BA58", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35a69b3a140ef678$export$2e2bcd8739ae039; });
function $35a69b3a140ef678$export$2e2bcd8739ae039(propType1, propType2) {
    return ()=>null;
}

});


var $2c943532c5a390a9$exports = {};
$parcel$extendImportMap({
    "g6uqV": "logo.72650e1a.png",
    "iaQtK": "loginBackground.22cc3b54.png"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));


parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $fa3c487c4b27a9d1$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
var $fa3c487c4b27a9d1$export$2e2bcd8739ae039 = $fa3c487c4b27a9d1$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $147b54102b881a3c$var$defaultNoopBatch(callback) {
    callback();
}
var $147b54102b881a3c$var$batch = $147b54102b881a3c$var$defaultNoopBatch; // Allow injecting another batching function later
var $147b54102b881a3c$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $147b54102b881a3c$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $147b54102b881a3c$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $147b54102b881a3c$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $5c0c0e9f3b5cd1de$var$createListenerCollection() {
    var batch = (0, $147b54102b881a3c$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $5c0c0e9f3b5cd1de$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $5c0c0e9f3b5cd1de$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $5c0c0e9f3b5cd1de$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $5c0c0e9f3b5cd1de$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $5c0c0e9f3b5cd1de$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $7fPBF = parcelRequire("7fPBF");
var $18a1784061377be5$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);


function $4c848518e85f237d$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $7fPBF.useMemo)(function() {
        var subscription = (0, $5c0c0e9f3b5cd1de$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $7fPBF.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $18a1784061377be5$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $4c848518e85f237d$export$2e2bcd8739ae039 = $4c848518e85f237d$var$Provider;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $8Ae2G = parcelRequire("8Ae2G");

var $7fPBF = parcelRequire("7fPBF");

var $j2VHG = parcelRequire("j2VHG");



var $93474d6295d06f0d$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $93474d6295d06f0d$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $93474d6295d06f0d$var$EMPTY_ARRAY = [];
var $93474d6295d06f0d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $93474d6295d06f0d$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $93474d6295d06f0d$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $93474d6295d06f0d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $18a1784061377be5$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $93474d6295d06f0d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $93474d6295d06f0d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $93474d6295d06f0d$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $93474d6295d06f0d$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $cFLic.default)(_ref2, $93474d6295d06f0d$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $kY3Ke.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $7fPBF.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $7fPBF.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $cFLic.default)(props, $93474d6295d06f0d$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $7fPBF.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $j2VHG.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $7fPBF.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $7fPBF.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $7fPBF.useMemo)(function() {
                if (!shouldHandleStateChanges) return $93474d6295d06f0d$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $5c0c0e9f3b5cd1de$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $7fPBF.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kY3Ke.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $7fPBF.useReducer)($93474d6295d06f0d$var$storeStateUpdatesReducer, $93474d6295d06f0d$var$EMPTY_ARRAY, $93474d6295d06f0d$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $7fPBF.useRef)();
            var lastWrapperProps = (0, $7fPBF.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $7fPBF.useRef)();
            var renderIsScheduled = (0, $7fPBF.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $93474d6295d06f0d$var$useIsomorphicLayoutEffectWithArgs($93474d6295d06f0d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $93474d6295d06f0d$var$useIsomorphicLayoutEffectWithArgs($93474d6295d06f0d$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $7fPBF.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, (0, $kY3Ke.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $7fPBF.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Connect, (0, $kY3Ke.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(Connect, WrappedComponent);
    };
}




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

function $3b08520b369c7e04$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $3b08520b369c7e04$export$2e2bcd8739ae039(objA, objB) {
    if ($3b08520b369c7e04$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$3b08520b369c7e04$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $c5241bafb2d740a2$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ea00bd81b65af2c1$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $0cc3d3c991995d47$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $70dd520dd4a0a28d$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $ea00bd81b65af2c1$export$2e2bcd8739ae039)(value)) (0, $0cc3d3c991995d47$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $ba16cca5bcca8350$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $ba16cca5bcca8350$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $ba16cca5bcca8350$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $ba16cca5bcca8350$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $ba16cca5bcca8350$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $ebb95f59f9a03d77$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $ba16cca5bcca8350$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $ebb95f59f9a03d77$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $ba16cca5bcca8350$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $ebb95f59f9a03d77$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $ba16cca5bcca8350$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $c5241bafb2d740a2$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $ebb95f59f9a03d77$export$2e2bcd8739ae039 = [
    $ebb95f59f9a03d77$export$a9f27b4b187c1166,
    $ebb95f59f9a03d77$export$ba20d1a7aa0c4a90,
    $ebb95f59f9a03d77$export$94a6e55709d4d961
];



function $4f0cafcf2cdd26e7$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $ba16cca5bcca8350$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $4f0cafcf2cdd26e7$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $ba16cca5bcca8350$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $4f0cafcf2cdd26e7$export$2e2bcd8739ae039 = [
    $4f0cafcf2cdd26e7$export$23fc470827b14aa,
    $4f0cafcf2cdd26e7$export$514bc8c1a53c1d66
];



var $kY3Ke = parcelRequire("kY3Ke");

function $37149b3dce38b811$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $kY3Ke.default)({}, ownProps, stateProps, dispatchProps);
}
function $37149b3dce38b811$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $37149b3dce38b811$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $37149b3dce38b811$export$5b105939c84b5234(mergeProps) : undefined;
}
function $37149b3dce38b811$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $37149b3dce38b811$export$691c327fc30bc857;
    } : undefined;
}
var $37149b3dce38b811$export$2e2bcd8739ae039 = [
    $37149b3dce38b811$export$d61b680184bc3f00,
    $37149b3dce38b811$export$a13ba70ef50dda6d
];



var $cFLic = parcelRequire("cFLic");

function $8c6c3df6a794a93c$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $0cc3d3c991995d47$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $8c6c3df6a794a93c$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $8c6c3df6a794a93c$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $8c6c3df6a794a93c$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $8c6c3df6a794a93c$var$verify(mergeProps, 'mergeProps', displayName);
}


var $50fa2eeb6771037b$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $50fa2eeb6771037b$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $50fa2eeb6771037b$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $50fa2eeb6771037b$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $cFLic.default)(_ref2, $50fa2eeb6771037b$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $50fa2eeb6771037b$export$d20c0c2ca6eb2b6f : $50fa2eeb6771037b$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $dfae31f1b650765c$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $dfae31f1b650765c$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $dfae31f1b650765c$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $dfae31f1b650765c$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $93474d6295d06f0d$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $4f0cafcf2cdd26e7$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $ebb95f59f9a03d77$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $37149b3dce38b811$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $50fa2eeb6771037b$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $dfae31f1b650765c$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $3b08520b369c7e04$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $3b08520b369c7e04$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $3b08520b369c7e04$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $cFLic.default)(_ref3, $dfae31f1b650765c$var$_excluded);
        var initMapStateToProps = $dfae31f1b650765c$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $dfae31f1b650765c$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $dfae31f1b650765c$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $kY3Ke.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $dfae31f1b650765c$export$2e2bcd8739ae039 = /*#__PURE__*/ $dfae31f1b650765c$export$9f9feb656dec1fc4();




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

function $544fc39e75452adc$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $7fPBF.useContext)((0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00));
    return contextValue;
}


function $65c1702f92c91515$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00) ? (0, $544fc39e75452adc$export$c1275ca9a6fd3ec5) : function() {
        return (0, $7fPBF.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $65c1702f92c91515$export$6ccbb43953eebf8 = /*#__PURE__*/ $65c1702f92c91515$export$671dba69185d0304();


function $0503a2a6eb4cf13a$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00);
    var useStore = context === (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00) ? (0, $65c1702f92c91515$export$6ccbb43953eebf8) : (0, $65c1702f92c91515$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $0503a2a6eb4cf13a$export$8ad76b76a4c905f8 = /*#__PURE__*/ $0503a2a6eb4cf13a$export$bc9b55530897c558();



var $7fPBF = parcelRequire("7fPBF");




var $51238fa605392ada$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $51238fa605392ada$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $7fPBF.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $7fPBF.useMemo)(function() {
        return (0, $5c0c0e9f3b5cd1de$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $7fPBF.useRef)();
    var latestSelector = (0, $7fPBF.useRef)();
    var latestStoreState = (0, $7fPBF.useRef)();
    var latestSelectedState = (0, $7fPBF.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $18a1784061377be5$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $18a1784061377be5$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $51238fa605392ada$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00) ? (0, $544fc39e75452adc$export$c1275ca9a6fd3ec5) : function() {
        return (0, $7fPBF.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $51238fa605392ada$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $51238fa605392ada$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $7fPBF.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $51238fa605392ada$export$2105062e25df4afe = /*#__PURE__*/ $51238fa605392ada$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 
var $fw0lo = parcelRequire("fw0lo");


var $fw0lo = parcelRequire("fw0lo");

// with standard React renderers (ReactDOM, React Native)
(0, $147b54102b881a3c$export$4b9874722d0da7bc)((0, $fw0lo.unstable_batchedUpdates));



var $baumZ = parcelRequire("baumZ");

var $juaRV = parcelRequire("juaRV");

var $k03mY = parcelRequire("k03mY");


var $6TO5S = parcelRequire("6TO5S");

var $dQMrF = parcelRequire("dQMrF");
function $fc98856cecf121dd$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            (0, $dQMrF.default)(e, r, t[r]);
        });
    }
    return e;
}



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $6TO5S = parcelRequire("6TO5S");

var $3zeAJ = parcelRequire("3zeAJ");
function $690e545d5a200a90$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $6TO5S.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3zeAJ.default)(t);
}


function $b48febf76cf3d138$export$2e2bcd8739ae039(t) {
    return $b48febf76cf3d138$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $b48febf76cf3d138$export$2e2bcd8739ae039(t);
}



var $3zeAJ = parcelRequire("3zeAJ");

var $iJeDO = parcelRequire("iJeDO");
function $5236ac5195402c05$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $iJeDO.default)(t, e);
}


var $1e580fbd50c9e2d3$var$consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $1e580fbd50c9e2d3$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $03dWn.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $4OFm0.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || $1e580fbd50c9e2d3$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $1e580fbd50c9e2d3$var$baseLogger = new $1e580fbd50c9e2d3$var$Logger();
var $1e580fbd50c9e2d3$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $03dWn.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $4OFm0.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $1e580fbd50c9e2d3$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $1e580fbd50c9e2d3$var$makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function $1e580fbd50c9e2d3$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $1e580fbd50c9e2d3$var$setPath(object, path, newValue) {
    var _getLastOfPath = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $1e580fbd50c9e2d3$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $1e580fbd50c9e2d3$var$getPath(object, path) {
    var _getLastOfPath3 = $1e580fbd50c9e2d3$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $1e580fbd50c9e2d3$var$getPathWithDefaults(data, defaultData, key) {
    var value = $1e580fbd50c9e2d3$var$getPath(data, key);
    if (value !== undefined) return value;
    return $1e580fbd50c9e2d3$var$getPath(defaultData, key);
}
function $1e580fbd50c9e2d3$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $1e580fbd50c9e2d3$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $1e580fbd50c9e2d3$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var $1e580fbd50c9e2d3$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function $1e580fbd50c9e2d3$var$escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return $1e580fbd50c9e2d3$var$_entityMap[s];
    });
    return data;
}
var $1e580fbd50c9e2d3$var$isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var $1e580fbd50c9e2d3$var$ResourceStore = function(_EventEmitter) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $03dWn.default)(this, ResourceStore);
        _this = (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(ResourceStore).call(this));
        if ($1e580fbd50c9e2d3$var$isIE10) $1e580fbd50c9e2d3$var$EventEmitter.call((0, $3zeAJ.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        return _this;
    }
    (0, $4OFm0.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                return $1e580fbd50c9e2d3$var$getPath(this.data, path);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = '.';
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $1e580fbd50c9e2d3$var$setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $1e580fbd50c9e2d3$var$getPath(this.data, path) || {};
                if (deep) $1e580fbd50c9e2d3$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, pack, resources);
                $1e580fbd50c9e2d3$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($1e580fbd50c9e2d3$var$EventEmitter);
var $1e580fbd50c9e2d3$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $1e580fbd50c9e2d3$var$checkedLoadedFor = {};
var $1e580fbd50c9e2d3$var$Translator = function(_EventEmitter) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $03dWn.default)(this, Translator);
        _this = (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(Translator).call(this));
        if ($1e580fbd50c9e2d3$var$isIE10) $1e580fbd50c9e2d3$var$EventEmitter.call((0, $3zeAJ.default)(_this));
        $1e580fbd50c9e2d3$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $3zeAJ.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('translator');
        return _this;
    }
    (0, $4OFm0.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $6TO5S.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, options, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, fallbackValue) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init((0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, options, {
                        interpolation: (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $1e580fbd50c9e2d3$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$1e580fbd50c9e2d3$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $1e580fbd50c9e2d3$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($1e580fbd50c9e2d3$var$EventEmitter);
function $1e580fbd50c9e2d3$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $1e580fbd50c9e2d3$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $03dWn.default)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.supportedLngs || false;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('languageUtils');
    }
    (0, $4OFm0.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $1e580fbd50c9e2d3$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $1e580fbd50c9e2d3$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $1e580fbd50c9e2d3$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
                return this.isSupportedCode(code);
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $1e580fbd50c9e2d3$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'kk',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $1e580fbd50c9e2d3$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
function $1e580fbd50c9e2d3$var$createRules() {
    var rules = {};
    $1e580fbd50c9e2d3$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $1e580fbd50c9e2d3$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $1e580fbd50c9e2d3$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $03dWn.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('pluralResolver');
        this.rules = $1e580fbd50c9e2d3$var$createRules();
    }
    (0, $4OFm0.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                return this.getSuffixes(code).map(function(suffix) {
                    return key + suffix;
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var rule = this.getRule(code);
                if (!rule) return [];
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx];
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = 'plural';
                        else if (suffix === 1) suffix = '';
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    };
                    if (this.options.compatibilityJSON === 'v1') {
                        if (suffix === 1) return '';
                        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                    else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        }
    ]);
    return PluralResolver;
}();
var $1e580fbd50c9e2d3$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $03dWn.default)(this, Interpolator);
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $4OFm0.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $1e580fbd50c9e2d3$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $1e580fbd50c9e2d3$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? $1e580fbd50c9e2d3$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? $1e580fbd50c9e2d3$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $1e580fbd50c9e2d3$var$regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? $1e580fbd50c9e2d3$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $1e580fbd50c9e2d3$var$regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $1e580fbd50c9e2d3$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($1e580fbd50c9e2d3$var$getPathWithDefaults(data, defaultData, k), f, lng, options);
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        value = handleFormat(match[1].trim());
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = $1e580fbd50c9e2d3$var$makeString(value);
                        str = str.replace(match[0], todo.safeValue(value));
                        todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = $1e580fbd50c9e2d3$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, options);
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $1e580fbd50c9e2d3$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $1e580fbd50c9e2d3$var$Connector = function(_EventEmitter) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $03dWn.default)(this, Connector);
        _this = (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(Connector).call(this));
        if ($1e580fbd50c9e2d3$var$isIE10) $1e580fbd50c9e2d3$var$EventEmitter.call((0, $3zeAJ.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $1e580fbd50c9e2d3$var$baseLogger.create('backendConnector');
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $4OFm0.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $1e580fbd50c9e2d3$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $1e580fbd50c9e2d3$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, options, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($1e580fbd50c9e2d3$var$EventEmitter);
function $1e580fbd50c9e2d3$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        whitelist: false,
        nonExplicitWhitelist: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $6TO5S.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $6TO5S.default)(args[2]) === 'object' || (0, $6TO5S.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: false
        }
    };
}
function $1e580fbd50c9e2d3$var$transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.whitelist) {
        if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist = options.whitelist.concat([
            'cimode'
        ]);
        options.supportedLngs = options.whitelist;
    }
    if (options.nonExplicitWhitelist) options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function $1e580fbd50c9e2d3$var$noop() {}
var $1e580fbd50c9e2d3$var$I18n = function(_EventEmitter) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $03dWn.default)(this, I18n);
        _this = (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(I18n).call(this));
        if ($1e580fbd50c9e2d3$var$isIE10) $1e580fbd50c9e2d3$var$EventEmitter.call((0, $3zeAJ.default)(_this));
        _this.options = $1e580fbd50c9e2d3$var$transformOptions(options);
        _this.services = {};
        _this.logger = $1e580fbd50c9e2d3$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $690e545d5a200a90$export$2e2bcd8739ae039)(_this, (0, $3zeAJ.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $4OFm0.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (options.whitelist && !options.supportedLngs) this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
                if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
                this.options = (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, $1e580fbd50c9e2d3$var$get(), this.options, $1e580fbd50c9e2d3$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $1e580fbd50c9e2d3$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $1e580fbd50c9e2d3$var$baseLogger.init(null, this.options);
                    var lu = new $1e580fbd50c9e2d3$var$LanguageUtil(this.options);
                    this.store = new $1e580fbd50c9e2d3$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $1e580fbd50c9e2d3$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $1e580fbd50c9e2d3$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $1e580fbd50c9e2d3$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $1e580fbd50c9e2d3$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $1e580fbd50c9e2d3$var$Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $1e580fbd50c9e2d3$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1e580fbd50c9e2d3$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $1e580fbd50c9e2d3$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') $1e580fbd50c9e2d3$var$postProcessor.addPostProcessor(module);
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $1e580fbd50c9e2d3$var$defer();
                this.emit('languageChanging', lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $6TO5S.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    return _this5.t(key, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $1e580fbd50c9e2d3$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $1e580fbd50c9e2d3$var$defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam'
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1e580fbd50c9e2d3$var$noop;
                var mergedOptions = (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = (0, $fc98856cecf121dd$export$2e2bcd8739ae039)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $1e580fbd50c9e2d3$var$Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        }
    ]);
    return I18n;
}($1e580fbd50c9e2d3$var$EventEmitter);
var $1e580fbd50c9e2d3$var$i18next = new $1e580fbd50c9e2d3$var$I18n();
var $1e580fbd50c9e2d3$export$2e2bcd8739ae039 = $1e580fbd50c9e2d3$var$i18next;


function $5e94ee2b5c33482b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5e94ee2b5c33482b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5e94ee2b5c33482b$var$_typeof(obj);
}
var $5e94ee2b5c33482b$var$arr = [];
var $5e94ee2b5c33482b$var$each = $5e94ee2b5c33482b$var$arr.forEach;
var $5e94ee2b5c33482b$var$slice = $5e94ee2b5c33482b$var$arr.slice;
function $5e94ee2b5c33482b$export$ebe90cb607ad99e(obj) {
    $5e94ee2b5c33482b$var$each.call($5e94ee2b5c33482b$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $5e94ee2b5c33482b$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $5e94ee2b5c33482b$var$_typeof(XMLHttpRequest)) === 'object';
}
function $5e94ee2b5c33482b$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $5e94ee2b5c33482b$export$1625492ec82002b9(maybePromise) {
    if ($5e94ee2b5c33482b$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



var $8ac3c7fe865e4864$exports = {};
var $8ac3c7fe865e4864$var$fetchApi;
if (typeof fetch === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $8ac3c7fe865e4864$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== 'undefined' && window.fetch) $8ac3c7fe865e4864$var$fetchApi = window.fetch;
    else $8ac3c7fe865e4864$var$fetchApi = fetch;
}

if (typeof window === 'undefined' || typeof window.document === 'undefined') {
    var $8ac3c7fe865e4864$var$f = $8ac3c7fe865e4864$var$fetchApi || (parcelRequire("fVMg8"));
    if ($8ac3c7fe865e4864$var$f.default) $8ac3c7fe865e4864$var$f = $8ac3c7fe865e4864$var$f.default;
    $8ac3c7fe865e4864$exports.default = $8ac3c7fe865e4864$var$f;
    $8ac3c7fe865e4864$exports = $8ac3c7fe865e4864$exports.default;
}


function $115a9e8b8151a003$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $115a9e8b8151a003$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $115a9e8b8151a003$var$_typeof(obj);
}
var $115a9e8b8151a003$var$fetchApi;
if (typeof fetch === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $115a9e8b8151a003$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== 'undefined' && window.fetch) $115a9e8b8151a003$var$fetchApi = window.fetch;
    else $115a9e8b8151a003$var$fetchApi = fetch;
}
var $115a9e8b8151a003$var$XmlHttpRequestApi;
if ((0, $5e94ee2b5c33482b$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $115a9e8b8151a003$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$115a9e8b8151a003$var$fetchApi && $8ac3c7fe865e4864$exports && !$115a9e8b8151a003$var$XmlHttpRequestApi && !$115a9e8b8151a003$var$ActiveXObjectApi) $115a9e8b8151a003$var$fetchApi = $8ac3c7fe865e4864$exports.default || $8ac3c7fe865e4864$exports;
if (typeof $115a9e8b8151a003$var$fetchApi !== 'function') $115a9e8b8151a003$var$fetchApi = undefined;
var $115a9e8b8151a003$var$addQueryString = function addQueryString(url, params) {
    if (params && $115a9e8b8151a003$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $115a9e8b8151a003$var$fetchIt = function fetchIt(url, fetchOptions, callback) {
    $115a9e8b8151a003$var$fetchApi(url, fetchOptions).then(function(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    }).catch(callback);
};
var $115a9e8b8151a003$var$omitFetchOptions = false;
var $115a9e8b8151a003$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    var headers = (0, $5e94ee2b5c33482b$export$ebe90cb607ad99e)({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = (0, $5e94ee2b5c33482b$export$ebe90cb607ad99e)({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $115a9e8b8151a003$var$omitFetchOptions ? {} : reqOptions);
    try {
        $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback);
            $115a9e8b8151a003$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $115a9e8b8151a003$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $115a9e8b8151a003$var$_typeof(payload) === 'object') payload = $115a9e8b8151a003$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($115a9e8b8151a003$var$XmlHttpRequestApi) x = new $115a9e8b8151a003$var$XmlHttpRequestApi();
        else x = new $115a9e8b8151a003$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $115a9e8b8151a003$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($115a9e8b8151a003$var$fetchApi) return $115a9e8b8151a003$var$requestWithFetch(options, url, payload, callback);
    if ((0, $5e94ee2b5c33482b$export$87022daa49baf612)() || typeof ActiveXObject === 'function') return $115a9e8b8151a003$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $115a9e8b8151a003$export$2e2bcd8739ae039 = $115a9e8b8151a003$var$request;


function $fcb831e2a23edeea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fcb831e2a23edeea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fcb831e2a23edeea$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fcb831e2a23edeea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcb831e2a23edeea$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fcb831e2a23edeea$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $fcb831e2a23edeea$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        allowMultiLoading: false,
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $fcb831e2a23edeea$var$_defineProperty({}, key, fallbackValue || '');
        },
        request: (0, $115a9e8b8151a003$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $fcb831e2a23edeea$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $fcb831e2a23edeea$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    $fcb831e2a23edeea$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = (0, $5e94ee2b5c33482b$export$ebe90cb607ad99e)(options, this.options || {}, $fcb831e2a23edeea$var$getDefaults());
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $5e94ee2b5c33482b$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                this.options.request(this.options, url, undefined, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message && err.message.indexOf('Failed to fetch') > -1) return callback('failed loading ' + url + ': ' + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (callback) callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$fcb831e2a23edeea$var$Backend.type = 'backend';
var $fcb831e2a23edeea$export$2e2bcd8739ae039 = $fcb831e2a23edeea$var$Backend;


var $9db39a503775575c$exports = {};
function $9db39a503775575c$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$9db39a503775575c$exports = $9db39a503775575c$var$_classCallCheck, $9db39a503775575c$exports.__esModule = true, $9db39a503775575c$exports["default"] = $9db39a503775575c$exports;


var $4d1d8bace1bc5f55$exports = {};

var $jHo6y = parcelRequire("jHo6y");
function $4d1d8bace1bc5f55$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $jHo6y(o.key), o);
    }
}
function $4d1d8bace1bc5f55$var$_createClass(e, r, t) {
    return r && $4d1d8bace1bc5f55$var$_defineProperties(e.prototype, r), t && $4d1d8bace1bc5f55$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$4d1d8bace1bc5f55$exports = $4d1d8bace1bc5f55$var$_createClass, $4d1d8bace1bc5f55$exports.__esModule = true, $4d1d8bace1bc5f55$exports["default"] = $4d1d8bace1bc5f55$exports;



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
var $dbc236e0ae4b1bc0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $dbc236e0ae4b1bc0$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var $dbc236e0ae4b1bc0$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $dbc236e0ae4b1bc0$var$htmlEntities[m];
};
var $dbc236e0ae4b1bc0$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($dbc236e0ae4b1bc0$var$matchHtmlEntity, $dbc236e0ae4b1bc0$var$unescapeHtmlEntity);
};


function $021c8539c0651064$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $021c8539c0651064$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $021c8539c0651064$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $021c8539c0651064$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $021c8539c0651064$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, $dbc236e0ae4b1bc0$export$e8bacd2802a88316)
};
var $021c8539c0651064$var$i18nInstance;
var $021c8539c0651064$export$5603ab5ced17ce64 = (0, $7fPBF.createContext)();
function $021c8539c0651064$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $021c8539c0651064$var$defaultOptions = $021c8539c0651064$var$_objectSpread($021c8539c0651064$var$_objectSpread({}, $021c8539c0651064$var$defaultOptions), options);
}
function $021c8539c0651064$export$212bb2fc580a90a8() {
    return $021c8539c0651064$var$defaultOptions;
}
var $021c8539c0651064$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9db39a503775575c$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4d1d8bace1bc5f55$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $021c8539c0651064$export$a039134f2fc7e0(instance) {
    $021c8539c0651064$var$i18nInstance = instance;
}
function $021c8539c0651064$export$64af334f494c2f47() {
    return $021c8539c0651064$var$i18nInstance;
}
var $021c8539c0651064$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        $021c8539c0651064$export$2e2366488d12e20d(instance.options.react);
        $021c8539c0651064$export$a039134f2fc7e0(instance);
    }
};
function $021c8539c0651064$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $021c8539c0651064$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($021c8539c0651064$var$_objectSpread($021c8539c0651064$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $021c8539c0651064$export$704200e5d0b9e8f() {
    var i18n = $021c8539c0651064$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");
var $f73f86de2138df56$var$arr = [];
var $f73f86de2138df56$var$each = $f73f86de2138df56$var$arr.forEach;
var $f73f86de2138df56$var$slice = $f73f86de2138df56$var$arr.slice;
function $f73f86de2138df56$var$defaults(obj) {
    $f73f86de2138df56$var$each.call($f73f86de2138df56$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $f73f86de2138df56$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $f73f86de2138df56$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var $f73f86de2138df56$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $f73f86de2138df56$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var $f73f86de2138df56$var$cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = $f73f86de2138df56$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') $f73f86de2138df56$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $f73f86de2138df56$var$querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$hasLocalStorageSupport = null;
var $f73f86de2138df56$var$localStorageAvailable = function localStorageAvailable() {
    if ($f73f86de2138df56$var$hasLocalStorageSupport !== null) return $f73f86de2138df56$var$hasLocalStorageSupport;
    try {
        $f73f86de2138df56$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasLocalStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasLocalStorageSupport;
};
var $f73f86de2138df56$var$localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $f73f86de2138df56$var$hasSessionStorageSupport = null;
var $f73f86de2138df56$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($f73f86de2138df56$var$hasSessionStorageSupport !== null) return $f73f86de2138df56$var$hasSessionStorageSupport;
    try {
        $f73f86de2138df56$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasSessionStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasSessionStorageSupport;
};
var $f73f86de2138df56$var$sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $f73f86de2138df56$var$navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $f73f86de2138df56$var$htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var $f73f86de2138df56$var$path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $f73f86de2138df56$var$getDefaults() {
    return {
        order: [
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'navigator',
            'htmlTag'
        ],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ] // cookieMinutes: 10,
    };
}
var $f73f86de2138df56$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $03dWn.default)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    (0, $4OFm0.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $f73f86de2138df56$var$defaults(options, this.options || {}, $f73f86de2138df56$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($f73f86de2138df56$var$cookie$1);
                this.addDetector($f73f86de2138df56$var$querystring);
                this.addDetector($f73f86de2138df56$var$localStorage);
                this.addDetector($f73f86de2138df56$var$sessionStorage);
                this.addDetector($f73f86de2138df56$var$navigator$1);
                this.addDetector($f73f86de2138df56$var$htmlTag);
                this.addDetector($f73f86de2138df56$var$path);
                this.addDetector($f73f86de2138df56$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$f73f86de2138df56$export$2e2bcd8739ae039.type = 'languageDetector';


const $0f5516e4ff7e5463$export$910b680d1eea6990 = 'hu';
const $0f5516e4ff7e5463$var$s3 = `https://cx-ray-locales-01.s3.eu-central-1.amazonaws.com`;
const $0f5516e4ff7e5463$var$bucket = `employee-ui`;
(0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039).use((0, $fcb831e2a23edeea$export$2e2bcd8739ae039)).use((0, $f73f86de2138df56$export$2e2bcd8739ae039)).use((0, $021c8539c0651064$export$ae7e14d40d89f296)).use((0, $f73f86de2138df56$export$2e2bcd8739ae039)).init({
    detection: {
        order: [
            'querystring',
            'localStorage',
            'navigator'
        ],
        lookupQuerystring: 'language',
        lookupLocalStorage: 'i18nextLng'
    },
    backend: {
        loadPath: `${$0f5516e4ff7e5463$var$s3}/${$0f5516e4ff7e5463$var$bucket}/{{lng}}/{{ns}}.json`
    },
    fallbackLng: ($0f5516e4ff7e5463$export$910b680d1eea6990 || '').toLowerCase(),
    interpolation: {
        escapeValue: false // react already safes from xss
    },
    react: {
        useSuspense: true
    }
});
var $0f5516e4ff7e5463$export$2e2bcd8739ae039 = (0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039);



var $dQMrF = parcelRequire("dQMrF");
function $8273a87573256c54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8273a87573256c54$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8273a87573256c54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dQMrF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8273a87573256c54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $71488736b7fc99c4$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $71488736b7fc99c4$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $71488736b7fc99c4$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $71488736b7fc99c4$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $71488736b7fc99c4$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $71488736b7fc99c4$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $71488736b7fc99c4$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $71488736b7fc99c4$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $71488736b7fc99c4$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($71488736b7fc99c4$var$isDate(val)) return 'date';
    if ($71488736b7fc99c4$var$isError(val)) return 'error';
    var constructorName = $71488736b7fc99c4$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $71488736b7fc99c4$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $71488736b7fc99c4$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $71488736b7fc99c4$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $71488736b7fc99c4$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $71488736b7fc99c4$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(1));
        return enhancer($71488736b7fc99c4$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$71488736b7fc99c4$var$isPlainObject(action)) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $71488736b7fc99c4$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$71488736b7fc99c4$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $71488736b7fc99c4$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$71488736b7fc99c4$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $71488736b7fc99c4$export$8928921ea2d3b126 = $71488736b7fc99c4$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $71488736b7fc99c4$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $71488736b7fc99c4$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $71488736b7fc99c4$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$71488736b7fc99c4$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $71488736b7fc99c4$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $71488736b7fc99c4$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $71488736b7fc99c4$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $71488736b7fc99c4$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $71488736b7fc99c4$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $71488736b7fc99c4$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $71488736b7fc99c4$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $71488736b7fc99c4$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $71488736b7fc99c4$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $71488736b7fc99c4$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $71488736b7fc99c4$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $71488736b7fc99c4$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $71488736b7fc99c4$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $71488736b7fc99c4$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $1ab49e43fd6bbe7b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $1ab49e43fd6bbe7b$var$thunk = $1ab49e43fd6bbe7b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$1ab49e43fd6bbe7b$var$thunk.withExtraArgument = $1ab49e43fd6bbe7b$var$createThunkMiddleware;
var $1ab49e43fd6bbe7b$export$2e2bcd8739ae039 = $1ab49e43fd6bbe7b$var$thunk;



const $b4a8182390b65be8$export$d6c7eb0ad914cae2 = 'cx-ray/EMPLOYEE/ALERT/DELETE_ALERT ';
const $b4a8182390b65be8$export$35bcca4b43e766a4 = 'cx-ray/EMPLOYEE/ALERT/ADD_ALERT ';
function $b4a8182390b65be8$export$6b49420dc69c7fe4() {
    return {
        type: $b4a8182390b65be8$export$d6c7eb0ad914cae2
    };
}
function $b4a8182390b65be8$export$c8c497ba354ffdce(alert) {
    return {
        type: $b4a8182390b65be8$export$35bcca4b43e766a4,
        payload: alert
    };
}


const $e84d7fda3797eb81$export$7431817582ed8a25 = 'cx-ray/RESET';
const $e84d7fda3797eb81$export$8e84bad0b35de9e8 = ()=>({
        type: $e84d7fda3797eb81$export$7431817582ed8a25
    });


const $bbc051c336ee5f97$export$3a9c49fbc167a8c7 = (state = [], action)=>{
    switch(action.type){
        case 0, $b4a8182390b65be8$export$35bcca4b43e766a4:
            return [
                ...state,
                action.payload
            ];
        case 0, $b4a8182390b65be8$export$d6c7eb0ad914cae2:
            return state.slice(0, state.length - 1);
        case 0, $e84d7fda3797eb81$export$7431817582ed8a25:
            return [];
        default:
            return state;
    }
};


function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


'use strict';
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const { iterator: $77146a31cb578292$var$iterator, toStringTag: $77146a31cb578292$var$toStringTag } = Symbol;
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if ($77146a31cb578292$var$kindOf(val) !== 'object') return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($77146a31cb578292$var$toStringTag in val) && !($77146a31cb578292$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $77146a31cb578292$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $77146a31cb578292$var$isFunction(thing.append) && ((kind = $77146a31cb578292$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest('URLSearchParams');
const [$77146a31cb578292$var$isReadableStream, $77146a31cb578292$var$isRequest, $77146a31cb578292$var$isResponse, $77146a31cb578292$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($77146a31cb578292$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $77146a31cb578292$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    const { caseless: caseless } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $77146a31cb578292$var$findKey(result, key) || key;
        if ($77146a31cb578292$var$isPlainObject(result[targetKey]) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(result[targetKey], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) a[key] = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$77146a31cb578292$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest('HTMLFormElement');
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest('RegExp');
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[$77146a31cb578292$var$toStringTag] === 'FormData' && thing[$77146a31cb578292$var$iterator]);
}
const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $77146a31cb578292$var$isArray(source) ? [] : {};
                $77146a31cb578292$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest('AsyncFunction');
const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $77146a31cb578292$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $77146a31cb578292$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $77146a31cb578292$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $77146a31cb578292$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $77146a31cb578292$var$isFunction($77146a31cb578292$var$_global.postMessage));
const $77146a31cb578292$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($77146a31cb578292$var$_global) : $77146a31cb578292$var$_setImmediate;
// *********************
const $77146a31cb578292$var$isIterable = (thing)=>thing != null && $77146a31cb578292$var$isFunction(thing[$77146a31cb578292$var$iterator]);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isReadableStream: $77146a31cb578292$var$isReadableStream,
    isRequest: $77146a31cb578292$var$isRequest,
    isResponse: $77146a31cb578292$var$isResponse,
    isHeaders: $77146a31cb578292$var$isHeaders,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable,
    setImmediate: $77146a31cb578292$var$_setImmediate,
    asap: $77146a31cb578292$var$asap,
    isIterable: $77146a31cb578292$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $b9cc6960093b095e$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $77146a31cb578292$export$2e2bcd8739ae039).inherits($b9cc6960093b095e$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $77146a31cb578292$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $b9cc6960093b095e$var$prototype = $b9cc6960093b095e$var$AxiosError.prototype;
const $b9cc6960093b095e$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $b9cc6960093b095e$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($b9cc6960093b095e$var$AxiosError, $b9cc6960093b095e$var$descriptors);
Object.defineProperty($b9cc6960093b095e$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$b9cc6960093b095e$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($b9cc6960093b095e$var$prototype);
    (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $b9cc6960093b095e$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;


// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
var $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    var buf = $82a04c4ec6982288$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    var buf = $82a04c4ec6982288$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        var len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        var buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $82a04c4ec6982288$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $27564b8a0078aa3d$export$6100ba28696e12de(buf);
    else return $27564b8a0078aa3d$export$6100ba28696e12de(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $c4e917b4c37bfab7$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $c4e917b4c37bfab7$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $c4e917b4c37bfab7$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $27564b8a0078aa3d$export$d622b2ad8d90c771($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $19044a9fa7281693$require$Buffer = $82a04c4ec6982288$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject((0, $77146a31cb578292$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $31df7fcb8acaa73a$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $19044a9fa7281693$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $77146a31cb578292$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $19044a9fa7281693$export$2e2bcd8739ae039)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $a2774d1dd3bec636$var$encode);
    } : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4a4d655613ae826e$var$encode;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a2774d1dd3bec636$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $ec4d8e24b0699790$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;





'use strict';
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};







'use strict';
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $a2774d1dd3bec636$export$2e2bcd8739ae039);


'use strict';
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9a13f762833a66d0$export$2e2bcd8739ae039,
        FormData: $16325b87e107b4bc$export$2e2bcd8739ae039,
        Blob: $650c3d387ae3fbd4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $1bbd8fa0325c4f9a$exports = {};

$parcel$export($1bbd8fa0325c4f9a$exports, "hasBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf; });
$parcel$export($1bbd8fa0325c4f9a$exports, "navigator", function () { return $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c0bcc9250309d66; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserWebWorkerEnv", function () { return $1bbd8fa0325c4f9a$export$c81692cf5af97dac; });
$parcel$export($1bbd8fa0325c4f9a$exports, "origin", function () { return $1bbd8fa0325c4f9a$export$f710a83a91838a36; });
const $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1bbd8fa0325c4f9a$export$c0bcc9250309d66 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && (!$1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1bbd8fa0325c4f9a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1bbd8fa0325c4f9a$export$f710a83a91838a36 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $f9f874191f496b63$export$2e2bcd8739ae039 = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $1bbd8fa0325c4f9a$exports, (0, $e4489594588108ef$export$2e2bcd8739ae039));


'use strict';
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(data, new (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).isNode && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $77146a31cb578292$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $7e146da7bba06216$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $24febbb5d340c733$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isStream(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isFile(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f1a69cd24a140b61$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isResponse(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(e, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $77146a31cb578292$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $c7e8ef3e2bb241a6$var$$internals = Symbol('internals');
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : String(value);
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $77146a31cb578292$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $cf2275aca40d6d88$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(header) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $77146a31cb578292$export$2e2bcd8739ae039).reduceDescriptors($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;


'use strict';
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $f6ac833a4b31e3dc$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $b9cc6960093b095e$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $77146a31cb578292$export$2e2bcd8739ae039).inherits($f6ac833a4b31e3dc$var$CanceledError, (0, $b9cc6960093b095e$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;







'use strict';
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5603d643a9d93c92$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5603d643a9d93c92$export$2e2bcd8739ae039 = $5603d643a9d93c92$var$throttle;



const $de65761df8a598af$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d592abf0a04957f1$export$2e2bcd8739ae039)(50, 250);
    return (0, $5603d643a9d93c92$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $de65761df8a598af$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $de65761df8a598af$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $f9f874191f496b63$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin), (0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $12188e34b7070552$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $f55e71b6c54c4376$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





'use strict';
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039) ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, thing) : thing;
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(target) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), prop, true)
    };
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $b00a7ead3edff84a$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4a4d655613ae826e$export$2e2bcd8739ae039)((0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $82d74b1a5a0a01da$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $534b3794da5c002d$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $2c92173995cdc070$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Request aborted', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Network Error', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT : (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $2ecf5cf4c0202afd$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $f9f874191f496b63$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};










const $62bdf0498e608a4a$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039) ? err : new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $62bdf0498e608a4a$export$2e2bcd8739ae039 = $62bdf0498e608a4a$var$composeSignals;


const $c626b6acbc30fe14$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c626b6acbc30fe14$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c626b6acbc30fe14$var$readStream(iterable))yield* $c626b6acbc30fe14$export$71b051935044bd5d(chunk, chunkSize);
};
const $c626b6acbc30fe14$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c626b6acbc30fe14$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c626b6acbc30fe14$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $c2191f87f9ef3849$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $c2191f87f9ef3849$var$isReadableStreamSupported = $c2191f87f9ef3849$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $c2191f87f9ef3849$var$encodeText = $c2191f87f9ef3849$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $c2191f87f9ef3849$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $c2191f87f9ef3849$var$supportsRequestStream = $c2191f87f9ef3849$var$isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE = 65536;
const $c2191f87f9ef3849$var$supportsResponseStream = $c2191f87f9ef3849$var$isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $c2191f87f9ef3849$var$resolvers = {
    stream: $c2191f87f9ef3849$var$supportsResponseStream && ((res)=>res.body)
};
$c2191f87f9ef3849$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$c2191f87f9ef3849$var$resolvers[type] && ($c2191f87f9ef3849$var$resolvers[type] = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $c2191f87f9ef3849$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(body)) return (await $c2191f87f9ef3849$var$encodeText(body)).byteLength;
};
const $c2191f87f9ef3849$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $c2191f87f9ef3849$var$getBodyLength(body) : length;
};
var $c2191f87f9ef3849$export$2e2bcd8739ae039 = $c2191f87f9ef3849$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $62bdf0498e608a4a$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $c2191f87f9ef3849$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $c2191f87f9ef3849$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $de65761df8a598af$export$d9fadd12586c18d6)(requestContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c626b6acbc30fe14$export$b0119225647bd83)(_request.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fetchOptions), {
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        }));
        let response = await fetch(request);
        const isStreamResponse = $c2191f87f9ef3849$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($c2191f87f9ef3849$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $de65761df8a598af$export$d9fadd12586c18d6)(responseContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c626b6acbc30fe14$export$b0119225647bd83)(response.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $c2191f87f9ef3849$var$resolvers[(0, $77146a31cb578292$export$2e2bcd8739ae039).findKey($c2191f87f9ef3849$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $2c92173995cdc070$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Network Error', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $c036c406f3928265$var$knownAdapters = {
    http: (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039),
    xhr: (0, $2cabe869ce51dbf6$export$2e2bcd8739ae039),
    fetch: (0, $c2191f87f9ef3849$export$2e2bcd8739ae039)
};
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $c036c406f3928265$var$renderReason = (reason)=>`- ${reason}`;
const $c036c406f3928265$var$isResolvedHandle = (adapter)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$c036c406f3928265$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $c036c406f3928265$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c036c406f3928265$var$renderReason).join('\n') : ' ' + $c036c406f3928265$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $c036c406f3928265$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $36f1aa490c1da053$export$2e2bcd8739ae039)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $95be4ecd446de127$export$a4ad2735b021c132 = "1.9.0";



'use strict';
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $95be4ecd446de127$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1ad671c27810423e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('options must be an object', (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};



'use strict';
const $66f2b8a41463d1e8$var$validators = (0, $1ad671c27810423e$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $66f2b8a41463d1e8$var$validators.spelling('baseURL'),
            withXsrfToken: $66f2b8a41463d1e8$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $4a4d655613ae826e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)(),
            response: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    $66f2b8a41463d1e8$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;






'use strict';
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)((0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $a5e696f232d0dc12$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.CancelToken = (0, $f4994f37c883aea2$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.isCancel = (0, $36f1aa490c1da053$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.VERSION = (0, $95be4ecd446de127$export$a4ad2735b021c132);
$747d656b899e6115$var$axios.toFormData = (0, $19044a9fa7281693$export$2e2bcd8739ae039);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $b9cc6960093b095e$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $8145c4b68bfee186$export$2e2bcd8739ae039);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $ec03acb464b74212$export$2e2bcd8739ae039);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $24febbb5d340c733$export$2e2bcd8739ae039)((0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.getAdapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter;
$747d656b899e6115$var$axios.HttpStatusCode = (0, $a9353565c2e0947e$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, getAdapter: $c6ba0193c6fadd6f$export$17ddc20a97d669e2, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a } = (0, $747d656b899e6115$export$2e2bcd8739ae039);



const $e4998d3746b968db$export$596d806903d1f59e = async ({ loginName: loginName, password: password })=>{
    localStorage.removeItem('jwtToken');
    const url = '/login';
    try {
        const response = await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(url, {
            loginName: loginName,
            password: password
        });
        const { token: token } = response.data;
        localStorage.setItem('jwtToken', token);
        (0, $c5b59547f7a0f380$export$3f6b74dd1f6f18f9)(token);
    } catch (error) {
        throw error;
    }
};
const $e4998d3746b968db$export$a0973bcfe11b05c9 = async ()=>{
    localStorage.removeItem('jwtToken');
    (0, $c5b59547f7a0f380$export$3f6b74dd1f6f18f9)('');
};


var $f6e729db3f817bb5$exports = {};
const $f6e729db3f817bb5$var$STATUS = {
    PROPOSED: 'proposed',
    DECLINED: 'declined',
    PASSIVE: 'passive',
    ACTIVE: 'active',
    COMPLETED: 'completed',
    FAILED: 'failed'
};
const $f6e729db3f817bb5$var$DEVELOPMENT_STATUS = {
    IN_DANGER: 'in-danger',
    NEUTRAL: 'neutral',
    AWESOME: 'awesome'
};
const $f6e729db3f817bb5$var$RATING_STATUS = {
    NOT_AVAILABLE: 'notAvailable',
    IN_PROGRESS: 'inProgress',
    COMPLETED: 'completed'
};
const $f6e729db3f817bb5$var$RATING_ROLE = {
    LEADER: 'leader',
    OWNER: 'owner'
};
const $f6e729db3f817bb5$var$OBJECTIVE_STATUS_CHIP_LABELS = {
    PROPOSED: 'objective.status.proposed',
    DECLINED: 'objective.status.declined',
    PASSIVE: 'objective.status.passive',
    ACTIVE: 'objective.status.active',
    COMPLETED: 'objective.status.completed',
    FAILED: 'objective.status.failed',
    UNKNOWN: 'objective.status.unknown'
};
const $f6e729db3f817bb5$var$RATING_CHIP_LABELS = {
    notAvailable: 'objective.evaluation.status.notAvailable',
    inProgress: 'objective.evaluation.status.inProgress',
    completed: 'objective.evaluation.status.completed'
};
const $f6e729db3f817bb5$var$DEFAULT_OBJECTIVE_WEIGHT = '1';
const $f6e729db3f817bb5$var$ERROR_MESSAGES = {
    NAME: 'objective.dialog.errorMessage.name',
    DESCRIPTION: 'objective.dialog.errorMessage.description',
    DEADLINE: 'objective.dialog.create.errorMessage.deadline',
    APPRAISER: 'objective.dialog.errorMessage.appraiser',
    CATEGORY: 'objective.dialog.errorMessage.category'
};
const $f6e729db3f817bb5$var$DOUGHNUT_CHART_COLORS = {
    GREEN: '#99B64E',
    PURPLE: '#5744BB',
    BLUE: '#76C9E6'
};
const $f6e729db3f817bb5$var$CRITERIA_TYPES = {
    BASIC: 'basic',
    ONLY_TEXT: 'only_text'
};
const $f6e729db3f817bb5$var$SUPPORTED_LANGUAGES = {
    EN: 'en',
    HU: 'hu',
    DE: 'de'
};
const $f6e729db3f817bb5$var$STATUS_TYPES = {
    DEVELOPMENT_STATUS: 'developmentStatus',
    STATUS: 'status'
};
const $f6e729db3f817bb5$var$EVENT_LOG_LIMIT = 10;
const $f6e729db3f817bb5$var$EVENT_LOG_ACTIONS = {
    CREATE: 'create'
};
const $f6e729db3f817bb5$var$OWNER_TYPES = {
    EMPLOYEE: 'employee',
    GROUP: 'group'
};
const $f6e729db3f817bb5$var$OBJECTIVES_INFO_TYPES = {
    WILL_EXPIRE: 'willExpire',
    EXPIRED: 'expired',
    PROPOSED: 'proposed',
    ACTIVE: 'active',
    NEUTRAL: 'neutral',
    AWESOME: 'awesome',
    IN_DANGER: 'inDanger'
};
// same as sm for materialUI breakpoint
const $f6e729db3f817bb5$var$SCREEN_BREAK_POINT = 960;
const $f6e729db3f817bb5$var$NAVIGATION_DRAWER_WIDTH = 190;
const $f6e729db3f817bb5$var$OBJECTIVE_RELATION_TYPES = {
    HIERARCHICAL: 'hierarchical'
};
const $f6e729db3f817bb5$var$UNAUTHORIZED_ERROR = 'unauthorized_request_error';
const $f6e729db3f817bb5$var$PRIVACY_POLICY = 'https://www.cx-ray.com/adatkezelesi-tajekoztato/';
const $f6e729db3f817bb5$var$MAX_ATTACHMENT_SIZE = 25;
const $f6e729db3f817bb5$var$LOCATIONS = {
    HOME: '/',
    OBJECTIVES: '/objectives',
    MISSING_LICENCE: '/missing-licence',
    REGISTRATION: '/registration/:hash'
};
const $f6e729db3f817bb5$var$EVENT_LOG = {
    OBJECTIVES: 'objectives',
    COMMENTS: 'comments',
    KPIS: 'kpis',
    KPI_ENTRIES: 'kpi_entries',
    PROPERTIES: {
        LOCKED_EVALUATION: 'lockedEvaluation'
    },
    ACTIONS: {
        DELETE: 'delete'
    }
};
const $f6e729db3f817bb5$var$ALREADY_REGISTERED_ERROR = 'already_registered';
$f6e729db3f817bb5$exports = {
    STATUS: $f6e729db3f817bb5$var$STATUS,
    RATING_STATUS: $f6e729db3f817bb5$var$RATING_STATUS,
    RATING_ROLE: $f6e729db3f817bb5$var$RATING_ROLE,
    OBJECTIVE_STATUS_CHIP_LABELS: $f6e729db3f817bb5$var$OBJECTIVE_STATUS_CHIP_LABELS,
    RATING_CHIP_LABELS: $f6e729db3f817bb5$var$RATING_CHIP_LABELS,
    DEFAULT_OBJECTIVE_WEIGHT: $f6e729db3f817bb5$var$DEFAULT_OBJECTIVE_WEIGHT,
    ERROR_MESSAGES: $f6e729db3f817bb5$var$ERROR_MESSAGES,
    DOUGHNUT_CHART_COLORS: $f6e729db3f817bb5$var$DOUGHNUT_CHART_COLORS,
    CRITERIA_TYPES: $f6e729db3f817bb5$var$CRITERIA_TYPES,
    SUPPORTED_LANGUAGES: $f6e729db3f817bb5$var$SUPPORTED_LANGUAGES,
    DEVELOPMENT_STATUS: $f6e729db3f817bb5$var$DEVELOPMENT_STATUS,
    STATUS_TYPES: $f6e729db3f817bb5$var$STATUS_TYPES,
    EVENT_LOG_LIMIT: $f6e729db3f817bb5$var$EVENT_LOG_LIMIT,
    EVENT_LOG_ACTIONS: $f6e729db3f817bb5$var$EVENT_LOG_ACTIONS,
    SCREEN_BREAK_POINT: $f6e729db3f817bb5$var$SCREEN_BREAK_POINT,
    NAVIGATION_DRAWER_WIDTH: $f6e729db3f817bb5$var$NAVIGATION_DRAWER_WIDTH,
    OBJECTIVES_INFO_TYPES: $f6e729db3f817bb5$var$OBJECTIVES_INFO_TYPES,
    OWNER_TYPES: $f6e729db3f817bb5$var$OWNER_TYPES,
    OBJECTIVE_RELATION_TYPES: $f6e729db3f817bb5$var$OBJECTIVE_RELATION_TYPES,
    UNAUTHORIZED_ERROR: $f6e729db3f817bb5$var$UNAUTHORIZED_ERROR,
    PRIVACY_POLICY: $f6e729db3f817bb5$var$PRIVACY_POLICY,
    MAX_ATTACHMENT_SIZE: $f6e729db3f817bb5$var$MAX_ATTACHMENT_SIZE,
    LOCATIONS: $f6e729db3f817bb5$var$LOCATIONS,
    EVENT_LOG: $f6e729db3f817bb5$var$EVENT_LOG,
    ALREADY_REGISTERED_ERROR: $f6e729db3f817bb5$var$ALREADY_REGISTERED_ERROR
};


const $c5b59547f7a0f380$var$url = "https://go.cx-ray.com/employeeUI";
const $c5b59547f7a0f380$var$service = (0, $747d656b899e6115$export$2e2bcd8739ae039).create({
    baseURL: $c5b59547f7a0f380$var$url,
    timeout: 5000,
    headers: {
        common: {
            Authorization: localStorage.getItem('jwtToken') || undefined
        }
    }
});
function $c5b59547f7a0f380$export$443273ce444d1cfc(history, t) {
    $c5b59547f7a0f380$var$service.interceptors.response.use((response)=>{
        return response;
    }, (error)=>{
        var _error_response, _error_response_data, _error_response1, _error_response2;
        if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 401) {
            (0, $e4998d3746b968db$export$a0973bcfe11b05c9)();
            history.push('/');
            const errorMessage = error.response.data.error === (0, $f6e729db3f817bb5$exports.UNAUTHORIZED_ERROR) ? t(`login.alert.${(0, $f6e729db3f817bb5$exports.UNAUTHORIZED_ERROR)}`) : error.response.data.error;
            return Promise.reject({
                message: errorMessage,
                status: error.response.status
            });
        }
        const errorMessage = ((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data = _error_response1.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.error) || error.message;
        return Promise.reject({
            message: errorMessage,
            status: (_error_response2 = error.response) === null || _error_response2 === void 0 ? void 0 : _error_response2.status
        });
    });
}
function $c5b59547f7a0f380$export$3f6b74dd1f6f18f9(token) {
    if (token) $c5b59547f7a0f380$var$service.defaults.headers.common.Authorization = `${token}`;
    else delete $c5b59547f7a0f380$var$service.defaults.headers.common.Authorization;
}
var $c5b59547f7a0f380$export$2e2bcd8739ae039 = $c5b59547f7a0f380$var$service;




var $9GPfD = parcelRequire("9GPfD");


var $7UqAk = parcelRequire("7UqAk");

var $745f2177c5cf84eb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $745f2177c5cf84eb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $745f2177c5cf84eb$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $745f2177c5cf84eb$var$__defProp = Object.defineProperty;
var $745f2177c5cf84eb$var$__defProps = Object.defineProperties;
var $745f2177c5cf84eb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $745f2177c5cf84eb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $745f2177c5cf84eb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $745f2177c5cf84eb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $745f2177c5cf84eb$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $745f2177c5cf84eb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $745f2177c5cf84eb$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($745f2177c5cf84eb$var$__hasOwnProp.call(b, prop)) $745f2177c5cf84eb$var$__defNormalProp(a, prop, b[prop]);
    if ($745f2177c5cf84eb$var$__getOwnPropSymbols) for(var _i = 0, _c = $745f2177c5cf84eb$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($745f2177c5cf84eb$var$__propIsEnum.call(b, prop)) $745f2177c5cf84eb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $745f2177c5cf84eb$var$__spreadProps = function(a, b) {
    return $745f2177c5cf84eb$var$__defProps(a, $745f2177c5cf84eb$var$__getOwnPropDescs(b));
};
var $745f2177c5cf84eb$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $745f2177c5cf84eb$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $7UqAk.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $745f2177c5cf84eb$var$__spreadArray([
            (0, $9GPfD.isDraft)(value) ? (0, $9GPfD.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $745f2177c5cf84eb$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $71488736b7fc99c4$export$f672e0b6f7222cd7;
    return (0, $71488736b7fc99c4$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $745f2177c5cf84eb$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $745f2177c5cf84eb$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $745f2177c5cf84eb$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $745f2177c5cf84eb$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $745f2177c5cf84eb$export$b956e38827fca970(action) {
    return $745f2177c5cf84eb$export$53b83ca8eaab0383(action) && "type" in action;
}
function $745f2177c5cf84eb$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $745f2177c5cf84eb$var$hasMatchFunction(action);
}
function $745f2177c5cf84eb$export$ebd532f9034651f3(action) {
    return $745f2177c5cf84eb$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($745f2177c5cf84eb$var$isValidKey);
}
function $745f2177c5cf84eb$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $745f2177c5cf84eb$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $745f2177c5cf84eb$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $745f2177c5cf84eb$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $745f2177c5cf84eb$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $745f2177c5cf84eb$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $745f2177c5cf84eb$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $745f2177c5cf84eb$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $745f2177c5cf84eb$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $745f2177c5cf84eb$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $745f2177c5cf84eb$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $745f2177c5cf84eb$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $745f2177c5cf84eb$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $745f2177c5cf84eb$var$freezeDraftable(val) {
    return (0, $9GPfD.isDraftable)(val) ? (0, $9GPfD.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $745f2177c5cf84eb$var$isProduction = true;
var $745f2177c5cf84eb$var$prefix = "Invariant failed";
function $745f2177c5cf84eb$var$invariant(condition, message) {
    if (condition) return;
    if ($745f2177c5cf84eb$var$isProduction) throw new Error($745f2177c5cf84eb$var$prefix);
    throw new Error($745f2177c5cf84eb$var$prefix + ": " + (message || ""));
}
function $745f2177c5cf84eb$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $745f2177c5cf84eb$var$getSerialize(serializer, decycler), indent);
}
function $745f2177c5cf84eb$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $745f2177c5cf84eb$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $745f2177c5cf84eb$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $745f2177c5cf84eb$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $745f2177c5cf84eb$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $745f2177c5cf84eb$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $745f2177c5cf84eb$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $745f2177c5cf84eb$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $745f2177c5cf84eb$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $745f2177c5cf84eb$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $745f2177c5cf84eb$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $745f2177c5cf84eb$export$53b83ca8eaab0383(val);
}
function $745f2177c5cf84eb$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $745f2177c5cf84eb$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $745f2177c5cf84eb$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $745f2177c5cf84eb$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $745f2177c5cf84eb$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$745f2177c5cf84eb$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $745f2177c5cf84eb$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $745f2177c5cf84eb$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $745f2177c5cf84eb$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $745f2177c5cf84eb$export$36c1185aeee5b0a6(options);
    };
}
function $745f2177c5cf84eb$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $745f2177c5cf84eb$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($745f2177c5cf84eb$var$isBoolean(thunk)) middlewareArray.push((0, $1ab49e43fd6bbe7b$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $1ab49e43fd6bbe7b$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $745f2177c5cf84eb$var$IS_PRODUCTION = true;
function $745f2177c5cf84eb$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $745f2177c5cf84eb$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($745f2177c5cf84eb$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $71488736b7fc99c4$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$745f2177c5cf84eb$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$745f2177c5cf84eb$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $71488736b7fc99c4$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $71488736b7fc99c4$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $745f2177c5cf84eb$var$composeWithDevTools($745f2177c5cf84eb$var$__spreadValues({
        trace: !$745f2177c5cf84eb$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $745f2177c5cf84eb$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $745f2177c5cf84eb$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $71488736b7fc99c4$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $745f2177c5cf84eb$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $745f2177c5cf84eb$var$isStateFunction(x) {
    return typeof x === "function";
}
var $745f2177c5cf84eb$var$hasWarnedAboutObjectNotation = false;
function $745f2177c5cf84eb$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $745f2177c5cf84eb$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($745f2177c5cf84eb$var$isStateFunction(initialState)) getInitialState = function() {
        return $745f2177c5cf84eb$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $745f2177c5cf84eb$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $745f2177c5cf84eb$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $9GPfD.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $9GPfD.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $9GPfD.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $745f2177c5cf84eb$var$hasWarnedAboutObjectNotation2 = false;
function $745f2177c5cf84eb$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $745f2177c5cf84eb$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : $745f2177c5cf84eb$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $745f2177c5cf84eb$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $745f2177c5cf84eb$export$309c7a02b0b0bc62(type, prepareCallback) : $745f2177c5cf84eb$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $745f2177c5cf84eb$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $745f2177c5cf84eb$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $745f2177c5cf84eb$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $745f2177c5cf84eb$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($745f2177c5cf84eb$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $745f2177c5cf84eb$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $745f2177c5cf84eb$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $745f2177c5cf84eb$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $745f2177c5cf84eb$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $745f2177c5cf84eb$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $745f2177c5cf84eb$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $745f2177c5cf84eb$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $745f2177c5cf84eb$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $745f2177c5cf84eb$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $745f2177c5cf84eb$var$createSingleArgumentStateOperator(mutator) {
    var operator = $745f2177c5cf84eb$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $745f2177c5cf84eb$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $745f2177c5cf84eb$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $9GPfD.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $9GPfD.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $745f2177c5cf84eb$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $745f2177c5cf84eb$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $745f2177c5cf84eb$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $745f2177c5cf84eb$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $745f2177c5cf84eb$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $745f2177c5cf84eb$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $745f2177c5cf84eb$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $745f2177c5cf84eb$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $745f2177c5cf84eb$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $745f2177c5cf84eb$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $745f2177c5cf84eb$var$createStateOperator(addOneMutably),
        addMany: $745f2177c5cf84eb$var$createStateOperator(addManyMutably),
        setOne: $745f2177c5cf84eb$var$createStateOperator(setOneMutably),
        setMany: $745f2177c5cf84eb$var$createStateOperator(setManyMutably),
        setAll: $745f2177c5cf84eb$var$createStateOperator(setAllMutably),
        updateOne: $745f2177c5cf84eb$var$createStateOperator(updateOneMutably),
        updateMany: $745f2177c5cf84eb$var$createStateOperator(updateManyMutably),
        upsertOne: $745f2177c5cf84eb$var$createStateOperator(upsertOneMutably),
        upsertMany: $745f2177c5cf84eb$var$createStateOperator(upsertManyMutably),
        removeOne: $745f2177c5cf84eb$var$createStateOperator(removeOneMutably),
        removeMany: $745f2177c5cf84eb$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $745f2177c5cf84eb$var$createSortedStateAdapter(selectId, sort) {
    var _c = $745f2177c5cf84eb$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($745f2177c5cf84eb$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $745f2177c5cf84eb$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $745f2177c5cf84eb$var$createStateOperator(addOneMutably),
        updateOne: $745f2177c5cf84eb$var$createStateOperator(updateOneMutably),
        upsertOne: $745f2177c5cf84eb$var$createStateOperator(upsertOneMutably),
        setOne: $745f2177c5cf84eb$var$createStateOperator(setOneMutably),
        setMany: $745f2177c5cf84eb$var$createStateOperator(setManyMutably),
        setAll: $745f2177c5cf84eb$var$createStateOperator(setAllMutably),
        addMany: $745f2177c5cf84eb$var$createStateOperator(addManyMutably),
        updateMany: $745f2177c5cf84eb$var$createStateOperator(updateManyMutably),
        upsertMany: $745f2177c5cf84eb$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $745f2177c5cf84eb$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $745f2177c5cf84eb$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $745f2177c5cf84eb$var$createInitialStateFactory();
    var selectorsFactory = $745f2177c5cf84eb$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $745f2177c5cf84eb$var$createSortedStateAdapter(selectId, sortComparer) : $745f2177c5cf84eb$var$createUnsortedStateAdapter(selectId);
    return $745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $745f2177c5cf84eb$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $745f2177c5cf84eb$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $745f2177c5cf84eb$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $745f2177c5cf84eb$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $745f2177c5cf84eb$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $745f2177c5cf84eb$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $745f2177c5cf84eb$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $745f2177c5cf84eb$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $745f2177c5cf84eb$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $745f2177c5cf84eb$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $745f2177c5cf84eb$var$__spreadProps($745f2177c5cf84eb$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $745f2177c5cf84eb$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $745f2177c5cf84eb$var$__spreadProps($745f2177c5cf84eb$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $745f2177c5cf84eb$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $745f2177c5cf84eb$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $745f2177c5cf84eb$var$__spreadProps($745f2177c5cf84eb$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $745f2177c5cf84eb$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $745f2177c5cf84eb$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $745f2177c5cf84eb$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$745f2177c5cf84eb$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $745f2177c5cf84eb$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $745f2177c5cf84eb$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $745f2177c5cf84eb$var$RejectWithValue) throw result;
                                                if (result instanceof $745f2177c5cf84eb$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $745f2177c5cf84eb$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($745f2177c5cf84eb$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $745f2177c5cf84eb$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $745f2177c5cf84eb$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $745f2177c5cf84eb$var$matches = function(matcher, action) {
    if ($745f2177c5cf84eb$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $745f2177c5cf84eb$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $745f2177c5cf84eb$var$matches(matcher, action);
        });
    };
}
function $745f2177c5cf84eb$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $745f2177c5cf84eb$var$matches(matcher, action);
        });
    };
}
function $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $745f2177c5cf84eb$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $745f2177c5cf84eb$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $745f2177c5cf84eb$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $745f2177c5cf84eb$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $745f2177c5cf84eb$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $745f2177c5cf84eb$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $745f2177c5cf84eb$export$9dd1fb32974da385($745f2177c5cf84eb$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $745f2177c5cf84eb$export$9dd1fb32974da385($745f2177c5cf84eb$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $745f2177c5cf84eb$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $745f2177c5cf84eb$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $745f2177c5cf84eb$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $745f2177c5cf84eb$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $745f2177c5cf84eb$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $745f2177c5cf84eb$var$noop = function() {};
var $745f2177c5cf84eb$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $745f2177c5cf84eb$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $745f2177c5cf84eb$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $745f2177c5cf84eb$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $745f2177c5cf84eb$var$task = "task";
var $745f2177c5cf84eb$var$listener = "listener";
var $745f2177c5cf84eb$var$completed = "completed";
var $745f2177c5cf84eb$var$cancelled = "cancelled";
var $745f2177c5cf84eb$var$taskCancelled = "task-" + $745f2177c5cf84eb$var$cancelled;
var $745f2177c5cf84eb$var$taskCompleted = "task-" + $745f2177c5cf84eb$var$completed;
var $745f2177c5cf84eb$var$listenerCancelled = $745f2177c5cf84eb$var$listener + "-" + $745f2177c5cf84eb$var$cancelled;
var $745f2177c5cf84eb$var$listenerCompleted = $745f2177c5cf84eb$var$listener + "-" + $745f2177c5cf84eb$var$completed;
var $745f2177c5cf84eb$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $745f2177c5cf84eb$var$task + " " + $745f2177c5cf84eb$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $745f2177c5cf84eb$var$validateActive = function(signal) {
    if (signal.aborted) throw new $745f2177c5cf84eb$export$cb1bdac908fed7f(signal.reason);
};
function $745f2177c5cf84eb$var$raceWithSignal(signal, promise2) {
    var cleanup = $745f2177c5cf84eb$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $745f2177c5cf84eb$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $745f2177c5cf84eb$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $745f2177c5cf84eb$var$noop;
    });
}
var $745f2177c5cf84eb$var$runTask = function(task2, cleanUp) {
    return $745f2177c5cf84eb$var$__async(void 0, null, function() {
        var value, error_1;
        return $745f2177c5cf84eb$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $745f2177c5cf84eb$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $745f2177c5cf84eb$var$createPause = function(signal) {
    return function(promise2) {
        return $745f2177c5cf84eb$var$catchRejection($745f2177c5cf84eb$var$raceWithSignal(signal, promise2).then(function(output) {
            $745f2177c5cf84eb$var$validateActive(signal);
            return output;
        }));
    };
};
var $745f2177c5cf84eb$var$createDelay = function(signal) {
    var pause = $745f2177c5cf84eb$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $745f2177c5cf84eb$var$assign = Object.assign;
var $745f2177c5cf84eb$var$INTERNAL_NIL_TOKEN = {};
var $745f2177c5cf84eb$var$alm = "listenerMiddleware";
var $745f2177c5cf84eb$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $745f2177c5cf84eb$var$addAbortSignalListener(parentAbortSignal, function() {
            return $745f2177c5cf84eb$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $745f2177c5cf84eb$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $745f2177c5cf84eb$var$runTask(function() {
            return $745f2177c5cf84eb$var$__async(void 0, null, function() {
                var result2;
                return $745f2177c5cf84eb$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $745f2177c5cf84eb$var$validateActive(parentAbortSignal);
                            $745f2177c5cf84eb$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $745f2177c5cf84eb$var$createPause(childAbortController.signal),
                                    delay: $745f2177c5cf84eb$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $745f2177c5cf84eb$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $745f2177c5cf84eb$var$abortControllerWithReason(childAbortController, $745f2177c5cf84eb$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $745f2177c5cf84eb$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $745f2177c5cf84eb$var$abortControllerWithReason(childAbortController, $745f2177c5cf84eb$var$taskCancelled);
            }
        };
    };
};
var $745f2177c5cf84eb$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $745f2177c5cf84eb$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $745f2177c5cf84eb$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $745f2177c5cf84eb$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $745f2177c5cf84eb$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $745f2177c5cf84eb$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $745f2177c5cf84eb$var$catchRejection(take(predicate, timeout));
    };
};
var $745f2177c5cf84eb$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $745f2177c5cf84eb$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $745f2177c5cf84eb$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $745f2177c5cf84eb$var$createListenerEntry = function(options) {
    var _c = $745f2177c5cf84eb$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $745f2177c5cf84eb$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $745f2177c5cf84eb$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $745f2177c5cf84eb$var$abortControllerWithReason(controller, $745f2177c5cf84eb$var$listenerCancelled);
    });
};
var $745f2177c5cf84eb$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($745f2177c5cf84eb$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $745f2177c5cf84eb$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $745f2177c5cf84eb$export$f03a6b845d3fb58b = $745f2177c5cf84eb$export$309c7a02b0b0bc62($745f2177c5cf84eb$var$alm + "/add");
var $745f2177c5cf84eb$export$b1b8022855fb2b71 = $745f2177c5cf84eb$export$309c7a02b0b0bc62($745f2177c5cf84eb$var$alm + "/removeAll");
var $745f2177c5cf84eb$export$b03e9483f936dccb = $745f2177c5cf84eb$export$309c7a02b0b0bc62($745f2177c5cf84eb$var$alm + "/remove");
var $745f2177c5cf84eb$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $745f2177c5cf84eb$var$__spreadArray([
        $745f2177c5cf84eb$var$alm + "/error"
    ], args));
};
function $745f2177c5cf84eb$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $745f2177c5cf84eb$var$defaultErrorHandler : _c;
    $745f2177c5cf84eb$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $745f2177c5cf84eb$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $745f2177c5cf84eb$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $745f2177c5cf84eb$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $745f2177c5cf84eb$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $745f2177c5cf84eb$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $745f2177c5cf84eb$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $745f2177c5cf84eb$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $745f2177c5cf84eb$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $745f2177c5cf84eb$var$createDelay(internalTaskController.signal),
                                pause: $745f2177c5cf84eb$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $745f2177c5cf84eb$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $745f2177c5cf84eb$var$abortControllerWithReason(controller, $745f2177c5cf84eb$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $745f2177c5cf84eb$export$cb1bdac908fed7f)) $745f2177c5cf84eb$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $745f2177c5cf84eb$var$abortControllerWithReason(internalTaskController, $745f2177c5cf84eb$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $745f2177c5cf84eb$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$745f2177c5cf84eb$export$b956e38827fca970(action)) return next(action);
                if ($745f2177c5cf84eb$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($745f2177c5cf84eb$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($745f2177c5cf84eb$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $745f2177c5cf84eb$var$INTERNAL_NIL_TOKEN) throw new Error($745f2177c5cf84eb$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $745f2177c5cf84eb$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $745f2177c5cf84eb$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $745f2177c5cf84eb$export$8fb31c0f05df007b = "RTK_autoBatch";
var $745f2177c5cf84eb$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$745f2177c5cf84eb$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $745f2177c5cf84eb$var$promise;
var $745f2177c5cf84eb$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($745f2177c5cf84eb$var$promise || ($745f2177c5cf84eb$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $745f2177c5cf84eb$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $745f2177c5cf84eb$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $745f2177c5cf84eb$var$createQueueWithTimer(10);
var $745f2177c5cf84eb$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $745f2177c5cf84eb$var$queueMicrotaskShim : options.type === "raf" ? $745f2177c5cf84eb$var$rAF : options.type === "callback" ? options.queueNotification : $745f2177c5cf84eb$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$745f2177c5cf84eb$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $9GPfD.enableES5)();


const $9abcdbaae8311c9d$var$licencesSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: 'licences',
    initialState: {
        hasValidObjectiveLicence: false
    },
    reducers: {
        setObjectiveLicences: (state, { payload: payload })=>{
            state.hasValidObjectiveLicence = payload;
        }
    }
});
const { setObjectiveLicences: $9abcdbaae8311c9d$export$69adbc1c065b23cf } = $9abcdbaae8311c9d$var$licencesSlice.actions;
var $9abcdbaae8311c9d$export$2e2bcd8739ae039 = $9abcdbaae8311c9d$var$licencesSlice.reducer;
const $9abcdbaae8311c9d$export$3b2effd73e7d4022 = (state)=>state.licencesSlice.hasValidObjectiveLicence;





const $c2fa3f0a340dc103$export$801fe16824f675f7 = async ()=>{
    const url = '/me';
    try {
        const { data: { language: language, hasValidObjectiveManagementLicence: hasValidObjectiveManagementLicence } = {} } = await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(url);
        return {
            language: language,
            hasValidObjectiveManagementLicence: hasValidObjectiveManagementLicence
        };
    } catch (error) {
        throw error;
    }
};
const $c2fa3f0a340dc103$export$ac983537af4b3a6d = (language)=>{
    const availableLanguages = Object.values((0, $f6e729db3f817bb5$exports.SUPPORTED_LANGUAGES));
    if (!availableLanguages.includes(language)) (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).changeLanguage((0, $f6e729db3f817bb5$exports.SUPPORTED_LANGUAGES).EN);
    else (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).changeLanguage(language);
};





const $6e7ac8ed3c2a9d89$var$alertMessageStart = 'registration.alert.';
const $6e7ac8ed3c2a9d89$export$52a0d68d182d568d = 'cx-ray/EMPLOYEE/REGISTRATON/CHECK_HASH_SUCCESS';
function $6e7ac8ed3c2a9d89$export$fd421699a75c4e85(registrationHash, history) {
    return async (dispatch)=>{
        const url = `/registration/${registrationHash}`;
        const token = localStorage.getItem('jwtToken');
        const handleLogOut = ()=>{
            (0, $e4998d3746b968db$export$a0973bcfe11b05c9)();
            dispatch((0, $e84d7fda3797eb81$export$8e84bad0b35de9e8)());
        };
        (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(url).then((result)=>{
            if (token) handleLogOut();
            dispatch({
                type: $6e7ac8ed3c2a9d89$export$52a0d68d182d568d,
                payload: result.data
            });
        }).catch((error)=>{
            if (error.message === (0, $f6e729db3f817bb5$exports.ALREADY_REGISTERED_ERROR)) history.push('/objectives');
            else dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `${$6e7ac8ed3c2a9d89$var$alertMessageStart}${error.message}`,
                severity: 'error'
            }));
        });
    };
}
function $6e7ac8ed3c2a9d89$export$b0d46c734102bfcb(registrationHash, registrationData, history) {
    return async (dispatch)=>{
        const url = `/registration/${registrationHash}`;
        (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(url, registrationData).then(async (result)=>{
            const token = result.data.token;
            localStorage.setItem('jwtToken', token);
            (0, $c5b59547f7a0f380$export$3f6b74dd1f6f18f9)(token);
            const { hasValidObjectiveManagementLicence: hasValidObjectiveManagementLicence } = await (0, $c2fa3f0a340dc103$export$801fe16824f675f7)();
            dispatch((0, $9abcdbaae8311c9d$export$69adbc1c065b23cf)(hasValidObjectiveManagementLicence));
            history.push('/objectives');
        }).catch((error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `${$6e7ac8ed3c2a9d89$var$alertMessageStart}${error.message}`,
                severity: 'error'
            }));
        });
    };
}





const $750868b12996ced6$var$alertMessageStart = 'forgotten_password.alert.';
const $750868b12996ced6$export$381649c7628df71 = 'cx-ray/EMPLOYEE/PASSWORD/DELETE_EMPLOYEES';
function $750868b12996ced6$export$dd9330a0c4a135a2(userName, history) {
    return async (dispatch)=>{
        const url = `/sendPasswordChange`;
        (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(url, userName).then((result)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `${$750868b12996ced6$var$alertMessageStart}${result.data.message}`,
                severity: 'success'
            }));
            history.push('/');
        }).catch((error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `${$750868b12996ced6$var$alertMessageStart}${error.message}`,
                severity: 'error'
            }));
        });
    };
}
function $750868b12996ced6$export$54d20a726a601ff1(resetHash) {
    return async (dispatch)=>{
        const url = `/changePassword/${resetHash}`;
        (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(url).then((result)=>{
            dispatch({
                type: (0, $6e7ac8ed3c2a9d89$export$52a0d68d182d568d),
                payload: result.data
            });
        }).catch((error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `${$750868b12996ced6$var$alertMessageStart}${error.message}`,
                severity: 'error'
            }));
        });
    };
}
function $750868b12996ced6$export$99d837dc30eb1ef7(resetHash, password, history) {
    return async (dispatch)=>{
        const url = `/changePassword/${resetHash}`;
        (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(url, password).then((result)=>{
            dispatch({
                type: $750868b12996ced6$export$381649c7628df71,
                payload: result.data
            });
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `${$750868b12996ced6$var$alertMessageStart}${result.data.message}`,
                severity: 'success'
            }));
            history.push('/');
        }).catch((error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `${$750868b12996ced6$var$alertMessageStart}${error.message}`,
                severity: 'error'
            }));
        });
    };
}





const $401a17725816a5a8$export$69fe409a26761117 = 'cx-ray/EMPLOYEE/FETCH';
const $401a17725816a5a8$export$8ada6ac8fd817fb5 = 'cx-ray/EMPLOYEE/EDIT_LOGINNAME';
const $401a17725816a5a8$export$eebee1d033f447f3 = 'cx-ray/EMPLOYEE/EDIT_PASSWORD';
const $401a17725816a5a8$export$e661479f79cf39ad = 'cx-ray/EMPLOYEE/EDIT_LANGUAGE';
const $401a17725816a5a8$export$d5f42470fa5a7347 = ()=>{
    return async (dispatch)=>{
        const url = `/me`;
        try {
            const { data: data } = await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(url);
            dispatch((0, $9abcdbaae8311c9d$export$69adbc1c065b23cf)(data.hasValidObjectiveManagementLicence));
            dispatch({
                type: $401a17725816a5a8$export$69fe409a26761117,
                payload: data
            });
            return data;
        } catch (error) {
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    };
};
const $401a17725816a5a8$export$7b2ff6d49bd2365 = (loginName)=>{
    return async (dispatch)=>{
        const url = `/me/loginName`;
        try {
            await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(url, {
                loginName: loginName
            });
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: 'settings.loginName.success',
                severity: 'success'
            }));
        } catch (error) {
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: 'settings.loginName.error',
                severity: 'error'
            }));
        }
    };
};
const $401a17725816a5a8$export$1af3d3323b2d472a = ({ password: password, currentPassword: currentPassword }, callback)=>{
    return async (dispatch)=>{
        const url = `/me/password`;
        try {
            await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(url, {
                password: password,
                currentPassword: currentPassword
            });
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: 'settings.password.success',
                severity: 'success'
            }));
            callback();
        } catch (error) {
            error.status === 403 ? dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: 'settings.password.currentPasswordError',
                severity: 'error'
            })) : dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: 'settings.password.error',
                severity: 'error'
            }));
        }
    };
};
const $401a17725816a5a8$export$bb8ea1997573c96e = (language)=>{
    return async (dispatch)=>{
        const url = `/me/language`;
        try {
            const { data: data } = await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(url, {
                language: language
            });
            dispatch({
                type: $401a17725816a5a8$export$e661479f79cf39ad,
                payload: data
            });
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: 'settings.language.success',
                severity: 'success'
            }));
        } catch (error) {
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: 'settings.language.error',
                severity: 'error'
            }));
        }
    };
};




const $a73c580aa0785cc5$export$ec1008daadda13a2 = 'cx-ray/EMPLOYEE/SET_NOTIFICATIONS';
const $a73c580aa0785cc5$export$c53275bee200c32a = (notifications)=>async (dispatch)=>{
        const url = `/notificationsSetting`;
        try {
            const { data: data } = await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(url, notifications);
            dispatch({
                type: $a73c580aa0785cc5$export$ec1008daadda13a2,
                payload: data.notifications
            });
        } catch (error) {
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    };



const $c60984d9db337d2c$export$95116760c24749c6 = (state = {}, action)=>{
    switch(action.type){
        case 0, $6e7ac8ed3c2a9d89$export$52a0d68d182d568d:
            return action.payload;
        case 0, $401a17725816a5a8$export$69fe409a26761117:
            return action.payload;
        case 0, $750868b12996ced6$export$381649c7628df71:
            return {};
        case 0, $a73c580aa0785cc5$export$ec1008daadda13a2:
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                notifications: action.payload
            });
        case 0, $401a17725816a5a8$export$e661479f79cf39ad:
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                language: action.payload
            });
        case 0, $e84d7fda3797eb81$export$7431817582ed8a25:
            return {};
        default:
            return state;
    }
};




const $74750fb419d4223b$export$98462486693866d = 'cx-ray/EMPLOYEE/ACCOUNT_INFO/FETCH';
const $74750fb419d4223b$var$createFetchAction = (payload)=>({
        type: $74750fb419d4223b$export$98462486693866d,
        payload: payload
    });
const $74750fb419d4223b$export$eb48dd7746a93f2a = ()=>async (dispatch)=>{
        try {
            const url = `/accountInfo`;
            var _ref;
            const { data: data = {} } = (_ref = await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(url)) !== null && _ref !== void 0 ? _ref : {};
            dispatch($74750fb419d4223b$var$createFetchAction(data));
        } catch (error) {
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    };



const $469d0d03214c3304$export$c0c48da7b7d94b79 = (state = [], action)=>{
    switch(action.type){
        case 0, $74750fb419d4223b$export$98462486693866d:
            return action.payload;
        case 0, $e84d7fda3797eb81$export$7431817582ed8a25:
            return [];
        default:
            return state;
    }
};



const $295ca3e31a29edec$var$redirectURLSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: 'redirectURL',
    initialState: {
        redirectURL: '/objectives'
    },
    reducers: {
        setRedirectURL: (state, { payload: { url: url } })=>{
            state.redirectURL = url;
        }
    }
});
const { setRedirectURL: $295ca3e31a29edec$export$c2736593113e9a96 } = $295ca3e31a29edec$var$redirectURLSlice.actions;
var $295ca3e31a29edec$export$2e2bcd8739ae039 = $295ca3e31a29edec$var$redirectURLSlice.reducer;
const $295ca3e31a29edec$export$48a4dab9caeca3ef = (state)=>state.redirectURLSlice.redirectURL;



const $d6d6df2b6f8af4bf$var$rootReducer = (0, $71488736b7fc99c4$export$66e4520cdb265d18)({
    employee: $c60984d9db337d2c$export$95116760c24749c6,
    alerts: $bbc051c336ee5f97$export$3a9c49fbc167a8c7,
    accountInfo: $469d0d03214c3304$export$c0c48da7b7d94b79,
    redirectURLSlice: $295ca3e31a29edec$export$2e2bcd8739ae039,
    licencesSlice: $9abcdbaae8311c9d$export$2e2bcd8739ae039
});
var $d6d6df2b6f8af4bf$export$2e2bcd8739ae039 = $d6d6df2b6f8af4bf$var$rootReducer;


const $2994cb1ba75a7bb3$var$composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $71488736b7fc99c4$export$f672e0b6f7222cd7);
const $2994cb1ba75a7bb3$var$store = (0, $71488736b7fc99c4$export$f51a9068ac82ea43)((0, $d6d6df2b6f8af4bf$export$2e2bcd8739ae039), $2994cb1ba75a7bb3$var$composeEnhancer((0, $71488736b7fc99c4$export$9ff26e0402cc7b7)((0, $1ab49e43fd6bbe7b$export$2e2bcd8739ae039))));
var $2994cb1ba75a7bb3$export$2e2bcd8739ae039 = $2994cb1ba75a7bb3$var$store;






var $7fPBF = parcelRequire("7fPBF");
var $da571d235d718dda$exports = {};
var $ce77166c8438e964$exports = {};
function $ce77166c8438e964$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$ce77166c8438e964$exports = $ce77166c8438e964$var$_arrayWithHoles, $ce77166c8438e964$exports.__esModule = true, $ce77166c8438e964$exports["default"] = $ce77166c8438e964$exports;


var $20e94df54b7e2c18$exports = {};
function $20e94df54b7e2c18$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$20e94df54b7e2c18$exports = $20e94df54b7e2c18$var$_iterableToArrayLimit, $20e94df54b7e2c18$exports.__esModule = true, $20e94df54b7e2c18$exports["default"] = $20e94df54b7e2c18$exports;


var $3e9b9f2b208dfc3f$exports = {};
var $cf96c9667eae972c$exports = {};
function $cf96c9667eae972c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$cf96c9667eae972c$exports = $cf96c9667eae972c$var$_arrayLikeToArray, $cf96c9667eae972c$exports.__esModule = true, $cf96c9667eae972c$exports["default"] = $cf96c9667eae972c$exports;


function $3e9b9f2b208dfc3f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cf96c9667eae972c$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cf96c9667eae972c$exports(r, a) : void 0;
    }
}
$3e9b9f2b208dfc3f$exports = $3e9b9f2b208dfc3f$var$_unsupportedIterableToArray, $3e9b9f2b208dfc3f$exports.__esModule = true, $3e9b9f2b208dfc3f$exports["default"] = $3e9b9f2b208dfc3f$exports;


var $c41d81e3d1c59d7f$exports = {};
function $c41d81e3d1c59d7f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$c41d81e3d1c59d7f$exports = $c41d81e3d1c59d7f$var$_nonIterableRest, $c41d81e3d1c59d7f$exports.__esModule = true, $c41d81e3d1c59d7f$exports["default"] = $c41d81e3d1c59d7f$exports;


function $da571d235d718dda$var$_slicedToArray(r, e) {
    return $ce77166c8438e964$exports(r) || $20e94df54b7e2c18$exports(r, e) || $3e9b9f2b208dfc3f$exports(r, e) || $c41d81e3d1c59d7f$exports();
}
$da571d235d718dda$exports = $da571d235d718dda$var$_slicedToArray, $da571d235d718dda$exports.__esModule = true, $da571d235d718dda$exports["default"] = $da571d235d718dda$exports;



var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");

function $445d14444882807b$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $445d14444882807b$var$alreadyWarned = {};
function $445d14444882807b$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $445d14444882807b$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $445d14444882807b$var$alreadyWarned[args[0]] = new Date();
    $445d14444882807b$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $445d14444882807b$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    });
}
function $445d14444882807b$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $445d14444882807b$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $445d14444882807b$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $445d14444882807b$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $445d14444882807b$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


function $9c081519ec78392c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9c081519ec78392c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9c081519ec78392c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9c081519ec78392c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $9c081519ec78392c$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $9c081519ec78392c$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $021c8539c0651064$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $021c8539c0651064$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $445d14444882807b$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = $9c081519ec78392c$var$_objectSpread($9c081519ec78392c$var$_objectSpread($9c081519ec78392c$var$_objectSpread({}, (0, $021c8539c0651064$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $445d14444882807b$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $7fPBF.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($da571d235d718dda$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $9c081519ec78392c$var$usePrevious(joinedNS);
    var isMounted = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}



var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $etJ3Q = parcelRequire("etJ3Q");

var $7Em3j = parcelRequire("7Em3j");

var $1sMi9 = parcelRequire("1sMi9");

var $dKzJP = parcelRequire("dKzJP");

var $5oAE5 = parcelRequire("5oAE5");


var $bG0nA = parcelRequire("bG0nA");

var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $ckpfM = parcelRequire("ckpfM");

var $2jEfe = parcelRequire("2jEfe");
var $c3110a4db551a5fc$export$9dd6ff9ea0189349 = function styles(theme) {
    var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
    var backgroundColor = (0, $2jEfe.emphasize)(theme.palette.background.default, emphasis);
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({}, theme.typography.body2, (0, $dQMrF.default)({
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            padding: '6px 16px',
            borderRadius: theme.shape.borderRadius,
            flexGrow: 1
        }, theme.breakpoints.up('sm'), {
            flexGrow: 'initial',
            minWidth: 288
        })),
        /* Styles applied to the message wrapper element. */ message: {
            padding: '8px 0'
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $c3110a4db551a5fc$var$SnackbarContent = /*#__PURE__*/ $7fPBF.forwardRef(function SnackbarContent(props, ref) {
    var action = props.action, classes = props.classes, className = props.className, message = props.message, _props$role = props.role, role = _props$role === void 0 ? 'alert' : _props$role, other = (0, $lfiYO.default)(props, [
        "action",
        "classes",
        "className",
        "message",
        "role"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $ckpfM.default), (0, $kY3Ke.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $jtRae.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.message
    }, message), action ? /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.action
    }, action) : null);
});
var $c3110a4db551a5fc$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($c3110a4db551a5fc$export$9dd6ff9ea0189349, {
    name: 'MuiSnackbarContent'
})($c3110a4db551a5fc$var$SnackbarContent);


var $562d3dadded7df64$export$9dd6ff9ea0189349 = function styles(theme) {
    var top1 = {
        top: 8
    };
    var bottom1 = {
        bottom: 8
    };
    var right = {
        justifyContent: 'flex-end'
    };
    var left = {
        justifyContent: 'flex-start'
    };
    var top3 = {
        top: 24
    };
    var bottom3 = {
        bottom: 24
    };
    var right3 = {
        right: 24
    };
    var left3 = {
        left: 24
    };
    var center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return {
        /* Styles applied to the root element. */ root: {
            zIndex: theme.zIndex.snackbar,
            position: 'fixed',
            display: 'flex',
            left: 8,
            right: 8,
            justifyContent: 'center',
            alignItems: 'center'
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */ anchorOriginTopCenter: (0, $kY3Ke.default)({}, top1, (0, $dQMrF.default)({}, theme.breakpoints.up('sm'), (0, $kY3Ke.default)({}, top3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */ anchorOriginBottomCenter: (0, $kY3Ke.default)({}, bottom1, (0, $dQMrF.default)({}, theme.breakpoints.up('sm'), (0, $kY3Ke.default)({}, bottom3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */ anchorOriginTopRight: (0, $kY3Ke.default)({}, top1, right, (0, $dQMrF.default)({}, theme.breakpoints.up('sm'), (0, $kY3Ke.default)({
            left: 'auto'
        }, top3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */ anchorOriginBottomRight: (0, $kY3Ke.default)({}, bottom1, right, (0, $dQMrF.default)({}, theme.breakpoints.up('sm'), (0, $kY3Ke.default)({
            left: 'auto'
        }, bottom3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */ anchorOriginTopLeft: (0, $kY3Ke.default)({}, top1, left, (0, $dQMrF.default)({}, theme.breakpoints.up('sm'), (0, $kY3Ke.default)({
            right: 'auto'
        }, top3, left3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */ anchorOriginBottomLeft: (0, $kY3Ke.default)({}, bottom1, left, (0, $dQMrF.default)({}, theme.breakpoints.up('sm'), (0, $kY3Ke.default)({
            right: 'auto'
        }, bottom3, left3)))
    };
};
var $562d3dadded7df64$var$Snackbar = /*#__PURE__*/ $7fPBF.forwardRef(function Snackbar(props, ref) {
    var action = props.action, _props$anchorOrigin = props.anchorOrigin;
    _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: 'bottom',
        horizontal: 'center'
    } : _props$anchorOrigin;
    var vertical = _props$anchorOrigin.vertical, horizontal = _props$anchorOrigin.horizontal, _props$autoHideDurati = props.autoHideDuration, autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati, children = props.children, classes = props.classes, className = props.className, ClickAwayListenerProps = props.ClickAwayListenerProps, ContentProps = props.ContentProps, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, message = props.message, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $bG0nA.default) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? {
        enter: (0, $etJ3Q.duration).enteringScreen,
        exit: (0, $etJ3Q.duration).leavingScreen
    } : _props$transitionDura, TransitionProps = props.TransitionProps, other = (0, $lfiYO.default)(props, [
        "action",
        "anchorOrigin",
        "autoHideDuration",
        "children",
        "classes",
        "className",
        "ClickAwayListenerProps",
        "ContentProps",
        "disableWindowBlurListener",
        "message",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var timerAutoHide = $7fPBF.useRef();
    var _React$useState = $7fPBF.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var handleClose = (0, $1sMi9.default)(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = (0, $1sMi9.default)(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, 'timeout');
        }, autoHideDurationParam);
    });
    $7fPBF.useEffect(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]); // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    var handlePause = function handlePause() {
        clearTimeout(timerAutoHide.current);
    }; // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    var handleResume = $7fPBF.useCallback(function() {
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    var handleClickAway = function handleClickAway(event) {
        if (onClose) onClose(event, 'clickaway');
    };
    var handleExited = function handleExited() {
        setExited(true);
    };
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    $7fPBF.useEffect(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return function() {
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]); // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ $7fPBF.createElement((0, $7Em3j.default), (0, $kY3Ke.default)({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps), /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes["anchorOrigin".concat((0, $dKzJP.default)(vertical)).concat((0, $dKzJP.default)(horizontal))], className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        appear: true,
        in: open,
        onEnter: (0, $5oAE5.default)(handleEnter, onEnter),
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, $5oAE5.default)(handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up'
    }, TransitionProps), children || /*#__PURE__*/ $7fPBF.createElement((0, $c3110a4db551a5fc$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        message: message,
        action: action
    }, ContentProps)))));
});
var $562d3dadded7df64$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($562d3dadded7df64$export$9dd6ff9ea0189349, {
    flip: false,
    name: 'MuiSnackbar'
})($562d3dadded7df64$var$Snackbar);




var $by0pu = parcelRequire("by0pu");


var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $2jEfe = parcelRequire("2jEfe");
var $3Sc7z = parcelRequire("3Sc7z");

var $ckpfM = parcelRequire("ckpfM");

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $7a57195816e281af$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');



var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $f739defa9ffa4d2f$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');



var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $5645434583ed2ba4$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');



var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $00939a3ff2494974$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');



var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $7a12b650b33ab0e1$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $iRcsz = parcelRequire("iRcsz");

var $dKzJP = parcelRequire("dKzJP");
var $ba9f1ac4b3dbaa47$export$9dd6ff9ea0189349 = function styles(theme) {
    var getColor = theme.palette.type === 'light' ? (0, $2jEfe.darken) : (0, $2jEfe.lighten);
    var getBackgroundColor = theme.palette.type === 'light' ? (0, $2jEfe.lighten) : (0, $2jEfe.darken);
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({}, theme.typography.body2, {
            borderRadius: theme.shape.borderRadius,
            backgroundColor: 'transparent',
            display: 'flex',
            padding: '6px 16px'
        }),
        /* Styles applied to the root element if `variant="standard"` and `color="success"`. */ standardSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
            '& $icon': {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="info"`. */ standardInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
            '& $icon': {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */ standardWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
            '& $icon': {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="error"`. */ standardError: {
            color: getColor(theme.palette.error.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
            '& $icon': {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */ outlinedSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            border: "1px solid ".concat(theme.palette.success.main),
            '& $icon': {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */ outlinedInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            border: "1px solid ".concat(theme.palette.info.main),
            '& $icon': {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */ outlinedWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            border: "1px solid ".concat(theme.palette.warning.main),
            '& $icon': {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */ outlinedError: {
            color: getColor(theme.palette.error.main, 0.6),
            border: "1px solid ".concat(theme.palette.error.main),
            '& $icon': {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="filled"` and `color="success"`. */ filledSuccess: {
            color: '#fff',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.success.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="info"`. */ filledInfo: {
            color: '#fff',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.info.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */ filledWarning: {
            color: '#fff',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.warning.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="error"`. */ filledError: {
            color: '#fff',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.error.main
        },
        /* Styles applied to the icon wrapper element. */ icon: {
            marginRight: 12,
            padding: '7px 0',
            display: 'flex',
            fontSize: 22,
            opacity: 0.9
        },
        /* Styles applied to the message wrapper element. */ message: {
            padding: '8px 0'
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $ba9f1ac4b3dbaa47$var$defaultIconMapping = {
    success: /*#__PURE__*/ $7fPBF.createElement((0, $7a57195816e281af$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ $7fPBF.createElement((0, $f739defa9ffa4d2f$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ $7fPBF.createElement((0, $5645434583ed2ba4$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ $7fPBF.createElement((0, $00939a3ff2494974$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
var $ba9f1ac4b3dbaa47$var$_ref = /*#__PURE__*/ $7fPBF.createElement((0, $7a12b650b33ab0e1$export$2e2bcd8739ae039), {
    fontSize: "small"
});
var $ba9f1ac4b3dbaa47$var$Alert = /*#__PURE__*/ $7fPBF.forwardRef(function Alert(props, ref) {
    var action = props.action, children = props.children, classes = props.classes, className = props.className, _props$closeText = props.closeText, closeText = _props$closeText === void 0 ? 'Close' : _props$closeText, color = props.color, icon = props.icon, _props$iconMapping = props.iconMapping, iconMapping = _props$iconMapping === void 0 ? $ba9f1ac4b3dbaa47$var$defaultIconMapping : _props$iconMapping, onClose = props.onClose, _props$role = props.role, role = _props$role === void 0 ? 'alert' : _props$role, _props$severity = props.severity, severity = _props$severity === void 0 ? 'success' : _props$severity, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $lfiYO.default)(props, [
        "action",
        "children",
        "classes",
        "className",
        "closeText",
        "color",
        "icon",
        "iconMapping",
        "onClose",
        "role",
        "severity",
        "variant"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $ckpfM.default), (0, $kY3Ke.default)({
        role: role,
        square: true,
        elevation: 0,
        className: (0, $jtRae.default)(classes.root, classes["".concat(variant).concat((0, $dKzJP.default)(color || severity))], className),
        ref: ref
    }, other), icon !== false ? /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.icon
    }, icon || iconMapping[severity] || $ba9f1ac4b3dbaa47$var$defaultIconMapping[severity]) : null, /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.message
    }, children), action != null ? /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.action
    }, action) : null, action == null && onClose ? /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.action
    }, /*#__PURE__*/ $7fPBF.createElement((0, $iRcsz.default), {
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
    }, $ba9f1ac4b3dbaa47$var$_ref)) : null);
});
var $ba9f1ac4b3dbaa47$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($ba9f1ac4b3dbaa47$export$9dd6ff9ea0189349, {
    name: 'MuiAlert'
})($ba9f1ac4b3dbaa47$var$Alert);



var $kY3Ke = parcelRequire("kY3Ke");

var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");



var $8qMCX = parcelRequire("8qMCX");

var $3Sc7z = parcelRequire("3Sc7z");

var $etJ3Q = parcelRequire("etJ3Q");


var $2Jy9X = parcelRequire("2Jy9X");

var $fH0xA = parcelRequire("fH0xA");

var $55RWP = parcelRequire("55RWP");
var $7e9dc35171fa81c7$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 0,
            overflow: 'hidden',
            transition: theme.transitions.create('height')
        },
        /* Styles applied to the root element when the transition has entered. */ entered: {
            height: 'auto',
            overflow: 'visible'
        },
        /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */ hidden: {
            visibility: 'hidden'
        },
        /* Styles applied to the outer wrapper element. */ wrapper: {
            // Hack to get children with a negative margin to not falsify the height computation.
            display: 'flex'
        },
        /* Styles applied to the inner wrapper element. */ wrapperInner: {
            width: '100%'
        }
    };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $7e9dc35171fa81c7$var$Collapse = /*#__PURE__*/ $7fPBF.forwardRef(function Collapse(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, collapsedHeight = props.collapsedHeight, _props$collapsedSize = props.collapsedSize, collapsedSizeProp = _props$collapsedSize === void 0 ? '0px' : _props$collapsedSize, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? (0, $etJ3Q.duration).standard : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $8qMCX.default) : _props$TransitionComp, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "collapsedHeight",
        "collapsedSize",
        "component",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $fH0xA.default)();
    var timer = $7fPBF.useRef();
    var wrapperRef = $7fPBF.useRef(null);
    var autoTransitionDuration = $7fPBF.useRef();
    var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === 'number' ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
    $7fPBF.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $7fPBF.useRef(null);
    var handleRef = (0, $55RWP.default)(ref, enableStrictModeCompat ? nodeRef : undefined);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $2gIIh.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps = (0, $2Jy9X.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration;
        if (timeout === 'auto') {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = "".concat(wrapperHeight, "px");
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    var handleExit = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        node.style.height = "".concat(wrapperHeight, "px");
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleExiting = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps2 = (0, $2Jy9X.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration;
        if (timeout === 'auto') {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = collapsedSize;
        if (onExiting) onExiting(node);
    });
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    };
    return /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
            className: (0, $jtRae.default)(classes.root, classes.container, className, {
                'entered': classes.entered,
                'exited': !inProp && collapsedSize === '0px' && classes.hidden
            }[state]),
            style: (0, $kY3Ke.default)({
                minHeight: collapsedSize
            }, style),
            ref: handleRef
        }, childProps), /*#__PURE__*/ $7fPBF.createElement("div", {
            className: classes.wrapper,
            ref: wrapperRef
        }, /*#__PURE__*/ $7fPBF.createElement("div", {
            className: classes.wrapperInner
        }, children)));
    });
});
$7e9dc35171fa81c7$var$Collapse.muiSupportAuto = true;
var $7e9dc35171fa81c7$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($7e9dc35171fa81c7$export$9dd6ff9ea0189349, {
    name: 'MuiCollapse'
})($7e9dc35171fa81c7$var$Collapse);



var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $fw0lo = parcelRequire("fw0lo");

var $kyQ4S = parcelRequire("kyQ4S");

var $8qMCX = parcelRequire("8qMCX");


var $55RWP = parcelRequire("55RWP");

var $fH0xA = parcelRequire("fH0xA");

var $etJ3Q = parcelRequire("etJ3Q");

var $2Jy9X = parcelRequire("2Jy9X");
// Later, we gonna translate back the node to his original location
// with `none`.`
function $24065f65990d49ec$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = window.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
    if (direction === 'right') return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
    if (direction === 'up') return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
     // direction === 'down'
    return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}
function $24065f65990d49ec$export$f820ccdc5b48abdf(direction, node) {
    var transform = $24065f65990d49ec$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $24065f65990d49ec$var$defaultTimeout = {
    enter: (0, $etJ3Q.duration).enteringScreen,
    exit: (0, $etJ3Q.duration).leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $24065f65990d49ec$var$Slide = /*#__PURE__*/ $7fPBF.forwardRef(function Slide(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $24065f65990d49ec$var$defaultTimeout : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $8qMCX.default) : _props$TransitionComp, other = (0, $lfiYO.default)(props, [
        "children",
        "direction",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $fH0xA.default)();
    var childrenRef = $7fPBF.useRef(null);
    /**
   * used in cloneElement(children, { ref: handleRef })
   */ var handleOwnRef = $7fPBF.useCallback(function(instance) {
        // #StrictMode ready
        childrenRef.current = $fw0lo.findDOMNode(instance);
    }, []);
    var handleRefIntermediary = (0, $55RWP.default)(children.ref, handleOwnRef);
    var handleRef = (0, $55RWP.default)(handleRefIntermediary, ref);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(isAppearing) {
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        $24065f65990d49ec$export$f820ccdc5b48abdf(direction, node);
        (0, $2Jy9X.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var transitionProps = (0, $2Jy9X.getTransitionProps)({
            timeout: timeout,
            style: style
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $kY3Ke.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.transition = theme.transitions.create('transform', (0, $kY3Ke.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $2Jy9X.getTransitionProps)({
            timeout: timeout,
            style: style
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $kY3Ke.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        node.style.transition = theme.transitions.create('transform', (0, $kY3Ke.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        $24065f65990d49ec$export$f820ccdc5b48abdf(direction, node);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(function(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    var updatePosition = $7fPBF.useCallback(function() {
        if (childrenRef.current) $24065f65990d49ec$export$f820ccdc5b48abdf(direction, childrenRef.current);
    }, [
        direction
    ]);
    $7fPBF.useEffect(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = (0, $kyQ4S.default)(function() {
            if (childrenRef.current) $24065f65990d49ec$export$f820ccdc5b48abdf(direction, childrenRef.current);
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    $7fPBF.useEffect(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        appear: true,
        in: inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
            ref: handleRef,
            style: (0, $kY3Ke.default)({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, children.props.style)
        }, childProps));
    });
});
var $24065f65990d49ec$export$2e2bcd8739ae039 = $24065f65990d49ec$var$Slide;


function $eb9c38114fe0ef26$var$SlideTransition(props) {
    if (props.in) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24065f65990d49ec$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        direction: "up"
    }));
    else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $24065f65990d49ec$export$2e2bcd8739ae039), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        direction: "right"
    }));
}
function $eb9c38114fe0ef26$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const alerts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.alerts);
    const [open, setOpen] = (0, $7fPBF.useState)(true);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const handleClose = ()=>{
        if (alerts.length === 1) {
            setOpen(false);
            dispatch((0, $b4a8182390b65be8$export$6b49420dc69c7fe4)());
            setTimeout(setOpen(true), 200);
        } else {
            setOpen(false);
            dispatch((0, $b4a8182390b65be8$export$6b49420dc69c7fe4)());
        }
    };
    const onExited = ()=>{
        setOpen(true);
    };
    const useStyles = (0, $by0pu.default)((theme)=>({
            snack: {
                minWidth: '400px',
                marginBottom: '30px',
                [theme.breakpoints.down('xs')]: {
                    minWidth: '100px'
                }
            },
            fakeSnack: {
                minWidth: '400px',
                [theme.breakpoints.down('xs')]: {
                    minWidth: '300px'
                }
            }
        }));
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: alerts.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $562d3dadded7df64$export$2e2bcd8739ae039), {
                    open: open,
                    TransitionComponent: $eb9c38114fe0ef26$var$SlideTransition,
                    onExited: onExited,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                    },
                    transitionDuration: {
                        enter: 200,
                        exit: 200
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f1ac4b3dbaa47$export$2e2bcd8739ae039), {
                        className: classes.snack,
                        variant: "filled",
                        onClose: handleClose,
                        severity: alerts[alerts.length - 1].severity,
                        children: t(alerts[alerts.length - 1].message)
                    })
                }),
                alerts.length > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $562d3dadded7df64$export$2e2bcd8739ae039), {
                    open: open,
                    TransitionProps: {
                        appear: false
                    },
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e9dc35171fa81c7$export$2e2bcd8739ae039), {
                        in: false,
                        collapsedHeight: 20,
                        className: classes.fakeSnack,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f1ac4b3dbaa47$export$2e2bcd8739ae039), {
                            className: classes.fakeSnack,
                            variant: "filled",
                            severity: alerts[alerts.length - 2].severity,
                            children: alerts[alerts.length - 2].message
                        })
                    })
                })
            ]
        })
    });
}



parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $1aa952074218c40d$export$407448d2b89b1813 = (0, $7fPBF.createContext)(null);
var $1aa952074218c40d$export$3a1a48c8f6ef640e = function MuiPickersUtilsProvider(_ref) {
    var Utils = _ref.utils, children = _ref.children, locale = _ref.locale, libInstance = _ref.libInstance;
    var utils = (0, $7fPBF.useMemo)(function() {
        return new Utils({
            locale: locale,
            instance: libInstance
        });
    }, [
        Utils,
        libInstance,
        locale
    ]);
    return (0, $7fPBF.createElement)($1aa952074218c40d$export$407448d2b89b1813.Provider, {
        value: utils,
        children: children
    });
};
var $1aa952074218c40d$var$checkUtils = function checkUtils(utils) {
    if (!utils) // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
};
function $1aa952074218c40d$export$3b14a55fb2447963() {
    var utils = (0, $7fPBF.useContext)($1aa952074218c40d$export$407448d2b89b1813);
    $1aa952074218c40d$var$checkUtils(utils);
    return utils;
}


function $c41ae7eb91efecef$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}



var $6TO5S = parcelRequire("6TO5S");
function $f4ec6dc17078088c$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $05b104d2fa74b1c7$export$2e2bcd8739ae039(argument) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $6TO5S.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $bad15b7880e6f97c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $b6e79fa3dbe621a2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $3b831424db570743$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}




function $656b09e1b179d990$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dateRight).getTime();
}




function $ce8f943b2f1f7b6a$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}




function $5cd7293820fa2400$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}


var $677412d78fecbb8b$var$defaultOptions = {};
function $677412d78fecbb8b$export$430a3269e24b912e() {
    return $677412d78fecbb8b$var$defaultOptions;
}
function $677412d78fecbb8b$export$95365be1b0704abc(newOptions) {
    $677412d78fecbb8b$var$defaultOptions = newOptions;
}





function $3a7443c6796c86d0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $c6b92cd202ceada3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



var $6TO5S = parcelRequire("6TO5S");

function $759553f6ee74cd0d$export$2e2bcd8739ae039(value) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $6TO5S.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $374216e389d08fec$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $759553f6ee74cd0d$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}





function $bd716e10292c6930$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $34348cf8fa5b62a4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $afb60d42de991571$var$MILLISECONDS_IN_DAY = 86400000;
function $afb60d42de991571$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $afb60d42de991571$var$MILLISECONDS_IN_DAY) + 1;
}





function $365301764998b714$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $518eb844f291f762$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $41042352236130d1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $518eb844f291f762$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK = 604800000;
function $b0bdf1d2df59ff38$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $365301764998b714$export$2e2bcd8739ae039)(date).getTime() - (0, $41042352236130d1$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK) + 1;
}








function $66392cbb34f04ad9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $bf632f7e6fcf0087$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $37d853466602e505$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK = 604800000;
function $57d2e8e06c23527b$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options).getTime() - (0, $37d853466602e505$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK) + 1;
}



function $598d25c1f2e4f194$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8845d2e14e26c506$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8845d2e14e26c506$export$2e2bcd8739ae039 = $8845d2e14e26c506$var$formatters;


var $71a1c96437171265$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $71a1c96437171265$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $518eb844f291f762$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $57d2e8e06c23527b$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $b0bdf1d2df59ff38$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $afb60d42de991571$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $71a1c96437171265$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $71a1c96437171265$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(minutes, 2);
}
function $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter);
}
function $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $71a1c96437171265$export$2e2bcd8739ae039 = $71a1c96437171265$var$formatters;


var $eeef144218f64d7d$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $eeef144218f64d7d$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $eeef144218f64d7d$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $eeef144218f64d7d$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $eeef144218f64d7d$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $eeef144218f64d7d$var$timeLongFormatter(timePattern, formatLong));
};
var $eeef144218f64d7d$var$longFormatters = {
    p: $eeef144218f64d7d$var$timeLongFormatter,
    P: $eeef144218f64d7d$var$dateTimeLongFormatter
};
var $eeef144218f64d7d$export$2e2bcd8739ae039 = $eeef144218f64d7d$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a197590075b6aa6e$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $12a3ea762b495ad3$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $12a3ea762b495ad3$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $12a3ea762b495ad3$export$c6cc36aa33304772(token) {
    return $12a3ea762b495ad3$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$c6b49d6dceb604a1(token) {
    return $12a3ea762b495ad3$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $2a93defe0440ad2b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $2a93defe0440ad2b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2a93defe0440ad2b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $2a93defe0440ad2b$export$2e2bcd8739ae039 = $2a93defe0440ad2b$var$formatDistance;


function $55e1f9cf760fc530$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $a6fa3c1fbba4fd67$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a6fa3c1fbba4fd67$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a6fa3c1fbba4fd67$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a6fa3c1fbba4fd67$var$formatLong = {
    date: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a6fa3c1fbba4fd67$export$2e2bcd8739ae039 = $a6fa3c1fbba4fd67$var$formatLong;


var $5f9228dede0d6aa7$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $5f9228dede0d6aa7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5f9228dede0d6aa7$var$formatRelativeLocale[token];
};
var $5f9228dede0d6aa7$export$2e2bcd8739ae039 = $5f9228dede0d6aa7$var$formatRelative;


function $457628062959e556$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $0ff1d0e06551a5c1$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $0ff1d0e06551a5c1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0ff1d0e06551a5c1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $0ff1d0e06551a5c1$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $0ff1d0e06551a5c1$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $0ff1d0e06551a5c1$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $0ff1d0e06551a5c1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $0ff1d0e06551a5c1$var$localize = {
    ordinalNumber: $0ff1d0e06551a5c1$var$ordinalNumber,
    era: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0ff1d0e06551a5c1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0ff1d0e06551a5c1$export$2e2bcd8739ae039 = $0ff1d0e06551a5c1$var$localize;


function $f58f09468deb70ae$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f58f09468deb70ae$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f58f09468deb70ae$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f58f09468deb70ae$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f58f09468deb70ae$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $ed51bd2201b1ffe0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $7cafbb556cfb2776$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $7cafbb556cfb2776$var$parseOrdinalNumberPattern = /\d+/i;
var $7cafbb556cfb2776$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $7cafbb556cfb2776$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $7cafbb556cfb2776$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $7cafbb556cfb2776$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7cafbb556cfb2776$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $7cafbb556cfb2776$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $7cafbb556cfb2776$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $7cafbb556cfb2776$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $7cafbb556cfb2776$var$match = {
    ordinalNumber: (0, $ed51bd2201b1ffe0$export$2e2bcd8739ae039)({
        matchPattern: $7cafbb556cfb2776$var$matchOrdinalNumberPattern,
        parsePattern: $7cafbb556cfb2776$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7cafbb556cfb2776$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7cafbb556cfb2776$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7cafbb556cfb2776$export$2e2bcd8739ae039 = $7cafbb556cfb2776$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $fbb6af908147d006$var$locale = {
    code: 'en-US',
    formatDistance: (0, $2a93defe0440ad2b$export$2e2bcd8739ae039),
    formatLong: (0, $a6fa3c1fbba4fd67$export$2e2bcd8739ae039),
    formatRelative: (0, $5f9228dede0d6aa7$export$2e2bcd8739ae039),
    localize: (0, $0ff1d0e06551a5c1$export$2e2bcd8739ae039),
    match: (0, $7cafbb556cfb2776$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fbb6af908147d006$export$2e2bcd8739ae039 = $fbb6af908147d006$var$locale;


var $e94e6c2283c04dc4$export$2e2bcd8739ae039 = (0, $fbb6af908147d006$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0918c9925a326e99$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0918c9925a326e99$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0918c9925a326e99$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0918c9925a326e99$var$doubleQuoteRegExp = /''/g;
var $0918c9925a326e99$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $0918c9925a326e99$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $e94e6c2283c04dc4$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $374216e389d08fec$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $34348cf8fa5b62a4$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0918c9925a326e99$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $eeef144218f64d7d$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($0918c9925a326e99$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0918c9925a326e99$var$cleanEscapedString(substring);
        var formatter = (0, $71a1c96437171265$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $12a3ea762b495ad3$export$c6b49d6dceb604a1)(substring)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $12a3ea762b495ad3$export$c6cc36aa33304772)(substring)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0918c9925a326e99$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $0918c9925a326e99$var$cleanEscapedString(input) {
    var matched = input.match($0918c9925a326e99$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($0918c9925a326e99$var$doubleQuoteRegExp, "'");
}




function $d0f608c42e15b075$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}




function $128ac71efb3a2f51$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}




function $88155eb6456a8ca8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}




function $3467188658b165bd$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}




function $8f5ca214877b2a80$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $0659d9ec4d7dbbf0$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}




function $e114ae87b2fb4d54$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $849043f97da8598e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}




function $f3df37b4dec5127a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $61980f1dae65c9e0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $36601e4381c8841a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $8b16156dc6f0bfd4$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfHour = (0, $36601e4381c8841a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $36601e4381c8841a$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}




var $6TO5S = parcelRequire("6TO5S");

var $6A22e = parcelRequire("6A22e");
function $e24194a208e52c1b$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $6A22e.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}





function $6f0e75fc27c44afd$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}








var $3zeAJ = parcelRequire("3zeAJ");


function $cb0780e1471bbfb2$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cb0780e1471bbfb2$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $c2ec9395872a8e53$export$2e2bcd8739ae039(t) {
    var r = (0, $cb0780e1471bbfb2$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, e);
    };
}



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $dQMrF = parcelRequire("dQMrF");
var $f8f535a8fee12b58$var$TIMEZONE_UNIT_PRIORITY = 10;
var $f8f535a8fee12b58$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $03dWn.default)(this, Setter);
        (0, $dQMrF.default)(this, "priority", void 0);
        (0, $dQMrF.default)(this, "subPriority", 0);
    }
    (0, $4OFm0.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $f8f535a8fee12b58$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $03dWn.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $4OFm0.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($f8f535a8fee12b58$export$81d53e3678089a6);
var $f8f535a8fee12b58$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $03dWn.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this2), "priority", $f8f535a8fee12b58$var$TIMEZONE_UNIT_PRIORITY);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $4OFm0.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($f8f535a8fee12b58$export$81d53e3678089a6);



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $dQMrF = parcelRequire("dQMrF");

var $d59a769c05ef4f32$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $03dWn.default)(this, Parser);
        (0, $dQMrF.default)(this, "incompatibleTokens", void 0);
        (0, $dQMrF.default)(this, "priority", void 0);
        (0, $dQMrF.default)(this, "subPriority", void 0);
    }
    (0, $4OFm0.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $f8f535a8fee12b58$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $453e127a2cb59433$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $03dWn.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 140);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $b22734c988ed96b7$export$dfd9b671c89acc8e = 7;
var $b22734c988ed96b7$export$3913210603d8e9ae = 365.2425;
var $b22734c988ed96b7$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $b22734c988ed96b7$export$91246f0b9bd9beff = 60000;
var $b22734c988ed96b7$export$7f72910d6dfd237a = 3600000;
var $b22734c988ed96b7$export$397c2d5776aa9055 = 1000;
var $b22734c988ed96b7$export$4dec998e48f9c246 = -$b22734c988ed96b7$export$81caae6e1cc7a622;
var $b22734c988ed96b7$export$f2f5ae5a8e2d8f9f = 60;
var $b22734c988ed96b7$export$3c58128db900d44e = 3;
var $b22734c988ed96b7$export$80d7e435f744f319 = 12;
var $b22734c988ed96b7$export$4db7641526e3241f = 4;
var $b22734c988ed96b7$export$698aec755e92c695 = 3600;
var $b22734c988ed96b7$export$a77c1a7ebebe2a5a = 60;
var $b22734c988ed96b7$export$815a9362476d2fe3 = $b22734c988ed96b7$export$698aec755e92c695 * 24;
var $b22734c988ed96b7$export$34804a017b31e2fe = $b22734c988ed96b7$export$815a9362476d2fe3 * 7;
var $b22734c988ed96b7$export$7271e9e3478110d1 = $b22734c988ed96b7$export$815a9362476d2fe3 * $b22734c988ed96b7$export$3913210603d8e9ae;
var $b22734c988ed96b7$export$8e6600bbdee7dabb = $b22734c988ed96b7$export$7271e9e3478110d1 / 12;
var $b22734c988ed96b7$export$be1dccf2de902d31 = $b22734c988ed96b7$export$8e6600bbdee7dabb * 3;


var $2f2b89d1b907546d$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $2f2b89d1b907546d$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $cac12873b21a7f06$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $cac12873b21a7f06$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cac12873b21a7f06$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $b22734c988ed96b7$export$7f72910d6dfd237a) + minutes * (0, $b22734c988ed96b7$export$91246f0b9bd9beff) + seconds * (0, $b22734c988ed96b7$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cac12873b21a7f06$export$d931c43c4608a164(dateString) {
    return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $cac12873b21a7f06$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $cac12873b21a7f06$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $cac12873b21a7f06$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $cac12873b21a7f06$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $cac12873b21a7f06$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $c1b2aad30ed081d9$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $03dWn.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $cac12873b21a7f06$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");




var $fd8a5a4d27b95514$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $03dWn.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $cac12873b21a7f06$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $b79f45105f4fc5bf$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $03dWn.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(4, dateString);
                return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $365301764998b714$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $d288b29c63f12ba7$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $03dWn.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(4, dateString);
                return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $f189536e19579fc7$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $03dWn.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 120);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $235c501771f8f2c8$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $03dWn.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 120);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $8cf9037af5c80a6b$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $03dWn.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 110);
        return _this;
    }
    (0, $4OFm0.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $e2c6ed9eece38c05$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $03dWn.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 110);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");







function $9f415d9aa929cb5f$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $57d2e8e06c23527b$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $1390979b933b1e35$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $03dWn.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 100);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)((0, $9f415d9aa929cb5f$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");







function $c23fbe21a3e9d7ec$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $b0bdf1d2df59ff38$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $51ad9c3a7ea45056$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $03dWn.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 100);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $365301764998b714$export$2e2bcd8739ae039)((0, $c23fbe21a3e9d7ec$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $e79adff529ff7d87$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e79adff529ff7d87$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e79adff529ff7d87$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $03dWn.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "subPriority", 1);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $cac12873b21a7f06$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $e79adff529ff7d87$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $e79adff529ff7d87$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $df3cfb3868b5f2d9$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $03dWn.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "subpriority", 1);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $cac12873b21a7f06$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");





function $dad70b9d49228da0$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $59f2ba411bffa594$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $03dWn.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $9fa34d129085f38e$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $03dWn.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $10ea24d6b77d76b5$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $03dWn.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");





function $782a867d325da60d$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $9fafc31a4201a6f4$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $03dWn.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $782a867d325da60d$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $f000735938cd3f06$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $03dWn.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $a786258bf503f7be$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $03dWn.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $08b08c6d5753cdfd$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $03dWn.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $4b936300b1515974$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $03dWn.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $fd3b98057917a9cb$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $03dWn.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $50f15d1a322aa483$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $03dWn.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $1f44a4cabb386e21$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $03dWn.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $90a17725cd6a5e78$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $03dWn.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 60);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $5849ee64b8145759$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $03dWn.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 50);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $ad67721c76585871$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $03dWn.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 30);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $f1ec95a2e92c6a8e$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $03dWn.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 10);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");



var $9f4e851982e313bd$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $03dWn.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 10);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $4OFm0.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $d1d76f4ee5cb7969$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $03dWn.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 40);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $4OFm0.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $cac12873b21a7f06$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");



var $dQMrF = parcelRequire("dQMrF");


var $e4fe9dee5db1b18a$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $03dWn.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "priority", 20);
        (0, $dQMrF.default)((0, $3zeAJ.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $4OFm0.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $cac12873b21a7f06$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));


var $a9a09c5462def3d7$export$19131010e7fd8373 = {
    G: new (0, $453e127a2cb59433$export$8e5a1d3f85a9688)(),
    y: new (0, $c1b2aad30ed081d9$export$48d352de7cd4a988)(),
    Y: new (0, $fd8a5a4d27b95514$export$b8ef38dfcf05d5db)(),
    R: new (0, $b79f45105f4fc5bf$export$951d1df011fde06f)(),
    u: new (0, $d288b29c63f12ba7$export$bad9d2ea38e8f1a)(),
    Q: new (0, $f189536e19579fc7$export$5cb0f701186dde1d)(),
    q: new (0, $235c501771f8f2c8$export$300c0c2990e20e6d)(),
    M: new (0, $8cf9037af5c80a6b$export$400dd8b40ef138a3)(),
    L: new (0, $e2c6ed9eece38c05$export$1d7eaa53eaa5deba)(),
    w: new (0, $1390979b933b1e35$export$c4005ffc174e07c0)(),
    I: new (0, $51ad9c3a7ea45056$export$6fc8dbedd560a6af)(),
    d: new (0, $e79adff529ff7d87$export$e8d4b28a20981dd2)(),
    D: new (0, $df3cfb3868b5f2d9$export$6cfe0d613455f615)(),
    E: new (0, $59f2ba411bffa594$export$1b03c8b76262f7bd)(),
    e: new (0, $9fa34d129085f38e$export$44d1c127ab42c480)(),
    c: new (0, $10ea24d6b77d76b5$export$e447a647caaaec1d)(),
    i: new (0, $9fafc31a4201a6f4$export$693fb1e525095b2a)(),
    a: new (0, $f000735938cd3f06$export$8d1e08492351df91)(),
    b: new (0, $a786258bf503f7be$export$73ca2bd0a17d273)(),
    B: new (0, $08b08c6d5753cdfd$export$bb9212adf05373db)(),
    h: new (0, $4b936300b1515974$export$8a04050a727a1756)(),
    H: new (0, $fd3b98057917a9cb$export$e56f4dea2c3e56dd)(),
    K: new (0, $50f15d1a322aa483$export$cbbe855312f87d77)(),
    k: new (0, $1f44a4cabb386e21$export$6008046d2b34b6a5)(),
    m: new (0, $90a17725cd6a5e78$export$2b52670d9e2be53)(),
    s: new (0, $5849ee64b8145759$export$94d46d540cf1366a)(),
    S: new (0, $ad67721c76585871$export$b8e6f8b2d70893b1)(),
    X: new (0, $f1ec95a2e92c6a8e$export$104d901d49fea29b)(),
    x: new (0, $9f4e851982e313bd$export$12910e5204b52b9)(),
    t: new (0, $d1d76f4ee5cb7969$export$2cd8bf877a05e96)(),
    T: new (0, $e4fe9dee5db1b18a$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e23ab16419322690$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e23ab16419322690$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e23ab16419322690$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e23ab16419322690$var$doubleQuoteRegExp = /''/g;
var $e23ab16419322690$var$notWhitespaceRegExp = /\S/;
var $e23ab16419322690$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e23ab16419322690$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $e94e6c2283c04dc4$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $f8f535a8fee12b58$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($e23ab16419322690$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $eeef144218f64d7d$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $eeef144218f64d7d$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($e23ab16419322690$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $e24194a208e52c1b$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $12a3ea762b495ad3$export$c6b49d6dceb604a1)(token)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $12a3ea762b495ad3$export$c6cc36aa33304772)(token)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $a9a09c5462def3d7$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($e23ab16419322690$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $e23ab16419322690$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $6TO5S.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $e23ab16419322690$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $34348cf8fa5b62a4$export$2e2bcd8739ae039)(date, (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $e24194a208e52c1b$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $6f0e75fc27c44afd$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $e23ab16419322690$var$cleanEscapedString(input) {
    return input.match($e23ab16419322690$var$escapedStringRegExp)[1].replace($e23ab16419322690$var$doubleQuoteRegExp, "'");
}





function $ee39c98c5378a0a6$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}





function $bdc3656b920d564d$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}






function $1ba80981c4aaa361$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $5d7226012cddb1a9$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $1ba80981c4aaa361$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $88db1f07d3462e3c$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}





function $ae8d0a047d9558ed$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}





function $e8b720dd7751e2f7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $caa0de56b1948e3d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}






function $580c0aebe042d20a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $eb08625b8e4078ad$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $ea2deec7f5afe484$var$DateFnsUtils = /** @class */ function() {
    function DateFnsUtils(_a) {
        var locale = (_a === void 0 ? {} : _a).locale;
        this.yearFormat = "yyyy";
        this.yearMonthFormat = "MMMM yyyy";
        this.dateTime12hFormat = "MMMM do hh:mm aaaa";
        this.dateTime24hFormat = "MMMM do HH:mm";
        this.time12hFormat = "hh:mm a";
        this.time24hFormat = "HH:mm";
        this.dateFormat = "MMMM do";
        this.locale = locale;
    }
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    DateFnsUtils.prototype.addDays = function(value, count) {
        return (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.isValid = function(value) {
        return (0, $374216e389d08fec$export$2e2bcd8739ae039)(this.date(value));
    };
    DateFnsUtils.prototype.getDiff = function(value, comparing) {
        return (0, $656b09e1b179d990$export$2e2bcd8739ae039)(value, this.date(comparing));
    };
    DateFnsUtils.prototype.isAfter = function(value, comparing) {
        return (0, $3467188658b165bd$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isBefore = function(value, comparing) {
        return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.startOfDay = function(value) {
        return (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.endOfDay = function(value) {
        return (0, $5cd7293820fa2400$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.getHours = function(value) {
        return (0, $d0f608c42e15b075$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setHours = function(value, count) {
        return (0, $ee39c98c5378a0a6$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.setMinutes = function(value, count) {
        return (0, $bdc3656b920d564d$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.getSeconds = function(value) {
        return (0, $128ac71efb3a2f51$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setSeconds = function(value, count) {
        return (0, $88db1f07d3462e3c$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.isSameDay = function(value, comparing) {
        return (0, $849043f97da8598e$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameMonth = function(value, comparing) {
        return (0, $61980f1dae65c9e0$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameYear = function(value, comparing) {
        return (0, $f3df37b4dec5127a$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameHour = function(value, comparing) {
        return (0, $8b16156dc6f0bfd4$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.startOfMonth = function(value) {
        return (0, $e8b720dd7751e2f7$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.endOfMonth = function(value) {
        return (0, $caa0de56b1948e3d$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.getYear = function(value) {
        return (0, $88155eb6456a8ca8$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setYear = function(value, count) {
        return (0, $ae8d0a047d9558ed$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.date = function(value) {
        if (typeof value === "undefined") return new Date();
        if (value === null) return null;
        return new Date(value);
    };
    DateFnsUtils.prototype.parse = function(value, formatString) {
        if (value === "") return null;
        return (0, $e23ab16419322690$export$2e2bcd8739ae039)(value, formatString, new Date(), {
            locale: this.locale
        });
    };
    DateFnsUtils.prototype.format = function(date, formatString) {
        return (0, $0918c9925a326e99$export$2e2bcd8739ae039)(date, formatString, {
            locale: this.locale
        });
    };
    DateFnsUtils.prototype.isEqual = function(date, comparing) {
        if (date === null && comparing === null) return true;
        return (0, $0659d9ec4d7dbbf0$export$2e2bcd8739ae039)(date, comparing);
    };
    DateFnsUtils.prototype.isNull = function(date) {
        return date === null;
    };
    DateFnsUtils.prototype.isAfterDay = function(date, value) {
        return (0, $3467188658b165bd$export$2e2bcd8739ae039)(date, (0, $5cd7293820fa2400$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isBeforeDay = function(date, value) {
        return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(date, (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isBeforeYear = function(date, value) {
        return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(date, (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isAfterYear = function(date, value) {
        return (0, $3467188658b165bd$export$2e2bcd8739ae039)(date, (0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.formatNumber = function(numberToFormat) {
        return numberToFormat;
    };
    DateFnsUtils.prototype.getMinutes = function(date) {
        return date.getMinutes();
    };
    DateFnsUtils.prototype.getMonth = function(date) {
        return date.getMonth();
    };
    DateFnsUtils.prototype.setMonth = function(date, count) {
        return (0, $5d7226012cddb1a9$export$2e2bcd8739ae039)(date, count);
    };
    DateFnsUtils.prototype.getMeridiemText = function(ampm) {
        return ampm === "am" ? "AM" : "PM";
    };
    DateFnsUtils.prototype.getNextMonth = function(date) {
        return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(date, 1);
    };
    DateFnsUtils.prototype.getPreviousMonth = function(date) {
        return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(date, -1);
    };
    DateFnsUtils.prototype.getMonthArray = function(date) {
        var firstMonth = (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(date);
        var monthArray = [
            firstMonth
        ];
        while(monthArray.length < 12){
            var prevMonth = monthArray[monthArray.length - 1];
            monthArray.push(this.getNextMonth(prevMonth));
        }
        return monthArray;
    };
    DateFnsUtils.prototype.mergeDateAndTime = function(date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    DateFnsUtils.prototype.getWeekdays = function() {
        var _this = this;
        var now = new Date();
        return (0, $ce8f943b2f1f7b6a$export$2e2bcd8739ae039)({
            start: (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(now, {
                locale: this.locale
            }),
            end: (0, $3a7443c6796c86d0$export$2e2bcd8739ae039)(now, {
                locale: this.locale
            })
        }).map(function(day) {
            return _this.format(day, "EEEEEE");
        });
    };
    DateFnsUtils.prototype.getWeekArray = function(date) {
        var start = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)((0, $e8b720dd7751e2f7$export$2e2bcd8739ae039)(date), {
            locale: this.locale
        });
        var end = (0, $3a7443c6796c86d0$export$2e2bcd8739ae039)((0, $caa0de56b1948e3d$export$2e2bcd8739ae039)(date), {
            locale: this.locale
        });
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while((0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(current, end)){
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    DateFnsUtils.prototype.getYearRange = function(start, end) {
        var startDate = (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(start);
        var endDate = (0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(end);
        var years = [];
        var current = startDate;
        while((0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(current, endDate)){
            years.push(current);
            current = (0, $3b831424db570743$export$2e2bcd8739ae039)(current, 1);
        }
        return years;
    };
    // displaying methpds
    DateFnsUtils.prototype.getCalendarHeaderText = function(date) {
        return this.format(date, this.yearMonthFormat);
    };
    DateFnsUtils.prototype.getYearText = function(date) {
        return this.format(date, "yyyy");
    };
    DateFnsUtils.prototype.getDatePickerHeaderText = function(date) {
        return this.format(date, "EEE, MMM d");
    };
    DateFnsUtils.prototype.getDateTimePickerHeaderText = function(date) {
        return this.format(date, "MMM d");
    };
    DateFnsUtils.prototype.getMonthText = function(date) {
        return this.format(date, "MMMM");
    };
    DateFnsUtils.prototype.getDayText = function(date) {
        return this.format(date, "d");
    };
    DateFnsUtils.prototype.getHourText = function(date, ampm) {
        return this.format(date, ampm ? "hh" : "HH");
    };
    DateFnsUtils.prototype.getMinuteText = function(date) {
        return this.format(date, "mm");
    };
    DateFnsUtils.prototype.getSecondText = function(date) {
        return this.format(date, "ss");
    };
    return DateFnsUtils;
}();
var $ea2deec7f5afe484$export$2e2bcd8739ae039 = $ea2deec7f5afe484$var$DateFnsUtils;







var $eb020cb44411c993$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $eb020cb44411c993$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $eb020cb44411c993$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $eb020cb44411c993$var$formatLong = {
    date: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $eb020cb44411c993$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $eb020cb44411c993$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $eb020cb44411c993$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $eb020cb44411c993$export$2e2bcd8739ae039 = $eb020cb44411c993$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $51943b9b451c992f$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $2a93defe0440ad2b$export$2e2bcd8739ae039),
    formatLong: (0, $eb020cb44411c993$export$2e2bcd8739ae039),
    formatRelative: (0, $5f9228dede0d6aa7$export$2e2bcd8739ae039),
    localize: (0, $0ff1d0e06551a5c1$export$2e2bcd8739ae039),
    match: (0, $7cafbb556cfb2776$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $51943b9b451c992f$export$2e2bcd8739ae039 = $51943b9b451c992f$var$locale;


var $a7d1b4e284a8a49e$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var $a7d1b4e284a8a49e$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $a7d1b4e284a8a49e$var$withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var $a7d1b4e284a8a49e$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $a7d1b4e284a8a49e$var$withSuffixes[key][comparison] : $a7d1b4e284a8a49e$var$withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $a7d1b4e284a8a49e$var$translations[adv] + ' ' + result;
    }
    return result;
};
var $a7d1b4e284a8a49e$export$2e2bcd8739ae039 = $a7d1b4e284a8a49e$var$formatDistance;



var $24d53fd1ac18bd14$var$dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var $24d53fd1ac18bd14$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $24d53fd1ac18bd14$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $24d53fd1ac18bd14$var$formatLong = {
    date: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $24d53fd1ac18bd14$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $24d53fd1ac18bd14$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $24d53fd1ac18bd14$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $24d53fd1ac18bd14$export$2e2bcd8739ae039 = $24d53fd1ac18bd14$var$formatLong;


var $a888d1191958cd8a$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function $a888d1191958cd8a$var$week(isFuture) {
    return function(date) {
        var weekday = $a888d1191958cd8a$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $a888d1191958cd8a$var$formatRelativeLocale = {
    lastWeek: $a888d1191958cd8a$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $a888d1191958cd8a$var$week(true),
    other: 'P'
};
var $a888d1191958cd8a$var$formatRelative = function formatRelative(token, date) {
    var format = $a888d1191958cd8a$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $a888d1191958cd8a$export$2e2bcd8739ae039 = $a888d1191958cd8a$var$formatRelative;



var $4911bb0e92e282c7$var$eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $4911bb0e92e282c7$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $4911bb0e92e282c7$var$formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $4911bb0e92e282c7$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $4911bb0e92e282c7$var$dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var $4911bb0e92e282c7$var$dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var $4911bb0e92e282c7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $4911bb0e92e282c7$var$localize = {
    ordinalNumber: $4911bb0e92e282c7$var$ordinalNumber,
    era: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $4911bb0e92e282c7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $4911bb0e92e282c7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $4911bb0e92e282c7$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $4911bb0e92e282c7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $4911bb0e92e282c7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $4911bb0e92e282c7$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $4911bb0e92e282c7$export$2e2bcd8739ae039 = $4911bb0e92e282c7$var$localize;




var $a2814b302bca4d70$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $a2814b302bca4d70$var$parseOrdinalNumberPattern = /\d+/i;
var $a2814b302bca4d70$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $a2814b302bca4d70$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $a2814b302bca4d70$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $a2814b302bca4d70$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $a2814b302bca4d70$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $a2814b302bca4d70$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a2814b302bca4d70$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $a2814b302bca4d70$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $a2814b302bca4d70$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $a2814b302bca4d70$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $a2814b302bca4d70$var$match = {
    ordinalNumber: (0, $ed51bd2201b1ffe0$export$2e2bcd8739ae039)({
        matchPattern: $a2814b302bca4d70$var$matchOrdinalNumberPattern,
        parsePattern: $a2814b302bca4d70$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $a2814b302bca4d70$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2814b302bca4d70$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $a2814b302bca4d70$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2814b302bca4d70$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $a2814b302bca4d70$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2814b302bca4d70$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $a2814b302bca4d70$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a2814b302bca4d70$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $a2814b302bca4d70$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a2814b302bca4d70$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a2814b302bca4d70$export$2e2bcd8739ae039 = $a2814b302bca4d70$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $3c962f6af8e83995$var$locale = {
    code: 'hu',
    formatDistance: (0, $a7d1b4e284a8a49e$export$2e2bcd8739ae039),
    formatLong: (0, $24d53fd1ac18bd14$export$2e2bcd8739ae039),
    formatRelative: (0, $a888d1191958cd8a$export$2e2bcd8739ae039),
    localize: (0, $4911bb0e92e282c7$export$2e2bcd8739ae039),
    match: (0, $a2814b302bca4d70$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $3c962f6af8e83995$export$2e2bcd8739ae039 = $3c962f6af8e83995$var$locale;


var $85e4be2062abd149$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $85e4be2062abd149$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $85e4be2062abd149$var$formatDistanceLocale[token].withPreposition : $85e4be2062abd149$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $85e4be2062abd149$export$2e2bcd8739ae039 = $85e4be2062abd149$var$formatDistance;



// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $92bb0f72d4881935$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $92bb0f72d4881935$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $92bb0f72d4881935$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $92bb0f72d4881935$var$formatLong = {
    date: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $92bb0f72d4881935$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $92bb0f72d4881935$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $92bb0f72d4881935$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $92bb0f72d4881935$export$2e2bcd8739ae039 = $92bb0f72d4881935$var$formatLong;


var $4746c2a9e767c5f9$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $4746c2a9e767c5f9$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4746c2a9e767c5f9$var$formatRelativeLocale[token];
};
var $4746c2a9e767c5f9$export$2e2bcd8739ae039 = $4746c2a9e767c5f9$var$formatRelative;



var $53292bdf31aa9e58$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $53292bdf31aa9e58$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $53292bdf31aa9e58$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $53292bdf31aa9e58$var$formattingMonthValues = {
    narrow: $53292bdf31aa9e58$var$monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $53292bdf31aa9e58$var$monthValues.wide
};
var $53292bdf31aa9e58$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $53292bdf31aa9e58$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $53292bdf31aa9e58$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $53292bdf31aa9e58$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $53292bdf31aa9e58$var$localize = {
    ordinalNumber: $53292bdf31aa9e58$var$ordinalNumber,
    era: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $53292bdf31aa9e58$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $53292bdf31aa9e58$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $53292bdf31aa9e58$var$monthValues,
        formattingValues: $53292bdf31aa9e58$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $53292bdf31aa9e58$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $53292bdf31aa9e58$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $53292bdf31aa9e58$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $53292bdf31aa9e58$export$2e2bcd8739ae039 = $53292bdf31aa9e58$var$localize;




var $1b5db816619b6a65$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $1b5db816619b6a65$var$parseOrdinalNumberPattern = /\d+/i;
var $1b5db816619b6a65$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $1b5db816619b6a65$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $1b5db816619b6a65$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $1b5db816619b6a65$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1b5db816619b6a65$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $1b5db816619b6a65$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $1b5db816619b6a65$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $1b5db816619b6a65$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $1b5db816619b6a65$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $1b5db816619b6a65$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $1b5db816619b6a65$var$match = {
    ordinalNumber: (0, $ed51bd2201b1ffe0$export$2e2bcd8739ae039)({
        matchPattern: $1b5db816619b6a65$var$matchOrdinalNumberPattern,
        parsePattern: $1b5db816619b6a65$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $1b5db816619b6a65$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1b5db816619b6a65$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $1b5db816619b6a65$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1b5db816619b6a65$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $1b5db816619b6a65$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1b5db816619b6a65$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $1b5db816619b6a65$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1b5db816619b6a65$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $1b5db816619b6a65$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1b5db816619b6a65$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1b5db816619b6a65$export$2e2bcd8739ae039 = $1b5db816619b6a65$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $9fe90a7e9d8a402d$var$locale = {
    code: 'de',
    formatDistance: (0, $85e4be2062abd149$export$2e2bcd8739ae039),
    formatLong: (0, $92bb0f72d4881935$export$2e2bcd8739ae039),
    formatRelative: (0, $4746c2a9e767c5f9$export$2e2bcd8739ae039),
    localize: (0, $53292bdf31aa9e58$export$2e2bcd8739ae039),
    match: (0, $1b5db816619b6a65$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9fe90a7e9d8a402d$export$2e2bcd8739ae039 = $9fe90a7e9d8a402d$var$locale;




const $6f74e9f8f54d4d5a$var$localeMap = {
    en: (0, $51943b9b451c992f$export$2e2bcd8739ae039),
    hu: (0, $3c962f6af8e83995$export$2e2bcd8739ae039),
    de: (0, $9fe90a7e9d8a402d$export$2e2bcd8739ae039)
};
const $6f74e9f8f54d4d5a$var$DatePickerProvider = ({ children: children })=>{
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    var _localeMap_i18n_language;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1aa952074218c40d$export$3a1a48c8f6ef640e), {
        utils: (0, $ea2deec7f5afe484$export$2e2bcd8739ae039),
        locale: (_localeMap_i18n_language = $6f74e9f8f54d4d5a$var$localeMap[i18n.language]) !== null && _localeMap_i18n_language !== void 0 ? _localeMap_i18n_language : $6f74e9f8f54d4d5a$var$localeMap[0, $0f5516e4ff7e5463$export$910b680d1eea6990],
        children: children
    });
};
var $6f74e9f8f54d4d5a$export$2e2bcd8739ae039 = $6f74e9f8f54d4d5a$var$DatePickerProvider;



var $kY3Ke = parcelRequire("kY3Ke");

var $kY3Ke = parcelRequire("kY3Ke");
var $b14010445a49f98f$export$6acf61af03e62db = typeof window === 'undefined';
function $b14010445a49f98f$export$8793edee2d425525() {
    return undefined;
}
function $b14010445a49f98f$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $b14010445a49f98f$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $b14010445a49f98f$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $b14010445a49f98f$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $b14010445a49f98f$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $b14010445a49f98f$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $b14010445a49f98f$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$b14010445a49f98f$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $kY3Ke.default)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $kY3Ke.default)({}, arg2, {
        queryKey: arg1
    });
}
function $b14010445a49f98f$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($b14010445a49f98f$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $kY3Ke.default)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $kY3Ke.default)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $kY3Ke.default)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $kY3Ke.default)({}, arg1);
}
function $b14010445a49f98f$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $b14010445a49f98f$export$aaae5295ec3351c9(arg1) ? [
        (0, $kY3Ke.default)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $b14010445a49f98f$export$42387eeaac09cf54(arg1, arg2) {
    return $b14010445a49f98f$export$aaae5295ec3351c9(arg1) ? (0, $kY3Ke.default)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $b14010445a49f98f$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return 'all';
    else if (active === false && inactive === false) return 'none';
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? 'active' : 'inactive';
    }
}
function $b14010445a49f98f$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($b14010445a49f98f$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $b14010445a49f98f$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$b14010445a49f98f$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $b14010445a49f98f$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === 'none') return false;
    else if (queryStatusFilter !== 'all') {
        var isActive = query.isActive();
        if (queryStatusFilter === 'active' && !isActive) return false;
        if (queryStatusFilter === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetching === 'boolean' && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $b14010445a49f98f$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($b14010445a49f98f$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($b14010445a49f98f$export$5fcb678681417b54(mutation.options.mutationKey) !== $b14010445a49f98f$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$b14010445a49f98f$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $b14010445a49f98f$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $b14010445a49f98f$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $b14010445a49f98f$export$5fcb678681417b54(queryKey) {
    var asArray = $b14010445a49f98f$export$4d32d63f64b825b9(queryKey);
    return $b14010445a49f98f$export$e7f2f041280beb00(asArray);
}
function $b14010445a49f98f$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $b14010445a49f98f$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $b14010445a49f98f$export$2f07189bb9fa26a7(a, b) {
    return $b14010445a49f98f$export$3bc9138b70293839($b14010445a49f98f$export$4d32d63f64b825b9(a), $b14010445a49f98f$export$4d32d63f64b825b9(b));
}
function $b14010445a49f98f$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some(function(key) {
        return !$b14010445a49f98f$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $b14010445a49f98f$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $b14010445a49f98f$export$53b83ca8eaab0383(a) && $b14010445a49f98f$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $b14010445a49f98f$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $b14010445a49f98f$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $b14010445a49f98f$export$53b83ca8eaab0383(o) {
    if (!$b14010445a49f98f$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$b14010445a49f98f$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $b14010445a49f98f$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $b14010445a49f98f$export$aaae5295ec3351c9(value) {
    return typeof value === 'string' || Array.isArray(value);
}
function $b14010445a49f98f$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $b14010445a49f98f$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $b14010445a49f98f$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $b14010445a49f98f$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
}



var $1KLsX = parcelRequire("1KLsX");


var $kY3Ke = parcelRequire("kY3Ke");


var $d71cd30eeffaca8c$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $b14010445a49f98f$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    };
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $b14010445a49f98f$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    };
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    };
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $d71cd30eeffaca8c$export$520687f44db6e1ab = new $d71cd30eeffaca8c$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $e078169100228fdf$var$logger = console;
function $e078169100228fdf$export$2b1d391cd05230fd() {
    return $e078169100228fdf$var$logger;
}
function $e078169100228fdf$export$3abbd92f765bee58(newLogger) {
    $e078169100228fdf$var$logger = newLogger;
}



var $1KLsX = parcelRequire("1KLsX");
var $5c53d597f9d08bb7$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $6e3b25249016e5ef$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $b14010445a49f98f$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === 'boolean') _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $5c53d597f9d08bb7$export$d26086b469ecdbcc));
var $6e3b25249016e5ef$export$6bf54661be5b02cf = new $6e3b25249016e5ef$export$86f1af424b2ca4de();



var $1KLsX = parcelRequire("1KLsX");


var $719ed4727143bd8c$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $b14010445a49f98f$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === 'boolean') _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $5c53d597f9d08bb7$export$d26086b469ecdbcc));
var $719ed4727143bd8c$export$b113e788b2dd3fdc = new $719ed4727143bd8c$export$58774fb55d5ff7fc();



function $f5177ef2c89b9562$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $f5177ef2c89b9562$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var $f5177ef2c89b9562$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $f5177ef2c89b9562$export$986cc6445c1d323(value) {
    return value instanceof $f5177ef2c89b9562$export$a8430ed4188f35a9;
} // CLASS
var $f5177ef2c89b9562$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $f5177ef2c89b9562$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($f5177ef2c89b9562$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $f5177ef2c89b9562$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $f5177ef2c89b9562$var$defaultRetryDelay;
            var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $b14010445a49f98f$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $6e3b25249016e5ef$export$6bf54661be5b02cf).isFocused() || !(0, $719ed4727143bd8c$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $b00bf3a597a425de$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $kY3Ke.default)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $b14010445a49f98f$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $b14010445a49f98f$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $b14010445a49f98f$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $b14010445a49f98f$export$8793edee2d425525)).catch((0, $b14010445a49f98f$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $b14010445a49f98f$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $b14010445a49f98f$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $b14010445a49f98f$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, 'signal', {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject('Missing queryFn');
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $f5177ef2c89b9562$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $f5177ef2c89b9562$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: 'error',
                    error: error
                });
                if (!(0, $f5177ef2c89b9562$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $e078169100228fdf$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: 'queryUpdated',
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== 'undefined';
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== 'undefined';
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? 'success' : 'idle'
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case 'failed':
                return (0, $kY3Ke.default)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case 'pause':
                return (0, $kY3Ke.default)({}, state, {
                    isPaused: true
                });
            case 'continue':
                return (0, $kY3Ke.default)({}, state, {
                    isPaused: false
                });
            case 'fetch':
                return (0, $kY3Ke.default)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: 'loading'
                });
            case 'success':
                return (0, $kY3Ke.default)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: 'success'
                });
            case 'error':
                var error = action.error;
                if ((0, $f5177ef2c89b9562$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $kY3Ke.default)({}, this.revertState);
                return (0, $kY3Ke.default)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: 'error'
                });
            case 'invalidate':
                return (0, $kY3Ke.default)({}, state, {
                    isInvalidated: true
                });
            case 'setState':
                return (0, $kY3Ke.default)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $c49003431597a9f1$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $b14010445a49f98f$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $b00bf3a597a425de$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'queryAdded',
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'queryRemoved',
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $b14010445a49f98f$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $b14010445a49f98f$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $b14010445a49f98f$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $b14010445a49f98f$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $5c53d597f9d08bb7$export$d26086b469ecdbcc));



var $1KLsX = parcelRequire("1KLsX");


var $kY3Ke = parcelRequire("kY3Ke");




var $79a4825474d5b187$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $kY3Ke.default)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $79a4825474d5b187$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $b14010445a49f98f$export$8793edee2d425525)).catch((0, $b14010445a49f98f$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === 'loading';
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: 'loading',
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $e078169100228fdf$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: 'error',
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $f5177ef2c89b9562$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject('No mutationFn found');
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $79a4825474d5b187$var$reducer(this.state, action);
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $79a4825474d5b187$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}
function $79a4825474d5b187$var$reducer(state, action) {
    switch(action.type){
        case 'failed':
            return (0, $kY3Ke.default)({}, state, {
                failureCount: state.failureCount + 1
            });
        case 'pause':
            return (0, $kY3Ke.default)({}, state, {
                isPaused: true
            });
        case 'continue':
            return (0, $kY3Ke.default)({}, state, {
                isPaused: false
            });
        case 'loading':
            return (0, $kY3Ke.default)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: 'loading',
                variables: action.variables
            });
        case 'success':
            return (0, $kY3Ke.default)({}, state, {
                data: action.data,
                error: null,
                status: 'success',
                isPaused: false
            });
        case 'error':
            return (0, $kY3Ke.default)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: 'error'
            });
        case 'setState':
            return (0, $kY3Ke.default)({}, state, action.state);
        default:
            return state;
    }
}




var $9b86e646be22e839$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $79a4825474d5b187$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $b14010445a49f98f$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $b14010445a49f98f$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $b14010445a49f98f$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $5c53d597f9d08bb7$export$d26086b469ecdbcc));







function $f8e21210973082fe$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $b14010445a49f98f$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject('Missing queryFn');
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $f5177ef2c89b9562$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== 'undefined';
                    var param = manual ? pageParam : $f8e21210973082fe$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== 'undefined';
                    var _param = _manual ? pageParam : $f8e21210973082fe$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === 'undefined';
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $f8e21210973082fe$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $f5177ef2c89b9562$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $f8e21210973082fe$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $f8e21210973082fe$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $f8e21210973082fe$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $f8e21210973082fe$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
function $f8e21210973082fe$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $f8e21210973082fe$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}


var $2701e4e367fb45bc$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $c49003431597a9f1$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $9b86e646be22e839$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $6e3b25249016e5ef$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $6e3b25249016e5ef$export$6bf54661be5b02cf).isFocused() && (0, $719ed4727143bd8c$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $719ed4727143bd8c$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $6e3b25249016e5ef$export$6bf54661be5b02cf).isFocused() && (0, $719ed4727143bd8c$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $b14010445a49f98f$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $kY3Ke.default)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $b14010445a49f98f$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $b14010445a49f98f$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $b14010445a49f98f$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $kY3Ke.default)({}, filters, {
            active: true
        });
        return (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $b14010445a49f98f$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        var promises = (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $b14010445a49f98f$export$8793edee2d425525)).catch((0, $b14010445a49f98f$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $b14010445a49f98f$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $kY3Ke.default)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $b14010445a49f98f$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $kY3Ke.default)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $b14010445a49f98f$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $b14010445a49f98f$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $b14010445a49f98f$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $b14010445a49f98f$export$8793edee2d425525)).catch((0, $b14010445a49f98f$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $b14010445a49f98f$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $f8e21210973082fe$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $b14010445a49f98f$export$8793edee2d425525)).catch((0, $b14010445a49f98f$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $b14010445a49f98f$export$8793edee2d425525)).catch((0, $b14010445a49f98f$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $b14010445a49f98f$export$5fcb678681417b54)(queryKey) === (0, $b14010445a49f98f$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $b14010445a49f98f$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $b14010445a49f98f$export$5fcb678681417b54)(mutationKey) === (0, $b14010445a49f98f$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $b14010445a49f98f$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $kY3Ke.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $b14010445a49f98f$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $kY3Ke.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $fw0lo = parcelRequire("fw0lo");
var $6d64a3a9e9739f85$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).unstable_batchedUpdates;


(0, $d71cd30eeffaca8c$export$520687f44db6e1ab).setBatchNotifyFunction((0, $6d64a3a9e9739f85$export$c78a37762a8d58e1));



var $d7b5cbcb312f2761$export$af88d00dbe7f521 = console;


(0, $e078169100228fdf$export$3abbd92f765bee58)((0, $d7b5cbcb312f2761$export$af88d00dbe7f521));



var $7fPBF = parcelRequire("7fPBF");
var $509c1684c3be0a4f$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(undefined);
var $509c1684c3be0a4f$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $509c1684c3be0a4f$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $509c1684c3be0a4f$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $509c1684c3be0a4f$var$defaultContext;
}
var $509c1684c3be0a4f$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($509c1684c3be0a4f$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($509c1684c3be0a4f$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
var $509c1684c3be0a4f$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $509c1684c3be0a4f$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($509c1684c3be0a4f$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Context.Provider, {
        value: client
    }, children));
};






var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $kY3Ke = parcelRequire("kY3Ke");

var $1KLsX = parcelRequire("1KLsX");



var $70b2924f2be16d1a$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $kY3Ke.default)({}, this.options, {
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $79a4825474d5b187$export$a1659b54bac3252a)();
        var result = (0, $kY3Ke.default)({}, state, {
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $5c53d597f9d08bb7$export$d26086b469ecdbcc));



function $44feb96f67e82ed0$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $2668994c46bd3e68$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $b14010445a49f98f$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $509c1684c3be0a4f$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $70b2924f2be16d1a$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $b14010445a49f98f$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $44feb96f67e82ed0$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $kY3Ke.default)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}



var $kY3Ke = parcelRequire("kY3Ke");

var $1KLsX = parcelRequire("1KLsX");






var $587ead52f8096f7a$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($587ead52f8096f7a$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $587ead52f8096f7a$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $587ead52f8096f7a$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $587ead52f8096f7a$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp('error');
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $kY3Ke.default)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $b14010445a49f98f$export$8793edee2d425525));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $b14010445a49f98f$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $b14010445a49f98f$export$e539f754e934e270)(this.options.staleTime)) return;
        var time = (0, $b14010445a49f98f$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $b14010445a49f98f$export$6acf61af03e62db) || this.options.enabled === false || !(0, $b14010445a49f98f$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $6e3b25249016e5ef$export$6bf54661be5b02cf).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $587ead52f8096f7a$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $587ead52f8096f7a$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = 'loading';
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $b14010445a49f98f$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $e078169100228fdf$export$2b1d391cd05230fd)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $b14010445a49f98f$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $e078169100228fdf$export$2b1d391cd05230fd)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        var result = {
            status: status,
            isLoading: status === 'loading',
            isSuccess: status === 'success',
            isError: status === 'error',
            isIdle: status === 'idle',
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== 'loading',
            isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
            isStale: $587ead52f8096f7a$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $b14010445a49f98f$export$3e67810a3f0e9f1c)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $kY3Ke.default)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error' && !(0, $f5177ef2c89b9562$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    };
    return QueryObserver;
}((0, $5c53d597f9d08bb7$export$d26086b469ecdbcc));
function $587ead52f8096f7a$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $587ead52f8096f7a$var$shouldFetchOnMount(query, options) {
    return $587ead52f8096f7a$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $587ead52f8096f7a$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $587ead52f8096f7a$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $587ead52f8096f7a$var$isStale(query, options);
    }
    return false;
}
function $587ead52f8096f7a$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $587ead52f8096f7a$var$isStale(query, options);
}
function $587ead52f8096f7a$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
function $1d1489ca3b909b0e$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $1d1489ca3b909b0e$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($1d1489ca3b909b0e$var$createValue()); // HOOK
var $1d1489ca3b909b0e$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($1d1489ca3b909b0e$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $1d1489ca3b909b0e$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(function() {
        return $1d1489ca3b909b0e$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($1d1489ca3b909b0e$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




function $357b64f35604fd55$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $509c1684c3be0a4f$export$22e77b9572c4fded)();
    var errorResetBoundary = (0, $1d1489ca3b909b0e$export$50dfac555130cafd)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $d71cd30eeffaca8c$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $44feb96f67e82ed0$export$2072f68e6c3507cf)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === 'tracked') result = observer.trackResult(result, defaultedOptions);
    return result;
}


function $13e6d41be5252f10$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $b14010445a49f98f$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $357b64f35604fd55$export$fff0865807e996c5)(parsedOptions, (0, $587ead52f8096f7a$export$a06cf8c0066f0d4c));
}




var $kY3Ke = parcelRequire("kY3Ke");

var $1KLsX = parcelRequire("1KLsX");


var $fa098cf2135872c5$export$85d960eb3ab339c8 = /*#__PURE__*/ function(_QueryObserver) {
    (0, $1KLsX.default)(InfiniteQueryObserver, _QueryObserver);
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function InfiniteQueryObserver(client, options) {
        return _QueryObserver.call(this, client, options) || this;
    }
    var _proto = InfiniteQueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        _QueryObserver.prototype.bindMethods.call(this);
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        _QueryObserver.prototype.setOptions.call(this, (0, $kY3Ke.default)({}, options, {
            behavior: (0, $f8e21210973082fe$export$84470d1367601e8d)()
        }), notifyOptions);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        options.behavior = (0, $f8e21210973082fe$export$84470d1367601e8d)();
        return _QueryObserver.prototype.getOptimisticResult.call(this, options);
    };
    _proto.fetchNextPage = function fetchNextPage(options) {
        var _options$cancelRefetc;
        return this.fetch({
            // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
            cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
            throwOnError: options == null ? void 0 : options.throwOnError,
            meta: {
                fetchMore: {
                    direction: 'forward',
                    pageParam: options == null ? void 0 : options.pageParam
                }
            }
        });
    };
    _proto.fetchPreviousPage = function fetchPreviousPage(options) {
        var _options$cancelRefetc2;
        return this.fetch({
            // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
            cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
            throwOnError: options == null ? void 0 : options.throwOnError,
            meta: {
                fetchMore: {
                    direction: 'backward',
                    pageParam: options == null ? void 0 : options.pageParam
                }
            }
        });
    };
    _proto.createResult = function createResult(query, options) {
        var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;
        var state = query.state;
        var result = _QueryObserver.prototype.createResult.call(this, query, options);
        return (0, $kY3Ke.default)({}, result, {
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, $f8e21210973082fe$export$b9c88add8b8b5e6a)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, $f8e21210973082fe$export$db1663b730a8e6e4)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
            isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
        });
    };
    return InfiniteQueryObserver;
}((0, $587ead52f8096f7a$export$a06cf8c0066f0d4c));




function $2bc6258289aa5150$export$bdc59d3c1a6569aa(arg1, arg2, arg3) {
    var options = (0, $b14010445a49f98f$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $357b64f35604fd55$export$fff0865807e996c5)(options, (0, $fa098cf2135872c5$export$85d960eb3ab339c8));
}











parcelRequire("7fPBF");

var $1KLsX = parcelRequire("1KLsX");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $kY3Ke = parcelRequire("kY3Ke");
function $8843d44a77f8363b$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $8843d44a77f8363b$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $8843d44a77f8363b$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $8843d44a77f8363b$var$isAbsolute(to);
    var isFromAbs = from && $8843d44a77f8363b$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $8843d44a77f8363b$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $8843d44a77f8363b$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $8843d44a77f8363b$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $8843d44a77f8363b$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$8843d44a77f8363b$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $8843d44a77f8363b$export$2e2bcd8739ae039 = $8843d44a77f8363b$var$resolvePathname;


function $c2ea1770624fbc7e$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $c2ea1770624fbc7e$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $c2ea1770624fbc7e$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $c2ea1770624fbc7e$var$valueOf(a);
        var bValue = $c2ea1770624fbc7e$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $c2ea1770624fbc7e$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $c2ea1770624fbc7e$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $c2ea1770624fbc7e$export$2e2bcd8739ae039 = $c2ea1770624fbc7e$var$valueEqual;



var $80ee8fc99f5202eb$var$isProduction = true;
var $80ee8fc99f5202eb$var$prefix = 'Invariant failed';
function $80ee8fc99f5202eb$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($80ee8fc99f5202eb$var$isProduction) throw new Error($80ee8fc99f5202eb$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($80ee8fc99f5202eb$var$prefix, ": ").concat(provided) : $80ee8fc99f5202eb$var$prefix;
    throw new Error(value);
}


function $db3bbae35c30d3fd$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $db3bbae35c30d3fd$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $db3bbae35c30d3fd$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $db3bbae35c30d3fd$var$stripBasename(path, prefix) {
    return $db3bbae35c30d3fd$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $db3bbae35c30d3fd$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $db3bbae35c30d3fd$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $db3bbae35c30d3fd$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $db3bbae35c30d3fd$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $kY3Ke.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $8843d44a77f8363b$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $db3bbae35c30d3fd$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $c2ea1770624fbc7e$export$2e2bcd8739ae039)(a.state, b.state);
}
function $db3bbae35c30d3fd$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $db3bbae35c30d3fd$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $db3bbae35c30d3fd$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $db3bbae35c30d3fd$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $db3bbae35c30d3fd$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $db3bbae35c30d3fd$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $db3bbae35c30d3fd$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $db3bbae35c30d3fd$var$PopStateEvent = 'popstate';
var $db3bbae35c30d3fd$var$HashChangeEvent = 'hashchange';
function $db3bbae35c30d3fd$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $db3bbae35c30d3fd$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$db3bbae35c30d3fd$var$canUseDOM && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $db3bbae35c30d3fd$var$supportsHistory();
    var needsHashChangeListener = !$db3bbae35c30d3fd$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $db3bbae35c30d3fd$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $db3bbae35c30d3fd$var$stripTrailingSlash($db3bbae35c30d3fd$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $db3bbae35c30d3fd$var$stripBasename(path, basename);
        return $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $db3bbae35c30d3fd$var$createTransitionManager();
    function setState(nextState) {
        (0, $kY3Ke.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($db3bbae35c30d3fd$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($db3bbae35c30d3fd$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($db3bbae35c30d3fd$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $db3bbae35c30d3fd$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($db3bbae35c30d3fd$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($db3bbae35c30d3fd$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($db3bbae35c30d3fd$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($db3bbae35c30d3fd$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $db3bbae35c30d3fd$var$HashChangeEvent$1 = 'hashchange';
var $db3bbae35c30d3fd$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $db3bbae35c30d3fd$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $db3bbae35c30d3fd$var$stripLeadingSlash,
        decodePath: $db3bbae35c30d3fd$var$addLeadingSlash
    },
    slash: {
        encodePath: $db3bbae35c30d3fd$var$addLeadingSlash,
        decodePath: $db3bbae35c30d3fd$var$addLeadingSlash
    }
};
function $db3bbae35c30d3fd$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $db3bbae35c30d3fd$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $db3bbae35c30d3fd$var$pushHashPath(path) {
    window.location.hash = path;
}
function $db3bbae35c30d3fd$var$replaceHashPath(path) {
    window.location.replace($db3bbae35c30d3fd$var$stripHash(window.location.href) + '#' + path);
}
function $db3bbae35c30d3fd$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$db3bbae35c30d3fd$var$canUseDOM && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $db3bbae35c30d3fd$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $db3bbae35c30d3fd$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $db3bbae35c30d3fd$var$stripTrailingSlash($db3bbae35c30d3fd$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $db3bbae35c30d3fd$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($db3bbae35c30d3fd$var$getHashPath());
        if (basename) path = $db3bbae35c30d3fd$var$stripBasename(path, basename);
        return $db3bbae35c30d3fd$export$90c043f1c57770b8(path);
    }
    var transitionManager = $db3bbae35c30d3fd$var$createTransitionManager();
    function setState(nextState) {
        (0, $kY3Ke.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $db3bbae35c30d3fd$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $db3bbae35c30d3fd$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $db3bbae35c30d3fd$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($db3bbae35c30d3fd$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($db3bbae35c30d3fd$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $db3bbae35c30d3fd$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $db3bbae35c30d3fd$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $db3bbae35c30d3fd$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $db3bbae35c30d3fd$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $db3bbae35c30d3fd$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $db3bbae35c30d3fd$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $db3bbae35c30d3fd$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $db3bbae35c30d3fd$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($db3bbae35c30d3fd$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $db3bbae35c30d3fd$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $db3bbae35c30d3fd$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $db3bbae35c30d3fd$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($db3bbae35c30d3fd$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($db3bbae35c30d3fd$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($db3bbae35c30d3fd$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $db3bbae35c30d3fd$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $db3bbae35c30d3fd$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $db3bbae35c30d3fd$var$createTransitionManager();
    function setState(nextState) {
        (0, $kY3Ke.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $db3bbae35c30d3fd$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $db3bbae35c30d3fd$export$90c043f1c57770b8(entry, undefined, createKey()) : $db3bbae35c30d3fd$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $db3bbae35c30d3fd$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $db3bbae35c30d3fd$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $db3bbae35c30d3fd$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $kY3Ke = parcelRequire("kY3Ke");
var $dc8e47b99ce13961$exports = {};
var $e6e5adef2b129624$exports = {};
$e6e5adef2b129624$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $dc8e47b99ce13961$exports = $dc8e47b99ce13961$var$pathToRegexp;
$dc8e47b99ce13961$exports.parse = $dc8e47b99ce13961$var$parse;
$dc8e47b99ce13961$exports.compile = $dc8e47b99ce13961$var$compile;
$dc8e47b99ce13961$exports.tokensToFunction = $dc8e47b99ce13961$var$tokensToFunction;
$dc8e47b99ce13961$exports.tokensToRegExp = $dc8e47b99ce13961$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $dc8e47b99ce13961$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $dc8e47b99ce13961$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $dc8e47b99ce13961$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $dc8e47b99ce13961$var$escapeGroup(pattern) : asterisk ? '.*' : $dc8e47b99ce13961$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $dc8e47b99ce13961$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $dc8e47b99ce13961$var$escapeString(delimiter) + ']+?';
    return $dc8e47b99ce13961$var$escapeString(prevText) + '|(?:(?!' + $dc8e47b99ce13961$var$escapeString(prevText) + ')[^' + $dc8e47b99ce13961$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $dc8e47b99ce13961$var$compile(str, options) {
    return $dc8e47b99ce13961$var$tokensToFunction($dc8e47b99ce13961$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $dc8e47b99ce13961$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $dc8e47b99ce13961$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $dc8e47b99ce13961$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $dc8e47b99ce13961$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $dc8e47b99ce13961$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($e6e5adef2b129624$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $dc8e47b99ce13961$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $dc8e47b99ce13961$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $dc8e47b99ce13961$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $dc8e47b99ce13961$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $dc8e47b99ce13961$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($dc8e47b99ce13961$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $dc8e47b99ce13961$var$flags(options));
    return $dc8e47b99ce13961$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$stringToRegexp(path, keys, options) {
    return $dc8e47b99ce13961$var$tokensToRegExp($dc8e47b99ce13961$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$tokensToRegExp(tokens, keys, options) {
    if (!$e6e5adef2b129624$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $dc8e47b99ce13961$var$escapeString(token);
        else {
            var prefix = $dc8e47b99ce13961$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $dc8e47b99ce13961$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $dc8e47b99ce13961$var$attachKeys(new RegExp('^' + route, $dc8e47b99ce13961$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $dc8e47b99ce13961$var$pathToRegexp(path, keys, options) {
    if (!$e6e5adef2b129624$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $dc8e47b99ce13961$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($e6e5adef2b129624$exports(path)) return $dc8e47b99ce13961$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $dc8e47b99ce13961$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $b60b3992f14166cb$exports = {};
'use strict';

$b60b3992f14166cb$exports = (parcelRequire("gYL3V"));



var $cFLic = parcelRequire("cFLic");

var $8Ae2G = parcelRequire("8Ae2G");
var $560cbe427eb95a5b$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $560cbe427eb95a5b$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $560cbe427eb95a5b$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $560cbe427eb95a5b$var$commonjsGlobal[key] = ($560cbe427eb95a5b$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $560cbe427eb95a5b$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $560cbe427eb95a5b$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $560cbe427eb95a5b$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $560cbe427eb95a5b$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $560cbe427eb95a5b$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $1KLsX.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $560cbe427eb95a5b$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($560cbe427eb95a5b$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $560cbe427eb95a5b$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $1KLsX.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $560cbe427eb95a5b$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $560cbe427eb95a5b$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $560cbe427eb95a5b$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $560cbe427eb95a5b$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext || $560cbe427eb95a5b$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $560cbe427eb95a5b$var$createNamedContext = function createNamedContext(name) {
    var context = $560cbe427eb95a5b$var$createContext();
    context.displayName = name;
    return context;
};
var $560cbe427eb95a5b$export$c213558b66925821 = /*#__PURE__*/ $560cbe427eb95a5b$var$createNamedContext("Router-History");
var $560cbe427eb95a5b$export$63baa8ccbe60bb07 = /*#__PURE__*/ $560cbe427eb95a5b$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $560cbe427eb95a5b$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $560cbe427eb95a5b$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $db3bbae35c30d3fd$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
var $560cbe427eb95a5b$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $560cbe427eb95a5b$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $560cbe427eb95a5b$var$messageType;
var $560cbe427eb95a5b$var$cache = {};
var $560cbe427eb95a5b$var$cacheLimit = 10000;
var $560cbe427eb95a5b$var$cacheCount = 0;
function $560cbe427eb95a5b$var$compilePath(path) {
    if ($560cbe427eb95a5b$var$cache[path]) return $560cbe427eb95a5b$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($dc8e47b99ce13961$exports))).compile(path);
    if ($560cbe427eb95a5b$var$cacheCount < $560cbe427eb95a5b$var$cacheLimit) {
        $560cbe427eb95a5b$var$cache[path] = generator;
        $560cbe427eb95a5b$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $560cbe427eb95a5b$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $560cbe427eb95a5b$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $560cbe427eb95a5b$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $db3bbae35c30d3fd$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $560cbe427eb95a5b$export$82476f982757e71e(to, computedMatch.params) : (0, $kY3Ke.default)({}, to, {
            pathname: $560cbe427eb95a5b$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $db3bbae35c30d3fd$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $db3bbae35c30d3fd$export$c3e8bb440bd55b18)(prevLocation, (0, $kY3Ke.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $560cbe427eb95a5b$var$cache$1 = {};
var $560cbe427eb95a5b$var$cacheLimit$1 = 10000;
var $560cbe427eb95a5b$var$cacheCount$1 = 0;
function $560cbe427eb95a5b$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $560cbe427eb95a5b$var$cache$1[cacheKey] || ($560cbe427eb95a5b$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($dc8e47b99ce13961$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($560cbe427eb95a5b$var$cacheCount$1 < $560cbe427eb95a5b$var$cacheLimit$1) {
        pathCache[path] = result;
        $560cbe427eb95a5b$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $560cbe427eb95a5b$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $560cbe427eb95a5b$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $560cbe427eb95a5b$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.count(children) === 0;
}
function $560cbe427eb95a5b$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $560cbe427eb95a5b$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $560cbe427eb95a5b$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $kY3Ke.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $560cbe427eb95a5b$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
function $560cbe427eb95a5b$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $560cbe427eb95a5b$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $kY3Ke.default)({}, location, {
        pathname: $560cbe427eb95a5b$var$addLeadingSlash(basename) + location.pathname
    });
}
function $560cbe427eb95a5b$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $560cbe427eb95a5b$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $kY3Ke.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $560cbe427eb95a5b$var$createURL(location) {
    return typeof location === "string" ? location : (0, $db3bbae35c30d3fd$export$fe53371bee54353d)(location);
}
function $560cbe427eb95a5b$var$staticHandler(methodName) {
    return function() {
        (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
    };
}
function $560cbe427eb95a5b$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $560cbe427eb95a5b$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $560cbe427eb95a5b$var$noop;
        };
        _this.handleBlock = function() {
            return $560cbe427eb95a5b$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $560cbe427eb95a5b$var$addBasename(basename, (0, $db3bbae35c30d3fd$export$90c043f1c57770b8)(location));
        context.url = $560cbe427eb95a5b$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $cFLic.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $560cbe427eb95a5b$var$addLeadingSlash(basename + $560cbe427eb95a5b$var$createURL(path));
            },
            action: "POP",
            location: $560cbe427eb95a5b$var$stripBasename(basename, (0, $db3bbae35c30d3fd$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $560cbe427eb95a5b$var$staticHandler("go"),
            goBack: $560cbe427eb95a5b$var$staticHandler("goBack"),
            goForward: $560cbe427eb95a5b$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$55185c17a0fcbe46, (0, $kY3Ke.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $560cbe427eb95a5b$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $560cbe427eb95a5b$export$81336c211d5ff295(location.pathname, (0, $kY3Ke.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $560cbe427eb95a5b$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $cFLic.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($560cbe427eb95a5b$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, (0, $kY3Ke.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(C, Component);
}
var $560cbe427eb95a5b$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext;
function $560cbe427eb95a5b$export$3420e1dc2c4a518c() {
    return $560cbe427eb95a5b$var$useContext($560cbe427eb95a5b$export$c213558b66925821);
}
function $560cbe427eb95a5b$export$45d76561a5302f2b() {
    return $560cbe427eb95a5b$var$useContext($560cbe427eb95a5b$export$63baa8ccbe60bb07).location;
}
function $560cbe427eb95a5b$export$99eaa27ddbbb95ef() {
    var match = $560cbe427eb95a5b$var$useContext($560cbe427eb95a5b$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $560cbe427eb95a5b$export$632be4bb944c1bc7(path) {
    var location = $560cbe427eb95a5b$export$45d76561a5302f2b();
    var match = $560cbe427eb95a5b$var$useContext($560cbe427eb95a5b$export$63baa8ccbe60bb07).match;
    return path ? $560cbe427eb95a5b$export$81336c211d5ff295(location.pathname, path) : match;
}
var $560cbe427eb95a5b$var$global$1, $560cbe427eb95a5b$var$key, $560cbe427eb95a5b$var$buildNames, $560cbe427eb95a5b$var$initialBuildName, $560cbe427eb95a5b$var$secondaryBuildName;



var $1KLsX = parcelRequire("1KLsX");

var $7fPBF = parcelRequire("7fPBF");




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $6e382b045249d040$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $db3bbae35c30d3fd$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $560cbe427eb95a5b$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $6e382b045249d040$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $db3bbae35c30d3fd$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $560cbe427eb95a5b$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
var $6e382b045249d040$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $6e382b045249d040$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $db3bbae35c30d3fd$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $6e382b045249d040$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $6e382b045249d040$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef;
if (typeof $6e382b045249d040$var$forwardRef === "undefined") $6e382b045249d040$var$forwardRef = $6e382b045249d040$var$forwardRefShim;
function $6e382b045249d040$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $6e382b045249d040$var$LinkAnchor = $6e382b045249d040$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $cFLic.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $kY3Ke.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$6e382b045249d040$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($6e382b045249d040$var$forwardRefShim !== $6e382b045249d040$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $6e382b045249d040$export$a6c7ac8248d6e38a = $6e382b045249d040$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $6e382b045249d040$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $cFLic.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $560cbe427eb95a5b$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $6e382b045249d040$var$normalizeToLocation($6e382b045249d040$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $kY3Ke.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $6e382b045249d040$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $db3bbae35c30d3fd$export$fe53371bee54353d)(context.location) === (0, $db3bbae35c30d3fd$export$fe53371bee54353d)($6e382b045249d040$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($6e382b045249d040$var$forwardRefShim !== $6e382b045249d040$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(component, props);
    });
});
var $6e382b045249d040$var$toType, $6e382b045249d040$var$refType;
var $6e382b045249d040$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $6e382b045249d040$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef;
if (typeof $6e382b045249d040$var$forwardRef$1 === "undefined") $6e382b045249d040$var$forwardRef$1 = $6e382b045249d040$var$forwardRefShim$1;
function $6e382b045249d040$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $6e382b045249d040$export$b0d92dbee9b5b60d = $6e382b045249d040$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $cFLic.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $560cbe427eb95a5b$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $80ee8fc99f5202eb$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $6e382b045249d040$var$normalizeToLocation($6e382b045249d040$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $560cbe427eb95a5b$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $6e382b045249d040$var$joinClassnames(className, activeClassName);
            style = (0, $kY3Ke.default)({}, style, activeStyle);
        }
        var props = (0, $kY3Ke.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($6e382b045249d040$var$forwardRefShim$1 !== $6e382b045249d040$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6e382b045249d040$export$a6c7ac8248d6e38a, props);
    });
});
var $6e382b045249d040$var$ariaCurrentType;




function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



parcelRequire("7fPBF");





const $cf65770b5de4cf48$var$AuthRoute = (_param)=>{
    var { component: Component, licenced: licenced } = _param, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "component",
        "licenced"
    ]);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const token = localStorage.getItem('jwtToken');
    const hasValidLicence = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $9abcdbaae8311c9d$export$3b2effd73e7d4022));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $560cbe427eb95a5b$export$e7b0ac011bb776c6), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
        render: (props)=>{
            if (!token) dispatch((0, $295ca3e31a29edec$export$c2736593113e9a96)({
                url: props.location.pathname
            }));
            if (token && !licenced) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Component, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
            if (token && licenced && hasValidLicence) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Component, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
            if (token && licenced && !hasValidLicence) {
                dispatch((0, $295ca3e31a29edec$export$c2736593113e9a96)({
                    url: props.location.pathname
                }));
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $560cbe427eb95a5b$export$2d8d895a0a0f636e), {
                    to: {
                        pathname: (0, $f6e729db3f817bb5$exports.LOCATIONS).MISSING_LICENCE,
                        state: {
                            from: props.location
                        }
                    }
                });
            }
            if (!token) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $560cbe427eb95a5b$export$2d8d895a0a0f636e), {
                to: {
                    pathname: (0, $f6e729db3f817bb5$exports.LOCATIONS).HOME,
                    state: {
                        from: props.location
                    }
                }
            });
        }
    }));
};
const $cf65770b5de4cf48$var$NonAuthRoute = (_param)=>{
    var { component: Component } = _param, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "component"
    ]);
    const token = rest.path === (0, $f6e729db3f817bb5$exports.LOCATIONS).REGISTRATION ? '' : localStorage.getItem('jwtToken');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $560cbe427eb95a5b$export$e7b0ac011bb776c6), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
        render: (props)=>!token ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Component, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $560cbe427eb95a5b$export$2d8d895a0a0f636e), {
                to: {
                    pathname: (0, $f6e729db3f817bb5$exports.LOCATIONS).OBJECTIVES,
                    location: {
                        from: props.location
                    }
                }
            })
    }));
};
const $cf65770b5de4cf48$var$NormalRoute = (_param)=>{
    var { component: Component } = _param, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "component"
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $560cbe427eb95a5b$export$e7b0ac011bb776c6), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
        render: (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Component, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props))
    }));
};
const $cf65770b5de4cf48$export$a666473f8cc4884f = (route)=>{
    if (route.auth) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cf65770b5de4cf48$var$AuthRoute, {
        path: route.path,
        exact: route.exact,
        component: route.component,
        licenced: route.licenced
    });
    else if (route.noneauth) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cf65770b5de4cf48$var$NonAuthRoute, {
        path: route.path,
        exact: route.exact,
        component: route.component
    });
    else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cf65770b5de4cf48$var$NormalRoute, {
        path: route.path,
        exact: route.exact,
        component: route.component
    });
};
var $cf65770b5de4cf48$export$2e2bcd8739ae039 = $cf65770b5de4cf48$export$a666473f8cc4884f;




var $7fPBF = parcelRequire("7fPBF");




var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");


var $c9ee90b78693ce6c$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $c9ee90b78693ce6c$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $c9ee90b78693ce6c$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $c9ee90b78693ce6c$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: '100%'
            };
            return;
        }
        if (size === 'auto') {
            styles[key] = {
                flexBasis: 'auto',
                flexGrow: 0,
                maxWidth: 'none'
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === 'xs') (0, $kY3Ke.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $c9ee90b78693ce6c$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}
function $c9ee90b78693ce6c$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $c9ee90b78693ce6c$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($c9ee90b78693ce6c$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($c9ee90b78693ce6c$var$getOffset(themeSpacing), ")"),
            '& > $item': {
                padding: $c9ee90b78693ce6c$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $c9ee90b78693ce6c$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $kY3Ke.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%'
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: 'border-box',
            margin: '0' // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ 'direction-xs-column': {
            flexDirection: 'column'
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ 'direction-xs-column-reverse': {
            flexDirection: 'column-reverse'
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ 'direction-xs-row-reverse': {
            flexDirection: 'row-reverse'
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ 'wrap-xs-nowrap': {
            flexWrap: 'nowrap'
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ 'wrap-xs-wrap-reverse': {
            flexWrap: 'wrap-reverse'
        },
        /* Styles applied to the root element if `alignItems="center"`. */ 'align-items-xs-center': {
            alignItems: 'center'
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ 'align-items-xs-flex-start': {
            alignItems: 'flex-start'
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ 'align-items-xs-flex-end': {
            alignItems: 'flex-end'
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ 'align-items-xs-baseline': {
            alignItems: 'baseline'
        },
        /* Styles applied to the root element if `alignContent="center"`. */ 'align-content-xs-center': {
            alignContent: 'center'
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ 'align-content-xs-flex-start': {
            alignContent: 'flex-start'
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ 'align-content-xs-flex-end': {
            alignContent: 'flex-end'
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ 'align-content-xs-space-between': {
            alignContent: 'space-between'
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ 'align-content-xs-space-around': {
            alignContent: 'space-around'
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ 'justify-content-xs-center': {
            justifyContent: 'center'
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ 'justify-content-xs-flex-end': {
            justifyContent: 'flex-end'
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ 'justify-content-xs-space-between': {
            justifyContent: 'space-between'
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ 'justify-content-xs-space-around': {
            justifyContent: 'space-around'
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ 'justify-content-xs-space-evenly': {
            justifyContent: 'space-evenly'
        }
    }, $c9ee90b78693ce6c$var$generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $c9ee90b78693ce6c$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $c9ee90b78693ce6c$var$Grid = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? 'row' : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? 'flex-start' : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $lfiYO.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $jtRae.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== 'flex-start' && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: className,
        ref: ref
    }, other));
});
var $c9ee90b78693ce6c$var$StyledGrid = (0, $3Sc7z.default)($c9ee90b78693ce6c$export$9dd6ff9ea0189349, {
    name: 'MuiGrid'
})($c9ee90b78693ce6c$var$Grid);
var $c9ee90b78693ce6c$var$requireProp;
var $c9ee90b78693ce6c$export$2e2bcd8739ae039 = $c9ee90b78693ce6c$var$StyledGrid;


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $4mLf7 = parcelRequire("4mLf7");
var $qjAyq = parcelRequire("qjAyq");
function $d817e1b1fb97b199$export$2e2bcd8739ae039(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theme = (0, $qjAyq.default)();
    var props = (0, $4mLf7.default)({
        theme: theme,
        name: 'MuiUseMediaQuery',
        props: {}
    });
    var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
    // All the browsers Material-UI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    var _props$options = (0, $kY3Ke.default)({}, props, options), _props$options$defaul = _props$options.defaultMatches, defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul, _props$options$matchM = _props$options.matchMedia, matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM, _props$options$noSsr = _props$options.noSsr, noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr, _props$options$ssrMat = _props$options.ssrMatchMedia, ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
    var _React$useState = $7fPBF.useState(function() {
        if (noSsr && supportMatchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
         // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), match = _React$useState[0], setMatch = _React$useState[1];
    $7fPBF.useEffect(function() {
        var active = true;
        if (!supportMatchMedia) return undefined;
        var queryList = matchMedia(query);
        var updateMatch = function updateMatch() {
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    return match;
}


var $fH0xA = parcelRequire("fH0xA");










var $8cc3d14fcf9888ac$exports = {};

$parcel$export($8cc3d14fcf9888ac$exports, "extract", function () { return $8cc3d14fcf9888ac$export$f9380c9a627682d3; }, function (v) { return $8cc3d14fcf9888ac$export$f9380c9a627682d3 = v; });
$parcel$export($8cc3d14fcf9888ac$exports, "parse", function () { return $8cc3d14fcf9888ac$export$98e6a39c04603d36; }, function (v) { return $8cc3d14fcf9888ac$export$98e6a39c04603d36 = v; });
$parcel$export($8cc3d14fcf9888ac$exports, "stringify", function () { return $8cc3d14fcf9888ac$export$fac44ee5b035f737; }, function (v) { return $8cc3d14fcf9888ac$export$fac44ee5b035f737 = v; });
$parcel$export($8cc3d14fcf9888ac$exports, "parseUrl", function () { return $8cc3d14fcf9888ac$export$7a5253c0f62e0150; }, function (v) { return $8cc3d14fcf9888ac$export$7a5253c0f62e0150 = v; });
$parcel$export($8cc3d14fcf9888ac$exports, "stringifyUrl", function () { return $8cc3d14fcf9888ac$export$a8c1621ea79325d3; }, function (v) { return $8cc3d14fcf9888ac$export$a8c1621ea79325d3 = v; });
$parcel$export($8cc3d14fcf9888ac$exports, "pick", function () { return $8cc3d14fcf9888ac$export$357523c63a2253b9; }, function (v) { return $8cc3d14fcf9888ac$export$357523c63a2253b9 = v; });
$parcel$export($8cc3d14fcf9888ac$exports, "exclude", function () { return $8cc3d14fcf9888ac$export$44c361b8ec72ef7f; }, function (v) { return $8cc3d14fcf9888ac$export$44c361b8ec72ef7f = v; });
var $8cc3d14fcf9888ac$export$f9380c9a627682d3;
var $8cc3d14fcf9888ac$export$98e6a39c04603d36;
var $8cc3d14fcf9888ac$export$fac44ee5b035f737;
var $8cc3d14fcf9888ac$export$7a5253c0f62e0150;
var $8cc3d14fcf9888ac$export$a8c1621ea79325d3;
var $8cc3d14fcf9888ac$export$357523c63a2253b9;
var $8cc3d14fcf9888ac$export$44c361b8ec72ef7f;
'use strict';
var $55fcfb920ddcc684$exports = {};
'use strict';
$55fcfb920ddcc684$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $67b1249d88ff3c9a$exports = {};
'use strict';
var $67b1249d88ff3c9a$var$token = '%[a-f0-9]{2}';
var $67b1249d88ff3c9a$var$singleMatcher = new RegExp('(' + $67b1249d88ff3c9a$var$token + ')|([^%]+?)', 'gi');
var $67b1249d88ff3c9a$var$multiMatcher = new RegExp('(' + $67b1249d88ff3c9a$var$token + ')+', 'gi');
function $67b1249d88ff3c9a$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $67b1249d88ff3c9a$var$decodeComponents(left), $67b1249d88ff3c9a$var$decodeComponents(right));
}
function $67b1249d88ff3c9a$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($67b1249d88ff3c9a$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $67b1249d88ff3c9a$var$decodeComponents(tokens, i).join('');
            tokens = input.match($67b1249d88ff3c9a$var$singleMatcher) || [];
        }
        return input;
    }
}
function $67b1249d88ff3c9a$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $67b1249d88ff3c9a$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $67b1249d88ff3c9a$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $67b1249d88ff3c9a$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
$67b1249d88ff3c9a$exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $67b1249d88ff3c9a$var$customDecodeURIComponent(encodedURI);
    }
};


var $55900e79e16017b8$exports = {};
'use strict';
$55900e79e16017b8$exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $3b9588f478f30ba8$exports = {};
'use strict';
$3b9588f478f30ba8$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $8cc3d14fcf9888ac$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $8cc3d14fcf9888ac$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $8cc3d14fcf9888ac$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $8cc3d14fcf9888ac$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $8cc3d14fcf9888ac$var$encode(key, options),
                            '[',
                            $8cc3d14fcf9888ac$var$encode(index, options),
                            ']=',
                            $8cc3d14fcf9888ac$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $8cc3d14fcf9888ac$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $8cc3d14fcf9888ac$var$encode(key, options),
                            '[]=',
                            $8cc3d14fcf9888ac$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $8cc3d14fcf9888ac$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $8cc3d14fcf9888ac$var$encode(key, options),
                            ':list=',
                            $8cc3d14fcf9888ac$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $8cc3d14fcf9888ac$var$encode(key, options),
                                keyValueSep,
                                $8cc3d14fcf9888ac$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $8cc3d14fcf9888ac$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $8cc3d14fcf9888ac$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $8cc3d14fcf9888ac$var$encode(key, options),
                            '=',
                            $8cc3d14fcf9888ac$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $8cc3d14fcf9888ac$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $8cc3d14fcf9888ac$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $8cc3d14fcf9888ac$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$8cc3d14fcf9888ac$var$decode(item, options)) : value === null ? value : $8cc3d14fcf9888ac$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $8cc3d14fcf9888ac$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$8cc3d14fcf9888ac$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $8cc3d14fcf9888ac$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $8cc3d14fcf9888ac$var$encode(value, options) {
    if (options.encode) return options.strict ? $55fcfb920ddcc684$exports(value) : encodeURIComponent(value);
    return value;
}
function $8cc3d14fcf9888ac$var$decode(value, options) {
    if (options.decode) return $67b1249d88ff3c9a$exports(value);
    return value;
}
function $8cc3d14fcf9888ac$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $8cc3d14fcf9888ac$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $8cc3d14fcf9888ac$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $8cc3d14fcf9888ac$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $8cc3d14fcf9888ac$var$extract(input) {
    input = $8cc3d14fcf9888ac$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $8cc3d14fcf9888ac$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $8cc3d14fcf9888ac$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $8cc3d14fcf9888ac$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $8cc3d14fcf9888ac$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $55900e79e16017b8$exports(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $8cc3d14fcf9888ac$var$decode(value, options);
        formatter($8cc3d14fcf9888ac$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $8cc3d14fcf9888ac$var$parseValue(value[k], options);
        else ret[key] = $8cc3d14fcf9888ac$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $8cc3d14fcf9888ac$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$8cc3d14fcf9888ac$export$f9380c9a627682d3 = $8cc3d14fcf9888ac$var$extract;
$8cc3d14fcf9888ac$export$98e6a39c04603d36 = $8cc3d14fcf9888ac$var$parse;
$8cc3d14fcf9888ac$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $8cc3d14fcf9888ac$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $8cc3d14fcf9888ac$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $8cc3d14fcf9888ac$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $8cc3d14fcf9888ac$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $8cc3d14fcf9888ac$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $8cc3d14fcf9888ac$var$encode(key, options) + '=' + $8cc3d14fcf9888ac$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$8cc3d14fcf9888ac$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $55900e79e16017b8$exports(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $8cc3d14fcf9888ac$var$parse($8cc3d14fcf9888ac$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $8cc3d14fcf9888ac$var$decode(hash, options)
    } : {});
};
$8cc3d14fcf9888ac$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$8cc3d14fcf9888ac$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $8cc3d14fcf9888ac$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $8cc3d14fcf9888ac$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $8cc3d14fcf9888ac$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $8cc3d14fcf9888ac$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $8cc3d14fcf9888ac$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$8cc3d14fcf9888ac$var$encodeFragmentIdentifier] ? $8cc3d14fcf9888ac$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$8cc3d14fcf9888ac$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$8cc3d14fcf9888ac$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $8cc3d14fcf9888ac$export$7a5253c0f62e0150(input, options);
    return $8cc3d14fcf9888ac$export$a8c1621ea79325d3({
        url: url,
        query: $3b9588f478f30ba8$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$8cc3d14fcf9888ac$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $8cc3d14fcf9888ac$export$357523c63a2253b9(input, exclusionFilter, options);
};


const $1cacef187b901f2c$export$ded69dcd8ce7e468 = (options, props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8cc3d14fcf9888ac$exports))).stringify((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        skipNull: true
    }));
};


const $553835ea16648c6f$export$d4731ebe50b2f70b = ({ objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objectives/${objectiveId}`);
const $553835ea16648c6f$export$73df232807302865 = async ({ offset: offset = 0, filters: filters })=>{
    const queryParams = (0, $1cacef187b901f2c$export$ded69dcd8ce7e468)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, filters), {
        offset: offset
    }));
    return await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objectives?${queryParams}`);
};
const $553835ea16648c6f$export$1a58453a98bcf79e = async ({ offset: offset = 0, filters: filters })=>{
    const queryParams = (0, $1cacef187b901f2c$export$ded69dcd8ce7e468)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, filters), {
        offset: offset
    }));
    return await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/groupObjectives?${queryParams}`);
};
const $553835ea16648c6f$export$d6292f1ee2869c8e = async ({ objective: objective })=>await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(`/objectives`, objective);
const $553835ea16648c6f$export$417f69f9ec942304 = async ({ objective: objective })=>await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`/objectives/${objective.id}`, objective);
const $553835ea16648c6f$export$f524d4048408793c = async (objectiveId)=>await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).delete(`/objectives/${objectiveId}`);
const $553835ea16648c6f$export$b76cada91418b11a = async ({ ownerId: ownerId, ownerType: ownerType, objective: objective })=>await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`/objectives/${objective.id}/status`, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
        ownerId: ownerId,
        ownerType: ownerType
    }));
const $553835ea16648c6f$export$fddb30f8f7aab3e3 = async ({ objective: objective })=>await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`/objectives/${objective.id}/developmentStatus`, objective);
const $553835ea16648c6f$export$9e16dc478dc7290d = async ({ objectiveData: objectiveData })=>await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`/objectives/${objectiveData.objective.id}/failed`, objectiveData);
const $553835ea16648c6f$export$a8b14870a33d7ee9 = async ({ createdAt: createdAt, pageNumber: pageNumber, objectiveId: objectiveId, subjectType: subjectType })=>{
    const queryParams = (0, $1cacef187b901f2c$export$ded69dcd8ce7e468)({
        subjectType: subjectType,
        createdAt: createdAt,
        pageNumber: pageNumber
    });
    return await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`objective/${objectiveId}/eventLogs?${queryParams}`);
};
const $553835ea16648c6f$export$36ce47d8e1207878 = async ({ ownerId: ownerId, ownerType: ownerType, objectiveId: objectiveId, kpiId: id, createdAt: createdAt, subjectType: subjectType, pageNumber: pageNumber })=>{
    const queryParams = (0, $1cacef187b901f2c$export$ded69dcd8ce7e468)({
        subjectType: subjectType,
        createdAt: createdAt,
        pageNumber: pageNumber
    });
    return await (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`objective/${objectiveId}/kpis/${id}/eventLogs?${queryParams}`);
};



const $5b370f02b85c28ed$export$77de90c6937e3257 = ({ objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objective/${objectiveId}/relations`);





var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");

var $ckpfM = parcelRequire("ckpfM");
var $d5169837f829e685$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            boxSizing: 'border-box',
            // Prevent padding issue with the Modal and fixed positioned AppBar.
            zIndex: theme.zIndex.appBar,
            flexShrink: 0
        },
        /* Styles applied to the root element if `position="fixed"`. */ positionFixed: {
            position: 'fixed',
            top: 0,
            left: 'auto',
            right: 0,
            '@media print': {
                // Prevent the app bar to be visible on each printed page.
                position: 'absolute'
            }
        },
        /* Styles applied to the root element if `position="absolute"`. */ positionAbsolute: {
            position: 'absolute',
            top: 0,
            left: 'auto',
            right: 0
        },
        /* Styles applied to the root element if `position="sticky"`. */ positionSticky: {
            // ⚠️ sticky is not supported by IE 11.
            position: 'sticky',
            top: 0,
            left: 'auto',
            right: 0
        },
        /* Styles applied to the root element if `position="static"`. */ positionStatic: {
            position: 'static'
        },
        /* Styles applied to the root element if `position="relative"`. */ positionRelative: {
            position: 'relative'
        },
        /* Styles applied to the root element if `color="default"`. */ colorDefault: {
            backgroundColor: backgroundColorDefault,
            color: theme.palette.getContrastText(backgroundColorDefault)
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="transparent"`. */ colorTransparent: {
            backgroundColor: 'transparent',
            color: 'inherit'
        }
    };
};
var $d5169837f829e685$var$AppBar = /*#__PURE__*/ $7fPBF.forwardRef(function AppBar(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$position = props.position, position = _props$position === void 0 ? 'fixed' : _props$position, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "color",
        "position"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $ckpfM.default), (0, $kY3Ke.default)({
        square: true,
        component: "header",
        elevation: 4,
        className: (0, $jtRae.default)(classes.root, classes["position".concat((0, $dKzJP.default)(position))], classes["color".concat((0, $dKzJP.default)(color))], className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $d5169837f829e685$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($d5169837f829e685$export$9dd6ff9ea0189349, {
    name: 'MuiAppBar'
})($d5169837f829e685$var$AppBar);


var $fwAOd = parcelRequire("fwAOd");
var $iRcsz = parcelRequire("iRcsz");
var $by0pu = parcelRequire("by0pu");
var $j9gH9 = parcelRequire("j9gH9");
var $kGz5b = parcelRequire("kGz5b");
var $fH0xA = parcelRequire("fH0xA");

var $359140b07f30c24a$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");
var $dcec985ce352b9cb$exports = {};

var $bRUy3 = parcelRequire("bRUy3");
var $dcec985ce352b9cb$var$_typeof = $bRUy3.default;
function $dcec985ce352b9cb$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($dcec985ce352b9cb$exports = $dcec985ce352b9cb$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $dcec985ce352b9cb$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, $dcec985ce352b9cb$exports.__esModule = true, $dcec985ce352b9cb$exports["default"] = $dcec985ce352b9cb$exports)(e, t);
}
$dcec985ce352b9cb$exports = $dcec985ce352b9cb$var$_interopRequireWildcard, $dcec985ce352b9cb$exports.__esModule = true, $dcec985ce352b9cb$exports["default"] = $dcec985ce352b9cb$exports;


Object.defineProperty($359140b07f30c24a$exports, "__esModule", {
    value: true
});
$359140b07f30c24a$exports.default = void 0;

var $359140b07f30c24a$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $359140b07f30c24a$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $359140b07f30c24a$var$_default = (0, $359140b07f30c24a$var$_createSvgIcon.default)(/*#__PURE__*/ $359140b07f30c24a$var$React.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
$359140b07f30c24a$exports.default = $359140b07f30c24a$var$_default;




var $7fPBF = parcelRequire("7fPBF");




var $iRcsz = parcelRequire("iRcsz");
var $by0pu = parcelRequire("by0pu");
var $7w83m = parcelRequire("7w83m");
var $g21Gx = parcelRequire("g21Gx");
var $03f30fc507164396$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($03f30fc507164396$exports, "__esModule", {
    value: true
});
$03f30fc507164396$exports.default = void 0;

var $03f30fc507164396$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $03f30fc507164396$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $03f30fc507164396$var$_default = (0, $03f30fc507164396$var$_createSvgIcon.default)(/*#__PURE__*/ $03f30fc507164396$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
}), 'AccountCircle');
$03f30fc507164396$exports.default = $03f30fc507164396$var$_default;


const $46ab6eacd6c2efdc$var$UserMenu = ({ handleLogOut: handleLogOut })=>{
    const { loginName: loginName } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee);
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const open = Boolean(anchorEl);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleMenu = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const useStyles = (0, $by0pu.default)({
        loginNameGridItem: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        loginName: {
            wordBreak: 'break-all'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        item: true,
        container: true,
        xs: 4,
        sm: 7,
        md: 7,
        className: classes.loginNameGridItem,
        justifyContent: "flex-end",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: classes.loginName,
                children: loginName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                "aria-label": "account-of-current-user",
                "aria-controls": "menu-appbar",
                "aria-haspopup": "true",
                onClick: handleMenu,
                color: "inherit",
                className: "user-menu-btn",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($03f30fc507164396$exports))), {})
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7w83m.default), {
                id: "menu-appbar",
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                keepMounted: true,
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                open: open,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $g21Gx.default), {
                        component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                        to: "/settings",
                        children: t('common.header.settings')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $g21Gx.default), {
                        onClick: handleLogOut,
                        component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                        to: "/",
                        children: t('common.header.logout')
                    })
                ]
            })
        ]
    });
};
var $46ab6eacd6c2efdc$export$2e2bcd8739ae039 = $46ab6eacd6c2efdc$var$UserMenu;



parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $2jEfe = parcelRequire("2jEfe");
var $b38083796464285f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 1,
            margin: 0,
            // Reset browser default style.
            border: 'none',
            flexShrink: 0,
            backgroundColor: theme.palette.divider
        },
        /* Styles applied to the root element if `absolute={true}`. */ absolute: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%'
        },
        /* Styles applied to the root element if `variant="inset"`. */ inset: {
            marginLeft: 72
        },
        /* Styles applied to the root element if `light={true}`. */ light: {
            backgroundColor: (0, $2jEfe.alpha)(theme.palette.divider, 0.08)
        },
        /* Styles applied to the root element if `variant="middle"`. */ middle: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2)
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            height: '100%',
            width: 1
        },
        /* Styles applied to the root element if `flexItem={true}`. */ flexItem: {
            alignSelf: 'stretch',
            height: 'auto'
        }
    };
};
var $b38083796464285f$var$Divider = /*#__PURE__*/ $7fPBF.forwardRef(function Divider(props, ref) {
    var _props$absolute = props.absolute, absolute = _props$absolute === void 0 ? false : _props$absolute, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'hr' : _props$component, _props$flexItem = props.flexItem, flexItem = _props$flexItem === void 0 ? false : _props$flexItem, _props$light = props.light, light = _props$light === void 0 ? false : _props$light, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$role = props.role, role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role, _props$variant = props.variant, variant = _props$variant === void 0 ? 'fullWidth' : _props$variant, other = (0, $lfiYO.default)(props, [
        "absolute",
        "classes",
        "className",
        "component",
        "flexItem",
        "light",
        "orientation",
        "role",
        "variant"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
        role: role,
        ref: ref
    }, other));
});
var $b38083796464285f$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($b38083796464285f$export$9dd6ff9ea0189349, {
    name: 'MuiDivider'
})($b38083796464285f$var$Divider);


var $iRcsz = parcelRequire("iRcsz");
var $fOH1P = parcelRequire("fOH1P");
var $by0pu = parcelRequire("by0pu");
var $fH0xA = parcelRequire("fH0xA");
var $f5276281961e8e5a$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($f5276281961e8e5a$exports, "__esModule", {
    value: true
});
$f5276281961e8e5a$exports.default = void 0;

var $f5276281961e8e5a$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $f5276281961e8e5a$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $f5276281961e8e5a$var$_default = (0, $f5276281961e8e5a$var$_createSvgIcon.default)(/*#__PURE__*/ $f5276281961e8e5a$var$React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');
$f5276281961e8e5a$exports.default = $f5276281961e8e5a$var$_default;


var $b0e76c1d4e995bd3$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($b0e76c1d4e995bd3$exports, "__esModule", {
    value: true
});
$b0e76c1d4e995bd3$exports.default = void 0;

var $b0e76c1d4e995bd3$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $b0e76c1d4e995bd3$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $b0e76c1d4e995bd3$var$_default = (0, $b0e76c1d4e995bd3$var$_createSvgIcon.default)(/*#__PURE__*/ $b0e76c1d4e995bd3$var$React.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');
$b0e76c1d4e995bd3$exports.default = $b0e76c1d4e995bd3$var$_default;





var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $xOJv4 = parcelRequire("xOJv4");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $kY3Ke = parcelRequire("kY3Ke");

var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $8qMCX = parcelRequire("8qMCX");

var $etJ3Q = parcelRequire("etJ3Q");

var $fH0xA = parcelRequire("fH0xA");

var $2Jy9X = parcelRequire("2Jy9X");

var $55RWP = parcelRequire("55RWP");
var $aee444e9a7aad56f$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
var $aee444e9a7aad56f$var$defaultTimeout = {
    enter: (0, $etJ3Q.duration).enteringScreen,
    exit: (0, $etJ3Q.duration).leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $aee444e9a7aad56f$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $8qMCX.default) : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $aee444e9a7aad56f$var$defaultTimeout : _props$timeout, other = (0, $lfiYO.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "TransitionComponent",
        "timeout"
    ]);
    var theme = (0, $fH0xA.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $7fPBF.useRef(null);
    var foreignRef = (0, $55RWP.default)(children.ref, ref);
    var handleRef = (0, $55RWP.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $2gIIh.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $2Jy9X.reflow)(node); // So the animation always start from the start.
        var transitionProps = (0, $2Jy9X.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $2Jy9X.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    return /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
            style: (0, $kY3Ke.default)({
                opacity: 0,
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $aee444e9a7aad56f$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
var $aee444e9a7aad56f$export$2e2bcd8739ae039 = $aee444e9a7aad56f$var$Fade;


var $62eb4b2d9a4a5ba8$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        // Improve scrollable dialog support.
        zIndex: -1,
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
var $62eb4b2d9a4a5ba8$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $aee444e9a7aad56f$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "invisible",
        "open",
        "transitionDuration",
        "TransitionComponent"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        timeout: transitionDuration
    }, other), /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $jtRae.default)(classes.root, className, invisible && classes.invisible),
        "aria-hidden": true,
        ref: ref
    }, children));
});
var $62eb4b2d9a4a5ba8$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($62eb4b2d9a4a5ba8$export$9dd6ff9ea0189349, {
    name: 'MuiBackdrop'
})($62eb4b2d9a4a5ba8$var$Backdrop);



var $3Sc7z = parcelRequire("3Sc7z");


var $ckpfM = parcelRequire("ckpfM");

var $dKzJP = parcelRequire("dKzJP");

var $etJ3Q = parcelRequire("etJ3Q");

var $fH0xA = parcelRequire("fH0xA");
var $8475ebd163bc8f87$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `variant="permanent or persistent"`. */ docked: {
            flex: '0 0 auto'
        },
        /* Styles applied to the `Paper` component. */ paper: {
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            flex: '1 0 auto',
            zIndex: theme.zIndex.drawer,
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            // temporary style
            position: 'fixed',
            top: 0,
            // We disable the focus ring for mouse, touch and keyboard users.
            // At some point, it would be better to keep it for keyboard users.
            // :focus-ring CSS pseudo-class will help.
            outline: 0
        },
        /* Styles applied to the `Paper` component if `anchor="left"`. */ paperAnchorLeft: {
            left: 0,
            right: 'auto'
        },
        /* Styles applied to the `Paper` component if `anchor="right"`. */ paperAnchorRight: {
            left: 'auto',
            right: 0
        },
        /* Styles applied to the `Paper` component if `anchor="top"`. */ paperAnchorTop: {
            top: 0,
            left: 0,
            bottom: 'auto',
            right: 0,
            height: 'auto',
            maxHeight: '100%'
        },
        /* Styles applied to the `Paper` component if `anchor="bottom"`. */ paperAnchorBottom: {
            top: 'auto',
            left: 0,
            bottom: 0,
            right: 0,
            height: 'auto',
            maxHeight: '100%'
        },
        /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */ paperAnchorDockedLeft: {
            borderRight: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */ paperAnchorDockedTop: {
            borderBottom: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */ paperAnchorDockedRight: {
            borderLeft: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */ paperAnchorDockedBottom: {
            borderTop: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Modal` component. */ modal: {}
    };
};
var $8475ebd163bc8f87$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $8475ebd163bc8f87$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $8475ebd163bc8f87$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === 'rtl' && $8475ebd163bc8f87$export$2a62b49acb270576(anchor) ? $8475ebd163bc8f87$var$oppositeDirection[anchor] : anchor;
}
var $8475ebd163bc8f87$var$defaultTransitionDuration = {
    enter: (0, $etJ3Q.duration).enteringScreen,
    exit: (0, $etJ3Q.duration).leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ var $8475ebd163bc8f87$var$Drawer = /*#__PURE__*/ $7fPBF.forwardRef(function Drawer(props, ref) {
    var _props$anchor = props.anchor, anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor, BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 16 : _props$elevation, _props$ModalProps = props.ModalProps;
    _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
    var BackdropPropsProp = _props$ModalProps.BackdropProps, ModalProps = (0, $lfiYO.default)(_props$ModalProps, [
        "BackdropProps"
    ]), onClose = props.onClose, _props$open = props.open, open = _props$open === void 0 ? false : _props$open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, SlideProps = props.SlideProps, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $24065f65990d49ec$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $8475ebd163bc8f87$var$defaultTransitionDuration : _props$transitionDura, _props$variant = props.variant, variant = _props$variant === void 0 ? 'temporary' : _props$variant, other = (0, $lfiYO.default)(props, [
        "anchor",
        "BackdropProps",
        "children",
        "classes",
        "className",
        "elevation",
        "ModalProps",
        "onClose",
        "open",
        "PaperProps",
        "SlideProps",
        "TransitionComponent",
        "transitionDuration",
        "variant"
    ]);
    var theme = (0, $fH0xA.default)(); // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    var mounted = $7fPBF.useRef(false);
    $7fPBF.useEffect(function() {
        mounted.current = true;
    }, []);
    var anchor = $8475ebd163bc8f87$export$830f4f08342d299e(theme, anchorProp);
    var drawer = /*#__PURE__*/ $7fPBF.createElement((0, $ckpfM.default), (0, $kY3Ke.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $jtRae.default)(classes.paper, classes["paperAnchor".concat((0, $dKzJP.default)(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat((0, $dKzJP.default)(anchor))])
    }), children);
    if (variant === 'permanent') return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes.docked, className),
        ref: ref
    }, other), drawer);
    var slidingDrawer = /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        direction: $8475ebd163bc8f87$var$oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps), drawer);
    if (variant === 'persistent') return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes.docked, className),
        ref: ref
    }, other), slidingDrawer);
     // variant === temporary
    return /*#__PURE__*/ $7fPBF.createElement((0, $xOJv4.default), (0, $kY3Ke.default)({
        BackdropProps: (0, $kY3Ke.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        BackdropComponent: (0, $62eb4b2d9a4a5ba8$export$2e2bcd8739ae039),
        className: (0, $jtRae.default)(classes.root, classes.modal, className),
        open: open,
        onClose: onClose,
        ref: ref
    }, other, ModalProps), slidingDrawer);
});
var $8475ebd163bc8f87$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($8475ebd163bc8f87$export$9dd6ff9ea0189349, {
    name: 'MuiDrawer',
    flip: false
})($8475ebd163bc8f87$var$Drawer);


var $j9gH9 = parcelRequire("j9gH9");

const $a0ab0732f55cb419$var$openedMixin = (theme)=>({
        width: (0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH),
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        overflowX: 'hidden'
    });
const $a0ab0732f55cb419$var$closedMixin = (theme)=>({
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: '55px'
    });
const $a0ab0732f55cb419$export$7a49bdedb3cef1c4 = (0, $j9gH9.default)((0, $8475ebd163bc8f87$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'open'
})(({ theme: theme, open: open })=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        width: (0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH),
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box'
    }, open && (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $a0ab0732f55cb419$var$openedMixin(theme)), {
        '& .MuiDrawer-paper': $a0ab0732f55cb419$var$openedMixin(theme)
    }), !open && (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $a0ab0732f55cb419$var$closedMixin(theme)), {
        '& .MuiDrawer-paper': $a0ab0732f55cb419$var$closedMixin(theme)
    })));
const $a0ab0732f55cb419$export$bb68d554ded258ea = (0, $j9gH9.default)('div')(({ theme: theme })=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1)
    }, theme.mixins.toolbar));





parcelRequire("7fPBF");


var $jaezp = parcelRequire("jaezp");
var $hPUC4 = parcelRequire("hPUC4");
var $fHFY6 = parcelRequire("fHFY6");
var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $1rW9t = parcelRequire("1rW9t");

var $2YkFy = parcelRequire("2YkFy");
var $f2875d42fcb2a6c2$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    },
    /* Styles applied to the `Typography` components if primary and secondary are set. */ multiline: {
        marginTop: 6,
        marginBottom: 6
    },
    /* Styles applied to the `Typography` components if dense. */ dense: {},
    /* Styles applied to the root element if `inset={true}`. */ inset: {
        paddingLeft: 56
    },
    /* Styles applied to the primary `Typography` component. */ primary: {},
    /* Styles applied to the secondary `Typography` component. */ secondary: {}
};
var $f2875d42fcb2a6c2$var$ListItemText = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, primaryProp = props.primary, primaryTypographyProps = props.primaryTypographyProps, secondaryProp = props.secondary, secondaryTypographyProps = props.secondaryTypographyProps, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography",
        "inset",
        "primary",
        "primaryTypographyProps",
        "secondary",
        "secondaryTypographyProps"
    ]);
    var _React$useContext = $7fPBF.useContext((0, $2YkFy.default)), dense = _React$useContext.dense;
    var primary = primaryProp != null ? primaryProp : children;
    if (primary != null && primary.type !== (0, $1rW9t.default) && !disableTypography) primary = /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), (0, $kY3Ke.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps), primary);
    var secondary = secondaryProp;
    if (secondary != null && secondary.type !== (0, $1rW9t.default) && !disableTypography) secondary = /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), (0, $kY3Ke.default)({
        variant: "body2",
        className: classes.secondary,
        color: "textSecondary",
        display: "block"
    }, secondaryTypographyProps), secondary);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
        ref: ref
    }, other), primary, secondary);
});
var $f2875d42fcb2a6c2$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($f2875d42fcb2a6c2$export$9dd6ff9ea0189349, {
    name: 'MuiListItemText'
})($f2875d42fcb2a6c2$var$ListItemText);


var $by0pu = parcelRequire("by0pu");
var $hzQpW = parcelRequire("hzQpW");

var $jtRae = parcelRequire("jtRae");
const $0ae755bbf1b62ecf$var$useStyles = (0, $by0pu.default)({
    icon: {
        minWidth: '40px'
    },
    listItemText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gridGap: 8,
        fontSize: '13px'
    },
    text: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 100
    },
    badge: {
        '& svg': {
            height: 24,
            width: 24
        }
    }
}, {
    name: 'DrawerItem'
});
const $0ae755bbf1b62ecf$var$DrawerListItem = ({ open: open, icon: icon, text: text, to: to, badgeProps: badgeProps })=>{
    const classes = $0ae755bbf1b62ecf$var$useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
        title: text,
        disableHoverListener: open,
        disableFocusListener: open,
        disableTouchListener: open,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $hPUC4.default), {
            button: true,
            component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
            to: to,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fHFY6.default), {
                    className: classes.icon,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $jaezp.default), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        invisible: open || !badgeProps.badgeContent
                    }, badgeProps), {
                        className: (0, $jtRae.default)(classes.badge, badgeProps.className),
                        overlap: "rectangular",
                        children: icon
                    }))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2875d42fcb2a6c2$export$2e2bcd8739ae039), {
                    classes: {
                        primary: classes.listItemText
                    },
                    primary: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: classes.text,
                                children: text
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: badgeProps.badgeContent
                            })
                        ]
                    })
                })
            ]
        }, 2)
    });
};
var $0ae755bbf1b62ecf$export$2e2bcd8739ae039 = $0ae755bbf1b62ecf$var$DrawerListItem;



const $d100f6a66ca66027$var$useStyles = (0, $by0pu.default)({
    groupBadge: {
        '& .MuiBadge-badge': {
            background: '#3498DB',
            color: 'white'
        }
    }
}, {
    name: 'NavigationDrawer'
});
const $d100f6a66ca66027$var$NavigationDrawer = ({ drawerOpen: drawerOpen, handleDrawerClose: handleDrawerClose, handleDrawerOpen: handleDrawerOpen, badgeInfo: badgeInfo = {} })=>{
    const theme = (0, $fH0xA.default)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $d100f6a66ca66027$var$useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0ab0732f55cb419$export$7a49bdedb3cef1c4), {
            variant: "permanent",
            open: drawerOpen,
            theme: theme,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0ab0732f55cb419$export$bb68d554ded258ea), {
                    theme: theme,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                        onClick: drawerOpen ? handleDrawerClose : handleDrawerOpen,
                        children: drawerOpen ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b0e76c1d4e995bd3$exports))), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f5276281961e8e5a$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fOH1P.default), {
                    children: (0, $259b7c5a28f3e893$export$492bdc31a14c4d1).map((route)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0ae755bbf1b62ecf$export$2e2bcd8739ae039), {
                            icon: route.icon,
                            text: t(route.translationKey),
                            to: route.path,
                            open: drawerOpen,
                            badgeProps: {
                                badgeContent: Number(badgeInfo[route.badgeInfoKey]) || null,
                                color: route.badgeColor,
                                className: classes[route.badgeClassName]
                            }
                        }, route.path))
                })
            ]
        })
    });
};
var $d100f6a66ca66027$export$2e2bcd8739ae039 = $d100f6a66ca66027$var$NavigationDrawer;




var $7fPBF = parcelRequire("7fPBF");

var $iRcsz = parcelRequire("iRcsz");
var $by0pu = parcelRequire("by0pu");
var $g21Gx = parcelRequire("g21Gx");


const $c5c6974e3317b2c8$var$MobileDrawer = ({ anchor: anchor, navigationRoutes: navigationRoutes = [], icon: icon, badgeInfo: badgeInfo = {} })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    const toggleDrawer = (open)=>(event)=>{
            if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
            setIsOpen(open);
        };
    const useStyles = (0, $by0pu.default)({
        menuItem: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gridGap: 8,
            fontSize: '13px'
        }
    }, {
        name: 'DrawerItem'
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                "aria-label": "account of current user",
                onClick: toggleDrawer(true),
                color: "inherit",
                children: icon
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8475ebd163bc8f87$export$2e2bcd8739ae039), {
                open: isOpen,
                onClose: toggleDrawer(false),
                anchor: anchor,
                children: navigationRoutes.map((route)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $g21Gx.default), {
                        component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                        to: route.path,
                        className: classes.menuItem,
                        onClick: route.onClick,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: t(route.translationKey)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: Number(badgeInfo[route.badgeInfoKey]) || ''
                            })
                        ]
                    }, route.path))
            })
        ]
    });
};
var $c5c6974e3317b2c8$export$2e2bcd8739ae039 = $c5c6974e3317b2c8$var$MobileDrawer;


var $abc54b4ee55e9dbc$exports = {};
$abc54b4ee55e9dbc$exports = $parcel$resolve("g6uqV");





const $8900baf4932ca27f$export$1eb43f64fa16e748 = ()=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/drawerInfo`);







const $899ea3d88a7a8f04$var$Header = ({ history: history, drawerOpen: drawerOpen, setDrawerOpen: setDrawerOpen })=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const theme = (0, $fH0xA.default)();
    const sm = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $401a17725816a5a8$export$d5f42470fa5a7347)());
    }, [
        dispatch
    ]);
    const drawerInfoQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)('drawerInfo', async ()=>{
        const { data: data } = await (0, $8900baf4932ca27f$export$1eb43f64fa16e748)();
        return data;
    });
    const handleDrawerOpen = ()=>{
        setDrawerOpen(true);
    };
    const handleDrawerClose = ()=>{
        setDrawerOpen(false);
    };
    const handleLogOut = ()=>{
        (0, $e4998d3746b968db$export$a0973bcfe11b05c9)();
        dispatch((0, $e84d7fda3797eb81$export$8e84bad0b35de9e8)());
    };
    const StyledAppBar = (0, $j9gH9.default)((0, $d5169837f829e685$export$2e2bcd8739ae039), {
        shouldForwardProp: (prop)=>prop !== 'open'
    })(({ theme: theme, open: open })=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create([
                'width',
                'margin'
            ], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            })
        }, open && {
            marginLeft: (0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH),
            width: `calc(100% - ${0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH}px)`,
            transition: theme.transitions.create([
                'width',
                'margin'
            ], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
        }));
    const useStyles = (0, $by0pu.default)({
        logo: {
            height: 'auto',
            width: '100%',
            maxWidth: '140px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(StyledAppBar, {
                position: "relative",
                color: 'primary',
                open: sm && drawerOpen,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $kGz5b.default), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        container: true,
                        direction: 'row',
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                item: true,
                                container: true,
                                wrap: "nowrap",
                                direction: 'row',
                                xs: 8,
                                sm: 5,
                                md: 5,
                                alignItems: "center",
                                children: [
                                    sm ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                                        "aria-label": "open drawer",
                                        edge: "start",
                                        onClick: handleDrawerOpen,
                                        color: "inherit",
                                        sx: {
                                            marginRight: '36px'
                                        },
                                        style: {
                                            display: drawerOpen && 'none'
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($359140b07f30c24a$exports))), {})
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c5c6974e3317b2c8$export$2e2bcd8739ae039), {
                                        navigationRoutes: (0, $259b7c5a28f3e893$export$492bdc31a14c4d1),
                                        anchor: 'left',
                                        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($359140b07f30c24a$exports))), {}),
                                        badgeInfo: drawerInfoQuery.data
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                                        component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                                        to: "/objectives",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($abc54b4ee55e9dbc$exports))),
                                            alt: "logo",
                                            className: classes.logo
                                        })
                                    })
                                ]
                            }),
                            sm ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $46ab6eacd6c2efdc$export$2e2bcd8739ae039), {
                                handleLogOut: handleLogOut
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c5c6974e3317b2c8$export$2e2bcd8739ae039), {
                                navigationRoutes: (0, $259b7c5a28f3e893$export$330acb37fe7f2d00)(handleLogOut),
                                anchor: 'right',
                                icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($03f30fc507164396$exports))), {})
                            })
                        ]
                    })
                })
            }),
            sm && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d100f6a66ca66027$export$2e2bcd8739ae039), {
                drawerOpen: drawerOpen,
                handleDrawerClose: handleDrawerClose,
                handleDrawerOpen: handleDrawerOpen,
                badgeInfo: drawerInfoQuery.data
            })
        ]
    });
};
var $899ea3d88a7a8f04$export$2e2bcd8739ae039 = $899ea3d88a7a8f04$var$Header;






var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");


var $xOJv4 = parcelRequire("xOJv4");



var $etJ3Q = parcelRequire("etJ3Q");

var $ckpfM = parcelRequire("ckpfM");
var $10c0df872321f413$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            '@media print': {
                // Use !important to override the Modal inline-style.
                position: 'absolute !important'
            }
        },
        /* Styles applied to the container element if `scroll="paper"`. */ scrollPaper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        /* Styles applied to the container element if `scroll="body"`. */ scrollBody: {
            overflowY: 'auto',
            overflowX: 'hidden',
            textAlign: 'center',
            '&:after': {
                content: '""',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0'
            }
        },
        /* Styles applied to the container element. */ container: {
            height: '100%',
            '@media print': {
                height: 'auto'
            },
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0
        },
        /* Styles applied to the `Paper` component. */ paper: {
            margin: 32,
            position: 'relative',
            overflowY: 'auto',
            // Fix IE 11 issue, to remove at some point.
            '@media print': {
                overflowY: 'visible',
                boxShadow: 'none'
            }
        },
        /* Styles applied to the `Paper` component if `scroll="paper"`. */ paperScrollPaper: {
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `scroll="body"`. */ paperScrollBody: {
            display: 'inline-block',
            verticalAlign: 'middle',
            textAlign: 'left' // 'initial' doesn't work on IE 11
        },
        /* Styles applied to the `Paper` component if `maxWidth=false`. */ paperWidthFalse: {
            maxWidth: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `maxWidth="xs"`. */ paperWidthXs: {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444),
            '&$paperScrollBody': (0, $dQMrF.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="sm"`. */ paperWidthSm: {
            maxWidth: theme.breakpoints.values.sm,
            '&$paperScrollBody': (0, $dQMrF.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="md"`. */ paperWidthMd: {
            maxWidth: theme.breakpoints.values.md,
            '&$paperScrollBody': (0, $dQMrF.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="lg"`. */ paperWidthLg: {
            maxWidth: theme.breakpoints.values.lg,
            '&$paperScrollBody': (0, $dQMrF.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="xl"`. */ paperWidthXl: {
            maxWidth: theme.breakpoints.values.xl,
            '&$paperScrollBody': (0, $dQMrF.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `fullWidth={true}`. */ paperFullWidth: {
            width: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `fullScreen={true}`. */ paperFullScreen: {
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: 'none',
            borderRadius: 0,
            '&$paperScrollBody': {
                margin: 0,
                maxWidth: '100%'
            }
        }
    };
};
var $10c0df872321f413$var$defaultTransitionDuration = {
    enter: (0, $etJ3Q.duration).enteringScreen,
    exit: (0, $etJ3Q.duration).leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ var $10c0df872321f413$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(props, ref) {
    var BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$fullScreen = props.fullScreen, fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onEscapeKeyDown = props.onEscapeKeyDown, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $ckpfM.default) : _props$PaperComponent, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$scroll = props.scroll, scroll = _props$scroll === void 0 ? 'paper' : _props$scroll, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $aee444e9a7aad56f$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $10c0df872321f413$var$defaultTransitionDuration : _props$transitionDura, TransitionProps = props.TransitionProps, ariaDescribedby = props['aria-describedby'], ariaLabelledby = props['aria-labelledby'], other = (0, $lfiYO.default)(props, [
        "BackdropProps",
        "children",
        "classes",
        "className",
        "disableBackdropClick",
        "disableEscapeKeyDown",
        "fullScreen",
        "fullWidth",
        "maxWidth",
        "onBackdropClick",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onEscapeKeyDown",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperComponent",
        "PaperProps",
        "scroll",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps",
        "aria-describedby",
        "aria-labelledby"
    ]);
    var mouseDownTarget = $7fPBF.useRef();
    var handleMouseDown = function handleMouseDown(event) {
        mouseDownTarget.current = event.target;
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        // Ignore the events not coming from the "backdrop"
        // We don't want to close the dialog when clicking the dialog content.
        if (event.target !== event.currentTarget) return;
         // Make sure the event starts and ends on the same DOM element.
        if (event.target !== mouseDownTarget.current) return;
        mouseDownTarget.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $xOJv4.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        BackdropComponent: (0, $62eb4b2d9a4a5ba8$export$2e2bcd8739ae039),
        BackdropProps: (0, $kY3Ke.default)({
            transitionDuration: transitionDuration
        }, BackdropProps),
        closeAfterTransition: true
    }, disableBackdropClick ? {
        disableBackdropClick: disableBackdropClick
    } : {}, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        role: "none presentation"
    }, TransitionProps), /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $jtRae.default)(classes.container, classes["scroll".concat((0, $dKzJP.default)(scroll))]),
        onMouseUp: handleBackdropClick,
        onMouseDown: handleMouseDown
    }, /*#__PURE__*/ $7fPBF.createElement(PaperComponent, (0, $kY3Ke.default)({
        elevation: 24,
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby
    }, PaperProps, {
        className: (0, $jtRae.default)(classes.paper, classes["paperScroll".concat((0, $dKzJP.default)(scroll))], classes["paperWidth".concat((0, $dKzJP.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
    }), children))));
});
var $10c0df872321f413$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($10c0df872321f413$export$9dd6ff9ea0189349, {
    name: 'MuiDialog'
})($10c0df872321f413$var$Dialog);


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");
var $ca0b0ca6e141049d$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        '& > :not(:first-child)': {
            marginLeft: 8
        }
    }
};
var $ca0b0ca6e141049d$var$DialogActions = /*#__PURE__*/ $7fPBF.forwardRef(function DialogActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $lfiYO.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
var $ca0b0ca6e141049d$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($ca0b0ca6e141049d$export$9dd6ff9ea0189349, {
    name: 'MuiDialogActions'
})($ca0b0ca6e141049d$var$DialogActions);


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");
var $909ad9fcbee124ba$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            flex: '1 1 auto',
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            overflowY: 'auto',
            padding: '8px 24px',
            '&:first-child': {
                // dialog without title
                paddingTop: 20
            }
        },
        /* Styles applied to the root element if `dividers={true}`. */ dividers: {
            padding: '16px 24px',
            borderTop: "1px solid ".concat(theme.palette.divider),
            borderBottom: "1px solid ".concat(theme.palette.divider)
        }
    };
};
var $909ad9fcbee124ba$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(props, ref) {
    var classes = props.classes, className = props.className, _props$dividers = props.dividers, dividers = _props$dividers === void 0 ? false : _props$dividers, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "dividers"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, dividers && classes.dividers),
        ref: ref
    }, other));
});
var $909ad9fcbee124ba$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($909ad9fcbee124ba$export$9dd6ff9ea0189349, {
    name: 'MuiDialogContent'
})($909ad9fcbee124ba$var$DialogContent);


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $1rW9t = parcelRequire("1rW9t");
var $873c41bd01dae2f9$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        margin: 0,
        padding: '16px 24px',
        flex: '0 0 auto'
    }
};
var $873c41bd01dae2f9$var$DialogTitle = /*#__PURE__*/ $7fPBF.forwardRef(function DialogTitle(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        ref: ref
    }, other), disableTypography ? children : /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), {
        component: "h2",
        variant: "h6"
    }, children));
});
var $873c41bd01dae2f9$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($873c41bd01dae2f9$export$9dd6ff9ea0189349, {
    name: 'MuiDialogTitle'
})($873c41bd01dae2f9$var$DialogTitle);


var $cuouK = parcelRequire("cuouK");
var $k2dmk = parcelRequire("k2dmk");
var $by0pu = parcelRequire("by0pu");
var $MQfsM = parcelRequire("MQfsM");
var $1rW9t = parcelRequire("1rW9t");

var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $iyOta = parcelRequire("iyOta");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $41eb5b0796717985$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            boxSizing: 'border-box',
            lineHeight: '48px',
            listStyle: 'none',
            color: theme.palette.text.secondary,
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.pxToRem(14)
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the root element if `inset={true}`. */ inset: {
            paddingLeft: 72
        },
        /* Styles applied to the root element if `disableSticky={false}`. */ sticky: {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            backgroundColor: 'inherit'
        }
    };
};
var $41eb5b0796717985$var$ListSubheader = /*#__PURE__*/ $7fPBF.forwardRef(function ListSubheader(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'li' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$disableSticky = props.disableSticky, disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "disableGutters",
        "disableSticky",
        "inset"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, color !== 'default' && classes["color".concat((0, $dKzJP.default)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $41eb5b0796717985$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($41eb5b0796717985$export$9dd6ff9ea0189349, {
    name: 'MuiListSubheader'
})($41eb5b0796717985$var$ListSubheader);



var $ckpfM = parcelRequire("ckpfM");

var $iRcsz = parcelRequire("iRcsz");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $b2966d6ebb90974c$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');



var $3Sc7z = parcelRequire("3Sc7z");

var $2jEfe = parcelRequire("2jEfe");

var $55RWP = parcelRequire("55RWP");


var $dKzJP = parcelRequire("dKzJP");

var $gd1Bg = parcelRequire("gd1Bg");
var $812a279261d3d883$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
    var deleteIconColor = (0, $2jEfe.alpha)(theme.palette.text.primary, 0.26);
    return {
        /* Styles applied to the root element. */ root: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(13),
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 32,
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            borderRadius: 16,
            whiteSpace: 'nowrap',
            transition: theme.transitions.create([
                'background-color',
                'box-shadow'
            ]),
            // label will inherit this from root, then `clickable` class overrides this for both
            cursor: 'default',
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            textDecoration: 'none',
            border: 'none',
            // Remove `button` border
            padding: 0,
            // Remove `button` padding
            verticalAlign: 'middle',
            boxSizing: 'border-box',
            '&$disabled': {
                opacity: 0.5,
                pointerEvents: 'none'
            },
            '& $avatar': {
                marginLeft: 5,
                marginRight: -6,
                width: 24,
                height: 24,
                color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
                fontSize: theme.typography.pxToRem(12)
            },
            '& $avatarColorPrimary': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.dark
            },
            '& $avatarColorSecondary': {
                color: theme.palette.secondary.contrastText,
                backgroundColor: theme.palette.secondary.dark
            },
            '& $avatarSmall': {
                marginLeft: 4,
                marginRight: -4,
                width: 18,
                height: 18,
                fontSize: theme.typography.pxToRem(10)
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            height: 24
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */ clickable: {
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
            cursor: 'pointer',
            '&:hover, &:focus': {
                backgroundColor: (0, $2jEfe.emphasize)(backgroundColor, 0.08)
            },
            '&:active': {
                boxShadow: theme.shadows[1]
            }
        },
        /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */ clickableColorPrimary: {
            '&:hover, &:focus': {
                backgroundColor: (0, $2jEfe.emphasize)(theme.palette.primary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */ clickableColorSecondary: {
            '&:hover, &:focus': {
                backgroundColor: (0, $2jEfe.emphasize)(theme.palette.secondary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` is defined. */ deletable: {
            '&:focus': {
                backgroundColor: (0, $2jEfe.emphasize)(backgroundColor, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */ deletableColorPrimary: {
            '&:focus': {
                backgroundColor: (0, $2jEfe.emphasize)(theme.palette.primary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */ deletableColorSecondary: {
            '&:focus': {
                backgroundColor: (0, $2jEfe.emphasize)(theme.palette.secondary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            backgroundColor: 'transparent',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
            },
            '& $avatar': {
                marginLeft: 4
            },
            '& $avatarSmall': {
                marginLeft: 2
            },
            '& $icon': {
                marginLeft: 4
            },
            '& $iconSmall': {
                marginLeft: 2
            },
            '& $deleteIcon': {
                marginRight: 5
            },
            '& $deleteIconSmall': {
                marginRight: 3
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat(theme.palette.primary.main),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat(theme.palette.secondary.main),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
            }
        },
        // TODO v5: remove
        /* Styles applied to the `avatar` element. */ avatar: {},
        /* Styles applied to the `avatar` element if `size="small"`. */ avatarSmall: {},
        /* Styles applied to the `avatar` element if `color="primary"`. */ avatarColorPrimary: {},
        /* Styles applied to the `avatar` element if `color="secondary"`. */ avatarColorSecondary: {},
        /* Styles applied to the `icon` element. */ icon: {
            color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
            marginLeft: 5,
            marginRight: -6
        },
        /* Styles applied to the `icon` element if `size="small"`. */ iconSmall: {
            width: 18,
            height: 18,
            marginLeft: 4,
            marginRight: -4
        },
        /* Styles applied to the `icon` element if `color="primary"`. */ iconColorPrimary: {
            color: 'inherit'
        },
        /* Styles applied to the `icon` element if `color="secondary"`. */ iconColorSecondary: {
            color: 'inherit'
        },
        /* Styles applied to the label `span` element. */ label: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            paddingLeft: 12,
            paddingRight: 12,
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the label `span` element if `size="small"`. */ labelSmall: {
            paddingLeft: 8,
            paddingRight: 8
        },
        /* Styles applied to the `deleteIcon` element. */ deleteIcon: {
            WebkitTapHighlightColor: 'transparent',
            color: deleteIconColor,
            height: 22,
            width: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: (0, $2jEfe.alpha)(deleteIconColor, 0.4)
            }
        },
        /* Styles applied to the `deleteIcon` element if `size="small"`. */ deleteIconSmall: {
            height: 16,
            width: 16,
            marginRight: 4,
            marginLeft: -4
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */ deleteIconColorPrimary: {
            color: (0, $2jEfe.alpha)(theme.palette.primary.contrastText, 0.7),
            '&:hover, &:active': {
                color: theme.palette.primary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */ deleteIconColorSecondary: {
            color: (0, $2jEfe.alpha)(theme.palette.secondary.contrastText, 0.7),
            '&:hover, &:active': {
                color: theme.palette.secondary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */ deleteIconOutlinedColorPrimary: {
            color: (0, $2jEfe.alpha)(theme.palette.primary.main, 0.7),
            '&:hover, &:active': {
                color: theme.palette.primary.main
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */ deleteIconOutlinedColorSecondary: {
            color: (0, $2jEfe.alpha)(theme.palette.secondary.main, 0.7),
            '&:hover, &:active': {
                color: theme.palette.secondary.main
            }
        }
    };
};
function $812a279261d3d883$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ var $812a279261d3d883$var$Chip = /*#__PURE__*/ $7fPBF.forwardRef(function Chip(props, ref) {
    var avatarProp = props.avatar, classes = props.classes, className = props.className, clickableProp = props.clickable, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, ComponentProp = props.component, deleteIconProp = props.deleteIcon, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, iconProp = props.icon, label = props.label, onClick = props.onClick, onDelete = props.onDelete, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'default' : _props$variant, other = (0, $lfiYO.default)(props, [
        "avatar",
        "classes",
        "className",
        "clickable",
        "color",
        "component",
        "deleteIcon",
        "disabled",
        "icon",
        "label",
        "onClick",
        "onDelete",
        "onKeyDown",
        "onKeyUp",
        "size",
        "variant"
    ]);
    var chipRef = $7fPBF.useRef(null);
    var handleRef = (0, $55RWP.default)(chipRef, ref);
    var handleDeleteIconClick = function handleDeleteIconClick(event) {
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $812a279261d3d883$var$isDeleteKeyboardEvent(event)) // will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    var handleKeyUp = function handleKeyUp(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $812a279261d3d883$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    var clickable = clickableProp !== false && onClick ? true : clickableProp;
    var small = size === 'small';
    var Component = ComponentProp || (clickable ? (0, $gd1Bg.default) : 'div');
    var moreProps = Component === (0, $gd1Bg.default) ? {
        component: 'div'
    } : {};
    var deleteIcon = null;
    if (onDelete) {
        var customClasses = (0, $jtRae.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, $dKzJP.default)(color))] : classes["deleteIconOutlinedColor".concat((0, $dKzJP.default)(color))]), small && classes.deleteIconSmall);
        deleteIcon = deleteIconProp && /*#__PURE__*/ $7fPBF.isValidElement(deleteIconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(deleteIconProp, {
            className: (0, $jtRae.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        }) : /*#__PURE__*/ $7fPBF.createElement((0, $b2966d6ebb90974c$export$2e2bcd8739ae039), {
            className: (0, $jtRae.default)(classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        });
    }
    var avatar = null;
    if (avatarProp && /*#__PURE__*/ $7fPBF.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $7fPBF.cloneElement(avatarProp, {
        className: (0, $jtRae.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, $dKzJP.default)(color))])
    });
    var icon = null;
    if (iconProp && /*#__PURE__*/ $7fPBF.isValidElement(iconProp)) icon = /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $jtRae.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, $dKzJP.default)(color))])
    });
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        role: clickable || onDelete ? 'button' : undefined,
        className: (0, $jtRae.default)(classes.root, className, color !== 'default' && [
            classes["color".concat((0, $dKzJP.default)(color))],
            clickable && classes["clickableColor".concat((0, $dKzJP.default)(color))],
            onDelete && classes["deletableColor".concat((0, $dKzJP.default)(color))]
        ], variant !== "default" && [
            classes.outlined,
            {
                'primary': classes.outlinedPrimary,
                'secondary': classes.outlinedSecondary
            }[color]
        ], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
        "aria-disabled": disabled ? true : undefined,
        tabIndex: clickable || onDelete ? 0 : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef
    }, moreProps, other), avatar || icon, /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $jtRae.default)(classes.label, small && classes.labelSmall)
    }, label), deleteIcon);
});
var $812a279261d3d883$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($812a279261d3d883$export$9dd6ff9ea0189349, {
    name: 'MuiChip'
})($812a279261d3d883$var$Chip);




var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $d86b9a6e861699e6$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');



var $kY3Ke = parcelRequire("kY3Ke");

var $2gIIh = parcelRequire("2gIIh");
parcelRequire("6TO5S");

var $7fPBF = parcelRequire("7fPBF");

var $6FBGG = parcelRequire("6FBGG");
var $ejsyu = parcelRequire("ejsyu");
var $3deDh = parcelRequire("3deDh");
var $1sMi9 = parcelRequire("1sMi9");
// Give up on IE 11 support for this feature
function $e7d191015c88253e$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $e7d191015c88253e$export$f76f94b238d946d8() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$ignoreAccents = config.ignoreAccents, ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents, _config$ignoreCase = config.ignoreCase, ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase, limit = config.limit, _config$matchFrom = config.matchFrom, matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom, stringify = config.stringify, _config$trim = config.trim, trim = _config$trim === void 0 ? false : _config$trim;
    return function(options, _ref) {
        var inputValue = _ref.inputValue, getOptionLabel = _ref.getOptionLabel;
        var input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $e7d191015c88253e$var$stripDiacritics(input);
        var filteredOptions = options.filter(function(option) {
            var candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $e7d191015c88253e$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
} // To replace with .findIndex() once we stop IE 11 support.
function $e7d191015c88253e$var$findIndex(array, comp) {
    for(var i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
var $e7d191015c88253e$var$defaultFilterOptions = $e7d191015c88253e$export$f76f94b238d946d8(); // Number of options to jump in list box when pageup and pagedown keys are used.
var $e7d191015c88253e$var$pageSize = 5;
function $e7d191015c88253e$export$2e2bcd8739ae039(props) {
    var _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete, _props$autoHighlight = props.autoHighlight, autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight, _props$autoSelect = props.autoSelect, autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect, _props$blurOnSelect = props.blurOnSelect, blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect, _props$clearOnBlur = props.clearOnBlur, clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur, _props$clearOnEscape = props.clearOnEscape, clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape, _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName, _props$debug = props.debug, debug = _props$debug === void 0 ? false : _props$debug, _props$defaultValue = props.defaultValue, defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue, _props$disableClearab = props.disableClearable, disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab, _props$disableCloseOn = props.disableCloseOnSelect, disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, _props$filterOptions = props.filterOptions, filterOptions = _props$filterOptions === void 0 ? $e7d191015c88253e$var$defaultFilterOptions : _props$filterOptions, _props$filterSelected = props.filterSelectedOptions, filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected, _props$freeSolo = props.freeSolo, freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo, getOptionDisabled = props.getOptionDisabled, _props$getOptionLabel = props.getOptionLabel, getOptionLabelProp = _props$getOptionLabel === void 0 ? function(option) {
        return option;
    } : _props$getOptionLabel, _props$getOptionSelec = props.getOptionSelected, getOptionSelected = _props$getOptionSelec === void 0 ? function(option, value) {
        return option === value;
    } : _props$getOptionSelec, groupBy = props.groupBy, _props$handleHomeEndK = props.handleHomeEndKeys, handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK, idProp = props.id, _props$includeInputIn = props.includeInputInList, includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn, inputValueProp = props.inputValue, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, onChange = props.onChange, onClose = props.onClose, onHighlightChange = props.onHighlightChange, onInputChange = props.onInputChange, onOpen = props.onOpen, openProp = props.open, _props$openOnFocus = props.openOnFocus, openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus, options = props.options, _props$selectOnFocus = props.selectOnFocus, selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus, valueProp = props.value;
    var id = (0, $ejsyu.default)(idProp);
    var getOptionLabel = getOptionLabelProp;
    var ignoreFocus = $7fPBF.useRef(false);
    var firstFocus = $7fPBF.useRef(true);
    var inputRef = $7fPBF.useRef(null);
    var listboxRef = $7fPBF.useRef(null);
    var _React$useState = $7fPBF.useState(null), anchorEl = _React$useState[0], setAnchorEl = _React$useState[1];
    var _React$useState2 = $7fPBF.useState(-1), focusedTag = _React$useState2[0], setFocusedTag = _React$useState2[1];
    var defaultHighlighted = autoHighlight ? 0 : -1;
    var highlightedIndexRef = $7fPBF.useRef(defaultHighlighted);
    var _useControlled = (0, $3deDh.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    }), _useControlled2 = (0, $2gIIh.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var _useControlled3 = (0, $3deDh.default)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    }), _useControlled4 = (0, $2gIIh.default)(_useControlled3, 2), inputValue = _useControlled4[0], setInputValue = _useControlled4[1];
    var _React$useState3 = $7fPBF.useState(false), focused = _React$useState3[0], setFocused = _React$useState3[1];
    var resetInputValue = (0, $1sMi9.default)(function(event, newValue) {
        var newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            var optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValue(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    });
    $7fPBF.useEffect(function() {
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue
    ]);
    var _useControlled5 = (0, $3deDh.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    }), _useControlled6 = (0, $2gIIh.default)(_useControlled5, 2), open = _useControlled6[0], setOpenState = _useControlled6[1];
    var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    var popupOpen = open;
    var filteredOptions = popupOpen ? filterOptions(options.filter(function(option) {
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some(function(value2) {
            return value2 !== null && getOptionSelected(option, value2);
        })) return false;
        return true;
    }), // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    var missingValue;
    var focusTag = (0, $1sMi9.default)(function(tagToFocus) {
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }); // Ensure the focusedTag is never inconsistent
    $7fPBF.useEffect(function() {
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        var nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) return -1;
            var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
            var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');
            if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    var setHighlightedIndex = (0, $1sMi9.default)(function(_ref2) {
        var event = _ref2.event, index = _ref2.index, _ref2$reason = _ref2.reason, reason = _ref2$reason === void 0 ? 'auto' : _ref2$reason;
        highlightedIndexRef.current = index; // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        var prev = listboxRef.current.querySelector('[data-focus]');
        if (prev) prev.removeAttribute('data-focus');
        var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));
        if (!option) return;
        option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
        //
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
            var element = option;
            var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            var elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    var changeHighlightedIndex = (0, $1sMi9.default)(function(_ref3) {
        var event = _ref3.event, diff = _ref3.diff, _ref3$direction = _ref3.direction, direction = _ref3$direction === void 0 ? 'next' : _ref3$direction, _ref3$reason = _ref3.reason, reason = _ref3$reason === void 0 ? 'auto' : _ref3$reason;
        if (!popupOpen) return;
        var getNextIndex = function getNextIndex() {
            var maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            var newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        var nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        }); // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                var option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                var index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    var syncHighlightedIndex = $7fPBF.useCallback(function() {
        if (!popupOpen) return;
        var valueItem = multiple ? value[0] : value; // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
         // Synchronize the value with the highlighted index
        if (!filterSelectedOptions && valueItem != null) {
            var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible
            if (multiple && currentOption && $e7d191015c88253e$var$findIndex(value, function(val) {
                return getOptionSelected(currentOption, val);
            }) !== -1) return;
            var itemIndex = $e7d191015c88253e$var$findIndex(filteredOptions, function(optionItem) {
                return getOptionSelected(optionItem, valueItem);
            });
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        } // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        } // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        filteredOptions.length === 0,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    var handleListboxRef = (0, $1sMi9.default)(function(node) {
        (0, $6FBGG.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $7fPBF.useEffect(function() {
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    var handleOpen = function handleOpen(event) {
        if (open) return;
        setOpenState(true);
        if (onOpen) onOpen(event);
    };
    var handleClose = function handleClose(event, reason) {
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    var handleValue = function handleValue(event, newValue, reason, details) {
        if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValue(newValue);
    };
    var isTouch = $7fPBF.useRef(false);
    var selectNewValue = function selectNewValue(event, option) {
        var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
        var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
        var reason = reasonProp;
        var newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            var matches;
            var itemIndex = $e7d191015c88253e$var$findIndex(newValue, function(valueItem) {
                return getOptionSelected(option, valueItem);
            });
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'remove-option';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        var nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
            if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    var handleFocusTag = function handleFocusTag(event, direction) {
        if (!multiple) return;
        handleClose(event, 'toggleInput');
        var nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    var handleClear = function handleClear(event) {
        ignoreFocus.current = true;
        setInputValue('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    var handleKeyDown = function handleKeyDown(other) {
        return function(event) {
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$e7d191015c88253e$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $e7d191015c88253e$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    // Wait until IME is settled.
                    if (event.which === 229) break;
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        var option = filteredOptions[highlightedIndexRef.current];
                        var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'select-option'); // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'create-option', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault(); // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    if (multiple && inputValue === '' && value.length > 0) {
                        var index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        var newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'remove-option', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
            if (other.onKeyDown) other.onKeyDown(event);
        };
    };
    var handleFocus = function handleFocus(event) {
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    var handleBlur = function handleBlur(event) {
        // Ignore the event when using the scrollbar with IE 11
        if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (debug && inputValue !== '') return;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    var handleInputChange = function handleInputChange(event) {
        var newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValue(newValue);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    var handleOptionMouseOver = function handleOptionMouseOver(event) {
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'mouse'
        });
    };
    var handleOptionTouchStart = function handleOptionTouchStart() {
        isTouch.current = true;
    };
    var handleOptionClick = function handleOptionClick(event) {
        var index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'select-option');
        isTouch.current = false;
    };
    var handleTagDelete = function handleTagDelete(index) {
        return function(event) {
            var newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'remove-option', {
                option: value[index]
            });
        };
    };
    var handlePopupIndicator = function handlePopupIndicator(event) {
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    }; // Prevent input blur when interacting with the combobox
    var handleMouseDown = function handleMouseDown(event) {
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    }; // Focus the input when interacting with the combobox
    var handleClick = function handleClick() {
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    var handleInputMouseDown = function handleInputMouseDown(event) {
        if (inputValue === '' || !open) handlePopupIndicator(event);
    };
    var dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    var groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        var indexBy = new Map();
        var warn = false;
        groupedOptions = filteredOptions.reduce(function(acc, option, index) {
            var group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    return {
        getRootProps: function getRootProps() {
            var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return (0, $kY3Ke.default)({
                'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
                role: 'combobox',
                'aria-expanded': popupOpen
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            });
        },
        getInputLabelProps: function getInputLabelProps() {
            return {
                id: "".concat(id, "-label"),
                htmlFor: id
            };
        },
        getInputProps: function getInputProps() {
            return {
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperativeley so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false'
            };
        },
        getClearProps: function getClearProps() {
            return {
                tabIndex: -1,
                onClick: handleClear
            };
        },
        getPopupIndicatorProps: function getPopupIndicatorProps() {
            return {
                tabIndex: -1,
                onClick: handlePopupIndicator
            };
        },
        getTagProps: function getTagProps(_ref4) {
            var index = _ref4.index;
            return {
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                onDelete: handleTagDelete(index)
            };
        },
        getListboxProps: function getListboxProps() {
            return {
                role: 'listbox',
                id: "".concat(id, "-popup"),
                'aria-labelledby': "".concat(id, "-label"),
                ref: handleListboxRef,
                onMouseDown: function onMouseDown(event) {
                    // Prevent blur
                    event.preventDefault();
                }
            };
        },
        getOptionProps: function getOptionProps(_ref5) {
            var index = _ref5.index, option = _ref5.option;
            var selected = (multiple ? value : [
                value
            ]).some(function(value2) {
                return value2 != null && getOptionSelected(option, value2);
            });
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: index,
                tabIndex: -1,
                role: 'option',
                id: "".concat(id, "-option-").concat(index),
                onMouseOver: handleOptionMouseOver,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}


var $43a59d95b15b9c9d$export$9dd6ff9ea0189349 = function styles(theme) {
    var _option;
    return {
        /* Styles applied to the root element. */ root: {
            '&$focused $clearIndicatorDirty': {
                visibility: 'visible'
            },
            /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
                '&:hover $clearIndicatorDirty': {
                    visibility: 'visible'
                }
            }
        },
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Pseudo-class applied to the root element if focused. */ focused: {},
        /* Styles applied to the tag elements, e.g. the chips. */ tag: {
            margin: 3,
            maxWidth: 'calc(100% - 6px)'
        },
        /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */ tagSizeSmall: {
            margin: 2,
            maxWidth: 'calc(100% - 4px)'
        },
        /* Styles applied when the popup icon is rendered. */ hasPopupIcon: {},
        /* Styles applied when the clear icon is rendered. */ hasClearIcon: {},
        /* Styles applied to the Input element. */ inputRoot: {
            flexWrap: 'wrap',
            '$hasPopupIcon &, $hasClearIcon &': {
                paddingRight: 30
            },
            '$hasPopupIcon$hasClearIcon &': {
                paddingRight: 56
            },
            '& $input': {
                width: 0,
                minWidth: 30
            },
            '&[class*="MuiInput-root"]': {
                paddingBottom: 1,
                '& $input': {
                    padding: 4
                },
                '& $input:first-child': {
                    padding: '6px 0'
                }
            },
            '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
                '& $input': {
                    padding: '4px 4px 5px'
                },
                '& $input:first-child': {
                    padding: '3px 0 6px'
                }
            },
            '&[class*="MuiOutlinedInput-root"]': {
                padding: 9,
                '$hasPopupIcon &, $hasClearIcon &': {
                    paddingRight: 39
                },
                '$hasPopupIcon$hasClearIcon &': {
                    paddingRight: 65
                },
                '& $input': {
                    padding: '9.5px 4px'
                },
                '& $input:first-child': {
                    paddingLeft: 6
                },
                '& $endAdornment': {
                    right: 9
                }
            },
            '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
                padding: 6,
                '& $input': {
                    padding: '4.5px 4px'
                }
            },
            '&[class*="MuiFilledInput-root"]': {
                paddingTop: 19,
                paddingLeft: 8,
                '$hasPopupIcon &, $hasClearIcon &': {
                    paddingRight: 39
                },
                '$hasPopupIcon$hasClearIcon &': {
                    paddingRight: 65
                },
                '& $input': {
                    padding: '9px 4px'
                },
                '& $endAdornment': {
                    right: 9
                }
            },
            '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
                paddingBottom: 1,
                '& $input': {
                    padding: '4.5px 4px'
                }
            }
        },
        /* Styles applied to the input element. */ input: {
            flexGrow: 1,
            textOverflow: 'ellipsis',
            opacity: 0
        },
        /* Styles applied to the input element if tag focused. */ inputFocused: {
            opacity: 1
        },
        /* Styles applied to the endAdornment element. */ endAdornment: {
            // We use a position absolute to support wrapping tags.
            position: 'absolute',
            right: 0,
            top: 'calc(50% - 14px)' // Center vertically
        },
        /* Styles applied to the clear indicator. */ clearIndicator: {
            marginRight: -2,
            padding: 4,
            visibility: 'hidden'
        },
        /* Styles applied to the clear indicator if the input is dirty. */ clearIndicatorDirty: {},
        /* Styles applied to the popup indicator. */ popupIndicator: {
            padding: 2,
            marginRight: -2
        },
        /* Styles applied to the popup indicator if the popup is open. */ popupIndicatorOpen: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the popper element. */ popper: {
            zIndex: theme.zIndex.modal
        },
        /* Styles applied to the popper element if `disablePortal={true}`. */ popperDisablePortal: {
            position: 'absolute'
        },
        /* Styles applied to the `Paper` component. */ paper: (0, $kY3Ke.default)({}, theme.typography.body1, {
            overflow: 'hidden',
            margin: '4px 0'
        }),
        /* Styles applied to the `listbox` component. */ listbox: {
            listStyle: 'none',
            margin: 0,
            padding: '8px 0',
            maxHeight: '40vh',
            overflow: 'auto'
        },
        /* Styles applied to the loading wrapper. */ loading: {
            color: theme.palette.text.secondary,
            padding: '14px 16px'
        },
        /* Styles applied to the no option wrapper. */ noOptions: {
            color: theme.palette.text.secondary,
            padding: '14px 16px'
        },
        /* Styles applied to the option elements. */ option: (_option = {
            minHeight: 48,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16
        }, (0, $dQMrF.default)(_option, theme.breakpoints.up('sm'), {
            minHeight: 'auto'
        }), (0, $dQMrF.default)(_option, '&[aria-selected="true"]', {
            backgroundColor: theme.palette.action.selected
        }), (0, $dQMrF.default)(_option, '&[data-focus="true"]', {
            backgroundColor: theme.palette.action.hover
        }), (0, $dQMrF.default)(_option, '&:active', {
            backgroundColor: theme.palette.action.selected
        }), (0, $dQMrF.default)(_option, '&[aria-disabled="true"]', {
            opacity: theme.palette.action.disabledOpacity,
            pointerEvents: 'none'
        }), _option),
        /* Styles applied to the group's label elements. */ groupLabel: {
            backgroundColor: theme.palette.background.paper,
            top: -8
        },
        /* Styles applied to the group's ul elements. */ groupUl: {
            padding: 0,
            '& $option': {
                paddingLeft: 24
            }
        }
    };
};
function $43a59d95b15b9c9d$var$DisablePortal(props) {
    // eslint-disable-next-line react/prop-types
    var anchorEl = props.anchorEl, open = props.open, other = (0, $lfiYO.default)(props, [
        "anchorEl",
        "open"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", other);
}
var $43a59d95b15b9c9d$var$_ref = /*#__PURE__*/ $7fPBF.createElement((0, $7a12b650b33ab0e1$export$2e2bcd8739ae039), {
    fontSize: "small"
});
var $43a59d95b15b9c9d$var$_ref2 = /*#__PURE__*/ $7fPBF.createElement((0, $d86b9a6e861699e6$export$2e2bcd8739ae039), null);
var $43a59d95b15b9c9d$var$Autocomplete = /*#__PURE__*/ $7fPBF.forwardRef(function Autocomplete(props, ref) {
    /* eslint-disable no-unused-vars */ var _props$autoComplete = props.autoComplete, autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete, _props$autoHighlight = props.autoHighlight, autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight, _props$autoSelect = props.autoSelect, autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect, _props$blurOnSelect = props.blurOnSelect, blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect, ChipProps = props.ChipProps, classes = props.classes, className = props.className, _props$clearOnBlur = props.clearOnBlur, clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur, _props$clearOnEscape = props.clearOnEscape, clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape, _props$clearText = props.clearText, clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? $43a59d95b15b9c9d$var$_ref : _props$closeIcon, _props$closeText = props.closeText, closeText = _props$closeText === void 0 ? 'Close' : _props$closeText, _props$debug = props.debug, debug = _props$debug === void 0 ? false : _props$debug, _props$defaultValue = props.defaultValue, defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue, _props$disableClearab = props.disableClearable, disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab, _props$disableCloseOn = props.disableCloseOnSelect, disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, filterOptions = props.filterOptions, _props$filterSelected = props.filterSelectedOptions, filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected, _props$forcePopupIcon = props.forcePopupIcon, forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon, _props$freeSolo = props.freeSolo, freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$getLimitTagsTe = props.getLimitTagsText, getLimitTagsText = _props$getLimitTagsTe === void 0 ? function(more) {
        return "+".concat(more);
    } : _props$getLimitTagsTe, getOptionDisabled = props.getOptionDisabled, _props$getOptionLabel = props.getOptionLabel, getOptionLabel = _props$getOptionLabel === void 0 ? function(x) {
        return x;
    } : _props$getOptionLabel, getOptionSelected = props.getOptionSelected, groupBy = props.groupBy, _props$handleHomeEndK = props.handleHomeEndKeys, handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK, idProp = props.id, _props$includeInputIn = props.includeInputInList, includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn, inputValueProp = props.inputValue, _props$limitTags = props.limitTags, limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags, _props$ListboxCompone = props.ListboxComponent, ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone, ListboxProps = props.ListboxProps, _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, _props$loadingText = props.loadingText, loadingText = _props$loadingText === void 0 ? "Loading\u2026" : _props$loadingText, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$noOptionsText = props.noOptionsText, noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText, onChange = props.onChange, onClose = props.onClose, onHighlightChange = props.onHighlightChange, onInputChange = props.onInputChange, onOpen = props.onOpen, open = props.open, _props$openOnFocus = props.openOnFocus, openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus, _props$openText = props.openText, openText = _props$openText === void 0 ? 'Open' : _props$openText, options = props.options, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $ckpfM.default) : _props$PaperComponent, _props$PopperComponen = props.PopperComponent, PopperComponentProp = _props$PopperComponen === void 0 ? (0, $iyOta.default) : _props$PopperComponen, _props$popupIcon = props.popupIcon, popupIcon = _props$popupIcon === void 0 ? $43a59d95b15b9c9d$var$_ref2 : _props$popupIcon, renderGroupProp = props.renderGroup, renderInput = props.renderInput, renderOptionProp = props.renderOption, renderTags = props.renderTags, _props$selectOnFocus = props.selectOnFocus, selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, valueProp = props.value, other = (0, $lfiYO.default)(props, [
        "autoComplete",
        "autoHighlight",
        "autoSelect",
        "blurOnSelect",
        "ChipProps",
        "classes",
        "className",
        "clearOnBlur",
        "clearOnEscape",
        "clearText",
        "closeIcon",
        "closeText",
        "debug",
        "defaultValue",
        "disableClearable",
        "disableCloseOnSelect",
        "disabled",
        "disabledItemsFocusable",
        "disableListWrap",
        "disablePortal",
        "filterOptions",
        "filterSelectedOptions",
        "forcePopupIcon",
        "freeSolo",
        "fullWidth",
        "getLimitTagsText",
        "getOptionDisabled",
        "getOptionLabel",
        "getOptionSelected",
        "groupBy",
        "handleHomeEndKeys",
        "id",
        "includeInputInList",
        "inputValue",
        "limitTags",
        "ListboxComponent",
        "ListboxProps",
        "loading",
        "loadingText",
        "multiple",
        "noOptionsText",
        "onChange",
        "onClose",
        "onHighlightChange",
        "onInputChange",
        "onOpen",
        "open",
        "openOnFocus",
        "openText",
        "options",
        "PaperComponent",
        "PopperComponent",
        "popupIcon",
        "renderGroup",
        "renderInput",
        "renderOption",
        "renderTags",
        "selectOnFocus",
        "size",
        "value"
    ]);
    /* eslint-enable no-unused-vars */ var PopperComponent = disablePortal ? $43a59d95b15b9c9d$var$DisablePortal : PopperComponentProp;
    var _useAutocomplete = (0, $e7d191015c88253e$export$2e2bcd8739ae039)((0, $kY3Ke.default)({}, props, {
        componentName: 'Autocomplete'
    })), getRootProps = _useAutocomplete.getRootProps, getInputProps = _useAutocomplete.getInputProps, getInputLabelProps = _useAutocomplete.getInputLabelProps, getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps, getClearProps = _useAutocomplete.getClearProps, getTagProps = _useAutocomplete.getTagProps, getListboxProps = _useAutocomplete.getListboxProps, getOptionProps = _useAutocomplete.getOptionProps, value = _useAutocomplete.value, dirty = _useAutocomplete.dirty, id = _useAutocomplete.id, popupOpen = _useAutocomplete.popupOpen, focused = _useAutocomplete.focused, focusedTag = _useAutocomplete.focusedTag, anchorEl = _useAutocomplete.anchorEl, setAnchorEl = _useAutocomplete.setAnchorEl, inputValue = _useAutocomplete.inputValue, groupedOptions = _useAutocomplete.groupedOptions;
    var startAdornment;
    if (multiple && value.length > 0) {
        var getCustomizedTagProps = function getCustomizedTagProps(params) {
            return (0, $kY3Ke.default)({
                className: (0, $jtRae.default)(classes.tag, size === 'small' && classes.tagSizeSmall),
                disabled: disabled
            }, getTagProps(params));
        };
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps);
        else startAdornment = value.map(function(option, index) {
            return /*#__PURE__*/ $7fPBF.createElement((0, $812a279261d3d883$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps));
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        var more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ $7fPBF.createElement("span", {
                className: classes.tag,
                key: startAdornment.length
            }, getLimitTagsText(more)));
        }
    }
    var defaultRenderGroup = function defaultRenderGroup(params) {
        return /*#__PURE__*/ $7fPBF.createElement("li", {
            key: params.key
        }, /*#__PURE__*/ $7fPBF.createElement((0, $41eb5b0796717985$export$2e2bcd8739ae039), {
            className: classes.groupLabel,
            component: "div"
        }, params.group), /*#__PURE__*/ $7fPBF.createElement("ul", {
            className: classes.groupUl
        }, params.children));
    };
    var renderGroup = renderGroupProp || defaultRenderGroup;
    var renderOption = renderOptionProp || getOptionLabel;
    var renderListOption = function renderListOption(option, index) {
        var optionProps = getOptionProps({
            option: option,
            index: index
        });
        return /*#__PURE__*/ $7fPBF.createElement("li", (0, $kY3Ke.default)({}, optionProps, {
            className: classes.option
        }), renderOption(option, {
            selected: optionProps['aria-selected'],
            inputValue: inputValue
        }));
    };
    var hasClearIcon = !disableClearable && !disabled;
    var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $jtRae.default)(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
    }, getRootProps(other)), renderInput({
        id: id,
        disabled: disabled,
        fullWidth: true,
        size: size === 'small' ? 'small' : undefined,
        InputLabelProps: getInputLabelProps(),
        InputProps: {
            ref: setAnchorEl,
            className: classes.inputRoot,
            startAdornment: startAdornment,
            endAdornment: /*#__PURE__*/ $7fPBF.createElement("div", {
                className: classes.endAdornment
            }, hasClearIcon ? /*#__PURE__*/ $7fPBF.createElement((0, $iRcsz.default), (0, $kY3Ke.default)({}, getClearProps(), {
                "aria-label": clearText,
                title: clearText,
                className: (0, $jtRae.default)(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
            }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/ $7fPBF.createElement((0, $iRcsz.default), (0, $kY3Ke.default)({}, getPopupIndicatorProps(), {
                disabled: disabled,
                "aria-label": popupOpen ? closeText : openText,
                title: popupOpen ? closeText : openText,
                className: (0, $jtRae.default)(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
            }), popupIcon) : null)
        },
        inputProps: (0, $kY3Ke.default)({
            className: (0, $jtRae.default)(classes.input, focusedTag === -1 && classes.inputFocused),
            disabled: disabled
        }, getInputProps())
    })), popupOpen && anchorEl ? /*#__PURE__*/ $7fPBF.createElement(PopperComponent, {
        className: (0, $jtRae.default)(classes.popper, disablePortal && classes.popperDisablePortal),
        style: {
            width: anchorEl ? anchorEl.clientWidth : null
        },
        role: "presentation",
        anchorEl: anchorEl,
        open: true
    }, /*#__PURE__*/ $7fPBF.createElement(PaperComponent, {
        className: classes.paper
    }, loading && groupedOptions.length === 0 ? /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.loading
    }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ $7fPBF.createElement("div", {
        className: classes.noOptions
    }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/ $7fPBF.createElement(ListboxComponent, (0, $kY3Ke.default)({
        className: classes.listbox
    }, getListboxProps(), ListboxProps), groupedOptions.map(function(option, index) {
        if (groupBy) return renderGroup({
            key: option.key,
            group: option.group,
            children: option.options.map(function(option2, index2) {
                return renderListOption(option2, option.index + index2);
            })
        });
        return renderListOption(option, index);
    })) : null)) : null);
});
var $43a59d95b15b9c9d$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($43a59d95b15b9c9d$export$9dd6ff9ea0189349, {
    name: 'MuiAutocomplete'
})($43a59d95b15b9c9d$var$Autocomplete);






function $ef64b5b7aae137f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(dirtyDate, days);
}



function $4b40f36c6c4e8120$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}



function $3e6008e0d859cbde$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}







const $8bfb433bad942c35$export$bc9baa0814b80b55 = {
    en: (0, $51943b9b451c992f$export$2e2bcd8739ae039),
    hu: (0, $3c962f6af8e83995$export$2e2bcd8739ae039),
    de: (0, $9fe90a7e9d8a402d$export$2e2bcd8739ae039)
};
const $8bfb433bad942c35$export$b76490726c886755 = ()=>{
    let date = new Date();
    const tomorrowDate = date.getDate() + 1;
    date.setDate(tomorrowDate);
    return date;
};
const $8bfb433bad942c35$export$1e32f7407816b987 = (date)=>{
    if (date) return `${date.year}/${date.month}/${date.day}`;
};
const $8bfb433bad942c35$export$f470d795e00a1a60 = (date)=>({
        day: (0, $4b40f36c6c4e8120$export$2e2bcd8739ae039)(date),
        month: (0, $3e6008e0d859cbde$export$2e2bcd8739ae039)(date) + 1,
        year: (0, $88155eb6456a8ca8$export$2e2bcd8739ae039)(date)
    });
const $8bfb433bad942c35$export$3ae94a2503e890a1 = (date, format = 'P', options)=>{
    return (0, $0918c9925a326e99$export$2e2bcd8739ae039)(new Date(date), format, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        locale: $8bfb433bad942c35$export$bc9baa0814b80b55[(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language]
    }, options));
};
const $8bfb433bad942c35$export$4d545125353fe8c5 = ()=>{
    const now = new Date();
    return JSON.stringify({
        from: $8bfb433bad942c35$export$f470d795e00a1a60(now),
        to: $8bfb433bad942c35$export$f470d795e00a1a60((0, $ef64b5b7aae137f5$export$2e2bcd8739ae039)(now, 2))
    });
};
const $8bfb433bad942c35$export$fa96065c64444af6 = ()=>{
    return (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language === (0, $f6e729db3f817bb5$exports.SUPPORTED_LANGUAGES).HU ? 'yyyy/MM/dd' : 'dd/MM/yyyy';
};
const $8bfb433bad942c35$export$17029b467e4298ef = (date, month)=>(0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(date, month);





const $bbe304316b6a71dc$export$4d09d4ac8ba225dd = (setValidation, validation, inputType, value)=>{
    if (inputType === 'deadline') setValidation((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validation), {
        deadline: isNaN(Date.parse(value))
    }));
    else if (inputType === 'appraiser') {
        const isAppraiserInValid = !value || !(!!value.empid && !!value.name && !!value.address);
        setValidation((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validation), {
            appraiser: isAppraiserInValid
        }));
    } else if (inputType === 'category') {
        const isCategoryValid = !value || !(!!value.account_id && !!value.category_id && !!value.category_name);
        setValidation((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validation), {
            category: isCategoryValid
        }));
    } else setValidation((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validation), {
        [inputType]: value.length === 0
    }));
};
const $bbe304316b6a71dc$export$b98e45bca1b0be2f = (setValidation, { name: name, description: description, deadline: deadline, appraiser: appraiser, category: category })=>{
    const isAppraiserInValid = !appraiser || !(!!appraiser.empid && !!appraiser.name && !!appraiser.address);
    const isCategoryValid = !category || !(!!category.account_id && !!category.category_id && !!category.category_name);
    if (name.length === 0 || description.length === 0 || category.length === 0 || isNaN(Date.parse(deadline)) || isAppraiserInValid) {
        setValidation({
            name: name.length === 0,
            description: description.length === 0,
            deadline: isNaN(Date.parse(deadline)),
            appraiser: isAppraiserInValid,
            category: isCategoryValid
        });
        return false;
    }
    return true;
};



parcelRequire("7fPBF");

var $cuouK = parcelRequire("cuouK");
var $k8IO2 = parcelRequire("k8IO2");
var $g21Gx = parcelRequire("g21Gx");
var $g1A03 = parcelRequire("g1A03");

const $e136e3176b99aeb2$var$CategorySelect = ({ categories: categories, handleOnChangeCategory: handleOnChangeCategory, category: category, error: error, helperText: helperText })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cuouK.default), {
        error: error,
        style: {
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $g1A03.default), {
                onChange: handleOnChangeCategory,
                value: category || '',
                displayEmpty: true,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $g21Gx.default), {
                        disabled: true,
                        value: "",
                        children: t('objective.dialog.create.category.placeholder')
                    }, "0"),
                    categories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $g21Gx.default), {
                            value: category,
                            children: category.category_name.hu
                        }, category.category_id))
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $k8IO2.default), {
                children: helperText
            })
        ]
    });
};
var $e136e3176b99aeb2$export$2e2bcd8739ae039 = $e136e3176b99aeb2$var$CategorySelect;






var $7fPBF = parcelRequire("7fPBF");
var $b871b7860d2a9903$exports = {};
"use strict";
Object.defineProperty($b871b7860d2a9903$exports, "__esModule", {
    value: !0
});
var $b871b7860d2a9903$var$e;

var $7fPBF = parcelRequire("7fPBF");
var $b871b7860d2a9903$var$n = ($b871b7860d2a9903$var$e = $7fPBF) && "object" == typeof $b871b7860d2a9903$var$e && "default" in $b871b7860d2a9903$var$e ? $b871b7860d2a9903$var$e.default : $b871b7860d2a9903$var$e;
function $b871b7860d2a9903$var$a(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $b871b7860d2a9903$var$r() {
    return ($b871b7860d2a9903$var$r = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var a in n)Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
        }
        return e;
    }).apply(this, arguments);
}
function $b871b7860d2a9903$var$o(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        t && (a = a.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, a);
    }
    return n;
}
function $b871b7860d2a9903$var$i(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $b871b7860d2a9903$var$o(Object(n), !0).forEach(function(t) {
            $b871b7860d2a9903$var$a(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $b871b7860d2a9903$var$o(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
function $b871b7860d2a9903$var$c(e, t) {
    if (null == e) return {};
    var n, a, r = function(e, t) {
        if (null == e) return {};
        var n, a, r = {}, o = Object.keys(e);
        for(a = 0; a < o.length; a++)n = o[a], t.indexOf(n) >= 0 || (r[n] = e[n]);
        return r;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for(a = 0; a < o.length; a++)n = o[a], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
}
function $b871b7860d2a9903$var$l(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
        var n = [], a = !0, r = !1, o = void 0;
        try {
            for(var i, c = e[Symbol.iterator](); !(a = (i = c.next()).done) && (n.push(i.value), !t || n.length !== t); a = !0);
        } catch (e) {
            r = !0, o = e;
        } finally{
            try {
                a || null == c.return || c.return();
            } finally{
                if (r) throw o;
            }
        }
        return n;
    }(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
}
function $b871b7860d2a9903$var$s(e) {
    return function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, n = new Array(e.length); t < e.length; t++)n[t] = e[t];
            return n;
        }
    }(e) || function(e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
}
var $b871b7860d2a9903$var$u = [
    "\u06F0",
    "\u06F1",
    "\u06F2",
    "\u06F3",
    "\u06F4",
    "\u06F5",
    "\u06F6",
    "\u06F7",
    "\u06F8",
    "\u06F9"
], $b871b7860d2a9903$var$d = function(e, t) {
    return Array.from(Array(e).keys()).map(function(e) {
        return {
            value: e + 1,
            id: "".concat(t, "-").concat(e)
        };
    });
}, $b871b7860d2a9903$var$m = function(e, t) {
    return !(!e || !t) && e.day === t.day && e.month === t.month && e.year === t.year;
}, $b871b7860d2a9903$var$f = function(e) {
    return 1 === e.toString().length ? "0".concat(e) : e;
}, $b871b7860d2a9903$var$h = function(e) {
    return $b871b7860d2a9903$var$i({}, e);
}, $b871b7860d2a9903$var$y = function(e, t) {
    var n = "NEXT" === t ? 1 : -1, a = e.month + n, r = e.year;
    return a < 1 && (a = 12, r -= 1), a > 12 && (a = 1, r += 1), {
        year: r,
        month: a,
        day: 1
    };
}, $b871b7860d2a9903$var$g = function(e, t) {
    return Object.prototype.hasOwnProperty.call(e || {}, t);
}, $b871b7860d2a9903$var$p = function(e) {
    if (Array.isArray(e)) return "MUTLI_DATE";
    if ($b871b7860d2a9903$var$g(e, "from") && $b871b7860d2a9903$var$g(e, "to")) return "RANGE";
    if (!e || $b871b7860d2a9903$var$g(e, "year") && $b871b7860d2a9903$var$g(e, "month") && $b871b7860d2a9903$var$g(e, "day")) return "SINGLE_DATE";
    throw new TypeError("The passed value is malformed! Please make sure you're using one of the valid value types for date picker.");
}, $b871b7860d2a9903$var$v = {
    toJalaali: function(e, t, n) {
        "[object Date]" === Object.prototype.toString.call(e) && (n = e.getDate(), t = e.getMonth() + 1, e = e.getFullYear());
        return $b871b7860d2a9903$var$C($b871b7860d2a9903$var$N(e, t, n));
    },
    toGregorian: function(e, t, n) {
        return $b871b7860d2a9903$var$w($b871b7860d2a9903$var$E(e, t, n));
    },
    isValidJalaaliDate: function(e, t, n) {
        return e >= -61 && e <= 3177 && t >= 1 && t <= 12 && n >= 1 && n <= $b871b7860d2a9903$var$S(e, t);
    },
    isLeapJalaaliYear: $b871b7860d2a9903$var$D,
    jalaaliMonthLength: $b871b7860d2a9903$var$S,
    jalCal: $b871b7860d2a9903$var$b,
    j2d: $b871b7860d2a9903$var$E,
    d2j: $b871b7860d2a9903$var$C,
    g2d: $b871b7860d2a9903$var$N,
    d2g: $b871b7860d2a9903$var$w
};
function $b871b7860d2a9903$var$D(e) {
    return 0 === $b871b7860d2a9903$var$b(e).leap;
}
function $b871b7860d2a9903$var$S(e, t) {
    return t <= 6 ? 31 : t <= 11 || $b871b7860d2a9903$var$D(e) ? 30 : 29;
}
function $b871b7860d2a9903$var$b(e) {
    var t, n, a, r, o, i, c = [
        -61,
        9,
        38,
        199,
        426,
        686,
        756,
        818,
        1111,
        1181,
        1210,
        1635,
        2060,
        2097,
        2192,
        2262,
        2324,
        2394,
        2456,
        3178
    ], l = c.length, s = e + 621, u = -14, d = c[0];
    if (e < d || e >= c[l - 1]) throw new Error("Invalid Jalaali year " + e);
    for(i = 1; i < l && (n = (t = c[i]) - d, !(e < t)); i += 1)u = u + 8 * $b871b7860d2a9903$var$_(n, 33) + $b871b7860d2a9903$var$_($b871b7860d2a9903$var$A(n, 33), 4), d = t;
    return u = u + 8 * $b871b7860d2a9903$var$_(o = e - d, 33) + $b871b7860d2a9903$var$_($b871b7860d2a9903$var$A(o, 33) + 3, 4), 4 === $b871b7860d2a9903$var$A(n, 33) && n - o == 4 && (u += 1), r = 20 + u - ($b871b7860d2a9903$var$_(s, 4) - $b871b7860d2a9903$var$_(3 * ($b871b7860d2a9903$var$_(s, 100) + 1), 4) - 150), n - o < 6 && (o = o - n + 33 * $b871b7860d2a9903$var$_(n + 4, 33)), -1 === (a = $b871b7860d2a9903$var$A($b871b7860d2a9903$var$A(o + 1, 33) - 1, 4)) && (a = 4), {
        leap: a,
        gy: s,
        march: r
    };
}
function $b871b7860d2a9903$var$E(e, t, n) {
    var a = $b871b7860d2a9903$var$b(e);
    return $b871b7860d2a9903$var$N(a.gy, 3, a.march) + 31 * (t - 1) - $b871b7860d2a9903$var$_(t, 7) * (t - 7) + n - 1;
}
function $b871b7860d2a9903$var$C(e) {
    var t, n = $b871b7860d2a9903$var$w(e).gy, a = n - 621, r = $b871b7860d2a9903$var$b(a);
    if ((t = e - $b871b7860d2a9903$var$N(n, 3, r.march)) >= 0) {
        if (t <= 185) return {
            jy: a,
            jm: 1 + $b871b7860d2a9903$var$_(t, 31),
            jd: $b871b7860d2a9903$var$A(t, 31) + 1
        };
        t -= 186;
    } else a -= 1, t += 179, 1 === r.leap && (t += 1);
    return {
        jy: a,
        jm: 7 + $b871b7860d2a9903$var$_(t, 30),
        jd: $b871b7860d2a9903$var$A(t, 30) + 1
    };
}
function $b871b7860d2a9903$var$N(e, t, n) {
    var a = $b871b7860d2a9903$var$_(1461 * (e + $b871b7860d2a9903$var$_(t - 8, 6) + 100100), 4) + $b871b7860d2a9903$var$_(153 * $b871b7860d2a9903$var$A(t + 9, 12) + 2, 5) + n - 34840408;
    return a = a - $b871b7860d2a9903$var$_(3 * $b871b7860d2a9903$var$_(e + 100100 + $b871b7860d2a9903$var$_(t - 8, 6), 100), 4) + 752;
}
function $b871b7860d2a9903$var$w(e) {
    var t, n, a, r;
    return t = (t = 4 * e + 139361631) + 4 * $b871b7860d2a9903$var$_(3 * $b871b7860d2a9903$var$_(4 * e + 183187720, 146097), 4) - 3908, n = 5 * $b871b7860d2a9903$var$_($b871b7860d2a9903$var$A(t, 1461), 4) + 308, a = $b871b7860d2a9903$var$_($b871b7860d2a9903$var$A(n, 153), 5) + 1, r = $b871b7860d2a9903$var$A($b871b7860d2a9903$var$_(n, 153), 12) + 1, {
        gy: $b871b7860d2a9903$var$_(t, 1461) - 100100 + $b871b7860d2a9903$var$_(8 - r, 6),
        gm: r,
        gd: a
    };
}
function $b871b7860d2a9903$var$_(e, t) {
    return ~~(e / t);
}
function $b871b7860d2a9903$var$A(e, t) {
    return e - ~~(e / t) * t;
}
var $b871b7860d2a9903$var$O = {
    en: {
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        weekDays: [
            {
                name: "Sunday",
                short: "S",
                isWeekend: !0
            },
            {
                name: "Monday",
                short: "M"
            },
            {
                name: "Tuesday",
                short: "T"
            },
            {
                name: "Wednesday",
                short: "W"
            },
            {
                name: "Thursday",
                short: "T"
            },
            {
                name: "Friday",
                short: "F"
            },
            {
                name: "Saturday",
                short: "S",
                isWeekend: !0
            }
        ],
        weekStartingIndex: 0,
        getToday: function(e) {
            return e;
        },
        toNativeDate: function(e) {
            return new Date(e.year, e.month - 1, e.day);
        },
        getMonthLength: function(e) {
            return new Date(e.year, e.month, 0).getDate();
        },
        transformDigit: function(e) {
            return e;
        },
        nextMonth: "Next Month",
        previousMonth: "Previous Month",
        openMonthSelector: "Open Month Selector",
        openYearSelector: "Open Year Selector",
        closeMonthSelector: "Close Month Selector",
        closeYearSelector: "Close Year Selector",
        from: "from",
        to: "to",
        defaultPlaceholder: "Select...",
        digitSeparator: ",",
        yearLetterSkip: 0,
        isRtl: !1
    },
    fa: {
        months: [
            "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
            "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
            "\u062E\u0631\u062F\u0627\u062F",
            "\u062A\u06CC\u0631",
            "\u0645\u0631\u062F\u0627\u062F",
            "\u0634\u0647\u0631\u06CC\u0648\u0631",
            "\u0645\u0647\u0631",
            "\u0622\u0628\u0627\u0646",
            "\u0622\u0630\u0631",
            "\u062F\u06CC",
            "\u0628\u0647\u0645\u0646",
            "\u0627\u0633\u0641\u0646\u062F"
        ],
        weekDays: [
            {
                name: "\u0634\u0646\u0628\u0647",
                short: "\u0634"
            },
            {
                name: "\u06CC\u06A9\u0634\u0646\u0628\u0647",
                short: "\u06CC"
            },
            {
                name: "\u062F\u0648\u0634\u0646\u0628\u0647",
                short: "\u062F"
            },
            {
                name: "\u0633\u0647 \u0634\u0646\u0628\u0647",
                short: "\u0633"
            },
            {
                name: "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
                short: "\u0686"
            },
            {
                name: "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
                short: "\u067E"
            },
            {
                name: "\u062C\u0645\u0639\u0647",
                short: "\u062C",
                isWeekend: !0
            }
        ],
        weekStartingIndex: 1,
        getToday: function(e) {
            var t = e.year, n = e.month, a = e.day, r = $b871b7860d2a9903$var$v.toJalaali(t, n, a);
            return {
                year: r.jy,
                month: r.jm,
                day: r.jd
            };
        },
        toNativeDate: function(e) {
            var t = $b871b7860d2a9903$var$v.toGregorian.apply($b871b7860d2a9903$var$v, $b871b7860d2a9903$var$s(function(e) {
                return [
                    e.year,
                    e.month,
                    e.day
                ];
            }(e)));
            return new Date(t.gy, t.gm - 1, t.gd);
        },
        getMonthLength: function(e) {
            return $b871b7860d2a9903$var$v.jalaaliMonthLength(e.year, e.month);
        },
        transformDigit: function(e) {
            return e.toString().split("").map(function(e) {
                return $b871b7860d2a9903$var$u[Number(e)];
            }).join("");
        },
        nextMonth: "\u0645\u0627\u0647 \u0628\u0639\u062F",
        previousMonth: "\u0645\u0627\u0647 \u0642\u0628\u0644",
        openMonthSelector: "\u0646\u0645\u0627\u06CC\u0634 \u0627\u0646\u062A\u062E\u0627\u0628\u06AF\u0631 \u0645\u0627\u0647",
        openYearSelector: "\u0646\u0645\u0627\u06CC\u0634 \u0627\u0646\u062A\u062E\u0627\u0628\u06AF\u0631 \u0633\u0627\u0644",
        closeMonthSelector: "\u0628\u0633\u062A\u0646 \u0627\u0646\u062A\u062E\u0627\u0628\u06AF\u0631 \u0645\u0627\u0647",
        closeYearSelector: "\u0628\u0633\u062A\u0646 \u0627\u0646\u062A\u062E\u0627\u0628\u06AF\u0631 \u0645\u0627\u0647",
        from: "\u0627\u0632",
        to: "\u062A\u0627",
        defaultPlaceholder: "\u0627\u0646\u062A\u062E\u0627\u0628...",
        digitSeparator: "\u060C",
        yearLetterSkip: -2,
        isRtl: !0
    }
}, $b871b7860d2a9903$var$k = function(e) {
    return "string" == typeof e ? $b871b7860d2a9903$var$O[e] : e;
}, $b871b7860d2a9903$var$T = function() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "en", t = "string" == typeof e ? $b871b7860d2a9903$var$k(e) : e, n = t.months, a = t.getToday, r = t.toNativeDate, o = t.getMonthLength, c = t.weekStartingIndex, l = t.transformDigit, s = function() {
        var e = new Date, t = e.getFullYear(), n = e.getMonth() + 1, r = e.getDate();
        return a({
            year: t,
            month: n,
            day: r
        });
    }, u = function(e) {
        return n[e - 1];
    }, d = function(e) {
        return n.indexOf(e) + 1;
    }, m = function(e) {
        return (r($b871b7860d2a9903$var$i({}, e, {
            day: 1
        })).getDay() + c) % 7;
    }, f = function(e, t) {
        return !(!e || !t) && r(e) < r(t);
    }, h = function(e) {
        var t = e.day, n = e.from, a = e.to;
        if (!t || !n || !a) return !1;
        var o = r(t), i = r(n), c = r(a);
        return o > i && o < c;
    };
    return {
        getToday: s,
        getMonthName: u,
        getMonthNumber: d,
        getMonthLength: o,
        getMonthFirstWeekday: m,
        isBeforeDate: f,
        checkDayInDayRange: h,
        getLanguageDigits: l
    };
}, $b871b7860d2a9903$var$M = function(e) {
    return $7fPBF.useMemo(function() {
        return $b871b7860d2a9903$var$T(e);
    }, [
        e
    ]);
}, $b871b7860d2a9903$var$L = function(e) {
    return $7fPBF.useMemo(function() {
        return $b871b7860d2a9903$var$k(e);
    }, [
        e
    ]);
}, $b871b7860d2a9903$var$x = function(e) {
    var t = e.parent, n = e.isInitialActiveChild, a = e.activeDate, r = e.monthChangeDirection;
    if (!t) return n ? a : $b871b7860d2a9903$var$y(a, "NEXT");
    var o = t.children[n ? 0 : 1];
    return o.classList.contains("-shown") || o.classList.contains("-shownAnimated") ? a : $b871b7860d2a9903$var$y(a, r);
}, $b871b7860d2a9903$var$R = function(e) {
    var t = e.parent, n = e.direction, a = Array.from(t.children), r = a.find(function(e) {
        return e.classList.contains("-shown");
    }), o = a.find(function(e) {
        return e !== r;
    }), i = r.classList[0], c = "NEXT" === n, l = function(e) {
        return e ? "-hiddenNext" : "-hiddenPrevious";
    };
    o.style.transition = "none", r.style.transition = "", r.className = "".concat(i, " ").concat(l(!c)), o.className = "".concat(i, " ").concat(l(c)), o.classList.add("-shownAnimated");
}, $b871b7860d2a9903$var$P = function(e) {
    var t = e.target;
    t.classList.remove("-hiddenNext"), t.classList.remove("-hiddenPrevious"), t.classList.replace("-shownAnimated", "-shown");
}, $b871b7860d2a9903$var$j = function(e) {
    var a = e.maximumDate, o = e.minimumDate, c = e.onMonthChange, l = e.activeDate, u = e.monthChangeDirection, d = e.onMonthSelect, f = e.onYearSelect, h = e.isMonthSelectorOpen, y = e.isYearSelectorOpen, g = e.locale, p = $7fPBF.useRef(null), v = $7fPBF.useRef(null), D = $b871b7860d2a9903$var$M(g), S = D.getMonthName, b = D.isBeforeDate, E = D.getLanguageDigits, C = $b871b7860d2a9903$var$L(g), N = C.isRtl, w = C.nextMonth, _ = C.previousMonth, A = C.openMonthSelector, O = C.closeMonthSelector, k = C.openYearSelector, T = C.closeYearSelector;
    $7fPBF.useEffect(function() {
        u && $b871b7860d2a9903$var$R({
            direction: u,
            parent: v.current
        });
    }, [
        u
    ]), $7fPBF.useEffect(function() {
        var e = h || y, t = p.current.querySelector(".Calendar__monthYear.-shown .Calendar__monthText"), n = t.nextSibling, a = function(e) {
            return e.classList.contains("-activeBackground");
        };
        if (!(!e && !a(t) && !a(n))) {
            var r = $b871b7860d2a9903$var$s(p.current.querySelectorAll(".Calendar__monthArrowWrapper")), o = h || a(t), i = o ? t : n, c = o ? n : t, l = o ? 1 : -1;
            N && (l *= -1);
            var u = e ? 1 : .95, d = e ? "".concat(l * c.offsetWidth / 2) : 0;
            e ? c.setAttribute("aria-hidden", !0) : c.removeAttribute("aria-hidden"), c.setAttribute("tabindex", e ? "-1" : "0"), c.style.transform = "", i.style.transform = "scale(".concat(u, ") ").concat(d ? "translateX(".concat(d, "px)") : ""), i.classList.toggle("-activeBackground"), c.classList.toggle("-hidden"), r.forEach(function(e) {
                var t = e.classList.contains("-hidden");
                e.classList.toggle("-hidden"), t ? (e.removeAttribute("aria-hidden"), e.setAttribute("tabindex", "0")) : (e.setAttribute("aria-hidden", !0), e.setAttribute("tabindex", "-1"));
            });
        }
    }, [
        h,
        y
    ]);
    var j = a && b(a, $b871b7860d2a9903$var$i({}, l, {
        month: l.month + 1,
        day: 1
    })), I = o && (b($b871b7860d2a9903$var$i({}, l, {
        day: 1
    }), o) || $b871b7860d2a9903$var$m(o, $b871b7860d2a9903$var$i({}, l, {
        day: 1
    }))), Y = function(e) {
        Array.from(v.current.children).some(function(e) {
            return e.classList.contains("-shownAnimated");
        }) || c(e);
    }, W = [
        !0,
        !1
    ].map(function(e) {
        var t = function(e) {
            var t = $b871b7860d2a9903$var$x({
                isInitialActiveChild: e,
                monthChangeDirection: u,
                activeDate: l,
                parent: v.current
            }), n = E(t.year);
            return {
                month: S(t.month),
                year: n
            };
        }(e), a = t.month, o = t.year, c = a === S(l.month), s = $b871b7860d2a9903$var$i({}, c ? {} : {
            "aria-hidden": !0
        });
        return $b871b7860d2a9903$var$n.createElement("div", $b871b7860d2a9903$var$r({
            onAnimationEnd: $b871b7860d2a9903$var$P,
            className: "Calendar__monthYear ".concat(e ? "-shown" : "-hiddenNext"),
            role: "presentation",
            key: String(e)
        }, s), $b871b7860d2a9903$var$n.createElement("button", $b871b7860d2a9903$var$r({
            onClick: d,
            type: "button",
            className: "Calendar__monthText",
            "aria-label": h ? O : A,
            tabIndex: c ? "0" : "-1"
        }, s), a), $b871b7860d2a9903$var$n.createElement("button", $b871b7860d2a9903$var$r({
            onClick: f,
            type: "button",
            className: "Calendar__yearText",
            "aria-label": y ? T : k,
            tabIndex: c ? "0" : "-1"
        }, s), o));
    });
    return $b871b7860d2a9903$var$n.createElement("div", {
        ref: p,
        className: "Calendar__header"
    }, $b871b7860d2a9903$var$n.createElement("button", {
        className: "Calendar__monthArrowWrapper -right",
        onClick: function() {
            Y("PREVIOUS");
        },
        "aria-label": _,
        type: "button",
        disabled: I
    }, $b871b7860d2a9903$var$n.createElement("span", {
        className: "Calendar__monthArrow"
    })), $b871b7860d2a9903$var$n.createElement("div", {
        className: "Calendar__monthYearContainer",
        ref: v,
        "data-testid": "month-year-container"
    }, "\xa0", W), $b871b7860d2a9903$var$n.createElement("button", {
        className: "Calendar__monthArrowWrapper -left",
        onClick: function() {
            Y("NEXT");
        },
        "aria-label": w,
        type: "button",
        disabled: j
    }, $b871b7860d2a9903$var$n.createElement("span", {
        className: "Calendar__monthArrow"
    })));
}, $b871b7860d2a9903$var$I = function(e, t) {
    var n = t.allowVerticalArrows, a = document.activeElement, r = function(e, t) {
        return e ? e.children[t] : null;
    }, o = function(e) {
        return e && (e.hasAttribute("aria-hidden") ? null : e);
    }, i = a.parentElement, c = i.nextSibling, l = i.previousSibling, s = o(a.nextSibling || r(c, 0)), u = l ? l.children.length - 1 : 0, d = o(a.previousSibling || r(l, u)), m = function(e) {
        return r(e, Array.from(a.parentElement.children).indexOf(a));
    }, f = o(m(c)), h = o(m(l));
    "true" === a.dataset.isDefaultSelectable || (a.tabIndex = "-1");
    var y = function(t) {
        e.preventDefault(), t && (t.setAttribute("tabindex", "0"), t.focus());
    };
    switch(e.key){
        case "ArrowRight":
            y(s);
            break;
        case "ArrowLeft":
            y(d);
            break;
        case "ArrowDown":
            n && y(f);
            break;
        case "ArrowUp":
            n && y(h);
    }
}, $b871b7860d2a9903$var$Y = function(e) {
    var a = e.activeDate, o = e.maximumDate, c = e.minimumDate, l = e.onMonthSelect, s = e.isOpen, u = e.locale, d = $7fPBF.useRef(null);
    $7fPBF.useEffect(function() {
        var e = s ? "add" : "remove";
        d.current.classList[e]("-open");
    }, [
        s
    ]);
    var f = $b871b7860d2a9903$var$M(u), h = f.getMonthNumber, y = f.isBeforeDate, g = $b871b7860d2a9903$var$L(u).months;
    return $b871b7860d2a9903$var$n.createElement("div", $b871b7860d2a9903$var$r({
        role: "presentation",
        className: "Calendar__monthSelectorAnimationWrapper"
    }, s ? {} : {
        "aria-hidden": !0
    }), $b871b7860d2a9903$var$n.createElement("div", {
        role: "presentation",
        "data-testid": "month-selector-wrapper",
        className: "Calendar__monthSelectorWrapper",
        onKeyDown: function(e) {
            $b871b7860d2a9903$var$I(e, {
                allowVerticalArrows: !1
            });
        }
    }, $b871b7860d2a9903$var$n.createElement("ul", {
        ref: d,
        className: "Calendar__monthSelector",
        "data-testid": "month-selector"
    }, g.map(function(e) {
        var t = h(e), r = {
            day: 1,
            month: t,
            year: a.year
        }, u = o && y(o, $b871b7860d2a9903$var$i({}, r, {
            month: t
        })), d = c && (y($b871b7860d2a9903$var$i({}, r, {
            month: t + 1
        }), c) || $b871b7860d2a9903$var$m($b871b7860d2a9903$var$i({}, r, {
            month: t + 1
        }), c)), f = t === a.month;
        return $b871b7860d2a9903$var$n.createElement("li", {
            key: e,
            className: "Calendar__monthSelectorItem ".concat(f ? "-active" : "")
        }, $b871b7860d2a9903$var$n.createElement("button", {
            tabIndex: f && s ? "0" : "-1",
            onClick: function() {
                l(t);
            },
            className: "Calendar__monthSelectorItemText",
            type: "button",
            disabled: u || d,
            "aria-pressed": f,
            "data-is-default-selectable": f
        }, e));
    }))));
}, $b871b7860d2a9903$var$W = function(e) {
    for(var a = e.isOpen, o = e.activeDate, i = e.onYearSelect, c = e.selectorStartingYear, l = e.selectorEndingYear, s = e.maximumDate, u = e.minimumDate, d = e.locale, m = $7fPBF.useRef(null), f = $7fPBF.useRef(null), h = $b871b7860d2a9903$var$M(d), y = h.getLanguageDigits, g = h.getToday, p = c || g().year - 100, v = l || g().year + 50, D = [], S = p; S <= v; S += 1)D.push(S);
    $7fPBF.useEffect(function() {
        var e = a ? "add" : "remove", t = m.current.querySelector(".Calendar__yearSelectorItem.-active");
        if (!t) throw new RangeError("Provided value for year is out of selectable year range. You're probably using a wrong locale prop value or your provided value's locale is different from the date picker locale. Try changing the 'locale' prop or the value you've provided.");
        m.current.classList[e]("-faded"), f.current.scrollTop = t.offsetTop - 5 * t.offsetHeight, f.current.classList[e]("-open");
    }, [
        a
    ]);
    return $b871b7860d2a9903$var$n.createElement("div", $b871b7860d2a9903$var$r({
        className: "Calendar__yearSelectorAnimationWrapper",
        role: "presentation"
    }, a ? {} : {
        "aria-hidden": !0
    }), $b871b7860d2a9903$var$n.createElement("div", {
        ref: m,
        className: "Calendar__yearSelectorWrapper",
        role: "presentation",
        "data-testid": "year-selector-wrapper",
        onKeyDown: function(e) {
            $b871b7860d2a9903$var$I(e, {
                allowVerticalArrows: !1
            });
        }
    }, $b871b7860d2a9903$var$n.createElement("ul", {
        ref: f,
        className: "Calendar__yearSelector",
        "data-testid": "year-selector"
    }, D.map(function(e) {
        var t = s && e > s.year, r = u && e < u.year, c = o.year === e;
        return $b871b7860d2a9903$var$n.createElement("li", {
            key: e,
            className: "Calendar__yearSelectorItem ".concat(c ? "-active" : "")
        }, $b871b7860d2a9903$var$n.createElement("button", {
            tabIndex: c && a ? "0" : "-1",
            className: "Calendar__yearSelectorText",
            type: "button",
            onClick: function() {
                i(e);
            },
            disabled: t || r,
            "aria-pressed": c,
            "data-is-default-selectable": c
        }, y(e)));
    }))));
};
$b871b7860d2a9903$var$W.defaultProps = {
    selectorStartingYear: 0,
    selectorEndingYear: 0
};
var $b871b7860d2a9903$var$B = function(e) {
    var a = e.activeDate, o = e.value, l = e.monthChangeDirection, u = e.onSlideChange, f = e.disabledDays, h = e.onDisabledDayError, y = e.minimumDate, g = e.maximumDate, v = e.onChange, D = e.locale, S = e.calendarTodayClassName, b = e.calendarSelectedDayClassName, E = e.calendarRangeStartClassName, C = e.calendarRangeEndClassName, N = e.calendarRangeBetweenClassName, w = e.shouldHighlightWeekends, _ = e.isQuickSelectorOpen, A = e.customDaysClassName, O = $7fPBF.useRef(null), k = $b871b7860d2a9903$var$L(D), T = k.isRtl, j = k.weekDays, Y = $b871b7860d2a9903$var$M(D), W = Y.getToday, B = Y.isBeforeDate, F = Y.checkDayInDayRange, G = Y.getMonthFirstWeekday, J = Y.getMonthLength, U = Y.getLanguageDigits, H = Y.getMonthName, V = W();
    $7fPBF.useEffect(function() {
        l && $b871b7860d2a9903$var$R({
            direction: l,
            parent: O.current
        });
    }, [
        l
    ]);
    var K = function(e) {
        var t, n = (t = o, JSON.parse(JSON.stringify(t, function(e, t) {
            return void 0 === t ? null : t;
        }))), a = n.from && n.to ? {
            from: null,
            to: null
        } : n, r = a.from ? "to" : "from";
        a[r] = e;
        var i = a.from, c = a.to;
        B(a.to, a.from) && (a.from = c, a.to = i);
        var l = f.find(function(e) {
            return F({
                day: e,
                from: a.from,
                to: a.to
            });
        });
        return l ? (h(l), o) : a;
    }, X = function(e) {
        var t = function() {
            switch($b871b7860d2a9903$var$p(o)){
                case "SINGLE_DATE":
                    return e;
                case "RANGE":
                    return K(e);
                case "MUTLI_DATE":
                    return function(e) {
                        var t = o.some(function(t) {
                            return $b871b7860d2a9903$var$m(t, e);
                        }), n = [].concat($b871b7860d2a9903$var$s(o), [
                            e
                        ]), a = o.filter(function(t) {
                            return !$b871b7860d2a9903$var$m(t, e);
                        });
                        return t ? a : n;
                    }(e);
            }
        }();
        v(t);
    }, q = function(e) {
        var t, n, a = $b871b7860d2a9903$var$m(e, V), r = (t = e, "SINGLE_DATE" === (n = $b871b7860d2a9903$var$p(o)) ? $b871b7860d2a9903$var$m(t, o) : "MUTLI_DATE" === n ? o.some(function(e) {
            return $b871b7860d2a9903$var$m(e, t);
        }) : void 0), i = o || {}, c = i.from, l = i.to;
        return {
            isToday: a,
            isSelected: r,
            isStartingDayRange: $b871b7860d2a9903$var$m(e, c),
            isEndingDayRange: $b871b7860d2a9903$var$m(e, l),
            isWithinRange: F({
                day: e,
                from: c,
                to: l
            })
        };
    }, Q = function(e) {
        var t = e.isDisabled, n = $b871b7860d2a9903$var$c(e, [
            "isDisabled"
        ]);
        t ? h(n) : X(n);
    }, z = function(e, t) {
        var o = e.id, c = e.value, l = e.month, s = e.year, u = e.isStandard, d = {
            day: c,
            month: l,
            year: s
        }, h = f.some(function(e) {
            return $b871b7860d2a9903$var$m(d, e);
        }), p = B(d, y), v = B(g, d), D = h || u && (p || v), O = j.some(function(e, n) {
            return e.isWeekend && n === t;
        }), k = function(e) {
            var t = q(e), n = t.isToday, a = t.isSelected, r = t.isStartingDayRange, o = t.isEndingDayRange, i = t.isWithinRange, c = A.find(function(t) {
                return $b871b7860d2a9903$var$m(e, t);
            });
            return "".concat(n && !a ? " -today ".concat(S) : "").concat(e.isStandard ? "" : " -blank").concat(e.isWeekend && w ? " -weekend" : "").concat(c ? " ".concat(c.className) : "").concat(a ? " -selected ".concat(b) : "").concat(r ? " -selectedStart ".concat(E) : "").concat(o ? " -selectedEnd ".concat(C) : "").concat(i ? " -selectedBetween ".concat(N) : "").concat(e.isDisabled ? " -disabled" : "");
        }($b871b7860d2a9903$var$i({}, d, {
            isWeekend: O,
            isStandard: u,
            isDisabled: D
        })), M = "".concat(j[t].name, ", ").concat(c, " ").concat(H(l), " ").concat(s), L = l === a.month, x = q(d), R = x.isSelected, P = x.isStartingDayRange, I = x.isEndingDayRange, Y = x.isWithinRange, W = function(e) {
            var t = e.isOnActiveSlide, n = e.isStandard, a = e.isSelected, r = e.isStartingDayRange, o = e.isToday, i = e.day;
            return !(_ || !t || !n) && (!!(a || r || o || 1 === i) || void 0);
        }($b871b7860d2a9903$var$i({}, d, {}, x, {
            isOnActiveSlide: L,
            isStandard: u
        }));
        return $b871b7860d2a9903$var$n.createElement("div", $b871b7860d2a9903$var$r({
            tabIndex: W ? "0" : "-1",
            key: o,
            className: "Calendar__day -".concat(T ? "rtl" : "ltr", " ").concat(k),
            onClick: function() {
                Q($b871b7860d2a9903$var$i({}, d, {
                    isDisabled: D
                }));
            },
            onKeyDown: function(e) {
                "Enter" === e.key && Q($b871b7860d2a9903$var$i({}, d, {
                    isDisabled: D
                }));
            },
            "aria-disabled": D,
            "aria-label": M,
            "aria-selected": R || P || I || Y
        }, u && L && !_ ? {} : {
            "aria-hidden": !0
        }, {
            role: "gridcell",
            "data-is-default-selectable": W
        }), u ? U(c) : "");
    }, Z = function(e) {
        var t = function(e) {
            var t = $b871b7860d2a9903$var$d(G(e), "starting-blank"), n = $b871b7860d2a9903$var$d(J(e)).map(function(t) {
                return $b871b7860d2a9903$var$i({}, t, {
                    isStandard: !0,
                    month: e.month,
                    year: e.year
                });
            });
            return [].concat($b871b7860d2a9903$var$s(t), $b871b7860d2a9903$var$s(n));
        }($b871b7860d2a9903$var$x({
            activeDate: a,
            isInitialActiveChild: e,
            monthChangeDirection: l,
            parent: O.current
        }));
        return Array.from(Array(6).keys()).map(function(e) {
            var a = t.slice(7 * e, 7 * e + 7).map(z);
            return $b871b7860d2a9903$var$n.createElement("div", {
                key: String(e),
                className: "Calendar__weekRow",
                role: "row"
            }, a);
        });
    };
    return $b871b7860d2a9903$var$n.createElement("div", {
        ref: O,
        className: "Calendar__sectionWrapper",
        role: "presentation",
        "data-testid": "days-section-wrapper",
        onKeyDown: function(e) {
            $b871b7860d2a9903$var$I(e, {
                allowVerticalArrows: !0
            });
        }
    }, $b871b7860d2a9903$var$n.createElement("div", {
        onAnimationEnd: function(e) {
            $b871b7860d2a9903$var$P(e), u();
        },
        className: "Calendar__section -shown",
        role: "rowgroup"
    }, Z(!0)), $b871b7860d2a9903$var$n.createElement("div", {
        onAnimationEnd: function(e) {
            $b871b7860d2a9903$var$P(e), u();
        },
        className: "Calendar__section -hiddenNext",
        role: "rowgroup"
    }, Z(!1)));
};
$b871b7860d2a9903$var$B.defaultProps = {
    onChange: function() {},
    onDisabledDayError: function() {},
    disabledDays: [],
    calendarTodayClassName: "",
    calendarSelectedDayClassName: "",
    calendarRangeStartClassName: "",
    calendarRangeBetweenClassName: "",
    calendarRangeEndClassName: "",
    shouldHighlightWeekends: !1
};
var $b871b7860d2a9903$var$F = function(e) {
    var r = e.value, o = e.onChange, c = e.onDisabledDayError, s = e.calendarClassName, u = e.calendarTodayClassName, d = e.calendarSelectedDayClassName, m = e.calendarRangeStartClassName, f = e.calendarRangeBetweenClassName, g = e.calendarRangeEndClassName, v = e.disabledDays, D = e.colorPrimary, S = e.colorPrimaryLight, b = e.slideAnimationDuration, E = e.minimumDate, C = e.maximumDate, N = e.selectorStartingYear, w = e.selectorEndingYear, _ = e.locale, A = e.shouldHighlightWeekends, O = e.renderFooter, k = e.customDaysClassName, T = $7fPBF.useRef(null), x = $b871b7860d2a9903$var$l($7fPBF.useState({
        activeDate: null,
        monthChangeDirection: "",
        isMonthSelectorOpen: !1,
        isYearSelectorOpen: !1
    }), 2), R = x[0], P = x[1];
    $7fPBF.useEffect(function() {
        var e = function(e) {
            "Tab" === e.key && T.current.classList.remove("-noFocusOutline");
        };
        var __calendarEl = T.current;
        return __calendarEl.addEventListener("keyup", e, !1), function() {
            __calendarEl.removeEventListener("keyup", e, !1);
        };
    });
    var I, F = $b871b7860d2a9903$var$M(_).getToday, G = $b871b7860d2a9903$var$L(_), J = G.weekDays, U = G.isRtl, H = F(), V = function(e) {
        return function() {
            P($b871b7860d2a9903$var$i({}, R, $b871b7860d2a9903$var$a({}, e, !R[e])));
        };
    }, K = V("isMonthSelectorOpen"), X = V("isYearSelectorOpen"), q = R.activeDate ? $b871b7860d2a9903$var$h(R.activeDate) : "MUTLI_DATE" === (I = $b871b7860d2a9903$var$p(r)) && r.length ? $b871b7860d2a9903$var$h(r[0]) : "SINGLE_DATE" === I && r ? $b871b7860d2a9903$var$h(r) : "RANGE" === I && r.from ? $b871b7860d2a9903$var$h(r.from) : $b871b7860d2a9903$var$h(H), Q = J.map(function(e) {
        return $b871b7860d2a9903$var$n.createElement("abbr", {
            key: e.name,
            title: e.name,
            className: "Calendar__weekDay"
        }, e.short);
    });
    return $b871b7860d2a9903$var$n.createElement("div", {
        className: "Calendar -noFocusOutline ".concat(s, " -").concat(U ? "rtl" : "ltr"),
        role: "grid",
        style: {
            "--cl-color-primary": D,
            "--cl-color-primary-light": S,
            "--animation-duration": b
        },
        ref: T
    }, $b871b7860d2a9903$var$n.createElement($b871b7860d2a9903$var$j, {
        maximumDate: C,
        minimumDate: E,
        activeDate: q,
        onMonthChange: function(e) {
            P($b871b7860d2a9903$var$i({}, R, {
                monthChangeDirection: e
            }));
        },
        onMonthSelect: K,
        onYearSelect: X,
        monthChangeDirection: R.monthChangeDirection,
        isMonthSelectorOpen: R.isMonthSelectorOpen,
        isYearSelectorOpen: R.isYearSelectorOpen,
        locale: _
    }), $b871b7860d2a9903$var$n.createElement($b871b7860d2a9903$var$Y, {
        isOpen: R.isMonthSelectorOpen,
        activeDate: q,
        onMonthSelect: function(e) {
            P($b871b7860d2a9903$var$i({}, R, {
                activeDate: $b871b7860d2a9903$var$i({}, q, {
                    month: e
                }),
                isMonthSelectorOpen: !1
            }));
        },
        maximumDate: C,
        minimumDate: E,
        locale: _
    }), $b871b7860d2a9903$var$n.createElement($b871b7860d2a9903$var$W, {
        isOpen: R.isYearSelectorOpen,
        activeDate: q,
        onYearSelect: function(e) {
            P($b871b7860d2a9903$var$i({}, R, {
                activeDate: $b871b7860d2a9903$var$i({}, q, {
                    year: e
                }),
                isYearSelectorOpen: !1
            }));
        },
        selectorStartingYear: N,
        selectorEndingYear: w,
        maximumDate: C,
        minimumDate: E,
        locale: _
    }), $b871b7860d2a9903$var$n.createElement("div", {
        className: "Calendar__weekDays"
    }, Q), $b871b7860d2a9903$var$n.createElement($b871b7860d2a9903$var$B, {
        activeDate: q,
        value: r,
        monthChangeDirection: R.monthChangeDirection,
        onSlideChange: function() {
            P($b871b7860d2a9903$var$i({}, R, {
                activeDate: $b871b7860d2a9903$var$y(q, R.monthChangeDirection),
                monthChangeDirection: ""
            }));
        },
        disabledDays: v,
        onDisabledDayError: c,
        minimumDate: E,
        maximumDate: C,
        onChange: o,
        calendarTodayClassName: u,
        calendarSelectedDayClassName: d,
        calendarRangeStartClassName: m,
        calendarRangeEndClassName: g,
        calendarRangeBetweenClassName: f,
        locale: _,
        shouldHighlightWeekends: A,
        customDaysClassName: k,
        isQuickSelectorOpen: R.isYearSelectorOpen || R.isMonthSelectorOpen
    }), $b871b7860d2a9903$var$n.createElement("div", {
        className: "Calendar__footer"
    }, O()));
};
$b871b7860d2a9903$var$F.defaultProps = {
    minimumDate: null,
    maximumDate: null,
    colorPrimary: "#0eca2d",
    colorPrimaryLight: "#cff4d5",
    slideAnimationDuration: "0.4s",
    calendarClassName: "",
    locale: "en",
    value: null,
    renderFooter: function() {
        return null;
    },
    customDaysClassName: []
};
var $b871b7860d2a9903$var$G = $b871b7860d2a9903$var$n.forwardRef(function(e, t) {
    var a = e.value, r = e.inputPlaceholder, o = e.inputClassName, i = e.inputName, c = e.formatInputText, l = e.renderInput, s = e.locale, u = $b871b7860d2a9903$var$M(s).getLanguageDigits, d = $b871b7860d2a9903$var$L(s), m = d.from, h = d.to, y = d.yearLetterSkip, g = d.digitSeparator, v = d.defaultPlaceholder, D = d.isRtl, S = function() {
        if (c()) return c();
        switch($b871b7860d2a9903$var$p(a)){
            case "SINGLE_DATE":
                return function() {
                    if (!a) return "";
                    var e = u(a.year), t = u($b871b7860d2a9903$var$f(a.month)), n = u($b871b7860d2a9903$var$f(a.day));
                    return "".concat(e, "/").concat(t, "/").concat(n);
                }();
            case "RANGE":
                return function() {
                    if (!a.from || !a.to) return "";
                    var e = a.from, t = a.to, n = "".concat(u($b871b7860d2a9903$var$f(e.year)).toString().slice(y), "/").concat(u($b871b7860d2a9903$var$f(e.month)), "/").concat(u($b871b7860d2a9903$var$f(e.day))), r = "".concat(u($b871b7860d2a9903$var$f(t.year)).toString().slice(y), "/").concat(u($b871b7860d2a9903$var$f(t.month)), "/").concat(u($b871b7860d2a9903$var$f(t.day)));
                    return "".concat(m, " ").concat(n, " ").concat(h, " ").concat(r);
                }();
            case "MUTLI_DATE":
                return a.map(function(e) {
                    return u(e.day);
                }).join("".concat(g, " "));
        }
    }, b = r || v;
    return l({
        ref: t
    }) || $b871b7860d2a9903$var$n.createElement("input", {
        "data-testid": "datepicker-input",
        readOnly: !0,
        ref: t,
        value: S(),
        name: i,
        placeholder: b,
        className: "DatePicker__input -".concat(D ? "rtl" : "ltr", " ").concat(o),
        "aria-label": b
    });
});
$b871b7860d2a9903$var$G.defaultProps = {
    formatInputText: function() {
        return "";
    },
    renderInput: function() {
        return null;
    },
    inputPlaceholder: "",
    inputClassName: "",
    inputName: ""
};
var $b871b7860d2a9903$var$J = function(e) {
    var a = e.value, r = e.onChange, o = e.formatInputText, i = e.inputPlaceholder, c = e.inputClassName, s = e.inputName, u = e.renderInput, d = e.wrapperClassName, m = e.calendarClassName, f = e.calendarTodayClassName, h = e.calendarSelectedDayClassName, y = e.calendarRangeStartClassName, g = e.calendarRangeBetweenClassName, v = e.calendarRangeEndClassName, D = e.calendarPopperPosition, S = e.disabledDays, b = e.onDisabledDayError, E = e.colorPrimary, C = e.colorPrimaryLight, N = e.slideAnimationDuration, w = e.minimumDate, _ = e.maximumDate, A = e.selectorStartingYear, O = e.selectorEndingYear, k = e.locale, T = e.shouldHighlightWeekends, M = e.renderFooter, L = e.customDaysClassName, x = $7fPBF.useRef(null), R = $7fPBF.useRef(null), P = $7fPBF.useRef(!1), j = $b871b7860d2a9903$var$l($7fPBF.useState(!1), 2), I = j[0], Y = j[1];
    $7fPBF.useEffect(function() {
        var e = function() {
            Y(!1);
        };
        return window.addEventListener("blur", e, !1), function() {
            window.removeEventListener("blur", e, !1);
        };
    }, []), $7fPBF.useEffect(function() {
        var e = $b871b7860d2a9903$var$p(a);
        "MUTLI_DATE" !== e && ("SINGLE_DATE" === e ? !I : !I && a.from && a.to) && R.current.blur();
    }, [
        a,
        I
    ]);
    $7fPBF.useLayoutEffect(function() {
        if (I) {
            var e = x.current.getBoundingClientRect(), t = e.left, n = e.width, a = e.height, r = e.top, o = document.documentElement, i = o.clientWidth, c = o.clientHeight, l = t + n > i, s = t < 0, u = r + a > c;
            x.current.style.left = function() {
                var e = t + n - i;
                if (l || s) {
                    var a = Math.abs(t), r = s ? a : 0;
                    return l ? "calc(50% - ".concat(e, "px)") : "calc(50% + ".concat(r, "px)");
                }
            }(), ("auto" === D && u || "top" === D) && x.current.classList.add("-top");
        }
    }, [
        I
    ]);
    return $7fPBF.useEffect(function() {
        !I && P.current && (R.current.focus(), P.current = !1);
    }, [
        P,
        I
    ]), $b871b7860d2a9903$var$n.createElement("div", {
        onFocus: function() {
            P.current || Y(!0);
        },
        onBlur: function(e) {
            if (e.persist(), I) {
                var t = x.current.contains(e.relatedTarget);
                P.current ? (P.current = !1, R.current.focus()) : t && e.relatedTarget ? e.relatedTarget.focus() : Y(!1);
            }
        },
        onKeyUp: function(e) {
            switch(e.key){
                case "Enter":
                    Y(!0);
                    break;
                case "Escape":
                    Y(!1), P.current = !0;
            }
        },
        className: "DatePicker ".concat(d),
        role: "presentation"
    }, $b871b7860d2a9903$var$n.createElement($b871b7860d2a9903$var$G, {
        ref: R,
        formatInputText: o,
        value: a,
        inputPlaceholder: i,
        inputClassName: c,
        renderInput: u,
        inputName: s,
        locale: k
    }), I && $b871b7860d2a9903$var$n.createElement($b871b7860d2a9903$var$n.Fragment, null, $b871b7860d2a9903$var$n.createElement("div", {
        ref: x,
        className: "DatePicker__calendarContainer",
        "data-testid": "calendar-container",
        role: "presentation",
        onMouseDown: function() {
            P.current = !0;
        }
    }, $b871b7860d2a9903$var$n.createElement($b871b7860d2a9903$var$F, {
        value: a,
        onChange: function(e) {
            var t = $b871b7860d2a9903$var$p(a);
            r(e), ("SINGLE_DATE" === t || "RANGE" === t && e.from && e.to) && Y(!1);
        },
        calendarClassName: m,
        calendarTodayClassName: f,
        calendarSelectedDayClassName: h,
        calendarRangeStartClassName: y,
        calendarRangeBetweenClassName: g,
        calendarRangeEndClassName: v,
        disabledDays: S,
        colorPrimary: E,
        colorPrimaryLight: C,
        slideAnimationDuration: N,
        onDisabledDayError: b,
        minimumDate: w,
        maximumDate: _,
        selectorStartingYear: A,
        selectorEndingYear: O,
        locale: k,
        shouldHighlightWeekends: T,
        renderFooter: M,
        customDaysClassName: L
    })), $b871b7860d2a9903$var$n.createElement("div", {
        className: "DatePicker__calendarArrow"
    })));
};
$b871b7860d2a9903$var$J.defaultProps = {
    wrapperClassName: "",
    locale: "en",
    calendarPopperPosition: "auto"
}, $b871b7860d2a9903$exports.Calendar = $b871b7860d2a9903$var$F, $b871b7860d2a9903$exports.default = $b871b7860d2a9903$var$J, $b871b7860d2a9903$exports.utils = $b871b7860d2a9903$var$T;



var $by0pu = parcelRequire("by0pu");


const $69c5fe3566014017$export$2f97ab58db958e4f = {
    // months list by order
    months: [
        "Janu\xe1r",
        "Febru\xe1r",
        "M\xe1rcius",
        "\xc1prilis",
        "M\xe1jus",
        "J\xfanius",
        "J\xfalius",
        'Augusztus',
        'Szeptember',
        "Okt\xf3ber",
        'November',
        'December'
    ],
    // week days by order
    weekDays: [
        {
            name: "H\xe9tf\u0151",
            short: 'H'
        },
        {
            name: 'Kedd',
            short: 'K'
        },
        {
            name: 'Szerda',
            short: 'Sze'
        },
        {
            name: "Cs\xfct\xf6rt\xf6k",
            short: 'Cs'
        },
        {
            name: "P\xe9ntek",
            short: 'P'
        },
        {
            name: 'Szombat',
            short: 'Szo',
            isWeekend: true
        },
        {
            name: "Vas\xe1rnap",
            short: 'V',
            isWeekend: true // is it a formal weekend or not?
        }
    ],
    // just play around with this number between 0 and 6
    weekStartingIndex: 6,
    // return a { year: number, month: number, day: number } object
    getToday (gregorainTodayObject) {
        return gregorainTodayObject;
    },
    // return a native JavaScript date here
    toNativeDate (date) {
        return new Date(date.year, date.month - 1, date.day);
    },
    // return a number for date's month length
    getMonthLength (date) {
        return new Date(date.year, date.month, 0).getDate();
    },
    // return a transformed digit to your locale
    transformDigit (digit) {
        return digit;
    },
    // texts in the date picker
    nextMonth: "K\xf6vetkez\u0151 h\xf3nap",
    previousMonth: "El\u0151z\u0151 h\xf3nap",
    openMonthSelector: "H\xf3nap v\xe1laszt\xf3",
    openYearSelector: "\xc9v v\xe1laszt\xf3",
    closeMonthSelector: "Bez\xe1r\xe1s",
    closeYearSelector: "Bez\xe1r\xe1s",
    defaultPlaceholder: '',
    // for input range value
    from: "ett\u0151l: ",
    to: 'eddig: ',
    // used for input value when multi dates are selected
    digitSeparator: '.',
    // if your provide -2 for example, year will be 2 digited
    yearLetterSkip: 0,
    // is your language rtl or ltr?
    isRtl: false
};
const $69c5fe3566014017$export$a3f37cad7baac28f = {
    // months list by order
    months: [
        'Januar',
        'Februar',
        'Marsch',
        'April',
        'Kann',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ],
    // week days by order
    weekDays: [
        {
            name: 'Montag',
            short: 'Mo'
        },
        {
            name: 'Dienstag',
            short: 'Di'
        },
        {
            name: 'Mittwoch',
            short: 'Mi'
        },
        {
            name: 'Donnerstag',
            short: 'Do'
        },
        {
            name: 'Freitag',
            short: 'Fr'
        },
        {
            name: 'Samstag',
            short: 'Sa',
            isWeekend: true
        },
        {
            name: 'Sonntag',
            short: 'So',
            isWeekend: true // is it a formal weekend or not?
        }
    ],
    // just play around with this number between 0 and 6
    weekStartingIndex: 6,
    // return a { year: number, month: number, day: number } object
    getToday (gregorainTodayObject) {
        return gregorainTodayObject;
    },
    // return a native JavaScript date here
    toNativeDate (date) {
        return new Date(date.year, date.month - 1, date.day);
    },
    // return a number for date's month length
    getMonthLength (date) {
        return new Date(date.year, date.month, 0).getDate();
    },
    // return a transformed digit to your locale
    transformDigit (digit) {
        return digit;
    },
    // texts in the date picker
    nextMonth: "N\xe4chsten Monat",
    previousMonth: 'Vorheriger Monat',
    openMonthSelector: "Monatsauswahl \xf6ffnen",
    openYearSelector: "Jahresauswahl \xf6ffnen",
    closeMonthSelector: 'Nah dran',
    closeYearSelector: 'Nah dran',
    defaultPlaceholder: '',
    // for input range value
    from: 'von: ',
    to: 'bis: ',
    // used for input value when multi dates are selected
    digitSeparator: '.',
    // if your provide -2 for example, year will be 2 digited
    yearLetterSkip: 0,
    // is your language rtl or ltr?
    isRtl: false
};




var $7fPBF = parcelRequire("7fPBF");

var $k2dmk = parcelRequire("k2dmk");
var $MQfsM = parcelRequire("MQfsM");

/**
 * @param {string} inputLabel - The label displayed above the input
 * @param {Object} inputValue - The selected date in Modern Calendar format ({ year, month, day })
 * @param {boolean} error - If true, the label will be displayed in an error state
 * @param {string} errorMessage - Optional helper text to show error messages
 * @param {Object} ref - The ref forwarded by react-modern-calendar-datepicker
 *
 * @returns {JSX.Element}
 */ const $fe53a7b1dd88b7e3$var$CustomInputField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(({ inputLabel: inputLabel, inputValue: inputValue, error: error, errorMessage: errorMessage }, ref)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $k2dmk.default), {
                children: inputLabel
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                className: "date-range-picker-input",
                fullWidth: true,
                variant: "standard",
                inputRef: ref,
                InputProps: {
                    readOnly: true
                },
                value: inputValue ? (0, $8bfb433bad942c35$export$1e32f7407816b987)(inputValue) : '',
                error: error,
                helperText: errorMessage
            })
        ]
    });
});
var $fe53a7b1dd88b7e3$export$2e2bcd8739ae039 = $fe53a7b1dd88b7e3$var$CustomInputField;



parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");


const $d0403c88207f708f$var$useStyles = (0, $by0pu.default)({
    footerWrapper: {
        paddingBottom: '16px'
    }
}, {
    name: 'DatePickerFooter'
});
/**
 * @param {function(number): void} handleMonthChange - Function to add months to the current date
 * @param {function(Date): void} onChange - Callback to set a new date (used for "reset" button)
 *
 * @returns {JSX.Element}
 */ const $d0403c88207f708f$var$DatePickerFooter = ({ handleMonthChange: handleMonthChange, onChange: onChange })=>{
    const classes = $d0403c88207f708f$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        container: true,
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        spacing: 1,
        className: classes.footerWrapper,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    size: "small",
                    variant: "outlined",
                    color: "primary",
                    onClick: ()=>handleMonthChange(3),
                    children: t('objective.dialog.calendar.threeMonths')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    size: "small",
                    variant: "outlined",
                    color: "primary",
                    onClick: ()=>handleMonthChange(6),
                    children: t('objective.dialog.calendar.sixMonths')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    size: "small",
                    variant: "outlined",
                    color: "primary",
                    onClick: ()=>handleMonthChange(12),
                    children: t('objective.dialog.calendar.twelveMonths')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    size: "small",
                    variant: "outlined",
                    color: "primary",
                    onClick: ()=>onChange((0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(new Date(), 1)),
                    children: t('objective.dialog.calendar.reset')
                })
            })
        ]
    });
};
var $d0403c88207f708f$export$2e2bcd8739ae039 = $d0403c88207f708f$var$DatePickerFooter;


const $d06a793a8d8d93ee$var$EN = 'en';
const $d06a793a8d8d93ee$var$DE = 'de';
const $d06a793a8d8d93ee$var$CALENDAR_VIEWPORT_MARGIN = 8;
// The library positions the popper relative to the input only ("top" ignores
// the viewport entirely), so on short screens the calendar header can end up
// above the visible area (CXR-2098). Shift the opened popper back into view,
// prioritizing the top edge so the month navigation always stays reachable.
const $d06a793a8d8d93ee$var$keepCalendarInViewport = (wrapper)=>{
    const container = wrapper.querySelector('.DatePicker__calendarContainer');
    if (!container) return;
    const { top: top, bottom: bottom } = container.getBoundingClientRect();
    const viewportHeight = document.documentElement.clientHeight;
    let shift = 0;
    if (bottom > viewportHeight - $d06a793a8d8d93ee$var$CALENDAR_VIEWPORT_MARGIN) shift = viewportHeight - $d06a793a8d8d93ee$var$CALENDAR_VIEWPORT_MARGIN - bottom;
    if (top + shift < $d06a793a8d8d93ee$var$CALENDAR_VIEWPORT_MARGIN) shift = $d06a793a8d8d93ee$var$CALENDAR_VIEWPORT_MARGIN - top;
    if (shift !== 0) {
        container.style.top = `${container.offsetTop + shift}px`;
        container.style.bottom = 'auto';
    }
};
const $d06a793a8d8d93ee$var$useStyles = (0, $by0pu.default)({
    calendarWrapper: {
        width: '100%'
    }
}, {
    name: 'CustomDatePicker'
});
/**
 * @param {Object} props - Component props, any additional props passed to the DatePicker
 * @param {function(Date): void} onChange - Callback to handle selected date changes
 * @param {string} value - The currently selected date
 * @param {string} dateFormat - Optional custom date format (not currently used directly)
 * @param {string} inputLabel - Label text displayed above the input field
 * @param {boolean} error - If true, the label will be displayed in an error state for InputField
 * @param {string} errorMessage - Error message shown below the input
 *
 * @returns {JSX.Element}
 */ const $d06a793a8d8d93ee$var$CustomDatePicker = (_param)=>{
    var { onChange: onChange, value: value, dateFormat: dateFormat, inputLabel: inputLabel, error: error, errorMessage: errorMessage } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "onChange",
        "value",
        "dateFormat",
        "inputLabel",
        "error",
        "errorMessage"
    ]);
    const classes = $d06a793a8d8d93ee$var$useStyles();
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [inputValue, setInputValue] = (0, $7fPBF.useState)(null);
    const wrapperRef = (0, $7fPBF.useRef)(null);
    const minDate = new Date();
    (0, $7fPBF.useEffect)(()=>{
        if (value) setInputValue((0, $8bfb433bad942c35$export$f470d795e00a1a60)(new Date(value)));
    }, [
        value
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        // rAF: wait for the library's own layout effect to apply the "-top" class
        // before measuring, but still reposition before the browser paints
        const reposition = ()=>window.requestAnimationFrame(()=>$d06a793a8d8d93ee$var$keepCalendarInViewport(wrapper));
        const observer = new MutationObserver(reposition);
        observer.observe(wrapper, {
            childList: true,
            subtree: true
        });
        window.addEventListener('resize', reposition);
        return ()=>{
            observer.disconnect();
            window.removeEventListener('resize', reposition);
        };
    }, []);
    const handleMonthChange = (month)=>{
        const newDate = (0, $8bfb433bad942c35$export$17029b467e4298ef)(new Date((0, $8bfb433bad942c35$export$1e32f7407816b987)(inputValue)), month);
        setInputValue((0, $8bfb433bad942c35$export$f470d795e00a1a60)(newDate));
        onChange(newDate);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b871b7860d2a9903$exports))), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            wrapperClassName: classes.calendarWrapper,
            value: inputValue,
            shouldHighlightWeekends: true,
            minimumDate: (0, $8bfb433bad942c35$export$f470d795e00a1a60)(minDate),
            colorPrimary: "#99B64E",
            onChange: (date)=>onChange(new Date((0, $8bfb433bad942c35$export$1e32f7407816b987)(date))),
            renderInput: ({ ref: ref })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe53a7b1dd88b7e3$export$2e2bcd8739ae039), {
                    ref: ref,
                    inputValue: inputValue,
                    inputLabel: inputLabel,
                    error: error,
                    errorMessage: errorMessage
                }),
            renderFooter: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d0403c88207f708f$export$2e2bcd8739ae039), {
                    handleMonthChange: handleMonthChange,
                    onChange: onChange
                }),
            locale: i18n.language === $d06a793a8d8d93ee$var$EN ? $d06a793a8d8d93ee$var$EN : i18n.language === $d06a793a8d8d93ee$var$DE ? (0, $69c5fe3566014017$export$a3f37cad7baac28f) : (0, $69c5fe3566014017$export$2f97ab58db958e4f),
            calendarPopperPosition: "top" //to prevent scrolling issues, it will be always visible
        }, props))
    });
};
var $d06a793a8d8d93ee$export$2e2bcd8739ae039 = $d06a793a8d8d93ee$var$CustomDatePicker;






const $c3447d4985bafc2a$var$NO_CATEGORIES = [];
const $c3447d4985bafc2a$var$ObjectiveDialog = ({ open: open, handleClose: handleClose, objectiveItem: objectiveItem, employeeIdOfCurrentUser: employeeIdOfCurrentUser, onSubmitSuccess: onSubmitSuccess })=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const categories = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
        var _state_accountInfo_categories;
        return (_state_accountInfo_categories = state.accountInfo.categories) !== null && _state_accountInfo_categories !== void 0 ? _state_accountInfo_categories : $c3447d4985bafc2a$var$NO_CATEGORIES;
    });
    const possibleAppraisers = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.accountInfo.possibleAppraisers);
    const getLeaderAppraiser = (objectiveItem, possibleAppraisers)=>{
        if (!possibleAppraisers) return {};
        const appraiser = possibleAppraisers.find((appraiser)=>{
            const leaderEmployeeId = objectiveItem.appraisers_and_criterias.appraisers.find((appraiser)=>appraiser.role === (0, $f6e729db3f817bb5$exports.RATING_ROLE).LEADER).employee_id;
            return appraiser.empid === leaderEmployeeId;
        });
        return appraiser;
    };
    const [objective, setObjective] = (0, $7fPBF.useState)(objectiveItem ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objectiveItem), {
        appraiser: getLeaderAppraiser(objectiveItem, possibleAppraisers)
    }) : {
        name: '',
        description: '',
        deadline: (0, $8bfb433bad942c35$export$b76490726c886755)(),
        weight: (0, $f6e729db3f817bb5$exports.DEFAULT_OBJECTIVE_WEIGHT),
        category: '',
        appraiser: {},
        status: (0, $f6e729db3f817bb5$exports.STATUS).PROPOSED
    });
    (0, $7fPBF.useEffect)(()=>{
        if (objectiveItem) setObjective((objective)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objectiveItem), {
                appraiser: getLeaderAppraiser(objectiveItem, possibleAppraisers),
                category: categories.find((category)=>category.category_name.hu === objectiveItem.category)
            });
        });
    }, [
        categories,
        objectiveItem,
        possibleAppraisers
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [validation, setValidation] = (0, $7fPBF.useState)({
        name: false,
        description: false,
        deadline: false,
        appraiser: false,
        category: false
    });
    const resetState = ()=>{
        setValidation({
            name: false,
            description: false,
            deadline: false,
            category: false
        });
        setObjective({
            name: '',
            description: '',
            deadline: (0, $8bfb433bad942c35$export$b76490726c886755)(),
            weight: (0, $f6e729db3f817bb5$exports.DEFAULT_OBJECTIVE_WEIGHT),
            category: '',
            appraiser: '',
            status: (0, $f6e729db3f817bb5$exports.STATUS).PROPOSED
        });
    };
    const saveObjectiveMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        const newObjective = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
            appraiserId: objective.appraiser.empid
        });
        return objective.id ? await (0, $553835ea16648c6f$export$417f69f9ec942304)({
            objective: newObjective
        }) : await (0, $553835ea16648c6f$export$d6292f1ee2869c8e)({
            objective: newObjective
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
            resetState();
            handleClose();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const handleObjectiveSave = ()=>{
        if (!(0, $bbe304316b6a71dc$export$b98e45bca1b0be2f)(setValidation, objective)) return;
        saveObjectiveMutation.mutate();
    };
    const handleDialogClose = ()=>{
        if (!objective.objective_id) resetState();
        handleClose();
    };
    const handleOnChangeName = (event)=>{
        setObjective((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
            name: event.target.value
        }));
        (0, $bbe304316b6a71dc$export$4d09d4ac8ba225dd)(setValidation, validation, 'name', event.target.value);
    };
    const handleOnChangeDescription = (event)=>{
        setObjective((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
            description: event.target.value
        }));
        (0, $bbe304316b6a71dc$export$4d09d4ac8ba225dd)(setValidation, validation, 'description', event.target.value);
    };
    const handleOnChangeAppraiser = (event, values)=>{
        setObjective((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
            appraiser: values
        }));
        (0, $bbe304316b6a71dc$export$4d09d4ac8ba225dd)(setValidation, validation, 'appraiser', values);
    };
    const handleDateChange = (date)=>{
        setObjective((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
            deadline: date
        }));
        (0, $bbe304316b6a71dc$export$4d09d4ac8ba225dd)(setValidation, validation, 'deadline', date);
    };
    const handleOnChangeWeight = (event)=>{
        let { value: value, min: min, max: max } = event.target;
        value = Math.max(min, Math.min(max, value));
        setObjective((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
            weight: value
        }));
    };
    const handleOnChangeCategory = (event)=>{
        setObjective((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
            category: event.target.value
        }));
        (0, $bbe304316b6a71dc$export$4d09d4ac8ba225dd)(setValidation, validation, 'category', event.target.value);
    };
    const useStyles = (0, $by0pu.default)((theme)=>({
            dialogDivider: {
                marginBottom: '7px'
            },
            inputLabel: {
                marginTop: '10px'
            },
            containerForSmall: {
                [theme.breakpoints.down('xs')]: {
                    flexDirection: 'column'
                }
            },
            datepicker: {
                minWidth: '170px'
            }
        }));
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
        PaperProps: {
            style: {
                minHeight: '600px',
                overflow: 'visible' // allow popper to extend beyond dialog
            }
        },
        open: open,
        fullWidth: true,
        maxWidth: 'md',
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                children: t('objective.dialog.create.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                style: {
                    overflow: 'visible'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    direction: 'column',
                    justifyContent: 'center',
                    alignItems: 'stretch',
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $k2dmk.default), {
                            children: t('objective.dialog.create.name.label')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            value: objective.name,
                            error: validation.name,
                            helperText: validation.name ? t((0, $f6e729db3f817bb5$exports.ERROR_MESSAGES).NAME) : ' ',
                            onChange: handleOnChangeName,
                            fullWidth: true,
                            placeholder: t('objective.dialog.create.name.placeholder'),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                variant: "subtitle2"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $k2dmk.default), {
                            className: classes.inputLabel,
                            children: t('objective.dialog.create.description.label')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            value: objective.description,
                            error: validation.description,
                            helperText: validation.description ? t((0, $f6e729db3f817bb5$exports.ERROR_MESSAGES).DESCRIPTION) : '',
                            multiline: true,
                            minRows: 3,
                            maxRows: 3,
                            onChange: handleOnChangeDescription,
                            fullWidth: true,
                            placeholder: t('objective.dialog.create.description.placeholder')
                        }),
                        (!objective.objective_id || objective.proposed_by === employeeIdOfCurrentUser) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $k2dmk.default), {
                                    className: classes.inputLabel,
                                    children: t('objective.dialog.create.appraiser.label')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $43a59d95b15b9c9d$export$2e2bcd8739ae039), {
                                    value: objective.objective_id ? objective.appraiser : undefined,
                                    options: possibleAppraisers,
                                    getOptionLabel: (option)=>`${option.name} (${option.address})`,
                                    style: {
                                        maxWidth: 300
                                    },
                                    renderInput: (params)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, params), {
                                            error: validation.appraiser,
                                            helperText: validation.appraiser ? t((0, $f6e729db3f817bb5$exports.ERROR_MESSAGES).APPRAISER) : '',
                                            placeholder: t('objective.dialog.create.appraiser.placeholder')
                                        })),
                                    onChange: handleOnChangeAppraiser
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            className: classes.dialogDivider,
                            flexItem: true
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            className: classes.containerForSmall,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 4,
                                    className: classes.datepicker,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d06a793a8d8d93ee$export$2e2bcd8739ae039), {
                                        inputLabel: t('objective.dialog.create.deadline.label'),
                                        value: objective.deadline,
                                        onChange: handleDateChange,
                                        dateFormat: (0, $8bfb433bad942c35$export$fa96065c64444af6)(),
                                        error: validation.deadline,
                                        errorMessage: validation.deadline ? t((0, $f6e729db3f817bb5$exports.ERROR_MESSAGES).DEADLINE) : ''
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $k2dmk.default), {
                                            children: t('objective.dialog.create.weight.label')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cuouK.default), {
                                            style: {
                                                width: '100%'
                                            },
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                                                type: 'number',
                                                inputProps: {
                                                    min: 0,
                                                    max: 1000,
                                                    step: 0.1,
                                                    defaultValue: objective.weight || (0, $f6e729db3f817bb5$exports.DEFAULT_OBJECTIVE_WEIGHT)
                                                },
                                                onChange: handleOnChangeWeight
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $k2dmk.default), {
                                            children: t('objective.dialog.create.category.label')
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e136e3176b99aeb2$export$2e2bcd8739ae039), {
                                            categories: categories,
                                            category: objective.category,
                                            handleOnChangeCategory: handleOnChangeCategory,
                                            error: validation.category,
                                            helperText: validation.category ? t((0, $f6e729db3f817bb5$exports.ERROR_MESSAGES).CATEGORY) : ''
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleObjectiveSave,
                        variant: "contained",
                        color: "primary",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: t('objective.dialog.save')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleDialogClose,
                        color: "primary",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: t('objective.dialog.cancel')
                        })
                    })
                ]
            })
        ]
    });
};
var $c3447d4985bafc2a$export$2e2bcd8739ae039 = $c3447d4985bafc2a$var$ObjectiveDialog;




var $7fPBF = parcelRequire("7fPBF");

var $dQMrF = parcelRequire("dQMrF");


var $c2PJn = parcelRequire("c2PJn");
function $136cfda4f1e98684$var$getPath(obj, path) {
    if (!path || typeof path !== 'string') return null;
    return path.split('.').reduce(function(acc, item) {
        return acc && acc[item] ? acc[item] : null;
    }, obj);
}
function $136cfda4f1e98684$var$style(options) {
    var prop = options.prop, _options$cssProperty = options.cssProperty, cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty, themeKey = options.themeKey, transform = options.transform;
    var fn = function fn(props) {
        if (props[prop] == null) return null;
        var propValue = props[prop];
        var theme = props.theme;
        var themeMapping = $136cfda4f1e98684$var$getPath(theme, themeKey) || {};
        var styleFromPropValue = function styleFromPropValue(propValueFinal) {
            var value;
            if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
            else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || propValueFinal;
            else {
                value = $136cfda4f1e98684$var$getPath(themeMapping, propValueFinal) || propValueFinal;
                if (transform) value = transform(value);
            }
            if (cssProperty === false) return value;
            return (0, $dQMrF.default)({}, cssProperty, value);
        };
        return (0, $c2PJn.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $136cfda4f1e98684$export$2e2bcd8739ae039 = $136cfda4f1e98684$var$style;


parcelRequire("kY3Ke");

var $cMoso = parcelRequire("cMoso");
function $1b27c9910d0eed3e$var$compose() {
    for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++)styles[_key] = arguments[_key];
    var fn = function fn(props) {
        return styles.reduce(function(acc, style) {
            var output = style(props);
            if (output) return (0, $cMoso.default)(acc, output);
            return acc;
        }, {});
    }; // Alternative approach that doesn't yield any performance gain.
    // const handlers = styles.reduce((acc, style) => {
    //   style.filterProps.forEach(prop => {
    //     acc[prop] = style;
    //   });
    //   return acc;
    // }, {});
    // const fn = props => {
    //   return Object.keys(props).reduce((acc, prop) => {
    //     if (handlers[prop]) {
    //       return merge(acc, handlers[prop](props));
    //     }
    //     return acc;
    //   }, {});
    // };
    fn.propTypes = {};
    fn.filterProps = styles.reduce(function(acc, style) {
        return acc.concat(style.filterProps);
    }, []);
    return fn;
}
var $1b27c9910d0eed3e$export$2e2bcd8739ae039 = $1b27c9910d0eed3e$var$compose;


function $7f7bec103caa558a$var$getBorder(value) {
    if (typeof value !== 'number') return value;
    return "".concat(value, "px solid");
}
var $7f7bec103caa558a$export$1edee58a52776cd9 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'border',
    themeKey: 'borders',
    transform: $7f7bec103caa558a$var$getBorder
});
var $7f7bec103caa558a$export$f9a7b6bd24892946 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'borderTop',
    themeKey: 'borders',
    transform: $7f7bec103caa558a$var$getBorder
});
var $7f7bec103caa558a$export$5abca33e6be905d2 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'borderRight',
    themeKey: 'borders',
    transform: $7f7bec103caa558a$var$getBorder
});
var $7f7bec103caa558a$export$e2ce9f12a980a822 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'borderBottom',
    themeKey: 'borders',
    transform: $7f7bec103caa558a$var$getBorder
});
var $7f7bec103caa558a$export$47658cca1a909427 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'borderLeft',
    themeKey: 'borders',
    transform: $7f7bec103caa558a$var$getBorder
});
var $7f7bec103caa558a$export$e7fb0694ba2404fc = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'borderColor',
    themeKey: 'palette'
});
var $7f7bec103caa558a$export$7a57f79000377ca2 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'borderRadius',
    themeKey: 'shape'
});
var $7f7bec103caa558a$var$borders = (0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)($7f7bec103caa558a$export$1edee58a52776cd9, $7f7bec103caa558a$export$f9a7b6bd24892946, $7f7bec103caa558a$export$5abca33e6be905d2, $7f7bec103caa558a$export$e2ce9f12a980a822, $7f7bec103caa558a$export$47658cca1a909427, $7f7bec103caa558a$export$e7fb0694ba2404fc, $7f7bec103caa558a$export$7a57f79000377ca2);
var $7f7bec103caa558a$export$2e2bcd8739ae039 = $7f7bec103caa558a$var$borders;



var $f45f6e8f2896f443$export$95a5c40fb210fe3e = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: function transform(value) {
        return {
            '@media print': {
                display: value
            }
        };
    }
});
var $f45f6e8f2896f443$export$e5efd59aba9975ad = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'display'
});
var $f45f6e8f2896f443$export$f6530fb6e67e00bd = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'overflow'
});
var $f45f6e8f2896f443$export$f00f69a6f0e8c5b6 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'textOverflow'
});
var $f45f6e8f2896f443$export$91fa9ac3f4021ce4 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'visibility'
});
var $f45f6e8f2896f443$export$9ef81298ca34ad41 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'whiteSpace'
});
var $f45f6e8f2896f443$export$2e2bcd8739ae039 = (0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)($f45f6e8f2896f443$export$95a5c40fb210fe3e, $f45f6e8f2896f443$export$e5efd59aba9975ad, $f45f6e8f2896f443$export$f6530fb6e67e00bd, $f45f6e8f2896f443$export$f00f69a6f0e8c5b6, $f45f6e8f2896f443$export$91fa9ac3f4021ce4, $f45f6e8f2896f443$export$9ef81298ca34ad41);



var $6b8d3d1f63b64ac9$export$d2ad290394bbc49d = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'flexBasis'
});
var $6b8d3d1f63b64ac9$export$84c3c16c9ed6c908 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'flexDirection'
});
var $6b8d3d1f63b64ac9$export$9a4bcd01f5c204bc = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'flexWrap'
});
var $6b8d3d1f63b64ac9$export$8dea3061ba53bfd1 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'justifyContent'
});
var $6b8d3d1f63b64ac9$export$898d9006406726bd = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'alignItems'
});
var $6b8d3d1f63b64ac9$export$38c32c6918694134 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'alignContent'
});
var $6b8d3d1f63b64ac9$export$aaaeab0fac9a3ccb = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'order'
});
var $6b8d3d1f63b64ac9$export$97691fbb80847c19 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'flex'
});
var $6b8d3d1f63b64ac9$export$36c65c169152373d = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'flexGrow'
});
var $6b8d3d1f63b64ac9$export$2670ac60b02109d2 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'flexShrink'
});
var $6b8d3d1f63b64ac9$export$4545dd3632cb520b = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'alignSelf'
});
var $6b8d3d1f63b64ac9$export$55e6b7a7f0eaa3ff = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'justifyItems'
});
var $6b8d3d1f63b64ac9$export$d012640ac9a6446f = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'justifySelf'
});
var $6b8d3d1f63b64ac9$var$flexbox = (0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)($6b8d3d1f63b64ac9$export$d2ad290394bbc49d, $6b8d3d1f63b64ac9$export$84c3c16c9ed6c908, $6b8d3d1f63b64ac9$export$9a4bcd01f5c204bc, $6b8d3d1f63b64ac9$export$8dea3061ba53bfd1, $6b8d3d1f63b64ac9$export$898d9006406726bd, $6b8d3d1f63b64ac9$export$38c32c6918694134, $6b8d3d1f63b64ac9$export$aaaeab0fac9a3ccb, $6b8d3d1f63b64ac9$export$97691fbb80847c19, $6b8d3d1f63b64ac9$export$36c65c169152373d, $6b8d3d1f63b64ac9$export$2670ac60b02109d2, $6b8d3d1f63b64ac9$export$4545dd3632cb520b, $6b8d3d1f63b64ac9$export$55e6b7a7f0eaa3ff, $6b8d3d1f63b64ac9$export$d012640ac9a6446f);
var $6b8d3d1f63b64ac9$export$2e2bcd8739ae039 = $6b8d3d1f63b64ac9$var$flexbox;



var $4cbc844371154670$export$62ffeaf1cd78b2a6 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridGap'
});
var $4cbc844371154670$export$d6171c086ca0de0 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridColumnGap'
});
var $4cbc844371154670$export$8bb113508eaa54d = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridRowGap'
});
var $4cbc844371154670$export$baf44164ca3a34e8 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
var $4cbc844371154670$export$8f7213a1cd01e832 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
var $4cbc844371154670$export$b0e0abbc49ba668 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
var $4cbc844371154670$export$bcd8b929d4b4142 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
var $4cbc844371154670$export$e5039a674e14c828 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
var $4cbc844371154670$export$42bd9088661ffb03 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
var $4cbc844371154670$export$920682ae05b999bc = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
var $4cbc844371154670$export$1b88fbdd482fd33a = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
var $4cbc844371154670$export$bdb486e40d52d26f = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
var $4cbc844371154670$var$grid = (0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)($4cbc844371154670$export$62ffeaf1cd78b2a6, $4cbc844371154670$export$d6171c086ca0de0, $4cbc844371154670$export$8bb113508eaa54d, $4cbc844371154670$export$baf44164ca3a34e8, $4cbc844371154670$export$8f7213a1cd01e832, $4cbc844371154670$export$b0e0abbc49ba668, $4cbc844371154670$export$bcd8b929d4b4142, $4cbc844371154670$export$e5039a674e14c828, $4cbc844371154670$export$42bd9088661ffb03, $4cbc844371154670$export$920682ae05b999bc, $4cbc844371154670$export$1b88fbdd482fd33a, $4cbc844371154670$export$bdb486e40d52d26f);
var $4cbc844371154670$export$2e2bcd8739ae039 = $4cbc844371154670$var$grid;



var $f66981910e721d0a$export$35e9368ef982300f = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette'
});
var $f66981910e721d0a$export$2506f56c10355b33 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette'
});
var $f66981910e721d0a$var$palette = (0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)($f66981910e721d0a$export$35e9368ef982300f, $f66981910e721d0a$export$2506f56c10355b33);
var $f66981910e721d0a$export$2e2bcd8739ae039 = $f66981910e721d0a$var$palette;



var $1c6e763218aac1d1$export$5880b8b5730aff45 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'position'
});
var $1c6e763218aac1d1$export$56446adcecbeec34 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
var $1c6e763218aac1d1$export$1e95b668f3b82d = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'top'
});
var $1c6e763218aac1d1$export$79ffe56a765070d2 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'right'
});
var $1c6e763218aac1d1$export$40e543e69a8b3fbb = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'bottom'
});
var $1c6e763218aac1d1$export$eabcd2c8791e7bf4 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'left'
});
var $1c6e763218aac1d1$export$2e2bcd8739ae039 = (0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)($1c6e763218aac1d1$export$5880b8b5730aff45, $1c6e763218aac1d1$export$56446adcecbeec34, $1c6e763218aac1d1$export$1e95b668f3b82d, $1c6e763218aac1d1$export$79ffe56a765070d2, $1c6e763218aac1d1$export$40e543e69a8b3fbb, $1c6e763218aac1d1$export$eabcd2c8791e7bf4);


var $60c43d29010cfa0a$var$boxShadow = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $60c43d29010cfa0a$export$2e2bcd8739ae039 = $60c43d29010cfa0a$var$boxShadow;



function $4d1df433c515822b$var$transform(value) {
    return value <= 1 ? "".concat(value * 100, "%") : value;
}
var $4d1df433c515822b$export$7e3df82ee760448c = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $4d1df433c515822b$var$transform
});
var $4d1df433c515822b$export$488fda99655ff65a = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'maxWidth',
    transform: $4d1df433c515822b$var$transform
});
var $4d1df433c515822b$export$ee148fbbe8357dd2 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $4d1df433c515822b$var$transform
});
var $4d1df433c515822b$export$ac607276a8fe9f0a = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $4d1df433c515822b$var$transform
});
var $4d1df433c515822b$export$dc0d8bd0b94f8570 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $4d1df433c515822b$var$transform
});
var $4d1df433c515822b$export$a43cf604e12f3b17 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $4d1df433c515822b$var$transform
});
var $4d1df433c515822b$export$ffed9f14fb65e276 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $4d1df433c515822b$var$transform
});
var $4d1df433c515822b$export$905076ed6620e671 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $4d1df433c515822b$var$transform
});
var $4d1df433c515822b$export$6ccc93f785106a58 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
var $4d1df433c515822b$var$sizing = (0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)($4d1df433c515822b$export$7e3df82ee760448c, $4d1df433c515822b$export$488fda99655ff65a, $4d1df433c515822b$export$ee148fbbe8357dd2, $4d1df433c515822b$export$ac607276a8fe9f0a, $4d1df433c515822b$export$dc0d8bd0b94f8570, $4d1df433c515822b$export$a43cf604e12f3b17, $4d1df433c515822b$export$6ccc93f785106a58);
var $4d1df433c515822b$export$2e2bcd8739ae039 = $4d1df433c515822b$var$sizing;


var $aXuZY = parcelRequire("aXuZY");
var $cwJVy = parcelRequire("cwJVy");

var $kY3Ke = parcelRequire("kY3Ke");



var $cMoso = parcelRequire("cMoso");
function $48688b10e166c983$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
}
var $48688b10e166c983$var$warnedOnce = false;
function $48688b10e166c983$var$styleFunctionSx(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var output = styleFunction(props);
        if (props.css) return (0, $kY3Ke.default)({}, (0, $cMoso.default)(output, styleFunction((0, $kY3Ke.default)({
            theme: props.theme
        }, props.css))), $48688b10e166c983$var$omit(props.css, [
            styleFunction.filterProps
        ]));
        if (props.sx) return (0, $kY3Ke.default)({}, (0, $cMoso.default)(output, styleFunction((0, $kY3Ke.default)({
            theme: props.theme
        }, props.sx))), $48688b10e166c983$var$omit(props.sx, [
            styleFunction.filterProps
        ]));
        return output;
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'css',
        'sx'
    ].concat((0, $cwJVy.default)(styleFunction.filterProps));
    return newStyleFunction;
}
function $48688b10e166c983$export$dbf350e5966cf602(styleFunction) {
    return $48688b10e166c983$var$styleFunctionSx(styleFunction);
}
var $48688b10e166c983$export$2e2bcd8739ae039 = $48688b10e166c983$var$styleFunctionSx;



var $9235740ddb9060f8$export$a5975749f0374264 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
var $9235740ddb9060f8$export$85e3c3ca0c6fb93 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'fontSize',
    themeKey: 'typography'
});
var $9235740ddb9060f8$export$a827189a08c5a3a3 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
var $9235740ddb9060f8$export$bc0b29e67df3229e = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
var $9235740ddb9060f8$export$3eb52878e4502ad1 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'letterSpacing'
});
var $9235740ddb9060f8$export$c9b91427b594e14 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'lineHeight'
});
var $9235740ddb9060f8$export$a87999391cd10ae9 = (0, $136cfda4f1e98684$export$2e2bcd8739ae039)({
    prop: 'textAlign'
});
var $9235740ddb9060f8$var$typography = (0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)($9235740ddb9060f8$export$a5975749f0374264, $9235740ddb9060f8$export$85e3c3ca0c6fb93, $9235740ddb9060f8$export$a827189a08c5a3a3, $9235740ddb9060f8$export$bc0b29e67df3229e, $9235740ddb9060f8$export$3eb52878e4502ad1, $9235740ddb9060f8$export$c9b91427b594e14, $9235740ddb9060f8$export$a87999391cd10ae9);
var $9235740ddb9060f8$export$2e2bcd8739ae039 = $9235740ddb9060f8$var$typography;



var $j9gH9 = parcelRequire("j9gH9");
var $d57f8c5132119daf$export$8b4cd039ebcc4f7b = (0, $48688b10e166c983$export$2e2bcd8739ae039)((0, $1b27c9910d0eed3e$export$2e2bcd8739ae039)((0, $7f7bec103caa558a$export$2e2bcd8739ae039), (0, $f45f6e8f2896f443$export$2e2bcd8739ae039), (0, $6b8d3d1f63b64ac9$export$2e2bcd8739ae039), (0, $4cbc844371154670$export$2e2bcd8739ae039), (0, $1c6e763218aac1d1$export$2e2bcd8739ae039), (0, $f66981910e721d0a$export$2e2bcd8739ae039), (0, $60c43d29010cfa0a$export$2e2bcd8739ae039), (0, $4d1df433c515822b$export$2e2bcd8739ae039), (0, $aXuZY.default), (0, $9235740ddb9060f8$export$2e2bcd8739ae039)));
/**
 * @ignore - do not document.
 */ var $d57f8c5132119daf$var$Box = (0, $j9gH9.default)('div')($d57f8c5132119daf$export$8b4cd039ebcc4f7b, {
    name: 'MuiBox'
});
var $d57f8c5132119daf$export$2e2bcd8739ae039 = $d57f8c5132119daf$var$Box;


var $iRcsz = parcelRequire("iRcsz");
var $by0pu = parcelRequire("by0pu");
var $9zU0q = parcelRequire("9zU0q");
var $hzQpW = parcelRequire("hzQpW");
var $fH0xA = parcelRequire("fH0xA");
var $48e5e77420a99f06$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($48e5e77420a99f06$exports, "__esModule", {
    value: true
});
$48e5e77420a99f06$exports.default = void 0;

var $48e5e77420a99f06$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $48e5e77420a99f06$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $48e5e77420a99f06$var$_default = (0, $48e5e77420a99f06$var$_createSvgIcon.default)(/*#__PURE__*/ $48e5e77420a99f06$var$React.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Edit');
$48e5e77420a99f06$exports.default = $48e5e77420a99f06$var$_default;



var $6qwOn = parcelRequire("6qwOn");
var $4752997e5ca2f6cc$exports = {};
//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

(function(global, factory) {
    factory((parcelRequire("6qwOn")));
})($4752997e5ca2f6cc$exports, function(moment) {
    'use strict';
    //! moment.js locale configuration
    var weekEndings = "vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch(key){
            case 's':
                return isFuture || withoutSuffix ? "n\xe9h\xe1ny m\xe1sodperc" : "n\xe9h\xe1ny m\xe1sodperce";
            case 'ss':
                return num + (isFuture || withoutSuffix) ? " m\xe1sodperc" : " m\xe1sodperce";
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? " \xf3ra" : " \xf3r\xe1ja");
            case 'hh':
                return num + (isFuture || withoutSuffix ? " \xf3ra" : " \xf3r\xe1ja");
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? " h\xf3nap" : " h\xf3napja");
            case 'MM':
                return num + (isFuture || withoutSuffix ? " h\xf3nap" : " h\xf3napja");
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? " \xe9v" : " \xe9ve");
            case 'yy':
                return num + (isFuture || withoutSuffix ? " \xe9v" : " \xe9ve");
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : "[m\xfalt] ") + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }
    var hu = moment.defineLocale('hu', {
        months: "janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split('_'),
        monthsShort: "jan._feb._m\xe1rc._\xe1pr._m\xe1j._j\xfan._j\xfal._aug._szept._okt._nov._dec.".split('_'),
        monthsParseExact: true,
        weekdays: "vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split('_'),
        weekdaysShort: "vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function(input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function(hours, minutes, isLower) {
            if (hours < 12) return isLower === true ? 'de' : 'DE';
            else return isLower === true ? 'du' : 'DU';
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function() {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function() {
                return week.call(this, false);
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "%s m\xfalva",
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1,
            doy: 4
        }
    });
    return hu;
});




var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $34df12d346b1bb0d$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown');


var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $f86ebe7fc4425398$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');


var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $a4b2a35faf1cd861$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');



var $jtRae = parcelRequire("jtRae");
var $c63aae241875c1a0$exports = {};
const $c63aae241875c1a0$var$isRaterDone = (objective = {}, objectiveRates = [], employeeIdOfRater)=>{
    if (typeof objective !== 'object' || Array.isArray(objective) || !Array.isArray(objectiveRates)) {
        console.error(new Error('bad input parameter type'));
        return false;
    }
    const { criterias: criterias = [] } = objective.appraisers_and_criterias || {};
    const ratesOfEmployee = objectiveRates.filter((rate)=>rate.rated_by === employeeIdOfRater);
    const unRatedCriterias = criterias.filter((criteria)=>!ratesOfEmployee.find((rate)=>rate.criteria.criteria_id === criteria.criteria_id));
    return unRatedCriterias.length === 0;
};
const $c63aae241875c1a0$var$isAllRaterDone = (objective = {}, objectiveRates = [])=>{
    if (typeof objective !== 'object' || Array.isArray(objective) || !Array.isArray(objectiveRates)) {
        console.error(new Error('bad input parameter type'));
        return false;
    }
    const { appraisers: appraisers = [] } = objective.appraisers_and_criterias || {};
    const findOneWhoNotDone = appraisers.find((appraiser)=>!$c63aae241875c1a0$var$isRaterDone(objective, objectiveRates, appraiser.employee_id));
    return !findOneWhoNotDone;
};
const $c63aae241875c1a0$var$weightedMean = (items)=>{
    const { valueSummary: valueSummary, weightSummary: weightSummary } = items.reduce(({ valueSummary: valueSummary, weightSummary: weightSummary }, { value: value, weight: weight })=>({
            valueSummary: valueSummary + value * weight,
            weightSummary: weightSummary + weight
        }), {
        valueSummary: 0,
        weightSummary: 0
    });
    return valueSummary / weightSummary;
};
const $c63aae241875c1a0$var$sumOfWeightedValuesAndSumOfWeights = (items)=>{
    const { valueSummary: valueSummary, weightSummary: weightSummary } = items.reduce(({ valueSummary: valueSummary, weightSummary: weightSummary }, { value: value, weight: weight })=>({
            valueSummary: valueSummary + value * weight,
            weightSummary: weightSummary + weight
        }), {
        valueSummary: 0,
        weightSummary: 0
    });
    return {
        valueSummary: valueSummary,
        weightSummary: weightSummary
    };
};
const $c63aae241875c1a0$var$raterWeightedMean = (rates = [])=>{
    if (!Array.isArray(rates)) {
        console.error(new Error('bad input parameter type'));
        return NaN;
    }
    if (rates.length <= 0) return {
        objectSummary: NaN,
        weightedMean: NaN
    };
    const ratesWithWeight = rates.filter((rate)=>rate.value !== null).map((rate)=>{
        const { value: value, criteria: { criteria_weight: criteria_weight } = {} } = rate || {};
        return {
            value: value,
            weight: criteria_weight
        };
    });
    return {
        weightedMean: $c63aae241875c1a0$var$weightedMean(ratesWithWeight),
        objectSummary: $c63aae241875c1a0$var$sumOfWeightedValuesAndSumOfWeights(ratesWithWeight)
    };
};
// return the weighted mean of completed appraisers
const $c63aae241875c1a0$var$allRaterWeightedMean = (objective = {}, objectiveRates = [])=>{
    if (typeof objective !== 'object' || Array.isArray(objective) || !Array.isArray(objectiveRates)) {
        console.error(new Error('bad input parameter type'));
        return {
            weightedMean: NaN
        };
    }
    const { appraisers: appraisers = [] } = objective.appraisers_and_criterias || {};
    const allRaterWhoDone = appraisers.filter((appraiser)=>$c63aae241875c1a0$var$isRaterDone(objective, objectiveRates, appraiser.employee_id));
    const ratesOfRatersWhoDone = objectiveRates.filter((rate)=>allRaterWhoDone.map((rater)=>rater.employee_id).includes(rate.rated_by));
    const weightedByCriteriaMeans = allRaterWhoDone.map((appraiser)=>{
        const ratesOfAppraiser = ratesOfRatersWhoDone.filter((rate)=>rate.rated_by === appraiser.employee_id);
        const { weightedMean: weightedMean } = $c63aae241875c1a0$var$raterWeightedMean(ratesOfAppraiser);
        return {
            weightedByCriteriaMean: weightedMean,
            appraiserWeight: parseFloat(appraiser.weight)
        };
    });
    const weightedMeansSum = weightedByCriteriaMeans.reduce((accumulator, currentMean)=>({
            sumOfWeightedMeans: accumulator.sumOfWeightedMeans + currentMean.weightedByCriteriaMean * currentMean.appraiserWeight,
            sumOfWeights: accumulator.sumOfWeights + currentMean.appraiserWeight
        }), {
        sumOfWeightedMeans: 0,
        sumOfWeights: 0
    });
    return {
        weightedMean: weightedMeansSum.sumOfWeightedMeans / weightedMeansSum.sumOfWeights
    };
};
/*
  return an object with the sum of weighted objective-criteria-values &
  sum of criteria weights of completed appraisers
*/ const $c63aae241875c1a0$var$allCriteriaWeightedValueAndWeightSummary = (objective = {}, objectiveRates = [])=>{
    if (typeof objective !== 'object' || Array.isArray(objective) || !Array.isArray(objectiveRates)) {
        console.error(new Error('bad input parameter type'));
        return {
            criteriavalueSummary: NaN,
            criteriaWeightSummary: NaN
        };
    }
    const { appraisers_and_criterias: appraisers_and_criterias = {} } = objective;
    if (objectiveRates.length === 0) return {
        criteriavalueSummary: NaN,
        criteriaWeightSummary: NaN
    };
    const { appraisers: appraisers = [] } = appraisers_and_criterias || {};
    const allRaterWhoDone = appraisers.filter((appraiser)=>$c63aae241875c1a0$var$isRaterDone(objective, objectiveRates, appraiser.employee_id));
    const ratesOfRatersWhoDone = objectiveRates.filter((rate)=>allRaterWhoDone.map((rater)=>rater.employee_id).includes(rate.rated_by));
    const weightedByCriteriaMeans = allRaterWhoDone.reduce((accumulator, appraiser)=>{
        const ratesOfAppraiser = ratesOfRatersWhoDone.filter((rate)=>rate.rated_by === appraiser.employee_id);
        const { objectSummary: { valueSummary: valueSummary, weightSummary: weightSummary } } = $c63aae241875c1a0$var$raterWeightedMean(ratesOfAppraiser);
        return {
            valueSummary: accumulator.valueSummary + valueSummary,
            weightSummary: accumulator.weightSummary + weightSummary
        };
    }, {
        valueSummary: 0,
        weightSummary: 0
    });
    return {
        criteriavalueSummary: weightedByCriteriaMeans.valueSummary,
        criteriaWeightSummary: weightedByCriteriaMeans.weightSummary
    };
};
// TODO: if we need to use ES6 export need to fix running Jest tests where we want to import
$c63aae241875c1a0$exports = {
    isRaterDone: $c63aae241875c1a0$var$isRaterDone,
    isAllRaterDone: $c63aae241875c1a0$var$isAllRaterDone,
    raterWeightedMean: $c63aae241875c1a0$var$raterWeightedMean,
    allRaterWeightedMean: $c63aae241875c1a0$var$allRaterWeightedMean,
    allCriteriaWeightedValueAndWeightSummary: $c63aae241875c1a0$var$allCriteriaWeightedValueAndWeightSummary
};


const $2409c916ecc098c0$export$d25ab5c0afe207fe = (appraisers)=>appraisers.every((appraiser)=>(appraiser === null || appraiser === void 0 ? void 0 : appraiser.evaluationClosed) === true);




parcelRequire("7fPBF");
const $f56e76a36f11ab96$var$RecomendedIcon = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                fill: "#ECF0F1"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M15 7.5C10.8643 7.5 7.5 10.8643 7.5 15C7.5 19.1357 10.8643 22.5 15 22.5C19.1357 22.5 22.5 19.1357 22.5 15C22.5 10.8643 19.1357 7.5 15 7.5ZM15 8.75C18.4595 8.75 21.25 11.5405 21.25 15C21.25 18.4595 18.4595 21.25 15 21.25C11.5405 21.25 8.75 18.4595 8.75 15C8.75 11.5405 11.5405 8.75 15 8.75ZM15 11.25C13.6255 11.25 12.5 12.3755 12.5 13.75H13.75C13.75 13.0518 14.3018 12.5 15 12.5C15.6982 12.5 16.25 13.0518 16.25 13.75C16.25 14.2285 15.9424 14.6533 15.4883 14.8047L15.2344 14.8828C14.7241 15.0513 14.375 15.5396 14.375 16.0742V16.875H15.625V16.0742L15.8789 15.9961C16.8408 15.6763 17.5 14.7632 17.5 13.75C17.5 12.3755 16.3745 11.25 15 11.25ZM14.375 17.5V18.75H15.625V17.5H14.375Z",
                fill: "#999999"
            })
        ]
    });
};
var $f56e76a36f11ab96$export$2e2bcd8739ae039 = $f56e76a36f11ab96$var$RecomendedIcon;



parcelRequire("7fPBF");
const $5ffeda3aff46a7df$var$Completed = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                fill: "#27AE60"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M9 15L13 19L21 11",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var $5ffeda3aff46a7df$export$2e2bcd8739ae039 = $5ffeda3aff46a7df$var$Completed;



parcelRequire("7fPBF");
const $75f241977272c280$var$FailedIcon = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                fill: "#E74C3C"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M20 20L10 10",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M10 20L20 10",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var $75f241977272c280$export$2e2bcd8739ae039 = $75f241977272c280$var$FailedIcon;



parcelRequire("7fPBF");
const $95312bc65bca7ffd$var$InDangerIcon = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                fill: "#F48401"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M15 7.01172L14.4531 7.94922L6.95312 20.9375L6.42578 21.875H23.5742L23.0469 20.9375L15.5469 7.94922L15 7.01172ZM15 9.51172L21.4062 20.625H8.59375L15 9.51172ZM14.375 13.75V17.5H15.625V13.75H14.375ZM14.375 18.125V19.375H15.625V18.125H14.375Z",
                fill: "white"
            })
        ]
    });
};
var $95312bc65bca7ffd$export$2e2bcd8739ae039 = $95312bc65bca7ffd$var$InDangerIcon;



parcelRequire("7fPBF");
const $2aafef214a95b89b$var$Neutral = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                fill: "#3498DB"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M15 6.875C14.7119 6.875 14.4141 6.89209 14.0918 6.92871L14.2285 8.16895C14.5068 8.13965 14.7583 8.125 15 8.125C18.7915 8.125 21.875 11.2085 21.875 15C21.875 18.7915 18.7915 21.875 15 21.875C14.7583 21.875 14.5093 21.8604 14.2358 21.8286L14.0967 23.0713C14.4165 23.1079 14.7119 23.125 15 23.125C19.48 23.125 23.125 19.48 23.125 15C23.125 10.52 19.48 6.875 15 6.875ZM12.3169 7.33643C11.7432 7.53662 11.1938 7.80518 10.6787 8.12744L11.3452 9.18457C11.7798 8.91113 12.2461 8.68652 12.7319 8.51562L12.3169 7.33643ZM9.25293 9.25537C8.84033 9.67041 8.45947 10.1514 8.125 10.6836L9.18457 11.3477C9.46777 10.8936 9.79004 10.4883 10.1367 10.1392L9.25293 9.25537ZM7.33398 12.3218C7.13135 12.9077 6.99463 13.5034 6.92871 14.0942L8.16895 14.231C8.2251 13.7354 8.34228 13.23 8.51562 12.7344L7.33398 12.3218ZM8.17139 15.7715L6.92871 15.9106C6.99707 16.5039 7.13379 17.0996 7.33887 17.6855L8.51807 17.2705C8.34473 16.7749 8.22754 16.272 8.17139 15.7715ZM9.18457 18.6572L8.12988 19.3237C8.46436 19.8535 8.84277 20.3345 9.25781 20.7495L10.1416 19.8633C9.79248 19.5142 9.47021 19.1089 9.18457 18.6572ZM11.3501 20.8203L10.6836 21.875C11.1987 22.1997 11.748 22.4634 12.3242 22.666L12.7344 21.4844C12.2485 21.3159 11.7822 21.0913 11.3501 20.8203Z",
                fill: "white"
            })
        ]
    });
};
var $2aafef214a95b89b$export$2e2bcd8739ae039 = $2aafef214a95b89b$var$Neutral;



parcelRequire("7fPBF");
const $00b06808ce60155b$var$AwesomeIcon = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                fill: "#1ABC9C"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M13.9844 7.5L11.4844 12.5H7.5V22.5H19.2773C20.1587 22.5 20.9277 21.8774 21.1133 21.0156L22.4609 14.7656C22.7075 13.6108 21.8042 12.5 20.625 12.5H15.7617C15.8081 12.1094 15.8179 11.7163 16.1133 10.8203C16.3037 10.2417 16.25 9.70947 16.25 9.375C16.25 8.90869 16.062 8.479 15.7422 8.125C15.4224 7.771 14.9414 7.5 14.375 7.5H13.9844ZM14.6875 8.90625C14.7266 8.93555 14.79 8.92578 14.8242 8.96484C14.9414 9.09424 15 9.27246 15 9.375C15 9.78027 15.0122 10.1587 14.9219 10.4297C14.4556 11.8433 14.375 13.0859 14.375 13.0859L14.3359 13.75H20.625C21.0376 13.75 21.3159 14.1089 21.2305 14.5117L19.9023 20.7617C19.8389 21.0547 19.5752 21.25 19.2773 21.25H12.5V13.2812L14.6875 8.90625ZM8.75 13.75H11.25V21.25H8.75V13.75ZM10 19.375C9.65576 19.375 9.375 19.6558 9.375 20C9.375 20.3442 9.65576 20.625 10 20.625C10.3442 20.625 10.625 20.3442 10.625 20C10.625 19.6558 10.3442 19.375 10 19.375Z",
                fill: "white"
            })
        ]
    });
};
var $00b06808ce60155b$export$2e2bcd8739ae039 = $00b06808ce60155b$var$AwesomeIcon;



parcelRequire("7fPBF");
const $c2bc9e2d5476054a$var$ObjectivesDrawerIcon = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                opacity: "0.3",
                d: "M10 3.33337C6.33337 3.33337 3.33337 6.33337 3.33337 10C3.33337 13.6667 6.33337 16.6667 10 16.6667C13.6667 16.6667 16.6667 13.6667 16.6667 10C16.6667 6.33337 13.6667 3.33337 10 3.33337ZM10 13.3334C8.16671 13.3334 6.66671 11.8334 6.66671 10C6.66671 8.16671 8.16671 6.66671 10 6.66671C11.8334 6.66671 13.3334 8.16671 13.3334 10C13.3334 11.8334 11.8334 13.3334 10 13.3334Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M10 17.5C5.83333 17.5 2.5 14.1667 2.5 10C2.5 5.83333 5.83333 2.5 10 2.5C14.1667 2.5 17.5 5.83333 17.5 10C17.5 14.1667 14.1667 17.5 10 17.5ZM10 4.16667C6.75 4.16667 4.16667 6.75 4.16667 10C4.16667 13.25 6.75 15.8333 10 15.8333C13.25 15.8333 15.8333 13.25 15.8333 10C15.8333 6.75 13.25 4.16667 10 4.16667Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M10 14.1667C7.66671 14.1667 5.83337 12.3334 5.83337 10C5.83337 7.66671 7.66671 5.83337 10 5.83337C12.3334 5.83337 14.1667 7.66671 14.1667 10C14.1667 12.3334 12.3334 14.1667 10 14.1667ZM10 7.50004C8.58337 7.50004 7.50004 8.58337 7.50004 10C7.50004 11.4167 8.58337 12.5 10 12.5C11.4167 12.5 12.5 11.4167 12.5 10C12.5 8.58337 11.4167 7.50004 10 7.50004Z",
                fill: "#757575"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M10 9.16671C9.77903 9.16671 9.56706 9.2545 9.41078 9.41078C9.2545 9.56706 9.16671 9.77903 9.16671 10C9.16671 10.2211 9.2545 10.433 9.41078 10.5893C9.56706 10.7456 9.77903 10.8334 10 10.8334C10.2211 10.8334 10.433 10.7456 10.5893 10.5893C10.7456 10.433 10.8334 10.2211 10.8334 10C10.8334 9.77903 10.7456 9.56706 10.5893 9.41078C10.433 9.2545 10.2211 9.16671 10 9.16671ZM9.16671 0.833374H10.8334V7.50004H9.16671V0.833374ZM13.3334 9.16671H19.1667V10.8334H13.3334V9.16671ZM9.16671 13.3334H10.8334V19.1667H9.16671V13.3334ZM0.833374 9.16671H6.66671V10.8334H0.833374V9.16671Z",
                fill: "#757575"
            })
        ]
    });
};
var $c2bc9e2d5476054a$export$2e2bcd8739ae039 = $c2bc9e2d5476054a$var$ObjectivesDrawerIcon;



parcelRequire("7fPBF");
const $cddda03f7a4afb68$var$ProjectsDrawerIcon = ()=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                clipPath: "url(#clip0_1806_1442)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M18.455 16.7884L16.7884 18.455L12.5 14.1667V12.5H14.1667L18.455 16.7884ZM19.8784 18.2117L19.045 17.3784L17.3784 19.045L18.2117 19.8784C18.3742 20.0409 18.6384 20.0409 18.8009 19.8784L19.8784 18.8009C20.0409 18.6375 20.0409 18.3742 19.8784 18.2117ZM5.83337 9.16671H7.50004V10.8334H5.83337V9.16671ZM9.16671 9.16671H14.1667V10.8334H9.16671V9.16671ZM3.33337 5.83337H16.6667V7.50004H3.33337V5.83337ZM5.8333712.5H7.50004V14.1667H5.83337V12.5ZM9.16671 12.5H10.8334V14.1667H9.16671V12.5Z",
                        fill: "#757575"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M11.8092 15.8333H4.16667V4.16667H15.8333L15.8325 11.8092L17.5 13.4767V4.16667C17.5 3.24583 16.7542 2.5 15.8333 2.5H4.16667C3.24583 2.5 2.5 3.24583 2.5 4.16667V15.8333C2.5 16.7542 3.24583 17.5 4.16667 17.5H13.4758L11.8092 15.8333Z",
                        fill: "#757575"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        opacity: "0.3",
                        d: "M3.33337 3.33337H16.6667V6.66671H3.33337V3.33337Z",
                        fill: "#757575"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                    id: "clip0_1806_1442",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "#757575"
                    })
                })
            })
        ]
    });
};
var $cddda03f7a4afb68$export$2e2bcd8739ae039 = $cddda03f7a4afb68$var$ProjectsDrawerIcon;





parcelRequire("7fPBF");



var $by0pu = parcelRequire("by0pu");

var $iozeL = parcelRequire("iozeL");
var $cmHIq = parcelRequire("cmHIq");
var $k03mY = parcelRequire("k03mY");
var $1OsIT = parcelRequire("1OsIT");var $a5ee93b5b03ee854$var$teal = {
    50: '#e0f2f1',
    100: '#b2dfdb',
    200: '#80cbc4',
    300: '#4db6ac',
    400: '#26a69a',
    500: '#009688',
    600: '#00897b',
    700: '#00796b',
    800: '#00695c',
    900: '#004d40',
    A100: '#a7ffeb',
    A200: '#64ffda',
    A400: '#1de9b6',
    A700: '#00bfa5'
};
var $a5ee93b5b03ee854$export$2e2bcd8739ae039 = $a5ee93b5b03ee854$var$teal;


const $099b64aead0697bf$var$style = {
    proposed: {
        background: (0, $a5ee93b5b03ee854$export$2e2bcd8739ae039)['100']
    },
    declined: {
        background: (0, $1OsIT.default)['A200']
    },
    approved: {
        background: (0, $a5ee93b5b03ee854$export$2e2bcd8739ae039)['200']
    },
    passive: {
        background: (0, $k03mY.default)['A100']
    },
    active: {
        background: (0, $iozeL.default)['A100']
    },
    completed: {
        background: (0, $cmHIq.default)['A100']
    },
    failed: {
        background: (0, $1OsIT.default)['A100']
    },
    unknown: {
        background: (0, $k03mY.default)['A400']
    },
    button: {
        margin: '10px 10px 20px 0px'
    },
    'in-danger': {
        background: '#F48401'
    },
    neutral: {
        background: '#3498DB'
    },
    awesome: {
        background: '#1ABC9C'
    },
    chip: {
        marginLeft: '5px'
    }
};
const $099b64aead0697bf$var$useStatusStyles = (0, $by0pu.default)($099b64aead0697bf$var$style);
var $099b64aead0697bf$export$2e2bcd8739ae039 = $099b64aead0697bf$var$useStatusStyles;



const $533e17f048a24c95$var$ObjectiveStatusChip = ({ status: status = (0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS).UNKNOWN })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = (0, $099b64aead0697bf$export$2e2bcd8739ae039)();
    const upperCaseStatus = (status || '').toUpperCase();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $812a279261d3d883$export$2e2bcd8739ae039), {
        label: t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)[upperCaseStatus]),
        className: `${classes[status]} ${classes.chip}`
    });
};
var $533e17f048a24c95$export$2e2bcd8739ae039 = $533e17f048a24c95$var$ObjectiveStatusChip;



parcelRequire("7fPBF");


var $by0pu = parcelRequire("by0pu");

var $iozeL = parcelRequire("iozeL");
var $cmHIq = parcelRequire("cmHIq");
var $k03mY = parcelRequire("k03mY");


const $0254f90c357b3372$var$RatingStatusChip = ({ ratingStatus: ratingStatus })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const useStyles = (0, $by0pu.default)({
        notAvailable: {
            background: (0, $k03mY.default)[200]
        },
        inProgress: {
            background: (0, $iozeL.default)[200]
        },
        completed: {
            background: (0, $cmHIq.default)['A100']
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $812a279261d3d883$export$2e2bcd8739ae039), {
        label: t((0, $f6e729db3f817bb5$exports.RATING_CHIP_LABELS)[ratingStatus]),
        className: classes[ratingStatus]
    });
};
var $0254f90c357b3372$export$2e2bcd8739ae039 = $0254f90c357b3372$var$RatingStatusChip;



parcelRequire("7fPBF");

var $fH0xA = parcelRequire("fH0xA");
var $a227607740a9882d$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($a227607740a9882d$exports, "__esModule", {
    value: true
});
$a227607740a9882d$exports.default = void 0;

var $a227607740a9882d$var$_extends2 = $62qsu((parcelRequire("cvBp9")));

var $8SBLK = parcelRequire("8SBLK");

var $a227607740a9882d$var$_defaultTheme = $62qsu((parcelRequire("bASKz")));
function $a227607740a9882d$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $8SBLK.default)(stylesOrCreator, (0, $a227607740a9882d$var$_extends2.default)({
        defaultTheme: $a227607740a9882d$var$_defaultTheme.default
    }, options));
}
var $a227607740a9882d$var$_default = $a227607740a9882d$var$makeStyles;
$a227607740a9882d$exports.default = $a227607740a9882d$var$_default;



var $jtRae = parcelRequire("jtRae");
const $0c2549b26267da36$var$useStyles = (0, (/*@__PURE__*/$parcel$interopDefault($a227607740a9882d$exports)))({
    root: {
        fontSize: 13
    },
    title: {
        fontSize: 12,
        color: '#999999',
        textTransform: 'uppercase',
        '&$normalPadding': {
            paddingBottom: 8
        }
    },
    normalPadding: {}
}, {
    name: 'DataDisplay'
});
/**
 * Component for showing data.
 *
 * @param  {JSXElement} children   Data to be displayed
 * @param  {string} area   String passed to gridArea style, to handle CSS grid responsiveness
 * @param  {JSXElement} title   Element that will be used as title for the data
 * @param  {"dense" | "normal"} titlePadding   Element that will be used as title for the data
 * @param  {boolean} responsive   Set it to false to always display title.
 * @param  {string} dataClassName   String passed to style child elements via material-ui style.
 */ const $0c2549b26267da36$var$DataDisplay = ({ children: children, area: area, title: title, titlePadding: titlePadding = 'dense', responsive: responsive = true, dataClassName: dataClassName = '' })=>{
    const classes = $0c2549b26267da36$var$useStyles();
    const theme = (0, $fH0xA.default)();
    const md = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('md'));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            gridArea: area
        },
        className: classes.root,
        children: title && (responsive && !md || !responsive) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
            container: true,
            direction: 'column',
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    className: (0, $jtRae.default)(classes.title, {
                        [classes.normalPadding]: titlePadding === 'normal'
                    }),
                    children: title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    className: dataClassName,
                    item: true,
                    children: children
                })
            ]
        }) : children
    });
};
var $0c2549b26267da36$export$2e2bcd8739ae039 = $0c2549b26267da36$var$DataDisplay;


var $c27ce68cd269a7c9$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($c27ce68cd269a7c9$exports, "__esModule", {
    value: true
});
$c27ce68cd269a7c9$exports.default = void 0;

var $c27ce68cd269a7c9$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $c27ce68cd269a7c9$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $c27ce68cd269a7c9$var$_default = (0, $c27ce68cd269a7c9$var$_createSvgIcon.default)(/*#__PURE__*/ $c27ce68cd269a7c9$var$React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
$c27ce68cd269a7c9$exports.default = $c27ce68cd269a7c9$var$_default;


const $b2f2a6ac7fc7de65$var$useStyles = (0, $by0pu.default)((theme)=>({
        itemHeader: {
            display: 'grid',
            width: '100%',
            gridGap: 8,
            alignItems: 'center',
            gridTemplateColumns: '1fr 1fr 1fr 1fr',
            gridTemplateAreas: `
      'name     name     actions  actions'
      'divider1 divider1 divider1   divider1'
      'category deadline weight     mean'
      'divider2 divider2 divider2   divider2'
      'status   status   rating     rating'
      `,
            [theme.breakpoints.up('md')]: {
                gridTemplateColumns: '1fr 1fr 75px 65px 1fr 1fr 65px 96px',
                gridTemplateAreas: `
        'name category deadline weight status rating mean actions'
      `
            }
        },
        actions: {
            marginLeft: 'auto'
        },
        groupColumns: {
            gridTemplateColumns: '1fr 1fr 1fr 1fr',
            gridTemplateAreas: `
      'name     name     actions    actions'
      'divider1 divider1 divider1   divider1'
      'category deadline weight     mean'
      'divider2 divider2 divider2   divider2'
      'status   status   rating     rating'
      'divider3 divider3 divider3   divider3'
      'group    group    appraiser  appraiser'
      `,
            [theme.breakpoints.up('md')]: {
                gridTemplateColumns: '1fr 1fr 1fr 1fr 75px 65px 1fr 1fr 65px 96px',
                gridTemplateAreas: `
        'name category group appraiser deadline weight status rating mean actions'
      `
            }
        },
        tooltip: {
            fontSize: '12px'
        }
    }), {
    name: 'ObjectiveSummary'
});
const $b2f2a6ac7fc7de65$var$ObjectiveSummary = ({ isPanelOpened: isPanelOpened, objective: objective, setUpdateDialogOpen: setUpdateDialogOpen, setDeleteDialogOpen: setDeleteDialogOpen, isEditable: isEditable, isDeletable: isDeletable, responsiveItems: responsiveItems = true })=>{
    var _objective_appraisers_and_criterias, _objective_owner_, _objective_owner_1, _objective_appraisers_and_criterias_appraisers_, _objective_appraisers_and_criterias1;
    (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn))).locale('hu');
    const classes = $b2f2a6ac7fc7de65$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $fH0xA.default)();
    const md = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('md'));
    const { IN_DANGER: IN_DANGER, NEUTRAL: NEUTRAL, AWESOME: AWESOME } = (0, $f6e729db3f817bb5$exports.DEVELOPMENT_STATUS);
    const { PROPOSED: PROPOSED, FAILED: FAILED, ACTIVE: ACTIVE, COMPLETED: COMPLETED } = (0, $f6e729db3f817bb5$exports.STATUS);
    const [actionsOpen, setActionsOpen] = (0, $7fPBF.useState)(null);
    const developmentStatusTitle = (developmentStatus)=>{
        switch(developmentStatus){
            case IN_DANGER:
                return t('objective.development.status.in-danger-title');
            case NEUTRAL:
                return t('objective.development.status.neutral-title');
            case AWESOME:
                return t('objective.development.status.awesome-title');
            default:
                return t('objective.development.status.neutral-title');
        }
    };
    const renderIconWithTooltip = (Icon, developmentStatus)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
            classes: {
                tooltip: classes.tooltip
            },
            placement: "top",
            title: developmentStatusTitle(developmentStatus),
            arrow: true,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Icon, {})
            })
        });
    const renderStatusIcon = (status, developmentStatus)=>{
        switch(status){
            case PROPOSED:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f56e76a36f11ab96$export$2e2bcd8739ae039), {});
            case FAILED:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75f241977272c280$export$2e2bcd8739ae039), {});
            case ACTIVE:
                switch(developmentStatus){
                    case IN_DANGER:
                        return renderIconWithTooltip((0, $95312bc65bca7ffd$export$2e2bcd8739ae039), developmentStatus);
                    case NEUTRAL:
                        return renderIconWithTooltip((0, $2aafef214a95b89b$export$2e2bcd8739ae039), developmentStatus);
                    case AWESOME:
                        return renderIconWithTooltip((0, $00b06808ce60155b$export$2e2bcd8739ae039), developmentStatus);
                    default:
                        return renderIconWithTooltip((0, $2aafef214a95b89b$export$2e2bcd8739ae039), developmentStatus);
                }
            case COMPLETED:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5ffeda3aff46a7df$export$2e2bcd8739ae039), {});
            default:
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f56e76a36f11ab96$export$2e2bcd8739ae039), {});
        }
    };
    let mean = '-';
    if ((0, $2409c916ecc098c0$export$d25ab5c0afe207fe)(objective === null || objective === void 0 ? void 0 : (_objective_appraisers_and_criterias = objective.appraisers_and_criterias) === null || _objective_appraisers_and_criterias === void 0 ? void 0 : _objective_appraisers_and_criterias.appraisers) && (objective.ratingsData.weightedMean || objective.ratingsData.weightedMean === 0)) mean = `${objective.ratingsData.weightedMean.toFixed(2)}%`;
    const isGroupObjective = ((_objective_owner_ = objective.owner[0]) === null || _objective_owner_ === void 0 ? void 0 : _objective_owner_.type) === (0, $f6e729db3f817bb5$exports.OWNER_TYPES).GROUP;
    const editButton = isEditable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
        onClick: (e)=>{
            e.stopPropagation();
            setActionsOpen(false);
            setUpdateDialogOpen(true);
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($48e5e77420a99f06$exports))), {})
    });
    const deleteButton = isDeletable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
        onClick: (e)=>{
            e.stopPropagation();
            setActionsOpen(false);
            setDeleteDialogOpen(true);
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c27ce68cd269a7c9$exports))), {})
    });
    var _objective_category, _objective_owner__name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, $jtRae.default)(classes.itemHeader, {
            [classes.groupColumns]: isGroupObjective
        }),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                area: 'name',
                title: t('objectiveList.header.name'),
                responsive: responsiveItems,
                children: objective.name
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                area: 'category',
                title: t('objectiveList.header.category'),
                responsive: responsiveItems,
                children: (_objective_category = objective.category) !== null && _objective_category !== void 0 ? _objective_category : '-'
            }),
            isGroupObjective && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                        area: 'group',
                        title: t('objectiveList.header.group'),
                        responsive: responsiveItems,
                        children: (_objective_owner__name = (_objective_owner_1 = objective.owner[0]) === null || _objective_owner_1 === void 0 ? void 0 : _objective_owner_1.name) !== null && _objective_owner__name !== void 0 ? _objective_owner__name : '-'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                        area: 'appraiser',
                        title: t('objectiveList.header.appraiser'),
                        responsive: responsiveItems,
                        children: (_objective_appraisers_and_criterias1 = objective.appraisers_and_criterias) === null || _objective_appraisers_and_criterias1 === void 0 ? void 0 : (_objective_appraisers_and_criterias_appraisers_ = _objective_appraisers_and_criterias1.appraisers[0]) === null || _objective_appraisers_and_criterias_appraisers_ === void 0 ? void 0 : _objective_appraisers_and_criterias_appraisers_.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                area: 'deadline',
                title: t('objectiveList.header.deadline'),
                responsive: responsiveItems,
                children: (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(objective.deadline).format('L')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                area: 'weight',
                title: t('objectiveList.header.weight'),
                responsive: responsiveItems,
                children: objective.weight
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                area: 'status',
                title: t('objectiveList.header.status'),
                responsive: responsiveItems,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d57f8c5132119daf$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        renderStatusIcon(objective.status, objective.development_status),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $533e17f048a24c95$export$2e2bcd8739ae039), {
                            status: objective.status
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                area: 'rating',
                title: t('objectiveList.header.rating'),
                responsive: responsiveItems,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0254f90c357b3372$export$2e2bcd8739ae039), {
                    ratingStatus: objective.ratingStatus
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c2549b26267da36$export$2e2bcd8739ae039), {
                area: 'mean',
                title: t('objectiveList.header.result'),
                responsive: responsiveItems,
                children: mean
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    gridArea: 'actions'
                },
                className: classes.actions,
                children: [
                    editButton && deleteButton ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setActionsOpen(e.currentTarget);
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4b2a35faf1cd861$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9zU0q.default), {
                                open: !!actionsOpen,
                                anchorEl: actionsOpen,
                                onClose: ()=>setActionsOpen(false),
                                children: [
                                    editButton,
                                    deleteButton
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            editButton,
                            deleteButton
                        ]
                    }),
                    isPanelOpened !== undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                        size: md ? 'medium' : 'small',
                        children: isPanelOpened ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34df12d346b1bb0d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f86ebe7fc4425398$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            !md && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            gridArea: 'divider1'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            gridArea: 'divider2'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {})
                    }),
                    isGroupObjective && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            gridArea: 'divider3'
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $b2f2a6ac7fc7de65$export$2e2bcd8739ae039 = $b2f2a6ac7fc7de65$var$ObjectiveSummary;




var $7fPBF = parcelRequire("7fPBF");


var $jaezp = parcelRequire("jaezp");
var $by0pu = parcelRequire("by0pu");
var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $gd1Bg = parcelRequire("gd1Bg");

var $dKzJP = parcelRequire("dKzJP");

var $df0b4c29990e52e3$export$9dd6ff9ea0189349 = function styles(theme) {
    var _extends2;
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({}, theme.typography.button, (_extends2 = {
            maxWidth: 264,
            minWidth: 72,
            position: 'relative',
            boxSizing: 'border-box',
            minHeight: 48,
            flexShrink: 0,
            padding: '6px 12px'
        }, (0, $dQMrF.default)(_extends2, theme.breakpoints.up('sm'), {
            padding: '6px 24px'
        }), (0, $dQMrF.default)(_extends2, "overflow", 'hidden'), (0, $dQMrF.default)(_extends2, "whiteSpace", 'normal'), (0, $dQMrF.default)(_extends2, "textAlign", 'center'), (0, $dQMrF.default)(_extends2, theme.breakpoints.up('sm'), {
            minWidth: 160
        }), _extends2)),
        /* Styles applied to the root element if both `icon` and `label` are provided. */ labelIcon: {
            minHeight: 72,
            paddingTop: 9,
            '& $wrapper > *:first-child': {
                marginBottom: 6
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */ textColorInherit: {
            color: 'inherit',
            opacity: 0.7,
            '&$selected': {
                opacity: 1
            },
            '&$disabled': {
                opacity: 0.5
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */ textColorPrimary: {
            color: theme.palette.text.secondary,
            '&$selected': {
                color: theme.palette.primary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */ textColorSecondary: {
            color: theme.palette.text.secondary,
            '&$selected': {
                color: theme.palette.secondary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */ selected: {},
        /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */ disabled: {},
        /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */ fullWidth: {
            flexShrink: 1,
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: 'none'
        },
        /* Styles applied to the root element if `wrapped={true}`. */ wrapped: {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.5
        },
        /* Styles applied to the `icon` and `label`'s wrapper element. */ wrapper: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            flexDirection: 'column'
        }
    };
};
var $df0b4c29990e52e3$var$Tab = /*#__PURE__*/ $7fPBF.forwardRef(function Tab(props, ref) {
    var classes = props.classes, className = props.className, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, fullWidth = props.fullWidth, icon = props.icon, indicator = props.indicator, label = props.label, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, selected = props.selected, selectionFollowsFocus = props.selectionFollowsFocus, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor, value = props.value, _props$wrapped = props.wrapped, wrapped = _props$wrapped === void 0 ? false : _props$wrapped, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "disabled",
        "disableFocusRipple",
        "fullWidth",
        "icon",
        "indicator",
        "label",
        "onChange",
        "onClick",
        "onFocus",
        "selected",
        "selectionFollowsFocus",
        "textColor",
        "value",
        "wrapped"
    ]);
    var handleClick = function handleClick(event) {
        if (onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    var handleFocus = function handleFocus(event) {
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $gd1Bg.default), (0, $kY3Ke.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $jtRae.default)(classes.root, classes["textColor".concat((0, $dKzJP.default)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        tabIndex: selected ? 0 : -1
    }, other), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.wrapper
    }, icon, label), indicator);
});
var $df0b4c29990e52e3$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($df0b4c29990e52e3$export$9dd6ff9ea0189349, {
    name: 'MuiTab'
})($df0b4c29990e52e3$var$Tab);


var $fH0xA = parcelRequire("fH0xA");
var $3Sc7z = parcelRequire("3Sc7z");

var $7fPBF = parcelRequire("7fPBF");

/**
 * @type {React.Context<{ idPrefix: string; value: string } | null>}
 */ var $1ff24193d7f3d742$var$Context = $7fPBF.createContext(null);
function $1ff24193d7f3d742$var$useUniquePrefix() {
    var _React$useState = $7fPBF.useState(null), id = _React$useState[0], setId = _React$useState[1];
    $7fPBF.useEffect(function() {
        setId("mui-p-".concat(Math.round(Math.random() * 1e5)));
    }, []);
    return id;
}
function $1ff24193d7f3d742$export$2e2bcd8739ae039(props) {
    var children = props.children, value = props.value;
    var idPrefix = $1ff24193d7f3d742$var$useUniquePrefix();
    var context = $7fPBF.useMemo(function() {
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($1ff24193d7f3d742$var$Context.Provider, {
        value: context
    }, children);
}
function $1ff24193d7f3d742$export$5a3bad273ac578e0() {
    return $7fPBF.useContext($1ff24193d7f3d742$var$Context);
}
function $1ff24193d7f3d742$export$629f80328afcade5(context, value) {
    var idPrefix = context.idPrefix;
    if (idPrefix === null) return null;
    return "".concat(context.idPrefix, "-P-").concat(value);
}
function $1ff24193d7f3d742$export$46f6d19d28231cb8(context, value) {
    var idPrefix = context.idPrefix;
    if (idPrefix === null) return null;
    return "".concat(context.idPrefix, "-T-").concat(value);
}


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $jtRae = parcelRequire("jtRae");


var $kyQ4S = parcelRequire("kyQ4S");

var $bSzdr = parcelRequire("bSzdr");
// Source from https://github.com/alitaheri/normalize-scroll-left
var $8856db2fe6e6beb6$var$cachedType;
function $8856db2fe6e6beb6$export$a10970ffb6510128() {
    if ($8856db2fe6e6beb6$var$cachedType) return $8856db2fe6e6beb6$var$cachedType;
    var dummy = document.createElement('div');
    var container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $8856db2fe6e6beb6$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $8856db2fe6e6beb6$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $8856db2fe6e6beb6$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $8856db2fe6e6beb6$var$cachedType;
} // Based on https://stackoverflow.com/a/24394376
function $8856db2fe6e6beb6$export$3c615b88e5d7e4f6(element, direction) {
    var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') return scrollLeft;
    var type = $8856db2fe6e6beb6$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $5cf507b3690dd422$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $5cf507b3690dd422$export$2e2bcd8739ae039(property, element, to) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function() {};
    var _options$ease = options.ease, ease = _options$ease === void 0 ? $5cf507b3690dd422$var$easeInOutSin : _options$ease, _options$duration = options.duration, duration = _options$duration === void 0 ? 300 : _options$duration;
    var start = null;
    var from = element[property];
    var cancelled = false;
    var cancel = function cancel() {
        cancelled = true;
    };
    var step = function step(timestamp) {
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        var time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(function() {
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $kyQ4S = parcelRequire("kyQ4S");
var $bd215851cfe92ed4$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $bd215851cfe92ed4$export$2e2bcd8739ae039(props) {
    var onChange = props.onChange, other = (0, $lfiYO.default)(props, [
        "onChange"
    ]);
    var scrollbarHeight = $7fPBF.useRef();
    var nodeRef = $7fPBF.useRef(null);
    var setMeasurements = function setMeasurements() {
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    $7fPBF.useEffect(function() {
        var handleResize = (0, $kyQ4S.default)(function() {
            var prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $7fPBF.useEffect(function() {
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        style: $bd215851cfe92ed4$var$styles,
        ref: nodeRef
    }, other));
}



var $3Sc7z = parcelRequire("3Sc7z");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $c2f8e642a07d0541$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: 'absolute',
            height: 2,
            bottom: 0,
            width: '100%',
            transition: theme.transitions.create()
        },
        colorPrimary: {
            backgroundColor: theme.palette.primary.main
        },
        colorSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        vertical: {
            height: '100%',
            width: 2,
            right: 0
        }
    };
};
/**
 * @ignore - internal component.
 */ var $c2f8e642a07d0541$var$TabIndicator = /*#__PURE__*/ $7fPBF.forwardRef(function TabIndicator(props, ref) {
    var classes = props.classes, className = props.className, color = props.color, orientation = props.orientation, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "color",
        "orientation"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("span", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes["color".concat((0, $dKzJP.default)(color))], className, orientation === 'vertical' && classes.vertical),
        ref: ref
    }, other));
});
var $c2f8e642a07d0541$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($c2f8e642a07d0541$export$9dd6ff9ea0189349, {
    name: 'PrivateTabIndicator'
})($c2f8e642a07d0541$var$TabIndicator);



var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $fppyJ = parcelRequire("fppyJ");

var $kxFei = parcelRequire("kxFei");

var $3Sc7z = parcelRequire("3Sc7z");

var $gd1Bg = parcelRequire("gd1Bg");
var $fd54430ddcc03a27$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        '&$disabled': {
            opacity: 0
        }
    },
    /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
        width: '100%',
        height: 40,
        '& svg': {
            transform: 'rotate(90deg)'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {}
};
var $fd54430ddcc03a27$var$_ref = /*#__PURE__*/ $7fPBF.createElement((0, $fppyJ.default), {
    fontSize: "small"
});
var $fd54430ddcc03a27$var$_ref2 = /*#__PURE__*/ $7fPBF.createElement((0, $kxFei.default), {
    fontSize: "small"
});
var $fd54430ddcc03a27$var$TabScrollButton = /*#__PURE__*/ $7fPBF.forwardRef(function TabScrollButton(props, ref) {
    var classes = props.classes, classNameProp = props.className, direction = props.direction, orientation = props.orientation, disabled = props.disabled, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "direction",
        "orientation",
        "disabled"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $gd1Bg.default), (0, $kY3Ke.default)({
        component: "div",
        className: (0, $jtRae.default)(classes.root, classNameProp, disabled && classes.disabled, orientation === 'vertical' && classes.vertical),
        ref: ref,
        role: null,
        tabIndex: null
    }, other), direction === 'left' ? $fd54430ddcc03a27$var$_ref : $fd54430ddcc03a27$var$_ref2);
});
var $fd54430ddcc03a27$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($fd54430ddcc03a27$export$9dd6ff9ea0189349, {
    name: 'MuiTabScrollButton'
})($fd54430ddcc03a27$var$TabScrollButton);



var $1sMi9 = parcelRequire("1sMi9");

var $fH0xA = parcelRequire("fH0xA");
var $9879aa3caa4864e2$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            minHeight: 48,
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            display: 'flex'
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            flexDirection: 'column'
        },
        /* Styles applied to the flex container element. */ flexContainer: {
            display: 'flex'
        },
        /* Styles applied to the flex container element if `orientation="vertical"`. */ flexContainerVertical: {
            flexDirection: 'column'
        },
        /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */ centered: {
            justifyContent: 'center'
        },
        /* Styles applied to the tablist element. */ scroller: {
            position: 'relative',
            display: 'inline-block',
            flex: '1 1 auto',
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the tablist element if `!variant="scrollable"`. */ fixed: {
            overflowX: 'hidden',
            width: '100%'
        },
        /* Styles applied to the tablist element if `variant="scrollable"`. */ scrollable: {
            overflowX: 'scroll',
            // Hide dimensionless scrollbar on MacOS
            scrollbarWidth: 'none',
            // Firefox
            '&::-webkit-scrollbar': {
                display: 'none' // Safari + Chrome
            }
        },
        /* Styles applied to the `ScrollButtonComponent` component. */ scrollButtons: {},
        /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */ scrollButtonsDesktop: (0, $dQMrF.default)({}, theme.breakpoints.down('xs'), {
            display: 'none'
        }),
        /* Styles applied to the `TabIndicator` component. */ indicator: {}
    };
};
var $9879aa3caa4864e2$var$Tabs = /*#__PURE__*/ $7fPBF.forwardRef(function Tabs(props, ref) {
    var ariaLabel = props['aria-label'], ariaLabelledBy = props['aria-labelledby'], action = props.action, _props$centered = props.centered, centered = _props$centered === void 0 ? false : _props$centered, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$indicatorColor = props.indicatorColor, indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor, onChange = props.onChange, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$ScrollButtonCo = props.ScrollButtonComponent, ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? (0, $fd54430ddcc03a27$export$2e2bcd8739ae039) : _props$ScrollButtonCo, _props$scrollButtons = props.scrollButtons, scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons, selectionFollowsFocus = props.selectionFollowsFocus, _props$TabIndicatorPr = props.TabIndicatorProps, TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr, TabScrollButtonProps = props.TabScrollButtonProps, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $lfiYO.default)(props, [
        "aria-label",
        "aria-labelledby",
        "action",
        "centered",
        "children",
        "classes",
        "className",
        "component",
        "indicatorColor",
        "onChange",
        "orientation",
        "ScrollButtonComponent",
        "scrollButtons",
        "selectionFollowsFocus",
        "TabIndicatorProps",
        "TabScrollButtonProps",
        "textColor",
        "value",
        "variant"
    ]);
    var theme = (0, $fH0xA.default)();
    var scrollable = variant === 'scrollable';
    var isRtl = theme.direction === 'rtl';
    var vertical = orientation === 'vertical';
    var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    var start = vertical ? 'top' : 'left';
    var end = vertical ? 'bottom' : 'right';
    var clientSize = vertical ? 'clientHeight' : 'clientWidth';
    var size = vertical ? 'height' : 'width';
    var _React$useState = $7fPBF.useState(false), mounted = _React$useState[0], setMounted = _React$useState[1];
    var _React$useState2 = $7fPBF.useState({}), indicatorStyle = _React$useState2[0], setIndicatorStyle = _React$useState2[1];
    var _React$useState3 = $7fPBF.useState({
        start: false,
        end: false
    }), displayScroll = _React$useState3[0], setDisplayScroll = _React$useState3[1];
    var _React$useState4 = $7fPBF.useState({
        overflow: 'hidden',
        marginBottom: null
    }), scrollerStyle = _React$useState4[0], setScrollerStyle = _React$useState4[1];
    var valueToIndex = new Map();
    var tabsRef = $7fPBF.useRef(null);
    var tabListRef = $7fPBF.useRef(null);
    var getTabsMeta = function getTabsMeta() {
        var tabsNode = tabsRef.current;
        var tabsMeta;
        if (tabsNode) {
            var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $8856db2fe6e6beb6$export$3c615b88e5d7e4f6)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        var tabMeta;
        if (tabsNode && value !== false) {
            var _children = tabListRef.current.children;
            if (_children.length > 0) {
                var tab = _children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    var updateIndicatorState = (0, $1sMi9.default)(function() {
        var _newIndicatorStyle;
        var _getTabsMeta = getTabsMeta(), tabsMeta = _getTabsMeta.tabsMeta, tabMeta = _getTabsMeta.tabMeta;
        var startValue = 0;
        if (tabMeta && tabsMeta) {
            if (vertical) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
            else {
                var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = tabMeta.left - tabsMeta.left + correction;
            }
        }
        var newIndicatorStyle = (_newIndicatorStyle = {}, (0, $dQMrF.default)(_newIndicatorStyle, start, startValue), (0, $dQMrF.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
        if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
            var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    var scroll = function scroll(scrollValue) {
        (0, $5cf507b3690dd422$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue);
    };
    var moveTabsScroll = function moveTabsScroll(delta) {
        var scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
            scrollValue *= isRtl && (0, $8856db2fe6e6beb6$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    var handleStartScrollClick = function handleStartScrollClick() {
        moveTabsScroll(-tabsRef.current[clientSize]);
    };
    var handleEndScrollClick = function handleEndScrollClick() {
        moveTabsScroll(tabsRef.current[clientSize]);
    };
    var handleScrollbarSizeChange = $7fPBF.useCallback(function(scrollbarHeight) {
        setScrollerStyle({
            overflow: null,
            marginBottom: -scrollbarHeight
        });
    }, []);
    var getConditionalElements = function getConditionalElements() {
        var conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ $7fPBF.createElement((0, $bd215851cfe92ed4$export$2e2bcd8739ae039), {
            className: classes.scrollable,
            onChange: handleScrollbarSizeChange
        }) : null;
        var scrollButtonsActive = displayScroll.start || displayScroll.end;
        var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ $7fPBF.createElement(ScrollButtonComponent, (0, $kY3Ke.default)({
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayScroll.start,
            className: (0, $jtRae.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
        }, TabScrollButtonProps)) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ $7fPBF.createElement(ScrollButtonComponent, (0, $kY3Ke.default)({
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayScroll.end,
            className: (0, $jtRae.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
        }, TabScrollButtonProps)) : null;
        return conditionalElements;
    };
    var scrollSelectedIntoView = (0, $1sMi9.default)(function() {
        var _getTabsMeta2 = getTabsMeta(), tabsMeta = _getTabsMeta2.tabsMeta, tabMeta = _getTabsMeta2.tabMeta;
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart);
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(_nextScrollStart);
        }
    });
    var updateScrollButtonState = (0, $1sMi9.default)(function() {
        if (scrollable && scrollButtons !== 'off') {
            var _tabsRef$current = tabsRef.current, scrollTop = _tabsRef$current.scrollTop, scrollHeight = _tabsRef$current.scrollHeight, clientHeight = _tabsRef$current.clientHeight, scrollWidth = _tabsRef$current.scrollWidth, clientWidth = _tabsRef$current.clientWidth;
            var showStartScroll;
            var showEndScroll;
            if (vertical) {
                showStartScroll = scrollTop > 1;
                showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
            } else {
                var scrollLeft = (0, $8856db2fe6e6beb6$export$3c615b88e5d7e4f6)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
                showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
                showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
            }
            if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) setDisplayScroll({
                start: showStartScroll,
                end: showEndScroll
            });
        }
    });
    $7fPBF.useEffect(function() {
        var handleResize = (0, $kyQ4S.default)(function() {
            updateIndicatorState();
            updateScrollButtonState();
        });
        var win = (0, $bSzdr.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    var handleTabsScroll = $7fPBF.useCallback((0, $kyQ4S.default)(function() {
        updateScrollButtonState();
    }));
    $7fPBF.useEffect(function() {
        return function() {
            handleTabsScroll.clear();
        };
    }, [
        handleTabsScroll
    ]);
    $7fPBF.useEffect(function() {
        setMounted(true);
    }, []);
    $7fPBF.useEffect(function() {
        updateIndicatorState();
        updateScrollButtonState();
    });
    $7fPBF.useEffect(function() {
        scrollSelectedIntoView();
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $7fPBF.useImperativeHandle(action, function() {
        return {
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    var indicator = /*#__PURE__*/ $7fPBF.createElement((0, $c2f8e642a07d0541$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        className: classes.indicator,
        orientation: orientation,
        color: indicatorColor
    }, TabIndicatorProps, {
        style: (0, $kY3Ke.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    var childIndex = 0;
    var children = $7fPBF.Children.map(childrenProp, function(child) {
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        var childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        var selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        });
    });
    var handleKeyDown = function handleKeyDown(event) {
        var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        var role = target.getAttribute('role');
        if (role !== 'tab') return;
        var newFocusTarget = null;
        var previousItemKey = orientation !== "vertical" ? 'ArrowLeft' : 'ArrowUp';
        var nextItemKey = orientation !== "vertical" ? 'ArrowRight' : 'ArrowDown';
        if (orientation !== "vertical" && theme.direction === 'rtl') {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
                break;
            case nextItemKey:
                newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
                break;
            case 'Home':
                newFocusTarget = tabListRef.current.firstChild;
                break;
            case 'End':
                newFocusTarget = tabListRef.current.lastChild;
                break;
            default:
                break;
        }
        if (newFocusTarget !== null) {
            newFocusTarget.focus();
            event.preventDefault();
        }
    };
    var conditionalElements = getConditionalElements();
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, vertical && classes.vertical),
        ref: ref
    }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $jtRae.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
        style: scrollerStyle,
        ref: tabsRef,
        onScroll: handleTabsScroll
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        className: (0, $jtRae.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
        onKeyDown: handleKeyDown,
        ref: tabListRef,
        role: "tablist"
    }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
var $9879aa3caa4864e2$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($9879aa3caa4864e2$export$9dd6ff9ea0189349, {
    name: 'MuiTabs'
})($9879aa3caa4864e2$var$Tabs);



var $9a2e81678754347d$var$TabList = /*#__PURE__*/ $7fPBF.forwardRef(function TabList(props, ref) {
    var childrenProp = props.children, other = (0, $lfiYO.default)(props, [
        "children"
    ]);
    var context = (0, $1ff24193d7f3d742$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    var children = $7fPBF.Children.map(childrenProp, function(child) {
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            'aria-controls': (0, $1ff24193d7f3d742$export$629f80328afcade5)(context, child.props.value),
            id: (0, $1ff24193d7f3d742$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ $7fPBF.createElement((0, $9879aa3caa4864e2$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, other, {
        ref: ref,
        value: context.value
    }), children);
});
var $9a2e81678754347d$export$2e2bcd8739ae039 = $9a2e81678754347d$var$TabList;


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $784882aa81ed5c1f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            padding: theme.spacing(3)
        }
    };
};
var $784882aa81ed5c1f$var$TabPanel = /*#__PURE__*/ $7fPBF.forwardRef(function TabPanel(props, ref) {
    var children = props.children, className = props.className, classes = props.classes, value = props.value, other = (0, $lfiYO.default)(props, [
        "children",
        "className",
        "classes",
        "value"
    ]);
    var context = (0, $1ff24193d7f3d742$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    var id = (0, $1ff24193d7f3d742$export$629f80328afcade5)(context, value);
    var tabId = (0, $1ff24193d7f3d742$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        "aria-labelledby": tabId,
        className: (0, $jtRae.default)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel"
    }, other), value === context.value && children);
});
var $784882aa81ed5c1f$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($784882aa81ed5c1f$export$9dd6ff9ea0189349, {
    name: 'MuiTabPanel'
})($784882aa81ed5c1f$var$TabPanel);






var $7fPBF = parcelRequire("7fPBF");



var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");





const $0bc299533abf3517$export$1c173c26d5727dfa = ({ objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objective/${objectiveId}/objectivesRates`);
const $0bc299533abf3517$export$b80954554c64aa5e = ({ objectiveRate: objectiveRate })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(`/objectivesRates`, objectiveRate);
const $0bc299533abf3517$export$d694a9efe5589cf = ({ objectiveRate: objectiveRate })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`/objectivesRates/${objectiveRate.id}`, objectiveRate);
const $0bc299533abf3517$export$3f29b9112c52725a = ({ objective: objective })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`/objectives/${objective.id}/ratingLock`, objective);



parcelRequire("7fPBF");


var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");

parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");


const $d844f8024dfda82d$var$StatusButton = ({ status: status, label: label, handleOnClick: handleOnClick, disabled: disabled = false })=>{
    const classes = (0, $099b64aead0697bf$export$2e2bcd8739ae039)();
    const setStatusOrOpenModelValue = status === (0, $f6e729db3f817bb5$exports.STATUS).COMPLETED || status === (0, $f6e729db3f817bb5$exports.STATUS).FAILED ? !!status : status;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
        variant: "contained",
        className: `${classes[status]} ${classes.button}`,
        name: status,
        onClick: ()=>handleOnClick(setStatusOrOpenModelValue),
        disabled: disabled,
        children: label
    }, status);
};
var $d844f8024dfda82d$export$2e2bcd8739ae039 = $d844f8024dfda82d$var$StatusButton;



const $443024259dfe5e8a$var$StatusPanel = ({ status: status, handleChange: handleChange, setCloseObjectiveDialogOpen: setCloseObjectiveDialogOpen, proposedByUser: proposedByUser = false, setCompletedObjectiveDialogOpen: setCompletedObjectiveDialogOpen, reachLimitOfActiveObjectives: reachLimitOfActiveObjectives })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const useStyles = (0, $by0pu.default)((theme)=>({
            moreThanTwoButton: {
                [theme.breakpoints.down('xs')]: {
                    display: 'flex',
                    maxWidth: '315px',
                    marginLeft: '-20px'
                }
            }
        }));
    const classes = useStyles();
    const { PROPOSED: PROPOSED, DECLINED: DECLINED, PASSIVE: PASSIVE, ACTIVE: ACTIVE, COMPLETED: COMPLETED, FAILED: FAILED } = (0, $f6e729db3f817bb5$exports.STATUS);
    switch(status){
        case PROPOSED:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: !proposedByUser ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                            label: t('objective.setStatus.approve'),
                            // if user approve the objective -> the status has change to passive
                            status: PASSIVE,
                            handleOnClick: handleChange
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                            label: t('objective.setStatus.decline'),
                            status: DECLINED,
                            handleOnClick: handleChange
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                    variant: 'body1',
                    component: 'span',
                    children: t('objective.setStatus.waitingForApproveOrDecline')
                })
            });
        case DECLINED:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                label: t('objective.setStatus.proposed'),
                status: PROPOSED,
                handleOnClick: handleChange
            });
        case PASSIVE:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                        label: t('objective.setStatus.activate'),
                        status: ACTIVE,
                        handleOnClick: handleChange,
                        disabled: reachLimitOfActiveObjectives
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                        label: t('objective.setStatus.proposed'),
                        status: PROPOSED,
                        handleOnClick: handleChange
                    })
                ]
            });
        case ACTIVE:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: classes.moreThanTwoButton,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                        label: t('objective.setStatus.completed'),
                        status: COMPLETED,
                        handleOnClick: setCompletedObjectiveDialogOpen
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                        label: t('objective.setStatus.failed'),
                        status: FAILED,
                        handleOnClick: setCloseObjectiveDialogOpen
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                        label: t('objective.setStatus.passive'),
                        status: PASSIVE,
                        handleOnClick: handleChange
                    })
                ]
            });
        case COMPLETED:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d844f8024dfda82d$export$2e2bcd8739ae039), {
                label: t('objective.setStatus.active'),
                status: (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE,
                handleOnClick: handleChange
            });
        default:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {});
    }
};
var $443024259dfe5e8a$export$2e2bcd8739ae039 = $443024259dfe5e8a$var$StatusPanel;



parcelRequire("7fPBF");


var $by0pu = parcelRequire("by0pu");
var $hzQpW = parcelRequire("hzQpW");
var $1rW9t = parcelRequire("1rW9t");


parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");


parcelRequire("7fPBF");

var $by0pu = parcelRequire("by0pu");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $ckpfM = parcelRequire("ckpfM");

var $3Sc7z = parcelRequire("3Sc7z");
var $edd72516fdfce69a$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        overflow: 'hidden'
    }
};
var $edd72516fdfce69a$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(props, ref) {
    var classes = props.classes, className = props.className, _props$raised = props.raised, raised = _props$raised === void 0 ? false : _props$raised, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "raised"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $ckpfM.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        elevation: raised ? 8 : 1,
        ref: ref
    }, other));
});
var $edd72516fdfce69a$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($edd72516fdfce69a$export$9dd6ff9ea0189349, {
    name: 'MuiCard'
})($edd72516fdfce69a$var$Card);


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");
var $8471706d6d1ef014$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        alignItems: 'center',
        padding: 8
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        '& > :not(:first-child)': {
            marginLeft: 8
        }
    }
};
var $8471706d6d1ef014$var$CardActions = /*#__PURE__*/ $7fPBF.forwardRef(function CardActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $lfiYO.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
var $8471706d6d1ef014$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($8471706d6d1ef014$export$9dd6ff9ea0189349, {
    name: 'MuiCardActions'
})($8471706d6d1ef014$var$CardActions);


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");
var $971cc648873ffa19$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    }
};
var $971cc648873ffa19$var$CardContent = /*#__PURE__*/ $7fPBF.forwardRef(function CardContent(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        ref: ref
    }, other));
});
var $971cc648873ffa19$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($971cc648873ffa19$export$9dd6ff9ea0189349, {
    name: 'MuiCardContent'
})($971cc648873ffa19$var$CardContent);


var $iRcsz = parcelRequire("iRcsz");
var $1rW9t = parcelRequire("1rW9t");

parcelRequire("7fPBF");
var $76b676f9af569df7$exports = {};
"use strict";
Object.defineProperty($76b676f9af569df7$exports, "__esModule", {
    value: true
});
Object.defineProperty($76b676f9af569df7$exports, "Chart", {
    enumerable: true,
    get: function get() {
        return $76b676f9af569df7$var$_chart["default"];
    }
});
$76b676f9af569df7$exports.defaults = $76b676f9af569df7$exports.Scatter = $76b676f9af569df7$exports.Bubble = $76b676f9af569df7$exports.Polar = $76b676f9af569df7$exports.Radar = $76b676f9af569df7$exports.HorizontalBar = $76b676f9af569df7$exports.Bar = $76b676f9af569df7$exports.Line = $76b676f9af569df7$exports.Pie = $76b676f9af569df7$exports.Doughnut = $76b676f9af569df7$exports["default"] = void 0;

var $76b676f9af569df7$var$_react = $76b676f9af569df7$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $76b676f9af569df7$var$_propTypes = $76b676f9af569df7$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $76b676f9af569df7$var$_chart = $76b676f9af569df7$var$_interopRequireDefault((parcelRequire("kYamb")));

var $76b676f9af569df7$var$_isEqual = $76b676f9af569df7$var$_interopRequireDefault((parcelRequire("hzZfF")));

var $76b676f9af569df7$var$_keyBy = $76b676f9af569df7$var$_interopRequireDefault((parcelRequire("8d7ev")));
function $76b676f9af569df7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76b676f9af569df7$var$_extends() {
    $76b676f9af569df7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $76b676f9af569df7$var$_extends.apply(this, arguments);
}
function $76b676f9af569df7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $76b676f9af569df7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $76b676f9af569df7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $76b676f9af569df7$var$_typeof(obj);
}
function $76b676f9af569df7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $76b676f9af569df7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $76b676f9af569df7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $76b676f9af569df7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $76b676f9af569df7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $76b676f9af569df7$var$ownKeys(Object(source), true).forEach(function(key) {
            $76b676f9af569df7$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $76b676f9af569df7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $76b676f9af569df7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $76b676f9af569df7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $76b676f9af569df7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $76b676f9af569df7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $76b676f9af569df7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $76b676f9af569df7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $76b676f9af569df7$var$_setPrototypeOf(subClass, superClass);
}
function $76b676f9af569df7$var$_setPrototypeOf(o, p) {
    $76b676f9af569df7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $76b676f9af569df7$var$_setPrototypeOf(o, p);
}
function $76b676f9af569df7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $76b676f9af569df7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $76b676f9af569df7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $76b676f9af569df7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $76b676f9af569df7$var$_possibleConstructorReturn(this, result);
    };
}
function $76b676f9af569df7$var$_possibleConstructorReturn(self, call) {
    if (call && ($76b676f9af569df7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $76b676f9af569df7$var$_assertThisInitialized(self);
}
function $76b676f9af569df7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $76b676f9af569df7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $76b676f9af569df7$var$_getPrototypeOf(o) {
    $76b676f9af569df7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $76b676f9af569df7$var$_getPrototypeOf(o);
}
function $76b676f9af569df7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $76b676f9af569df7$var$NODE_ENV = false;
var $76b676f9af569df7$var$ChartComponent = /*#__PURE__*/ function(_React$Component) {
    $76b676f9af569df7$var$_inherits(ChartComponent, _React$Component);
    var _super = $76b676f9af569df7$var$_createSuper(ChartComponent);
    function ChartComponent() {
        var _this;
        $76b676f9af569df7$var$_classCallCheck(this, ChartComponent);
        _this = _super.call(this);
        $76b676f9af569df7$var$_defineProperty($76b676f9af569df7$var$_assertThisInitialized(_this), "handleOnClick", function(event) {
            var instance = _this.chartInstance;
            var _this$props = _this.props, getDatasetAtEvent = _this$props.getDatasetAtEvent, getElementAtEvent = _this$props.getElementAtEvent, getElementsAtEvent = _this$props.getElementsAtEvent, onElementsClick = _this$props.onElementsClick;
            getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
            getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
            getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
            onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
        });
        $76b676f9af569df7$var$_defineProperty($76b676f9af569df7$var$_assertThisInitialized(_this), "ref", function(element) {
            _this.element = element;
        });
        _this.chartInstance = undefined;
        return _this;
    }
    $76b676f9af569df7$var$_createClass(ChartComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderChart();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.redraw) {
                    this.destroyChart();
                    this.renderChart();
                    return;
                }
                this.updateChart();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this$props2 = this.props, redraw = _this$props2.redraw, type = _this$props2.type, options = _this$props2.options, plugins = _this$props2.plugins, legend = _this$props2.legend, height = _this$props2.height, width = _this$props2.width;
                if (nextProps.redraw === true) return true;
                if (height !== nextProps.height || width !== nextProps.width) return true;
                if (type !== nextProps.type) return true;
                if (!(0, $76b676f9af569df7$var$_isEqual["default"])(legend, nextProps.legend)) return true;
                if (!(0, $76b676f9af569df7$var$_isEqual["default"])(options, nextProps.options)) return true;
                var nextData = this.transformDataProp(nextProps);
                if (!(0, $76b676f9af569df7$var$_isEqual["default"])(this.shadowDataProp, nextData)) return true;
                return !(0, $76b676f9af569df7$var$_isEqual["default"])(plugins, nextProps.plugins);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyChart();
            }
        },
        {
            key: "transformDataProp",
            value: function transformDataProp(props) {
                var data = props.data;
                if (typeof data == 'function') {
                    var node = this.element;
                    return data(node);
                } else return data;
            } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
        },
        {
            key: "memoizeDataProps",
            value: function memoizeDataProps() {
                if (!this.props.data) return;
                var data = this.transformDataProp(this.props);
                this.shadowDataProp = $76b676f9af569df7$var$_objectSpread($76b676f9af569df7$var$_objectSpread({}, data), {}, {
                    datasets: data.datasets && data.datasets.map(function(set) {
                        return $76b676f9af569df7$var$_objectSpread({}, set);
                    })
                });
                this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
                return data;
            }
        },
        {
            key: "checkDatasets",
            value: function checkDatasets(datasets) {
                var isDev = $76b676f9af569df7$var$NODE_ENV !== 'production' && $76b676f9af569df7$var$NODE_ENV !== 'prod';
                var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
                var multipleDatasets = datasets.length > 1;
                if (isDev && multipleDatasets && !usingCustomKeyProvider) {
                    var shouldWarn = false;
                    datasets.forEach(function(dataset) {
                        if (!dataset.label) shouldWarn = true;
                    });
                    if (shouldWarn) console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
                }
            }
        },
        {
            key: "getCurrentDatasets",
            value: function getCurrentDatasets() {
                return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
            }
        },
        {
            key: "saveCurrentDatasets",
            value: function saveCurrentDatasets() {
                var _this2 = this;
                this.datasets = this.datasets || {};
                var currentDatasets = this.getCurrentDatasets();
                currentDatasets.forEach(function(d) {
                    _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
                });
            }
        },
        {
            key: "updateChart",
            value: function updateChart() {
                var _this3 = this;
                var options = this.props.options;
                var data = this.memoizeDataProps(this.props);
                if (!this.chartInstance) return;
                if (options) this.chartInstance.options = $76b676f9af569df7$var$_chart["default"].helpers.configMerge(this.chartInstance.options, options);
                 // Pipe datasets to chart instance datasets enabling
                // seamless transitions
                var currentDatasets = this.getCurrentDatasets();
                var nextDatasets = data.datasets || [];
                this.checkDatasets(currentDatasets);
                var currentDatasetsIndexed = (0, $76b676f9af569df7$var$_keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
                // on each dataset.
                this.chartInstance.config.data.datasets = nextDatasets.map(function(next) {
                    var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
                    if (current && current.type === next.type && next.data) {
                        // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
                        // The data array must be edited in place. As chart.js adds listeners to it.
                        current.data.splice(next.data.length);
                        next.data.forEach(function(point, pid) {
                            current.data[pid] = next.data[pid];
                        });
                        var _data = next.data, otherProps = $76b676f9af569df7$var$_objectWithoutProperties(next, [
                            "data"
                        ]); // Merge properties. Notice a weakness here. If a property is removed
                        // from next, it will be retained by current and never disappears.
                        // Workaround is to set value to null or undefined in next.
                        return $76b676f9af569df7$var$_objectSpread($76b676f9af569df7$var$_objectSpread({}, current), otherProps);
                    } else return next;
                });
                var datasets = data.datasets, rest = $76b676f9af569df7$var$_objectWithoutProperties(data, [
                    "datasets"
                ]);
                this.chartInstance.config.data = $76b676f9af569df7$var$_objectSpread($76b676f9af569df7$var$_objectSpread({}, this.chartInstance.config.data), rest);
                this.chartInstance.update();
            }
        },
        {
            key: "renderChart",
            value: function renderChart() {
                var _this$props3 = this.props, options = _this$props3.options, legend = _this$props3.legend, type = _this$props3.type, plugins = _this$props3.plugins;
                var node = this.element;
                var data = this.memoizeDataProps();
                if (typeof legend !== 'undefined' && !(0, $76b676f9af569df7$var$_isEqual["default"])(ChartComponent.defaultProps.legend, legend)) options.legend = legend;
                this.chartInstance = new $76b676f9af569df7$var$_chart["default"](node, {
                    type: type,
                    data: data,
                    options: options,
                    plugins: plugins
                });
            }
        },
        {
            key: "destroyChart",
            value: function destroyChart() {
                if (!this.chartInstance) return;
                 // Put all of the datasets that have existed in the chart back on the chart
                // so that the metadata associated with this chart get destroyed.
                // This allows the datasets to be used in another chart. This can happen,
                // for example, in a tabbed UI where the chart gets created each time the
                // tab gets switched to the chart and uses the same data).
                this.saveCurrentDatasets();
                var datasets = Object.values(this.datasets);
                this.chartInstance.config.data.datasets = datasets;
                this.chartInstance.destroy();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, height = _this$props4.height, width = _this$props4.width, id = _this$props4.id;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement("canvas", {
                    ref: this.ref,
                    height: height,
                    width: width,
                    id: id,
                    onClick: this.handleOnClick
                });
            }
        }
    ]);
    return ChartComponent;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$var$_defineProperty($76b676f9af569df7$var$ChartComponent, "getLabelAsKey", function(d) {
    return d.label;
});
$76b676f9af569df7$var$_defineProperty($76b676f9af569df7$var$ChartComponent, "propTypes", {
    data: $76b676f9af569df7$var$_propTypes["default"].oneOfType([
        $76b676f9af569df7$var$_propTypes["default"].object,
        $76b676f9af569df7$var$_propTypes["default"].func
    ]).isRequired,
    getDatasetAtEvent: $76b676f9af569df7$var$_propTypes["default"].func,
    getElementAtEvent: $76b676f9af569df7$var$_propTypes["default"].func,
    getElementsAtEvent: $76b676f9af569df7$var$_propTypes["default"].func,
    height: $76b676f9af569df7$var$_propTypes["default"].number,
    legend: $76b676f9af569df7$var$_propTypes["default"].object,
    onElementsClick: $76b676f9af569df7$var$_propTypes["default"].func,
    options: $76b676f9af569df7$var$_propTypes["default"].object,
    plugins: $76b676f9af569df7$var$_propTypes["default"].arrayOf($76b676f9af569df7$var$_propTypes["default"].object),
    redraw: $76b676f9af569df7$var$_propTypes["default"].bool,
    type: function type(props, propName, componentName) {
        if (!$76b676f9af569df7$var$_chart["default"].controllers[props[propName]]) return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    },
    width: $76b676f9af569df7$var$_propTypes["default"].number,
    datasetKeyProvider: $76b676f9af569df7$var$_propTypes["default"].func
});
$76b676f9af569df7$var$_defineProperty($76b676f9af569df7$var$ChartComponent, "defaultProps", {
    legend: {
        display: true,
        position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: $76b676f9af569df7$var$ChartComponent.getLabelAsKey
});
var $76b676f9af569df7$var$_default = $76b676f9af569df7$var$ChartComponent;
$76b676f9af569df7$exports["default"] = $76b676f9af569df7$var$_default;
var $76b676f9af569df7$var$Doughnut = /*#__PURE__*/ function(_React$Component2) {
    $76b676f9af569df7$var$_inherits(Doughnut, _React$Component2);
    var _super2 = $76b676f9af569df7$var$_createSuper(Doughnut);
    function Doughnut() {
        $76b676f9af569df7$var$_classCallCheck(this, Doughnut);
        return _super2.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(Doughnut, [
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref) {
                        return _this4.chartInstance = _ref && _ref.chartInstance;
                    },
                    type: "doughnut"
                }));
            }
        }
    ]);
    return Doughnut;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.Doughnut = $76b676f9af569df7$var$Doughnut;
var $76b676f9af569df7$var$Pie = /*#__PURE__*/ function(_React$Component3) {
    $76b676f9af569df7$var$_inherits(Pie, _React$Component3);
    var _super3 = $76b676f9af569df7$var$_createSuper(Pie);
    function Pie() {
        $76b676f9af569df7$var$_classCallCheck(this, Pie);
        return _super3.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(Pie, [
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref2) {
                        return _this5.chartInstance = _ref2 && _ref2.chartInstance;
                    },
                    type: "pie"
                }));
            }
        }
    ]);
    return Pie;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.Pie = $76b676f9af569df7$var$Pie;
var $76b676f9af569df7$var$Line = /*#__PURE__*/ function(_React$Component4) {
    $76b676f9af569df7$var$_inherits(Line, _React$Component4);
    var _super4 = $76b676f9af569df7$var$_createSuper(Line);
    function Line() {
        $76b676f9af569df7$var$_classCallCheck(this, Line);
        return _super4.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(Line, [
        {
            key: "render",
            value: function render() {
                var _this6 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref3) {
                        return _this6.chartInstance = _ref3 && _ref3.chartInstance;
                    },
                    type: "line"
                }));
            }
        }
    ]);
    return Line;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.Line = $76b676f9af569df7$var$Line;
var $76b676f9af569df7$var$Bar = /*#__PURE__*/ function(_React$Component5) {
    $76b676f9af569df7$var$_inherits(Bar, _React$Component5);
    var _super5 = $76b676f9af569df7$var$_createSuper(Bar);
    function Bar() {
        $76b676f9af569df7$var$_classCallCheck(this, Bar);
        return _super5.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(Bar, [
        {
            key: "render",
            value: function render() {
                var _this7 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref4) {
                        return _this7.chartInstance = _ref4 && _ref4.chartInstance;
                    },
                    type: "bar"
                }));
            }
        }
    ]);
    return Bar;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.Bar = $76b676f9af569df7$var$Bar;
var $76b676f9af569df7$var$HorizontalBar = /*#__PURE__*/ function(_React$Component6) {
    $76b676f9af569df7$var$_inherits(HorizontalBar, _React$Component6);
    var _super6 = $76b676f9af569df7$var$_createSuper(HorizontalBar);
    function HorizontalBar() {
        $76b676f9af569df7$var$_classCallCheck(this, HorizontalBar);
        return _super6.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(HorizontalBar, [
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref5) {
                        return _this8.chartInstance = _ref5 && _ref5.chartInstance;
                    },
                    type: "horizontalBar"
                }));
            }
        }
    ]);
    return HorizontalBar;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.HorizontalBar = $76b676f9af569df7$var$HorizontalBar;
var $76b676f9af569df7$var$Radar = /*#__PURE__*/ function(_React$Component7) {
    $76b676f9af569df7$var$_inherits(Radar, _React$Component7);
    var _super7 = $76b676f9af569df7$var$_createSuper(Radar);
    function Radar() {
        $76b676f9af569df7$var$_classCallCheck(this, Radar);
        return _super7.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(Radar, [
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref6) {
                        return _this9.chartInstance = _ref6 && _ref6.chartInstance;
                    },
                    type: "radar"
                }));
            }
        }
    ]);
    return Radar;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.Radar = $76b676f9af569df7$var$Radar;
var $76b676f9af569df7$var$Polar = /*#__PURE__*/ function(_React$Component8) {
    $76b676f9af569df7$var$_inherits(Polar, _React$Component8);
    var _super8 = $76b676f9af569df7$var$_createSuper(Polar);
    function Polar() {
        $76b676f9af569df7$var$_classCallCheck(this, Polar);
        return _super8.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(Polar, [
        {
            key: "render",
            value: function render() {
                var _this10 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref7) {
                        return _this10.chartInstance = _ref7 && _ref7.chartInstance;
                    },
                    type: "polarArea"
                }));
            }
        }
    ]);
    return Polar;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.Polar = $76b676f9af569df7$var$Polar;
var $76b676f9af569df7$var$Bubble = /*#__PURE__*/ function(_React$Component9) {
    $76b676f9af569df7$var$_inherits(Bubble, _React$Component9);
    var _super9 = $76b676f9af569df7$var$_createSuper(Bubble);
    function Bubble() {
        $76b676f9af569df7$var$_classCallCheck(this, Bubble);
        return _super9.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(Bubble, [
        {
            key: "render",
            value: function render() {
                var _this11 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref8) {
                        return _this11.chartInstance = _ref8 && _ref8.chartInstance;
                    },
                    type: "bubble"
                }));
            }
        }
    ]);
    return Bubble;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.Bubble = $76b676f9af569df7$var$Bubble;
var $76b676f9af569df7$var$Scatter = /*#__PURE__*/ function(_React$Component10) {
    $76b676f9af569df7$var$_inherits(Scatter, _React$Component10);
    var _super10 = $76b676f9af569df7$var$_createSuper(Scatter);
    function Scatter() {
        $76b676f9af569df7$var$_classCallCheck(this, Scatter);
        return _super10.apply(this, arguments);
    }
    $76b676f9af569df7$var$_createClass(Scatter, [
        {
            key: "render",
            value: function render() {
                var _this12 = this;
                return /*#__PURE__*/ $76b676f9af569df7$var$_react["default"].createElement($76b676f9af569df7$var$ChartComponent, $76b676f9af569df7$var$_extends({}, this.props, {
                    ref: function ref(_ref9) {
                        return _this12.chartInstance = _ref9 && _ref9.chartInstance;
                    },
                    type: "scatter"
                }));
            }
        }
    ]);
    return Scatter;
}($76b676f9af569df7$var$_react["default"].Component);
$76b676f9af569df7$exports.Scatter = $76b676f9af569df7$var$Scatter;
var $76b676f9af569df7$var$defaults = $76b676f9af569df7$var$_chart["default"].defaults;
$76b676f9af569df7$exports.defaults = $76b676f9af569df7$var$defaults;



var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");
const $48e2a17e2d5a5a6a$var$DoughnutChart = ({ color: color, valueToDisplay: valueToDisplay })=>{
    const setLeftMarginForValue = (valueToDisplay)=>{
        if (valueToDisplay < 10) return '50px';
        else if (valueToDisplay >= 100) return '40px';
        else return '46px';
    };
    const parsedValueToDisplay = typeof valueToDisplay !== Number ? parseInt(valueToDisplay, 10) : valueToDisplay;
    const useStyles = (0, $by0pu.default)({
        container: {
            position: 'relative'
        },
        value: {
            position: 'absolute',
            color: color,
            zIndex: 10,
            marginLeft: setLeftMarginForValue(valueToDisplay),
            marginTop: '52px',
            fontWeight: 'bold'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1rW9t.default), {
        className: classes.container,
        component: "div",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.value,
                component: "div",
                children: `${parsedValueToDisplay.toFixed(0)}%`
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                component: "div",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $76b676f9af569df7$exports.Doughnut), {
                    data: {
                        datasets: [
                            {
                                backgroundColor: [
                                    color,
                                    '#E0E0E0'
                                ],
                                data: [
                                    parsedValueToDisplay,
                                    100 - (parsedValueToDisplay > 100 ? 100 : parsedValueToDisplay)
                                ],
                                borderWidth: [
                                    1,
                                    1
                                ]
                            }
                        ]
                    },
                    options: {
                        cutoutPercentage: 50,
                        events: [],
                        maintainAspectRatio: false,
                        responsive: false
                    },
                    width: 116,
                    height: 116
                })
            })
        ]
    });
};
var $48e2a17e2d5a5a6a$export$2e2bcd8739ae039 = $48e2a17e2d5a5a6a$var$DoughnutChart;


var $9af6f5db7788b683$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($9af6f5db7788b683$exports, "__esModule", {
    value: true
});
$9af6f5db7788b683$exports.default = void 0;

var $9af6f5db7788b683$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $9af6f5db7788b683$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $9af6f5db7788b683$var$_default = (0, $9af6f5db7788b683$var$_createSvgIcon.default)(/*#__PURE__*/ $9af6f5db7788b683$var$React.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z"
}), 'CreateOutlined');
$9af6f5db7788b683$exports.default = $9af6f5db7788b683$var$_default;


const $2d9e69b73fc50a78$var$EvaluationWithChart = ({ nameToDisplay: nameToDisplay, valueToDisplay: valueToDisplay, rateable: rateable, handleDialogeOpen: handleDialogeOpen, color: color })=>{
    const useStyles = (0, $by0pu.default)({
        root: {
            width: '138px',
            background: '#F4F4F4',
            minHeight: '146px',
            borderRadius: '4px 0px 0px 4px',
            color: '#666666',
            margin: '10px 0px 10px 0px',
            borderColor: '#F4F4F4'
        },
        name: {
            fontWeight: 'Bold',
            marginTop: '3px',
            fontSize: '12px'
        },
        cardAction: {
            padding: 0,
            position: 'absolute',
            zIndex: 100
        },
        button: {
            padding: 11,
            paddingTop: 11,
            color: '#76C9E6'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $edd72516fdfce69a$export$2e2bcd8739ae039), {
        className: classes.root,
        variant: 'outlined',
        children: [
            rateable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8471706d6d1ef014$export$2e2bcd8739ae039), {
                className: classes.cardAction,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                    onClick: ()=>handleDialogeOpen(),
                    "aria-label": "edit",
                    className: classes.button,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9af6f5db7788b683$exports))), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $971cc648873ffa19$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $48e2a17e2d5a5a6a$export$2e2bcd8739ae039), {
                        valueToDisplay: valueToDisplay,
                        color: color
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        align: "center",
                        container: true,
                        direction: "column",
                        justifyContent: "center",
                        spacing: 0,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            className: classes.name,
                            component: "div",
                            children: nameToDisplay
                        })
                    })
                ]
            })
        ]
    });
};
var $2d9e69b73fc50a78$export$2e2bcd8739ae039 = $2d9e69b73fc50a78$var$EvaluationWithChart;



parcelRequire("7fPBF");

var $by0pu = parcelRequire("by0pu");


var $fwAOd = parcelRequire("fwAOd");
var $iRcsz = parcelRequire("iRcsz");
var $1rW9t = parcelRequire("1rW9t");

const $59ef8489b4c717b5$var$EvaluationWithText = ({ nameToDisplay: nameToDisplay, rateable: rateable, handleDialogeOpen: handleDialogeOpen, isOnlyText: isOnlyText, textAnswer: textAnswer })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const selectText = ()=>{
        if (nameToDisplay === t('objective.average.title')) return ` ${t('objective.card.text.AverageNotAvailable')}`;
        if (isOnlyText && textAnswer) return '';
        if (rateable) return ` ${t('objective.card.text.appraisable')}`;
        return ` ${t('objective.card.text.notAppraisable')}`;
    };
    const isBottomButtonDisplayable = ()=>rateable && isOnlyText && textAnswer || !rateable ? false : true;
    const useStyles = (0, $by0pu.default)({
        root: {
            width: '138px',
            background: '#F4F4F4',
            minHeight: '146px',
            borderRadius: '4px 0px 0px 4px',
            borderColor: '#F4F4F4',
            color: '#666666',
            margin: '10px 0px 10px 0px'
        },
        typography: {
            marginTop: '15px',
            fontSize: '12px'
        },
        name: {
            fontWeight: 'Bold'
        },
        button: {
            marginTop: '20px',
            width: '90px',
            height: '31px',
            marginBottom: ' 10px'
        },
        cardAction: {
            padding: 0,
            position: 'absolute',
            zIndex: 100
        },
        iconButton: {
            padding: 11,
            paddingTop: 11,
            color: '#76C9E6'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $edd72516fdfce69a$export$2e2bcd8739ae039), {
        className: classes.root,
        variant: 'outlined',
        children: [
            rateable && isOnlyText && textAnswer && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8471706d6d1ef014$export$2e2bcd8739ae039), {
                className: classes.cardAction,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                    onClick: ()=>handleDialogeOpen(),
                    "aria-label": "edit",
                    className: classes.iconButton,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9af6f5db7788b683$exports))), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $971cc648873ffa19$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    align: "center",
                    container: true,
                    direction: "column",
                    justifyContent: "center",
                    spacing: 0,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1rW9t.default), {
                        className: classes.typography,
                        component: "div",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d57f8c5132119daf$export$2e2bcd8739ae039), {
                                className: classes.name,
                                display: "inline",
                                children: nameToDisplay
                            }),
                            selectText()
                        ]
                    })
                })
            }),
            isBottomButtonDisplayable() && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8471706d6d1ef014$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    align: "center",
                    container: true,
                    justifyContent: "center",
                    spacing: 1,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: ()=>handleDialogeOpen(),
                        className: classes.button,
                        variant: "contained",
                        color: "secondary",
                        size: "small",
                        children: t('objective.card.button')
                    })
                })
            })
        ]
    });
};
var $59ef8489b4c717b5$export$2e2bcd8739ae039 = $59ef8489b4c717b5$var$EvaluationWithText;






var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $i8OTH = parcelRequire("i8OTH");
var $by0pu = parcelRequire("by0pu");
var $MQfsM = parcelRequire("MQfsM");
var $1rW9t = parcelRequire("1rW9t");

var $baumZ = parcelRequire("baumZ");
var $juaRV = parcelRequire("juaRV");
var $3Sc7z = parcelRequire("3Sc7z");



parcelRequire("7fPBF");

var $cwJVy = parcelRequire("cwJVy");

var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $fH0xA = parcelRequire("fH0xA");

var $2jEfe = parcelRequire("2jEfe");

var $K4XJ4 = parcelRequire("K4XJ4");

var $g3iV0 = parcelRequire("g3iV0");

var $1sMi9 = parcelRequire("1sMi9");

var $55RWP = parcelRequire("55RWP");

var $dKzJP = parcelRequire("dKzJP");

var $3deDh = parcelRequire("3deDh");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");
var $98ae59b9288706b9$var$styles = function styles(theme) {
    return {
        thumb: {
            '&$open': {
                '& $offset': {
                    transform: 'scale(1) translateY(-10px)'
                }
            }
        },
        open: {},
        offset: (0, $kY3Ke.default)({
            zIndex: 1
        }, theme.typography.body2, {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.2,
            transition: theme.transitions.create([
                'transform'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            top: -34,
            transformOrigin: 'bottom center',
            transform: 'scale(0)',
            position: 'absolute'
        }),
        circle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
            height: 32,
            borderRadius: '50% 50% 50% 0',
            backgroundColor: 'currentColor',
            transform: 'rotate(-45deg)'
        },
        label: {
            color: theme.palette.primary.contrastText,
            transform: 'rotate(45deg)'
        }
    };
};
/**
 * @ignore - internal component.
 */ function $98ae59b9288706b9$var$ValueLabel(props) {
    var children = props.children, classes = props.classes, className = props.className, open = props.open, value = props.value, valueLabelDisplay = props.valueLabelDisplay;
    if (valueLabelDisplay === 'off') return children;
    return /*#__PURE__*/ $7fPBF.cloneElement(children, {
        className: (0, $jtRae.default)(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, $jtRae.default)(classes.offset, className)
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.circle
    }, /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.label
    }, value))));
}
var $98ae59b9288706b9$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($98ae59b9288706b9$var$styles, {
    name: 'PrivateValueLabel'
})($98ae59b9288706b9$var$ValueLabel);


function $9e112db4a6a9b562$var$asc(a, b) {
    return a - b;
}
function $9e112db4a6a9b562$var$clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
}
function $9e112db4a6a9b562$var$findClosest(values, currentValue) {
    var _values$reduce = values.reduce(function(acc, value, index) {
        var distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null), closestIndex = _values$reduce.index;
    return closestIndex;
}
function $9e112db4a6a9b562$var$trackFinger(event, touchId) {
    if (touchId.current !== undefined && event.changedTouches) {
        for(var i = 0; i < event.changedTouches.length; i += 1){
            var touch = event.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $9e112db4a6a9b562$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $9e112db4a6a9b562$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $9e112db4a6a9b562$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        var parts = num.toExponential().split('e-');
        var matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    var decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $9e112db4a6a9b562$var$roundValueToStep(value, step, min) {
    var nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($9e112db4a6a9b562$var$getDecimalPrecision(step)));
}
function $9e112db4a6a9b562$var$setValueIndex(_ref) {
    var values = _ref.values, source = _ref.source, newValue = _ref.newValue, index = _ref.index;
    // Performance shortcut
    if (values[index] === newValue) return source;
    var output = values.slice();
    output[index] = newValue;
    return output;
}
function $9e112db4a6a9b562$var$focusThumb(_ref2) {
    var sliderRef = _ref2.sliderRef, activeIndex = _ref2.activeIndex, setActive = _ref2.setActive;
    if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
    if (setActive) setActive(activeIndex);
}
var $9e112db4a6a9b562$var$axisProps = {
    horizontal: {
        offset: function offset(percent) {
            return {
                left: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                width: "".concat(percent, "%")
            };
        }
    },
    'horizontal-reverse': {
        offset: function offset(percent) {
            return {
                right: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                width: "".concat(percent, "%")
            };
        }
    },
    vertical: {
        offset: function offset(percent) {
            return {
                bottom: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                height: "".concat(percent, "%")
            };
        }
    }
};
var $9e112db4a6a9b562$var$Identity = function Identity(x) {
    return x;
};
var $9e112db4a6a9b562$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 2,
            width: '100%',
            boxSizing: 'content-box',
            padding: '13px 0',
            display: 'inline-block',
            position: 'relative',
            cursor: 'pointer',
            touchAction: 'none',
            color: theme.palette.primary.main,
            WebkitTapHighlightColor: 'transparent',
            '&$disabled': {
                pointerEvents: 'none',
                cursor: 'default',
                color: theme.palette.grey[400]
            },
            '&$vertical': {
                width: 2,
                height: '100%',
                padding: '0 13px'
            },
            // The primary input mechanism of the device includes a pointing device of limited accuracy.
            '@media (pointer: coarse)': {
                // Reach 42px touch target, about ~8mm on screen.
                padding: '20px 0',
                '&$vertical': {
                    padding: '0 20px'
                }
            },
            '@media print': {
                colorAdjust: 'exact'
            }
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {},
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `marks` is provided with at least one label. */ marked: {
            marginBottom: 20,
            '&$vertical': {
                marginBottom: 'auto',
                marginRight: 20
            }
        },
        /* Pseudo-class applied to the root element if `orientation="vertical"`. */ vertical: {},
        /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the rail element. */ rail: {
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor',
            opacity: 0.38,
            '$vertical &': {
                height: '100%',
                width: 2
            }
        },
        /* Styles applied to the track element. */ track: {
            display: 'block',
            position: 'absolute',
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor',
            '$vertical &': {
                width: 2
            }
        },
        /* Styles applied to the track element if `track={false}`. */ trackFalse: {
            '& $track': {
                display: 'none'
            }
        },
        /* Styles applied to the track element if `track="inverted"`. */ trackInverted: {
            '& $track': {
                backgroundColor: theme.palette.type === 'light' ? (0, $2jEfe.lighten)(theme.palette.primary.main, 0.62) : (0, $2jEfe.darken)(theme.palette.primary.main, 0.5)
            },
            '& $rail': {
                opacity: 1
            }
        },
        /* Styles applied to the thumb element. */ thumb: {
            position: 'absolute',
            width: 12,
            height: 12,
            marginLeft: -6,
            marginTop: -5,
            boxSizing: 'border-box',
            borderRadius: '50%',
            outline: 0,
            backgroundColor: 'currentColor',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: theme.transitions.create([
                'box-shadow'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            '&::after': {
                position: 'absolute',
                content: '""',
                borderRadius: '50%',
                // reach 42px hit target (2 * 15 + thumb diameter)
                left: -15,
                top: -15,
                right: -15,
                bottom: -15
            },
            '&$focusVisible,&:hover': {
                boxShadow: "0px 0px 0px 8px ".concat((0, $2jEfe.alpha)(theme.palette.primary.main, 0.16)),
                '@media (hover: none)': {
                    boxShadow: 'none'
                }
            },
            '&$active': {
                boxShadow: "0px 0px 0px 14px ".concat((0, $2jEfe.alpha)(theme.palette.primary.main, 0.16))
            },
            '&$disabled': {
                width: 8,
                height: 8,
                marginLeft: -4,
                marginTop: -3,
                '&:hover': {
                    boxShadow: 'none'
                }
            },
            '$vertical &': {
                marginLeft: -5,
                marginBottom: -6
            },
            '$vertical &$disabled': {
                marginLeft: -3,
                marginBottom: -4
            }
        },
        /* Styles applied to the thumb element if `color="primary"`. */ thumbColorPrimary: {},
        /* Styles applied to the thumb element if `color="secondary"`. */ thumbColorSecondary: {
            '&$focusVisible,&:hover': {
                boxShadow: "0px 0px 0px 8px ".concat((0, $2jEfe.alpha)(theme.palette.secondary.main, 0.16))
            },
            '&$active': {
                boxShadow: "0px 0px 0px 14px ".concat((0, $2jEfe.alpha)(theme.palette.secondary.main, 0.16))
            }
        },
        /* Pseudo-class applied to the thumb element if it's active. */ active: {},
        /* Pseudo-class applied to the thumb element if keyboard focused. */ focusVisible: {},
        /* Styles applied to the thumb label element. */ valueLabel: {
            // IE 11 centering bug, to remove from the customization demos once no longer supported
            left: 'calc(-50% - 4px)'
        },
        /* Styles applied to the mark element. */ mark: {
            position: 'absolute',
            width: 2,
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the mark element if active (depending on the value). */ markActive: {
            backgroundColor: theme.palette.background.paper,
            opacity: 0.8
        },
        /* Styles applied to the mark label element. */ markLabel: (0, $kY3Ke.default)({}, theme.typography.body2, {
            color: theme.palette.text.secondary,
            position: 'absolute',
            top: 26,
            transform: 'translateX(-50%)',
            whiteSpace: 'nowrap',
            '$vertical &': {
                top: 'auto',
                left: 26,
                transform: 'translateY(50%)'
            },
            '@media (pointer: coarse)': {
                top: 40,
                '$vertical &': {
                    left: 31
                }
            }
        }),
        /* Styles applied to the mark label element if active (depending on the value). */ markLabelActive: {
            color: theme.palette.text.primary
        }
    };
};
var $9e112db4a6a9b562$var$Slider = /*#__PURE__*/ $7fPBF.forwardRef(function Slider(props, ref) {
    var ariaLabel = props['aria-label'], ariaLabelledby = props['aria-labelledby'], ariaValuetext = props['aria-valuetext'], classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'span' : _props$component, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, getAriaLabel = props.getAriaLabel, getAriaValueText = props.getAriaValueText, _props$marks = props.marks, marksProp = _props$marks === void 0 ? false : _props$marks, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, name = props.name, onChange = props.onChange, onChangeCommitted = props.onChangeCommitted, onMouseDown = props.onMouseDown, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$scale = props.scale, scale = _props$scale === void 0 ? $9e112db4a6a9b562$var$Identity : _props$scale, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, _props$ThumbComponent = props.ThumbComponent, ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent, _props$track = props.track, track = _props$track === void 0 ? 'normal' : _props$track, valueProp = props.value, _props$ValueLabelComp = props.ValueLabelComponent, ValueLabelComponent = _props$ValueLabelComp === void 0 ? (0, $98ae59b9288706b9$export$2e2bcd8739ae039) : _props$ValueLabelComp, _props$valueLabelDisp = props.valueLabelDisplay, valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp, _props$valueLabelForm = props.valueLabelFormat, valueLabelFormat = _props$valueLabelForm === void 0 ? $9e112db4a6a9b562$var$Identity : _props$valueLabelForm, other = (0, $lfiYO.default)(props, [
        "aria-label",
        "aria-labelledby",
        "aria-valuetext",
        "classes",
        "className",
        "color",
        "component",
        "defaultValue",
        "disabled",
        "getAriaLabel",
        "getAriaValueText",
        "marks",
        "max",
        "min",
        "name",
        "onChange",
        "onChangeCommitted",
        "onMouseDown",
        "orientation",
        "scale",
        "step",
        "ThumbComponent",
        "track",
        "value",
        "ValueLabelComponent",
        "valueLabelDisplay",
        "valueLabelFormat"
    ]);
    var theme = (0, $fH0xA.default)();
    var touchId = $7fPBF.useRef(); // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transfered when inversing a range slider.
    var _React$useState = $7fPBF.useState(-1), active = _React$useState[0], setActive = _React$useState[1];
    var _React$useState2 = $7fPBF.useState(-1), open = _React$useState2[0], setOpen = _React$useState2[1];
    var _useControlled = (0, $3deDh.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Slider'
    }), _useControlled2 = (0, $2gIIh.default)(_useControlled, 2), valueDerived = _useControlled2[0], setValueState = _useControlled2[1];
    var range = Array.isArray(valueDerived);
    var values = range ? valueDerived.slice().sort($9e112db4a6a9b562$var$asc) : [
        valueDerived
    ];
    values = values.map(function(value) {
        return $9e112db4a6a9b562$var$clamp(value, min, max);
    });
    var marks = marksProp === true && step !== null ? (0, $cwJVy.default)(Array(Math.floor((max - min) / step) + 1)).map(function(_, index) {
        return {
            value: min + step * index
        };
    }) : marksProp || [];
    var _useIsFocusVisible = (0, $K4XJ4.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $7fPBF.useState(-1), focusVisible = _React$useState3[0], setFocusVisible = _React$useState3[1];
    var sliderRef = $7fPBF.useRef();
    var handleFocusRef = (0, $55RWP.default)(focusVisibleRef, sliderRef);
    var handleRef = (0, $55RWP.default)(ref, handleFocusRef);
    var handleFocus = (0, $1sMi9.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        if (isFocusVisible(event)) setFocusVisible(index);
        setOpen(index);
    });
    var handleBlur = (0, $1sMi9.default)(function() {
        if (focusVisible !== -1) {
            setFocusVisible(-1);
            onBlurVisible();
        }
        setOpen(-1);
    });
    var handleMouseOver = (0, $1sMi9.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        setOpen(index);
    });
    var handleMouseLeave = (0, $1sMi9.default)(function() {
        setOpen(-1);
    });
    var isRtl = theme.direction === 'rtl';
    var handleKeyDown = (0, $1sMi9.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        var value = values[index];
        var tenPercents = (max - min) / 10;
        var marksValues = marks.map(function(mark) {
            return mark.value;
        });
        var marksIndex = marksValues.indexOf(value);
        var newValue;
        var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
        var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';
        switch(event.key){
            case 'Home':
                newValue = min;
                break;
            case 'End':
                newValue = max;
                break;
            case 'PageUp':
                if (step) newValue = value + tenPercents;
                break;
            case 'PageDown':
                if (step) newValue = value - tenPercents;
                break;
            case increaseKey:
            case 'ArrowUp':
                if (step) newValue = value + step;
                else newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
                break;
            case decreaseKey:
            case 'ArrowDown':
                if (step) newValue = value - step;
                else newValue = marksValues[marksIndex - 1] || marksValues[0];
                break;
            default:
                return;
        } // Prevent scroll of the page
        event.preventDefault();
        if (step) newValue = $9e112db4a6a9b562$var$roundValueToStep(newValue, step, min);
        newValue = $9e112db4a6a9b562$var$clamp(newValue, min, max);
        if (range) {
            var previousValue = newValue;
            newValue = $9e112db4a6a9b562$var$setValueIndex({
                values: values,
                source: valueDerived,
                newValue: newValue,
                index: index
            }).sort($9e112db4a6a9b562$var$asc);
            $9e112db4a6a9b562$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: newValue.indexOf(previousValue)
            });
        }
        setValueState(newValue);
        setFocusVisible(index);
        if (onChange) onChange(event, newValue);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    });
    var previousIndex = $7fPBF.useRef();
    var axis = orientation;
    if (isRtl && orientation !== "vertical") axis += '-reverse';
    var getFingerNewValue = function getFingerNewValue(_ref3) {
        var finger = _ref3.finger, _ref3$move = _ref3.move, move = _ref3$move === void 0 ? false : _ref3$move, values2 = _ref3.values, source = _ref3.source;
        var slider = sliderRef.current;
        var _slider$getBoundingCl = slider.getBoundingClientRect(), width = _slider$getBoundingCl.width, height = _slider$getBoundingCl.height, bottom = _slider$getBoundingCl.bottom, left = _slider$getBoundingCl.left;
        var percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        var newValue;
        newValue = $9e112db4a6a9b562$var$percentToValue(percent, min, max);
        if (step) newValue = $9e112db4a6a9b562$var$roundValueToStep(newValue, step, min);
        else {
            var marksValues = marks.map(function(mark) {
                return mark.value;
            });
            var closestIndex = $9e112db4a6a9b562$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = $9e112db4a6a9b562$var$clamp(newValue, min, max);
        var activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $9e112db4a6a9b562$var$findClosest(values2, newValue);
            else activeIndex = previousIndex.current;
            var previousValue = newValue;
            newValue = $9e112db4a6a9b562$var$setValueIndex({
                values: values2,
                source: source,
                newValue: newValue,
                index: activeIndex
            }).sort($9e112db4a6a9b562$var$asc);
            activeIndex = newValue.indexOf(previousValue);
            previousIndex.current = activeIndex;
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    var handleTouchMove = (0, $1sMi9.default)(function(event) {
        var finger = $9e112db4a6a9b562$var$trackFinger(event, touchId);
        if (!finger) return;
        var _getFingerNewValue = getFingerNewValue({
            finger: finger,
            move: true,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue.newValue, activeIndex = _getFingerNewValue.activeIndex;
        $9e112db4a6a9b562$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    });
    var handleTouchEnd = (0, $1sMi9.default)(function(event) {
        var finger = $9e112db4a6a9b562$var$trackFinger(event, touchId);
        if (!finger) return;
        var _getFingerNewValue2 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue2.newValue;
        setActive(-1);
        if (event.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
        touchId.current = undefined;
        var doc = (0, $g3iV0.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    });
    var handleTouchStart = (0, $1sMi9.default)(function(event) {
        // Workaround as Safari has partial support for touchAction: 'none'.
        event.preventDefault();
        var touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        var finger = $9e112db4a6a9b562$var$trackFinger(event, touchId);
        var _getFingerNewValue3 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue3.newValue, activeIndex = _getFingerNewValue3.activeIndex;
        $9e112db4a6a9b562$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
        var doc = (0, $g3iV0.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    $7fPBF.useEffect(function() {
        var slider = sliderRef.current;
        slider.addEventListener('touchstart', handleTouchStart);
        var doc = (0, $g3iV0.default)(slider);
        return function() {
            slider.removeEventListener('touchstart', handleTouchStart);
            doc.removeEventListener('mousemove', handleTouchMove);
            doc.removeEventListener('mouseup', handleTouchEnd);
            doc.removeEventListener('touchmove', handleTouchMove);
            doc.removeEventListener('touchend', handleTouchEnd);
        };
    }, [
        handleTouchEnd,
        handleTouchMove,
        handleTouchStart
    ]);
    var handleMouseDown = (0, $1sMi9.default)(function(event) {
        if (onMouseDown) onMouseDown(event);
        event.preventDefault();
        var finger = $9e112db4a6a9b562$var$trackFinger(event, touchId);
        var _getFingerNewValue4 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue4.newValue, activeIndex = _getFingerNewValue4.activeIndex;
        $9e112db4a6a9b562$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
        var doc = (0, $g3iV0.default)(sliderRef.current);
        doc.addEventListener('mousemove', handleTouchMove);
        doc.addEventListener('mouseup', handleTouchEnd);
    });
    var trackOffset = $9e112db4a6a9b562$var$valueToPercent(range ? values[0] : min, min, max);
    var trackLeap = $9e112db4a6a9b562$var$valueToPercent(values[values.length - 1], min, max) - trackOffset;
    var trackStyle = (0, $kY3Ke.default)({}, $9e112db4a6a9b562$var$axisProps[axis].offset(trackOffset), $9e112db4a6a9b562$var$axisProps[axis].leap(trackLeap));
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        ref: handleRef,
        className: (0, $jtRae.default)(classes.root, classes["color".concat((0, $dKzJP.default)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function(mark) {
            return mark.label;
        }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
        onMouseDown: handleMouseDown
    }, other), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.rail
    }), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.track,
        style: trackStyle
    }), /*#__PURE__*/ $7fPBF.createElement("input", {
        value: values.join(','),
        name: name,
        type: "hidden"
    }), marks.map(function(mark, index) {
        var percent = $9e112db4a6a9b562$var$valueToPercent(mark.value, min, max);
        var style = $9e112db4a6a9b562$var$axisProps[axis].offset(percent);
        var markActive;
        if (track === false) markActive = values.indexOf(mark.value) !== -1;
        else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
        return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, {
            key: mark.value
        }, /*#__PURE__*/ $7fPBF.createElement("span", {
            style: style,
            "data-index": index,
            className: (0, $jtRae.default)(classes.mark, markActive && classes.markActive)
        }), mark.label != null ? /*#__PURE__*/ $7fPBF.createElement("span", {
            "aria-hidden": true,
            "data-index": index,
            style: style,
            className: (0, $jtRae.default)(classes.markLabel, markActive && classes.markLabelActive)
        }, mark.label) : null);
    }), values.map(function(value, index) {
        var percent = $9e112db4a6a9b562$var$valueToPercent(value, min, max);
        var style = $9e112db4a6a9b562$var$axisProps[axis].offset(percent);
        return /*#__PURE__*/ $7fPBF.createElement(ValueLabelComponent, {
            key: index,
            valueLabelFormat: valueLabelFormat,
            valueLabelDisplay: valueLabelDisplay,
            className: classes.valueLabel,
            value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
            index: index,
            open: open === index || active === index || valueLabelDisplay === 'on',
            disabled: disabled
        }, /*#__PURE__*/ $7fPBF.createElement(ThumbComponent, {
            className: (0, $jtRae.default)(classes.thumb, classes["thumbColor".concat((0, $dKzJP.default)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
            tabIndex: disabled ? null : 0,
            role: "slider",
            style: style,
            "data-index": index,
            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-orientation": orientation,
            "aria-valuemax": scale(max),
            "aria-valuemin": scale(min),
            "aria-valuenow": scale(value),
            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave
        }));
    }));
});
var $9e112db4a6a9b562$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($9e112db4a6a9b562$export$9dd6ff9ea0189349, {
    name: 'MuiSlider'
})($9e112db4a6a9b562$var$Slider);



var $baumZ = parcelRequire("baumZ");
var $juaRV = parcelRequire("juaRV");
const $70df8373e1068464$var$RatingSlider = (props)=>{
    const CustomSliderTheme = (0, $baumZ.default)({
        overrides: {
            MuiSlider: {
                root: {
                    color: '#4FB2CD',
                    marginBottom: '20px',
                    width: '80%',
                    height: 8
                },
                thumb: {
                    height: 24,
                    width: 24,
                    backgroundColor: '#5DCDE7',
                    border: '1px solid #5DCDE7',
                    marginTop: -8,
                    marginLeft: -12,
                    '&:focus, &:hover, &$active': {
                        boxShadow: 'inherit'
                    }
                },
                active: {},
                valueLabel: {
                    left: 'calc(-50% + 6px)'
                },
                track: {
                    height: 8,
                    borderRadius: 4
                },
                rail: {
                    height: 8,
                    borderRadius: 4
                },
                mark: {
                    display: 'none'
                },
                markLabel: {
                    top: '30px'
                }
            }
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $juaRV.default), {
        theme: CustomSliderTheme,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9e112db4a6a9b562$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            step: 1,
            min: 0,
            type: "number"
        }, props))
    });
};
var $70df8373e1068464$export$2e2bcd8739ae039 = $70df8373e1068464$var$RatingSlider;




const $9172051f9afe01c8$var$EvaluateDialog = (props)=>{
    const { open: open, handleClose: handleClose, nameOfCriteria: nameOfCriteria, isOnlyText: isOnlyText, rateOfCriteria: rateOfCriteria, employeeId: employeeId, onSubmitSuccess: onSubmitSuccess } = props;
    const [rating, setRating] = (0, $7fPBF.useState)(rateOfCriteria);
    const [sliderValue, setSliderValue] = (0, $7fPBF.useState)(rateOfCriteria.value);
    const [isOverPeformed, setOverPreformed] = (0, $7fPBF.useState)(false);
    const handleCheckBox = (event)=>{
        setOverPreformed(event.target.checked);
        if (!event.target.checked && sliderValue > 100) setSliderValue(100);
    };
    (0, $7fPBF.useEffect)(()=>{
        let { value: value } = rateOfCriteria;
        if (value && !sliderValue && sliderValue !== 0) setSliderValue(value);
    }, [
        rateOfCriteria,
        sliderValue
    ]);
    (0, $7fPBF.useEffect)(()=>{
        let { value: value } = rateOfCriteria;
        setRating(rateOfCriteria);
        if (value > 100) setOverPreformed(true);
        if (value <= 100) setOverPreformed(false);
    }, [
        rateOfCriteria
    ]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const handleOnChangeText = (event)=>setRating((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rating), {
            text: event.target.value
        }));
    const handleOnChangeSlideValue = (event, value)=>setSliderValue(value);
    const handleCancel = ()=>{
        handleClose();
        setRating(rateOfCriteria);
    };
    const saveObjectiveRateMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        const params = {
            employeeId: employeeId,
            objectiveId: rating.objective_id,
            objectiveRate: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rating), {
                value: sliderValue,
                employeeId: employeeId
            })
        };
        return rating.id ? await (0, $0bc299533abf3517$export$d694a9efe5589cf)(params) : await (0, $0bc299533abf3517$export$b80954554c64aa5e)(params);
    }, {
        onSuccess: ()=>{
            onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
            handleClose();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const handleSubmit = ()=>{
        if (!isOnlyText && typeof sliderValue === 'undefined') {
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `K\xe9rj\xfck adjon meg sz\xe1zal\xe9kos \xe9rt\xe9kel\xe9st`,
                severity: 'error'
            }));
            return;
        }
        saveObjectiveRateMutation.mutate();
    };
    const useStyles = (0, $by0pu.default)({
        centered: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        value: {
            fontWeight: 'bold',
            fontSize: '48px',
            lineHeight: '56px',
            color: '#5DCDE7'
        },
        title: {
            backgroundColor: '#fff',
            color: 'inherit'
        },
        buttons: {
            width: '95%',
            margin: '0 auto',
            justifyContent: 'start',
            paddingBottom: '24px'
        },
        checkbox: {
            width: '100%',
            justifyContent: 'start'
        },
        checkboxtext: {
            color: isOverPeformed ? '#58AF61' : '#000000',
            marginLeft: '0 !important'
        },
        valueField: {
            maxWidth: '120px',
            width: '100%'
        },
        saveBtn: {
            backgroundColor: '#5DCDE7',
            '&:hover': {
                backgroundColor: '#528CA1'
            }
        },
        backBtn: {
            color: '#5DCDE7',
            borderColor: '#5DCDE7',
            '&:hover': {
                borderColor: '#5DCDE7'
            }
        }
    });
    const marks = [
        {
            value: 0,
            label: '0%'
        },
        {
            value: 100,
            label: '100%'
        },
        {
            value: rating.criteria.criteria_rate_upper_limit && isOverPeformed ? rating.criteria.criteria_rate_upper_limit : '',
            label: rating.criteria.criteria_rate_upper_limit && isOverPeformed ? ` ${rating.criteria.criteria_rate_upper_limit}%` : ''
        }
    ];
    const TextFieldTheme = (0, $baumZ.default)({
        overrides: {
            MuiOutlinedInput: {
                root: {
                    '&$focused $notchedOutline': {
                        'borderColor': '#5DCDE7'
                    }
                }
            }
        }
    });
    const GreenCheckbox = (0, $3Sc7z.default)({
        root: {
            color: '#000000',
            '&$checked': {
                color: '#58AF61'
            },
            '&:hover': {
                backgroundColor: 'transparent'
            }
        },
        checked: {}
    })((props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            color: "default"
        }, props)));
    const sliderMaxValue = rating.criteria.criteria_rate_upper_limit > 100 && isOverPeformed ? parseInt(rating.criteria.criteria_rate_upper_limit) : 100;
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
        open: open,
        "aria-labelledby": "form-dialog-title",
        fullWidth: true,
        maxWidth: 'md',
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                className: classes.title,
                children: nameOfCriteria
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                className: classes.centered,
                children: [
                    !isOnlyText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                variant: "h5",
                                className: classes.value,
                                children: `${sliderValue !== null && sliderValue !== void 0 ? sliderValue : ''}%`
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $70df8373e1068464$export$2e2bcd8739ae039), {
                                value: parseInt(sliderValue) || 0,
                                max: sliderMaxValue,
                                marks: marks,
                                onChange: handleOnChangeSlideValue
                            })
                        ]
                    }),
                    !isOnlyText && rating.criteria.criteria_rate_upper_limit > 100 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                        className: classes.checkbox,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(GreenCheckbox, {
                                checked: isOverPeformed,
                                onChange: handleCheckBox
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: classes.checkboxtext,
                                children: t('objective.evaluation.dialog.checkbox.text')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $juaRV.default), {
                        theme: TextFieldTheme,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            value: rating.text,
                            variant: "outlined",
                            placeholder: t('objective.evaluation.dialog.placeholder.text'),
                            multiline: true,
                            minRows: 10,
                            maxRows: 10,
                            fullWidth: true,
                            onChange: handleOnChangeText,
                            InputProps: {
                                classes: {
                                    root: classes.texfiledRoot
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                className: classes.buttons,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleSubmit,
                        className: classes.saveBtn,
                        variant: "contained",
                        color: "primary",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: t('objective.evaluation.dialog.save')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleCancel,
                        className: classes.backBtn,
                        variant: "outlined",
                        color: "primary",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: t('objective.evaluation.dialog.cancel')
                        })
                    })
                ]
            })
        ]
    });
};
var $9172051f9afe01c8$export$2e2bcd8739ae039 = $9172051f9afe01c8$var$EvaluateDialog;



parcelRequire("7fPBF");

var $by0pu = parcelRequire("by0pu");




var $fdb53c189abb406c$exports = {};
'use strict';
Object.defineProperty($fdb53c189abb406c$exports, "__esModule", {
    value: true
});
var $a27ed38cb47779fb$exports = {};
'use strict';
Object.defineProperty($a27ed38cb47779fb$exports, "__esModule", {
    value: true
});
var $a27ed38cb47779fb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $a27ed38cb47779fb$var$React = $a27ed38cb47779fb$var$_interopRequireWildcard($7fPBF);
var $d97cae922f83a46c$exports = {};
'use strict';
Object.defineProperty($d97cae922f83a46c$exports, "__esModule", {
    value: true
});

var $7fPBF = parcelRequire("7fPBF");
var $d97cae922f83a46c$var$React = $d97cae922f83a46c$var$_interopRequireWildcard($7fPBF);
function $d97cae922f83a46c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
$d97cae922f83a46c$exports.default = function(decoratedHref, decoratedText, key) {
    return $d97cae922f83a46c$var$React.createElement('a', {
        href: decoratedHref,
        key: key
    }, decoratedText);
};


var $a27ed38cb47779fb$var$_defaultComponentDecorator2 = $a27ed38cb47779fb$var$_interopRequireDefault($d97cae922f83a46c$exports);
var $30e15dfe5712f1fc$exports = {};
"use strict";
Object.defineProperty($30e15dfe5712f1fc$exports, "__esModule", {
    value: true
});
$30e15dfe5712f1fc$exports.default = function(href) {
    return href;
};


var $a27ed38cb47779fb$var$_defaultHrefDecorator2 = $a27ed38cb47779fb$var$_interopRequireDefault($30e15dfe5712f1fc$exports);
var $44a362d350fa9fe7$exports = {};
'use strict';
Object.defineProperty($44a362d350fa9fe7$exports, "__esModule", {
    value: true
});
var $f939b866251b1587$exports = {};
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $f939b866251b1587$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $f939b866251b1587$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $f939b866251b1587$var$isString(obj) {
    return $f939b866251b1587$var$_class(obj) === '[object String]';
}
function $f939b866251b1587$var$isObject(obj) {
    return $f939b866251b1587$var$_class(obj) === '[object Object]';
}
function $f939b866251b1587$var$isRegExp(obj) {
    return $f939b866251b1587$var$_class(obj) === '[object RegExp]';
}
function $f939b866251b1587$var$isFunction(obj) {
    return $f939b866251b1587$var$_class(obj) === '[object Function]';
}
function $f939b866251b1587$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $f939b866251b1587$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $f939b866251b1587$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $f939b866251b1587$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $f939b866251b1587$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $f939b866251b1587$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $f939b866251b1587$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $f939b866251b1587$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $f939b866251b1587$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $f939b866251b1587$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $f939b866251b1587$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("cs61D"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($f939b866251b1587$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($f939b866251b1587$var$isObject(val)) {
            if ($f939b866251b1587$var$isRegExp(val.validate)) compiled.validate = $f939b866251b1587$var$createValidator(val.validate);
            else if ($f939b866251b1587$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($f939b866251b1587$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $f939b866251b1587$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($f939b866251b1587$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $f939b866251b1587$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($f939b866251b1587$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $f939b866251b1587$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $f939b866251b1587$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $f939b866251b1587$var$createMatch(self, shift) {
    var match = new $f939b866251b1587$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $f939b866251b1587$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $f939b866251b1587$var$LinkifyIt)) return new $f939b866251b1587$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($f939b866251b1587$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $f939b866251b1587$var$assign({}, $f939b866251b1587$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $f939b866251b1587$var$assign({}, $f939b866251b1587$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $f939b866251b1587$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $f939b866251b1587$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $f939b866251b1587$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $f939b866251b1587$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $f939b866251b1587$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $f939b866251b1587$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $f939b866251b1587$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $f939b866251b1587$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $f939b866251b1587$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $f939b866251b1587$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($f939b866251b1587$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($f939b866251b1587$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $f939b866251b1587$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $f939b866251b1587$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $f939b866251b1587$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $f939b866251b1587$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $f939b866251b1587$var$LinkifyIt.prototype.onCompile = function onCompile() {};
$f939b866251b1587$exports = $f939b866251b1587$var$LinkifyIt;


var $44a362d350fa9fe7$var$_linkifyIt2 = $44a362d350fa9fe7$var$_interopRequireDefault($f939b866251b1587$exports);
var $b82a897db15ba6f5$exports = {};
$b82a897db15ba6f5$exports = JSON.parse('["aaa","aarp","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dunlop","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","link","live","living","lk","llc","llp","loan","loans","locker","locus","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mv","mw","mx","my","mz","na","nab","nagoya","name","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shell","shia","shiksha","shoes","shop","shopping","shouji","show","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","verm\xf6gensberater","verm\xf6gensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volvo","vote","voting","voto","voyage","vu","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","\u03B5\u03BB","\u03B5\u03C5","\u0431\u0433","\u0431\u0435\u043B","\u0434\u0435\u0442\u0438","\u0435\u044E","\u043A\u0430\u0442\u043E\u043B\u0438\u043A","\u043A\u043E\u043C","\u043C\u043A\u0434","\u043C\u043E\u043D","\u043C\u043E\u0441\u043A\u0432\u0430","\u043E\u043D\u043B\u0430\u0439\u043D","\u043E\u0440\u0433","\u0440\u0443\u0441","\u0440\u0444","\u0441\u0430\u0439\u0442","\u0441\u0440\u0431","\u0443\u043A\u0440","\u049B\u0430\u0437","\u0570\u0561\u0575","\u05D9\u05E9\u05E8\u05D0\u05DC","\u05E7\u05D5\u05DD","\u0627\u0628\u0648\u0638\u0628\u064A","\u0627\u0631\u0627\u0645\u0643\u0648","\u0627\u0644\u0627\u0631\u062F\u0646","\u0627\u0644\u0628\u062D\u0631\u064A\u0646","\u0627\u0644\u062C\u0632\u0627\u0626\u0631","\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629","\u0627\u0644\u0639\u0644\u064A\u0627\u0646","\u0627\u0644\u0645\u063A\u0631\u0628","\u0627\u0645\u0627\u0631\u0627\u062A","\u0627\u06CC\u0631\u0627\u0646","\u0628\u0627\u0631\u062A","\u0628\u0627\u0632\u0627\u0631","\u0628\u064A\u062A\u0643","\u0628\u06BE\u0627\u0631\u062A","\u062A\u0648\u0646\u0633","\u0633\u0648\u062F\u0627\u0646","\u0633\u0648\u0631\u064A\u0629","\u0634\u0628\u0643\u0629","\u0639\u0631\u0627\u0642","\u0639\u0631\u0628","\u0639\u0645\u0627\u0646","\u0641\u0644\u0633\u0637\u064A\u0646","\u0642\u0637\u0631","\u0643\u0627\u062B\u0648\u0644\u064A\u0643","\u0643\u0648\u0645","\u0645\u0635\u0631","\u0645\u0644\u064A\u0633\u064A\u0627","\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627","\u0645\u0648\u0642\u0639","\u0647\u0645\u0631\u0627\u0647","\u067E\u0627\u06A9\u0633\u062A\u0627\u0646","\u0680\u0627\u0631\u062A","\u0915\u0949\u092E","\u0928\u0947\u091F","\u092D\u093E\u0930\u0924","\u092D\u093E\u0930\u0924\u092E\u094D","\u092D\u093E\u0930\u094B\u0924","\u0938\u0902\u0917\u0920\u0928","\u09AC\u09BE\u0982\u09B2\u09BE","\u09AD\u09BE\u09B0\u09A4","\u09AD\u09BE\u09F0\u09A4","\u0A2D\u0A3E\u0A30\u0A24","\u0AAD\u0ABE\u0AB0\u0AA4","\u0B2D\u0B3E\u0B30\u0B24","\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE","\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8","\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD","\u0C2D\u0C3E\u0C30\u0C24\u0C4D","\u0CAD\u0CBE\u0CB0\u0CA4","\u0D2D\u0D3E\u0D30\u0D24\u0D02","\u0DBD\u0D82\u0D9A\u0DCF","\u0E04\u0E2D\u0E21","\u0E44\u0E17\u0E22","\u0EA5\u0EB2\u0EA7","\u10D2\u10D4","\u307F\u3093\u306A","\u30A2\u30DE\u30BE\u30F3","\u30AF\u30E9\u30A6\u30C9","\u30B0\u30FC\u30B0\u30EB","\u30B3\u30E0","\u30B9\u30C8\u30A2","\u30BB\u30FC\u30EB","\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3","\u30DD\u30A4\u30F3\u30C8","\u4E16\u754C","\u4E2D\u4FE1","\u4E2D\u56FD","\u4E2D\u570B","\u4E2D\u6587\u7F51","\u4E9A\u9A6C\u900A","\u4F01\u4E1A","\u4F5B\u5C71","\u4FE1\u606F","\u5065\u5EB7","\u516B\u5366","\u516C\u53F8","\u516C\u76CA","\u53F0\u6E7E","\u53F0\u7063","\u5546\u57CE","\u5546\u5E97","\u5546\u6807","\u5609\u91CC","\u5609\u91CC\u5927\u9152\u5E97","\u5728\u7EBF","\u5927\u62FF","\u5929\u4E3B\u6559","\u5A31\u4E50","\u5BB6\u96FB","\u5E7F\u4E1C","\u5FAE\u535A","\u6148\u5584","\u6211\u7231\u4F60","\u624B\u673A","\u62DB\u8058","\u653F\u52A1","\u653F\u5E9C","\u65B0\u52A0\u5761","\u65B0\u95FB","\u65F6\u5C1A","\u66F8\u7C4D","\u673A\u6784","\u6DE1\u9A6C\u9521","\u6E38\u620F","\u6FB3\u9580","\u70B9\u770B","\u79FB\u52A8","\u7EC4\u7EC7\u673A\u6784","\u7F51\u5740","\u7F51\u5E97","\u7F51\u7AD9","\u7F51\u7EDC","\u8054\u901A","\u8C37\u6B4C","\u8D2D\u7269","\u901A\u8CA9","\u96C6\u56E2","\u96FB\u8A0A\u76C8\u79D1","\u98DE\u5229\u6D66","\u98DF\u54C1","\u9910\u5385","\u9999\u683C\u91CC\u62C9","\u9999\u6E2F","\uB2F7\uB137","\uB2F7\uCEF4","\uC0BC\uC131","\uD55C\uAD6D"]');


var $44a362d350fa9fe7$var$_tlds2 = $44a362d350fa9fe7$var$_interopRequireDefault($b82a897db15ba6f5$exports);
function $44a362d350fa9fe7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $44a362d350fa9fe7$var$linkify = new $44a362d350fa9fe7$var$_linkifyIt2.default();
$44a362d350fa9fe7$var$linkify.tlds($44a362d350fa9fe7$var$_tlds2.default);
$44a362d350fa9fe7$exports.default = function(text) {
    return $44a362d350fa9fe7$var$linkify.match(text);
};


var $a27ed38cb47779fb$var$_defaultMatchDecorator2 = $a27ed38cb47779fb$var$_interopRequireDefault($44a362d350fa9fe7$exports);
var $6d2d28f2d497b260$exports = {};
"use strict";
Object.defineProperty($6d2d28f2d497b260$exports, "__esModule", {
    value: true
});
$6d2d28f2d497b260$exports.default = function(text) {
    return text;
};


var $a27ed38cb47779fb$var$_defaultTextDecorator2 = $a27ed38cb47779fb$var$_interopRequireDefault($6d2d28f2d497b260$exports);
function $a27ed38cb47779fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a27ed38cb47779fb$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $a27ed38cb47779fb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a27ed38cb47779fb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a27ed38cb47779fb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a27ed38cb47779fb$var$Linkify = function(_React$Component) {
    $a27ed38cb47779fb$var$_inherits(Linkify, _React$Component);
    function Linkify() {
        $a27ed38cb47779fb$var$_classCallCheck(this, Linkify);
        return $a27ed38cb47779fb$var$_possibleConstructorReturn(this, (Linkify.__proto__ || Object.getPrototypeOf(Linkify)).apply(this, arguments));
    }
    $a27ed38cb47779fb$var$_createClass(Linkify, [
        {
            key: 'parseString',
            value: function parseString(string) {
                var _this2 = this;
                if (string === '') return string;
                var matches = this.props.matchDecorator(string);
                if (!matches) return string;
                var elements = [];
                var lastIndex = 0;
                matches.forEach(function(match, i) {
                    // Push preceding text if there is any
                    if (match.index > lastIndex) elements.push(string.substring(lastIndex, match.index));
                    var decoratedHref = _this2.props.hrefDecorator(match.url);
                    var decoratedText = _this2.props.textDecorator(match.text);
                    var decoratedComponent = _this2.props.componentDecorator(decoratedHref, decoratedText, i);
                    elements.push(decoratedComponent);
                    lastIndex = match.lastIndex;
                });
                // Push remaining text if there is any
                if (string.length > lastIndex) elements.push(string.substring(lastIndex));
                return elements.length === 1 ? elements[0] : elements;
            }
        },
        {
            key: 'parse',
            value: function parse(children) {
                var _this3 = this;
                var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (typeof children === 'string') return this.parseString(children);
                else if ($a27ed38cb47779fb$var$React.isValidElement(children) && children.type !== 'a' && children.type !== 'button') return $a27ed38cb47779fb$var$React.cloneElement(children, {
                    key: key
                }, this.parse(children.props.children));
                else if (Array.isArray(children)) return children.map(function(child, i) {
                    return _this3.parse(child, i);
                });
                return children;
            }
        },
        {
            key: 'render',
            value: function render() {
                return $a27ed38cb47779fb$var$React.createElement($a27ed38cb47779fb$var$React.Fragment, null, this.parse(this.props.children));
            }
        }
    ]);
    return Linkify;
}($a27ed38cb47779fb$var$React.Component);
$a27ed38cb47779fb$var$Linkify.defaultProps = {
    componentDecorator: $a27ed38cb47779fb$var$_defaultComponentDecorator2.default,
    hrefDecorator: $a27ed38cb47779fb$var$_defaultHrefDecorator2.default,
    matchDecorator: $a27ed38cb47779fb$var$_defaultMatchDecorator2.default,
    textDecorator: $a27ed38cb47779fb$var$_defaultTextDecorator2.default
};
$a27ed38cb47779fb$exports.default = $a27ed38cb47779fb$var$Linkify;


var $fdb53c189abb406c$var$_Linkify2 = $fdb53c189abb406c$var$_interopRequireDefault($a27ed38cb47779fb$exports);
function $fdb53c189abb406c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$fdb53c189abb406c$exports.default = $fdb53c189abb406c$var$_Linkify2.default;


const $432444006420a8b4$var$Linkify = (_param)=>{
    var { children: children } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "children"
    ]);
    const componentDecorator = (href, text, key)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            children: text
        }, key);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fdb53c189abb406c$exports))), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        componentDecorator: componentDecorator
    }, props), {
        children: children
    }));
};
var $432444006420a8b4$export$2e2bcd8739ae039 = $432444006420a8b4$var$Linkify;


const $958b872cea20a57f$var$TextAnswer = ({ textAnswerTodisplay: textAnswerTodisplay })=>{
    const useStyles = (0, $by0pu.default)((theme)=>({
            textAnswerCard: {
                width: '383px',
                background: '#F4F4F4',
                borderRadius: '0px 4px 4px 0px',
                color: '#666666',
                position: 'relative',
                margin: '10px 0px 10px 0px',
                overflow: 'auto',
                borderColor: '#F4F4F4',
                [theme.breakpoints.down('md')]: {
                    width: '138px'
                }
            },
            text: {
                position: 'absolute',
                margin: '10px',
                fontSize: '12px'
            }
        }));
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $edd72516fdfce69a$export$2e2bcd8739ae039), {
        className: classes.textAnswerCard,
        variant: 'outlined',
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $971cc648873ffa19$export$2e2bcd8739ae039), {
            className: classes.text,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $432444006420a8b4$export$2e2bcd8739ae039), {
                children: textAnswerTodisplay
            })
        })
    });
};
var $958b872cea20a57f$export$2e2bcd8739ae039 = $958b872cea20a57f$var$TextAnswer;



const $86029f3e572210b6$var$CardSelectorAndEvaluationDialogContainer = ({ rate: rate, rateable: rateable, doughnutChartColor: doughnutChartColor, idOfCurrentUser: idOfCurrentUser, onSubmitSuccess: onSubmitSuccess })=>{
    const [dialogOpen, setDialogOpen] = (0, $7fPBF.useState)(false);
    const isOnlyText = rate.criteria.criteria_type === (0, $f6e729db3f817bb5$exports.CRITERIA_TYPES).ONLY_TEXT;
    const selectCardToDisplay = (valueToDisplay)=>valueToDisplay || valueToDisplay === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2d9e69b73fc50a78$export$2e2bcd8739ae039), {
            nameToDisplay: rate.criteria.criteria_name.hu,
            valueToDisplay: valueToDisplay,
            rateable: rateable,
            color: doughnutChartColor,
            handleDialogeOpen: ()=>setDialogOpen(true)
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $59ef8489b4c717b5$export$2e2bcd8739ae039), {
            nameToDisplay: rate.criteria.criteria_name.hu,
            rateable: rateable,
            handleDialogeOpen: ()=>setDialogOpen(true),
            isOnlyText: isOnlyText,
            textAnswer: rate.text
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                direction: 'row',
                children: [
                    selectCardToDisplay(rate.value),
                    rate.text && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $958b872cea20a57f$export$2e2bcd8739ae039), {
                        textAnswerTodisplay: rate.text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9172051f9afe01c8$export$2e2bcd8739ae039), {
                open: dialogOpen,
                handleClose: ()=>setDialogOpen(false),
                nameOfCriteria: rate.criteria.criteria_name.hu,
                rateOfCriteria: rate,
                employeeId: idOfCurrentUser,
                isOnlyText: isOnlyText,
                onSubmitSuccess: onSubmitSuccess
            })
        ]
    });
};
var $86029f3e572210b6$export$2e2bcd8739ae039 = $86029f3e572210b6$var$CardSelectorAndEvaluationDialogContainer;


const $ad6e14ee7b22c953$var$AverageOfRatesOfObjective = ({ averageOfObjectiveRates: averageOfObjectiveRates })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86029f3e572210b6$export$2e2bcd8739ae039), {
        rate: {
            value: isNaN(averageOfObjectiveRates) ? undefined : averageOfObjectiveRates,
            criteria: {
                criteria_name: {
                    hu: t('objective.average.title')
                }
            }
        },
        rateable: false,
        doughnutChartColor: (0, $f6e729db3f817bb5$exports.DOUGHNUT_CHART_COLORS).GREEN
    });
};
var $ad6e14ee7b22c953$export$2e2bcd8739ae039 = $ad6e14ee7b22c953$var$AverageOfRatesOfObjective;



parcelRequire("7fPBF");


var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");





var $7fPBF = parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");




parcelRequire("7fPBF");


var $fwAOd = parcelRequire("fwAOd");
var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $3Sc7z = parcelRequire("3Sc7z");

var $1rW9t = parcelRequire("1rW9t");
var $8c20b368aae28118$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        marginBottom: 12
    }
};
var $8c20b368aae28118$var$DialogContentText = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContentText(props, ref) {
    return /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), (0, $kY3Ke.default)({
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref
    }, props));
});
var $8c20b368aae28118$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($8c20b368aae28118$export$9dd6ff9ea0189349, {
    name: 'MuiDialogContentText'
})($8c20b368aae28118$var$DialogContentText);






const $cca43849ade6c08e$export$4298b47e5970e27c = ({ objective: objective, evaluationStatusDialogOpen: evaluationStatusDialogOpen, setEvaluationStatusDialogOpen: setEvaluationStatusDialogOpen, isEvaluationClosed: isEvaluationClosed, appraiserId: appraiserId, onSubmitSuccess: onSubmitSuccess })=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const updateObjectiveRateLockMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>(0, $0bc299533abf3517$export$3f29b9112c52725a)({
            objective: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
                isEvaluationClosed: isEvaluationClosed,
                appraiserId: appraiserId
            })
        }), {
        onSuccess: ()=>{
            onSubmitSuccess();
            setEvaluationStatusDialogOpen(false);
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
        open: evaluationStatusDialogOpen,
        onClose: ()=>setEvaluationStatusDialogOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                children: t('objective.evaluation.status.dialog.lock.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c20b368aae28118$export$2e2bcd8739ae039), {
                    children: t('objective.evaluation.status.dialog.lock.description')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: updateObjectiveRateLockMutation.mutate,
                        color: "primary",
                        variant: "contained",
                        children: t('objective.evaluation.status.dialog.lock.confirm')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: ()=>setEvaluationStatusDialogOpen(false),
                        color: "primary",
                        autoFocus: true,
                        children: t('objective.evaluation.status.dialog.cancel')
                    })
                ]
            })
        ]
    });
};


const $bc0fad4ce82b0246$export$c57b5c659140899 = ({ rateable: rateable, raterDone: raterDone, isEvaluationClosed: isEvaluationClosed, isCurrentUser: isCurrentUser, objective: objective, appraiserId: appraiserId, onSubmitSuccess: onSubmitSuccess })=>{
    const [evaluationStatusDialogOpen, setEvaluationStatusDialogOpen] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const useStyles = (0, $by0pu.default)({
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: '521px',
            marginBottom: '15px'
        }
    });
    const classes = useStyles();
    return isCurrentUser && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                className: classes.container,
                container: true,
                direction: 'row',
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: ()=>setEvaluationStatusDialogOpen(true),
                    disabled: !rateable || !raterDone,
                    variant: "contained",
                    color: "primary",
                    children: t('objective.evaluation.status.lock.button')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cca43849ade6c08e$export$4298b47e5970e27c), {
                objective: objective,
                evaluationStatusDialogOpen: evaluationStatusDialogOpen,
                setEvaluationStatusDialogOpen: setEvaluationStatusDialogOpen,
                isEvaluationClosed: isEvaluationClosed,
                appraiserId: appraiserId,
                onSubmitSuccess: onSubmitSuccess
            })
        ]
    });
};


const $ec6b3996af44999d$var$CriteriaEvaluationsGroupedByEmployees = ({ objective: objective, objectiveRates: objectiveRates, onSubmitSuccess: onSubmitSuccess })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { appraisers: appraisers, criterias: criterias } = objective.appraisers_and_criterias;
    const idOfCurrentUser = objective.employee_id;
    const appraisersWithCurrentUserFirst = [
        ...appraisers.filter((appraiser)=>appraiser.employee_id === idOfCurrentUser),
        ...appraisers.filter((appraiser)=>appraiser.employee_id !== idOfCurrentUser)
    ];
    const getEvaluationRate = (objectiveRates, employeeId, criterion)=>{
        var _objectiveRates_find;
        return (_objectiveRates_find = objectiveRates.find((rate)=>rate.rated_by === employeeId && rate.criteria.criteria_id === criterion.criteria_id)) !== null && _objectiveRates_find !== void 0 ? _objectiveRates_find : {
            objective_id: objective.objective_id,
            criteria: criterion
        };
    };
    const getIfRateable = (employeeId, evaluationClosed)=>employeeId === idOfCurrentUser && objective.status === (0, $f6e729db3f817bb5$exports.STATUS).COMPLETED && !evaluationClosed;
    const getColorForDoughnutChart = (employeeId)=>idOfCurrentUser === employeeId ? (0, $f6e729db3f817bb5$exports.DOUGHNUT_CHART_COLORS).BLUE : (0, $f6e729db3f817bb5$exports.DOUGHNUT_CHART_COLORS).PURPLE;
    const getEvaluationStatusText = (evaluationClosed)=>evaluationClosed ? t('objective.appraiser.status.closed') : t('objective.appraiser.status.inProgress');
    const useStyles = (0, $by0pu.default)({
        name: {
            color: '#999999',
            fontSize: '16px',
            textTransform: 'uppercase'
        },
        infoBox: {
            margin: '5px'
        }
    });
    const classes = useStyles();
    return appraisersWithCurrentUserFirst.map((appraiser)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
            item: true,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                    className: classes.name,
                    children: `${appraiser.name}
         ${t('objective.appraiser.evaluation')}
         ${getEvaluationStatusText(appraiser.evaluationClosed)}`
                }),
                (appraiser === null || appraiser === void 0 ? void 0 : appraiser.employee_id) !== idOfCurrentUser && (appraiser === null || appraiser === void 0 ? void 0 : appraiser.evaluationClosed) !== true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                    className: classes.infoBox,
                    children: t('objective.average.not_available_yet')
                }) : criterias.map((criterion)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86029f3e572210b6$export$2e2bcd8739ae039), {
                        rate: getEvaluationRate(objectiveRates, appraiser.employee_id, criterion),
                        rateable: getIfRateable(appraiser.employee_id, appraiser.evaluationClosed),
                        doughnutChartColor: getColorForDoughnutChart(appraiser.employee_id),
                        idOfCurrentUser: idOfCurrentUser,
                        onSubmitSuccess: onSubmitSuccess
                    }, criterion.criteria_id)),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc0fad4ce82b0246$export$c57b5c659140899), {
                    rateable: getIfRateable(appraiser.employee_id, appraiser.evaluationClosed),
                    raterDone: (0, $c63aae241875c1a0$exports.isRaterDone)(objective, objectiveRates, appraiser.employee_id),
                    isEvaluationClosed: !!appraiser.evaluationClosed,
                    isCurrentUser: idOfCurrentUser === appraiser.employee_id,
                    objective: objective,
                    appraiserId: appraiser.employee_id,
                    onSubmitSuccess: onSubmitSuccess
                })
            ]
        }, appraiser.employee_id));
};
var $ec6b3996af44999d$export$2e2bcd8739ae039 = $ec6b3996af44999d$var$CriteriaEvaluationsGroupedByEmployees;




var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $8178b6fc0e340708$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M6 4v3.17c0 .53.21 1.04.59 1.42L10 12l-3.42 3.42c-.37.38-.58.89-.58 1.42V20c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-3.16c0-.53-.21-1.04-.58-1.41L14 12l3.41-3.4c.38-.38.59-.89.59-1.42V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2z"
}), 'HourglassFullRounded');


const $8e9d2e17cb2f0f04$var$useStyles = (0, $by0pu.default)({
    root: {
        minWidth: '531px'
    },
    title: {
        color: '#999999',
        fontSize: '16px',
        textTransform: 'uppercase'
    },
    baseText: {
        fontSize: '16px',
        marginBottom: '10px',
        maxWidth: '531px',
        whiteSpace: 'pre-wrap'
    },
    infoBox: {
        margin: '5px'
    },
    icon: {
        color: '#C69060'
    },
    appraiserName: {
        marginLeft: '8px'
    },
    appraisersWrapper: {
        display: 'flex',
        alignItems: 'baseline'
    }
}, {
    name: 'ObjectiveInfo'
});
const $8e9d2e17cb2f0f04$var$ObjectiveInfo = ({ objective: objective, objectiveRates: objectiveRates, averageOfObjectiveRates: averageOfObjectiveRates, isPanelOpened: isPanelOpened, onSubmitSuccess: onSubmitSuccess })=>{
    var _objective_appraisers_and_criterias;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $8e9d2e17cb2f0f04$var$useStyles();
    const getApprasiersOfObjective = (objective)=>{
        const { appraisers_and_criterias: { appraisers: appraisers }, approvals: approvals, status: status } = objective || {};
        const approvalIds = approvals.map(({ employee_id: employee_id })=>employee_id);
        if (status === (0, $f6e729db3f817bb5$exports.STATUS).PROPOSED) {
            const renderNames = (appraisers)=>{
                const displayName = appraisers.map(({ employee_id: employee_id, name: name }, index)=>{
                    return approvalIds.includes(employee_id) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                        placement: "top",
                        title: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            variant: "body2",
                            children: t('objective.alert.acceptWarning')
                        }),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d57f8c5132119daf$export$2e2bcd8739ae039), {
                            display: "flex",
                            alignItems: "end",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                    variant: "body2",
                                    display: "initial",
                                    className: index !== 0 && classes.appraiserName,
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8178b6fc0e340708$export$2e2bcd8739ae039), {
                                    className: classes.icon
                                }),
                                index < appraisers.length - 1 && ','
                            ]
                        })
                    }, employee_id) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1rW9t.default), {
                        variant: "body2",
                        className: index !== 0 && classes.appraiserName,
                        children: [
                            name,
                            index < appraisers.length - 1 && ','
                        ]
                    }, employee_id);
                });
                return displayName;
            };
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: classes.appraisersWrapper,
                children: renderNames(appraisers)
            });
        } else return appraisers.map(({ name: name })=>name).join(', ');
    };
    return isPanelOpened ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        container: true,
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.title,
                component: "div",
                children: t('objective.description')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.baseText,
                component: "div",
                children: objective.description
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.title,
                component: "div",
                children: t('objective.appraisers')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.baseText,
                component: "div",
                children: getApprasiersOfObjective(objective)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.title,
                component: "div",
                children: t('objective.average.title')
            }),
            (0, $2409c916ecc098c0$export$d25ab5c0afe207fe)(objective === null || objective === void 0 ? void 0 : (_objective_appraisers_and_criterias = objective.appraisers_and_criterias) === null || _objective_appraisers_and_criterias === void 0 ? void 0 : _objective_appraisers_and_criterias.appraisers) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ad6e14ee7b22c953$export$2e2bcd8739ae039), {
                averageOfObjectiveRates: averageOfObjectiveRates
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.infoBox,
                children: t('objective.average.not_available_yet')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ec6b3996af44999d$export$2e2bcd8739ae039), {
                objective: objective,
                objectiveRates: objectiveRates,
                onSubmitSuccess: onSubmitSuccess
            })
        ]
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {});
};
var $8e9d2e17cb2f0f04$export$2e2bcd8739ae039 = $8e9d2e17cb2f0f04$var$ObjectiveInfo;






var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $86a6140e16b13821$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $dQMrF.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            display: 'block'
        }, theme.breakpoints.up('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `disableGutters={true}`. */ disableGutters: {
            paddingLeft: 0,
            paddingRight: 0
        },
        /* Styles applied to the root element if `fixed={true}`. */ fixed: Object.keys(theme.breakpoints.values).reduce(function(acc, breakpoint) {
            var value = theme.breakpoints.values[breakpoint];
            if (value !== 0) acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: value
            };
            return acc;
        }, {}),
        /* Styles applied to the root element if `maxWidth="xs"`. */ maxWidthXs: (0, $dQMrF.default)({}, theme.breakpoints.up('xs'), {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444)
        }),
        /* Styles applied to the root element if `maxWidth="sm"`. */ maxWidthSm: (0, $dQMrF.default)({}, theme.breakpoints.up('sm'), {
            maxWidth: theme.breakpoints.values.sm
        }),
        /* Styles applied to the root element if `maxWidth="md"`. */ maxWidthMd: (0, $dQMrF.default)({}, theme.breakpoints.up('md'), {
            maxWidth: theme.breakpoints.values.md
        }),
        /* Styles applied to the root element if `maxWidth="lg"`. */ maxWidthLg: (0, $dQMrF.default)({}, theme.breakpoints.up('lg'), {
            maxWidth: theme.breakpoints.values.lg
        }),
        /* Styles applied to the root element if `maxWidth="xl"`. */ maxWidthXl: (0, $dQMrF.default)({}, theme.breakpoints.up('xl'), {
            maxWidth: theme.breakpoints.values.xl
        })
    };
};
var $86a6140e16b13821$var$Container = /*#__PURE__*/ $7fPBF.forwardRef(function Container(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$fixed = props.fixed, fixed = _props$fixed === void 0 ? false : _props$fixed, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "fixed",
        "maxWidth"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, $dKzJP.default)(String(maxWidth)))]),
        ref: ref
    }, other));
});
var $86a6140e16b13821$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($86a6140e16b13821$export$9dd6ff9ea0189349, {
    name: 'MuiContainer'
})($86a6140e16b13821$var$Container);


var $lLRv0 = parcelRequire("lLRv0");
var $by0pu = parcelRequire("by0pu");
var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $kVsLZ = parcelRequire("kVsLZ");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $9c76cb0722134d9f$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');



var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var /**
 * @ignore - internal component.
 */ $95d58b183d97a49c$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $3Sc7z = parcelRequire("3Sc7z");
var $9bbcca4655b75c84$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: 'relative',
            display: 'flex',
            '&$checked $layer': {
                transform: 'scale(1)',
                transition: theme.transitions.create('transform', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.shortest
                })
            }
        },
        layer: {
            left: 0,
            position: 'absolute',
            transform: 'scale(0)',
            transition: theme.transitions.create('transform', {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.shortest
            })
        },
        checked: {}
    };
};
/**
 * @ignore - internal component.
 */ function $9bbcca4655b75c84$var$RadioButtonIcon(props) {
    var checked = props.checked, classes = props.classes, fontSize = props.fontSize;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $jtRae.default)(classes.root, checked && classes.checked)
    }, /*#__PURE__*/ $7fPBF.createElement((0, $9c76cb0722134d9f$export$2e2bcd8739ae039), {
        fontSize: fontSize
    }), /*#__PURE__*/ $7fPBF.createElement((0, $95d58b183d97a49c$export$2e2bcd8739ae039), {
        fontSize: fontSize,
        className: classes.layer
    }));
}
var $9bbcca4655b75c84$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($9bbcca4655b75c84$export$9dd6ff9ea0189349, {
    name: 'PrivateRadioButtonIcon'
})($9bbcca4655b75c84$var$RadioButtonIcon);



var $2jEfe = parcelRequire("2jEfe");

var $dKzJP = parcelRequire("dKzJP");

var $5oAE5 = parcelRequire("5oAE5");

var $3Sc7z = parcelRequire("3Sc7z");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ var $0c8707430385c257$var$RadioGroupContext = $7fPBF.createContext();
var $0c8707430385c257$export$2e2bcd8739ae039 = $0c8707430385c257$var$RadioGroupContext;


function $48152382b729ca33$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $0c8707430385c257$export$2e2bcd8739ae039));
}


var $d3a3a7167ebe47fc$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $2jEfe.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $2jEfe.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $d3a3a7167ebe47fc$var$defaultCheckedIcon = /*#__PURE__*/ $7fPBF.createElement((0, $9bbcca4655b75c84$export$2e2bcd8739ae039), {
    checked: true
});
var $d3a3a7167ebe47fc$var$defaultIcon = /*#__PURE__*/ $7fPBF.createElement((0, $9bbcca4655b75c84$export$2e2bcd8739ae039), null);
var $d3a3a7167ebe47fc$var$Radio = /*#__PURE__*/ $7fPBF.forwardRef(function Radio(props, ref) {
    var checkedProp = props.checked, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, nameProp = props.name, onChangeProp = props.onChange, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $lfiYO.default)(props, [
        "checked",
        "classes",
        "color",
        "name",
        "onChange",
        "size"
    ]);
    var radioGroup = (0, $48152382b729ca33$export$2e2bcd8739ae039)();
    var checked = checkedProp;
    var onChange = (0, $5oAE5.default)(onChangeProp, radioGroup && radioGroup.onChange);
    var name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = radioGroup.value === props.value;
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ $7fPBF.createElement((0, $kVsLZ.default), (0, $kY3Ke.default)({
        color: color,
        type: "radio",
        icon: /*#__PURE__*/ $7fPBF.cloneElement($d3a3a7167ebe47fc$var$defaultIcon, {
            fontSize: size === 'small' ? 'small' : 'medium'
        }),
        checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement($d3a3a7167ebe47fc$var$defaultCheckedIcon, {
            fontSize: size === 'small' ? 'small' : 'medium'
        }),
        classes: {
            root: (0, $jtRae.default)(classes.root, classes["color".concat((0, $dKzJP.default)(color))]),
            checked: classes.checked,
            disabled: classes.disabled
        },
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref
    }, other));
});
var $d3a3a7167ebe47fc$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($d3a3a7167ebe47fc$export$9dd6ff9ea0189349, {
    name: 'MuiRadio'
})($d3a3a7167ebe47fc$var$Radio);


var $kY3Ke = parcelRequire("kY3Ke");

var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");
var $597375740cdc67aa$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    },
    /* Styles applied to the root element if `row={true}`. */ row: {
        flexDirection: 'row'
    }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ var $597375740cdc67aa$var$FormGroup = /*#__PURE__*/ $7fPBF.forwardRef(function FormGroup(props, ref) {
    var classes = props.classes, className = props.className, _props$row = props.row, row = _props$row === void 0 ? false : _props$row, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "row"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, row && classes.row),
        ref: ref
    }, other));
});
var $597375740cdc67aa$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($597375740cdc67aa$export$9dd6ff9ea0189349, {
    name: 'MuiFormGroup'
})($597375740cdc67aa$var$FormGroup);



var $55RWP = parcelRequire("55RWP");

var $3deDh = parcelRequire("3deDh");


var $ejsyu = parcelRequire("ejsyu");
var $440df831f575b8c2$var$RadioGroup = /*#__PURE__*/ $7fPBF.forwardRef(function RadioGroup(props, ref) {
    var actions = props.actions, children = props.children, nameProp = props.name, valueProp = props.value, onChange = props.onChange, other = (0, $lfiYO.default)(props, [
        "actions",
        "children",
        "name",
        "value",
        "onChange"
    ]);
    var rootRef = $7fPBF.useRef(null);
    var _useControlled = (0, $3deDh.default)({
        controlled: valueProp,
        default: props.defaultValue,
        name: 'RadioGroup'
    }), _useControlled2 = (0, $2gIIh.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    $7fPBF.useImperativeHandle(actions, function() {
        return {
            focus: function focus() {
                var input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        };
    }, []);
    var handleRef = (0, $55RWP.default)(ref, rootRef);
    var handleChange = function handleChange(event) {
        setValue(event.target.value);
        if (onChange) onChange(event, event.target.value);
    };
    var name = (0, $ejsyu.default)(nameProp);
    return /*#__PURE__*/ $7fPBF.createElement((0, $0c8707430385c257$export$2e2bcd8739ae039).Provider, {
        value: {
            name: name,
            onChange: handleChange,
            value: value
        }
    }, /*#__PURE__*/ $7fPBF.createElement((0, $597375740cdc67aa$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        role: "radiogroup",
        ref: handleRef
    }, other), children));
});
var $440df831f575b8c2$export$2e2bcd8739ae039 = $440df831f575b8c2$var$RadioGroup;


var $1rW9t = parcelRequire("1rW9t");



parcelRequire("7fPBF");


const $d37c81fe4282e60a$var$DevelopmentStatusChip = ({ label: label, developmentStatus: developmentStatus })=>{
    const classes = (0, $099b64aead0697bf$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $812a279261d3d883$export$2e2bcd8739ae039), {
        label: label,
        className: `${classes[developmentStatus]} ${classes.button}`
    });
};
var $d37c81fe4282e60a$export$2e2bcd8739ae039 = $d37c81fe4282e60a$var$DevelopmentStatusChip;





const $d09ca5af4961575b$var$useStyles = (0, $by0pu.default)({
    container: {
        backgroundColor: '#F4F4F4',
        padding: '20px'
    },
    radiogroup: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #D6D6D6',
        boxSizing: 'border-box',
        borderRadius: '100px',
        maxWidth: '655px',
        width: '100%',
        height: '38px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '10px 10px 20px 0px',
        padding: 0,
        position: 'relative',
        '& .MuiFormControlLabel-root': {
            marginRight: 0
        }
    },
    radio: {
        '& .MuiSvgIcon-root': {
            display: 'none'
        }
    },
    indicator: {
        maxWidth: '30%',
        width: '100%',
        height: '28px',
        position: 'absolute',
        left: 0,
        background: 'blue',
        borderRadius: '100px',
        transition: `transform 600ms cubic-bezier(.02,.94,.09,.97),
         background 300ms cubic-bezier(.17,.67,.14,1.03)`,
        transform: 'translate3d(1rem,0,0)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#FFF',
        lineHeight: '22px',
        padding: '0 8px',
        '@media screen and (max-width: 400px)': {
            maxWidth: '40%'
        },
        '@media screen and (max-width: 350px) and (min-width: 600px), (max-width: 800px)': {
            maxWidth: '45%'
        },
        '@media screen and (max-width: 300px)': {
            maxWidth: '55%'
        }
    },
    title: {
        color: '#999999',
        fontSize: '16px',
        textTransform: 'uppercase'
    }
});
const $d09ca5af4961575b$var$DevelopmentStatus = ({ objective: objective, onSubmitSuccess: onSubmitSuccess })=>{
    const classes = $d09ca5af4961575b$var$useStyles();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [developmentStatus, setDevelopmentStatus] = (0, $7fPBF.useState)(objective.development_status);
    const { IN_DANGER: IN_DANGER, NEUTRAL: NEUTRAL, AWESOME: AWESOME } = (0, $f6e729db3f817bb5$exports.DEVELOPMENT_STATUS);
    const changeDevelopmentStatusMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (developmentStatus)=>{
        return await (0, $553835ea16648c6f$export$fddb30f8f7aab3e3)({
            objective: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
                developmentStatus: developmentStatus
            })
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const handleChange = (event)=>{
        setDevelopmentStatus(event.target.value);
        changeDevelopmentStatusMutation.mutate(event.target.value);
    };
    const addClassName = (name)=>{
        return name === developmentStatus ? `${developmentStatus}-selected` : '';
    };
    const translatedDevelopmentStatus = (type)=>{
        switch(type){
            case IN_DANGER:
                return t('objective.development.status.in-danger');
            case NEUTRAL:
                return t('objective.development.status.neutral');
            case AWESOME:
                return t('objective.development.status.awesome');
            default:
                return t('objective.development.status.neutral');
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $86a6140e16b13821$export$2e2bcd8739ae039), {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.title,
                children: t('objective.development.status.title')
            }),
            objective.status === (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $440df831f575b8c2$export$2e2bcd8739ae039), {
                "aria-label": "development-status",
                name: "development_status",
                value: developmentStatus,
                onChange: handleChange,
                className: classes.radiogroup,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $lLRv0.default), {
                        value: IN_DANGER,
                        className: addClassName(IN_DANGER),
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3a3a7167ebe47fc$export$2e2bcd8739ae039), {
                            className: classes.radio
                        }),
                        label: t('objective.development.status.in-danger')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $lLRv0.default), {
                        value: NEUTRAL,
                        className: addClassName(NEUTRAL),
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3a3a7167ebe47fc$export$2e2bcd8739ae039), {
                            className: classes.radio
                        }),
                        label: t('objective.development.status.neutral')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $lLRv0.default), {
                        value: AWESOME,
                        className: addClassName(AWESOME),
                        control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3a3a7167ebe47fc$export$2e2bcd8739ae039), {
                            className: classes.radio
                        }),
                        label: t('objective.development.status.awesome')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: `switch__indicator ${classes.indicator}`,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: translatedDevelopmentStatus(objective.development_status)
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d37c81fe4282e60a$export$2e2bcd8739ae039), {
                developmentStatus: objective.development_status,
                label: t(`objective.development.status.${objective.development_status}`)
            })
        ]
    });
};
var $d09ca5af4961575b$export$2e2bcd8739ae039 = $d09ca5af4961575b$var$DevelopmentStatus;




var $7fPBF = parcelRequire("7fPBF");



parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");
var $MQfsM = parcelRequire("MQfsM");
var $4e495c2b72081305$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($4e495c2b72081305$exports, "__esModule", {
    value: true
});
$4e495c2b72081305$exports.default = void 0;

var $4e495c2b72081305$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $4e495c2b72081305$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $4e495c2b72081305$var$_default = (0, $4e495c2b72081305$var$_createSvgIcon.default)(/*#__PURE__*/ $4e495c2b72081305$var$React.createElement("path", {
    d: "M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"
}), 'DateRangeOutlined');
$4e495c2b72081305$exports.default = $4e495c2b72081305$var$_default;



var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");



var $jtRae = parcelRequire("jtRae");
parcelRequire("kY3Ke");
parcelRequire("lfiYO");


var $by0pu = parcelRequire("by0pu");

var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");



var $jtRae = parcelRequire("jtRae");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $1rW9t = parcelRequire("1rW9t");

var $lEobJ = parcelRequire("lEobJ");
var $2jEfe = parcelRequire("2jEfe");
var $by0pu = parcelRequire("by0pu");
var $3Sc7z = parcelRequire("3Sc7z");

var $fwAOd = parcelRequire("fwAOd");

var $kGz5b = parcelRequire("kGz5b");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $lEobJ = parcelRequire("lEobJ");
var $by0pu = parcelRequire("by0pu");
var $3Sc7z = parcelRequire("3Sc7z");

var $fwAOd = parcelRequire("fwAOd");




var $9zU0q = parcelRequire("9zU0q");
/** Use it instead of .includes method for IE support */ function $cd212b0f1fc3eb1e$export$407448d2b89b1813(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every(function(item) {
        return array.indexOf(item) !== -1;
    });
    return array.indexOf(itemOrItems) !== -1;
}
var $cd212b0f1fc3eb1e$export$96f57966bedc81b4 = 310;
var $cd212b0f1fc3eb1e$export$db3b6bfb95261072 = 325;
var $cd212b0f1fc3eb1e$export$8b22cf2602fb60ce = 305;
var $cd212b0f1fc3eb1e$var$useStyles = (0, $by0pu.default)(function(theme) {
    return {
        staticWrapperRoot: {
            overflow: 'hidden',
            minWidth: $cd212b0f1fc3eb1e$export$96f57966bedc81b4,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.background.paper
        }
    };
}, {
    name: 'MuiPickersStaticWrapper'
});
var $cd212b0f1fc3eb1e$var$StaticWrapper = function StaticWrapper(_ref) {
    var children = _ref.children;
    var classes = $cd212b0f1fc3eb1e$var$useStyles();
    return (0, $7fPBF.createElement)("div", {
        className: classes.staticWrapperRoot,
        children: children
    });
};
var $cd212b0f1fc3eb1e$var$ModalDialog = function ModalDialog(_ref) {
    var children = _ref.children, classes = _ref.classes, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onClear = _ref.onClear, onSetToday = _ref.onSetToday, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, clearable = _ref.clearable, showTodayButton = _ref.showTodayButton, showTabs = _ref.showTabs, wider = _ref.wider, other = (0, $lfiYO.default)(_ref, [
        "children",
        "classes",
        "onAccept",
        "onDismiss",
        "onClear",
        "onSetToday",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "clearable",
        "showTodayButton",
        "showTabs",
        "wider"
    ]);
    return (0, $7fPBF.createElement)((0, $10c0df872321f413$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        role: "dialog",
        onClose: onDismiss,
        classes: {
            paper: (0, $jtRae.default)(classes.dialogRoot, wider && classes.dialogRootWider)
        }
    }, other), (0, $7fPBF.createElement)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
        children: children,
        className: classes.dialog
    }), (0, $7fPBF.createElement)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
        classes: {
            root: (0, $jtRae.default)((clearable || showTodayButton) && classes.withAdditionalAction)
        }
    }, clearable && (0, $7fPBF.createElement)((0, $fwAOd.default), {
        color: "primary",
        onClick: onClear
    }, clearLabel), showTodayButton && (0, $7fPBF.createElement)((0, $fwAOd.default), {
        color: "primary",
        onClick: onSetToday
    }, todayLabel), cancelLabel && (0, $7fPBF.createElement)((0, $fwAOd.default), {
        color: "primary",
        onClick: onDismiss
    }, cancelLabel), okLabel && (0, $7fPBF.createElement)((0, $fwAOd.default), {
        color: "primary",
        onClick: onAccept
    }, okLabel)));
};
$cd212b0f1fc3eb1e$var$ModalDialog.displayName = 'ModalDialog';
var $cd212b0f1fc3eb1e$var$styles = (0, $lEobJ.default)({
    dialogRoot: {
        minWidth: $cd212b0f1fc3eb1e$export$96f57966bedc81b4
    },
    dialogRootWider: {
        minWidth: $cd212b0f1fc3eb1e$export$db3b6bfb95261072
    },
    dialog: {
        '&:first-child': {
            padding: 0
        }
    },
    withAdditionalAction: {
        // set justifyContent to default value to fix IE11 layout bug
        // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
        justifyContent: 'flex-start',
        '& > *:first-child': {
            marginRight: 'auto'
        }
    }
});
var $cd212b0f1fc3eb1e$var$ModalDialog$1 = (0, $3Sc7z.default)($cd212b0f1fc3eb1e$var$styles, {
    name: 'MuiPickersModal'
})($cd212b0f1fc3eb1e$var$ModalDialog);
var $cd212b0f1fc3eb1e$export$3b14a55fb2447963 = typeof window === 'undefined' ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);
function $cd212b0f1fc3eb1e$export$43caf9889c228507(e, keyHandlers) {
    var handler = keyHandlers[e.key];
    if (handler) {
        handler(); // if event was handled prevent other side effects (e.g. page scroll)
        e.preventDefault();
    }
}
function $cd212b0f1fc3eb1e$var$useKeyDown(active, keyHandlers) {
    var keyHandlersRef = (0, $7fPBF.useRef)(keyHandlers);
    keyHandlersRef.current = keyHandlers;
    $cd212b0f1fc3eb1e$export$3b14a55fb2447963(function() {
        if (active) {
            var handleKeyDown = function handleKeyDown(event) {
                $cd212b0f1fc3eb1e$export$43caf9889c228507(event, keyHandlersRef.current);
            };
            window.addEventListener('keydown', handleKeyDown);
            return function() {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        active
    ]);
}
var $cd212b0f1fc3eb1e$var$ModalWrapper = function ModalWrapper(_ref) {
    var open = _ref.open, children = _ref.children, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, showTodayButton = _ref.showTodayButton, clearable = _ref.clearable, DialogProps = _ref.DialogProps, showTabs = _ref.showTabs, wider = _ref.wider, InputComponent = _ref.InputComponent, DateInputProps = _ref.DateInputProps, onClear = _ref.onClear, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, other = (0, $lfiYO.default)(_ref, [
        "open",
        "children",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "showTodayButton",
        "clearable",
        "DialogProps",
        "showTabs",
        "wider",
        "InputComponent",
        "DateInputProps",
        "onClear",
        "onAccept",
        "onDismiss",
        "onSetToday"
    ]);
    $cd212b0f1fc3eb1e$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $7fPBF.createElement)((0, $7fPBF.Fragment), null, (0, $7fPBF.createElement)(InputComponent, (0, $kY3Ke.default)({}, other, DateInputProps)), (0, $7fPBF.createElement)($cd212b0f1fc3eb1e$var$ModalDialog$1, (0, $kY3Ke.default)({
        wider: wider,
        showTabs: showTabs,
        open: open,
        onClear: onClear,
        onAccept: onAccept,
        onDismiss: onDismiss,
        onSetToday: onSetToday,
        clearLabel: clearLabel,
        todayLabel: todayLabel,
        okLabel: okLabel,
        cancelLabel: cancelLabel,
        clearable: clearable,
        showTodayButton: showTodayButton,
        children: children
    }, DialogProps)));
};
$cd212b0f1fc3eb1e$var$ModalWrapper.defaultProps = {
    okLabel: 'OK',
    cancelLabel: 'Cancel',
    clearLabel: 'Clear',
    todayLabel: 'Today',
    clearable: false,
    showTodayButton: false
};
var $cd212b0f1fc3eb1e$var$InlineWrapper = function InlineWrapper(_ref) {
    var open = _ref.open, wider = _ref.wider, children = _ref.children, PopoverProps = _ref.PopoverProps, onClear = _ref.onClear, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, onAccept = _ref.onAccept, showTabs = _ref.showTabs, DateInputProps = _ref.DateInputProps, InputComponent = _ref.InputComponent, other = (0, $lfiYO.default)(_ref, [
        "open",
        "wider",
        "children",
        "PopoverProps",
        "onClear",
        "onDismiss",
        "onSetToday",
        "onAccept",
        "showTabs",
        "DateInputProps",
        "InputComponent"
    ]);
    var ref = (0, $7fPBF.useRef)();
    $cd212b0f1fc3eb1e$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $7fPBF.createElement)((0, $7fPBF.Fragment), null, (0, $7fPBF.createElement)(InputComponent, (0, $kY3Ke.default)({}, other, DateInputProps, {
        inputRef: ref
    })), (0, $7fPBF.createElement)((0, $9zU0q.default), (0, $kY3Ke.default)({
        open: open,
        onClose: onDismiss,
        anchorEl: ref.current,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        children: children
    }, PopoverProps)));
};
function $cd212b0f1fc3eb1e$var$getWrapperFromVariant(variant) {
    switch(variant){
        case 'inline':
            return $cd212b0f1fc3eb1e$var$InlineWrapper;
        case 'static':
            return $cd212b0f1fc3eb1e$var$StaticWrapper;
        default:
            return $cd212b0f1fc3eb1e$var$ModalWrapper;
    }
}
var $cd212b0f1fc3eb1e$export$e7c866399fa523f5 = (0, $7fPBF.createContext)(null);
var $cd212b0f1fc3eb1e$export$71cec2538cb2c617 = function Wrapper(_ref) {
    var variant = _ref.variant, props = (0, $lfiYO.default)(_ref, [
        "variant"
    ]);
    var Component = $cd212b0f1fc3eb1e$var$getWrapperFromVariant(variant);
    return (0, $7fPBF.createElement)($cd212b0f1fc3eb1e$export$e7c866399fa523f5.Provider, {
        value: variant || 'dialog'
    }, (0, $7fPBF.createElement)(Component, props));
};



var $MQfsM = parcelRequire("MQfsM");

var $iRcsz = parcelRequire("iRcsz");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $1rW9t = parcelRequire("1rW9t");

var $3Sc7z = parcelRequire("3Sc7z");

var $bdGMx = parcelRequire("bdGMx");
var $0d5df0aef00ddb22$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        height: '0.01em',
        // Fix IE 11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    },
    /* Styles applied to the root element if `variant="filled"`. */ filled: {
        '&$positionStart:not($hiddenLabel)': {
            marginTop: 16
        }
    },
    /* Styles applied to the root element if `position="start"`. */ positionStart: {
        marginRight: 8
    },
    /* Styles applied to the root element if `position="end"`. */ positionEnd: {
        marginLeft: 8
    },
    /* Styles applied to the root element if `disablePointerEvents=true`. */ disablePointerEvents: {
        pointerEvents: 'none'
    },
    /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */ hiddenLabel: {},
    /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */ marginDense: {}
};
var $0d5df0aef00ddb22$var$InputAdornment = /*#__PURE__*/ $7fPBF.forwardRef(function InputAdornment(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disablePointer = props.disablePointerEvents, disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, position = props.position, variantProp = props.variant, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disablePointerEvents",
        "disableTypography",
        "position",
        "variant"
    ]);
    var muiFormControl = (0, $bdGMx.useFormControl)() || {};
    var variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    return /*#__PURE__*/ $7fPBF.createElement((0, $bdGMx.default).Provider, {
        value: null
    }, /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), {
        color: "textSecondary"
    }, children) : children));
});
var $0d5df0aef00ddb22$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($0d5df0aef00ddb22$export$9dd6ff9ea0189349, {
    name: 'MuiInputAdornment'
})($0d5df0aef00ddb22$var$InputAdornment);



var $1KLsX = parcelRequire("1KLsX");

var $7fPBF = parcelRequire("7fPBF");
var $1542018035baed54$export$5519909ee832c7c = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Rifm, _React$Component);
    function Rifm(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._state = null;
        _this._del = false;
        _this._handleChange = function(evt) {
            var stateValue = _this.state.value;
            var value = evt.target.value;
            var input = evt.target;
            var op = value.length > stateValue.length;
            var del = _this._del;
            var noOp = stateValue === _this.props.format(value);
            _this.setState({
                value: value,
                local: true
            }, function() {
                var selectionStart = input.selectionStart;
                var refuse = _this.props.refuse || /[^\d]+/g;
                var before = value.substr(0, selectionStart).replace(refuse, '');
                _this._state = {
                    input: input,
                    before: before,
                    op: op,
                    di: del && noOp,
                    del: del
                };
                if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
                    var start = -1;
                    for(var i = 0; i !== before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
                    var c = value.substr(start + 1).replace(refuse, '')[0];
                    start = value.indexOf(c, start + 1);
                    value = "" + value.substr(0, start) + value.substr(start + 1);
                }
                var fv = _this.props.format(value);
                if (stateValue === fv) _this.setState({
                    value: value
                });
                else _this.props.onChange(fv);
            });
        };
        _this._hKD = function(evt) {
            if (evt.code === 'Delete') _this._del = true;
        };
        _this._hKU = function(evt) {
            if (evt.code === 'Delete') _this._del = false;
        };
        _this.state = {
            value: props.value,
            local: true
        };
        return _this;
    }
    Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        return {
            value: state.local ? state.value : props.value,
            local: false
        };
    };
    var _proto = Rifm.prototype;
    _proto.render = function render() {
        var _handleChange = this._handleChange, value = this.state.value, children = this.props.children;
        return children({
            value: value,
            onChange: _handleChange
        });
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener('keydown', this._hKD);
        document.removeEventListener('keyup', this._hKU);
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentDidMount = function componentDidMount() {
        document.addEventListener('keydown', this._hKD);
        document.addEventListener('keyup', this._hKU);
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        var _state = this._state;
        if (_state) {
            var value = this.state.value;
            var start = -1;
            for(var i = 0; i !== _state.before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
             // format usually looks better without this
            if (this.props.replace && (_state.op || _state.del && !_state.di)) while(value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1]))start += 1;
            _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
        }
        this._state = null;
    };
    return Rifm;
}((0, $7fPBF.Component));



var $gC5xr = parcelRequire("gC5xr");

var $2gIIh = parcelRequire("2gIIh");

var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $jtRae = parcelRequire("jtRae");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $1rW9t = parcelRequire("1rW9t");

var $by0pu = parcelRequire("by0pu");


var $7fPBF = parcelRequire("7fPBF");



var $jtRae = parcelRequire("jtRae");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $1rW9t = parcelRequire("1rW9t");

var $by0pu = parcelRequire("by0pu");
var $fH0xA = parcelRequire("fH0xA");
var $3Sc7z = parcelRequire("3Sc7z");


var $iRcsz = parcelRequire("iRcsz");

var $gC5xr = parcelRequire("gC5xr");

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");




var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $1rW9t = parcelRequire("1rW9t");

var $by0pu = parcelRequire("by0pu");

var $iRcsz = parcelRequire("iRcsz");
var $01677e367425c551$export$28e6b9b82ee883c = (0, $by0pu.default)(function(theme) {
    return {
        day: {
            width: 36,
            height: 36,
            fontSize: theme.typography.caption.fontSize,
            margin: '0 2px',
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
            padding: 0
        },
        hidden: {
            opacity: 0,
            pointerEvents: 'none'
        },
        current: {
            color: theme.palette.primary.main,
            fontWeight: 600
        },
        daySelected: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                backgroundColor: theme.palette.primary.main
            }
        },
        dayDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersDay'
});
var $01677e367425c551$export$7a9a31a911eb9a20 = function Day(_ref) {
    var children = _ref.children, disabled = _ref.disabled, hidden = _ref.hidden, current = _ref.current, selected = _ref.selected, other = (0, $lfiYO.default)(_ref, [
        "children",
        "disabled",
        "hidden",
        "current",
        "selected"
    ]);
    var classes = $01677e367425c551$export$28e6b9b82ee883c();
    var className = (0, $jtRae.default)(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
    return (0, $7fPBF.createElement)((0, $iRcsz.default), (0, $kY3Ke.default)({
        className: className,
        tabIndex: hidden || disabled ? -1 : 0
    }, other), (0, $7fPBF.createElement)((0, $1rW9t.default), {
        variant: "body2",
        color: "inherit"
    }, children));
};
$01677e367425c551$export$7a9a31a911eb9a20.displayName = 'Day';
$01677e367425c551$export$7a9a31a911eb9a20.defaultProps = {
    disabled: false,
    hidden: false,
    current: false,
    selected: false
};
var $01677e367425c551$export$2e2bcd8739ae039 = $01677e367425c551$export$7a9a31a911eb9a20;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $1KLsX = parcelRequire("1KLsX");

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $1e3f901d29816e8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $89edc8a1840ff9c1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $89edc8a1840ff9c1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $89edc8a1840ff9c1$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $89edc8a1840ff9c1$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $7fPBF = parcelRequire("7fPBF");

var $8qMCX = parcelRequire("8qMCX");


var $kKJSm = parcelRequire("kKJSm");
var $f9e47e451b39ae9f$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $1e3f901d29816e8c$export$2e2bcd8739ae039)(node, c);
    });
};
var $f9e47e451b39ae9f$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $89edc8a1840ff9c1$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $f9e47e451b39ae9f$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $kKJSm.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $f9e47e451b39ae9f$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $f9e47e451b39ae9f$var$removeClass(node, baseClassName);
        if (activeClassName) $f9e47e451b39ae9f$var$removeClass(node, activeClassName);
        if (doneClassName) $f9e47e451b39ae9f$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $cFLic.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8qMCX.default), (0, $kY3Ke.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$f9e47e451b39ae9f$var$CSSTransition.defaultProps = {
    classNames: ''
};
$f9e47e451b39ae9f$var$CSSTransition.propTypes = {};
var $f9e47e451b39ae9f$export$2e2bcd8739ae039 = $f9e47e451b39ae9f$var$CSSTransition;


var $4axyc = parcelRequire("4axyc");

var $9SdKL = parcelRequire("9SdKL");
var $8ffb4fc961e2858e$var$findClosestEnabledDate = function findClosestEnabledDate(_ref) {
    var date = _ref.date, utils = _ref.utils, minDate = _ref.minDate, maxDate = _ref.maxDate, disableFuture = _ref.disableFuture, disablePast = _ref.disablePast, shouldDisableDate = _ref.shouldDisableDate;
    var today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    var forward = date;
    var backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!shouldDisableDate(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!shouldDisableDate(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    } // fallback to today if no enabled days
    return utils.date();
};
var $8ffb4fc961e2858e$export$23f2a1d2818174ef = function isYearOnlyView(views) {
    return views.length === 1 && views[0] === 'year';
};
var $8ffb4fc961e2858e$export$8b22cf2602fb60ce = function isYearAndMonthViews(views) {
    return views.length === 2 && (0, $cd212b0f1fc3eb1e$export$407448d2b89b1813)(views, 'month') && (0, $cd212b0f1fc3eb1e$export$407448d2b89b1813)(views, 'year');
};
var $8ffb4fc961e2858e$export$39b482c5e57630a8 = function getFormatByViews(views, utils) {
    if ($8ffb4fc961e2858e$export$23f2a1d2818174ef(views)) return utils.yearFormat;
    if ($8ffb4fc961e2858e$export$8b22cf2602fb60ce(views)) return utils.yearMonthFormat;
    return utils.dateFormat;
};
var $8ffb4fc961e2858e$var$DayWrapper = function DayWrapper(_ref) {
    var children = _ref.children, value = _ref.value, disabled = _ref.disabled, onSelect = _ref.onSelect, dayInCurrentMonth = _ref.dayInCurrentMonth, other = (0, $lfiYO.default)(_ref, [
        "children",
        "value",
        "disabled",
        "onSelect",
        "dayInCurrentMonth"
    ]);
    var handleClick = (0, $7fPBF.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $7fPBF.createElement)("div", (0, $kY3Ke.default)({
        role: "presentation",
        onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
        onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
    }, other), children);
};
var $8ffb4fc961e2858e$var$animationDuration = 350;
var $8ffb4fc961e2858e$var$useStyles = (0, $by0pu.default)(function(theme) {
    var slideTransition = theme.transitions.create('transform', {
        duration: $8ffb4fc961e2858e$var$animationDuration,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        transitionContainer: {
            display: 'block',
            position: 'relative',
            '& > *': {
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0
            }
        },
        'slideEnter-left': {
            willChange: 'transform',
            transform: 'translate(100%)'
        },
        'slideEnter-right': {
            willChange: 'transform',
            transform: 'translate(-100%)'
        },
        slideEnterActive: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        slideExit: {
            transform: 'translate(0%)'
        },
        'slideExitActiveLeft-left': {
            willChange: 'transform',
            transform: 'translate(-200%)',
            transition: slideTransition
        },
        'slideExitActiveLeft-right': {
            willChange: 'transform',
            transform: 'translate(200%)',
            transition: slideTransition
        }
    };
}, {
    name: 'MuiPickersSlideTransition'
});
var $8ffb4fc961e2858e$var$SlideTransition = function SlideTransition(_ref) {
    var children = _ref.children, transKey = _ref.transKey, slideDirection = _ref.slideDirection, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className;
    var classes = $8ffb4fc961e2858e$var$useStyles();
    var transitionClasses = {
        exit: classes.slideExit,
        enterActive: classes.slideEnterActive,
        // @ts-ignore
        enter: classes['slideEnter-' + slideDirection],
        // @ts-ignore
        exitActive: classes['slideExitActiveLeft-' + slideDirection]
    };
    return (0, $7fPBF.createElement)((0, $4axyc.default), {
        className: (0, $jtRae.default)(classes.transitionContainer, className),
        childFactory: function childFactory(element) {
            return (0, $7fPBF.cloneElement)(element, {
                classNames: transitionClasses
            });
        }
    }, (0, $7fPBF.createElement)((0, $f9e47e451b39ae9f$export$2e2bcd8739ae039), {
        mountOnEnter: true,
        unmountOnExit: true,
        key: transKey + slideDirection,
        timeout: $8ffb4fc961e2858e$var$animationDuration,
        classNames: transitionClasses,
        children: children
    }));
};
var $8ffb4fc961e2858e$var$ArrowLeftIcon = function ArrowLeftIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $gC5xr.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $8ffb4fc961e2858e$var$ArrowRightIcon = function ArrowRightIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $gC5xr.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $8ffb4fc961e2858e$var$useStyles$1 = (0, $by0pu.default)(function(theme) {
    return {
        switchHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(1)
        },
        transitionContainer: {
            width: '100%',
            overflow: 'hidden',
            height: 23
        },
        iconButton: {
            zIndex: 1,
            backgroundColor: theme.palette.background.paper
        },
        daysHeader: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: 16
        },
        dayLabel: {
            width: 36,
            margin: '0 2px',
            textAlign: 'center',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersCalendarHeader'
});
var $8ffb4fc961e2858e$var$CalendarHeader = function CalendarHeader(_ref) {
    var currentMonth = _ref.currentMonth, onMonthChange = _ref.onMonthChange, leftArrowIcon = _ref.leftArrowIcon, rightArrowIcon = _ref.rightArrowIcon, leftArrowButtonProps = _ref.leftArrowButtonProps, rightArrowButtonProps = _ref.rightArrowButtonProps, disablePrevMonth = _ref.disablePrevMonth, disableNextMonth = _ref.disableNextMonth, slideDirection = _ref.slideDirection;
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var classes = $8ffb4fc961e2858e$var$useStyles$1();
    var theme = (0, $fH0xA.default)();
    var rtl = theme.direction === 'rtl';
    var selectNextMonth = function selectNextMonth() {
        return onMonthChange(utils.getNextMonth(currentMonth), 'left');
    };
    var selectPreviousMonth = function selectPreviousMonth() {
        return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
    };
    return (0, $7fPBF.createElement)("div", null, (0, $7fPBF.createElement)("div", {
        className: classes.switchHeader
    }, (0, $7fPBF.createElement)((0, $iRcsz.default), (0, $kY3Ke.default)({}, leftArrowButtonProps, {
        disabled: disablePrevMonth,
        onClick: selectPreviousMonth,
        className: classes.iconButton
    }), rtl ? rightArrowIcon : leftArrowIcon), (0, $7fPBF.createElement)($8ffb4fc961e2858e$var$SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
    }, (0, $7fPBF.createElement)((0, $1rW9t.default), {
        align: "center",
        variant: "body1"
    }, utils.getCalendarHeaderText(currentMonth))), (0, $7fPBF.createElement)((0, $iRcsz.default), (0, $kY3Ke.default)({}, rightArrowButtonProps, {
        disabled: disableNextMonth,
        onClick: selectNextMonth,
        className: classes.iconButton
    }), rtl ? leftArrowIcon : rightArrowIcon)), (0, $7fPBF.createElement)("div", {
        className: classes.daysHeader
    }, utils.getWeekdays().map(function(day, index) {
        return (0, $7fPBF.createElement)((0, $1rW9t.default), {
            key: index // eslint-disable-line react/no-array-index-key
            ,
            variant: "caption",
            className: classes.dayLabel
        }, day);
    })));
};
$8ffb4fc961e2858e$var$CalendarHeader.displayName = 'CalendarHeader';
$8ffb4fc961e2858e$var$CalendarHeader.defaultProps = {
    leftArrowIcon: (0, $7fPBF.createElement)($8ffb4fc961e2858e$var$ArrowLeftIcon, null),
    rightArrowIcon: (0, $7fPBF.createElement)($8ffb4fc961e2858e$var$ArrowRightIcon, null),
    disablePrevMonth: false,
    disableNextMonth: false
};
var $8ffb4fc961e2858e$var$withUtils = function withUtils() {
    return function(Component) {
        var WithUtils = function WithUtils(props) {
            var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
            return (0, $7fPBF.createElement)(Component, (0, $kY3Ke.default)({
                utils: utils
            }, props));
        };
        WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
        return WithUtils;
    };
};
var $8ffb4fc961e2858e$var$KeyDownListener = function KeyDownListener(_ref) {
    var onKeyDown = _ref.onKeyDown;
    (0, $7fPBF.useEffect)(function() {
        window.addEventListener('keydown', onKeyDown);
        return function() {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [
        onKeyDown
    ]);
    return null;
};
var $8ffb4fc961e2858e$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Calendar, _React$Component);
    function Calendar() {
        var _getPrototypeOf2;
        var _this;
        (0, $03dWn.default)(this, Calendar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(Calendar)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            slideDirection: 'left',
            currentMonth: _this.props.utils.startOfMonth(_this.props.date),
            loadingQueue: 0
        };
        _this.pushToLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue + 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.popFromLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue;
            loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.handleChangeMonth = function(newMonth, slideDirection) {
            _this.setState({
                currentMonth: newMonth,
                slideDirection: slideDirection
            });
            if (_this.props.onMonthChange) {
                var returnVal = _this.props.onMonthChange(newMonth);
                if (returnVal) {
                    _this.pushToLoadingQueue();
                    returnVal.then(function() {
                        _this.popFromLoadingQueue();
                    });
                }
            }
        };
        _this.validateMinMaxDate = function(day) {
            var _this$props = _this.props, minDate = _this$props.minDate, maxDate = _this$props.maxDate, utils = _this$props.utils, disableFuture = _this$props.disableFuture, disablePast = _this$props.disablePast;
            var now = utils.date();
            return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
        };
        _this.shouldDisablePrevMonth = function() {
            var _this$props2 = _this.props, utils = _this$props2.utils, disablePast = _this$props2.disablePast, minDate = _this$props2.minDate;
            var now = utils.date();
            var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
            return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableNextMonth = function() {
            var _this$props3 = _this.props, utils = _this$props3.utils, disableFuture = _this$props3.disableFuture, maxDate = _this$props3.maxDate;
            var now = utils.date();
            var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
            return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableDate = function(day) {
            var shouldDisableDate = _this.props.shouldDisableDate;
            return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
        };
        _this.handleDaySelect = function(day) {
            var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var _this$props4 = _this.props, date = _this$props4.date, utils = _this$props4.utils;
            _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
        };
        _this.moveToDay = function(day) {
            var utils = _this.props.utils;
            if (day && !_this.shouldDisableDate(day)) {
                if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) _this.handleChangeMonth(utils.startOfMonth(day), 'left');
                _this.handleDaySelect(day, false);
            }
        };
        _this.handleKeyDown = function(event) {
            var _this$props5 = _this.props, theme = _this$props5.theme, date = _this$props5.date, utils = _this$props5.utils;
            (0, $cd212b0f1fc3eb1e$export$43caf9889c228507)(event, {
                ArrowUp: function ArrowUp() {
                    return _this.moveToDay(utils.addDays(date, -7));
                },
                ArrowDown: function ArrowDown() {
                    return _this.moveToDay(utils.addDays(date, 7));
                },
                ArrowLeft: function ArrowLeft() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
                },
                ArrowRight: function ArrowRight() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
                }
            });
        };
        _this.renderWeeks = function() {
            var _this$props6 = _this.props, utils = _this$props6.utils, classes = _this$props6.classes;
            var weeks = utils.getWeekArray(_this.state.currentMonth);
            return weeks.map(function(week) {
                return (0, $7fPBF.createElement)("div", {
                    key: "week-".concat(week[0].toString()),
                    className: classes.week
                }, _this.renderDays(week));
            });
        };
        _this.renderDays = function(week) {
            var _this$props7 = _this.props, date = _this$props7.date, renderDay = _this$props7.renderDay, utils = _this$props7.utils;
            var now = utils.date();
            var selectedDate = utils.startOfDay(date);
            var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
            return week.map(function(day) {
                var disabled = _this.shouldDisableDate(day);
                var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
                var dayComponent = (0, $7fPBF.createElement)((0, $01677e367425c551$export$2e2bcd8739ae039), {
                    disabled: disabled,
                    current: utils.isSameDay(day, now),
                    hidden: !isDayInCurrentMonth,
                    selected: utils.isSameDay(selectedDate, day)
                }, utils.getDayText(day));
                if (renderDay) dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
                return (0, $7fPBF.createElement)($8ffb4fc961e2858e$var$DayWrapper, {
                    value: day,
                    key: day.toString(),
                    disabled: disabled,
                    dayInCurrentMonth: isDayInCurrentMonth,
                    onSelect: _this.handleDaySelect
                }, dayComponent);
            });
        };
        return _this;
    }
    (0, $4OFm0.default)(Calendar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props8 = this.props, date = _this$props8.date, minDate = _this$props8.minDate, maxDate = _this$props8.maxDate, utils = _this$props8.utils, disablePast = _this$props8.disablePast, disableFuture = _this$props8.disableFuture;
                if (this.shouldDisableDate(date)) {
                    var closestEnabledDate = $8ffb4fc961e2858e$var$findClosestEnabledDate({
                        date: date,
                        utils: utils,
                        minDate: utils.date(minDate),
                        maxDate: utils.date(maxDate),
                        disablePast: Boolean(disablePast),
                        disableFuture: Boolean(disableFuture),
                        shouldDisableDate: this.shouldDisableDate
                    });
                    this.handleDaySelect(closestEnabledDate, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, currentMonth = _this$state.currentMonth, slideDirection = _this$state.slideDirection;
                var _this$props9 = this.props, classes = _this$props9.classes, allowKeyboardControl = _this$props9.allowKeyboardControl, leftArrowButtonProps = _this$props9.leftArrowButtonProps, leftArrowIcon = _this$props9.leftArrowIcon, rightArrowButtonProps = _this$props9.rightArrowButtonProps, rightArrowIcon = _this$props9.rightArrowIcon, loadingIndicator = _this$props9.loadingIndicator;
                var loadingElement = loadingIndicator ? loadingIndicator : (0, $7fPBF.createElement)((0, $9SdKL.default), null);
                return (0, $7fPBF.createElement)((0, $7fPBF.Fragment), null, allowKeyboardControl && this.context !== 'static' && (0, $7fPBF.createElement)($8ffb4fc961e2858e$var$KeyDownListener, {
                    onKeyDown: this.handleKeyDown
                }), (0, $7fPBF.createElement)($8ffb4fc961e2858e$var$CalendarHeader, {
                    currentMonth: currentMonth,
                    slideDirection: slideDirection,
                    onMonthChange: this.handleChangeMonth,
                    leftArrowIcon: leftArrowIcon,
                    leftArrowButtonProps: leftArrowButtonProps,
                    rightArrowIcon: rightArrowIcon,
                    rightArrowButtonProps: rightArrowButtonProps,
                    disablePrevMonth: this.shouldDisablePrevMonth(),
                    disableNextMonth: this.shouldDisableNextMonth()
                }), (0, $7fPBF.createElement)($8ffb4fc961e2858e$var$SlideTransition, {
                    slideDirection: slideDirection,
                    transKey: currentMonth.toString(),
                    className: classes.transitionContainer
                }, (0, $7fPBF.createElement)((0, $7fPBF.Fragment), null, this.state.loadingQueue > 0 && (0, $7fPBF.createElement)("div", {
                    className: classes.progressContainer
                }, loadingElement) || (0, $7fPBF.createElement)("div", null, this.renderWeeks()))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                var utils = nextProps.utils, nextDate = nextProps.date;
                if (!utils.isEqual(nextDate, state.lastDate)) {
                    var nextMonth = utils.getMonth(nextDate);
                    var lastDate = state.lastDate || nextDate;
                    var lastMonth = utils.getMonth(lastDate);
                    return {
                        lastDate: nextDate,
                        currentMonth: nextProps.utils.startOfMonth(nextDate),
                        // prettier-ignore
                        slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
                    };
                }
                return null;
            }
        }
    ]);
    return Calendar;
}((0, $7fPBF.Component));
$8ffb4fc961e2858e$export$e7094788287c5e9b.contextType = (0, $cd212b0f1fc3eb1e$export$e7c866399fa523f5);
$8ffb4fc961e2858e$export$e7094788287c5e9b.defaultProps = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    disablePast: false,
    disableFuture: false,
    allowKeyboardControl: true
};
var $8ffb4fc961e2858e$export$2408f22a0fab9ae5 = function styles(theme) {
    return {
        transitionContainer: {
            minHeight: 216,
            marginTop: theme.spacing(1.5)
        },
        progressContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        week: {
            display: 'flex',
            justifyContent: 'center'
        }
    };
};
var $8ffb4fc961e2858e$export$407448d2b89b1813 = (0, $3Sc7z.default)($8ffb4fc961e2858e$export$2408f22a0fab9ae5, {
    name: 'MuiPickersCalendar',
    withTheme: true
})($8ffb4fc961e2858e$var$withUtils()($8ffb4fc961e2858e$export$e7094788287c5e9b));



var $2gIIh = parcelRequire("2gIIh");

var $7fPBF = parcelRequire("7fPBF");



var $jtRae = parcelRequire("jtRae");

var $kY3Ke = parcelRequire("kY3Ke");

var $1rW9t = parcelRequire("1rW9t");

var $by0pu = parcelRequire("by0pu");
parcelRequire("03dWn");
parcelRequire("4OFm0");




var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $lEobJ = parcelRequire("lEobJ");
var $3Sc7z = parcelRequire("3Sc7z");

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");



var $e9916fbd2c40553b$var$ClockType;
(function(ClockType) {
    ClockType["HOURS"] = "hours";
    ClockType["MINUTES"] = "minutes";
    ClockType["SECONDS"] = "seconds";
})($e9916fbd2c40553b$var$ClockType || ($e9916fbd2c40553b$var$ClockType = {}));
var $e9916fbd2c40553b$export$8b22cf2602fb60ce = $e9916fbd2c40553b$var$ClockType;
var $e9916fbd2c40553b$var$ClockPointer = /*#__PURE__*/ function(_React$Component) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ClockPointer, _React$Component);
    function ClockPointer() {
        var _getPrototypeOf2;
        var _this;
        (0, $03dWn.default)(this, ClockPointer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(ClockPointer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            toAnimateTransform: false,
            previousType: undefined
        };
        _this.getAngleStyle = function() {
            var _this$props = _this.props, value = _this$props.value, isInner = _this$props.isInner, type = _this$props.type;
            var max = type === $e9916fbd2c40553b$export$8b22cf2602fb60ce.HOURS ? 12 : 60;
            var angle = 360 / max * value;
            if (type === $e9916fbd2c40553b$export$8b22cf2602fb60ce.HOURS && value > 12) angle -= 360; // round up angle to max 360 degrees
            return {
                height: isInner ? '26%' : '40%',
                transform: "rotateZ(".concat(angle, "deg)")
            };
        };
        return _this;
    }
    (0, $4OFm0.default)(ClockPointer, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, hasSelected = _this$props2.hasSelected;
                return (0, $7fPBF.createElement)("div", {
                    style: this.getAngleStyle(),
                    className: (0, $jtRae.default)(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
                }, (0, $7fPBF.createElement)("div", {
                    className: (0, $jtRae.default)(classes.thumb, hasSelected && classes.noPoint)
                }));
            }
        }
    ]);
    return ClockPointer;
}((0, $7fPBF.Component));
$e9916fbd2c40553b$var$ClockPointer.getDerivedStateFromProps = function(nextProps, state) {
    if (nextProps.type !== state.previousType) return {
        toAnimateTransform: true,
        previousType: nextProps.type
    };
    return {
        toAnimateTransform: false,
        previousType: nextProps.type
    };
};
var $e9916fbd2c40553b$var$styles = function styles(theme) {
    return (0, $lEobJ.default)({
        pointer: {
            width: 2,
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            left: 'calc(50% - 1px)',
            bottom: '50%',
            transformOrigin: 'center bottom 0px'
        },
        animateTransform: {
            transition: theme.transitions.create([
                'transform',
                'height'
            ])
        },
        thumb: {
            width: 4,
            height: 4,
            backgroundColor: theme.palette.primary.contrastText,
            borderRadius: '100%',
            position: 'absolute',
            top: -21,
            left: -15,
            border: "14px solid ".concat(theme.palette.primary.main),
            boxSizing: 'content-box'
        },
        noPoint: {
            backgroundColor: theme.palette.primary.main
        }
    });
};
var $e9916fbd2c40553b$var$ClockPointer$1 = (0, $3Sc7z.default)($e9916fbd2c40553b$var$styles, {
    name: 'MuiPickersClockPointer'
})($e9916fbd2c40553b$var$ClockPointer);
var $e9916fbd2c40553b$var$center = {
    x: 130,
    y: 130
};
var $e9916fbd2c40553b$var$basePoint = {
    x: $e9916fbd2c40553b$var$center.x,
    y: 0
};
var $e9916fbd2c40553b$var$cx = $e9916fbd2c40553b$var$basePoint.x - $e9916fbd2c40553b$var$center.x;
var $e9916fbd2c40553b$var$cy = $e9916fbd2c40553b$var$basePoint.y - $e9916fbd2c40553b$var$center.y;
var $e9916fbd2c40553b$var$rad2deg = function rad2deg(rad) {
    return rad * 57.29577951308232;
};
var $e9916fbd2c40553b$var$getAngleValue = function getAngleValue(step, offsetX, offsetY) {
    var x = offsetX - $e9916fbd2c40553b$var$center.x;
    var y = offsetY - $e9916fbd2c40553b$var$center.y;
    var atan = Math.atan2($e9916fbd2c40553b$var$cx, $e9916fbd2c40553b$var$cy) - Math.atan2(x, y);
    var deg = $e9916fbd2c40553b$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    var value = Math.floor(deg / step) || 0;
    var delta = Math.pow(x, 2) + Math.pow(y, 2);
    var distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
var $e9916fbd2c40553b$var$getHours = function getHours(offsetX, offsetY, ampm) {
    var _getAngleValue = $e9916fbd2c40553b$var$getAngleValue(30, offsetX, offsetY), value = _getAngleValue.value, distance = _getAngleValue.distance;
    value = value || 12;
    if (!ampm) {
        if (distance < 90) {
            value += 12;
            value %= 24;
        }
    } else value %= 12;
    return value;
};
var $e9916fbd2c40553b$var$getMinutes = function getMinutes(offsetX, offsetY) {
    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var angleStep = step * 6;
    var _getAngleValue2 = $e9916fbd2c40553b$var$getAngleValue(angleStep, offsetX, offsetY), value = _getAngleValue2.value;
    value = value * step % 60;
    return value;
};
var $e9916fbd2c40553b$export$39b482c5e57630a8 = function getMeridiem(date, utils) {
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var $e9916fbd2c40553b$export$db3b6bfb95261072 = function convertToMeridiem(time, meridiem, ampm, utils) {
    if (ampm) {
        var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) {
            var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
            return utils.setHours(time, hours);
        }
    }
    return time;
};
var $e9916fbd2c40553b$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Clock, _React$Component);
    function Clock() {
        var _getPrototypeOf2;
        var _this;
        (0, $03dWn.default)(this, Clock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(Clock)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.isMoving = false;
        _this.handleTouchMove = function(e) {
            _this.isMoving = true;
            _this.setTime(e);
        };
        _this.handleTouchEnd = function(e) {
            if (_this.isMoving) {
                _this.setTime(e, true);
                _this.isMoving = false;
            }
        };
        _this.handleMove = function(e) {
            e.preventDefault();
            e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari
            var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;
            if (isButtonPressed) _this.setTime(e.nativeEvent, false);
        };
        _this.handleMouseUp = function(e) {
            if (_this.isMoving) _this.isMoving = false;
            _this.setTime(e.nativeEvent, true);
        };
        _this.hasSelected = function() {
            var _this$props = _this.props, type = _this$props.type, value = _this$props.value;
            if (type === $e9916fbd2c40553b$export$8b22cf2602fb60ce.HOURS) return true;
            return value % 5 === 0;
        };
        return _this;
    }
    (0, $4OFm0.default)(Clock, [
        {
            key: "setTime",
            value: function setTime(e) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var offsetX = e.offsetX, offsetY = e.offsetY;
                if (typeof offsetX === 'undefined') {
                    var rect = e.target.getBoundingClientRect();
                    offsetX = e.changedTouches[0].clientX - rect.left;
                    offsetY = e.changedTouches[0].clientY - rect.top;
                }
                var value = this.props.type === $e9916fbd2c40553b$export$8b22cf2602fb60ce.SECONDS || this.props.type === $e9916fbd2c40553b$export$8b22cf2602fb60ce.MINUTES ? $e9916fbd2c40553b$var$getMinutes(offsetX, offsetY, this.props.minutesStep) : $e9916fbd2c40553b$var$getHours(offsetX, offsetY, Boolean(this.props.ampm));
                this.props.onChange(value, isFinish);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, value = _this$props2.value, children = _this$props2.children, type = _this$props2.type, ampm = _this$props2.ampm;
                var isPointerInner = !ampm && type === $e9916fbd2c40553b$export$8b22cf2602fb60ce.HOURS && (value < 1 || value > 12);
                return (0, $7fPBF.createElement)("div", {
                    className: classes.container
                }, (0, $7fPBF.createElement)("div", {
                    className: classes.clock
                }, (0, $7fPBF.createElement)("div", {
                    role: "menu",
                    tabIndex: -1,
                    className: classes.squareMask,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    onMouseUp: this.handleMouseUp,
                    onMouseMove: this.handleMove
                }), (0, $7fPBF.createElement)("div", {
                    className: classes.pin
                }), (0, $7fPBF.createElement)($e9916fbd2c40553b$var$ClockPointer$1, {
                    type: type,
                    value: value,
                    isInner: isPointerInner,
                    hasSelected: this.hasSelected()
                }), children));
            }
        }
    ]);
    return Clock;
}((0, $7fPBF.Component));
$e9916fbd2c40553b$export$e7094788287c5e9b.defaultProps = {
    ampm: false,
    minutesStep: 1
};
var $e9916fbd2c40553b$export$2408f22a0fab9ae5 = function styles(theme) {
    return (0, $lEobJ.default)({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
        },
        clock: {
            backgroundColor: 'rgba(0,0,0,.07)',
            borderRadius: '50%',
            height: 260,
            width: 260,
            position: 'relative',
            pointerEvents: 'none'
        },
        squareMask: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            pointerEvents: 'auto',
            outline: 'none',
            touchActions: 'none',
            userSelect: 'none',
            '&:active': {
                cursor: 'move'
            }
        },
        pin: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }
    });
};
var $e9916fbd2c40553b$export$407448d2b89b1813 = (0, $3Sc7z.default)($e9916fbd2c40553b$export$2408f22a0fab9ae5, {
    name: 'MuiPickersClock'
})($e9916fbd2c40553b$export$e7094788287c5e9b);


var $e61ec10ec65007a8$var$positions = {
    0: [
        0,
        40
    ],
    1: [
        55,
        19.6
    ],
    2: [
        94.4,
        59.5
    ],
    3: [
        109,
        114
    ],
    4: [
        94.4,
        168.5
    ],
    5: [
        54.5,
        208.4
    ],
    6: [
        0,
        223
    ],
    7: [
        -54.5,
        208.4
    ],
    8: [
        -94.4,
        168.5
    ],
    9: [
        -109,
        114
    ],
    10: [
        -94.4,
        59.5
    ],
    11: [
        -54.5,
        19.6
    ],
    12: [
        0,
        5
    ],
    13: [
        36.9,
        49.9
    ],
    14: [
        64,
        77
    ],
    15: [
        74,
        114
    ],
    16: [
        64,
        151
    ],
    17: [
        37,
        178
    ],
    18: [
        0,
        188
    ],
    19: [
        -37,
        178
    ],
    20: [
        -64,
        151
    ],
    21: [
        -74,
        114
    ],
    22: [
        -64,
        77
    ],
    23: [
        -37,
        50
    ]
};
var $e61ec10ec65007a8$var$useStyles = (0, $by0pu.default)(function(theme) {
    var size = theme.spacing(4);
    return {
        clockNumber: {
            width: size,
            height: 32,
            userSelect: 'none',
            position: 'absolute',
            left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
            color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
        },
        clockNumberSelected: {
            color: theme.palette.primary.contrastText
        }
    };
}, {
    name: 'MuiPickersClockNumber'
});
var $e61ec10ec65007a8$var$ClockNumber = function ClockNumber(_ref) {
    var selected = _ref.selected, label = _ref.label, index = _ref.index, isInner = _ref.isInner;
    var classes = $e61ec10ec65007a8$var$useStyles();
    var className = (0, $jtRae.default)(classes.clockNumber, selected && classes.clockNumberSelected);
    var transformStyle = (0, $7fPBF.useMemo)(function() {
        var position = $e61ec10ec65007a8$var$positions[index];
        return {
            transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
        };
    }, [
        index
    ]);
    return (0, $7fPBF.createElement)((0, $1rW9t.default), {
        component: "span",
        className: className,
        variant: isInner ? 'body2' : 'body1',
        style: transformStyle,
        children: label
    });
};
var $e61ec10ec65007a8$var$getHourNumbers = function getHourNumbers(_ref) {
    var ampm = _ref.ampm, utils = _ref.utils, date = _ref.date;
    var currentHours = utils.getHours(date);
    var hourNumbers = [];
    var startHour = ampm ? 1 : 0;
    var endHour = ampm ? 12 : 23;
    var isSelected = function isSelected(hour) {
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(var hour = startHour; hour <= endHour; hour += 1){
        var label = hour.toString();
        if (hour === 0) label = '00';
        var props = {
            index: hour,
            label: utils.formatNumber(label),
            selected: isSelected(hour),
            isInner: !ampm && (hour === 0 || hour > 12)
        };
        hourNumbers.push((0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, (0, $kY3Ke.default)({
            key: hour
        }, props)));
    }
    return hourNumbers;
};
var $e61ec10ec65007a8$var$getMinutesNumbers = function getMinutesNumbers(_ref2) {
    var value = _ref2.value, utils = _ref2.utils;
    var f = utils.formatNumber;
    return [
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('00'),
            selected: value === 0,
            index: 12,
            key: 12
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('05'),
            selected: value === 5,
            index: 1,
            key: 1
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('10'),
            selected: value === 10,
            index: 2,
            key: 2
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('15'),
            selected: value === 15,
            index: 3,
            key: 3
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('20'),
            selected: value === 20,
            index: 4,
            key: 4
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('25'),
            selected: value === 25,
            index: 5,
            key: 5
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('30'),
            selected: value === 30,
            index: 6,
            key: 6
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('35'),
            selected: value === 35,
            index: 7,
            key: 7
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('40'),
            selected: value === 40,
            index: 8,
            key: 8
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('45'),
            selected: value === 45,
            index: 9,
            key: 9
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('50'),
            selected: value === 50,
            index: 10,
            key: 10
        }),
        (0, $7fPBF.createElement)($e61ec10ec65007a8$var$ClockNumber, {
            label: f('55'),
            selected: value === 55,
            index: 11,
            key: 11
        })
    ];
};
var $e61ec10ec65007a8$export$e6ca67116c8adcad = function ClockView(_ref) {
    var type = _ref.type, onHourChange = _ref.onHourChange, onMinutesChange = _ref.onMinutesChange, onSecondsChange = _ref.onSecondsChange, ampm = _ref.ampm, date = _ref.date, minutesStep = _ref.minutesStep;
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var viewProps = (0, $7fPBF.useMemo)(function() {
        switch(type){
            case (0, $e9916fbd2c40553b$export$8b22cf2602fb60ce).HOURS:
                return {
                    value: utils.getHours(date),
                    children: $e61ec10ec65007a8$var$getHourNumbers({
                        date: date,
                        utils: utils,
                        ampm: Boolean(ampm)
                    }),
                    onChange: function onChange(value, isFinish) {
                        var currentMeridiem = (0, $e9916fbd2c40553b$export$39b482c5e57630a8)(date, utils);
                        var updatedTimeWithMeridiem = (0, $e9916fbd2c40553b$export$db3b6bfb95261072)(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
                        onHourChange(updatedTimeWithMeridiem, isFinish);
                    }
                };
            case (0, $e9916fbd2c40553b$export$8b22cf2602fb60ce).MINUTES:
                var minutesValue = utils.getMinutes(date);
                return {
                    value: minutesValue,
                    children: $e61ec10ec65007a8$var$getMinutesNumbers({
                        value: minutesValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setMinutes(date, value);
                        onMinutesChange(updatedTime, isFinish);
                    }
                };
            case (0, $e9916fbd2c40553b$export$8b22cf2602fb60ce).SECONDS:
                var secondsValue = utils.getSeconds(date);
                return {
                    value: secondsValue,
                    children: $e61ec10ec65007a8$var$getMinutesNumbers({
                        value: secondsValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setSeconds(date, value);
                        onSecondsChange(updatedTime, isFinish);
                    }
                };
            default:
                throw new Error('You must provide the type for TimePickerView');
        }
    }, [
        ampm,
        date,
        onHourChange,
        onMinutesChange,
        onSecondsChange,
        type,
        utils
    ]);
    return (0, $7fPBF.createElement)((0, $e9916fbd2c40553b$export$407448d2b89b1813), (0, $kY3Ke.default)({
        type: type,
        ampm: ampm,
        minutesStep: minutesStep
    }, viewProps));
};
$e61ec10ec65007a8$export$e6ca67116c8adcad.displayName = 'TimePickerView';
$e61ec10ec65007a8$export$e6ca67116c8adcad.defaultProps = {
    ampm: true,
    minutesStep: 1
};
var $e61ec10ec65007a8$var$ClockView$1 = (0, $7fPBF.memo)($e61ec10ec65007a8$export$e6ca67116c8adcad);
var $e61ec10ec65007a8$export$2e2bcd8739ae039 = $e61ec10ec65007a8$var$ClockView$1;


function $de175b290940fe5c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de175b290940fe5c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $de175b290940fe5c$var$ownKeys(source, true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $de175b290940fe5c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $de175b290940fe5c$var$date = (0, $2oXYc.oneOfType)([
    (0, $2oXYc.object),
    (0, $2oXYc.string),
    (0, $2oXYc.number),
    (0, $2oXYc.instanceOf)(Date)
]);
var $de175b290940fe5c$var$datePickerView = (0, $2oXYc.oneOf)([
    'year',
    'month',
    'day'
]);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */ var $de175b290940fe5c$export$625550452a3fa3ec = {
    ampm: true,
    invalidDateMessage: 'Invalid Time Format'
};
var $de175b290940fe5c$export$4368d992c4eafac0 = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    invalidDateMessage: 'Invalid Date Format',
    minDateMessage: 'Date should not be before minimal date',
    maxDateMessage: 'Date should not be after maximal date',
    allowKeyboardControl: true
};
var $de175b290940fe5c$export$407448d2b89b1813 = $de175b290940fe5c$var$_objectSpread({}, $de175b290940fe5c$export$625550452a3fa3ec, {}, $de175b290940fe5c$export$4368d992c4eafac0, {
    showTabs: true
});
function $de175b290940fe5c$var$useViews(views, openTo, onChange) {
    var _React$useState = (0, $7fPBF.useState)(openTo && (0, $cd212b0f1fc3eb1e$export$407448d2b89b1813)(views, openTo) ? openTo : views[0]), _React$useState2 = (0, $2gIIh.default)(_React$useState, 2), openView = _React$useState2[0], setOpenView = _React$useState2[1];
    var handleChangeAndOpenNext = (0, $7fPBF.useCallback)(function(date, isFinish) {
        var nextViewToOpen = views[views.indexOf(openView) + 1];
        if (isFinish && nextViewToOpen) {
            // do not close picker if needs to show next view
            onChange(date, false);
            setOpenView(nextViewToOpen);
            return;
        }
        onChange(date, Boolean(isFinish));
    }, [
        onChange,
        openView,
        views
    ]);
    return {
        handleChangeAndOpenNext: handleChangeAndOpenNext,
        openView: openView,
        setOpenView: setOpenView
    };
}
var $de175b290940fe5c$var$useStyles = (0, $by0pu.default)(function(theme) {
    return {
        root: {
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        yearSelected: {
            margin: '10px 0',
            fontWeight: theme.typography.fontWeightMedium
        },
        yearDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersYear'
});
var $de175b290940fe5c$var$Year = function Year(_ref) {
    var onSelect = _ref.onSelect, forwardedRef = _ref.forwardedRef, value = _ref.value, selected = _ref.selected, disabled = _ref.disabled, children = _ref.children, other = (0, $lfiYO.default)(_ref, [
        "onSelect",
        "forwardedRef",
        "value",
        "selected",
        "disabled",
        "children"
    ]);
    var classes = $de175b290940fe5c$var$useStyles();
    var handleClick = (0, $7fPBF.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $7fPBF.createElement)((0, $1rW9t.default), (0, $kY3Ke.default)({
        role: "button",
        component: "div",
        tabIndex: disabled ? -1 : 0,
        onClick: handleClick,
        onKeyPress: handleClick,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children,
        ref: forwardedRef,
        className: (0, $jtRae.default)(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
    }, other));
};
$de175b290940fe5c$var$Year.displayName = 'Year';
var $de175b290940fe5c$var$Year$1 = (0, $7fPBF.forwardRef)(function(props, ref) {
    return (0, $7fPBF.createElement)($de175b290940fe5c$var$Year, (0, $kY3Ke.default)({}, props, {
        forwardedRef: ref
    }));
});
var $de175b290940fe5c$var$useStyles$1 = (0, $by0pu.default)({
    container: {
        height: 300,
        overflowY: 'auto'
    }
}, {
    name: 'MuiPickersYearSelection'
});
var $de175b290940fe5c$var$YearSelection = function YearSelection(_ref) {
    var date = _ref.date, onChange = _ref.onChange, onYearChange = _ref.onYearChange, minDate = _ref.minDate, maxDate = _ref.maxDate, disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, animateYearScrolling = _ref.animateYearScrolling;
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var classes = $de175b290940fe5c$var$useStyles$1();
    var currentVariant = (0, $7fPBF.useContext)((0, $cd212b0f1fc3eb1e$export$e7c866399fa523f5));
    var selectedYearRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(function() {
        if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) try {
            selectedYearRef.current.scrollIntoView({
                block: currentVariant === 'static' ? 'nearest' : 'center',
                behavior: animateYearScrolling ? 'smooth' : 'auto'
            });
        } catch (e) {
            // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
            selectedYearRef.current.scrollIntoView();
        }
    }, []); // eslint-disable-line
    var currentYear = utils.getYear(date);
    var onYearSelect = (0, $7fPBF.useCallback)(function(year) {
        var newDate = utils.setYear(date, year);
        if (onYearChange) onYearChange(newDate);
        onChange(newDate, true);
    }, [
        date,
        onChange,
        onYearChange,
        utils
    ]);
    return (0, $7fPBF.createElement)("div", {
        className: classes.container
    }, utils.getYearRange(minDate, maxDate).map(function(year) {
        var yearNumber = utils.getYear(year);
        var selected = yearNumber === currentYear;
        return (0, $7fPBF.createElement)($de175b290940fe5c$var$Year$1, {
            key: utils.getYearText(year),
            selected: selected,
            value: yearNumber,
            onSelect: onYearSelect,
            ref: selected ? selectedYearRef : undefined,
            disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
        }, utils.getYearText(year));
    }));
};
var $de175b290940fe5c$var$useStyles$2 = (0, $by0pu.default)(function(theme) {
    return {
        root: {
            flex: '1 0 33.33%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            height: 75,
            transition: theme.transitions.create('font-size', {
                duration: '100ms'
            }),
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        monthSelected: {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium
        },
        monthDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersMonth'
});
var $de175b290940fe5c$var$Month = function Month(_ref) {
    var selected = _ref.selected, onSelect = _ref.onSelect, disabled = _ref.disabled, value = _ref.value, children = _ref.children, other = (0, $lfiYO.default)(_ref, [
        "selected",
        "onSelect",
        "disabled",
        "value",
        "children"
    ]);
    var classes = $de175b290940fe5c$var$useStyles$2();
    var handleSelection = (0, $7fPBF.useCallback)(function() {
        onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $7fPBF.createElement)((0, $1rW9t.default), (0, $kY3Ke.default)({
        role: "button",
        component: "div",
        className: (0, $jtRae.default)(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
        tabIndex: disabled ? -1 : 0,
        onClick: handleSelection,
        onKeyPress: handleSelection,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children
    }, other));
};
$de175b290940fe5c$var$Month.displayName = 'Month';
var $de175b290940fe5c$var$useStyles$3 = (0, $by0pu.default)({
    container: {
        width: 310,
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'stretch'
    }
}, {
    name: 'MuiPickersMonthSelection'
});
var $de175b290940fe5c$var$MonthSelection = function MonthSelection(_ref) {
    var disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, minDate = _ref.minDate, maxDate = _ref.maxDate, date = _ref.date, onMonthChange = _ref.onMonthChange, onChange = _ref.onChange;
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var classes = $de175b290940fe5c$var$useStyles$3();
    var currentMonth = utils.getMonth(date);
    var shouldDisableMonth = function shouldDisableMonth(month) {
        var now = utils.date();
        var utilMinDate = utils.date(minDate);
        var utilMaxDate = utils.date(maxDate);
        var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
        var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
        var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
        var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
        return isBeforeFirstEnabled || isAfterLastEnabled;
    };
    var onMonthSelect = (0, $7fPBF.useCallback)(function(month) {
        var newDate = utils.setMonth(date, month);
        onChange(newDate, true);
        if (onMonthChange) onMonthChange(newDate);
    }, [
        date,
        onChange,
        onMonthChange,
        utils
    ]);
    return (0, $7fPBF.createElement)("div", {
        className: classes.container
    }, utils.getMonthArray(date).map(function(month) {
        var monthNumber = utils.getMonth(month);
        var monthText = utils.format(month, 'MMM');
        return (0, $7fPBF.createElement)($de175b290940fe5c$var$Month, {
            key: monthText,
            value: monthNumber,
            selected: monthNumber === currentMonth,
            onSelect: onMonthSelect,
            disabled: shouldDisableMonth(month)
        }, monthText);
    }));
};
var $de175b290940fe5c$var$getOrientation = function getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
};
function $de175b290940fe5c$var$useIsLandscape(customOrientation) {
    var _React$useState = (0, $7fPBF.useState)($de175b290940fe5c$var$getOrientation()), _React$useState2 = (0, $2gIIh.default)(_React$useState, 2), orientation = _React$useState2[0], setOrientation = _React$useState2[1];
    var eventHandler = (0, $7fPBF.useCallback)(function() {
        return setOrientation($de175b290940fe5c$var$getOrientation());
    }, []);
    (0, $cd212b0f1fc3eb1e$export$3b14a55fb2447963)(function() {
        window.addEventListener('orientationchange', eventHandler);
        return function() {
            return window.removeEventListener('orientationchange', eventHandler);
        };
    }, [
        eventHandler
    ]);
    var orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
}
function $de175b290940fe5c$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $de175b290940fe5c$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $de175b290940fe5c$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $de175b290940fe5c$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $de175b290940fe5c$var$viewsMap = {
    year: $de175b290940fe5c$var$YearSelection,
    month: $de175b290940fe5c$var$MonthSelection,
    date: (0, $8ffb4fc961e2858e$export$407448d2b89b1813),
    hours: (0, $e61ec10ec65007a8$export$e6ca67116c8adcad),
    minutes: (0, $e61ec10ec65007a8$export$e6ca67116c8adcad),
    seconds: (0, $e61ec10ec65007a8$export$e6ca67116c8adcad)
};
var $de175b290940fe5c$var$useStyles$4 = (0, $by0pu.default)({
    container: {
        display: 'flex',
        flexDirection: 'column'
    },
    containerLandscape: {
        flexDirection: 'row'
    },
    pickerView: {
        overflowX: 'hidden',
        minHeight: (0, $cd212b0f1fc3eb1e$export$8b22cf2602fb60ce),
        minWidth: (0, $cd212b0f1fc3eb1e$export$96f57966bedc81b4),
        maxWidth: (0, $cd212b0f1fc3eb1e$export$db3b6bfb95261072),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    pickerViewLandscape: {
        padding: '0 8px'
    }
}, {
    name: 'MuiPickersBasePicker'
});
var $de175b290940fe5c$export$56c0d5a1e737357d = function Picker(_ref) {
    var date = _ref.date, views = _ref.views, disableToolbar = _ref.disableToolbar, onChange = _ref.onChange, openTo = _ref.openTo, unparsedMinDate = _ref.minDate, unparsedMaxDate = _ref.maxDate, ToolbarComponent = _ref.ToolbarComponent, orientation = _ref.orientation, rest = (0, $lfiYO.default)(_ref, [
        "date",
        "views",
        "disableToolbar",
        "onChange",
        "openTo",
        "minDate",
        "maxDate",
        "ToolbarComponent",
        "orientation"
    ]);
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var classes = $de175b290940fe5c$var$useStyles$4();
    var isLandscape = $de175b290940fe5c$var$useIsLandscape(orientation);
    var _useViews = $de175b290940fe5c$var$useViews(views, openTo, onChange), openView = _useViews.openView, setOpenView = _useViews.setOpenView, handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
    var minDate = (0, $7fPBF.useMemo)(function() {
        return utils.date(unparsedMinDate);
    }, [
        unparsedMinDate,
        utils
    ]);
    var maxDate = (0, $7fPBF.useMemo)(function() {
        return utils.date(unparsedMaxDate);
    }, [
        unparsedMaxDate,
        utils
    ]);
    return (0, $7fPBF.createElement)("div", {
        className: (0, $jtRae.default)(classes.container, isLandscape && classes.containerLandscape)
    }, !disableToolbar && (0, $7fPBF.createElement)(ToolbarComponent, (0, $kY3Ke.default)({}, rest, {
        views: views,
        isLandscape: isLandscape,
        date: date,
        onChange: onChange,
        setOpenView: setOpenView,
        openView: openView
    })), (0, $7fPBF.createElement)("div", {
        className: (0, $jtRae.default)(classes.pickerView, isLandscape && classes.pickerViewLandscape)
    }, openView === 'year' && (0, $7fPBF.createElement)($de175b290940fe5c$var$YearSelection, (0, $kY3Ke.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'month' && (0, $7fPBF.createElement)($de175b290940fe5c$var$MonthSelection, (0, $kY3Ke.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'date' && (0, $7fPBF.createElement)((0, $8ffb4fc961e2858e$export$407448d2b89b1813), (0, $kY3Ke.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && (0, $7fPBF.createElement)((0, $e61ec10ec65007a8$export$e6ca67116c8adcad), (0, $kY3Ke.default)({}, rest, {
        date: date,
        type: openView,
        onHourChange: handleChangeAndOpenNext,
        onMinutesChange: handleChangeAndOpenNext,
        onSecondsChange: handleChangeAndOpenNext
    }))));
};
$de175b290940fe5c$export$56c0d5a1e737357d.defaultProps = $de175b290940fe5c$var$_objectSpread$1({}, $de175b290940fe5c$export$4368d992c4eafac0, {
    views: Object.keys($de175b290940fe5c$var$viewsMap)
});


var $4dce3e9338009f47$var$useStyles = (0, $by0pu.default)(function(theme) {
    var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
    return {
        toolbarTxt: {
            color: (0, $2jEfe.fade)(textColor, 0.54)
        },
        toolbarBtnSelected: {
            color: textColor
        }
    };
}, {
    name: 'MuiPickersToolbarText'
});
var $4dce3e9338009f47$export$db3b6bfb95261072 = function ToolbarText(_ref) {
    var selected = _ref.selected, label = _ref.label, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $lfiYO.default)(_ref, [
        "selected",
        "label",
        "className"
    ]);
    var classes = $4dce3e9338009f47$var$useStyles();
    return (0, $7fPBF.createElement)((0, $1rW9t.default), (0, $kY3Ke.default)({
        children: label,
        className: (0, $jtRae.default)(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
    }, other));
};
var $4dce3e9338009f47$var$ToolbarButton = function ToolbarButton(_ref) {
    var classes = _ref.classes, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, label = _ref.label, selected = _ref.selected, variant = _ref.variant, align = _ref.align, typographyClassName = _ref.typographyClassName, other = (0, $lfiYO.default)(_ref, [
        "classes",
        "className",
        "label",
        "selected",
        "variant",
        "align",
        "typographyClassName"
    ]);
    return (0, $7fPBF.createElement)((0, $fwAOd.default), (0, $kY3Ke.default)({
        variant: "text",
        className: (0, $jtRae.default)(classes.toolbarBtn, className)
    }, other), (0, $7fPBF.createElement)($4dce3e9338009f47$export$db3b6bfb95261072, {
        align: align,
        className: typographyClassName,
        variant: variant,
        label: label,
        selected: selected
    }));
};
$4dce3e9338009f47$var$ToolbarButton.defaultProps = {
    className: ''
};
var $4dce3e9338009f47$var$styles = (0, $lEobJ.default)({
    toolbarBtn: {
        padding: 0,
        minWidth: '16px',
        textTransform: 'none'
    }
});
var $4dce3e9338009f47$export$971d5caa766a69d7 = (0, $3Sc7z.default)($4dce3e9338009f47$var$styles, {
    name: 'MuiPickersToolbarButton'
})($4dce3e9338009f47$var$ToolbarButton);
var $4dce3e9338009f47$var$useStyles$1 = (0, $by0pu.default)(function(theme) {
    return {
        toolbar: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: 100,
            backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
        },
        toolbarLandscape: {
            height: 'auto',
            maxWidth: 150,
            padding: 8,
            justifyContent: 'flex-start'
        }
    };
}, {
    name: 'MuiPickersToolbar'
});
var $4dce3e9338009f47$export$56c0d5a1e737357d = function PickerToolbar(_ref) {
    var children = _ref.children, isLandscape = _ref.isLandscape, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $lfiYO.default)(_ref, [
        "children",
        "isLandscape",
        "className"
    ]);
    var classes = $4dce3e9338009f47$var$useStyles$1();
    return (0, $7fPBF.createElement)((0, $kGz5b.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
    }, other), children);
};
function $4dce3e9338009f47$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4dce3e9338009f47$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4dce3e9338009f47$var$ownKeys(source, true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4dce3e9338009f47$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4dce3e9338009f47$export$407448d2b89b1813 = function PureDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, InputProps = _ref.InputProps, onOpen = _ref.openPicker, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $MQfsM.default) : _ref$TextFieldCompone, other = (0, $lfiYO.default)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "InputProps",
        "openPicker",
        "TextFieldComponent"
    ]);
    var PureDateInputProps = (0, $7fPBF.useMemo)(function() {
        return $4dce3e9338009f47$var$_objectSpread({}, InputProps, {
            readOnly: true
        });
    }, [
        InputProps
    ]);
    return (0, $7fPBF.createElement)(TextFieldComponent, (0, $kY3Ke.default)({
        error: Boolean(validationError),
        helperText: validationError
    }, other, {
        // do not overridable
        onClick: onOpen,
        value: inputValue,
        variant: inputVariant,
        InputProps: PureDateInputProps,
        onKeyDown: function onKeyDown(e) {
            // space
            if (e.keyCode === 32) {
                e.stopPropagation();
                onOpen();
            }
        }
    }));
};
$4dce3e9338009f47$export$407448d2b89b1813.displayName = 'PureDateInput';
var $4dce3e9338009f47$var$KeyboardIcon = function KeyboardIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $gC5xr.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }));
};
var $4dce3e9338009f47$var$getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
    var invalidLabel = _ref.invalidLabel, emptyLabel = _ref.emptyLabel, labelFunc = _ref.labelFunc;
    var date = utils.date(value);
    if (labelFunc) return labelFunc(isEmpty ? null : date, invalidLabel);
    if (isEmpty) return emptyLabel || '';
    return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};
var $4dce3e9338009f47$var$getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.endOfDay(date);
};
var $4dce3e9338009f47$var$getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.startOfDay(date);
};
var $4dce3e9338009f47$export$90a7f3efeed30595 = function validate(value, utils, _ref2) {
    var maxDate = _ref2.maxDate, minDate = _ref2.minDate, disablePast = _ref2.disablePast, disableFuture = _ref2.disableFuture, maxDateMessage = _ref2.maxDateMessage, minDateMessage = _ref2.minDateMessage, invalidDateMessage = _ref2.invalidDateMessage, strictCompareDates = _ref2.strictCompareDates;
    var parsedValue = utils.date(value); // if null - do not show error
    if (value === null) return '';
    if (!utils.isValid(value)) return invalidDateMessage;
    if (maxDate && utils.isAfter(parsedValue, $4dce3e9338009f47$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) return maxDateMessage;
    if (disableFuture && utils.isAfter(parsedValue, $4dce3e9338009f47$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) return maxDateMessage;
    if (minDate && utils.isBefore(parsedValue, $4dce3e9338009f47$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) return minDateMessage;
    if (disablePast && utils.isBefore(parsedValue, $4dce3e9338009f47$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) return minDateMessage;
    return '';
};
function $4dce3e9338009f47$export$ffb5f4729a158638(userFormat) {
    var ampm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var formats = arguments.length > 2 ? arguments[2] : undefined;
    if (userFormat) return userFormat;
    return ampm ? formats['12h'] : formats['24h'];
}
function $4dce3e9338009f47$var$makeMaskFromFormat(format, numberMaskChar) {
    return format.replace(/[a-z]/gi, numberMaskChar);
}
var $4dce3e9338009f47$var$maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
    return function(value) {
        var result = '';
        var parsed = value.replace(refuse, '');
        if (parsed === '') return parsed;
        var i = 0;
        var n = 0;
        while(i < mask.length){
            var maskChar = mask[i];
            if (maskChar === numberMaskChar && n < parsed.length) {
                var parsedChar = parsed[n];
                result += parsedChar;
                n += 1;
            } else result += maskChar;
            i += 1;
        }
        return result;
    };
};
function $4dce3e9338009f47$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4dce3e9338009f47$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4dce3e9338009f47$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4dce3e9338009f47$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4dce3e9338009f47$export$3466f893ebf79586 = function KeyboardDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, KeyboardButtonProps = _ref.KeyboardButtonProps, InputAdornmentProps = _ref.InputAdornmentProps, onOpen = _ref.openPicker, onChange = _ref.onChange, InputProps = _ref.InputProps, mask = _ref.mask, _ref$maskChar = _ref.maskChar, maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar, _ref$refuse = _ref.refuse, refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse, format = _ref.format, keyboardIcon = _ref.keyboardIcon, disabled = _ref.disabled, rifmFormatter = _ref.rifmFormatter, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $MQfsM.default) : _ref$TextFieldCompone, other = (0, $lfiYO.default)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "KeyboardButtonProps",
        "InputAdornmentProps",
        "openPicker",
        "onChange",
        "InputProps",
        "mask",
        "maskChar",
        "refuse",
        "format",
        "keyboardIcon",
        "disabled",
        "rifmFormatter",
        "TextFieldComponent"
    ]);
    var inputMask = mask || $4dce3e9338009f47$var$makeMaskFromFormat(format, maskChar); // prettier-ignore
    var formatter = (0, $7fPBF.useMemo)(function() {
        return $4dce3e9338009f47$var$maskedDateFormatter(inputMask, maskChar, refuse);
    }, [
        inputMask,
        maskChar,
        refuse
    ]);
    var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';
    var handleChange = function handleChange(text) {
        var finalString = text === '' || text === inputMask ? null : text;
        onChange(finalString);
    };
    return (0, $7fPBF.createElement)((0, $1542018035baed54$export$5519909ee832c7c), {
        key: inputMask,
        value: inputValue,
        onChange: handleChange,
        refuse: refuse,
        format: rifmFormatter || formatter
    }, function(_ref2) {
        var onChange = _ref2.onChange, value = _ref2.value;
        return (0, $7fPBF.createElement)(TextFieldComponent, (0, $kY3Ke.default)({
            disabled: disabled,
            error: Boolean(validationError),
            helperText: validationError
        }, other, {
            value: value,
            onChange: onChange,
            variant: inputVariant,
            InputProps: $4dce3e9338009f47$var$_objectSpread$1({}, InputProps, (0, $dQMrF.default)({}, "".concat(position, "Adornment"), (0, $7fPBF.createElement)((0, $0d5df0aef00ddb22$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                position: position
            }, InputAdornmentProps), (0, $7fPBF.createElement)((0, $iRcsz.default), (0, $kY3Ke.default)({
                disabled: disabled
            }, KeyboardButtonProps, {
                onClick: onOpen
            }), keyboardIcon))))
        }));
    });
};
$4dce3e9338009f47$export$3466f893ebf79586.defaultProps = {
    keyboardIcon: (0, $7fPBF.createElement)($4dce3e9338009f47$var$KeyboardIcon, null)
};
function $4dce3e9338009f47$var$useOpenState(_ref) {
    var open = _ref.open, onOpen = _ref.onOpen, onClose = _ref.onClose;
    var setIsOpenState = null;
    if (open === undefined || open === null) {
        // The component is uncontrolled, so we need to give it its own state.
        var _useState = (0, $7fPBF.useState)(false);
        var _useState2 = (0, $2gIIh.default)(_useState, 2);
        open = _useState2[0];
        setIsOpenState = _useState2[1];
    } // prettier-ignore
    var setIsOpen = (0, $7fPBF.useCallback)(function(newIsOpen) {
        setIsOpenState && setIsOpenState(newIsOpen);
        return newIsOpen ? onOpen && onOpen() : onClose && onClose();
    }, [
        onOpen,
        onClose,
        setIsOpenState
    ]);
    return {
        isOpen: open,
        setIsOpen: setIsOpen
    };
}
var $4dce3e9338009f47$var$useValueToDate = function useValueToDate(utils, _ref) {
    var value = _ref.value, initialFocusedDate = _ref.initialFocusedDate;
    var nowRef = (0, $7fPBF.useRef)(utils.date());
    var date = utils.date(value || initialFocusedDate || nowRef.current);
    return date && utils.isValid(date) ? date : nowRef.current;
};
function $4dce3e9338009f47$var$useDateValues(props, options) {
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var date = $4dce3e9338009f47$var$useValueToDate(utils, props);
    var format = props.format || options.getDefaultFormat();
    return {
        date: date,
        format: format
    };
}
function $4dce3e9338009f47$export$3b14a55fb2447963(props, options) {
    var autoOk = props.autoOk, disabled = props.disabled, readOnly = props.readOnly, onAccept = props.onAccept, _onChange = props.onChange, onError = props.onError, value = props.value, variant = props.variant;
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var _useOpenState = $4dce3e9338009f47$var$useOpenState(props), isOpen = _useOpenState.isOpen, setIsOpen = _useOpenState.setIsOpen;
    var _useDateValues = $4dce3e9338009f47$var$useDateValues(props, options), date = _useDateValues.date, format = _useDateValues.format;
    var _useState = (0, $7fPBF.useState)(date), _useState2 = (0, $2gIIh.default)(_useState, 2), pickerDate = _useState2[0], setPickerDate = _useState2[1];
    (0, $7fPBF.useEffect)(function() {
        // if value was changed in closed state - treat it as accepted
        if (!isOpen && !utils.isEqual(pickerDate, date)) setPickerDate(date);
    }, [
        date,
        isOpen,
        pickerDate,
        utils
    ]);
    var acceptDate = (0, $7fPBF.useCallback)(function(acceptedDate) {
        _onChange(acceptedDate);
        if (onAccept) onAccept(acceptedDate);
        setIsOpen(false);
    }, [
        onAccept,
        _onChange,
        setIsOpen
    ]);
    var wrapperProps = (0, $7fPBF.useMemo)(function() {
        return {
            format: format,
            open: isOpen,
            onClear: function onClear() {
                return acceptDate(null);
            },
            onAccept: function onAccept() {
                return acceptDate(pickerDate);
            },
            onSetToday: function onSetToday() {
                return setPickerDate(utils.date());
            },
            onDismiss: function onDismiss() {
                setIsOpen(false);
            }
        };
    }, [
        acceptDate,
        format,
        isOpen,
        pickerDate,
        setIsOpen,
        utils
    ]);
    var pickerProps = (0, $7fPBF.useMemo)(function() {
        return {
            date: pickerDate,
            onChange: function onChange(newDate) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                setPickerDate(newDate);
                if (isFinish && autoOk) {
                    acceptDate(newDate);
                    return;
                } // simulate autoOk, but do not close the modal
                if (variant === 'inline' || variant === 'static') {
                    _onChange(newDate);
                    onAccept && onAccept(newDate);
                }
            }
        };
    }, [
        acceptDate,
        autoOk,
        onAccept,
        _onChange,
        pickerDate,
        variant
    ]);
    var validationError = $4dce3e9338009f47$export$90a7f3efeed30595(value, utils, props);
    (0, $7fPBF.useEffect)(function() {
        if (onError) onError(validationError, value);
    }, [
        onError,
        validationError,
        value
    ]);
    var inputValue = $4dce3e9338009f47$var$getDisplayDate(date, format, utils, value === null, props);
    var inputProps = (0, $7fPBF.useMemo)(function() {
        return {
            inputValue: inputValue,
            validationError: validationError,
            openPicker: function openPicker() {
                return !readOnly && !disabled && setIsOpen(true);
            }
        };
    }, [
        disabled,
        inputValue,
        readOnly,
        setIsOpen,
        validationError
    ]);
    var pickerState = {
        pickerProps: pickerProps,
        inputProps: inputProps,
        wrapperProps: wrapperProps
    };
    (0, $7fPBF.useDebugValue)(pickerState);
    return pickerState;
}
function $4dce3e9338009f47$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4dce3e9338009f47$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4dce3e9338009f47$var$ownKeys$2(source, true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4dce3e9338009f47$var$ownKeys$2(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4dce3e9338009f47$var$parseInputString(value, utils, format) {
    try {
        return utils.parse(value, format);
    } catch (_unused) {
        return null;
    }
}
function $4dce3e9338009f47$export$8b22cf2602fb60ce(props, options) {
    var _props$format = props.format, format = _props$format === void 0 ? options.getDefaultFormat() : _props$format, inputValue = props.inputValue, _onChange = props.onChange, value = props.value;
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var displayDate = $4dce3e9338009f47$var$getDisplayDate(value, format, utils, value === null, props);
    var _useState = (0, $7fPBF.useState)(displayDate), _useState2 = (0, $2gIIh.default)(_useState, 2), innerInputValue = _useState2[0], setInnerInputValue = _useState2[1];
    var dateValue = inputValue ? $4dce3e9338009f47$var$parseInputString(inputValue, utils, format) : value;
    (0, $7fPBF.useEffect)(function() {
        if (value === null || utils.isValid(value)) setInnerInputValue(displayDate);
    }, [
        displayDate,
        setInnerInputValue,
        utils,
        value
    ]);
    var handleKeyboardChange = (0, $7fPBF.useCallback)(function(date) {
        _onChange(date, date === null ? null : utils.format(date, format));
    }, [
        format,
        _onChange,
        utils
    ]);
    var _usePickerState = $4dce3e9338009f47$export$3b14a55fb2447963($4dce3e9338009f47$var$_objectSpread$2({}, props, {
        value: dateValue,
        onChange: handleKeyboardChange
    }), options), innerInputProps = _usePickerState.inputProps, wrapperProps = _usePickerState.wrapperProps, pickerProps = _usePickerState.pickerProps;
    var inputProps = (0, $7fPBF.useMemo)(function() {
        return $4dce3e9338009f47$var$_objectSpread$2({}, innerInputProps, {
            // reuse validation and open/close logic
            format: wrapperProps.format,
            inputValue: inputValue || innerInputValue,
            onChange: function onChange(value) {
                setInnerInputValue(value || '');
                var date = value === null ? null : utils.parse(value, wrapperProps.format);
                _onChange(date, value);
            }
        });
    }, [
        innerInputProps,
        innerInputValue,
        inputValue,
        _onChange,
        utils,
        wrapperProps.format
    ]);
    return {
        inputProps: inputProps,
        wrapperProps: wrapperProps,
        pickerProps: pickerProps
    };
}
function $4dce3e9338009f47$export$953cecd6e717a553(_ref) {
    var Input = _ref.Input, useState = _ref.useState, useOptions = _ref.useOptions, getCustomProps = _ref.getCustomProps, DefaultToolbarComponent = _ref.DefaultToolbarComponent;
    function PickerWithState(props) {
        var allowKeyboardControl = props.allowKeyboardControl, ampm = props.ampm, animateYearScrolling = props.animateYearScrolling, autoOk = props.autoOk, dateRangeIcon = props.dateRangeIcon, disableFuture = props.disableFuture, disablePast = props.disablePast, disableToolbar = props.disableToolbar, emptyLabel = props.emptyLabel, format = props.format, forwardedRef = props.forwardedRef, hideTabs = props.hideTabs, initialFocusedDate = props.initialFocusedDate, invalidDateMessage = props.invalidDateMessage, invalidLabel = props.invalidLabel, labelFunc = props.labelFunc, leftArrowButtonProps = props.leftArrowButtonProps, leftArrowIcon = props.leftArrowIcon, loadingIndicator = props.loadingIndicator, maxDate = props.maxDate, maxDateMessage = props.maxDateMessage, minDate = props.minDate, minDateMessage = props.minDateMessage, minutesStep = props.minutesStep, onAccept = props.onAccept, onChange = props.onChange, onClose = props.onClose, onMonthChange = props.onMonthChange, onOpen = props.onOpen, onYearChange = props.onYearChange, openTo = props.openTo, orientation = props.orientation, renderDay = props.renderDay, rightArrowButtonProps = props.rightArrowButtonProps, rightArrowIcon = props.rightArrowIcon, shouldDisableDate = props.shouldDisableDate, strictCompareDates = props.strictCompareDates, timeIcon = props.timeIcon, _props$ToolbarCompone = props.ToolbarComponent, ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone, value = props.value, variant = props.variant, views = props.views, other = (0, $lfiYO.default)(props, [
            "allowKeyboardControl",
            "ampm",
            "animateYearScrolling",
            "autoOk",
            "dateRangeIcon",
            "disableFuture",
            "disablePast",
            "disableToolbar",
            "emptyLabel",
            "format",
            "forwardedRef",
            "hideTabs",
            "initialFocusedDate",
            "invalidDateMessage",
            "invalidLabel",
            "labelFunc",
            "leftArrowButtonProps",
            "leftArrowIcon",
            "loadingIndicator",
            "maxDate",
            "maxDateMessage",
            "minDate",
            "minDateMessage",
            "minutesStep",
            "onAccept",
            "onChange",
            "onClose",
            "onMonthChange",
            "onOpen",
            "onYearChange",
            "openTo",
            "orientation",
            "renderDay",
            "rightArrowButtonProps",
            "rightArrowIcon",
            "shouldDisableDate",
            "strictCompareDates",
            "timeIcon",
            "ToolbarComponent",
            "value",
            "variant",
            "views"
        ]);
        var injectedProps = getCustomProps ? getCustomProps(props) : {};
        var options = useOptions(props);
        var _useState = useState(props, options), pickerProps = _useState.pickerProps, inputProps = _useState.inputProps, wrapperProps = _useState.wrapperProps;
        return (0, $7fPBF.createElement)((0, $cd212b0f1fc3eb1e$export$71cec2538cb2c617), (0, $kY3Ke.default)({
            variant: variant,
            InputComponent: Input,
            DateInputProps: inputProps
        }, injectedProps, wrapperProps, other), (0, $7fPBF.createElement)((0, $de175b290940fe5c$export$56c0d5a1e737357d), (0, $kY3Ke.default)({}, pickerProps, {
            allowKeyboardControl: allowKeyboardControl,
            ampm: ampm,
            animateYearScrolling: animateYearScrolling,
            dateRangeIcon: dateRangeIcon,
            disableFuture: disableFuture,
            disablePast: disablePast,
            disableToolbar: disableToolbar,
            hideTabs: hideTabs,
            leftArrowButtonProps: leftArrowButtonProps,
            leftArrowIcon: leftArrowIcon,
            loadingIndicator: loadingIndicator,
            maxDate: maxDate,
            minDate: minDate,
            minutesStep: minutesStep,
            onMonthChange: onMonthChange,
            onYearChange: onYearChange,
            openTo: openTo,
            orientation: orientation,
            renderDay: renderDay,
            rightArrowButtonProps: rightArrowButtonProps,
            rightArrowIcon: rightArrowIcon,
            shouldDisableDate: shouldDisableDate,
            strictCompareDates: strictCompareDates,
            timeIcon: timeIcon,
            ToolbarComponent: ToolbarComponent,
            views: views
        })));
    }
    return PickerWithState;
}











parcelRequire("2gIIh");

parcelRequire("03dWn");
parcelRequire("4OFm0");












var $745a23e9bec21737$var$useStyles = (0, $by0pu.default)({
    toolbar: {
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    toolbarLandscape: {
        padding: 16
    },
    dateLandscape: {
        marginRight: 16
    }
}, {
    name: 'MuiPickersDatePickerRoot'
});
var $745a23e9bec21737$var$DatePickerToolbar = function DatePickerToolbar(_ref) {
    var date = _ref.date, views = _ref.views, setOpenView = _ref.setOpenView, isLandscape = _ref.isLandscape, openView = _ref.openView;
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    var classes = $745a23e9bec21737$var$useStyles();
    var isYearOnly = (0, $7fPBF.useMemo)(function() {
        return (0, $8ffb4fc961e2858e$export$23f2a1d2818174ef)(views);
    }, [
        views
    ]);
    var isYearAndMonth = (0, $7fPBF.useMemo)(function() {
        return (0, $8ffb4fc961e2858e$export$8b22cf2602fb60ce)(views);
    }, [
        views
    ]);
    return (0, $7fPBF.createElement)((0, $4dce3e9338009f47$export$56c0d5a1e737357d), {
        isLandscape: isLandscape,
        className: (0, $jtRae.default)(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
    }, (0, $7fPBF.createElement)((0, $4dce3e9338009f47$export$971d5caa766a69d7), {
        variant: isYearOnly ? 'h3' : 'subtitle1',
        onClick: function onClick() {
            return setOpenView('year');
        },
        selected: openView === 'year',
        label: utils.getYearText(date)
    }), !isYearOnly && !isYearAndMonth && (0, $7fPBF.createElement)((0, $4dce3e9338009f47$export$971d5caa766a69d7), {
        variant: "h4",
        selected: openView === 'date',
        onClick: function onClick() {
            return setOpenView('date');
        },
        align: isLandscape ? 'left' : 'center',
        label: utils.getDatePickerHeaderText(date),
        className: (0, $jtRae.default)(isLandscape && classes.dateLandscape)
    }), isYearAndMonth && (0, $7fPBF.createElement)((0, $4dce3e9338009f47$export$971d5caa766a69d7), {
        variant: "h4",
        onClick: function onClick() {
            return setOpenView('month');
        },
        selected: openView === 'month',
        label: utils.getMonthText(date)
    }));
};
function $745a23e9bec21737$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $745a23e9bec21737$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $745a23e9bec21737$var$ownKeys(source, true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $745a23e9bec21737$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $745a23e9bec21737$var$defaultProps = $745a23e9bec21737$var$_objectSpread({}, (0, $de175b290940fe5c$export$4368d992c4eafac0), {
    openTo: 'date',
    views: [
        'year',
        'date'
    ]
});
function $745a23e9bec21737$var$useOptions(props) {
    var utils = (0, $1aa952074218c40d$export$3b14a55fb2447963)();
    return {
        getDefaultFormat: function getDefaultFormat() {
            return (0, $8ffb4fc961e2858e$export$39b482c5e57630a8)(props.views, utils);
        }
    };
}
var $745a23e9bec21737$export$5109c6dd95d8fb00 = (0, $4dce3e9338009f47$export$953cecd6e717a553)({
    useOptions: $745a23e9bec21737$var$useOptions,
    Input: (0, $4dce3e9338009f47$export$407448d2b89b1813),
    useState: (0, $4dce3e9338009f47$export$3b14a55fb2447963),
    DefaultToolbarComponent: $745a23e9bec21737$var$DatePickerToolbar
});
var $745a23e9bec21737$export$d8c44f501031ee7c = (0, $4dce3e9338009f47$export$953cecd6e717a553)({
    useOptions: $745a23e9bec21737$var$useOptions,
    Input: (0, $4dce3e9338009f47$export$3466f893ebf79586),
    useState: (0, $4dce3e9338009f47$export$8b22cf2602fb60ce),
    DefaultToolbarComponent: $745a23e9bec21737$var$DatePickerToolbar
});
$745a23e9bec21737$export$5109c6dd95d8fb00.defaultProps = $745a23e9bec21737$var$defaultProps;
$745a23e9bec21737$export$d8c44f501031ee7c.defaultProps = $745a23e9bec21737$var$defaultProps;





const $4bdf0f4f2d57d0b8$export$868fee70d5b89439 = ({ objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`objectives/${objectiveId}/todos`);
const $4bdf0f4f2d57d0b8$export$c3b1bf9bee0d44d3 = ({ objectiveId: objectiveId, todo: todo })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(`objectives/${objectiveId}/todos`, todo);
const $4bdf0f4f2d57d0b8$export$cb3f627a9987da4 = ({ objectiveId: objectiveId, todo: todo })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`objectives/${objectiveId}/todos/${todo.id}`, todo);
const $4bdf0f4f2d57d0b8$export$a8f41ab6a0a1eaf2 = ({ objectiveId: objectiveId, todoId: todoId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).delete(`/objectives/${objectiveId}/todos/${todoId}`);



const $0bee6a0138f01099$var$useStyles = (0, $by0pu.default)((theme)=>({
        addBtn: {
            marginTop: '20px'
        },
        container: {
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column'
            }
        },
        datepicker: {
            minWidth: '170px'
        }
    }));
const $0bee6a0138f01099$var$NewTodo = ({ objectiveId: objectiveId, onSubmitSuccess: onSubmitSuccess })=>{
    const classes = $0bee6a0138f01099$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [name, setName] = (0, $7fPBF.useState)('');
    const [deadline, setDeadline] = (0, $7fPBF.useState)(null);
    const [validation, setValidation] = (0, $7fPBF.useState)({
        name: false,
        deadline: true
    });
    const createTodoMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        return await (0, $4bdf0f4f2d57d0b8$export$c3b1bf9bee0d44d3)({
            objectiveId: objectiveId,
            todo: {
                name: name,
                deadline: deadline,
                objectiveId: objectiveId
            }
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
            setName('');
            setDeadline(null);
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const handleOnChangeName = (event)=>{
        setName(event.target.value);
        setValidation((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validation), {
            name: event.target.value.length !== 0
        }));
    };
    const handleDeadlineChange = (date)=>{
        setDeadline(date);
        setValidation((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validation), {
            deadline: !date || !isNaN(Date.parse(date))
        }));
    };
    const handleAddTodo = ()=>{
        if (validation.name && validation.deadline) createTodoMutation.mutate();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                className: classes.container,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 8,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            value: name,
                            onChange: handleOnChangeName,
                            fullWidth: true,
                            placeholder: t('objective.todos.create.name.placeholder')
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 4,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $745a23e9bec21737$export$d8c44f501031ee7c), {
                            className: classes.datepicker,
                            value: deadline,
                            error: !validation.deadline,
                            helperText: !validation.deadline ? t('objective.todos.create.deadline.error') : '',
                            autoOk: true,
                            disableToolbar: true,
                            variant: "inline",
                            format: "yyyy/MM/dd",
                            onChange: handleDeadlineChange,
                            minDate: (0, $8bfb433bad942c35$export$b76490726c886755)(),
                            placeholder: t('objective.todos.create.deadline.placeholder'),
                            KeyboardButtonProps: {
                                'aria-label': 'change date',
                                position: 'start'
                            },
                            keyboardIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4e495c2b72081305$exports))), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                className: classes.addBtn,
                variant: "contained",
                color: "secondary",
                onClick: handleAddTodo,
                disabled: !validation.name || !validation.deadline,
                children: t('objective.todos.create.add.btn')
            })
        ]
    });
};
var $0bee6a0138f01099$export$2e2bcd8739ae039 = $0bee6a0138f01099$var$NewTodo;






var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $i8OTH = parcelRequire("i8OTH");
var $by0pu = parcelRequire("by0pu");
var $MQfsM = parcelRequire("MQfsM");
var $hzQpW = parcelRequire("hzQpW");


var $ac53efdc74124655$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($ac53efdc74124655$exports, "__esModule", {
    value: true
});
$ac53efdc74124655$exports.default = void 0;

var $ac53efdc74124655$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $ac53efdc74124655$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $ac53efdc74124655$var$_default = (0, $ac53efdc74124655$var$_createSvgIcon.default)(/*#__PURE__*/ $ac53efdc74124655$var$React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');
$ac53efdc74124655$exports.default = $ac53efdc74124655$var$_default;







const $e9a9674780796c08$var$useStyles = (0, $by0pu.default)((theme)=>({
        root: {
            color: '#666666',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                borderBottom: '1px solid #F1F1F1'
            }
        },
        binIcon: {
            color: '#666666',
            [theme.breakpoints.down('sm')]: {
                marginLeft: '100px'
            }
        },
        checkbox: {
            color: '#666666',
            marginLeft: '-20px'
        },
        nameInput: {
            color: '#666666',
            [theme.breakpoints.down('sm')]: {
                marginLeft: '30px'
            }
        },
        row: {
            display: 'flex',
            flexDirection: 'row'
        },
        datePicker: {
            minWidth: '170px'
        }
    }));
const $e9a9674780796c08$var$DialogTodoItem = ({ objectiveId: objectiveId, todoToUpdate: todoToUpdate, onSubmitSuccess: onSubmitSuccess, status: status })=>{
    const classes = $e9a9674780796c08$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [name, setName] = (0, $7fPBF.useState)(todoToUpdate.name);
    const [validation, setValidation] = (0, $7fPBF.useState)({
        name: todoToUpdate.name.length !== 0,
        deadline: !todoToUpdate.deadline || !isNaN(Date.parse(todoToUpdate.deadline))
    });
    const updateTodoMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (todo)=>{
        return await (0, $4bdf0f4f2d57d0b8$export$cb3f627a9987da4)({
            objectiveId: objectiveId,
            todo: todo
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const deleteTodoMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        return await (0, $4bdf0f4f2d57d0b8$export$a8f41ab6a0a1eaf2)({
            objectiveId: objectiveId,
            todoId: todoToUpdate.id
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const handleIsDoneChange = (event)=>{
        updateTodoMutation.mutate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, todoToUpdate), {
            is_done: event.target.checked
        }));
    };
    const handleOnChangeName = (event)=>{
        const isNameValid = event.target.value.length !== 0;
        setValidation((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validation), {
            name: isNameValid
        }));
        setName(event.target.value);
    };
    const handleNameBlur = ()=>{
        if (validation.name && name !== todoToUpdate.name) updateTodoMutation.mutate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, todoToUpdate), {
            name: name
        }));
    };
    const handleDeadlineChange = (date)=>{
        const isDateValid = !date || !isNaN(Date.parse(date));
        setValidation((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validation), {
            deadline: isDateValid
        }));
        if (isDateValid) updateTodoMutation.mutate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, todoToUpdate), {
            deadline: date
        }));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: classes.row,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 1,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                            disableHoverListener: (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE === status,
                            title: t(`objective.todos.error.statusError`),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), {
                                    className: classes.checkbox,
                                    checked: todoToUpdate.is_done,
                                    onChange: handleIsDoneChange,
                                    inputProps: {
                                        'aria-label': 'primary checkbox'
                                    },
                                    disabled: (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE !== status
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 11,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            onBlur: handleNameBlur,
                            value: name,
                            error: !validation.name,
                            helperText: !validation.name ? 'objective.todos.create.name.error' : '',
                            className: classes.nameInput,
                            onChange: handleOnChangeName,
                            fullWidth: true,
                            placeholder: t('objective.todos.create.name.placeholder')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: classes.row,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 7,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $745a23e9bec21737$export$d8c44f501031ee7c), {
                            className: classes.datePicker,
                            value: todoToUpdate.deadline,
                            error: !validation.deadline,
                            helperText: !validation.deadline ? t('objective.todos.create.deadline.error') : '',
                            autoOk: true,
                            disableToolbar: true,
                            variant: "inline",
                            format: "yyyy/MM/dd",
                            onChange: handleDeadlineChange,
                            minDate: (0, $8bfb433bad942c35$export$b76490726c886755)(),
                            KeyboardButtonProps: {
                                'aria-label': 'change date',
                                position: 'start'
                            },
                            keyboardIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4e495c2b72081305$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 5,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: deleteTodoMutation.mutate,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ac53efdc74124655$exports))), {
                                className: classes.binIcon
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $e9a9674780796c08$export$2e2bcd8739ae039 = $e9a9674780796c08$var$DialogTodoItem;



var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");
const $09c47ef95da3f50a$var$useStyles = (0, $by0pu.default)({
    divider: {
        margin: '30px auto'
    }
});
const $09c47ef95da3f50a$var$TodosDialog = ({ objectiveId: objectiveId, open: open, handleClose: handleClose, todos: todos, onSubmitSuccess: onSubmitSuccess, status: status })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $09c47ef95da3f50a$var$useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
        open: open,
        fullWidth: true,
        maxWidth: 'md',
        onClose: handleClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                children: t('objective.todos.dialog.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                children: [
                    todos.map((todo)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e9a9674780796c08$export$2e2bcd8739ae039), {
                            todoToUpdate: todo,
                            objectiveId: objectiveId,
                            onSubmitSuccess: onSubmitSuccess,
                            status: status
                        }, todo.id)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                        className: classes.divider
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bee6a0138f01099$export$2e2bcd8739ae039), {
                        objectiveId: objectiveId,
                        onSubmitSuccess: onSubmitSuccess
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: handleClose,
                    color: "primary",
                    children: t('objective.todos.dialog.close.btn')
                })
            })
        ]
    });
};
var $09c47ef95da3f50a$export$2e2bcd8739ae039 = $09c47ef95da3f50a$var$TodosDialog;





parcelRequire("7fPBF");


var $5b40c7dadcfb26af$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($5b40c7dadcfb26af$exports, "__esModule", {
    value: true
});
$5b40c7dadcfb26af$exports.default = void 0;

var $5b40c7dadcfb26af$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $5b40c7dadcfb26af$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $5b40c7dadcfb26af$var$_default = (0, $5b40c7dadcfb26af$var$_createSvgIcon.default)(/*#__PURE__*/ $5b40c7dadcfb26af$var$React.createElement("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
$5b40c7dadcfb26af$exports.default = $5b40c7dadcfb26af$var$_default;



var $i8OTH = parcelRequire("i8OTH");
var $by0pu = parcelRequire("by0pu");
var $hzQpW = parcelRequire("hzQpW");

var $6qwOn = parcelRequire("6qwOn");





const $3dd9bbfafdca69fd$var$useStyles = (0, $by0pu.default)({
    root: {
        color: '#666666'
    },
    checkbox: {
        color: '#666666'
    },
    textBox: {
        margin: 'auto 0',
        display: 'flex',
        flexDirection: 'row'
    },
    deadline: {
        margin: 'auto 0 auto 10px'
    }
});
const $3dd9bbfafdca69fd$var$TodoItem = ({ todo: todo, objectiveId: objectiveId, onSubmitSuccess: onSubmitSuccess, status: status })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $3dd9bbfafdca69fd$var$useStyles();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const updateTodoMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (todo)=>{
        return await (0, $4bdf0f4f2d57d0b8$export$cb3f627a9987da4)({
            objectiveId: objectiveId,
            todo: todo
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const handleIsDoneChange = (event)=>{
        updateTodoMutation.mutate((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, todo), {
            is_done: event.target.checked
        }));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: classes.textBox,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                        disableHoverListener: (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE === status,
                        title: t(`objective.todos.error.statusError`),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), {
                                className: classes.checkbox,
                                checked: todo.is_done,
                                onChange: handleIsDoneChange,
                                disabled: (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE !== status
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        className: classes.textBox,
                        children: [
                            " ",
                            todo.name
                        ]
                    })
                ]
            }),
            todo.deadline && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                className: classes.textBox,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5b40c7dadcfb26af$exports))), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: classes.deadline,
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(todo.deadline).format('L')
                    })
                ]
            })
        ]
    }, todo.id);
};
var $3dd9bbfafdca69fd$export$2e2bcd8739ae039 = $3dd9bbfafdca69fd$var$TodoItem;



var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");



const $0440723b6a109160$var$TodosPanel = ({ objectiveId: objectiveId, status: status })=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [todoListDialogOpen, setTodoListDialogOpen] = (0, $7fPBF.useState)(false);
    const todosQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'todos',
        objectiveId
    ], async ()=>{
        const { data: data } = await (0, $4bdf0f4f2d57d0b8$export$868fee70d5b89439)({
            objectiveId: objectiveId
        });
        data.sort((x, y)=>new Date(x.deadline) - new Date(y.deadline));
        return data;
    }, {
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    var _todosQuery_data;
    const todos = (_todosQuery_data = todosQuery.data) !== null && _todosQuery_data !== void 0 ? _todosQuery_data : [];
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const useStyles = (0, $by0pu.default)({
        title: {
            color: '#999999',
            fontSize: '16px',
            textTransform: 'uppercase'
        },
        btn: {
            marginTop: '20px'
        },
        container: {
            backgroundColor: '#F4F4F4',
            padding: '20px'
        },
        noTodo: {
            marginTop: '5px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $86a6140e16b13821$export$2e2bcd8739ae039), {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.title,
                children: t('objective.todos.list.title')
            }),
            todos.length !== 0 ? todos.map((todo)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3dd9bbfafdca69fd$export$2e2bcd8739ae039), {
                    todo: todo,
                    objectiveId: objectiveId,
                    onSubmitSuccess: todosQuery.refetch,
                    status: status
                }, todo.id)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                variant: "body2",
                className: classes.noTodo,
                children: t('objective.todos.noTodo')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                className: classes.btn,
                variant: "contained",
                color: "secondary",
                onClick: ()=>setTodoListDialogOpen(true),
                children: todos.length === 0 ? t('objective.todos.list.create.btn') : t('objective.todos.list.edit.btn')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09c47ef95da3f50a$export$2e2bcd8739ae039), {
                open: todoListDialogOpen,
                handleClose: ()=>setTodoListDialogOpen(false),
                objectiveId: objectiveId,
                todos: todos,
                onSubmitSuccess: todosQuery.refetch,
                status: status
            })
        ]
    });
};
var $0440723b6a109160$export$2e2bcd8739ae039 = $0440723b6a109160$var$TodosPanel;



parcelRequire("7fPBF");

var $fOH1P = parcelRequire("fOH1P");
var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");





var $7fPBF = parcelRequire("7fPBF");


var $dzfbx = parcelRequire("dzfbx");
var $hPUC4 = parcelRequire("hPUC4");
var $by0pu = parcelRequire("by0pu");
var $cc9391fc9edf9223$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($cc9391fc9edf9223$exports, "__esModule", {
    value: true
});
$cc9391fc9edf9223$exports.default = void 0;

var $cc9391fc9edf9223$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $cc9391fc9edf9223$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $cc9391fc9edf9223$var$_default = (0, $cc9391fc9edf9223$var$_createSvgIcon.default)(/*#__PURE__*/ $cc9391fc9edf9223$var$React.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
}), 'LockOutlined');
$cc9391fc9edf9223$exports.default = $cc9391fc9edf9223$var$_default;




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
// Fallback locale.
// (when not a single one of the supplied "preferred" locales is available)
var $bd57aa6cfe038407$var$defaultLocale = 'en'; // For all locales added
// their relative time formatter messages will be stored here.
var $bd57aa6cfe038407$var$localesData = {}; // According to the spec BCP 47 language tags are case-insensitive.
// https://tools.ietf.org/html/rfc5646
var $bd57aa6cfe038407$var$lowercaseLocaleLookup = {};
function $bd57aa6cfe038407$export$f09106e7c6677ec5() {
    return $bd57aa6cfe038407$var$defaultLocale;
}
function $bd57aa6cfe038407$export$a1a5025df4e9ba34(locale) {
    $bd57aa6cfe038407$var$defaultLocale = locale;
}
function $bd57aa6cfe038407$export$aa5c834303254f2b(locale) {
    return $bd57aa6cfe038407$var$localesData[locale];
}
function $bd57aa6cfe038407$export$9b0a0997606861b1(localeData) {
    if (!localeData) throw new Error('No locale data passed');
     // This locale data is stored in a global variable
    // and later used when calling `.format(time)`.
    $bd57aa6cfe038407$var$localesData[localeData.locale] = localeData;
    $bd57aa6cfe038407$var$lowercaseLocaleLookup[localeData.locale.toLowerCase()] = localeData.locale;
}
function $bd57aa6cfe038407$export$df9bcabe7f932e01(locale) {
    if ($bd57aa6cfe038407$var$localesData[locale]) return locale;
    if ($bd57aa6cfe038407$var$lowercaseLocaleLookup[locale.toLowerCase()]) return $bd57aa6cfe038407$var$lowercaseLocaleLookup[locale.toLowerCase()];
}



function $9c9d5070956ee633$export$2e2bcd8739ae039(locale) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var localeMatcher = options.localeMatcher || 'lookup';
    switch(localeMatcher){
        case 'lookup':
            return $9c9d5070956ee633$export$2e0348b7dcc5be0a(locale);
        // "best fit" locale matching is not supported.
        // https://github.com/catamphetamine/relative-time-format/issues/2
        case 'best fit':
            // return resolveLocaleBestFit(locale)
            return $9c9d5070956ee633$export$2e0348b7dcc5be0a(locale);
        default:
            throw new RangeError("Invalid \"localeMatcher\" option: ".concat(localeMatcher));
    }
}
function $9c9d5070956ee633$export$2e0348b7dcc5be0a(locale) {
    var resolvedLocale = (0, $bd57aa6cfe038407$export$df9bcabe7f932e01)(locale);
    if (resolvedLocale) return resolvedLocale;
     // `sr-Cyrl-BA` -> `sr-Cyrl` -> `sr`.
    var parts = locale.split('-');
    while(locale.length > 1){
        parts.pop();
        locale = parts.join('-');
        var _resolvedLocale = (0, $bd57aa6cfe038407$export$df9bcabe7f932e01)(locale);
        if (_resolvedLocale) return _resolvedLocale;
    }
}


// (this file was autogenerated by `generate-locales`)
// "plural rules" functions are not stored in locale JSON files because they're not strings.
// This file isn't big — it's about 5 kilobytes in size (minified).
// Alternatively, the pluralization rules for each locale could be stored
// in their JSON files in a non-parsed form and later parsed via `make-plural` library.
// But `make-plural` library itself is relatively big in size:
// `make-plural.min.js` is about 6 kilobytes (https://unpkg.com/make-plural/).
// So, it's more practical to bypass runtime `make-plural` pluralization rules compilation
// and just include the already compiled pluarlization rules for all locales in the library code.
var $cdde293ac67ab855$var$$ = {
    af: function af(n) {
        return n == 1 ? 'one' : 'other';
    },
    am: function am(n) {
        return n >= 0 && n <= 1 ? 'one' : 'other';
    },
    ar: function ar(n) {
        var s = String(n).split('.'), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
        return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 99 ? 'many' : 'other';
    },
    ast: function ast(n) {
        var s = String(n).split('.'), v0 = !s[1];
        return n == 1 && v0 ? 'one' : 'other';
    },
    be: function be(n) {
        var s = String(n).split('.'), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        return n10 == 1 && n100 != 11 ? 'one' : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? 'few' : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? 'many' : 'other';
    },
    br: function br(n) {
        var s = String(n).split('.'), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), n1000000 = t0 && s[0].slice(-6);
        return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? 'one' : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? 'two' : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? 'few' : n != 0 && t0 && n1000000 == 0 ? 'many' : 'other';
    },
    bs: function bs(n) {
        var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
        return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? 'few' : 'other';
    },
    ca: function ca(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
        return n == 1 && v0 ? 'one' : i != 0 && i1000000 == 0 && v0 ? 'many' : 'other';
    },
    ceb: function ceb(n) {
        var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), f10 = f.slice(-1);
        return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? 'one' : 'other';
    },
    cs: function cs(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1];
        return n == 1 && v0 ? 'one' : i >= 2 && i <= 4 && v0 ? 'few' : !v0 ? 'many' : 'other';
    },
    cy: function cy(n) {
        return n == 0 ? 'zero' : n == 1 ? 'one' : n == 2 ? 'two' : n == 3 ? 'few' : n == 6 ? 'many' : 'other';
    },
    da: function da(n) {
        var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
        return n == 1 || !t0 && (i == 0 || i == 1) ? 'one' : 'other';
    },
    dsb: function dsb(n) {
        var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i100 = i.slice(-2), f100 = f.slice(-2);
        return v0 && i100 == 1 || f100 == 1 ? 'one' : v0 && i100 == 2 || f100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || f100 == 3 || f100 == 4 ? 'few' : 'other';
    },
    dz: function dz(n) {
        return 'other';
    },
    es: function es(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
        return n == 1 ? 'one' : i != 0 && i1000000 == 0 && v0 ? 'many' : 'other';
    },
    ff: function ff(n) {
        return n >= 0 && n < 2 ? 'one' : 'other';
    },
    fr: function fr(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
        return n >= 0 && n < 2 ? 'one' : i != 0 && i1000000 == 0 && v0 ? 'many' : 'other';
    },
    ga: function ga(n) {
        var s = String(n).split('.'), t0 = Number(s[0]) == n;
        return n == 1 ? 'one' : n == 2 ? 'two' : t0 && n >= 3 && n <= 6 ? 'few' : t0 && n >= 7 && n <= 10 ? 'many' : 'other';
    },
    gd: function gd(n) {
        var s = String(n).split('.'), t0 = Number(s[0]) == n;
        return n == 1 || n == 11 ? 'one' : n == 2 || n == 12 ? 'two' : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? 'few' : 'other';
    },
    he: function he(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1];
        return i == 1 && v0 || i == 0 && !v0 ? 'one' : i == 2 && v0 ? 'two' : 'other';
    },
    is: function is(n) {
        var s = String(n).split('.'), i = s[0], t = (s[1] || '').replace(/0+$/, ''), t0 = Number(s[0]) == n, i10 = i.slice(-1), i100 = i.slice(-2);
        return t0 && i10 == 1 && i100 != 11 || t % 10 == 1 && t % 100 != 11 ? 'one' : 'other';
    },
    ksh: function ksh(n) {
        return n == 0 ? 'zero' : n == 1 ? 'one' : 'other';
    },
    lt: function lt(n) {
        var s = String(n).split('.'), f = s[1] || '', t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        return n10 == 1 && (n100 < 11 || n100 > 19) ? 'one' : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? 'few' : f != 0 ? 'many' : 'other';
    },
    lv: function lv(n) {
        var s = String(n).split('.'), f = s[1] || '', v = f.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
        return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && f100 >= 11 && f100 <= 19 ? 'zero' : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? 'one' : 'other';
    },
    mk: function mk(n) {
        var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
        return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? 'one' : 'other';
    },
    mt: function mt(n) {
        var s = String(n).split('.'), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
        return n == 1 ? 'one' : n == 2 ? 'two' : n == 0 || n100 >= 3 && n100 <= 10 ? 'few' : n100 >= 11 && n100 <= 19 ? 'many' : 'other';
    },
    pa: function pa(n) {
        return n == 0 || n == 1 ? 'one' : 'other';
    },
    pl: function pl(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
        return n == 1 && v0 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 12 && i100 <= 14 ? 'many' : 'other';
    },
    pt: function pt(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
        return i == 0 || i == 1 ? 'one' : i != 0 && i1000000 == 0 && v0 ? 'many' : 'other';
    },
    ro: function ro(n) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
        return n == 1 && v0 ? 'one' : !v0 || n == 0 || n != 1 && n100 >= 1 && n100 <= 19 ? 'few' : 'other';
    },
    ru: function ru(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
        return v0 && i10 == 1 && i100 != 11 ? 'one' : v0 && i10 >= 2 && i10 <= 4 && (i100 < 12 || i100 > 14) ? 'few' : v0 && i10 == 0 || v0 && i10 >= 5 && i10 <= 9 || v0 && i100 >= 11 && i100 <= 14 ? 'many' : 'other';
    },
    se: function se(n) {
        return n == 1 ? 'one' : n == 2 ? 'two' : 'other';
    },
    si: function si(n) {
        var s = String(n).split('.'), i = s[0], f = s[1] || '';
        return n == 0 || n == 1 || i == 0 && f == 1 ? 'one' : 'other';
    },
    sl: function sl(n) {
        var s = String(n).split('.'), i = s[0], v0 = !s[1], i100 = i.slice(-2);
        return v0 && i100 == 1 ? 'one' : v0 && i100 == 2 ? 'two' : v0 && (i100 == 3 || i100 == 4) || !v0 ? 'few' : 'other';
    }
};
$cdde293ac67ab855$var$$.as = $cdde293ac67ab855$var$$.am;
$cdde293ac67ab855$var$$.az = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.bg = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.bn = $cdde293ac67ab855$var$$.am;
$cdde293ac67ab855$var$$.brx = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.ce = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.chr = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.de = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.ee = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.el = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.en = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.et = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.eu = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.fa = $cdde293ac67ab855$var$$.am;
$cdde293ac67ab855$var$$.fi = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.fil = $cdde293ac67ab855$var$$.ceb;
$cdde293ac67ab855$var$$.fo = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.fur = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.fy = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.gl = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.gu = $cdde293ac67ab855$var$$.am;
$cdde293ac67ab855$var$$.ha = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.hi = $cdde293ac67ab855$var$$.am;
$cdde293ac67ab855$var$$.hr = $cdde293ac67ab855$var$$.bs;
$cdde293ac67ab855$var$$.hsb = $cdde293ac67ab855$var$$.dsb;
$cdde293ac67ab855$var$$.hu = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.hy = $cdde293ac67ab855$var$$.ff;
$cdde293ac67ab855$var$$.ia = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.id = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.ig = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.it = $cdde293ac67ab855$var$$.ca;
$cdde293ac67ab855$var$$.ja = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.jgo = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.jv = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.ka = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.kea = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.kk = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.kl = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.km = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.kn = $cdde293ac67ab855$var$$.am;
$cdde293ac67ab855$var$$.ko = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.ks = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.ku = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.ky = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.lb = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.lkt = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.lo = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.ml = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.mn = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.mr = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.ms = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.my = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.nb = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.ne = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.nl = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.nn = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.no = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.or = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.pcm = $cdde293ac67ab855$var$$.am;
$cdde293ac67ab855$var$$.ps = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.rm = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.sah = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.sc = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.sd = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.sk = $cdde293ac67ab855$var$$.cs;
$cdde293ac67ab855$var$$.so = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.sq = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.sr = $cdde293ac67ab855$var$$.bs;
$cdde293ac67ab855$var$$.su = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.sv = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.sw = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.ta = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.te = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.th = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.ti = $cdde293ac67ab855$var$$.pa;
$cdde293ac67ab855$var$$.tk = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.to = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.tr = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.ug = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.uk = $cdde293ac67ab855$var$$.ru;
$cdde293ac67ab855$var$$.ur = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.uz = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.vi = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.wae = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.wo = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.xh = $cdde293ac67ab855$var$$.af;
$cdde293ac67ab855$var$$.yi = $cdde293ac67ab855$var$$.ast;
$cdde293ac67ab855$var$$.yo = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.yue = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.zh = $cdde293ac67ab855$var$$.dz;
$cdde293ac67ab855$var$$.zu = $cdde293ac67ab855$var$$.am;
var $cdde293ac67ab855$export$2e2bcd8739ae039 = $cdde293ac67ab855$var$$;


/**
 * Returns a `locale` for which a function exists in `./PluralRuleFunctions.js`.
 * @param  {string} locale
 * @return {string}
 * @example
 * getPluralRulesLocale("ru-RU-Cyrl") // Returns "ru".
 */ function $e057f1ec09bb8cf2$export$2e2bcd8739ae039(locale) {
    // "pt" language is the only one having different pluralization rules
    // for the one ("pt") (Portuguese) locale and the other ("pt-PT") (European Portuguese).
    // http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html
    // (see the entries for "pt" and "pt_PT" there)
    if (locale === 'pt-PT') return locale;
    return $e057f1ec09bb8cf2$var$getLanguageFromLanguageTag(locale);
}
/**
 * Extracts language from an IETF BCP 47 language tag.
 * @param {string} languageTag - IETF BCP 47 language tag.
 * @return {string}
 * @example
 * // Returns "he"
 * getLanguageFromLanguageTag("he-IL-u-ca-hebrew-tz-jeruslm")
 * // Returns "ar"
 * getLanguageFromLanguageTag("ar-u-nu-latn")
 */ var $e057f1ec09bb8cf2$var$LANGUAGE_REG_EXP = /^([a-z0-9]+)/i;
function $e057f1ec09bb8cf2$var$getLanguageFromLanguageTag(languageTag) {
    var match = languageTag.match($e057f1ec09bb8cf2$var$LANGUAGE_REG_EXP);
    if (!match) throw new TypeError("Invalid locale: ".concat(languageTag));
    return match[1];
}


function $46359e0effd7ae1b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $46359e0effd7ae1b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $46359e0effd7ae1b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $46359e0effd7ae1b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $46359e0effd7ae1b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/**
 * `Intl.PluralRules` polyfill.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/PluralRules
 */ var $46359e0effd7ae1b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PluralRules(locale, options) {
        $46359e0effd7ae1b$var$_classCallCheck(this, PluralRules);
        var locales = PluralRules.supportedLocalesOf(locale);
        if (locales.length === 0) throw new RangeError("Unsupported locale: " + locale);
        if (options && options.type !== "cardinal") throw new RangeError("Only \"cardinal\" \"type\" is supported");
        this.$ = (0, $cdde293ac67ab855$export$2e2bcd8739ae039)[(0, $e057f1ec09bb8cf2$export$2e2bcd8739ae039)(locales[0])];
    }
    $46359e0effd7ae1b$var$_createClass(PluralRules, [
        {
            key: "select",
            value: function select(number) {
                return this.$(number);
            }
        }
    ], [
        {
            key: "supportedLocalesOf",
            value: function supportedLocalesOf(locales) {
                if (typeof locales === "string") locales = [
                    locales
                ];
                return locales.filter(function(locale) {
                    return (0, $cdde293ac67ab855$export$2e2bcd8739ae039)[(0, $e057f1ec09bb8cf2$export$2e2bcd8739ae039)(locale)];
                });
            }
        }
    ]);
    return PluralRules;
}();


function $b662e5204c4b31d5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b662e5204c4b31d5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b662e5204c4b31d5$var$_typeof(obj);
}
function $b662e5204c4b31d5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b662e5204c4b31d5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b662e5204c4b31d5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b662e5204c4b31d5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b662e5204c4b31d5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b662e5204c4b31d5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b662e5204c4b31d5$var$_slicedToArray(arr, i) {
    return $b662e5204c4b31d5$var$_arrayWithHoles(arr) || $b662e5204c4b31d5$var$_iterableToArrayLimit(arr, i) || $b662e5204c4b31d5$var$_unsupportedIterableToArray(arr, i) || $b662e5204c4b31d5$var$_nonIterableRest();
}
function $b662e5204c4b31d5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b662e5204c4b31d5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b662e5204c4b31d5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b662e5204c4b31d5$var$_arrayLikeToArray(o, minLen);
}
function $b662e5204c4b31d5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b662e5204c4b31d5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b662e5204c4b31d5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b662e5204c4b31d5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b662e5204c4b31d5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b662e5204c4b31d5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b662e5204c4b31d5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b662e5204c4b31d5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $b662e5204c4b31d5$export$a037d132965e1c9f = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
]; // Valid values for the `numeric` option.
var $b662e5204c4b31d5$var$NUMERIC_VALUES = [
    "auto",
    "always"
]; // Valid values for the `style` option.
var $b662e5204c4b31d5$var$STYLE_VALUES = [
    "long",
    "short",
    "narrow"
]; // Valid values for the `localeMatcher` option.
var $b662e5204c4b31d5$var$LOCALE_MATCHER_VALUES = [
    "lookup",
    "best fit"
];
/**
 * Polyfill for `Intl.RelativeTimeFormat` proposal.
 * https://github.com/tc39/proposal-intl-relative-time
 * https://github.com/tc39/proposal-intl-relative-time/issues/55
 */ var $b662e5204c4b31d5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|string[])} [locales] - Preferred locales (or locale).
   * @param {Object} [options] - Formatting options.
   * @param {string} [options.style="long"] - One of: "long", "short", "narrow".
   * @param {string} [options.numeric="always"] - (Version >= 2) One of: "always", "auto".
   * @param {string} [options.localeMatcher="lookup"] - One of: "lookup", "best fit". Currently only "lookup" is supported.
   */ function RelativeTimeFormat() {
        var locales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b662e5204c4b31d5$var$_classCallCheck(this, RelativeTimeFormat);
        var numeric = options.numeric, style = options.style, localeMatcher = options.localeMatcher;
        this.numeric = "always";
        this.style = "long";
        this.localeMatcher = "lookup"; // Set `numeric` option.
        if (numeric !== undefined) {
            if ($b662e5204c4b31d5$var$NUMERIC_VALUES.indexOf(numeric) < 0) throw new RangeError("Invalid \"numeric\" option: ".concat(numeric));
            this.numeric = numeric;
        } // Set `style` option.
        if (style !== undefined) {
            if ($b662e5204c4b31d5$var$STYLE_VALUES.indexOf(style) < 0) throw new RangeError("Invalid \"style\" option: ".concat(style));
            this.style = style;
        } // Set `localeMatcher` option.
        if (localeMatcher !== undefined) {
            if ($b662e5204c4b31d5$var$LOCALE_MATCHER_VALUES.indexOf(localeMatcher) < 0) throw new RangeError("Invalid \"localeMatcher\" option: ".concat(localeMatcher));
            this.localeMatcher = localeMatcher;
        } // Set `locale`.
        // Convert `locales` to an array.
        if (typeof locales === 'string') locales = [
            locales
        ];
         // Add default locale.
        locales.push((0, $bd57aa6cfe038407$export$f09106e7c6677ec5)()); // Choose the most appropriate locale.
        this.locale = RelativeTimeFormat.supportedLocalesOf(locales, {
            localeMatcher: this.localeMatcher
        })[0];
        if (!this.locale) throw new Error("No supported locale was found");
         // Construct an `Intl.PluralRules` instance (polyfill).
        if ((0, $46359e0effd7ae1b$export$2e2bcd8739ae039).supportedLocalesOf(this.locale).length > 0) this.pluralRules = new (0, $46359e0effd7ae1b$export$2e2bcd8739ae039)(this.locale);
        else console.warn("\"".concat(this.locale, "\" locale is not supported"));
         // Use `Intl.NumberFormat` for formatting numbers (when available).
        if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
            this.numberFormat = new Intl.NumberFormat(this.locale);
            this.numberingSystem = this.numberFormat.resolvedOptions().numberingSystem;
        } else this.numberingSystem = 'latn';
        this.locale = (0, $9c9d5070956ee633$export$2e2bcd8739ae039)(this.locale, {
            localeMatcher: this.localeMatcher
        });
    }
    /**
   * Formats time `number` in `units` (either in past or in future).
   * @param {number} number - Time interval value.
   * @param {string} unit - Time interval measurement unit.
   * @return {string}
   * @throws {RangeError} If unit is not one of "second", "minute", "hour", "day", "week", "month", "quarter".
   * @example
   * // Returns "2 days ago"
   * rtf.format(-2, "day")
   * // Returns "in 5 minutes"
   * rtf.format(5, "minute")
   */ $b662e5204c4b31d5$var$_createClass(RelativeTimeFormat, [
        {
            key: "format",
            value: function format() {
                var _parseFormatArgs = $b662e5204c4b31d5$var$parseFormatArgs(arguments), _parseFormatArgs2 = $b662e5204c4b31d5$var$_slicedToArray(_parseFormatArgs, 2), number = _parseFormatArgs2[0], unit = _parseFormatArgs2[1];
                return this.getRule(number, unit).replace('{0}', this.formatNumber(Math.abs(number)));
            }
        },
        {
            key: "formatToParts",
            value: function formatToParts() {
                var _parseFormatArgs3 = $b662e5204c4b31d5$var$parseFormatArgs(arguments), _parseFormatArgs4 = $b662e5204c4b31d5$var$_slicedToArray(_parseFormatArgs3, 2), number = _parseFormatArgs4[0], unit = _parseFormatArgs4[1];
                var rule = this.getRule(number, unit);
                var valueIndex = rule.indexOf("{0}"); // "yesterday"/"today"/"tomorrow".
                if (valueIndex < 0) return [
                    {
                        type: "literal",
                        value: rule
                    }
                ];
                var parts = [];
                if (valueIndex > 0) parts.push({
                    type: "literal",
                    value: rule.slice(0, valueIndex)
                });
                parts = parts.concat(this.formatNumberToParts(Math.abs(number)).map(function(part) {
                    return $b662e5204c4b31d5$var$_objectSpread($b662e5204c4b31d5$var$_objectSpread({}, part), {}, {
                        unit: unit
                    });
                }));
                if (valueIndex + 3 < rule.length - 1) parts.push({
                    type: "literal",
                    value: rule.slice(valueIndex + 3)
                });
                return parts;
            }
        },
        {
            key: "getRule",
            value: function getRule(value, unit) {
                // Get locale-specific time interval formatting rules
                // of a given `style` for the given value of measurement `unit`.
                //
                // E.g.:
                //
                // ```json
                // {
                //  "past": {
                //    "one": "a second ago",
                //    "other": "{0} seconds ago"
                //  },
                //  "future": {
                //    "one": "in a second",
                //    "other": "in {0} seconds"
                //  }
                // }
                // ```
                //
                var unitMessages = (0, $bd57aa6cfe038407$export$aa5c834303254f2b)(this.locale)[this.style][unit]; // Bundle size optimization technique for styles like
                // "tiny" in `javascript-time-ago`: "1m", "2h", "3d"...
                if (typeof unitMessages === 'string') return unitMessages;
                 // Special case for "yesterday"/"today"/"tomorrow".
                if (this.numeric === "auto") {
                    // "yesterday", "the day before yesterday", etc.
                    if (value === -2 || value === -1) {
                        var message = unitMessages["previous".concat(value === -1 ? '' : '-' + Math.abs(value))];
                        if (message) return message;
                    } else if (value === 1 || value === 2) {
                        var _message = unitMessages["next".concat(value === 1 ? '' : '-' + Math.abs(value))];
                        if (_message) return _message;
                    } else if (value === 0) {
                        if (unitMessages.current) return unitMessages.current;
                    }
                } // Choose either "past" or "future" based on time `value` sign.
                // If there's only "other" then it's being collapsed.
                // (the resulting bundle size optimization technique)
                var pluralizedMessages = unitMessages[$b662e5204c4b31d5$var$isNegative(value) ? "past" : "future"]; // Bundle size optimization technique for styles like "narrow"
                // having messages like "in {0} d." or "{0} d. ago".
                if (typeof pluralizedMessages === "string") return pluralizedMessages;
                 // Quantify `value`.
                // There seems to be no such locale in CLDR
                // for which "plural rules" function is missing.
                var quantifier = this.pluralRules && this.pluralRules.select(Math.abs(value)) || 'other'; // "other" rule is supposed to be always present.
                // If only "other" rule is present then "rules" is not an object and is a string.
                return pluralizedMessages[quantifier] || pluralizedMessages.other;
            }
        },
        {
            key: "formatNumber",
            value: function formatNumber(number) {
                return this.numberFormat ? this.numberFormat.format(number) : String(number);
            }
        },
        {
            key: "formatNumberToParts",
            value: function formatNumberToParts(number) {
                // `Intl.NumberFormat.formatToParts()` is not present, for example,
                // in Node.js 8.x while `Intl.NumberFormat` itself is present.
                return this.numberFormat && this.numberFormat.formatToParts ? this.numberFormat.formatToParts(number) : [
                    {
                        type: "integer",
                        value: this.formatNumber(number)
                    }
                ];
            }
        },
        {
            key: "resolvedOptions",
            value: function resolvedOptions() {
                return {
                    locale: this.locale,
                    style: this.style,
                    numeric: this.numeric,
                    numberingSystem: this.numberingSystem
                };
            }
        }
    ]);
    return RelativeTimeFormat;
}();
$b662e5204c4b31d5$export$2e2bcd8739ae039.supportedLocalesOf = function(locales) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Convert `locales` to an array.
    if (typeof locales === 'string') locales = [
        locales
    ];
    else if (!Array.isArray(locales)) throw new TypeError('Invalid "locales" argument');
    return locales.filter(function(locale) {
        return (0, $9c9d5070956ee633$export$2e2bcd8739ae039)(locale, options);
    });
};
/**
 * Adds locale data for a specific locale.
 * @param {Object} localeData
 */ $b662e5204c4b31d5$export$2e2bcd8739ae039.addLocale = (0, $bd57aa6cfe038407$export$9b0a0997606861b1);
/**
 * Sets default locale.
 * @param  {string} locale
 */ $b662e5204c4b31d5$export$2e2bcd8739ae039.setDefaultLocale = (0, $bd57aa6cfe038407$export$a1a5025df4e9ba34);
/**
 * Gets default locale.
 * @return  {string} locale
 */ $b662e5204c4b31d5$export$2e2bcd8739ae039.getDefaultLocale = (0, $bd57aa6cfe038407$export$f09106e7c6677ec5);
/**
 * Export `Intl.PluralRules` just in case it's used somewhere else.
 */ $b662e5204c4b31d5$export$2e2bcd8739ae039.PluralRules = (0, $46359e0effd7ae1b$export$2e2bcd8739ae039); // The specification allows units to be in plural form.
// Convert plural to singular.
// Example: "seconds" -> "second".
var $b662e5204c4b31d5$var$UNIT_ERROR = 'Invalid "unit" argument';
function $b662e5204c4b31d5$var$parseUnit(unit) {
    if ($b662e5204c4b31d5$var$_typeof(unit) === 'symbol') throw new TypeError($b662e5204c4b31d5$var$UNIT_ERROR);
    if (typeof unit !== 'string') throw new RangeError("".concat($b662e5204c4b31d5$var$UNIT_ERROR, ": ").concat(unit));
    if (unit[unit.length - 1] === 's') unit = unit.slice(0, unit.length - 1);
    if ($b662e5204c4b31d5$export$a037d132965e1c9f.indexOf(unit) < 0) throw new RangeError("".concat($b662e5204c4b31d5$var$UNIT_ERROR, ": ").concat(unit));
    return unit;
} // Converts `value` to a `Number`.
// The specification allows value to be a non-number.
// For example, "-0" is supposed to be treated as `-0`.
// Also checks if `value` is a finite number.
var $b662e5204c4b31d5$var$NUMBER_ERROR = 'Invalid "number" argument';
function $b662e5204c4b31d5$var$parseNumber(value) {
    value = Number(value);
    if (Number.isFinite) {
        if (!Number.isFinite(value)) throw new RangeError("".concat($b662e5204c4b31d5$var$NUMBER_ERROR, ": ").concat(value));
    }
    return value;
}
/**
 * Tells `0` from `-0`.
 * https://stackoverflow.com/questions/7223359/are-0-and-0-the-same
 * @param  {number} number
 * @return {Boolean}
 * @example
 * isNegativeZero(0); // false
 * isNegativeZero(-0); // true
 */ function $b662e5204c4b31d5$var$isNegativeZero(number) {
    return 1 / number === -Infinity;
}
function $b662e5204c4b31d5$var$isNegative(number) {
    return number < 0 || number === 0 && $b662e5204c4b31d5$var$isNegativeZero(number);
}
function $b662e5204c4b31d5$var$parseFormatArgs(args) {
    if (args.length < 2) throw new TypeError("\"unit\" argument is required");
    return [
        $b662e5204c4b31d5$var$parseNumber(args[0]),
        $b662e5204c4b31d5$var$parseUnit(args[1])
    ];
}


function $7fce43b8df160aa2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7fce43b8df160aa2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7fce43b8df160aa2$var$_typeof(obj);
}
function $7fce43b8df160aa2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7fce43b8df160aa2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7fce43b8df160aa2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7fce43b8df160aa2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7fce43b8df160aa2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/**
 * A basic in-memory cache.
 *
 * import Cache from 'javascript-time-ago/Cache'
 * const cache = new Cache()
 * const object = cache.get('key1', 'key2', ...) || cache.put('key1', 'key2', ..., createObject())
 */ var $7fce43b8df160aa2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Cache() {
        $7fce43b8df160aa2$var$_classCallCheck(this, Cache);
        this.cache = {};
    }
    $7fce43b8df160aa2$var$_createClass(Cache, [
        {
            key: "get",
            value: function get() {
                var cache = this.cache;
                for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
                for(var _i = 0, _keys = keys; _i < _keys.length; _i++){
                    var key = _keys[_i];
                    if ($7fce43b8df160aa2$var$_typeof(cache) !== 'object') return;
                    cache = cache[key];
                }
                return cache;
            }
        },
        {
            key: "put",
            value: function put() {
                for(var _len2 = arguments.length, keys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)keys[_key2] = arguments[_key2];
                var value = keys.pop();
                var lastKey = keys.pop();
                var cache = this.cache;
                for(var _i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++){
                    var key = _keys2[_i2];
                    if ($7fce43b8df160aa2$var$_typeof(cache[key]) !== 'object') cache[key] = {};
                    cache = cache[key];
                }
                return cache[lastKey] = value;
            }
        }
    ]);
    return Cache;
}();


function $ee407ffcbf700d82$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ee407ffcbf700d82$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ee407ffcbf700d82$var$_typeof(obj);
}
function $ee407ffcbf700d82$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ee407ffcbf700d82$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ee407ffcbf700d82$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ee407ffcbf700d82$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ee407ffcbf700d82$var$_arrayLikeToArray(o, minLen);
}
function $ee407ffcbf700d82$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ee407ffcbf700d82$export$2e2bcd8739ae039(locales, isLocaleDataAvailable) {
    // This is not an intelligent algorithm,
    // but it will do for this library's case.
    // `sr-Cyrl-BA` -> `sr-Cyrl` -> `sr`.
    for(var _iterator = $ee407ffcbf700d82$var$_createForOfIteratorHelperLoose(locales), _step; !(_step = _iterator()).done;){
        var locale = _step.value;
        if (isLocaleDataAvailable(locale)) return locale;
        var parts = locale.split('-');
        while(parts.length > 1){
            parts.pop();
            locale = parts.join('-');
            if (isLocaleDataAvailable(locale)) return locale;
        }
    }
    throw new Error("No locale data has been registered for any of the locales: ".concat(locales.join(', ')));
}
function $ee407ffcbf700d82$export$fb4e49444e7aca99(locales) {
    /* istanbul ignore else */ if ($ee407ffcbf700d82$export$25931a910d8e0cde()) return Intl.DateTimeFormat.supportedLocalesOf(locales)[0];
}
function $ee407ffcbf700d82$export$25931a910d8e0cde() {
    // Babel transforms `typeof` into some "branches"
    // so istanbul will show this as "branch not covered".
    /* istanbul ignore next */ var isIntlAvailable = (typeof Intl === "undefined" ? "undefined" : $ee407ffcbf700d82$var$_typeof(Intl)) === 'object';
    return isIntlAvailable && typeof Intl.DateTimeFormat === 'function';
}


function $6f90e8cdc9d220b7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6f90e8cdc9d220b7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6f90e8cdc9d220b7$var$_typeof(obj);
}
function $6f90e8cdc9d220b7$export$2e2bcd8739ae039(object) {
    return $6f90e8cdc9d220b7$var$isObject(object) && (Array.isArray(object.steps) || // `gradation` property is deprecated: it has been renamed to `steps`.
    Array.isArray(object.gradation) || // `flavour` property is deprecated: it has been renamed to `labels`.
    Array.isArray(object.flavour) || typeof object.flavour === 'string' || Array.isArray(object.labels) || typeof object.labels === 'string' || // `units` property is deprecated.
    Array.isArray(object.units) || // `custom` property is deprecated.
    typeof object.custom === 'function');
}
var $6f90e8cdc9d220b7$var$OBJECT_CONSTRUCTOR = {}.constructor;
function $6f90e8cdc9d220b7$var$isObject(object) {
    return $6f90e8cdc9d220b7$var$_typeof(object) !== undefined && object !== null && object.constructor === $6f90e8cdc9d220b7$var$OBJECT_CONSTRUCTOR;
}


var $23b8a195613e9b42$export$1cacba1045a8e790 = 60; // in seconds
var $23b8a195613e9b42$export$842e383dfc19bc67 = 60 * $23b8a195613e9b42$export$1cacba1045a8e790; // in seconds
var $23b8a195613e9b42$export$d2d39d1adcc883a2 = 24 * $23b8a195613e9b42$export$842e383dfc19bc67; // in seconds
var $23b8a195613e9b42$export$36cb58223e61606e = 7 * $23b8a195613e9b42$export$d2d39d1adcc883a2; // in seconds
var $23b8a195613e9b42$export$af5de1609f06c8e6 = 30.44 * $23b8a195613e9b42$export$d2d39d1adcc883a2; // in seconds
var $23b8a195613e9b42$export$31803937850fb2da = 365.2425 * $23b8a195613e9b42$export$d2d39d1adcc883a2; // in seconds
function $23b8a195613e9b42$export$8f56cda1ff4fae16(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $23b8a195613e9b42$export$1cacba1045a8e790;
        case 'hour':
            return $23b8a195613e9b42$export$842e383dfc19bc67;
        case 'day':
            return $23b8a195613e9b42$export$d2d39d1adcc883a2;
        case 'week':
            return $23b8a195613e9b42$export$36cb58223e61606e;
        case 'month':
            return $23b8a195613e9b42$export$af5de1609f06c8e6;
        case 'year':
            return $23b8a195613e9b42$export$31803937850fb2da;
    }
} // export function getPreviousUnitFor(unit) {
 // 	switch (unit) {
 // 		case 'second':
 // 			return 'now'
 // 		case 'minute':
 // 			return 'second'
 // 		case 'hour':
 // 			return 'minute'
 // 		case 'day':
 // 			return 'hour'
 // 		case 'week':
 // 			return 'day'
 // 		case 'month':
 // 			return 'week'
 // 		case 'year':
 // 			return 'month'
 // 	}
 // }


function $982c7e0a7f528347$export$2e2bcd8739ae039(step) {
    // `factor` is a legacy property.
    if (step.factor !== undefined) return step.factor;
     // "unit" is now called "formatAs".
    return (0, $23b8a195613e9b42$export$8f56cda1ff4fae16)(step.unit || step.formatAs) || 1;
}



function $7d685aaa52f9ed1f$export$232899b3019cc012(round) {
    switch(round){
        case 'floor':
            return Math.floor;
        default:
            return Math.round;
    }
} // For non-negative numbers.
function $7d685aaa52f9ed1f$export$1bb21b414310c646(round) {
    switch(round){
        case 'floor':
            // Math.floor(x) = x
            // Math.floor(x + 1) = x + 1
            return 1;
        default:
            // Math.round(x) = x
            // Math.round(x + 0.5) = x + 1
            return 0.5;
    }
}


function $6f8d6ddf8eef0d75$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6f8d6ddf8eef0d75$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6f8d6ddf8eef0d75$var$_typeof(obj);
}
function $6f8d6ddf8eef0d75$export$2e2bcd8739ae039(step, _ref) {
    var prevStep = _ref.prevStep, timestamp = _ref.timestamp, now = _ref.now, future = _ref.future, round = _ref.round;
    var minTime; // "threshold_for_xxx" is a legacy property.
    if (prevStep) {
        if (prevStep.id || prevStep.unit) minTime = step["threshold_for_".concat(prevStep.id || prevStep.unit)];
    }
    if (minTime === undefined) // "threshold" is a legacy property.
    {
        if (step.threshold !== undefined) {
            // "threshold" is a legacy name for "minTime".
            minTime = step.threshold; // "threshold" function is deprecated.
            if (typeof minTime === 'function') minTime = minTime(now, future);
        }
    }
    if (minTime === undefined) minTime = step.minTime;
     // A deprecated way of specifying a different threshold
    // depending on the previous step's unit.
    if ($6f8d6ddf8eef0d75$var$_typeof(minTime) === 'object') {
        if (prevStep && prevStep.id && minTime[prevStep.id] !== undefined) minTime = minTime[prevStep.id];
        else minTime = minTime["default"];
    }
    if (typeof minTime === 'function') minTime = minTime(timestamp, {
        future: future,
        getMinTimeForUnit: function getMinTimeForUnit(toUnit, fromUnit) {
            return $6f8d6ddf8eef0d75$var$_getMinTimeForUnit(toUnit, fromUnit || prevStep && prevStep.formatAs, {
                round: round
            });
        }
    });
     // Evaluate the `test()` function.
    // `test()` function is deprecated.
    if (minTime === undefined) {
        if (step.test) {
            if (step.test(timestamp, {
                now: now,
                future: future
            })) // `0` threshold always passes.
            minTime = 0;
            else // `MAX_SAFE_INTEGER` threshold won't ever pass in real life.
            minTime = 9007199254740991; // Number.MAX_SAFE_INTEGER
        }
    }
    if (minTime === undefined) {
        if (prevStep) {
            if (step.formatAs && prevStep.formatAs) minTime = $6f8d6ddf8eef0d75$var$_getMinTimeForUnit(step.formatAs, prevStep.formatAs, {
                round: round
            });
        } else // The first step's `minTime` is `0` by default.
        minTime = 0;
    } // Warn if no `minTime` was defined or could be deduced.
    if (minTime === undefined) console.warn('[javascript-time-ago] A step should specify `minTime`:\n' + JSON.stringify(step, null, 2));
    return minTime;
}
function $6f8d6ddf8eef0d75$var$_getMinTimeForUnit(toUnit, fromUnit, _ref2) {
    var round = _ref2.round;
    var toUnitAmount = (0, $23b8a195613e9b42$export$8f56cda1ff4fae16)(toUnit); // if (!fromUnit) {
    // 	return toUnitAmount;
    // }
    // if (!fromUnit) {
    // 	fromUnit = getPreviousUnitFor(toUnit)
    // }
    var fromUnitAmount;
    if (fromUnit === 'now') fromUnitAmount = (0, $23b8a195613e9b42$export$8f56cda1ff4fae16)(toUnit);
    else fromUnitAmount = (0, $23b8a195613e9b42$export$8f56cda1ff4fae16)(fromUnit);
    if (toUnitAmount !== undefined && fromUnitAmount !== undefined) return toUnitAmount - fromUnitAmount * (1 - (0, $7d685aaa52f9ed1f$export$1bb21b414310c646)(round));
}



function $590782c0b3226530$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $590782c0b3226530$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $590782c0b3226530$var$ownKeys(Object(source), !0).forEach(function(key) {
            $590782c0b3226530$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $590782c0b3226530$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $590782c0b3226530$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $590782c0b3226530$export$2e2bcd8739ae039(steps, secondsPassed, _ref) {
    var now = _ref.now, future = _ref.future, round = _ref.round, units = _ref.units, getNextStep = _ref.getNextStep;
    // Ignore steps having not-supported time units in `formatAs`.
    steps = $590782c0b3226530$var$filterStepsByUnits(steps, units);
    var step = $590782c0b3226530$var$_getStep(steps, secondsPassed, {
        now: now,
        future: future,
        round: round
    });
    if (getNextStep) {
        if (step) {
            var prevStep = steps[steps.indexOf(step) - 1];
            var nextStep = steps[steps.indexOf(step) + 1];
            return [
                prevStep,
                step,
                nextStep
            ];
        }
        return [
            undefined,
            undefined,
            steps[0]
        ];
    }
    return step;
}
function $590782c0b3226530$var$_getStep(steps, secondsPassed, _ref2) {
    var now = _ref2.now, future = _ref2.future, round = _ref2.round;
    // If no steps fit the conditions then return nothing.
    if (steps.length === 0) return;
     // Find the most appropriate step.
    var i = $590782c0b3226530$var$getStepIndex(steps, secondsPassed, {
        now: now,
        future: future || secondsPassed < 0,
        round: round
    }); // If no step is applicable the return nothing.
    if (i === -1) return;
    var step = steps[i]; // Apply granularity to the time amount
    // (and fall back to the previous step
    //  if the first level of granularity
    //  isn't met by this amount)
    if (step.granularity) {
        // Recalculate the amount of seconds passed based on `granularity`.
        var secondsPassedGranular = (0, $7d685aaa52f9ed1f$export$232899b3019cc012)(round)(Math.abs(secondsPassed) / (0, $982c7e0a7f528347$export$2e2bcd8739ae039)(step) / step.granularity) * step.granularity; // If the granularity for this step is too high,
        // then fall back to the previous step.
        // (if there is any previous step)
        if (secondsPassedGranular === 0 && i > 0) return steps[i - 1];
    }
    return step;
}
/**
 * Iterates through steps until it finds the maximum one satisfying the `minTime` threshold.
 * @param  {Object} steps - Steps.
 * @param  {number} secondsPassed - How much seconds have passed since the date till `now`.
 * @param  {number} options.now - Current timestamp.
 * @param  {boolean} options.future - Whether the time interval should be formatted as a future one.
 * @param  {number} [i] - Gradation step currently being tested.
 * @return {number} Gradation step index.
 */ function $590782c0b3226530$var$getStepIndex(steps, secondsPassed, options) {
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var minTime = (0, $6f8d6ddf8eef0d75$export$2e2bcd8739ae039)(steps[i], $590782c0b3226530$var$_objectSpread({
        prevStep: steps[i - 1],
        timestamp: options.now - secondsPassed * 1000
    }, options)); // If `minTime` isn't defined or deduceable for this step, then stop.
    if (minTime === undefined) return i - 1;
     // If the `minTime` threshold for moving from previous step
    // to this step is too high then return the previous step.
    if (Math.abs(secondsPassed) < minTime) return i - 1;
     // If it's the last step then return it.
    if (i === steps.length - 1) return i;
     // Move to the next step.
    return $590782c0b3226530$var$getStepIndex(steps, secondsPassed, options, i + 1);
}
/**
 * Leaves only allowed steps.
 * @param  {Object[]} steps
 * @param  {string[]} units - Allowed time units.
 * @return {Object[]}
 */ function $590782c0b3226530$var$filterStepsByUnits(steps, units) {
    return steps.filter(function(_ref3) {
        var unit = _ref3.unit, formatAs = _ref3.formatAs;
        // "unit" is now called "formatAs".
        unit = unit || formatAs; // If this step has a `unit` defined
        // then this `unit` must be in the list of allowed `units`.
        if (unit) return units.indexOf(unit) >= 0;
         // A step is not required to specify a `unit`:
        // alternatively, it could specify `format()`.
        // (see "twitter" style for an example)
        return true;
    });
}





function $bae490492ea1d9df$export$2e2bcd8739ae039(unit, timestamp, _ref) {
    var now = _ref.now, round = _ref.round;
    // For some units, like "now", there's no defined amount of seconds in them.
    if (!(0, $23b8a195613e9b42$export$8f56cda1ff4fae16)(unit)) // If there's no amount of seconds defined for this unit
    // then the update interval can't be determined reliably.
    return;
    var unitDenominator = (0, $23b8a195613e9b42$export$8f56cda1ff4fae16)(unit) * 1000;
    var future = timestamp > now;
    var preciseAmount = Math.abs(timestamp - now);
    var roundedAmount = (0, $7d685aaa52f9ed1f$export$232899b3019cc012)(round)(preciseAmount / unitDenominator) * unitDenominator;
    if (future) {
        if (roundedAmount > 0) // Amount decreases with time.
        return preciseAmount - roundedAmount + $bae490492ea1d9df$var$getDiffToPreviousRoundedNumber(round, unitDenominator);
        else // Refresh right after the zero point,
        // when "future" changes to "past".
        return preciseAmount - roundedAmount + 1;
    } // Amount increases with time.
    return -(preciseAmount - roundedAmount) + $bae490492ea1d9df$var$getDiffToNextRoundedNumber(round, unitDenominator);
}
function $bae490492ea1d9df$var$getDiffToNextRoundedNumber(round, unitDenominator) {
    return (0, $7d685aaa52f9ed1f$export$1bb21b414310c646)(round) * unitDenominator;
}
function $bae490492ea1d9df$var$getDiffToPreviousRoundedNumber(round, unitDenominator) {
    return (1 - (0, $7d685aaa52f9ed1f$export$1bb21b414310c646)(round)) * unitDenominator + 1;
}




var $c4632288a97ae3ff$var$YEAR = 31536000000;
var $c4632288a97ae3ff$export$b4bf424ed968e242 = 1000 * $c4632288a97ae3ff$var$YEAR;
function $c4632288a97ae3ff$export$2e2bcd8739ae039(date, step, _ref) {
    var prevStep = _ref.prevStep, nextStep = _ref.nextStep, now = _ref.now, future = _ref.future, round = _ref.round;
    var timestamp = date.getTime ? date.getTime() : date;
    var getTimeToNextUpdateForUnit = function getTimeToNextUpdateForUnit(unit) {
        return (0, $bae490492ea1d9df$export$2e2bcd8739ae039)(unit, timestamp, {
            now: now,
            round: round
        });
    }; // For future dates, steps move from the last one to the first one,
    // while for past dates, steps move from the first one to the last one,
    // due to the fact that time flows in one direction,
    // and future dates' interval naturally becomes smaller
    // while past dates' interval naturally grows larger.
    //
    // For future dates, it's the transition
    // from the current step to the previous step,
    // therefore check the `minTime` of the current step.
    //
    // For past dates, it's the transition
    // from the current step to the next step,
    // therefore check the `minTime` of the next step.
    //
    var timeToStepChange = $c4632288a97ae3ff$export$c41f51d4f4ae4370(future ? step : nextStep, timestamp, {
        future: future,
        now: now,
        round: round,
        prevStep: future ? prevStep : step // isFirstStep: future && isFirstStep
    });
    if (timeToStepChange === undefined) // Can't reliably determine "time to next update"
    // if not all of the steps provide `minTime`.
    return;
    var timeToNextUpdate;
    if (step) {
        if (step.getTimeToNextUpdate) timeToNextUpdate = step.getTimeToNextUpdate(timestamp, {
            getTimeToNextUpdateForUnit: getTimeToNextUpdateForUnit,
            getRoundFunction: (0, $7d685aaa52f9ed1f$export$232899b3019cc012),
            now: now,
            future: future,
            round: round
        });
        if (timeToNextUpdate === undefined) {
            // "unit" is now called "formatAs".
            var unit = step.unit || step.formatAs;
            if (unit) // For some units, like "now", there's no defined amount of seconds in them.
            // In such cases, `getTimeToNextUpdateForUnit()` returns `undefined`,
            // and the next step's `minTime` could be used to calculate the update interval:
            // it will just assume that the label never changes for this step.
            timeToNextUpdate = getTimeToNextUpdateForUnit(unit);
        }
    }
    if (timeToNextUpdate === undefined) return timeToStepChange;
    return Math.min(timeToNextUpdate, timeToStepChange);
}
function $c4632288a97ae3ff$export$adc1859bc6650326(currentOrNextStep, timestamp, _ref2) {
    var now = _ref2.now, future = _ref2.future, round = _ref2.round, prevStep = _ref2.prevStep;
    // The first step's `minTime` is `0` by default.
    // It doesn't "change" steps at zero point
    // but it does change the wording when switching
    // from "future" to "past": "in ..." -> "... ago".
    // Therefore, the label should be updated at zero-point too.
    var minTime = (0, $6f8d6ddf8eef0d75$export$2e2bcd8739ae039)(currentOrNextStep, {
        timestamp: timestamp,
        now: now,
        future: future,
        round: round,
        prevStep: prevStep
    });
    if (minTime === undefined) return;
    if (future) // The step changes to the previous step
    // as soon as `timestamp - now` becomes
    // less than the `minTime` of the current step:
    // `timestamp - now === minTime - 1`
    // => `now === timestamp - minTime + 1`.
    return timestamp - minTime * 1000 + 1;
    else {
        // The step changes to the next step
        // as soon as `now - timestamp` becomes
        // equal to `minTime` of the next step:
        // `now - timestamp === minTime`
        // => `now === timestamp + minTime`.
        // This is a special case when double-update could be skipped.
        if (minTime === 0 && timestamp === now) return $c4632288a97ae3ff$export$b4bf424ed968e242;
        return timestamp + minTime * 1000;
    }
}
function $c4632288a97ae3ff$export$c41f51d4f4ae4370(step, timestamp, _ref3) {
    var now = _ref3.now, future = _ref3.future, round = _ref3.round, prevStep = _ref3.prevStep;
    if (step) {
        var stepChangesAt = $c4632288a97ae3ff$export$adc1859bc6650326(step, timestamp, {
            now: now,
            future: future,
            round: round,
            prevStep: prevStep
        });
        if (stepChangesAt === undefined) return;
        return stepChangesAt - now;
    } else {
        if (future) // No step.
        // Update right after zero point, when it changes from "future" to "past".
        return timestamp - now + 1;
        else // The last step doesn't ever change when `date` is in the past.
        return $c4632288a97ae3ff$export$b4bf424ed968e242;
    }
}


// For all locales added
// their relative time formatter messages will be stored here.
var $41243a8f54b175bb$var$localesData = {};
function $41243a8f54b175bb$export$aa5c834303254f2b(locale) {
    return $41243a8f54b175bb$var$localesData[locale];
}
function $41243a8f54b175bb$export$9b0a0997606861b1(localeData) {
    if (!localeData) throw new Error('[javascript-time-ago] No locale data passed.');
     // This locale data is stored in a global variable
    // and later used when calling `.format(time)`.
    $41243a8f54b175bb$var$localesData[localeData.locale] = localeData;
}


// just now
// 1 second ago
// 2 seconds ago
// …
// 59 seconds ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 hour ago
// 2 hours ago
// …
// 24 hours ago
// 1 day ago
// 2 days ago
// …
// 6 days ago
// 1 week ago
// 2 weeks ago
// …
// 3 weeks ago
// 1 month ago
// 2 months ago
// …
// 11 months ago
// 1 year ago
// 2 years ago
// …
var $870fd193d95426ff$export$2e2bcd8739ae039 = [
    {
        formatAs: 'now'
    },
    {
        formatAs: 'second'
    },
    {
        formatAs: 'minute'
    },
    {
        formatAs: 'hour'
    },
    {
        formatAs: 'day'
    },
    {
        formatAs: 'week'
    },
    {
        formatAs: 'month'
    },
    {
        formatAs: 'year'
    }
];


var // 1 second ago
// 2 seconds ago
// …
// 59 seconds ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 hour ago
// 2 hours ago
// …
// 24 hours ago
// 1 day ago
// 2 days ago
// …
// 6 days ago
// 1 week ago
// 2 weeks ago
// 3 weeks ago
// 4 weeks ago
// 1 month ago
// 2 months ago
// …
// 11 months ago
// 1 year ago
// 2 years ago
// …
//
$0dbb0926828d207e$export$2e2bcd8739ae039 = {
    steps: (0, $870fd193d95426ff$export$2e2bcd8739ae039),
    labels: 'long'
};


function $9c25b3ce781894fd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9c25b3ce781894fd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9c25b3ce781894fd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9c25b3ce781894fd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9c25b3ce781894fd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9c25b3ce781894fd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var // 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 minute ago
// 2 minutes ago
// …
// 59 minutes ago
// 1 hour ago
// 2 hours ago
// …
// 24 hours ago
// 1 day ago
// 2 days ago
// …
// 6 days ago
// 1 week ago
// 2 weeks ago
// 3 weeks ago
// 4 weeks ago
// 1 month ago
// 2 months ago
// …
// 11 months ago
// 1 year ago
// 2 years ago
// …
//
$9c25b3ce781894fd$export$2e2bcd8739ae039 = $9c25b3ce781894fd$var$_objectSpread($9c25b3ce781894fd$var$_objectSpread({}, (0, $0dbb0926828d207e$export$2e2bcd8739ae039)), {}, {
    // Skip "seconds".
    steps: (0, $0dbb0926828d207e$export$2e2bcd8739ae039).steps.filter(function(step) {
        return step.formatAs !== 'second';
    })
});





var // Developers shouldn't need to use it in their custom steps.
// "threshold" is a legacy name of "min".
// Developers should use "min" property name instead of "threshold".
// "threshold_for_idOrUnit: value" is a legacy way of specifying "min: { id: value }".
// Developers should use "min" property instead of "threshold".
// just now
// 1 minute ago
// 2 minutes ago
// 5 minutes ago
// 10 minutes ago
// 15 minutes ago
// 20 minutes ago
// …
// 50 minutes ago
// an hour ago
// 2 hours ago
// …
// 20 hours ago
// a day ago
// 2 days ago
// 5 days ago
// a week ago
// 2 weeks ago
// 3 weeks ago
// a month ago
// 2 months ago
// 4 months ago
// a year ago
// 2 years ago
// …
$b56ee126f21d3d86$export$2e2bcd8739ae039 = [
    {
        // This step returns the amount of seconds
        // by dividing the amount of seconds by `1`.
        factor: 1,
        // "now" labels are used for formatting the output.
        unit: 'now'
    },
    {
        // When the language doesn't support `now` unit,
        // the first step is ignored, and it uses this `second` unit.
        threshold: 1,
        // `threshold_for_now` should be the same as `threshold` on minutes.
        threshold_for_now: 45.5,
        // This step returns the amount of seconds
        // by dividing the amount of seconds by `1`.
        factor: 1,
        // "second" labels are used for formatting the output.
        unit: 'second'
    },
    {
        // `threshold` should be the same as `threshold_for_now` on seconds.
        threshold: 45.5,
        // Return the amount of minutes by dividing the amount
        // of seconds by the amount of seconds in a minute.
        factor: (0, $23b8a195613e9b42$export$1cacba1045a8e790),
        // "minute" labels are used for formatting the output.
        unit: 'minute'
    },
    {
        // This step is effective starting from 2.5 minutes.
        threshold: 2.5 * (0, $23b8a195613e9b42$export$1cacba1045a8e790),
        // Allow only 5-minute increments of minutes starting from 2.5 minutes.
        // `granularity` — (advanced) Time interval value "granularity".
        // For example, it could be set to `5` for minutes to allow only 5-minute increments
        // when formatting time intervals: `0 minutes`, `5 minutes`, `10 minutes`, etc.
        // Perhaps this feature will be removed because there seem to be no use cases
        // of it in the real world.
        granularity: 5,
        // Return the amount of minutes by dividing the amount
        // of seconds by the amount of seconds in a minute.
        factor: (0, $23b8a195613e9b42$export$1cacba1045a8e790),
        // "minute" labels are used for formatting the output.
        unit: 'minute'
    },
    {
        // This step is effective starting from 22.5 minutes.
        threshold: 22.5 * (0, $23b8a195613e9b42$export$1cacba1045a8e790),
        // Return the amount of minutes by dividing the amount
        // of seconds by the amount of seconds in  half-an-hour.
        factor: 0.5 * (0, $23b8a195613e9b42$export$842e383dfc19bc67),
        // "half-hour" labels are used for formatting the output.
        // (if available, which is no longer the case)
        unit: 'half-hour'
    },
    {
        // This step is effective starting from 42.5 minutes.
        threshold: 42.5 * (0, $23b8a195613e9b42$export$1cacba1045a8e790),
        threshold_for_minute: 52.5 * (0, $23b8a195613e9b42$export$1cacba1045a8e790),
        // Return the amount of minutes by dividing the amount
        // of seconds by the amount of seconds in an hour.
        factor: (0, $23b8a195613e9b42$export$842e383dfc19bc67),
        // "hour" labels are used for formatting the output.
        unit: 'hour'
    },
    {
        // This step is effective starting from 20.5 hours.
        threshold: 20.5 / 24 * (0, $23b8a195613e9b42$export$d2d39d1adcc883a2),
        // Return the amount of minutes by dividing the amount
        // of seconds by the amount of seconds in a day.
        factor: (0, $23b8a195613e9b42$export$d2d39d1adcc883a2),
        // "day" labels are used for formatting the output.
        unit: 'day'
    },
    {
        // This step is effective starting from 5.5 days.
        threshold: 5.5 * (0, $23b8a195613e9b42$export$d2d39d1adcc883a2),
        // Return the amount of minutes by dividing the amount
        // of seconds by the amount of seconds in a week.
        factor: (0, $23b8a195613e9b42$export$36cb58223e61606e),
        // "week" labels are used for formatting the output.
        unit: 'week'
    },
    {
        // This step is effective starting from 3.5 weeks.
        threshold: 3.5 * (0, $23b8a195613e9b42$export$36cb58223e61606e),
        // Return the amount of minutes by dividing the amount
        // of seconds by the amount of seconds in a month.
        factor: (0, $23b8a195613e9b42$export$af5de1609f06c8e6),
        // "month" labels are used for formatting the output.
        unit: 'month'
    },
    {
        // This step is effective starting from 10.5 months.
        threshold: 10.5 * (0, $23b8a195613e9b42$export$af5de1609f06c8e6),
        // Return the amount of minutes by dividing the amount
        // of seconds by the amount of seconds in a year.
        factor: (0, $23b8a195613e9b42$export$31803937850fb2da),
        // "year" labels are used for formatting the output.
        unit: 'year'
    }
];


var // It's here just for legacy compatibility.
// Use "steps" name instead.
// "flavour" is a legacy name for "labels".
// It's here just for legacy compatibility.
// Use "labels" name instead.
// "units" is a legacy property.
// It's here just for legacy compatibility.
// Developers shouldn't need to use it in their custom styles.
$e7d4d2a6bb1d0e1c$export$2e2bcd8739ae039 = {
    gradation: (0, $b56ee126f21d3d86$export$2e2bcd8739ae039),
    flavour: 'long',
    units: [
        'now',
        'minute',
        'hour',
        'day',
        'week',
        'month',
        'year'
    ]
};



var // It's here just for legacy compatibility.
// Use "steps" name instead.
// "flavour" is a legacy name for "labels".
// It's here just for legacy compatibility.
// Use "labels" name instead.
// "units" is a legacy property.
// It's here just for legacy compatibility.
// Developers shouldn't need to use it in their custom styles.
// Similar to the default style but with "ago" omitted.
//
// just now
// 5 minutes
// 10 minutes
// 15 minutes
// 20 minutes
// an hour
// 2 hours
// …
// 20 hours
// 1 day
// 2 days
// a week
// 2 weeks
// 3 weeks
// a month
// 2 months
// 3 months
// 4 months
// a year
// 2 years
//
$e99fc90dbfa451af$export$2e2bcd8739ae039 = {
    gradation: (0, $b56ee126f21d3d86$export$2e2bcd8739ae039),
    flavour: 'long-time',
    units: [
        'now',
        'minute',
        'hour',
        'day',
        'week',
        'month',
        'year'
    ]
};


// Looks like this one's deprecated.
// /**
//  * Returns a step corresponding to the unit.
//  * @param  {Object[]} steps
//  * @param  {string} unit
//  * @return {?Object}
//  */
// export function getStepForUnit(steps, unit) {
// 	for (const step of steps) {
// 		if (step.unit === unit) {
// 			return step
// 		}
// 	}
// }
// Looks like this one won't be used in the next major version.
/**
 * Converts value to a `Date`
 * @param {(number|Date)} value
 * @return {Date}
 */ function $f9922ba962a731b6$export$aa350b96d91cd94(value) {
    return value instanceof Date ? value : new Date(value);
}




// ("1m", "2h", "Mar 3", "Apr 4, 2012").
//
// Seconds, minutes or hours are shown for shorter intervals,
// and longer intervals are formatted using full date format.
var $0dc3a552e1bbed1d$var$steps = [
    {
        formatAs: 'second'
    },
    {
        formatAs: 'minute'
    },
    {
        formatAs: 'hour'
    }
]; // A cache for `Intl.DateTimeFormat` formatters
// for various locales (is a global variable).
var $0dc3a552e1bbed1d$var$formatters = {}; // Starting from day intervals, output month and day.
var $0dc3a552e1bbed1d$var$monthAndDay = {
    minTime: function minTime(timestamp, _ref) {
        var future = _ref.future, getMinTimeForUnit = _ref.getMinTimeForUnit;
        // Returns `23.5 * 60 * 60` when `round` is "round",
        // and `24 * 60 * 60` when `round` is "floor".
        return getMinTimeForUnit('day');
    },
    format: function format(value, locale) {
        /* istanbul ignore else */ if (!$0dc3a552e1bbed1d$var$formatters[locale]) $0dc3a552e1bbed1d$var$formatters[locale] = {};
        /* istanbul ignore else */ if (!$0dc3a552e1bbed1d$var$formatters[locale].dayMonth) // "Apr 11" (MMMd)
        $0dc3a552e1bbed1d$var$formatters[locale].dayMonth = new Intl.DateTimeFormat(locale, {
            month: 'short',
            day: 'numeric'
        });
         // Output month and day.
        return $0dc3a552e1bbed1d$var$formatters[locale].dayMonth.format((0, $f9922ba962a731b6$export$aa350b96d91cd94)(value));
    }
}; // If the `date` happened/happens outside of current year,
// then output day, month and year.
// The interval should be such that the `date` lies outside of the current year.
var $0dc3a552e1bbed1d$var$yearMonthAndDay = {
    minTime: function minTime(timestamp, _ref2) {
        var future = _ref2.future;
        if (future) {
            // January 1, 00:00, of the `date`'s year is right after
            // the maximum `now` for formatting a future date:
            // When `now` is before that date, the `date` is formatted as "day/month/year" (this step),
            // When `now` is equal to or after that date, the `date` is formatted as "day/month" (another step).
            // After that, it's hours, minutes, seconds, and after that it's no longer `future`.
            // The date is right after the maximum `now` for formatting a future date,
            // so subtract 1 millisecond from it.
            var maxFittingNow = new Date(new Date(timestamp).getFullYear(), 0).getTime() - 1; // Return `minTime` (in seconds).
            return (timestamp - maxFittingNow) / 1000;
        } else {
            // January 1, 00:00, of the year following the `date`'s year
            // is the minimum `now` for formatting a past date:
            // When `now` is before that date, the `date` is formatted as "day/month" (another step),
            // When `now` is equal to or after that date, the `date` is formatted as "day/month/year" (this step).
            // After that, it's hours, minutes, seconds, and after that it's no longer `future`.
            var minFittingNow = new Date(new Date(timestamp).getFullYear() + 1, 0).getTime(); // Return `minTime` (in seconds).
            return (minFittingNow - timestamp) / 1000;
        }
    },
    format: function format(value, locale) {
        /* istanbul ignore if */ if (!$0dc3a552e1bbed1d$var$formatters[locale]) $0dc3a552e1bbed1d$var$formatters[locale] = {};
        /* istanbul ignore else */ if (!$0dc3a552e1bbed1d$var$formatters[locale].dayMonthYear) // "Apr 11, 2017" (yMMMd)
        $0dc3a552e1bbed1d$var$formatters[locale].dayMonthYear = new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
         // Output day, month and year.
        return $0dc3a552e1bbed1d$var$formatters[locale].dayMonthYear.format((0, $f9922ba962a731b6$export$aa350b96d91cd94)(value));
    }
}; // If `Intl.DateTimeFormat` is supported,
// then longer time intervals will be formatted as dates.
/* istanbul ignore else */ if ((0, $ee407ffcbf700d82$export$25931a910d8e0cde)()) $0dc3a552e1bbed1d$var$steps.push($0dc3a552e1bbed1d$var$monthAndDay, $0dc3a552e1bbed1d$var$yearMonthAndDay);
else $0dc3a552e1bbed1d$var$steps.push({
    formatAs: 'day'
}, {
    formatAs: 'week'
}, {
    formatAs: 'month'
}, {
    formatAs: 'year'
});
var $0dc3a552e1bbed1d$export$2e2bcd8739ae039 = {
    steps: $0dc3a552e1bbed1d$var$steps,
    labels: [
        'mini',
        'short-time',
        // "narrow" labels can sometimes be weird (like "+5d."),
        // but "short" labels have the " ago" part, so "narrow" seem
        // more appropriate.
        // "short" labels would have been more appropriate if they
        // didn't have the " ago" part, hence the "short-time" above.
        'narrow',
        // of this array can be removed.
        'short'
    ]
};



function $d97b552bdd2b5acc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d97b552bdd2b5acc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d97b552bdd2b5acc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d97b552bdd2b5acc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d97b552bdd2b5acc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d97b552bdd2b5acc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d97b552bdd2b5acc$export$2e2bcd8739ae039 = $d97b552bdd2b5acc$var$_objectSpread($d97b552bdd2b5acc$var$_objectSpread({}, (0, $0dc3a552e1bbed1d$export$2e2bcd8739ae039)), {}, {
    // Add "now".
    steps: [
        {
            formatAs: 'now'
        }
    ].concat((0, $0dc3a552e1bbed1d$export$2e2bcd8739ae039).steps)
});



function $1f1308668a4e4391$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1f1308668a4e4391$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1f1308668a4e4391$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1f1308668a4e4391$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1f1308668a4e4391$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1f1308668a4e4391$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1f1308668a4e4391$export$2e2bcd8739ae039 = $1f1308668a4e4391$var$_objectSpread($1f1308668a4e4391$var$_objectSpread({}, (0, $0dc3a552e1bbed1d$export$2e2bcd8739ae039)), {}, {
    // Skip "seconds".
    steps: (0, $0dc3a552e1bbed1d$export$2e2bcd8739ae039).steps.filter(function(step) {
        return step.formatAs !== 'second';
    })
});



function $aa55b391d690466a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa55b391d690466a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aa55b391d690466a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aa55b391d690466a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aa55b391d690466a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aa55b391d690466a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $aa55b391d690466a$export$2e2bcd8739ae039 = $aa55b391d690466a$var$_objectSpread($aa55b391d690466a$var$_objectSpread({}, (0, $1f1308668a4e4391$export$2e2bcd8739ae039)), {}, {
    // Add "now".
    steps: [
        {
            formatAs: 'now'
        }
    ].concat((0, $1f1308668a4e4391$export$2e2bcd8739ae039).steps)
});




function $3d9efb8ff6d3f0d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3d9efb8ff6d3f0d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3d9efb8ff6d3f0d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3d9efb8ff6d3f0d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3d9efb8ff6d3f0d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3d9efb8ff6d3f0d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3d9efb8ff6d3f0d4$export$2e2bcd8739ae039 = $3d9efb8ff6d3f0d4$var$_objectSpread($3d9efb8ff6d3f0d4$var$_objectSpread({}, (0, $0dc3a552e1bbed1d$export$2e2bcd8739ae039)), {}, {
    // Skip "seconds".
    steps: (0, $0dc3a552e1bbed1d$export$2e2bcd8739ae039).steps.filter(function(step) {
        return step.formatAs !== 'second';
    }) // Start showing `1m` from the first minute.
    .map(function(step) {
        return step.formatAs === 'minute' ? $3d9efb8ff6d3f0d4$var$_objectSpread($3d9efb8ff6d3f0d4$var$_objectSpread({}, step), {}, {
            minTime: (0, $23b8a195613e9b42$export$1cacba1045a8e790)
        }) : step;
    })
});


var $f045f338ba209869$export$2e2bcd8739ae039 = {
    steps: [
        {
            formatAs: 'second'
        },
        {
            formatAs: 'minute'
        },
        {
            formatAs: 'hour'
        },
        {
            formatAs: 'day'
        },
        {
            formatAs: 'month'
        },
        {
            formatAs: 'year'
        }
    ],
    labels: [
        'mini',
        'short-time',
        // "narrow" labels can sometimes be weird (like "+5d."),
        // but "short" labels have the " ago" part, so "narrow" seem
        // more appropriate.
        // "short" labels would have been more appropriate if they
        // didn't have the " ago" part, hence the "short-time" above.
        'narrow',
        // of this array can be removed.
        'short'
    ]
};



function $53996ede24e2aaf4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $53996ede24e2aaf4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $53996ede24e2aaf4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $53996ede24e2aaf4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $53996ede24e2aaf4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $53996ede24e2aaf4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $53996ede24e2aaf4$export$2e2bcd8739ae039 = $53996ede24e2aaf4$var$_objectSpread($53996ede24e2aaf4$var$_objectSpread({}, (0, $f045f338ba209869$export$2e2bcd8739ae039)), {}, {
    // Add "now".
    steps: [
        {
            formatAs: 'now'
        }
    ].concat((0, $f045f338ba209869$export$2e2bcd8739ae039).steps)
});



function $fde97dba3321ff27$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fde97dba3321ff27$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fde97dba3321ff27$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fde97dba3321ff27$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fde97dba3321ff27$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fde97dba3321ff27$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $fde97dba3321ff27$export$2e2bcd8739ae039 = $fde97dba3321ff27$var$_objectSpread($fde97dba3321ff27$var$_objectSpread({}, (0, $f045f338ba209869$export$2e2bcd8739ae039)), {}, {
    // Skip "seconds".
    steps: (0, $f045f338ba209869$export$2e2bcd8739ae039).steps.filter(function(step) {
        return step.formatAs !== 'second';
    })
});



function $976d017a94e8d23b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $976d017a94e8d23b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $976d017a94e8d23b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $976d017a94e8d23b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $976d017a94e8d23b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $976d017a94e8d23b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $976d017a94e8d23b$export$2e2bcd8739ae039 = $976d017a94e8d23b$var$_objectSpread($976d017a94e8d23b$var$_objectSpread({}, (0, $fde97dba3321ff27$export$2e2bcd8739ae039)), {}, {
    // Add "now".
    steps: [
        {
            formatAs: 'now'
        }
    ].concat((0, $fde97dba3321ff27$export$2e2bcd8739ae039).steps)
});


function $b9322c979fb92c68$export$2e2bcd8739ae039(style) {
    switch(style){
        // "default" style name is deprecated.
        case 'default':
        case 'round':
            return 0, $0dbb0926828d207e$export$2e2bcd8739ae039;
        case 'round-minute':
            return 0, $9c25b3ce781894fd$export$2e2bcd8739ae039;
        case 'approximate':
            return 0, $e7d4d2a6bb1d0e1c$export$2e2bcd8739ae039;
        // "time" style name is deprecated.
        case 'time':
        case 'approximate-time':
            return 0, $e99fc90dbfa451af$export$2e2bcd8739ae039;
        case 'mini':
            return 0, $f045f338ba209869$export$2e2bcd8739ae039;
        case 'mini-now':
            return 0, $53996ede24e2aaf4$export$2e2bcd8739ae039;
        case 'mini-minute':
            return 0, $fde97dba3321ff27$export$2e2bcd8739ae039;
        case 'mini-minute-now':
            return 0, $976d017a94e8d23b$export$2e2bcd8739ae039;
        case 'twitter':
            return 0, $0dc3a552e1bbed1d$export$2e2bcd8739ae039;
        case 'twitter-now':
            return 0, $d97b552bdd2b5acc$export$2e2bcd8739ae039;
        case 'twitter-minute':
            return 0, $1f1308668a4e4391$export$2e2bcd8739ae039;
        case 'twitter-minute-now':
            return 0, $aa55b391d690466a$export$2e2bcd8739ae039;
        case 'twitter-first-minute':
            return 0, $3d9efb8ff6d3f0d4$export$2e2bcd8739ae039;
        default:
            // For historical reasons, the default style is "approximate".
            return 0, $e7d4d2a6bb1d0e1c$export$2e2bcd8739ae039;
    }
}



function $1a34c0d312e0c078$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1a34c0d312e0c078$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1a34c0d312e0c078$var$_typeof(obj);
}
function $1a34c0d312e0c078$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $1a34c0d312e0c078$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1a34c0d312e0c078$var$_slicedToArray(arr, i) {
    return $1a34c0d312e0c078$var$_arrayWithHoles(arr) || $1a34c0d312e0c078$var$_iterableToArrayLimit(arr, i) || $1a34c0d312e0c078$var$_unsupportedIterableToArray(arr, i) || $1a34c0d312e0c078$var$_nonIterableRest();
}
function $1a34c0d312e0c078$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1a34c0d312e0c078$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1a34c0d312e0c078$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1a34c0d312e0c078$var$_arrayLikeToArray(o, minLen);
}
function $1a34c0d312e0c078$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1a34c0d312e0c078$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1a34c0d312e0c078$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1a34c0d312e0c078$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1a34c0d312e0c078$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1a34c0d312e0c078$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1a34c0d312e0c078$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1a34c0d312e0c078$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $1a34c0d312e0c078$var$UNITS = [
    'now',
    'second',
    'minute',
    'hour',
    'day',
    'week',
    'month',
    'quarter',
    'year'
];
var $1a34c0d312e0c078$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|string[])} locales=[] - Preferred locales (or locale).
   * @param {boolean} [polyfill] — Pass `false` to use native `Intl.RelativeTimeFormat` and `Intl.PluralRules` instead of the polyfills.
   */ function TimeAgo() {
        var locales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, polyfill = _ref.polyfill;
        $1a34c0d312e0c078$var$_classCallCheck(this, TimeAgo);
        // Convert `locales` to an array.
        if (typeof locales === 'string') locales = [
            locales
        ];
         // Choose the most appropriate locale
        // from the list of `locales` added by the user.
        // For example, new TimeAgo("en-US") -> "en".
        this.locale = (0, $ee407ffcbf700d82$export$2e2bcd8739ae039)(locales.concat(TimeAgo.getDefaultLocale()), (0, $41243a8f54b175bb$export$aa5c834303254f2b));
        if (typeof Intl !== 'undefined') // Use `Intl.NumberFormat` for formatting numbers (when available).
        {
            if (Intl.NumberFormat) this.numberFormat = new Intl.NumberFormat(this.locale);
        } // Some people have requested the ability to use native
        // `Intl.RelativeTimeFormat` and `Intl.PluralRules`
        // instead of the polyfills.
        // https://github.com/catamphetamine/javascript-time-ago/issues/21
        if (polyfill === false) {
            this.IntlRelativeTimeFormat = Intl.RelativeTimeFormat;
            this.IntlPluralRules = Intl.PluralRules;
        } else {
            this.IntlRelativeTimeFormat = (0, $b662e5204c4b31d5$export$2e2bcd8739ae039);
            this.IntlPluralRules = (0, $b662e5204c4b31d5$export$2e2bcd8739ae039).PluralRules;
        } // Cache `Intl.RelativeTimeFormat` instance.
        this.relativeTimeFormatCache = new (0, $7fce43b8df160aa2$export$2e2bcd8739ae039)(); // Cache `Intl.PluralRules` instance.
        this.pluralRulesCache = new (0, $7fce43b8df160aa2$export$2e2bcd8739ae039)();
    }
    /**
   * Formats relative date/time.
   *
   * @param {(number|Date)} input — A `Date` or a javascript timestamp.
   *
   * @param {(string|object)} style — Date/time formatting style. Either one of the built-in style names or a "custom" style definition object having `steps: object[]` and `labels: string[]`.
   *
   * @param {number} [options.now] - Sets the current date timestamp.
   *
   * @param  {boolean} [options.future] — Tells how to format value `0`:
   *         as "future" (`true`) or "past" (`false`).
   *         Is `false` by default, but should have been `true` actually,
   *         in order to correspond to `Intl.RelativeTimeFormat`
   *         that uses `future` formatting for `0` unless `-0` is passed.
   *
   * @param {string} [options.round] — Rounding method. Overrides the style's one.
   *
   * @param {boolean} [options.getTimeToNextUpdate] — Pass `true` to return `[formattedDate, timeToNextUpdate]` instead of just `formattedDate`.
   *
   * @return {string} The formatted relative date/time. If no eligible `step` is found, then an empty string is returned.
   */ $1a34c0d312e0c078$var$_createClass(TimeAgo, [
        {
            key: "format",
            value: function format(input, style, options) {
                if (!options) {
                    if (style && !$1a34c0d312e0c078$var$isStyle(style)) {
                        options = style;
                        style = undefined;
                    } else options = {};
                }
                if (!style) style = (0, $9c25b3ce781894fd$export$2e2bcd8739ae039);
                if (typeof style === 'string') style = (0, $b9322c979fb92c68$export$2e2bcd8739ae039)(style);
                var timestamp = $1a34c0d312e0c078$var$getTimestamp(input); // Get locale messages for this type of labels.
                // "flavour" is a legacy name for "labels".
                var _this$getLabels = this.getLabels(style.flavour || style.labels), labels = _this$getLabels.labels, labelsType = _this$getLabels.labelsType;
                var now; // Can pass a custom `now`, e.g. for testing purposes.
                //
                // Legacy way was passing `now` in `style`.
                // That way is deprecated.
                if (style.now !== undefined) now = style.now;
                 // The new way is passing `now` option to `.format()`.
                if (now === undefined && options.now !== undefined) now = options.now;
                if (now === undefined) now = Date.now();
                 // how much time has passed (in seconds)
                var secondsPassed = (now - timestamp) / 1000; // in seconds
                var future = options.future || secondsPassed < 0;
                var nowLabel = $1a34c0d312e0c078$var$getNowLabel(labels, (0, $41243a8f54b175bb$export$aa5c834303254f2b)(this.locale).now, (0, $41243a8f54b175bb$export$aa5c834303254f2b)(this.locale)["long"], future); // `custom` – A function of `{ elapsed, time, date, now, locale }`.
                //
                // Looks like `custom` function is deprecated and will be removed
                // in the next major version.
                //
                // If this function returns a value, then the `.format()` call will return that value.
                // Otherwise the relative date/time is formatted as usual.
                // This feature is currently not used anywhere and is here
                // just for providing the ultimate customization point
                // in case anyone would ever need that. Prefer using
                // `steps[step].format(value, locale)` instead.
                //
                if (style.custom) {
                    var custom = style.custom({
                        now: now,
                        date: new Date(timestamp),
                        time: timestamp,
                        elapsed: secondsPassed,
                        locale: this.locale
                    });
                    if (custom !== undefined) // Won't return `timeToNextUpdate` here
                    // because `custom()` seems deprecated.
                    return custom;
                } // Get the list of available time interval units.
                var units = $1a34c0d312e0c078$var$getTimeIntervalMeasurementUnits(// create a new custom `style` instead.
                style.units, labels, nowLabel); // // If no available time unit is suitable, just output an empty string.
                // if (units.length === 0) {
                // 	console.error(`None of the "${units.join(', ')}" time units have been found in "${labelsType}" labels for "${this.locale}" locale.`)
                // 	return ''
                // }
                var round = options.round || style.round; // Choose the appropriate time measurement unit
                // and get the corresponding rounded time amount.
                var _getStep = (0, $590782c0b3226530$export$2e2bcd8739ae039)(// For historical reasons, "approximate" steps are used by default.
                // In the next major version, there'll be no default for `steps`.
                style.gradation || style.steps || (0, $9c25b3ce781894fd$export$2e2bcd8739ae039).steps, secondsPassed, {
                    now: now,
                    units: units,
                    round: round,
                    future: future,
                    getNextStep: true
                }), _getStep2 = $1a34c0d312e0c078$var$_slicedToArray(_getStep, 3), prevStep = _getStep2[0], step = _getStep2[1], nextStep = _getStep2[2];
                var formattedDate = this.formatDateForStep(timestamp, step, secondsPassed, {
                    labels: labels,
                    labelsType: labelsType,
                    nowLabel: nowLabel,
                    now: now,
                    future: future,
                    round: round
                }) || '';
                if (options.getTimeToNextUpdate) {
                    var timeToNextUpdate = (0, $c4632288a97ae3ff$export$2e2bcd8739ae039)(timestamp, step, {
                        nextStep: nextStep,
                        prevStep: prevStep,
                        now: now,
                        future: future,
                        round: round
                    });
                    return [
                        formattedDate,
                        timeToNextUpdate
                    ];
                }
                return formattedDate;
            }
        },
        {
            key: "formatDateForStep",
            value: function formatDateForStep(timestamp, step, secondsPassed, _ref2) {
                var _this = this;
                var labels = _ref2.labels, labelsType = _ref2.labelsType, nowLabel = _ref2.nowLabel, now = _ref2.now, future = _ref2.future, round = _ref2.round;
                // If no step matches, then output an empty string.
                if (!step) return;
                if (step.format) return step.format(timestamp, this.locale, {
                    formatAs: function formatAs(unit, value) {
                        // Mimicks `Intl.RelativeTimeFormat.format()`.
                        return _this.formatValue(value, unit, {
                            labels: labels,
                            future: future
                        });
                    },
                    now: now,
                    future: future
                });
                 // "unit" is now called "formatAs".
                var unit = step.unit || step.formatAs;
                if (!unit) throw new Error("[javascript-time-ago] Each step must define either `formatAs` or `format()`. Step: ".concat(JSON.stringify(step)));
                 // `Intl.RelativeTimeFormat` doesn't operate in "now" units.
                // Therefore, threat "now" as a special case.
                if (unit === 'now') return nowLabel;
                 // Amount in units.
                var amount = Math.abs(secondsPassed) / (0, $982c7e0a7f528347$export$2e2bcd8739ae039)(step); // Apply granularity to the time amount
                // (and fallback to the previous step
                //  if the first level of granularity
                //  isn't met by this amount)
                //
                // `granularity` — (advanced) Time interval value "granularity".
                // For example, it could be set to `5` for minutes to allow only 5-minute increments
                // when formatting time intervals: `0 minutes`, `5 minutes`, `10 minutes`, etc.
                // Perhaps this feature will be removed because there seem to be no use cases
                // of it in the real world.
                //
                if (step.granularity) // Recalculate the amount of seconds passed based on granularity
                amount = (0, $7d685aaa52f9ed1f$export$232899b3019cc012)(round)(amount / step.granularity) * step.granularity;
                var valueForFormatting = -1 * Math.sign(secondsPassed) * (0, $7d685aaa52f9ed1f$export$232899b3019cc012)(round)(amount); // By default, this library formats a `0` in "past" mode,
                // unless `future: true` option is passed.
                // This is different to `relative-time-format`'s behavior
                // which formats a `0` in "future" mode by default, unless it's a `-0`.
                // So, convert `0` to `-0` if `future: true` option wasn't passed.
                // `=== 0` matches both `0` and `-0`.
                if (valueForFormatting === 0) {
                    if (future) valueForFormatting = 0;
                    else valueForFormatting = -0;
                }
                switch(labelsType){
                    case 'long':
                    case 'short':
                    case 'narrow':
                        // Format the amount using `Intl.RelativeTimeFormat`.
                        return this.getFormatter(labelsType).format(valueForFormatting, unit);
                    default:
                        // Format the amount.
                        // (mimicks `Intl.RelativeTimeFormat` behavior for other time label styles)
                        return this.formatValue(valueForFormatting, unit, {
                            labels: labels,
                            future: future
                        });
                }
            }
        },
        {
            key: "formatValue",
            value: function formatValue(value, unit, _ref3) {
                var labels = _ref3.labels, future = _ref3.future;
                return this.getFormattingRule(labels, unit, value, {
                    future: future
                }).replace('{0}', this.formatNumber(Math.abs(value)));
            }
        },
        {
            key: "getFormattingRule",
            value: function getFormattingRule(formattingRules, unit, value, _ref4) {
                var future = _ref4.future;
                // Passing the language is required in order to
                // be able to correctly classify the `value` as a number.
                var locale = this.locale;
                formattingRules = formattingRules[unit]; // Check for a special "compacted" rules case:
                // if formatting rules are the same for "past" and "future",
                // and also for all possible `value`s, then those rules are
                // stored as a single string.
                if (typeof formattingRules === 'string') return formattingRules;
                 // Choose either "past" or "future" based on time `value` sign.
                // If "past" is same as "future" then they're stored as "other".
                // If there's only "other" then it's being collapsed.
                var pastOrFuture = value === 0 ? future ? 'future' : 'past' : value < 0 ? 'past' : 'future';
                var quantifierRules = formattingRules[pastOrFuture] || formattingRules; // Bundle size optimization technique.
                if (typeof quantifierRules === 'string') return quantifierRules;
                 // Quantify `value`.
                var quantifier = this.getPluralRules().select(Math.abs(value)); // "other" rule is supposed to always be present.
                // If only "other" rule is present then "rules" is not an object and is a string.
                return quantifierRules[quantifier] || quantifierRules.other;
            }
        },
        {
            key: "formatNumber",
            value: function formatNumber(number) {
                return this.numberFormat ? this.numberFormat.format(number) : String(number);
            }
        },
        {
            key: "getFormatter",
            value: function getFormatter(labelsType) {
                // `Intl.RelativeTimeFormat` instance creation is (hypothetically) assumed
                // a lengthy operation so the instances are cached and reused.
                return this.relativeTimeFormatCache.get(this.locale, labelsType) || this.relativeTimeFormatCache.put(this.locale, labelsType, new this.IntlRelativeTimeFormat(this.locale, {
                    style: labelsType
                }));
            }
        },
        {
            key: "getPluralRules",
            value: function getPluralRules() {
                // `Intl.PluralRules` instance creation is (hypothetically) assumed
                // a lengthy operation so the instances are cached and reused.
                return this.pluralRulesCache.get(this.locale) || this.pluralRulesCache.put(this.locale, new this.IntlPluralRules(this.locale));
            }
        },
        {
            key: "getLabels",
            value: function getLabels() {
                var labelsType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                // Convert `labels` to an array.
                if (typeof labelsType === 'string') labelsType = [
                    labelsType
                ];
                 // Supports legacy "tiny" and "mini-time" label styles.
                labelsType = labelsType.map(function(labelsType) {
                    switch(labelsType){
                        case 'tiny':
                        case 'mini-time':
                            return 'mini';
                        default:
                            return labelsType;
                    }
                }); // "long" labels type is the default one.
                // (it's always present for all languages)
                labelsType = labelsType.concat('long'); // Find a suitable labels type.
                var localeData = (0, $41243a8f54b175bb$export$aa5c834303254f2b)(this.locale);
                for(var _iterator = $1a34c0d312e0c078$var$_createForOfIteratorHelperLoose(labelsType), _step; !(_step = _iterator()).done;){
                    var _labelsType = _step.value;
                    if (localeData[_labelsType]) return {
                        labelsType: _labelsType,
                        labels: localeData[_labelsType]
                    };
                }
            }
        }
    ]);
    return TimeAgo;
}();
var $1a34c0d312e0c078$var$defaultLocale = 'en';
/**
 * Gets default locale.
 * @return  {string} locale
 */ $1a34c0d312e0c078$export$2e2bcd8739ae039.getDefaultLocale = function() {
    return $1a34c0d312e0c078$var$defaultLocale;
};
/**
 * Sets default locale.
 * @param  {string} locale
 */ $1a34c0d312e0c078$export$2e2bcd8739ae039.setDefaultLocale = function(locale) {
    return $1a34c0d312e0c078$var$defaultLocale = locale;
};
/**
 * Adds locale data for a specific locale and marks the locale as default.
 * @param {Object} localeData
 */ $1a34c0d312e0c078$export$2e2bcd8739ae039.addDefaultLocale = function(localeData) {
    if ($1a34c0d312e0c078$var$defaultLocaleHasBeenSpecified) return console.error('[javascript-time-ago] `TimeAgo.addDefaultLocale()` can only be called once. To add other locales, use `TimeAgo.addLocale()`.');
    $1a34c0d312e0c078$var$defaultLocaleHasBeenSpecified = true;
    $1a34c0d312e0c078$export$2e2bcd8739ae039.setDefaultLocale(localeData.locale);
    $1a34c0d312e0c078$export$2e2bcd8739ae039.addLocale(localeData);
};
var $1a34c0d312e0c078$var$defaultLocaleHasBeenSpecified;
/**
 * Adds locale data for a specific locale.
 * @param {Object} localeData
 */ $1a34c0d312e0c078$export$2e2bcd8739ae039.addLocale = function(localeData) {
    (0, $41243a8f54b175bb$export$9b0a0997606861b1)(localeData);
    (0, $b662e5204c4b31d5$export$2e2bcd8739ae039).addLocale(localeData);
};
/**
 * (legacy alias)
 * Adds locale data for a specific locale.
 * @param {Object} localeData
 * @deprecated
 */ $1a34c0d312e0c078$export$2e2bcd8739ae039.locale = $1a34c0d312e0c078$export$2e2bcd8739ae039.addLocale;
/**
 * Adds custom labels to locale data.
 * @param {string} locale
 * @param {string} name
 * @param {object} labels
 */ $1a34c0d312e0c078$export$2e2bcd8739ae039.addLabels = function(locale, name, labels) {
    var localeData = (0, $41243a8f54b175bb$export$aa5c834303254f2b)(locale);
    if (!localeData) {
        (0, $41243a8f54b175bb$export$9b0a0997606861b1)({
            locale: locale
        });
        localeData = (0, $41243a8f54b175bb$export$aa5c834303254f2b)(locale); // throw new Error(`[javascript-time-ago] No data for locale "${locale}"`)
    }
    localeData[name] = labels;
}; // Normalizes `.format()` `time` argument.
function $1a34c0d312e0c078$var$getTimestamp(input) {
    if (input.constructor === Date || $1a34c0d312e0c078$var$isMockedDate(input)) return input.getTime();
    if (typeof input === 'number') return input;
     // For some weird reason istanbul doesn't see this `throw` covered.
    /* istanbul ignore next */ throw new Error("Unsupported relative time formatter input: ".concat($1a34c0d312e0c078$var$_typeof(input), ", ").concat(input));
} // During testing via some testing libraries `Date`s aren't actually `Date`s.
// https://github.com/catamphetamine/javascript-time-ago/issues/22
function $1a34c0d312e0c078$var$isMockedDate(object) {
    return $1a34c0d312e0c078$var$_typeof(object) === 'object' && typeof object.getTime === 'function';
} // Get available time interval measurement units.
function $1a34c0d312e0c078$var$getTimeIntervalMeasurementUnits(allowedUnits, labels, nowLabel) {
    // Get all time interval measurement units that're available
    // in locale data for a given time labels style.
    var units = Object.keys(labels); // `now` unit is handled separately and is shipped in its own `now.json` file.
    // `now.json` isn't present for all locales, so it could be substituted with
    // ".second.current".
    // Add `now` unit if it's available in locale data.
    if (nowLabel) units.push('now');
     // If only a specific set of available time measurement units can be used
    // then only those units are allowed (if they're present in locale data).
    if (allowedUnits) units = allowedUnits.filter(function(unit) {
        return unit === 'now' || units.indexOf(unit) >= 0;
    });
    return units;
}
function $1a34c0d312e0c078$var$getNowLabel(labels, nowLabels, longLabels, future) {
    var nowLabel = labels.now || nowLabels && nowLabels.now; // Specific "now" message form extended locale data (if present).
    if (nowLabel) {
        // Bundle size optimization technique.
        if (typeof nowLabel === 'string') return nowLabel;
         // Not handling `value === 0` as `localeData.now.current` here
        // because it wouldn't make sense: "now" is a moment,
        // so one can't possibly differentiate between a
        // "previous" moment, a "current" moment and a "next moment".
        // It can only be differentiated between "past" and "future".
        if (future) return nowLabel.future;
        else return nowLabel.past;
    } // Use ".second.current" as "now" message.
    if (longLabels && longLabels.second && longLabels.second.current) return longLabels.second.current;
}
function $1a34c0d312e0c078$var$isStyle(variable) {
    return typeof variable === 'string' || (0, $6f90e8cdc9d220b7$export$2e2bcd8739ae039)(variable);
}


var $bd34446cf0164c1a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $bd34446cf0164c1a$export$fb4e49444e7aca99(locales) {
    /* istanbul ignore else */ if ($bd34446cf0164c1a$export$25931a910d8e0cde()) return Intl.DateTimeFormat.supportedLocalesOf(locales)[0];
}
function $bd34446cf0164c1a$export$25931a910d8e0cde() {
    // Babel transforms `typeof` into some "branches"
    // so istanbul will show this as "branch not covered".
    /* istanbul ignore next */ var isIntlAvailable = (typeof Intl === 'undefined' ? 'undefined' : $bd34446cf0164c1a$var$_typeof(Intl)) === 'object';
    return isIntlAvailable && typeof Intl.DateTimeFormat === 'function';
}


var $3f8dfb7d21f1353f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $3f8dfb7d21f1353f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $3f8dfb7d21f1353f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * A basic in-memory cache.
 *
 * import Cache from 'javascript-time-ago/Cache'
 * const cache = new Cache()
 * const object = cache.get('key1', 'key2', ...) || cache.put('key1', 'key2', ..., createObject())
 */ var $3f8dfb7d21f1353f$var$Cache = function() {
    function Cache() {
        $3f8dfb7d21f1353f$var$_classCallCheck(this, Cache);
        this.cache = {};
    }
    $3f8dfb7d21f1353f$var$_createClass(Cache, [
        {
            key: 'get',
            value: function get() {
                var cache = this.cache;
                for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
                for(var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var key = _ref;
                    if ((typeof cache === 'undefined' ? 'undefined' : $3f8dfb7d21f1353f$var$_typeof(cache)) !== 'object') return;
                    cache = cache[key];
                }
                return cache;
            }
        },
        {
            key: 'put',
            value: function put() {
                for(var _len2 = arguments.length, keys = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)keys[_key2] = arguments[_key2];
                var value = keys.pop();
                var lastKey = keys.pop();
                var cache = this.cache;
                for(var _iterator2 = keys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var key = _ref2;
                    if ($3f8dfb7d21f1353f$var$_typeof(cache[key]) !== 'object') cache[key] = {};
                    cache = cache[key];
                }
                return cache[lastKey] = value;
            }
        }
    ]);
    return Cache;
}();
var $3f8dfb7d21f1353f$export$2e2bcd8739ae039 = $3f8dfb7d21f1353f$var$Cache;


var $a3d41227ca40419e$var$cache = new (0, $3f8dfb7d21f1353f$export$2e2bcd8739ae039)();
function $a3d41227ca40419e$export$2e2bcd8739ae039(locales, format) {
    // Fall back to `date.toString()` for old web browsers.
    // https://caniuse.com/#search=intl
    if (!(0, $bd34446cf0164c1a$export$25931a910d8e0cde)()) return function(date) {
        return date.toString();
    };
    // If none of the `locales` are supported
    // a default system locale will be used.
    var locale = $a3d41227ca40419e$var$resolveLocale(locales);
    // `Intl.DateTimeFormat` format caching key.
    // E.g. `"{"day":"numeric","month":"short",...}"`.
    // Didn't benchmark what's faster:
    // creating a new `Intl.DateTimeFormat` instance
    // or stringifying a small JSON `format`.
    // Perhaps strigifying JSON `format` is faster.
    var formatFingerprint = JSON.stringify(format);
    // Get `Intl.DateTimeFormat` instance for these `locale` and `format`.
    // (`locale` can be `undefined` therefore `String(locale)`)
    var formatter = $a3d41227ca40419e$var$cache.get(String(locale), formatFingerprint) || $a3d41227ca40419e$var$cache.put(String(locale), formatFingerprint, new Intl.DateTimeFormat(locale, format));
    // Return date formatter
    return function(date) {
        return formatter.format(date);
    };
}
// Caching locale resolving for optimizing pages 
// with a lot of `<ReactTimeAgo/>` elements (say, 100 or more).
// `Intl.DateTimeFormat.supportedLocalesOf(locales)` is not instantaneous.
// For example, it could be 25 milliseconds for 200 calls.
var $a3d41227ca40419e$var$resolvedLocales = {};
/**
 * Resolves a list of possible locales to a single ("best fit") supported locale.
 * @param  {string[]} locales
 * @return {string}
 */ function $a3d41227ca40419e$var$resolveLocale(locales) {
    var localesFingerprint = locales.toString();
    if ($a3d41227ca40419e$var$resolvedLocales[localesFingerprint]) return $a3d41227ca40419e$var$resolvedLocales[localesFingerprint];
    return $a3d41227ca40419e$var$resolvedLocales[localesFingerprint] = (0, $bd34446cf0164c1a$export$fb4e49444e7aca99)(locales);
}


var $56a179deb25e4a9b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $56a179deb25e4a9b$export$aa350b96d91cd94(value) {
    return $56a179deb25e4a9b$var$isDate(value) ? value : new Date(value);
}
function $56a179deb25e4a9b$export$1428f42a7de81803(value) {
    return $56a179deb25e4a9b$var$isDate(value) ? value.getTime() : value;
}
function $56a179deb25e4a9b$var$isDate(object) {
    return object instanceof Date || $56a179deb25e4a9b$export$ab434ee81522ab9d(object);
}
function $56a179deb25e4a9b$export$ab434ee81522ab9d(object) {
    return (typeof object === 'undefined' ? 'undefined' : $56a179deb25e4a9b$var$_typeof(object)) === 'object' && typeof object.getTime === 'function';
}



var $ad5b0bfbd0dd4c9b$exports = {};
var $1bafc835992f3364$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $1bafc835992f3364$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $1bafc835992f3364$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $1bafc835992f3364$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($1bafc835992f3364$exports);


var $ad5b0bfbd0dd4c9b$var$root = typeof window === 'undefined' ? $parcel$global : window, $ad5b0bfbd0dd4c9b$var$vendors = [
    'moz',
    'webkit'
], $ad5b0bfbd0dd4c9b$var$suffix = 'AnimationFrame', $ad5b0bfbd0dd4c9b$var$raf = $ad5b0bfbd0dd4c9b$var$root['request' + $ad5b0bfbd0dd4c9b$var$suffix], $ad5b0bfbd0dd4c9b$var$caf = $ad5b0bfbd0dd4c9b$var$root['cancel' + $ad5b0bfbd0dd4c9b$var$suffix] || $ad5b0bfbd0dd4c9b$var$root['cancelRequest' + $ad5b0bfbd0dd4c9b$var$suffix];
for(var $ad5b0bfbd0dd4c9b$var$i = 0; !$ad5b0bfbd0dd4c9b$var$raf && $ad5b0bfbd0dd4c9b$var$i < $ad5b0bfbd0dd4c9b$var$vendors.length; $ad5b0bfbd0dd4c9b$var$i++){
    $ad5b0bfbd0dd4c9b$var$raf = $ad5b0bfbd0dd4c9b$var$root[$ad5b0bfbd0dd4c9b$var$vendors[$ad5b0bfbd0dd4c9b$var$i] + 'Request' + $ad5b0bfbd0dd4c9b$var$suffix];
    $ad5b0bfbd0dd4c9b$var$caf = $ad5b0bfbd0dd4c9b$var$root[$ad5b0bfbd0dd4c9b$var$vendors[$ad5b0bfbd0dd4c9b$var$i] + 'Cancel' + $ad5b0bfbd0dd4c9b$var$suffix] || $ad5b0bfbd0dd4c9b$var$root[$ad5b0bfbd0dd4c9b$var$vendors[$ad5b0bfbd0dd4c9b$var$i] + 'CancelRequest' + $ad5b0bfbd0dd4c9b$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$ad5b0bfbd0dd4c9b$var$raf || !$ad5b0bfbd0dd4c9b$var$caf) {
    var $ad5b0bfbd0dd4c9b$var$last = 0, $ad5b0bfbd0dd4c9b$var$id = 0, $ad5b0bfbd0dd4c9b$var$queue = [], $ad5b0bfbd0dd4c9b$var$frameDuration = 1000 / 60;
    $ad5b0bfbd0dd4c9b$var$raf = function(callback) {
        if ($ad5b0bfbd0dd4c9b$var$queue.length === 0) {
            var _now = $1bafc835992f3364$exports(), next = Math.max(0, $ad5b0bfbd0dd4c9b$var$frameDuration - (_now - $ad5b0bfbd0dd4c9b$var$last));
            $ad5b0bfbd0dd4c9b$var$last = next + _now;
            setTimeout(function() {
                var cp = $ad5b0bfbd0dd4c9b$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $ad5b0bfbd0dd4c9b$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($ad5b0bfbd0dd4c9b$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $ad5b0bfbd0dd4c9b$var$queue.push({
            handle: ++$ad5b0bfbd0dd4c9b$var$id,
            callback: callback,
            cancelled: false
        });
        return $ad5b0bfbd0dd4c9b$var$id;
    };
    $ad5b0bfbd0dd4c9b$var$caf = function(handle) {
        for(var i = 0; i < $ad5b0bfbd0dd4c9b$var$queue.length; i++)if ($ad5b0bfbd0dd4c9b$var$queue[i].handle === handle) $ad5b0bfbd0dd4c9b$var$queue[i].cancelled = true;
    };
}
$ad5b0bfbd0dd4c9b$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $ad5b0bfbd0dd4c9b$var$raf.call($ad5b0bfbd0dd4c9b$var$root, fn);
};
$ad5b0bfbd0dd4c9b$exports.cancel = function() {
    $ad5b0bfbd0dd4c9b$var$caf.apply($ad5b0bfbd0dd4c9b$var$root, arguments);
};
$ad5b0bfbd0dd4c9b$exports.polyfill = function(object) {
    if (!object) object = $ad5b0bfbd0dd4c9b$var$root;
    object.requestAnimationFrame = $ad5b0bfbd0dd4c9b$var$raf;
    object.cancelAnimationFrame = $ad5b0bfbd0dd4c9b$var$caf;
};


// "Binary" search in a sorted array.
function $b0f0836d9b121c98$export$2e2bcd8739ae039(array, test) {
    if (array.length === 0) return 0;
    var min = 0;
    var max = array.length - 1;
    var guess = void 0;
    while(min <= max){
        guess = Math.floor((max + min) / 2);
        var result = test(array[guess]);
        if (result === 0) return guess;
        else if (result < 0) {
            min = guess + 1;
            if (min > max) return min;
        } else {
            max = guess - 1;
            if (max < min) return min;
        }
    }
// return -1
// return min
}


var $a3dc9c8776dbe2a8$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $a3dc9c8776dbe2a8$export$2e2bcd8739ae039 = {
    instances: [],
    add: function add(instance) {
        var _this = this;
        var wasIdle = this.instances.length === 0;
        $a3dc9c8776dbe2a8$var$_add(this.instances, instance);
        if (wasIdle) this.start();
        return {
            stop: function stop() {
                $a3dc9c8776dbe2a8$var$remove(_this.instances, instance);
                if (_this.instances.length === 0) _this.stop();
            },
            forceUpdate: function forceUpdate() {
                $a3dc9c8776dbe2a8$var$updateInstance(instance, _this.instances);
            }
        };
    },
    tick: function tick() {
        var now = Date.now();
        while(true){
            var instance = this.instances[0];
            if (now >= instance.nextUpdateTime) $a3dc9c8776dbe2a8$var$updateInstance(instance, this.instances);
            else break;
        }
    },
    scheduleNextTick: function scheduleNextTick() {
        var _this2 = this;
        this.scheduledTick = (0, (/*@__PURE__*/$parcel$interopDefault($ad5b0bfbd0dd4c9b$exports)))(function() {
            _this2.tick();
            _this2.scheduleNextTick();
        });
    },
    start: function start() {
        this.scheduleNextTick();
    },
    stop: function stop() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ad5b0bfbd0dd4c9b$exports))).cancel(this.scheduledTick);
    }
};
function $a3dc9c8776dbe2a8$var$_updateInstance(instance) {
    var _instance$getNextValu = instance.getNextValue(), _instance$getNextValu2 = $a3dc9c8776dbe2a8$var$_slicedToArray(_instance$getNextValu, 2), value = _instance$getNextValu2[0], nextUpdateTime = _instance$getNextValu2[1];
    instance.setValue(value);
    instance.nextUpdateTime = nextUpdateTime;
}
function $a3dc9c8776dbe2a8$var$updateInstance(instance, instances) {
    $a3dc9c8776dbe2a8$var$_updateInstance(instance);
    $a3dc9c8776dbe2a8$var$remove(instances, instance);
    $a3dc9c8776dbe2a8$var$_add(instances, instance);
}
function $a3dc9c8776dbe2a8$var$_add(instances, instance) {
    var i = $a3dc9c8776dbe2a8$var$findTargetIndex(instances, instance);
    instances.splice(i, 0, instance);
}
function $a3dc9c8776dbe2a8$var$remove(instances, instance) {
    var i = instances.indexOf(instance);
    instances.splice(i, 1);
}
function $a3dc9c8776dbe2a8$var$findTargetIndex(instances, instance) {
    var nextUpdateTime = instance.nextUpdateTime;
    return (0, $b0f0836d9b121c98$export$2e2bcd8739ae039)(instances, function(instance) {
        if (instance.nextUpdateTime === nextUpdateTime) return 0;
        else if (instance.nextUpdateTime > nextUpdateTime) return 1;
        else return -1;
    });
}



var $2oXYc = parcelRequire("2oXYc");
// The first step isn't required to define `minTime` or `test()`.
var $c5a85ab6c0bd0c1e$var$step = (0, $2oXYc.oneOfType)([
    (0, $2oXYc.shape)({
        minTime: (0, $2oXYc.number),
        formatAs: (0, $2oXYc.string).isRequired
    }),
    (0, $2oXYc.shape)({
        test: (0, $2oXYc.func),
        formatAs: (0, $2oXYc.string).isRequired
    }),
    (0, $2oXYc.shape)({
        minTime: (0, $2oXYc.number),
        format: (0, $2oXYc.func).isRequired
    }),
    (0, $2oXYc.shape)({
        test: (0, $2oXYc.func),
        format: (0, $2oXYc.func).isRequired
    })
]);
var $c5a85ab6c0bd0c1e$export$1d567c320f4763bc = (0, $2oXYc.oneOfType)([
    // Not using `oneOf()` here, because that way
    // this package wouldn't support some hypothetical
    // new styles added to `javascript-time-ago` in some future.
    (0, $2oXYc.string),
    (0, $2oXYc.shape)({
        steps: (0, $2oXYc.arrayOf)($c5a85ab6c0bd0c1e$var$step).isRequired,
        labels: (0, $2oXYc.oneOfType)([
            (0, $2oXYc.string),
            (0, $2oXYc.arrayOf)((0, $2oXYc.string))
        ]).isRequired,
        round: (0, $2oXYc.string)
    })
]);


var $a2da34cf44eef56c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a2da34cf44eef56c$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
function $a2da34cf44eef56c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a2da34cf44eef56c$var$ReactTimeAgo(_ref) {
    var date = _ref.date, future = _ref.future, timeStyle = _ref.timeStyle, round = _ref.round, minTimeLeft = _ref.minTimeLeft, tooltip = _ref.tooltip, Component = _ref.component, container = _ref.container, wrapperComponent = _ref.wrapperComponent, wrapperProps = _ref.wrapperProps, locale = _ref.locale, locales = _ref.locales, formatVerboseDate = _ref.formatVerboseDate, verboseDateFormat = _ref.verboseDateFormat, updateInterval = _ref.updateInterval, tick = _ref.tick, polyfill = _ref.polyfill, rest = $a2da34cf44eef56c$var$_objectWithoutProperties(_ref, [
        'date',
        'future',
        'timeStyle',
        'round',
        'minTimeLeft',
        'tooltip',
        'component',
        'container',
        'wrapperComponent',
        'wrapperProps',
        'locale',
        'locales',
        'formatVerboseDate',
        'verboseDateFormat',
        'updateInterval',
        'tick',
        'polyfill'
    ]);
    // Get the list of preferred locales.
    var preferredLocales = (0, $7fPBF.useMemo)(function() {
        // Convert `locale` to `locales`.
        if (locale) locales = [
            locale
        ];
        // Add `javascript-time-ago` default locale.
        return locales.concat((0, $1a34c0d312e0c078$export$2e2bcd8739ae039).getDefaultLocale());
    }, [
        locale,
        locales
    ]);
    // Create `javascript-time-ago` formatter instance.
    var timeAgo = (0, $7fPBF.useMemo)(function() {
        return $a2da34cf44eef56c$var$getTimeAgo(preferredLocales, polyfill);
    }, [
        preferredLocales,
        polyfill
    ]);
    // The date or timestamp that was passed.
    // Convert timestamp to `Date`.
    date = (0, $7fPBF.useMemo)(function() {
        return (0, $56a179deb25e4a9b$export$aa350b96d91cd94)(date);
    }, [
        date
    ]);
    // Formats the `date`.
    var formatDate = (0, $7fPBF.useCallback)(function() {
        var now = Date.now();
        var stopUpdates = void 0;
        if (future) {
            if (now >= date.getTime()) {
                now = date.getTime();
                stopUpdates = true;
            }
        }
        if (minTimeLeft !== undefined) {
            var maxNow = date.getTime() - minTimeLeft * 1000;
            if (now > maxNow) {
                now = maxNow;
                stopUpdates = true;
            }
        }
        var _timeAgo$format = timeAgo.format(date, timeStyle, {
            getTimeToNextUpdate: true,
            now: now,
            future: future,
            round: round
        }), _timeAgo$format2 = $a2da34cf44eef56c$var$_slicedToArray(_timeAgo$format, 2), formattedDate = _timeAgo$format2[0], timeToNextUpdate = _timeAgo$format2[1];
        if (stopUpdates) timeToNextUpdate = $a2da34cf44eef56c$var$INFINITY;
        else // Legacy compatibility: there used to be an `updateInterval` property.
        // That was before `getTimeToNextUpdate` feature was introduced in `javascript-time-ago`.
        // A default interval of one minute is introduced because
        // `getTimeToNextUpdate` feature may theoretically return `undefined`.
        timeToNextUpdate = updateInterval || timeToNextUpdate || 60000; // A minute by default.
        return [
            formattedDate,
            now + timeToNextUpdate
        ];
    }, [
        date,
        future,
        timeStyle,
        updateInterval,
        round,
        minTimeLeft,
        timeAgo
    ]);
    var formatDateRef = (0, $7fPBF.useRef)();
    formatDateRef.current = formatDate;
    var _useMemo = (0, $7fPBF.useMemo)(formatDate, []), _useMemo2 = $a2da34cf44eef56c$var$_slicedToArray(_useMemo, 2), _formattedDate = _useMemo2[0], _nextUpdateTime = _useMemo2[1];
    var _useState = (0, $7fPBF.useState)(_formattedDate), _useState2 = $a2da34cf44eef56c$var$_slicedToArray(_useState, 2), formattedDate = _useState2[0], setFormattedDate = _useState2[1];
    // The component sets the "verbose date" tooltip after the component 
    // has mounted rather than on the first render. 
    // The reason is that otherwise React would complain that 
    // server-side-rendered markup doesn't match client-side-rendered one.
    var _useState3 = (0, $7fPBF.useState)(), _useState4 = $a2da34cf44eef56c$var$_slicedToArray(_useState3, 2), shouldSetTooltipText = _useState4[0], setShouldSetTooltipText = _useState4[1];
    var updater = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function() {
        if (tick) {
            updater.current = (0, $a3dc9c8776dbe2a8$export$2e2bcd8739ae039).add({
                getNextValue: function getNextValue() {
                    return formatDateRef.current();
                },
                setValue: setFormattedDate,
                nextUpdateTime: _nextUpdateTime
            });
            return function() {
                return updater.current.stop();
            };
        }
    }, [
        tick
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (updater.current) updater.current.forceUpdate();
        else {
            var _formatDate = formatDate(), _formatDate2 = $a2da34cf44eef56c$var$_slicedToArray(_formatDate, 1), _formattedDate2 = _formatDate2[0];
            setFormattedDate(_formattedDate2);
        }
    }, [
        formatDate
    ]);
    (0, $7fPBF.useEffect)(function() {
        setShouldSetTooltipText(true);
    }, []);
    // Create verbose date formatter for the tooltip text.
    // (only on client side, because tooltips aren't rendered 
    //  until triggered by user interaction)
    var verboseDateFormatter = (0, $7fPBF.useMemo)(function() {
        if (typeof window !== 'undefined') return (0, $a3d41227ca40419e$export$2e2bcd8739ae039)(preferredLocales, verboseDateFormat);
    }, [
        preferredLocales,
        verboseDateFormat
    ]);
    // Format verbose date for the tooltip.
    // (only on client side, because tooltips aren't rendered 
    //  until triggered by user interaction)
    var verboseDate = (0, $7fPBF.useMemo)(function() {
        if (typeof window !== 'undefined') {
            if (formatVerboseDate) return formatVerboseDate(date);
            return verboseDateFormatter(date);
        }
    }, [
        date,
        formatVerboseDate,
        verboseDateFormatter
    ]);
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, $a2da34cf44eef56c$var$_extends({
        date: date,
        verboseDate: shouldSetTooltipText ? verboseDate : undefined,
        tooltip: tooltip
    }, rest), formattedDate);
    var WrapperComponent = wrapperComponent || container;
    if (WrapperComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrapperComponent, $a2da34cf44eef56c$var$_extends({}, wrapperProps, {
        verboseDate: shouldSetTooltipText ? verboseDate : undefined
    }), result);
    return result;
}
$a2da34cf44eef56c$var$ReactTimeAgo.propTypes = {
    // The `date` or `timestamp`.
    // E.g. `new Date()` or `1355972400000`.
    date: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]).isRequired,
    // Preferred locale.
    // Is 'en' by default.
    // E.g. 'ru-RU'.
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    // Alternatively to `locale`, one could pass `locales`:
    // A list of preferred locales (ordered).
    // Will choose the first supported locale from the list.
    // E.g. `['ru-RU', 'en-GB']`.
    locales: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
    // If set to `true`, then will stop at "zero point"
    // when going from future dates to past dates.
    // In other words, even if the `date` has passed,
    // it will still render as if `date` is `now`.
    future: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    // Date/time formatting style.
    // See `javascript-time-ago` docs on "Styles" for more info.
    // E.g. 'round', 'round-minute', 'twitter', 'twitter-first-minute'.
    timeStyle: (0, $c5a85ab6c0bd0c1e$export$1d567c320f4763bc),
    // `round` parameter of `javascript-time-ago`.
    // See `javascript-time-ago` docs on "Rounding" for more info.
    // Examples: "round", "floor".
    round: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    // If specified, the time won't "tick" past this threshold (in seconds).
    // For example, if `minTimeLeft` is `60 * 60`
    // then the time won't "tick" past "in 1 hour".
    minTimeLeft: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    // A React component to render the relative time label.
    // Receives properties:
    // * date: Date — The date.
    // * verboseDate: string? — Formatted verbose date. Is always present on client, is always `undefined` on server (because tooltips aren't shown on server).
    // * tooltip: boolean — The `tooltip` property of `<ReactTimeAgo/>` component.
    // * children: string — The relative time label.
    // * All "unknown" properties that have been passed to `<ReactTimeAgo/>` are passed through to this component.
    component: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).elementType.isRequired,
    // Whether to use HTML `tooltip` attribute to show a verbose date tooltip.
    // Is `true` by default.
    // Can be set to `false` to disable the native HTML `tooltip`.
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    // Verbose date formatter.
    // By default it's `(date) => new Intl.DateTimeFormat(locale, {…}).format(date)`.
    formatVerboseDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    // `Intl.DateTimeFormat` format for formatting verbose date.
    // See `Intl.DateTimeFormat` docs for more info.
    verboseDateFormat: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    // (deprecated)
    // How often the component refreshes itself.
    // Instead, consider using `getNextTimeToUpdate()` feature
    // of `javascript-time-ago` styles.
    updateInterval: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            threshold: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            interval: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
        }))
    ]),
    // (deprecated).
    // Set to `false` to disable automatic refresh of the component.
    // Is `true` by default.
    // I guess no one actually turns that off.
    tick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    // Pass `false` to use native `Intl.RelativeTimeFormat` / `Intl.PluralRules`
    // instead of the polyfilled ones in `javascript-time-ago`.
    polyfill: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    // (advanced)
    // A React Component to wrap the resulting `<time/>` React Element.
    // Receives `verboseDate` and `children` properties.
    // Also receives `wrapperProps`, if they're passed.
    // `verboseDate` can be used for displaying verbose date label
    // in an "on mouse over" (or "on touch") tooltip.
    // See the "Tooltip" readme section for more info.
    // Another example could be having `wrapperComponent`
    // being rerendered every time the component refreshes itself.
    wrapperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    // Custom `props` passed to `wrapperComponent`.
    wrapperProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
};
$a2da34cf44eef56c$var$ReactTimeAgo.defaultProps = {
    // No preferred locales.
    locales: [],
    // Use a `<time/>` tag by default.
    component: $a2da34cf44eef56c$var$Time,
    // Use HTML `tooltip` attribute to show a verbose date tooltip.
    tooltip: true,
    // `Intl.DateTimeFormat` for verbose date.
    // Example: "Thursday, December 20, 2012, 7:00:00 AM GMT+4"
    verboseDateFormat: {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit'
    },
    // Automatically refreshes itself.
    tick: true
};
$a2da34cf44eef56c$var$ReactTimeAgo = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($a2da34cf44eef56c$var$ReactTimeAgo);
var $a2da34cf44eef56c$export$2e2bcd8739ae039 = $a2da34cf44eef56c$var$ReactTimeAgo;
// `setTimeout()` has a bug where it fires immediately
// when the interval is longer than about `24.85` days.
// https://stackoverflow.com/questions/3468607/why-does-settimeout-break-for-large-millisecond-delay-values
var $a2da34cf44eef56c$var$SET_TIMEOUT_MAX_SAFE_INTERVAL = 2147483647;
function $a2da34cf44eef56c$var$getSafeTimeoutInterval(interval) {
    return Math.min(interval, $a2da34cf44eef56c$var$SET_TIMEOUT_MAX_SAFE_INTERVAL);
}
// A thousand years is practically a metaphor for "infinity".
var $a2da34cf44eef56c$var$YEAR = 31536000000;
var $a2da34cf44eef56c$var$INFINITY = 1000 * $a2da34cf44eef56c$var$YEAR;
function $a2da34cf44eef56c$var$Time(_ref2) {
    var date = _ref2.date, verboseDate = _ref2.verboseDate, tooltip = _ref2.tooltip, children = _ref2.children, rest = $a2da34cf44eef56c$var$_objectWithoutProperties(_ref2, [
        'date',
        'verboseDate',
        'tooltip',
        'children'
    ]);
    var isoString = (0, $7fPBF.useMemo)(function() {
        return date.toISOString();
    }, [
        date
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement('time', $a2da34cf44eef56c$var$_extends({}, rest, {
        dateTime: isoString,
        title: tooltip ? verboseDate : undefined
    }), children);
}
$a2da34cf44eef56c$var$Time.propTypes = {
    date: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date).isRequired,
    verboseDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
var $a2da34cf44eef56c$var$TimeAgoCache = new (0, $3f8dfb7d21f1353f$export$2e2bcd8739ae039)();
function $a2da34cf44eef56c$var$getTimeAgo(preferredLocales, polyfill) {
    // `TimeAgo` instance creation is (hypothetically) assumed
    // a lengthy operation so the instances are cached and reused.
    // https://gitlab.com/catamphetamine/react-time-ago/-/issues/1
    var key = String(preferredLocales) + ':' + String(polyfill);
    return $a2da34cf44eef56c$var$TimeAgoCache.get(key) || $a2da34cf44eef56c$var$TimeAgoCache.put(key, new (0, $1a34c0d312e0c078$export$2e2bcd8739ae039)(preferredLocales, {
        polyfill: polyfill
    }));
}



parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $dKzJP = parcelRequire("dKzJP");

var $3Sc7z = parcelRequire("3Sc7z");


var $K4XJ4 = parcelRequire("K4XJ4");

var $55RWP = parcelRequire("55RWP");

var $1rW9t = parcelRequire("1rW9t");
var $7cac207432c70082$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `underline="none"`. */ underlineNone: {
        textDecoration: 'none'
    },
    /* Styles applied to the root element if `underline="hover"`. */ underlineHover: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    },
    /* Styles applied to the root element if `underline="always"`. */ underlineAlways: {
        textDecoration: 'underline'
    },
    // Same reset as ButtonBase.root
    /* Styles applied to the root element if `component="button"`. */ button: {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$focusVisible': {
            outline: 'auto'
        }
    },
    /* Pseudo-class applied to the root element if the link is keyboard focused. */ focusVisible: {}
};
var $7cac207432c70082$var$Link = /*#__PURE__*/ $7fPBF.forwardRef(function Link(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'a' : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? 'hover' : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? 'inherit' : _props$variant, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant"
    ]);
    var _useIsFocusVisible = (0, $K4XJ4.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState = $7fPBF.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    var handlerRef = (0, $55RWP.default)(ref, focusVisibleRef);
    var handleBlur = function handleBlur(event) {
        if (focusVisible) {
            onBlurVisible();
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    };
    var handleFocus = function handleFocus(event) {
        if (isFocusVisible(event)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $1rW9t.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes["underline".concat((0, $dKzJP.default)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        variant: variant
    }, other));
});
var $7cac207432c70082$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($7cac207432c70082$export$9dd6ff9ea0189349, {
    name: 'MuiLink'
})($7cac207432c70082$var$Link);


var $by0pu = parcelRequire("by0pu");
const $4ccfbf95ed686155$var$ActionLink = ({ type: type, onClickFunction: onClickFunction, className: className = '' })=>{
    const useStyles = (0, $by0pu.default)({
        button: {
            marginRight: '10px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7cac207432c70082$export$2e2bcd8739ae039), {
        onClick: onClickFunction,
        color: "inherit",
        variant: "body2",
        className: className || classes.button,
        children: type
    });
};
var $4ccfbf95ed686155$export$2e2bcd8739ae039 = $4ccfbf95ed686155$var$ActionLink;



parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $c94c2e9631b0f584$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            fontSize: theme.typography.pxToRem(24),
            width: '1em',
            height: '1em',
            // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
            // To remove at some point.
            overflow: 'hidden',
            flexShrink: 0
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(36)
        }
    };
};
var $c94c2e9631b0f584$var$Icon = /*#__PURE__*/ $7fPBF.forwardRef(function Icon(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'span' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "fontSize"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
        className: (0, $jtRae.default)('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat((0, $dKzJP.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $dKzJP.default)(fontSize))]),
        "aria-hidden": true,
        ref: ref
    }, other));
});
$c94c2e9631b0f584$var$Icon.muiName = 'Icon';
var $c94c2e9631b0f584$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($c94c2e9631b0f584$export$9dd6ff9ea0189349, {
    name: 'MuiIcon'
})($c94c2e9631b0f584$var$Icon);


var $b683a24bca0c1dd8$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($b683a24bca0c1dd8$exports, "__esModule", {
    value: true
});
$b683a24bca0c1dd8$exports.default = void 0;

var $b683a24bca0c1dd8$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $b683a24bca0c1dd8$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $b683a24bca0c1dd8$var$_default = (0, $b683a24bca0c1dd8$var$_createSvgIcon.default)(/*#__PURE__*/ $b683a24bca0c1dd8$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
}), 'Error');
$b683a24bca0c1dd8$exports.default = $b683a24bca0c1dd8$var$_default;



var $by0pu = parcelRequire("by0pu");

var $1OsIT = parcelRequire("1OsIT");



const $f97412ebadb8a208$export$6026ae6c58b4c197 = ({ objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`objectives/${objectiveId}/comments`);
const $f97412ebadb8a208$export$2a15b079e3f46654 = ({ objectiveId: objectiveId, comment: comment })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(`objectives/${objectiveId}/comments`, comment);
const $f97412ebadb8a208$export$5a1cd239009d83a6 = ({ objectiveId: objectiveId, comment: comment })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`objectives/${objectiveId}/comments/${comment.id}`, comment);
const $f97412ebadb8a208$export$2e6e3ad634e3776 = ({ objectiveId: objectiveId, commentId: commentId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).delete(`/objectives/${objectiveId}/comments/${commentId}`);


const $d61c5fcd676c856b$var$useStyles = (0, $by0pu.default)((theme)=>({
        title: {
            backgroundColor: 'white',
            color: '#252733'
        },
        errorIcon: {
            top: theme.spacing(0.3),
            right: theme.spacing(0.5),
            verticalAlign: 'middle',
            position: 'relative',
            color: 'crimson'
        },
        deleteBtn: {
            background: (0, $1OsIT.default)['A200']
        }
    }));
const $d61c5fcd676c856b$var$DeleteDialog = ({ open: open, setOpen: setOpen, commentId: commentId, objectiveId: objectiveId, onSubmitSuccess: onSubmitSuccess })=>{
    const classes = $d61c5fcd676c856b$var$useStyles();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const deleteCommentMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        return await (0, $f97412ebadb8a208$export$2e6e3ad634e3776)({
            objectiveId: objectiveId,
            commentId: commentId
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const handleClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
            open: open,
            onClose: handleClose,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                    className: classes.title,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c94c2e9631b0f584$export$2e2bcd8739ae039), {
                            className: classes.errorIcon,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b683a24bca0c1dd8$exports))), {})
                        }),
                        t('comments.deleteDialog.title')
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                    children: t('comments.deleteDialog.content')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: deleteCommentMutation.mutate,
                            variant: "contained",
                            className: classes.deleteBtn,
                            children: t('comments.deleteDialog.deleteBtn')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: handleClose,
                            children: t('comments.deleteDialog.cancelBtn')
                        })
                    ]
                })
            ]
        })
    });
};
var $d61c5fcd676c856b$export$2e2bcd8739ae039 = $d61c5fcd676c856b$var$DeleteDialog;







const $093be1222eff1c28$var$CommentItem = ({ objectiveId: objectiveId, comment: comment, employeeId: employeeId, onSubmitSuccess: onSubmitSuccess })=>{
    const lng = (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).languages[0];
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [content, setContent] = (0, $7fPBF.useState)(comment.content);
    const [isEditing, setIsEditing] = (0, $7fPBF.useState)(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = (0, $7fPBF.useState)(false);
    const updateCommentMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        return await (0, $f97412ebadb8a208$export$5a1cd239009d83a6)({
            employeeId: employeeId,
            objectiveId: objectiveId,
            comment: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, comment), {
                content: content
            })
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
            setIsEditing(false);
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const handleOnChangeComment = (event)=>{
        setContent(event.target.value);
    };
    const onDelete = ()=>{
        setDeleteDialogOpen(true);
    };
    const onUpdate = ()=>{
        setIsEditing(true);
    };
    const onCancel = ()=>{
        setIsEditing(false);
        setContent(comment.content);
    };
    const useStyles = (0, $by0pu.default)({
        listItem: {
            marginBottom: '10px'
        },
        comment: {
            margin: '15px 0',
            fontSize: '12px',
            color: '#666666'
        },
        updating: {
            borderRadius: '5px 5px 5px 5px',
            border: '1px solid #c9c9c9',
            padding: '10px'
        },
        nonUpdating: {
            borderStyle: 'none',
            color: '#666666',
            paddingLeft: '0'
        },
        info: {
            fontSize: '12px',
            color: '#999999',
            marginLeft: '15px'
        },
        lockIcon: {
            margin: 'auto auto -5px 15px',
            color: '#9FA2B4'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hPUC4.default), {
        className: classes.listItem,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
            container: true,
            direction: 'column',
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                            children: comment.commenter_name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a2da34cf44eef56c$export$2e2bcd8739ae039), {
                            className: classes.info,
                            date: new Date(comment.created_at),
                            locale: lng
                        }),
                        comment.edited_at !== null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: classes.info,
                                    children: "|"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: classes.info,
                                    children: t('objective.comment.edited')
                                })
                            ]
                        }),
                        !comment.is_public && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc9391fc9edf9223$exports))), {
                                className: classes.lockIcon
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    className: classes.comment,
                    children: isEditing ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dzfbx.default), {
                        value: content,
                        onChange: handleOnChangeComment,
                        classes: {
                            root: classes.updating,
                            disabled: classes.nonUpdating
                        },
                        multiline: true,
                        fullWidth: true
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $432444006420a8b4$export$2e2bcd8739ae039), {
                        children: comment.content
                    })
                }),
                comment.commented_by === employeeId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    children: [
                        isEditing ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4ccfbf95ed686155$export$2e2bcd8739ae039), {
                                    type: t('objective.comment.cancel'),
                                    onClickFunction: onCancel
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4ccfbf95ed686155$export$2e2bcd8739ae039), {
                                    type: t('objective.comment.save'),
                                    onClickFunction: updateCommentMutation.mutate
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4ccfbf95ed686155$export$2e2bcd8739ae039), {
                                    type: t('objective.comment.edit'),
                                    onClickFunction: onUpdate
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4ccfbf95ed686155$export$2e2bcd8739ae039), {
                                    type: t('objective.comment.delete'),
                                    onClickFunction: onDelete
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d61c5fcd676c856b$export$2e2bcd8739ae039), {
                            open: deleteDialogOpen,
                            setOpen: setDeleteDialogOpen,
                            commentId: comment.id,
                            objectiveId: objectiveId,
                            onSubmitSuccess: onSubmitSuccess
                        })
                    ]
                })
            ]
        })
    });
};
var $093be1222eff1c28$export$2e2bcd8739ae039 = $093be1222eff1c28$var$CommentItem;




var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $lLRv0 = parcelRequire("lLRv0");
var $by0pu = parcelRequire("by0pu");

var $MQfsM = parcelRequire("MQfsM");



const $254a38fa9ff77749$var$useStyles = (0, $by0pu.default)((theme)=>({
        sendBtn: {
            marginTop: '20px',
            marginBottom: '20px'
        },
        radio: {
            color: '#9FA2B4'
        },
        labelPublic: {
            marginLeft: '0'
        },
        labelPrivate: {
            [theme.breakpoints.down('xs')]: {
                marginLeft: '0'
            }
        }
    }));
const $254a38fa9ff77749$var$NewComment = ({ objectiveId: objectiveId, onSubmitSuccess: onSubmitSuccess })=>{
    const classes = $254a38fa9ff77749$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [content, setContent] = (0, $7fPBF.useState)('');
    const [isPublic, setIsPublic] = (0, $7fPBF.useState)(true);
    const createCommentMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        return await (0, $f97412ebadb8a208$export$2a15b079e3f46654)({
            objectiveId: objectiveId,
            comment: {
                content: content,
                objectiveId: objectiveId,
                isPublic: isPublic
            }
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
            setContent('');
            setIsPublic(true);
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const onContentChange = (event)=>{
        setContent(event.target.value);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $lLRv0.default), {
                checked: isPublic,
                onChange: ()=>setIsPublic(true),
                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3a3a7167ebe47fc$export$2e2bcd8739ae039), {
                    classes: {
                        root: classes.radio
                    }
                }),
                label: t('objective.comment.selectType.public'),
                labelPlacement: "start",
                className: classes.labelPublic
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $lLRv0.default), {
                checked: !isPublic,
                onChange: ()=>setIsPublic(false),
                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d3a3a7167ebe47fc$export$2e2bcd8739ae039), {
                    classes: {
                        root: classes.radio
                    }
                }),
                label: t('objective.comment.selectType.note'),
                labelPlacement: "start",
                className: classes.labelPrivate
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                value: content,
                onChange: onContentChange,
                variant: "outlined",
                color: "secondary",
                fullWidth: true,
                multiline: true,
                minRows: 3,
                maxRows: 3,
                placeholder: isPublic ? t('objective.comment.public.create.placeholder') : t('objective.comment.note.create.placeholder')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                className: classes.sendBtn,
                onClick: createCommentMutation.mutate,
                variant: "contained",
                color: "secondary",
                disabled: content === '',
                children: isPublic ? t('objective.comment.public.create.btn') : t('objective.comment.note.create.btn')
            })
        ]
    });
};
var $254a38fa9ff77749$export$2e2bcd8739ae039 = $254a38fa9ff77749$var$NewComment;






const $8e20e1fc426c4f73$var$useStyles = (0, $by0pu.default)({
    container: {
        backgroundColor: '#F4F4F4',
        padding: '20px'
    },
    title: {
        color: '#999999',
        fontSize: '16px',
        textTransform: 'uppercase'
    }
});
const $8e20e1fc426c4f73$var$CommentsList = ({ objectiveId: objectiveId, employee: employee })=>{
    var _commentsQuery_data;
    const classes = $8e20e1fc426c4f73$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const commentsQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'comments',
        objectiveId
    ], async ()=>{
        const { data: data } = await (0, $f97412ebadb8a208$export$6026ae6c58b4c197)({
            objectiveId: objectiveId
        });
        data.sort((x, y)=>new Date(x.created_at) - new Date(y.created_at));
        return data;
    }, {
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $86a6140e16b13821$export$2e2bcd8739ae039), {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.title,
                children: t('objective.comments.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fOH1P.default), {
                children: (_commentsQuery_data = commentsQuery.data) === null || _commentsQuery_data === void 0 ? void 0 : _commentsQuery_data.map((comment)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $093be1222eff1c28$export$2e2bcd8739ae039), {
                        comment: comment,
                        objectiveId: objectiveId,
                        employeeId: employee.employee_id,
                        onSubmitSuccess: commentsQuery.refetch
                    }, comment.comment_id))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $254a38fa9ff77749$export$2e2bcd8739ae039), {
                objectiveId: objectiveId,
                onSubmitSuccess: commentsQuery.refetch
            })
        ]
    });
};
var $8e20e1fc426c4f73$export$2e2bcd8739ae039 = $8e20e1fc426c4f73$var$CommentsList;



parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");

const $ab5b0342cb6fe691$export$409d0b14e1979161 = ({ closeObjectiveDialogOpen: closeObjectiveDialogOpen, setCloseObjectiveDialogOpen: setCloseObjectiveDialogOpen, handleFailedObjective: handleFailedObjective })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleCloseFailedEvaluation = ()=>{
        handleFailedObjective();
        setCloseObjectiveDialogOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
        open: closeObjectiveDialogOpen,
        onClose: ()=>setCloseObjectiveDialogOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                children: t('objective.evaluation.status.dialog.lock.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c20b368aae28118$export$2e2bcd8739ae039), {
                    children: t('objective.evaluation.status.dialog.lock.failed_description')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleCloseFailedEvaluation,
                        color: "primary",
                        variant: "contained",
                        children: t('objective.evaluation.status.dialog.lock.confirm')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: ()=>setCloseObjectiveDialogOpen(false),
                        color: "primary",
                        autoFocus: true,
                        children: t('objective.evaluation.status.dialog.cancel')
                    })
                ]
            })
        ]
    });
};



parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");


const $29f07647fa6b2df4$var$CompletedObjectiveStatusDialog = ({ open: open, setCompletedObjectiveDialogOpen: setCompletedObjectiveDialogOpen, handleStatusChange: handleStatusChange })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleSetObjectiveCompleted = ()=>{
        handleStatusChange((0, $f6e729db3f817bb5$exports.STATUS).COMPLETED);
        setCompletedObjectiveDialogOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
        open: open,
        onClose: ()=>setCompletedObjectiveDialogOpen(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                children: t('objective.evaluation.status.dialog.set_completed.title')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c20b368aae28118$export$2e2bcd8739ae039), {
                    children: t('objective.evaluation.status.dialog.set_completed.description')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleSetObjectiveCompleted,
                        color: "primary",
                        variant: "contained",
                        children: t('objective.evaluation.status.dialog.set_completed.confirm')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: ()=>setCompletedObjectiveDialogOpen(false),
                        color: "primary",
                        autoFocus: true,
                        children: t('objective.evaluation.status.dialog.cancel')
                    })
                ]
            })
        ]
    });
};
var $29f07647fa6b2df4$export$2e2bcd8739ae039 = $29f07647fa6b2df4$var$CompletedObjectiveStatusDialog;




var $7fPBF = parcelRequire("7fPBF");


var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");

var $gSkQi = parcelRequire("gSkQi");


const $cf0e40a933e30d20$export$b37adf77d4d80157 = ({ objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objectives/${objectiveId}/kpis`);
const $cf0e40a933e30d20$export$901ebd53317a9d7a = ({ kpi: kpi, objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(`/objectives/${objectiveId}/kpis`, {
        kpi: kpi
    });
const $cf0e40a933e30d20$export$1fc50355bb00e113 = ({ kpi: kpi, objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`/objectives/${objectiveId}/kpis`, {
        kpi: kpi
    });
const $cf0e40a933e30d20$export$fd68e9e14a0b2c8a = ({ kpiId: kpiId, objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).delete(`/objectives/${objectiveId}/kpis/${kpiId}`);






var $7fPBF = parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");




var $MQfsM = parcelRequire("MQfsM");
parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");
var $18522b4fc47f45cb$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $18522b4fc47f45cb$var$isDateObject = (value1)=>value1 instanceof Date;
var $18522b4fc47f45cb$var$isNullOrUndefined = (value1)=>value1 == null;
const $18522b4fc47f45cb$var$isObjectType = (value1)=>typeof value1 === 'object';
var $18522b4fc47f45cb$var$isObject = (value1)=>!$18522b4fc47f45cb$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $18522b4fc47f45cb$var$isObjectType(value1) && !$18522b4fc47f45cb$var$isDateObject(value1);
var $18522b4fc47f45cb$var$getEventValue = (event)=>$18522b4fc47f45cb$var$isObject(event) && event.target ? $18522b4fc47f45cb$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $18522b4fc47f45cb$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $18522b4fc47f45cb$var$isNameInFieldArray = (names, name)=>names.has($18522b4fc47f45cb$var$getNodeParentName(name));
var $18522b4fc47f45cb$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $18522b4fc47f45cb$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $18522b4fc47f45cb$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $18522b4fc47f45cb$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($18522b4fc47f45cb$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $18522b4fc47f45cb$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$18522b4fc47f45cb$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $18522b4fc47f45cb$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $18522b4fc47f45cb$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $18522b4fc47f45cb$var$isUndefined = (val)=>val === undefined;
var $18522b4fc47f45cb$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$18522b4fc47f45cb$var$isObject(object)) return defaultValue;
    const result = $18522b4fc47f45cb$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$18522b4fc47f45cb$var$isNullOrUndefined(result) ? result : result[key], object);
    return $18522b4fc47f45cb$var$isUndefined(result) || result === object ? $18522b4fc47f45cb$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $18522b4fc47f45cb$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $18522b4fc47f45cb$var$isKey = (value1)=>/^\w*$/.test(value1);
var $18522b4fc47f45cb$var$stringToPath = (input)=>$18522b4fc47f45cb$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $18522b4fc47f45cb$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $18522b4fc47f45cb$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $18522b4fc47f45cb$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $18522b4fc47f45cb$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $18522b4fc47f45cb$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $18522b4fc47f45cb$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($18522b4fc47f45cb$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $18522b4fc47f45cb$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children } = props, data = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($18522b4fc47f45cb$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $18522b4fc47f45cb$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $18522b4fc47f45cb$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $18522b4fc47f45cb$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $18522b4fc47f45cb$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$606f11b2eb45ecc6(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState, formState));
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$18522b4fc47f45cb$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $18522b4fc47f45cb$var$isString = (value1)=>typeof value1 === 'string';
var $18522b4fc47f45cb$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($18522b4fc47f45cb$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $18522b4fc47f45cb$export$3c773aa2b84f29e0(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(defaultValue);
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(control._getWatch(name, _defaultValue.current));
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>!disabled && updateValue($18522b4fc47f45cb$var$generateWatchOutput(name, control._names, formState.values || control._formValues, false, _defaultValue.current))
        }), [
        name,
        control,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$e8c786024a2b0a79(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $18522b4fc47f45cb$var$isNameInFieldArray(control._names.array, name);
    const value1 = $18522b4fc47f45cb$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name, $18522b4fc47f45cb$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $18522b4fc47f45cb$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(props);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(control.register(name, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.rules), {
        value: value1
    }), $18522b4fc47f45cb$var$isBoolean(props.disabled) ? {
        disabled: props.disabled
    } : {})));
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $18522b4fc47f45cb$var$getEventValue(event),
                name: name
            },
            type: $18522b4fc47f45cb$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $18522b4fc47f45cb$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((elm)=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus && elm.focus(),
            select: ()=>elm.select && elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            name: name,
            value: value1
        }, $18522b4fc47f45cb$var$isBoolean(disabled) || formState.disabled ? {
            disabled: formState.disabled || disabled
        } : {}), {
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        control.register(name, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _props.current.rules, $18522b4fc47f45cb$var$isBoolean(_props.current.disabled) ? {
            disabled: _props.current.disabled
        } : {}));
        const updateMounted = (name, value1)=>{
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($18522b4fc47f45cb$var$isUndefined($18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name))) $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $18522b4fc47f45cb$export$bd0bf19f25da8474 = (props)=>props.render($18522b4fc47f45cb$export$e8c786024a2b0a79(props));
const $18522b4fc47f45cb$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($18522b4fc47f45cb$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $18522b4fc47f45cb$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $18522b4fc47f45cb$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$a7fed597f4b8afd8(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $18522b4fc47f45cb$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus } = props, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "control",
        "onSubmit",
        "children",
        "action",
        "method",
        "headers",
        "encType",
        "onError",
        "render",
        "onSuccess",
        "validateStatus"
    ]);
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $18522b4fc47f45cb$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, headers, encType ? {
                        'Content-Type': encType
                    } : {}),
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit
    }, rest), children);
}
var $18522b4fc47f45cb$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, errors[name]), {
        types: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, errors[name] && errors[name].types ? errors[name].types : {}), {
            [type]: message || true
        })
    }) : {};
var $18522b4fc47f45cb$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $18522b4fc47f45cb$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $18522b4fc47f45cb$var$isPrimitive = (value1)=>$18522b4fc47f45cb$var$isNullOrUndefined(value1) || !$18522b4fc47f45cb$var$isObjectType(value1);
function $18522b4fc47f45cb$var$deepEqual(object1, object2) {
    if ($18522b4fc47f45cb$var$isPrimitive(object1) || $18522b4fc47f45cb$var$isPrimitive(object2)) return object1 === object2;
    if ($18522b4fc47f45cb$var$isDateObject(object1) && $18522b4fc47f45cb$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($18522b4fc47f45cb$var$isDateObject(val1) && $18522b4fc47f45cb$var$isDateObject(val2) || $18522b4fc47f45cb$var$isObject(val1) && $18522b4fc47f45cb$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$18522b4fc47f45cb$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $18522b4fc47f45cb$var$isEmptyObject = (value1)=>$18522b4fc47f45cb$var$isObject(value1) && !Object.keys(value1).length;
var $18522b4fc47f45cb$var$isFileInput = (element)=>element.type === 'file';
var $18522b4fc47f45cb$var$isFunction = (value1)=>typeof value1 === 'function';
var $18522b4fc47f45cb$var$isHTMLElement = (value1)=>{
    if (!$18522b4fc47f45cb$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $18522b4fc47f45cb$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $18522b4fc47f45cb$var$isRadioInput = (element)=>element.type === 'radio';
var $18522b4fc47f45cb$var$isRadioOrCheckbox = (ref)=>$18522b4fc47f45cb$var$isRadioInput(ref) || $18522b4fc47f45cb$var$isCheckBoxInput(ref);
var $18522b4fc47f45cb$var$live = (ref)=>$18522b4fc47f45cb$var$isHTMLElement(ref) && ref.isConnected;
function $18522b4fc47f45cb$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $18522b4fc47f45cb$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $18522b4fc47f45cb$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$18522b4fc47f45cb$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $18522b4fc47f45cb$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $18522b4fc47f45cb$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($18522b4fc47f45cb$var$isObject(childObject) && $18522b4fc47f45cb$var$isEmptyObject(childObject) || Array.isArray(childObject) && $18522b4fc47f45cb$var$isEmptyArray(childObject))) $18522b4fc47f45cb$var$unset(object, paths.slice(0, -1));
    return object;
}
var $18522b4fc47f45cb$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($18522b4fc47f45cb$var$isFunction(data[key])) return true;
    }
    return false;
};
function $18522b4fc47f45cb$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($18522b4fc47f45cb$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $18522b4fc47f45cb$var$isObject(data[key]) && !$18522b4fc47f45cb$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $18522b4fc47f45cb$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$18522b4fc47f45cb$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $18522b4fc47f45cb$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($18522b4fc47f45cb$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $18522b4fc47f45cb$var$isObject(data[key]) && !$18522b4fc47f45cb$var$objectHasFunction(data[key])) {
            if ($18522b4fc47f45cb$var$isUndefined(formValues) || $18522b4fc47f45cb$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $18522b4fc47f45cb$var$markFieldsDirty(data[key], []) : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $18522b4fc47f45cb$var$markFieldsDirty(data[key]));
            else $18522b4fc47f45cb$var$getDirtyFieldsFromDefaultValues(data[key], $18522b4fc47f45cb$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$18522b4fc47f45cb$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $18522b4fc47f45cb$var$getDirtyFields = (defaultValues, formValues)=>$18522b4fc47f45cb$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $18522b4fc47f45cb$var$markFieldsDirty(formValues));
const $18522b4fc47f45cb$var$defaultResult = {
    value: false,
    isValid: false
};
const $18522b4fc47f45cb$var$validResult = {
    value: true,
    isValid: true
};
var $18522b4fc47f45cb$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$18522b4fc47f45cb$var$isUndefined(options[0].attributes.value) ? $18522b4fc47f45cb$var$isUndefined(options[0].value) || options[0].value === '' ? $18522b4fc47f45cb$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $18522b4fc47f45cb$var$validResult : $18522b4fc47f45cb$var$defaultResult;
    }
    return $18522b4fc47f45cb$var$defaultResult;
};
var $18522b4fc47f45cb$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$18522b4fc47f45cb$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $18522b4fc47f45cb$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $18522b4fc47f45cb$var$defaultReturn = {
    isValid: false,
    value: null
};
var $18522b4fc47f45cb$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $18522b4fc47f45cb$var$defaultReturn) : $18522b4fc47f45cb$var$defaultReturn;
function $18522b4fc47f45cb$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($18522b4fc47f45cb$var$isFileInput(ref)) return ref.files;
    if ($18522b4fc47f45cb$var$isRadioInput(ref)) return $18522b4fc47f45cb$var$getRadioValue(_f.refs).value;
    if ($18522b4fc47f45cb$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($18522b4fc47f45cb$var$isCheckBoxInput(ref)) return $18522b4fc47f45cb$var$getCheckboxValue(_f.refs).value;
    return $18522b4fc47f45cb$var$getFieldValueAs($18522b4fc47f45cb$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $18522b4fc47f45cb$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        field && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $18522b4fc47f45cb$var$isRegex = (value1)=>value1 instanceof RegExp;
var $18522b4fc47f45cb$var$getRuleValue = (rule)=>$18522b4fc47f45cb$var$isUndefined(rule) ? rule : $18522b4fc47f45cb$var$isRegex(rule) ? rule.source : $18522b4fc47f45cb$var$isObject(rule) ? $18522b4fc47f45cb$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $18522b4fc47f45cb$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.all,
        isOnTouch: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onTouched
    });
const $18522b4fc47f45cb$var$ASYNC_FUNCTION = 'AsyncFunction';
var $18522b4fc47f45cb$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($18522b4fc47f45cb$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $18522b4fc47f45cb$var$ASYNC_FUNCTION || $18522b4fc47f45cb$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $18522b4fc47f45cb$var$ASYNC_FUNCTION));
var $18522b4fc47f45cb$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $18522b4fc47f45cb$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $18522b4fc47f45cb$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const _ref of fieldsNames || Object.keys(fields)){
        let key = _ref;
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f } = field, currentField = (0, $8901fc92b5563702$export$71511d61b312f219)(field, [
                "_f"
            ]);
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($18522b4fc47f45cb$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($18522b4fc47f45cb$var$isObject(currentField)) {
                if ($18522b4fc47f45cb$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $18522b4fc47f45cb$var$schemaErrorLookup(errors, _fields, name) {
    const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name);
    if (error || $18522b4fc47f45cb$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $18522b4fc47f45cb$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name } = formStateData, formState = (0, $8901fc92b5563702$export$71511d61b312f219)(formStateData, [
        "name"
    ]);
    return $18522b4fc47f45cb$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $18522b4fc47f45cb$var$VALIDATION_MODE.all));
};
var $18522b4fc47f45cb$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $18522b4fc47f45cb$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $18522b4fc47f45cb$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $18522b4fc47f45cb$var$unsetEmptyArray = (ref, name)=>!$18522b4fc47f45cb$var$compact($18522b4fc47f45cb$export$3988ae62b71be9a3(ref, name)).length && $18522b4fc47f45cb$var$unset(ref, name);
var $18522b4fc47f45cb$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name));
    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $18522b4fc47f45cb$var$isMessage = (value1)=>$18522b4fc47f45cb$var$isString(value1);
function $18522b4fc47f45cb$var$getValidateError(result, ref, type = 'validate') {
    if ($18522b4fc47f45cb$var$isMessage(result) || Array.isArray(result) && result.every($18522b4fc47f45cb$var$isMessage) || $18522b4fc47f45cb$var$isBoolean(result) && !result) return {
        type: type,
        message: $18522b4fc47f45cb$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $18522b4fc47f45cb$var$getValueAndMessage = (validationData)=>$18522b4fc47f45cb$var$isObject(validationData) && !$18522b4fc47f45cb$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $18522b4fc47f45cb$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($18522b4fc47f45cb$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $18522b4fc47f45cb$var$isRadioInput(ref);
    const isCheckBox = $18522b4fc47f45cb$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $18522b4fc47f45cb$var$isFileInput(ref)) && $18522b4fc47f45cb$var$isUndefined(ref.value) && $18522b4fc47f45cb$var$isUndefined(inputValue) || $18522b4fc47f45cb$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $18522b4fc47f45cb$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.maxLength, minType = $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref
        }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $18522b4fc47f45cb$var$isNullOrUndefined(inputValue)) || $18522b4fc47f45cb$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$18522b4fc47f45cb$var$getCheckboxValue(refs).isValid || isRadio && !$18522b4fc47f45cb$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $18522b4fc47f45cb$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $18522b4fc47f45cb$var$getValueAndMessage(required);
        if (value1) {
            error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                type: $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef
            }, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$18522b4fc47f45cb$var$isNullOrUndefined(min) || !$18522b4fc47f45cb$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $18522b4fc47f45cb$var$getValueAndMessage(max);
        const minOutput = $18522b4fc47f45cb$var$getValueAndMessage(min);
        if (!$18522b4fc47f45cb$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$18522b4fc47f45cb$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$18522b4fc47f45cb$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($18522b4fc47f45cb$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($18522b4fc47f45cb$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.max, $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($18522b4fc47f45cb$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $18522b4fc47f45cb$var$getValueAndMessage(maxLength);
        const minLengthOutput = $18522b4fc47f45cb$var$getValueAndMessage(minLength);
        const exceedMax = !$18522b4fc47f45cb$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$18522b4fc47f45cb$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $18522b4fc47f45cb$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $18522b4fc47f45cb$var$getValueAndMessage(pattern);
        if ($18522b4fc47f45cb$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                type: $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref
            }, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($18522b4fc47f45cb$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $18522b4fc47f45cb$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validateError, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($18522b4fc47f45cb$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$18522b4fc47f45cb$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $18522b4fc47f45cb$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validateError, appendErrorsCurry(key, validateError.message));
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$18522b4fc47f45cb$var$isEmptyObject(validationResult)) {
                error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    ref: inputRef
                }, validationResult);
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $18522b4fc47f45cb$var$defaultOptions = {
    mode: $18522b4fc47f45cb$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $18522b4fc47f45cb$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $18522b4fc47f45cb$export$1361f5e0e4cca3c3(props = {}) {
    let _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $18522b4fc47f45cb$var$defaultOptions, props);
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $18522b4fc47f45cb$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    const _fields = {};
    let _defaultValues = $18522b4fc47f45cb$var$isObject(_options.defaultValues) || $18522b4fc47f45cb$var$isObject(_options.values) ? $18522b4fc47f45cb$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $18522b4fc47f45cb$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _proxyFormState);
    const _subjects = {
        array: $18522b4fc47f45cb$var$createSubject(),
        state: $18522b4fc47f45cb$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $18522b4fc47f45cb$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $18522b4fc47f45cb$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $18522b4fc47f45cb$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$18522b4fc47f45cb$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $18522b4fc47f45cb$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name, $18522b4fc47f45cb$var$isUndefined(value1) ? $18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $18522b4fc47f45cb$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $18522b4fc47f45cb$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $18522b4fc47f45cb$var$deepEqual($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $18522b4fc47f45cb$var$unset(_formState.dirtyFields, name) : $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $18522b4fc47f45cb$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $18522b4fc47f45cb$var$unset(_formState.errors, name);
        }
        if ((error ? !$18522b4fc47f45cb$var$deepEqual(previousFieldError, error) : previousFieldError) || !$18522b4fc47f45cb$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fieldState, shouldUpdateValid && $18522b4fc47f45cb$var$isBoolean(isValid) ? {
                isValid: isValid
            } : {}), {
                errors: _formState.errors,
                name: name
            });
            _formState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState, updatedFormState);
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $18522b4fc47f45cb$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name);
            error ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $18522b4fc47f45cb$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const _ref in fields){
            let name = _ref;
            const field = fields[name];
            if (field) {
                const { _f: _f } = field, fieldValue = (0, $8901fc92b5563702$export$71511d61b312f219)(field, [
                    "_f"
                ]);
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $18522b4fc47f45cb$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $18522b4fc47f45cb$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($18522b4fc47f45cb$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $18522b4fc47f45cb$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $18522b4fc47f45cb$var$unset(_formState.errors, _f.name));
                }
                !$18522b4fc47f45cb$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$18522b4fc47f45cb$var$live(ref)) : !$18522b4fc47f45cb$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, data), !$18522b4fc47f45cb$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$18522b4fc47f45cb$var$generateWatchOutput(names, _names, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _state.mount ? _formValues : $18522b4fc47f45cb$var$isUndefined(defaultValue) ? _defaultValues : $18522b4fc47f45cb$var$isString(names) ? {
            [names]: defaultValue
        } : defaultValue), isGlobal, defaultValue);
    const _getFieldArray = (name)=>$18522b4fc47f45cb$var$compact($18522b4fc47f45cb$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, $18522b4fc47f45cb$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $18522b4fc47f45cb$var$isHTMLElement(fieldReference.ref) && $18522b4fc47f45cb$var$isNullOrUndefined(value1) ? '' : value1;
                if ($18522b4fc47f45cb$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($18522b4fc47f45cb$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($18522b4fc47f45cb$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $18522b4fc47f45cb$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $18522b4fc47f45cb$var$isObject(fieldValue) || field && !field._f) && !$18522b4fc47f45cb$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $18522b4fc47f45cb$var$cloneObject(value1);
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $18522b4fc47f45cb$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$18522b4fc47f45cb$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $18522b4fc47f45cb$var$isWatched(name, _names) && _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState));
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $18522b4fc47f45cb$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $18522b4fc47f45cb$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $18522b4fc47f45cb$var$deepEqual(fieldValue, $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $18522b4fc47f45cb$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $18522b4fc47f45cb$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $18522b4fc47f45cb$var$getFieldValue(field._f) : $18522b4fc47f45cb$var$getEventValue(event);
            const isBlurEvent = event.type === $18522b4fc47f45cb$var$EVENTS.BLUR || event.type === $18522b4fc47f45cb$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$18522b4fc47f45cb$var$hasValidation(field._f) && !_options.resolver && !$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $18522b4fc47f45cb$var$skipValidation(isBlurEvent, $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $18522b4fc47f45cb$var$isWatched(name, _names, isBlurEvent);
            $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$18522b4fc47f45cb$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $18522b4fc47f45cb$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    name: name
                }, watched ? {} : fieldState));
            }
            !isBlurEvent && watched && _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState));
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $18522b4fc47f45cb$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $18522b4fc47f45cb$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $18522b4fc47f45cb$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $18522b4fc47f45cb$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $18522b4fc47f45cb$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($18522b4fc47f45cb$var$isUndefined(name) ? name : fieldNames);
            isValid = $18522b4fc47f45cb$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, !$18522b4fc47f45cb$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
            name: name
        }, _options.resolver || !name ? {
            isValid: isValid
        } : {}), {
            errors: _formState.errors
        }));
        options.shouldFocus && !validationResult && $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _state.mount ? _formValues : _defaultValues);
        return $18522b4fc47f45cb$var$isUndefined(fieldNames) ? values : $18522b4fc47f45cb$var$isString(fieldNames) ? $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$18522b4fc47f45cb$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$18522b4fc47f45cb$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$18522b4fc47f45cb$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $18522b4fc47f45cb$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$18522b4fc47f45cb$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $18522b4fc47f45cb$var$convertToArrayPayload(name).forEach((inputName)=>$18522b4fc47f45cb$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type } = currentError, restOfErrorTree = (0, $8901fc92b5563702$export$71511d61b312f219)(currentError, [
            "ref",
            "message",
            "type"
        ]);
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restOfErrorTree, error), {
            ref: ref
        }));
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$18522b4fc47f45cb$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($18522b4fc47f45cb$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $18522b4fc47f45cb$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    values: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formValues)
                }, _formState, formState));
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _proxySubscribeFormState, props.formState);
        return _subscribe((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            formState: _proxySubscribeFormState
        }));
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $18522b4fc47f45cb$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $18522b4fc47f45cb$var$unset(_fields, fieldName);
                $18522b4fc47f45cb$var$unset(_formValues, fieldName);
            }
            !options.keepError && $18522b4fc47f45cb$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $18522b4fc47f45cb$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $18522b4fc47f45cb$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $18522b4fc47f45cb$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $18522b4fc47f45cb$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $18522b4fc47f45cb$var$cloneObject(_formValues)
        });
        _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState, !options.keepDirty ? {} : {
            isDirty: _getDirty()
        }));
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($18522b4fc47f45cb$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $18522b4fc47f45cb$var$isBoolean(options.disabled) || $18522b4fc47f45cb$var$isBoolean(_options.disabled);
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field || {}), {
            _f: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field && field._f ? field._f : {
                ref: {
                    name: name
                }
            }), {
                name: name,
                mount: true
            }), options)
        }));
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $18522b4fc47f45cb$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, disabledIsDefined ? {
            disabled: options.disabled || _options.disabled
        } : {}, _options.progressive ? {
            required: !!options.required,
            min: $18522b4fc47f45cb$var$getRuleValue(options.min),
            max: $18522b4fc47f45cb$var$getRuleValue(options.max),
            minLength: $18522b4fc47f45cb$var$getRuleValue(options.minLength),
            maxLength: $18522b4fc47f45cb$var$getRuleValue(options.maxLength),
            pattern: $18522b4fc47f45cb$var$getRuleValue(options.pattern)
        } : {}), {
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $18522b4fc47f45cb$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $18522b4fc47f45cb$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field._f, radioOrCheckbox ? {
                            refs: [
                                ...refs.filter($18522b4fc47f45cb$var$live),
                                fieldRef,
                                ...Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                    {}
                                ] : []
                            ],
                            ref: {
                                type: fieldRef.type,
                                name: name
                            }
                        } : {
                            ref: fieldRef
                        })
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($18522b4fc47f45cb$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        });
    };
    const _focusError = ()=>_options.shouldFocusError && $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($18522b4fc47f45cb$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $18522b4fc47f45cb$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$18522b4fc47f45cb$export$adaa4cf7ef1b65be(fieldValues, name, undefined);
            $18522b4fc47f45cb$var$unset(_formState.errors, 'root');
            if ($18522b4fc47f45cb$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState.errors), e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $18522b4fc47f45cb$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name)) {
            if ($18522b4fc47f45cb$var$isUndefined(options.defaultValue)) setValue(name, $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_defaultValues, name, $18522b4fc47f45cb$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $18522b4fc47f45cb$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $18522b4fc47f45cb$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $18522b4fc47f45cb$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState));
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $18522b4fc47f45cb$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $18522b4fc47f45cb$var$cloneObject(updatedValues);
        const isEmptyResetValues = $18522b4fc47f45cb$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(values, fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($18522b4fc47f45cb$var$isWeb && $18522b4fc47f45cb$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($18522b4fc47f45cb$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                for (const fieldName of _names.mount)setValue(fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldName));
            }
            _formValues = $18522b4fc47f45cb$var$cloneObject(values);
            _subjects.array.next({
                values: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, values)
            });
            _subjects.state.next({
                values: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, values)
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$18522b4fc47f45cb$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($18522b4fc47f45cb$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $18522b4fc47f45cb$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState, updatedFormState);
    };
    const _resetDefaultValues = ()=>$18522b4fc47f45cb$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _options, value);
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, methods), {
        formControl: methods
    });
}
var $18522b4fc47f45cb$var$generateId = ()=>{
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $18522b4fc47f45cb$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $18522b4fc47f45cb$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$18522b4fc47f45cb$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $18522b4fc47f45cb$var$appendAt = (data, value1)=>[
        ...data,
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1)
    ];
var $18522b4fc47f45cb$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $18522b4fc47f45cb$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $18522b4fc47f45cb$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($18522b4fc47f45cb$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $18522b4fc47f45cb$var$prependAt = (data, value1)=>[
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1),
        ...$18522b4fc47f45cb$var$convertToArrayPayload(data)
    ];
function $18522b4fc47f45cb$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $18522b4fc47f45cb$var$compact(temp).length ? temp : [];
}
var $18522b4fc47f45cb$var$removeArrayAt = (data, index)=>$18522b4fc47f45cb$var$isUndefined(index) ? [] : $18522b4fc47f45cb$var$removeAtIndexes(data, $18522b4fc47f45cb$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $18522b4fc47f45cb$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $18522b4fc47f45cb$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$310131896651d559(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(control._getFieldArray(name).map($18522b4fc47f45cb$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    rules && control.register(name, rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === _name.current || !fieldArrayName) {
                    const fieldValues = $18522b4fc47f45cb$export$3988ae62b71be9a3(values, _name.current);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($18522b4fc47f45cb$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $18522b4fc47f45cb$var$appendAt(ids.current, appendValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$appendAt, {
            argA: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, 0, options);
        ids.current = $18522b4fc47f45cb$var$prependAt(ids.current, prependValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$prependAt, {
            argA: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $18522b4fc47f45cb$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name)) && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, index, options);
        ids.current = $18522b4fc47f45cb$var$insert(ids.current, index, insertValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$insert, {
            argA: index,
            argB: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $18522b4fc47f45cb$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $18522b4fc47f45cb$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $18522b4fc47f45cb$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $18522b4fc47f45cb$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $18522b4fc47f45cb$var$cloneObject(value1);
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $18522b4fc47f45cb$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($18522b4fc47f45cb$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        control._state.action = false;
        $18522b4fc47f45cb$var$isWatched(name, control._names) && control._subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState));
        if (_actioned.current && (!$18522b4fc47f45cb$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$18522b4fc47f45cb$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $18522b4fc47f45cb$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($18522b4fc47f45cb$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $18522b4fc47f45cb$var$getValidationModes(control._options.mode).isOnSubmit)) $18522b4fc47f45cb$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $18522b4fc47f45cb$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$18522b4fc47f45cb$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $18522b4fc47f45cb$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $18522b4fc47f45cb$var$cloneObject(control._formValues)
        });
        control._names.focus && $18522b4fc47f45cb$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        !$18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>fields.map((field, index)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field), {
                    [keyName]: ids.current[index] || $18522b4fc47f45cb$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $18522b4fc47f45cb$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $18522b4fc47f45cb$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        _formControl.current = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.formControl ? props.formControl : $18522b4fc47f45cb$export$1361f5e0e4cca3c3(props)), {
            formState: formState
        });
        if (props.formControl && props.defaultValues && !$18522b4fc47f45cb$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
    }
    const control = _formControl.current.control;
    control._options = props;
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState)),
            reRenderRoot: true
        });
        updateFormState((data)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data), {
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (props.values && !$18522b4fc47f45cb$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState));
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $18522b4fc47f45cb$var$getProxyFormState(formState, control);
    return _formControl.current;
}


const $8ec1ebd703e704fc$export$8e08daf317aa0a7c = /^[+-]?\d*\.?\d+(?:[Ee][+-]?\d+)?$/;



const $b0a8143a20319458$var$ObjectiveKPIForm = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                name: "name",
                defaultValue: "",
                rules: {
                    required: {
                        value: true,
                        message: 'required'
                    }
                },
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                        label: t('objective.kpi.fields.name'),
                        value: value,
                        onChange: onChange,
                        margin: "dense",
                        fullWidth: true,
                        error: !!error,
                        helperText: (error === null || error === void 0 ? void 0 : error.message) && t(`form.errors.${error.message}`)
                    })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    margin: '16px 0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    gridGap: 16
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: "goalValue",
                        defaultValue: "",
                        rules: {
                            required: {
                                value: true,
                                message: 'required'
                            },
                            pattern: {
                                value: (0, $8ec1ebd703e704fc$export$8e08daf317aa0a7c),
                                message: 'notNumber'
                            },
                            min: {
                                value: 0,
                                message: 'isNegative'
                            }
                        },
                        render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                                label: t('objective.kpi.fields.goalValue'),
                                value: value,
                                onChange: onChange,
                                margin: "dense",
                                fullWidth: true,
                                error: !!error,
                                helperText: (error === null || error === void 0 ? void 0 : error.message) && t(`form.errors.${error.message}`)
                            })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: "unit",
                        defaultValue: "",
                        rules: {
                            required: {
                                value: true,
                                message: 'required'
                            }
                        },
                        render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                                label: t('objective.kpi.fields.unit'),
                                value: value,
                                onChange: onChange,
                                margin: "dense",
                                fullWidth: true,
                                error: !!error,
                                helperText: (error === null || error === void 0 ? void 0 : error.message) && t(`form.errors.${error.message}`)
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                name: "deadline",
                rules: {
                    required: {
                        value: true,
                        message: 'required'
                    }
                },
                defaultValue: new Date(),
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $745a23e9bec21737$export$d8c44f501031ee7c), {
                        value: value,
                        onChange: (date)=>onChange(date),
                        minDate: new Date(),
                        format: "yyyy/MM/dd",
                        autoOk: true,
                        disableToolbar: true,
                        label: t('objective.kpi.fields.deadline'),
                        variant: "inline",
                        margin: "dense",
                        fullWidth: true,
                        error: !!error,
                        helperText: (error === null || error === void 0 ? void 0 : error.message) && t(`form.errors.${error.message}`)
                    })
            })
        ]
    });
};
var $b0a8143a20319458$export$2e2bcd8739ae039 = $b0a8143a20319458$var$ObjectiveKPIForm;




const $059ee1df6ddff704$var$CreateKPI = ({ objective: objective, onSubmitSuccess: onSubmitSuccess })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const form = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)();
    const createMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (values)=>{
        await (0, $cf0e40a933e30d20$export$901ebd53317a9d7a)({
            kpi: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                objectiveId: objective.id
            }, values),
            objectiveId: objective.id,
            ownerId: objective.owner[0].id,
            ownerType: objective.owner[0].type
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
            setOpen(false);
            form.reset();
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $18522b4fc47f45cb$export$8ce1ff4f94d08846), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, form), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                onClick: ()=>setOpen(true),
                variant: "contained",
                color: "secondary",
                style: {
                    marginTop: 16
                },
                children: t('objective.kpi.actions.create')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                PaperProps: {
                    component: 'form',
                    onSubmit: form.handleSubmit(createMutation.mutate)
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                        children: t('objective.kpi.title.create')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0a8143a20319458$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                                type: "submit",
                                color: "primary",
                                variant: "contained",
                                children: t('objective.dialog.save')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                                onClick: ()=>setOpen(false),
                                color: "primary",
                                children: t('objective.dialog.cancel')
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var $059ee1df6ddff704$export$2e2bcd8739ae039 = $059ee1df6ddff704$var$CreateKPI;




var $7fPBF = parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $iRcsz = parcelRequire("iRcsz");
var $hzQpW = parcelRequire("hzQpW");
var $1rW9t = parcelRequire("1rW9t");


var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $8dd10bcd03d52584$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), 'AddCircle');


var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $33ce0734640685aa$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');


var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $1c87356a25ad1ad4$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Edit');


var $a0a03b09113b2fa7$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($a0a03b09113b2fa7$exports, "__esModule", {
    value: true
});
$a0a03b09113b2fa7$exports.default = void 0;

var $a0a03b09113b2fa7$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $a0a03b09113b2fa7$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $a0a03b09113b2fa7$var$_default = (0, $a0a03b09113b2fa7$var$_createSvgIcon.default)(/*#__PURE__*/ $a0a03b09113b2fa7$var$React.createElement("path", {
    d: "M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
}), 'ArrowDownwardRounded');
$a0a03b09113b2fa7$exports.default = $a0a03b09113b2fa7$var$_default;






parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");


const $b75cb0025df7de8f$export$78980d96c3373c37 = ({ objectiveId: objectiveId, kpiId: kpiId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objectives/${objectiveId}/kpis/${kpiId}/kpientries`);
const $b75cb0025df7de8f$export$400dde64ed88158c = ({ kpiEntry: kpiEntry, objectiveId: objectiveId, kpiId: kpiId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(`/objectives/${objectiveId}/kpis/${kpiId}/kpientries`, {
        kpiEntry: kpiEntry
    });
const $b75cb0025df7de8f$export$6af7839205ee9bba = ({ kpiEntry: kpiEntry, objectiveId: objectiveId, kpiId: kpiId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`/objectives/${objectiveId}/kpis/${kpiId}/kpientries`, {
        kpiEntry: kpiEntry
    });
const $b75cb0025df7de8f$export$c6142cfe0242952e = ({ entryId: entryId, kpiId: kpiId, objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).delete(`/objectives/${objectiveId}/kpis/${kpiId}/kpientries/${entryId}`);





var $MQfsM = parcelRequire("MQfsM");
parcelRequire("7fPBF");



const $8326d45af7eebc97$var$KPIEntryForm = ({ kpi: kpi })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                name: "value",
                defaultValue: "",
                rules: {
                    required: {
                        value: true,
                        message: 'required'
                    },
                    pattern: {
                        value: (0, $8ec1ebd703e704fc$export$8e08daf317aa0a7c),
                        message: 'notNumber'
                    },
                    min: {
                        value: 0,
                        message: 'isNegative'
                    }
                },
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                        label: `${t('objective.kpi.entry.fields.value')} (${kpi.unit})`,
                        value: value,
                        onChange: onChange,
                        margin: "dense",
                        fullWidth: true,
                        error: !!error,
                        helperText: (error === null || error === void 0 ? void 0 : error.message) && t(`form.errors.${error.message}`)
                    })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                name: "comment",
                defaultValue: "",
                render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                        label: t('objective.kpi.entry.fields.comment'),
                        value: value,
                        onChange: onChange,
                        margin: "dense",
                        fullWidth: true
                    })
            })
        ]
    });
};
var $8326d45af7eebc97$export$2e2bcd8739ae039 = $8326d45af7eebc97$var$KPIEntryForm;





const $50d86b0d35311d1c$var$UpdateKPIEntry = ({ kpi: kpi, kpiEntry: kpiEntry, objective: objective, onSubmitSuccess: onSubmitSuccess, onCancel: onCancel })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const form = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        defaultValues: kpiEntry
    });
    const updateMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (values)=>{
        await (0, $b75cb0025df7de8f$export$6af7839205ee9bba)({
            kpiEntry: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, kpiEntry), {
                objectiveKPIEntryId: kpiEntry.objective_kpi_entry_id
            }), values),
            kpiId: kpi.objectiveKPIId,
            objectiveId: objective.id,
            ownerId: objective.owner[0].id,
            ownerType: objective.owner[0].type
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$8ce1ff4f94d08846), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, form), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
            onSubmit: form.handleSubmit(updateMutation.mutate),
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8326d45af7eebc97$export$2e2bcd8739ae039), {
                    kpi: kpi
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            type: "submit",
                            color: "primary",
                            variant: "contained",
                            children: t('objective.dialog.save')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: onCancel,
                            color: "primary",
                            children: t('objective.dialog.cancel')
                        })
                    ]
                })
            ]
        })
    }));
};
var $50d86b0d35311d1c$export$2e2bcd8739ae039 = $50d86b0d35311d1c$var$UpdateKPIEntry;





parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");







const $b2f0c7c7112953f7$var$CreateKPIEntry = ({ kpi: kpi, objective: objective, onSubmitSuccess: onSubmitSuccess, onCancel: onCancel })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const form = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)();
    const createMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (values)=>{
        await (0, $b75cb0025df7de8f$export$400dde64ed88158c)({
            kpiEntry: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                objectiveKPIId: kpi.objectiveKPIId
            }, values),
            kpiId: kpi.objectiveKPIId,
            objectiveId: objective.id,
            ownerId: objective.owner[0].id,
            ownerType: objective.owner[0].type
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$8ce1ff4f94d08846), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, form), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
            onSubmit: form.handleSubmit(createMutation.mutate),
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8326d45af7eebc97$export$2e2bcd8739ae039), {
                    kpi: kpi
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            type: "submit",
                            color: "primary",
                            variant: "contained",
                            children: t('objective.dialog.save')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: onCancel,
                            color: "primary",
                            children: t('objective.dialog.cancel')
                        })
                    ]
                })
            ]
        })
    }));
};
var $b2f0c7c7112953f7$export$2e2bcd8739ae039 = $b2f0c7c7112953f7$var$CreateKPIEntry;





parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");





const $ccbe778b237c5c26$var$UpdateKPI = ({ kpi: kpi, objective: objective, onSubmitSuccess: onSubmitSuccess, onCancel: onCancel })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const form = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        defaultValues: kpi
    });
    const updateMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (values)=>{
        await (0, $cf0e40a933e30d20$export$1fc50355bb00e113)({
            kpi: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, kpi), {
                objectiveId: objective.id
            }), values),
            objectiveId: objective.id,
            ownerId: objective.owner[0].id,
            ownerType: objective.owner[0].type
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$8ce1ff4f94d08846), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, form), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
            onSubmit: form.handleSubmit(updateMutation.mutate),
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0a8143a20319458$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            type: "submit",
                            color: "primary",
                            variant: "contained",
                            children: t('objective.dialog.save')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: onCancel,
                            color: "primary",
                            children: t('objective.dialog.cancel')
                        })
                    ]
                })
            ]
        })
    }));
};
var $ccbe778b237c5c26$export$2e2bcd8739ae039 = $ccbe778b237c5c26$var$UpdateKPI;



parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $1rW9t = parcelRequire("1rW9t");



const $66b086fdadbdbc63$var$DeleteKPI = ({ kpi: kpi, objective: objective, onSubmitSuccess: onSubmitSuccess, onCancel: onCancel })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const deleteMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        await (0, $cf0e40a933e30d20$export$fd68e9e14a0b2c8a)({
            kpiId: kpi.objectiveKPIId,
            objectiveId: objective.id,
            ownerId: objective.owner[0].id,
            ownerType: objective.owner[0].type
        });
    }, {
        onSuccess: onSubmitSuccess
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                children: t('objective.kpi.deleteConfirmation')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                    children: kpi.name
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                style: {
                    marginTop: 8
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: deleteMutation.mutate,
                        color: "primary",
                        variant: "contained",
                        children: t('objective.dialog.save')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: onCancel,
                        color: "primary",
                        children: t('objective.dialog.cancel')
                    })
                ]
            })
        ]
    });
};
var $66b086fdadbdbc63$export$2e2bcd8739ae039 = $66b086fdadbdbc63$var$DeleteKPI;



parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $1rW9t = parcelRequire("1rW9t");



const $6bdd0d5ab75d10a1$var$DeleteKPIEntry = ({ kpi: kpi, kpiEntry: kpiEntry, objective: objective, onSubmitSuccess: onSubmitSuccess, onCancel: onCancel })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const deleteMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        await (0, $b75cb0025df7de8f$export$c6142cfe0242952e)({
            kpiId: kpi.objectiveKPIId,
            entryId: kpiEntry.objective_kpi_entry_id,
            objectiveId: objective.id,
            ownerId: objective.owner[0].id,
            ownerType: objective.owner[0].type
        });
    }, {
        onSuccess: onSubmitSuccess
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                children: t('objective.kpi.entryDeleteConfirmation')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1rW9t.default), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                        children: kpi.name
                    }),
                    " ",
                    kpiEntry === null || kpiEntry === void 0 ? void 0 : kpiEntry.value,
                    " ",
                    kpi.unit
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                style: {
                    marginTop: 8
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: deleteMutation.mutate,
                        color: "primary",
                        variant: "contained",
                        children: t('objective.dialog.save')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: onCancel,
                        color: "primary",
                        children: t('objective.dialog.cancel')
                    })
                ]
            })
        ]
    });
};
var $6bdd0d5ab75d10a1$export$2e2bcd8739ae039 = $6bdd0d5ab75d10a1$var$DeleteKPIEntry;




var $7fPBF = parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $cuouK = parcelRequire("cuouK");
var $1rW9t = parcelRequire("1rW9t");

var $lfiYO = parcelRequire("lfiYO");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $2jEfe = parcelRequire("2jEfe");
var $3Sc7z = parcelRequire("3Sc7z");

var $gd1Bg = parcelRequire("gd1Bg");

var $dKzJP = parcelRequire("dKzJP");
var $06176b7c8ef7e78a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kY3Ke.default)({}, theme.typography.button, {
            boxSizing: 'border-box',
            borderRadius: theme.shape.borderRadius,
            padding: 11,
            border: "1px solid ".concat((0, $2jEfe.alpha)(theme.palette.action.active, 0.12)),
            color: (0, $2jEfe.alpha)(theme.palette.action.active, 0.38),
            '&$selected': {
                color: theme.palette.action.active,
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.action.active, 0.12),
                '&:hover': {
                    backgroundColor: (0, $2jEfe.alpha)(theme.palette.action.active, 0.15)
                },
                '& + &': {
                    borderLeft: 0,
                    marginLeft: 0
                }
            },
            '&$disabled': {
                color: (0, $2jEfe.alpha)(theme.palette.action.disabled, 0.12)
            },
            '&:hover': {
                textDecoration: 'none',
                // Reset on mouse devices
                backgroundColor: (0, $2jEfe.alpha)(theme.palette.text.primary, 0.05),
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                },
                '&$disabled': {
                    backgroundColor: 'transparent'
                }
            }
        }),
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the `label` wrapper element. */ label: {
            width: '100%',
            // Ensure the correct width for iOS Safari
            display: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 7,
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {
            padding: 15,
            fontSize: theme.typography.pxToRem(15)
        }
    };
};
var $06176b7c8ef7e78a$var$ToggleButton = /*#__PURE__*/ $7fPBF.forwardRef(function ToggleButton(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, onChange = props.onChange, onClick = props.onClick, selected = props.selected, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, value = props.value, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "disabled",
        "disableFocusRipple",
        "onChange",
        "onClick",
        "selected",
        "size",
        "value"
    ]);
    var handleChange = function handleChange(event) {
        if (onClick) {
            onClick(event, value);
            if (event.isDefaultPrevented()) return;
        }
        if (onChange) onChange(event, value);
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $gd1Bg.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, disabled && classes.disabled, selected && classes.selected, size !== 'medium' && classes["size".concat((0, $dKzJP.default)(size))]),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        "aria-pressed": selected
    }, other), /*#__PURE__*/ $7fPBF.createElement("span", {
        className: classes.label
    }, children));
});
var $06176b7c8ef7e78a$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($06176b7c8ef7e78a$export$9dd6ff9ea0189349, {
    name: 'MuiToggleButton'
})($06176b7c8ef7e78a$var$ToggleButton);


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $jtRae = parcelRequire("jtRae");
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $dd482353c524097d$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}



var $3Sc7z = parcelRequire("3Sc7z");

var $dKzJP = parcelRequire("dKzJP");
var $c0bb7d62132be7c8$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            flexDirection: 'column'
        },
        /* Styles applied to the children. */ grouped: {},
        /* Styles applied to the children if `orientation="horizontal"`. */ groupedHorizontal: {
            '&:not(:first-child)': {
                marginLeft: -1,
                borderLeft: '1px solid transparent',
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
            },
            '&:not(:last-child)': {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
            }
        },
        /* Styles applied to the children if `orientation="vertical"`. */ groupedVertical: {
            '&:not(:first-child)': {
                marginTop: -1,
                borderTop: '1px solid transparent',
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0
            },
            '&:not(:last-child)': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }
        }
    };
};
var $c0bb7d62132be7c8$var$ToggleButtonGroup = /*#__PURE__*/ $7fPBF.forwardRef(function ToggleButton(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$exclusive = props.exclusive, exclusive = _props$exclusive === void 0 ? false : _props$exclusive, onChange = props.onChange, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, value = props.value, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "exclusive",
        "onChange",
        "orientation",
        "size",
        "value"
    ]);
    var handleChange = function handleChange(event, buttonValue) {
        if (!onChange) return;
        var index = value && value.indexOf(buttonValue);
        var newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    };
    var handleExclusiveChange = function handleExclusiveChange(event, buttonValue) {
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    };
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        role: "group",
        className: (0, $jtRae.default)(classes.root, className, orientation === 'vertical' && classes.vertical),
        ref: ref
    }, other), $7fPBF.Children.map(children, function(child) {
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            className: (0, $jtRae.default)(classes.grouped, classes["grouped".concat((0, $dKzJP.default)(orientation))], child.props.className),
            onChange: exclusive ? handleExclusiveChange : handleChange,
            selected: child.props.selected === undefined ? (0, $dd482353c524097d$export$2e2bcd8739ae039)(child.props.value, value) : child.props.selected,
            size: child.props.size || size
        });
    }));
});
var $c0bb7d62132be7c8$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($c0bb7d62132be7c8$export$9dd6ff9ea0189349, {
    name: 'MuiToggleButtonGroup'
})($c0bb7d62132be7c8$var$ToggleButtonGroup);





parcelRequire("7fPBF");

parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");

var $eBahF = parcelRequire("eBahF");


const $1e109de0513c0ef5$var$KPI = 'kpi';
const $1e109de0513c0ef5$var$useStyles = (0, $by0pu.default)({
    root: {
        marginBottom: '20px'
    },
    basicInfo: {
        margin: '15px 0'
    },
    title: {
        margin: ' auto 8px'
    },
    grid: {
        maxWidth: '762px',
        '& .MuiDataGrid-cell': {
            padding: '0  0 0 10px'
        }
    }
});
const $1e109de0513c0ef5$var$LogItem = ({ event: event, handleOpen: handleOpen = ()=>{} })=>{
    const { itemType: itemType, actualItem: actualItem = {}, previousItem: previousItem = {}, when: when, what: what, who: { name: actorName } } = event;
    const classes = $1e109de0513c0ef5$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { PROPERTIES: { LOCKED_EVALUATION: LOCKED_EVALUATION }, ACTIONS: { DELETE: DELETE } } = (0, $f6e729db3f817bb5$exports.EVENT_LOG);
    const columns = [
        {
            field: 'id',
            hide: true
        },
        {
            field: 'propertyName',
            headerName: ' ',
            width: 240,
            sortable: false
        },
        {
            field: 'previousValue',
            headerName: t(`objective.eventlog.before`),
            width: 260
        },
        {
            field: 'actualValue',
            headerName: t('objective.eventlog.after'),
            width: 260
        }
    ];
    const properties = Object.keys(actualItem);
    const changes = properties.filter((property)=>JSON.stringify(actualItem[property]) !== JSON.stringify(previousItem[property])).map((property, index)=>({
            id: index,
            propertyName: t(`${itemType}.eventlog.${property}`),
            previousValue: property === LOCKED_EVALUATION ? t(`objective.eventlog.${property}_${previousItem[property]}`) : previousItem[property],
            actualValue: property === LOCKED_EVALUATION ? t(`objective.eventlog.${property}_${actualItem[property]}`) : actualItem[property]
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                className: classes.basicInfo,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: classes.title,
                        children: actorName
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                        orientation: "vertical",
                        flexItem: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: classes.title,
                        children: when
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                        orientation: "vertical",
                        flexItem: true
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: classes.title,
                        children: t(`${itemType}.event.${what}`)
                    }),
                    itemType === $1e109de0513c0ef5$var$KPI && what === DELETE && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        variant: "outlined",
                        color: "primary",
                        onClick: handleOpen,
                        children: t('objective.eventlog.open.entries')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eBahF.DataGrid), {
                rows: changes,
                columns: columns,
                checkboxSelection: false,
                disableSelectionOnClick: true,
                headerHeight: 42,
                rowHeight: 42,
                autoHeight: true,
                hideFooter: true,
                disableColumnMenu: true,
                className: classes.grid
            })
        ]
    });
};
var $1e109de0513c0ef5$export$2e2bcd8739ae039 = $1e109de0513c0ef5$var$LogItem;


const $bcd5869e13626df6$var$KpiLogItem = ({ event: event, handleOpen: handleOpen })=>{
    const details = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        itemType: 'kpi',
        actualItem: event === null || event === void 0 ? void 0 : event.kpi,
        previousItem: event === null || event === void 0 ? void 0 : event.oldKpi
    }, event);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e109de0513c0ef5$export$2e2bcd8739ae039), {
        event: details,
        handleOpen: handleOpen
    });
};
var $bcd5869e13626df6$export$2e2bcd8739ae039 = $bcd5869e13626df6$var$KpiLogItem;




parcelRequire("7fPBF");

const $efa69e9c91b693e2$var$KpiEntryLogItem = ({ event: event })=>{
    const details = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        itemType: 'kpiEntry',
        actualItem: event === null || event === void 0 ? void 0 : event.kpiEntry,
        previousItem: event === null || event === void 0 ? void 0 : event.oldKpiEntry
    }, event);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e109de0513c0ef5$export$2e2bcd8739ae039), {
        event: details
    });
};
var $efa69e9c91b693e2$export$2e2bcd8739ae039 = $efa69e9c91b693e2$var$KpiEntryLogItem;



parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $9SdKL = parcelRequire("9SdKL");
var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");
const $36b809d1f393b765$var$useStyles = (0, $by0pu.default)({
    loadMore: {
        marginBottom: '20px'
    }
});
const $36b809d1f393b765$var$LoadMoreButton = ({ loading: loading, canLoadMore: canLoadMore, loadMore: loadMore, loadMoreTranslation: loadMoreTranslation, noMoreToLoadTranslation: noMoreToLoadTranslation })=>{
    const classes = $36b809d1f393b765$var$useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d57f8c5132119daf$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "center",
        children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9SdKL.default), {}) : canLoadMore ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
            onClick: loadMore,
            variant: "contained",
            color: "secondary",
            className: classes.loadMore,
            children: loadMoreTranslation
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
            variant: "h6",
            component: "h3",
            className: classes.loadMore,
            children: noMoreToLoadTranslation
        })
    });
};
var $36b809d1f393b765$export$2e2bcd8739ae039 = $36b809d1f393b765$var$LoadMoreButton;








function $316c4b5385bc3f70$export$2e2bcd8739ae039({ objective: objective, kpi: kpi, subjectType: subjectType }) {
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [objectiveOwner] = objective === null || objective === void 0 ? void 0 : objective.owner;
    return (0, $2bc6258289aa5150$export$bdc59d3c1a6569aa)([
        'objectiveKpiLogs',
        objectiveOwner === null || objectiveOwner === void 0 ? void 0 : objectiveOwner.id,
        objective === null || objective === void 0 ? void 0 : objective.id,
        kpi === null || kpi === void 0 ? void 0 : kpi.objective_kpi_id,
        subjectType
    ], async ({ pageParam: pageParam = 1 })=>{
        const { data: data } = await (0, $553835ea16648c6f$export$36ce47d8e1207878)({
            ownerId: objectiveOwner.id,
            ownerType: objectiveOwner.type,
            objectiveId: objective.id,
            kpiId: kpi.objective_kpi_id,
            createdAt: objective.created_at,
            subjectType: subjectType,
            pageNumber: pageParam
        });
        return data;
    }, {
        getNextPageParam: (lastPage, pages)=>(lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) % (0, $f6e729db3f817bb5$exports.EVENT_LOG_LIMIT) === 0 ? pages.flat().length / (0, $f6e729db3f817bb5$exports.EVENT_LOG_LIMIT) + 1 : undefined,
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
}


const $577cf5e51bc66d13$var$KpiEventLog = ({ onCancel: onCancel, objective: objective, kpi: kpi })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { KPIS: KPIS, KPI_ENTRIES: KPI_ENTRIES } = (0, $f6e729db3f817bb5$exports.EVENT_LOG);
    const [subjectType, setSubjectType] = (0, $7fPBF.useState)(KPIS);
    const { data: data, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isLoading: isLoading, isFetching: isFetching, refetch: refetch } = (0, $316c4b5385bc3f70$export$2e2bcd8739ae039)({
        objective: objective,
        kpi: kpi,
        subjectType: subjectType
    });
    const handleSelectResource = (event, type)=>{
        if (!type) return;
        setSubjectType(type);
        refetch();
    };
    var _data_pages_flat;
    const kpiEventLogs = (_data_pages_flat = data === null || data === void 0 ? void 0 : data.pages.flat()) !== null && _data_pages_flat !== void 0 ? _data_pages_flat : [];
    const renderEventLogs = ()=>{
        switch(subjectType){
            case KPIS:
                return kpiEventLogs.map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bcd5869e13626df6$export$2e2bcd8739ae039), {
                        event: event
                    }, index));
            case KPI_ENTRIES:
                return kpiEventLogs.map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efa69e9c91b693e2$export$2e2bcd8739ae039), {
                        event: event
                    }, index));
            default:
                return kpiEventLogs.map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bcd5869e13626df6$export$2e2bcd8739ae039), {
                        event: event
                    }, index));
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                children: t('objective.button.tab.eventLog')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cuouK.default), {
                component: "fieldset",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c0bb7d62132be7c8$export$2e2bcd8739ae039), {
                    value: subjectType,
                    exclusive: true,
                    onChange: handleSelectResource,
                    "aria-label": "text alignment",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06176b7c8ef7e78a$export$2e2bcd8739ae039), {
                            value: KPIS,
                            children: t('objective.eventlog.type.kpi')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06176b7c8ef7e78a$export$2e2bcd8739ae039), {
                            value: KPI_ENTRIES,
                            children: t('objective.eventlog.type.kpi_entry')
                        })
                    ]
                })
            }),
            renderEventLogs(),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $36b809d1f393b765$export$2e2bcd8739ae039), {
                    loading: isFetching || isLoading,
                    canLoadMore: hasNextPage,
                    loadMore: fetchNextPage,
                    loadMoreTranslation: t('objective.eventlog.loadMoreBtn'),
                    noMoreToLoadTranslation: t('objective.eventlog.NoMoreEvents')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                style: {
                    marginTop: 8
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: onCancel,
                    color: "primary",
                    children: t('objective.dialog.cancel')
                })
            })
        ]
    });
};
var $577cf5e51bc66d13$export$2e2bcd8739ae039 = $577cf5e51bc66d13$var$KpiEventLog;




parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $dKzJP = parcelRequire("dKzJP");

var $3Sc7z = parcelRequire("3Sc7z");

var $2jEfe = parcelRequire("2jEfe");

var $fH0xA = parcelRequire("fH0xA");
var $997f88ad7b0d5228$var$TRANSITION_DURATION = 4; // seconds
var $997f88ad7b0d5228$export$9dd6ff9ea0189349 = function styles(theme) {
    var getColor = function getColor(color) {
        return theme.palette.type === 'light' ? (0, $2jEfe.lighten)(color, 0.62) : (0, $2jEfe.darken)(color, 0.5);
    };
    var backgroundPrimary = getColor(theme.palette.primary.main);
    var backgroundSecondary = getColor(theme.palette.secondary.main);
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            overflow: 'hidden',
            height: 4,
            '@media print': {
                colorAdjust: 'exact'
            }
        },
        /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */ colorPrimary: {
            backgroundColor: backgroundPrimary
        },
        /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */ colorSecondary: {
            backgroundColor: backgroundSecondary
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {},
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {},
        /* Styles applied to the root element if `variant="buffer"`. */ buffer: {
            backgroundColor: 'transparent'
        },
        /* Styles applied to the root element if `variant="query"`. */ query: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the additional bar element if `variant="buffer"`. */ dashed: {
            position: 'absolute',
            marginTop: 0,
            height: '100%',
            width: '100%',
            animation: '$buffer 3s infinite linear'
        },
        /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */ dashedColorPrimary: {
            backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
            backgroundSize: '10px 10px',
            backgroundPosition: '0 -23px'
        },
        /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */ dashedColorSecondary: {
            backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
            backgroundSize: '10px 10px',
            backgroundPosition: '0 -23px'
        },
        /* Styles applied to the layered bar1 and bar2 elements. */ bar: {
            width: '100%',
            position: 'absolute',
            left: 0,
            bottom: 0,
            top: 0,
            transition: 'transform 0.2s linear',
            transformOrigin: 'left'
        },
        /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */ barColorPrimary: {
            backgroundColor: theme.palette.primary.main
        },
        /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */ barColorSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */ bar1Indeterminate: {
            width: 'auto',
            animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
        },
        /* Styles applied to the bar1 element if `variant="determinate"`. */ bar1Determinate: {
            transition: "transform .".concat($997f88ad7b0d5228$var$TRANSITION_DURATION, "s linear")
        },
        /* Styles applied to the bar1 element if `variant="buffer"`. */ bar1Buffer: {
            zIndex: 1,
            transition: "transform .".concat($997f88ad7b0d5228$var$TRANSITION_DURATION, "s linear")
        },
        /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */ bar2Indeterminate: {
            width: 'auto',
            animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
        },
        /* Styles applied to the bar2 element if `variant="buffer"`. */ bar2Buffer: {
            transition: "transform .".concat($997f88ad7b0d5228$var$TRANSITION_DURATION, "s linear")
        },
        // Legends:
        // || represents the viewport
        // -  represents a light background
        // x  represents a dark background
        '@keyframes indeterminate1': {
            //  |-----|---x-||-----||-----|
            '0%': {
                left: '-35%',
                right: '100%'
            },
            //  |-----|-----||-----||xxxx-|
            '60%': {
                left: '100%',
                right: '-90%'
            },
            '100%': {
                left: '100%',
                right: '-90%'
            }
        },
        '@keyframes indeterminate2': {
            //  |xxxxx|xxxxx||-----||-----|
            '0%': {
                left: '-200%',
                right: '100%'
            },
            //  |-----|-----||-----||-x----|
            '60%': {
                left: '107%',
                right: '-8%'
            },
            '100%': {
                left: '107%',
                right: '-8%'
            }
        },
        '@keyframes buffer': {
            '0%': {
                opacity: 1,
                backgroundPosition: '0 -23px'
            },
            '50%': {
                opacity: 0,
                backgroundPosition: '0 -23px'
            },
            '100%': {
                opacity: 1,
                backgroundPosition: '-200px -23px'
            }
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $997f88ad7b0d5228$var$LinearProgress = /*#__PURE__*/ $7fPBF.forwardRef(function LinearProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, value = props.value, valueBuffer = props.valueBuffer, _props$variant = props.variant, variant = _props$variant === void 0 ? 'indeterminate' : _props$variant, other = (0, $lfiYO.default)(props, [
        "classes",
        "className",
        "color",
        "value",
        "valueBuffer",
        "variant"
    ]);
    var theme = (0, $fH0xA.default)();
    var rootProps = {};
    var inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            var transform = value - 100;
            if (theme.direction === 'rtl') transform = -transform;
            inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            var _transform = (valueBuffer || 0) - 100;
            if (theme.direction === 'rtl') _transform = -_transform;
            inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
        }
    }
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, classes["color".concat((0, $dKzJP.default)(color))], className, {
            'determinate': classes.determinate,
            'indeterminate': classes.indeterminate,
            'buffer': classes.buffer,
            'query': classes.query
        }[variant]),
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other), variant === 'buffer' ? /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $jtRae.default)(classes.dashed, classes["dashedColor".concat((0, $dKzJP.default)(color))])
    }) : null, /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $jtRae.default)(classes.bar, classes["barColor".concat((0, $dKzJP.default)(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
            'determinate': classes.bar1Determinate,
            'buffer': classes.bar1Buffer
        }[variant]),
        style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $jtRae.default)(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [
            classes["color".concat((0, $dKzJP.default)(color))],
            classes.bar2Buffer
        ] : classes["barColor".concat((0, $dKzJP.default)(color))]),
        style: inlineStyles.bar2
    }));
});
var $997f88ad7b0d5228$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($997f88ad7b0d5228$export$9dd6ff9ea0189349, {
    name: 'MuiLinearProgress'
})($997f88ad7b0d5228$var$LinearProgress);


var $by0pu = parcelRequire("by0pu");

var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $4be2f73f5c358bbf$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), /*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'AccessTime');


const $7f096f5d3d4b7bc1$var$useStyles = (0, $by0pu.default)({
    kpiProgress: {
        textAlign: 'center'
    },
    kpiProgressLine: {
        position: 'relative'
    },
    kpiProrate: {
        color: '#666',
        position: 'absolute',
        top: -2
    },
    prorateIndicator: {
        height: 8,
        width: 2
    },
    kpiProrateInfo: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        opacity: 0.8
    },
    prorateIcon: {
        height: 16,
        width: 16
    }
}, {
    name: 'KPIProrate'
});
const $7f096f5d3d4b7bc1$var$KPIProgressIndicator = ({ progress: progress, prorate: prorate, showValue: showValue = true })=>{
    const classes = $7f096f5d3d4b7bc1$var$useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: classes.kpiProgress,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: `${progress}%`
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: classes.kpiProgressLine,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $997f88ad7b0d5228$export$2e2bcd8739ae039), {
                        variant: "determinate",
                        value: progress > 100 ? 100 : progress
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: classes.kpiProrate,
                        style: {
                            left: `${prorate}%`
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: classes.prorateIndicator,
                                style: {
                                    background: prorate > progress ? 'red' : '#666'
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: classes.kpiProrateInfo,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4be2f73f5c358bbf$export$2e2bcd8739ae039), {
                                        className: classes.prorateIcon
                                    }),
                                    showValue && `${prorate || 0}%`
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7f096f5d3d4b7bc1$export$2e2bcd8739ae039 = $7f096f5d3d4b7bc1$var$KPIProgressIndicator;




const $601dae6a01f8d1ab$var$ObjectiveKPIDetails = ({ objective: objective, kpi: kpi, progress: progress, prorate: prorate, onSubmitSuccess: onSubmitSuccess, editable: editable })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { accountInfo: accountInfo, employee: employee } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state);
    const employees = [
        ...accountInfo.possibleAppraisers,
        employee
    ];
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [state, setState] = (0, $7fPBF.useState)('details');
    const [selectedEntry, setSelectedEntry] = (0, $7fPBF.useState)(null);
    const hasEntries = !!kpi.entries.length;
    const resetState = ()=>{
        setState('details');
        setSelectedEntry(null);
    };
    const onClose = ()=>{
        setOpen(false);
        resetState();
    };
    const addKpiEntryTooltipTitle = (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE === objective.status ? t('objective.kpi.actions.entryCreate ') : t('objective.kpi.entry.error.status.create');
    const editKpiEntryTooltipTitle = (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE === objective.status ? t('objective.kpi.actions.entryUpdate') : t('objective.kpi.entry.error.status.update');
    const deleteKpiEntryTooltipTitle = (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE === objective.status ? t('objective.kpi.actions.entryDelete') : t('objective.kpi.entry.error.status.delete');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                title: t('objective.kpi.actions.details'),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                    onClick: ()=>setOpen(true),
                    color: "primary",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd10bcd03d52584$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
                open: open,
                onClose: onClose,
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                        children: t(`objective.kpi.title.${state}`)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $7e9dc35171fa81c7$export$2e2bcd8739ae039), {
                                direction: "left",
                                in: state === 'details',
                                mountOnEnter: true,
                                unmountOnExit: true,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "row",
                                        style: {
                                            marginBottom: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                container: true,
                                                item: true,
                                                xs: 8,
                                                sm: 4,
                                                alignItems: "center",
                                                children: kpi.name
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                container: true,
                                                item: true,
                                                xs: 4,
                                                sm: 2,
                                                alignItems: "center",
                                                children: [
                                                    kpi.goalValue,
                                                    " ",
                                                    kpi.unit
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                container: true,
                                                item: true,
                                                xs: 5,
                                                sm: 3,
                                                alignItems: "center",
                                                children: (0, $8bfb433bad942c35$export$3ae94a2503e890a1)(new Date(kpi.deadline))
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 5,
                                                sm: 2,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f096f5d3d4b7bc1$export$2e2bcd8739ae039), {
                                                    prorate: prorate,
                                                    progress: progress
                                                })
                                            }),
                                            editable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                container: true,
                                                item: true,
                                                xs: 2,
                                                sm: 1,
                                                justifyContent: "flex-end",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                                                    title: t('objective.kpi.actions.update'),
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                                                        onClick: ()=>setState('update'),
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c87356a25ad1ad4$export$2e2bcd8739ae039), {})
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    editable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        style: {
                                            display: 'flex',
                                            justifyContent: 'flex-end'
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                                            title: hasEntries ? t('objective.kpi.deleteRestriciton') : '',
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                                                    onClick: ()=>{
                                                        setState('delete');
                                                    },
                                                    variant: "contained",
                                                    style: hasEntries ? undefined : {
                                                        background: '#ff8a80'
                                                    },
                                                    disabled: hasEntries,
                                                    children: t('objective.action.delete')
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                                        style: {
                                            margin: '32px 0 16px',
                                            background: '#aaa'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                        style: {
                                            fontSize: 18,
                                            marginBottom: 8
                                        },
                                        children: t('objective.kpi.entries')
                                    }),
                                    kpi.entries.map((entry, index)=>{
                                        var _employees_find;
                                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                    container: true,
                                                    direction: "row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 8,
                                                            sm: 2,
                                                            children: [
                                                                entry.value,
                                                                " ",
                                                                kpi.unit
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 4,
                                                            sm: 4,
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $432444006420a8b4$export$2e2bcd8739ae039), {
                                                                children: entry.comment
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 5,
                                                            sm: 3,
                                                            children: (0, $8bfb433bad942c35$export$3ae94a2503e890a1)(new Date(entry.date))
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                            item: true,
                                                            xs: 4,
                                                            sm: 2,
                                                            children: (_employees_find = employees.find((emp)=>Number(emp.empid) === entry.employee_id)) === null || _employees_find === void 0 ? void 0 : _employees_find.name
                                                        }),
                                                        editable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                                            container: true,
                                                            item: true,
                                                            xs: 3,
                                                            sm: 1,
                                                            justifyContent: "flex-end",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                                                                    title: editKpiEntryTooltipTitle,
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                                                                            size: "small",
                                                                            onClick: ()=>{
                                                                                setState('entryUpdate');
                                                                                setSelectedEntry(entry);
                                                                            },
                                                                            disabled: (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE !== objective.status,
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c87356a25ad1ad4$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                                                                    title: deleteKpiEntryTooltipTitle,
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                                                                            size: "small",
                                                                            onClick: ()=>{
                                                                                setState('entryDelete');
                                                                                setSelectedEntry(entry);
                                                                            },
                                                                            disabled: (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE !== objective.status,
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $33ce0734640685aa$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                kpi.entries.length - 1 > index && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                                                    style: {
                                                        margin: 4
                                                    }
                                                })
                                            ]
                                        }, entry.objective_kpi_entry_id);
                                    }),
                                    editable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        style: {
                                            display: 'flex',
                                            justifyContent: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                                            title: addKpiEntryTooltipTitle,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                                                    onClick: ()=>setState('entryCreate'),
                                                    color: "primary",
                                                    disabled: (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE !== objective.status,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8dd10bcd03d52584$export$2e2bcd8739ae039), {})
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                                        style: {
                                            margin: '16px 0',
                                            background: '#aaa'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                        style: {
                                            fontSize: 18,
                                            marginBottom: 8
                                        },
                                        children: t('objective.button.tab.eventLog')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                                    title: t('objective.kpi.actions.openEventLog '),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                                            onClick: ()=>setState('eventLog'),
                                            color: "primary",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a0a03b09113b2fa7$exports))), {})
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e9dc35171fa81c7$export$2e2bcd8739ae039), {
                                direction: "left",
                                in: state === 'update',
                                mountOnEnter: true,
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ccbe778b237c5c26$export$2e2bcd8739ae039), {
                                    kpi: kpi,
                                    objective: objective,
                                    onSubmitSuccess: ()=>{
                                        onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
                                        resetState();
                                    },
                                    onCancel: resetState
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e9dc35171fa81c7$export$2e2bcd8739ae039), {
                                direction: "left",
                                in: state === 'delete',
                                mountOnEnter: true,
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $66b086fdadbdbc63$export$2e2bcd8739ae039), {
                                    kpi: kpi,
                                    objective: objective,
                                    onSubmitSuccess: ()=>{
                                        onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
                                        resetState();
                                    },
                                    onCancel: resetState
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e9dc35171fa81c7$export$2e2bcd8739ae039), {
                                direction: "left",
                                in: state === 'entryCreate',
                                mountOnEnter: true,
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2f0c7c7112953f7$export$2e2bcd8739ae039), {
                                    kpi: kpi,
                                    objective: objective,
                                    onSubmitSuccess: ()=>{
                                        onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
                                        resetState();
                                    },
                                    onCancel: resetState
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e9dc35171fa81c7$export$2e2bcd8739ae039), {
                                direction: "left",
                                in: state === 'entryUpdate',
                                mountOnEnter: true,
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $50d86b0d35311d1c$export$2e2bcd8739ae039), {
                                    objective: objective,
                                    kpi: kpi,
                                    kpiEntry: selectedEntry,
                                    onSubmitSuccess: ()=>{
                                        onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
                                        resetState();
                                    },
                                    onCancel: resetState
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e9dc35171fa81c7$export$2e2bcd8739ae039), {
                                direction: "left",
                                in: state === 'entryDelete',
                                mountOnEnter: true,
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6bdd0d5ab75d10a1$export$2e2bcd8739ae039), {
                                    objective: objective,
                                    kpi: kpi,
                                    kpiEntry: selectedEntry,
                                    onSubmitSuccess: ()=>{
                                        onSubmitSuccess === null || onSubmitSuccess === void 0 ? void 0 : onSubmitSuccess();
                                        resetState();
                                    },
                                    onCancel: resetState
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e9dc35171fa81c7$export$2e2bcd8739ae039), {
                                direction: "left",
                                in: state === 'eventLog',
                                mountOnEnter: true,
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $577cf5e51bc66d13$export$2e2bcd8739ae039), {
                                    onCancel: resetState,
                                    objective: objective,
                                    kpi: kpi
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                                style: {
                                    marginTop: 8
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: onClose,
                            color: "primary",
                            children: t('objective.todos.dialog.close.btn')
                        })
                    })
                ]
            })
        ]
    });
};
var $601dae6a01f8d1ab$export$2e2bcd8739ae039 = $601dae6a01f8d1ab$var$ObjectiveKPIDetails;







var $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY = 86400000;
function $0ff83ae00b0d75a6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY);
}


const $8471830f5d20576a$export$7233d5beb649b77a = ({ objective: objective, objectiveRelations: objectiveRelations })=>{
    return objectiveRelations ? objectiveRelations.reduce((acc, _param)=>{
        var { type: type } = _param, objectiveRelation = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "type"
        ]);
        const title = type === (0, $f6e729db3f817bb5$exports.OBJECTIVE_RELATION_TYPES).HIERARCHICAL ? `${type}-${objective.id === objectiveRelation.parent_id ? 'children' : 'parents'}` : type;
        const addNewGroup = (acc, title, objectiveRelation)=>[
                ...acc,
                {
                    title: title,
                    objectiveRelations: [
                        objectiveRelation
                    ]
                }
            ];
        const addRelationToExistingGroupOfSameTitle = (acc, title, objectiveRelation)=>acc.map((group)=>group.title === title ? {
                    title: title,
                    objectiveRelations: [
                        ...group.objectiveRelations,
                        objectiveRelation
                    ]
                } : group);
        return !acc.some((group)=>group.title === title) ? addNewGroup(acc, title, objectiveRelation) : addRelationToExistingGroupOfSameTitle(acc, title, objectiveRelation);
    }, []) : [];
};
const $8471830f5d20576a$export$9a678af2ba4c315e = (kpi)=>kpi.entries.reduce((acc, entry)=>acc + entry.value, 0) / Number(kpi.goalValue) * 100;
const $8471830f5d20576a$export$c973f85f8e8731c7 = (kpi)=>{
    const deadline = new Date(kpi.deadline);
    const daysFromNow = (0, $0ff83ae00b0d75a6$export$2e2bcd8739ae039)(deadline, new Date());
    if (daysFromNow < 0) return 100;
    const daysFromCreation = (0, $0ff83ae00b0d75a6$export$2e2bcd8739ae039)(deadline, new Date(kpi.created_at));
    return (daysFromCreation - daysFromNow) / daysFromCreation * 100;
};





const $2d6d3e722daedca1$var$useStyles = (0, $by0pu.default)({
    kpiRoot: {
        color: '#666666',
        background: '#F4F4F4',
        padding: 16
    },
    title: {
        color: '#999999',
        fontSize: 12,
        marginBottom: 8,
        textZransform: 'uppercase'
    }
}, {
    name: 'ObjectiveKPIs'
});
const $2d6d3e722daedca1$var$ObjectiveKPIs = ({ objective: objective })=>{
    var _query_data;
    const classes = $2d6d3e722daedca1$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const query = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'objectiveKPIs',
        objective
    ], async ()=>{
        const { data: data } = await (0, $cf0e40a933e30d20$export$b37adf77d4d80157)({
            objectiveId: objective.id,
            ownerId: objective.owner[0].id,
            ownerType: objective.owner[0].type
        });
        return data;
    });
    const editable = objective.owner[0].type === (0, $f6e729db3f817bb5$exports.OWNER_TYPES).EMPLOYEE;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: classes.kpiRoot,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.title,
                children: t('objective.kpi.title.list')
            }),
            (_query_data = query.data) === null || _query_data === void 0 ? void 0 : _query_data.map((kpi)=>{
                const progress = (0, $gSkQi.round)((0, $8471830f5d20576a$export$9a678af2ba4c315e)(kpi), 2);
                const prorate = (0, $gSkQi.round)((0, $8471830f5d20576a$export$c973f85f8e8731c7)(kpi), 2);
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                            container: true,
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    xs: 8,
                                    sm: 4,
                                    alignItems: "center",
                                    children: kpi.name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    xs: 4,
                                    sm: 2,
                                    alignItems: "center",
                                    children: [
                                        kpi.goalValue,
                                        " ",
                                        kpi.unit
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    xs: 5,
                                    sm: 3,
                                    alignItems: "center",
                                    children: (0, $8bfb433bad942c35$export$3ae94a2503e890a1)(new Date(kpi.deadline))
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 5,
                                    sm: 2,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f096f5d3d4b7bc1$export$2e2bcd8739ae039), {
                                        prorate: prorate,
                                        progress: progress,
                                        showValue: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 2,
                                    sm: 1,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $601dae6a01f8d1ab$export$2e2bcd8739ae039), {
                                        kpi: kpi,
                                        progress: progress,
                                        prorate: prorate,
                                        objective: objective,
                                        onSubmitSuccess: query.refetch,
                                        editable: editable
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {})
                    ]
                }, kpi.objectiveKPIId);
            }),
            editable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $059ee1df6ddff704$export$2e2bcd8739ae039), {
                objective: objective,
                onSubmitSuccess: query.refetch
            })
        ]
    });
};
var $2d6d3e722daedca1$export$2e2bcd8739ae039 = $2d6d3e722daedca1$var$ObjectiveKPIs;



parcelRequire("7fPBF");


const $9e83f5186b56e852$export$d9406b141a18b745 = ({ objectiveId: objectiveId, attachmentId: attachmentId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objectives/${objectiveId}/attachments/${attachmentId}`, {
        responseType: 'blob'
    });
const $9e83f5186b56e852$export$dd8d729018c6467d = ({ objectiveId: objectiveId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objectives/${objectiveId}/attachments`);
const $9e83f5186b56e852$export$6d54d3d043688f99 = ({ file: file, objectiveId: objectiveId })=>{
    var formData = new FormData();
    formData.append('file', file);
    return (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post(`/objectives/${objectiveId}/attachments`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const $9e83f5186b56e852$export$9ed76097473092d5 = ({ objectiveAttachmentId: objectiveAttachmentId, objectiveId: objectiveId })=>{
    return (0, $c5b59547f7a0f380$export$2e2bcd8739ae039).delete(`/objectives/${objectiveId}/attachments/${objectiveAttachmentId}`);
};



var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");

function $e9ac0b4484ff84d5$export$2e2bcd8739ae039(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}




var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");


const $2d92873b4087ba05$var$CreateAttachment = ({ objectiveId: objectiveId, ownerId: ownerId, ownerType: ownerType, onSuccess: onSuccess })=>{
    var _mutation_error;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const inputRef = (0, $7fPBF.useRef)(null);
    const mutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (file)=>{
        if (file.size > (0, $f6e729db3f817bb5$exports.MAX_ATTACHMENT_SIZE) * 1048576) throw new Error(`T\xfal big ${(0, $f6e729db3f817bb5$exports.MAX_ATTACHMENT_SIZE)}MB max`);
        return await (0, $9e83f5186b56e852$export$6d54d3d043688f99)({
            file: file,
            objectiveId: objectiveId,
            ownerId: ownerId,
            ownerType: ownerType
        });
    }, {
        onSuccess: onSuccess,
        onSettled: ()=>{
            inputRef.current.value = null;
        }
    });
    const inputId = `file-${objectiveId}`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fwAOd.default), {
                color: "secondary",
                variant: "contained",
                component: "label",
                htmlFor: inputId,
                children: [
                    t('objective.attachment.create'),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        ref: inputRef,
                        onChange: (e)=>{
                            mutation.mutate(e.target.files[0]);
                        },
                        type: "file",
                        id: inputId,
                        hidden: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
                open: mutation.isError,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                        children: (_mutation_error = mutation.error) === null || _mutation_error === void 0 ? void 0 : _mutation_error.message
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: mutation.reset,
                            children: "OK"
                        })
                    })
                ]
            })
        ]
    });
};
var $2d92873b4087ba05$export$2e2bcd8739ae039 = $2d92873b4087ba05$var$CreateAttachment;





var $7fPBF = parcelRequire("7fPBF");




var $fwAOd = parcelRequire("fwAOd");
const $f4226b5c31774d35$var$DeleteAttachment = ({ name: name, objectiveAttachmentId: objectiveAttachmentId, objectiveId: objectiveId, ownerId: ownerId, ownerType: ownerType, onSuccess: onSuccess })=>{
    var _mutation_error;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const mutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        return await (0, $9e83f5186b56e852$export$9ed76097473092d5)({
            objectiveAttachmentId: objectiveAttachmentId,
            objectiveId: objectiveId,
            ownerId: ownerId,
            ownerType: ownerType
        });
    }, {
        onSuccess: ()=>{
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        },
        onSettled: ()=>{
            setOpen(false);
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                onClick: ()=>setOpen(true),
                style: {
                    display: 'block',
                    cursor: 'pointer',
                    fontSize: 12,
                    margin: '8px 0'
                },
                children: t('objective.comment.delete')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                        children: t('objective.attachment.title.delete')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                        children: [
                            t('objective.attachment.deleteConfirm'),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    marginTop: 8,
                                    wordBreak: 'break-word'
                                },
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                                onClick: mutation.mutate,
                                variant: "contained",
                                color: "primary",
                                children: t('objective.comment.delete')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                                onClick: ()=>setOpen(false),
                                color: "primary",
                                children: t('objective.dialog.cancel')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
                open: mutation.isError,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                        children: (_mutation_error = mutation.error) === null || _mutation_error === void 0 ? void 0 : _mutation_error.message
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: mutation.reset,
                            children: "OK"
                        })
                    })
                ]
            })
        ]
    });
};
var $f4226b5c31774d35$export$2e2bcd8739ae039 = $f4226b5c31774d35$var$DeleteAttachment;




const $740a4a6d3745de89$var$useStyles = (0, $by0pu.default)({
    attachmentRoot: {
        background: '#F4F4F4',
        padding: 16
    },
    title: {
        color: '#999',
        fontSize: 12,
        marginBottom: 8,
        textTransform: 'uppercase'
    },
    attachmentItem: {
        marginBottom: 8
    },
    attachmentRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        margin: '8px 0'
    },
    uploader: {
        color: 'black',
        fontWeight: 'bold'
    },
    uploadTime: {
        color: '#999999',
        fontSize: 12,
        marginLeft: 'auto'
    },
    fileName: {
        wordBreak: 'break-word'
    },
    fileSize: {
        fontSize: 12,
        marginLeft: 'auto',
        whiteSpace: 'nowrap'
    }
}, {
    name: 'ObjectiveAttachments'
});
const $740a4a6d3745de89$var$Attachments = ({ objective: objective })=>{
    var _query_data;
    const classes = $740a4a6d3745de89$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const lng = (0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039).languages[0];
    const { accountInfo: accountInfo, employee: employee } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state);
    const employees = [
        ...accountInfo.possibleAppraisers,
        employee
    ];
    const ownerId = objective.owner[0].id;
    const ownerType = objective.owner[0].type;
    const objectiveId = objective.id;
    const query = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'objectiveAttachment',
        objectiveId
    ], async ()=>{
        const { data: data } = await (0, $9e83f5186b56e852$export$dd8d729018c6467d)({
            objectiveId: objectiveId,
            ownerId: ownerId,
            ownerType: ownerType
        });
        return data;
    });
    async function downloadAttachment({ attachmentId: attachmentId, fileName: fileName }) {
        const { data: data } = await (0, $9e83f5186b56e852$export$d9406b141a18b745)({
            objectiveId: objectiveId,
            attachmentId: attachmentId
        });
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: classes.attachmentRoot,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                className: classes.title,
                children: t('objective.attachment.title.list')
            }),
            (_query_data = query.data) === null || _query_data === void 0 ? void 0 : _query_data.map((attachment)=>{
                var _employees_find;
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: classes.attachmentItem,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: classes.attachmentRow,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: classes.uploader,
                                    children: (_employees_find = employees.find((emp)=>emp.empid === attachment.createdBy)) === null || _employees_find === void 0 ? void 0 : _employees_find.name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a2da34cf44eef56c$export$2e2bcd8739ae039), {
                                    className: classes.uploadTime,
                                    date: new Date(attachment.createdAt),
                                    locale: lng
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: classes.attachmentRow,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: `/attachment/${attachment.objectiveAttachmentId}`,
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        downloadAttachment({
                                            attachmentId: attachment.objectiveAttachmentId,
                                            fileName: attachment.originalFileName
                                        });
                                    },
                                    className: classes.fileName,
                                    children: attachment.originalFileName
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: classes.fileSize,
                                    children: (0, $e9ac0b4484ff84d5$export$2e2bcd8739ae039)(attachment.size)
                                })
                            ]
                        }),
                        employee.empid === attachment.employeeId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f4226b5c31774d35$export$2e2bcd8739ae039), {
                            name: attachment.originalFileName,
                            objectiveAttachmentId: attachment.objectiveAttachmentId,
                            objectiveId: objectiveId,
                            ownerId: ownerId,
                            ownerType: ownerType,
                            onSuccess: query.refetch
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {})
                    ]
                }, attachment.objectiveAttachmentId);
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2d92873b4087ba05$export$2e2bcd8739ae039), {
                objectiveId: objectiveId,
                ownerId: ownerId,
                ownerType: ownerType,
                onSuccess: query.refetch
            })
        ]
    });
};
var $740a4a6d3745de89$export$2e2bcd8739ae039 = $740a4a6d3745de89$var$Attachments;


const $f6fe08fc5e225c4a$var$useStyles = (0, $by0pu.default)((theme)=>({
        buttons: {
            display: 'flex',
            justifyContent: 'flex-start'
        },
        limitText: {
            display: 'flex',
            justifyContent: 'flex-start',
            color: '#ff0a0a'
        },
        warning: {
            fontSize: '14px'
        }
    }));
const $f6fe08fc5e225c4a$var$DetailsPanel = ({ objective: objective, onSubmitSuccess: onSubmitSuccess })=>{
    var _objective_owner_find;
    const classes = $f6fe08fc5e225c4a$var$useStyles();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const employeeIdOfCurrentUser = objective === null || objective === void 0 ? void 0 : objective.employee_id;
    const [closeObjectiveDialogOpen, setCloseObjectiveDialogOpen] = (0, $7fPBF.useState)(false);
    const [completedObjectiveDialogOpen, setCompletedObjectiveDialogOpen] = (0, $7fPBF.useState)(false);
    const reachLimitOfActiveObjectives = objective === null || objective === void 0 ? void 0 : (_objective_owner_find = objective.owner.find(({ type: type })=>type === (0, $f6e729db3f817bb5$exports.OWNER_TYPES).EMPLOYEE)) === null || _objective_owner_find === void 0 ? void 0 : _objective_owner_find.activeObjectiveLimitReached;
    const owner = objective === null || objective === void 0 ? void 0 : objective.owner[0];
    const changeStatusMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async (status)=>{
        return await (0, $553835ea16648c6f$export$b76cada91418b11a)({
            objective: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, objective), {
                status: status
            })
        });
    }, {
        onSuccess: ()=>{
            onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const objectiveRatesQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'objectiveRates',
        objective === null || objective === void 0 ? void 0 : objective.id
    ], async ()=>{
        const { data: data } = await (0, $0bc299533abf3517$export$1c173c26d5727dfa)({
            objectiveId: objective === null || objective === void 0 ? void 0 : objective.id
        });
        data.sort((a, b)=>a.criteria.criteria_name.hu.localeCompare(b.criteria.criteria_name.hu));
        return data;
    }, {
        enabled: !!objective,
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    var _objectiveRatesQuery_data;
    const objectiveRates = (_objectiveRatesQuery_data = objectiveRatesQuery.data) !== null && _objectiveRatesQuery_data !== void 0 ? _objectiveRatesQuery_data : [];
    const updateObjectiveToFailedMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>await (0, $553835ea16648c6f$export$9e16dc478dc7290d)({
            objectiveData: {
                objective: objective,
                appraiserId: employeeIdOfCurrentUser
            }
        }), {
        onSuccess: ()=>{
            onSubmitSuccess();
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                md: 6,
                children: [
                    owner.type === (0, $f6e729db3f817bb5$exports.OWNER_TYPES).EMPLOYEE && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: classes.buttons,
                                children: objective.status !== (0, $f6e729db3f817bb5$exports.STATUS).COMPLETED && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $443024259dfe5e8a$export$2e2bcd8739ae039), {
                                    status: objective.status,
                                    handleChange: changeStatusMutation.mutate,
                                    setCloseObjectiveDialogOpen: setCloseObjectiveDialogOpen,
                                    proposedByUser: (objective.proposed_by || '').toString() === employeeIdOfCurrentUser,
                                    setCompletedObjectiveDialogOpen: setCompletedObjectiveDialogOpen,
                                    reachLimitOfActiveObjectives: reachLimitOfActiveObjectives
                                })
                            }),
                            reachLimitOfActiveObjectives && objective.status === (0, $f6e729db3f817bb5$exports.STATUS).PASSIVE && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: classes.limitText,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                    variant: "caption",
                                    className: classes.warning,
                                    gutterBottom: true,
                                    children: t('objective.alert.reachLimit')
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e9d2e17cb2f0f04$export$2e2bcd8739ae039), {
                        isPanelOpened: true,
                        objective: objective,
                        objectiveRates: objectiveRates,
                        averageOfObjectiveRates: objective.ratingsData.weightedMean,
                        onSubmitSuccess: ()=>{
                            onSubmitSuccess();
                            objectiveRatesQuery.refetch();
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                md: 6,
                children: [
                    (owner === null || owner === void 0 ? void 0 : owner.type) === (0, $f6e729db3f817bb5$exports.OWNER_TYPES).EMPLOYEE ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d09ca5af4961575b$export$2e2bcd8739ae039), {
                                objective: objective,
                                onSubmitSuccess: onSubmitSuccess
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2d6d3e722daedca1$export$2e2bcd8739ae039), {
                                objective: objective
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0440723b6a109160$export$2e2bcd8739ae039), {
                                objectiveId: objective.id,
                                status: objective.status
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e20e1fc426c4f73$export$2e2bcd8739ae039), {
                                objectiveId: objective.objective_id,
                                employee: objective.appraisers_and_criterias.appraisers.find((appraiser)=>appraiser.role === (0, $f6e729db3f817bb5$exports.RATING_ROLE).OWNER)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2d6d3e722daedca1$export$2e2bcd8739ae039), {
                        objective: objective
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $740a4a6d3745de89$export$2e2bcd8739ae039), {
                        objective: objective
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab5b0342cb6fe691$export$409d0b14e1979161), {
                closeObjectiveDialogOpen: closeObjectiveDialogOpen,
                setCloseObjectiveDialogOpen: setCloseObjectiveDialogOpen,
                handleFailedObjective: updateObjectiveToFailedMutation.mutate
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $29f07647fa6b2df4$export$2e2bcd8739ae039), {
                open: completedObjectiveDialogOpen,
                setCompletedObjectiveDialogOpen: setCompletedObjectiveDialogOpen,
                handleStatusChange: changeStatusMutation.mutate
            })
        ]
    });
};
var $f6fe08fc5e225c4a$export$2e2bcd8739ae039 = $f6fe08fc5e225c4a$var$DetailsPanel;




var $7fPBF = parcelRequire("7fPBF");


var $cuouK = parcelRequire("cuouK");





parcelRequire("7fPBF");

const $769c0cd7f9786542$var$ObjectiveLog = ({ event: event })=>{
    const details = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        itemType: 'objective',
        actualItem: event === null || event === void 0 ? void 0 : event.objective,
        previousItem: event === null || event === void 0 ? void 0 : event.oldObjective
    }, event);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e109de0513c0ef5$export$2e2bcd8739ae039), {
        event: details
    });
};
var $769c0cd7f9786542$export$2e2bcd8739ae039 = $769c0cd7f9786542$var$ObjectiveLog;




parcelRequire("7fPBF");

const $09e65f18f113203c$var$CommentLog = ({ event: event })=>{
    const details = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        itemType: 'comment',
        actualItem: {
            text: event === null || event === void 0 ? void 0 : event.newComment
        },
        previousItem: {
            text: event === null || event === void 0 ? void 0 : event.oldComment
        }
    }, event);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1e109de0513c0ef5$export$2e2bcd8739ae039), {
        event: details
    });
};
var $09e65f18f113203c$export$2e2bcd8739ae039 = $09e65f18f113203c$var$CommentLog;




parcelRequire("7fPBF");


var $fwAOd = parcelRequire("fwAOd");




/**
 * @component
 *
 * @param {boolean} open      - Controls whether the dialog is open.
 * @param {Function} setOpen  - Function to toggle the dialog's open state.
 * @param {Object} objective  - The objective associated with the KPI logs.
 * @param {Object} kpi        - The KPI whose deleted logs are displayed.
 *
 * @returns {JSX.Element} A Material-UI Dialog showing deleted KPI logs.
 */ const $85b4bc77d9af6ca8$var$DeletedKpiEntryLogs = ({ open: open, setOpen: setOpen, objective: objective, kpi: kpi })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { KPI_ENTRIES: KPI_ENTRIES } = (0, $f6e729db3f817bb5$exports.EVENT_LOG);
    const { data: data, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isLoading: isLoading, isFetching: isFetching } = (0, $316c4b5385bc3f70$export$2e2bcd8739ae039)({
        objective: objective,
        kpi: kpi,
        subjectType: KPI_ENTRIES
    });
    var _data_pages_flat;
    const kpiEntryLogs = (_data_pages_flat = data === null || data === void 0 ? void 0 : data.pages.flat()) !== null && _data_pages_flat !== void 0 ? _data_pages_flat : [];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
        open: open,
        onClose: ()=>setOpen(false),
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                children: t('objective.eventlog.type.kpi_entry')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                children: [
                    kpiEntryLogs.map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $efa69e9c91b693e2$export$2e2bcd8739ae039), {
                            event: event
                        }, `${event.name}-${index}`)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        container: true,
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $36b809d1f393b765$export$2e2bcd8739ae039), {
                            loading: isFetching || isLoading,
                            canLoadMore: hasNextPage,
                            loadMore: fetchNextPage,
                            loadMoreTranslation: t('objective.eventlog.loadMoreBtn'),
                            noMoreToLoadTranslation: t('objective.eventlog.NoMoreEvents')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: ()=>setOpen(false),
                    color: "primary",
                    children: t('objective.dialog.cancel')
                })
            })
        ]
    });
};
var $85b4bc77d9af6ca8$export$2e2bcd8739ae039 = $85b4bc77d9af6ca8$var$DeletedKpiEntryLogs;






const $913737ed8255f29a$var$Panel = ({ objective: objective, createdAt: createdAt, enabled: enabled, owner: owner })=>{
    var _objectiveEventsQuery_data;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [subjectType, setSubjectType] = (0, $7fPBF.useState)((0, $f6e729db3f817bb5$exports.EVENT_LOG).OBJECTIVES);
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const handleOpen = ()=>setOpen(true);
    const handleSelectResource = (event, selectedResource)=>{
        setSubjectType(selectedResource);
    };
    const objectiveEventsQuery = (0, $2bc6258289aa5150$export$bdc59d3c1a6569aa)([
        'objectiveLogs',
        objective.id,
        subjectType
    ], async ({ pageParam: pageParam = 1 })=>{
        const { data: data } = await (0, $553835ea16648c6f$export$a8b14870a33d7ee9)({
            objectiveId: objective === null || objective === void 0 ? void 0 : objective.id,
            createdAt: createdAt,
            pageNumber: pageParam,
            subjectType: subjectType
        });
        return data;
    }, {
        getNextPageParam: (lastPage, pages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) % (0, $f6e729db3f817bb5$exports.EVENT_LOG_LIMIT) === 0 && lastPage.length !== 0 ? (pages === null || pages === void 0 ? void 0 : pages.flat().length) / (0, $f6e729db3f817bb5$exports.EVENT_LOG_LIMIT) + 1 : undefined;
        },
        enabled: enabled,
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    var _objectiveEventsQuery_data_pages_flat;
    const objectiveEventLogs = (_objectiveEventsQuery_data_pages_flat = (_objectiveEventsQuery_data = objectiveEventsQuery.data) === null || _objectiveEventsQuery_data === void 0 ? void 0 : _objectiveEventsQuery_data.pages.flat()) !== null && _objectiveEventsQuery_data_pages_flat !== void 0 ? _objectiveEventsQuery_data_pages_flat : [];
    const eventIsLoading = objectiveEventsQuery.isFetching;
    const renderResourceTrails = ()=>{
        switch(subjectType){
            case (0, $f6e729db3f817bb5$exports.EVENT_LOG).OBJECTIVES:
                return objectiveEventLogs.map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $769c0cd7f9786542$export$2e2bcd8739ae039), {
                        event: event
                    }, index));
            case (0, $f6e729db3f817bb5$exports.EVENT_LOG).COMMENTS:
                return objectiveEventLogs.map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09e65f18f113203c$export$2e2bcd8739ae039), {
                        event: event
                    }, index));
            case (0, $f6e729db3f817bb5$exports.EVENT_LOG).KPIS:
                return objectiveEventLogs.map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bcd5869e13626df6$export$2e2bcd8739ae039), {
                                event: event,
                                handleOpen: handleOpen
                            }, index),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $85b4bc77d9af6ca8$export$2e2bcd8739ae039), {
                                open: open,
                                setOpen: setOpen,
                                objective: objective,
                                kpi: event
                            })
                        ]
                    }, index));
            default:
                return objectiveEventLogs.map((event, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $769c0cd7f9786542$export$2e2bcd8739ae039), {
                        event: event
                    }, index));
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            owner.type === (0, $f6e729db3f817bb5$exports.OWNER_TYPES).EMPLOYEE && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cuouK.default), {
                component: "fieldset",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c0bb7d62132be7c8$export$2e2bcd8739ae039), {
                    value: subjectType,
                    exclusive: true,
                    onChange: handleSelectResource,
                    "aria-label": "text alignment",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06176b7c8ef7e78a$export$2e2bcd8739ae039), {
                            value: (0, $f6e729db3f817bb5$exports.EVENT_LOG).OBJECTIVES,
                            children: t('objective.eventlog.type.general')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06176b7c8ef7e78a$export$2e2bcd8739ae039), {
                            value: (0, $f6e729db3f817bb5$exports.EVENT_LOG).COMMENTS,
                            children: t('objective.eventlog.type.comment')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $06176b7c8ef7e78a$export$2e2bcd8739ae039), {
                            value: (0, $f6e729db3f817bb5$exports.EVENT_LOG).KPIS,
                            children: t('objective.eventlog.type.kpi')
                        })
                    ]
                })
            }),
            renderResourceTrails(),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $36b809d1f393b765$export$2e2bcd8739ae039), {
                    loading: eventIsLoading,
                    canLoadMore: objectiveEventsQuery.hasNextPage,
                    loadMore: objectiveEventsQuery.fetchNextPage,
                    loadMoreTranslation: t('objective.event.loadMoreBtn'),
                    noMoreToLoadTranslation: t('objective.event.NoMoreEvents')
                })
            })
        ]
    });
};
var $913737ed8255f29a$export$2e2bcd8739ae039 = $913737ed8255f29a$var$Panel;




var $iRcsz = parcelRequire("iRcsz");
var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");




var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $c9eda21f2c1c83bb$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), 'OpenInNew');




var $jtRae = parcelRequire("jtRae");
const $7c2f80abb8d4a5a3$var$useStyles = (0, $by0pu.default)({
    group: {
        marginTop: 8,
        borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
        borderRight: '1px solid rgba(0, 0, 0, 0.12)'
    },
    groupTitle: {
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        background: '#F4F4F4',
        padding: 16
    },
    listRow: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr 48px',
        gridGap: 8,
        alignItems: 'center',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        padding: '8px 16px'
    },
    listHeader: {
        '& p': {
            color: '#999999',
            fontSize: 11,
            textTransform: 'uppercase'
        }
    },
    listItem: {
        '& p': {
            fontSize: 13
        }
    },
    noRelated: {
        marginTop: '30px'
    }
}, {
    name: 'RelatedObjectives'
});
const $7c2f80abb8d4a5a3$var$RelatedObjectives = ({ objective: objective, objectiveRelations: objectiveRelations })=>{
    const classes = $7c2f80abb8d4a5a3$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const groupedRelatedObjectives = (0, $8471830f5d20576a$export$7233d5beb649b77a)({
        objective: objective,
        objectiveRelations: objectiveRelations
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                children: t('objective.relation.title')
            }),
            groupedRelatedObjectives.length > 0 ? groupedRelatedObjectives.map((group)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: classes.group,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            className: classes.groupTitle,
                            children: t(`objective.relation.types.${group.title}`)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, $jtRae.default)(classes.listRow, classes.listHeader),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                    children: t('objective.listHeader.name')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                    children: t('objective.listHeader.deadline')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                    children: t('objective.listHeader.category')
                                })
                            ]
                        }),
                        group.objectiveRelations.map((objectiveRelation)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: (0, $jtRae.default)(classes.listRow, classes.listItem),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1rW9t.default), {
                                        children: [
                                            objectiveRelation.objective.owner[0].name,
                                            " - ",
                                            objectiveRelation.objective.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                        children: (0, $8bfb433bad942c35$export$3ae94a2503e890a1)(new Date(objectiveRelation.objective.deadline))
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                                        children: objectiveRelation.objective.category
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $iRcsz.default), {
                                            component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                                            target: "_blank",
                                            to: `/objective/${objectiveRelation.objective.objective_id}`,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9eda21f2c1c83bb$export$2e2bcd8739ae039), {})
                                        })
                                    })
                                ]
                            }, objectiveRelation.objective_relations_id))
                    ]
                }, group.title)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                variant: "body2",
                className: classes.group,
                children: t('objective.relation.noRelated')
            })
        ]
    });
};
var $7c2f80abb8d4a5a3$export$2e2bcd8739ae039 = $7c2f80abb8d4a5a3$var$RelatedObjectives;


const $9b36a890191564c2$var$StyledBadge = (0, $3Sc7z.default)(()=>({
        badge: {
            right: -18,
            top: 8,
            padding: '4px',
            backgroundColor: '#A6A6A6',
            width: '25px',
            height: '25px',
            borderRadius: '50%',
            color: '#FFFFFF',
            fontWeight: 600
        }
    }))((0, $jaezp.default));
const $9b36a890191564c2$var$useStyles = (0, $by0pu.default)(()=>({
        panel: {
            padding: 0
        },
        tabs: {
            marginBottom: '16px'
        },
        connectedGoalsTab: {
            width: '100%',
            maxWidth: '320px'
        }
    }));
const $9b36a890191564c2$var$Tabs = ({ objectiveRelations: objectiveRelations, objective: objective, onSubmitSuccess: onSubmitSuccess })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $9b36a890191564c2$var$useStyles();
    const theme = (0, $fH0xA.default)();
    const md = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('md'));
    const [tabValue, setTabValue] = (0, $7fPBF.useState)('1');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1ff24193d7f3d742$export$2e2bcd8739ae039), {
        value: tabValue,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $9a2e81678754347d$export$2e2bcd8739ae039), {
                    className: classes.tabs,
                    onChange: (event, newValue)=>{
                        setTabValue(newValue);
                    },
                    orientation: md ? 'horizontal' : 'vertical',
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df0b4c29990e52e3$export$2e2bcd8739ae039), {
                            label: t('objective.button.tab.details'),
                            value: "1"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df0b4c29990e52e3$export$2e2bcd8739ae039), {
                            className: classes.connectedGoalsTab,
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($9b36a890191564c2$var$StyledBadge, {
                                badgeContent: objectiveRelations.length,
                                max: 999,
                                overlap: "rectangular",
                                children: t('objective.button.tab.relations')
                            }),
                            value: "2"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df0b4c29990e52e3$export$2e2bcd8739ae039), {
                            label: t('objective.button.tab.eventlog'),
                            value: "3"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $784882aa81ed5c1f$export$2e2bcd8739ae039), {
                value: "1",
                className: classes.panel,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f6fe08fc5e225c4a$export$2e2bcd8739ae039), {
                        objective: objective,
                        onSubmitSuccess: onSubmitSuccess
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $784882aa81ed5c1f$export$2e2bcd8739ae039), {
                value: "2",
                className: classes.panel,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c2f80abb8d4a5a3$export$2e2bcd8739ae039), {
                    objective: objective,
                    objectiveRelations: objectiveRelations
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $784882aa81ed5c1f$export$2e2bcd8739ae039), {
                value: "3",
                className: classes.panel,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $913737ed8255f29a$export$2e2bcd8739ae039), {
                    enabled: tabValue === '3',
                    objective: objective,
                    createdAt: objective === null || objective === void 0 ? void 0 : objective.createdAt,
                    owner: objective === null || objective === void 0 ? void 0 : objective.owner[0]
                })
            })
        ]
    });
};
var $9b36a890191564c2$export$2e2bcd8739ae039 = $9b36a890191564c2$var$Tabs;


const $128c11857d1e96b1$var$ObjectivePage = ()=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { objectiveId: objectiveId } = (0, $560cbe427eb95a5b$export$99eaa27ddbbb95ef)();
    const theme = (0, $fH0xA.default)();
    const md = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('md'));
    const queryClient = (0, $509c1684c3be0a4f$export$22e77b9572c4fded)();
    const employee = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee);
    const [drawerOpen, setDrawerOpen] = (0, $7fPBF.useState)(false);
    const [updateDialogOpen, setUpdateDialogOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $74750fb419d4223b$export$eb48dd7746a93f2a)());
        if (JSON.stringify(employee) === '{}') dispatch((0, $401a17725816a5a8$export$d5f42470fa5a7347)()).then((employee)=>{
            (0, $c2fa3f0a340dc103$export$ac983537af4b3a6d)(employee.language);
        });
    }, [
        dispatch,
        employee
    ]);
    const objectiveQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'objective',
        objectiveId
    ], async ()=>{
        const { data: data } = await (0, $553835ea16648c6f$export$d4731ebe50b2f70b)({
            objectiveId: objectiveId
        });
        return data[0];
    });
    const objective = objectiveQuery.data;
    const employeeIdOfCurrentUser = objective === null || objective === void 0 ? void 0 : objective.employee_id;
    const objectiveRelationsQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'objectiveRelations',
        objectiveId
    ], async ()=>{
        const { data: data } = await (0, $5b370f02b85c28ed$export$77de90c6937e3257)({
            objectiveId: objectiveId
        });
        return data;
    }, {
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    var _objectiveRelationsQuery_data;
    const objectiveRelations = (_objectiveRelationsQuery_data = objectiveRelationsQuery.data) !== null && _objectiveRelationsQuery_data !== void 0 ? _objectiveRelationsQuery_data : [];
    const onSubmitSuccess = ()=>{
        queryClient.invalidateQueries([
            'objective',
            objectiveId
        ]);
        queryClient.invalidateQueries([
            'objectiveRates',
            objectiveId
        ]);
    };
    const isEditable = (objective === null || objective === void 0 ? void 0 : objective.status) !== (0, $f6e729db3f817bb5$exports.STATUS).COMPLETED && (objective === null || objective === void 0 ? void 0 : objective.status) !== (0, $f6e729db3f817bb5$exports.STATUS).FAILED && (objective === null || objective === void 0 ? void 0 : objective.employee_id) === (objective === null || objective === void 0 ? void 0 : objective.proposed_by);
    return objective ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $899ea3d88a7a8f04$export$2e2bcd8739ae039), {
                drawerOpen: drawerOpen,
                setDrawerOpen: setDrawerOpen
            }),
            objective && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    padding: 16,
                    marginLeft: !md ? 'auto' : drawerOpen ? `${0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH}px` : '55px'
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2f2a6ac7fc7de65$export$2e2bcd8739ae039), {
                        objective: objective,
                        isEditable: isEditable,
                        setUpdateDialogOpen: setUpdateDialogOpen,
                        responsiveItems: false
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        container: true,
                        direction: 'column',
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9b36a890191564c2$export$2e2bcd8739ae039), {
                            objectiveRelations: objectiveRelations,
                            objective: objective,
                            onSubmitSuccess: onSubmitSuccess
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3447d4985bafc2a$export$2e2bcd8739ae039), {
                        open: updateDialogOpen,
                        handleClose: ()=>setUpdateDialogOpen(false),
                        objectiveItem: objective,
                        employeeIdOfCurrentUser: employeeIdOfCurrentUser,
                        onSubmitSuccess: onSubmitSuccess
                    })
                ]
            })
        ]
    }) : null;
};
var $128c11857d1e96b1$export$2e2bcd8739ae039 = $128c11857d1e96b1$var$ObjectivePage;





var $7fPBF = parcelRequire("7fPBF");






var $fH0xA = parcelRequire("fH0xA");

parcelRequire("7fPBF");






parcelRequire("7fPBF");


var $fwAOd = parcelRequire("fwAOd");
var $fOH1P = parcelRequire("fOH1P");
var $hPUC4 = parcelRequire("hPUC4");
var $by0pu = parcelRequire("by0pu");
var $ckpfM = parcelRequire("ckpfM");
var $fH0xA = parcelRequire("fH0xA");

var $7fPBF = parcelRequire("7fPBF");


const $60cfffc9961daa74$var$defaultConfig = {
    direction: 'descending',
    key: 'created_at'
};
function $60cfffc9961daa74$export$2b3d2f2382009a90(items, config = $60cfffc9961daa74$var$defaultConfig) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [sortConfig, setSortConfig] = (0, $7fPBF.useState)(config);
    const sortedItems = (0, $7fPBF.useMemo)(()=>{
        const sortByStatus = [
            t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)['PROPOSED']),
            t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)['DECLINED']),
            t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)['PASSIVE']),
            t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)['ACTIVE']),
            t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)['FAILED']),
            t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)['COMPLETED'])
        ];
        let sortableItems = [
            ...items
        ];
        if (sortConfig !== null) sortableItems.sort((a, b)=>{
            if (sortConfig.key === 'status') {
                a = sortByStatus.indexOf(t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)[a[sortConfig.key].toUpperCase()]));
                b = sortByStatus.indexOf(t((0, $f6e729db3f817bb5$exports.OBJECTIVE_STATUS_CHIP_LABELS)[b[sortConfig.key].toUpperCase()]));
            } else {
                a = sortConfig.key === 'created_at' || sortConfig.key === 'deadline' ? new Date(a[sortConfig.key]) : a[sortConfig.key];
                b = sortConfig.key === 'created_at' || sortConfig.key === 'deadline' ? new Date(b[sortConfig.key]) : b[sortConfig.key];
            }
            if (a < b) return sortConfig.direction === 'ascending' ? -1 : 1;
            if (a > b) return sortConfig.direction === 'ascending' ? 1 : -1;
            return 0;
        });
        return sortableItems;
    }, [
        items,
        sortConfig,
        t
    ]);
    const requestSort = (key)=>{
        let direction = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'descending') setSortConfig($60cfffc9961daa74$var$defaultConfig);
        else if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
            setSortConfig({
                key: key,
                direction: direction
            });
        } else setSortConfig({
            key: key,
            direction: direction
        });
    };
    return {
        items: sortedItems,
        requestSort: requestSort,
        sortConfig: sortConfig
    };
}




var $7fPBF = parcelRequire("7fPBF");



var $kY3Ke = parcelRequire("kY3Ke");

var $a2azi = parcelRequire("a2azi");

var $1DcFf = parcelRequire("1DcFf");

var $6A22e = parcelRequire("6A22e");

var $bM4Gu = parcelRequire("bM4Gu");
function $378e28034d64ade8$export$2e2bcd8739ae039(r) {
    return (0, $a2azi.default)(r) || (0, $1DcFf.default)(r) || (0, $6A22e.default)(r) || (0, $bM4Gu.default)();
}



var $2gIIh = parcelRequire("2gIIh");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $jtRae = parcelRequire("jtRae");



var $ckpfM = parcelRequire("ckpfM");

var $3Sc7z = parcelRequire("3Sc7z");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ var $76225d5ebf2e132f$var$AccordionContext = $7fPBF.createContext({});
var $76225d5ebf2e132f$export$2e2bcd8739ae039 = $76225d5ebf2e132f$var$AccordionContext;



var $3deDh = parcelRequire("3deDh");
var $8eb56da890a42ae3$export$9dd6ff9ea0189349 = function styles(theme) {
    var transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            transition: theme.transitions.create([
                'margin'
            ], transition),
            '&:before': {
                position: 'absolute',
                left: 0,
                top: -1,
                right: 0,
                height: 1,
                content: '""',
                opacity: 1,
                backgroundColor: theme.palette.divider,
                transition: theme.transitions.create([
                    'opacity',
                    'background-color'
                ], transition)
            },
            '&:first-child': {
                '&:before': {
                    display: 'none'
                }
            },
            '&$expanded': {
                margin: '16px 0',
                '&:first-child': {
                    marginTop: 0
                },
                '&:last-child': {
                    marginBottom: 0
                },
                '&:before': {
                    opacity: 0
                }
            },
            '&$expanded + &': {
                '&:before': {
                    display: 'none'
                }
            },
            '&$disabled': {
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: 0,
            '&:first-child': {
                borderTopLeftRadius: theme.shape.borderRadius,
                borderTopRightRadius: theme.shape.borderRadius
            },
            '&:last-child': {
                borderBottomLeftRadius: theme.shape.borderRadius,
                borderBottomRightRadius: theme.shape.borderRadius,
                // Fix a rendering issue on Edge
                '@supports (-ms-ime-align: auto)': {
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0
                }
            }
        },
        /* Styles applied to the root element if `expanded={true}`. */ expanded: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {}
    };
};
var $8eb56da890a42ae3$var$Accordion = /*#__PURE__*/ $7fPBF.forwardRef(function Accordion(props, ref) {
    var childrenProp = props.children, classes = props.classes, className = props.className, _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, expandedProp = props.expanded, onChange = props.onChange, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $7e9dc35171fa81c7$export$2e2bcd8739ae039) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "defaultExpanded",
        "disabled",
        "expanded",
        "onChange",
        "square",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var _useControlled = (0, $3deDh.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    }), _useControlled2 = (0, $2gIIh.default)(_useControlled, 2), expanded = _useControlled2[0], setExpandedState = _useControlled2[1];
    var handleChange = $7fPBF.useCallback(function(event) {
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    var _React$Children$toArr = $7fPBF.Children.toArray(childrenProp), _React$Children$toArr2 = (0, $378e28034d64ade8$export$2e2bcd8739ae039)(_React$Children$toArr), summary = _React$Children$toArr2[0], children = _React$Children$toArr2.slice(1);
    var contextValue = $7fPBF.useMemo(function() {
        return {
            expanded: expanded,
            disabled: disabled,
            toggle: handleChange
        };
    }, [
        expanded,
        disabled,
        handleChange
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $ckpfM.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
        ref: ref,
        square: square
    }, other), /*#__PURE__*/ $7fPBF.createElement((0, $76225d5ebf2e132f$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, summary), /*#__PURE__*/ $7fPBF.createElement(TransitionComponent, (0, $kY3Ke.default)({
        in: expanded,
        timeout: "auto"
    }, TransitionProps), /*#__PURE__*/ $7fPBF.createElement("div", {
        "aria-labelledby": summary.props.id,
        id: summary.props['aria-controls'],
        role: "region"
    }, children)));
});
var $8eb56da890a42ae3$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($8eb56da890a42ae3$export$9dd6ff9ea0189349, {
    name: 'MuiAccordion'
})($8eb56da890a42ae3$var$Accordion);


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");

var $3Sc7z = parcelRequire("3Sc7z");
var $0027963611e4ddbd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            padding: theme.spacing(1, 2, 2)
        }
    };
};
var $0027963611e4ddbd$var$AccordionDetails = /*#__PURE__*/ $7fPBF.forwardRef(function AccordionDetails(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $lfiYO.default)(props, [
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.root, className),
        ref: ref
    }, other));
});
var $0027963611e4ddbd$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($0027963611e4ddbd$export$9dd6ff9ea0189349, {
    name: 'MuiAccordionDetails'
})($0027963611e4ddbd$var$AccordionDetails);


var $kY3Ke = parcelRequire("kY3Ke");

var $lfiYO = parcelRequire("lfiYO");

var $7fPBF = parcelRequire("7fPBF");


var $jtRae = parcelRequire("jtRae");


var $gd1Bg = parcelRequire("gd1Bg");

var $iRcsz = parcelRequire("iRcsz");

var $3Sc7z = parcelRequire("3Sc7z");

var $076b6dd35d98da64$export$9dd6ff9ea0189349 = function styles(theme) {
    var transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            minHeight: 48,
            transition: theme.transitions.create([
                'min-height',
                'background-color'
            ], transition),
            padding: theme.spacing(0, 2),
            '&:hover:not($disabled)': {
                cursor: 'pointer'
            },
            '&$expanded': {
                minHeight: 64
            },
            '&$focused, &$focusVisible': {
                backgroundColor: theme.palette.action.focus
            },
            '&$disabled': {
                opacity: theme.palette.action.disabledOpacity
            }
        },
        /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */ expanded: {},
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focused: {},
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the children wrapper element. */ content: {
            display: 'flex',
            flexGrow: 1,
            transition: theme.transitions.create([
                'margin'
            ], transition),
            margin: '12px 0',
            '&$expanded': {
                margin: '20px 0'
            }
        },
        /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */ expandIcon: {
            transform: 'rotate(0deg)',
            transition: theme.transitions.create('transform', transition),
            '&:hover': {
                // Disable the hover effect for the IconButton,
                // because a hover effect should apply to the entire Expand button and
                // not only to the IconButton.
                backgroundColor: 'transparent'
            },
            '&$expanded': {
                transform: 'rotate(180deg)'
            }
        }
    };
};
var $076b6dd35d98da64$var$AccordionSummary = /*#__PURE__*/ $7fPBF.forwardRef(function AccordionSummary(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, expandIcon = props.expandIcon, focusVisibleClassName = props.focusVisibleClassName, _props$IconButtonProp = props.IconButtonProps, IconButtonProps = _props$IconButtonProp === void 0 ? {} : _props$IconButtonProp, onClick = props.onClick, other = (0, $lfiYO.default)(props, [
        "children",
        "classes",
        "className",
        "expandIcon",
        "focusVisibleClassName",
        "IconButtonProps",
        "onClick"
    ]);
    var _React$useContext = $7fPBF.useContext((0, $76225d5ebf2e132f$export$2e2bcd8739ae039)), _React$useContext$dis = _React$useContext.disabled, disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis, expanded = _React$useContext.expanded, toggle = _React$useContext.toggle;
    var handleChange = function handleChange(event) {
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $gd1Bg.default), (0, $kY3Ke.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $jtRae.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded),
        focusVisibleClassName: (0, $jtRae.default)(classes.focusVisible, classes.focused, focusVisibleClassName),
        onClick: handleChange,
        ref: ref
    }, other), /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, $jtRae.default)(classes.content, expanded && classes.expanded)
    }, children), expandIcon && /*#__PURE__*/ $7fPBF.createElement((0, $iRcsz.default), (0, $kY3Ke.default)({
        className: (0, $jtRae.default)(classes.expandIcon, expanded && classes.expanded),
        edge: "end",
        component: "div",
        tabIndex: null,
        role: null,
        "aria-hidden": true
    }, IconButtonProps), expandIcon));
});
var $076b6dd35d98da64$export$2e2bcd8739ae039 = (0, $3Sc7z.default)($076b6dd35d98da64$export$9dd6ff9ea0189349, {
    name: 'MuiAccordionSummary'
})($076b6dd35d98da64$var$AccordionSummary);


var $by0pu = parcelRequire("by0pu");
var $fH0xA = parcelRequire("fH0xA");

var $6qwOn = parcelRequire("6qwOn");











var $fwAOd = parcelRequire("fwAOd");

const $595b4f22f68b7fd4$var$DeleteObjectiveModal = ({ open: open, onClose: onClose, objective: objective, onSuccess: onSuccess })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const mutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        await (0, $553835ea16648c6f$export$f524d4048408793c)(objective.id);
    }, {
        onSuccess: ()=>{
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            onClose();
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $10c0df872321f413$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $873c41bd01dae2f9$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                        children: objective.name
                    }),
                    " - ",
                    t('objective.dialog.delete.title')
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $909ad9fcbee124ba$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c20b368aae28118$export$2e2bcd8739ae039), {
                    children: t('objective.alert.deleteConfirmation')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ca0b0ca6e141049d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: mutation.mutate,
                        color: "primary",
                        variant: "contained",
                        children: t('objective.dialog.save')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: onClose,
                        color: "primary",
                        children: t('objective.dialog.cancel')
                    })
                ]
            })
        ]
    });
};
var $595b4f22f68b7fd4$export$2e2bcd8739ae039 = $595b4f22f68b7fd4$var$DeleteObjectiveModal;


const $08432df66dbb740b$var$useStyles = (0, $by0pu.default)((theme)=>({
        root: {
            width: '100%'
        },
        expansionPanel: {
            borderBottom: '1px solid #DFE0EB'
        },
        detailsContainer: {
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column'
            }
        }
    }));
const $08432df66dbb740b$var$ObjectiveItem = ({ objective: objective = {}, onSubmitSuccess: onSubmitSuccess })=>{
    const classes = $08432df66dbb740b$var$useStyles();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const theme = (0, $fH0xA.default)();
    const md = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('md'));
    (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn))).locale('hu');
    const [isPanelOpened, setPanelOpen] = (0, $7fPBF.useState)(false);
    const [updateDialogOpen, setUpdateDialogOpen] = (0, $7fPBF.useState)(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = (0, $7fPBF.useState)(false);
    const employeeIdOfCurrentUser = objective.employee_id;
    const isEditable = objective.status !== (0, $f6e729db3f817bb5$exports.STATUS).COMPLETED && objective.status !== (0, $f6e729db3f817bb5$exports.STATUS).FAILED && objective.employee_id === objective.proposed_by;
    const isDeletable = objective.status === (0, $f6e729db3f817bb5$exports.STATUS).PROPOSED && objective.employee_id === objective.proposed_by;
    const objectiveRelationsQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'objectiveRelations',
        objective.id
    ], async ()=>{
        const { data: data } = await (0, $5b370f02b85c28ed$export$77de90c6937e3257)({
            objectiveId: objective.id
        });
        return data;
    }, {
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    var _objectiveRelationsQuery_data;
    const objectiveRelations = (_objectiveRelationsQuery_data = objectiveRelationsQuery.data) !== null && _objectiveRelationsQuery_data !== void 0 ? _objectiveRelationsQuery_data : [];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $8eb56da890a42ae3$export$2e2bcd8739ae039), {
            square: true,
            className: classes.expansionPanel,
            expanded: isPanelOpened,
            elevation: md ? 0 : 1,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $076b6dd35d98da64$export$2e2bcd8739ae039), {
                    "aria-controls": "panel1a-content",
                    id: objective.objective_id,
                    onClick: ()=>setPanelOpen(!isPanelOpened),
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b2f2a6ac7fc7de65$export$2e2bcd8739ae039), {
                        objective: objective,
                        setUpdateDialogOpen: setUpdateDialogOpen,
                        setDeleteDialogOpen: setDeleteDialogOpen,
                        isEditable: isEditable,
                        isDeletable: isDeletable,
                        isPanelOpened: isPanelOpened,
                        onSubmitSuccess: onSubmitSuccess
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0027963611e4ddbd$export$2e2bcd8739ae039), {
                    className: classes.detailsContainer,
                    children: isPanelOpened && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        container: true,
                        direction: 'column',
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9b36a890191564c2$export$2e2bcd8739ae039), {
                            objectiveRelations: objectiveRelations,
                            objective: objective,
                            onSubmitSuccess: onSubmitSuccess
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3447d4985bafc2a$export$2e2bcd8739ae039), {
                    open: updateDialogOpen,
                    handleClose: ()=>setUpdateDialogOpen(false),
                    objectiveItem: objective,
                    employeeIdOfCurrentUser: employeeIdOfCurrentUser,
                    onSubmitSuccess: onSubmitSuccess
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $595b4f22f68b7fd4$export$2e2bcd8739ae039), {
                    open: deleteDialogOpen,
                    onClose: ()=>setDeleteDialogOpen(false),
                    objective: objective,
                    onSuccess: onSubmitSuccess
                })
            ]
        })
    });
};
var $08432df66dbb740b$export$2e2bcd8739ae039 = $08432df66dbb740b$var$ObjectiveItem;




var $764cb88797df0c14$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($764cb88797df0c14$exports, "__esModule", {
    value: true
});
$764cb88797df0c14$exports.default = void 0;

var $764cb88797df0c14$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $764cb88797df0c14$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $764cb88797df0c14$var$_default = (0, $764cb88797df0c14$var$_createSvgIcon.default)(/*#__PURE__*/ $764cb88797df0c14$var$React.createElement("path", {
    d: "M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59a.9959.9959 0 00-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
}), 'ArrowUpwardRounded');
$764cb88797df0c14$exports.default = $764cb88797df0c14$var$_default;



var $jtRae = parcelRequire("jtRae");
const $252e2ed8d7363a2e$var$useStyles = (0, $by0pu.default)((theme)=>({
        root: {
            margin: 16,
            verticalAlign: 'middle'
        },
        header: {
            display: 'grid',
            width: '100%',
            gridGap: 8,
            alignItems: 'center',
            gridTemplateColumns: '1fr 1fr 1fr 1fr',
            gridTemplateAreas: `
      'name     name     actions  actions'
      'divider1 divider1 divider1   divider1'
      'category deadline weight     mean'
      'divider2 divider2 divider2   divider2'
      'status   status   rating     rating'
      `,
            [theme.breakpoints.up('md')]: {
                gridTemplateColumns: '1fr 1fr 75px 65px 1fr 1fr 65px 96px',
                gridTemplateAreas: `
        'name category deadline weight status rating mean actions'
      `
            }
        },
        headerButton: {
            color: '#999999',
            justifyContent: 'flex-start',
            minWidth: 0,
            height: 'unset',
            fontSize: 11,
            marginLeft: -8,
            '& svg': {
                height: 20,
                width: 20
            },
            '& p': {
                margin: 0
            },
            '&.Mui-disabled': {
                color: '#999999'
            },
            '& .MuiButton-label': {
                height: 20
            }
        },
        list: {
            padding: 0
        },
        listItem: {
            padding: 0,
            marginBottom: 16,
            [theme.breakpoints.up('md')]: {
                marginBottom: 0
            }
        },
        groupColumns: {
            gridTemplateColumns: '1fr 1fr 1fr 1fr',
            gridTemplateAreas: `
      'name     name     actions    actions'
      'divider1 divider1 divider1   divider1'
      'category deadline weight     mean'
      'divider2 divider2 divider2   divider2'
      'status   status   rating     rating'
      'divider3 divider3 divider3   divider3'
      'group    group    appraiser  appraiser'
      `,
            [theme.breakpoints.up('md')]: {
                gridTemplateColumns: '1fr 1fr 1fr 1fr 75px 65px 1fr 1fr 65px 96px',
                gridTemplateAreas: `
        'name category group appraiser deadline weight status rating mean actions'
      `
            }
        }
    }), {
    name: 'ObjectiveList'
});
const $252e2ed8d7363a2e$var$ObjectiveList = ({ objectives: objectives, loading: loading, onSubmitSuccess: onSubmitSuccess, canLoadMore: canLoadMore, loadMore: loadMore, showGroupColumns: showGroupColumns })=>{
    const classes = $252e2ed8d7363a2e$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const theme = (0, $fH0xA.default)();
    const md = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('md'));
    const { items: items, requestSort: requestSort, sortConfig: sortConfig } = (0, $60cfffc9961daa74$export$2b3d2f2382009a90)(objectives);
    const arrowButton = {
        ascending: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a0a03b09113b2fa7$exports))), {}),
        descending: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($764cb88797df0c14$exports))), {})
    };
    const getClassNamesFor = (name)=>{
        if (!sortConfig) return;
        return sortConfig.key === name ? arrowButton[sortConfig.direction] : '';
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ckpfM.default), {
                className: classes.root,
                children: [
                    md && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d57f8c5132119daf$export$2e2bcd8739ae039), {
                        px: 2,
                        borderBottom: '1px solid #DFE0EB',
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: (0, $jtRae.default)(classes.header, {
                                [classes.groupColumns]: showGroupColumns
                            }),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fwAOd.default), {
                                    onClick: ()=>requestSort('name'),
                                    style: {
                                        gridArea: 'name'
                                    },
                                    className: classes.headerButton,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t('objective.listHeader.name')
                                        }),
                                        getClassNamesFor('name')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fwAOd.default), {
                                    onClick: ()=>requestSort('category'),
                                    style: {
                                        gridArea: 'category'
                                    },
                                    className: classes.headerButton,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t('objective.listHeader.category')
                                        }),
                                        getClassNamesFor('category')
                                    ]
                                }),
                                showGroupColumns && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fwAOd.default), {
                                            // onClick={ () => requestSort('appraiser') }
                                            style: {
                                                gridArea: 'group'
                                            },
                                            className: classes.headerButton,
                                            disabled: true,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: t('objective.listHeader.group')
                                                }),
                                                getClassNamesFor('appraiser')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fwAOd.default), {
                                            // onClick={ () => requestSort('appraiser') }
                                            style: {
                                                gridArea: 'appraiser'
                                            },
                                            className: classes.headerButton,
                                            disabled: true,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: t('objective.listHeader.appraiser')
                                                }),
                                                getClassNamesFor('appraiser')
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fwAOd.default), {
                                    onClick: ()=>requestSort('deadline'),
                                    style: {
                                        gridArea: 'deadline'
                                    },
                                    className: classes.headerButton,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t('objective.listHeader.deadline')
                                        }),
                                        getClassNamesFor('deadline')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fwAOd.default), {
                                    onClick: ()=>requestSort('weight'),
                                    style: {
                                        gridArea: 'weight'
                                    },
                                    className: classes.headerButton,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t('objective.listHeader.weight')
                                        }),
                                        getClassNamesFor('weight')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fwAOd.default), {
                                    onClick: ()=>requestSort('status'),
                                    style: {
                                        gridArea: 'status'
                                    },
                                    className: classes.headerButton,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t('objective.listHeader.status')
                                        }),
                                        getClassNamesFor('status')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                                    // onClick={() => requestSort('')}
                                    style: {
                                        gridArea: 'rating'
                                    },
                                    className: classes.headerButton,
                                    disabled: true,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: t('objective.listHeader.rating')
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                                    // onClick={() => requestSort('')}
                                    style: {
                                        gridArea: 'mean'
                                    },
                                    className: classes.headerButton,
                                    disabled: true,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: t('objective.listHeader.result')
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    style: {
                                        gridArea: 'actions'
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fOH1P.default), {
                        className: classes.list,
                        children: items.map((objective)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hPUC4.default), {
                                className: classes.listItem,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $08432df66dbb740b$export$2e2bcd8739ae039), {
                                    objective: objective,
                                    onSubmitSuccess: onSubmitSuccess
                                }, objective.objective_id)
                            }, objective.objective_id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $36b809d1f393b765$export$2e2bcd8739ae039), {
                    loading: loading,
                    canLoadMore: canLoadMore,
                    loadMore: loadMore,
                    loadMoreTranslation: t('objectiveList.loadMoreBtn'),
                    noMoreToLoadTranslation: t('objectiveList.NoMoreObjectives')
                })
            })
        ]
    });
};
var $252e2ed8d7363a2e$export$2e2bcd8739ae039 = $252e2ed8d7363a2e$var$ObjectiveList;




var $7fPBF = parcelRequire("7fPBF");

const $5e95649937aab08b$var$FilterContext = /*#__PURE__*/ (0, $7fPBF.createContext)({
    statusFilters: [],
    handleStatusFiltersChange: ()=>{},
    developmentStatusFilters: [],
    handleDevelopmentStatusFiltersChange: ()=>{},
    categoryFilters: [],
    handleCategoryFiltersChange: ()=>{},
    dateRange: {
        from: null,
        to: null
    },
    setDateRange: ()=>{},
    fixDateValue: null,
    setFixDateValue: ()=>{},
    resetFilters: ()=>{}
});
const $5e95649937aab08b$export$396ef541d9951d45 = ()=>(0, $7fPBF.useContext)($5e95649937aab08b$var$FilterContext);
const $5e95649937aab08b$var$FilterProvider = ({ defaultValues: defaultValues = {}, children: children })=>{
    var _defaultValues_statusFilters;
    const [statusFilters, setStatusFilters] = (0, $7fPBF.useState)((_defaultValues_statusFilters = defaultValues.statusFilters) !== null && _defaultValues_statusFilters !== void 0 ? _defaultValues_statusFilters : []);
    var _defaultValues_developmentStatusFilters;
    const [developmentStatusFilters, setDevelopmentStatusFilters] = (0, $7fPBF.useState)((_defaultValues_developmentStatusFilters = defaultValues.developmentStatusFilters) !== null && _defaultValues_developmentStatusFilters !== void 0 ? _defaultValues_developmentStatusFilters : []);
    var _defaultValues_categoryFilters;
    const [categoryFilters, setCategoryFilters] = (0, $7fPBF.useState)((_defaultValues_categoryFilters = defaultValues.categoryFilters) !== null && _defaultValues_categoryFilters !== void 0 ? _defaultValues_categoryFilters : []);
    var _defaultValues_selectedDateRange;
    const [dateRange, setDateRange] = (0, $7fPBF.useState)((_defaultValues_selectedDateRange = defaultValues.selectedDateRange) !== null && _defaultValues_selectedDateRange !== void 0 ? _defaultValues_selectedDateRange : {
        from: null,
        to: null
    });
    var _defaultValues_fixDateValue;
    const [fixDateValue, setFixDateValue] = (0, $7fPBF.useState)((_defaultValues_fixDateValue = defaultValues.fixDateValue) !== null && _defaultValues_fixDateValue !== void 0 ? _defaultValues_fixDateValue : null);
    const handleStatusFiltersChange = (status)=>{
        const isNewFilter = !statusFilters.includes(status);
        const newStatusFilters = isNewFilter ? statusFilters.concat([
            status
        ]) : statusFilters.filter((filter)=>filter !== status);
        setStatusFilters(newStatusFilters);
        if (status === (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE && statusFilters.includes((0, $f6e729db3f817bb5$exports.STATUS).ACTIVE) || statusFilters.length >= 1 && statusFilters.includes((0, $f6e729db3f817bb5$exports.STATUS).ACTIVE)) setDevelopmentStatusFilters([]);
    };
    const handleDevelopmentStatusFiltersChange = (developmentStatus)=>{
        const isNewFilter = !developmentStatusFilters.includes(developmentStatus);
        const newDevelopmentStatusFilters = isNewFilter ? developmentStatusFilters.concat([
            developmentStatus
        ]) : developmentStatusFilters.filter((filter)=>filter !== developmentStatus);
        setDevelopmentStatusFilters(newDevelopmentStatusFilters);
    };
    const handleCategoryFiltersChange = (category)=>{
        const isNewFilter = !categoryFilters.includes(category);
        const newFilters = isNewFilter ? categoryFilters.concat([
            category
        ]) : categoryFilters.filter((filter)=>filter !== category);
        setCategoryFilters(newFilters);
    };
    const resetFilters = ()=>{
        setStatusFilters([]);
        setDevelopmentStatusFilters([]);
        setCategoryFilters([]);
        setDateRange({
            from: null,
            to: null
        });
        setFixDateValue(null);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($5e95649937aab08b$var$FilterContext.Provider, {
        value: {
            statusFilters: statusFilters,
            handleStatusFiltersChange: handleStatusFiltersChange,
            developmentStatusFilters: developmentStatusFilters,
            handleDevelopmentStatusFiltersChange: handleDevelopmentStatusFiltersChange,
            categoryFilters: categoryFilters,
            handleCategoryFiltersChange: handleCategoryFiltersChange,
            dateRange: dateRange,
            setDateRange: setDateRange,
            fixDateValue: fixDateValue,
            setFixDateValue: setFixDateValue,
            resetFilters: resetFilters,
            setStatusFilters: setStatusFilters,
            setDevelopmentStatusFilters: setDevelopmentStatusFilters
        },
        children: children
    });
};
var $5e95649937aab08b$export$2e2bcd8739ae039 = $5e95649937aab08b$var$FilterProvider;


const $47950fba2515545b$var$GroupObjectives = ()=>{
    var _objectivesQuery_data;
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { statusFilters: statusFilters, developmentStatusFilters: developmentStatusFilters, categoryFilters: categoryFilters, dateRange: dateRange } = (0, $5e95649937aab08b$export$396ef541d9951d45)();
    const objectivesQuery = (0, $2bc6258289aa5150$export$bdc59d3c1a6569aa)([
        'objectives',
        statusFilters,
        developmentStatusFilters,
        categoryFilters,
        dateRange
    ], async ({ pageParam: pageParam = 0 })=>{
        var _this, _this1;
        const { data: data } = await (0, $553835ea16648c6f$export$1a58453a98bcf79e)({
            offset: pageParam,
            filters: {
                statuses: statusFilters || '',
                developmentStatuses: developmentStatusFilters || '',
                categories: categoryFilters || '',
                dateStart: dateRange.from ? (_this = new Date((0, $8bfb433bad942c35$export$1e32f7407816b987)(dateRange.from))) === null || _this === void 0 ? void 0 : _this.toISOString() : null,
                dateEnd: dateRange.to ? (_this1 = new Date((0, $8bfb433bad942c35$export$1e32f7407816b987)(dateRange.to))) === null || _this1 === void 0 ? void 0 : _this1.toISOString() : null
            }
        });
        return data;
    }, {
        getNextPageParam: (lastPage, allPages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) ? allPages === null || allPages === void 0 ? void 0 : allPages.flat().length : undefined;
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    var _objectivesQuery_data_pages_flat;
    const objectives = (_objectivesQuery_data_pages_flat = (_objectivesQuery_data = objectivesQuery.data) === null || _objectivesQuery_data === void 0 ? void 0 : _objectivesQuery_data.pages.flat()) !== null && _objectivesQuery_data_pages_flat !== void 0 ? _objectivesQuery_data_pages_flat : [];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $252e2ed8d7363a2e$export$2e2bcd8739ae039), {
        objectives: objectives,
        loading: objectivesQuery.isFetching,
        onSubmitSuccess: objectivesQuery.refetch,
        canLoadMore: objectivesQuery.hasNextPage,
        loadMore: objectivesQuery.fetchNextPage,
        showGroupColumns: true
    });
};
var $47950fba2515545b$export$2e2bcd8739ae039 = $47950fba2515545b$var$GroupObjectives;



parcelRequire("7fPBF");

var $by0pu = parcelRequire("by0pu");
var $fH0xA = parcelRequire("fH0xA");



parcelRequire("7fPBF");


var $fwAOd = parcelRequire("fwAOd");







function $4405d79342e3778c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $ef64b5b7aae137f5$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $5dcf6825012fa4ab$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $3b831424db570743$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



const { EN: $993b1397da441086$var$EN, DE: $993b1397da441086$var$DE } = (0, $f6e729db3f817bb5$exports.SUPPORTED_LANGUAGES);
const $993b1397da441086$var$DateRangePicker = (_param)=>{
    var { selectedDateRange: selectedDateRange, setSelectedDateRange: setSelectedDateRange } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "selectedDateRange",
        "setSelectedDateRange"
    ]);
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const now = new Date();
    const lastYear = (0, $5dcf6825012fa4ab$export$2e2bcd8739ae039)(now, 1);
    const thisYearValue = {
        from: (0, $8bfb433bad942c35$export$f470d795e00a1a60)((0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(now)),
        to: (0, $8bfb433bad942c35$export$f470d795e00a1a60)((0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(now))
    };
    const lastYearValue = {
        from: (0, $8bfb433bad942c35$export$f470d795e00a1a60)((0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(lastYear)),
        to: (0, $8bfb433bad942c35$export$f470d795e00a1a60)((0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(lastYear))
    };
    const lastWeekValue = {
        from: (0, $8bfb433bad942c35$export$f470d795e00a1a60)((0, $4405d79342e3778c$export$2e2bcd8739ae039)(now, 1)),
        to: (0, $8bfb433bad942c35$export$f470d795e00a1a60)(now)
    };
    const next2WeeksValue = {
        from: (0, $8bfb433bad942c35$export$f470d795e00a1a60)(now),
        to: (0, $8bfb433bad942c35$export$f470d795e00a1a60)((0, $ef64b5b7aae137f5$export$2e2bcd8739ae039)(now, 2))
    };
    const handleOnChange = (value)=>(e)=>{
            setSelectedDateRange(value);
            e.target.blur();
        };
    const renderCustomInput = ({ ref: ref })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
            readOnly: true,
            ref: ref,
            placeholder: t('objective.filtering.dateRange.label'),
            value: selectedDateRange.from && selectedDateRange.to ? `${(0, $8bfb433bad942c35$export$1e32f7407816b987)(selectedDateRange.from)} - ${(0, $8bfb433bad942c35$export$1e32f7407816b987)(selectedDateRange.to)}` : '',
            style: {
                textAlign: 'center',
                padding: '0.5rem 0.5rem',
                width: '18rem',
                letterSpacing: '0.03rem',
                fontSize: '1rem',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                color: 'currentColor',
                outline: 'none'
            },
            className: "date-range-picker-input"
        });
    const renderCustomFooter = ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "datePicker-custom-footer",
            style: {
                display: 'flex',
                flexDirection: 'column',
                gridGap: 8,
                padding: 8
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: handleOnChange(thisYearValue),
                    variant: "outlined",
                    color: "primary",
                    className: "this-year",
                    children: t('objective.filtering.dateRange.thisYear')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: handleOnChange(lastYearValue),
                    variant: "outlined",
                    color: "primary",
                    className: "last-year",
                    children: t('objective.filtering.dateRange.lastYear')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: handleOnChange(lastWeekValue),
                    variant: "outlined",
                    color: "primary",
                    className: "last-week",
                    children: t('objective.filtering.dateRange.lastWeek')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: handleOnChange(next2WeeksValue),
                    variant: "outlined",
                    color: "primary",
                    className: "next2-weeks",
                    children: t('objective.filtering.dateRange.next2Weeks')
                })
            ]
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b871b7860d2a9903$exports))), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        value: selectedDateRange,
        shouldHighlightWeekends: true,
        colorPrimary: "#99B64E",
        onChange: setSelectedDateRange,
        renderInput: renderCustomInput,
        renderFooter: renderCustomFooter,
        locale: i18n.language === $993b1397da441086$var$EN ? $993b1397da441086$var$EN : i18n.language === $993b1397da441086$var$DE ? (0, $69c5fe3566014017$export$a3f37cad7baac28f) : (0, $69c5fe3566014017$export$2f97ab58db958e4f),
        calendarPopperPosition: "bottom"
    }, props));
};
var $993b1397da441086$export$2e2bcd8739ae039 = $993b1397da441086$var$DateRangePicker;




var $7fPBF = parcelRequire("7fPBF");


var $fwAOd = parcelRequire("fwAOd");
var $i8OTH = parcelRequire("i8OTH");
var $fOH1P = parcelRequire("fOH1P");
var $hPUC4 = parcelRequire("hPUC4");
var $fHFY6 = parcelRequire("fHFY6");
var $by0pu = parcelRequire("by0pu");
var $9zU0q = parcelRequire("9zU0q");
var $hzQpW = parcelRequire("hzQpW");
var $1rW9t = parcelRequire("1rW9t");

const $ce10a9ded7e022d3$var$useStyles = (0, $by0pu.default)({
    listItemIcon: {
        minWidth: 'unset'
    },
    checkbox: {
        '&:hover': {
            background: 'transparent'
        }
    },
    listItemText: {
        paddingRight: 8,
        fontSize: 14
    }
}, {
    name: 'StatusFilter'
});
const $ce10a9ded7e022d3$var$StatusFilter = ({ type: type, statuses: statuses, statusFilters: statusFilters, handleStatusFilter: handleStatusFilter, disabled: disabled })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $ce10a9ded7e022d3$var$useStyles();
    const [anchor, setAnchor] = (0, $7fPBF.useState)(null);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                title: disabled ? t(`objective.filter.warning.developmentStatus`) : '',
                arrow: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        className: `StatusFilter-${type}-button`,
                        onClick: (e)=>setAnchor(e.currentTarget),
                        disabled: disabled,
                        startIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), {
                            color: "primary",
                            checked: !!statusFilters.length,
                            disableRipple: true,
                            className: classes.checkbox,
                            disabled: disabled
                        }),
                        endIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34df12d346b1bb0d$export$2e2bcd8739ae039), {}),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            className: classes.listItemText,
                            children: t(`objective.filter.${type}`)
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9zU0q.default), {
                open: !!anchor,
                anchorEl: anchor,
                onClose: ()=>setAnchor(null),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fOH1P.default), {
                    className: "status-list",
                    children: statuses.map((status)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $hPUC4.default), {
                            onClick: ()=>handleStatusFilter(status),
                            button: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fHFY6.default), {
                                    className: classes.listItemIcon,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), {
                                        color: "primary",
                                        checked: statusFilters.includes(status),
                                        disableRipple: true,
                                        className: classes.checkbox,
                                        value: status
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2875d42fcb2a6c2$export$2e2bcd8739ae039), {
                                    className: classes.listItemText,
                                    children: t(`objective.${type}.${status}`)
                                })
                            ]
                        }, status))
                })
            })
        ]
    });
};
var $ce10a9ded7e022d3$export$2e2bcd8739ae039 = $ce10a9ded7e022d3$var$StatusFilter;



parcelRequire("7fPBF");

var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");
var $080938b804d47fd6$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($080938b804d47fd6$exports, "__esModule", {
    value: true
});
$080938b804d47fd6$exports.default = void 0;

var $080938b804d47fd6$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $080938b804d47fd6$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $080938b804d47fd6$var$_default = (0, $080938b804d47fd6$var$_createSvgIcon.default)(/*#__PURE__*/ $080938b804d47fd6$var$React.createElement("path", {
    d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'HighlightOff');
$080938b804d47fd6$exports.default = $080938b804d47fd6$var$_default;




const $4de3e80ff0c39e0c$var$ClearFiltersButton = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { statusFilters: statusFilters, developmentStatusFilters: developmentStatusFilters, categoryFilters: categoryFilters, dateRange: dateRange, resetFilters: resetFilters } = (0, $5e95649937aab08b$export$396ef541d9951d45)();
    const isDateFiltered = dateRange.from && dateRange.to;
    const useStyles = (0, $by0pu.default)({
        filterGroup: {
            display: 'flex',
            gridGap: 8
        }
    }, {
        name: 'ClearFitlerButton'
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: classes.filterGroup,
        children: (isDateFiltered || statusFilters.length !== 0 || developmentStatusFilters.length !== 0 || categoryFilters.length !== 0) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
            onClick: resetFilters,
            endIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($080938b804d47fd6$exports))), {}),
            children: t('objective.filter.clear')
        })
    });
};
var $4de3e80ff0c39e0c$export$2e2bcd8739ae039 = $4de3e80ff0c39e0c$var$ClearFiltersButton;




var $7fPBF = parcelRequire("7fPBF");


var $fwAOd = parcelRequire("fwAOd");
var $i8OTH = parcelRequire("i8OTH");
var $fOH1P = parcelRequire("fOH1P");
var $hPUC4 = parcelRequire("hPUC4");
var $fHFY6 = parcelRequire("fHFY6");
var $by0pu = parcelRequire("by0pu");
var $9zU0q = parcelRequire("9zU0q");
var $1rW9t = parcelRequire("1rW9t");


const $3b4ff8150203e672$var$useStyles = (0, $by0pu.default)({
    listItemIcon: {
        minWidth: 'unset'
    },
    checkbox: {
        '&:hover': {
            background: 'transparent'
        }
    },
    listItemText: {
        fontSize: 14
    }
}, {
    name: 'CategoryFilter'
});
const $3b4ff8150203e672$var$CategoryFilter = ({ categoryFilters: categoryFilters, handleCategoryFilter: handleCategoryFilter })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $3b4ff8150203e672$var$useStyles();
    const categories = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.accountInfo.categories);
    const [anchor, setAnchor] = (0, $7fPBF.useState)(null);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                onClick: (e)=>setAnchor(e.currentTarget),
                className: "CategoryFilter-buton",
                startIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), {
                    color: "primary",
                    checked: !!categoryFilters.length,
                    disableRipple: true,
                    className: classes.checkbox
                }),
                endIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34df12d346b1bb0d$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                    className: classes.listItemText,
                    children: t('objective.listHeader.category')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9zU0q.default), {
                open: !!anchor,
                anchorEl: anchor,
                onClose: ()=>setAnchor(null),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fOH1P.default), {
                    className: "Category-list",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $hPUC4.default), {
                            onClick: ()=>handleCategoryFilter(''),
                            button: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fHFY6.default), {
                                    className: classes.listItemIcon,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), {
                                        color: "primary",
                                        checked: categoryFilters.includes(''),
                                        disableRipple: true,
                                        className: classes.checkbox
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2875d42fcb2a6c2$export$2e2bcd8739ae039), {
                                    className: classes.listItemText,
                                    children: "-"
                                })
                            ]
                        }),
                        (categories !== null && categories !== void 0 ? categories : []).map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $hPUC4.default), {
                                onClick: ()=>handleCategoryFilter(category.category_name.hu),
                                button: true,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fHFY6.default), {
                                        className: classes.listItemIcon,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), {
                                            color: "primary",
                                            checked: categoryFilters.includes(category.category_name.hu),
                                            disableRipple: true,
                                            className: classes.checkbox,
                                            value: category.category_name.hu
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f2875d42fcb2a6c2$export$2e2bcd8739ae039), {
                                        className: classes.listItemText,
                                        children: category.category_name.hu
                                    })
                                ]
                            }, category))
                    ]
                })
            })
        ]
    });
};
var $3b4ff8150203e672$export$2e2bcd8739ae039 = $3b4ff8150203e672$var$CategoryFilter;




const $281226a9c8e4918a$var$useStyles = (0, $by0pu.default)({
    row: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gridGap: 8,
        alignItems: 'center',
        '&:not(:last-child)': {
            marginBottom: 8
        }
    },
    filterGroup: {
        display: 'flex',
        gridGap: 8
    }
}, {
    name: 'Filters'
});
const $281226a9c8e4918a$var$Filters = ()=>{
    const classes = $281226a9c8e4918a$var$useStyles();
    const theme = (0, $fH0xA.default)();
    const sm = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const { statusFilters: statusFilters, handleStatusFiltersChange: handleStatusFiltersChange, developmentStatusFilters: developmentStatusFilters, handleDevelopmentStatusFiltersChange: handleDevelopmentStatusFiltersChange, categoryFilters: categoryFilters, handleCategoryFiltersChange: handleCategoryFiltersChange, dateRange: dateRange, setDateRange: setDateRange } = (0, $5e95649937aab08b$export$396ef541d9951d45)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: sm ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: classes.row,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: classes.filterGroup,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce10a9ded7e022d3$export$2e2bcd8739ae039), {
                            type: (0, $f6e729db3f817bb5$exports.STATUS_TYPES).STATUS,
                            statuses: Object.values((0, $f6e729db3f817bb5$exports.STATUS)),
                            handleStatusFilter: handleStatusFiltersChange,
                            statusFilters: statusFilters
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce10a9ded7e022d3$export$2e2bcd8739ae039), {
                            type: (0, $f6e729db3f817bb5$exports.STATUS_TYPES).DEVELOPMENT_STATUS,
                            statuses: Object.values((0, $f6e729db3f817bb5$exports.DEVELOPMENT_STATUS)),
                            handleStatusFilter: handleDevelopmentStatusFiltersChange,
                            statusFilters: developmentStatusFilters,
                            disabled: !statusFilters.includes((0, $f6e729db3f817bb5$exports.STATUS).ACTIVE) || statusFilters.length > 1 && statusFilters.includes((0, $f6e729db3f817bb5$exports.STATUS).ACTIVE)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4ff8150203e672$export$2e2bcd8739ae039), {
                            handleCategoryFilter: handleCategoryFiltersChange,
                            categoryFilters: categoryFilters
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: classes.filterGroup,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $993b1397da441086$export$2e2bcd8739ae039), {
                        selectedDateRange: dateRange,
                        setSelectedDateRange: setDateRange
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4de3e80ff0c39e0c$export$2e2bcd8739ae039), {})
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4de3e80ff0c39e0c$export$2e2bcd8739ae039), {})
    });
};
var $281226a9c8e4918a$export$2e2bcd8739ae039 = $281226a9c8e4918a$var$Filters;



const $50b4a5e380d3c4ed$var$GroupObjectivePage = ()=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const theme = (0, $fH0xA.default)();
    const sm = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const [drawerOpen, setDrawerOpen] = (0, $7fPBF.useState)(false);
    const employee = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee);
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $74750fb419d4223b$export$eb48dd7746a93f2a)());
        if (JSON.stringify(employee) === '{}') dispatch((0, $401a17725816a5a8$export$d5f42470fa5a7347)()).then((employee)=>{
            (0, $c2fa3f0a340dc103$export$ac983537af4b3a6d)(employee === null || employee === void 0 ? void 0 : employee.language);
        });
    }, [
        dispatch,
        employee
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5e95649937aab08b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $899ea3d88a7a8f04$export$2e2bcd8739ae039), {
                drawerOpen: drawerOpen,
                setDrawerOpen: setDrawerOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    marginLeft: !sm ? 'auto' : drawerOpen ? `${0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH}px` : '55px'
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d57f8c5132119daf$export$2e2bcd8739ae039), {
                        m: 2,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $281226a9c8e4918a$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $47950fba2515545b$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $50b4a5e380d3c4ed$export$2e2bcd8739ae039 = $50b4a5e380d3c4ed$var$GroupObjectivePage;



var $7fPBF = parcelRequire("7fPBF");



const $ea770b7d5c81ac8c$var$InjectAxiosInterceptors = ()=>{
    const history = (0, $560cbe427eb95a5b$export$3420e1dc2c4a518c)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $c5b59547f7a0f380$export$443273ce444d1cfc)(history, t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        history
    ]);
    // not rendering anything
    return null;
};
var $ea770b7d5c81ac8c$export$2e2bcd8739ae039 = $ea770b7d5c81ac8c$var$InjectAxiosInterceptors;




var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $5278824381c7d973$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
}), 'Group');


var $7fPBF = parcelRequire("7fPBF");

var $319Q5 = parcelRequire("319Q5");
var $5d8aa3cfd0a7f968$export$2e2bcd8739ae039 = (0, $319Q5.default)(/*#__PURE__*/ $7fPBF.createElement("path", {
    d: "M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"
}), 'Note');




var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");

var $ckpfM = parcelRequire("ckpfM");

var $1rW9t = parcelRequire("1rW9t");

var $MQfsM = parcelRequire("MQfsM");






const $94977a2c99b466d7$export$83d3388cc66dd8c6 = (str)=>{
    return str.split(/\s/).join('');
};



const $82c46e29820dc6b6$var$Login = (props)=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const url = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $295ca3e31a29edec$export$48a4dab9caeca3ef));
    const [loginName, setLoginName] = (0, $7fPBF.useState)('');
    const [password, setPassword] = (0, $7fPBF.useState)('');
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    (0, $7fPBF.useEffect)(()=>{
        if (localStorage.getItem('jwtToken')) props.history.push(url);
    }, [
        props.history,
        url
    ]);
    const handleKeyPress = (event)=>{
        if (event.charCode === 13) handleLogin();
    };
    const handleLogin = async ()=>{
        try {
            await (0, $e4998d3746b968db$export$596d806903d1f59e)({
                loginName: loginName,
                password: password
            });
            const { language: language, hasValidObjectiveManagementLicence: hasValidObjectiveManagementLicence } = await (0, $c2fa3f0a340dc103$export$801fe16824f675f7)();
            dispatch((0, $9abcdbaae8311c9d$export$69adbc1c065b23cf)(hasValidObjectiveManagementLicence));
            (0, $c2fa3f0a340dc103$export$ac983537af4b3a6d)(language);
            props.history.push(url);
        } catch (error) {
            const { message: message } = error;
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: `login.alert.${message}`,
                severity: 'error'
            }));
        }
    };
    const handleOnChangeEmployeeId = (event)=>setLoginName((0, $94977a2c99b466d7$export$83d3388cc66dd8c6)(event.target.value));
    const handleOnChangePassword = (event)=>setPassword(event.target.value);
    const useStyles = (0, $by0pu.default)({
        root: {
            justify: 'center',
            minHeight: '100vh',
            backgroundImage: `url(${(0, {})})`,
            backgroundSize: 'contain',
            backgroundPosition: '-180px'
        },
        paper: {
            padding: '20px',
            width: '250px'
        },
        textField: {
            width: '100%',
            marginTop: '10px',
            marginBottom: '10px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        container: true,
        className: classes.root,
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ckpfM.default), {
            className: classes.paper,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    direction: 'column',
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            variant: "h5",
                            component: "h3",
                            children: t('login.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            label: t('login.label.user_name'),
                            className: classes.textField,
                            onChange: handleOnChangeEmployeeId,
                            value: loginName,
                            onKeyPress: handleKeyPress
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            type: "password",
                            label: t('login.label.password'),
                            className: classes.textField,
                            onChange: handleOnChangePassword,
                            onKeyPress: handleKeyPress
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7cac207432c70082$export$2e2bcd8739ae039), {
                            href: "/forgottenPassword",
                            color: "inherit",
                            variant: "body2",
                            children: t('login.button.forgotten_password')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleLogin,
                        color: "primary",
                        children: t('login.button.login')
                    })
                })
            ]
        })
    });
};
var $82c46e29820dc6b6$export$2e2bcd8739ae039 = $82c46e29820dc6b6$var$Login;




var $7fPBF = parcelRequire("7fPBF");


var $emuQy = parcelRequire("emuQy");

var $bRUy3 = parcelRequire("bRUy3");

var $8MJe2 = parcelRequire("8MJe2");

var $7fPBF = parcelRequire("7fPBF");
var $f1ee620f0561c02a$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $f1ee620f0561c02a$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $3be60b4f29d3a6e3$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $3be60b4f29d3a6e3$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($f1ee620f0561c02a$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3be60b4f29d3a6e3$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3be60b4f29d3a6e3$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3be60b4f29d3a6e3$var$i = /^\s*$/, $3be60b4f29d3a6e3$var$s = Object.create(null);
function $3be60b4f29d3a6e3$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($3be60b4f29d3a6e3$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $3be60b4f29d3a6e3$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $3be60b4f29d3a6e3$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($3be60b4f29d3a6e3$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $3be60b4f29d3a6e3$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $3be60b4f29d3a6e3$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $3be60b4f29d3a6e3$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $3be60b4f29d3a6e3$var$a("", t);
        }, "");
    }
};
var $3be60b4f29d3a6e3$export$2e2bcd8739ae039 = $3be60b4f29d3a6e3$var$c;




var $69274dd39b5dbdf8$var$_excluded = [
    "format"
], $69274dd39b5dbdf8$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $69274dd39b5dbdf8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $69274dd39b5dbdf8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $69274dd39b5dbdf8$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8MJe2)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $69274dd39b5dbdf8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $69274dd39b5dbdf8$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $69274dd39b5dbdf8$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $69274dd39b5dbdf8$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every(function(child) {
        return (0, $7fPBF.isValidElement)(child);
    });
}
function $69274dd39b5dbdf8$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $69274dd39b5dbdf8$var$mergeProps(source, target) {
    var newTarget = $69274dd39b5dbdf8$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $69274dd39b5dbdf8$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return '';
    var stringNode = '';
    var childrenArray = $69274dd39b5dbdf8$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === 'string') stringNode += "".concat(child);
        else if ((0, $7fPBF.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $69274dd39b5dbdf8$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $445d14444882807b$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(child) === 'object') {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(child, $69274dd39b5dbdf8$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $445d14444882807b$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $445d14444882807b$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $69274dd39b5dbdf8$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $69274dd39b5dbdf8$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === 'string') return;
            if ($69274dd39b5dbdf8$var$hasChildren(child)) getData($69274dd39b5dbdf8$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(child) === 'object' && !(0, $7fPBF.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $3be60b4f29d3a6e3$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $69274dd39b5dbdf8$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $69274dd39b5dbdf8$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $7fPBF.cloneElement)(child, $69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $69274dd39b5dbdf8$var$getAsArray(reactNode);
        var astNodes = $69274dd39b5dbdf8$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $69274dd39b5dbdf8$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $7fPBF.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $69274dd39b5dbdf8$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(child) === 'object' && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($69274dd39b5dbdf8$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $7fPBF.cloneElement)(child, $69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $7fPBF.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $7fPBF.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($bRUy3)))(child) === 'object' && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $7fPBF.cloneElement)(child, $69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $7fPBF.cloneElement)(child, $69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === 'text') {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $7fPBF.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $69274dd39b5dbdf8$var$getAsArray(children || []));
    return $69274dd39b5dbdf8$var$getChildren(result[0]);
}
function $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($emuQy)))(_ref, $69274dd39b5dbdf8$var$_excluded2);
    var _ref2 = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $021c8539c0651064$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread({}, (0, $021c8539c0651064$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    var defaultValue = defaults || $69274dd39b5dbdf8$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: '#$?',
            suffix: '?$#'
        })
    };
    var combinedTOpts = $69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread($69274dd39b5dbdf8$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $69274dd39b5dbdf8$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $7fPBF.createElement)(useAsParent, additionalProps, content) : content;
}



var $fwAOd = parcelRequire("fwAOd");
var $i8OTH = parcelRequire("i8OTH");
var $lLRv0 = parcelRequire("lLRv0");
var $by0pu = parcelRequire("by0pu");
var $ckpfM = parcelRequire("ckpfM");
var $MQfsM = parcelRequire("MQfsM");
var $1rW9t = parcelRequire("1rW9t");




const $bf2b7f6e429b3b7b$var$Registration = (props)=>{
    const [loginName, setLoginName] = (0, $7fPBF.useState)('');
    const [password, setPassword] = (0, $7fPBF.useState)('');
    const [passwordSecondTime, setPasswordSecondTime] = (0, $7fPBF.useState)('');
    const [isUserNameValid, setIsUserNameValid] = (0, $7fPBF.useState)(true);
    const [gdpr, setGdpr] = (0, $7fPBF.useState)(false);
    const registrationHash = props.match.params.hash;
    const employee = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee);
    const alerts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.alert);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $6e7ac8ed3c2a9d89$export$fd421699a75c4e85)(registrationHash, props.history));
    }, [
        dispatch,
        registrationHash,
        props.history
    ]);
    const handleOnChangeLoginName = (event)=>{
        setLoginName((0, $94977a2c99b466d7$export$83d3388cc66dd8c6)(event.target.value));
        setIsUserNameValid((0, $94977a2c99b466d7$export$83d3388cc66dd8c6)(event.target.value).length !== 0);
    };
    const handleOnPaste = (event)=>{
        event.preventDefault();
    };
    const handleOnChangePassword = (event)=>setPassword(event.target.value);
    const handleOnChangePasswordAgain = (event)=>setPasswordSecondTime(event.target.value);
    const handleGdprChecked = (event)=>setGdpr(event.target.checked);
    const handleRegister = async ()=>{
        if (loginName.length === 0) return dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
            message: t(`settings.loginName.missing`),
            severity: 'error'
        }));
        if (!gdpr) return dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
            message: t('settings.qdpr.not_accepted'),
            severity: 'error'
        }));
        if (password && password === passwordSecondTime) {
            const registrationData = {
                password: password,
                employeeId: employee.id,
                loginName: loginName
            };
            return dispatch((0, $6e7ac8ed3c2a9d89$export$b0d46c734102bfcb)(registrationHash, registrationData, props.history));
        } else return dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
            message: t(`common.alert.passwords_missmatch`),
            severity: 'error'
        }));
    };
    const useStyles = (0, $by0pu.default)((theme)=>({
            root: {
                justify: 'center',
                minHeight: '100vh'
            },
            paper: {
                padding: '20px',
                width: '250px'
            },
            textField: {
                width: '100%',
                marginTop: '10px',
                marginBottom: '10px'
            },
            helpText: {
                maxWidth: '600px',
                textAlign: 'justify',
                [theme.breakpoints.down('xs')]: {
                    margin: '0px 20px 0px 20px'
                }
            },
            welcomeText: {
                marginBottom: '30px',
                textAlign: 'center'
            },
            gdprText: {
                madgin: 0,
                fontSize: '12px'
            },
            checkBox: {
                padding: '0 0 0 5px',
                transform: 'scale(0.8)',
                '&.Mui-checked': {
                    color: '#99B64E'
                }
            }
        }));
    const classes = useStyles();
    if (!employee || alerts && alerts.filter((alert)=>alert.message === t('registration.alert.already_registered')).length !== 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        container: true,
        className: classes.root,
        justifyContent: "center",
        alignItems: "center",
        direction: 'column',
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                    className: classes.welcomeText,
                    variant: "h5",
                    component: "h3",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                        i18nKey: 'registration.welcome',
                        values: {
                            name: employee.name
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                    className: classes.helpText,
                    component: "h6",
                    children: t('registration.description')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ckpfM.default), {
                className: classes.paper,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        container: true,
                        direction: 'column',
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                                onPaste: handleOnPaste,
                                label: t('registration.label.user_name'),
                                className: classes.textField,
                                onChange: handleOnChangeLoginName,
                                value: loginName,
                                error: !isUserNameValid,
                                helperText: isUserNameValid ? '' : t('settings.loginName.missing')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                                onPaste: handleOnPaste,
                                type: "password",
                                label: t('registration.label.password'),
                                className: classes.textField,
                                onChange: handleOnChangePassword
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                                onPaste: handleOnPaste,
                                type: "password",
                                label: t('registration.label.password_again'),
                                className: classes.textField,
                                onChange: handleOnChangePasswordAgain
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $lLRv0.default), {
                                control: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $i8OTH.default), {
                                    className: classes.checkBox,
                                    checked: gdpr,
                                    onChange: handleGdprChecked,
                                    name: "GDPR"
                                }),
                                label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1rW9t.default), {
                                    className: classes.gdprText,
                                    variant: "body1",
                                    children: [
                                        t('registration.label.gdpr.text'),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                            href: (0, $f6e729db3f817bb5$exports.PRIVACY_POLICY),
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: t('registration.label.gdpr.url_text')
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        container: true,
                        direction: "row",
                        justifyContent: "flex-end",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: handleRegister,
                            color: "primary",
                            children: t('registration.button.register')
                        })
                    })
                ]
            })
        ]
    });
};
var $bf2b7f6e429b3b7b$export$2e2bcd8739ae039 = $bf2b7f6e429b3b7b$var$Registration;




var $7fPBF = parcelRequire("7fPBF");


var $ckpfM = parcelRequire("ckpfM");

var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");

var $1rW9t = parcelRequire("1rW9t");

var $MQfsM = parcelRequire("MQfsM");


const $12eae5248a184b4a$var$ForgottenPassword = (props)=>{
    const [userName, setUserName] = (0, $7fPBF.useState)('');
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const handleOnChangeUserName = (event)=>setUserName(event.target.value);
    const handleSend = ()=>dispatch((0, $750868b12996ced6$export$dd9330a0c4a135a2)({
            userName: userName
        }, props.history));
    const handleBack = ()=>props.history.push('/');
    const useStyles = (0, $by0pu.default)({
        root: {
            justify: 'center',
            minHeight: '100vh'
        },
        paper: {
            padding: '20px',
            width: '250px'
        },
        textField: {
            width: '100%',
            marginTop: '10px',
            marginBottom: '10px'
        },
        helpText: {
            marginTop: '20px'
        },
        buttonBox: {
            display: 'flex',
            direction: 'row',
            justifyContent: 'space-between',
            marginTop: '20px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        container: true,
        className: classes.root,
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ckpfM.default), {
            className: classes.paper,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    direction: 'column',
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            variant: "h5",
                            component: "h3",
                            children: t('forgotten_password.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            className: classes.helpText,
                            component: "h6",
                            children: t('forgotten_password.description')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            label: t('forgotten_password.label.user_name'),
                            className: classes.textField,
                            onChange: handleOnChangeUserName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    className: classes.buttonBox,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: handleBack,
                            className: classes.backBtn,
                            color: "primary",
                            children: t('forgotten_password.button.back')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: handleSend,
                            color: "primary",
                            variant: "outlined",
                            children: t('forgotten_password.button.send')
                        })
                    ]
                })
            ]
        })
    });
};
var $12eae5248a184b4a$export$2e2bcd8739ae039 = $12eae5248a184b4a$var$ForgottenPassword;




var $7fPBF = parcelRequire("7fPBF");


var $ckpfM = parcelRequire("ckpfM");

var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");

var $1rW9t = parcelRequire("1rW9t");

var $MQfsM = parcelRequire("MQfsM");



const $207b5c3faacc9d80$var$ChangePassword = (props)=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [password, setPassword] = (0, $7fPBF.useState)('');
    const [passwordSecondTime, setPasswordSecondTime] = (0, $7fPBF.useState)('');
    const alerts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.alerts);
    const resetHash = props.match.params.hash;
    const employee = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $750868b12996ced6$export$54d20a726a601ff1)(resetHash));
    }, [
        dispatch,
        resetHash
    ]);
    const handleOnChangePassword = (event)=>setPassword(event.target.value);
    const handleOnChangePasswordAgain = (event)=>setPasswordSecondTime(event.target.value);
    const handleSend = ()=>{
        if (password && password === passwordSecondTime) dispatch((0, $750868b12996ced6$export$99d837dc30eb1ef7)(resetHash, {
            password: password
        }, props.history));
        else dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
            message: t('common.alert.passwords_missmatch'),
            severity: 'error'
        }));
    };
    const useStyles = (0, $by0pu.default)({
        root: {
            justify: 'center',
            minHeight: '100vh'
        },
        paper: {
            padding: '20px',
            width: '250px'
        },
        textField: {
            width: '100%',
            marginTop: '10px',
            marginBottom: '10px'
        },
        helpText: {
            marginTop: '20px'
        }
    });
    const classes = useStyles();
    // TODO: ez mit csinál, miért van, mire jó?
    if (!employee || alerts.filter((alert)=>alert.message === 'Invalid link' || alert.message === 'Link expired').length !== 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        container: true,
        className: classes.root,
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ckpfM.default), {
            className: classes.paper,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    direction: 'column',
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            variant: "h5",
                            component: "h3",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                                i18nKey: 'change_password.welcome',
                                values: {
                                    name: employee.name
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            className: classes.helpText,
                            component: "h6",
                            children: t('change_password.description')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            type: "password",
                            label: t('change_password.label.password'),
                            className: classes.textField,
                            onChange: handleOnChangePassword
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                            type: "password",
                            label: t('change_password.label.password_again'),
                            className: classes.textField,
                            onChange: handleOnChangePasswordAgain
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleSend,
                        color: "primary",
                        children: t('change_password.button.send')
                    })
                })
            ]
        })
    });
};
var $207b5c3faacc9d80$export$2e2bcd8739ae039 = $207b5c3faacc9d80$var$ChangePassword;




var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");


var $by0pu = parcelRequire("by0pu");

var $fwAOd = parcelRequire("fwAOd");

var $hzQpW = parcelRequire("hzQpW");

var $7fPBF = parcelRequire("7fPBF");

function $3091ddbcc4677a86$export$9b98266184eefdf6() {
    const { criteria: criteria, categories: categories } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.accountInfo);
    const [objectiveCreatable, setObjectiveCreatable] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const criterionIsAvailable = Array.isArray(criteria) && criteria.length > 0;
        const categoryIsAvailable = Array.isArray(categories) && categories.length > 0;
        setObjectiveCreatable(criterionIsAvailable && categoryIsAvailable);
    }, [
        criteria,
        categories
    ]);
    return [
        objectiveCreatable
    ];
}





const $9133984d0de53ac7$var$CreatePanel = ()=>{
    const queryClient = (0, $509c1684c3be0a4f$export$22e77b9572c4fded)();
    const [objectiveCreatable] = (0, $3091ddbcc4677a86$export$9b98266184eefdf6)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { statusFilters: statusFilters, developmentStatusFilters: developmentStatusFilters, categoryFilters: categoryFilters, dateRange: dateRange } = (0, $5e95649937aab08b$export$396ef541d9951d45)();
    const useStyles = (0, $by0pu.default)({
        addBtn: {
            height: '40px'
        },
        buttonContainer: {
            height: '40px'
        }
    });
    const classes = useStyles();
    const onSubmitSuccess = ()=>{
        queryClient.invalidateQueries([
            'objectives',
            statusFilters,
            developmentStatusFilters,
            categoryFilters,
            dateRange
        ]);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                arrow: true,
                title: t('objective.button.create.tooltip'),
                disableFocusListener: objectiveCreatable,
                disableHoverListener: objectiveCreatable,
                disableTouchListener: objectiveCreatable,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: classes.buttonContainer,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        variant: "contained",
                        color: "primary",
                        className: classes.addBtn,
                        onClick: ()=>setOpen(!open),
                        disabled: !objectiveCreatable,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: t('objective.button.create.label')
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3447d4985bafc2a$export$2e2bcd8739ae039), {
                open: open,
                handleClose: ()=>setOpen(false),
                onSubmitSuccess: onSubmitSuccess
            })
        ]
    });
};
var $9133984d0de53ac7$export$2e2bcd8739ae039 = $9133984d0de53ac7$var$CreatePanel;



parcelRequire("7fPBF");

var $9SdKL = parcelRequire("9SdKL");
var $by0pu = parcelRequire("by0pu");
var $fH0xA = parcelRequire("fH0xA");




const $d7eede2cb78439b2$export$cf8af139ae36ddf8 = ()=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`/objectivesSummary`);






const $f0790e4d8087b7a7$var$useStyles = (0, $by0pu.default)({
    container: {
        backgroundColor: '#F5F5F5',
        padding: '20px'
    },
    number: {
        fontSize: '40px',
        fontWeight: '700'
    },
    clickable: {
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    willExpire: {
        color: '#F48401',
        '&:hover': {
            color: '#db7600'
        }
    },
    expired: {
        color: '#e74c3d',
        '&:hover': {
            color: '#c94234'
        }
    },
    proposed: {
        color: '#999999',
        '&:hover': {
            color: '#757575'
        }
    },
    active: {
        color: '#49586e',
        '&:hover': {
            color: '#3a4657'
        }
    },
    neutral: {
        color: '#3498DB',
        '&:hover': {
            color: '#2d83bd'
        }
    },
    awesome: {
        color: '#1ABC9C',
        '&:hover': {
            color: '#169c81'
        }
    },
    inDanger: {
        color: '#F48401',
        '&:hover': {
            color: '#d67300'
        }
    },
    horizontalDivider: {
        width: '100%',
        margin: '10px 0'
    }
}, {
    name: 'InfoPanel'
});
const $f0790e4d8087b7a7$var$ObjectivesInfoPanel = ()=>{
    var _objectivesInfoQuery_data;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $f0790e4d8087b7a7$var$useStyles();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const theme = (0, $fH0xA.default)();
    const xs = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.down('xs'));
    const { resetFilters: resetFilters, setStatusFilters: setStatusFilters, setDateRange: setDateRange, setDevelopmentStatusFilters: setDevelopmentStatusFilters } = (0, $5e95649937aab08b$export$396ef541d9951d45)();
    const objectivesInfoQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'objectivesInfo'
    ], async ()=>{
        const { data: data } = await (0, $d7eede2cb78439b2$export$cf8af139ae36ddf8)();
        return data;
    }, {
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const objectivesInfo = (_objectivesInfoQuery_data = objectivesInfoQuery.data) === null || _objectivesInfoQuery_data === void 0 ? void 0 : _objectivesInfoQuery_data[0];
    const isLoading = objectivesInfoQuery.isFetching;
    const { will_expire_count: will_expire_count, expired_count: expired_count, proposed_count: proposed_count, active_count: active_count, awesome_count: awesome_count, neutral_count: neutral_count, in_danger_count: in_danger_count } = objectivesInfo || {};
    const filterWillExpire = ()=>{
        resetFilters();
        setDateRange(JSON.parse((0, $8bfb433bad942c35$export$4d545125353fe8c5)()));
    };
    const filterExpired = ()=>{
        resetFilters();
        setDateRange({
            from: (0, $8bfb433bad942c35$export$f470d795e00a1a60)(new Date(0)),
            to: (0, $8bfb433bad942c35$export$f470d795e00a1a60)(new Date())
        });
        setStatusFilters([
            (0, $f6e729db3f817bb5$exports.STATUS).PROPOSED,
            (0, $f6e729db3f817bb5$exports.STATUS).DECLINED,
            (0, $f6e729db3f817bb5$exports.STATUS).PASSIVE,
            (0, $f6e729db3f817bb5$exports.STATUS).ACTIVE
        ]);
    };
    const filterStatus = (status)=>{
        resetFilters();
        setStatusFilters(status);
    };
    const filterDevelopmentStatus = (developmentStatus)=>{
        resetFilters();
        setStatusFilters((0, $f6e729db3f817bb5$exports.STATUS).ACTIVE);
        setDevelopmentStatusFilters(developmentStatus);
    };
    const createInfoItem = (count, type, onClick, isStatusType)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
            item: true,
            className: `${classes[type]}
      ${classes.clickable}`,
            onClick: onClick,
            sm: "auto",
            xs: isStatusType ? 5 : 3,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    className: classes.number,
                    children: count || 0
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    children: t(`objectivesInfo.${type}`)
                })
            ]
        });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86a6140e16b13821$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
            container: true,
            className: classes.container,
            justifyContent: "space-around",
            children: !objectivesInfo && isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9SdKL.default), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    createInfoItem(will_expire_count, (0, $f6e729db3f817bb5$exports.OBJECTIVES_INFO_TYPES).WILL_EXPIRE, filterWillExpire, true),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            orientation: "vertical"
                        })
                    }),
                    createInfoItem(expired_count, (0, $f6e729db3f817bb5$exports.OBJECTIVES_INFO_TYPES).EXPIRED, filterExpired, true),
                    xs ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            orientation: "horizontal",
                            className: classes.horizontalDivider
                        })
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            orientation: "vertical"
                        })
                    }),
                    createInfoItem(proposed_count, (0, $f6e729db3f817bb5$exports.OBJECTIVES_INFO_TYPES).PROPOSED, ()=>filterStatus((0, $f6e729db3f817bb5$exports.STATUS).PROPOSED), true),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            orientation: "vertical"
                        })
                    }),
                    createInfoItem(active_count, (0, $f6e729db3f817bb5$exports.OBJECTIVES_INFO_TYPES).ACTIVE, ()=>filterStatus((0, $f6e729db3f817bb5$exports.STATUS).ACTIVE), true),
                    xs ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            orientation: "horizontal",
                            className: classes.horizontalDivider
                        })
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            orientation: "vertical"
                        })
                    }),
                    createInfoItem(neutral_count, (0, $f6e729db3f817bb5$exports.OBJECTIVES_INFO_TYPES).NEUTRAL, ()=>filterDevelopmentStatus((0, $f6e729db3f817bb5$exports.DEVELOPMENT_STATUS).NEUTRAL), false),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            orientation: "vertical"
                        })
                    }),
                    createInfoItem(awesome_count, (0, $f6e729db3f817bb5$exports.OBJECTIVES_INFO_TYPES).AWESOME, ()=>filterDevelopmentStatus((0, $f6e729db3f817bb5$exports.DEVELOPMENT_STATUS).AWESOME), false),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            orientation: "vertical"
                        })
                    }),
                    createInfoItem(in_danger_count, (0, $f6e729db3f817bb5$exports.OBJECTIVES_INFO_TYPES).IN_DANGER, ()=>filterDevelopmentStatus((0, $f6e729db3f817bb5$exports.DEVELOPMENT_STATUS).IN_DANGER), false)
                ]
            })
        })
    });
};
var $f0790e4d8087b7a7$export$2e2bcd8739ae039 = $f0790e4d8087b7a7$var$ObjectivesInfoPanel;



var $by0pu = parcelRequire("by0pu");
var $fH0xA = parcelRequire("fH0xA");






parcelRequire("7fPBF");







const $d121498a986083f6$var$Objectives = ()=>{
    var _objectivesQuery_data;
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { statusFilters: statusFilters, developmentStatusFilters: developmentStatusFilters, categoryFilters: categoryFilters, dateRange: dateRange } = (0, $5e95649937aab08b$export$396ef541d9951d45)();
    const objectivesQuery = (0, $2bc6258289aa5150$export$bdc59d3c1a6569aa)([
        'objectives',
        statusFilters,
        developmentStatusFilters,
        categoryFilters,
        dateRange
    ], async ({ pageParam: pageParam = 0 })=>{
        var _this, _this1;
        const { data: data } = await (0, $553835ea16648c6f$export$73df232807302865)({
            offset: pageParam,
            filters: {
                statuses: statusFilters || '',
                developmentStatuses: developmentStatusFilters || '',
                categories: categoryFilters || '',
                dateStart: dateRange.from ? (_this = new Date((0, $8bfb433bad942c35$export$1e32f7407816b987)(dateRange.from))) === null || _this === void 0 ? void 0 : _this.toISOString() : null,
                dateEnd: dateRange.to ? (_this1 = new Date((0, $8bfb433bad942c35$export$1e32f7407816b987)(dateRange.to))) === null || _this1 === void 0 ? void 0 : _this1.toISOString() : null
            }
        });
        return data;
    }, {
        getNextPageParam: (lastPage, allPages)=>{
            return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) ? allPages === null || allPages === void 0 ? void 0 : allPages.flat().length : undefined;
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    var _objectivesQuery_data_pages_flat;
    const objectives = (_objectivesQuery_data_pages_flat = (_objectivesQuery_data = objectivesQuery.data) === null || _objectivesQuery_data === void 0 ? void 0 : _objectivesQuery_data.pages.flat()) !== null && _objectivesQuery_data_pages_flat !== void 0 ? _objectivesQuery_data_pages_flat : [];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $252e2ed8d7363a2e$export$2e2bcd8739ae039), {
        objectives: objectives,
        loading: objectivesQuery.isFetching,
        onSubmitSuccess: objectivesQuery.refetch,
        canLoadMore: objectivesQuery.hasNextPage,
        loadMore: objectivesQuery.fetchNextPage
    });
};
var $d121498a986083f6$export$2e2bcd8739ae039 = $d121498a986083f6$var$Objectives;


const $748579619b0988e4$var$useStyles = (0, $by0pu.default)({
    button: {
        margin: 16
    },
    description: {
        marginTop: '20px',
        fontSize: '18px',
        marginLeft: '20px'
    }
});
const $748579619b0988e4$var$UserMainPage = ()=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const classes = $748579619b0988e4$var$useStyles();
    const theme = (0, $fH0xA.default)();
    const sm = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const objectivesSettings = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
        var _state_accountInfo_objectivesSettings;
        return (_state_accountInfo_objectivesSettings = state.accountInfo.objectivesSettings) !== null && _state_accountInfo_objectivesSettings !== void 0 ? _state_accountInfo_objectivesSettings : {};
    });
    const employee = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee);
    const [drawerOpen, setDrawerOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $74750fb419d4223b$export$eb48dd7746a93f2a)());
        if (JSON.stringify(employee) === '{}') dispatch((0, $401a17725816a5a8$export$d5f42470fa5a7347)()).then((employee)=>{
            (0, $c2fa3f0a340dc103$export$ac983537af4b3a6d)(employee === null || employee === void 0 ? void 0 : employee.language);
        });
    }, [
        dispatch,
        employee
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5e95649937aab08b$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $899ea3d88a7a8f04$export$2e2bcd8739ae039), {
                drawerOpen: drawerOpen,
                setDrawerOpen: setDrawerOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    marginLeft: !sm ? 'auto' : drawerOpen ? `${0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH}px` : '55px'
                },
                children: [
                    objectivesSettings.objectives_instructions && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: classes.button,
                        children: objectivesSettings.objectives_instructions
                    }),
                    objectivesSettings.proposable_by_owner && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: classes.button,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9133984d0de53ac7$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0790e4d8087b7a7$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d57f8c5132119daf$export$2e2bcd8739ae039), {
                        m: 2,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $281226a9c8e4918a$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d121498a986083f6$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $748579619b0988e4$export$2e2bcd8739ae039 = $748579619b0988e4$var$UserMainPage;




var $7fPBF = parcelRequire("7fPBF");



const $ab48d5c4af272962$export$f0d2ca471cdb99b0 = ()=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`projects`);





var $9SdKL = parcelRequire("9SdKL");
var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");
var $fH0xA = parcelRequire("fH0xA");


parcelRequire("7fPBF");

var $eBahF = parcelRequire("eBahF");


var $6qwOn = parcelRequire("6qwOn");
var $f67073e438bad995$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($f67073e438bad995$exports, "__esModule", {
    value: true
});
$f67073e438bad995$exports.default = void 0;

var $f67073e438bad995$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $f67073e438bad995$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $f67073e438bad995$var$_default = (0, $f67073e438bad995$var$_createSvgIcon.default)(/*#__PURE__*/ $f67073e438bad995$var$React.createElement("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), 'OpenInNew');
$f67073e438bad995$exports.default = $f67073e438bad995$var$_default;



const $6c189fd1f1bb2aba$var$List = ({ projects: projects })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const columns = [
        {
            field: 'survey_name',
            headerName: t('project.header.name'),
            minWidth: 190,
            flex: 1,
            renderCell: (params)=>{
                var _params_value, _params_value1, _params_value2, _params_value3;
                return (params === null || params === void 0 ? void 0 : (_params_value = params.value) === null || _params_value === void 0 ? void 0 : _params_value.is_closed) ? (_params_value1 = params.value) === null || _params_value1 === void 0 ? void 0 : _params_value1.survey_name : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                    href: (_params_value2 = params.value) === null || _params_value2 === void 0 ? void 0 : _params_value2.link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: (_params_value3 = params.value) === null || _params_value3 === void 0 ? void 0 : _params_value3.survey_name
                });
            }
        },
        {
            field: 'type',
            headerName: t('project.header.type'),
            minWidth: 190
        },
        {
            field: 'group_name',
            headerName: t('project.header.groupName'),
            flex: 0.5
        },
        {
            field: 'date_start',
            headerName: t('project.header.sent'),
            minWidth: 130
        },
        {
            field: 'status',
            headerName: t('project.header.status'),
            minWidth: 130
        },
        {
            field: 'progress',
            headerName: t('project.header.progress'),
            minWidth: 130
        },
        {
            field: 'invite_link',
            align: 'center',
            headerName: t('project.header.link'),
            renderCell: (params)=>params.value ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                    href: params.value,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f67073e438bad995$exports))), {
                        fontSize: "small"
                    })
                }) : ''
        }
    ];
    const rows = projects.map((project)=>{
        const { survey_id: id, survey_name: survey_name, type: type, group_name: group_name, date_start: date_start, is_closed: is_closed, progress: progress, invite_link: invite_link } = project;
        return {
            id: id,
            survey_name: {
                survey_name: survey_name,
                link: invite_link,
                is_closed: is_closed
            },
            type: t(`project.type.${type === null || type === void 0 ? void 0 : type.toLowerCase()}`),
            group_name: group_name,
            date_start: (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(date_start).format('L'),
            status: is_closed ? t('project.status.closed') : t('project.status.open'),
            progress: t(`project.progress.${progress}`),
            invite_link: invite_link
        };
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eBahF.DataGrid), {
            rows: rows,
            columns: columns,
            checkboxSelection: false,
            disableSelectionOnClick: true,
            headerHeight: 42,
            rowHeight: 42,
            autoHeight: true,
            hideFooter: true,
            disableColumnMenu: true
        })
    });
};
var $6c189fd1f1bb2aba$export$2e2bcd8739ae039 = $6c189fd1f1bb2aba$var$List;



const $6e52cf2fab4d511b$var$useStyles = (0, $by0pu.default)({
    title: {
        color: '#999999',
        fontSize: '16px',
        textTransform: 'uppercase',
        margin: '40px auto 20px auto'
    }
});
const $6e52cf2fab4d511b$var$ProjectsPage = ()=>{
    const theme = (0, $fH0xA.default)();
    const sm = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $6e52cf2fab4d511b$var$useStyles();
    const [drawerOpen, setDrawerOpen] = (0, $7fPBF.useState)(false);
    const projectsQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'projects'
    ], async ()=>{
        const { data: data } = await (0, $ab48d5c4af272962$export$f0d2ca471cdb99b0)();
        return data;
    }, {
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const projects = projectsQuery.data;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $899ea3d88a7a8f04$export$2e2bcd8739ae039), {
                drawerOpen: drawerOpen,
                setDrawerOpen: setDrawerOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    marginLeft: !sm ? 'auto' : drawerOpen ? `${0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH}px` : '55px'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $86a6140e16b13821$export$2e2bcd8739ae039), {
                    maxWidth: "xl",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            className: classes.title,
                            children: t('projects.title')
                        }),
                        !projects && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9SdKL.default), {}),
                        projects && projects.length !== 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6c189fd1f1bb2aba$export$2e2bcd8739ae039), {
                            projects: projects
                        }),
                        projects && projects.length === 0 && t('projects.noProjects')
                    ]
                })
            })
        ]
    });
};
var $6e52cf2fab4d511b$export$2e2bcd8739ae039 = $6e52cf2fab4d511b$var$ProjectsPage;




var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $by0pu = parcelRequire("by0pu");



var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $itsQ3 = parcelRequire("itsQ3");
var $by0pu = parcelRequire("by0pu");
var $MQfsM = parcelRequire("MQfsM");


const $361268c2bdcd9466$var$LoginName = ()=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const employee = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee);
    const [loginName, setLoginName] = (0, $7fPBF.useState)(employee.loginName);
    const [isLoginNameValid, setIsLoginNameValid] = (0, $7fPBF.useState)(true);
    (0, $7fPBF.useEffect)(()=>{
        setLoginName(employee.loginName);
    }, [
        employee
    ]);
    const handleOnChangeLoginName = (event)=>{
        setLoginName((0, $94977a2c99b466d7$export$83d3388cc66dd8c6)(event.target.value));
        setIsLoginNameValid((0, $94977a2c99b466d7$export$83d3388cc66dd8c6)(event.target.value).length !== 0);
    };
    const handleOnSaveLoginName = ()=>{
        if (isLoginNameValid) dispatch((0, $401a17725816a5a8$export$7b2ff6d49bd2365)(loginName));
    };
    const useStyles = (0, $by0pu.default)({
        saveBtn: {
            marginTop: '10px'
        },
        label: {
            color: '#999999',
            fontSize: '16px',
            textTransform: 'uppercase'
        },
        textField: {
            paddingTop: '15px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
            item: true,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $itsQ3.default), {
                    className: classes.label,
                    children: t('settings.loginName.title')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                    className: classes.textField,
                    value: loginName,
                    error: !isLoginNameValid,
                    helperText: isLoginNameValid ? '' : t('settings.loginName.missing'),
                    onChange: handleOnChangeLoginName,
                    fullWidth: true,
                    placeholder: t('settings.loginName.placeholder')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleOnSaveLoginName,
                        color: "primary",
                        variant: "contained",
                        disabled: !loginName || loginName === employee.loginName,
                        className: `${classes.saveBtn} save-userName`,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: t('settings.loginName.save')
                        })
                    })
                })
            ]
        })
    });
};
var $361268c2bdcd9466$export$2e2bcd8739ae039 = $361268c2bdcd9466$var$LoginName;




var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $itsQ3 = parcelRequire("itsQ3");
var $by0pu = parcelRequire("by0pu");
var $MQfsM = parcelRequire("MQfsM");
var $hzQpW = parcelRequire("hzQpW");
var $1b61e55be5607f2e$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");

Object.defineProperty($1b61e55be5607f2e$exports, "__esModule", {
    value: true
});
$1b61e55be5607f2e$exports.default = void 0;

var $1b61e55be5607f2e$var$React = $dcec985ce352b9cb$exports((parcelRequire("7fPBF")));

var $1b61e55be5607f2e$var$_createSvgIcon = $62qsu((parcelRequire("4FMad")));
var $1b61e55be5607f2e$var$_default = (0, $1b61e55be5607f2e$var$_createSvgIcon.default)(/*#__PURE__*/ $1b61e55be5607f2e$var$React.createElement("path", {
    d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
}), 'HelpOutline');
$1b61e55be5607f2e$exports.default = $1b61e55be5607f2e$var$_default;




const $e920d794233ccdd2$var$Password = ()=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [password, setPassword] = (0, $7fPBF.useState)('');
    const [passwordSecondTime, setPasswordSecondTime] = (0, $7fPBF.useState)('');
    const [currentPassword, setCurrentPassword] = (0, $7fPBF.useState)('');
    const handleOnSavePassword = ()=>{
        if (!currentPassword) return errorMessage(t('common.alert.missing_current_password'));
        if (password !== passwordSecondTime) return errorMessage(t('common.alert.passwords_missmatch'));
        dispatch((0, $401a17725816a5a8$export$1af3d3323b2d472a)({
            password: password,
            currentPassword: currentPassword
        }, resetState));
    };
    const resetState = ()=>{
        setPassword('');
        setPasswordSecondTime('');
        setCurrentPassword('');
    };
    const errorMessage = (error)=>{
        return dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
            message: error,
            severity: 'error'
        }));
    };
    const handleOnChangeCurrentPassword = (event)=>setCurrentPassword(event.target.value);
    const handleOnChangePassword = (event)=>setPassword(event.target.value);
    const handleOnChangePasswordAgain = (event)=>setPasswordSecondTime(event.target.value);
    const useStyles = (0, $by0pu.default)({
        helpIcon: {
            color: '#969696'
        },
        saveBtn: {
            marginTop: '10px'
        },
        label: {
            color: '#999999',
            fontSize: '16px',
            textTransform: 'uppercase'
        },
        icon: {
            margin: '-3px auto auto 10px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
            item: true,
            className: "password-form",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $itsQ3.default), {
                            className: classes.label,
                            children: t('settings.password.title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: classes.icon,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $hzQpW.default), {
                                title: t('settings.password.password.helperText'),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1b61e55be5607f2e$exports))), {
                                    fontSize: "small",
                                    className: classes.helpIcon
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                    fullWidth: true,
                    value: currentPassword,
                    type: "password",
                    label: t('settings.password.currentPassword.label'),
                    onChange: handleOnChangeCurrentPassword
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                    fullWidth: true,
                    value: password,
                    type: "password",
                    label: t('settings.password.password.label'),
                    onChange: handleOnChangePassword
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), {
                    fullWidth: true,
                    value: passwordSecondTime,
                    type: "password",
                    label: t('settings.password.passwordAgain.label'),
                    onChange: handleOnChangePasswordAgain
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: handleOnSavePassword,
                        color: "primary",
                        variant: "contained",
                        disabled: !password || !passwordSecondTime || !currentPassword,
                        className: classes.saveBtn,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: t('settings.password.save')
                        })
                    })
                })
            ]
        })
    });
};
var $e920d794233ccdd2$export$2e2bcd8739ae039 = $e920d794233ccdd2$var$Password;




var $7fPBF = parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");
var $itsQ3 = parcelRequire("itsQ3");
var $by0pu = parcelRequire("by0pu");
var $g21Gx = parcelRequire("g21Gx");
var $g1A03 = parcelRequire("g1A03");



const $4b1afa1fb9223dd7$var$Language = ()=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const employee = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee);
    const [language, setLanguage] = (0, $7fPBF.useState)(employee.language);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        (0, $c2fa3f0a340dc103$export$ac983537af4b3a6d)(employee.language);
        setLanguage(employee.language);
    }, [
        employee
    ]);
    const useStyles = (0, $by0pu.default)({
        saveBtn: {
            marginTop: '10px'
        },
        label: {
            color: '#999999',
            fontSize: '16px',
            textTransform: 'uppercase'
        },
        select: {
            paddingTop: '15px',
            maxWidth: '280px',
            width: '100%'
        }
    });
    const classes = useStyles();
    const handleLanguageChange = (event)=>{
        setLanguage(event.target.value);
    };
    const handleOnSaveLanguage = ()=>{
        dispatch((0, $401a17725816a5a8$export$bb8ea1997573c96e)(language.toLowerCase()));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                direction: "row",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $itsQ3.default), {
                    className: classes.label,
                    children: t('settings.language.title')
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $g1A03.default), {
                value: language ? language.toUpperCase() : '',
                onChange: handleLanguageChange,
                className: classes.select,
                children: Object.keys((0, $f6e729db3f817bb5$exports.SUPPORTED_LANGUAGES)).map((lang)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $g21Gx.default), {
                        value: (0, $f6e729db3f817bb5$exports.SUPPORTED_LANGUAGES)[lang].toUpperCase(),
                        children: (0, $f6e729db3f817bb5$exports.SUPPORTED_LANGUAGES)[lang].toUpperCase()
                    }, (0, $f6e729db3f817bb5$exports.SUPPORTED_LANGUAGES)[lang]))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                    onClick: handleOnSaveLanguage,
                    color: "primary",
                    variant: "contained",
                    className: `${classes.saveBtn} update-language`,
                    disabled: !language || language.toLowerCase() === employee.language,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: t('settings.language.save')
                    })
                })
            })
        ]
    });
};
var $4b1afa1fb9223dd7$export$2e2bcd8739ae039 = $4b1afa1fb9223dd7$var$Language;



parcelRequire("7fPBF");



var $itsQ3 = parcelRequire("itsQ3");
var $by0pu = parcelRequire("by0pu");
var $4mZpH = parcelRequire("4mZpH");

const $f998c89445c68be1$var$Notifications = ()=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const notifications = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.employee.notifications);
    const useStyles = (0, $by0pu.default)({
        label: {
            margin: 'auto 0'
        }
    });
    const classes = useStyles();
    const changeNotifications = (event)=>{
        dispatch((0, $a73c580aa0785cc5$export$c53275bee200c32a)({
            notifications: event.target.checked
        }));
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
        item: true,
        container: true,
        direction: "row",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $itsQ3.default), {
                className: classes.label,
                children: t('settings.notifications.label')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4mZpH.default), {
                checked: notifications || false,
                onChange: changeNotifications
            })
        ]
    });
};
var $f998c89445c68be1$export$2e2bcd8739ae039 = $f998c89445c68be1$var$Notifications;




const $629e73bba98205af$var$SettingsPage = ()=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [drawerOpen, setDrawerOpen] = (0, $7fPBF.useState)(false);
    const useStyles = (0, $by0pu.default)({
        root: {
            margin: '30px auto',
            width: '280px'
        },
        divider: {
            margin: '20px 0'
        },
        button: {
            border: '#99B64E solid 2px',
            boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.3)',
            borderRadius: '4px',
            marginTop: '12px'
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        dispatch((0, $401a17725816a5a8$export$d5f42470fa5a7347)());
    }, [
        dispatch
    ]);
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $899ea3d88a7a8f04$export$2e2bcd8739ae039), {
                drawerOpen: drawerOpen,
                setDrawerOpen: setDrawerOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: classes.root,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "column",
                    justifyContent: "center",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f998c89445c68be1$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            className: classes.divider
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $361268c2bdcd9466$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            className: classes.divider
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b1afa1fb9223dd7$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                            className: classes.divider
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e920d794233ccdd2$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            className: `${classes.button} back-to-goals`,
                            component: (0, $6e382b045249d040$export$a6c7ac8248d6e38a),
                            to: "/objectives",
                            color: "primary",
                            children: t('settings.backButton')
                        })
                    ]
                })
            })
        ]
    });
};
var $629e73bba98205af$export$2e2bcd8739ae039 = $629e73bba98205af$var$SettingsPage;




var $7fPBF = parcelRequire("7fPBF");



const $fc912324afeee9af$export$31c1108d729ca1e2 = ()=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get(`managerialDecisions`);
const $fc912324afeee9af$export$84d11a0f7b895826 = (id)=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`managerialDecisions/${id}/approve`);





var $9SdKL = parcelRequire("9SdKL");
var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");
var $fH0xA = parcelRequire("fH0xA");


parcelRequire("7fPBF");



var $fwAOd = parcelRequire("fwAOd");

var $8SBLK = parcelRequire("8SBLK");

var $6qwOn = parcelRequire("6qwOn");




parcelRequire("7fPBF");



var $9SdKL = parcelRequire("9SdKL");



parcelRequire("7fPBF");




var $fwAOd = parcelRequire("fwAOd");


const $284bd93a9689a48d$var$getEndpoint = (managerialDecisionId)=>`/managerialDecisions/${managerialDecisionId}/comments`;
const $284bd93a9689a48d$export$2a15b079e3f46654 = ({ managerialDecisionId: managerialDecisionId, content: content })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).post($284bd93a9689a48d$var$getEndpoint(managerialDecisionId), {
        content: content
    });
const $284bd93a9689a48d$export$5d914151c350a309 = (managerialDecisionId)=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).get($284bd93a9689a48d$var$getEndpoint(managerialDecisionId));
const $284bd93a9689a48d$export$5a1cd239009d83a6 = ({ managerialDecisionId: managerialDecisionId, commentId: commentId, content: content })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).put(`${$284bd93a9689a48d$var$getEndpoint(managerialDecisionId)}/${commentId}`, {
        content: content
    });
const $284bd93a9689a48d$export$2e6e3ad634e3776 = ({ managerialDecisionId: managerialDecisionId, commentId: commentId })=>(0, $c5b59547f7a0f380$export$2e2bcd8739ae039).delete(`${$284bd93a9689a48d$var$getEndpoint(managerialDecisionId)}/${commentId}`);





parcelRequire("7fPBF");



var $MQfsM = parcelRequire("MQfsM");

const $e9354814627de1d9$var$Form = ({ error: error, variant: variant })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                item: true,
                style: {
                    marginBottom: '10px'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                    name: "content",
                    render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $MQfsM.default), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field), {
                            label: t('managerialDecisionComments.form.content'),
                            variant: variant,
                            required: true,
                            multiline: true,
                            fullWidth: true
                        }))
                })
            }),
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba9f1ac4b3dbaa47$export$2e2bcd8739ae039), {
                severity: "error",
                children: error
            })
        ]
    });
};
var $e9354814627de1d9$export$2e2bcd8739ae039 = $e9354814627de1d9$var$Form;



const $fb39b8ed24227c71$var$Create = ({ managerialDecisionId: managerialDecisionId })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const form = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)();
    const queryClient = (0, $509c1684c3be0a4f$export$22e77b9572c4fded)();
    const createCommentMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ({ content: content })=>{
        await (0, $284bd93a9689a48d$export$2a15b079e3f46654)({
            managerialDecisionId: managerialDecisionId,
            content: content
        });
    }, {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                'managerialDecisionComments',
                managerialDecisionId
            ]);
            form.reset({
                content: ''
            });
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$8ce1ff4f94d08846), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, form), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
            onSubmit: form.handleSubmit((values)=>createCommentMutation.mutate(values)),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                direction: "column",
                spacing: 1,
                style: {
                    marginTop: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e9354814627de1d9$export$2e2bcd8739ae039), {
                        variant: 'outlined'
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            variant: 'outlined',
                            color: 'primary',
                            type: 'submit',
                            children: t('managerialDecisionComments.form.btn.save')
                        })
                    })
                ]
            })
        })
    }));
};
var $fb39b8ed24227c71$export$2e2bcd8739ae039 = $fb39b8ed24227c71$var$Create;




var $7fPBF = parcelRequire("7fPBF");


var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");










var $7fPBF = parcelRequire("7fPBF");


var $fwAOd = parcelRequire("fwAOd");







const $2852d261de2818c5$var$Update = ({ comment: comment, setIsEditing: setIsEditing, managerialDecisionId: managerialDecisionId })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const form = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { employeeId: employeeId } = (0, $560cbe427eb95a5b$export$99eaa27ddbbb95ef)();
    const queryClient = (0, $509c1684c3be0a4f$export$22e77b9572c4fded)();
    const [error, setError] = (0, $7fPBF.useState)('');
    (0, $7fPBF.useEffect)(()=>{
        if (comment) form.reset({
            content: comment.content
        });
    }, [
        form,
        comment
    ]);
    const updateCommentMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ({ content: content })=>{
        await (0, $284bd93a9689a48d$export$5a1cd239009d83a6)({
            employeeId: employeeId,
            managerialDecisionId: managerialDecisionId,
            commentId: comment === null || comment === void 0 ? void 0 : comment.id,
            content: content
        });
    }, {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                'managerialDecisionComments',
                managerialDecisionId
            ]);
            setIsEditing(false);
            setError('');
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$8ce1ff4f94d08846), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, form), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
            onSubmit: form.handleSubmit((values)=>updateCommentMutation.mutate(values)),
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e9354814627de1d9$export$2e2bcd8739ae039), {
                    error: error,
                    variant: 'standard'
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            onClick: ()=>setIsEditing(false),
                            color: "inherit",
                            size: "small",
                            children: t('managerialDecisionComments.form.btn.cancel')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                            color: "inherit",
                            type: "sumbit",
                            size: "small",
                            variant: "outlined",
                            style: {
                                marginLeft: '10px'
                            },
                            children: t('managerialDecisionComments.form.btn.update')
                        })
                    ]
                })
            ]
        })
    }));
};
var $2852d261de2818c5$export$2e2bcd8739ae039 = $2852d261de2818c5$var$Update;


const $8607ed02c85bf5b1$var$CommenttItem = ({ comment: comment, managerialDecisionId: managerialDecisionId })=>{
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const queryClient = (0, $509c1684c3be0a4f$export$22e77b9572c4fded)();
    const { content: content, commenter_name: commenter_name, created_at: created_at, edited_at: edited_at, isEditable: isEditable } = comment;
    const lng = (0, $1e580fbd50c9e2d3$export$2e2bcd8739ae039).languages[0];
    const [isEditing, setIsEditing] = (0, $7fPBF.useState)(false);
    const deleteCommentMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        return await (0, $284bd93a9689a48d$export$2e6e3ad634e3776)({
            managerialDecisionId: managerialDecisionId,
            commentId: comment === null || comment === void 0 ? void 0 : comment.id
        });
    }, {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                'managerialDecisionComments',
                managerialDecisionId
            ]);
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const useStyles = (0, $by0pu.default)({
        comment: {
            margin: '8px 0',
            fontSize: '12px',
            color: '#666666',
            whiteSpace: 'pre-wrap'
        },
        info: {
            fontSize: '12px',
            color: '#999999',
            marginLeft: '10px'
        },
        button: {
            marginRight: '10px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                container: true,
                direction: 'column',
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                children: commenter_name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a2da34cf44eef56c$export$2e2bcd8739ae039), {
                                className: classes.info,
                                date: new Date(created_at),
                                locale: lng
                            }),
                            edited_at !== null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: classes.info,
                                        children: "|"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: classes.info,
                                        children: t('managerialDecisionComments.edited')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        item: true,
                        className: classes.comment,
                        children: isEditing ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2852d261de2818c5$export$2e2bcd8739ae039), {
                            comment: comment,
                            setIsEditing: setIsEditing,
                            managerialDecisionId: managerialDecisionId
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            variant: "body1",
                            children: content
                        })
                    }),
                    isEditable && !isEditing && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7cac207432c70082$export$2e2bcd8739ae039), {
                                    onClick: ()=>setIsEditing(true),
                                    color: "inherit",
                                    variant: "body2",
                                    className: classes.button,
                                    children: t('managerialDecisionComments.update')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7cac207432c70082$export$2e2bcd8739ae039), {
                                    onClick: deleteCommentMutation.mutate,
                                    color: "inherit",
                                    variant: "body2",
                                    className: classes.button,
                                    children: t('managerialDecisionComments.delete')
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b38083796464285f$export$2e2bcd8739ae039), {
                style: {
                    margin: '10px auto'
                }
            })
        ]
    });
};
var $8607ed02c85bf5b1$export$2e2bcd8739ae039 = $8607ed02c85bf5b1$var$CommenttItem;




const $8fdcb2076f649a6d$var$Comments = ({ managerialDecisionId: managerialDecisionId })=>{
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const commentsQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'managerialDecisionComments',
        managerialDecisionId
    ], async ()=>{
        const { data: data } = await (0, $284bd93a9689a48d$export$5d914151c350a309)(managerialDecisionId);
        return data;
    }, {
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const comments = commentsQuery.data;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            !comments && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9SdKL.default), {}),
            comments && comments.length !== 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: comments.map((comment)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8607ed02c85bf5b1$export$2e2bcd8739ae039), {
                        comment: comment,
                        managerialDecisionId: managerialDecisionId
                    }, comment.id))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fb39b8ed24227c71$export$2e2bcd8739ae039), {
                managerialDecisionId: managerialDecisionId
            })
        ]
    });
};
var $8fdcb2076f649a6d$export$2e2bcd8739ae039 = $8fdcb2076f649a6d$var$Comments;




const $0df0d0a79594c5b5$var$ManagerialDecisionItem = ({ managerialDecision: managerialDecision, managerialDecisionsQuery: managerialDecisionsQuery })=>{
    var _category_category_name;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const queryClient = (0, $509c1684c3be0a4f$export$22e77b9572c4fded)();
    (0, (/*@__PURE__*/$parcel$interopDefault($6qwOn))).locale('hu');
    const lng = (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).languages[0];
    const { id: id, title: title, created_at: created_at, creator_name: creator_name, updated_by: updated_by, updated_at: updated_at, category: category, description: description, approved_at: approved_at } = managerialDecision;
    const createFormattedDate = (date)=>`${(0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(date).format('L')}, ${(0, (/*@__PURE__*/$parcel$interopDefault($6qwOn)))(date).format('LT')}`;
    const createDateString = (action, action_by, action_date)=>{
        const actionByString = `: ${action_by} `;
        return `
      ${t('managerialDecisions.date.' + action)}${action !== 'approved' ? actionByString : ' '}|
      ${t('managerialDecisions.date.date')}: ${createFormattedDate(action_date)}
    `;
    };
    const approveManagerialDecisionMutation = (0, $2668994c46bd3e68$export$609860bf8b0084c)(async ()=>{
        return await (0, $fc912324afeee9af$export$84d11a0f7b895826)(id);
    }, {
        onSuccess: ()=>{
            managerialDecisionsQuery.refetch();
            queryClient.invalidateQueries('drawerInfo');
        },
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const approve = ()=>{
        approveManagerialDecisionMutation.mutate();
    };
    const useStyles = (0, $8SBLK.default)({
        wrapper: {
            background: '#F4F4F4',
            marginBottom: '15px',
            padding: '20px',
            borderRadius: '4px',
            color: '#000000DA'
        },
        title: {
            fontWeight: '350px',
            fontSize: '17px'
        },
        chip: {
            fontSize: '13px'
        },
        description: {
            marginLeft: '10px',
            whiteSpace: 'pre-wrap'
        },
        grey: {
            color: 'grey'
        },
        dates: {
            fontSize: '14px'
        }
    });
    const classes = useStyles();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: classes.wrapper,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    container: true,
                    item: true,
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                            item: true,
                            className: classes.title,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                            item: true,
                            className: classes.dates,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: updated_at && updated_by ? classes.grey : '',
                                    children: createDateString('created', creator_name, created_at)
                                }),
                                updated_at && updated_by && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: createDateString('updated', updated_by, new Date(Number(updated_at)))
                                }),
                                approved_at && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: createDateString('approved', '', approved_at)
                                })
                            ]
                        })
                    ]
                }),
                category && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $812a279261d3d883$export$2e2bcd8739ae039), {
                        className: classes.chip,
                        label: category === null || category === void 0 ? void 0 : (_category_category_name = category.category_name) === null || _category_category_name === void 0 ? void 0 : _category_category_name[lng]
                    })
                }),
                description && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    className: classes.description,
                    children: description
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fwAOd.default), {
                        onClick: approve,
                        disabled: approved_at,
                        color: "secondary",
                        variant: "contained",
                        children: approved_at ? t('managerialDecisions.approved') : t('managerialDecisions.notApproved')
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c9ee90b78693ce6c$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fdcb2076f649a6d$export$2e2bcd8739ae039), {
                        managerialDecisionId: id
                    })
                })
            ]
        })
    });
};
var $0df0d0a79594c5b5$export$2e2bcd8739ae039 = $0df0d0a79594c5b5$var$ManagerialDecisionItem;



const $15a8840f39517793$var$useStyles = (0, $by0pu.default)({
    title: {
        color: '#999999',
        fontSize: '16px',
        textTransform: 'uppercase',
        margin: '40px auto 20px auto'
    }
});
const $15a8840f39517793$var$ManagerialDecisionsPage = ()=>{
    const theme = (0, $fH0xA.default)();
    const sm = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const classes = $15a8840f39517793$var$useStyles();
    const [drawerOpen, setDrawerOpen] = (0, $7fPBF.useState)(false);
    const managerialDecisionsQuery = (0, $13e6d41be5252f10$export$dd0a697e1782aedd)([
        'managerialDecisions'
    ], async ()=>{
        const { data: data } = await (0, $fc912324afeee9af$export$31c1108d729ca1e2)();
        return data;
    }, {
        onError: (error)=>{
            dispatch((0, $b4a8182390b65be8$export$c8c497ba354ffdce)({
                message: error.message,
                severity: 'error'
            }));
        }
    });
    const managerialDecisions = managerialDecisionsQuery.data;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $899ea3d88a7a8f04$export$2e2bcd8739ae039), {
                drawerOpen: drawerOpen,
                setDrawerOpen: setDrawerOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    marginLeft: !sm ? 'auto' : drawerOpen ? `${0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH}px` : '55px'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $86a6140e16b13821$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                            className: classes.title,
                            children: t('managerialDecisions.title')
                        }),
                        !managerialDecisions && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9SdKL.default), {}),
                        managerialDecisions && managerialDecisions.length !== 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: managerialDecisions.map((managerialDecision)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0df0d0a79594c5b5$export$2e2bcd8739ae039), {
                                    managerialDecision: managerialDecision,
                                    managerialDecisionsQuery: managerialDecisionsQuery
                                }, managerialDecision.id))
                        }),
                        managerialDecisions && managerialDecisions.length === 0 && t('managerialDecisions.noManagerialDecisions')
                    ]
                })
            })
        ]
    });
};
var $15a8840f39517793$export$2e2bcd8739ae039 = $15a8840f39517793$var$ManagerialDecisionsPage;




var $7fPBF = parcelRequire("7fPBF");



var $by0pu = parcelRequire("by0pu");
var $1rW9t = parcelRequire("1rW9t");
var $fH0xA = parcelRequire("fH0xA");




const $e6777e26a54ed3ad$var$useStyles = (0, $by0pu.default)({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
    }
});
const $e6777e26a54ed3ad$var$MissingLicenceWarning = (props)=>{
    const theme = (0, $fH0xA.default)();
    const classes = $e6777e26a54ed3ad$var$useStyles();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const sm = (0, $d817e1b1fb97b199$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const [drawerOpen, setDrawerOpen] = (0, $7fPBF.useState)(false);
    const hasValidLicence = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $9abcdbaae8311c9d$export$3b2effd73e7d4022));
    const url = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $295ca3e31a29edec$export$48a4dab9caeca3ef));
    (0, $7fPBF.useEffect)(()=>{
        if (hasValidLicence) props.history.push(url);
    }, [
        hasValidLicence,
        props,
        url
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $899ea3d88a7a8f04$export$2e2bcd8739ae039), {
                drawerOpen: drawerOpen,
                setDrawerOpen: setDrawerOpen
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    marginLeft: !sm ? 'auto' : drawerOpen ? `${0, $f6e729db3f817bb5$exports.NAVIGATION_DRAWER_WIDTH}px` : '55px'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $86a6140e16b13821$export$2e2bcd8739ae039), {
                    maxWidth: "xl",
                    className: classes.container,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1rW9t.default), {
                        variant: "h3",
                        children: t('objective.licence.missing')
                    })
                })
            })
        ]
    });
};
var $e6777e26a54ed3ad$export$2e2bcd8739ae039 = $e6777e26a54ed3ad$var$MissingLicenceWarning;




const $259b7c5a28f3e893$export$492bdc31a14c4d1 = [
    {
        path: '/objectives',
        translationKey: 'common.header.objectives',
        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c2bc9e2d5476054a$export$2e2bcd8739ae039), {}),
        badgeInfoKey: 'proposedEmployeeObjectives',
        badgeColor: 'error'
    },
    {
        path: '/groupObjectives',
        translationKey: 'common.header.groupObjectives',
        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5278824381c7d973$export$2e2bcd8739ae039), {}),
        badgeInfoKey: 'activeGroupObjectives',
        badgeClassName: 'groupBadge'
    },
    {
        path: '/projects',
        translationKey: 'common.header.projects',
        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cddda03f7a4afb68$export$2e2bcd8739ae039), {}),
        badgeInfoKey: 'runningProjects',
        badgeColor: 'error'
    },
    {
        path: '/managerialDecisions',
        translationKey: 'common.header.managerialDecisions',
        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5d8aa3cfd0a7f968$export$2e2bcd8739ae039), {}),
        badgeInfoKey: 'notApprovedManagerialDecisions',
        badgeColor: 'error'
    }
];
const $259b7c5a28f3e893$export$330acb37fe7f2d00 = (handleLogOut)=>[
        {
            path: '/settings',
            translationKey: 'common.header.settings',
            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c2bc9e2d5476054a$export$2e2bcd8739ae039), {})
        },
        {
            path: '/',
            translationKey: 'common.header.logout',
            onClick: handleLogOut,
            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5278824381c7d973$export$2e2bcd8739ae039), {})
        }
    ];
const $259b7c5a28f3e893$export$66b32f6f30eb4b4 = [
    {
        path: '/',
        key: 'root',
        exact: true,
        noneauth: true,
        licenced: false,
        component: (0, $82c46e29820dc6b6$export$2e2bcd8739ae039)
    },
    {
        path: '/registration/:hash',
        key: 'registration',
        exact: true,
        noneauth: true,
        licenced: false,
        component: (0, $bf2b7f6e429b3b7b$export$2e2bcd8739ae039)
    },
    {
        path: '/forgottenPassword',
        key: 'forgottenPassword',
        exact: true,
        noneauth: true,
        licenced: false,
        component: (0, $12eae5248a184b4a$export$2e2bcd8739ae039)
    },
    {
        path: '/changePassword/:hash',
        key: 'changePassword',
        exact: true,
        noneauth: true,
        licenced: false,
        component: (0, $207b5c3faacc9d80$export$2e2bcd8739ae039)
    },
    {
        path: '/objectives',
        key: 'objectives',
        exact: true,
        auth: true,
        licenced: true,
        component: (0, $748579619b0988e4$export$2e2bcd8739ae039)
    },
    {
        path: '/groupObjectives',
        key: 'groupObjectives',
        exact: true,
        auth: true,
        licenced: true,
        component: (0, $50b4a5e380d3c4ed$export$2e2bcd8739ae039)
    },
    {
        path: '/objective/:objectiveId',
        key: 'objective',
        exact: true,
        auth: true,
        licenced: true,
        component: (0, $128c11857d1e96b1$export$2e2bcd8739ae039)
    },
    {
        path: '/projects',
        key: 'projects',
        exact: true,
        auth: true,
        licenced: false,
        component: (0, $6e52cf2fab4d511b$export$2e2bcd8739ae039)
    },
    {
        path: '/settings',
        key: 'settings',
        exact: true,
        auth: true,
        licenced: false,
        component: (0, $629e73bba98205af$export$2e2bcd8739ae039)
    },
    {
        path: '/managerialDecisions',
        key: 'managerialDecisions',
        exact: true,
        auth: true,
        licenced: false,
        component: (0, $15a8840f39517793$export$2e2bcd8739ae039)
    },
    {
        path: '/missing-licence',
        key: 'missing-licence',
        exact: true,
        auth: true,
        licenced: false,
        component: (0, $e6777e26a54ed3ad$export$2e2bcd8739ae039)
    }
];
function $259b7c5a28f3e893$export$9af28c8ee4e983d6({ routes: routes }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6e382b045249d040$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea770b7d5c81ac8c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $560cbe427eb95a5b$export$b5d5cf8927ab7262), {
                children: [
                    routes.map((route, i)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cf65770b5de4cf48$export$a666473f8cc4884f), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, route), {
                            auth: route.auth
                        }), route.key)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $560cbe427eb95a5b$export$e7b0ac011bb776c6), {
                        component: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                children: "Not Found!"
                            })
                    })
                ]
            })
        ]
    });
}


function $6aaba76260e26777$var$App() {
    const primaryColor = '#99B64E';
    const themeOptions = {
        palette: {
            primary: {
                main: primaryColor,
                contrastText: '#fff'
            },
            secondary: {
                main: '#76C9E6',
                contrastText: '#fff'
            },
            tertiary: {
                main: (0, $k03mY.default)
            },
            text: {
                primary: '#252733',
                secondary: '#000000'
            }
        },
        overrides: {
            MuiDialogTitle: {
                root: {
                    backgroundColor: primaryColor
                }
            },
            MuiLink: {
                underlineHover: {
                    cursor: 'pointer'
                }
            }
        }
    };
    const theme = (0, $baumZ.default)(themeOptions);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Suspense), {
        fallback: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
            children: "Loading..."
        }),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4c848518e85f237d$export$2e2bcd8739ae039), {
            store: (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $juaRV.default), {
                theme: theme,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6f74e9f8f54d4d5a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $509c1684c3be0a4f$export$45604f0cc8ae667b), {
                            client: new (0, $2701e4e367fb45bc$export$405d0624ed55a03f)({
                                defaultOptions: {
                                    queries: {
                                        retry: false,
                                        refetchOnWindowFocus: false
                                    }
                                }
                            }),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $259b7c5a28f3e893$export$9af28c8ee4e983d6), {
                                routes: (0, $259b7c5a28f3e893$export$66b32f6f30eb4b4)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eb9c38114fe0ef26$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}
var $6aaba76260e26777$export$2e2bcd8739ae039 = $6aaba76260e26777$var$App;


// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $b8077eed590c44e8$var$isLocalhost = Boolean(window.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $b8077eed590c44e8$export$6503ec6e8aabbaf(config) {
    if ('serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener('load', ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($b8077eed590c44e8$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $b8077eed590c44e8$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $b8077eed590c44e8$var$registerValidSW(swUrl, config);
        });
    }
}
function $b8077eed590c44e8$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error('Error during service worker registration:', error);
    });
}
function $b8077eed590c44e8$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get('content-type');
        if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $b8077eed590c44e8$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function $b8077eed590c44e8$export$d07f55d4c15c0440() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}



var $ae7d8cb98fb46a3d$exports = {};
$ae7d8cb98fb46a3d$exports = JSON.parse("{\"locale\":\"en\",\"long\":{\"year\":{\"previous\":\"last year\",\"current\":\"this year\",\"next\":\"next year\",\"past\":{\"one\":\"{0} year ago\",\"other\":\"{0} years ago\"},\"future\":{\"one\":\"in {0} year\",\"other\":\"in {0} years\"}},\"quarter\":{\"previous\":\"last quarter\",\"current\":\"this quarter\",\"next\":\"next quarter\",\"past\":{\"one\":\"{0} quarter ago\",\"other\":\"{0} quarters ago\"},\"future\":{\"one\":\"in {0} quarter\",\"other\":\"in {0} quarters\"}},\"month\":{\"previous\":\"last month\",\"current\":\"this month\",\"next\":\"next month\",\"past\":{\"one\":\"{0} month ago\",\"other\":\"{0} months ago\"},\"future\":{\"one\":\"in {0} month\",\"other\":\"in {0} months\"}},\"week\":{\"previous\":\"last week\",\"current\":\"this week\",\"next\":\"next week\",\"past\":{\"one\":\"{0} week ago\",\"other\":\"{0} weeks ago\"},\"future\":{\"one\":\"in {0} week\",\"other\":\"in {0} weeks\"}},\"day\":{\"previous\":\"yesterday\",\"current\":\"today\",\"next\":\"tomorrow\",\"past\":{\"one\":\"{0} day ago\",\"other\":\"{0} days ago\"},\"future\":{\"one\":\"in {0} day\",\"other\":\"in {0} days\"}},\"hour\":{\"current\":\"this hour\",\"past\":{\"one\":\"{0} hour ago\",\"other\":\"{0} hours ago\"},\"future\":{\"one\":\"in {0} hour\",\"other\":\"in {0} hours\"}},\"minute\":{\"current\":\"this minute\",\"past\":{\"one\":\"{0} minute ago\",\"other\":\"{0} minutes ago\"},\"future\":{\"one\":\"in {0} minute\",\"other\":\"in {0} minutes\"}},\"second\":{\"current\":\"now\",\"past\":{\"one\":\"{0} second ago\",\"other\":\"{0} seconds ago\"},\"future\":{\"one\":\"in {0} second\",\"other\":\"in {0} seconds\"}}},\"short\":{\"year\":{\"previous\":\"last yr.\",\"current\":\"this yr.\",\"next\":\"next yr.\",\"past\":\"{0} yr. ago\",\"future\":\"in {0} yr.\"},\"quarter\":{\"previous\":\"last qtr.\",\"current\":\"this qtr.\",\"next\":\"next qtr.\",\"past\":{\"one\":\"{0} qtr. ago\",\"other\":\"{0} qtrs. ago\"},\"future\":{\"one\":\"in {0} qtr.\",\"other\":\"in {0} qtrs.\"}},\"month\":{\"previous\":\"last mo.\",\"current\":\"this mo.\",\"next\":\"next mo.\",\"past\":\"{0} mo. ago\",\"future\":\"in {0} mo.\"},\"week\":{\"previous\":\"last wk.\",\"current\":\"this wk.\",\"next\":\"next wk.\",\"past\":\"{0} wk. ago\",\"future\":\"in {0} wk.\"},\"day\":{\"previous\":\"yesterday\",\"current\":\"today\",\"next\":\"tomorrow\",\"past\":{\"one\":\"{0} day ago\",\"other\":\"{0} days ago\"},\"future\":{\"one\":\"in {0} day\",\"other\":\"in {0} days\"}},\"hour\":{\"current\":\"this hour\",\"past\":\"{0} hr. ago\",\"future\":\"in {0} hr.\"},\"minute\":{\"current\":\"this minute\",\"past\":\"{0} min. ago\",\"future\":\"in {0} min.\"},\"second\":{\"current\":\"now\",\"past\":\"{0} sec. ago\",\"future\":\"in {0} sec.\"}},\"narrow\":{\"year\":{\"previous\":\"last yr.\",\"current\":\"this yr.\",\"next\":\"next yr.\",\"past\":\"{0}y ago\",\"future\":\"in {0}y\"},\"quarter\":{\"previous\":\"last qtr.\",\"current\":\"this qtr.\",\"next\":\"next qtr.\",\"past\":\"{0}q ago\",\"future\":\"in {0}q\"},\"month\":{\"previous\":\"last mo.\",\"current\":\"this mo.\",\"next\":\"next mo.\",\"past\":\"{0}mo ago\",\"future\":\"in {0}mo\"},\"week\":{\"previous\":\"last wk.\",\"current\":\"this wk.\",\"next\":\"next wk.\",\"past\":\"{0}w ago\",\"future\":\"in {0}w\"},\"day\":{\"previous\":\"yesterday\",\"current\":\"today\",\"next\":\"tomorrow\",\"past\":\"{0}d ago\",\"future\":\"in {0}d\"},\"hour\":{\"current\":\"this hour\",\"past\":\"{0}h ago\",\"future\":\"in {0}h\"},\"minute\":{\"current\":\"this minute\",\"past\":\"{0}m ago\",\"future\":\"in {0}m\"},\"second\":{\"current\":\"now\",\"past\":\"{0}s ago\",\"future\":\"in {0}s\"}},\"now\":{\"now\":{\"current\":\"now\",\"future\":\"in a moment\",\"past\":\"just now\"}},\"mini\":{\"year\":\"{0}yr\",\"month\":\"{0}mo\",\"week\":\"{0}wk\",\"day\":\"{0}d\",\"hour\":\"{0}h\",\"minute\":\"{0}m\",\"second\":\"{0}s\",\"now\":\"now\"},\"short-time\":{\"year\":\"{0} yr.\",\"month\":\"{0} mo.\",\"week\":\"{0} wk.\",\"day\":{\"one\":\"{0} day\",\"other\":\"{0} days\"},\"hour\":\"{0} hr.\",\"minute\":\"{0} min.\",\"second\":\"{0} sec.\"},\"long-time\":{\"year\":{\"one\":\"{0} year\",\"other\":\"{0} years\"},\"month\":{\"one\":\"{0} month\",\"other\":\"{0} months\"},\"week\":{\"one\":\"{0} week\",\"other\":\"{0} weeks\"},\"day\":{\"one\":\"{0} day\",\"other\":\"{0} days\"},\"hour\":{\"one\":\"{0} hour\",\"other\":\"{0} hours\"},\"minute\":{\"one\":\"{0} minute\",\"other\":\"{0} minutes\"},\"second\":{\"one\":\"{0} second\",\"other\":\"{0} seconds\"}}}");


var $ac783b792b8637ca$exports = {};
$ac783b792b8637ca$exports = JSON.parse('{"locale":"hu","long":{"year":{"previous":"el\u0151z\u0151 \xe9v","current":"ez az \xe9v","next":"k\xf6vetkez\u0151 \xe9v","past":"{0} \xe9vvel ezel\u0151tt","future":"{0} \xe9v m\xfalva"},"quarter":{"previous":"el\u0151z\u0151 negyed\xe9v","current":"ez a negyed\xe9v","next":"k\xf6vetkez\u0151 negyed\xe9v","past":"{0} negyed\xe9vvel ezel\u0151tt","future":"{0} negyed\xe9v m\xfalva"},"month":{"previous":"el\u0151z\u0151 h\xf3nap","current":"ez a h\xf3nap","next":"k\xf6vetkez\u0151 h\xf3nap","past":"{0} h\xf3nappal ezel\u0151tt","future":"{0} h\xf3nap m\xfalva"},"week":{"previous":"el\u0151z\u0151 h\xe9t","current":"ez a h\xe9t","next":"k\xf6vetkez\u0151 h\xe9t","past":"{0} h\xe9ttel ezel\u0151tt","future":"{0} h\xe9t m\xfalva"},"day":{"previous":"tegnap","previous-2":"tegnapel\u0151tt","current":"ma","next":"holnap","next-2":"holnaput\xe1n","past":"{0} nappal ezel\u0151tt","future":"{0} nap m\xfalva"},"hour":{"current":"ebben az \xf3r\xe1ban","past":"{0} \xf3r\xe1val ezel\u0151tt","future":"{0} \xf3ra m\xfalva"},"minute":{"current":"ebben a percben","past":"{0} perccel ezel\u0151tt","future":"{0} perc m\xfalva"},"second":{"current":"most","past":"{0} m\xe1sodperccel ezel\u0151tt","future":"{0} m\xe1sodperc m\xfalva"}},"short":{"year":{"previous":"el\u0151z\u0151 \xe9v","current":"ez az \xe9v","next":"k\xf6vetkez\u0151 \xe9v","past":"{0} \xe9vvel ezel\u0151tt","future":"{0} \xe9v m\xfalva"},"quarter":{"previous":"el\u0151z\u0151 negyed\xe9v","current":"ez a negyed\xe9v","next":"k\xf6vetkez\u0151 negyed\xe9v","past":"{0} negyed\xe9vvel ezel\u0151tt","future":"{0} negyed\xe9v m\xfalva"},"month":{"previous":"el\u0151z\u0151 h\xf3nap","current":"ez a h\xf3nap","next":"k\xf6vetkez\u0151 h\xf3nap","past":"{0} h\xf3nappal ezel\u0151tt","future":"{0} h\xf3nap m\xfalva"},"week":{"previous":"el\u0151z\u0151 h\xe9t","current":"ez a h\xe9t","next":"k\xf6vetkez\u0151 h\xe9t","past":"{0} h\xe9ttel ezel\u0151tt","future":"{0} h\xe9t m\xfalva"},"day":{"previous":"tegnap","previous-2":"tegnapel\u0151tt","current":"ma","next":"holnap","next-2":"holnaput\xe1n","past":"{0} napja","future":"{0} nap m\xfalva"},"hour":{"current":"ebben az \xf3r\xe1ban","past":"{0} \xf3r\xe1val ezel\u0151tt","future":"{0} \xf3ra m\xfalva"},"minute":{"current":"ebben a percben","past":"{0} perccel ezel\u0151tt","future":"{0} perc m\xfalva"},"second":{"current":"most","past":"{0} m\xe1sodperccel ezel\u0151tt","future":"{0} m\xe1sodperc m\xfalva"}},"narrow":{"year":{"previous":"el\u0151z\u0151 \xe9v","current":"ez az \xe9v","next":"k\xf6vetkez\u0151 \xe9v","past":"{0} \xe9ve","future":"{0} \xe9v m\xfalva"},"quarter":{"previous":"el\u0151z\u0151 negyed\xe9v","current":"ez a negyed\xe9v","next":"k\xf6vetkez\u0151 negyed\xe9v","past":"{0} negyed\xe9vvel ezel\u0151tt","future":"{0} n.\xe9v m\xfalva"},"month":{"previous":"el\u0151z\u0151 h\xf3nap","current":"ez a h\xf3nap","next":"k\xf6vetkez\u0151 h\xf3nap","past":"{0} h\xf3napja","future":"{0} h\xf3nap m\xfalva"},"week":{"previous":"el\u0151z\u0151 h\xe9t","current":"ez a h\xe9t","next":"k\xf6vetkez\u0151 h\xe9t","past":"{0} hete","future":"{0} h\xe9t m\xfalva"},"day":{"previous":"tegnap","previous-2":"tegnapel\u0151tt","current":"ma","next":"holnap","next-2":"holnaput\xe1n","past":"{0} napja","future":"{0} nap m\xfalva"},"hour":{"current":"ebben az \xf3r\xe1ban","past":"{0} \xf3r\xe1ja","future":"{0} \xf3ra m\xfalva"},"minute":{"current":"ebben a percben","past":"{0} perce","future":"{0} perc m\xfalva"},"second":{"current":"most","past":"{0} m.perce","future":"{0} m\xe1sodperc m\xfalva"}}}');


var $cf23f5e7acd8b805$exports = {};
$cf23f5e7acd8b805$exports = JSON.parse('{"locale":"de","long":{"year":{"previous":"letztes Jahr","current":"dieses Jahr","next":"n\xe4chstes Jahr","past":{"one":"vor {0} Jahr","other":"vor {0} Jahren"},"future":{"one":"in {0} Jahr","other":"in {0} Jahren"}},"quarter":{"previous":"letztes Quartal","current":"dieses Quartal","next":"n\xe4chstes Quartal","past":{"one":"vor {0} Quartal","other":"vor {0} Quartalen"},"future":{"one":"in {0} Quartal","other":"in {0} Quartalen"}},"month":{"previous":"letzten Monat","current":"diesen Monat","next":"n\xe4chsten Monat","past":{"one":"vor {0} Monat","other":"vor {0} Monaten"},"future":{"one":"in {0} Monat","other":"in {0} Monaten"}},"week":{"previous":"letzte Woche","current":"diese Woche","next":"n\xe4chste Woche","past":{"one":"vor {0} Woche","other":"vor {0} Wochen"},"future":{"one":"in {0} Woche","other":"in {0} Wochen"}},"day":{"previous":"gestern","previous-2":"vorgestern","current":"heute","next":"morgen","next-2":"\xfcbermorgen","past":{"one":"vor {0} Tag","other":"vor {0} Tagen"},"future":{"one":"in {0} Tag","other":"in {0} Tagen"}},"hour":{"current":"in dieser Stunde","past":{"one":"vor {0} Stunde","other":"vor {0} Stunden"},"future":{"one":"in {0} Stunde","other":"in {0} Stunden"}},"minute":{"current":"in dieser Minute","past":{"one":"vor {0} Minute","other":"vor {0} Minuten"},"future":{"one":"in {0} Minute","other":"in {0} Minuten"}},"second":{"current":"jetzt","past":{"one":"vor {0} Sekunde","other":"vor {0} Sekunden"},"future":{"one":"in {0} Sekunde","other":"in {0} Sekunden"}}},"short":{"year":{"previous":"letztes Jahr","current":"dieses Jahr","next":"n\xe4chstes Jahr","past":{"one":"vor {0} Jahr","other":"vor {0} Jahren"},"future":{"one":"in {0} Jahr","other":"in {0} Jahren"}},"quarter":{"previous":"letztes Quartal","current":"dieses Quartal","next":"n\xe4chstes Quartal","past":"vor {0} Quart.","future":"in {0} Quart."},"month":{"previous":"letzten Monat","current":"diesen Monat","next":"n\xe4chsten Monat","past":{"one":"vor {0} Monat","other":"vor {0}\xa0Monaten"},"future":{"one":"in {0} Monat","other":"in {0} Monaten"}},"week":{"previous":"letzte Woche","current":"diese Woche","next":"n\xe4chste Woche","past":{"one":"vor {0} Woche","other":"vor {0} Wochen"},"future":{"one":"in {0} Woche","other":"in {0} Wochen"}},"day":{"previous":"gestern","previous-2":"vorgestern","current":"heute","next":"morgen","next-2":"\xfcbermorgen","past":{"one":"vor {0} Tag","other":"vor {0} Tagen"},"future":{"one":"in {0} Tag","other":"in {0} Tagen"}},"hour":{"current":"in dieser Stunde","past":"vor {0} Std.","future":"in {0} Std."},"minute":{"current":"in dieser Minute","past":"vor {0} Min.","future":"in {0} Min."},"second":{"current":"jetzt","past":"vor {0} Sek.","future":"in {0} Sek."}},"narrow":{"year":{"previous":"letztes Jahr","current":"dieses Jahr","next":"n\xe4chstes Jahr","past":{"one":"vor {0} Jahr","other":"vor {0} Jahren"},"future":{"one":"in {0} Jahr","other":"in {0} Jahren"}},"quarter":{"previous":"letztes Quartal","current":"dieses Quartal","next":"n\xe4chstes Quartal","past":"vor {0} Q","future":"in {0} Q"},"month":{"previous":"letzten Monat","current":"diesen Monat","next":"n\xe4chsten Monat","past":{"one":"vor {0}\xa0Monat","other":"vor {0} Monaten"},"future":{"one":"in {0} Monat","other":"in {0} Monaten"}},"week":{"previous":"letzte Woche","current":"diese Woche","next":"n\xe4chste Woche","past":"vor {0} Wo.","future":"in {0} Wo."},"day":{"previous":"gestern","previous-2":"vorgestern","current":"heute","next":"morgen","next-2":"\xfcbermorgen","past":{"one":"vor {0} Tag","other":"vor {0} Tagen"},"future":{"one":"in {0} Tag","other":"in {0} Tagen"}},"hour":{"current":"in dieser Stunde","past":"vor {0} Std.","future":"in {0} Std."},"minute":{"current":"in dieser Minute","past":"vor {0} m","future":"in {0} m"},"second":{"current":"jetzt","past":"vor {0} s","future":"in {0} s"}},"now":{"now":{"current":"jetzt","future":"in einem Moment","past":"gerade jetzt"}},"mini":{"year":"{0} J.","month":"{0} Mt.","week":"{0} Wo.","day":"{0} T.","hour":"{0} Std.","minute":"{0} Min.","second":"{0} s","now":"jetzt"},"long-time":{"year":{"one":"{0} Jahr","other":"{0} Jahre"},"month":{"one":"{0} Monat","other":"{0} Monate"},"week":{"one":"{0} Woche","other":"{0} Wochen"},"day":{"one":"{0} Tag","other":"{0} Tage"},"hour":{"one":"{0} Stunde","other":"{0} Stunden"},"minute":{"one":"{0} Minute","other":"{0} Minuten"},"second":{"one":"{0} Sekunde","other":"{0} Sekunden"}}}');


(0, $1a34c0d312e0c078$export$2e2bcd8739ae039).addLocale((0, (/*@__PURE__*/$parcel$interopDefault($ae7d8cb98fb46a3d$exports))));
(0, $1a34c0d312e0c078$export$2e2bcd8739ae039).addLocale((0, (/*@__PURE__*/$parcel$interopDefault($ac783b792b8637ca$exports))));
(0, $1a34c0d312e0c078$export$2e2bcd8739ae039).addLocale((0, (/*@__PURE__*/$parcel$interopDefault($cf23f5e7acd8b805$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aaba76260e26777$export$2e2bcd8739ae039), {}), document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
$b8077eed590c44e8$export$d07f55d4c15c0440();


//# sourceMappingURL=public.4b5e65c1.js.map
